// @__NO_SIDE_EFFECTS__
function uy(e) {
  const A = /* @__PURE__ */ Object.create(null);
  for (const t of e.split(",")) A[t] = 1;
  return (t) => t in A;
}
const Ft = {}, El = [], qs = () => {
}, px = () => !1, Pg = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), kg = (e) => e.startsWith("onUpdate:"), Gr = Object.assign, hy = (e, A) => {
  const t = e.indexOf(A);
  t > -1 && e.splice(t, 1);
}, t_ = Object.prototype.hasOwnProperty, ut = (e, A) => t_.call(e, A), Se = Array.isArray, Lo = (e) => qh(e) === "[object Map]", Jc = (e) => qh(e) === "[object Set]", iC = (e) => qh(e) === "[object Date]", Re = (e) => typeof e == "function", kt = (e) => typeof e == "string", ys = (e) => typeof e == "symbol", dt = (e) => e !== null && typeof e == "object", Bx = (e) => (dt(e) || Re(e)) && Re(e.then) && Re(e.catch), wx = Object.prototype.toString, qh = (e) => wx.call(e), r_ = (e) => qh(e).slice(8, -1), mx = (e) => qh(e) === "[object Object]", fy = (e) => kt(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, uh = /* @__PURE__ */ uy(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Kg = (e) => {
  const A = /* @__PURE__ */ Object.create(null);
  return ((t) => A[t] || (A[t] = e(t)));
}, n_ = /-\w/g, Yn = Kg(
  (e) => e.replace(n_, (A) => A.slice(1).toUpperCase())
), i_ = /\B([A-Z])/g, Jl = Kg(
  (e) => e.replace(i_, "-$1").toLowerCase()
), Vg = Kg((e) => e.charAt(0).toUpperCase() + e.slice(1)), sB = Kg(
  (e) => e ? `on${Vg(e)}` : ""
), Ws = (e, A) => !Object.is(e, A), Wd = (e, ...A) => {
  for (let t = 0; t < e.length; t++)
    e[t](...A);
}, vx = (e, A, t, r = !1) => {
  Object.defineProperty(e, A, {
    configurable: !0,
    enumerable: !1,
    writable: r,
    value: t
  });
}, dy = (e) => {
  const A = parseFloat(e);
  return isNaN(A) ? e : A;
}, s_ = (e) => {
  const A = kt(e) ? Number(e) : NaN;
  return isNaN(A) ? e : A;
};
let sC;
const Gg = () => sC || (sC = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function zt(e) {
  if (Se(e)) {
    const A = {};
    for (let t = 0; t < e.length; t++) {
      const r = e[t], n = kt(r) ? c_(r) : zt(r);
      if (n)
        for (const i in n)
          A[i] = n[i];
    }
    return A;
  } else if (kt(e) || dt(e))
    return e;
}
const a_ = /;(?![^(]*\))/g, o_ = /:([^]+)/, l_ = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function c_(e) {
  const A = {};
  return e.replace(l_, (t) => t.startsWith("/*") ? "" : t).split(a_).forEach((t) => {
    if (t) {
      const r = t.split(o_);
      r.length > 1 && (A[r[0].trim()] = r[1].trim());
    }
  }), A;
}
function ks(e) {
  let A = "";
  if (kt(e))
    A = e;
  else if (Se(e))
    for (let t = 0; t < e.length; t++) {
      const r = ks(e[t]);
      r && (A += r + " ");
    }
  else if (dt(e))
    for (const t in e)
      e[t] && (A += t + " ");
  return A.trim();
}
const u_ = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", h_ = /* @__PURE__ */ uy(u_);
function yx(e) {
  return !!e || e === "";
}
function f_(e, A, t) {
  if (e.length !== A.length) return !1;
  let r = !0;
  for (let n = 0; r && n < e.length; n++)
    r = Au(e[n], A[n], t);
  return r;
}
function aC(e, A, t) {
  if (e.size !== A.size) return !1;
  const r = Array.from(A), n = new Uint8Array(r.length);
  for (const i of e) {
    let s = -1;
    for (let a = 0; a < r.length; a++)
      if (!n[a] && Au(i, r[a], t)) {
        s = a;
        break;
      }
    if (s < 0) return !1;
    n[s] = 1;
  }
  return !0;
}
function d_(e, A, t) {
  let r = Lo(e), n = Lo(A);
  if (r || n || (r = Jc(e), n = Jc(A), r || n))
    return r && n ? aC(e, A, t) : !1;
  const i = Object.keys(e).length, s = Object.keys(A).length;
  if (i !== s)
    return !1;
  for (const a in e) {
    const o = e.hasOwnProperty(a), l = A.hasOwnProperty(a);
    if (o && !l || !o && l || !Au(e[a], A[a], t))
      return !1;
  }
  return String(e) === String(A);
}
function oC(e, A, t, r) {
  t || (t = [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map()]);
  const [n, i] = t;
  if (n.has(e) || i.has(A))
    return n.get(e) === A && i.get(A) === e;
  n.set(e, A), i.set(A, e);
  const s = r(e, A, t);
  return n.delete(e), i.delete(A), s;
}
function Au(e, A, t) {
  if (e === A) return !0;
  let r = iC(e), n = iC(A);
  return r || n ? r && n ? e.getTime() === A.getTime() : !1 : (r = ys(e), n = ys(A), r || n ? e === A : (r = Se(e), n = Se(A), r || n ? r && n ? oC(e, A, t, f_) : !1 : (r = dt(e), n = dt(A), r || n ? !r || !n ? !1 : oC(e, A, t, d_) : String(e) === String(A))));
}
function Cx(e, A) {
  return e.findIndex((t) => Au(t, A));
}
const bx = (e) => !!(e && e.__v_isRef === !0), ye = (e) => kt(e) ? e : e == null ? "" : Se(e) || dt(e) && (e.toString === wx || !Re(e.toString)) ? bx(e) ? ye(e.value) : JSON.stringify(e, Fx, 2) : String(e), Fx = (e, A) => bx(A) ? Fx(e, A.value) : Lo(A) ? {
  [`Map(${A.size})`]: [...A.entries()].reduce(
    (t, [r, n], i) => (t[aB(r, i) + " =>"] = n, t),
    {}
  )
} : Jc(A) ? {
  [`Set(${A.size})`]: [...A.values()].map((t) => aB(t))
} : ys(A) ? aB(A) : dt(A) && !Se(A) && !mx(A) ? String(A) : A, aB = (e, A = "") => {
  var t;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    ys(e) ? `Symbol(${(t = e.description) != null ? t : A})` : e
  );
};
let nn;
class g_ {
  // TODO isolatedDeclarations "__v_skip"
  constructor(A = !1) {
    this.detached = A, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this._warnOnRun = !0, this.__v_skip = !0, !A && nn && (nn.active ? (this.parent = nn, this.index = (nn.scopes || (nn.scopes = [])).push(
      this
    ) - 1) : (this._active = !1, this._warnOnRun = !1));
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let A, t;
      if (this.scopes) {
        const r = this.scopes.slice();
        for (A = 0, t = r.length; A < t; A++)
          r[A].pause();
      }
      for (A = 0, t = this.effects.length; A < t; A++)
        this.effects[A].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let A, t;
      if (this.scopes) {
        const n = this.scopes.slice();
        for (A = 0, t = n.length; A < t; A++)
          n[A].resume();
      }
      const r = this.effects.slice();
      for (A = 0, t = r.length; A < t; A++)
        r[A].resume();
    }
  }
  run(A) {
    if (this._active) {
      const t = nn;
      try {
        return nn = this, A();
      } finally {
        nn = t;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = nn, nn = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    if (this._on > 0 && --this._on === 0) {
      if (nn === this)
        nn = this.prevScope;
      else {
        let A = nn;
        for (; A; ) {
          if (A.prevScope === this) {
            A.prevScope = this.prevScope;
            break;
          }
          A = A.prevScope;
        }
      }
      this.prevScope = void 0;
    }
  }
  stop(A) {
    if (this._active) {
      this._active = !1;
      let t, r;
      for (t = 0, r = this.effects.length; t < r; t++)
        this.effects[t].stop();
      for (this.effects.length = 0, t = 0, r = this.cleanups.length; t < r; t++)
        this.cleanups[t]();
      if (this.cleanups.length = 0, this.scopes) {
        const n = this.scopes.slice();
        for (t = 0, r = n.length; t < r; t++)
          n[t].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !A) {
        const n = this.parent.scopes.pop();
        n && n !== this && (this.parent.scopes[this.index] = n, n.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function p_() {
  return nn;
}
let xt;
const oB = /* @__PURE__ */ new WeakSet();
class Qx {
  constructor(A) {
    this.fn = A, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, nn && (nn.active ? nn.effects.push(this) : this.flags &= -2);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, oB.has(this) && (oB.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Ex(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, lC(this), xx(this);
    const A = xt, t = ms;
    xt = this, ms = !0;
    try {
      return this.fn();
    } finally {
      Ix(this), xt = A, ms = t, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let A = this.deps; A; A = A.nextDep)
        By(A);
      this.deps = this.depsTail = void 0, lC(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? oB.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    b1(this) && this.run();
  }
  get dirty() {
    return b1(this);
  }
}
let Ux = 0, hh, fh;
function Ex(e, A = !1) {
  if (e.flags |= 8, A) {
    e.next = fh, fh = e;
    return;
  }
  e.next = hh, hh = e;
}
function gy() {
  Ux++;
}
function py() {
  if (--Ux > 0)
    return;
  if (fh) {
    let A = fh;
    for (fh = void 0; A; ) {
      const t = A.next;
      A.next = void 0, A.flags &= -9, A = t;
    }
  }
  let e;
  for (; hh; ) {
    let A = hh;
    for (hh = void 0; A; ) {
      const t = A.next;
      if (A.next = void 0, A.flags &= -9, A.flags & 1)
        try {
          A.trigger();
        } catch (r) {
          e || (e = r);
        }
      A = t;
    }
  }
  if (e) throw e;
}
function xx(e) {
  for (let A = e.deps; A; A = A.nextDep)
    A.version = -1, A.prevActiveLink = A.dep.activeLink, A.dep.activeLink = A;
}
function Ix(e) {
  let A, t = e.depsTail, r = t;
  for (; r; ) {
    const n = r.prevDep;
    r.version === -1 ? (r === t && (t = n), By(r), B_(r)) : A = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = n;
  }
  e.deps = A, e.depsTail = t;
}
function b1(e) {
  for (let A = e.deps; A; A = A.nextDep)
    if (A.dep.version !== A.version || A.dep.computed && (Sx(A.dep.computed) || A.dep.version !== A.version))
      return !0;
  return !!e._dirty;
}
function Sx(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Eh) || (e.globalVersion = Eh, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !b1(e))))
    return;
  e.flags |= 2;
  const A = e.dep, t = xt, r = ms;
  xt = e, ms = !0;
  try {
    xx(e);
    const n = e.fn(e._value);
    (A.version === 0 || Ws(n, e._value)) && (e.flags |= 128, e._value = n, A.version++);
  } catch (n) {
    throw A.version++, n;
  } finally {
    xt = t, ms = r, Ix(e), e.flags &= -3;
  }
}
function By(e, A = !1) {
  const { dep: t, prevSub: r, nextSub: n } = e;
  if (r && (r.nextSub = n, e.prevSub = void 0), n && (n.prevSub = r, e.nextSub = void 0), t.subs === e && (t.subs = r, !r && t.computed)) {
    t.computed.flags &= -5;
    for (let i = t.computed.deps; i; i = i.nextDep)
      By(i, !0);
  }
  !A && !--t.sc && t.map && t.map.delete(t.key);
}
function B_(e) {
  const { prevDep: A, nextDep: t } = e;
  A && (A.nextDep = t, e.prevDep = void 0), t && (t.prevDep = A, e.nextDep = void 0);
}
let ms = !0;
const Lx = [];
function Ta() {
  Lx.push(ms), ms = !1;
}
function _a() {
  const e = Lx.pop();
  ms = e === void 0 ? !0 : e;
}
function lC(e) {
  const { cleanup: A } = e;
  if (e.cleanup = void 0, A) {
    const t = xt;
    xt = void 0;
    try {
      A();
    } finally {
      xt = t;
    }
  }
}
let Eh = 0;
class w_ {
  constructor(A, t) {
    this.sub = A, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class wy {
  // TODO isolatedDeclarations "__v_skip"
  constructor(A) {
    this.computed = A, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0;
  }
  track(A) {
    if (!xt || !ms || xt === this.computed)
      return;
    let t = this.activeLink;
    if (t === void 0 || t.sub !== xt)
      t = this.activeLink = new w_(xt, this), xt.deps ? (t.prevDep = xt.depsTail, xt.depsTail.nextDep = t, xt.depsTail = t) : xt.deps = xt.depsTail = t, Hx(t);
    else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
      const r = t.nextDep;
      r.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = r), t.prevDep = xt.depsTail, t.nextDep = void 0, xt.depsTail.nextDep = t, xt.depsTail = t, xt.deps === t && (xt.deps = r);
    }
    return t;
  }
  trigger(A) {
    this.version++, Eh++, this.notify(A);
  }
  notify(A) {
    gy();
    try {
      for (let t = this.subs; t; t = t.prevSub)
        t.sub.notify() && t.sub.dep.notify();
    } finally {
      py();
    }
  }
}
function Hx(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const A = e.dep.computed;
    if (A && !e.dep.subs) {
      A.flags |= 20;
      for (let r = A.deps; r; r = r.nextDep)
        Hx(r);
    }
    const t = e.dep.subs;
    t !== e && (e.prevSub = t, t && (t.nextSub = e)), e.dep.subs = e;
  }
}
const F1 = /* @__PURE__ */ new WeakMap(), _l = /* @__PURE__ */ Symbol(
  ""
), Q1 = /* @__PURE__ */ Symbol(
  ""
), xh = /* @__PURE__ */ Symbol(
  ""
);
function En(e, A, t) {
  if (ms && xt) {
    let r = F1.get(e);
    r || F1.set(e, r = /* @__PURE__ */ new Map());
    let n = r.get(t);
    n || (r.set(t, n = new wy()), n.map = r, n.key = t), n.track();
  }
}
function Ea(e, A, t, r, n, i) {
  const s = F1.get(e);
  if (!s) {
    Eh++;
    return;
  }
  const a = (o) => {
    o && o.trigger();
  };
  if (gy(), A === "clear")
    s.forEach(a);
  else {
    const o = Se(e), l = o && fy(t);
    if (o && t === "length") {
      const c = Number(r);
      s.forEach((u, d) => {
        (d === "length" || d === xh || !ys(d) && d >= c) && a(u);
      });
    } else
      switch ((t !== void 0 || s.has(void 0)) && a(s.get(t)), l && a(s.get(xh)), A) {
        case "add":
          o ? l && a(s.get("length")) : (a(s.get(_l)), Lo(e) && a(s.get(Q1)));
          break;
        case "delete":
          o || (a(s.get(_l)), Lo(e) && a(s.get(Q1)));
          break;
        case "set":
          Lo(e) && a(s.get(_l));
          break;
      }
  }
  py();
}
function Bc(e) {
  const A = /* @__PURE__ */ at(e);
  return A === e || (En(A, "iterate", xh), /* @__PURE__ */ Yi(e)) ? A : /* @__PURE__ */ zs(e) ? /* @__PURE__ */ Ho(e) ? A.map((t) => Do(Ji(t))) : A.map(Do) : A.map(Ji);
}
function Wg(e) {
  return En(e = /* @__PURE__ */ at(e), "iterate", xh), e;
}
function Vs(e, A) {
  return /* @__PURE__ */ zs(e) ? Do(/* @__PURE__ */ Ho(e) ? Ji(A) : A) : Ji(A);
}
const m_ = {
  __proto__: null,
  [Symbol.iterator]() {
    return lB(this, Symbol.iterator, (e) => Vs(this, e));
  },
  concat(...e) {
    return Bc(this).concat(
      ...e.map((A) => Se(A) ? Bc(A) : A)
    );
  },
  entries() {
    return lB(this, "entries", (e) => (e[1] = Vs(this, e[1]), e));
  },
  every(e, A) {
    return da(this, "every", e, A, void 0, arguments);
  },
  filter(e, A) {
    return da(
      this,
      "filter",
      e,
      A,
      (t) => t.map((r) => Vs(this, r)),
      arguments
    );
  },
  find(e, A) {
    return da(
      this,
      "find",
      e,
      A,
      (t) => Vs(this, t),
      arguments
    );
  },
  findIndex(e, A) {
    return da(this, "findIndex", e, A, void 0, arguments);
  },
  findLast(e, A) {
    return da(
      this,
      "findLast",
      e,
      A,
      (t) => Vs(this, t),
      arguments
    );
  },
  findLastIndex(e, A) {
    return da(this, "findLastIndex", e, A, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, A) {
    return da(this, "forEach", e, A, void 0, arguments);
  },
  includes(...e) {
    return cB(this, "includes", e);
  },
  indexOf(...e) {
    return cB(this, "indexOf", e);
  },
  join(e) {
    return Bc(this).join(e);
  },
  // keys() iterator only reads `length`, no optimization required
  lastIndexOf(...e) {
    return cB(this, "lastIndexOf", e);
  },
  map(e, A) {
    return da(this, "map", e, A, void 0, arguments);
  },
  pop() {
    return yu(this, "pop");
  },
  push(...e) {
    return yu(this, "push", e);
  },
  reduce(e, ...A) {
    return cC(this, "reduce", e, A);
  },
  reduceRight(e, ...A) {
    return cC(this, "reduceRight", e, A);
  },
  shift() {
    return yu(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, A) {
    return da(this, "some", e, A, void 0, arguments);
  },
  splice(...e) {
    return yu(this, "splice", e);
  },
  toReversed() {
    return Bc(this).toReversed();
  },
  toSorted(e) {
    return Bc(this).toSorted(e);
  },
  toSpliced(...e) {
    return Bc(this).toSpliced(...e);
  },
  unshift(...e) {
    return yu(this, "unshift", e);
  },
  values() {
    return lB(this, "values", (e) => Vs(this, e));
  }
};
function lB(e, A, t) {
  const r = Wg(e), n = r[A]();
  return r !== e && !/* @__PURE__ */ Yi(e) && (n._next = n.next, n.next = () => {
    const i = n._next();
    return i.done || (i.value = t(i.value)), i;
  }), n;
}
const v_ = Array.prototype;
function da(e, A, t, r, n, i) {
  const s = Wg(e), a = s !== e && !/* @__PURE__ */ Yi(e), o = s[A];
  if (o !== v_[A]) {
    const u = o.apply(e, i);
    return a ? Ji(u) : u;
  }
  let l = t;
  s !== e && (a ? l = function(u, d) {
    return t.call(this, Vs(e, u), d, e);
  } : t.length > 2 && (l = function(u, d) {
    return t.call(this, u, d, e);
  }));
  const c = o.call(s, l, r);
  return a && n ? n(c) : c;
}
function cC(e, A, t, r) {
  const n = Wg(e), i = n !== e && !/* @__PURE__ */ Yi(e);
  let s = t, a = !1;
  n !== e && (i ? (a = r.length === 0, s = function(l, c, u) {
    return a && (a = !1, l = Vs(e, l)), t.call(this, l, Vs(e, c), u, e);
  }) : t.length > 3 && (s = function(l, c, u) {
    return t.call(this, l, c, u, e);
  }));
  const o = n[A](s, ...r);
  return a ? Vs(e, o) : o;
}
function cB(e, A, t) {
  const r = /* @__PURE__ */ at(e);
  En(r, "iterate", xh);
  const n = r[A](...t);
  return (n === -1 || n === !1) && /* @__PURE__ */ yy(t[0]) ? (t[0] = /* @__PURE__ */ at(t[0]), r[A](...t)) : n;
}
function yu(e, A, t = []) {
  Ta(), gy();
  const r = (/* @__PURE__ */ at(e))[A].apply(e, t);
  return py(), _a(), r;
}
const y_ = /* @__PURE__ */ uy("__proto__,__v_isRef,__isVue"), Tx = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(ys)
);
function C_(e) {
  ys(e) || (e = String(e));
  const A = /* @__PURE__ */ at(this);
  return En(A, "has", e), A.hasOwnProperty(e);
}
class _x {
  constructor(A = !1, t = !1) {
    this._isReadonly = A, this._isShallow = t;
  }
  get(A, t, r) {
    if (t === "__v_skip") return A.__v_skip;
    const n = this._isReadonly, i = this._isShallow;
    if (t === "__v_isReactive")
      return !n;
    if (t === "__v_isReadonly")
      return n;
    if (t === "__v_isShallow")
      return i;
    if (t === "__v_raw")
      return r === (n ? i ? H_ : Rx : i ? Dx : Nx).get(A) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(A) === Object.getPrototypeOf(r) ? A : void 0;
    const s = Se(A);
    if (!n) {
      let o;
      if (s && (o = m_[t]))
        return o;
      if (t === "hasOwnProperty")
        return C_;
    }
    const a = Reflect.get(
      A,
      t,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      /* @__PURE__ */ Ln(A) ? A : r
    );
    if ((ys(t) ? Tx.has(t) : y_(t)) || (n || En(A, "get", t), i))
      return a;
    if (/* @__PURE__ */ Ln(a)) {
      const o = s && fy(t) ? a : a.value;
      return n && dt(o) ? /* @__PURE__ */ E1(o) : o;
    }
    return dt(a) ? n ? /* @__PURE__ */ E1(a) : /* @__PURE__ */ $l(a) : a;
  }
}
class Ox extends _x {
  constructor(A = !1) {
    super(!1, A);
  }
  set(A, t, r, n) {
    let i = A[t];
    const s = Se(A) && fy(t);
    if (!this._isShallow) {
      const l = /* @__PURE__ */ zs(i);
      if (!/* @__PURE__ */ Yi(r) && !/* @__PURE__ */ zs(r) && (i = /* @__PURE__ */ at(i), r = /* @__PURE__ */ at(r)), !s && /* @__PURE__ */ Ln(i) && !/* @__PURE__ */ Ln(r))
        return l || (i.value = r), !0;
    }
    const a = s ? Number(t) < A.length : ut(A, t), o = Reflect.set(
      A,
      t,
      r,
      /* @__PURE__ */ Ln(A) ? A : n
    );
    return A === /* @__PURE__ */ at(n) && o && (a ? Ws(r, i) && Ea(A, "set", t, r) : Ea(A, "add", t, r)), o;
  }
  deleteProperty(A, t) {
    const r = ut(A, t);
    A[t];
    const n = Reflect.deleteProperty(A, t);
    return n && r && Ea(A, "delete", t, void 0), n;
  }
  has(A, t) {
    const r = Reflect.has(A, t);
    return (!ys(t) || !Tx.has(t)) && En(A, "has", t), r;
  }
  ownKeys(A) {
    return En(
      A,
      "iterate",
      Se(A) ? "length" : _l
    ), Reflect.ownKeys(A);
  }
}
class b_ extends _x {
  constructor(A = !1) {
    super(!0, A);
  }
  set(A, t) {
    return !0;
  }
  deleteProperty(A, t) {
    return !0;
  }
}
const F_ = /* @__PURE__ */ new Ox(), Q_ = /* @__PURE__ */ new b_(), U_ = /* @__PURE__ */ new Ox(!0);
const U1 = (e) => e, Tf = (e) => Reflect.getPrototypeOf(e);
function E_(e, A, t) {
  return function(...r) {
    const n = this.__v_raw, i = /* @__PURE__ */ at(n), s = Lo(i), a = e === "entries" || e === Symbol.iterator && s, o = e === "keys" && s, l = n[e](...r), c = t ? U1 : A ? Do : Ji;
    return !A && En(
      i,
      "iterate",
      o ? Q1 : _l
    ), Gr(
      // inheriting all iterator properties
      Object.create(l),
      {
        // iterator protocol
        next() {
          const { value: u, done: d } = l.next();
          return d ? { value: u, done: d } : {
            value: a ? [c(u[0]), c(u[1])] : c(u),
            done: d
          };
        }
      }
    );
  };
}
function _f(e) {
  return function(...A) {
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function x_(e, A) {
  const t = {
    get(n) {
      const i = this.__v_raw, s = /* @__PURE__ */ at(i), a = /* @__PURE__ */ at(n);
      e || (Ws(n, a) && En(s, "get", n), En(s, "get", a));
      const { has: o } = Tf(s), l = A ? U1 : e ? Do : Ji;
      if (o.call(s, n))
        return l(i.get(n));
      if (o.call(s, a))
        return l(i.get(a));
      i !== s && i.get(n);
    },
    get size() {
      const n = this.__v_raw;
      return !e && En(/* @__PURE__ */ at(n), "iterate", _l), n.size;
    },
    has(n) {
      const i = this.__v_raw, s = /* @__PURE__ */ at(i), a = /* @__PURE__ */ at(n);
      return e || (Ws(n, a) && En(s, "has", n), En(s, "has", a)), n === a ? i.has(n) : i.has(n) || i.has(a);
    },
    forEach(n, i) {
      const s = this, a = s.__v_raw, o = /* @__PURE__ */ at(a), l = A ? U1 : e ? Do : Ji;
      return !e && En(o, "iterate", _l), a.forEach((c, u) => n.call(i, l(c), l(u), s));
    }
  };
  return Gr(
    t,
    e ? {
      add: _f("add"),
      set: _f("set"),
      delete: _f("delete"),
      clear: _f("clear")
    } : {
      add(n) {
        const i = /* @__PURE__ */ at(this), s = Tf(i), a = /* @__PURE__ */ at(n), o = !A && !/* @__PURE__ */ Yi(n) && !/* @__PURE__ */ zs(n) ? a : n;
        return s.has.call(i, o) || Ws(n, o) && s.has.call(i, n) || Ws(a, o) && s.has.call(i, a) || (i.add(o), Ea(i, "add", o, o)), this;
      },
      set(n, i) {
        !A && !/* @__PURE__ */ Yi(i) && !/* @__PURE__ */ zs(i) && (i = /* @__PURE__ */ at(i));
        const s = /* @__PURE__ */ at(this), { has: a, get: o } = Tf(s);
        let l = a.call(s, n);
        l || (n = /* @__PURE__ */ at(n), l = a.call(s, n));
        const c = o.call(s, n);
        return s.set(n, i), l ? Ws(i, c) && Ea(s, "set", n, i) : Ea(s, "add", n, i), this;
      },
      delete(n) {
        const i = /* @__PURE__ */ at(this), { has: s, get: a } = Tf(i);
        let o = s.call(i, n);
        o || (n = /* @__PURE__ */ at(n), o = s.call(i, n)), a && a.call(i, n);
        const l = i.delete(n);
        return o && Ea(i, "delete", n, void 0), l;
      },
      clear() {
        const n = /* @__PURE__ */ at(this), i = n.size !== 0, s = n.clear();
        return i && Ea(
          n,
          "clear",
          void 0,
          void 0
        ), s;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((n) => {
    t[n] = E_(n, e, A);
  }), t;
}
function my(e, A) {
  const t = x_(e, A);
  return (r, n, i) => n === "__v_isReactive" ? !e : n === "__v_isReadonly" ? e : n === "__v_raw" ? r : Reflect.get(
    ut(t, n) && n in r ? t : r,
    n,
    i
  );
}
const I_ = {
  get: /* @__PURE__ */ my(!1, !1)
}, S_ = {
  get: /* @__PURE__ */ my(!1, !0)
}, L_ = {
  get: /* @__PURE__ */ my(!0, !1)
};
const Nx = /* @__PURE__ */ new WeakMap(), Dx = /* @__PURE__ */ new WeakMap(), Rx = /* @__PURE__ */ new WeakMap(), H_ = /* @__PURE__ */ new WeakMap();
function T_(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
// @__NO_SIDE_EFFECTS__
function $l(e) {
  return /* @__PURE__ */ zs(e) ? e : vy(
    e,
    !1,
    F_,
    I_,
    Nx
  );
}
// @__NO_SIDE_EFFECTS__
function __(e) {
  return vy(
    e,
    !1,
    U_,
    S_,
    Dx
  );
}
// @__NO_SIDE_EFFECTS__
function E1(e) {
  return vy(
    e,
    !0,
    Q_,
    L_,
    Rx
  );
}
function vy(e, A, t, r, n) {
  if (!dt(e) || e.__v_raw && !(A && e.__v_isReactive) || e.__v_skip || !Object.isExtensible(e))
    return e;
  const i = n.get(e);
  if (i)
    return i;
  const s = T_(r_(e));
  if (s === 0)
    return e;
  const a = new Proxy(
    e,
    s === 2 ? r : t
  );
  return n.set(e, a), a;
}
// @__NO_SIDE_EFFECTS__
function Ho(e) {
  return /* @__PURE__ */ zs(e) ? /* @__PURE__ */ Ho(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function zs(e) {
  return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function Yi(e) {
  return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function yy(e) {
  return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function at(e) {
  const A = e && e.__v_raw;
  return A ? /* @__PURE__ */ at(A) : e;
}
function O_(e) {
  return !ut(e, "__v_skip") && Object.isExtensible(e) && vx(e, "__v_skip", !0), e;
}
const Ji = (e) => dt(e) ? /* @__PURE__ */ $l(e) : e, Do = (e) => dt(e) ? /* @__PURE__ */ E1(e) : e;
// @__NO_SIDE_EFFECTS__
function Ln(e) {
  return e ? e.__v_isRef === !0 : !1;
}
// @__NO_SIDE_EFFECTS__
function We(e) {
  return N_(e, !1);
}
function N_(e, A) {
  return /* @__PURE__ */ Ln(e) ? e : new D_(e, A);
}
class D_ {
  constructor(A, t) {
    this.dep = new wy(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = t ? A : /* @__PURE__ */ at(A), this._value = t ? A : Ji(A), this.__v_isShallow = t;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(A) {
    const t = this._rawValue, r = this.__v_isShallow || /* @__PURE__ */ Yi(A) || /* @__PURE__ */ zs(A);
    A = r ? A : /* @__PURE__ */ at(A), Ws(A, t) && (this._rawValue = A, this._value = r ? A : Ji(A), this.dep.trigger());
  }
}
function lt(e) {
  return /* @__PURE__ */ Ln(e) ? e.value : e;
}
const R_ = {
  get: (e, A, t) => A === "__v_raw" ? e : lt(Reflect.get(e, A, t)),
  set: (e, A, t, r) => {
    const n = e[A];
    return /* @__PURE__ */ Ln(n) && !/* @__PURE__ */ Ln(t) ? (n.value = t, !0) : Reflect.set(e, A, t, r);
  }
};
function Mx(e) {
  return /* @__PURE__ */ Ho(e) ? e : new Proxy(e, R_);
}
class M_ {
  constructor(A, t, r) {
    this.fn = A, this.setter = t, this._value = void 0, this.dep = new wy(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Eh - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !t, this.isSSR = r;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    xt !== this)
      return Ex(this, !0), !0;
  }
  get value() {
    const A = this.dep.track();
    return Sx(this), A && (A.version = this.dep.version), this._value;
  }
  set value(A) {
    this.setter && this.setter(A);
  }
}
// @__NO_SIDE_EFFECTS__
function P_(e, A, t = !1) {
  let r, n;
  return Re(e) ? r = e : (r = e.get, n = e.set), new M_(r, n, t);
}
const Of = {}, sg = /* @__PURE__ */ new WeakMap();
let Bl;
function k_(e, A = !1, t = Bl) {
  if (t) {
    let r = sg.get(t);
    r || sg.set(t, r = []), r.push(e);
  }
}
function K_(e, A, t = Ft) {
  const { immediate: r, deep: n, once: i, scheduler: s, augmentJob: a, call: o } = t, l = (F) => n ? F : /* @__PURE__ */ Yi(F) || n === !1 || n === 0 ? xa(F, 1) : xa(F);
  let c, u, d, h, p = !1, B = !1;
  if (/* @__PURE__ */ Ln(e) ? (u = () => e.value, p = /* @__PURE__ */ Yi(e)) : /* @__PURE__ */ Ho(e) ? (u = () => l(e), p = !0) : Se(e) ? (B = !0, p = e.some((F) => /* @__PURE__ */ Ho(F) || /* @__PURE__ */ Yi(F)), u = () => e.map((F) => {
    if (/* @__PURE__ */ Ln(F))
      return F.value;
    if (/* @__PURE__ */ Ho(F))
      return l(F);
    if (Re(F))
      return o ? o(F, 2) : F();
  })) : Re(e) ? A ? u = o ? () => o(e, 2) : e : u = () => {
    if (d) {
      Ta();
      try {
        d();
      } finally {
        _a();
      }
    }
    const F = Bl;
    Bl = c;
    try {
      return o ? o(e, 3, [h]) : e(h);
    } finally {
      Bl = F;
    }
  } : u = qs, A && n) {
    const F = u, T = n === !0 ? 1 / 0 : n;
    u = () => xa(F(), T);
  }
  const y = p_(), m = () => {
    c.stop(), y && y.active && hy(y.effects, c);
  };
  if (i && A) {
    const F = A;
    A = (...T) => {
      const V = F(...T);
      return m(), V;
    };
  }
  let C = B ? new Array(e.length).fill(Of) : Of;
  const Q = (F) => {
    if (!(!(c.flags & 1) || !c.dirty && !F))
      if (A) {
        const T = c.run();
        if (F || n || p || (B ? T.some((V, M) => Ws(V, C[M])) : Ws(T, C))) {
          d && d();
          const V = Bl;
          Bl = c;
          try {
            const M = [
              T,
              // pass undefined as the old value when it's changed for the first time
              C === Of ? void 0 : B && C[0] === Of ? [] : C,
              h
            ];
            C = T, o ? o(A, 3, M) : (
              // @ts-expect-error
              A(...M)
            );
          } finally {
            Bl = V;
          }
        }
      } else
        c.run();
  };
  return a && a(Q), c = new Qx(u), c.scheduler = s ? () => s(Q, !1) : Q, h = (F) => k_(F, !1, c), d = c.onStop = () => {
    const F = sg.get(c);
    if (F) {
      if (o)
        o(F, 4);
      else
        for (const T of F) T();
      sg.delete(c);
    }
  }, A ? r ? Q(!0) : C = c.run() : s ? s(Q.bind(null, !0), !0) : c.run(), m.pause = c.pause.bind(c), m.resume = c.resume.bind(c), m.stop = m, m;
}
function xa(e, A = 1 / 0, t) {
  if (A <= 0 || !dt(e) || e.__v_skip || (t = t || /* @__PURE__ */ new Map(), (t.get(e) || 0) >= A))
    return e;
  if (t.set(e, A), A--, /* @__PURE__ */ Ln(e))
    xa(e.value, A, t);
  else if (Se(e))
    for (let r = 0; r < e.length; r++)
      xa(e[r], A, t);
  else if (Jc(e) || Lo(e))
    e.forEach((r) => {
      xa(r, A, t);
    });
  else if (mx(e)) {
    for (const r in e)
      xa(e[r], A, t);
    for (const r of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, r) && xa(e[r], A, t);
  }
  return e;
}
function $h(e, A, t, r) {
  try {
    return r ? e(...r) : e();
  } catch (n) {
    jg(n, A, t);
  }
}
function Zi(e, A, t, r) {
  if (Re(e)) {
    const n = $h(e, A, t, r);
    return n && Bx(n) && n.catch((i) => {
      jg(i, A, t);
    }), n;
  }
  if (Se(e)) {
    const n = [];
    for (let i = 0; i < e.length; i++)
      n.push(Zi(e[i], A, t, r));
    return n;
  }
}
function jg(e, A, t, r = !0) {
  const n = A ? A.vnode : null, { errorHandler: i, throwUnhandledErrorInProduction: s } = A && A.appContext.config || Ft;
  if (A) {
    let a = A.parent;
    const o = A.proxy, l = `https://vuejs.org/error-reference/#runtime-${t}`;
    for (; a; ) {
      const c = a.ec;
      if (c) {
        for (let u = 0; u < c.length; u++)
          if (c[u](e, o, l) === !1)
            return;
      }
      a = a.parent;
    }
    if (i) {
      Ta(), $h(i, null, 10, [
        e,
        o,
        l
      ]), _a();
      return;
    }
  }
  V_(e, t, n, r, s);
}
function V_(e, A, t, r = !0, n = !1) {
  if (n)
    throw e;
  console.error(e);
}
const Xn = [];
let Ps = -1;
const Vc = [];
let mo = null, _c = 0;
const Px = /* @__PURE__ */ Promise.resolve();
let ag = null;
function x1(e) {
  const A = ag || Px;
  return e ? A.then(this ? e.bind(this) : e) : A;
}
function G_(e) {
  let A = Ps + 1, t = Xn.length;
  for (; A < t; ) {
    const r = A + t >>> 1, n = Xn[r], i = Ih(n);
    i < e || i === e && n.flags & 2 ? A = r + 1 : t = r;
  }
  return A;
}
function Cy(e) {
  if (!(e.flags & 1)) {
    const A = Ih(e), t = Xn[Xn.length - 1];
    !t || // fast path when the job id is larger than the tail
    !(e.flags & 2) && A >= Ih(t) ? Xn.push(e) : Xn.splice(G_(A), 0, e), e.flags |= 1, kx();
  }
}
function kx() {
  ag || (ag = Px.then(Vx));
}
function W_(e) {
  if (!Se(e))
    mo && e.id === -1 ? mo.splice(_c + 1, 0, e) : e.flags & 1 || (Vc.push(e), e.flags |= 1);
  else
    for (let A = 0; A < e.length; A++)
      Vc.push(e[A]);
  kx();
}
function uC(e, A, t = Ps + 1) {
  for (; t < Xn.length; t++) {
    const r = Xn[t];
    if (r && r.flags & 2) {
      if (e && r.id !== e.uid)
        continue;
      Xn.splice(t, 1), t--, r.flags & 4 && (r.flags &= -2), r(), r.flags & 4 || (r.flags &= -2);
    }
  }
}
function Kx(e) {
  if (Vc.length) {
    const A = [...new Set(Vc)].sort(
      (t, r) => Ih(t) - Ih(r)
    );
    if (Vc.length = 0, mo) {
      for (let t = 0; t < A.length; t++)
        mo.push(A[t]);
      return;
    }
    for (mo = A, _c = 0; _c < mo.length; _c++) {
      const t = mo[_c];
      t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2;
    }
    mo = null, _c = 0;
  }
}
const Ih = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Vx(e) {
  try {
    for (Ps = 0; Ps < Xn.length; Ps++) {
      const A = Xn[Ps];
      A && !(A.flags & 8) && (A.flags & 4 && (A.flags &= -2), $h(
        A,
        A.i,
        A.i ? 15 : 14
      ), A.flags & 4 || (A.flags &= -2));
    }
  } finally {
    for (; Ps < Xn.length; Ps++) {
      const A = Xn[Ps];
      A && (A.flags &= -2);
    }
    Ps = -1, Xn.length = 0, Kx(), ag = null, (Xn.length || Vc.length) && Vx();
  }
}
let on = null, Gx = null;
function og(e) {
  const A = on;
  return on = e, Gx = e && e.type.__scopeId || null, A;
}
function Fa(e, A = on, t) {
  if (!A || e._n)
    return e;
  const r = (...n) => {
    r._d && fg(-1);
    const i = og(A), s = La.length;
    let a;
    try {
      a = e(...n);
    } finally {
      for (let o = La.length; o > s; o--) xy();
      og(i), r._d && fg(1);
    }
    return a;
  };
  return r._n = !0, r._c = !0, r._d = !0, r;
}
function lo(e, A) {
  if (on === null)
    return e;
  const t = Zg(on), r = e.dirs || (e.dirs = []);
  for (let n = 0; n < A.length; n++) {
    let [i, s, a, o = Ft] = A[n];
    i && (Re(i) && (i = {
      mounted: i,
      updated: i
    }), i.deep && xa(s), r.push({
      dir: i,
      instance: t,
      value: s,
      oldValue: void 0,
      arg: a,
      modifiers: o
    }));
  }
  return e;
}
function ol(e, A, t, r) {
  const n = e.dirs, i = A && A.dirs;
  for (let s = 0; s < n.length; s++) {
    const a = n[s];
    i && (a.oldValue = i[s].value);
    let o = a.dir[r];
    o && (Ta(), Zi(o, t, 8, [
      e.el,
      a,
      e,
      A
    ]), _a());
  }
}
function j_(e, A) {
  if (In) {
    let t = In.provides;
    const r = In.parent && In.parent.provides;
    r === t && (t = In.provides = Object.create(r)), t[e] = A;
  }
}
function jd(e, A, t = !1) {
  const r = vI();
  if (r || Wc) {
    let n = Wc ? Wc._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
    if (n && e in n)
      return n[e];
    if (arguments.length > 1)
      return t && Re(A) ? A.call(r && r.proxy) : A;
  }
}
const q_ = /* @__PURE__ */ Symbol.for("v-scx"), $_ = () => jd(q_);
function uB(e, A, t) {
  return Wx(e, A, t);
}
function Wx(e, A, t = Ft) {
  const { immediate: r, deep: n, flush: i, once: s } = t, a = Gr({}, t), o = A && r || !A && i !== "post";
  let l;
  if (_h) {
    if (i === "sync") {
      const h = $_();
      l = h.__watcherHandles || (h.__watcherHandles = []);
    } else if (!o) {
      const h = () => {
      };
      return h.stop = qs, h.resume = qs, h.pause = qs, h;
    }
  }
  const c = In;
  a.call = (h, p, B) => Zi(h, c, p, B);
  let u = !1;
  i === "post" ? a.scheduler = (h) => {
    $n(h, c && c.suspense);
  } : i !== "sync" && (u = !0, a.scheduler = (h, p) => {
    p ? h() : Cy(h);
  }), a.augmentJob = (h) => {
    A && (h.flags |= 4), u && (h.flags |= 2, c && (h.id = c.uid, h.i = c));
  };
  const d = K_(e, A, a);
  return _h && (l ? l.push(d) : o && d()), d;
}
function z_(e, A, t) {
  const r = this.proxy, n = kt(e) ? e.includes(".") ? jx(r, e) : () => r[e] : e.bind(r, r);
  let i;
  Re(A) ? i = A : (i = A.handler, t = A);
  const s = zh(this), a = Wx(n, i.bind(r), t);
  return s(), a;
}
function jx(e, A) {
  const t = A.split(".");
  return () => {
    let r = e;
    for (let n = 0; n < t.length && r; n++)
      r = r[t[n]];
    return r;
  };
}
const go = /* @__PURE__ */ new WeakMap(), qx = /* @__PURE__ */ Symbol("_vte"), qg = (e) => e.__isTeleport, yl = (e) => e && (e.disabled || e.disabled === ""), X_ = (e) => e && (e.defer || e.defer === ""), hC = (e) => typeof SVGElement < "u" && e instanceof SVGElement, fC = (e) => typeof MathMLElement == "function" && e instanceof MathMLElement, I1 = (e, A) => {
  const t = e && e.to;
  return kt(t) ? A ? A(t) : null : t;
}, Y_ = {
  name: "Teleport",
  __isTeleport: !0,
  process(e, A, t, r, n, i, s, a, o, l) {
    const {
      mc: c,
      pc: u,
      pbc: d,
      o: { insert: h, querySelector: p, createText: B, createComment: y, parentNode: m }
    } = l, C = yl(A.props);
    let { dynamicChildren: Q } = A;
    const F = (M, D, I) => {
      M.shapeFlag & 16 && c(
        M.children,
        D,
        I,
        n,
        i,
        s,
        a,
        o
      );
    }, T = (M = A) => {
      const D = yl(M.props), I = M.target = I1(M.props, p), q = S1(I, M, B, h);
      I && (s !== "svg" && hC(I) ? s = "svg" : s !== "mathml" && fC(I) && (s = "mathml"), n && n.isCE && (n.ce._teleportTargets || (n.ce._teleportTargets = /* @__PURE__ */ new Set())).add(I), D || (F(M, I, q), Gu(M, !1)));
    }, V = (M) => {
      const D = () => {
        if (go.get(M) === D) {
          if (go.delete(M), yl(M.props)) {
            const I = m(M.el) || t;
            F(M, I, M.anchor), Gu(M, !0);
          }
          T(M);
        }
      };
      go.set(M, D), $n(D, i);
    };
    if (e == null) {
      const M = A.el = B(""), D = A.anchor = B("");
      if (h(M, t, r), h(D, t, r), X_(A.props) || i && i.pendingBranch) {
        V(A);
        return;
      }
      C && (F(A, t, D), Gu(A, !0)), T();
    } else {
      A.el = e.el;
      const M = A.anchor = e.anchor, D = go.get(e);
      if (D) {
        D.flags |= 8, go.delete(e), V(A);
        return;
      }
      A.targetStart = e.targetStart;
      const I = A.target = e.target, q = A.targetAnchor = e.targetAnchor, U = yl(e.props), x = U ? t : I, P = U ? M : q;
      if (s === "svg" || hC(I) ? s = "svg" : (s === "mathml" || fC(I)) && (s = "mathml"), Q ? (d(
        e.dynamicChildren,
        Q,
        x,
        n,
        i,
        s,
        a
      ), Ey(e, A, !0)) : o || u(
        e,
        A,
        x,
        P,
        n,
        i,
        s,
        a,
        !1
      ), C)
        U ? A.props && e.props && A.props.to !== e.props.to && (A.props.to = e.props.to) : Nf(
          A,
          t,
          M,
          l,
          1
        );
      else if ((A.props && A.props.to) !== (e.props && e.props.to)) {
        const N = I1(A.props, p);
        N && (A.target = N, Nf(
          A,
          N,
          null,
          l,
          0
        ));
      } else U && Nf(
        A,
        I,
        q,
        l,
        1
      );
      Gu(A, C);
    }
  },
  remove(e, A, t, { um: r, o: { remove: n } }, i) {
    const {
      shapeFlag: s,
      children: a,
      anchor: o,
      targetStart: l,
      targetAnchor: c,
      target: u,
      props: d
    } = e, h = yl(d), p = i || !h, B = go.get(e);
    if (B && (B.flags |= 8, go.delete(e)), u && (n(l), n(c)), i && n(o), !B && (h || u) && s & 16)
      for (let y = 0; y < a.length; y++) {
        const m = a[y];
        r(
          m,
          A,
          t,
          p,
          !!m.dynamicChildren
        );
      }
  },
  move: Nf,
  hydrate: J_
};
function Nf(e, A, t, { o: { insert: r }, m: n }, i = 2) {
  i === 0 && r(e.targetAnchor, A, t);
  const { el: s, anchor: a, shapeFlag: o, children: l, props: c } = e, u = i === 2;
  if (u && r(s, A, t), !go.has(e) && (!u || yl(c)) && o & 16)
    for (let d = 0; d < l.length; d++)
      n(
        l[d],
        A,
        t,
        2
      );
  u && r(a, A, t);
}
function J_(e, A, t, r, n, i, {
  o: { nextSibling: s, parentNode: a, querySelector: o, insert: l, createText: c }
}, u) {
  function d(y, m) {
    let C = m;
    for (; C; ) {
      if (C && C.nodeType === 8) {
        if (C.data === "teleport start anchor")
          A.targetStart = C;
        else if (C.data === "teleport anchor") {
          A.targetAnchor = C, y._lpa = A.targetAnchor && s(A.targetAnchor);
          break;
        }
      }
      C = s(C);
    }
  }
  function h(y, m) {
    m.anchor = u(
      s(y),
      m,
      a(y),
      t,
      r,
      n,
      i
    );
  }
  const p = A.target = I1(
    A.props,
    o
  ), B = yl(A.props);
  if (p) {
    const y = p._lpa || p.firstChild;
    A.shapeFlag & 16 && (B ? (h(e, A), d(p, y), A.targetAnchor || S1(
      p,
      A,
      c,
      l,
      // if target is the same as the main view, insert anchors before current node
      // to avoid hydrating mismatch
      a(e) === p ? e : null
    )) : (A.anchor = s(e), d(p, y), A.targetAnchor || S1(p, A, c, l), u(
      y && s(y),
      A,
      p,
      t,
      r,
      n,
      i
    ))), Gu(A, B);
  } else B && A.shapeFlag & 16 && (h(e, A), A.targetStart = e, A.targetAnchor = s(e));
  return A.anchor && s(A.anchor);
}
const dC = Y_;
function Gu(e, A) {
  const t = e.ctx;
  if (t && t.ut) {
    let r, n;
    for (A ? (r = e.el, n = e.anchor) : (r = e.targetStart, n = e.targetAnchor); r && r !== n; )
      r.nodeType === 1 && r.setAttribute("data-v-owner", t.uid), r = r.nextSibling;
    t.ut();
  }
}
function S1(e, A, t, r, n = null) {
  const i = A.targetStart = t(""), s = A.targetAnchor = t("");
  return i[qx] = s, e && (r(i, e, n), r(s, e, n)), s;
}
const ki = /* @__PURE__ */ Symbol("_leaveCb"), Cu = /* @__PURE__ */ Symbol("_enterCb");
function Z_() {
  const e = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return ug(() => {
    e.isMounted = !0;
  }), by(() => {
    e.isUnmounting = !0;
  }), e;
}
const Di = [Function, Array], $x = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: Di,
  onEnter: Di,
  onAfterEnter: Di,
  onEnterCancelled: Di,
  // leave
  onBeforeLeave: Di,
  onLeave: Di,
  onAfterLeave: Di,
  onLeaveCancelled: Di,
  // appear
  onBeforeAppear: Di,
  onAppear: Di,
  onAfterAppear: Di,
  onAppearCancelled: Di
}, zx = (e) => {
  const A = e.subTree;
  return A.component ? zx(A.component) : A;
}, A6 = {
  name: "BaseTransition",
  props: $x,
  setup(e, { slots: A }) {
    const t = vI(), r = Z_();
    return () => {
      const n = A.default && Jx(A.default(), !0), i = n && n.length ? Xx(n) : (
        // Keep explicit default-slot conditionals on the same transition path
        // as regular v-if branches, which render a comment placeholder.
        t.subTree ? $t() : void 0
      );
      if (!i)
        return;
      const s = /* @__PURE__ */ at(e), { mode: a } = s;
      if (r.isLeaving)
        return hB(i);
      const o = lg(i);
      if (!o)
        return hB(i);
      let l = L1(
        o,
        s,
        r,
        t,
        // #11061, ensure enterHooks is fresh after clone
        (u) => l = u
      );
      o.type !== xn && Sh(o, l);
      let c = t.subTree && lg(t.subTree);
      if (c && c.type !== xn && !Cl(c, o) && zx(t).type !== xn) {
        let u = L1(
          c,
          s,
          r,
          t
        );
        if (Sh(c, u), a === "out-in" && o.type !== xn)
          return r.isLeaving = !0, u.afterLeave = () => {
            r.isLeaving = !1, t.job.flags & 8 || t.update(), delete u.afterLeave, c = void 0;
          }, hB(i);
        a === "in-out" && o.type !== xn ? u.delayLeave = (d, h, p) => {
          const B = Yx(
            r,
            c
          );
          B[String(c.key)] = c, d[ki] = () => {
            h(), d[ki] = void 0, delete l.delayedLeave, c = void 0;
          }, l.delayedLeave = () => {
            p(), delete l.delayedLeave, c = void 0;
          };
        } : c = void 0;
      } else c && (c = void 0);
      return i;
    };
  }
};
function Xx(e) {
  let A = e[0];
  if (e.length > 1) {
    for (const t of e)
      if (t.type !== xn) {
        A = t;
        break;
      }
  }
  return A;
}
const e6 = A6;
function Yx(e, A) {
  const { leavingVNodes: t } = e;
  let r = t.get(A.type);
  return r || (r = /* @__PURE__ */ Object.create(null), t.set(A.type, r)), r;
}
function L1(e, A, t, r, n) {
  const {
    appear: i,
    mode: s,
    persisted: a = !1,
    onBeforeEnter: o,
    onEnter: l,
    onAfterEnter: c,
    onEnterCancelled: u,
    onBeforeLeave: d,
    onLeave: h,
    onAfterLeave: p,
    onLeaveCancelled: B,
    onBeforeAppear: y,
    onAppear: m,
    onAfterAppear: C,
    onAppearCancelled: Q
  } = A, F = String(e.key), T = Yx(t, e), V = (I, q) => {
    I && Zi(
      I,
      r,
      9,
      q
    );
  }, M = (I, q) => {
    const U = q[1];
    V(I, q), Se(I) ? I.every((x) => x.length <= 1) && U() : I.length <= 1 && U();
  }, D = {
    mode: s,
    persisted: a,
    beforeEnter(I) {
      let q = o;
      if (!t.isMounted)
        if (i)
          q = y || o;
        else
          return;
      I[ki] && I[ki](
        !0
        /* cancelled */
      );
      const U = T[F];
      U && Cl(e, U) && U.el[ki] && U.el[ki](), V(q, [I]);
    },
    enter(I) {
      if (T[F] === e) return;
      let q = l, U = c, x = u;
      if (!t.isMounted)
        if (i)
          q = m || l, U = C || c, x = Q || u;
        else
          return;
      let P = !1;
      I[Cu] = (iA) => {
        P || (P = !0, iA ? V(x, [I]) : V(U, [I]), D.delayedLeave && D.delayedLeave(), I[Cu] = void 0);
      };
      const N = I[Cu].bind(null, !1);
      q ? M(q, [I, N]) : N();
    },
    leave(I, q) {
      const U = String(e.key);
      if (I[Cu] && I[Cu](
        !0
        /* cancelled */
      ), t.isUnmounting)
        return q();
      V(d, [I]);
      let x = !1;
      I[ki] = (N) => {
        x || (x = !0, q(), N ? V(B, [I]) : V(p, [I]), I[ki] = void 0, T[U] === e && delete T[U]);
      };
      const P = I[ki].bind(null, !1);
      T[U] = e, h ? M(h, [I, P]) : P();
    },
    clone(I) {
      const q = L1(
        I,
        A,
        t,
        r,
        n
      );
      return n && n(q), q;
    }
  };
  return D;
}
function hB(e) {
  if (zg(e))
    return e = Ro(e), e.children = null, e;
}
function lg(e) {
  if (!zg(e))
    return qg(e.type) && e.children ? Xx(e.children) : e;
  if (e.component)
    return e.component.subTree;
  const { shapeFlag: A, children: t } = e;
  if (t) {
    if (A & 16)
      return t[0];
    if (A & 32 && Re(t.default))
      return t.default();
  }
}
function Sh(e, A) {
  if (e.shapeFlag & 6 && e.component) {
    e.transition = A;
    const t = e.component.subTree;
    Sh(
      qg(t.type) && lg(t) || t,
      A
    );
  } else e.shapeFlag & 128 ? (e.ssContent.transition = A.clone(e.ssContent), e.ssFallback.transition = A.clone(e.ssFallback)) : e.transition = A;
}
function Jx(e, A = !1, t) {
  let r = [], n = 0;
  for (let i = 0; i < e.length; i++) {
    let s = e[i];
    const a = t == null ? s.key : String(t) + String(s.key != null ? s.key : i);
    s.type === Xt ? (s.patchFlag & 128 && n++, r = r.concat(
      Jx(s.children, A, a)
    )) : (A || s.type !== xn) && r.push(a != null ? Ro(s, { key: a }) : s);
  }
  if (n > 1)
    for (let i = 0; i < r.length; i++)
      r[i].patchFlag = -2;
  return r;
}
// @__NO_SIDE_EFFECTS__
function $g(e, A) {
  return Re(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    Gr({ name: e.name }, A, { setup: e })
  ) : e;
}
function Zx(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
function gC(e, A) {
  let t;
  return !!((t = Object.getOwnPropertyDescriptor(e, A)) && !t.configurable);
}
const cg = /* @__PURE__ */ new WeakMap();
function dh(e, A, t, r, n = !1) {
  if (Se(e)) {
    e.forEach(
      (B, y) => dh(
        B,
        A && (Se(A) ? A[y] : A),
        t,
        r,
        n
      )
    );
    return;
  }
  if (Gc(r) && !n) {
    r.shapeFlag & 512 && r.type.__asyncResolved && r.component.subTree.component && dh(e, A, t, r.component.subTree);
    return;
  }
  const i = r.shapeFlag & 4 ? Zg(r.component) : r.el, s = n ? null : i, { i: a, r: o } = e, l = A && A.r, c = a.refs === Ft ? a.refs = {} : a.refs, u = a.setupState, d = /* @__PURE__ */ at(u), h = u === Ft ? px : (B) => gC(c, B) ? !1 : ut(d, B), p = (B, y) => !(y && gC(c, y));
  if (l != null && l !== o) {
    if (pC(A), kt(l))
      c[l] = null, h(l) && (u[l] = null);
    else if (/* @__PURE__ */ Ln(l)) {
      const B = A;
      p(l, B.k) && (l.value = null), B.k && (c[B.k] = null);
    }
  }
  if (Re(o))
    $h(o, a, 12, [s, c]);
  else {
    const B = kt(o), y = /* @__PURE__ */ Ln(o);
    if (B || y) {
      const m = () => {
        if (e.f) {
          const C = B ? h(o) ? u[o] : c[o] : p() || !e.k ? o.value : c[e.k];
          if (n)
            Se(C) && hy(C, i);
          else if (Se(C))
            C.includes(i) || C.push(i);
          else if (B)
            c[o] = [i], h(o) && (u[o] = c[o]);
          else {
            const Q = [i];
            p(o, e.k) && (o.value = Q), e.k && (c[e.k] = Q);
          }
        } else B ? (c[o] = s, h(o) && (u[o] = s)) : y && (p(o, e.k) && (o.value = s), e.k && (c[e.k] = s));
      };
      if (s) {
        const C = () => {
          m(), cg.delete(e);
        };
        C.id = -1, cg.set(e, C), $n(C, t);
      } else
        pC(e), m();
    }
  }
}
function pC(e) {
  const A = cg.get(e);
  A && (A.flags |= 8, cg.delete(e));
}
Gg().requestIdleCallback;
Gg().cancelIdleCallback;
const Gc = (e) => !!e.type.__asyncLoader, zg = (e) => e.type.__isKeepAlive;
function t6(e, A) {
  AI(e, "a", A);
}
function r6(e, A) {
  AI(e, "da", A);
}
function AI(e, A, t = In) {
  const r = e.__wdc || (e.__wdc = () => {
    let n = t;
    for (; n; ) {
      if (n.isDeactivated)
        return;
      n = n.parent;
    }
    return e();
  });
  if (Xg(A, r, t), t) {
    let n = t.parent;
    for (; n && n.parent; )
      zg(n.parent.vnode) && n6(r, A, t, n), n = n.parent;
  }
}
function n6(e, A, t, r) {
  const n = Xg(
    A,
    e,
    r,
    !0
    /* prepend */
  );
  Fy(() => {
    hy(r[A], n);
  }, t);
}
function Xg(e, A, t = In, r = !1) {
  if (t) {
    const n = t[e] || (t[e] = []), i = A.__weh || (A.__weh = (...s) => {
      Ta();
      const a = zh(t), o = Zi(A, t, e, s);
      return a(), _a(), o;
    });
    return r ? n.unshift(i) : n.push(i), i;
  }
}
const Ra = (e) => (A, t = In) => {
  (!_h || e === "sp") && Xg(e, (...r) => A(...r), t);
}, i6 = Ra("bm"), ug = Ra("m"), s6 = Ra(
  "bu"
), a6 = Ra("u"), by = Ra(
  "bum"
), Fy = Ra("um"), o6 = Ra(
  "sp"
), l6 = Ra("rtg"), c6 = Ra("rtc");
function u6(e, A = In) {
  Xg("ec", e, A);
}
const h6 = "components";
function Df(e, A) {
  return d6(h6, e, !0, A) || e;
}
const f6 = /* @__PURE__ */ Symbol.for("v-ndc");
function d6(e, A, t = !0, r = !1) {
  const n = on || In;
  if (n) {
    const i = n.type;
    {
      const a = J6(
        i,
        !1
      );
      if (a && (a === A || a === Yn(A) || a === Vg(Yn(A))))
        return i;
    }
    const s = (
      // local registration
      // check instance[type] first which is resolved for options API
      BC(n[e] || i[e], A) || // global registration
      BC(n.appContext[e], A)
    );
    return !s && r ? i : s;
  }
}
function BC(e, A) {
  return e && (e[A] || e[Yn(A)] || e[Vg(Yn(A))]);
}
function Wu(e, A, t, r) {
  let n;
  const i = t, s = Se(e);
  if (s || kt(e)) {
    const a = s && /* @__PURE__ */ Ho(e);
    let o = !1, l = !1;
    a && (o = !/* @__PURE__ */ Yi(e), l = /* @__PURE__ */ zs(e), e = Wg(e)), n = new Array(e.length);
    for (let c = 0, u = e.length; c < u; c++)
      n[c] = A(
        o ? l ? Do(Ji(e[c])) : Ji(e[c]) : e[c],
        c,
        void 0,
        i
      );
  } else if (typeof e == "number") {
    n = new Array(e);
    for (let a = 0; a < e; a++)
      n[a] = A(a + 1, a, void 0, i);
  } else if (dt(e))
    if (e[Symbol.iterator])
      n = Array.from(
        e,
        (a, o) => A(a, o, void 0, i)
      );
    else {
      const a = Object.keys(e);
      n = new Array(a.length);
      for (let o = 0, l = a.length; o < l; o++) {
        const c = a[o];
        n[o] = A(e[c], c, o, i);
      }
    }
  else
    n = [];
  return n;
}
function g6(e, A, t, r, n, i) {
  if (t == null && (t = {}), on.ce || on.parent && Gc(on.parent) && on.parent.ce) {
    const l = t, c = Object.keys(l).length > 0;
    return Ee(), Fo(
      Xt,
      null,
      [nt("slot", l, r)],
      c ? -2 : 64
    );
  }
  let s = e[A];
  s && s._c && (s._d = !1);
  const a = La.length;
  Ee();
  let o;
  try {
    const l = s && eI(s(t)), c = t.key || i || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    l && l.key;
    o = Fo(
      Xt,
      {
        key: (c && !ys(c) ? c : `_${A}`) + // #7256 force differentiate fallback content from actual content
        (!l && r ? "_fb" : "")
      },
      l || (r ? r() : []),
      l && e._ === 1 ? 64 : -2
    );
  } catch (l) {
    for (let c = La.length; c > a; c--) xy();
    throw l;
  } finally {
    s && s._c && (s._d = !0);
  }
  return o.scopeId && (o.slotScopeIds = [o.scopeId + "-s"]), o;
}
function eI(e) {
  return e.some((A) => Hh(A) ? !(A.type === xn || A.type === Xt && !eI(A.children)) : !0) ? e : null;
}
const H1 = (e) => e ? yI(e) ? Zg(e) : H1(e.parent) : null, gh = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ Gr(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => e.props,
    $attrs: (e) => e.attrs,
    $slots: (e) => e.slots,
    $refs: (e) => e.refs,
    $parent: (e) => H1(e.parent),
    $root: (e) => H1(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => rI(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      Cy(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = x1.bind(e.proxy)),
    $watch: (e) => z_.bind(e)
  })
), fB = (e, A) => e !== Ft && !e.__isScriptSetup && ut(e, A), p6 = {
  get({ _: e }, A) {
    if (A === "__v_skip")
      return !0;
    const { ctx: t, setupState: r, data: n, props: i, accessCache: s, type: a, appContext: o } = e;
    if (A[0] !== "$") {
      const d = s[A];
      if (d !== void 0)
        switch (d) {
          case 1:
            return r[A];
          case 2:
            return n[A];
          case 4:
            return t[A];
          case 3:
            return i[A];
        }
      else {
        if (fB(r, A))
          return s[A] = 1, r[A];
        if (n !== Ft && ut(n, A))
          return s[A] = 2, n[A];
        if (ut(i, A))
          return s[A] = 3, i[A];
        if (t !== Ft && ut(t, A))
          return s[A] = 4, t[A];
        T1 && (s[A] = 0);
      }
    }
    const l = gh[A];
    let c, u;
    if (l)
      return A === "$attrs" && En(e.attrs, "get", ""), l(e);
    if (
      // css module (injected by vue-loader)
      (c = a.__cssModules) && (c = c[A])
    )
      return c;
    if (t !== Ft && ut(t, A))
      return s[A] = 4, t[A];
    if (
      // global properties
      u = o.config.globalProperties, ut(u, A)
    )
      return u[A];
  },
  set({ _: e }, A, t) {
    const { data: r, setupState: n, ctx: i } = e;
    return fB(n, A) ? (n[A] = t, !0) : r !== Ft && ut(r, A) ? (r[A] = t, !0) : ut(e.props, A) || A[0] === "$" && A.slice(1) in e ? !1 : (i[A] = t, !0);
  },
  has({
    _: { data: e, setupState: A, accessCache: t, ctx: r, appContext: n, props: i, type: s }
  }, a) {
    let o;
    return !!(t[a] || e !== Ft && a[0] !== "$" && ut(e, a) || fB(A, a) || ut(i, a) || ut(r, a) || ut(gh, a) || ut(n.config.globalProperties, a) || (o = s.__cssModules) && o[a]);
  },
  defineProperty(e, A, t) {
    return t.get != null ? e._.accessCache[A] = 0 : ut(t, "value") && this.set(e, A, t.value, null), Reflect.defineProperty(e, A, t);
  }
};
function wC(e) {
  return Se(e) ? e.reduce(
    (A, t) => (A[t] = null, A),
    {}
  ) : e;
}
let T1 = !0;
function B6(e) {
  const A = rI(e), t = e.proxy, r = e.ctx;
  T1 = !1, A.beforeCreate && mC(A.beforeCreate, e, "bc");
  const {
    // state
    data: n,
    computed: i,
    methods: s,
    watch: a,
    provide: o,
    inject: l,
    // lifecycle
    created: c,
    beforeMount: u,
    mounted: d,
    beforeUpdate: h,
    updated: p,
    activated: B,
    deactivated: y,
    beforeDestroy: m,
    beforeUnmount: C,
    destroyed: Q,
    unmounted: F,
    render: T,
    renderTracked: V,
    renderTriggered: M,
    errorCaptured: D,
    serverPrefetch: I,
    // public API
    expose: q,
    inheritAttrs: U,
    // assets
    components: x,
    directives: P,
    filters: N
  } = A;
  if (l && w6(l, r, null), s)
    for (const sA in s) {
      const tA = s[sA];
      Re(tA) && (r[sA] = tA.bind(t));
    }
  if (n) {
    const sA = n.call(t, t);
    dt(sA) && (e.data = /* @__PURE__ */ $l(sA));
  }
  if (T1 = !0, i)
    for (const sA in i) {
      const tA = i[sA], cA = Re(tA) ? tA.bind(t, t) : Re(tA.get) ? tA.get.bind(t, t) : qs, FA = !Re(tA) && Re(tA.set) ? tA.set.bind(t) : qs, CA = bt({
        get: cA,
        set: FA
      });
      Object.defineProperty(r, sA, {
        enumerable: !0,
        configurable: !0,
        get: () => CA.value,
        set: (S) => CA.value = S
      });
    }
  if (a)
    for (const sA in a)
      tI(a[sA], r, t, sA);
  if (o) {
    const sA = Re(o) ? o.call(t) : o;
    Reflect.ownKeys(sA).forEach((tA) => {
      j_(tA, sA[tA]);
    });
  }
  c && mC(c, e, "c");
  function nA(sA, tA) {
    Se(tA) ? tA.forEach((cA) => sA(cA.bind(t))) : tA && sA(tA.bind(t));
  }
  if (nA(i6, u), nA(ug, d), nA(s6, h), nA(a6, p), nA(t6, B), nA(r6, y), nA(u6, D), nA(c6, V), nA(l6, M), nA(by, C), nA(Fy, F), nA(o6, I), Se(q))
    if (q.length) {
      const sA = e.exposed || (e.exposed = {});
      q.forEach((tA) => {
        Object.defineProperty(sA, tA, {
          get: () => t[tA],
          set: (cA) => t[tA] = cA,
          enumerable: !0
        });
      });
    } else e.exposed || (e.exposed = {});
  T && e.render === qs && (e.render = T), U != null && (e.inheritAttrs = U), x && (e.components = x), P && (e.directives = P), I && Zx(e);
}
function w6(e, A, t = qs) {
  Se(e) && (e = _1(e));
  for (const r in e) {
    const n = e[r];
    let i;
    dt(n) ? "default" in n ? i = jd(
      n.from || r,
      n.default,
      !0
    ) : i = jd(n.from || r) : i = jd(n), /* @__PURE__ */ Ln(i) ? Object.defineProperty(A, r, {
      enumerable: !0,
      configurable: !0,
      get: () => i.value,
      set: (s) => i.value = s
    }) : A[r] = i;
  }
}
function mC(e, A, t) {
  Zi(
    Se(e) ? e.map((r) => r.bind(A.proxy)) : e.bind(A.proxy),
    A,
    t
  );
}
function tI(e, A, t, r) {
  let n = r.includes(".") ? jx(t, r) : () => t[r];
  if (kt(e)) {
    const i = A[e];
    Re(i) && uB(n, i);
  } else if (Re(e))
    uB(n, e.bind(t));
  else if (dt(e))
    if (Se(e))
      e.forEach((i) => tI(i, A, t, r));
    else {
      const i = Re(e.handler) ? e.handler.bind(t) : A[e.handler];
      Re(i) && uB(n, i, e);
    }
}
function rI(e) {
  const A = e.type, { mixins: t, extends: r } = A, {
    mixins: n,
    optionsCache: i,
    config: { optionMergeStrategies: s }
  } = e.appContext, a = i.get(A);
  let o;
  return a ? o = a : !n.length && !t && !r ? o = A : (o = {}, n.length && n.forEach(
    (l) => hg(o, l, s, !0)
  ), hg(o, A, s)), dt(A) && i.set(A, o), o;
}
function hg(e, A, t, r = !1) {
  const { mixins: n, extends: i } = A;
  i && hg(e, i, t, !0), n && n.forEach(
    (s) => hg(e, s, t, !0)
  );
  for (const s in A)
    if (!(r && s === "expose")) {
      const a = m6[s] || t && t[s];
      e[s] = a ? a(e[s], A[s]) : A[s];
    }
  return e;
}
const m6 = {
  data: vC,
  props: yC,
  emits: yC,
  // objects
  methods: ju,
  computed: ju,
  // lifecycle
  beforeCreate: qn,
  created: qn,
  beforeMount: qn,
  mounted: qn,
  beforeUpdate: qn,
  updated: qn,
  beforeDestroy: qn,
  beforeUnmount: qn,
  destroyed: qn,
  unmounted: qn,
  activated: qn,
  deactivated: qn,
  errorCaptured: qn,
  serverPrefetch: qn,
  // assets
  components: ju,
  directives: ju,
  // watch
  watch: y6,
  // provide / inject
  provide: vC,
  inject: v6
};
function vC(e, A) {
  return A ? e ? function() {
    return Gr(
      Re(e) ? e.call(this, this) : e,
      Re(A) ? A.call(this, this) : A
    );
  } : A : e;
}
function v6(e, A) {
  return ju(_1(e), _1(A));
}
function _1(e) {
  if (Se(e)) {
    const A = {};
    for (let t = 0; t < e.length; t++)
      A[e[t]] = e[t];
    return A;
  }
  return e;
}
function qn(e, A) {
  return e ? [...new Set([].concat(e, A))] : A;
}
function ju(e, A) {
  return e ? Gr(/* @__PURE__ */ Object.create(null), e, A) : A;
}
function yC(e, A) {
  return e ? Se(e) && Se(A) ? [.../* @__PURE__ */ new Set([...e, ...A])] : Gr(
    /* @__PURE__ */ Object.create(null),
    wC(e),
    wC(A ?? {})
  ) : A;
}
function y6(e, A) {
  if (!e) return A;
  if (!A) return e;
  const t = Gr(/* @__PURE__ */ Object.create(null), e);
  for (const r in A)
    t[r] = qn(e[r], A[r]);
  return t;
}
function nI() {
  return {
    app: null,
    config: {
      isNativeTag: px,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let C6 = 0;
function b6(e, A) {
  return function(r, n = null) {
    Re(r) || (r = Gr({}, r)), n != null && !dt(n) && (n = null);
    const i = nI(), s = /* @__PURE__ */ new WeakSet(), a = [];
    let o = !1;
    const l = i.app = {
      _uid: C6++,
      _component: r,
      _props: n,
      _container: null,
      _context: i,
      _instance: null,
      version: eO,
      get config() {
        return i.config;
      },
      set config(c) {
      },
      use(c, ...u) {
        return s.has(c) || (c && Re(c.install) ? (s.add(c), c.install(l, ...u)) : Re(c) && (s.add(c), c(l, ...u))), l;
      },
      mixin(c) {
        return i.mixins.includes(c) || i.mixins.push(c), l;
      },
      component(c, u) {
        return u ? (i.components[c] = u, l) : i.components[c];
      },
      directive(c, u) {
        return u ? (i.directives[c] = u, l) : i.directives[c];
      },
      mount(c, u, d) {
        if (!o) {
          const h = l._ceVNode || nt(r, n);
          return h.appContext = i, d === !0 ? d = "svg" : d === !1 && (d = void 0), e(h, c, d), o = !0, l._container = c, c.__vue_app__ = l, Zg(h.component);
        }
      },
      onUnmount(c) {
        a.push(c);
      },
      unmount() {
        o && (Zi(
          a,
          l._instance,
          16
        ), e(null, l._container), delete l._container.__vue_app__);
      },
      provide(c, u) {
        return i.provides[c] = u, l;
      },
      runWithContext(c) {
        const u = Wc;
        Wc = l;
        try {
          return c();
        } finally {
          Wc = u;
        }
      }
    };
    return l;
  };
}
let Wc = null;
const F6 = (e, A) => A === "modelValue" || A === "model-value" ? e.modelModifiers : e[`${A}Modifiers`] || e[`${Yn(A)}Modifiers`] || e[`${Jl(A)}Modifiers`];
function Q6(e, A, ...t) {
  if (e.isUnmounted) return;
  const r = e.vnode.props || Ft;
  let n = t;
  const i = A.startsWith("update:"), s = i && F6(r, A.slice(7));
  s && (s.trim && (n = t.map((c) => kt(c) ? c.trim() : c)), s.number && (n = n.map(dy)));
  let a, o = r[a = sB(A)] || // also try camelCase event handler (#2249)
  r[a = sB(Yn(A))];
  !o && i && (o = r[a = sB(Jl(A))]), o && Zi(
    o,
    e,
    6,
    n
  );
  const l = r[a + "Once"];
  if (l) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[a])
      return;
    e.emitted[a] = !0, Zi(
      l,
      e,
      6,
      n
    );
  }
}
const U6 = /* @__PURE__ */ new WeakMap();
function iI(e, A, t = !1) {
  const r = t ? U6 : A.emitsCache, n = r.get(e);
  if (n !== void 0)
    return n;
  const i = e.emits;
  let s = {}, a = !1;
  if (!Re(e)) {
    const o = (l) => {
      const c = iI(l, A, !0);
      c && (a = !0, Gr(s, c));
    };
    !t && A.mixins.length && A.mixins.forEach(o), e.extends && o(e.extends), e.mixins && e.mixins.forEach(o);
  }
  return !i && !a ? (dt(e) && r.set(e, null), null) : (Se(i) ? i.forEach((o) => s[o] = null) : Gr(s, i), dt(e) && r.set(e, s), s);
}
function Yg(e, A) {
  return !e || !Pg(A) ? !1 : (A = A.slice(2), A = A === "Once" ? A : A.replace(/Once$/, ""), ut(e, A[0].toLowerCase() + A.slice(1)) || ut(e, Jl(A)) || ut(e, A));
}
function CC(e) {
  const {
    type: A,
    vnode: t,
    proxy: r,
    withProxy: n,
    propsOptions: [i],
    slots: s,
    attrs: a,
    emit: o,
    render: l,
    renderCache: c,
    props: u,
    data: d,
    setupState: h,
    ctx: p,
    inheritAttrs: B
  } = e, y = og(e);
  let m, C;
  try {
    if (t.shapeFlag & 4) {
      const F = n || r, T = F;
      m = Gs(
        l.call(
          T,
          F,
          c,
          u,
          h,
          d,
          p
        )
      ), C = a;
    } else {
      const F = A;
      m = Gs(
        F.length > 1 ? F(
          u,
          { attrs: a, slots: s, emit: o }
        ) : F(
          u,
          null
        )
      ), C = A.props ? a : E6(a);
    }
  } catch (F) {
    La.length = 0, jg(F, e, 1), m = nt(xn);
  }
  let Q = m;
  if (C && B !== !1) {
    const F = Object.keys(C), { shapeFlag: T } = Q;
    F.length && T & 7 && (i && F.some(kg) && (C = x6(
      C,
      i
    )), Q = Ro(Q, C, !1, !0));
  }
  if (t.dirs && (Q = Ro(Q, null, !1, !0), Q.dirs = Q.dirs ? Q.dirs.concat(t.dirs) : t.dirs), t.transition) {
    const F = qg(Q.type) && lg(Q) || Q;
    Sh(F, t.transition);
  }
  return m = Q, og(y), m;
}
const E6 = (e) => {
  let A;
  for (const t in e)
    (t === "class" || t === "style" || Pg(t)) && ((A || (A = {}))[t] = e[t]);
  return A;
}, x6 = (e, A) => {
  const t = {};
  for (const r in e)
    (!kg(r) || !(r.slice(9) in A)) && (t[r] = e[r]);
  return t;
};
function I6(e, A, t) {
  const { props: r, children: n, component: i } = e, { props: s, children: a, patchFlag: o } = A, l = i.emitsOptions;
  if (A.dirs || A.transition)
    return !0;
  if (t && o >= 0) {
    if (o & 1024)
      return !0;
    if (o & 16)
      return r ? bC(r, s, l) : !!s;
    if (o & 8) {
      const c = A.dynamicProps;
      for (let u = 0; u < c.length; u++) {
        const d = c[u];
        if (sI(s, r, d) && !Yg(l, d))
          return !0;
      }
    }
  } else
    return (n || a) && (!a || !a.$stable) ? !0 : r === s ? !1 : r ? s ? bC(r, s, l) : !0 : !!s;
  return !1;
}
function bC(e, A, t) {
  const r = Object.keys(A);
  if (r.length !== Object.keys(e).length)
    return !0;
  for (let n = 0; n < r.length; n++) {
    const i = r[n];
    if (sI(A, e, i) && !Yg(t, i))
      return !0;
  }
  return !1;
}
function sI(e, A, t) {
  const r = e[t], n = A[t];
  return t === "style" && dt(r) && dt(n) ? !Au(r, n) : r !== n;
}
function S6({ vnode: e, parent: A, suspense: t }, r) {
  for (; A; ) {
    const n = A.subTree;
    if (n.suspense && n.suspense.activeBranch === e && (n.suspense.vnode.el = n.el = r, e = n), n === e)
      (e = A.vnode).el = r, A = A.parent;
    else
      break;
  }
  t && t.activeBranch === e && (t.vnode.el = r);
}
const aI = {}, oI = () => Object.create(aI), lI = (e) => Object.getPrototypeOf(e) === aI;
function L6(e, A, t, r = !1) {
  const n = {}, i = oI();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), cI(e, A, n, i);
  for (const s in e.propsOptions[0])
    s in n || (n[s] = void 0);
  t ? e.props = r ? n : /* @__PURE__ */ __(n) : e.type.props ? e.props = n : e.props = i, e.attrs = i;
}
function H6(e, A, t, r) {
  const {
    props: n,
    attrs: i,
    vnode: { patchFlag: s }
  } = e, a = /* @__PURE__ */ at(n), [o] = e.propsOptions;
  let l = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (r || s > 0) && !(s & 16)
  ) {
    if (s & 8) {
      const c = e.vnode.dynamicProps;
      for (let u = 0; u < c.length; u++) {
        let d = c[u];
        if (Yg(e.emitsOptions, d))
          continue;
        const h = A[d];
        if (o)
          if (ut(i, d))
            h !== i[d] && (i[d] = h, l = !0);
          else {
            const p = Yn(d);
            n[p] = O1(
              o,
              a,
              p,
              h,
              e,
              !1
            );
          }
        else
          h !== i[d] && (i[d] = h, l = !0);
      }
    }
  } else {
    cI(e, A, n, i) && (l = !0);
    let c;
    for (const u in a)
      (!A || // for camelCase
      !ut(A, u) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((c = Jl(u)) === u || !ut(A, c))) && (o ? t && // for camelCase
      (t[u] !== void 0 || // for kebab-case
      t[c] !== void 0) && (n[u] = O1(
        o,
        a,
        u,
        void 0,
        e,
        !0
      )) : delete n[u]);
    if (i !== a)
      for (const u in i)
        (!A || !ut(A, u)) && (delete i[u], l = !0);
  }
  l && Ea(e.attrs, "set", "");
}
function cI(e, A, t, r) {
  const [n, i] = e.propsOptions;
  let s = !1, a;
  if (A)
    for (let o in A) {
      if (uh(o))
        continue;
      const l = A[o];
      let c;
      n && ut(n, c = Yn(o)) ? !i || !i.includes(c) ? t[c] = l : (a || (a = {}))[c] = l : Yg(e.emitsOptions, o) || (!(o in r) || l !== r[o]) && (r[o] = l, s = !0);
    }
  if (i) {
    const o = /* @__PURE__ */ at(t), l = a || Ft;
    for (let c = 0; c < i.length; c++) {
      const u = i[c];
      t[u] = O1(
        n,
        o,
        u,
        l[u],
        e,
        !ut(l, u)
      );
    }
  }
  return s;
}
function O1(e, A, t, r, n, i) {
  const s = e[t];
  if (s != null) {
    const a = ut(s, "default");
    if (a && r === void 0) {
      const o = s.default;
      if (s.type !== Function && !s.skipFactory && Re(o)) {
        const { propsDefaults: l } = n;
        if (t in l)
          r = l[t];
        else {
          const c = zh(n);
          r = l[t] = o.call(
            null,
            A
          ), c();
        }
      } else
        r = o;
      n.ce && n.ce._setProp(t, r);
    }
    s[
      0
      /* shouldCast */
    ] && (i && !a ? r = !1 : s[
      1
      /* shouldCastTrue */
    ] && (r === "" || r === Jl(t)) && (r = !0));
  }
  return r;
}
const T6 = /* @__PURE__ */ new WeakMap();
function uI(e, A, t = !1) {
  const r = t ? T6 : A.propsCache, n = r.get(e);
  if (n)
    return n;
  const i = e.props, s = {}, a = [];
  let o = !1;
  if (!Re(e)) {
    const c = (u) => {
      o = !0;
      const [d, h] = uI(u, A, !0);
      Gr(s, d), h && a.push(...h);
    };
    !t && A.mixins.length && A.mixins.forEach(c), e.extends && c(e.extends), e.mixins && e.mixins.forEach(c);
  }
  if (!i && !o)
    return dt(e) && r.set(e, El), El;
  if (Se(i))
    for (let c = 0; c < i.length; c++) {
      const u = Yn(i[c]);
      FC(u) && (s[u] = Ft);
    }
  else if (i)
    for (const c in i) {
      const u = Yn(c);
      if (FC(u)) {
        const d = i[c], h = s[u] = Se(d) || Re(d) ? { type: d } : Gr({}, d), p = h.type;
        let B = !1, y = !0;
        if (Se(p))
          for (let m = 0; m < p.length; ++m) {
            const C = p[m], Q = Re(C) && C.name;
            if (Q === "Boolean") {
              B = !0;
              break;
            } else Q === "String" && (y = !1);
          }
        else
          B = Re(p) && p.name === "Boolean";
        h[
          0
          /* shouldCast */
        ] = B, h[
          1
          /* shouldCastTrue */
        ] = y, (B || ut(h, "default")) && a.push(u);
      }
    }
  const l = [s, a];
  return dt(e) && r.set(e, l), l;
}
function FC(e) {
  return e[0] !== "$" && !uh(e);
}
const Qy = (e) => e === "_" || e === "_ctx" || e === "$stable", Uy = (e) => Se(e) ? e.map(Gs) : [Gs(e)], _6 = (e, A, t) => {
  if (A._n)
    return A;
  const r = Fa((...n) => Uy(A(...n)), t);
  return r._c = !1, r;
}, hI = (e, A, t) => {
  const r = e._ctx;
  for (const n in e) {
    if (Qy(n)) continue;
    const i = e[n];
    if (Re(i))
      A[n] = _6(n, i, r);
    else if (i != null) {
      const s = Uy(i);
      A[n] = () => s;
    }
  }
}, fI = (e, A) => {
  const t = Uy(A);
  e.slots.default = () => t;
}, dI = (e, A, t) => {
  for (const r in A)
    (t || !Qy(r)) && (e[r] = A[r]);
}, O6 = (e, A, t) => {
  const r = e.slots = oI();
  if (e.vnode.shapeFlag & 32) {
    const n = A._;
    n ? (dI(r, A, t), t && vx(r, "_", n, !0)) : hI(A, r);
  } else A && fI(e, A);
}, N6 = (e, A, t) => {
  const { vnode: r, slots: n } = e;
  let i = !0, s = Ft;
  if (r.shapeFlag & 32) {
    const a = A._;
    a ? t && a === 1 ? i = !1 : dI(n, A, t) : (i = !A.$stable, hI(A, n)), s = A;
  } else A && (fI(e, A), s = { default: 1 });
  if (i)
    for (const a in n)
      !Qy(a) && s[a] == null && delete n[a];
}, $n = k6;
function D6(e) {
  return R6(e);
}
function R6(e, A) {
  const t = Gg();
  t.__VUE__ = !0;
  const {
    insert: r,
    remove: n,
    patchProp: i,
    createElement: s,
    createText: a,
    createComment: o,
    setText: l,
    setElementText: c,
    parentNode: u,
    nextSibling: d,
    setScopeId: h = qs,
    insertStaticContent: p
  } = e, B = (k, X, uA, E = null, dA = null, vA = null, rA = void 0, fA = null, EA = !!X.dynamicChildren) => {
    if (k === X)
      return;
    k && !Cl(k, X) && (E = gA(k), S(k, dA, vA, !0), k = null), X.patchFlag === -2 && (EA = !1, X.dynamicChildren = null), X.dynamicChildren && k && k.dynamicChildren && k.dynamicChildren.hasOnce && (X.dynamicChildren === El && (X.dynamicChildren = []), X.dynamicChildren.hasOnce = !0);
    const { type: lA, ref: HA, shapeFlag: SA } = X;
    switch (lA) {
      case Jg:
        y(k, X, uA, E);
        break;
      case xn:
        m(k, X, uA, E);
        break;
      case gB:
        k == null && C(X, uA, E, rA);
        break;
      case Xt:
        x(
          k,
          X,
          uA,
          E,
          dA,
          vA,
          rA,
          fA,
          EA
        );
        break;
      default:
        SA & 1 ? T(
          k,
          X,
          uA,
          E,
          dA,
          vA,
          rA,
          fA,
          EA
        ) : SA & 6 ? P(
          k,
          X,
          uA,
          E,
          dA,
          vA,
          rA,
          fA,
          EA
        ) : (SA & 64 || SA & 128) && lA.process(
          k,
          X,
          uA,
          E,
          dA,
          vA,
          rA,
          fA,
          EA,
          pA
        );
    }
    HA != null && dA ? dh(HA, k && k.ref, vA, X || k, !X) : HA == null && k && k.ref != null && dh(k.ref, null, vA, k, !0);
  }, y = (k, X, uA, E) => {
    if (k == null)
      r(
        X.el = a(X.children),
        uA,
        E
      );
    else {
      const dA = X.el = k.el;
      X.children !== k.children && l(dA, X.children);
    }
  }, m = (k, X, uA, E) => {
    k == null ? r(
      X.el = o(X.children || ""),
      uA,
      E
    ) : X.el = k.el;
  }, C = (k, X, uA, E) => {
    [k.el, k.anchor] = p(
      k.children,
      X,
      uA,
      E,
      k.el,
      k.anchor
    );
  }, Q = ({ el: k, anchor: X }, uA, E) => {
    let dA;
    for (; k && k !== X; )
      dA = d(k), r(k, uA, E), k = dA;
    r(X, uA, E);
  }, F = ({ el: k, anchor: X }) => {
    let uA;
    for (; k && k !== X; )
      uA = d(k), n(k), k = uA;
    n(X);
  }, T = (k, X, uA, E, dA, vA, rA, fA, EA) => {
    if (X.type === "svg" ? rA = "svg" : X.type === "math" && (rA = "mathml"), k == null)
      V(
        X,
        uA,
        E,
        dA,
        vA,
        rA,
        fA,
        EA
      );
    else {
      const lA = k.el && k.el._isVueCE ? k.el : null;
      try {
        lA && lA._beginPatch(), I(
          k,
          X,
          dA,
          vA,
          rA,
          fA,
          EA
        );
      } finally {
        lA && lA._endPatch();
      }
    }
  }, V = (k, X, uA, E, dA, vA, rA, fA) => {
    let EA, lA;
    const { props: HA, shapeFlag: SA, transition: yA, dirs: TA } = k;
    if (EA = k.el = s(
      k.type,
      vA,
      HA && HA.is,
      HA
    ), SA & 8 ? c(EA, k.children) : SA & 16 && D(
      k.children,
      EA,
      null,
      E,
      dA,
      dB(k, vA),
      rA,
      fA
    ), TA && ol(k, null, E, "created"), M(EA, k, k.scopeId, rA, E), HA) {
      for (const MA in HA)
        MA !== "value" && !uh(MA) && i(EA, MA, null, HA[MA], vA, E);
      "value" in HA && i(EA, "value", null, HA.value, vA), (lA = HA.onVnodeBeforeMount) && Ns(lA, E, k);
    }
    TA && ol(k, null, E, "beforeMount");
    const _A = M6(dA, yA);
    _A && yA.beforeEnter(EA), r(EA, X, uA), ((lA = HA && HA.onVnodeMounted) || _A || TA) && $n(() => {
      lA && Ns(lA, E, k), _A && yA.enter(EA), TA && ol(k, null, E, "mounted");
    }, dA);
  }, M = (k, X, uA, E, dA) => {
    if (uA && h(k, uA), E)
      for (let vA = 0; vA < E.length; vA++)
        h(k, E[vA]);
    if (dA) {
      let vA = dA.subTree;
      if (X === vA || BI(vA.type) && (vA.ssContent === X || vA.ssFallback === X)) {
        const rA = dA.vnode;
        M(
          k,
          rA,
          rA.scopeId,
          rA.slotScopeIds,
          dA.parent
        );
      }
    }
  }, D = (k, X, uA, E, dA, vA, rA, fA, EA = 0) => {
    for (let lA = EA; lA < k.length; lA++) {
      const HA = k[lA] = fA ? Ua(k[lA]) : Gs(k[lA]);
      B(
        null,
        HA,
        X,
        uA,
        E,
        dA,
        vA,
        rA,
        fA
      );
    }
  }, I = (k, X, uA, E, dA, vA, rA) => {
    const fA = X.el = k.el;
    let { patchFlag: EA, dynamicChildren: lA, dirs: HA } = X;
    EA |= k.patchFlag & 16;
    const SA = k.props || Ft, yA = X.props || Ft;
    let TA;
    if (uA && ll(uA, !1), (TA = yA.onVnodeBeforeUpdate) && Ns(TA, uA, X, k), HA && ol(X, k, uA, "beforeUpdate"), uA && ll(uA, !0), // #6385 the old vnode may be a user-wrapped non-isomorphic block
    // Force full diff when block metadata is unstable.
    lA && (!k.dynamicChildren || k.dynamicChildren.length !== lA.length) && (EA = 0, rA = !1, lA = null), (SA.innerHTML && yA.innerHTML == null || SA.textContent && yA.textContent == null) && c(fA, ""), lA ? q(
      k.dynamicChildren,
      lA,
      fA,
      uA,
      E,
      dB(X, dA),
      vA
    ) : rA || tA(
      k,
      X,
      fA,
      null,
      uA,
      E,
      dB(X, dA),
      vA,
      !1
    ), EA > 0) {
      if (EA & 16)
        U(fA, SA, yA, uA, dA);
      else if (EA & 2 && SA.class !== yA.class && i(fA, "class", null, yA.class, dA), EA & 4 && i(fA, "style", SA.style, yA.style, dA), EA & 8) {
        const _A = X.dynamicProps;
        for (let MA = 0; MA < _A.length; MA++) {
          const VA = _A[MA], $A = SA[VA], ee = yA[VA];
          (ee !== $A || VA === "value") && i(fA, VA, $A, ee, dA, uA);
        }
      }
      EA & 1 && k.children !== X.children && c(fA, X.children);
    } else !rA && lA == null && U(fA, SA, yA, uA, dA);
    ((TA = yA.onVnodeUpdated) || HA) && $n(() => {
      TA && Ns(TA, uA, X, k), HA && ol(X, k, uA, "updated");
    }, E);
  }, q = (k, X, uA, E, dA, vA, rA) => {
    for (let fA = 0; fA < X.length; fA++) {
      const EA = k[fA], lA = X[fA], HA = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        EA.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (EA.type === Xt || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Cl(EA, lA) || // - In the case of a component, it could contain anything.
        EA.shapeFlag & 198) ? u(EA.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          uA
        )
      );
      B(
        EA,
        lA,
        HA,
        null,
        E,
        dA,
        vA,
        rA,
        !0
      );
    }
  }, U = (k, X, uA, E, dA) => {
    if (X !== uA) {
      if (X !== Ft)
        for (const vA in X)
          !uh(vA) && !(vA in uA) && i(
            k,
            vA,
            X[vA],
            null,
            dA,
            E
          );
      for (const vA in uA) {
        if (uh(vA)) continue;
        const rA = uA[vA], fA = X[vA];
        rA !== fA && vA !== "value" && i(k, vA, fA, rA, dA, E);
      }
      "value" in uA && i(k, "value", X.value, uA.value, dA);
    }
  }, x = (k, X, uA, E, dA, vA, rA, fA, EA) => {
    const lA = X.el = k ? k.el : a(""), HA = X.anchor = k ? k.anchor : a("");
    let { patchFlag: SA, dynamicChildren: yA, slotScopeIds: TA } = X;
    TA && (fA = fA ? fA.concat(TA) : TA), k == null ? (r(lA, uA, E), r(HA, uA, E), D(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      X.children || [],
      uA,
      HA,
      dA,
      vA,
      rA,
      fA,
      EA
    )) : SA > 0 && SA & 64 && yA && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    k.dynamicChildren && k.dynamicChildren.length === yA.length ? (q(
      k.dynamicChildren,
      yA,
      uA,
      dA,
      vA,
      rA,
      fA
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (X.key != null || dA && X === dA.subTree) && Ey(
      k,
      X,
      !0
      /* shallow */
    )) : tA(
      k,
      X,
      uA,
      HA,
      dA,
      vA,
      rA,
      fA,
      EA
    );
  }, P = (k, X, uA, E, dA, vA, rA, fA, EA) => {
    X.slotScopeIds = fA, k == null ? X.shapeFlag & 512 ? dA.ctx.activate(
      X,
      uA,
      E,
      rA,
      EA
    ) : N(
      X,
      uA,
      E,
      dA,
      vA,
      rA,
      EA
    ) : iA(k, X, EA);
  }, N = (k, X, uA, E, dA, vA, rA) => {
    const fA = k.component = q6(
      k,
      E,
      dA
    );
    if (zg(k) && (fA.ctx.renderer = pA), $6(fA, !1, rA), fA.asyncDep) {
      if (dA && dA.registerDep(fA, nA, rA), !k.el) {
        const EA = fA.subTree = nt(xn);
        m(null, EA, X, uA), k.placeholder = EA.el;
      }
    } else
      nA(
        fA,
        k,
        X,
        uA,
        dA,
        vA,
        rA
      );
  }, iA = (k, X, uA) => {
    const E = X.component = k.component;
    if (I6(k, X, uA))
      if (E.asyncDep && !E.asyncResolved) {
        X.el = k.el, sA(E, X, uA);
        return;
      } else
        E.next = X, E.update();
    else
      X.el = k.el, E.vnode = X;
  }, nA = (k, X, uA, E, dA, vA, rA) => {
    const fA = () => {
      if (k.isMounted) {
        let { next: SA, bu: yA, u: TA, parent: _A, vnode: MA } = k;
        {
          const Fe = gI(k);
          if (Fe) {
            SA && (SA.el = MA.el, sA(k, SA, rA)), Fe.asyncDep.then(() => {
              $n(() => {
                k.isUnmounted || lA();
              }, dA);
            });
            return;
          }
        }
        let VA = SA, $A;
        ll(k, !1), SA ? (SA.el = MA.el, sA(k, SA, rA)) : SA = MA, yA && Wd(yA), ($A = SA.props && SA.props.onVnodeBeforeUpdate) && Ns($A, _A, SA, MA), ll(k, !0);
        const ee = CC(k), ZA = k.subTree;
        k.subTree = ee, B(
          ZA,
          ee,
          // parent may have changed if it's in a teleport
          u(ZA.el),
          // anchor may have changed if it's in a fragment
          gA(ZA),
          k,
          dA,
          vA
        ), SA.el = ee.el, VA === null && S6(k, ee.el), TA && $n(TA, dA), ($A = SA.props && SA.props.onVnodeUpdated) && $n(
          () => Ns($A, _A, SA, MA),
          dA
        );
      } else {
        let SA;
        const { el: yA, props: TA } = X, { bm: _A, m: MA, parent: VA, root: $A, type: ee } = k, ZA = Gc(X);
        ll(k, !1), _A && Wd(_A), !ZA && (SA = TA && TA.onVnodeBeforeMount) && Ns(SA, VA, X), ll(k, !0);
        {
          $A.ce && $A.ce._hasShadowRoot() && $A.ce._injectChildStyle(
            ee,
            k.parent ? k.parent.type : void 0
          );
          const Fe = k.subTree = CC(k);
          B(
            null,
            Fe,
            uA,
            E,
            k,
            dA,
            vA
          ), X.el = Fe.el;
        }
        if (MA && $n(MA, dA), !ZA && (SA = TA && TA.onVnodeMounted)) {
          const Fe = X;
          $n(
            () => Ns(SA, VA, Fe),
            dA
          );
        }
        (X.shapeFlag & 256 || VA && Gc(VA.vnode) && VA.vnode.shapeFlag & 256) && k.a && $n(k.a, dA), k.isMounted = !0, X = uA = E = null;
      }
    };
    k.scope.on();
    const EA = k.effect = new Qx(fA);
    k.scope.off();
    const lA = k.update = EA.run.bind(EA), HA = k.job = EA.runIfDirty.bind(EA);
    HA.i = k, HA.id = k.uid, EA.scheduler = () => Cy(HA), ll(k, !0), lA();
  }, sA = (k, X, uA) => {
    X.component = k;
    const E = k.vnode.props;
    k.vnode = X, k.next = null, H6(k, X.props, E, uA), N6(k, X.children, uA), Ta(), uC(k), _a();
  }, tA = (k, X, uA, E, dA, vA, rA, fA, EA = !1) => {
    const lA = k && k.children, HA = k ? k.shapeFlag : 0, SA = X.children, { patchFlag: yA, shapeFlag: TA } = X;
    if (yA > 0) {
      if (yA & 128) {
        FA(
          lA,
          SA,
          uA,
          E,
          dA,
          vA,
          rA,
          fA,
          EA
        );
        return;
      } else if (yA & 256) {
        cA(
          lA,
          SA,
          uA,
          E,
          dA,
          vA,
          rA,
          fA,
          EA
        );
        return;
      }
    }
    TA & 8 ? (HA & 16 && oA(lA, dA, vA), SA !== lA && c(uA, SA)) : HA & 16 ? TA & 16 ? FA(
      lA,
      SA,
      uA,
      E,
      dA,
      vA,
      rA,
      fA,
      EA
    ) : oA(lA, dA, vA, !0) : (HA & 8 && c(uA, ""), TA & 16 && D(
      SA,
      uA,
      E,
      dA,
      vA,
      rA,
      fA,
      EA
    ));
  }, cA = (k, X, uA, E, dA, vA, rA, fA, EA) => {
    k = k || El, X = X || El;
    const lA = k.length, HA = X.length, SA = Math.min(lA, HA);
    let yA;
    for (yA = 0; yA < SA; yA++) {
      const TA = X[yA] = EA ? Ua(X[yA]) : Gs(X[yA]);
      B(
        k[yA],
        TA,
        uA,
        null,
        dA,
        vA,
        rA,
        fA,
        EA
      );
    }
    lA > HA ? oA(
      k,
      dA,
      vA,
      !0,
      !1,
      SA
    ) : D(
      X,
      uA,
      E,
      dA,
      vA,
      rA,
      fA,
      EA,
      SA
    );
  }, FA = (k, X, uA, E, dA, vA, rA, fA, EA) => {
    let lA = 0;
    const HA = X.length;
    let SA = k.length - 1, yA = HA - 1;
    for (; lA <= SA && lA <= yA; ) {
      const TA = k[lA], _A = X[lA] = EA ? Ua(X[lA]) : Gs(X[lA]);
      if (Cl(TA, _A))
        B(
          TA,
          _A,
          uA,
          null,
          dA,
          vA,
          rA,
          fA,
          EA
        );
      else
        break;
      lA++;
    }
    for (; lA <= SA && lA <= yA; ) {
      const TA = k[SA], _A = X[yA] = EA ? Ua(X[yA]) : Gs(X[yA]);
      if (Cl(TA, _A))
        B(
          TA,
          _A,
          uA,
          null,
          dA,
          vA,
          rA,
          fA,
          EA
        );
      else
        break;
      SA--, yA--;
    }
    if (lA > SA) {
      if (lA <= yA) {
        const TA = yA + 1, _A = TA < HA ? X[TA].el : E;
        for (; lA <= yA; )
          B(
            null,
            X[lA] = EA ? Ua(X[lA]) : Gs(X[lA]),
            uA,
            _A,
            dA,
            vA,
            rA,
            fA,
            EA
          ), lA++;
      }
    } else if (lA > yA)
      for (; lA <= SA; )
        S(k[lA], dA, vA, !0), lA++;
    else {
      const TA = lA, _A = lA, MA = /* @__PURE__ */ new Map();
      for (lA = _A; lA <= yA; lA++) {
        const ae = X[lA] = EA ? Ua(X[lA]) : Gs(X[lA]);
        ae.key != null && MA.set(ae.key, lA);
      }
      let VA, $A = 0;
      const ee = yA - _A + 1;
      let ZA = !1, Fe = 0;
      const me = new Array(ee);
      for (lA = 0; lA < ee; lA++) me[lA] = 0;
      for (lA = TA; lA <= SA; lA++) {
        const ae = k[lA];
        if ($A >= ee) {
          S(ae, dA, vA, !0);
          continue;
        }
        let Te;
        if (ae.key != null)
          Te = MA.get(ae.key);
        else
          for (VA = _A; VA <= yA; VA++)
            if (me[VA - _A] === 0 && Cl(ae, X[VA])) {
              Te = VA;
              break;
            }
        Te === void 0 ? S(ae, dA, vA, !0) : (me[Te - _A] = lA + 1, Te >= Fe ? Fe = Te : ZA = !0, B(
          ae,
          X[Te],
          uA,
          null,
          dA,
          vA,
          rA,
          fA,
          EA
        ), $A++);
      }
      const Ce = ZA ? P6(me) : El;
      for (VA = Ce.length - 1, lA = ee - 1; lA >= 0; lA--) {
        const ae = _A + lA, Te = X[ae], ie = X[ae + 1], Ke = ae + 1 < HA ? (
          // #13559, #14173 fallback to el placeholder for unresolved async component
          ie.el || pI(ie)
        ) : E;
        me[lA] === 0 ? B(
          null,
          Te,
          uA,
          Ke,
          dA,
          vA,
          rA,
          fA,
          EA
        ) : ZA && (VA < 0 || lA !== Ce[VA] ? CA(Te, uA, Ke, 2) : VA--);
      }
    }
  }, CA = (k, X, uA, E, dA = null) => {
    const { el: vA, type: rA, transition: fA, children: EA, shapeFlag: lA } = k;
    if (lA & 6) {
      CA(k.component.subTree, X, uA, E);
      return;
    }
    if (lA & 128) {
      k.suspense.move(X, uA, E);
      return;
    }
    if (lA & 64) {
      rA.move(k, X, uA, pA);
      return;
    }
    if (rA === Xt) {
      r(vA, X, uA);
      for (let SA = 0; SA < EA.length; SA++)
        CA(EA[SA], X, uA, E);
      r(k.anchor, X, uA);
      return;
    }
    if (rA === gB) {
      Q(k, X, uA);
      return;
    }
    if (E !== 2 && lA & 1 && fA)
      if (E === 0)
        fA.persisted && !vA[ki] ? r(vA, X, uA) : (fA.beforeEnter(vA), r(vA, X, uA), $n(() => fA.enter(vA), dA));
      else {
        const { leave: SA, delayLeave: yA, afterLeave: TA } = fA, _A = () => {
          k.ctx.isUnmounted ? n(vA) : r(vA, X, uA);
        }, MA = () => {
          const VA = vA._isLeaving || !!vA[ki];
          vA._isLeaving && vA[ki](
            !0
            /* cancelled */
          ), fA.persisted && !VA ? _A() : SA(vA, () => {
            _A(), TA && TA();
          });
        };
        yA ? yA(vA, _A, MA) : MA();
      }
    else
      r(vA, X, uA);
  }, S = (k, X, uA, E = !1, dA = !1) => {
    const {
      type: vA,
      props: rA,
      ref: fA,
      children: EA,
      dynamicChildren: lA,
      shapeFlag: HA,
      patchFlag: SA,
      dirs: yA,
      cacheIndex: TA,
      memo: _A
    } = k;
    if ((SA === -2 || lA && lA.hasOnce) && (dA = !1), fA != null && (Ta(), dh(fA, null, uA, k, !0), _a()), TA != null && (!k.ctx || k.ctx === X) && (X.renderCache[TA] = void 0), HA & 256) {
      X.ctx.deactivate(k);
      return;
    }
    const MA = HA & 1 && yA, VA = !Gc(k);
    let $A;
    if (VA && ($A = rA && rA.onVnodeBeforeUnmount) && Ns($A, X, k), HA & 6)
      AA(k.component, uA, E);
    else {
      if (HA & 128) {
        k.suspense.unmount(uA, E);
        return;
      }
      MA && ol(k, null, X, "beforeUnmount"), HA & 64 ? k.type.remove(
        k,
        X,
        uA,
        pA,
        E
      ) : lA && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !lA.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (vA !== Xt || SA > 0 && SA & 64) ? oA(
        lA,
        X,
        uA,
        !1,
        !0
      ) : (vA === Xt && SA & 384 || !dA && HA & 16) && oA(EA, X, uA), E && W(k);
    }
    const ee = _A != null && TA == null;
    (VA && ($A = rA && rA.onVnodeUnmounted) || MA || ee) && $n(() => {
      $A && Ns($A, X, k), MA && ol(k, null, X, "unmounted"), ee && (k.el = null);
    }, uA);
  }, W = (k) => {
    const { type: X, el: uA, anchor: E, transition: dA } = k;
    if (X === Xt) {
      Y(uA, E);
      return;
    }
    if (X === gB) {
      F(k), dA && !dA.persisted && dA.afterLeave && dA.afterLeave();
      return;
    }
    const vA = () => {
      n(uA), dA && !dA.persisted && dA.afterLeave && dA.afterLeave();
    };
    if (k.shapeFlag & 1 && dA && !dA.persisted) {
      const { leave: rA, delayLeave: fA } = dA, EA = () => rA(uA, vA);
      fA ? fA(k.el, vA, EA) : EA();
    } else
      vA();
  }, Y = (k, X) => {
    let uA;
    for (; k !== X; )
      uA = d(k), n(k), k = uA;
    n(X);
  }, AA = (k, X, uA) => {
    const { bum: E, scope: dA, job: vA, subTree: rA, um: fA, m: EA, a: lA } = k;
    QC(EA), QC(lA), E && Wd(E), dA.stop(), vA ? (vA.flags |= 8, S(rA, k, X, uA)) : k.vnode.el && rA && (rA.transition = k.vnode.transition, S(rA, k, X, uA)), fA && $n(fA, X), $n(() => {
      k.isUnmounted = !0;
    }, X);
  }, oA = (k, X, uA, E = !1, dA = !1, vA = 0) => {
    for (let rA = vA; rA < k.length; rA++)
      S(k[rA], X, uA, E, dA);
  }, gA = (k) => {
    if (k.shapeFlag & 6)
      return gA(k.component.subTree);
    if (k.shapeFlag & 128)
      return k.suspense.next();
    const X = d(k.anchor || k.el), uA = X && X[qx];
    return uA ? d(uA) : X;
  };
  let xA = !1;
  const IA = (k, X, uA) => {
    let E;
    k == null ? X._vnode && (S(X._vnode, null, null, !0), E = X._vnode.component) : B(
      X._vnode || null,
      k,
      X,
      null,
      null,
      null,
      uA
    ), X._vnode = k, xA || (xA = !0, uC(E), Kx(), xA = !1);
  }, pA = {
    p: B,
    um: S,
    m: CA,
    r: W,
    mt: N,
    mc: D,
    pc: tA,
    pbc: q,
    n: gA,
    o: e
  };
  return {
    render: IA,
    hydrate: void 0,
    createApp: b6(IA)
  };
}
function dB({ type: e, props: A }, t) {
  return t === "svg" && e === "foreignObject" || t === "mathml" && e === "annotation-xml" && A && A.encoding && A.encoding.includes("html") ? void 0 : t;
}
function ll({ effect: e, job: A }, t) {
  t ? (e.flags |= 32, A.flags |= 4) : (e.flags &= -33, A.flags &= -5);
}
function M6(e, A) {
  return (!e || e && !e.pendingBranch) && A && !A.persisted;
}
function Ey(e, A, t = !1) {
  const r = e.children, n = A.children;
  if (Se(r) && Se(n))
    for (let i = 0; i < r.length; i++) {
      const s = r[i];
      let a = n[i];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = n[i] = Ua(n[i]), a.el = s.el), !t && a.patchFlag !== -2 && Ey(s, a)), a.type === Jg && (a.patchFlag === -1 && (a = n[i] = Ua(a)), a.el = s.el), a.type === xn && !a.el && (a.el = s.el);
    }
}
function P6(e) {
  const A = e.slice(), t = [0];
  let r, n, i, s, a;
  const o = e.length;
  for (r = 0; r < o; r++) {
    const l = e[r];
    if (l !== 0) {
      if (n = t[t.length - 1], e[n] < l) {
        A[r] = n, t.push(r);
        continue;
      }
      for (i = 0, s = t.length - 1; i < s; )
        a = i + s >> 1, e[t[a]] < l ? i = a + 1 : s = a;
      l < e[t[i]] && (i > 0 && (A[r] = t[i - 1]), t[i] = r);
    }
  }
  for (i = t.length, s = t[i - 1]; i-- > 0; )
    t[i] = s, s = A[s];
  return t;
}
function gI(e) {
  const A = e.subTree.component;
  if (A)
    return A.asyncDep && !A.asyncResolved ? A : gI(A);
}
function QC(e) {
  if (e)
    for (let A = 0; A < e.length; A++)
      e[A].flags |= 8;
}
function pI(e) {
  if (e.placeholder)
    return e.placeholder;
  const A = e.component;
  return A ? pI(A.subTree) : null;
}
const BI = (e) => e.__isSuspense;
function k6(e, A) {
  A && A.pendingBranch ? Se(e) ? A.effects.push(...e) : A.effects.push(e) : W_(e);
}
const Xt = /* @__PURE__ */ Symbol.for("v-fgt"), Jg = /* @__PURE__ */ Symbol.for("v-txt"), xn = /* @__PURE__ */ Symbol.for("v-cmt"), gB = /* @__PURE__ */ Symbol.for("v-stc"), La = [];
let Ei = null;
function Ee(e = !1) {
  La.push(Ei = e ? null : []);
}
function xy() {
  La.pop(), Ei = La[La.length - 1] || null;
}
let Lh = 1;
function fg(e, A = !1) {
  Lh += e, e < 0 && Ei && A && (Ei.hasOnce = !0);
}
function wI(e) {
  return e.dynamicChildren = Lh > 0 ? Ei || El : null, xy(), Lh > 0 && Ei && Ei.push(e), e;
}
function Le(e, A, t, r, n, i) {
  return wI(
    eA(
      e,
      A,
      t,
      r,
      n,
      i,
      !0
    )
  );
}
function Fo(e, A, t, r, n) {
  return wI(
    nt(
      e,
      A,
      t,
      r,
      n,
      !0
    )
  );
}
function Hh(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Cl(e, A) {
  return e.type === A.type && e.key === A.key;
}
const mI = ({ key: e }) => e ?? null, qd = ({
  ref: e,
  ref_key: A,
  ref_for: t
}) => (typeof e == "number" && (e = "" + e), e != null ? kt(e) || /* @__PURE__ */ Ln(e) || Re(e) ? { i: on, r: e, k: A, f: !!t } : e : null);
function eA(e, A = null, t = null, r = 0, n = null, i = e === Xt ? 0 : 1, s = !1, a = !1) {
  const o = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: A,
    key: A && mI(A),
    ref: A && qd(A),
    scopeId: Gx,
    slotScopeIds: null,
    children: t,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: i,
    patchFlag: r,
    dynamicProps: n,
    dynamicChildren: null,
    appContext: null,
    ctx: on
  };
  return a ? (dg(o, t), i & 128 && e.normalize(o)) : t && (o.shapeFlag |= kt(t) ? 8 : 16), Lh > 0 && // avoid a block node from tracking itself
  !s && // has current parent block
  Ei && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (o.patchFlag > 0 || i & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  o.patchFlag !== 32 && Ei.push(o), o;
}
const nt = K6;
function K6(e, A = null, t = null, r = 0, n = null, i = !1) {
  if ((!e || e === f6) && (e = xn), Hh(e)) {
    const a = Ro(
      e,
      A,
      !0
      /* mergeRef: true */
    );
    return t && dg(a, t), Lh > 0 && !i && Ei && (a.shapeFlag & 6 ? Ei[Ei.indexOf(e)] = a : Ei.push(a)), a.patchFlag = -2, a;
  }
  if (Z6(e) && (e = e.__vccOpts), A) {
    A = V6(A);
    let { class: a, style: o } = A;
    a && !kt(a) && (A.class = ks(a)), dt(o) && (/* @__PURE__ */ yy(o) && !Se(o) && (o = Gr({}, o)), A.style = zt(o));
  }
  const s = kt(e) ? 1 : BI(e) ? 128 : qg(e) ? 64 : dt(e) ? 4 : Re(e) ? 2 : 0;
  return eA(
    e,
    A,
    t,
    r,
    n,
    s,
    i,
    !0
  );
}
function V6(e) {
  return e ? /* @__PURE__ */ yy(e) || lI(e) ? Gr({}, e) : e : null;
}
function Ro(e, A, t = !1, r = !1) {
  const { props: n, ref: i, patchFlag: s, children: a, transition: o } = e, l = A ? G6(n || {}, A) : n, c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: l,
    key: l && mI(l),
    ref: A && A.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      t && i ? Se(i) ? i.concat(qd(A)) : [i, qd(A)] : qd(A)
    ) : i,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: a,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: A && e.type !== Xt ? s === -1 ? 16 : s | 16 : s,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: o,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && Ro(e.ssContent),
    ssFallback: e.ssFallback && Ro(e.ssFallback),
    placeholder: e.placeholder,
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce,
    cacheIndex: e.cacheIndex
  };
  return o && r && Sh(
    c,
    o.clone(c)
  ), c;
}
function Ci(e = " ", A = 0) {
  return nt(Jg, null, e, A);
}
function $t(e = "", A = !1) {
  return A ? (Ee(), Fo(xn, null, e)) : nt(xn, null, e);
}
function Gs(e) {
  return e == null || typeof e == "boolean" ? nt(xn) : Se(e) ? nt(
    Xt,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : Hh(e) ? Ua(e) : nt(Jg, null, String(e));
}
function Ua(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : Ro(e);
}
function dg(e, A) {
  let t = 0;
  const { shapeFlag: r } = e;
  if (A == null)
    A = null;
  else if (Se(A))
    t = 16;
  else if (typeof A == "object")
    if (r & 65) {
      const n = A.default;
      n && (n._c && (n._d = !1), dg(e, n()), n._c && (n._d = !0));
      return;
    } else {
      t = 32;
      const n = A._;
      !n && !lI(A) ? A._ctx = on : n === 3 && on && (on.slots._ === 1 ? A._ = 1 : (A._ = 2, e.patchFlag |= 1024));
    }
  else if (Re(A)) {
    if (r & 65) {
      dg(e, { default: A });
      return;
    }
    A = { default: A, _ctx: on }, t = 32;
  } else
    A = String(A), r & 64 ? (t = 16, A = [Ci(A)]) : t = 8;
  e.children = A, e.shapeFlag |= t;
}
function G6(...e) {
  const A = {};
  for (let t = 0; t < e.length; t++) {
    const r = e[t];
    for (const n in r)
      if (n === "class")
        A.class !== r.class && (A.class = ks([A.class, r.class]));
      else if (n === "style")
        A.style = zt([A.style, r.style]);
      else if (Pg(n)) {
        const i = A[n], s = r[n];
        s && i !== s && !(Se(i) && i.includes(s)) ? A[n] = i ? [].concat(i, s) : s : s == null && i == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
        // the model listener.
        !kg(n) && (A[n] = s);
      } else n !== "" && (A[n] = r[n]);
  }
  return A;
}
function Ns(e, A, t, r = null) {
  Zi(e, A, 7, [
    t,
    r
  ]);
}
const W6 = nI();
let j6 = 0;
function q6(e, A, t) {
  const r = e.type, n = (A ? A.appContext : e.appContext) || W6, i = {
    uid: j6++,
    vnode: e,
    type: r,
    parent: A,
    appContext: n,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new g_(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: A ? A.provides : Object.create(n.provides),
    ids: A ? A.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: uI(r, n),
    emitsOptions: iI(r, n),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: Ft,
    // inheritAttrs
    inheritAttrs: r.inheritAttrs,
    // state
    ctx: Ft,
    data: Ft,
    props: Ft,
    attrs: Ft,
    slots: Ft,
    refs: Ft,
    setupState: Ft,
    setupContext: null,
    // suspense related
    suspense: t,
    suspenseId: t ? t.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return i.ctx = { _: i }, i.root = A ? A.root : i, i.emit = Q6.bind(null, i), e.ce && e.ce(i), i;
}
let In = null;
const vI = () => In || on;
let gg, Th;
{
  const e = Gg(), A = (t, r) => {
    let n;
    return (n = e[t]) || (n = e[t] = []), n.push(r), (i) => {
      n.length > 1 ? n.forEach((s) => s(i)) : n[0](i);
    };
  };
  gg = A(
    "__VUE_INSTANCE_SETTERS__",
    (t) => In = t
  ), Th = A(
    "__VUE_SSR_SETTERS__",
    (t) => _h = t
  );
}
const zh = (e) => {
  const A = In;
  return gg(e), e.scope.on(), () => {
    e.scope.off(), gg(A);
  };
}, UC = () => {
  In && In.scope.off(), gg(null);
};
function yI(e) {
  return e.vnode.shapeFlag & 4;
}
let _h = !1;
function $6(e, A = !1, t = !1) {
  A && Th(A);
  const { props: r, children: n } = e.vnode, i = yI(e);
  L6(e, r, i, A), O6(e, n, t || A);
  const s = i ? z6(e, A) : void 0;
  return A && Th(!1), s;
}
function z6(e, A) {
  const t = e.type;
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, p6);
  const { setup: r } = t;
  if (r) {
    Ta();
    const n = e.setupContext = r.length > 1 ? Y6(e) : null, i = zh(e), s = $h(
      r,
      e,
      0,
      [
        e.props,
        n
      ]
    ), a = Bx(s);
    if (_a(), i(), (a || e.sp) && !Gc(e) && Zx(e), a) {
      if (s.then(UC, UC), A)
        return s.then((o) => {
          Th(!0);
          try {
            EC(e, o, A);
          } finally {
            Th(!1);
          }
        }).catch((o) => {
          jg(o, e, 0);
        });
      e.asyncDep = s;
    } else
      EC(e, s);
  } else
    CI(e);
}
function EC(e, A, t) {
  Re(A) ? e.type.__ssrInlineRender ? e.ssrRender = A : e.render = A : dt(A) && (e.setupState = Mx(A)), CI(e);
}
function CI(e, A, t) {
  const r = e.type;
  e.render || (e.render = r.render || qs);
  {
    const n = zh(e);
    Ta();
    try {
      B6(e);
    } finally {
      _a(), n();
    }
  }
}
const X6 = {
  get(e, A) {
    return En(e, "get", ""), e[A];
  }
};
function Y6(e) {
  const A = (t) => {
    e.exposed = t || {};
  };
  return {
    attrs: new Proxy(e.attrs, X6),
    slots: e.slots,
    emit: e.emit,
    expose: A
  };
}
function Zg(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(Mx(O_(e.exposed)), {
    get(A, t) {
      if (t in A)
        return A[t];
      if (t in gh)
        return gh[t](e);
    },
    has(A, t) {
      return t in A || t in gh;
    }
  })) : e.proxy;
}
function J6(e, A = !0) {
  return Re(e) ? e.displayName || e.name : e.name || A && e.__name;
}
function Z6(e) {
  return Re(e) && "__vccOpts" in e;
}
const bt = (e, A) => /* @__PURE__ */ P_(e, A, _h);
function AO(e, A, t) {
  try {
    fg(-1);
    const r = arguments.length;
    return r === 2 ? dt(A) && !Se(A) ? Hh(A) ? nt(e, null, [A]) : nt(e, A) : nt(e, null, A) : (r > 3 ? t = Array.prototype.slice.call(arguments, 2) : r === 3 && Hh(t) && (t = [t]), nt(e, A, t));
  } finally {
    fg(1);
  }
}
const eO = "3.5.43";
let N1;
const xC = typeof window < "u" && window.trustedTypes;
if (xC)
  try {
    N1 = /* @__PURE__ */ xC.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch {
  }
const bI = N1 ? (e) => N1.createHTML(e) : (e) => e, tO = "http://www.w3.org/2000/svg", rO = "http://www.w3.org/1998/Math/MathML", Qa = typeof document < "u" ? document : null, IC = Qa && /* @__PURE__ */ Qa.createElement("template"), nO = {
  insert: (e, A, t) => {
    A.insertBefore(e, t || null);
  },
  remove: (e) => {
    const A = e.parentNode;
    A && A.removeChild(e);
  },
  createElement: (e, A, t, r) => {
    const n = A === "svg" ? Qa.createElementNS(tO, e) : A === "mathml" ? Qa.createElementNS(rO, e) : t ? Qa.createElement(e, { is: t }) : Qa.createElement(e);
    return e === "select" && r && r.multiple != null && n.setAttribute("multiple", r.multiple), n;
  },
  createText: (e) => Qa.createTextNode(e),
  createComment: (e) => Qa.createComment(e),
  setText: (e, A) => {
    e.nodeValue = A;
  },
  setElementText: (e, A) => {
    e.textContent = A;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => Qa.querySelector(e),
  setScopeId(e, A) {
    e.setAttribute(A, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, A, t, r, n, i) {
    const s = t ? t.previousSibling : A.lastChild;
    if (n && (n === i || n.nextSibling))
      for (; A.insertBefore(n.cloneNode(!0), t), !(n === i || !(n = n.nextSibling)); )
        ;
    else {
      IC.innerHTML = bI(
        r === "svg" ? `<svg>${e}</svg>` : r === "mathml" ? `<math>${e}</math>` : e
      );
      const a = IC.content;
      if (r === "svg" || r === "mathml") {
        const o = a.firstChild;
        for (; o.firstChild; )
          a.appendChild(o.firstChild);
        a.removeChild(o);
      }
      A.insertBefore(a, t);
    }
    return [
      // first
      s ? s.nextSibling : A.firstChild,
      // last
      t ? t.previousSibling : A.lastChild
    ];
  }
}, co = "transition", bu = "animation", Oh = /* @__PURE__ */ Symbol("_vtc"), FI = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, iO = /* @__PURE__ */ Gr(
  {},
  $x,
  FI
), sO = (e) => (e.displayName = "Transition", e.props = iO, e), Fu = /* @__PURE__ */ sO(
  (e, { slots: A }) => AO(e6, aO(e), A)
), cl = (e, A = []) => {
  Se(e) ? e.forEach((t) => t(...A)) : e && e(...A);
}, SC = (e) => e ? Se(e) ? e.some((A) => A.length > 1) : e.length > 1 : !1;
function aO(e) {
  const A = {};
  for (const x in e)
    x in FI || (A[x] = e[x]);
  if (e.css === !1)
    return A;
  const {
    name: t = "v",
    type: r,
    duration: n,
    enterFromClass: i = `${t}-enter-from`,
    enterActiveClass: s = `${t}-enter-active`,
    enterToClass: a = `${t}-enter-to`,
    appearFromClass: o = i,
    appearActiveClass: l = s,
    appearToClass: c = a,
    leaveFromClass: u = `${t}-leave-from`,
    leaveActiveClass: d = `${t}-leave-active`,
    leaveToClass: h = `${t}-leave-to`
  } = e, p = oO(n), B = p && p[0], y = p && p[1], {
    onBeforeEnter: m,
    onEnter: C,
    onEnterCancelled: Q,
    onLeave: F,
    onLeaveCancelled: T,
    onBeforeAppear: V = m,
    onAppear: M = C,
    onAppearCancelled: D = Q
  } = A, I = (x, P, N, iA) => {
    x._enterCancelled = iA, ul(x, P ? c : a), ul(x, P ? l : s), N && N();
  }, q = (x, P) => {
    x._isLeaving = !1, ul(x, u), ul(x, h), ul(x, d), P && P();
  }, U = (x) => (P, N) => {
    const iA = x ? M : C, nA = () => I(P, x, N);
    cl(iA, [P, nA]), LC(() => {
      ul(P, x ? o : i), ga(P, x ? c : a), SC(iA) || HC(P, r, B, nA);
    });
  };
  return Gr(A, {
    onBeforeEnter(x) {
      cl(m, [x]), ga(x, i), ga(x, s);
    },
    onBeforeAppear(x) {
      cl(V, [x]), ga(x, o), ga(x, l);
    },
    onEnter: U(!1),
    onAppear: U(!0),
    onLeave(x, P) {
      x._isLeaving = !0;
      const N = () => q(x, P);
      ga(x, u), x._enterCancelled ? (ga(x, d), OC(x)) : (OC(x), ga(x, d)), LC(() => {
        x._isLeaving && (ul(x, u), ga(x, h), SC(F) || HC(x, r, y, N));
      }), cl(F, [x, N]);
    },
    onEnterCancelled(x) {
      I(x, !1, void 0, !0), cl(Q, [x]);
    },
    onAppearCancelled(x) {
      I(x, !0, void 0, !0), cl(D, [x]);
    },
    onLeaveCancelled(x) {
      q(x), cl(T, [x]);
    }
  });
}
function oO(e) {
  if (e == null)
    return null;
  if (dt(e))
    return [pB(e.enter), pB(e.leave)];
  {
    const A = pB(e);
    return [A, A];
  }
}
function pB(e) {
  return s_(e);
}
function ga(e, A) {
  A.split(/\s+/).forEach((t) => t && e.classList.add(t)), (e[Oh] || (e[Oh] = /* @__PURE__ */ new Set())).add(A);
}
function ul(e, A) {
  A.split(/\s+/).forEach((r) => r && e.classList.remove(r));
  const t = e[Oh];
  t && (t.delete(A), t.size || (e[Oh] = void 0));
}
function LC(e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}
let lO = 0;
function HC(e, A, t, r) {
  const n = e._endId = ++lO, i = () => {
    n === e._endId && r();
  };
  if (t != null)
    return setTimeout(i, t);
  const { type: s, timeout: a, propCount: o } = cO(e, A);
  if (!s)
    return r();
  const l = s + "end";
  let c = 0;
  const u = () => {
    e.removeEventListener(l, d), i();
  }, d = (h) => {
    h.target === e && ++c >= o && u();
  };
  setTimeout(() => {
    c < o && u();
  }, a + 1), e.addEventListener(l, d);
}
function cO(e, A) {
  const t = window.getComputedStyle(e), r = (p) => (t[p] || "").split(", "), n = r(`${co}Delay`), i = r(`${co}Duration`), s = TC(n, i), a = r(`${bu}Delay`), o = r(`${bu}Duration`), l = TC(a, o);
  let c = null, u = 0, d = 0;
  A === co ? s > 0 && (c = co, u = s, d = i.length) : A === bu ? l > 0 && (c = bu, u = l, d = o.length) : (u = Math.max(s, l), c = u > 0 ? s > l ? co : bu : null, d = c ? c === co ? i.length : o.length : 0);
  const h = c === co && /\b(?:transform|all)(?:,|$)/.test(
    r(`${co}Property`).toString()
  );
  return {
    type: c,
    timeout: u,
    propCount: d,
    hasTransform: h
  };
}
function TC(e, A) {
  for (; e.length < A.length; )
    e = e.concat(e);
  return Math.max(...A.map((t, r) => _C(t) + _C(e[r])));
}
function _C(e) {
  return e === "auto" ? 0 : Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function OC(e) {
  return (e ? e.ownerDocument : document).body.offsetHeight;
}
function uO(e, A, t) {
  const r = e[Oh];
  r && (A = (A ? [A, ...r] : [...r]).join(" ")), A == null ? e.removeAttribute("class") : t ? e.setAttribute("class", A) : e.className = A;
}
const pg = /* @__PURE__ */ Symbol("_vod"), QI = /* @__PURE__ */ Symbol("_vsh"), NC = {
  // used for prop mismatch check during hydration
  name: "show",
  beforeMount(e, { value: A }, { transition: t }) {
    e[pg] = e.style.display === "none" ? "" : e.style.display, t && A ? t.beforeEnter(e) : Qu(e, A);
  },
  mounted(e, { value: A }, { transition: t }) {
    t && A && t.enter(e);
  },
  updated(e, { value: A, oldValue: t }, { transition: r }) {
    !A != !t && (r ? A ? (r.beforeEnter(e), Qu(e, !0), r.enter(e)) : r.leave(e, () => {
      Qu(e, !1);
    }) : Qu(e, A));
  },
  beforeUnmount(e, { value: A }) {
    Qu(e, A);
  }
};
function Qu(e, A) {
  e.style.display = A ? e[pg] : "none", e[QI] = !A;
}
const hO = /* @__PURE__ */ Symbol(""), fO = /(?:^|;)\s*display\s*:/;
function dO(e, A, t) {
  const r = e.style, n = kt(t);
  let i = !1;
  if (t && !n) {
    if (A)
      if (kt(A))
        for (const s of A.split(";")) {
          const a = s.slice(0, s.indexOf(":")).trim();
          t[a] == null && qu(r, a, "");
        }
      else
        for (const s in A)
          t[s] == null && qu(r, s, "");
    for (const s in t) {
      s === "display" && (i = !0);
      const a = t[s];
      a != null ? pO(
        e,
        s,
        !kt(A) && A ? A[s] : void 0,
        a
      ) || qu(r, s, a) : qu(r, s, "");
    }
  } else if (n) {
    if (A !== t) {
      const s = r[hO];
      s && (t += ";" + s), r.cssText = t, i = fO.test(t);
    }
  } else A && e.removeAttribute("style");
  pg in e && (e[pg] = i ? r.display : "", e[QI] && (r.display = "none"));
}
const Rf = /\s*!important$/;
function qu(e, A, t) {
  if (Se(t))
    t.forEach((r) => qu(e, A, r));
  else if (t == null && (t = ""), A.startsWith("--"))
    Rf.test(t) ? e.setProperty(A, t.replace(Rf, ""), "important") : e.setProperty(A, t);
  else {
    const r = gO(e, A);
    Rf.test(t) ? e.setProperty(
      Jl(r),
      t.replace(Rf, ""),
      "important"
    ) : e[r] = t;
  }
}
const DC = ["Webkit", "Moz", "ms"], BB = {};
function gO(e, A) {
  const t = BB[A];
  if (t)
    return t;
  let r = Yn(A);
  if (r !== "filter" && r in e)
    return BB[A] = r;
  r = Vg(r);
  for (let n = 0; n < DC.length; n++) {
    const i = DC[n] + r;
    if (i in e)
      return BB[A] = i;
  }
  return A;
}
function pO(e, A, t, r) {
  return e.tagName === "TEXTAREA" && (A === "width" || A === "height") && kt(r) && t === r;
}
const RC = "http://www.w3.org/1999/xlink";
function MC(e, A, t, r, n, i = h_(A)) {
  r && A.startsWith("xlink:") ? t == null ? e.removeAttributeNS(RC, A.slice(6, A.length)) : e.setAttributeNS(RC, A, t) : t == null || i && !yx(t) ? e.removeAttribute(A) : e.setAttribute(
    A,
    i ? "" : ys(t) ? String(t) : t
  );
}
function PC(e, A, t, r, n) {
  if (A === "innerHTML" || A === "textContent") {
    t != null && (e[A] = A === "innerHTML" ? bI(t) : t);
    return;
  }
  const i = e.tagName;
  if (A === "value" && i !== "PROGRESS" && // custom elements may use _value internally
  !i.includes("-")) {
    const a = i === "OPTION" ? e.getAttribute("value") || "" : e.value, o = t == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(t);
    (a !== o || !("_value" in e)) && (e.value = o), t == null && e.removeAttribute(A), e._value = t;
    return;
  }
  let s = !1;
  if (t === "" || t == null) {
    const a = typeof e[A];
    a === "boolean" ? t = yx(t) : t == null && a === "string" ? (t = "", s = !0) : a === "number" && (t = 0, s = !0);
  }
  try {
    e[A] = t;
  } catch {
  }
  s && e.removeAttribute(n || A);
}
function bl(e, A, t, r) {
  e.addEventListener(A, t, r);
}
function BO(e, A, t, r) {
  e.removeEventListener(A, t, r);
}
const kC = /* @__PURE__ */ Symbol("_vei");
function wO(e, A, t, r, n = null) {
  const i = e[kC] || (e[kC] = {}), s = i[A];
  if (r && s)
    s.value = r;
  else {
    const [a, o] = yO(A);
    if (r) {
      const l = i[A] = FO(
        r,
        n
      );
      bl(e, a, l, o);
    } else s && (BO(e, a, s, o), i[A] = void 0);
  }
}
const mO = /(Once|Passive|Capture)$/, vO = /^on:?(?:Once|Passive|Capture)$/;
function yO(e) {
  let A, t;
  for (; (t = e.match(mO)) && !vO.test(e); )
    A || (A = {}), e = e.slice(0, e.length - t[1].length), A[t[1].toLowerCase()] = !0;
  return [e[2] === ":" ? e.slice(3) : Jl(e.slice(2)), A];
}
let wB = 0;
const CO = /* @__PURE__ */ Promise.resolve(), bO = () => wB || (CO.then(() => wB = 0), wB = Date.now());
function FO(e, A) {
  const t = (r) => {
    if (!r._vts)
      r._vts = Date.now();
    else if (r._vts <= t.attached)
      return;
    const n = t.value;
    if (Se(n)) {
      const i = r.stopImmediatePropagation;
      r.stopImmediatePropagation = () => {
        i.call(r), r._stopped = !0;
      };
      const s = n.slice(), a = [r];
      for (let o = 0; o < s.length && !r._stopped; o++) {
        const l = s[o];
        l && Zi(
          l,
          A,
          5,
          a
        );
      }
    } else
      Zi(
        n,
        A,
        5,
        [r]
      );
  };
  return t.value = e, t.attached = bO(), t;
}
const KC = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, QO = (e, A, t, r, n, i) => {
  const s = n === "svg";
  A === "class" ? uO(e, r, s) : A === "style" ? dO(e, t, r) : Pg(A) ? kg(A) || wO(e, A, t, r, i) : (A[0] === "." ? (A = A.slice(1), !0) : A[0] === "^" ? (A = A.slice(1), !1) : UO(e, A, r, s)) ? (PC(e, A, r), !e.tagName.includes("-") && (A === "value" || A === "checked" || A === "selected") && MC(e, A, r, s, i, A !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && // #12408 check if it's declared prop or it's async custom element
  (EO(e, A) || // @ts-expect-error _def is private
  e._def.__asyncLoader && (/[A-Z]/.test(A) || !kt(r))) ? PC(e, Yn(A), r, i, A) : (A === "true-value" ? e._trueValue = r : A === "false-value" && (e._falseValue = r), MC(e, A, r, s));
};
function UO(e, A, t, r) {
  if (r)
    return !!(A === "innerHTML" || A === "textContent" || A in e && KC(A) && Re(t));
  if (A === "spellcheck" || A === "draggable" || A === "translate" || A === "autocorrect" || A === "sandbox" && e.tagName === "IFRAME" || A === "form" || A === "list" && e.tagName === "INPUT" || A === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (A === "width" || A === "height") {
    const n = e.tagName;
    if (n === "IMG" || n === "VIDEO" || n === "CANVAS" || n === "SOURCE")
      return !1;
  }
  return KC(A) && kt(t) ? !1 : A in e;
}
function EO(e, A) {
  const t = (
    // @ts-expect-error _def is private
    e._def.props
  );
  if (!t)
    return !1;
  const r = Yn(A);
  return Array.isArray(t) ? t.some((n) => Yn(n) === r) : Object.keys(t).some((n) => Yn(n) === r);
}
const Bg = (e) => {
  const A = e.props["onUpdate:modelValue"] || !1;
  return Se(A) ? (t) => Wd(A, t) : A;
};
function xO(e) {
  e.target.composing = !0;
}
function VC(e) {
  const A = e.target;
  A.composing && (A.composing = !1, A.dispatchEvent(new Event("input")));
}
const xl = /* @__PURE__ */ Symbol("_assign"), Mf = /* @__PURE__ */ Symbol("_initialValue");
function mB(e, A, t) {
  return A && (e = e.trim()), t && (e = dy(e)), e;
}
const Uu = {
  created(e, { modifiers: { lazy: A, trim: t, number: r } }, n) {
    e.parentNode && (e.type === "text" ? e[Mf] = e.defaultValue.replace(/[\r\n]/g, "") : e.type === "textarea" && (e[Mf] = e.defaultValue.replace(/\r\n?/g, `
`))), e[xl] = Bg(n);
    const i = r || n.props && n.props.type === "number";
    bl(e, A ? "change" : "input", (s) => {
      s.target.composing || e[xl](mB(e.value, t, i));
    }), (t || i) && bl(e, "change", () => {
      e.value = mB(e.value, t, i);
    }), A || (bl(e, "compositionstart", xO), bl(e, "compositionend", VC), bl(e, "change", VC));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(e, { value: A, modifiers: { trim: t, number: r } }) {
    const n = A ?? "", i = e[Mf];
    delete e[Mf], i !== void 0 && (e.type === "text" || e.type === "textarea") && e.value !== i ? e[xl](mB(e.value, t, r)) : e.value = n;
  },
  beforeUpdate(e, { value: A, oldValue: t, modifiers: { lazy: r, trim: n, number: i } }, s) {
    if (e[xl] = Bg(s), e.composing) return;
    const a = (i || e.type === "number") && !/^0\d/.test(e.value) ? dy(e.value) : e.value, o = A ?? "";
    if (a === o)
      return;
    const l = e.getRootNode();
    (l instanceof Document || l instanceof ShadowRoot) && l.activeElement === e && e.type !== "range" && (r && A === t || n && e.value.trim() === o) || (e.value = o);
  }
}, IO = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(e, A, t) {
    e[xl] = Bg(t), bl(e, "change", () => {
      const r = e._modelValue, n = SO(e), i = e.checked, s = e[xl];
      if (Se(r)) {
        const a = Cx(r, n), o = a !== -1;
        if (i && !o)
          s(r.concat(n));
        else if (!i && o) {
          const l = [...r];
          l.splice(a, 1), s(l);
        }
      } else if (Jc(r)) {
        const a = new Set(r);
        i ? a.add(n) : a.delete(n), s(a);
      } else
        s(UI(e, i));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: GC,
  beforeUpdate(e, A, t) {
    e[xl] = Bg(t), GC(e, A, t);
  }
};
function GC(e, { value: A, oldValue: t }, r) {
  e._modelValue = A;
  let n;
  if (Se(A))
    n = Cx(A, r.props.value) > -1;
  else if (Jc(A))
    n = A.has(r.props.value);
  else {
    if (A === t) return;
    n = Au(A, UI(e, !0));
  }
  e.checked !== n && (e.checked = n);
}
function SO(e) {
  return "_value" in e ? e._value : e.value;
}
function UI(e, A) {
  const t = A ? "_trueValue" : "_falseValue";
  return t in e ? e[t] : A;
}
const LO = ["ctrl", "shift", "alt", "meta"], HO = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, A) => LO.some((t) => e[`${t}Key`] && !A.includes(t))
}, vB = (e, A) => {
  if (!e) return e;
  const t = e._withMods || (e._withMods = {}), r = A.join(".");
  return t[r] || (t[r] = ((n, ...i) => {
    for (let s = 0; s < A.length; s++) {
      const a = HO[A[s]];
      if (a && a(n, A)) return;
    }
    return e(n, ...i);
  }));
}, TO = /* @__PURE__ */ Gr({ patchProp: QO }, nO);
let WC;
function _O() {
  return WC || (WC = D6(TO));
}
const OO = ((...e) => {
  const A = _O().createApp(...e), { mount: t } = A;
  return A.mount = (r) => {
    const n = DO(r);
    if (!n) return;
    const i = A._component;
    !Re(i) && !i.render && !i.template && (i.template = n.innerHTML), n.nodeType === 1 && (n.textContent = "");
    const s = t(n, !1, NO(n));
    return n instanceof Element && (n.removeAttribute("v-cloak"), n.setAttribute("data-v-app", "")), s;
  }, A;
});
function NO(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function DO(e) {
  return kt(e) ? document.querySelector(e) : e;
}
const RO = {
  name: "Home",
  header: {
    category: {
      shop: {
        name: "Products",
        earth: "Earth",
        fire: "Fire",
        water: "Water",
        gold: "Gold",
        wood: "Wood"
      },
      blog: {
        name: "Bazi&Wuxing",
        bazi: "Bazi",
        wuxing: "Wuxing"
      },
      bazi: "Fortune"
    },
    user: "Profile",
    logout: "Logout",
    login: "Login"
  },
  bestSellers: "Shop Best Sellers",
  product: {
    quickAdd: "QUICK ADD"
  },
  footer: {
    subscribe: "Join Our Mailing List",
    subscribeDesc: "Join our mailing list to be the first to know about exclusive sales and redefine your path!",
    join: "JOIN",
    link: "Link",
    contact: "Contact Us",
    privacy: "Privacy Policy",
    shipping: "Shipping Policy",
    return: "Return and Refund Policy",
    terms: "Terms of Service"
  },
  scrollMore: "Slide to see more"
}, MO = {
  author: {
    report: "Report"
  }
}, PO = {
  contact: "Contact Us",
  privacy: "Privacy Policy",
  copyright: "Copyright Notice",
  terms: "Terms of service",
  return: "Return and Refund Policy",
  shipping: "Shipping Policy",
  about: "About Us",
  service: "Service Policy"
}, kO = {
  order: {
    newest: "Newest",
    oldest: "Oldest",
    sales_desc: "Sales ↓",
    sales_asc: "Sales ↑"
  },
  outOfStock: "Out of Stock",
  sizeChart: "Size Chart",
  color: "Color",
  wristSize: "Wrist Size",
  masterBlessings: "Master's Blessings",
  additional5WorkingDays: "Additional 5 Working Days",
  addToCart: "ADD TO CART",
  lifetimeFreeRopeReplacementService: "Lifetime Free Rope Replacement Service",
  freeWorldwideShippingOnOrdersOver100: "Free Worldwide Shipping On Orders Over 100",
  faq: "FAQ",
  material: "MATERIAL",
  element: "Element",
  beadSize: "Bead Size",
  averageWristSizeForFemale: "Average Wrist Size For Female",
  averageWristSizeForMale: "Average Wrist Size For Male",
  moreProductRecommendations: "MORE PRODUCTS RECOMMENDATIONS",
  customerReviews: "CUSTOMER REVIEWS",
  buyWithShop: "Buy With Shop",
  morePaymentOptions: "More payment options",
  inStock: "In Stock",
  more: "Load More",
  loading: "Loading...",
  noComments: "No Comments Yet",
  quantity: "Quatity"
}, KO = {
  title: "LOGIN",
  welcome: "Welcome Back",
  tip: "The first login will automatically register an account",
  placeholder: {
    username: "Email",
    password: "Please input password",
    captcha: "Please input verification code"
  },
  sendCaptcha: "Send Code",
  autoLogin: "Automatic Login",
  login: "Login",
  resend: "Resend",
  loginLoading: "Login in...",
  error: {
    passwordLength: "Password length invalid",
    captchaLength: "Code Length Match Invaild",
    loginFailed: "Please check if the information filled in is correct",
    sendCaptchaFailed: "Captcha Send Failed! Please contact web master"
  },
  usePasswordLogin: "Use Password Login",
  useCaptchaLogin: "Use Captcha Login"
}, VO = {
  checkout: "CHECK OUT",
  shipping: "Shipping, taxes are calculated at checkout",
  empty: "There are currently no products in the shopping cart",
  cart: "CART",
  freeShipping: "Congratulations! your order has met the criteria for free shipping",
  subtotal: "SUBTOTAL",
  size: "Wrist Size",
  color: "Color",
  blessing: "Master's Blessings"
}, GO = {
  name: "Name",
  email: "Email",
  address: {
    save: "Save",
    cancel: "Cancel",
    edit: "Edit Address",
    add: "New Address",
    default: "This is my default address",
    country: "Country/Region",
    name: "First Name",
    surname: "Last Name",
    address: "Address",
    mobile: "Phone (optional)",
    state: "State/Province",
    zipcode: "ZipCode",
    city: "City",
    address2: "Apartment,suite,etc. (optional)",
    saveAddress: "Save this address",
    phone: "Phone (Optional)",
    selectAddress: "Save my information for a faster checkout with a Shop account",
    useAddress: "Use this Address"
  },
  header: {
    shop: "Shop",
    order: "Order",
    information: "Information"
  },
  userInfo: "Information Management",
  addAddress: "ADD",
  address2: "Address2",
  defaultAddress: "Default Address",
  noAddress: "No Address Found",
  loadError: "Failed to load user addres list",
  retry: "Retry",
  orderManagement: "Order Management",
  orderNo: "Order No",
  pay: "Pay",
  loading: "Loading...",
  noMoreOrders: "No More Orders",
  pending: "Pending",
  paid: "Paid",
  cancel: "Cancel",
  confirmCancelOrder: "Cancel Order",
  cancelOrderWarning: "Cannot be restored after cancellation"
}, WO = {
  name: "Checkout",
  shippingFee: "Shipping Fee",
  freeShipping: "Free Shipping",
  subtotal: "Subtotal",
  total: "Total",
  color: "Color",
  wristSize: "Wrist Size",
  mastersBlessings: "Master's Blessings",
  submit: "Pay Now",
  addNewAddress: "Add New Address",
  processing: "Processing...",
  cancel: "Cancel Payment"
}, jO = {
  loading: {
    loading: "Loading..."
  },
  cancel: "Cancel",
  confirm: "Confirm"
}, qO = {
  name: "Fortune",
  bazi: {
    title: "The Most Mysterious Metaphysics in China",
    gender: "Gender",
    birthDate: "Birth Date",
    birthTime: "Time Of Birth",
    zi: "Zi Hour",
    chou: "Chou Hour",
    yin: "Yin Hour",
    mao: "Mao Hour",
    chen: "Chen Hour",
    si: "Si Hour",
    wu: "Wu Hour",
    wei: "Wei Hour",
    shen: "Shen Hour",
    you: "You Hour",
    xu: "Xu Hour",
    hai: "Hai Hour",
    genderMale: "Male",
    genderFemale: "Female",
    month: "Month",
    selectYear: "Year",
    selectMonth: "Month",
    selectDay: "Day",
    selectTime: "Time",
    selectGender: "Gender",
    analysis: "Fortune telling analysis",
    name: "Name",
    reportTitle: "Fortune telling analysis report",
    bazi: "Eight character layout",
    year: "Year",
    yearPillar: "Year Pillar（年柱）",
    monthPillar: "Moon Pillar（月柱）",
    dayPillar: "Sun Pillar（日柱）",
    timePillar: "Hour Pillar（时柱）",
    elementAnalysis: "Element Analysis",
    return: "Return",
    basic: "Basic",
    elementMetal: "Metal",
    elementWater: "Water",
    elementWood: "Wood",
    elementFire: "Fire",
    elementEarth: "Earth",
    fortuneAnalysis: "Fortune analysis",
    personality: "Personality",
    career: "Career",
    relationship: "Relationship",
    health: "Health",
    benefactorDirection: "Benefactor Direction",
    luckyDirection: "Lucky Direction",
    luckyNumber: "Lucky Number",
    luckyColor: "Lucky Color",
    luckySuggestion: "Lucky Suggestion",
    day: "Day",
    analyze: "Embark on an energy journey",
    recommendGoods: "Recommmend for you",
    HeavenlyStems: "Heavenly Stems（天干）",
    EarthlyBranches: "Earthly Branches（地支）",
    energy: "Five Elements Energy",
    beneficial: "Beneficial Five Elements",
    usefulGod: "Useful God",
    joyousGod: "Joyous God",
    negativeGod: "Negative God",
    adversarialGod: "Adversarial God",
    neutralGod: "Neutral God",
    best: "Best",
    secondBest: "Second Best",
    worst: "Worst",
    secondWorst: "Second Worst",
    middlingWorst: "Middling Worst",
    introduction: {
      title: "Five Elements Introduction",
      金: 'Metal is called "Ren Ge" (change and reform), corresponding to the direction of the northwest; it corresponds to the season of autumn (July-August). The number 27 corresponds to metal; it is the main star of the celestial time, corresponding to the Five Virtues Theory; the heavenly stem is Geng and Xin; the heavenly earth sign is Shen and You. The corresponding color is white; the five flavors are pungent and hot; it causes pain. Corresponding to the human body: The five zang organs are the lung and large intestine, the trunk is the bones and bone structure, the rest are the mouth, teeth and respiratory system. Occupation: Metal-related products, gold and silver jewelry, finance industry, military and police, etc.',
      木: "Wood is called curved and straight, corresponding to the east direction; The corresponding time is in the first two months of spring. The corresponding number 38 is wood; The timing of heaven governs the wind, corresponding to the five virtues and benevolence; The heavenly stems are the branches of A, B, and the earth are the branches of Yin and Mao. The corresponding color is blue-green; The five flavors are mainly sour, feeling sour and swollen. Corresponding to the human body: the five organs are hepatitis A and gallbladder B, the trunk is the limbs and neck, and the rest are the hair and nervous system. And a soft and curvy body shape and body parts. Occupation: Books, Wood Planting, Horticulture, Medicine, Culture, Education, Printing, Paper, Cloth, Textile, Decoration, Decoration, etc.",
      水: "Water is called Runxia, corresponding to the north direction; Corresponding to the winter months of October and November. The corresponding number one six is water; Rain and winter correspond to the Five Virtues and Wisdom; The Heavenly Stem is the Ren Gui Earthly Branch and the Hai Zi. The corresponding color is black; The five flavors are mainly salty; It feels numb and cool. Corresponding to the human body: the five organs are the kidneys and bladder, the trunk is the ears, and the rest are the blood circulation and reproductive urinary system. Occupation: Fisheries and aquatic products, water transportation, catering, entertainment, tourism, service-oriented industries, commerce, etc.",
      火: "Fire comes from the scorching sun, corresponding to the direction of due south; The corresponding time is April and May in summer. The corresponding number four nine is fire; The weather is hot, corresponding to the five virtues and rituals; The heavenly stem is Bingding and the earthly branch is Siwu. The corresponding color is reddish brown; The five flavors are bitter and feel hot. Corresponding to the human body: the five organs C are the heart, D are the small intestine and three burners, the trunk is the head and eyes, and the rest are the blood, cardiovascular and cerebrovascular systems, as well as internal heat, swelling, inflammation, burns, and bone spurs. Occupation: Beauty, makeup, photography, lighting and electrical appliances, flammable gas stations, high-temperature firefighting and chemical engineering, etc.",
      土: "Earth, Day, Harvest, corresponding to the Central Four Dimensions; The corresponding time is the end of the four seasons, June 9th and December. The number fifty is earth; The Heavenly Time Master Cloud corresponds to the Five Virtues Master Faith; Tian Gan Wu Ji Di Zhi Chen Xu Chou Wei. Corresponding color is yellow. The five flavors are mainly sweet. Corresponding to the human body: the five organs are the stomach and the spleen, the trunk is the abdomen, uterus, buttocks, skin, muscles, and digestive system. Occupation: Planting and breeding, mineral real estate, building materials, cement and stone tools, funeral and infrastructure, etc."
    },
    gregorian: "Gregorian calendar",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    seasonalInfo: "Seasonal information",
    readMore: "Click to get all reports",
    formValidationError: "Form Validation Error",
    yearRequired: "Please select birth year",
    monthRequired: "Please select birth month",
    dayRequired: "Please select birth date",
    yearInvalid: "Birth year must be between 1900 and current year",
    monthInvalid: "Birth month must be between 1-12",
    dayInvalid: "Birth date is invalid",
    dayInvalidForMonth: "Invalid date for the selected month",
    timeInvalid: "Birth time must be between 0-23",
    submitError: "Submission failed, please try again later",
    emailVerificationTitle: "Email Verification",
    email: "Email Address",
    emailPlaceholder: "Enter your email address",
    verificationCode: "Verification Code",
    codePlaceholder: "Enter verification code",
    sendCode: "Send Code",
    sending: "Sending...",
    cancel: "Cancel",
    confirm: "Confirm",
    submitting: "Verifying...",
    emailRequired: "Please enter email address",
    emailInvalid: "Please enter a valid email address",
    sendCodeFailed: "Failed to send verification code, please try again later",
    verificationFailed: "Verification failed",
    fillAllFields: "Please fill in both email and verification code",
    sendSuccess: "The report will be sent to your email in a few minutes.",
    fortune: "Fortune"
  }
}, $O = {
  status: {
    cancelled: "Cancelled",
    offlinePaymentUnpaid: "Offline Payment, Unpaid",
    unpaid: "Unpaid",
    pendingReceipt: "Pending Receipt",
    applyingForARefund: "Applying for Refund",
    refunded: "Refunded",
    partialRefundSubOrder: "Partial Refund (Sub Order)",
    allSubOrdersApplyRefundIng: "All Sub Orders Applying for Refund",
    inTheGroup: "In Group Order",
    notShipped: "Not Shipped",
    pendingVerification: "Pending Verification",
    pendingCollection: "Pending Collection",
    toBeEvaluated: "Order Delivered",
    transactionCompleted: "Transaction Completed"
  }
}, zO = {
  error: {
    fetchCodeFrist: "Please send captcha",
    verificationCode: "Captchat invaild"
  }
}, XO = {
  wuxing: "What Is Wuxing? Discover the Five Elements of Balance Find Balance in a Busy World",
  bazi: "Crystal Bracelets Inspired by Bazi (八字) | Discover Your Energy Blueprint"
}, YO = {
  home: RO,
  comment: MO,
  agreement: PO,
  products: kO,
  login: KO,
  cart: VO,
  user: GO,
  checkout: WO,
  common: jO,
  chinese: qO,
  order: $O,
  验证码错误: "Verification code error",
  请先获取验证码: "Please get the verification code first",
  response: zO,
  blog: XO,
  金: "Metal",
  木: "Wood",
  水: "Water",
  火: "Fire",
  土: "Earth",
  甲: "jiǎ (甲)",
  乙: "yǐ (乙)",
  丙: "bǐng (丙)",
  丁: "dīng (丁)",
  戊: "wù (戊)",
  己: "jǐ (己)",
  庚: "gēng (庚)",
  辛: "xīn (辛)",
  壬: "rén (壬)",
  癸: "guǐ (癸)",
  子: "zǐ (子)",
  丑: "chǒu (丑)",
  寅: "yín (寅)",
  卯: "mǎo (卯)",
  辰: "chén (辰)",
  巳: "sì (巳)",
  午: "wǔ (午)",
  未: "wèi (未)",
  申: "shēn (申)",
  酉: "yǒu (酉)",
  戌: "xū (戌)",
  亥: "hài (亥)",
  立春: "Beginning of Spring",
  雨水: "Rain Water",
  惊蛰: "Awakening of Insects",
  春分: "Spring Equinox",
  清明: "Pure Brightness",
  谷雨: "Grain Rain",
  立夏: "Beginning of Summer",
  小满: "Grain Buds",
  芒种: "Grain in Ear",
  夏至: "Summer Solstice",
  小暑: "Minor Heat",
  大暑: "Major Heat",
  立秋: "Beginning of Autumn",
  处暑: "End of Heat",
  白露: "White Dew",
  秋分: "Autumn Equinox",
  寒露: "Cold Dew",
  霜降: "Frost's Descent",
  立冬: "Beginning of Winter",
  小雪: "Minor Snow",
  大雪: "Major Snow",
  冬至: "Winter Solstice",
  小寒: "Minor Cold",
  大寒: "Major Cold"
}, Pf = {
  apiBaseUrl: "https://shop-cb-api.ikiji.cn",
  locale: "en",
  routes: {
    zodiac: "/pages/zodiac-2026",
    products: "/collections/all"
  },
  assets: {}
}, JO = typeof window > "u" ? void 0 : window.__BAZI_SHOPIFY_CONFIG__, ZO = (e) => ({
  apiBaseUrl: e?.apiBaseUrl ?? Pf.apiBaseUrl,
  locale: e?.locale ?? Pf.locale,
  routes: {
    ...Pf.routes,
    ...e?.routes
  },
  assets: {
    ...Pf.assets,
    ...e?.assets
  }
}), Zl = ZO(JO), po = (e) => Zl.assets[e] || "", AN = (e) => /^[a-z][a-z\d+.-]*:\/\//i.test(e), eN = /* @__PURE__ */ new Set([
  "[object ArrayBuffer]",
  "[object Blob]",
  "[object File]",
  "[object FormData]",
  "[object ReadableStream]",
  "[object URLSearchParams]"
]), tN = (e) => typeof e == "string" || ArrayBuffer.isView(e) ? !0 : e !== null && eN.has(Object.prototype.toString.call(e)), rN = (e, A = Zl.apiBaseUrl) => {
  if (AN(e)) return e;
  const t = String(A || "").replace(/\/+$/, "").replace(/\/api$/i, ""), r = e.replace(/^\/+/, "").replace(/^api(?:\/|$)/i, ""), n = r ? `/api/${r}` : "/api";
  return t ? `${t}${n}` : n;
}, nN = (e, A) => {
  if (!A) return e;
  const t = new URLSearchParams();
  for (const [o, l] of Object.entries(A))
    l != null && t.append(o, String(l));
  const r = t.toString();
  if (!r) return e;
  const n = e.indexOf("#"), i = n >= 0 ? e.slice(n) : "", s = n >= 0 ? e.slice(0, n) : e, a = s.includes("?") ? "&" : "?";
  return `${s}${a}${r}${i}`;
}, iN = async (e) => {
  if (e.status === 204) return;
  const A = await e.text();
  if (A)
    try {
      return JSON.parse(A);
    } catch {
      return A;
    }
}, sN = (e, A) => {
  if (A && typeof A == "object") {
    const t = A;
    if (typeof t.msg == "string" && t.msg) return t.msg;
    if (typeof t.message == "string" && t.message) return t.message;
  }
  return typeof A == "string" && A ? A : `HTTP ${e.status}${e.statusText ? ` ${e.statusText}` : ""}`;
}, aN = ({
  apiBaseUrl: e = Zl.apiBaseUrl,
  fetchImpl: A = (t, r) => globalThis.fetch(t, r)
} = {}) => async (t, r = {}) => {
  const n = new Headers(r.headers), i = {
    method: r.method,
    headers: n,
    signal: r.signal
  };
  r.body !== void 0 && (tN(r.body) ? i.body = r.body : (i.body = JSON.stringify(r.body), n.has("Content-Type") || n.set("Content-Type", "application/json")));
  const s = nN(rN(t, e), r.query), a = await A(s, i), o = await iN(a);
  if (!a.ok) throw new Error(sN(a, o));
  return o;
}, EI = aN(), xI = "leymen:bazi:standalone", kf = () => ({
  userInfo: {},
  token: "",
  baziInfo: {},
  baziReportId: 0,
  baziReportDetail: {},
  baziFormData: {}
}), Eu = (e) => e !== null && typeof e == "object" && !Array.isArray(e), oN = (e) => {
  if (!e) return kf();
  try {
    const A = e.getItem(xI);
    if (!A) return kf();
    const t = JSON.parse(A);
    return Eu(t) ? {
      userInfo: Eu(t.userInfo) ? t.userInfo : {},
      token: typeof t.token == "string" ? t.token : "",
      baziInfo: Eu(t.baziInfo) ? t.baziInfo : {},
      baziReportId: typeof t.baziReportId == "number" ? t.baziReportId : 0,
      baziReportDetail: Eu(t.baziReportDetail) ? t.baziReportDetail : {},
      baziFormData: Eu(t.baziFormData) ? t.baziFormData : {}
    } : kf();
  } catch {
    return kf();
  }
}, lN = () => {
  if (typeof window > "u") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}, cN = (e = lN()) => {
  const A = /* @__PURE__ */ $l(oN(e)), t = () => {
    if (e)
      try {
        e.setItem(
          xI,
          JSON.stringify({
            userInfo: A.userInfo,
            token: A.token,
            baziInfo: A.baziInfo,
            baziReportId: A.baziReportId,
            baziReportDetail: A.baziReportDetail,
            baziFormData: A.baziFormData
          })
        );
      } catch {
      }
  };
  return /* @__PURE__ */ $l({
    get baziReportDetail() {
      return A.baziReportDetail;
    },
    get getBaziFormData() {
      return A.baziFormData;
    },
    get getBaziInfo() {
      return A.baziInfo;
    },
    get getBaziReportId() {
      return A.baziReportId;
    },
    get isLogin() {
      return !!A.token;
    },
    get userInfo() {
      return A.userInfo;
    },
    setBaziInfo(r) {
      A.baziInfo = r, t();
    },
    setBaziReportDetail(r) {
      A.baziReportDetail = r, t();
    },
    setBaziReportId(r) {
      A.baziReportId = r, t();
    },
    setBaziFormData(r) {
      A.baziFormData = r, t();
    },
    setToken(r) {
      A.token = r, t();
    },
    setUser(r) {
      A.userInfo = r, t();
    },
    clearBaziFormData() {
      A.baziFormData = {}, t();
    },
    clearBaziInfo() {
      A.baziInfo = {}, A.baziReportDetail = {}, A.baziReportId = 0, t();
    }
  });
}, uN = cN(), II = () => typeof window > "u" ? {} : window, hN = (e, A) => e === "/zodiac-2026" ? A.routes.zodiac : e === "/products" ? A.routes.products : e, fN = (e, A) => {
  if (!A) return e;
  const t = new URLSearchParams();
  for (const [o, l] of Object.entries(A))
    l != null && t.append(o, String(l));
  const r = t.toString();
  if (!r) return e;
  const n = e.indexOf("#"), i = n >= 0 ? e.slice(n) : "", s = n >= 0 ? e.slice(0, n) : e, a = s.includes("?") ? "&" : "?";
  return `${s}${a}${r}${i}`;
}, SI = (e, A = Zl) => {
  const t = typeof e == "string" ? e : e.path, r = typeof e == "string" ? void 0 : e.query;
  return fN(hN(t, A), r);
}, dN = (e = II(), A = Zl) => ({
  currentRoute: {
    get value() {
      return {
        query: Object.fromEntries(new URLSearchParams(e.location?.search ?? ""))
      };
    }
  },
  async push(t) {
    e.location?.assign?.(SI(t, A));
  }
}), gN = dN(), pN = /* @__PURE__ */ We(Zl.locale), BN = {
  apiBaseUrl: Zl.apiBaseUrl
}, wN = (e) => {
}, LI = (e) => {
  let A = YO;
  for (const t of e.split(".")) {
    if (!A || typeof A != "object" || !(t in A)) return e;
    A = A[t];
  }
  return typeof A == "string" ? A : e;
}, jC = () => ({
  locale: pN,
  t: LI
}), mN = () => uN, vN = () => gN, yN = (e = II()) => {
  const A = e.location;
  if (!A) return;
  const t = new URLSearchParams(A.search ?? "");
  t.delete("id");
  const r = t.toString(), n = `${A.pathname ?? ""}${r ? `?${r}` : ""}#bazi-select`;
  A.assign?.(n);
}, CN = (e, A) => {
  Object.assign(e.style, {
    top: "",
    right: "",
    bottom: "",
    left: "",
    transform: ""
  });
  const [t = "bottom", r = "right"] = A.split("-");
  e.style[t === "top" ? "top" : "bottom"] = "16px", r === "left" ? e.style.left = "16px" : r === "center" ? (e.style.left = "50%", e.style.transform = "translateX(-50%)") : e.style.right = "16px";
}, bN = (e) => {
  if (typeof document > "u" || !document.body) return null;
  let A = document.querySelector(".bazi-standalone-toast-region");
  return A || (A = document.createElement("div"), A.className = "bazi-standalone-toast-region", A.setAttribute("aria-live", "polite"), A.setAttribute("aria-relevant", "additions"), Object.assign(A.style, {
    position: "fixed",
    zIndex: "2147483647",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    pointerEvents: "none"
  }), document.body.appendChild(A)), A.dataset.position = e, CN(A, e), A;
}, FN = {
  success: "#166534",
  error: "#b91c1c"
}, HI = (e, A = {}) => {
  const t = A.position ?? "bottom-right", r = A.type ?? "default", n = bN(t);
  if (!n) return;
  const i = document.createElement("div");
  if (i.className = "bazi-standalone-toast", i.dataset.type = r, i.textContent = String(e), i.setAttribute("role", r === "error" ? "alert" : "status"), Object.assign(i.style, {
    maxWidth: "min(360px, calc(100vw - 32px))",
    padding: "12px 16px",
    borderRadius: "6px",
    background: FN[r] ?? "#1f2937",
    color: "#ffffff",
    fontFamily: "system-ui, sans-serif",
    fontSize: "14px",
    lineHeight: "1.4",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
    pointerEvents: "auto"
  }), n.appendChild(i), A.autoClose === !1) return;
  const s = typeof A.autoClose == "number" ? Math.max(0, A.autoClose) : 3e3;
  globalThis.setTimeout(() => i.remove(), s);
}, fs = HI;
fs.success = (e, A = {}) => {
  HI(e, { ...A, type: "success" });
};
const QN = ({
  request: e,
  isComplete: A,
  onComplete: t,
  onError: r,
  onExhausted: n,
  intervalMs: i,
  requestTimeoutMs: s,
  maxAttempts: a,
  setTimeout: o = (u, d) => globalThis.setTimeout(u, d),
  clearTimeout: l = (u) => globalThis.clearTimeout(u),
  createAbortController: c = () => new AbortController()
}) => {
  const u = Math.max(1, Math.floor(a)), d = Math.max(0, i), h = Math.max(1, Math.floor(s));
  let p = 0, B = !1, y = 0, m, C, Q;
  const F = (U) => B && p === U, T = () => {
    m !== void 0 && (l(m), m = void 0);
  }, V = (U = C) => {
    U === void 0 || C !== U || (l(U), C = void 0);
  }, M = () => {
    const U = Q;
    Q = void 0, V(), U?.abort();
  }, D = () => {
    B = !1, T(), M();
  }, I = async (U) => {
    try {
      await U();
    } catch (x) {
      console.error("Bazi report poller hook failed:", x);
    }
  }, q = async (U, x) => {
    if (!F(x)) return;
    y += 1;
    const P = y, N = {
      input: U,
      attempt: P,
      maxAttempts: u,
      generation: x
    }, iA = c();
    Q = iA;
    let nA, sA, tA;
    try {
      const cA = new Promise((W) => {
        nA = o(() => {
          C === nA && (C = void 0), !(!F(x) || Q !== iA) && (W({ type: "timeout" }), iA.abort());
        }, h), C = nA;
      });
      let FA;
      try {
        FA = e(U, iA.signal, P);
      } catch (W) {
        FA = Promise.reject(W);
      }
      const CA = FA.then(
        (W) => ({ type: "success", value: W }),
        (W) => ({ type: "error", error: W })
      ), S = await Promise.race([CA, cA]);
      S.type === "success" ? sA = S.value : S.type === "error" ? tA = S.error : tA = new Error(`Bazi report request timed out after ${h}ms`);
    } finally {
      V(nA), Q === iA && (Q = void 0);
    }
    if (F(x)) {
      if (tA !== void 0) {
        if (await I(() => r(tA, N)), !F(x)) return;
      } else {
        let cA = !1;
        try {
          cA = A(sA, N);
        } catch (FA) {
          if (await I(() => r(FA, N)), !F(x)) return;
        }
        if (cA) {
          B = !1, await I(() => t(sA, N));
          return;
        }
      }
      if (P >= u) {
        B = !1, await I(() => n(N));
        return;
      }
      m = o(() => {
        m = void 0, q(U, x);
      }, d);
    }
  };
  return {
    start(U) {
      D(), p += 1, y = 0, B = !0, q(U, p);
    },
    stop() {
      p += 1, D();
    },
    isRunning() {
      return B;
    }
  };
}, UN = {
  water: {
    name: "Water",
    chinese: "水",
    description: "You are a Water soul — intuitive, quietly powerful, and depth-seeking by nature. Like a river that runs beneath the surface, your strongest currents are often invisible to others, yet they shape everything above."
  },
  wood: {
    name: "Wood",
    chinese: "木",
    description: "You are a Wood soul — visionary, vital, and always reaching toward what is possible. Like a young shoot breaking through stone, there is a quiet force in you that bends without breaking and finds light even in narrow spaces."
  },
  fire: {
    name: "Fire",
    chinese: "火",
    description: "You are a Fire soul — radiant, magnetic, and alive to the world around you. Like a flame that draws people toward its warmth, you illuminate the spaces you inhabit and move others simply by being present."
  },
  earth: {
    name: "Earth",
    chinese: "土",
    description: "You are an Earth soul — grounded, nurturing, and steady in ways others lean on without realising. Like a mountain that holds the weather of all four seasons, you are built for endurance, for patience, for being the ground beneath someone else's journey."
  },
  metal: {
    name: "Metal",
    chinese: "金",
    description: "You are a Metal soul — precise, principled, and refined by time and discernment into something few can replicate. Like autumn air that clarifies everything it touches, you carry a natural gift for seeing through noise and distilling what is true."
  }
}, EN = {
  fire: {
    wood: "But your chart carries an excess of Fire, which can push your natural intensity past its edge into restlessness, impulsiveness, and a hunger for momentum that outpaces your ability to sustain it. Wood compounds this further, feeding the flame before it has found its direction and turning creative energy into scattered pursuit rather than focused creation.",
    earth: "But your chart carries an excess of Fire, which can drive your energy into cycles of overextension — burning brightly in short bursts but struggling to maintain the steady warmth that builds something lasting. Earth compounds this further, absorbing your momentum before it can gather into meaningful direction and leaving effort feeling heavier than it should.",
    metal: "But your chart carries an excess of Fire, which can make stillness feel like stagnation and reflection feel like retreat — pushing you toward action before clarity has had a chance to form. Metal compounds this further, melting under that heat before it can offer the precision and structure your energy needs to find its edge.",
    water: "But your chart carries an excess of Fire, which can turn your natural expressiveness into emotional volatility — feeling everything at full intensity with little room for the depth that tempers and sustains. Water compounds this further, its cooling presence overwhelmed before it can fully restore the calm and wisdom your chart is reaching for, leaving depth available but unable to complete its work."
  },
  water: {
    wood: "But your chart carries an excess of Water, which can pull your natural depth into overthinking — circling the same currents until stillness becomes paralysis and reflection becomes a place you cannot easily leave. Wood compounds this further, drawing that excess energy upward into scattered growth before roots have had a chance to form, adding restlessness to what is already heavy.",
    fire: "But your chart carries an excess of Water, which can cool your energy past the point of calm into withdrawal — dampening the spark that moves you forward and making inaction feel like wisdom. Fire compounds this further, its warming function suppressed beneath the weight of what has accumulated, leaving the vitality and momentum your chart needs present but unable to fully rise.",
    earth: "But your chart carries an excess of Water, which can flood the boundaries that give your energy shape and direction — spreading widely without gathering into anything you can stand on. Earth compounds this further, becoming waterlogged rather than stable, losing the grounded strength that would otherwise give your depth somewhere purposeful to settle.",
    metal: "But your chart carries an excess of Water, which can deepen your natural sensitivity into heaviness — carrying the weight of too much feeling without the structure to process and release what you no longer need. Metal compounds this further, being drawn into that depth before it can offer the clarity and precision that would otherwise help you cut through what clouds your vision."
  },
  wood: {
    fire: "But your chart carries an excess of Wood, which can turn your natural vitality into restlessness — reaching outward in too many directions at once and mistaking expansion for progress. Fire compounds this further, igniting that scattered energy into bursts of enthusiasm that burn intensely but struggle to sustain the slow, steady growth that produces something enduring.",
    water: "But your chart carries an excess of Wood, which can push your vision so far forward that your roots lose contact with what grounds and nourishes them. Water compounds this further, feeding that upward momentum before the foundation is ready, deepening growth that has already outpaced the stability it needs to survive.",
    earth: "But your chart carries an excess of Wood, which can fracture your focus across too many possibilities — each one genuine, each one pulling you slightly further from the one thing that deserves your full attention. Earth compounds this further, being broken up by that relentless expansion rather than providing the stable ground that would slow and anchor your growth into something lasting.",
    metal: "But your chart carries an excess of Wood, which can make structure feel like restriction and discipline feel like a constraint on your natural creativity — bending away from boundaries before they have had a chance to shape something refined. Metal compounds this further, being worn down by that resistance before it can offer the precision that would otherwise give your vision its sharpest, most purposeful form."
  },
  earth: {
    fire: "But your chart carries an excess of Earth, which can thicken your natural steadiness into immovability — patience hardening into resistance and support quietly becoming burden. Fire compounds this further, struggling to warm what has grown too dense, leaving the spark of momentum too weak to move what has settled too deeply into place.",
    wood: "But your chart carries an excess of Earth, which can turn your grounded nature into stagnation — holding so firmly to what is known and stable that new growth finds no space to take root. Wood compounds this further, fracturing that density with restless upward movement rather than offering the steady, organised growth that would loosen the soil without destabilising what lies beneath.",
    water: "But your chart carries an excess of Earth, which can absorb your energy quietly and completely — effort disappearing into obligation, momentum slowing without a clear reason you can name. Water compounds this further, becoming murky rather than clear when held within too much density, losing the flow and adaptability that would otherwise move what has grown heavy back into motion.",
    metal: "But your chart carries an excess of Earth, which can bury the clarity and precision that help you move forward — covering discernment with layers of accumulated worry, obligation, and the weight of what you carry for others. Metal compounds this further, struggling to emerge from that density before it can offer the refined edge that would otherwise cut cleanly through what obscures your path."
  },
  metal: {
    fire: "But your chart carries an excess of Metal, which can sharpen your natural discernment into rigidity — holding so precisely to principle and standard that warmth and flexibility find little room to breathe. Fire compounds this further, being cooled before it can offer the vitality and connection that would otherwise soften what has become too fixed and allow your precision to move through the world with grace rather than severity.",
    wood: "But your chart carries an excess of Metal, which can turn your gift for refinement into a cycle of cutting away — pruning until there is little left to grow from, and mistaking reduction for clarity. Wood compounds this further, struggling to rise against that force before it can offer the vital, forward momentum that would otherwise give your precision something living and purposeful to shape.",
    water: "But your chart carries an excess of Metal, which can pull your energy inward into isolation — the world held at a careful distance in the name of standards that only grow harder to meet. Water compounds this further, being drawn into that cold precision before it can offer the adaptive flow and emotional depth that would otherwise carry your clarity forward with warmth rather than withdrawal.",
    earth: "But your chart carries an excess of Metal, which can make the steady, patient accumulation of trust and connection feel too slow — moving past what nourishes before it has had a chance to take hold. Earth compounds this further, being compressed by that weight rather than offering the grounded stability that would otherwise give your precision a foundation deep enough to build something that lasts."
  }
}, xN = {
  water: {
    metal: "What your chart calls for is Metal's clarity flowing into Water's depth — precision that dissolves into wisdom, structure that softens into flow. Metal distills; Water carries what remains forward. Together, they restore the quiet discernment that allows you to move through complexity without being consumed by it.",
    wood: "What your chart calls for is Wood's vitality channelled into Water's intuition — direction that gives your depth somewhere meaningful to go. Wood draws Water upward, transforming stillness into momentum. Together, they restore the sense of purposeful movement that turns your inner knowing into outer action.",
    fire: "What your chart calls for is Fire's warmth meeting Water's wisdom — illumination that brings your depth to the surface where it can be felt by others. Fire evaporates what is stagnant; Water tempers what burns too quickly. Together, they restore the balance between feeling deeply and expressing freely.",
    earth: "What your chart calls for is Earth's steadiness holding Water's flow — a riverbank that gives direction to energy that would otherwise spread without purpose. Earth contains; Water nourishes what grows within those boundaries. Together, they restore the grounded calm that transforms restless depth into reliable strength."
  },
  wood: {
    water: "What your chart calls for is Water's wisdom feeding Wood's vision — the deep roots that allow tall growth to remain anchored. Water nourishes; Wood transforms that nourishment into form and forward movement. Together, they restore the creative momentum that grows steadily rather than in bursts that exhaust before they flourish.",
    fire: "What your chart calls for is Fire's passion igniting Wood's vision — the spark that turns potential into pursuit. Fire gives Wood its direction and urgency; Wood gives Fire its purpose and longevity. Together, they restore the energised clarity that moves ideas from conception into sustained, meaningful creation.",
    earth: "What your chart calls for is Earth's stability grounding Wood's expansion — the bedrock beneath the roots that keeps growth from becoming restlessness. Earth steadies; Wood rises with intention rather than urgency. Together, they restore the patient momentum that allows your vision to build something that lasts beyond the season.",
    metal: "What your chart calls for is Metal's precision pruning Wood's growth — the discerning hand that shapes expansion into excellence rather than excess. Metal refines what Wood produces; Wood softens what Metal might otherwise hold too rigidly. Together, they restore the focused vitality that channels creative energy toward what truly matters."
  },
  fire: {
    wood: "What your chart calls for is Wood's vitality feeding Fire's radiance — the steady fuel that allows your light to burn with purpose rather than in sudden, consuming flares. Wood sustains; Fire transforms what it is given into warmth and illumination. Together, they restore the sustained passion that inspires others without depleting the one who carries it.",
    earth: "What your chart calls for is Earth's groundedness containing Fire's intensity — the vessel that allows heat to build into something transformative rather than scattering into sparks. Earth holds; Fire warms what it is given space to inhabit. Together, they restore the centred vitality that turns your passion into lasting impact rather than fleeting brilliance.",
    metal: "What your chart calls for is Metal's clarity directing Fire's energy — the channel that transforms radiance into precision, illumination into insight. Metal gives Fire its edge; Fire softens what Metal might otherwise make too cold. Together, they restore the purposeful brilliance that allows your warmth to cut through rather than simply glow.",
    water: "What your chart calls for is Water's wisdom tempering Fire's flame — the depth beneath the surface that sustains what burns above it. Water cools without extinguishing; Fire warms without overwhelming when Water is present. Together, they restore the emotional equilibrium that allows you to feel fully without being consumed by the intensity of your own nature."
  },
  earth: {
    fire: "What your chart calls for is Fire's warmth nourishing Earth's foundation — the light that draws life upward from ground that is rich but needs activation. Fire warms; Earth receives that warmth and transforms it into stability others can stand on. Together, they restore the centred vitality that grounds your nurturing energy in genuine strength rather than quiet endurance.",
    metal: "What your chart calls for is Metal's precision emerging from Earth's depth — the clarity that rises from patience, the structure that forms only after long and steady accumulation. Earth produces Metal; Metal gives Earth its discernment and edge. Together, they restore the grounded clarity that allows you to hold firm without holding on too tightly.",
    wood: "What your chart calls for is Wood's growth drawing from Earth's nourishment — the vitality that proves your steadiness is not stillness, but a living, generative force. Wood draws what it needs from Earth; Earth finds purpose in what Wood becomes. Together, they restore the nurturing momentum that transforms patience into visible, meaningful growth.",
    water: "What your chart calls for is Water's flow softening Earth's density — the movement that keeps what is stable from becoming fixed, what is grounded from becoming immovable. Water loosens; Earth gives that movement shape and direction. Together, they restore the adaptive steadiness that remains flexible without losing its centre."
  },
  metal: {
    earth: "What your chart calls for is Earth's depth giving rise to Metal's clarity — the slow, patient accumulation from which precision and discernment eventually emerge. Earth produces Metal; Metal honours that origin by cutting cleanly and truthfully. Together, they restore the grounded refinement that carries both the weight of wisdom and the lightness of clear sight.",
    water: "What your chart calls for is Metal's edge meeting Water's flow — the blade that has learned to move with the current rather than against it, sharp but never rigid. Metal structures; Water carries that structure forward with grace and adaptability. Together, they restore the refined fluidity that allows clarity to move through the world without leaving damage in its wake.",
    wood: "What your chart calls for is Metal's precision meeting Wood's vitality — the balance between refinement and renewal, between the discipline of the edge and the resilience of the living thing it shapes. Metal defines; Wood grows within and beyond those definitions. Together, they restore the creative discipline that holds both structure and possibility without sacrificing either.",
    fire: "What your chart calls for is Fire's warmth tempering Metal's edge — the heat that forges rather than melts, that strengthens the blade without making it brittle. Fire refines Metal into its truest form; Metal gives Fire's energy a lasting, purposeful shape. Together, they restore the tempered clarity that is neither cold nor consuming — precise, warm, and enduring."
  }
}, IN = {
  water: {
    metal: {
      body: "Metal enters first, bringing precision and clarity to the edges of your energy — distilling what is scattered into what is essential, and what is clouded into what is true. Water receives what Metal has refined and carries it forward as wisdom, depth, and the quiet adaptability that allows you to move through complexity without being consumed by it.",
      invitation: "This is your chart's invitation to let clarity become depth — to let Metal sharpen what you carry and let Water flow with what remains. Crystals that carry Metal and Water frequencies can restore the discerning calm your chart is calling for, refining what feels overwhelming into insight you can move with."
    },
    wood: {
      body: "Wood enters first, drawing stagnant energy upward into movement — transforming what has pooled into purposeful momentum and giving your depth a living direction to grow toward. Water nourishes what Wood has set in motion, sustaining that growth with the quiet wisdom and emotional intelligence that keeps momentum from outrunning its own foundation.",
      invitation: "This is your chart's invitation to let depth become direction — to let Wood draw from what you carry and let Water sustain what grows from it. Crystals that carry Wood and Water frequencies can restore the purposeful flow your chart is calling for, transforming stillness into momentum that is rooted enough to last."
    },
    fire: {
      body: "Fire enters first, warming what has grown too still and drawing your energy toward the surface — bringing the vitality and warmth that depth alone cannot generate. Water receives that warmth and is renewed by it, circulating rather than stagnating, moving outward rather than turning inward, carrying wisdom into expression rather than keeping it contained.",
      invitation: "This is your chart's invitation to let depth rise into warmth — to let Fire bring your energy to the surface and let Water carry that warmth forward with grace and adaptability. Crystals that carry Fire and Water frequencies can restore the circulating vitality your chart is calling for, warming what has grown still and giving your depth the expression it deserves."
    },
    earth: {
      body: "Earth enters first, providing the containment and direction that gives flowing energy its shape and its power — transforming what spreads thinly into what moves with purpose. Water flows within what Earth defines, no longer scattered across everything but gathered into a current that knows where it is going and why.",
      invitation: "This is your chart's invitation to let depth find its direction — to let Earth give your energy its banks and let Water move with the purpose that containment makes possible. Crystals that carry Earth and Water frequencies can restore the grounded flow your chart is calling for, giving your depth the structure it needs to become a steady, reliable source of wisdom and calm."
    }
  },
  wood: {
    water: {
      body: "Water enters first, nourishing the roots that growth depends on — providing the deep, sustaining resource that allows upward movement to continue without depleting the source it draws from. Wood receives that nourishment and rises with it, transforming quiet depth into visible, purposeful growth that is rooted enough to weather what comes.",
      invitation: "This is your chart's invitation to grow from depth rather than urgency — to let Water feed what Wood reaches toward and let that nourishment become the foundation of something enduring. Crystals that carry Water and Wood frequencies can restore the sustained momentum your chart is calling for, grounding your vision in the depth it needs to grow without exhausting itself."
    },
    fire: {
      body: "Fire enters first, igniting Wood's potential with passion and direction — transforming what is possible into what is pursued, and what is dormant into what is alive. Wood channels that ignition into upward, organised growth, giving Fire's energy a living structure to move through rather than consuming itself in the absence of form.",
      invitation: "This is your chart's invitation to let passion become momentum — to let Fire ignite what Wood carries and let that ignition grow into something with roots as strong as its reach. Crystals that carry Fire and Wood frequencies can restore the inspired vitality your chart is calling for, fuelling your vision with warmth and giving that warmth somewhere meaningful to grow."
    },
    earth: {
      body: "Earth enters first, providing the stable, nourishing ground that growth requires before it can rise — the foundation that holds roots in place and feeds what grows from them with patience and quiet strength. Wood draws from that stability and rises with intention rather than urgency, building upward from ground that is prepared to support what reaches toward it.",
      invitation: "This is your chart's invitation to grow from solid ground — to let Earth prepare the foundation and let Wood rise from it with the steady, purposeful momentum that only genuine rootedness can produce. Crystals that carry Earth and Wood frequencies can restore the grounded vitality your chart is calling for, nourishing your vision from the ground up so that what grows endures beyond the season."
    },
    metal: {
      body: "Metal enters first, bringing the discernment and focus that gives Wood's natural momentum somewhere precise to go — not constraining what is growing but ensuring that its reach is as intentional as it is vital. Wood receives that clarity and rises with greater purpose and direction, transforming expansive energy into the kind of refined, sustained momentum that builds something lasting.",
      invitation: "This is your chart's invitation to let growth move with both vitality and intention — to let Metal sharpen where your energy is best placed and let Wood rise powerfully from that clarity. Crystals that carry Metal and Wood frequencies can restore the focused vitality your chart is calling for, bringing precision to your vision and direction to your momentum without diminishing the life force that drives it."
    }
  },
  fire: {
    wood: {
      body: "Wood enters first, providing the steady, living fuel that allows Fire to burn with purpose rather than in sudden consuming flares — the structure that transforms a spark into a sustained flame. Fire receives that fuel and radiates with it, warming and illuminating rather than scattering, expressing rather than exhausting.",
      invitation: "This is your chart's invitation to let passion be sustained — to let Wood feed what Fire expresses and let that expression warm everything it touches without depleting the one who carries it. Crystals that carry Wood and Fire frequencies can restore the sustained radiance your chart is calling for, giving your passion the living fuel it needs to shine steadily rather than in bursts."
    },
    earth: {
      body: "Earth enters first, providing the vessel that gives Fire's heat somewhere to gather and deepen — containing what would otherwise scatter and transforming intensity into something that builds rather than burns. Fire warms within what Earth holds, becoming the steady, reliable warmth of something that has found its proper home rather than the fleeting brightness of something still searching for one.",
      invitation: "This is your chart's invitation to let intensity find its container — to let Earth hold what Fire generates and let that containment transform brilliance into endurance. Crystals that carry Earth and Fire frequencies can restore the grounded vitality your chart is calling for, giving your passion the structure it needs to become something lasting rather than something luminous but brief."
    },
    metal: {
      body: "Metal enters first, giving Fire's energy its edge and direction — transforming radiance into precision, and illumination into insight that cuts cleanly rather than simply glowing. Fire receives that sharpening and becomes purposeful warmth — not scattered heat but directed light that serves where it shines.",
      invitation: "This is your chart's invitation to let brilliance become precision — to let Metal give your Fire its edge and let that edge illuminate with intention rather than simply intensity. Crystals that carry Metal and Fire frequencies can restore the purposeful radiance your chart is calling for, sharpening your natural warmth into the kind of clarity that moves through the world with both light and direction."
    },
    water: {
      body: "Water enters first, tempering what burns with the depth and emotional intelligence that Fire alone cannot generate — not extinguishing the flame but ensuring it burns with wisdom rather than recklessness. Fire receives that tempering and becomes the kind of warmth that sustains rather than consumes, illuminating from a place of depth rather than pure intensity.",
      invitation: "This is your chart's invitation to let fire burn with wisdom — to let Water bring depth to what Fire illuminates and let that depth transform passion into something that endures beyond the moment. Crystals that carry Water and Fire frequencies can restore the balance between your natural radiance and the depth that sustains it, allowing you to shine without burning out."
    }
  },
  earth: {
    fire: {
      body: "Fire enters first, warming the ground and activating the latent vitality within what has been patient and still — the light that draws life upward from soil that is rich but needs the warmth of purpose to become generative. Earth receives that warmth and transforms it into the steady, nourishing strength that others can stand on and grow from.",
      invitation: "This is your chart's invitation to let warmth activate what patience has prepared — to let Fire bring your Earth to life and let that life become the grounded, generous strength your chart is built to offer. Crystals that carry Fire and Earth frequencies can restore the activated stability your chart is calling for, warming your groundedness into something that gives and grows rather than simply holds."
    },
    metal: {
      body: "Metal enters first, emerging from Earth's depth as its most refined expression — the clarity and discernment that only forms after long and patient accumulation. Earth receives that refinement and is honoured by it, its quiet steadiness proven to have been the origin of something precise, purposeful, and enduring.",
      invitation: "This is your chart's invitation to let patience become clarity — to let Metal draw from what Earth has accumulated and let that clarity give your groundedness its sharpest, most purposeful edge. Crystals that carry Metal and Earth frequencies can restore the grounded discernment your chart is calling for, transforming accumulated steadiness into the kind of clarity that knows exactly where to place its weight."
    },
    wood: {
      body: "Wood enters first, breaking through what has grown too dense and creating the movement and openness that allows life to return to ground that has been still for too long. Earth receives that loosening and becomes generative rather than fixed — the rich, nourishing foundation it was always meant to be, now open enough to let things grow from it.",
      invitation: "This is your chart's invitation to let movement return to what has held still — to let Wood open what Earth has compacted and let that opening restore the natural cycle of nourishment and growth. Crystals that carry Wood and Earth frequencies can restore the generative groundedness your chart is calling for, loosening what has settled too deeply and inviting the growth that your stability was always meant to support."
    },
    water: {
      body: "Water enters first, softening what has grown too dense and restoring the adaptability and flow that keeps groundedness from becoming immovability. Earth receives that softening and becomes the living, breathing foundation it was meant to be — stable but not rigid, holding but not consuming, steady in a way that moves with life rather than against it.",
      invitation: "This is your chart's invitation to let steadiness become fluid — to let Water soften what Earth holds and let that softening transform your groundedness into something that bends without breaking. Crystals that carry Water and Earth frequencies can restore the adaptive stability your chart is calling for, keeping your foundation alive and responsive rather than fixed and unmovable."
    }
  },
  metal: {
    earth: {
      body: "Earth enters first, providing the depth and patient accumulation from which Metal slowly and inevitably emerges — the origin of precision, the ground from which clarity is eventually distilled. Metal rises from that foundation already knowing its purpose, its edge formed not by force but by the slow, unhurried pressure of what Earth has quietly been building toward.",
      invitation: "This is your chart's invitation to let clarity emerge from depth — to let Earth provide the foundation and let Metal rise from it as the refined, purposeful discernment that patience alone makes possible. Crystals that carry Earth and Metal frequencies can restore the grounded clarity your chart is calling for, giving your precision the deep foundation it needs to hold its edge without becoming brittle."
    },
    water: {
      body: "Water enters first, carrying Metal's precision forward with adaptability and grace — ensuring that clarity moves through the world as flow rather than force, and that what is sharp does not become what is isolating. Metal gives Water its direction and its edge; Water gives Metal the emotional intelligence and forward movement that precision alone cannot sustain.",
      invitation: "This is your chart's invitation to let clarity move — to let Water carry what Metal has refined and let that refinement flow outward with grace rather than remaining contained within you. Crystals that carry Water and Metal frequencies can restore the fluid precision your chart is calling for, giving your clarity the adaptability it needs to move through the world without losing its edge."
    },
    wood: {
      body: "Wood enters first, softening Metal's edge with the vitality and renewal that keeps precision from becoming rigidity — reminding your energy that structure exists to support growth, not to replace it. Metal receives that softening and becomes the kind of clarity that shapes without cutting, that defines without diminishing, that holds its edge while remaining in relationship with what is living and changing.",
      invitation: "This is your chart's invitation to let precision coexist with vitality — to let Wood bring renewal to what Metal refines and let that renewal keep your clarity both sharp and alive. Crystals that carry Wood and Metal frequencies can restore the vital discernment your chart is calling for, keeping your precision flexible enough to serve growth rather than constraining it."
    },
    fire: {
      body: "Fire enters first, tempering Metal with the warmth and human vitality that transforms cold precision into something purposeful and connected — the heat that forges rather than melts, that strengthens the blade without making it brittle. Metal receives that tempering and becomes its truest form — not the sharp edge that isolates but the refined clarity that illuminates, warms, and endures.",
      invitation: "This is your chart's invitation to let precision be forged rather than simply sharpened — to let Fire bring warmth to what Metal refines and let that warmth transform your clarity into something that connects as powerfully as it cuts. Crystals that carry Fire and Metal frequencies can restore the tempered precision your chart is calling for, giving your natural discernment the warmth it needs to move through the world as light rather than edge."
    }
  }
}, SN = {
  water: {
    metal: "Together, Water and Metal form one of the most quietly powerful pairings in the five element system. Metal distils and Water carries what remains forward. One clarifies, the other deepens. What Metal makes precise, Water makes enduring, transforming the sharp insight of a single moment into the deep, accumulated wisdom of a life lived with intention. This is the pairing of those who see clearly and move accordingly, unhurried, purposeful, and difficult to shake.",
    wood: "Together, Water and Wood form the pairing of deep roots and upward reach. Water nourishes what Wood becomes, and Wood draws Water's stillness into motion, transforming quiet depth into visible, living growth. One sustains, the other rises. What Water holds in reserve, Wood carries into the world as momentum, vision, and the kind of forward movement that does not forget where it came from.",
    fire: "Together, Water and Fire form the pairing of depth and illumination, of what is felt and what is expressed. Fire warms what Water carries, bringing depth toward the surface where it can be felt and shared. Water receives that warmth and is renewed by it, moving outward rather than turning inward. What Fire illuminates, Water gives staying power, transforming momentary brilliance into the kind of warmth that endures long after the initial spark has passed.",
    earth: "Together, Water and Earth form the pairing of flow and foundation, of movement and the ground that gives it shape. Earth contains what Water carries and Water softens what Earth holds, keeping groundedness from becoming rigidity and flow from becoming formlessness. One provides the banks, the other provides the current. What Earth defines, Water fills with purpose, creating the steady, purposeful movement of a river that knows exactly where it is going."
  },
  wood: {
    water: "Together, Wood and Water form the pairing of nourishment and growth, of the deep source and what rises from it. Water feeds what Wood reaches toward, and Wood gives Water's depth a living, visible expression in the world. One sustains, the other transforms. What Water nourishes quietly beneath the surface, Wood carries upward into form, momentum, and the enduring vitality of something that has been given everything it needs to grow.",
    fire: "Together, Wood and Fire form the pairing of fuel and flame, of living structure and the passion it ignites. Wood gives Fire its direction and longevity, and Fire gives Wood its urgency and warmth. One provides the form, the other provides the force. What Wood builds steadily over time, Fire illuminates and accelerates, transforming patient momentum into the kind of inspired, sustained pursuit that moves both the one who carries it and everyone around them.",
    earth: "Together, Wood and Earth form the pairing of growth and the ground it rises from. Earth nourishes what Wood becomes, and Wood proves that Earth's patience was never stillness but preparation. One holds, the other rises. What Earth accumulates in silence, Wood transforms into visible, purposeful growth, making good on the promise that every season of quiet tending is always, eventually, followed by something that reaches toward the light.",
    metal: "Together, Wood and Metal form the pairing of growth and the hand that shapes it. Metal prunes what Wood has overextended and Wood softens what Metal might otherwise hold too rigidly. One defines, the other grows within and beyond that definition. What Metal refines, Wood renews, creating the rare balance of a vision that is both disciplined enough to focus and vital enough to keep reaching."
  },
  fire: {
    wood: "Together, Fire and Wood form the pairing of the flame and the living fuel that sustains it. Wood feeds Fire with steady, organised purpose, and Fire transforms what Wood provides into warmth, illumination, and the kind of radiant energy that moves others. One fuels, the other radiates. What Wood builds with patience, Fire expresses with passion, creating the sustained brilliance of something that burns brightly not because it consumes recklessly but because it has been given exactly what it needs.",
    earth: "Together, Fire and Earth form the pairing of warmth and the vessel that holds it. Earth contains what Fire generates, transforming intensity into something that builds and endures rather than flares and fades. One provides the heat, the other provides the home. What Fire ignites with passion, Earth grounds into purpose, creating the steady, reliable warmth of something that has found its proper place and burns all the more powerfully for it.",
    metal: "Together, Fire and Metal form the pairing of the forge and what it creates. Fire tempers Metal into its truest, most purposeful form, and Metal gives Fire's energy the precision and direction that radiance alone cannot sustain. One provides the heat, the other provides the edge. What Fire illuminates with warmth, Metal sharpens into clarity, creating the rare combination of brilliance that does not merely glow but cuts cleanly through to what is true.",
    water: "Together, Fire and Water form the pairing of illumination and depth, of what burns at the surface and what moves beneath it. Water tempers Fire's intensity into wisdom and Fire warms Water's depth into expression. One brings light, the other brings understanding. What Fire reveals in a moment of clarity, Water carries forward as something lasting, creating the balance between feeling fully and moving wisely that makes passion sustainable rather than consuming."
  },
  earth: {
    fire: "Together, Earth and Fire form the pairing of the ground and the warmth that brings it to life. Fire activates what Earth has patiently prepared, and Earth receives that warmth and transforms it into the steady, nourishing strength that others can stand on. One warms, the other holds. What Fire ignites with vitality, Earth grounds into endurance, creating the living foundation of something that is both warm enough to welcome and stable enough to last.",
    metal: "Together, Earth and Metal form the pairing of patient accumulation and what it ultimately produces. Metal emerges from Earth as its most refined expression, and Earth honours Metal's clarity by proving that precision was always what its patience was building toward. One accumulates, the other distils. What Earth holds through seasons of quiet tending, Metal refines into the clear, purposeful discernment of someone who has earned their edge through depth rather than force.",
    wood: "Together, Earth and Wood form the pairing of nourishing ground and the growth it makes possible. Wood draws from Earth's abundance and Earth finds its purpose fulfilled in what Wood becomes. One nourishes, the other rises. What Earth holds with quiet generosity, Wood transforms into visible momentum and forward reach, creating the living cycle of a foundation that gives and the growth that proves the giving was never wasted.",
    water: "Together, Earth and Water form the pairing of structure and the flow that keeps it alive. Water softens what Earth holds and Earth gives Water's movement its shape and direction. One provides the banks, the other provides the current. What Earth defines with patience and steadiness, Water fills with adaptability and grace, creating the grounded flow of something that is both reliable enough to trust and fluid enough to meet whatever comes."
  },
  metal: {
    earth: "Together, Metal and Earth form the pairing of what accumulates and what it eventually becomes. Earth is the origin of Metal's clarity, the patient depth from which precision slowly and inevitably emerges. One prepares, the other arrives. What Earth holds through long seasons of quiet accumulation, Metal distils into the refined, purposeful edge of someone who has not rushed their knowing but allowed it to form completely before bringing it forward.",
    water: "Together, Metal and Water form the pairing of clarity and the wisdom that carries it forward. Metal refines and Water receives what remains, moving it through the world with adaptability, depth, and the quiet grace of someone who knows what they know and does not need to announce it. One sharpens, the other flows. What Metal makes true, Water makes enduring, creating the rare combination of precision and depth that sees clearly and moves accordingly.",
    wood: "Together, Metal and Wood form the pairing of the edge and the living thing it shapes. Metal brings discipline to Wood's vitality and Wood brings renewal to Metal's precision, ensuring that clarity remains in relationship with what is growing rather than standing apart from it. One defines, the other grows. What Metal refines with discernment, Wood softens with life, creating the balance of a vision that is both sharp enough to focus and vital enough to keep reaching beyond what it has already mastered.",
    fire: "Together, Metal and Fire form the pairing of the forge and the blade it produces. Fire provides the heat that transforms raw Metal into something refined, purposeful, and enduring, and Metal gives Fire's energy a lasting shape that outlives the moment of its making. One provides the force, the other provides the form. What Fire tempers with intensity, Metal carries forward as precision, creating the enduring clarity of something that has been tested by heat and emerged sharper, truer, and more purposeful for it."
  }
}, yB = {
  intro: "2026 is the Year of the Fire Horse — a year of amplified intensity, rapid movement, and high-octane energy. Fire energy will surge across all charts this year, heating up ambitions, accelerating timelines, and testing patience.",
  fireByRole: {
    negative: "What this means for your chart: Fire is your Negative God. A Fire Horse year pours fuel on an already roaring flame. You may feel extraordinary drive this year, but the risk of burnout, impulsive decisions, and emotional volatility is equally heightened. This is not a year to add more fire. It is a year to tend what cools, deepens, and steadies.",
    adversarial: "What this means for your chart: Fire is your Adversarial God — a disruptive element in your chart that the Fire Horse year will amplify. While this year's energy may bring bursts of momentum and visibility, it also risks scattering your focus and pulling you toward urgency over intention. The Fire Horse rewards those who channel its speed, not those who are swept up by it. This year calls for grounding, not acceleration.",
    useful: "What this means for your chart: Fire is your Useful God — the element your chart most needs, and the Fire Horse delivers it in abundance. This is one of the more auspicious alignments a chart can have in 2026. The year's energy works with your elemental needs rather than against them, amplifying your clarity, momentum, and capacity for meaningful action. The invitation this year is to move with the current rather than against it — and to do so with intention.",
    joyous: "What this means for your chart: Fire is your Joyous God — the element that supports and enhances your chart's primary need. A Fire Horse year strengthens that supporting energy, creating conditions where the momentum you have been building finds genuine traction. This is a year where effort compounds, where what you have been tending quietly begins to grow visibly. Use the year's intensity as fuel, not as pressure.",
    neutral: "What this means for your chart: Fire sits as a Neutral God in your chart — neither a primary support nor a direct source of friction. The Fire Horse year will heighten the overall pace and intensity of energy around you, but your chart is not in direct conflict with it nor directly amplified by it. The opportunity this year lies in staying oriented while the world moves fast — using your chart's elemental strengths to navigate 2026's intensity with steadiness and clear sight."
  }
}, LN = {
  water: {
    metal: "This is precisely why Water and Metal are your anchors in 2026. Water gives you the depth, patience, and wisdom to let the right moments find you rather than chasing every spark the Fire Horse ignites. Metal sharpens that discernment further — cutting through the noise of a loud, fast-moving year so that what you act on is what truly deserves your energy. In a year when everything accelerates, this pairing is your permission to slow down, clarify, and move with precision rather than urgency.",
    wood: "This is precisely why Water and Wood are your anchors in 2026. Water gives you the depth and patience to move beneath the surface of a fast and noisy year, protecting your energy from the Fire Horse's pull toward reactivity. Wood channels what Water nourishes into purposeful, upward momentum — ensuring that the growth you build this year is rooted rather than reactive. Together, they give you direction without urgency and vitality without depletion.",
    fire: "This is precisely why Water and Fire working in balance are essential for you in 2026. Rather than resisting the Fire Horse year entirely, your chart calls for Water to temper and deepen what Fire illuminates — transforming the year's intensity into wisdom rather than volatility. Fire brings your depth to the surface; Water ensures what surfaces is grounded and enduring. This is a year to feel the energy fully and move through it with depth rather than being consumed by it.",
    earth: "This is precisely why Water and Earth are your anchors in 2026. Earth gives your energy its banks in a year that threatens to overflow all boundaries, containing what could scatter into something steady and purposeful. Water flows within what Earth defines, moving with calm intention through a year that rewards those who do not lose their centre. Together, they are your foundation — grounded, adaptive, and difficult to unsettle."
  },
  wood: {
    water: "This is precisely why Wood and Water are your anchors in 2026. Water nourishes your chart's need for rooted, sustainable growth — ensuring that the momentum the Fire Horse year generates has something deep to draw from rather than depleting what is already in motion. Wood gives that nourishment its direction, transforming what Water sustains into visible, purposeful progress. In a year of high intensity, this pairing keeps your growth steady and your roots intact.",
    fire: "This is precisely why Wood and Fire are your anchors in 2026. The Fire Horse year brings exactly the kind of igniting energy that Wood needs to move from potential into pursuit — and your chart is positioned to channel that intensity productively. Fire accelerates what Wood has been building; Wood gives Fire's energy a living structure to move through rather than burning without form. This is a year where your vision has the wind behind it. Move with intention.",
    earth: "This is precisely why Wood and Earth are your anchors in 2026. Earth steadies what the Fire Horse year risks making restless, providing the stable, nourishing ground that keeps Wood's momentum from outrunning its own foundation. Wood rises with intention from what Earth holds firm, building upward through a fast-moving year without losing contact with what sustains it. Together, they ensure that what you grow this year is built on something that lasts.",
    metal: "This is precisely why Wood and Metal are your anchors in 2026. In a year that tempts expansion in every direction, Metal brings the discernment to know which direction is worth your energy — and Wood channels that clarity into sustained, focused growth. Metal defines; Wood rises within that definition with greater precision and purpose than the Fire Horse year's scattered pace would otherwise allow. This is a year to grow selectively and powerfully."
  },
  fire: {
    wood: "This is precisely why Fire and Wood are your anchors in 2026. Your chart is aligned with the Fire Horse year's dominant energy, and Wood ensures that alignment becomes momentum rather than overwhelm. Wood feeds Fire with steady, organised fuel — transforming the year's intensity into sustained radiance rather than a burning that exhausts itself. This is one of the more powerful chart alignments for 2026. Channel it with purpose and you will move further this year than you expect.",
    earth: "This is precisely why Fire and Earth are your anchors in 2026. Earth gives the Fire Horse year's amplified energy somewhere to gather and deepen within your chart, preventing the year's intensity from scattering before it has built anything lasting. Fire warms within what Earth contains, and what results is not fleeting brilliance but enduring, grounded vitality. This year rewards those who hold their centre while the world accelerates around them.",
    metal: "This is precisely why Fire and Metal are your anchors in 2026. Metal gives the Fire Horse year's energy its edge in your chart — ensuring that what the year ignites moves toward precision and insight rather than scattering across too many directions at once. Fire illuminates; Metal sharpens what that illumination reveals. Together, they turn a year of high intensity into one of high clarity — purposeful, directed, and difficult to deflect.",
    water: "This is precisely why Fire and Water working in balance are your anchors in 2026. The Fire Horse year amplifies Fire's presence in every chart, and for yours, Water ensures that amplification deepens rather than destabilises. Water tempers what Fire illuminates, giving this year's intensity the emotional intelligence and staying power it needs to produce something lasting. Together, they make the Fire Horse year not a year of volatility but a year of tempered, sustainable brilliance."
  },
  earth: {
    fire: "This is precisely why Earth and Fire are your anchors in 2026. The Fire Horse year activates exactly what your chart needs — warmth and vitality moving through what has been patient and still, drawing the latent strength of Earth into purposeful, generative expression. Fire warms; Earth transforms that warmth into the steady, nourishing foundation others can stand on. This is a year where your groundedness becomes your greatest asset, activated and alive.",
    metal: "This is precisely why Earth and Metal are your anchors in 2026. Metal emerges from Earth's depth as discernment and clarity — and in a Fire Horse year that rewards those who know exactly where to place their energy, that clarity becomes your competitive edge. Earth steadies what Metal refines, ensuring that the precision you bring to 2026 is built on something unhurried and deep rather than reactive and brittle. This is a year to move slowly, clearly, and with lasting effect.",
    wood: "This is precisely why Earth and Wood are your anchors in 2026. Wood loosens what the Fire Horse year risks making too rigid or too dense, creating the openness that allows Earth's natural generativity to express itself fully. Earth nourishes what Wood draws upward, and together they restore the living cycle of a foundation that grows rather than simply holds. In a year of high movement, this pairing keeps you rooted and growing simultaneously.",
    water: "This is precisely why Earth and Water are your anchors in 2026. Water softens what the Fire Horse year's intensity risks hardening — keeping your groundedness adaptive and responsive rather than fixed under pressure. Earth gives Water's movement its shape and direction, ensuring that the flow the year demands does not scatter what you have carefully built. Together, they are the steady, adaptive centre that a fast-moving year cannot unsettle."
  },
  metal: {
    earth: "This is precisely why Metal and Earth are your anchors in 2026. Earth provides the deep, patient foundation from which Metal's clarity slowly and powerfully emerges — and in a Fire Horse year that rewards decisive, well-placed action, that clarity becomes your most valuable resource. Earth steadies; Metal distils what patience has accumulated into the precise, purposeful discernment that allows you to move through 2026's intensity without being drawn off course by it.",
    water: "This is precisely why Metal and Water are your anchors in 2026. Metal cuts through the noise of a Fire Horse year with precision and truth, ensuring that what you pursue is what genuinely deserves your energy rather than what simply feels urgent in the moment. Water carries what Metal clarifies forward with depth and adaptability, giving your discernment the grace to move through a fast-moving year without hardening into rigidity. Together, they are clarity in motion.",
    wood: "This is precisely why Metal and Wood are your anchors in 2026. Metal brings the focus and precision that a Fire Horse year's scattered energy threatens to overwhelm, giving your vision a clear, defined direction through the noise. Wood softens that precision with vitality and renewal, ensuring that what Metal clarifies remains alive and growing rather than refined into something too fixed to adapt. Together, they give you the disciplined momentum that turns a high-intensity year into measurable, lasting progress.",
    fire: "This is precisely why Metal and Fire are your anchors in 2026. The Fire Horse year provides the very tempering heat that Metal requires to become its truest, most purposeful form — and your chart is positioned to use that intensity as a forge rather than a threat. Fire strengthens what Metal becomes; Metal gives Fire's energy a lasting shape that outlives the year's momentum. This is a year to let pressure refine rather than deplete you, and to emerge from it sharper and more purposeful than before."
  }
}, CB = (e, A, t) => {
  const r = {
    method: "POST",
    body: t.body,
    query: t.query
  };
  return e(A, r);
}, HN = (e = EI) => ({
  postRegisterVerifyEmail(A = {}) {
    return CB(e, "/api/register/verifyEmail", A);
  },
  postSubscribeNew(A = {}) {
    return CB(e, "/api/subscribeNew", A);
  },
  postFortuneSendInferByEmail(A = {}) {
    return CB(e, "/api/fortune/sendInferByEmail", A);
  },
  getOrderDetailByUni(A = {}) {
    const t = A.path?.uni ?? "";
    return e(`/api/order/detail/${encodeURIComponent(String(t))}`, {
      method: "GET",
      query: A.query
    });
  }
}), Iy = HN(), TN = Iy.postRegisterVerifyEmail, _N = Iy.postSubscribeNew, ON = Iy.postFortuneSendInferByEmail, NN = { class: "w-full relative" }, DN = ["src"], RN = { class: "absolute top-0 z-20 left-0 w-full h-full box-border flex flex-col items-center px-4 bg-gradient-to-t from-white/80 to-transparent" }, MN = { class: "max-w-7xl mx-auto flex-1" }, PN = { class: "pb-24 relative z-20 px-4 sm:px-6 md:px-0 w-full mt-4 flex flex-col items-center justify-center gap-2 sm:gap-3 md:gap-4 box-border h-full" }, kN = {
  key: 0,
  class: "max-w-3xl px-2 text-center text-xs sm:text-sm md:text-base font-normal leading-5 sm:leading-6 md:leading-7"
}, KN = { class: "bazi-pdf-content-shell box-border container mx-auto relative z-30 -mt-32" }, VN = { class: "bazi-pdf-content-border px-3 md:px-6 py-4 sm:py-6 shadow-md bg-[#FCFCFC] rounded-lg box-border w-full" }, GN = { class: "bazi-pdf-content-inner border border-[#D6BB86] p-3 sm:p-4 md:p-6 rounded-lg flex flex-col" }, WN = {
  key: 0,
  class: "flex flex-col w-full justify-center items-center max-w-xl mx-auto py-4 sm:py-6 md:py-6 px-3 sm:px-4"
}, jN = {
  key: 0,
  class: "w-full mb-4"
}, qN = { class: "bg-red-50 border border-red-200 rounded-md p-3" }, $N = { class: "flex" }, zN = { class: "ml-3" }, XN = { class: "mt-2 text-sm text-red-700" }, YN = {
  role: "list",
  class: "list-disc pl-5 space-y-1"
}, JN = { class: "flex flex-col gap-2 font-semibold" }, ZN = {
  key: 0,
  class: "flex flex-col gap-2 font-semibold"
}, AD = {
  class: "flex flex-col gap-2 font-semibold",
  key: "gender"
}, eD = {
  class: "flex flex-col gap-2 font-semibold box-border",
  key: "birthDate"
}, tD = { class: "grid grid-cols-1 sm:grid-cols-3 gap-2 w-full" }, rD = {
  class: "flex flex-col gap-2 font-semibold",
  key: "birthTime"
}, nD = {
  class: "bazi-loading-state",
  key: "animation"
}, iD = {
  key: 0,
  class: "flex flex-col gap-7 items-center w-full"
}, sD = { class: "bg-white p-8 w-full rounded-sm border-[0.5px] border-[#E0E0E0]" }, aD = { class: "flex items-center justify-center" }, oD = { class: "flex flex-col gap-6 text-sm" }, lD = { class: "flex items-center flex-col md:lg:flex-row gap-8 md:lg:gap-48" }, cD = { class: "w-full md:lg:grid md:lg:grid-cols-2 flex gap-4 flex-1" }, uD = { class: "flex items-center" }, hD = { class: "w-full flex gap-1 items-center flex-1" }, fD = { class: "flex items-center capitalize" }, dD = { class: "flex items-center flex-col md:lg:flex-row gap-8 md:lg:gap-48" }, gD = { class: "w-full md:lg:grid md:lg:grid-cols-2 flex gap-4 flex-1" }, pD = { class: "flex items-center md:lg:text-nowrap" }, BD = { class: "w-full flex gap-1 items-center flex-1" }, wD = { class: "w-full flex gap-1 items-center" }, mD = { class: "flex items-center flex-col md:lg:flex-row gap-8 md:lg:gap-48" }, vD = { class: "w-full md:lg:grid md:lg:grid-cols-2 flex gap-4 flex-1" }, yD = { class: "flex items-center md:lg:text-nowrap" }, CD = { class: "w-full flex gap-1 items-center flex-1" }, bD = { class: "p-12 leading-8" }, FD = { class: "text-xs md:text-base leading-8" }, QD = { class: "mt-4 text-xs leading-8 md:text-base" }, UD = { class: "bazi-table-container border-[0.5px] border-[#E0E0E0]" }, ED = {
  class: "bazi-table",
  "border-spacing": "0px"
}, xD = { class: "bazi-table-head" }, ID = { class: "bazi-table-th-icon" }, SD = ["src"], LD = { class: "bazi-energy-card bg-white px-3 pr-0 md:px-6 p-6 w-full rounded-sm border-[0.5px] border-[#E0E0E0]" }, HD = { class: "bazi-energy-layout grid grid-cols-2 lg:grid-cols-2 gap-3 sm:gap-4 md:gap-6" }, TD = { class: "bazi-energy-stats-panel md:max-w-60 mx-auto flex items-center" }, _D = { class: "bazi-energy-stats-grid grid grid-cols-[minmax(0,1fr)_auto] gap-x-2 sm:gap-x-4 gap-y-5 sm:gap-y-5 py-3 sm:py-4 w-full items-center" }, OD = { class: "wuxing-stat-item" }, ND = ["src", "alt"], DD = { class: "wuxing-stat-dots" }, RD = { class: "flex justify-end md:justify-center items-center" }, MD = { class: "relative" }, PD = {
  viewBox: "0 0 200 200",
  width: "240",
  height: "240",
  class: "w-[140px] h-[140px] md:w-[240px] md:h-[240px] overflow-visible"
}, kD = ["points"], KD = ["points"], VD = { class: "w-full flex items-center gap-4 relative" }, GD = { class: "box-border group tooltip-container relative flex items-center justify-center" }, WD = ["aria-expanded"], jD = { class: "flex flex-col gap-3 sm:gap-4 w-full p-3 sm:p-4 md:p-6 rounded-sm border-[0.5px] border-[#E0E0E0] bg-white" }, qD = { class: "" }, $D = { class: "gods-grid flex flex-col gap-2 md:grid md:grid-cols-5" }, zD = { class: "png-body-text p-12 leading-8" }, XD = { class: "mt-4 text-xs md:text-base" }, YD = { class: "mt-4 text-xs md:text-base" }, JD = {
  key: 0,
  class: "mt-6 text-xs md:text-base"
}, ZD = { class: "font-bold" }, A8 = { class: "mt-3" };
const e8 = { class: "flex flex-col gap-3 w-full p-6 bg-white rounded-sm border-[0.5px] border-[#E0E0E0]" }, t8 = {
  key: 0,
  class: "bazi-full-report-preview"
}, r8 = { class: "bazi-full-report-action" }, n8 = ["disabled"], i8 = {
  key: 2,
  class: "uppercase"
}, s8 = {
  key: 0,
  class: "bazi-full-report-mask"
}, a8 = { key: 1 }, o8 = { class: "font-bold" }, l8 = { class: "mt-3" }, c8 = { class: "mt-4 text-sm" }, u8 = { class: "mt-4 text-sm" }, h8 = { class: "mt-4 text-sm" }, f8 = { class: "mt-4 text-sm" }, d8 = { class: "flex flex-col gap-3 w-full p-6 bg-white rounded-sm border-[0.5px] border-[#E0E0E0]" }, g8 = { class: "leading-8" }, p8 = { class: "mt-4" }, B8 = { key: 0 }, w8 = {
  "data-bazi-pdf-hide": "balance-signup",
  class: "flex flex-col gap-3 w-full p-6 bg-white border-[0.5px] border-[#E0E0E0] rounded-3xl"
}, m8 = ["disabled"], v8 = {
  "data-bazi-pdf-hide": "recommended-products",
  class: "w-full flex flex-col gap-7"
}, y8 = { class: "mt-4 flex flex-center" }, C8 = { class: "flex flex-center" }, b8 = ["src"], F8 = { class: "px-12 leading-8" }, Q8 = {
  key: 0,
  class: "w-full flex flex-col gap-7"
}, U8 = ["src", "alt", "onError"], E8 = { class: "flex min-w-0 flex-col justify-center gap-4" }, x8 = {
  key: 0,
  class: "mt-1 text-xs font-semibold tracking-[0.22em] text-[#A76F4F]"
}, I8 = {
  key: 1,
  class: "mt-3 text-sm italic leading-6 tracking-[0.14em] text-[#8C7468]"
}, S8 = {
  key: 0,
  class: "line-clamp-5 text-sm leading-6 text-[#4A352D]"
}, L8 = { class: "grid grid-cols-[minmax(0,1fr)_3rem] pt-3" }, H8 = { class: "truncate" }, T8 = ["onClick", "aria-label"], _8 = { class: "w-full px-3 sm:px-4 md:px-6" }, O8 = { class: "mx-auto mt-8 max-w-5xl text-center text-[16px] leading-8 text-[#A76F4F]" }, N8 = { class: "md:hidden" }, D8 = ["src"], R8 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center"
}, M8 = { class: "relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-4 sm:p-6" }, P8 = { class: "flex flex-col sm:flex-row gap-2" }, k8 = ["disabled"], K8 = { key: 0 }, V8 = { key: 1 }, G8 = { key: 2 }, W8 = {
  key: 0,
  class: "text-red-600 text-sm"
}, j8 = { class: "flex gap-3 pt-4" }, q8 = ["disabled"], $8 = { key: 0 }, z8 = { key: 1 }, X8 = { class: "left-0 w-full" }, Y8 = ["src"], J8 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4"
}, Z8 = { class: "bg-white shadow-xl rounded-md max-w-3xl w-full max-h-[90vh] flex flex-col relative z-10" }, AR = { class: "overflow-y-auto flex-1 p-4" }, eR = { class: "pt-6 px-8" }, tR = { class: "flex items-center gap-2" }, rR = ["disabled"], nR = { class: "text-black/85 text-sm" }, iR = { class: "font-semibold" }, sR = { class: "mt-6 flex items-center h-16" }, aR = { class: "bg-[#F7F7F7] rounded-[4px 0 0 4px] h-full w-full flex items-center justify-center" }, oR = { class: "text-sm line-clamp-1 underline cursor-pointer text-[#D59F69]" }, lR = {
  key: 0,
  class: "flex w-full mt-6"
}, cR = ["disabled"], uR = { class: "line-through text-red-300" }, hR = ["disabled"], fR = {
  key: 1,
  class: "w-5 h-5 shrink-0 border-2 border-white/30 border-t-white rounded-full animate-spin"
}, dR = { class: "text-sm font-semibold" }, bB = "FirstFortuneCompleted", gR = /* @__PURE__ */ $g({
  __name: "App",
  setup(e) {
    const { t: A } = jC();
    wN({
      script: [
        {
          type: "application/ld+json",
          innerHTML: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebApplication",
            name: "Wuxing Energy Calculator",
            description: "Free Five Elements calculator that analyzes your Chinese astrology profile and recommends crystal bracelets for balance",
            url: "https://www.leymenjewels.com/chinese/bazi",
            applicationCategory: "LifestyleApplication",
            operatingSystem: "Web Browser",
            author: {
              "@type": "Organization",
              name: "Leymen"
            },
            publisher: {
              "@type": "Organization",
              name: "Leymen",
              logo: {
                "@type": "ImageObject",
                url: "https://www.leymenjewels.com/images/header/logo.webp"
              }
            },
            offers: {
              "@type": "Offer",
              price: "0",
              priceCurrency: "USD",
              availability: "https://schema.org/InStock"
            },
            applicationSubCategory: "Astrology Tool",
            featureList: [
              "Five Elements calculation",
              "Bazi analysis",
              "Personalized recommendations",
              "Energy balance assessment"
            ],
            inLanguage: "en",
            dateModified: (/* @__PURE__ */ new Date()).toISOString().split("T")[0],
            mainEntity: {
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "What is Wuxing?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Wuxing (五行) is the Chinese Five Elements theory that explains the relationship between Wood, Fire, Earth, Metal, and Water elements in nature and in human life."
                  }
                },
                {
                  "@type": "Question",
                  name: "How does the Bazi calculator work?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Our Bazi calculator analyzes your birth date and time to determine your elemental balance and recommends crystals that can help restore harmony."
                  }
                },
                {
                  "@type": "Question",
                  name: "Is the calculator really free?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes! Our Wuxing energy calculator is completely free to use with no hidden fees or required purchases."
                  }
                }
              ]
            }
          })
        }
      ]
    });
    const t = vN(), r = /* @__PURE__ */ We([]), n = /* @__PURE__ */ We({}), i = (/* @__PURE__ */ new Date()).getFullYear(), s = /* @__PURE__ */ We(!1), a = Array.from({ length: i - 1900 + 1 }, (G, O) => {
      const LA = i - O;
      return { value: String(LA), label: String(LA) };
    }), o = /* @__PURE__ */ We(null), l = /* @__PURE__ */ We("useful"), c = /* @__PURE__ */ We(!1), u = /* @__PURE__ */ We(!1), d = bt(() => t.currentRoute.value.query.id), h = () => {
      const G = window.__st?.cid;
      return G == null || G === "" || typeof G == "string" && !G.trim() ? 0 : G;
    }, p = () => {
      const G = h(), O = typeof G == "string" ? G.trim() : G;
      return O !== 0 && O !== "0" && O !== "" && O !== null && O !== void 0;
    }, B = /* @__PURE__ */ We(!1), y = (G) => {
      const O = String(BN.apiBaseUrl || "").replace(/\/+$/, "");
      return `${G.startsWith("/api/") ? O.replace(/\/api$/, "") : O}${G}`;
    }, m = async (G, O = {}) => {
      const LA = await EI(y(G), O), kA = LA.status ?? LA.code;
      if (kA !== void 0 && kA !== 200)
        throw new Error(LA.msg || "API request failed");
      return LA;
    }, C = () => pA.gender === "male" ? "male" : "women", Q = () => ({
      year: Number(pA.year),
      month: Number(pA.month),
      day: Number(pA.day),
      time: Number(pA.time || "12"),
      gender: C(),
      name: pA.name || "",
      lang: iA.value,
      openid: h()
    }), F = (G) => m("/api/fortune/fortuneBazi", {
      method: "POST",
      body: G
    }), T = () => m("/api/fortune/reportList", {
      query: {
        user_id: h(),
        user_id_type: "openid",
        page: 1,
        limit: 10
      }
    }), V = (G) => {
      const O = { ...G };
      return p() ? (delete O.email, O.openid = h()) : (delete O.openid, O.email = pA.email), m("/api/fortune/createReport", {
        method: "POST",
        body: O
      });
    }, M = (G, O) => m(`/api/fortune/showReport/${G}`, {
      query: {
        openid: h()
      },
      signal: O
    }), D = () => m("/api/shopify/products", {
      query: {
        first: 46,
        sort_key: "ID",
        reverse: !1
      }
    }), I = (G) => m("/api/shopify/product", {
      query: {
        id: ge(G),
        variants_first: 100,
        media_first: 50
      }
    }), q = (G) => m("/api/fortune/addProductTags", {
      method: "POST",
      body: G
    }), U = /* @__PURE__ */ We(null), x = /* @__PURE__ */ We(!1), P = /* @__PURE__ */ We(!1), N = mN(), { locale: iA } = jC(), nA = {
      金: "metal",
      木: "wood",
      水: "water",
      火: "fire",
      土: "earth"
    }, sA = (G) => {
      if (!G) return;
      const { scrollLeft: O, scrollWidth: LA, clientWidth: kA } = G, JA = LA > kA;
      x.value = JA && O > 10, P.value = JA && O < LA - kA - 10;
    }, tA = (G) => {
      if (!G) return;
      const O = G.clientWidth * 0.8;
      G.scrollBy({ left: -O, behavior: "smooth" });
    }, cA = (G) => {
      if (!G) return;
      const O = G.clientWidth * 0.8;
      G.scrollBy({ left: O, behavior: "smooth" });
    }, FA = (G) => {
      G.target.closest(".tooltip-container") || (c.value = !1);
    }, CA = () => {
      u.value = window.innerWidth < 768 || "ontouchstart" in window;
    }, S = () => {
      c.value = !c.value;
    }, W = () => {
      t.push("/zodiac-2026");
    }, Y = () => {
      u.value || (c.value = !0);
    }, AA = () => {
      u.value || (c.value = !1);
    };
    ug(() => {
      document.addEventListener("click", FA), CA(), window.addEventListener("resize", CA);
    }), Fy(() => {
      document.removeEventListener("click", FA), window.removeEventListener("resize", CA);
    });
    const oA = bt(() => {
      const G = parseInt(pA.year), O = parseInt(pA.month);
      if (!G || !O)
        return Array.from({ length: 31 }, (kA, JA) => ({
          value: String(JA + 1),
          label: String(JA + 1)
        }));
      let LA = 31;
      return [4, 6, 9, 11].includes(O) ? LA = 30 : O === 2 && (LA = G % 4 === 0 && G % 100 !== 0 || G % 400 === 0 ? 29 : 28), Array.from({ length: LA }, (kA, JA) => ({
        value: String(JA + 1),
        label: String(JA + 1)
      }));
    }), xA = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ].map((G, O) => ({
      value: String(O + 1),
      label: G
    })), IA = Array.from({ length: 24 }, (G, O) => {
      const LA = String(O).padStart(2, "0"), kA = String((O + 1) % 24).padStart(2, "0");
      return {
        value: LA,
        label: `${LA}:00-${kA}:00`
      };
    });
    let pA = /* @__PURE__ */ $l({
      name: "",
      email: "",
      gender: "",
      year: "",
      month: "",
      day: "",
      time: "12"
      // 默认中午12点
    });
    const WA = [
      { value: "male", label: A("chinese.bazi.genderMale") },
      { value: "female", label: A("chinese.bazi.genderFemale") }
    ], k = (G) => {
      o.value === G ? o.value = null : o.value = G;
    }, X = (G) => {
      const O = G.target, LA = O.closest("#bazi-select"), kA = O.closest(".dropdown-content") || O.closest(".dropdown-trigger");
      !LA && !kA && (o.value = null);
    }, uA = (G) => {
      l.value = G;
    }, E = {
      metal: "#AABAD2",
      wood: "#16892D",
      water: "#319BFF",
      fire: "#FF2615",
      earth: "#A3751A",
      金: "#AABAD2",
      木: "#16892D",
      水: "#319BFF",
      火: "#FF2615",
      土: "#A3751A"
    }, dA = {
      metal: {
        border: "1px solid #AABAD2",
        backgroundColor: "#FBFDFF"
      },
      wood: {
        border: "1px solid #16892D",
        backgroundColor: "#fdfffd"
      },
      water: {
        border: "1px solid #319BFF",
        backgroundColor: "#FAFDFF"
      },
      fire: {
        border: "1px solid #FF2615",
        backgroundColor: "#fff9f9"
      },
      earth: {
        border: "1px solid #A3751A",
        backgroundColor: "#fffcf6"
      },
      金: {
        border: "1px solid #AABAD2",
        backgroundColor: "#FBFDFF"
      },
      木: {
        border: "1px solid #16892D",
        backgroundColor: "#fdfffd"
      },
      水: {
        border: "1px solid #319BFF",
        backgroundColor: "#FAFDFF"
      },
      火: {
        border: "1px solid #FF2615",
        backgroundColor: "#fff9f9"
      },
      土: {
        border: "1px solid #A3751A",
        backgroundColor: "#fffcf6"
      }
    }, vA = [
      { key: "metal", name: "Metal", chinese: "金", color: E.metal },
      { key: "wood", name: "Wood", chinese: "木", color: E.wood },
      { key: "water", name: "Water", chinese: "水", color: E.water },
      { key: "fire", name: "Fire", chinese: "火", color: E.fire },
      { key: "earth", name: "Earth", chinese: "土", color: E.earth }
    ], rA = /* @__PURE__ */ We(N.getBaziInfo), fA = (G) => {
      if (G && typeof G == "object" && !Array.isArray(G)) return G;
      if (!(typeof G != "string" || !G))
        try {
          const O = JSON.parse(G);
          return O && typeof O == "object" && !Array.isArray(O) ? O : void 0;
        } catch {
          return;
        }
    }, EA = /* @__PURE__ */ We(), lA = /* @__PURE__ */ We(), HA = /* @__PURE__ */ We(!1), SA = /* @__PURE__ */ We([]), yA = /^[^\s@]+@[^\s@]+\.[^\s@]+$/, TA = /* @__PURE__ */ We(!1), _A = /* @__PURE__ */ $l({
      email: "",
      code: ""
    }), MA = /* @__PURE__ */ We(""), VA = /* @__PURE__ */ We(!1), $A = /* @__PURE__ */ We(!1), ee = /* @__PURE__ */ We(0), ZA = /* @__PURE__ */ We(""), Fe = /* @__PURE__ */ We(!1), me = {
      // 天干映射
      甲: E.wood,
      // 阳木
      乙: E.wood,
      // 阴木
      丙: E.fire,
      // 阳火
      丁: E.fire,
      // 阴火
      戊: E.earth,
      // 阳土
      己: E.earth,
      // 阴土
      庚: E.metal,
      // 阳金
      辛: E.metal,
      // 阴金
      壬: E.water,
      // 阳水
      癸: E.water,
      // 阴水
      // 地支映射（按主气五行）
      寅: E.wood,
      // 阳木
      卯: E.wood,
      // 阴木
      巳: E.fire,
      // 阴火
      午: E.fire,
      // 阳火
      申: E.metal,
      // 阳金
      酉: E.metal,
      // 阴金
      亥: E.water,
      // 阴水
      子: E.water,
      // 阳水
      辰: E.earth,
      // 阳土
      戌: E.earth,
      // 阳土
      丑: E.earth,
      // 阴土
      未: E.earth
      // 阴土
    }, Ce = () => {
      const G = [];
      if (p() || (pA.email ? yA.test(pA.email) || G.push(A("chinese.bazi.emailInvalid")) : G.push(A("chinese.bazi.emailRequired"))), !pA.year)
        G.push(A("chinese.bazi.yearRequired"));
      else {
        const O = parseInt(pA.year), LA = (/* @__PURE__ */ new Date()).getFullYear();
        (O < 1900 || O > LA) && G.push(A("chinese.bazi.yearInvalid"));
      }
      if (!pA.month)
        G.push(A("chinese.bazi.monthRequired"));
      else {
        const O = parseInt(pA.month);
        (O < 1 || O > 12) && G.push(A("chinese.bazi.monthInvalid"));
      }
      if (!pA.day)
        G.push(A("chinese.bazi.dayRequired"));
      else {
        const O = parseInt(pA.day), LA = parseInt(pA.month), kA = parseInt(pA.year);
        if (O < 1 || O > 31)
          G.push(A("chinese.bazi.dayInvalid"));
        else if (LA && kA) {
          let JA = 31;
          [4, 6, 9, 11].includes(LA) ? JA = 30 : LA === 2 && (JA = kA % 4 === 0 && kA % 100 !== 0 || kA % 400 === 0 ? 29 : 28), O > JA && G.push(A("chinese.bazi.dayInvalidForMonth"));
        }
      }
      if (pA.time) {
        const O = parseInt(pA.time);
        (O < 0 || O > 23) && G.push(A("chinese.bazi.timeInvalid"));
      }
      return {
        isValid: G.length === 0,
        errors: G
      };
    }, ae = async () => {
      SA.value = [];
      const G = Ce();
      if (!G.isValid) {
        SA.value = G.errors;
        return;
      }
      HA.value = !0;
      let O = !1;
      await new Promise((LA) => setTimeout(LA, 3e3));
      try {
        const LA = await F(Q());
        rA.value = LA.data, rA.value.gender = pA.gender, rA.value.name = pA.name || "", rA.value.year = parseInt(pA.year), rA.value.month = parseInt(pA.month), rA.value.day = parseInt(pA.day), rA.value.time = parseInt(pA.time || "12"), N.setBaziInfo(LA.data), SA.value = [], await Hr(), O = !0;
      } catch (LA) {
        console.error(LA), SA.value = ["Submission failed, please try again later"];
      } finally {
        HA.value = !1, s.value = !0, O && rr(!1);
      }
    }, Te = async () => {
      if (!(!ZA.value || Fe.value)) {
        Fe.value = !0;
        try {
          await _N({
            composable: "$fetch",
            body: {
              name: rA.value?.name || "",
              email: ZA.value,
              option: 1
            }
          }), ZA.value = "", fs("Thank you for subscribing!", {
            position: "bottom-right",
            autoClose: 3e3,
            type: "success"
          });
        } catch (G) {
          console.error(G), fs("Subscription failed, please try again later.", {
            position: "bottom-right",
            autoClose: 3e3,
            type: "error"
          });
        } finally {
          Fe.value = !1;
        }
      }
    }, ie = (G) => G.title || G.handle || "Leymen Bracelet", Ke = (G) => G.onlineStoreUrl ? G.onlineStoreUrl : G.handle ? `/products/${encodeURIComponent(G.handle)}` : "/collections/all", ge = (G) => G.legacyResourceId ? G.legacyResourceId : G.id?.match(/\d+$/)?.[0] || G.id, xe = (G) => G.featuredMedia?.preview?.image?.url || G.images?.nodes?.[0]?.url || G.media?.nodes?.[0]?.preview?.image?.url || "", Ye = (G) => [
      G.featuredMedia?.preview?.image?.url,
      ...G.images?.nodes?.map((O) => O.url) || [],
      ...G.media?.nodes?.map((O) => O.preview?.image?.url) || []
    ].filter((O, LA, kA) => !!O && kA.indexOf(O) === LA), ue = (G) => {
      const O = G.priceRangeV2?.minVariantPrice?.amount;
      if (!O) return "";
      const LA = Number(O);
      return `$${Number.isFinite(LA) ? LA.toLocaleString("en-US", {
        minimumFractionDigits: LA % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }) : O}`;
    }, pe = (G) => {
      const O = G.includes("?") ? "&" : "?";
      return `${G}${O}image_retry=${Date.now()}`;
    }, ze = (G, O) => {
      const LA = G.target;
      if (LA.dataset.fallbackComplete === "true") return;
      const kA = Number(LA.dataset.retryCount || 0), JA = Ye(O);
      if (kA === 0 && JA[0]) {
        LA.dataset.retryCount = "1", LA.src = pe(JA[0]);
        return;
      }
      const Ue = JA[kA];
      if (Ue) {
        LA.dataset.retryCount = String(kA + 1), LA.src = Ue;
        return;
      }
      LA.dataset.fallbackComplete = "true", LA.src = po("logo");
    }, Ii = (G) => G.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim(), Jt = (G) => {
      if (!G) return;
      const LA = (G.match(/<p[^>]*>[\s\S]*?<\/p>/gi) || [G]).map(Ii).filter((kA) => kA && !/^about this product/i.test(kA));
      return LA[LA.length - 1];
    }, Wr = (G) => Jt(G.descriptionHtml || G.description), un = (G) => {
      const O = [
        G.title,
        G.handle,
        G.description,
        G.descriptionHtml,
        G.featuredMedia?.alt,
        G.featuredMedia?.preview?.image?.altText,
        G.featuredMedia?.preview?.image?.alt,
        ...G.tags || []
      ].filter(Boolean).join(" ").toLowerCase();
      return Object.values(nA).find((LA) => new RegExp(`\\b${LA}\\b`, "i").test(O));
    }, Be = (G) => {
      const O = un(G);
      return O ? On[O] : "";
    }, Jr = (G) => {
      if (typeof G == "number" && (!Number.isSafeInteger(G) || G <= 0)) return;
      const O = String(G ?? "").trim();
      return /^[1-9]\d{0,19}$/.test(O) ? O : void 0;
    }, Zt = (G) => {
      if (G.length !== 3) return;
      const O = G.map((kA) => {
        const JA = Be(kA), Ue = ie(kA).trim();
        if (!JA || !Ue) return;
        const KA = 255 - Array.from(`${JA}-`).length, Ne = Array.from(Ue).slice(0, KA).join("").trim();
        return Ne ? `${JA}-${Ne}` : void 0;
      });
      if (O.some((kA) => !kA)) return;
      const LA = O;
      if (new Set(LA.map((kA) => kA.toLowerCase())).size === 3)
        return LA;
    };
    let Vt = "", Ar;
    const Bt = async (G) => {
      const O = Zt(r.value);
      if (!O) {
        console.warn("Skipping Shopify product tags: exactly three valid, unique product tags are required.");
        return;
      }
      const LA = Jr(G) || Jr(h()), kA = pA.email.trim().toLowerCase();
      if (!LA && !kA) {
        console.warn("Skipping Shopify product tags: no Shopify customer identity is available.");
        return;
      }
      const JA = LA ? { openid: LA, tags: O } : { email: kA, tags: O }, Ue = JSON.stringify(JA);
      if (Vt === Ue && Ar) {
        await Ar;
        return;
      }
      Vt = Ue, Ar = (async () => {
        try {
          await q(JA);
        } catch (KA) {
          Vt = "", Ar = void 0, console.error("Failed to sync Shopify product tags:", KA), fs("Unable to save your product recommendations. Please try again later.", {
            type: "error",
            position: "bottom-right"
          });
        }
      })(), await Ar;
    }, er = (G) => Jt(G), Gt = (G) => n.value[G.id] || Wr(G), ui = async (G) => {
      const O = G.filter(
        (JA) => JA.id && (!n.value[JA.id] || !Wr(JA))
      );
      if (!O.length) return;
      const LA = {}, kA = {};
      await Promise.all(
        O.map(async (JA) => {
          try {
            const { data: Ue } = await I(JA), KA = er(Ue?.descriptionHtml || Ue?.description);
            KA && (LA[JA.id] = KA), kA[JA.id] = { ...JA, ...Ue };
          } catch (Ue) {
            console.error("Failed to fetch recommended product detail:", Ue);
            const KA = Wr(JA);
            KA && (LA[JA.id] = KA);
          }
        })
      ), Object.keys(LA).length && (n.value = {
        ...n.value,
        ...LA
      }), Object.keys(kA).length && (r.value = r.value.map((JA) => {
        const Ue = kA[JA.id];
        return Ue ? { ...JA, ...Ue } : JA;
      }));
    }, hi = (G) => {
      window.location.href = Ke(G);
    }, Hr = async () => {
      const { data: G } = await D(), O = G?.list || [], LA = lA.value?.useful_god ?? rA.value?.useful_god, kA = lA.value?.joyous_god ?? rA.value?.joyous_god, JA = nA[LA], Ue = nA[kA];
      if (!O.length) {
        r.value = [];
        return;
      }
      const KA = (Wt) => Wt ? O.filter((Dt) => un(Dt) === Wt) : [];
      let Ne = [];
      if (JA && Ue && JA !== Ue ? Ne = [...KA(Ue).slice(0, 2), ...KA(JA).slice(0, 1)] : (JA || Ue) && (Ne = KA(JA || Ue).slice(0, 3)), Ne.length < 3) {
        const Wt = new Set(Ne.map((Dt) => Dt.id));
        Ne = [
          ...Ne,
          ...O.filter((Dt) => !Wt.has(Dt.id)).slice(0, 3 - Ne.length)
        ];
      }
      r.value = Ne, await ui(r.value);
    }, jr = bt(() => rA.value && (rA.value.categoryId || rA.value.ganzhi_year || rA.value.useful_god || rA.value.strengths));
    rA.value && !r.value.length && Hr().catch((G) => {
      console.error("Failed to load initial recommended products:", G);
    });
    const tr = () => {
      TA.value = !1, _A.email = "", _A.code = "", MA.value = "", ee.value = 0, VA.value = !1;
    }, Tn = async () => {
      if (!_A.email) {
        MA.value = A("chinese.bazi.emailRequired");
        return;
      }
      if (!yA.test(_A.email)) {
        MA.value = A("chinese.bazi.emailInvalid");
        return;
      }
      VA.value = !0, MA.value = "";
      try {
        const G = await TN({
          composable: "$fetch",
          body: {
            email: _A.email,
            type: "10"
          }
        });
        ee.value = 60;
        const O = setInterval(() => {
          ee.value--, ee.value <= 0 && clearInterval(O);
        }, 1e3);
      } catch (G) {
        console.error("发送验证码失败:", G), MA.value = A("chinese.bazi.sendCodeFailed");
      } finally {
        VA.value = !1;
      }
    }, hn = async () => {
      if (!_A.email || !_A.code) {
        MA.value = A("chinese.bazi.fillAllFields");
        return;
      }
      $A.value = !0, MA.value = "";
      try {
        const G = await ON({
          composable: "$fetch",
          body: {
            email: _A.email,
            captcha: _A.code,
            ...pA,
            gender: pA.gender || "female",
            lang: iA.value
          }
        });
        N.isLogin || await N.setToken(G.data?.token || ""), tr(), fs.success(A("chinese.bazi.sendSuccess")), rA.value && (window.scrollTo({ top: 0, behavior: "smooth" }), setTimeout(() => {
          window.location.reload();
        }, 5e3));
      } catch (G) {
        console.error("验证失败:", G), MA.value = A("chinese.bazi.verificationFailed");
      } finally {
        $A.value = !1;
      }
    }, je = /* @__PURE__ */ We(!1), Nt = /* @__PURE__ */ We(null), Si = (G) => !G || G.startsWith("data:") || G.startsWith("blob:") || G.startsWith("http") ? G : `${window.location.origin}${G.startsWith("/") ? G : `/${G}`}`, ts = async () => {
      const G = [100, 200, 300, 400, 500, 600, 700, 800, 900];
      await Promise.all(G.map((O) => document.fonts.load(`${O} 16px Costaline`))), await document.fonts.ready;
    }, Li = async (G) => {
      const O = Array.from(G.querySelectorAll("img"));
      await Promise.all(
        O.map(
          (LA) => new Promise((kA) => {
            const JA = LA, Ue = JA.getAttribute("src");
            if (!Ue) {
              kA();
              return;
            }
            const KA = Si(Ue);
            if (JA.crossOrigin = "anonymous", JA.complete && JA.naturalHeight > 0) {
              JA.src !== KA && (JA.src = KA), kA();
              return;
            }
            const Ne = new Image();
            Ne.crossOrigin = "anonymous", Ne.onload = () => {
              JA.src = KA, JA.crossOrigin = "anonymous", kA();
            }, Ne.onerror = () => kA(), Ne.src = KA;
          })
        )
      );
    }, rs = (G, O) => {
      const LA = (kA, JA) => {
        if (kA instanceof HTMLElement && JA instanceof HTMLElement) {
          const Ne = window.getComputedStyle(kA);
          JA.style.fontFamily = Ne.fontFamily, JA.style.fontSize = Ne.fontSize, JA.style.fontStyle = Ne.fontStyle, JA.style.fontWeight = Ne.fontWeight, JA.style.letterSpacing = Ne.letterSpacing, JA.style.lineHeight = Ne.lineHeight;
        }
        const Ue = Array.from(kA.children), KA = Array.from(JA.children);
        Ue.forEach((Ne, Wt) => {
          KA[Wt] && LA(Ne, KA[Wt]);
        });
      };
      LA(G, O);
    }, Ma = (G) => {
      G.querySelectorAll("[data-bazi-pdf-hide]").forEach((kA) => {
        kA.remove();
      });
      const O = G.querySelector("[data-bazi-pdf-root]");
      O instanceof HTMLElement && (O.classList.add("bazi-pdf-capture"), Nt.value && rs(Nt.value, O)), G.querySelectorAll("img").forEach((kA) => {
        const JA = kA, Ue = JA.getAttribute("src");
        Ue && (JA.src = Si(Ue), JA.crossOrigin = "anonymous");
      });
      const LA = G.createElement("style");
      LA.textContent = `
[data-bazi-pdf-root].bazi-pdf-capture {
    width: 1200px !important;
    max-width: none !important;
    font-family: 'Costaline', sans-serif !important;
    background: #fcf7f5 !important;
}
.bazi-pdf-capture * {
    animation: none !important;
    transition: none !important;
    font-family: inherit !important;
}
.bazi-pdf-capture .bazi-pdf-banner-image {
    display: block !important;
    height: 30rem !important;
    object-fit: cover !important;
}
.bazi-pdf-capture .bazi-pdf-content-shell {
    width: 100% !important;
    max-width: none !important;
    padding: 0 16px 96px 16px !important;
    position: relative !important;
    z-index: 50 !important;
    margin-top: 0 !important;
}
.bazi-pdf-capture .bazi-pdf-content-border {
    width: auto !important;
    box-sizing: border-box !important;
    padding: 24px !important;
    background-color: #fff !important;
    margin: 0 48px 48px 48px !important;
    position: relative !important;
    top: -120px !important;
    border-radius: 8px !important;
    box-shadow: none !important;
}
.bazi-pdf-capture .bazi-pdf-content-inner {
    padding: 24px !important;
    border-radius: 8px !important;
}
.bazi-pdf-capture .bazi-section-title {
    margin: 0 0 0 12px !important;
    padding: 12px 0 12px 16px !important;
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
}
.bazi-pdf-capture .bazi-section-title::before {
    left: 0 !important;
    top: 50% !important;
    bottom: auto !important;
    height: 16px !important;
    width: 4px !important;
    transform: translateY(-50%) !important;
    border-radius: 9999px !important;
}
.bazi-pdf-capture .gods-grid {
    display: grid !important;
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    gap: 8px !important;
}
.bazi-pdf-capture .god-card {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    height: auto !important;
    min-height: 0 !important;
    aspect-ratio: 3 / 4 !important;
    padding: 24px !important;
    gap: 24px !important;
}
.bazi-pdf-capture .god-card h2 {
    font-size: 16px !important;
    line-height: 1.25 !important;
}
.bazi-pdf-capture .god-card > span:first-of-type {
    display: flex !important;
    flex: 1 !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 18px !important;
}
.bazi-pdf-capture .god-card > span:last-of-type {
    font-size: 12px !important;
}
.bazi-pdf-capture .png-body-text,
.bazi-pdf-capture .png-body-text span,
.bazi-pdf-capture .png-body-text div {
    font-size: 16px !important;
    line-height: 2 !important;
}
`, G.head.appendChild(LA);
    }, ra = async () => {
      if (!Nt.value)
        throw new Error("Bazi page content not found");
      await ts(), await Li(Nt.value);
      const { default: G } = await Promise.resolve().then(() => yV);
      return G(Nt.value, {
        scale: 2,
        useCORS: !0,
        allowTaint: !1,
        logging: !1,
        scrollY: 0,
        scrollX: 0,
        backgroundColor: "#fcf7f5",
        windowWidth: 1200,
        imageTimeout: 15e3,
        letterRendering: !0,
        onclone: Ma
      });
    }, Pa = async (G, O) => {
      const { jsPDF: LA } = await Promise.resolve().then(() => hj), kA = new LA({ unit: "mm", format: "a4", orientation: "portrait" }), JA = 8, Ue = kA.internal.pageSize.getWidth(), KA = kA.internal.pageSize.getHeight(), Ne = Ue - JA * 2, Wt = KA - JA * 2, Dt = G.toDataURL("image/png"), w = G.height * Ne / G.width;
      let L = w, z = JA;
      for (kA.addImage(Dt, "PNG", JA, z, Ne, w), L -= Wt; L > 0; )
        z = JA - (w - L), kA.addPage(), kA.addImage(Dt, "PNG", JA, z, Ne, w), L -= Wt;
      kA.save(O);
    }, ka = async () => {
      if (!(je.value || !jr.value)) {
        je.value = !0;
        try {
          await x1(), await new Promise((LA) => setTimeout(LA, 300));
          const G = (rA.value?.name || pA.name || "bazi").replace(/[^\w\u4e00-\u9fff-]/g, "_"), O = await ra();
          if (!O.width || !O.height)
            throw new Error("Generated canvas is empty");
          await Pa(O, `${G}-element-report.pdf`), fs("PDF downloaded successfully", {
            position: "bottom-right",
            autoClose: 3e3,
            type: "success"
          });
        } catch (G) {
          console.error(G), fs("Failed to generate PDF, please try again", {
            position: "bottom-right",
            autoClose: 3e3,
            type: "error"
          });
        } finally {
          je.value = !1;
        }
      }
    }, _n = () => {
      rA.value?.categoryId && t.push({
        path: "/products",
        query: {
          cate_id: rA.value.categoryId
        }
      });
    };
    A("chinese.bazi.january"), A("chinese.bazi.february"), A("chinese.bazi.march"), A("chinese.bazi.april"), A("chinese.bazi.may"), A("chinese.bazi.june"), A("chinese.bazi.july"), A("chinese.bazi.august"), A("chinese.bazi.september"), A("chinese.bazi.october"), A("chinese.bazi.november"), A("chinese.bazi.december");
    const st = bt(() => {
      if (!rA.value) return null;
      const G = {
        year: rA.value?.ganzhi_year || "",
        month: rA.value?.ganzhi_month || "",
        day: rA.value?.ganzhi_day || "",
        hour: rA.value?.ganzhi_hour || ""
      };
      return {
        heavenlyStems: {
          year: G.year[0] || "",
          month: G.month[0] || "",
          day: G.day[0] || "",
          hour: G.hour[0] || ""
        },
        earthlyBranches: {
          year: G.year[1] || "",
          month: G.month[1] || "",
          day: G.day[1] || "",
          hour: G.hour[1] || ""
        },
        // 计算每个字符对应的颜色
        colors: {
          heavenlyStems: {
            year: me[G.year[0]] || "#000000",
            month: me[G.month[0]] || "#000000",
            day: me[G.day[0]] || "#000000",
            hour: me[G.hour[0]] || "#000000"
          },
          earthlyBranches: {
            year: me[G.year[1]] || "#000000",
            month: me[G.month[1]] || "#000000",
            day: me[G.day[1]] || "#000000",
            hour: me[G.hour[1]] || "#000000"
            // 使用小时数字映射
          }
        }
      };
    }), ns = bt(() => rA.value?.strengths || {}), On = {
      metal: "Metal",
      wood: "Wood",
      water: "Water",
      fire: "Fire",
      earth: "Earth"
    }, Ai = {
      metal: "clarity and refinement",
      wood: "growth and renewal",
      water: "depth and wisdom",
      fire: "warmth and vitality",
      earth: "grounding and stability"
    }, Ka = bt(() => {
      const G = lA.value?.useful_god ?? rA.value?.useful_god, O = lA.value?.joyous_god ?? rA.value?.joyous_god, LA = [G, O].map((Dt) => nA[Dt]).filter((Dt) => !!Dt), kA = [...new Set(LA)];
      if (!kA.length)
        return "Your chart calls for supportive elemental energy. These bracelets were selected to strengthen what your chart needs most and bring your five elements into balance.";
      const JA = kA.map((Dt) => On[Dt]), Ue = kA.map((Dt) => Ai[Dt]), KA = new Intl.ListFormat("en", {
        style: "long",
        type: "conjunction"
      }).format(JA), Ne = new Intl.ListFormat("en", {
        style: "long",
        type: "conjunction"
      }).format(Ue), Wt = kA.length > 1 ? "elements" : "element";
      return `Your chart calls for ${KA} energy - the ${Wt} of ${Ne}. These bracelets were selected to strengthen what your chart needs most and bring your five elements into balance.`;
    }), is = ["wood", "fire", "earth", "metal", "water"], Zr = (G) => typeof G == "string" && is.includes(G), Ss = (G, O) => {
      const LA = [G?.soul_key, O?.soul_key].find(Zr);
      if (LA) return LA;
      const kA = [
        G?.day_master_element,
        G?.soul_element,
        O?.day_master_element,
        O?.soul_element
      ];
      for (const Ue of kA) {
        if (typeof Ue != "string") continue;
        const KA = nA[Ue];
        if (Zr(KA)) return KA;
      }
      const JA = G?.wuxing_day ?? O?.wuxing_day;
      if (typeof JA == "string") {
        const Ue = Array.from(JA)[0], KA = nA[Ue];
        if (Zr(KA)) return KA;
      }
    }, Va = bt(() => {
      const G = lA.value ?? fA(rA.value?.fortune_ba_zi), O = Ss(rA.value, G);
      return O ? UN[O].description : "";
    }), St = bt(() => {
      const G = lA.value?.useful_god ?? rA.value?.useful_god, O = lA.value?.joyous_god ?? rA.value?.joyous_god;
      if (!G || !O) return "";
      const LA = nA[G], kA = nA[O];
      return !LA || !kA ? "" : xN[LA]?.[kA] ?? "";
    }), ss = bt(() => {
      const G = lA.value?.negative_god ?? rA.value?.negative_god, O = lA.value?.adversarial_god ?? rA.value?.adversarial_god;
      if (!G || !O) return "";
      const LA = nA[G], kA = nA[O];
      return !LA || !kA ? "" : EN[LA]?.[kA] ?? "";
    }), qr = bt(() => {
      const G = lA.value?.useful_god ?? rA.value?.useful_god, O = lA.value?.joyous_god ?? rA.value?.joyous_god;
      if (!G || !O) return "";
      const LA = nA[G], kA = nA[O];
      return !LA || !kA ? "" : SN[LA]?.[kA] ?? "";
    }), Nn = bt(() => {
      const G = lA.value?.useful_god ?? rA.value?.useful_god, O = lA.value?.joyous_god ?? rA.value?.joyous_god;
      if (!G || !O) return "";
      const LA = nA[G], kA = nA[O];
      return !LA || !kA ? "" : `${On[LA]} and ${On[kA]}`;
    }), Dn = bt(() => {
      const G = lA.value?.useful_god ?? rA.value?.useful_god, O = lA.value?.joyous_god ?? rA.value?.joyous_god;
      if (!G || !O) return;
      const LA = nA[G], kA = nA[O];
      if (!(!LA || !kA))
        return IN[LA]?.[kA];
    }), hr = bt(() => [
      { role: "useful", chinese: lA.value?.useful_god ?? rA.value?.useful_god },
      { role: "joyous", chinese: lA.value?.joyous_god ?? rA.value?.joyous_god },
      { role: "negative", chinese: lA.value?.negative_god ?? rA.value?.negative_god },
      { role: "adversarial", chinese: lA.value?.adversarial_god ?? rA.value?.adversarial_god },
      { role: "neutral", chinese: lA.value?.neutral_god ?? rA.value?.neutral_god }
    ].find((O) => O.chinese === "火")?.role), Tr = bt(() => {
      const G = hr.value;
      return G ? `${yB.intro} ${yB.fireByRole[G]}` : yB.intro;
    }), Rn = bt(() => {
      const G = lA.value?.useful_god ?? rA.value?.useful_god, O = lA.value?.joyous_god ?? rA.value?.joyous_god;
      if (!G || !O) return "";
      const LA = nA[G], kA = nA[O];
      return !LA || !kA ? "" : LN[LA]?.[kA] ?? "";
    }), Lt = bt(() => {
      const G = Object.values(ns.value);
      return Math.max(...G, 5);
    }), Ga = (G) => Array.from({ length: G }, (O, LA) => LA + 1), Wa = () => {
      const kA = [];
      for (let JA = 0; JA < 5; JA++) {
        const Ue = (JA * 72 - 90) * Math.PI / 180, KA = 100 + 75 * Math.cos(Ue), Ne = 100 + 75 * Math.sin(Ue);
        kA.push(`${KA},${Ne}`);
      }
      return kA.join(" ");
    }, ja = () => ["金", "木", "水", "火", "土"].map((Ue, KA) => {
      const Ne = ns.value[Ue] / 2 || 0, Dt = (Lt.value > 0 ? Ne / Lt.value : 0) * 70 + 5, w = (KA * 72 - 90) * Math.PI / 180, L = 100 + Dt * Math.cos(w), z = 100 + Dt * Math.sin(w);
      return `${L},${z}`;
    }).join(" "), qa = () => {
      for (const G in pA)
        pA[G] = "";
    }, Mn = async () => {
      fn.value = !0, Ya(), await N.clearBaziInfo(), Ae.value = !1, An.value = !1, fi.value = !1, wA.value = !1, $.value = null, Hi.value = !1, PA.value = !1, Qe.value = void 0, Je.value = 0, _r.value = !1, dn.value = "", zA.value = 0, await N.clearBaziFormData(), rA.value = {}, EA.value = void 0, lA.value = void 0, r.value = [], SA.value = [], HA.value = !1, qa(), yN(), await x1(), document.getElementById("bazi-select")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, Hi = /* @__PURE__ */ We(!1), fi = /* @__PURE__ */ We(!1), An = /* @__PURE__ */ We(!1), fn = /* @__PURE__ */ We(!1), _r = /* @__PURE__ */ We(!1), dn = /* @__PURE__ */ We(""), Pn = bt(() => N.baziReportDetail), zA = /* @__PURE__ */ We(0), $ = /* @__PURE__ */ We(), wA = /* @__PURE__ */ We(!1), PA = /* @__PURE__ */ We(!1), Ae = /* @__PURE__ */ We(!1), GA = () => {
      fn.value = !0, fi.value = !1, wA.value = !1, $.value = null, Ae.value = !1, An.value = !1, Hi.value = !1, PA.value = !1, Qe.value = void 0, Je.value = 0;
    }, Qe = /* @__PURE__ */ We(), Je = /* @__PURE__ */ We(0), ot = /* @__PURE__ */ We(), rr = async (G = !1) => {
      if (!An.value && !_r.value) {
        fn.value = !1, dn.value = "";
        try {
          An.value = !0, _r.value = !0;
          const { data: O } = await V(Q()), LA = Number(O?.reportId || O?.id || 0);
          if (!LA)
            throw new Error("No report id returned from create report task");
          N.setBaziReportId(LA), zA.value = O?.status || 0, Xa(LA), Bt(O?.openid);
        } catch (O) {
          _r.value = !1, An.value = !1, console.error("Payment error:", O), fs("Unable to create your report. Please try again.", {
            type: "error",
            position: "bottom-right"
          });
        } finally {
          An.value = !1;
        }
      }
    }, Fr = (G) => fA(G), kn = (G) => {
      if (!G) return;
      N.setBaziReportDetail(G), EA.value = G;
      const O = Fr(G.fortune_ba_zi);
      lA.value = O, rA.value = G, O && (rA.value = { ...rA.value, ...O }, rA.value.name = rA.value?.user_name || "", rA.value.year = O.gregorian_year || "", rA.value.month = O.gregorian_month || "", rA.value.day = O.gregorian_day || "", rA.value.hour = O.gregorian_hour || "");
    };
    let et = !1, Ls = 0;
    const $a = (G, O, LA) => {
      _r.value = !1, dn.value = LA ? G : "", console.error(G, O), fs(G, {
        type: "error",
        position: "bottom-right"
      });
    }, na = (G) => `meta:${bB}:${G}`, za = (G) => {
      try {
        return window.localStorage.getItem(na(G)) === "1";
      } catch {
        return !1;
      }
    }, Ti = (G) => {
      const O = G?.meta_conversion, LA = O?.event_id;
      if (!(G?.status !== 1 || O?.event_name !== bB || O.status !== "eligible" || O.eligible !== !0 || !LA || za(LA)) && typeof window.fbq == "function") {
        window.fbq(
          "trackCustom",
          bB,
          {
            content_name: "八字测算",
            fortune_type: "bazi"
          },
          { eventID: LA }
        );
        try {
          window.localStorage.setItem(na(LA), "1");
        } catch {
        }
      }
    }, ia = QN({
      intervalMs: 3e3,
      requestTimeoutMs: 15e3,
      maxAttempts: 10,
      request: (G, O) => M(G, O),
      isComplete: (G) => {
        const O = G.data?.info;
        if (O?.status !== 1 || O.meta_conversion?.status === "pending") return !1;
        const LA = O.meta_conversion;
        return !(LA?.status === "eligible" && LA.eligible === !0 && LA.event_id && !za(LA.event_id) && typeof window.fbq != "function");
      },
      onComplete: (G, O) => {
        if (!et || Number(N.getBaziReportId) !== O.input) return;
        const LA = G.data?.info;
        Ti(LA), kn(LA), _r.value = !1, dn.value = "", zA.value = LA?.status || 0, Hr().catch((kA) => {
          console.error("Failed to load recommended products for report:", kA);
        });
      },
      onError: (G, O) => {
        if (!et || fn.value) return;
        const LA = "Unable to refresh your report. Retry now or wait for another attempt.";
        _r.value = !1, dn.value = LA, console.error(`Failed to fetch Bazi report ${O.input}, attempt ${O.attempt}:`, G), Ls !== O.generation && (Ls = O.generation, fs(LA, {
          type: "error",
          position: "bottom-right"
        }));
      },
      onExhausted: (G) => {
        !et || Number(N.getBaziReportId) !== G.input || $a("Your report is taking longer than expected. Please retry.", void 0, !0);
      }
    }), Xa = (G) => {
      !Number.isFinite(G) || G <= 0 || (N.setBaziReportId(G), _r.value = !0, dn.value = "", Ls = 0, ia.start(G));
    }, $o = () => {
      ia.stop();
    }, Hs = () => {
      const G = Number(N.getBaziReportId || d.value || 0);
      if (!G) {
        $a("No report is available to retry.", void 0, !1);
        return;
      }
      Xa(G);
    }, Ya = () => {
      $o(), _r.value = !1;
    }, sa = async () => {
      if (h() !== 0)
        try {
          const { data: G } = await T();
          if (!et || fn.value) return;
          const O = G?.list?.[0], LA = Number(O?.id || 0);
          if (!LA) return;
          Xa(LA);
        } catch (G) {
          et && !fn.value && $a("Unable to load your previous reports. Please try again.", G, !1);
        }
    }, zo = () => {
      navigator.clipboard.writeText(
        `I thought you'd appreciate Leymen — refined crystal bracelets crafted to match your Five Elements profile. The profiles are personal, beautifully interpreted, and surprisingly accurate. Explore your own profile here: https://www.leymenjewels.com/?invite=${N.userInfo.invite_code}`
      ).then(() => {
        fs("Your invite link has been copied to the clipboard", {
          type: "success",
          position: "bottom-right"
        });
      }).catch((G) => {
      });
    }, aa = () => {
      sA(U.value);
    };
    return N.getBaziFormData && (pA = Object.assign(pA, N.getBaziFormData)), ug(() => {
      et = !0, B.value = p(), console.log("Component mounted, resetting shouldStopPolling to false"), fn.value = !1, document.addEventListener("click", X), window.addEventListener("resize", aa);
      const G = Number(d.value || 0);
      G ? Xa(G) : window.location.hash !== "#bazi-select" && sa();
    }), by(() => {
      et = !1, Ya(), fn.value = !0, wA.value = !1, $.value = null, document.removeEventListener("click", X), window.removeEventListener("resize", aa);
    }), (G, O) => {
      const LA = Df("CommonSelect"), kA = Df("Icon"), JA = Df("HomeGoodsItem"), Ue = Df("NuxtLink");
      return Ee(), Le("div", {
        ref_key: "baziPageRef",
        ref: Nt,
        "data-bazi-pdf-root": "",
        class: "flex-1 flex flex-col text-[#5A392D]/90"
      }, [
        eA("div", NN, [
          eA("img", {
            src: lt(po)("banner"),
            alt: "banner",
            draggable: !1,
            class: "bazi-pdf-banner-image w-full object-cover h-88 md:h-118"
          }, null, 8, DN),
          eA("div", RN, [
            eA("div", MN, [
              eA("div", PN, [
                O[26] || (O[26] = eA("div", { class: "text-lg sm:text-xl md:text-3xl font-bold container mx-auto text-center" }, [
                  eA("span", { class: "uppercase leading-tight w-full sm:leading-14 tracking-[4px] md:lg:text-nowrap" }, "Discover Your Elemental Blueprint")
                ], -1)),
                !jr.value && !HA.value ? (Ee(), Le("p", kN, " Bazi is a 3,000-year-old Chinese system that maps the elemental energy written into your birth date. The free reading reveals your personal elemental chart and the specific element your energy is calling for. ")) : $t("", !0)
              ])
            ]),
            O[27] || (O[27] = eA("div", { class: "absolute top-0 left-0 bg-gradient-to-t from-white/50 to-transparent" }, null, -1))
          ])
        ]),
        eA("div", KN, [
          eA("div", VN, [
            eA("div", GN, [
              nt(Fu, null, {
                default: Fa(() => [
                  !jr.value && !HA.value ? (Ee(), Le("div", WN, [
                    SA.value.length > 0 ? (Ee(), Le("div", jN, [
                      eA("div", qN, [
                        eA("div", $N, [
                          O[29] || (O[29] = eA("div", { class: "flex-shrink-0" }, [
                            eA("svg", {
                              class: "h-5 w-5 text-red-400",
                              viewBox: "0 0 20 20",
                              fill: "currentColor"
                            }, [
                              eA("path", {
                                "fill-rule": "evenodd",
                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                "clip-rule": "evenodd"
                              })
                            ])
                          ], -1)),
                          eA("div", zN, [
                            O[28] || (O[28] = eA("h3", { class: "text-sm font-medium text-red-800" }, "Form Validation Error", -1)),
                            eA("div", XN, [
                              eA("ul", YN, [
                                (Ee(!0), Le(Xt, null, Wu(SA.value, (KA) => (Ee(), Le("li", { key: KA }, ye(KA), 1))), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])) : $t("", !0),
                    eA("form", {
                      onSubmit: vB(ae, ["prevent"]),
                      id: "bazi-select",
                      novalidate: "",
                      class: "gap-4 flex flex-col flex-1 w-full"
                    }, [
                      eA("div", JN, [
                        O[30] || (O[30] = eA("span", null, "Name", -1)),
                        lo(eA("input", {
                          type: "text",
                          "onUpdate:modelValue": O[0] || (O[0] = (KA) => lt(pA).name = KA),
                          class: "flex items-center focus:outline-none justify-between p-3 border border-[#CCB9B2]",
                          placeholder: "Enter Name"
                        }, null, 512), [
                          [Uu, lt(pA).name]
                        ])
                      ]),
                      B.value ? $t("", !0) : (Ee(), Le("div", ZN, [
                        O[31] || (O[31] = eA("span", { class: "text-sm sm:text-base" }, [
                          eA("span", { class: "text-red-500" }, "*"),
                          Ci(" Email ")
                        ], -1)),
                        lo(eA("input", {
                          "onUpdate:modelValue": O[1] || (O[1] = (KA) => lt(pA).email = KA),
                          type: "email",
                          autocomplete: "email",
                          required: "",
                          class: "flex items-center focus:outline-none justify-between p-3 border border-[#CCB9B2]",
                          placeholder: "Enter Email"
                        }, null, 512), [
                          [
                            Uu,
                            lt(pA).email,
                            void 0,
                            { trim: !0 }
                          ]
                        ])
                      ])),
                      eA("div", AD, [
                        O[32] || (O[32] = eA("span", null, "Gender", -1)),
                        nt(LA, {
                          modelValue: lt(pA).gender,
                          "onUpdate:modelValue": O[2] || (O[2] = (KA) => lt(pA).gender = KA),
                          options: WA,
                          placeholder: "Select Gender",
                          "is-open": o.value === "gender",
                          onToggleDropdown: O[3] || (O[3] = (KA) => k("gender"))
                        }, null, 8, ["modelValue", "is-open"])
                      ]),
                      eA("div", eD, [
                        O[33] || (O[33] = eA("span", { class: "text-sm sm:text-base" }, [
                          eA("span", { class: "text-red-500" }, "*"),
                          Ci(" Birth Date ")
                        ], -1)),
                        eA("div", tD, [
                          nt(LA, {
                            class: "w-full",
                            modelValue: lt(pA).year,
                            "onUpdate:modelValue": O[4] || (O[4] = (KA) => lt(pA).year = KA),
                            options: lt(a),
                            placeholder: "Year",
                            "is-open": o.value === "year",
                            onToggleDropdown: O[5] || (O[5] = (KA) => k("year")),
                            required: ""
                          }, null, 8, ["modelValue", "options", "is-open"]),
                          nt(LA, {
                            class: "w-full",
                            modelValue: lt(pA).month,
                            "onUpdate:modelValue": O[6] || (O[6] = (KA) => lt(pA).month = KA),
                            options: lt(xA),
                            placeholder: "Month",
                            "is-open": o.value === "month",
                            onToggleDropdown: O[7] || (O[7] = (KA) => k("month")),
                            required: ""
                          }, null, 8, ["modelValue", "options", "is-open"]),
                          nt(LA, {
                            class: "w-full",
                            modelValue: lt(pA).day,
                            "onUpdate:modelValue": O[8] || (O[8] = (KA) => lt(pA).day = KA),
                            options: oA.value,
                            placeholder: "Day",
                            "is-open": o.value === "day",
                            onToggleDropdown: O[9] || (O[9] = (KA) => k("day")),
                            required: ""
                          }, null, 8, ["modelValue", "options", "is-open"])
                        ])
                      ]),
                      eA("div", rD, [
                        O[34] || (O[34] = eA("span", null, "Time Of Birth", -1)),
                        nt(LA, {
                          modelValue: lt(pA).time,
                          "onUpdate:modelValue": O[10] || (O[10] = (KA) => lt(pA).time = KA),
                          options: lt(IA),
                          placeholder: "Select Time",
                          "is-open": o.value === "time",
                          onToggleDropdown: O[11] || (O[11] = (KA) => k("time")),
                          required: ""
                        }, null, 8, ["modelValue", "options", "is-open"])
                      ]),
                      O[35] || (O[35] = eA("div", { class: "flex justify-center pt-4 sm:pt-6" }, [
                        eA("button", {
                          type: "submit",
                          class: "bg-[#F0E5CF] hover:bg-[#F0E5CF]/80 p-3 sm:p-4 min-w-48 w-full sm:w-auto uppercase rounded-sm text-[#936333]/90 tracking-widest cursor-pointer active:bg-[#F0E5CF]/60 transition-colors duration-200 text-sm sm:text-base font-semibold",
                          key: "submit"
                        }, [
                          eA("span", null, "READ MY BLUEPRINT")
                        ])
                      ], -1))
                    ], 32)
                  ])) : $t("", !0)
                ]),
                _: 1
              }),
              nt(Fu, null, {
                default: Fa(() => [
                  HA.value ? (Ee(), Le("div", nD, [...O[36] || (O[36] = [
                    eA("div", {
                      class: "bazi-yin-yang-loader",
                      role: "status",
                      "aria-label": "Calculating Bazi chart"
                    }, [
                      eA("span", {
                        class: "bazi-yin-yang-part",
                        "aria-hidden": "true"
                      }),
                      eA("span", {
                        class: "bazi-yin-yang-part",
                        "aria-hidden": "true"
                      }),
                      eA("span", {
                        class: "bazi-yin-yang-part",
                        "aria-hidden": "true"
                      }),
                      eA("span", {
                        class: "bazi-yin-yang-part",
                        "aria-hidden": "true"
                      }),
                      eA("span", {
                        class: "bazi-yin-yang-part",
                        "aria-hidden": "true"
                      }),
                      eA("span", {
                        class: "bazi-yin-yang-part",
                        "aria-hidden": "true"
                      })
                    ], -1)
                  ])])) : $t("", !0)
                ]),
                _: 1
              }),
              nt(Fu, { name: "fade" }, {
                default: Fa(() => [
                  jr.value && !HA.value ? (Ee(), Le("div", iD, [
                    eA("div", sD, [
                      eA("div", aD, [
                        eA("div", oD, [
                          eA("div", lD, [
                            eA("div", cD, [
                              O[37] || (O[37] = eA("div", { class: "flex items-center justify-end" }, [
                                eA("span", { class: "text-end" }, "Name：")
                              ], -1)),
                              eA("div", uD, [
                                eA("span", null, ye(rA.value?.name || "--"), 1)
                              ])
                            ]),
                            eA("div", hD, [
                              O[38] || (O[38] = eA("div", { class: "flex items-center justify-end" }, [
                                eA("span", { class: "text-end" }, "Gender：")
                              ], -1)),
                              eA("div", fD, [
                                eA("span", null, ye(rA.value?.gender || "--"), 1)
                              ])
                            ])
                          ]),
                          eA("div", dD, [
                            eA("div", gD, [
                              O[39] || (O[39] = eA("div", { class: "flex items-center md:lg:justify-end" }, [
                                eA("span", { class: "md:lg:text-end" }, "Birth Date：")
                              ], -1)),
                              eA("div", pD, [
                                eA("span", null, ye(rA.value?.year && rA.value?.month && rA.value?.day ? `${rA.value.year}-${String(rA.value.month).padStart(
                                  2,
                                  "0"
                                )}-${String(rA.value.day).padStart(2, "0")} ${rA.value.time ? `${rA.value.time}:00` : "12:00"}` : "--"), 1)
                              ])
                            ]),
                            eA("div", BD, [
                              eA("div", wD, [
                                eA("span", null, "农历 " + ye(rA.value?.lunar_year_chinese) + "年" + ye(rA.value?.lunar_month_chinese) + ye(rA.value?.lunar_day_chinese) + " " + ye(rA.value?.lunar_hour_chinese), 1)
                              ])
                            ])
                          ]),
                          eA("div", mD, [
                            eA("div", vD, [
                              O[40] || (O[40] = eA("div", { class: "flex items-center justify-end md:text-end" }, [
                                eA("span", null, "Seasonal Info：")
                              ], -1)),
                              eA("div", yD, [
                                eA("span", null, ye(rA.value?.previous_date == rA.value?.next_date ? rA.value?.previous_date || "--" : `${rA.value?.previous_date} - ${rA.value?.next_date}` || "--"), 1)
                              ])
                            ]),
                            eA("div", CD, [
                              eA("span", null, ye(rA.value?.previous_term == rA.value?.next_term ? rA.value?.previous_term || "--" : `${G.$t(rA.value?.previous_term)} - ${G.$t(rA.value?.next_term)}` || "--"), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    O[75] || (O[75] = eA("div", { class: "w-full" }, [
                      eA("h2", { class: "bazi-section-title ml-3 relative pl-3 sm:pl-4 text-sm before:content-[''] before:absolute before:left-0 before:bottom-1/2 before:translate-y-1/3 before:bg-[#D59F69] before:h-3 sm:before:h-4 before:w-1 before:rounded-full uppercase font-bold" }, " YOUR ELEMENTAL SNAPSHOT ")
                    ], -1)),
                    eA("div", bD, [
                      eA("span", FD, ye(Va.value) + " " + ye(ss.value), 1),
                      eA("div", QD, " What you need most: " + ye(St.value), 1)
                    ]),
                    eA("div", UD, [
                      eA("table", ED, [
                        eA("thead", xD, [
                          eA("tr", null, [
                            eA("th", ID, [
                              eA("img", {
                                src: lt(po)("fish"),
                                alt: "logo",
                                class: "w-8 h-8 flex-shrink-0 object-cover"
                              }, null, 8, SD)
                            ]),
                            O[41] || (O[41] = eA("th", { class: "bazi-table-th text-sm" }, "Year Pillar(年柱)", -1)),
                            O[42] || (O[42] = eA("th", { class: "bazi-table-th text-sm" }, "Month Pillar(月柱)", -1)),
                            O[43] || (O[43] = eA("th", { class: "bazi-table-th text-sm" }, "Day Pillar(日柱)", -1)),
                            O[44] || (O[44] = eA("th", { class: "bazi-table-th text-sm" }, "Hour Pillar(时柱)", -1))
                          ])
                        ]),
                        eA("tbody", null, [
                          eA("tr", null, [
                            O[45] || (O[45] = eA("td", { class: "bazi-table-td-label text-[0.7em]" }, "Heavenly Stems(天干)", -1)),
                            eA("td", {
                              class: "bazi-table-td-char",
                              style: zt({ color: st.value?.colors.heavenlyStems.year || "#000000" })
                            }, ye(G.$t(st.value?.heavenlyStems.year) || ""), 5),
                            eA("td", {
                              class: "bazi-table-td-char",
                              style: zt({ color: st.value?.colors.heavenlyStems.month || "#000000" })
                            }, ye(G.$t(st.value?.heavenlyStems.month) || ""), 5),
                            eA("td", {
                              class: "bazi-table-td-char",
                              style: zt({ color: st.value?.colors.heavenlyStems.day || "#000000" })
                            }, ye(G.$t(st.value?.heavenlyStems.day) || ""), 5),
                            eA("td", {
                              class: "bazi-table-td-char",
                              style: zt({ color: st.value?.colors.heavenlyStems.hour || "#000000" })
                            }, ye(G.$t(st.value?.heavenlyStems.hour) || ""), 5)
                          ]),
                          eA("tr", null, [
                            O[46] || (O[46] = eA("td", { class: "bazi-table-td-label text-[0.7em]" }, "Earthly Branches(地支)", -1)),
                            eA("td", {
                              class: "bazi-table-td-char",
                              style: zt({ color: st.value?.colors.earthlyBranches.year || "#000000" })
                            }, ye(G.$t(st.value?.earthlyBranches.year) || ""), 5),
                            eA("td", {
                              class: "bazi-table-td-char",
                              style: zt({ color: st.value?.colors.earthlyBranches.month || "#000000" })
                            }, ye(G.$t(st.value?.earthlyBranches.month) || ""), 5),
                            eA("td", {
                              class: "bazi-table-td-char",
                              style: zt({ color: st.value?.colors.earthlyBranches.day || "#000000" })
                            }, ye(G.$t(st.value?.earthlyBranches.day) || ""), 5),
                            eA("td", {
                              class: "bazi-table-td-char",
                              style: zt({ color: st.value?.colors.earthlyBranches.hour || "#000000" })
                            }, ye(G.$t(st.value?.earthlyBranches.hour) || ""), 5)
                          ])
                        ])
                      ])
                    ]),
                    O[76] || (O[76] = eA("div", { class: "w-full" }, [
                      eA("h2", { class: "bazi-section-title ml-3 relative pl-3 sm:pl-4 text-sm before:content-[''] before:absolute before:left-0 before:bottom-1/2 before:translate-y-1/3 before:bg-[#D59F69] before:h-3 sm:before:h-4 before:w-1 before:rounded-full uppercase font-bold" }, " Five Elements Energy ")
                    ], -1)),
                    eA("div", LD, [
                      eA("div", HD, [
                        eA("div", TD, [
                          eA("div", _D, [
                            (Ee(), Le(Xt, null, Wu(vA, (KA, Ne) => (Ee(), Le(Xt, {
                              key: KA.key
                            }, [
                              eA("div", OD, [
                                eA("img", {
                                  src: lt(po)(`wuxing-${KA.key}`),
                                  alt: KA.key,
                                  class: "wuxing-stat-icon w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0"
                                }, null, 8, ND),
                                eA("span", {
                                  class: "wuxing-stat-label text-xs md:text-base whitespace-nowrap",
                                  style: zt({ color: KA.color })
                                }, ye(G.$t(`chinese.bazi.element${KA.name}`)), 5)
                              ]),
                              eA("div", DD, [
                                (Ee(!0), Le(Xt, null, Wu(Ga(
                                  ns.value[KA.chinese]
                                ), (Wt) => (Ee(), Le("div", {
                                  key: `${KA.key}-${Wt}`,
                                  class: "wuxing-stat-dot wuxing-stat-dot-mobile",
                                  style: zt({
                                    backgroundColor: KA.color,
                                    borderColor: KA.color
                                  })
                                }, null, 4))), 128))
                              ])
                            ], 64))), 64))
                          ])
                        ]),
                        eA("div", RD, [
                          eA("div", MD, [
                            (Ee(), Le("svg", PD, [
                              eA("polygon", {
                                points: Wa(),
                                fill: "none",
                                stroke: "#D6BB86",
                                "stroke-width": "1",
                                opacity: "0.3"
                              }, null, 8, kD),
                              eA("polygon", {
                                points: ja(),
                                fill: "#F0E5CF",
                                stroke: "#D59F69",
                                "stroke-width": "2",
                                opacity: "0.8"
                              }, null, 8, KD),
                              O[47] || (O[47] = eA("text", {
                                x: "100",
                                y: "15",
                                "text-anchor": "middle",
                                "dominant-baseline": "middle",
                                class: "text-xs md:text-sm fill-[#AABAD2] font-semibold"
                              }, " Metal ", -1)),
                              O[48] || (O[48] = eA("text", {
                                x: "180",
                                y: "85",
                                "text-anchor": "middle",
                                "dominant-baseline": "middle",
                                class: "text-xs md:text-sm fill-[#16892D] font-semibold"
                              }, " Wood ", -1)),
                              O[49] || (O[49] = eA("text", {
                                x: "145",
                                y: "190",
                                "text-anchor": "middle",
                                "dominant-baseline": "middle",
                                class: "text-xs md:text-sm fill-[#319BFF] font-semibold"
                              }, " Water ", -1)),
                              O[50] || (O[50] = eA("text", {
                                x: "55",
                                y: "190",
                                "text-anchor": "middle",
                                "dominant-baseline": "middle",
                                class: "text-xs md:text-sm fill-[#FF2615] font-semibold"
                              }, " Fire ", -1)),
                              O[51] || (O[51] = eA("text", {
                                x: "20",
                                y: "85",
                                "text-anchor": "middle",
                                "dominant-baseline": "middle",
                                class: "text-xs md:text-sm fill-[#A3751A] font-semibold"
                              }, " Earth ", -1))
                            ]))
                          ])
                        ])
                      ])
                    ]),
                    eA("div", VD, [
                      O[53] || (O[53] = eA("h2", { class: "bazi-section-title ml-3 relative pl-3 sm:pl-4 text-sm before:content-[''] before:absolute before:left-0 before:bottom-1/2 before:translate-y-1/3 before:bg-[#D59F69] before:h-3 sm:before:h-4 before:w-1 before:rounded-full uppercase font-bold" }, " YOUR ELEMENTAL ALLIES ", -1)),
                      eA("div", GD, [
                        eA("button", {
                          type: "button",
                          "aria-label": "Learn about elemental allies",
                          "aria-expanded": c.value,
                          "aria-controls": "bazi-elemental-allies-tooltip",
                          onClick: S,
                          onMouseenter: Y,
                          onMouseleave: AA,
                          class: "cursor-pointer"
                        }, [
                          nt(kA, {
                            name: "mynaui:question-circle",
                            size: "24",
                            class: "cursor-pointer"
                          })
                        ], 40, WD),
                        eA("div", {
                          id: "bazi-elemental-allies-tooltip",
                          role: "tooltip",
                          class: ks(["absolute md:right-1/2 -translate-x-1/2 md:translate-x-1/2 top-full p-3 sm:p-4 md:p-6 text-black/90 bg-white rounded-sm text-sm shadow-md z-50 transition-all duration-200", [c.value ? "block" : "hidden"]]),
                          style: {
                            width: "min(calc(100vw - 2rem), 18rem)",
                            maxWidth: "calc(100vw - 2rem)",
                            marginTop: "0.5rem"
                          },
                          onMouseenter: Y,
                          onMouseleave: AA
                        }, [...O[52] || (O[52] = [
                          eA("span", { class: "text-xs sm:text-sm leading-relaxed" }, "The Five Elements represent the harmony of nature within you — Metal, Wood, Water, Fire, and Earth. Each holds a distinct energy that must remain in balance. Through professional calculation, we determine which element brings support and equilibrium to your chart. For example, when Wood is overly strong, Metal restores structure and clarity; when Wood is weak, Water nourishes growth. This understanding guides us in selecting the elements that help you return to balance — where energy flows with ease, and life moves in harmony.", -1)
                        ])], 34)
                      ])
                    ]),
                    eA("div", jD, [
                      eA("div", qD, [
                        eA("div", $D, [
                          eA("div", {
                            onClick: O[12] || (O[12] = (KA) => uA("useful")),
                            class: "god-card h-20 sm:h-24 md:aspect-[3/4] md:h-full rounded-sm p-2 py-3 sm:p-4 md:p-6 flex flex-col justify-center items-center gap-2 sm:gap-3 md:gap-6 cursor-pointer transition-all duration-200",
                            style: zt(dA[rA.value?.useful_god])
                          }, [
                            eA("h2", {
                              class: ks(["font-bold uppercase text-center w-full text-xs md:text-base leading-tight", { "text-[12px]!": lt(iA) === "en" }])
                            }, " Useful God ", 2),
                            eA("span", {
                              class: "text-sm sm:text-base md:text-lg font-bold uppercase flex-1 flex items-center justify-center leading-tight",
                              style: zt({ color: E[rA.value?.useful_god] })
                            }, ye(G.$t(rA.value?.useful_god)), 5),
                            O[54] || (O[54] = eA("span", { class: "text-[#EC652E] text-[9px] sm:text-xs md:text-xs font-bold uppercase italic text-center leading-tight" }, "Most Restorative", -1))
                          ], 4),
                          eA("div", {
                            onClick: O[13] || (O[13] = (KA) => uA("joyous")),
                            class: "god-card h-20 sm:h-24 md:aspect-[3/4] md:h-full rounded-sm p-2 py-3 sm:p-4 md:p-6 flex flex-col justify-center items-center gap-2 sm:gap-3 md:gap-6 cursor-pointer transition-all duration-200",
                            style: zt(dA[rA.value?.joyous_god])
                          }, [
                            eA("h2", {
                              class: ks(["font-bold uppercase text-center w-full text-xs md:text-base leading-tight", { "text-[12px]!": lt(iA) === "en" }])
                            }, " Joyous God ", 2),
                            eA("span", {
                              class: "text-sm sm:text-base md:text-base font-bold uppercase flex-1 flex items-center justify-center leading-tight",
                              style: zt({ color: E[rA.value?.joyous_god] })
                            }, ye(G.$t(rA.value?.joyous_god)), 5),
                            O[55] || (O[55] = eA("span", { class: "text-[#EC652E] text-[9px] sm:text-xs md:text-xs font-bold uppercase italic text-center leading-tight" }, "Supportive", -1))
                          ], 4),
                          eA("div", {
                            onClick: O[14] || (O[14] = (KA) => uA("negative")),
                            class: "god-card h-20 sm:h-24 md:aspect-[3/4] md:h-full rounded-sm p-2 py-3 sm:p-4 md:p-6 flex flex-col justify-center items-center gap-2 sm:gap-3 md:gap-6 cursor-pointer transition-all duration-200",
                            style: zt(dA[rA.value?.negative_god])
                          }, [
                            eA("h2", {
                              class: ks([{ "text-[12px]!": lt(iA) === "en" }, "font-bold text-[10px] text-xs md:text-base uppercase text-center w-full leading-tight"])
                            }, " Negative God ", 2),
                            eA("span", {
                              class: "text-sm sm:text-base md:text-base font-bold uppercase flex-1 flex items-center justify-center leading-tight",
                              style: zt({ color: E[rA.value?.negative_god] })
                            }, ye(G.$t(rA.value?.negative_god)), 5),
                            O[56] || (O[56] = eA("span", { class: "text-[#EC652E] text-[9px] sm:text-xs md:text-xs font-bold uppercase italic text-center leading-tight" }, "Overactive", -1))
                          ], 4),
                          eA("div", {
                            onClick: O[15] || (O[15] = (KA) => uA("adversarial")),
                            class: "god-card h-20 sm:h-24 md:aspect-[3/4] md:h-full rounded-sm p-2 py-3 sm:p-4 md:p-6 flex flex-col justify-center items-center gap-2 sm:gap-3 md:gap-6 cursor-pointer transition-all duration-200",
                            style: zt(dA[rA.value?.adversarial_god])
                          }, [
                            eA("h2", {
                              class: ks([{ "text-[12px]!": lt(iA) === "en" }, "font-bold text-xs md:text-base uppercase text-center w-full leading-tight"])
                            }, " Adversarial God ", 2),
                            eA("span", {
                              class: "text-sm sm:text-base md:text-base font-bold uppercase flex-1 flex items-center justify-center leading-tight",
                              style: zt({ color: E[rA.value?.adversarial_god] })
                            }, ye(G.$t(rA.value?.adversarial_god)), 5),
                            O[57] || (O[57] = eA("span", { class: "text-[#EC652E] text-[9px] sm:text-xs md:text-xs font-bold uppercase italic text-center leading-tight" }, "Dispersing ", -1))
                          ], 4),
                          eA("div", {
                            onClick: O[16] || (O[16] = (KA) => uA("neutral")),
                            class: "god-card h-20 sm:h-24 md:aspect-[3/4] md:h-full rounded-sm p-2 py-3 sm:p-4 md:p-6 flex flex-col justify-center items-center gap-2 sm:gap-3 md:gap-6 cursor-pointer transition-all duration-200",
                            style: zt(dA[rA.value?.neutral_god])
                          }, [
                            eA("h2", {
                              class: ks([{ "text-[12px]!": lt(iA) === "en" }, "font-bold text-[10px] text-xs md:text-base uppercase text-center w-full leading-tight"])
                            }, " Neutral God ", 2),
                            eA("span", {
                              class: "text-sm sm:text-base md:text-base font-bold uppercase flex-1 flex items-center justify-center leading-tight",
                              style: zt({ color: E[rA.value?.neutral_god] })
                            }, ye(G.$t(rA.value?.neutral_god)), 5),
                            O[58] || (O[58] = eA("span", { class: "text-[#EC652E] text-[9px] sm:text-xs md:text-xs font-bold uppercase italic text-center leading-tight" }, "Neutral Influence", -1))
                          ], 4)
                        ]),
                        eA("div", zD, [
                          O[59] || (O[59] = eA("div", { class: "text-xs md:text-base" }, " What does this mean? Your chart reveals which elemental energies support your path and which create friction. ", -1)),
                          eA("div", XD, ye(Dn.value?.body), 1),
                          eA("div", YD, ye(Dn.value?.invitation), 1),
                          qr.value && Nn.value ? (Ee(), Le("section", JD, [
                            eA("h2", ZD, "Nature of " + ye(Nn.value), 1),
                            eA("p", A8, ye(qr.value), 1)
                          ])) : $t("", !0)
                        ]),
                        $t("", !0)
                      ])
                    ]),
                    O[77] || (O[77] = eA("div", { class: "w-full" }, [
                      eA("h2", { class: "bazi-section-title ml-3 relative pl-3 sm:pl-4 text-sm before:content-[''] before:absolute before:left-0 before:bottom-1/2 before:translate-y-1/3 before:bg-[#D59F69] before:h-3 sm:before:h-4 before:w-1 before:rounded-full uppercase font-bold" }, " Your Elemental Reading ")
                    ], -1)),
                    eA("div", e8, [
                      !Pn.value.id && !d.value ? (Ee(), Le("div", t8, [
                        O[65] || (O[65] = eA("span", null, "Fate core: You are the leader of the Jia Wood Sun, born in the cold winter and ugly moon, with heavy earth and gold, restraining and consuming your body. Only the weak support of the Sun Lord and the Time Branch's watermark star can make you a typical weak person with strong wealth and heavy evil. This means that you are born with a strong desire and perception for wealth, but your own energy is insufficient, like a frail person guarding a huge treasure trove. Not only is it difficult to control, but it can also cause disasters and immense pressure due to wealth. Career characteristics: You have a high level of ambition and are unwilling to be outdone, but you should avoid independent entrepreneurship or investment. The Seven Kills of Destiny is best suited for seeking development within large enterprises, institutions, or systems, relying on professional skills (injury officers) to secure positions under strict rules and pressure (Seven Kills). The core of your lifelong career lies in 'leveraging', relying on teams, platforms, and partners (on par), and fighting alone will undoubtedly lead to failure. Current Universiade (24-33 years old, Bingxu luck): The God of Food generates wealth, which may seem like a chance, but the dryness of the soil in Xuxu intensifies the power of the Wealth Star, making the weakness of the body even more apparent. This fortune is mostly due to hard work and financial difficulties, with enormous financial pressure, and is prone to financial losses due to investment and cooperation. It is a decade of accumulating experience and honing one's character. Future opportunities: After the age of 34, enter Yiyou and Jia Shenyun, and compete with the robbery gang to slightly assume the role of a financial official. At that time, cooperation will be strengthened, and breakthroughs can be achieved in career through partnerships and leveraging the power of others. True good luck comes in the Guiwei and Renwu periods after the age of 54, with the help of water and wood, to achieve a peaceful old age. ", -1)),
                        eA("div", r8, [
                          dn.value && !_r.value ? (Ee(), Le("button", {
                            key: 0,
                            class: "bg-[#F0E5CF] h-14 text-sm md:text-base cursor-pointer uppercase text-[#936333]/90 px-4 py-2 rounded-sm",
                            onClick: Hs
                          }, " Retry report ")) : _r.value ? _r.value ? (Ee(), Le("button", i8, [
                            nt(kA, {
                              name: "mynaui:circle-notch",
                              class: "w-6 h-6 mr-2 animate-spin"
                            }),
                            O[64] || (O[64] = Ci(" Generating your report ", -1))
                          ])) : $t("", !0) : (Ee(), Le("button", {
                            key: 1,
                            class: "bg-[#F0E5CF] h-14 text-sm md:text-base cursor-pointer uppercase text-[#936333]/90 px-4 py-2 rounded-sm disabled:opacity-50 disabled:cursor-not-allowed",
                            onClick: O[20] || (O[20] = (KA) => rr(!1)),
                            disabled: An.value
                          }, [
                            An.value ? (Ee(), Fo(kA, {
                              key: 0,
                              name: "mynaui:circle-notch",
                              class: "w-6 h-6 mr-2 animate-spin"
                            })) : $t("", !0),
                            O[63] || (O[63] = Ci(" CLICK TO GET FULL REPORT ", -1))
                          ], 8, n8))
                        ]),
                        Pn.value.id ? $t("", !0) : (Ee(), Le("div", s8))
                      ])) : (Ee(), Le("div", a8, [
                        eA("h2", o8, "Nature of " + ye(Nn.value), 1),
                        eA("p", l8, ye(qr.value), 1),
                        O[66] || (O[66] = eA("h2", { class: "font-bold mt-2" }, "Career & Abundance", -1)),
                        eA("p", c8, ye(Pn.value?.career_and_wealth_context || rA.value?.career_and_wealth_context), 1),
                        O[67] || (O[67] = eA("h2", { class: "font-bold mt-2" }, "The Heart’s Current", -1)),
                        eA("p", u8, ye(Pn.value?.emotion_context || rA.value?.emotion_context), 1),
                        O[68] || (O[68] = eA("h2", { class: "font-bold mt-2" }, "Vitality & The Body’s Wisdom", -1)),
                        eA("p", h8, ye(Pn.value?.healthy_context || rA.value?.healthy_context), 1),
                        O[69] || (O[69] = eA("h2", { class: "font-bold mt-2" }, "Roots & Bonds", -1)),
                        eA("p", f8, ye(Pn.value?.six_emotion_context || rA.value?.six_emotion_context), 1)
                      ]))
                    ]),
                    O[78] || (O[78] = eA("div", { class: "w-full" }, [
                      eA("h2", { class: "bazi-section-title ml-3 relative pl-3 sm:pl-4 text-sm before:content-[''] before:absolute before:left-0 before:bottom-1/2 before:translate-y-1/3 before:bg-[#D59F69] before:h-3 sm:before:h-4 before:w-1 before:rounded-full uppercase font-bold" }, " WHAT'S AHEAD: YOUR ELEMENTS IN 2026 ")
                    ], -1)),
                    eA("div", d8, [
                      eA("div", g8, [
                        eA("span", null, ye(Tr.value), 1),
                        eA("div", p8, [
                          Rn.value ? (Ee(), Le("p", B8, ye(Rn.value), 1)) : $t("", !0),
                          eA("p", {
                            class: ks({ "mt-4": Rn.value })
                          }, " Your elemental balance shifts with the seasons. We publish a detailed forecast for all twelve Chinese Zodiac signs each Lunar New Year, with updated crystal recommendations tailored to the year's energy. ", 2)
                        ])
                      ])
                    ]),
                    eA("div", {
                      "data-bazi-pdf-hide": "zodiac-forecast",
                      class: "px-[50px] py-[10px] bg-[#F0E5CF] cursor-pointer",
                      onClick: W
                    }, " Read Your 2026 Zodiac Forecast "),
                    eA("div", w8, [
                      O[70] || (O[70] = eA("div", { class: "text-center mt-4" }, "STAY IN BALANCE", -1)),
                      O[71] || (O[71] = eA("div", { class: "text-center mt-4" }, " Your elements don't stand still - and neither should your awareness of them. Join us for seasonal elemental insights, your annual zodiac forecast, and crystal guidance matched to the energy of each year. ", -1)),
                      eA("form", {
                        class: "w-full max-w-xl mx-auto mt-10 flex flex-col gap-7",
                        onSubmit: vB(Te, ["prevent"])
                      }, [
                        lo(eA("input", {
                          "onUpdate:modelValue": O[21] || (O[21] = (KA) => ZA.value = KA),
                          type: "email",
                          placeholder: "your email",
                          required: "",
                          pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                          class: "w-full border-0 border-b border-[#D6C2BE] bg-transparent px-4 pb-3 text-sm tracking-[0.12em] text-[#5A392D] placeholder:text-[#B9ADAA] focus:outline-none focus:ring-0"
                        }, null, 512), [
                          [Uu, ZA.value]
                        ]),
                        eA("button", {
                          type: "submit",
                          disabled: Fe.value,
                          class: "h-12 w-full bg-[#BF997F] text-white tracking-[0.08em] cursor-pointer transition-colors hover:bg-[#B78D70] active:bg-[#A97E63] disabled:cursor-not-allowed disabled:opacity-60"
                        }, ye(Fe.value ? "JOINING..." : "JOIN"), 9, m8)
                      ], 32)
                    ]),
                    eA("div", v8, [
                      eA("div", y8, [
                        eA("div", C8, [
                          eA("img", {
                            class: "w-[30px] h-[24px] mr-3",
                            src: lt(po)("king")
                          }, null, 8, b8),
                          O[72] || (O[72] = eA("h2", null, "YOUR ELEMENTAL PRESCRIPTION", -1))
                        ])
                      ]),
                      O[73] || (O[73] = eA("div", { class: "text-center text-[#AC7B60]" }, "Crystals chosen for your chart", -1)),
                      eA("div", F8, ye(Ka.value), 1),
                      r.value.length ? (Ee(), Le("div", Q8, [
                        (Ee(!0), Le(Xt, null, Wu(r.value, (KA) => (Ee(), Le("article", {
                          key: KA.id,
                          class: "grid grid-cols-1 gap-6 rounded-lg bg-[#F7F5F1] p-4 sm:p-6 md:grid-cols-[minmax(220px,0.9fr)_minmax(0,1.1fr)] md:gap-10 lg:p-8"
                        }, [
                          nt(Ue, {
                            to: Ke(KA),
                            class: "flex min-h-56 items-center justify-center overflow-hidden rounded-md bg-[#F9FBFB] md:min-h-64"
                          }, {
                            default: Fa(() => [
                              eA("img", {
                                src: xe(KA),
                                alt: ie(KA),
                                class: "h-full w-full object-cover",
                                style: { "min-height": "100%", "object-fit": "cover" },
                                loading: "lazy",
                                decoding: "async",
                                referrerpolicy: "no-referrer",
                                onError: (Ne) => ze(Ne, KA)
                              }, null, 40, U8)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          eA("div", E8, [
                            eA("div", null, [
                              nt(Ue, {
                                to: Ke(KA),
                                class: "text-sm font-semibold uppercase tracking-[0.28em] text-[#5A392D] transition-colors hover:text-[#7A210F]"
                              }, {
                                default: Fa(() => [
                                  Ci(ye(ie(KA)), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              Be(KA) ? (Ee(), Le("div", x8, ye(Be(KA)) + " Collection ", 1)) : $t("", !0),
                              Gt(KA) ? (Ee(), Le("p", I8, ye(Gt(KA)), 1)) : $t("", !0)
                            ]),
                            Wr(KA) ? (Ee(), Le("p", S8, ye(Wr(KA)), 1)) : $t("", !0),
                            eA("div", L8, [
                              nt(Ue, {
                                to: Ke(KA),
                                class: "text-white flex h-12 min-w-0 items-center justify-center bg-[#6F1E0B] px-4 text-center text-xs font-medium uppercase tracking-[0.08em] transition-colors hover:bg-[#81270F] sm:text-sm"
                              }, {
                                default: Fa(() => [
                                  eA("span", H8, " Explore " + ye(ie(KA)) + " | " + ye(ue(KA)), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              eA("button", {
                                type: "button",
                                onClick: (Ne) => hi(KA),
                                class: "flex h-12 items-center justify-center border border-[#7A210F] bg-white text-[#7A210F] transition-colors hover:bg-[#F2E9E3]",
                                "aria-label": `Quick add ${ie(KA)}`
                              }, [
                                nt(kA, {
                                  name: "mynaui:cart",
                                  class: "h-6 w-6"
                                })
                              ], 8, T8)
                            ])
                          ])
                        ]))), 128))
                      ])) : $t("", !0)
                    ]),
                    O[79] || (O[79] = eA("div", { class: "flex flex-col gap-3 w-full p-6 bg-white border-[0.5px] border-[#E0E0E0] rounded-3xl" }, [
                      eA("div", { class: "text-center mt-8 text-[#9A6C52] text-[16px]" }, "DEEPEN YOUR ALIGNMENT"),
                      eA("div", { class: "text-center mt-2 text-black text-[20px] font-bold" }, " Master Monk Blessing "),
                      eA("div", { class: "text-center mt-4 text-[16px] leading-8" }, " Each bracelet can be consecrated by a master monk in a traditional elementalblessing ceremony - aligning the crystals to your personal energy and settingan intention for your path ahead. "),
                      eA("div", { class: "text-center mt-4 text-[16px] text-[#A76F4F]" }, " Add to any bracelet for $88 ")
                    ], -1)),
                    O[80] || (O[80] = eA("div", { class: "w-full" }, [
                      eA("h2", { class: "bazi-section-title ml-3 relative pl-3 sm:pl-4 text-sm before:content-[''] before:absolute before:left-0 before:bottom-1/2 before:translate-y-1/3 before:bg-[#D59F69] before:h-3 sm:before:h-4 before:w-1 before:rounded-full uppercase font-bold" }, " A CLOSING REFLECTION ")
                    ], -1)),
                    eA("div", _8, [
                      O[74] || (O[74] = eA("p", { class: "text-[16px] leading-8" }, " This reading draws from the classical wells of Di Tian Sui and Yuan Hai Zi Ping - texts that have mappedthe relationship between heaven, earth, and the human journey for centuries. What emerges from your chart is not a fixed story, but a living landscape - one that asks for your attention, your adaptability, andyour willingness to move with the seasons rather than against them. ", -1)),
                      eA("p", O8, ye(Pn.value?.epilogue_context || rA.value?.epilogue_context), 1)
                    ]),
                    eA("button", {
                      "data-bazi-pdf-hide": "recalculate",
                      onClick: Mn,
                      class: "bg-[#f0e5cf] w-full max-w-2xl text-[#a56c33] cursor-pointer transition-colors hover:bg-[#e6d4b8] px-4 py-2 text-sm font-medium"
                    }, " Re-Calculate "),
                    O[81] || (O[81] = eA("div", { class: "w-full mt-6 md:hidden" }, [
                      eA("h2", { class: "bazi-section-title ml-3 relative pl-3 sm:pl-4 text-sm before:content-[''] before:absolute before:left-0 before:bottom-1/2 before:translate-y-1/3 before:bg-[#D59F69] before:h-3 sm:before:h-4 before:w-1 before:rounded-full uppercase font-bold" }, " Add to Home Screen ")
                    ], -1)),
                    eA("div", N8, [
                      eA("video", {
                        class: "w-full",
                        src: lt(po)("guide"),
                        muted: "",
                        loop: "",
                        autoplay: "",
                        type: "video/mp4"
                      }, null, 8, D8)
                    ])
                  ])) : $t("", !0)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        nt(Fu, { name: "fade" }, {
          default: Fa(() => [
            TA.value ? (Ee(), Le("div", R8, [
              eA("div", {
                class: "absolute inset-0 bg-black/50 backdrop-blur-sm",
                onClick: tr
              }),
              eA("div", M8, [
                eA("button", {
                  type: "button",
                  "aria-label": "Close email verification dialog",
                  onClick: tr,
                  class: "absolute top-4 cursor-pointer right-4 text-gray-400 hover:text-gray-600 transition-colors"
                }, [
                  nt(kA, {
                    name: "mynaui:x",
                    class: "w-6 h-6"
                  })
                ]),
                O[84] || (O[84] = eA("h3", { class: "text-xl font-semibold text-gray-900 mb-4" }, "Email Verification", -1)),
                eA("form", {
                  onSubmit: vB(hn, ["prevent"]),
                  class: "space-y-4"
                }, [
                  eA("div", null, [
                    O[82] || (O[82] = eA("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Email Address", -1)),
                    lo(eA("input", {
                      "onUpdate:modelValue": O[22] || (O[22] = (KA) => _A.email = KA),
                      type: "email",
                      required: "",
                      class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D59F69] focus:border-transparent",
                      placeholder: "Enter your email address"
                    }, null, 512), [
                      [Uu, _A.email]
                    ])
                  ]),
                  eA("div", null, [
                    O[83] || (O[83] = eA("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Verification Code ", -1)),
                    eA("div", P8, [
                      lo(eA("input", {
                        "onUpdate:modelValue": O[23] || (O[23] = (KA) => _A.code = KA),
                        type: "text",
                        required: "",
                        class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D59F69] focus:border-transparent",
                        placeholder: "Enter the verification code"
                      }, null, 512), [
                        [Uu, _A.code]
                      ]),
                      eA("button", {
                        type: "button",
                        onClick: Tn,
                        disabled: VA.value || ee.value > 0,
                        class: "cursor-pointer px-4 py-2 bg-[#D59F69] text-white rounded-md hover:bg-[#C48A5A] disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors whitespace-nowrap text-sm sm:text-base"
                      }, [
                        ee.value > 0 ? (Ee(), Le("span", K8, ye(ee.value) + "s", 1)) : VA.value ? (Ee(), Le("span", V8, "Sending...")) : (Ee(), Le("span", G8, "Send Code"))
                      ], 8, k8)
                    ])
                  ]),
                  MA.value ? (Ee(), Le("div", W8, ye(MA.value), 1)) : $t("", !0),
                  eA("div", j8, [
                    eA("button", {
                      type: "button",
                      onClick: tr,
                      class: "flex-1 cursor-pointer px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
                    }, " Cancel "),
                    eA("button", {
                      type: "submit",
                      disabled: $A.value,
                      class: "flex-1 cursor-pointer px-4 py-2 bg-[#D59F69] text-white rounded-md hover:bg-[#C48A5A] disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
                    }, [
                      $A.value ? (Ee(), Le("span", $8, "Submitting...")) : (Ee(), Le("span", z8, "Confirm"))
                    ], 8, q8)
                  ])
                ], 32)
              ])
            ])) : $t("", !0)
          ]),
          _: 1
        }),
        lo(eA("div", X8, [
          eA("img", {
            src: lt(po)("footer"),
            alt: "footer",
            class: "w-full h-full object-cover"
          }, null, 8, Y8)
        ], 512), [
          [NC, s.value]
        ]),
        (Ee(), Fo(dC, { to: "body" }, [
          nt(Fu, {
            name: "fade",
            "leave-active-class": "duration-300 ease-out",
            "leave-to-class": "translate-y-full opacity-0"
          }, {
            default: Fa(() => [
              fi.value ? (Ee(), Le("div", J8, [
                eA("div", {
                  class: "absolute inset-0 bg-black/50 backdrop-blur-sm",
                  onClick: GA
                }),
                eA("div", Z8, [
                  eA("button", {
                    type: "button",
                    "aria-label": "Close payment dialog",
                    onClick: GA,
                    class: "absolute right-4 top-4 z-20 cursor-pointer text-gray-400 hover:text-gray-600 transition-colors"
                  }, [
                    nt(kA, {
                      name: "mynaui:x",
                      size: "24"
                    })
                  ]),
                  eA("div", AR, [
                    eA("div", eR, [
                      eA("div", tR, [
                        lo(eA("input", {
                          type: "checkbox",
                          name: "coupon",
                          class: "size-4 active:bg-[#D59F69] active:border-[#D59F69]",
                          "onUpdate:modelValue": O[24] || (O[24] = (KA) => Hi.value = KA),
                          disabled: wA.value || Ae.value || !PA.value
                        }, null, 8, rR), [
                          [IO, Hi.value]
                        ]),
                        eA("span", nR, [
                          O[85] || (O[85] = Ci("Choose to use the free deduction coupon. ", -1)),
                          eA("span", iR, " (" + ye(Je.value) + ") ", 1),
                          O[86] || (O[86] = Ci(" coupon available.", -1))
                        ])
                      ]),
                      O[89] || (O[89] = eA("h3", { class: "text-sm text-center text-[#070707]/85 mt-2" }, " Invite three, get one free coupon. ", -1)),
                      eA("div", sR, [
                        eA("div", aR, [
                          eA("span", oR, ye(`https://www.leymenjewels.com/?invite=${lt(N).userInfo.invite_code}`), 1)
                        ]),
                        eA("div", {
                          onClick: zo,
                          class: "active:opacity-80 cursor-pointer bg-[#D8D8D8] text-black/85 size-16 text-sm p-2 shrink-0 flex items-center justify-center text-center align-middle"
                        }, " COPY ")
                      ]),
                      wA.value ? $t("", !0) : (Ee(), Le("div", lR, [
                        eA("button", {
                          class: "h-12 w-full bg-[#292823] cursor-pointer text-white hover:bg-[#3D2B2B] disabled:opacity-50",
                          onClick: O[25] || (O[25] = (KA) => rr(!0)),
                          disabled: Ae.value
                        }, [
                          eA("span", null, [
                            Ae.value ? (Ee(), Fo(kA, {
                              key: 0,
                              name: "mynaui:refresh",
                              class: "animate-spin w-4 h-4"
                            })) : $t("", !0),
                            Ae.value ? (Ee(), Le(Xt, { key: 1 }, [
                              Ci(" Processing... ")
                            ], 64)) : (Ee(), Le(Xt, { key: 2 }, [
                              O[87] || (O[87] = Ci(" Fortune Calculation ( ", -1)),
                              PA.value && Qe.value && Hi.value ? (Ee(), Le(Xt, { key: 0 }, [
                                Ci(" Free ")
                              ], 64)) : (Ee(), Le(Xt, { key: 1 }, [
                                eA("span", uR, "$" + ye(ot.value?.data?.detail?.storeInfo?.ot_price || ""), 1),
                                Ci(" $" + ye(ot.value?.data?.detail?.storeInfo?.price || 9.9), 1)
                              ], 64)),
                              O[88] || (O[88] = Ci(" ) ", -1))
                            ], 64))
                          ])
                        ], 8, cR)
                      ])),
                      O[90] || (O[90] = eA("div", { class: "text-center mt-2 text-sm" }, [
                        eA("span", null, "Get 50% Off Your First Calculation - Don't Miss Your Intro Offer")
                      ], -1)),
                      O[91] || (O[91] = eA("div", { class: "mt-6" }, [
                        eA("div", { id: "airwallex-payment" })
                      ], -1))
                    ])
                  ])
                ])
              ])) : $t("", !0)
            ]),
            _: 1
          })
        ])),
        (Ee(), Fo(dC, { to: "body" }, [
          lo(eA("button", {
            type: "button",
            disabled: je.value,
            onClick: ka,
            class: "static ml-auto mr-4 mb-4 z-[9999] flex items-center gap-2 px-4 py-3 bg-[#D59F69] text-white rounded-full shadow-xl hover:bg-[#C48A5A] disabled:opacity-60 disabled:cursor-not-allowed transition-colors cursor-pointer sm:fixed sm:bottom-6 sm:right-6 sm:m-0"
          }, [
            je.value ? (Ee(), Le("span", fR)) : (Ee(), Fo(kA, {
              key: 0,
              name: "mynaui:download",
              class: "w-5 h-5 shrink-0"
            })),
            eA("span", dR, ye(je.value ? "Generating..." : "Download PDF"), 1)
          ], 8, hR), [
            [NC, jr.value && !HA.value]
          ])
        ]))
      ], 512);
    };
  }
}), pR = (e, A) => {
  const t = e.__vccOpts || e;
  for (const [r, n] of A)
    t[r] = n;
  return t;
}, BR = /* @__PURE__ */ pR(gR, [["__scopeId", "data-v-aaba6d67"]]), wR = {
  "arrow-left": {
    body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19.5 12h-15m5.625 6L4.5 12l5.625-6"/>'
  },
  "arrow-right": {
    body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.5 12h15m-5.625 6l5.625-6l-5.625-6"/>'
  },
  cart: {
    body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.5 21a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m-8 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M3.71 5.4h15.214c1.378 0 2.373 1.27 1.995 2.548l-1.654 5.6C19.01 14.408 18.196 15 17.27 15H8.112c-.927 0-1.742-.593-1.996-1.452zm0 0L3 3"/>'
  },
  "circle-notch": {
    body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7.717 4A9.05 9.05 0 0 0 3 11.956C3 16.951 7.03 21 12 21s9-4.05 9-9.044A9.05 9.05 0 0 0 16.283 4"/>'
  },
  download: {
    body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 16.004V17a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1M12 4.5v11m3.5-3.5L12 15.5L8.5 12"/>'
  },
  "question-circle": {
    body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0"/><path d="M12 13.496c0-2.003 2-1.503 2-3.506c0-2.659-4-2.659-4 0m2 6.007v-.5"/></g>'
  },
  refresh: {
    body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M20.5 8c-1.392-3.179-4.823-5-8.522-5C7.299 3 3.453 6.552 3 11.1"/><path d="M16.489 8.4h3.97A.54.54 0 0 0 21 7.86V3.9M3.5 16c1.392 3.179 4.823 5 8.522 5c4.679 0 8.525-3.552 8.978-8.1"/><path d="M7.511 15.6h-3.97a.54.54 0 0 0-.541.54v3.96"/></g>'
  },
  x: {
    body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 6L6 18M6 6l12 12"/>'
  }
}, mR = 24, vR = 24, FB = {
  icons: wR,
  width: mR,
  height: vR
}, yR = ["width", "height", "viewBox", "role", "aria-label", "aria-hidden", "innerHTML"], CR = /* @__PURE__ */ $g({
  __name: "StandaloneIcon",
  props: {
    name: {},
    size: { default: "1em" },
    label: {}
  },
  setup(e) {
    const A = e, t = FB.icons, r = {
      "arrow-left": t["arrow-left"],
      "arrow-right": t["arrow-right"],
      cart: t.cart,
      "circle-notch": t["circle-notch"],
      download: t.download,
      "question-circle": t["question-circle"],
      refresh: t.refresh,
      x: t.x
    }, n = bt(() => A.name.replace(/^mynaui:/, "")), i = bt(() => r[n.value]), s = bt(() => i.value?.body ?? ""), a = bt(() => i.value?.width ?? FB.width ?? 24), o = bt(() => i.value?.height ?? FB.height ?? 24), l = bt(() => i.value?.left ?? 0), c = bt(() => i.value?.top ?? 0), u = bt(() => `${l.value} ${c.value} ${a.value} ${o.value}`);
    return (d, h) => i.value ? (Ee(), Le("svg", {
      key: 0,
      xmlns: "http://www.w3.org/2000/svg",
      width: e.size,
      height: e.size,
      viewBox: u.value,
      role: e.label ? "img" : void 0,
      "aria-label": e.label ?? void 0,
      "aria-hidden": e.label ? void 0 : "true",
      focusable: "false",
      innerHTML: s.value
    }, null, 8, yR)) : $t("", !0);
  }
}), bR = ["href"], FR = /* @__PURE__ */ $g({
  __name: "StandaloneLink",
  props: {
    to: {}
  },
  setup(e) {
    const A = e, t = bt(() => SI(A.to));
    return (r, n) => (Ee(), Le("a", { href: t.value }, [
      g6(r.$slots, "default")
    ], 8, bR));
  }
}), QR = ["value", "aria-label"], UR = {
  value: "",
  disabled: ""
}, ER = ["value"], xR = /* @__PURE__ */ $g({
  __name: "StandaloneSelect",
  props: {
    options: {},
    placeholder: { default: "Select" },
    modelValue: { default: "" },
    isOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "toggle-dropdown"],
  setup(e, { emit: A }) {
    const t = A, r = (n) => {
      t("update:modelValue", n.target.value), t("toggle-dropdown");
    };
    return (n, i) => (Ee(), Le("select", {
      value: e.modelValue,
      "aria-label": e.placeholder,
      class: "w-full border border-[#CCB9B2] bg-white p-3 text-[#5A392D] focus:outline-none focus:ring-2 focus:ring-[#D6BB86]",
      onChange: r
    }, [
      eA("option", UR, ye(e.placeholder), 1),
      (Ee(!0), Le(Xt, null, Wu(e.options, (s) => (Ee(), Le("option", {
        key: s.value,
        value: s.value
      }, ye(s.label), 9, ER))), 128))
    ], 40, QR));
  }
}), TI = document.querySelector("[data-bazi-shopify-app]");
if (!TI) throw new Error("Bazi Shopify mount element was not found");
const eu = OO(BR);
eu.component("CommonSelect", xR);
eu.component("Icon", CR);
eu.component("NuxtLink", FR);
eu.config.globalProperties.$t = LI;
eu.config.globalProperties.$asset = po;
eu.mount(TI);
var _I = class D1 {
  constructor(A = {}) {
    const t = A.window || (typeof window < "u" ? window : void 0);
    if (!t) throw new Error("Window object is required but not available");
    this.window = t, this.cspNonce = A.cspNonce, this.cache = A.cache;
  }
  /**
  * Create configuration from an element
  * Extracts window from element's owner document
  */
  static fromElement(A, t = {}) {
    const r = A.ownerDocument;
    if (!r) throw new Error("Element is not attached to a document");
    const n = r.defaultView;
    if (!n) throw new Error("Document is not attached to a window");
    return new D1({
      window: n,
      ...t
    });
  }
  /**
  * Clone configuration with override options
  */
  clone(A = {}) {
    return new D1({
      window: A.window || this.window,
      cspNonce: A.cspNonce ?? this.cspNonce,
      cache: A.cache ?? this.cache
    });
  }
}, OI = class {
  constructor(e = {}) {
    this.config = {
      maxImageTimeout: 3e5,
      allowDataUrls: !0,
      ...e
    };
  }
  /**
  * Validate a URL
  *
  * @param url - URL to validate
  * @param context - Context for validation (e.g., 'proxy', 'image')
  * @returns Validation result
  */
  validateUrl(e, A = "general") {
    if (!e || typeof e != "string") return {
      valid: !1,
      error: "URL must be a non-empty string"
    };
    if (e.startsWith("data:"))
      return this.config.allowDataUrls ? {
        valid: !0,
        sanitized: e
      } : {
        valid: !1,
        error: "Data URLs are not allowed"
      };
    if (e.startsWith("blob:")) return {
      valid: !0,
      sanitized: e
    };
    try {
      const t = new URL(e);
      if (!["http:", "https:"].includes(t.protocol)) return {
        valid: !1,
        error: `Protocol ${t.protocol} is not allowed. Only http and https are permitted.`
      };
      if (A === "proxy" && this.config.allowedProxyDomains && this.config.allowedProxyDomains.length > 0) {
        const r = t.hostname.toLowerCase();
        if (!this.config.allowedProxyDomains.some((n) => {
          const i = n.toLowerCase();
          return r === i || r.endsWith("." + i);
        })) return {
          valid: !1,
          error: `Proxy domain ${t.hostname} is not in the allowed list`
        };
      }
      if (A === "proxy") {
        if (!this.config.allowLocalhostProxy) {
          const r = t.hostname.toLowerCase();
          if (r === "localhost" || r === "127.0.0.1" || r === "::1") return {
            valid: !1,
            error: "Localhost is not allowed for proxy URLs"
          };
          if (this.isPrivateIP(r)) return {
            valid: !1,
            error: "Private IP addresses are not allowed for proxy URLs"
          };
          if (r.startsWith("169.254.") || r.startsWith("fe80:")) return {
            valid: !1,
            error: "Link-local addresses are not allowed for proxy URLs"
          };
        }
        return {
          valid: !0,
          sanitized: e,
          requiresRuntimeCheck: !0
        };
      }
      return {
        valid: !0,
        sanitized: e
      };
    } catch (t) {
      return {
        valid: !1,
        error: `Invalid URL format: ${t instanceof Error ? t.message : "Unknown error"}`
      };
    }
  }
  /**
  * Check if a hostname is a private IP address
  */
  isPrivateIP(e) {
    return [
      /^0\./,
      /^10\./,
      /^100\.(6[4-9]|[7-9][0-9]|1[0-1][0-9]|12[0-7])\./,
      /^127\./,
      /^169\.254\./,
      /^172\.(1[6-9]|2[0-9]|3[0-1])\./,
      /^192\.0\.0\./,
      /^192\.0\.2\./,
      /^192\.168\./,
      /^198\.(1[8-9])\./,
      /^198\.51\.100\./,
      /^203\.0\.113\./,
      /^2(2[4-9]|3[0-9])\./,
      /^24[0-9]\./,
      /^255\.255\.255\.255$/
    ].some((A) => A.test(e)) ? !0 : e.includes(":") ? this.isPrivateIPv6(e) : !1;
  }
  /**
  * Check if an IPv6 address is private or special
  * Handles compressed IPv6 addresses (e.g., ::1, fc00::1)
  */
  isPrivateIPv6(e) {
    const A = e.toLowerCase().trim().replace(/^\[|\]$/g, "").split("%")[0];
    if (/^(0:){7}1$/.test(A) || A === "::1" || /^(0:){7}0$/.test(A) || A === "::") return !0;
    const t = this.expandIPv6(A);
    if (!t) return this.isPrivateIPv6Prefix(A);
    const r = parseInt(t.substring(0, 2), 16);
    if (r >= 252 && r <= 253) return !0;
    if (r === 254) {
      const n = parseInt(t.substring(2, 4), 16);
      if (n >= 128 && n <= 191) return !0;
    }
    return r === 255;
  }
  /**
  * Expand compressed IPv6 address to full form
  * e.g., "::1" -> "0000:0000:0000:0000:0000:0000:0000:0001"
  */
  expandIPv6(e) {
    try {
      if (e.includes("::")) {
        const A = e.split("::");
        if (A.length > 2) return null;
        const t = A[0] ? A[0].split(":") : [], r = A[1] ? A[1].split(":") : [], n = 8 - t.length - r.length;
        if (n < 0) return null;
        const i = Array(n).fill("0000");
        return [
          ...t,
          ...i,
          ...r
        ].map((s) => s.padStart(4, "0")).join(":");
      } else {
        const A = e.split(":");
        return A.length !== 8 ? null : A.map((t) => t.padStart(4, "0")).join(":");
      }
    } catch {
      return null;
    }
  }
  /**
  * Fallback prefix matching for IPv6 when expansion fails
  */
  isPrivateIPv6Prefix(e) {
    return !!(/^fc[0-9a-f]{0,2}:?/i.test(e) || /^fd[0-9a-f]{0,2}:?/i.test(e) || /^fe[89ab][0-9a-f]:?/i.test(e) || /^ff[0-9a-f]{0,2}:?/i.test(e));
  }
  /**
  * Validate CSP nonce
  *
  * @param nonce - CSP nonce to validate
  * @returns Validation result
  */
  validateCspNonce(e) {
    return !e || typeof e != "string" ? {
      valid: !1,
      error: "CSP nonce must be a non-empty string"
    } : e.length < 16 ? {
      valid: !1,
      error: "CSP nonce is too short (minimum 16 characters recommended)"
    } : /^[A-Za-z0-9+/=_-]+$/.test(e) ? {
      valid: !0,
      sanitized: e
    } : {
      valid: !1,
      error: "CSP nonce contains invalid characters"
    };
  }
  /**
  * Validate image timeout
  *
  * @param timeout - Timeout in milliseconds
  * @returns Validation result
  */
  validateImageTimeout(e) {
    return typeof e != "number" || isNaN(e) ? {
      valid: !1,
      error: "Image timeout must be a number"
    } : e < 0 ? {
      valid: !1,
      error: "Image timeout cannot be negative"
    } : this.config.maxImageTimeout && e > this.config.maxImageTimeout ? {
      valid: !1,
      error: `Image timeout ${e}ms exceeds maximum allowed ${this.config.maxImageTimeout}ms`
    } : {
      valid: !0,
      sanitized: e
    };
  }
  /**
  * Validate window dimensions
  *
  * @param width - Window width
  * @param height - Window height
  * @returns Validation result
  */
  validateDimensions(e, A) {
    if (typeof e != "number" || typeof A != "number") return {
      valid: !1,
      error: "Dimensions must be numbers"
    };
    if (isNaN(e) || isNaN(A)) return {
      valid: !1,
      error: "Dimensions cannot be NaN"
    };
    if (e <= 0 || A <= 0) return {
      valid: !1,
      error: "Dimensions must be positive"
    };
    const t = 32767;
    return e > t || A > t ? {
      valid: !1,
      error: `Dimensions exceed maximum allowed (${t}px)`
    } : {
      valid: !0,
      sanitized: {
        width: e,
        height: A
      }
    };
  }
  /**
  * Validate scale factor
  *
  * @param scale - Scale factor
  * @returns Validation result
  */
  validateScale(e) {
    return typeof e != "number" || isNaN(e) ? {
      valid: !1,
      error: "Scale must be a number"
    } : e <= 0 ? {
      valid: !1,
      error: "Scale must be positive"
    } : e > 10 ? {
      valid: !1,
      error: "Scale factor too large (maximum 10x)"
    } : {
      valid: !0,
      sanitized: e
    };
  }
  /**
  * Validate HTML element
  *
  * @param element - Element to validate
  * @returns Validation result
  */
  validateElement(e) {
    if (!e) return {
      valid: !1,
      error: "Element is required"
    };
    if (typeof e != "object") return {
      valid: !1,
      error: "Element must be an object"
    };
    const A = e;
    return typeof HTMLElement < "u" && e instanceof HTMLElement ? e.ownerDocument ? { valid: !0 } : {
      valid: !1,
      error: "Element must be attached to a document"
    } : A.ownerDocument ? A.ownerDocument.defaultView ? { valid: !0 } : {
      valid: !1,
      error: "Document must be attached to a window (ownerDocument.defaultView required)"
    } : {
      valid: !1,
      error: "Element must be attached to a document (ownerDocument required)"
    };
  }
  /**
  * Validate entire options object
  *
  * @param options - Options to validate
  * @returns Validation result with all errors
  */
  validateOptions(e) {
    const A = [], t = e.proxy;
    if (t != null && typeof t == "string" && t.length > 0) {
      const r = this.validateUrl(t, "proxy");
      r.valid || A.push(`Proxy: ${r.error}`);
    }
    if (e.imageTimeout !== void 0) {
      const r = this.validateImageTimeout(e.imageTimeout);
      r.valid || A.push(`Image timeout: ${r.error}`);
    }
    if (e.width !== void 0 || e.height !== void 0) {
      const r = e.width ?? 800, n = e.height ?? 600, i = this.validateDimensions(r, n);
      i.valid || A.push(`Dimensions: ${i.error}`);
    }
    if (e.scale !== void 0) {
      const r = this.validateScale(e.scale);
      r.valid || A.push(`Scale: ${r.error}`);
    }
    if (e.cspNonce !== void 0) {
      const r = this.validateCspNonce(e.cspNonce);
      r.valid || A.push(`CSP nonce: ${r.error}`);
    }
    if (this.config.customValidator) {
      const r = this.config.customValidator(e, "options");
      r.valid || A.push(`Custom validation: ${r.error}`);
    }
    return A.length > 0 ? {
      valid: !1,
      error: A.join("; ")
    } : { valid: !0 };
  }
};
function NI(e = {}) {
  return new OI({
    allowDataUrls: !0,
    maxImageTimeout: 3e5,
    ...e
  });
}
var DI = class {
  constructor(e, A = !0) {
    this.context = e, this.activeMetrics = /* @__PURE__ */ new Map(), this.completedMetrics = [], this.enabled = A, this.getTime = typeof performance < "u" && typeof performance.now == "function" ? () => performance.now() : () => Date.now();
  }
  /**
  * Start measuring a performance metric
  *
  * @param name - Unique name for this metric
  * @param metadata - Optional metadata to attach
  */
  start(e, A) {
    this.enabled && (this.activeMetrics.has(e) && this.context?.logger.warn(`Performance metric '${e}' already started. Overwriting.`), this.activeMetrics.set(e, {
      name: e,
      startTime: this.getTime(),
      metadata: A
    }));
  }
  /**
  * End measuring a performance metric
  *
  * @param name - Name of the metric to end
  * @returns The completed metric, or undefined if not found
  */
  end(e) {
    if (!this.enabled) return;
    const A = this.activeMetrics.get(e);
    if (!A) {
      this.context?.logger.warn(`Performance metric '${e}' not found. Was start() called?`);
      return;
    }
    return A.endTime = this.getTime(), A.duration = A.endTime - A.startTime, this.completedMetrics.push(A), this.activeMetrics.delete(e), this.context?.logger.debug(`⏱️  ${e}: ${A.duration.toFixed(2)}ms`, A.metadata), A;
  }
  /**
  * Measure a synchronous function
  *
  * @param name - Name for this measurement
  * @param fn - Function to measure
  * @param metadata - Optional metadata
  * @returns The function's return value
  */
  measure(e, A, t) {
    this.start(e, t);
    try {
      const r = A();
      return this.end(e), r;
    } catch (r) {
      throw this.end(e), r;
    }
  }
  /**
  * Measure an asynchronous function
  *
  * @param name - Name for this measurement
  * @param fn - Async function to measure
  * @param metadata - Optional metadata
  * @returns Promise resolving to the function's return value
  */
  async measureAsync(e, A, t) {
    this.start(e, t);
    try {
      const r = await A();
      return this.end(e), r;
    } catch (r) {
      throw this.end(e), r;
    }
  }
  /**
  * Get all completed metrics
  *
  * @returns Array of completed performance metrics
  */
  getMetrics() {
    return [...this.completedMetrics];
  }
  /**
  * Get a specific metric by name
  *
  * @param name - Metric name
  * @returns The metric, or undefined if not found
  */
  getMetric(e) {
    return this.completedMetrics.find((A) => A.name === e);
  }
  /**
  * Get performance summary
  *
  * @returns Aggregated performance data
  */
  getSummary() {
    const e = this.completedMetrics.reduce((t, r) => t + (r.duration || 0), 0), A = this.completedMetrics.map((t) => ({
      name: t.name,
      duration: t.duration || 0,
      percentage: e > 0 ? ((t.duration || 0) / e * 100).toFixed(1) + "%" : "0%"
    }));
    return {
      totalDuration: e,
      metrics: this.getMetrics(),
      breakdown: A
    };
  }
  /**
  * Log performance summary to console
  */
  logSummary() {
    if (!this.enabled || this.completedMetrics.length === 0 || !this.context) return;
    const e = this.getSummary();
    this.context.logger.info(`
📊 Performance Summary (Total: ${e.totalDuration.toFixed(2)}ms):`), e.breakdown.sort((A, t) => t.duration - A.duration).forEach((A) => {
      this.context.logger.info(`  ${A.name.padEnd(20)} ${A.duration.toFixed(2).padStart(8)}ms  ${A.percentage.padStart(6)}`);
    });
  }
  /**
  * Clear all metrics
  */
  clear() {
    this.activeMetrics.clear(), this.completedMetrics.splice(0);
  }
  /**
  * Check if monitoring is enabled
  */
  isEnabled() {
    return this.enabled;
  }
  /**
  * Get active (uncompleted) metrics
  * Useful for debugging leaked measurements
  */
  getActiveMetrics() {
    return Array.from(this.activeMetrics.keys());
  }
}, Bs, Hn = (Bs = class {
  constructor(A, t, r, n) {
    this.left = A, this.top = t, this.width = r, this.height = n;
  }
  add(A, t, r, n) {
    return new Bs(this.left + A, this.top + t, this.width + r, this.height + n);
  }
  static fromClientRect(A, t) {
    return new Bs(t.left + A.windowBounds.left, t.top + A.windowBounds.top, t.width, t.height);
  }
  static fromDOMRectList(A, t) {
    const r = Array.from(t);
    let n = r.find((i) => i.width !== 0);
    return n || (n = r.find((i) => i.height !== 0)), !n && r.length > 0 && (n = r[0]), n ? new Bs(n.left + A.windowBounds.left, n.top + A.windowBounds.top, n.width, n.height) : Bs.EMPTY;
  }
}, Bs.EMPTY = new Bs(0, 0, 0, 0), Bs);
const Nh = (e, A) => Hn.fromClientRect(e, A.getBoundingClientRect()), IR = (e) => {
  const A = e.body, t = e.documentElement;
  if (!A || !t) throw new Error("Unable to get document size");
  return new Hn(0, 0, Math.max(Math.max(A.scrollWidth, t.scrollWidth), Math.max(A.offsetWidth, t.offsetWidth), Math.max(A.clientWidth, t.clientWidth)), Math.max(Math.max(A.scrollHeight, t.scrollHeight), Math.max(A.offsetHeight, t.offsetHeight), Math.max(A.clientHeight, t.clientHeight)));
};
var Ap = function(e) {
  for (var A = [], t = 0, r = e.length; t < r; ) {
    var n = e.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < r) {
      var i = e.charCodeAt(t++);
      (i & 64512) === 56320 ? A.push(((n & 1023) << 10) + (i & 1023) + 65536) : (A.push(n), t--);
    } else A.push(n);
  }
  return A;
}, wr = function() {
  for (var e = [], A = 0; A < arguments.length; A++) e[A] = arguments[A];
  if (String.fromCodePoint) return String.fromCodePoint.apply(String, e);
  var t = e.length;
  if (!t) return "";
  for (var r = [], n = -1, i = ""; ++n < t; ) {
    var s = e[n];
    s <= 65535 ? r.push(s) : (s -= 65536, r.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === t || r.length > 16384) && (i += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return i;
}, qC = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", SR = typeof Uint8Array > "u" ? [] : /* @__PURE__ */ new Uint8Array(256);
for (var Kf = 0; Kf < qC.length; Kf++) SR[qC.charCodeAt(Kf)] = Kf;
var $C = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $u = typeof Uint8Array > "u" ? [] : /* @__PURE__ */ new Uint8Array(256);
for (var Vf = 0; Vf < $C.length; Vf++) $u[$C.charCodeAt(Vf)] = Vf;
var LR = function(e) {
  var A = e.length * 0.75, t = e.length, r, n = 0, i, s, a, o;
  e[e.length - 1] === "=" && (A--, e[e.length - 2] === "=" && A--);
  var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), c = Array.isArray(l) ? l : new Uint8Array(l);
  for (r = 0; r < t; r += 4)
    i = $u[e.charCodeAt(r)], s = $u[e.charCodeAt(r + 1)], a = $u[e.charCodeAt(r + 2)], o = $u[e.charCodeAt(r + 3)], c[n++] = i << 2 | s >> 4, c[n++] = (s & 15) << 4 | a >> 2, c[n++] = (a & 3) << 6 | o & 63;
  return l;
}, HR = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 2) t.push(e[r + 1] << 8 | e[r]);
  return t;
}, TR = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 4) t.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
  return t;
}, Ol = 5, Sy = 11, QB = 2, _R = Sy - Ol, RI = 65536 >> Ol, UB = (1 << Ol) - 1, OR = RI + (1024 >> Ol) + 32, NR = 65536 >> Sy, DR = (1 << _R) - 1, zC = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint16Array(Array.prototype.slice.call(e, A, t));
}, RR = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint32Array(Array.prototype.slice.call(e, A, t));
}, MR = function(e, A) {
  var t = LR(e), r = Array.isArray(t) ? TR(t) : new Uint32Array(t), n = Array.isArray(t) ? HR(t) : new Uint16Array(t), i = 24, s = zC(n, i / 2, r[4] / 2), a = r[5] === 2 ? zC(n, (i + r[4]) / 2) : RR(r, Math.ceil((i + r[4]) / 4));
  return new PR(r[0], r[1], r[2], r[3], s, a);
}, PR = (function() {
  function e(A, t, r, n, i, s) {
    this.initialValue = A, this.errorValue = t, this.highStart = r, this.highValueIndex = n, this.index = i, this.data = s;
  }
  return e.prototype.get = function(A) {
    var t;
    if (A >= 0) {
      if (A < 55296 || A > 56319 && A <= 65535)
        return t = this.index[A >> Ol], t = (t << QB) + (A & UB), this.data[t];
      if (A <= 65535)
        return t = this.index[RI + (A - 55296 >> Ol)], t = (t << QB) + (A & UB), this.data[t];
      if (A < this.highStart)
        return t = OR - NR + (A >> Sy), t = this.index[t], t += A >> Ol & DR, t = this.index[t], t = (t << QB) + (A & UB), this.data[t];
      if (A <= 1114111) return this.data[this.highValueIndex];
    }
    return this.errorValue;
  }, e;
})(), XC = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", kR = typeof Uint8Array > "u" ? [] : /* @__PURE__ */ new Uint8Array(256);
for (var Gf = 0; Gf < XC.length; Gf++) kR[XC.charCodeAt(Gf)] = Gf;
var KR = "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", YC = 50, VR = 1, MI = 2, PI = 3, GR = 4, WR = 5, JC = 7, kI = 8, ZC = 9, Uo = 10, R1 = 11, Ab = 12, M1 = 13, jR = 14, zu = 15, P1 = 16, Wf = 17, xu = 18, qR = 19, eb = 20, k1 = 21, Iu = 22, EB = 23, wc = 24, bi = 25, Xu = 26, Yu = 27, mc = 28, $R = 29, Fl = 30, zR = 31, jf = 32, qf = 33, K1 = 34, V1 = 35, G1 = 36, Dh = 37, W1 = 38, $d = 39, zd = 40, xB = 41, KI = 42, XR = 43, YR = [9001, 65288], VI = "!", qe = "×", $f = "÷", j1 = MR(KR), pa = [Fl, G1], q1 = [
  VR,
  MI,
  PI,
  WR
], GI = [Uo, kI], tb = [Yu, Xu], JR = q1.concat(GI), rb = [
  W1,
  $d,
  zd,
  K1,
  V1
], ZR = [zu, M1], AM = function(e, A) {
  A === void 0 && (A = "strict");
  var t = [], r = [], n = [];
  return e.forEach(function(i, s) {
    var a = j1.get(i);
    if (a > YC ? (n.push(!0), a -= YC) : n.push(!1), [
      "normal",
      "auto",
      "loose"
    ].indexOf(A) !== -1 && [
      8208,
      8211,
      12316,
      12448
    ].indexOf(i) !== -1)
      return r.push(s), t.push(P1);
    if (a === GR || a === R1) {
      if (s === 0)
        return r.push(s), t.push(Fl);
      var o = t[s - 1];
      return JR.indexOf(o) === -1 ? (r.push(r[s - 1]), t.push(o)) : (r.push(s), t.push(Fl));
    }
    if (r.push(s), a === zR) return t.push(A === "strict" ? k1 : Dh);
    if (a === KI || a === $R) return t.push(Fl);
    if (a === XR) return i >= 131072 && i <= 196605 || i >= 196608 && i <= 262141 ? t.push(Dh) : t.push(Fl);
    t.push(a);
  }), [
    r,
    t,
    n
  ];
}, IB = function(e, A, t, r) {
  var n = r[t];
  if (Array.isArray(e) ? e.indexOf(n) !== -1 : e === n)
    for (var i = t; i <= r.length; ) {
      i++;
      var s = r[i];
      if (s === A) return !0;
      if (s !== Uo) break;
    }
  if (n === Uo)
    for (var i = t; i > 0; ) {
      i--;
      var a = r[i];
      if (Array.isArray(e) ? e.indexOf(a) !== -1 : e === a)
        for (var o = t; o <= r.length; ) {
          o++;
          var s = r[o];
          if (s === A) return !0;
          if (s !== Uo) break;
        }
      if (a !== Uo) break;
    }
  return !1;
}, nb = function(e, A) {
  for (var t = e; t >= 0; ) {
    var r = A[t];
    if (r === Uo) t--;
    else return r;
  }
  return 0;
}, eM = function(e, A, t, r, n) {
  if (t[r] === 0) return qe;
  var i = r - 1;
  if (Array.isArray(n) && n[i] === !0) return qe;
  var s = i - 1, a = i + 1, o = A[i], l = s >= 0 ? A[s] : 0, c = A[a];
  if (o === MI && c === PI) return qe;
  if (q1.indexOf(o) !== -1) return VI;
  if (q1.indexOf(c) !== -1 || GI.indexOf(c) !== -1) return qe;
  if (nb(i, A) === kI) return $f;
  if (j1.get(e[i]) === R1 || (o === jf || o === qf) && j1.get(e[a]) === R1 || o === JC || c === JC || o === ZC || [
    Uo,
    M1,
    zu
  ].indexOf(o) === -1 && c === ZC || [
    Wf,
    xu,
    qR,
    wc,
    mc
  ].indexOf(c) !== -1 || nb(i, A) === Iu || IB(EB, Iu, i, A) || IB([Wf, xu], k1, i, A) || IB(Ab, Ab, i, A)) return qe;
  if (o === Uo) return $f;
  if (o === EB || c === EB) return qe;
  if (c === P1 || o === P1) return $f;
  if ([
    M1,
    zu,
    k1
  ].indexOf(c) !== -1 || o === jR || l === G1 && ZR.indexOf(o) !== -1 || o === mc && c === G1 || c === eb || pa.indexOf(c) !== -1 && o === bi || pa.indexOf(o) !== -1 && c === bi || o === Yu && [
    Dh,
    jf,
    qf
  ].indexOf(c) !== -1 || [
    Dh,
    jf,
    qf
  ].indexOf(o) !== -1 && c === Xu || pa.indexOf(o) !== -1 && tb.indexOf(c) !== -1 || tb.indexOf(o) !== -1 && pa.indexOf(c) !== -1 || [Yu, Xu].indexOf(o) !== -1 && (c === bi || [Iu, zu].indexOf(c) !== -1 && A[a + 1] === bi) || [Iu, zu].indexOf(o) !== -1 && c === bi || o === bi && [
    bi,
    mc,
    wc
  ].indexOf(c) !== -1) return qe;
  if ([
    bi,
    mc,
    wc,
    Wf,
    xu
  ].indexOf(c) !== -1)
    for (var u = i; u >= 0; ) {
      var d = A[u];
      if (d === bi) return qe;
      if ([mc, wc].indexOf(d) !== -1) u--;
      else break;
    }
  if ([Yu, Xu].indexOf(c) !== -1)
    for (var u = [Wf, xu].indexOf(o) !== -1 ? s : i; u >= 0; ) {
      var d = A[u];
      if (d === bi) return qe;
      if ([mc, wc].indexOf(d) !== -1) u--;
      else break;
    }
  if (W1 === o && [
    W1,
    $d,
    K1,
    V1
  ].indexOf(c) !== -1 || [$d, K1].indexOf(o) !== -1 && [$d, zd].indexOf(c) !== -1 || [zd, V1].indexOf(o) !== -1 && c === zd || rb.indexOf(o) !== -1 && [eb, Xu].indexOf(c) !== -1 || rb.indexOf(c) !== -1 && o === Yu || pa.indexOf(o) !== -1 && pa.indexOf(c) !== -1 || o === wc && pa.indexOf(c) !== -1 || pa.concat(bi).indexOf(o) !== -1 && c === Iu && YR.indexOf(e[a]) === -1 || pa.concat(bi).indexOf(c) !== -1 && o === xu) return qe;
  if (o === xB && c === xB) {
    for (var h = t[i], p = 1; h > 0 && (h--, A[h] === xB); )
      p++;
    if (p % 2 !== 0) return qe;
  }
  return o === jf && c === qf ? qe : $f;
}, tM = function(e, A) {
  A || (A = {
    lineBreak: "normal",
    wordBreak: "normal"
  });
  var t = AM(e, A.lineBreak), r = t[0], n = t[1], i = t[2];
  (A.wordBreak === "break-all" || A.wordBreak === "break-word") && (n = n.map(function(a) {
    return [
      bi,
      Fl,
      KI
    ].indexOf(a) !== -1 ? Dh : a;
  }));
  var s = A.wordBreak === "keep-all" ? i.map(function(a, o) {
    return a && e[o] >= 19968 && e[o] <= 40959;
  }) : void 0;
  return [
    r,
    n,
    s
  ];
}, rM = (function() {
  function e(A, t, r, n) {
    this.codePoints = A, this.required = t === VI, this.start = r, this.end = n;
  }
  return e.prototype.slice = function() {
    return wr.apply(void 0, this.codePoints.slice(this.start, this.end));
  }, e;
})(), nM = function(e, A) {
  var t = Ap(e), r = tM(t, A), n = r[0], i = r[1], s = r[2], a = t.length, o = 0, l = 0;
  return { next: function() {
    if (l >= a) return {
      done: !0,
      value: null
    };
    for (var c = qe; l < a && (c = eM(t, i, n, ++l, s)) === qe; ) ;
    if (c !== qe || l === a) {
      var u = new rM(t, c, o, l);
      return o = l, {
        value: u,
        done: !1
      };
    }
    return {
      done: !0,
      value: null
    };
  } };
};
const ib = 65533, Qn = (e) => e >= 48 && e <= 57, iM = (e) => e >= 55296 && e <= 57343, vc = (e) => Qn(e) || e >= 65 && e <= 70 || e >= 97 && e <= 102, sM = (e) => e >= 97 && e <= 122, aM = (e) => e >= 65 && e <= 90, oM = (e) => sM(e) || aM(e), lM = (e) => e >= 128, zf = (e) => e === 10 || e === 9 || e === 32, wg = (e) => oM(e) || lM(e) || e === 95, sb = (e) => wg(e) || Qn(e) || e === 45, cM = (e) => e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e === 127, vo = (e, A) => e !== 92 ? !1 : A !== 10, Xf = (e, A, t) => e === 45 ? wg(A) || vo(A, t) : wg(e) ? !0 : !!(e === 92 && vo(e, A)), SB = (e, A, t) => e === 43 || e === 45 ? Qn(A) ? !0 : A === 46 && Qn(t) : Qn(e === 46 ? A : e), uM = (e) => {
  let A = 0, t = 1;
  (e[A] === 43 || e[A] === 45) && (e[A] === 45 && (t = -1), A++);
  const r = [];
  for (; Qn(e[A]); ) r.push(e[A++]);
  const n = r.length ? parseInt(wr(...r), 10) : 0;
  e[A] === 46 && A++;
  const i = [];
  for (; Qn(e[A]); ) i.push(e[A++]);
  const s = i.length, a = s ? parseInt(wr(...i), 10) : 0;
  (e[A] === 69 || e[A] === 101) && A++;
  let o = 1;
  (e[A] === 43 || e[A] === 45) && (e[A] === 45 && (o = -1), A++);
  const l = [];
  for (; Qn(e[A]); ) l.push(e[A++]);
  const c = l.length ? parseInt(wr(...l), 10) : 0;
  return t * (n + a * Math.pow(10, -s)) * Math.pow(10, o * c);
}, hM = { type: 2 }, fM = { type: 3 }, dM = { type: 4 }, gM = { type: 13 }, pM = { type: 8 }, BM = { type: 21 }, wM = { type: 9 }, mM = { type: 10 }, vM = { type: 11 }, yM = { type: 12 }, CM = { type: 14 }, Yf = { type: 23 }, bM = { type: 1 }, FM = { type: 25 }, QM = { type: 24 }, UM = { type: 26 }, EM = { type: 27 }, xM = { type: 28 }, IM = { type: 29 }, SM = { type: 31 }, $1 = { type: 32 };
var Ki, z1 = (Ki = class {
  static get() {
    return Ki._pool.pop() || new Ki();
  }
  static release(A) {
    Ki._pool.length < Ki.MAX_POOL_SIZE && (A._reset(), Ki._pool.push(A));
  }
  constructor() {
    this._value = [];
  }
  _reset() {
    this._value = [];
  }
  write(A) {
    this._value = this._value.concat(Ap(A));
  }
  read() {
    const A = [];
    let t = this.consumeToken();
    for (; t !== $1; )
      A.push(t), t = this.consumeToken();
    return A;
  }
  consumeToken() {
    const A = this.consumeCodePoint();
    switch (A) {
      case 34:
        return this.consumeStringToken(34);
      case 35: {
        const t = this.peekCodePoint(0), r = this.peekCodePoint(1), n = this.peekCodePoint(2);
        if (sb(t) || vo(r, n)) {
          const i = Xf(t, r, n) ? 2 : 1;
          return {
            type: 5,
            value: this.consumeName(),
            flags: i
          };
        }
        break;
      }
      case 36:
        if (this.peekCodePoint(0) === 61)
          return this.consumeCodePoint(), gM;
        break;
      case 39:
        return this.consumeStringToken(39);
      case 40:
        return hM;
      case 41:
        return fM;
      case 42:
        if (this.peekCodePoint(0) === 61)
          return this.consumeCodePoint(), CM;
        break;
      case 43:
        if (SB(A, this.peekCodePoint(0), this.peekCodePoint(1)))
          return this.reconsumeCodePoint(A), this.consumeNumericToken();
        break;
      case 44:
        return dM;
      case 45: {
        const t = A, r = this.peekCodePoint(0), n = this.peekCodePoint(1);
        if (SB(t, r, n))
          return this.reconsumeCodePoint(A), this.consumeNumericToken();
        if (Xf(t, r, n))
          return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
        if (r === 45 && n === 62)
          return this.consumeCodePoint(), this.consumeCodePoint(), QM;
        break;
      }
      case 46:
        if (SB(A, this.peekCodePoint(0), this.peekCodePoint(1)))
          return this.reconsumeCodePoint(A), this.consumeNumericToken();
        break;
      case 47:
        if (this.peekCodePoint(0) === 42)
          for (this.consumeCodePoint(); ; ) {
            let t = this.consumeCodePoint();
            if (t === 42 && (t = this.consumeCodePoint(), t === 47))
              return this.consumeToken();
            if (t === -1) return this.consumeToken();
          }
        break;
      case 58:
        return UM;
      case 59:
        return EM;
      case 60:
        if (this.peekCodePoint(0) === 33 && this.peekCodePoint(1) === 45 && this.peekCodePoint(2) === 45)
          return this.consumeCodePoint(), this.consumeCodePoint(), FM;
        break;
      case 64:
        if (Xf(this.peekCodePoint(0), this.peekCodePoint(1), this.peekCodePoint(2))) return {
          type: 7,
          value: this.consumeName()
        };
        break;
      case 91:
        return xM;
      case 92:
        if (vo(A, this.peekCodePoint(0)))
          return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
        break;
      case 93:
        return IM;
      case 61:
        if (this.peekCodePoint(0) === 61)
          return this.consumeCodePoint(), pM;
        break;
      case 123:
        return vM;
      case 125:
        return yM;
      case 117:
      case 85: {
        const t = this.peekCodePoint(0), r = this.peekCodePoint(1);
        return t === 43 && (vc(r) || r === 63) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
      }
      case 124:
        if (this.peekCodePoint(0) === 61)
          return this.consumeCodePoint(), wM;
        if (this.peekCodePoint(0) === 124)
          return this.consumeCodePoint(), BM;
        break;
      case 126:
        if (this.peekCodePoint(0) === 61)
          return this.consumeCodePoint(), mM;
        break;
      case -1:
        return $1;
    }
    return zf(A) ? (this.consumeWhiteSpace(), SM) : Qn(A) ? (this.reconsumeCodePoint(A), this.consumeNumericToken()) : wg(A) ? (this.reconsumeCodePoint(A), this.consumeIdentLikeToken()) : {
      type: 6,
      value: wr(A)
    };
  }
  consumeCodePoint() {
    const A = this._value.shift();
    return typeof A > "u" ? -1 : A;
  }
  reconsumeCodePoint(A) {
    this._value.unshift(A);
  }
  peekCodePoint(A) {
    return A >= this._value.length ? -1 : this._value[A];
  }
  consumeUnicodeRangeToken() {
    const A = [];
    let t = this.consumeCodePoint();
    for (; vc(t) && A.length < 6; )
      A.push(t), t = this.consumeCodePoint();
    let r = !1;
    for (; t === 63 && A.length < 6; )
      A.push(t), t = this.consumeCodePoint(), r = !0;
    if (r) return {
      type: 30,
      start: parseInt(wr(...A.map((i) => i === 63 ? 48 : i)), 16),
      end: parseInt(wr(...A.map((i) => i === 63 ? 70 : i)), 16)
    };
    const n = parseInt(wr(...A), 16);
    if (this.peekCodePoint(0) === 45 && vc(this.peekCodePoint(1))) {
      this.consumeCodePoint(), t = this.consumeCodePoint();
      const i = [];
      for (; vc(t) && i.length < 6; )
        i.push(t), t = this.consumeCodePoint();
      return {
        type: 30,
        start: n,
        end: parseInt(wr(...i), 16)
      };
    } else return {
      type: 30,
      start: n,
      end: n
    };
  }
  consumeIdentLikeToken() {
    const A = this.consumeName();
    return A.toLowerCase() === "url" && this.peekCodePoint(0) === 40 ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === 40 ? (this.consumeCodePoint(), {
      type: 19,
      value: A
    }) : {
      type: 20,
      value: A
    };
  }
  consumeUrlToken() {
    const A = [];
    if (this.consumeWhiteSpace(), this.peekCodePoint(0) === -1) return {
      type: 22,
      value: ""
    };
    const t = this.peekCodePoint(0);
    if (t === 39 || t === 34) {
      const r = this.consumeStringToken(this.consumeCodePoint());
      return r.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === -1 || this.peekCodePoint(0) === 41) ? (this.consumeCodePoint(), {
        type: 22,
        value: r.value
      }) : (this.consumeBadUrlRemnants(), Yf);
    }
    for (; ; ) {
      const r = this.consumeCodePoint();
      if (r === -1 || r === 41) return {
        type: 22,
        value: wr(...A)
      };
      if (zf(r))
        return this.consumeWhiteSpace(), this.peekCodePoint(0) === -1 || this.peekCodePoint(0) === 41 ? (this.consumeCodePoint(), {
          type: 22,
          value: wr(...A)
        }) : (this.consumeBadUrlRemnants(), Yf);
      if (r === 34 || r === 39 || r === 40 || cM(r))
        return this.consumeBadUrlRemnants(), Yf;
      if (r === 92) if (vo(r, this.peekCodePoint(0))) A.push(this.consumeEscapedCodePoint());
      else
        return this.consumeBadUrlRemnants(), Yf;
      else A.push(r);
    }
  }
  consumeWhiteSpace() {
    for (; zf(this.peekCodePoint(0)); ) this.consumeCodePoint();
  }
  consumeBadUrlRemnants() {
    for (; ; ) {
      const A = this.consumeCodePoint();
      if (A === 41 || A === -1) return;
      vo(A, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
    }
  }
  consumeStringSlice(A) {
    let r = "";
    for (; A > 0; ) {
      const n = Math.min(5e4, A);
      r += wr(...this._value.splice(0, n)), A -= n;
    }
    return this._value.shift(), r;
  }
  consumeStringToken(A) {
    let t = "", r = 0;
    do {
      const n = this._value[r];
      if (n === -1 || n === void 0 || n === A)
        return t += this.consumeStringSlice(r), {
          type: 0,
          value: t
        };
      if (n === 10)
        return this._value.splice(0, r), bM;
      if (n === 92) {
        const i = this._value[r + 1];
        i !== -1 && i !== void 0 && (i === 10 ? (t += this.consumeStringSlice(r), r = -1, this._value.shift()) : vo(n, i) && (t += this.consumeStringSlice(r), t += wr(this.consumeEscapedCodePoint()), r = -1));
      }
      r++;
    } while (!0);
  }
  consumeNumber() {
    const A = [];
    let t = 4, r = this.peekCodePoint(0);
    for ((r === 43 || r === 45) && A.push(this.consumeCodePoint()); Qn(this.peekCodePoint(0)); ) A.push(this.consumeCodePoint());
    r = this.peekCodePoint(0);
    let n = this.peekCodePoint(1);
    if (r === 46 && Qn(n))
      for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), t = 8; Qn(this.peekCodePoint(0)); ) A.push(this.consumeCodePoint());
    r = this.peekCodePoint(0), n = this.peekCodePoint(1);
    const i = this.peekCodePoint(2);
    if ((r === 69 || r === 101) && ((n === 43 || n === 45) && Qn(i) || Qn(n)))
      for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), t = 8; Qn(this.peekCodePoint(0)); ) A.push(this.consumeCodePoint());
    return [uM(A), t];
  }
  consumeNumericToken() {
    const [A, t] = this.consumeNumber(), r = this.peekCodePoint(0);
    return Xf(r, this.peekCodePoint(1), this.peekCodePoint(2)) ? {
      type: 15,
      number: A,
      flags: t,
      unit: this.consumeName()
    } : r === 37 ? (this.consumeCodePoint(), {
      type: 16,
      number: A,
      flags: t
    }) : {
      type: 17,
      number: A,
      flags: t
    };
  }
  consumeEscapedCodePoint() {
    const A = this.consumeCodePoint();
    if (vc(A)) {
      let t = wr(A);
      for (; vc(this.peekCodePoint(0)) && t.length < 6; ) t += wr(this.consumeCodePoint());
      zf(this.peekCodePoint(0)) && this.consumeCodePoint();
      const r = parseInt(t, 16);
      return r === 0 || iM(r) || r > 1114111 ? ib : r;
    }
    return A === -1 ? ib : A;
  }
  consumeName() {
    let A = "";
    for (; ; ) {
      const t = this.consumeCodePoint();
      if (sb(t)) A += wr(t);
      else if (vo(t, this.peekCodePoint(0))) A += wr(this.consumeEscapedCodePoint());
      else
        return this.reconsumeCodePoint(t), A;
    }
  }
}, Ki._pool = [], Ki.MAX_POOL_SIZE = 40, Ki), WI = class Xd {
  constructor(A) {
    this._tokens = A;
  }
  static create(A) {
    const t = new z1();
    return t.write(A), new Xd(t.read());
  }
  static parseValue(A) {
    return Xd.create(A).parseComponentValue();
  }
  static parseValues(A) {
    return Xd.create(A).parseComponentValues();
  }
  parseComponentValue() {
    let A = this.consumeToken();
    for (; A.type === 31; ) A = this.consumeToken();
    if (A.type === 32) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
    this.reconsumeToken(A);
    const t = this.consumeComponentValue();
    do
      A = this.consumeToken();
    while (A.type === 31);
    if (A.type === 32) return t;
    throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
  }
  parseComponentValues() {
    const A = [];
    for (; ; ) {
      const t = this.consumeComponentValue();
      if (t.type === 32) return A;
      A.push(t);
    }
  }
  consumeComponentValue() {
    const A = this.consumeToken();
    switch (A.type) {
      case 11:
      case 28:
      case 2:
        return this.consumeSimpleBlock(A.type);
      case 19:
        return this.consumeFunction(A);
    }
    return A;
  }
  consumeSimpleBlock(A) {
    const t = {
      type: A,
      values: []
    };
    let r = this.consumeToken();
    for (; ; ) {
      if (r.type === 32 || HM(r, A)) return t;
      this.reconsumeToken(r), t.values.push(this.consumeComponentValue()), r = this.consumeToken();
    }
  }
  consumeFunction(A) {
    const t = {
      name: A.value,
      values: [],
      type: 18
    };
    for (; ; ) {
      const r = this.consumeToken();
      if (r.type === 32 || r.type === 3) return t;
      this.reconsumeToken(r), t.values.push(this.consumeComponentValue());
    }
  }
  consumeToken() {
    const A = this._tokens.shift();
    return typeof A > "u" ? $1 : A;
  }
  reconsumeToken(A) {
    this._tokens.unshift(A);
  }
};
const Xs = (e) => e.type === 15, Pr = (e) => e.type === 17, Oe = (e) => e.type === 20, LM = (e) => e.type === 0, Rh = (e, A) => Oe(e) && e.value === A, Xh = (e) => e.type !== 31, Vr = (e) => e.type !== 31 && e.type !== 4, bs = (e) => {
  const A = [];
  let t = [];
  return e.forEach((r) => {
    if (r.type === 4) {
      t.length && (A.push(t), t = []);
      return;
    }
    r.type !== 31 && t.push(r);
  }), t.length && A.push(t), A;
}, HM = (e, A) => A === 11 && e.type === 12 || A === 28 && e.type === 29 ? !0 : A === 2 && e.type === 3, TM = /(\d+(?:\.\d+)?|[+\-*/()])/g, jI = (e) => {
  const A = e.match(TM);
  if (!A) return NaN;
  const t = [], r = [], n = {
    "+": 1,
    "-": 1,
    "*": 2,
    "/": 2
  };
  for (const s of A) if (/^\d+(?:\.\d+)?$/.test(s)) t.push(parseFloat(s));
  else if (s === "(") r.push(s);
  else if (s === ")") {
    for (; r.length && r[r.length - 1] !== "("; ) t.push(r.pop());
    if (!r.length) return NaN;
    r.pop();
  } else {
    for (; r.length && n[r[r.length - 1]] >= n[s]; ) t.push(r.pop());
    r.push(s);
  }
  for (; r.length; ) {
    const s = r.pop();
    if (s === "(") return NaN;
    t.push(s);
  }
  const i = [];
  for (const s of t) if (typeof s == "number") i.push(s);
  else {
    const a = i.pop(), o = i.pop();
    if (o === void 0 || a === void 0) return NaN;
    switch (s) {
      case "+":
        i.push(o + a);
        break;
      case "-":
        i.push(o - a);
        break;
      case "*":
        i.push(o * a);
        break;
      case "/":
        i.push(a === 0 ? NaN : o / a);
        break;
      default:
        return NaN;
    }
  }
  return i.length === 1 ? i[0] : NaN;
}, or = (e, A, t) => Math.min(Math.max(e, A), t), oi = (e, A) => [
  e[0] * A[0] + e[1] * A[1] + e[2] * A[2],
  e[3] * A[0] + e[4] * A[1] + e[5] * A[2],
  e[6] * A[0] + e[7] * A[1] + e[8] * A[2]
], Vo = (e) => oi([
  3.2409699419045226,
  -1.537383177570094,
  -0.4986107602930034,
  -0.9692436362808796,
  1.8759675015077202,
  0.04155505740717559,
  0.05563007969699366,
  -0.20397695888897652,
  1.0569715142428786
], e), X1 = (e) => oi([
  0.41239079926595934,
  0.357584339383878,
  0.1804807884018343,
  0.21263900587151027,
  0.715168678767756,
  0.07219231536073371,
  0.01933081871559182,
  0.11919477979462598,
  0.9505321522496607
], e), Ac = (e) => e.map((A) => {
  const t = A < 0 ? -1 : 1, r = Math.abs(A);
  return r > 31308e-7 ? t * (1.055 * r ** (1 / 2.4) - 0.055) : 12.92 * A;
}), Y1 = (e) => e.map((A) => {
  const t = A < 0 ? -1 : 1, r = Math.abs(A);
  return r <= 0.04045 ? A / 12.92 : t * ((r + 0.055) / 1.055) ** 2.4;
}), _M = (e) => {
  const [A, t, r] = Ac(Vo([
    e[0],
    e[1],
    e[2]
  ]));
  return [
    A,
    t,
    r,
    e[3]
  ];
}, OM = (e) => {
  const [A, t, r] = Vo([
    e[0],
    e[1],
    e[2]
  ]);
  return [
    or(Math.round(A * 255), 0, 255),
    or(Math.round(t * 255), 0, 255),
    or(Math.round(r * 255), 0, 255),
    e[3]
  ];
}, Mo = (e) => e.type === 17 || e.type === 15, ft = (e) => e.type === 16 || Mo(e) || qI(e), qI = (e) => e.type === 17 && e._calcPercentage !== void 0, NM = (e) => e.type === 18 && e.name === "calc", DM = (e) => {
  const A = ab(e, 0);
  if (!A) return null;
  const t = ab(e, 100);
  if (!t) return null;
  const r = A.number, n = t.number - r;
  return n === 0 ? A : {
    type: 17,
    number: r,
    flags: 4,
    _calcPercentage: n,
    _calcPixelOffset: r
  };
}, $I = (e) => NM(e) ? DM(e) : ft(e) ? e : null, ab = (e, A = 0) => {
  const t = (r) => {
    let n = "";
    for (const i of r)
      if (i.type !== 31) {
        if (i.type === 18) if (i.name === "calc") {
          const s = t(i.values);
          if (s === null) return null;
          n += `(${s})`;
        } else return null;
        else if (i.type === 17) n += i.number.toString();
        else if (i.type === 15) i.unit === "px" ? n += i.number.toString() : i.unit === "rem" || i.unit === "em" ? n += (i.number * 16).toString() : n += i.number.toString();
        else if (i.type === 16) n += (i.number / 100 * A).toString();
        else if (i.type === 6) {
          const s = i.value;
          s === "+" || s === "-" || s === "*" || s === "/" ? n += ` ${s} ` : s === "(" ? n += "(" : s === ")" && (n += ")");
        }
      }
    return n;
  };
  try {
    const r = t(e.values);
    if (r === null || r.trim() === "") return null;
    const n = jI(r);
    if (typeof n == "number" && !isNaN(n)) return {
      type: 17,
      number: n,
      flags: 4
    };
  } catch {
    return null;
  }
  return null;
}, zI = (e) => e.length > 1 ? [e[0], e[1]] : [e[0]], br = {
  type: 17,
  number: 0,
  flags: 4
}, Ia = {
  type: 16,
  number: 50,
  flags: 4
}, ws = {
  type: 16,
  number: 100,
  flags: 4
}, Ju = (e, A, t) => {
  const [r, n] = e;
  return [Ie(r, A), Ie(typeof n < "u" ? n : r, t)];
}, Ie = (e, A) => {
  if (qI(e)) return e._calcPercentage / 100 * A + e._calcPixelOffset;
  if (e.type === 16) return e.number / 100 * A;
  if (Xs(e)) switch (e.unit) {
    case "rem":
    case "em":
      return 16 * e.number;
    default:
      return e.number;
  }
  return e.number;
}, XI = "deg", YI = "grad", JI = "rad", ZI = "turn", tu = {
  name: "angle",
  parse: (e, A) => {
    if (A.type === 15) switch (A.unit) {
      case XI:
        return Math.PI * A.number / 180;
      case YI:
        return Math.PI / 200 * A.number;
      case JI:
        return A.number;
      case ZI:
        return Math.PI * 2 * A.number;
    }
    throw new Error("Unsupported angle type");
  }
}, AS = (e) => e.type === 15 && (e.unit === XI || e.unit === YI || e.unit === JI || e.unit === ZI), eS = (e) => {
  switch (e.filter(Oe).map((A) => A.value).join(" ")) {
    case "to bottom right":
    case "to right bottom":
    case "left top":
    case "top left":
      return [br, br];
    case "to top":
    case "bottom":
      return Wi(0);
    case "to bottom left":
    case "to left bottom":
    case "right top":
    case "top right":
      return [br, ws];
    case "to right":
    case "left":
      return Wi(90);
    case "to top left":
    case "to left top":
    case "right bottom":
    case "bottom right":
      return [ws, ws];
    case "to bottom":
    case "top":
      return Wi(180);
    case "to top right":
    case "to right top":
    case "left bottom":
    case "bottom left":
      return [ws, br];
    case "to left":
    case "right":
      return Wi(270);
  }
  return 0;
}, Wi = (e) => Math.PI * e / 180, Sa = (e) => (255 & e) === 0, _t = (e) => {
  const A = 255 & e, t = 255 & e >> 8, r = 255 & e >> 16, n = 255 & e >> 24;
  return A < 255 ? `rgba(${n},${r},${t},${A / 255})` : `rgb(${n},${r},${t})`;
}, vs = (e, A, t, r) => (e << 24 | A << 16 | t << 8 | Math.round(r * 255) << 0) >>> 0, yo = (e, A) => {
  if (e.type === 17) return e.number;
  if (e.type === 16) {
    const t = A === 3 ? 1 : 255;
    return A === 3 ? e.number / 100 * t : Math.round(e.number / 100 * t);
  }
  return 0;
}, ec = (e) => (e[0].type === 20 ? e[0].value : "unknown") === "from", RM = (e) => vs(or(Math.round(e[0] * 255), 0, 255), or(Math.round(e[1] * 255), 0, 255), or(Math.round(e[2] * 255), 0, 255), or(e[3], 0, 1)), Ly = ([e, A, t, r]) => {
  const n = Ac([
    e,
    A,
    t
  ]);
  return vs(or(Math.round(n[0] * 255), 0, 255), or(Math.round(n[1] * 255), 0, 255), or(Math.round(n[2] * 255), 0, 255), r);
}, Yh = (e) => {
  const A = Vo([
    e[0],
    e[1],
    e[2]
  ]);
  return Ly([
    A[0],
    A[1],
    A[2],
    e[3]
  ]);
}, MM = (e, A) => {
  if (ec(A.filter(Vr))) throw new Error("Relative color not supported for lab()");
  const [t, r, n, i] = ep(A), s = Ac(Vo(np([
    t,
    r,
    n
  ])));
  return vs(or(Math.round(s[0] * 255), 0, 255), or(Math.round(s[1] * 255), 0, 255), or(Math.round(s[2] * 255), 0, 255), i);
}, PM = (e, A) => {
  if (ec(A.filter(Vr))) throw new Error("Relative color not supported for oklab()");
  const [t, r, n, i] = ep(A), s = Ac(Vo(rp([
    t,
    r,
    n
  ])));
  return vs(or(Math.round(s[0] * 255), 0, 255), or(Math.round(s[1] * 255), 0, 255), or(Math.round(s[2] * 255), 0, 255), i);
}, kM = (e, A) => {
  if (ec(A.filter(Vr))) throw new Error("Relative color not supported for oklch()");
  const [t, r, n, i] = nS(A), s = Ac(Vo(rp(tp([
    t,
    r,
    n
  ]))));
  return vs(or(Math.round(s[0] * 255), 0, 255), or(Math.round(s[1] * 255), 0, 255), or(Math.round(s[2] * 255), 0, 255), i);
}, KM = (e, A) => {
  if (ec(A.filter(Vr))) throw new Error("Relative color not supported for lch()");
  const [t, r, n, i] = rS(A), s = Ac(Vo(np(tp([
    t,
    r,
    n
  ]))));
  return vs(or(Math.round(s[0] * 255), 0, 255), or(Math.round(s[1] * 255), 0, 255), or(Math.round(s[2] * 255), 0, 255), i);
}, tS = (e, A) => {
  const [t, r, n, i] = A.filter(Vr);
  return [
    (t.type === 17 ? Wi(t.number) : tu.parse(e, t)) / (Math.PI * 2),
    ft(r) ? r.number / 100 : 0,
    ft(n) ? n.number / 100 : 0,
    typeof i < "u" && ft(i) ? Ie(i, 1) : 1
  ];
}, ob = (e, A) => {
  if (ec(A)) throw new Error("Relative color not supported for hsl()");
  const [t, r, n, i] = tS(e, A), s = sS([
    t,
    r,
    n
  ]);
  return vs(s[0] * 255, s[1] * 255, s[2] * 255, r === 0 ? 1 : i);
}, rS = (e) => {
  const A = e.filter(Vr);
  return [
    ft(A[0]) ? A[0].number : 0,
    ft(A[1]) ? A[1].number : 0,
    Pr(A[2]) || Xs(A[2]) ? A[2].number : 0,
    typeof A[4] < "u" && ft(A[4]) ? Ie(A[4], 1) : 1
  ];
}, ep = (e) => {
  const A = e.filter(Vr);
  return [
    A[0].type === 16 ? A[0].number / 100 : Pr(A[0]) ? A[0].number : 0,
    A[1].type === 16 ? A[1].number / 100 : Pr(A[1]) ? A[1].number : 0,
    Pr(A[2]) || Xs(A[2]) ? A[2].number : 0,
    typeof A[4] < "u" && ft(A[4]) ? Ie(A[4], 1) : 1
  ];
}, nS = (e) => {
  const A = e.filter(Vr);
  return [
    A[0].type === 16 ? A[0].number / 100 : Pr(A[0]) ? A[0].number : 0,
    A[1].type === 16 ? A[1].number / 100 : Pr(A[1]) ? A[1].number : 0,
    Pr(A[2]) || Xs(A[2]) ? A[2].number : 0,
    typeof A[4] < "u" && ft(A[4]) ? Ie(A[4], 1) : 1
  ];
}, iS = (e) => oi([
  1.0479297925449969,
  0.022946870601609652,
  -0.05019226628920524,
  0.02962780877005599,
  0.9904344267538799,
  -0.017073799063418826,
  -0.009243040646204504,
  0.015055191490298152,
  0.7518742814281371
], e), Hy = (e) => oi([
  0.955473421488075,
  -0.02309845494876471,
  0.06325924320057072,
  -0.0283697093338637,
  1.0099953980813041,
  0.021041441191917323,
  0.012314014864481998,
  -0.020507649298898964,
  1.330365926242124
], e), LB = (e, A, t) => (t < 0 && (t += 1), t >= 1 && (t -= 1), t < 1 / 6 ? (A - e) * t * 6 + e : t < 1 / 2 ? A : t < 2 / 3 ? (A - e) * 6 * (2 / 3 - t) + e : e), sS = ([e, A, t]) => {
  if (A === 0) return [
    t * 255,
    t * 255,
    t * 255
  ];
  const r = t <= 0.5 ? t * (A + 1) : t + A - t * A, n = t * 2 - r;
  return [
    LB(n, r, e + 1 / 3),
    LB(n, r, e),
    LB(n, r, e - 1 / 3)
  ];
}, tp = ([e, A, t]) => (A < 0 && (A = 0), isNaN(t) && (t = 0), [
  e,
  A * Math.cos(t * Math.PI / 180),
  A * Math.sin(t * Math.PI / 180)
]), rp = (e) => oi([
  1.2268798758459243,
  -0.5578149944602171,
  0.2813910456659647,
  -0.0405757452148008,
  1.112286803280317,
  -0.0717110580655164,
  -0.0763729366746601,
  -0.4214933324022432,
  1.5869240198367816
], oi([
  1,
  0.3963377773761749,
  0.2158037573099136,
  1,
  -0.1055613458156586,
  -0.0638541728258133,
  1,
  -0.0894841775298119,
  -1.2914855480194092
], e).map((A) => A ** 3)), np = (e) => {
  const A = (e[0] + 16) / 116, t = e[1] / 500 + A, r = A - e[2] / 200, n = 24389 / 27, i = 24 / 116, s = [
    (t > i ? t ** 3 : (116 * t - 16) / n) * 0.3457 / 0.3585,
    e[0] > 8 ? A ** 3 : e[0] / n,
    (r > i ? r ** 3 : (116 * r - 16) / n) * 0.2958 / 0.3585
  ];
  return Hy([
    s[0],
    s[1],
    s[2]
  ]);
}, VM = (e, A) => {
  const t = A.filter(Vr);
  if (t.length === 3) {
    const [r, n, i] = t.map(yo), s = Y1([
      r / 255,
      n / 255,
      i / 255
    ]), [a, o, l] = X1([
      s[0],
      s[1],
      s[2]
    ]);
    return [
      a,
      o,
      l,
      1
    ];
  }
  if (t.length === 4) {
    const [r, n, i, s] = t.map(yo), a = Y1([
      r / 255,
      n / 255,
      i / 255
    ]), [o, l, c] = X1([
      a[0],
      a[1],
      a[2]
    ]);
    return [
      o,
      l,
      c,
      s
    ];
  }
  return [
    0,
    0,
    0,
    1
  ];
}, GM = (e, A) => {
  const [t, r, n, i] = tS(e, A), s = Y1(sS([
    t,
    r,
    n
  ])), [a, o, l] = X1([
    s[0],
    s[1],
    s[2]
  ]);
  return [
    a,
    o,
    l,
    i
  ];
}, WM = (e, A) => {
  const [t, r, n, i] = ep(A), [s, a, o] = np([
    t,
    r,
    n
  ]);
  return [
    s,
    a,
    o,
    i
  ];
}, jM = (e, A) => {
  const [t, r, n, i] = rS(A), [s, a, o] = np(tp([
    t,
    r,
    n
  ]));
  return [
    s,
    a,
    o,
    i
  ];
}, qM = (e, A) => {
  const [t, r, n, i] = nS(A), [s, a, o] = rp(tp([
    t,
    r,
    n
  ]));
  return [
    s,
    a,
    o,
    i
  ];
}, $M = (e, A) => {
  const [t, r, n, i] = ep(A), [s, a, o] = rp([
    t,
    r,
    n
  ]);
  return [
    s,
    a,
    o,
    i
  ];
}, zM = (e) => Hy([
  e[0],
  e[1],
  e[2]
]), lb = (e) => e, XM = (e) => {
  const [A, t, r] = iS([
    e[0],
    e[2],
    e[3]
  ]);
  return [
    A,
    t,
    r,
    e[3]
  ];
}, cb = (e) => Yh([
  e[0],
  e[1],
  e[2],
  e[3]
]), YM = (e) => {
  const A = zM([
    e[0],
    e[1],
    e[2]
  ]);
  return Yh([
    A[0],
    A[1],
    A[2],
    e[3]
  ]);
}, JM = (e) => oi([
  0.4865709486482162,
  0.26566769316909306,
  0.1982172852343625,
  0.2289745640697488,
  0.6917385218365064,
  0.079286914093745,
  0,
  0.04511338185890264,
  1.043944368900976
], e), ZM = (e) => oi([
  2.493496911941425,
  -0.9313836179191239,
  -0.40271078445071684,
  -0.8294889695615747,
  1.7626640603183463,
  0.023624685841943577,
  0.03584583024378447,
  -0.07617238926804182,
  0.9568845240076872
], e), AP = (e) => e.map((A) => {
  const t = A < 0 ? -1 : 1;
  return A * t <= 0.04045 ? A / 12.92 : t * ((A + 0.055) / 1.055) ** 2.4 || 0;
}), eP = (e) => Ac(e), tP = (e) => {
  const A = AP([
    e[0],
    e[1],
    e[2]
  ]);
  return JM([
    A[0],
    A[1],
    A[2]
  ]);
}, rP = (e) => {
  const [A, t, r] = eP(ZM([
    e[0],
    e[1],
    e[2]
  ]));
  return [
    A,
    t,
    r,
    e[3]
  ];
}, nP = (e) => {
  const A = tP([
    e[0],
    e[1],
    e[2]
  ]);
  return Yh([
    A[0],
    A[1],
    A[2],
    e[3]
  ]);
}, iP = (e) => oi([
  2.0415879038107465,
  -0.5650069742788596,
  -0.34473135077832956,
  -0.9692436362808795,
  1.8759675015077202,
  0.04155505740717557,
  0.013444280632031142,
  -0.11836239223101838,
  1.0151749943912054
], e), sP = (e) => oi([
  0.5766690429101305,
  0.1855582379065463,
  0.1882286462349947,
  0.29734497525053605,
  0.6273635662554661,
  0.0752914584939978,
  0.02703136138641234,
  0.07068885253582723,
  0.9913375368376388
], e), aP = (e) => {
  const A = e.map((t) => (t < 0 ? -1 : 1) * Math.abs(t) ** 2.19921875);
  return [
    A[0],
    A[1],
    A[2]
  ];
}, oP = (e) => {
  const A = e.map((t) => (t < 0 ? -1 : 1) * Math.abs(t) ** 0.4547069271758437);
  return [
    A[0],
    A[1],
    A[2]
  ];
}, lP = (e) => {
  const [A, t, r] = oP(iP([
    e[0],
    e[1],
    e[2]
  ]));
  return [
    A,
    t,
    r,
    e[3]
  ];
}, cP = (e) => {
  const A = Vo(sP(aP([
    e[0],
    e[1],
    e[2]
  ])));
  return Ly([
    A[0],
    A[1],
    A[2],
    e[3]
  ]);
}, uP = (e) => oi([
  0.7977666449006423,
  0.13518129740053308,
  0.0313477341283922,
  0.2880748288194013,
  0.711835234241873,
  8993693872564e-17,
  0,
  0,
  0.8251046025104602
], e), hP = (e) => oi([
  1.3457868816471583,
  -0.25557208737979464,
  -0.05110186497554526,
  -0.5446307051249019,
  1.5082477428451468,
  0.02052744743642139,
  0,
  0,
  1.2119675456389452
], e), fP = (e) => e.map((A) => A < 16 / 512 ? A / 16 : A ** 1.8), dP = (e) => e.map((A) => A > 1 / 512 ? A ** (1 / 1.8) : A * 16), gP = (e) => {
  const A = fP([
    e[0],
    e[1],
    e[2]
  ]);
  return Hy(uP([
    A[0],
    A[1],
    A[2]
  ]));
}, pP = (e) => {
  const [A, t, r] = dP(hP(iS([
    e[0],
    e[1],
    e[2]
  ])));
  return [
    A,
    t,
    r,
    e[3]
  ];
}, BP = (e) => {
  const A = gP([
    e[0],
    e[1],
    e[2]
  ]);
  return Yh([
    A[0],
    A[1],
    A[2],
    e[3]
  ]);
}, mg = 1.09929682680944, aS = 0.018053968510807, wP = (e) => e.map(function(A) {
  return A < aS * 4.5 ? A / 4.5 : Math.pow((A + mg - 1) / mg, 1 / 0.45);
}), mP = (e) => e.map(function(A) {
  return A >= aS ? mg * Math.pow(A, 0.45) - (mg - 1) : 4.5 * A;
}), vP = (e) => oi([
  0.6369580483012914,
  0.14461690358620832,
  0.1688809751641721,
  0.2627002120112671,
  0.6779980715188708,
  0.05930171646986196,
  0,
  0.028072693049087428,
  1.060985057710791
], e), yP = (e) => oi([
  1.716651187971268,
  -0.355670783776392,
  -0.25336628137366,
  -0.666684351832489,
  1.616481236634939,
  0.0157685458139111,
  0.017639857445311,
  -0.042770613257809,
  0.942103121235474
], e), CP = (e) => {
  const A = wP([
    e[0],
    e[1],
    e[2]
  ]);
  return vP([
    A[0],
    A[1],
    A[2]
  ]);
}, bP = (e) => {
  const [A, t, r] = mP(yP([
    e[0],
    e[1],
    e[2]
  ]));
  return [
    A,
    t,
    r,
    e[3]
  ];
}, FP = (e) => {
  const A = CP([
    e[0],
    e[1],
    e[2]
  ]);
  return Yh([
    A[0],
    A[1],
    A[2],
    e[3]
  ]);
}, To = {
  name: "color",
  parse: (e, A) => {
    if (A.type === 18) {
      const t = xP[A.name];
      if (typeof t > "u") throw new Error(`Attempting to parse an unsupported color function "${A.name}"`);
      return t(e, A.values);
    }
    if (A.type === 5) {
      const [t, r, n, i] = oS(A);
      return vs(t, r, n, i);
    }
    if (A.type === 20) {
      const t = $s[A.value.toUpperCase()];
      if (typeof t < "u") return t;
    }
    return $s.TRANSPARENT;
  }
}, oS = (e) => {
  if (e.value.length === 3) {
    const A = e.value.substring(0, 1), t = e.value.substring(1, 2), r = e.value.substring(2, 3);
    return [
      parseInt(A + A, 16),
      parseInt(t + t, 16),
      parseInt(r + r, 16),
      1
    ];
  }
  if (e.value.length === 4) {
    const A = e.value.substring(0, 1), t = e.value.substring(1, 2), r = e.value.substring(2, 3), n = e.value.substring(3, 4);
    return [
      parseInt(A + A, 16),
      parseInt(t + t, 16),
      parseInt(r + r, 16),
      parseInt(n + n, 16) / 255
    ];
  }
  if (e.value.length === 6) {
    const A = e.value.substring(0, 2), t = e.value.substring(2, 4), r = e.value.substring(4, 6);
    return [
      parseInt(A, 16),
      parseInt(t, 16),
      parseInt(r, 16),
      1
    ];
  }
  if (e.value.length === 8) {
    const A = e.value.substring(0, 2), t = e.value.substring(2, 4), r = e.value.substring(4, 6), n = e.value.substring(6, 8);
    return [
      parseInt(A, 16),
      parseInt(t, 16),
      parseInt(r, 16),
      parseInt(n, 16) / 255
    ];
  }
  return [
    0,
    0,
    0,
    1
  ];
}, ub = (e, A) => {
  const t = A.filter(Vr);
  if (ec(t)) throw new Error("Relative color not supported for rgb()");
  if (t.length === 3) {
    const [r, n, i] = t.map(yo);
    return vs(r, n, i, 1);
  }
  if (t.length === 4) {
    const [r, n, i, s] = t.map(yo);
    return vs(r, n, i, s);
  }
  return t.length === 5 && t[3].type === 6 && t[3].value === "/" ? vs(yo(t[0], 0), yo(t[1], 1), yo(t[2], 2), yo(t[4], 3)) : 0;
}, QP = (e, A) => {
  const t = A.filter(Vr), r = t[0].type === 20 ? t[0].value : "unknown";
  if (ec(t)) {
    const n = (y, m) => {
      if (Pr(m)) return m.number;
      const C = (F) => F === "r" || F === "x" ? 0 : F === "g" || F === "y" ? 1 : 2;
      if (Oe(m)) return y[C(m.value)];
      const Q = (F) => {
        const T = F.filter(Vr);
        let V = "(";
        for (const M of T) V += M.type === 18 && M.name === "calc" ? Q(M.values) : Pr(M) ? M.number : M.type === 6 || Oe(M) ? M.value : "";
        return V += ")", V;
      };
      if (m.type === 18) {
        const F = m.values.filter(Vr);
        if (m.name === "calc") return jI(Q(F).replace(/r|x/, y[0].toString()).replace(/g|y/, y[1].toString()).replace(/b|z/, y[2].toString()));
      }
      return null;
    }, i = t[1].type === 18 ? t[1].name : Oe(t[1]) || t[1].type === 5 ? "rgb" : "unknown", s = Oe(t[2]) ? t[2].value : "unknown";
    let a = t[1].type === 18 ? t[1].values : Oe(t[1]) ? [t[1]] : [];
    if (Oe(t[1])) {
      if (typeof $s[t[1].value.toUpperCase()] > "u") throw new Error("Attempting to use unknown color in relative color 'from'");
      {
        const y = jc(e, t[1].value), m = 255 & y, C = 255 & y >> 8, Q = 255 & y >> 16;
        a = [
          {
            type: 17,
            number: 255 & y >> 24,
            flags: 1
          },
          {
            type: 17,
            number: Q,
            flags: 1
          },
          {
            type: 17,
            number: C,
            flags: 1
          },
          {
            type: 17,
            number: m > 1 ? m / 255 : m,
            flags: 1
          }
        ];
      }
    } else if (t[1].type === 5) {
      const [y, m, C, Q] = oS(t[1]);
      a = [
        {
          type: 17,
          number: y,
          flags: 1
        },
        {
          type: 17,
          number: m,
          flags: 1
        },
        {
          type: 17,
          number: C,
          flags: 1
        },
        {
          type: 17,
          number: Q > 1 ? Q / 255 : Q,
          flags: 1
        }
      ];
    }
    if (a.length === 0) throw new Error("Attempting to use unknown color in relative color 'from'");
    if (s === "unknown") throw new Error("Attempting to use unknown colorspace in relative color 'to'");
    const o = UP[i], l = EP[s], c = hb[s];
    if (typeof o > "u") throw new Error(`Attempting to parse an unsupported color space "${i}" for color() function`);
    if (typeof l > "u") throw new Error(`Attempting to parse an unsupported color space "${s}" for color() function`);
    const u = l(o(e, a)), d = n(u, t[3]), h = n(u, t[4]), p = n(u, t[5]), B = t.length > 6 && t[6].type === 6 && t[6].value === "/" && Pr(t[7]) ? t[7].number : 1;
    if (d === null || h === null || p === null) throw new Error("Invalid relative color in color() function");
    return c([
      d,
      h,
      p,
      B
    ]);
  } else {
    const n = r, i = hb[n];
    if (typeof i > "u") throw new Error(`Attempting to parse an unsupported color space "${n}" for color() function`);
    return i([
      Pr(t[1]) ? t[1].number : 0,
      Pr(t[2]) ? t[2].number : 0,
      Pr(t[3]) ? t[3].number : 0,
      t.length > 4 && t[4].type === 6 && t[4].value === "/" && Pr(t[5]) ? t[5].number : 1
    ]);
  }
}, hb = {
  srgb: RM,
  "srgb-linear": Ly,
  "display-p3": nP,
  "a98-rgb": cP,
  "prophoto-rgb": BP,
  xyz: cb,
  "xyz-d50": YM,
  "xyz-d65": cb,
  rec2020: FP
}, UP = {
  rgb: VM,
  hsl: GM,
  lab: WM,
  lch: jM,
  oklab: $M,
  oklch: qM
}, EP = {
  srgb: _M,
  "srgb-linear": OM,
  "display-p3": rP,
  "a98-rgb": lP,
  "prophoto-rgb": pP,
  xyz: lb,
  "xyz-d50": XM,
  "xyz-d65": lb,
  rec2020: bP
}, xP = {
  hsl: ob,
  hsla: ob,
  rgb: ub,
  rgba: ub,
  lch: KM,
  oklch: kM,
  oklab: PM,
  lab: MM,
  color: QP
}, jc = (e, A) => To.parse(e, WI.create(A).parseComponentValue()), $s = {
  ALICEBLUE: 4042850303,
  ANTIQUEWHITE: 4209760255,
  AQUA: 16777215,
  AQUAMARINE: 2147472639,
  AZURE: 4043309055,
  BEIGE: 4126530815,
  BISQUE: 4293182719,
  BLACK: 255,
  BLANCHEDALMOND: 4293643775,
  BLUE: 65535,
  BLUEVIOLET: 2318131967,
  BROWN: 2771004159,
  BURLYWOOD: 3736635391,
  CADETBLUE: 1604231423,
  CHARTREUSE: 2147418367,
  CHOCOLATE: 3530104575,
  CORAL: 4286533887,
  CORNFLOWERBLUE: 1687547391,
  CORNSILK: 4294499583,
  CRIMSON: 3692313855,
  CYAN: 16777215,
  DARKBLUE: 35839,
  DARKCYAN: 9145343,
  DARKGOLDENROD: 3095837695,
  DARKGRAY: 2846468607,
  DARKGREEN: 6553855,
  DARKGREY: 2846468607,
  DARKKHAKI: 3182914559,
  DARKMAGENTA: 2332068863,
  DARKOLIVEGREEN: 1433087999,
  DARKORANGE: 4287365375,
  DARKORCHID: 2570243327,
  DARKRED: 2332033279,
  DARKSALMON: 3918953215,
  DARKSEAGREEN: 2411499519,
  DARKSLATEBLUE: 1211993087,
  DARKSLATEGRAY: 793726975,
  DARKSLATEGREY: 793726975,
  DARKTURQUOISE: 13554175,
  DARKVIOLET: 2483082239,
  DEEPPINK: 4279538687,
  DEEPSKYBLUE: 12582911,
  DIMGRAY: 1768516095,
  DIMGREY: 1768516095,
  DODGERBLUE: 512819199,
  FIREBRICK: 2988581631,
  FLORALWHITE: 4294635775,
  FORESTGREEN: 579543807,
  FUCHSIA: 4278255615,
  GAINSBORO: 3705462015,
  GHOSTWHITE: 4177068031,
  GOLD: 4292280575,
  GOLDENROD: 3668254975,
  GRAY: 2155905279,
  GREEN: 8388863,
  GREENYELLOW: 2919182335,
  GREY: 2155905279,
  HONEYDEW: 4043305215,
  HOTPINK: 4285117695,
  INDIANRED: 3445382399,
  INDIGO: 1258324735,
  IVORY: 4294963455,
  KHAKI: 4041641215,
  LAVENDER: 3873897215,
  LAVENDERBLUSH: 4293981695,
  LAWNGREEN: 2096890111,
  LEMONCHIFFON: 4294626815,
  LIGHTBLUE: 2916673279,
  LIGHTCORAL: 4034953471,
  LIGHTCYAN: 3774873599,
  LIGHTGOLDENRODYELLOW: 4210742015,
  LIGHTGRAY: 3553874943,
  LIGHTGREEN: 2431553791,
  LIGHTGREY: 3553874943,
  LIGHTPINK: 4290167295,
  LIGHTSALMON: 4288707327,
  LIGHTSEAGREEN: 548580095,
  LIGHTSKYBLUE: 2278488831,
  LIGHTSLATEGRAY: 2005441023,
  LIGHTSLATEGREY: 2005441023,
  LIGHTSTEELBLUE: 2965692159,
  LIGHTYELLOW: 4294959359,
  LIME: 16711935,
  LIMEGREEN: 852308735,
  LINEN: 4210091775,
  MAGENTA: 4278255615,
  MAROON: 2147483903,
  MEDIUMAQUAMARINE: 1724754687,
  MEDIUMBLUE: 52735,
  MEDIUMORCHID: 3126187007,
  MEDIUMPURPLE: 2473647103,
  MEDIUMSEAGREEN: 1018393087,
  MEDIUMSLATEBLUE: 2070474495,
  MEDIUMSPRINGGREEN: 16423679,
  MEDIUMTURQUOISE: 1221709055,
  MEDIUMVIOLETRED: 3340076543,
  MIDNIGHTBLUE: 421097727,
  MINTCREAM: 4127193855,
  MISTYROSE: 4293190143,
  MOCCASIN: 4293178879,
  NAVAJOWHITE: 4292783615,
  NAVY: 33023,
  OLDLACE: 4260751103,
  OLIVE: 2155872511,
  OLIVEDRAB: 1804477439,
  ORANGE: 4289003775,
  ORANGERED: 4282712319,
  ORCHID: 3664828159,
  PALEGOLDENROD: 4008225535,
  PALEGREEN: 2566625535,
  PALETURQUOISE: 2951671551,
  PALEVIOLETRED: 3681588223,
  PAPAYAWHIP: 4293907967,
  PEACHPUFF: 4292524543,
  PERU: 3448061951,
  PINK: 4290825215,
  PLUM: 3718307327,
  POWDERBLUE: 2967529215,
  PURPLE: 2147516671,
  REBECCAPURPLE: 1714657791,
  RED: 4278190335,
  ROSYBROWN: 3163525119,
  ROYALBLUE: 1097458175,
  SADDLEBROWN: 2336560127,
  SALMON: 4202722047,
  SANDYBROWN: 4104413439,
  SEAGREEN: 780883967,
  SEASHELL: 4294307583,
  SIENNA: 2689740287,
  SILVER: 3233857791,
  SKYBLUE: 2278484991,
  SLATEBLUE: 1784335871,
  SLATEGRAY: 1887473919,
  SLATEGREY: 1887473919,
  SNOW: 4294638335,
  SPRINGGREEN: 16744447,
  STEELBLUE: 1182971135,
  TAN: 3535047935,
  TEAL: 8421631,
  THISTLE: 3636451583,
  TOMATO: 4284696575,
  TRANSPARENT: 0,
  TURQUOISE: 1088475391,
  VIOLET: 4001558271,
  WHEAT: 4125012991,
  WHITE: 4294967295,
  WHITESMOKE: 4126537215,
  YELLOW: 4294902015,
  YELLOWGREEN: 2597139199
}, Il = (e) => e.nodeType === Node.ELEMENT_NODE, lS = (e) => e.nodeType === Node.TEXT_NODE, Sl = (e) => typeof e.className == "object", Mh = (e) => Il(e) && typeof e.style < "u" && !Sl(e), IP = (e) => e.tagName === "INPUT", SP = (e) => e.tagName === "HTML", cS = (e) => e.tagName === "svg", Ty = (e) => e.tagName === "BODY", uS = (e) => e.tagName === "CANVAS", fb = (e) => e.tagName === "VIDEO", J1 = (e) => e.tagName === "IMG", hS = (e) => e.tagName === "IFRAME", fS = (e) => e.tagName === "STYLE", LP = (e) => e.tagName === "SCRIPT", vg = (e) => e.tagName === "TEXTAREA", yg = (e) => e.tagName === "SELECT", Zu = (e) => e.tagName === "SLOT", HP = (e) => e.tagName === "LI", TP = (e) => e.tagName === "OL", db = (e) => !Sl(e) && e.tagName.indexOf("-") > 0, _P = /* @__PURE__ */ new Set([
  "IMG",
  "VIDEO",
  "AUDIO",
  "CANVAS",
  "IFRAME",
  "INPUT",
  "TEXTAREA",
  "SELECT",
  "BR",
  "HR",
  "META",
  "LINK",
  "BASE",
  "COL",
  "SOURCE",
  "TRACK",
  "WBR",
  "AREA",
  "PARAM",
  "EMBED",
  "OBJECT"
]), OP = (e) => !Sl(e) && !_P.has(e.tagName), Z1 = {
  name: "list-style-type",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "disc":
        return 0;
      case "circle":
        return 1;
      case "square":
        return 2;
      case "decimal":
        return 3;
      case "cjk-decimal":
        return 4;
      case "decimal-leading-zero":
        return 5;
      case "lower-roman":
        return 6;
      case "upper-roman":
        return 7;
      case "lower-greek":
        return 8;
      case "lower-alpha":
        return 9;
      case "upper-alpha":
        return 10;
      case "arabic-indic":
        return 11;
      case "armenian":
        return 12;
      case "bengali":
        return 13;
      case "cambodian":
        return 14;
      case "cjk-earthly-branch":
        return 15;
      case "cjk-heavenly-stem":
        return 16;
      case "cjk-ideographic":
        return 17;
      case "devanagari":
        return 18;
      case "ethiopic-numeric":
        return 19;
      case "georgian":
        return 20;
      case "gujarati":
        return 21;
      case "gurmukhi":
        return 22;
      case "hebrew":
        return 52;
      case "hiragana":
        return 23;
      case "hiragana-iroha":
        return 24;
      case "japanese-formal":
        return 25;
      case "japanese-informal":
        return 26;
      case "kannada":
        return 27;
      case "katakana":
        return 28;
      case "katakana-iroha":
        return 29;
      case "khmer":
        return 30;
      case "korean-hangul-formal":
        return 31;
      case "korean-hanja-formal":
        return 32;
      case "korean-hanja-informal":
        return 33;
      case "lao":
        return 34;
      case "lower-armenian":
        return 35;
      case "malayalam":
        return 36;
      case "mongolian":
        return 37;
      case "myanmar":
        return 38;
      case "oriya":
        return 39;
      case "persian":
        return 40;
      case "simp-chinese-formal":
        return 41;
      case "simp-chinese-informal":
        return 42;
      case "tamil":
        return 43;
      case "telugu":
        return 44;
      case "thai":
        return 45;
      case "tibetan":
        return 46;
      case "trad-chinese-formal":
        return 47;
      case "trad-chinese-informal":
        return 48;
      case "upper-armenian":
        return 49;
      case "disclosure-open":
        return 50;
      case "disclosure-closed":
        return 51;
      default:
        return -1;
    }
  }
}, zr = (e, A) => (e & A) !== 0;
var NP = class {
  constructor() {
    this.counters = {};
  }
  getCounterValue(A) {
    const t = this.counters[A];
    return t && t.length ? t[t.length - 1] : 1;
  }
  getCounterValues(A) {
    const t = this.counters[A];
    return t || [];
  }
  pop(A) {
    A.forEach((t) => this.counters[t].pop());
  }
  parse(A) {
    const t = A.counterIncrement, r = A.counterReset;
    let n = !0;
    t !== null && t.forEach((s) => {
      const a = this.counters[s.counter];
      a && s.increment !== 0 && (n = !1, a.length || a.push(1), a[Math.max(0, a.length - 1)] += s.increment);
    });
    const i = [];
    return n && r.forEach((s) => {
      let a = this.counters[s.counter];
      i.push(s.counter), a || (a = this.counters[s.counter] = []), a.push(s.reset);
    }), i;
  }
};
const gb = {
  integers: [
    1e3,
    900,
    500,
    400,
    100,
    90,
    50,
    40,
    10,
    9,
    5,
    4,
    1
  ],
  values: [
    "M",
    "CM",
    "D",
    "CD",
    "C",
    "XC",
    "L",
    "XL",
    "X",
    "IX",
    "V",
    "IV",
    "I"
  ]
}, pb = {
  integers: [
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "Ք",
    "Փ",
    "Ւ",
    "Ց",
    "Ր",
    "Տ",
    "Վ",
    "Ս",
    "Ռ",
    "Ջ",
    "Պ",
    "Չ",
    "Ո",
    "Շ",
    "Ն",
    "Յ",
    "Մ",
    "Ճ",
    "Ղ",
    "Ձ",
    "Հ",
    "Կ",
    "Ծ",
    "Խ",
    "Լ",
    "Ի",
    "Ժ",
    "Թ",
    "Ը",
    "Է",
    "Զ",
    "Ե",
    "Դ",
    "Գ",
    "Բ",
    "Ա"
  ]
}, DP = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    19,
    18,
    17,
    16,
    15,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "י׳",
    "ט׳",
    "ח׳",
    "ז׳",
    "ו׳",
    "ה׳",
    "ד׳",
    "ג׳",
    "ב׳",
    "א׳",
    "ת",
    "ש",
    "ר",
    "ק",
    "צ",
    "פ",
    "ע",
    "ס",
    "נ",
    "מ",
    "ל",
    "כ",
    "יט",
    "יח",
    "יז",
    "טז",
    "טו",
    "י",
    "ט",
    "ח",
    "ז",
    "ו",
    "ה",
    "ד",
    "ג",
    "ב",
    "א"
  ]
}, RP = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "ჵ",
    "ჰ",
    "ჯ",
    "ჴ",
    "ხ",
    "ჭ",
    "წ",
    "ძ",
    "ც",
    "ჩ",
    "შ",
    "ყ",
    "ღ",
    "ქ",
    "ფ",
    "ჳ",
    "ტ",
    "ს",
    "რ",
    "ჟ",
    "პ",
    "ო",
    "ჲ",
    "ნ",
    "მ",
    "ლ",
    "კ",
    "ი",
    "თ",
    "ჱ",
    "ზ",
    "ვ",
    "ე",
    "დ",
    "გ",
    "ბ",
    "ა"
  ]
}, yc = (e, A, t, r, n, i) => e < A || e > t ? Ph(e, n, i.length > 0) : r.integers.reduce((s, a, o) => {
  for (; e >= a; )
    e -= a, s += r.values[o];
  return s;
}, "") + i, dS = (e, A, t, r) => {
  let n = "";
  do
    t || e--, n = r(e) + n, e /= A;
  while (e * A >= A);
  return n;
}, pr = (e, A, t, r, n) => {
  const i = t - A + 1;
  return (e < 0 ? "-" : "") + (dS(Math.abs(e), i, r, (s) => wr(Math.floor(s % i) + A)) + n);
}, hl = (e, A, t = ". ") => {
  const r = A.length;
  return dS(Math.abs(e), r, !1, (n) => A[Math.floor(n % r)]) + t;
}, MP = 1, PP = 2, kP = 4, KP = 8, Ba = (e, A, t, r, n, i) => {
  if (e < -9999 || e > 9999) return Ph(e, 4, n.length > 0);
  let s = Math.abs(e), a = n;
  if (s === 0) return A[0] + a;
  for (let o = 0; s > 0 && o <= 4; o++) {
    const l = s % 10;
    l === 0 && zr(i, MP) && a !== "" ? a = A[l] + a : l > 1 || l === 1 && o === 0 || l === 1 && o === 1 && zr(i, PP) || l === 1 && o === 1 && zr(i, kP) && e > 100 || l === 1 && o > 1 && zr(i, KP) ? a = A[l] + (o > 0 ? t[o - 1] : "") + a : l === 1 && o > 0 && (a = t[o - 1] + a), s = Math.floor(s / 10);
  }
  return (e < 0 ? r : "") + a;
}, Bb = "十百千萬", wb = "拾佰仟萬", mb = "マイナス", HB = "마이너스", Ph = (e, A, t) => {
  const r = t ? ". " : "", n = t ? "、" : "", i = t ? ", " : "", s = t ? " " : "";
  switch (A) {
    case 0:
      return "•" + s;
    case 1:
      return "◦" + s;
    case 2:
      return "◾" + s;
    case 5:
      const a = pr(e, 48, 57, !0, r);
      return a.length < 4 ? `0${a}` : a;
    case 4:
      return hl(e, "〇一二三四五六七八九", n);
    case 6:
      return yc(e, 1, 3999, gb, 3, r).toLowerCase();
    case 7:
      return yc(e, 1, 3999, gb, 3, r);
    case 8:
      return pr(e, 945, 969, !1, r);
    case 9:
      return pr(e, 97, 122, !1, r);
    case 10:
      return pr(e, 65, 90, !1, r);
    case 11:
      return pr(e, 1632, 1641, !0, r);
    case 12:
    case 49:
      return yc(e, 1, 9999, pb, 3, r);
    case 35:
      return yc(e, 1, 9999, pb, 3, r).toLowerCase();
    case 13:
      return pr(e, 2534, 2543, !0, r);
    case 14:
    case 30:
      return pr(e, 6112, 6121, !0, r);
    case 15:
      return hl(e, "子丑寅卯辰巳午未申酉戌亥", n);
    case 16:
      return hl(e, "甲乙丙丁戊己庚辛壬癸", n);
    case 17:
    case 48:
      return Ba(e, "零一二三四五六七八九", Bb, "負", n, 14);
    case 47:
      return Ba(e, "零壹貳參肆伍陸柒捌玖", wb, "負", n, 15);
    case 42:
      return Ba(e, "零一二三四五六七八九", Bb, "负", n, 14);
    case 41:
      return Ba(e, "零壹贰叁肆伍陆柒捌玖", wb, "负", n, 15);
    case 26:
      return Ba(e, "〇一二三四五六七八九", "十百千万", mb, n, 0);
    case 25:
      return Ba(e, "零壱弐参四伍六七八九", "拾百千万", mb, n, 7);
    case 31:
      return Ba(e, "영일이삼사오육칠팔구", "십백천만", HB, i, 7);
    case 33:
      return Ba(e, "零一二三四五六七八九", "十百千萬", HB, i, 0);
    case 32:
      return Ba(e, "零壹貳參四五六七八九", "拾百千", HB, i, 7);
    case 18:
      return pr(e, 2406, 2415, !0, r);
    case 20:
      return yc(e, 1, 19999, RP, 3, r);
    case 21:
      return pr(e, 2790, 2799, !0, r);
    case 22:
      return pr(e, 2662, 2671, !0, r);
    case 52:
      return yc(e, 1, 10999, DP, 3, r);
    case 23:
      return hl(e, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
    case 24:
      return hl(e, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
    case 27:
      return pr(e, 3302, 3311, !0, r);
    case 28:
      return hl(e, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", n);
    case 29:
      return hl(e, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", n);
    case 34:
      return pr(e, 3792, 3801, !0, r);
    case 37:
      return pr(e, 6160, 6169, !0, r);
    case 38:
      return pr(e, 4160, 4169, !0, r);
    case 39:
      return pr(e, 2918, 2927, !0, r);
    case 40:
      return pr(e, 1776, 1785, !0, r);
    case 43:
      return pr(e, 3046, 3055, !0, r);
    case 44:
      return pr(e, 3174, 3183, !0, r);
    case 45:
      return pr(e, 3664, 3673, !0, r);
    case 46:
      return pr(e, 3872, 3881, !0, r);
    default:
      return pr(e, 48, 57, !0, r);
  }
}, VP = {
  name: "background-clip",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: (e, A) => A.map((t) => {
    if (Oe(t)) switch (t.value) {
      case "padding-box":
        return 1;
      case "content-box":
        return 2;
      case "text":
        return 3;
    }
    return 0;
  })
}, GP = {
  name: "background-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, ip = (e, A) => {
  const t = To.parse(e, A[0]), r = A[1];
  return r && ft(r) ? {
    color: t,
    stop: r
  } : {
    color: t,
    stop: null
  };
}, TB = (e, A) => {
  const t = e[0], r = e[e.length - 1];
  t.stop === null && (t.stop = br), r.stop === null && (r.stop = ws);
  const n = [];
  let i = 0;
  for (let a = 0; a < e.length; a++) {
    const o = e[a].stop;
    if (o !== null) {
      const l = Ie(o, A);
      l > i ? n.push(l) : n.push(i), i = l;
    } else n.push(null);
  }
  let s = null;
  for (let a = 0; a < n.length; a++) {
    const o = n[a];
    if (o === null)
      s === null && (s = a);
    else if (s !== null) {
      const l = a - s, c = (o - n[s - 1]) / (l + 1);
      for (let u = 1; u <= l; u++) n[s + u - 1] = c * u;
      s = null;
    }
  }
  return e.map(({ color: a }, o) => ({
    color: a,
    stop: Math.max(Math.min(1, n[o] / A), 0)
  }));
}, WP = (e, A, t) => {
  const r = A / 2, n = t / 2, i = Ie(e[0], A) - r, s = n - Ie(e[1], t);
  return (Math.atan2(s, i) + Math.PI * 2) % (Math.PI * 2);
}, vb = (e, A, t) => {
  const r = typeof e == "number" ? e : WP(e, A, t), n = Math.abs(A * Math.sin(r)) + Math.abs(t * Math.cos(r)), i = A / 2, s = t / 2, a = n / 2, o = Math.sin(r - Math.PI / 2) * a, l = Math.cos(r - Math.PI / 2) * a;
  return [
    n,
    i - l,
    i + l,
    s - o,
    s + o
  ];
}, ds = (e, A) => Math.sqrt(e * e + A * A), yb = (e, A, t, r, n) => [
  [0, 0],
  [0, A],
  [e, 0],
  [e, A]
].reduce((i, s) => {
  const [a, o] = s, l = ds(t - a, r - o);
  return (n ? l < i.optimumDistance : l > i.optimumDistance) ? {
    optimumCorner: s,
    optimumDistance: l
  } : i;
}, {
  optimumDistance: n ? 1 / 0 : -1 / 0,
  optimumCorner: null
}).optimumCorner, jP = (e, A, t, r, n) => {
  let i = 0, s = 0;
  switch (e.size) {
    case 0:
      e.shape === 0 ? i = s = Math.min(Math.abs(A), Math.abs(A - r), Math.abs(t), Math.abs(t - n)) : e.shape === 1 && (i = Math.min(Math.abs(A), Math.abs(A - r)), s = Math.min(Math.abs(t), Math.abs(t - n)));
      break;
    case 2:
      if (e.shape === 0) i = s = Math.min(ds(A, t), ds(A, t - n), ds(A - r, t), ds(A - r, t - n));
      else if (e.shape === 1) {
        const a = Math.min(Math.abs(t), Math.abs(t - n)) / Math.min(Math.abs(A), Math.abs(A - r)), [o, l] = yb(r, n, A, t, !0);
        i = ds(o - A, (l - t) / a), s = a * i;
      }
      break;
    case 1:
      e.shape === 0 ? i = s = Math.max(Math.abs(A), Math.abs(A - r), Math.abs(t), Math.abs(t - n)) : e.shape === 1 && (i = Math.max(Math.abs(A), Math.abs(A - r)), s = Math.max(Math.abs(t), Math.abs(t - n)));
      break;
    case 3:
      if (e.shape === 0) i = s = Math.max(ds(A, t), ds(A, t - n), ds(A - r, t), ds(A - r, t - n));
      else if (e.shape === 1) {
        const a = Math.max(Math.abs(t), Math.abs(t - n)) / Math.max(Math.abs(A), Math.abs(A - r)), [o, l] = yb(r, n, A, t, !1);
        i = ds(o - A, (l - t) / a), s = a * i;
      }
      break;
  }
  return Array.isArray(e.size) && (i = Ie(e.size[0], r), s = e.size.length === 2 ? Ie(e.size[1], n) : i), [i, s];
}, gS = (e, A) => {
  let t = Wi(180);
  const r = [];
  return bs(A).forEach((n, i) => {
    if (i === 0) {
      const a = n[0];
      if (a.type === 20 && a.value === "to") {
        t = eS(n);
        return;
      } else if (AS(a)) {
        t = tu.parse(e, a);
        return;
      }
    }
    const s = ip(e, n);
    r.push(s);
  }), {
    angle: t,
    stops: r,
    type: 1
  };
}, Jf = (e, A) => {
  let t = Wi(180);
  const r = [];
  return bs(A).forEach((n, i) => {
    if (i === 0) {
      const a = n[0];
      if (a.type === 20 && [
        "top",
        "left",
        "right",
        "bottom"
      ].indexOf(a.value) !== -1) {
        t = eS(n);
        return;
      } else if (AS(a)) {
        t = (tu.parse(e, a) + Wi(270)) % Wi(360);
        return;
      }
    }
    const s = ip(e, n);
    r.push(s);
  }), {
    angle: t,
    stops: r,
    type: 1
  };
}, qP = (e, A) => {
  const t = Wi(180), r = [];
  let n = 1;
  const i = 0, s = 3, a = [];
  return bs(A).forEach((o, l) => {
    const c = o[0];
    if (l === 0) {
      if (Oe(c) && c.value === "linear") {
        n = 1;
        return;
      } else if (Oe(c) && c.value === "radial") {
        n = 2;
        return;
      }
    }
    if (c.type === 18) {
      if (c.name === "from") {
        const u = To.parse(e, c.values[0]);
        r.push({
          stop: br,
          color: u
        });
      } else if (c.name === "to") {
        const u = To.parse(e, c.values[0]);
        r.push({
          stop: ws,
          color: u
        });
      } else if (c.name === "color-stop") {
        const u = c.values.filter(Vr);
        if (u.length === 2) {
          const d = To.parse(e, u[1]), h = u[0];
          Pr(h) && r.push({
            stop: {
              type: 16,
              number: h.number * 100,
              flags: h.flags
            },
            color: d
          });
        }
      }
    }
  }), n === 1 ? {
    angle: (t + Wi(180)) % Wi(360),
    stops: r,
    type: n
  } : {
    size: s,
    shape: i,
    stops: r,
    position: a,
    type: n
  };
}, pS = "closest-side", BS = "farthest-side", wS = "closest-corner", mS = "farthest-corner", vS = "circle", yS = "ellipse", CS = "cover", bS = "contain", $P = (e, A) => {
  let t = 0, r = 3;
  const n = [], i = [];
  return bs(A).forEach((s, a) => {
    let o = !0;
    if (a === 0) {
      let l = !1;
      o = s.reduce((c, u) => {
        if (l)
          if (Oe(u)) switch (u.value) {
            case "center":
              return i.push(Ia), c;
            case "top":
            case "left":
              return i.push(br), c;
            case "right":
            case "bottom":
              return i.push(ws), c;
          }
          else (ft(u) || Mo(u)) && i.push(u);
        else if (Oe(u)) switch (u.value) {
          case vS:
            return t = 0, !1;
          case yS:
            return t = 1, !1;
          case "at":
            return l = !0, !1;
          case pS:
            return r = 0, !1;
          case CS:
          case BS:
            return r = 1, !1;
          case bS:
          case wS:
            return r = 2, !1;
          case mS:
            return r = 3, !1;
        }
        else if (Mo(u) || ft(u))
          return Array.isArray(r) || (r = []), r.push(u), !1;
        return c;
      }, o);
    }
    if (o) {
      const l = ip(e, s);
      n.push(l);
    }
  }), {
    size: r,
    shape: t,
    stops: n,
    position: i,
    type: 2
  };
}, Zf = (e, A) => {
  let t = 0, r = 3;
  const n = [], i = [];
  return bs(A).forEach((s, a) => {
    let o = !0;
    if (a === 0 ? o = s.reduce((l, c) => {
      if (Oe(c)) switch (c.value) {
        case "center":
          return i.push(Ia), !1;
        case "top":
        case "left":
          return i.push(br), !1;
        case "right":
        case "bottom":
          return i.push(ws), !1;
      }
      else if (ft(c) || Mo(c))
        return i.push(c), !1;
      return l;
    }, o) : a === 1 && (o = s.reduce((l, c) => {
      if (Oe(c)) switch (c.value) {
        case vS:
          return t = 0, !1;
        case yS:
          return t = 1, !1;
        case bS:
        case pS:
          return r = 0, !1;
        case BS:
          return r = 1, !1;
        case wS:
          return r = 2, !1;
        case CS:
        case mS:
          return r = 3, !1;
      }
      else if (Mo(c) || ft(c))
        return Array.isArray(r) || (r = []), r.push(c), !1;
      return l;
    }, o)), o) {
      const l = ip(e, s);
      n.push(l);
    }
  }), {
    size: r,
    shape: t,
    stops: n,
    position: i,
    type: 2
  };
}, Su = (e, A) => ({
  ...gS(e, A),
  type: 3
}), zP = (e) => e.type === 1, XP = (e) => e.type === 2, YP = (e) => e.type === 3, sp = {
  name: "image",
  parse: (e, A) => {
    if (A.type === 22) {
      const t = {
        url: A.value,
        type: 0
      };
      return e.cache.addImage(A.value), t;
    }
    if (A.type === 18) {
      const t = QS[A.name];
      if (typeof t > "u") throw new Error(`Attempting to parse an unsupported image function "${A.name}"`);
      return t(e, A.values);
    }
    throw new Error(`Unsupported image type ${A.type}`);
  }
};
function FS(e) {
  return !(e.type === 20 && e.value === "none") && (e.type !== 18 || !!QS[e.name]);
}
const QS = {
  "linear-gradient": gS,
  "-moz-linear-gradient": Jf,
  "-ms-linear-gradient": Jf,
  "-o-linear-gradient": Jf,
  "-webkit-linear-gradient": Jf,
  "radial-gradient": $P,
  "-moz-radial-gradient": Zf,
  "-ms-radial-gradient": Zf,
  "-o-radial-gradient": Zf,
  "-webkit-radial-gradient": Zf,
  "-webkit-gradient": qP,
  "repeating-linear-gradient": Su,
  "-webkit-repeating-linear-gradient": Su,
  "-moz-repeating-linear-gradient": Su,
  "-ms-repeating-linear-gradient": Su,
  "-o-repeating-linear-gradient": Su
}, JP = {
  name: "background-image",
  initialValue: "none",
  type: 1,
  prefix: !1,
  skipCache: !0,
  parse: (e, A) => {
    if (A.length === 0) return [];
    const t = A[0];
    return t.type === 20 && t.value === "none" ? [] : A.filter((r) => Vr(r) && FS(r)).map((r) => sp.parse(e, r));
  }
}, ZP = {
  name: "background-origin",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: (e, A) => A.map((t) => {
    if (Oe(t)) switch (t.value) {
      case "padding-box":
        return 1;
      case "content-box":
        return 2;
    }
    return 0;
  })
}, Ak = {
  name: "background-position",
  initialValue: "0% 0%",
  type: 1,
  prefix: !1,
  parse: (e, A) => bs(A).map((t) => t.map($I).filter((r) => r !== null)).map(zI)
}, ek = {
  name: "background-repeat",
  initialValue: "repeat",
  prefix: !1,
  type: 1,
  parse: (e, A) => bs(A).map((t) => t.filter(Oe).map((r) => r.value).join(" ")).map(tk)
}, tk = (e) => {
  switch (e) {
    case "no-repeat":
      return 1;
    case "repeat-x":
    case "repeat no-repeat":
      return 2;
    case "repeat-y":
    case "no-repeat repeat":
      return 3;
    default:
      return 0;
  }
}, rk = {
  name: "background-size",
  initialValue: "0",
  prefix: !1,
  type: 1,
  parse: (e, A) => bs(A).map((t) => t.map((r) => nk(r) ? r : $I(r)).filter((r) => r !== null))
}, nk = (e) => Oe(e) || ft(e), ap = (e) => ({
  name: `border-${e}-color`,
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}), ik = ap("top"), sk = ap("right"), ak = ap("bottom"), ok = ap("left"), op = (e) => ({
  name: `border-${e}-radius`,
  initialValue: "0 0",
  prefix: !1,
  type: 1,
  parse: (A, t) => zI(t.filter(ft))
}), lk = op("top-left"), ck = op("top-right"), uk = op("bottom-right"), hk = op("bottom-left"), lp = (e) => ({
  name: `border-${e}-style`,
  initialValue: "solid",
  prefix: !1,
  type: 2,
  parse: (A, t) => {
    switch (t) {
      case "none":
        return 0;
      case "dashed":
        return 2;
      case "dotted":
        return 3;
      case "double":
        return 4;
    }
    return 1;
  }
}), fk = lp("top"), dk = lp("right"), gk = lp("bottom"), pk = lp("left"), cp = (e) => ({
  name: `border-${e}-width`,
  initialValue: "0",
  type: 0,
  prefix: !1,
  parse: (A, t) => Xs(t) ? t.number : 0
}), Bk = cp("top"), wk = cp("right"), mk = cp("bottom"), vk = cp("left"), Av = { type: 0 }, ev = (e) => {
  const [A] = e;
  return A ? Oe(A) ? A.value === "farthest-side" ? "farthest-side" : "closest-side" : ft(A) ? A : "closest-side" : "closest-side";
}, US = (e) => {
  let A = null, t = null;
  for (const r of e) if (Oe(r)) switch (r.value) {
    case "left":
      A = br;
      break;
    case "right":
      A = ws;
      break;
    case "top":
      t = br;
      break;
    case "bottom":
      t = ws;
      break;
    case "center":
      A === null ? A = Ia : t === null && (t = Ia);
      break;
  }
  else ft(r) && (A === null ? A = r : t === null && (t = r));
  return {
    cx: A ?? Ia,
    cy: t ?? Ia
  };
}, yk = (e) => {
  const A = [];
  for (const n of e)
    if (n.type !== 31) {
      if (Oe(n) && n.value === "round") break;
      ft(n) && A.push(n);
    }
  const t = A[0] ?? br, r = A[1] ?? t;
  return {
    type: 1,
    top: t,
    right: r,
    bottom: A[2] ?? t,
    left: A[3] ?? r
  };
}, Ck = (e) => {
  const A = e.filter(Xh), t = A.findIndex((i) => Rh(i, "at")), r = t === -1 ? A : A.slice(0, t), n = t === -1 ? [] : A.slice(t + 1);
  return {
    type: 2,
    radius: ev(r),
    ...US(n)
  };
}, bk = (e) => {
  const A = e.filter(Xh), t = A.findIndex((i) => Rh(i, "at")), r = t === -1 ? A : A.slice(0, t), n = t === -1 ? [] : A.slice(t + 1);
  return {
    type: 3,
    rx: ev(r.slice(0, 1)),
    ry: ev(r.slice(1, 2)),
    ...US(n)
  };
}, Fk = (e) => {
  const A = bs(e), t = [];
  for (const r of A) {
    if (r.length === 1 && Oe(r[0])) continue;
    const n = r.filter(ft);
    n.length >= 2 && t.push([n[0], n[1]]);
  }
  return {
    type: 4,
    points: t
  };
}, Qk = (e) => {
  const A = e.find((t) => t.type === 0);
  return A ? {
    type: 5,
    d: A.value
  } : Av;
}, Uk = {
  name: "clip-path",
  initialValue: "none",
  prefix: !1,
  type: 0,
  parse: (e, A) => {
    if (Oe(A) && A.value === "none") return Av;
    if (A.type === 18) switch (A.name) {
      case "inset":
        return yk(A.values);
      case "circle":
        return Ck(A.values);
      case "ellipse":
        return bk(A.values);
      case "polygon":
        return Fk(A.values);
      case "path":
        return Qk(A.values);
    }
    return Av;
  }
}, Ek = {
  name: "color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, xk = {
  name: "direction",
  initialValue: "ltr",
  prefix: !1,
  type: 2,
  parse: (e, A) => A === "rtl" ? 1 : 0
}, Ik = {
  name: "display",
  initialValue: "inline-block",
  prefix: !1,
  type: 1,
  parse: (e, A) => A.filter(Oe).reduce((t, r) => t | Sk(r.value), 0)
}, Sk = (e) => {
  switch (e) {
    case "block":
    case "-webkit-box":
      return 2;
    case "inline":
      return 4;
    case "run-in":
      return 8;
    case "flow":
      return 16;
    case "flow-root":
      return 32;
    case "table":
      return 64;
    case "flex":
    case "-webkit-flex":
      return 128;
    case "grid":
    case "-ms-grid":
      return 256;
    case "ruby":
      return 512;
    case "subgrid":
      return 1024;
    case "list-item":
      return 2048;
    case "table-row-group":
      return 4096;
    case "table-header-group":
      return 8192;
    case "table-footer-group":
      return 16384;
    case "table-row":
      return 32768;
    case "table-cell":
      return 65536;
    case "table-column-group":
      return 131072;
    case "table-column":
      return 262144;
    case "table-caption":
      return 524288;
    case "ruby-base":
      return 1048576;
    case "ruby-text":
      return 2097152;
    case "ruby-base-container":
      return 4194304;
    case "ruby-text-container":
      return 8388608;
    case "contents":
      return 16777216;
    case "inline-block":
      return 33554432;
    case "inline-list-item":
      return 67108864;
    case "inline-table":
      return 134217728;
    case "inline-flex":
      return 268435456;
    case "inline-grid":
      return 536870912;
  }
  return 0;
}, Cb = {
  name: "float",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "left":
        return 1;
      case "right":
        return 2;
      case "inline-start":
        return 3;
      case "inline-end":
        return 4;
    }
    return 0;
  }
}, Lk = {
  name: "letter-spacing",
  initialValue: "0",
  prefix: !1,
  type: 0,
  parse: (e, A) => A.type === 20 && A.value === "normal" ? 0 : A.type === 17 || A.type === 15 ? A.number : 0
}, Hk = {
  name: "line-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: (e, A) => A === "strict" ? "strict" : "normal"
}, Tk = {
  name: "line-height",
  initialValue: "normal",
  prefix: !1,
  type: 4
}, tv = (e, A) => Oe(e) && e.value === "normal" ? 1.2 * A : e.type === 17 ? A * e.number : ft(e) ? Ie(e, A) : A, _k = {
  name: "list-style-image",
  initialValue: "none",
  type: 0,
  prefix: !1,
  skipCache: !0,
  parse: (e, A) => A.type === 20 && A.value === "none" ? null : sp.parse(e, A)
}, Ok = {
  name: "list-style-position",
  initialValue: "outside",
  prefix: !1,
  type: 2,
  parse: (e, A) => A === "inside" ? 0 : 1
}, up = (e) => ({
  name: `margin-${e}`,
  initialValue: "0",
  prefix: !1,
  type: 4
}), Nk = up("top"), Dk = up("right"), Rk = up("bottom"), Mk = up("left"), bb = {
  name: "overflow",
  initialValue: "visible",
  prefix: !1,
  type: 1,
  parse: (e, A) => A.filter(Oe).map((t) => {
    switch (t.value) {
      case "hidden":
        return 1;
      case "scroll":
        return 2;
      case "clip":
        return 3;
      case "auto":
        return 4;
      default:
        return 0;
    }
  })
}, Pk = {
  name: "overflow-wrap",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: (e, A) => A === "break-word" ? "break-word" : "normal"
}, hp = (e) => ({
  name: `padding-${e}`,
  initialValue: "0",
  prefix: !1,
  type: 3,
  format: "length-percentage"
}), kk = hp("top"), Kk = hp("right"), Vk = hp("bottom"), Gk = hp("left"), Wk = {
  name: "text-align",
  initialValue: "left",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "right":
        return 2;
      case "center":
      case "justify":
        return 1;
      default:
        return 0;
    }
  }
}, jk = {
  name: "position",
  initialValue: "static",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "relative":
        return 1;
      case "absolute":
        return 2;
      case "fixed":
        return 3;
      case "sticky":
        return 4;
    }
    return 0;
  }
}, qk = {
  name: "text-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: (e, A) => A.length === 1 && Rh(A[0], "none") ? [] : bs(A).map((t) => {
    const r = {
      color: $s.TRANSPARENT,
      offsetX: br,
      offsetY: br,
      blur: br
    };
    let n = 0;
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      Mo(s) ? (n === 0 ? r.offsetX = s : n === 1 ? r.offsetY = s : r.blur = s, n++) : r.color = To.parse(e, s);
    }
    return r;
  })
}, $k = {
  name: "text-transform",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "uppercase":
        return 2;
      case "lowercase":
        return 1;
      case "capitalize":
        return 3;
    }
    return 0;
  }
}, zk = {
  name: "transform",
  initialValue: "none",
  prefix: !0,
  type: 0,
  parse: (e, A) => {
    if (A.type === 20 && A.value === "none") return null;
    if (A.type === 18) {
      const t = Zk[A.name];
      if (typeof t > "u") throw new Error(`Attempting to parse an unsupported transform function "${A.name}"`);
      return t(e, A.values);
    }
    return null;
  }
}, Xk = (e, A) => {
  const t = A.filter((r) => r.type === 17).map((r) => r.number);
  return t.length === 6 ? t : null;
}, Yk = (e, A) => {
  const t = A.filter((l) => l.type === 17).map((l) => l.number), [r, n, {}, {}, i, s, {}, {}, {}, {}, {}, {}, a, o] = t;
  return t.length === 16 ? [
    r,
    n,
    i,
    s,
    a,
    o
  ] : null;
}, Jk = (e, A) => {
  if (A.length !== 1) return null;
  const t = A[0];
  let r = 0;
  if (t.type === 17 && t.number === 0) r = 0;
  else if (t.type === 15) r = tu.parse(e, t);
  else return null;
  const n = Math.cos(r), i = Math.sin(r);
  return [
    n,
    i,
    -i,
    n,
    0,
    0
  ];
}, Zk = {
  matrix: Xk,
  matrix3d: Yk,
  rotate: Jk
}, Fb = {
  type: 16,
  number: 50,
  flags: 4
}, AK = [Fb, Fb], eK = {
  name: "transform-origin",
  initialValue: "50% 50%",
  prefix: !0,
  type: 1,
  parse: (e, A) => {
    const t = A.filter(ft);
    return t.length !== 2 ? AK : [t[0], t[1]];
  }
}, tK = {
  name: "rotate",
  initialValue: "none",
  prefix: !1,
  type: 0,
  parse: (e, A) => A.type === 20 && A.value === "none" ? null : A.type === 17 && A.number === 0 ? 0 : A.type === 15 ? tu.parse(e, A) * 180 / Math.PI : null
}, rK = {
  name: "visibility",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "hidden":
        return 1;
      case "collapse":
        return 2;
      default:
        return 0;
    }
  }
}, nK = {
  name: "word-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "break-all":
        return "break-all";
      case "keep-all":
        return "keep-all";
      default:
        return "normal";
    }
  }
}, iK = {
  name: "white-space",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "pre":
        return "pre";
      case "nowrap":
        return "nowrap";
      case "pre-wrap":
        return "pre-wrap";
      case "pre-line":
        return "pre-line";
      default:
        return "normal";
    }
  }
}, Cg = (e) => e !== 0, _B = (e) => e === 3 || e === 4, sK = {
  name: "writing-mode",
  initialValue: "horizontal-tb",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "vertical-rl":
        return 1;
      case "vertical-lr":
        return 2;
      case "sideways-rl":
        return 3;
      case "sideways-lr":
        return 4;
      default:
        return 0;
    }
  }
}, aK = {
  name: "z-index",
  initialValue: "auto",
  prefix: !1,
  type: 0,
  parse: (e, A) => {
    if (A.type === 20) return {
      auto: !0,
      order: 0
    };
    if (Pr(A)) return {
      auto: !1,
      order: A.number
    };
    throw new Error("Invalid z-index number parsed");
  }
}, ES = {
  name: "time",
  parse: (e, A) => {
    if (A.type === 15) switch (A.unit.toLowerCase()) {
      case "s":
        return 1e3 * A.number;
      case "ms":
        return A.number;
    }
    throw new Error("Unsupported time type");
  }
}, oK = {
  name: "opacity",
  initialValue: "1",
  type: 0,
  prefix: !1,
  parse: (e, A) => Pr(A) ? A.number : 1
}, Qb = {
  name: "text-decoration-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, Ub = {
  name: "text-decoration-line",
  initialValue: "none",
  prefix: !1,
  type: 1,
  parse: (e, A) => A.filter(Oe).map((t) => {
    switch (t.value) {
      case "underline":
        return 1;
      case "overline":
        return 2;
      case "line-through":
        return 3;
      case "none":
        return 4;
    }
    return 0;
  }).filter((t) => t !== 0)
}, lK = {
  name: "text-decoration-style",
  initialValue: "solid",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "double":
        return 1;
      case "dotted":
        return 2;
      case "dashed":
        return 3;
      case "wavy":
        return 4;
      default:
        return 0;
    }
  }
}, cK = {
  name: "text-decoration-thickness",
  initialValue: "auto",
  prefix: !1,
  type: 0,
  parse: (e, A) => {
    if (Oe(A)) switch (A.value) {
      case "auto":
        return "auto";
      case "from-font":
        return "from-font";
    }
    return Xs(A) ? A.number : "auto";
  }
}, uK = {
  name: "text-underline-offset",
  initialValue: "auto",
  prefix: !1,
  type: 0,
  parse: (e, A) => Oe(A) && A.value === "auto" ? "auto" : Xs(A) ? A.number : "auto"
}, hK = {
  name: "font-family",
  initialValue: "",
  prefix: !1,
  type: 1,
  parse: (e, A) => {
    const t = [], r = [], n = [];
    let i = !1;
    return A.forEach((s) => {
      switch (s.type) {
        case 20:
          t.push(s.value);
          break;
        case 0:
          i = !0, t.push(s.value);
          break;
        case 17:
          t.push(s.number.toString());
          break;
        case 4:
          r.push(t.join(" ")), n.push(i), i = !1, t.length = 0;
          break;
      }
    }), t.length && (r.push(t.join(" ")), n.push(i)), r.map((s, a) => n[a] || s.indexOf(" ") !== -1 ? `'${s.replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/\n/g, "\\a ").replace(/\r/g, "\\d ").replace(/\f/g, "\\c ")}'` : s);
  }
}, fK = {
  name: "font-size",
  initialValue: "0",
  prefix: !1,
  type: 3,
  format: "length"
}, dK = {
  name: "font-weight",
  initialValue: "normal",
  type: 0,
  prefix: !1,
  parse: (e, A) => Pr(A) ? A.number : Oe(A) && A.value === "bold" ? 700 : 400
}, gK = {
  name: "font-variant",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: (e, A) => A.filter(Oe).map((t) => t.value)
}, pK = {
  name: "font-style",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "oblique":
        return "oblique";
      case "italic":
        return "italic";
      default:
        return "normal";
    }
  }
}, BK = {
  name: "content",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: (e, A) => {
    if (A.length === 0) return [];
    const t = A[0];
    return t.type === 20 && t.value === "none" ? [] : A;
  }
}, xS = (e, A) => {
  const t = [], r = e.filter(Xh);
  for (let n = 0; n < r.length; n++) {
    const i = r[n], s = r[n + 1];
    if (i.type === 20) {
      const a = s && Pr(s) ? s.number : A;
      t.push([i.value, a]);
    }
  }
  return t;
}, wK = {
  name: "counter-increment",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: (e, A) => {
    if (A.length === 0) return null;
    const t = A[0];
    return t.type === 20 && t.value === "none" ? null : xS(A, 1).map(([r, n]) => ({
      counter: r,
      increment: n
    }));
  }
}, mK = {
  name: "counter-reset",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: (e, A) => A.length === 0 ? [] : xS(A, 0).filter(([t]) => t !== "none").map(([t, r]) => ({
    counter: t,
    reset: r
  }))
}, vK = {
  name: "duration",
  initialValue: "0s",
  prefix: !1,
  type: 1,
  parse: (e, A) => A.filter(Xs).map((t) => ES.parse(e, t))
}, yK = {
  name: "quotes",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: (e, A) => {
    if (A.length === 0) return null;
    const t = A[0];
    if (t.type === 20 && t.value === "none") return null;
    const r = [], n = A.filter(LM);
    if (n.length % 2 !== 0) return null;
    for (let i = 0; i < n.length; i += 2) {
      const s = n[i].value, a = n[i + 1].value;
      r.push({
        open: s,
        close: a
      });
    }
    return r;
  }
}, Eb = (e, A, t) => {
  if (!e) return "";
  const r = e[Math.min(A, e.length - 1)];
  return r ? t ? r.open : r.close : "";
}, CK = {
  name: "box-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: (e, A) => A.length === 1 && Rh(A[0], "none") ? [] : bs(A).map((t) => {
    const r = {
      color: 255,
      offsetX: br,
      offsetY: br,
      blur: br,
      spread: br,
      inset: !1
    };
    let n = 0;
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      Rh(s, "inset") ? r.inset = !0 : Mo(s) ? (n === 0 ? r.offsetX = s : n === 1 ? r.offsetY = s : n === 2 ? r.blur = s : r.spread = s, n++) : r.color = To.parse(e, s);
    }
    return r;
  })
}, bK = {
  name: "paint-order",
  initialValue: "normal",
  prefix: !1,
  type: 1,
  parse: (e, A) => {
    const t = [
      0,
      1,
      2
    ], r = [];
    return A.filter(Oe).forEach((n) => {
      switch (n.value) {
        case "stroke":
          r.push(1);
          break;
        case "fill":
          r.push(0);
          break;
        case "markers":
          r.push(2);
          break;
      }
    }), t.forEach((n) => {
      r.indexOf(n) === -1 && r.push(n);
    }), r;
  }
}, FK = {
  name: "-webkit-text-stroke-color",
  initialValue: "currentcolor",
  prefix: !1,
  type: 3,
  format: "color"
}, QK = {
  name: "-webkit-text-stroke-width",
  initialValue: "0",
  type: 0,
  prefix: !1,
  parse: (e, A) => Xs(A) ? A.number : 0
}, UK = {
  name: "-webkit-line-clamp",
  initialValue: "none",
  prefix: !0,
  type: 0,
  parse: (e, A) => A.type === 20 && A.value === "none" ? 0 : A.type === 17 ? Math.max(0, Math.floor(A.number)) : 0
}, EK = {
  name: "object-fit",
  initialValue: "fill",
  prefix: !1,
  type: 1,
  parse: (e, A) => A.filter(Oe).reduce((t, r) => t | xK(r.value), 0)
}, xK = (e) => {
  switch (e) {
    case "contain":
      return 2;
    case "cover":
      return 4;
    case "none":
      return 8;
    case "scale-down":
      return 16;
  }
  return 0;
}, IK = {
  name: "text-overflow",
  initialValue: "clip",
  prefix: !1,
  type: 2,
  parse: (e, A) => A === "ellipsis" ? 1 : 0
}, SK = {
  name: "image-rendering",
  initialValue: "auto",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A.toLowerCase()) {
      case "crisp-edges":
      case "-webkit-crisp-edges":
      case "-moz-crisp-edges":
        return 1;
      case "pixelated":
      case "-webkit-optimize-contrast":
        return 2;
      case "smooth":
      case "high-quality":
        return 3;
      default:
        return 0;
    }
  }
}, Ir = {
  NORMAL: "normal",
  MULTIPLY: "multiply",
  SCREEN: "screen",
  OVERLAY: "overlay",
  DARKEN: "darken",
  LIGHTEN: "lighten",
  COLOR_DODGE: "color-dodge",
  COLOR_BURN: "color-burn",
  HARD_LIGHT: "hard-light",
  SOFT_LIGHT: "soft-light",
  DIFFERENCE: "difference",
  EXCLUSION: "exclusion",
  HUE: "hue",
  SATURATION: "saturation",
  COLOR: "color",
  LUMINOSITY: "luminosity"
}, LK = new Set(Object.values(Ir)), HK = {
  name: "mix-blend-mode",
  initialValue: "normal",
  type: 2,
  prefix: !1,
  parse: (e, A) => LK.has(A) ? A : Ir.NORMAL
}, TK = {
  name: "filter",
  initialValue: "none",
  prefix: !1,
  type: 1,
  parse: (e, A) => {
    if (A.length === 1 && A[0].type === 20 && A[0].value === "none") return null;
    const t = [];
    for (const r of A) if (r.type === 18) {
      const n = r, i = IS(n.values);
      switch (n.name) {
        case "blur":
          t.push(`blur(${i})`);
          break;
        case "brightness":
        case "contrast":
        case "invert":
        case "opacity":
        case "saturate":
        case "sepia":
          t.push(`${n.name}(${i})`);
          break;
        case "grayscale":
          t.push(`grayscale(${i})`);
          break;
        case "hue-rotate":
          t.push(`hue-rotate(${i})`);
          break;
        case "drop-shadow":
          t.push(`drop-shadow(${i})`);
          break;
      }
    }
    return t.length > 0 ? t.join(" ") : null;
  }
}, IS = (e) => {
  const A = [];
  for (const t of e) {
    if (t.type === 31) {
      A.push(" ");
      continue;
    }
    t.type === 18 ? A.push(`${t.name}(${IS(t.values)})`) : t.type === 4 ? A.push(",") : t.type === 6 ? A.push(t.value) : t.type === 15 ? A.push(`${t.number}${t.unit}`) : t.type === 17 ? A.push(`${t.number}`) : t.type === 16 ? A.push(`${t.number}%`) : t.type === 20 ? A.push(t.value) : t.type === 5 && A.push(`#${t.value}`);
  }
  return A.join("").trim();
}, _K = {
  name: "font-variant-ligatures",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: (e, A) => {
    switch (A) {
      case "none":
        return 1;
      case "common-ligatures":
        return 2;
      case "no-common-ligatures":
        return 3;
      case "discretionary-ligatures":
        return 4;
      case "no-discretionary-ligatures":
        return 5;
      case "historical-ligatures":
        return 6;
      case "no-historical-ligatures":
        return 7;
      case "contextual":
        return 8;
      case "no-contextual":
        return 9;
      default:
        return 0;
    }
  }
}, OK = {
  name: "zoom",
  initialValue: "1",
  type: 0,
  prefix: !1,
  parse: (e, A) => A.type === 16 ? Math.max(0, A.number / 100) : A.type === 17 ? Math.max(0, A.number) : 1
}, NK = {
  name: "object-position",
  initialValue: "50% 50%",
  prefix: !1,
  type: 1,
  parse: (e, A) => {
    const t = [];
    let r = 0;
    for (; r < A.length && t.length < 2; ) {
      const n = A[r];
      if (Oe(n)) switch (n.value) {
        case "left":
        case "top":
          t.push(br);
          break;
        case "center":
          t.push(Ia);
          break;
        case "right":
        case "bottom":
          t.push(ws);
          break;
      }
      else ft(n) && t.push(n);
      r++;
    }
    for (; t.length < 2; ) t.push(Ia);
    return [t[0], t[1]];
  }
}, DK = new Set(Object.values({
  NORMAL: "normal",
  MULTIPLY: "multiply",
  SCREEN: "screen",
  OVERLAY: "overlay",
  DARKEN: "darken",
  LIGHTEN: "lighten",
  COLOR_DODGE: "color-dodge",
  COLOR_BURN: "color-burn",
  HARD_LIGHT: "hard-light",
  SOFT_LIGHT: "soft-light",
  DIFFERENCE: "difference",
  EXCLUSION: "exclusion",
  HUE: "hue",
  SATURATION: "saturation",
  COLOR: "color",
  LUMINOSITY: "luminosity"
})), RK = {
  name: "background-blend-mode",
  initialValue: "normal",
  prefix: !1,
  type: 1,
  parse: (e, A) => {
    const t = [], r = A.filter(Vr);
    for (const n of r) Oe(n) && DK.has(n.value) && t.push(n.value);
    return t.length > 0 ? t : ["normal"];
  }
}, MK = {
  name: "border-image-source",
  initialValue: "none",
  prefix: !1,
  type: 1,
  skipCache: !0,
  parse: (e, A) => {
    if (A.length === 0) return null;
    const t = A.filter((r) => Vr(r) && FS(r));
    return t.length === 0 ? null : sp.parse(e, t[0]);
  }
}, PK = (e) => {
  const A = [...e];
  return A.length === 1 ? A.push(A[0], A[0], A[0]) : A.length === 2 ? A.push(A[0], A[1]) : A.length === 3 && A.push(A[1]), A.slice(0, 4);
}, kK = {
  name: "border-image-slice",
  initialValue: "100%",
  prefix: !1,
  type: 1,
  parse: (e, A) => {
    const t = A.filter(Xh), r = [];
    let n = !1, i = "percent";
    for (const c of t) {
      if (Oe(c) && c.value === "fill") {
        n = !0;
        continue;
      }
      c.type === 17 ? (r.push(c.number), i = "number") : c.type === 16 && (r.push(c.number), i = "percent");
    }
    const [s, a, o, l] = PK(r.length > 0 ? r : [100]);
    return {
      top: s,
      right: a,
      bottom: o,
      left: l,
      fill: n,
      unit: i
    };
  }
}, KK = (e) => {
  switch (e) {
    case "repeat":
      return 1;
    case "round":
      return 2;
    case "space":
      return 3;
    default:
      return 0;
  }
}, VK = {
  name: "border-image-repeat",
  initialValue: "stretch",
  prefix: !1,
  type: 1,
  parse: (e, A) => {
    const t = A.filter(Xh), r = [];
    for (const i of t) Oe(i) && r.push(KK(i.value));
    const n = r[0] ?? 0;
    return {
      horizontal: n,
      vertical: r[1] ?? n
    };
  }
}, GK = {
  name: "box-decoration-break",
  initialValue: "slice",
  prefix: !1,
  type: 2,
  parse: (e, A) => A === "clone" ? 1 : 0
}, WK = 1e4;
var jK = class {
  constructor(e) {
    this.styles = e;
  }
  get topColor() {
    return this.styles.borderTopColor;
  }
  get rightColor() {
    return this.styles.borderRightColor;
  }
  get bottomColor() {
    return this.styles.borderBottomColor;
  }
  get leftColor() {
    return this.styles.borderLeftColor;
  }
  get topStyle() {
    return this.styles.borderTopStyle;
  }
  get rightStyle() {
    return this.styles.borderRightStyle;
  }
  get bottomStyle() {
    return this.styles.borderBottomStyle;
  }
  get leftStyle() {
    return this.styles.borderLeftStyle;
  }
  get topWidth() {
    return this.styles.borderTopWidth;
  }
  get rightWidth() {
    return this.styles.borderRightWidth;
  }
  get bottomWidth() {
    return this.styles.borderBottomWidth;
  }
  get leftWidth() {
    return this.styles.borderLeftWidth;
  }
  get topLeftRadius() {
    return this.styles.borderTopLeftRadius;
  }
  get topRightRadius() {
    return this.styles.borderTopRightRadius;
  }
  get bottomRightRadius() {
    return this.styles.borderBottomRightRadius;
  }
  get bottomLeftRadius() {
    return this.styles.borderBottomLeftRadius;
  }
  get imageSource() {
    return this.styles.borderImageSource;
  }
  get imageSlice() {
    return this.styles.borderImageSlice;
  }
  get imageRepeat() {
    return this.styles.borderImageRepeat;
  }
  get boxShadow() {
    return this.styles.boxShadow;
  }
}, qK = class {
  constructor(e) {
    this.styles = e;
  }
  get color() {
    return this.styles.backgroundColor;
  }
  get image() {
    return this.styles.backgroundImage;
  }
  get clip() {
    return this.styles.backgroundClip;
  }
  get origin() {
    return this.styles.backgroundOrigin;
  }
  get position() {
    return this.styles.backgroundPosition;
  }
  get repeat() {
    return this.styles.backgroundRepeat;
  }
  get size() {
    return this.styles.backgroundSize;
  }
  get blendMode() {
    return this.styles.backgroundBlendMode;
  }
}, $K = class {
  constructor(e) {
    this.styles = e;
  }
  get family() {
    return this.styles.fontFamily;
  }
  get size() {
    return this.styles.fontSize;
  }
  get style() {
    return this.styles.fontStyle;
  }
  get variant() {
    return this.styles.fontVariant;
  }
  get weight() {
    return this.styles.fontWeight;
  }
  get ligatures() {
    return this.styles.fontVariantLigatures;
  }
  get color() {
    return this.styles.color;
  }
  get letterSpacing() {
    return this.styles.letterSpacing;
  }
  get lineHeight() {
    return this.styles.lineHeight;
  }
  get textAlign() {
    return this.styles.textAlign;
  }
  get textTransform() {
    return this.styles.textTransform;
  }
  get textOverflow() {
    return this.styles.textOverflow;
  }
  get textShadow() {
    return this.styles.textShadow;
  }
  get textDecorationColor() {
    return this.styles.textDecorationColor;
  }
  get textDecorationLine() {
    return this.styles.textDecorationLine;
  }
  get textDecorationStyle() {
    return this.styles.textDecorationStyle;
  }
  get textDecorationThickness() {
    return this.styles.textDecorationThickness;
  }
  get textUnderlineOffset() {
    return this.styles.textUnderlineOffset;
  }
  get wordBreak() {
    return this.styles.wordBreak;
  }
  get lineBreak() {
    return this.styles.lineBreak;
  }
  get overflowWrap() {
    return this.styles.overflowWrap;
  }
  get writingMode() {
    return this.styles.writingMode;
  }
  get direction() {
    return this.styles.direction;
  }
  get webkitTextStrokeColor() {
    return this.styles.webkitTextStrokeColor;
  }
  get webkitTextStrokeWidth() {
    return this.styles.webkitTextStrokeWidth;
  }
  get webkitLineClamp() {
    return this.styles.webkitLineClamp;
  }
  get paintOrder() {
    return this.styles.paintOrder;
  }
}, zK = class {
  constructor(e) {
    this.styles = e;
  }
  get display() {
    return this.styles.display;
  }
  get position() {
    return this.styles.position;
  }
  get float() {
    return this.styles.float;
  }
  get zIndex() {
    return this.styles.zIndex;
  }
  get marginTop() {
    return this.styles.marginTop;
  }
  get marginRight() {
    return this.styles.marginRight;
  }
  get marginBottom() {
    return this.styles.marginBottom;
  }
  get marginLeft() {
    return this.styles.marginLeft;
  }
  get paddingTop() {
    return this.styles.paddingTop;
  }
  get paddingRight() {
    return this.styles.paddingRight;
  }
  get paddingBottom() {
    return this.styles.paddingBottom;
  }
  get paddingLeft() {
    return this.styles.paddingLeft;
  }
  get overflowX() {
    return this.styles.overflowX;
  }
  get overflowY() {
    return this.styles.overflowY;
  }
  get opacity() {
    return this.styles.opacity;
  }
  get visibility() {
    return this.styles.visibility;
  }
  get transform() {
    return this.styles.transform;
  }
  get transformOrigin() {
    return this.styles.transformOrigin;
  }
  get rotate() {
    return this.styles.rotate;
  }
  get zoom() {
    return this.styles.zoom;
  }
  get clipPath() {
    return this.styles.clipPath;
  }
  get mixBlendMode() {
    return this.styles.mixBlendMode;
  }
  get filter() {
    return this.styles.filter;
  }
  get imageRendering() {
    return this.styles.imageRendering;
  }
  get objectFit() {
    return this.styles.objectFit;
  }
  get objectPosition() {
    return this.styles.objectPosition;
  }
  get boxDecorationBreak() {
    return this.styles.boxDecorationBreak;
  }
  get listStyleImage() {
    return this.styles.listStyleImage;
  }
  get listStylePosition() {
    return this.styles.listStylePosition;
  }
  get listStyleType() {
    return this.styles.listStyleType;
  }
  get animationDuration() {
    return this.styles.animationDuration;
  }
  isVisible() {
    return this.styles.isVisible();
  }
  isTransparent() {
    return this.styles.isTransparent();
  }
  isTransformed() {
    return this.styles.isTransformed();
  }
  isPositioned() {
    return this.styles.isPositioned();
  }
  isPositionedWithZIndex() {
    return this.styles.isPositionedWithZIndex();
  }
  isFloating() {
    return this.styles.isFloating();
  }
  isInlineLevel() {
    return this.styles.isInlineLevel();
  }
}, jl, XK = (jl = class {
  get border() {
    return this._border ?? (this._border = new jK(this));
  }
  get background() {
    return this._background ?? (this._background = new qK(this));
  }
  get font() {
    return this._font ?? (this._font = new $K(this));
  }
  get layout() {
    return this._layout ?? (this._layout = new zK(this));
  }
  constructor(A, t) {
    const r = jl.standardProps;
    if (t.display === "none") {
      this.display = 0;
      for (const [s, a] of r) s !== "display" && (this[s] = ni(A, a, void 0));
      this.float = ni(A, Cb, void 0), this.textDecorationColor = ni(A, Qb, void 0), this.textDecorationLine = ni(A, Ub, void 0);
      const i = ni(A, bb, void 0);
      this.overflowX = i[0], this.overflowY = i[i.length > 1 ? 1 : 0];
      return;
    }
    for (const [i, s, a] of r) this[i] = ni(A, s, t[a]);
    this.float = ni(A, Cb, t.cssFloat), this.textDecorationColor = ni(A, Qb, t.textDecorationColor ?? t.color), this.textDecorationLine = ni(A, Ub, t.textDecorationLine ?? t.textDecoration);
    const n = ni(A, bb, t.overflow);
    this.overflowX = n[0], this.overflowY = n[n.length > 1 ? 1 : 0];
  }
  isVisible() {
    return this.display > 0 && this.opacity > 0 && this.visibility === 0;
  }
  isTransparent() {
    return Sa(this.backgroundColor);
  }
  isTransformed() {
    return this.transform !== null || this.rotate !== null;
  }
  isPositioned() {
    return this.position !== 0;
  }
  isPositionedWithZIndex() {
    return this.isPositioned() && !this.zIndex.auto;
  }
  isFloating() {
    return this.float !== 0;
  }
  isInlineLevel() {
    return zr(this.display, 4) || zr(this.display, 33554432) || zr(this.display, 268435456) || zr(this.display, 536870912) || zr(this.display, 67108864) || zr(this.display, 134217728);
  }
}, jl.standardProps = [
  [
    "animationDuration",
    vK,
    "animationDuration"
  ],
  [
    "backgroundClip",
    VP,
    "backgroundClip"
  ],
  [
    "backgroundColor",
    GP,
    "backgroundColor"
  ],
  [
    "backgroundImage",
    JP,
    "backgroundImage"
  ],
  [
    "backgroundOrigin",
    ZP,
    "backgroundOrigin"
  ],
  [
    "backgroundPosition",
    Ak,
    "backgroundPosition"
  ],
  [
    "backgroundRepeat",
    ek,
    "backgroundRepeat"
  ],
  [
    "backgroundSize",
    rk,
    "backgroundSize"
  ],
  [
    "borderTopColor",
    ik,
    "borderTopColor"
  ],
  [
    "borderRightColor",
    sk,
    "borderRightColor"
  ],
  [
    "borderBottomColor",
    ak,
    "borderBottomColor"
  ],
  [
    "borderLeftColor",
    ok,
    "borderLeftColor"
  ],
  [
    "borderTopLeftRadius",
    lk,
    "borderTopLeftRadius"
  ],
  [
    "borderTopRightRadius",
    ck,
    "borderTopRightRadius"
  ],
  [
    "borderBottomRightRadius",
    uk,
    "borderBottomRightRadius"
  ],
  [
    "borderBottomLeftRadius",
    hk,
    "borderBottomLeftRadius"
  ],
  [
    "borderTopStyle",
    fk,
    "borderTopStyle"
  ],
  [
    "borderRightStyle",
    dk,
    "borderRightStyle"
  ],
  [
    "borderBottomStyle",
    gk,
    "borderBottomStyle"
  ],
  [
    "borderLeftStyle",
    pk,
    "borderLeftStyle"
  ],
  [
    "borderTopWidth",
    Bk,
    "borderTopWidth"
  ],
  [
    "borderRightWidth",
    wk,
    "borderRightWidth"
  ],
  [
    "borderBottomWidth",
    mk,
    "borderBottomWidth"
  ],
  [
    "borderLeftWidth",
    vk,
    "borderLeftWidth"
  ],
  [
    "boxShadow",
    CK,
    "boxShadow"
  ],
  [
    "clipPath",
    Uk,
    "clipPath"
  ],
  [
    "color",
    Ek,
    "color"
  ],
  [
    "direction",
    xk,
    "direction"
  ],
  [
    "display",
    Ik,
    "display"
  ],
  [
    "fontFamily",
    hK,
    "fontFamily"
  ],
  [
    "fontSize",
    fK,
    "fontSize"
  ],
  [
    "fontStyle",
    pK,
    "fontStyle"
  ],
  [
    "fontVariant",
    gK,
    "fontVariant"
  ],
  [
    "fontWeight",
    dK,
    "fontWeight"
  ],
  [
    "letterSpacing",
    Lk,
    "letterSpacing"
  ],
  [
    "lineBreak",
    Hk,
    "lineBreak"
  ],
  [
    "lineHeight",
    Tk,
    "lineHeight"
  ],
  [
    "listStyleImage",
    _k,
    "listStyleImage"
  ],
  [
    "listStylePosition",
    Ok,
    "listStylePosition"
  ],
  [
    "listStyleType",
    Z1,
    "listStyleType"
  ],
  [
    "marginTop",
    Nk,
    "marginTop"
  ],
  [
    "marginRight",
    Dk,
    "marginRight"
  ],
  [
    "marginBottom",
    Rk,
    "marginBottom"
  ],
  [
    "marginLeft",
    Mk,
    "marginLeft"
  ],
  [
    "opacity",
    oK,
    "opacity"
  ],
  [
    "overflowWrap",
    Pk,
    "overflowWrap"
  ],
  [
    "paddingTop",
    kk,
    "paddingTop"
  ],
  [
    "paddingRight",
    Kk,
    "paddingRight"
  ],
  [
    "paddingBottom",
    Vk,
    "paddingBottom"
  ],
  [
    "paddingLeft",
    Gk,
    "paddingLeft"
  ],
  [
    "paintOrder",
    bK,
    "paintOrder"
  ],
  [
    "position",
    jk,
    "position"
  ],
  [
    "textAlign",
    Wk,
    "textAlign"
  ],
  [
    "textDecorationStyle",
    lK,
    "textDecorationStyle"
  ],
  [
    "textDecorationThickness",
    cK,
    "textDecorationThickness"
  ],
  [
    "textUnderlineOffset",
    uK,
    "textUnderlineOffset"
  ],
  [
    "textShadow",
    qk,
    "textShadow"
  ],
  [
    "textTransform",
    $k,
    "textTransform"
  ],
  [
    "textOverflow",
    IK,
    "textOverflow"
  ],
  [
    "transform",
    zk,
    "transform"
  ],
  [
    "transformOrigin",
    eK,
    "transformOrigin"
  ],
  [
    "rotate",
    tK,
    "rotate"
  ],
  [
    "visibility",
    rK,
    "visibility"
  ],
  [
    "webkitTextStrokeColor",
    FK,
    "webkitTextStrokeColor"
  ],
  [
    "webkitTextStrokeWidth",
    QK,
    "webkitTextStrokeWidth"
  ],
  [
    "webkitLineClamp",
    UK,
    "webkitLineClamp"
  ],
  [
    "wordBreak",
    nK,
    "wordBreak"
  ],
  [
    "whiteSpace",
    iK,
    "whiteSpace"
  ],
  [
    "writingMode",
    sK,
    "writingMode"
  ],
  [
    "zIndex",
    aK,
    "zIndex"
  ],
  [
    "objectFit",
    EK,
    "objectFit"
  ],
  [
    "imageRendering",
    SK,
    "imageRendering"
  ],
  [
    "mixBlendMode",
    HK,
    "mixBlendMode"
  ],
  [
    "filter",
    TK,
    "filter"
  ],
  [
    "fontVariantLigatures",
    _K,
    "fontVariantLigatures"
  ],
  [
    "zoom",
    OK,
    "zoom"
  ],
  [
    "objectPosition",
    NK,
    "objectPosition"
  ],
  [
    "backgroundBlendMode",
    RK,
    "backgroundBlendMode"
  ],
  [
    "borderImageSource",
    MK,
    "borderImageSource"
  ],
  [
    "borderImageSlice",
    kK,
    "borderImageSlice"
  ],
  [
    "borderImageRepeat",
    VK,
    "borderImageRepeat"
  ],
  [
    "boxDecorationBreak",
    GK,
    "boxDecorationBreak"
  ]
], jl), YK = class {
  constructor(A, t) {
    this.content = ni(A, BK, t.content), this.quotes = ni(A, yK, t.quotes);
  }
}, xb = class {
  constructor(A, t) {
    this.counterIncrement = ni(A, wK, t.counterIncrement), this.counterReset = ni(A, mK, t.counterReset);
  }
};
const Ib = /* @__PURE__ */ new Map(), ni = (e, A, t) => {
  let r = t !== null && typeof t < "u" ? t.toString() : A.initialValue;
  r.trim() === "" && (r = A.initialValue);
  let n = Ib.get(A);
  if (n) {
    const o = n.get(r);
    if (o !== void 0)
      return n.delete(r), n.set(r, o), o;
  }
  const i = z1.get();
  i.write(r);
  const s = new WI(i.read());
  z1.release(i);
  const a = (() => {
    switch (A.type) {
      case 2: {
        const o = s.parseComponentValue();
        return A.parse(e, Oe(o) ? o.value : A.initialValue);
      }
      case 0:
        return A.parse(e, s.parseComponentValue());
      case 1:
        return A.parse(e, s.parseComponentValues());
      case 4:
        return s.parseComponentValue();
      case 3:
        switch (A.format) {
          case "angle":
            return tu.parse(e, s.parseComponentValue());
          case "color":
            return To.parse(e, s.parseComponentValue());
          case "image":
            return sp.parse(e, s.parseComponentValue());
          case "length": {
            const o = s.parseComponentValue();
            return Mo(o) ? o : br;
          }
          case "length-percentage": {
            const o = s.parseComponentValue();
            return ft(o) ? o : br;
          }
          case "time":
            return ES.parse(e, s.parseComponentValue());
        }
    }
  })();
  if (n || (n = /* @__PURE__ */ new Map(), Ib.set(A, n)), !(A.skipCache || A.type === 3 && A.format === "image")) {
    if (n.size >= 200) {
      const o = n.keys().next().value;
      n.delete(o);
    }
    n.set(r, a);
  }
  return a;
}, JK = "data-html2canvas-debug", ZK = (e) => {
  if (typeof e.getAttribute != "function") return 0;
  switch (e.getAttribute(JK)) {
    case "all":
      return 1;
    case "clone":
      return 2;
    case "parse":
      return 3;
    case "render":
      return 4;
    default:
      return 0;
  }
}, rv = (e, A) => {
  const t = ZK(e);
  return t === 1 || A === t;
}, A7 = "data-html2canvas-ignore";
var e7 = class {
  constructor(e, A, t) {
    this.cloneNodeFn = e, this.options = A, this.context = t;
  }
  appendChildNode(e, A, t) {
    this.safeAppendClonedChild(e, A, t);
  }
  /**
  * Clone child nodes from source element to clone element.
  * Handles shadow DOM, slots, and light DOM appropriately.
  */
  cloneChildNodes(e, A, t) {
    e.shadowRoot && A.shadowRoot ? (this.cloneShadowDOMChildren(e.shadowRoot, A.shadowRoot, t), this.cloneLightDOMChildren(e, A, t)) : e.shadowRoot && !A.shadowRoot ? this.cloneShadowDOMAsLightDOM(e.shadowRoot, A, t) : this.cloneLightDOMChildren(e, A, t);
  }
  /**
  * Check if a child node should be cloned based on filtering rules.
  * Filters out: scripts, ignored elements, and optionally styles.
  */
  shouldCloneChild(e) {
    return !Il(e) || !LP(e) && !e.hasAttribute("data-html2canvas-ignore") && (typeof this.options.ignoreElements != "function" || !this.options.ignoreElements(e));
  }
  /**
  * Check if a style element should be cloned based on copyStyles option.
  */
  shouldCloneStyleElement(e) {
    return !this.options.copyStyles || !Il(e) || !fS(e);
  }
  /**
  * Safely append a cloned child to a target, applying all filtering rules.
  */
  safeAppendClonedChild(e, A, t) {
    this.shouldCloneChild(A) && this.shouldCloneStyleElement(A) && e.appendChild(this.cloneNodeFn(A, t));
  }
  /**
  * Clone assigned nodes from a slot element to the target.
  */
  cloneAssignedNodes(e, A, t) {
    e.forEach((r) => {
      this.safeAppendClonedChild(A, r, t);
    });
  }
  /**
  * Clone fallback content from a slot element when no nodes are assigned.
  */
  cloneSlotFallbackContent(e, A, t) {
    for (let r = e.firstChild; r; r = r.nextSibling) this.safeAppendClonedChild(A, r, t);
  }
  /**
  * Handle cloning of a slot element, including assigned nodes or fallback content.
  */
  cloneSlotElement(e, A, t) {
    if (!Zu(e)) return;
    const r = e;
    if (typeof r.assignedNodes != "function") {
      this.context.logger.warn("HTMLSlotElement.assignedNodes is not available", e), this.cloneSlotFallbackContent(e, A, t);
      return;
    }
    const n = r.assignedNodes();
    if (!n || !Array.isArray(n)) {
      this.context.logger.warn("assignedNodes() did not return a valid array", e), this.cloneSlotFallbackContent(e, A, t);
      return;
    }
    n.length > 0 ? this.cloneAssignedNodes(n, A, t) : this.cloneSlotFallbackContent(e, A, t);
  }
  /**
  * Clone shadow DOM children to the target shadow root.
  */
  cloneShadowDOMChildren(e, A, t) {
    for (let r = e.firstChild; r; r = r.nextSibling) Il(r) && Zu(r) ? this.cloneSlotElement(r, A, t) : this.safeAppendClonedChild(A, r, t);
  }
  /**
  * Clone light DOM children to the target element.
  */
  cloneLightDOMChildren(e, A, t) {
    for (let r = e.firstChild; r; r = r.nextSibling) this.appendChildNode(A, r, t);
  }
  /**
  * Clone slot element as light DOM when shadow root creation failed.
  */
  cloneSlotElementAsLightDOM(e, A, t) {
    if (!Zu(e)) return;
    const r = e;
    if (typeof r.assignedNodes != "function") {
      for (let i = e.firstChild; i; i = i.nextSibling) this.appendChildNode(A, i, t);
      return;
    }
    const n = r.assignedNodes();
    if (n && Array.isArray(n) && n.length > 0) n.forEach((i) => this.appendChildNode(A, i, t));
    else for (let i = e.firstChild; i; i = i.nextSibling) this.appendChildNode(A, i, t);
  }
  /**
  * Clone shadow DOM content as light DOM when shadow root creation failed.
  * This is a fallback mechanism to ensure content is not lost.
  */
  cloneShadowDOMAsLightDOM(e, A, t) {
    for (let r = e.firstChild; r; r = r.nextSibling) Il(r) && Zu(r) ? this.cloneSlotElementAsLightDOM(r, A, t) : this.appendChildNode(A, r, t);
  }
};
const t7 = (e) => {
  let A = e;
  for (; A; ) {
    if (A.parentNode && A.parentNode.host) return A.parentNode;
    const t = A.getRootNode();
    if (t && t !== A.ownerDocument && t.host) return t;
    A = A.parentNode;
  }
  return null;
};
var OB = class {
  constructor(A, t, r) {
    if (this.context = A, this.options = r, this.scrolledElements = [], this.referenceElement = t, this.counters = new NP(), this.quoteDepth = 0, this.slotCloner = new e7((n, i) => this.cloneNode(n, i), {
      ignoreElements: r.ignoreElements,
      copyStyles: r.copyStyles ?? !0
    }, A), !t.ownerDocument) throw new Error("Cloned element does not have an owner document");
    if (!this.options.iframeContainer) {
      const n = t7(t);
      n && (this.options.iframeContainer = n);
    }
    this.documentElement = this.cloneNode(t.ownerDocument.documentElement, !1);
  }
  toIFrame(A, t) {
    const r = r7(A, t, this.options.iframeContainer);
    if (!r.contentWindow) throw new Error("Unable to find iframe window");
    const n = A.defaultView.pageXOffset, i = A.defaultView.pageYOffset, s = r.contentWindow, a = s.document, o = s7(r).then(async () => {
      this.scrolledElements.forEach(c7), s && s.scrollTo(t.left, t.top);
      const d = this.options.onclone, h = this.clonedReferenceElement;
      if (typeof h > "u") throw new Error(`Error finding the ${this.referenceElement.nodeName} in the cloned document`);
      return a.fonts && a.fonts.ready && await a.fonts.ready, /(AppleWebKit)/g.test(navigator.userAgent) && await i7(a), typeof d == "function" && await Promise.resolve().then(() => d(a, h)), s.scrollTo(t.left, t.top), /AppleWebKit/g.test(navigator.userAgent) && (s.scrollY !== t.top || s.scrollX !== t.left) && (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(s.scrollX - t.left, s.scrollY - t.top, 0, 0)), r;
    }), l = A.baseURI;
    a.open();
    const c = o7(document.doctype) + "<html></html>";
    try {
      const d = this.referenceElement.ownerDocument?.defaultView, h = d && d.trustedTypes;
      let p = h?.getPolicy?.("html2canvas-pro");
      !p && h && (p = h.createPolicy("html2canvas-pro", { createHTML: (y) => y }));
      const B = p ? p.createHTML(c) : c;
      a.write(B);
    } catch {
      a.write(c);
    }
    l7(this.referenceElement.ownerDocument, n, i), a.close();
    const u = a.adoptNode(this.documentElement);
    return g7(u, l), a.replaceChild(u, a.documentElement), o;
  }
  createElementClone(A) {
    if (rv(A, 2)) debugger;
    if (uS(A)) return this.createCanvasClone(A);
    if (fb(A)) return this.createVideoClone(A);
    if (fS(A)) return this.createStyleClone(A);
    const t = A.cloneNode(!1);
    return J1(t) && (J1(A) && A.currentSrc && A.currentSrc !== A.src && (t.src = A.currentSrc, t.srcset = ""), t.loading === "lazy" && (t.loading = "eager")), db(t) && !Sl(t) ? this.createCustomElementClone(A, t) : t;
  }
  createCustomElementClone(A, t) {
    const r = document.createElement("div");
    r.className = t.className, NB(t.style, r);
    const n = t.attributes;
    for (let i = 0; i < n.length; i++) {
      const s = n[i];
      s.name !== "class" && s.name !== "style" && r.setAttribute(s.name, s.value);
    }
    if (A.shadowRoot) try {
      r.attachShadow({ mode: "open" });
    } catch (i) {
      this.context.logger.error("Failed to attach shadow root to custom element clone:", i);
    }
    return r;
  }
  createStyleClone(A) {
    try {
      const r = A.sheet;
      if (r && r.cssRules) {
        const n = [].slice.call(r.cssRules, 0).reduce((s, a) => a && typeof a.cssText == "string" ? s + a.cssText : s, ""), i = A.cloneNode(!1);
        return i.textContent = n, this.options.cspNonce && (i.nonce = this.options.cspNonce), i;
      }
    } catch (r) {
      if (this.context.logger.error("Unable to access cssRules property", r), r.name !== "SecurityError") throw r;
    }
    const t = A.cloneNode(!1);
    return this.options.cspNonce && (t.nonce = this.options.cspNonce), t;
  }
  createCanvasClone(A) {
    if (this.options.inlineImages && A.ownerDocument) {
      const r = A.ownerDocument.createElement("img");
      try {
        return r.src = A.toDataURL(), r;
      } catch {
        this.context.logger.info("Unable to inline canvas contents, canvas is tainted", A);
      }
    }
    const t = A.cloneNode(!1);
    try {
      t.width = A.width, t.height = A.height;
      const r = A.getContext("2d"), n = t.getContext("2d", { willReadFrequently: !0 });
      if (n) if (!this.options.allowTaint && r) n.putImageData(r.getImageData(0, 0, A.width, A.height), 0, 0);
      else {
        const i = A.getContext("webgl2") ?? A.getContext("webgl");
        i && i.getContextAttributes()?.preserveDrawingBuffer === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", A), n.drawImage(A, 0, 0);
      }
      return t;
    } catch {
      this.context.logger.info("Unable to clone canvas as it is tainted", A);
    }
    return t;
  }
  createVideoClone(A) {
    const t = A.ownerDocument.createElement("canvas");
    t.width = A.offsetWidth, t.height = A.offsetHeight;
    const r = t.getContext("2d");
    try {
      return r && (r.drawImage(A, 0, 0, t.width, t.height), this.options.allowTaint || r.getImageData(0, 0, t.width, t.height)), t;
    } catch {
      this.context.logger.info("Unable to clone video as it is tainted", A);
    }
    const n = A.ownerDocument.createElement("canvas");
    return n.width = A.offsetWidth, n.height = A.offsetHeight, n;
  }
  appendChildNode(A, t, r) {
    this.slotCloner.appendChildNode(A, t, r);
  }
  /**
  * Clone child nodes from source element to clone element.
  * Delegates to SlotCloner which handles shadow DOM, slots, and light DOM.
  */
  cloneChildNodes(A, t, r) {
    this.slotCloner.cloneChildNodes(A, t, r);
  }
  cloneNode(A, t) {
    if (lS(A)) return document.createTextNode(A.data);
    if (!A.ownerDocument) return A.cloneNode(!1);
    const r = A.ownerDocument.defaultView;
    if (r && Il(A) && (Mh(A) || Sl(A))) {
      const n = this.createElementClone(A);
      n.style.transitionProperty = "none";
      const i = r.getComputedStyle(A), s = OP(A);
      this.referenceElement === A && Mh(n) && (this.clonedReferenceElement = n), Ty(n) && f7(n, this.options.cspNonce);
      const a = this.counters.parse(new xb(this.context, i));
      if (s) {
        const o = r.getComputedStyle(A, ":before"), l = this.resolvePseudoContent(A, n, o, 0);
        l && n.insertBefore(l, n.firstChild);
        const c = r.getComputedStyle(A, ":after"), u = this.resolvePseudoContent(A, n, c, 1);
        u && n.appendChild(u);
      }
      return db(A) && (t = !0), fb(A) || this.cloneChildNodes(A, n, t), this.counters.pop(a), (i && (this.options.copyStyles || Sl(A)) && !hS(A) || t) && NB(i, n), (A.scrollTop !== 0 || A.scrollLeft !== 0) && this.scrolledElements.push([
        n,
        A.scrollLeft,
        A.scrollTop
      ]), (vg(A) || yg(A)) && (vg(n) || yg(n)) && (n.value = A.value), n;
    }
    return A.cloneNode(!1);
  }
  resolvePseudoContent(A, t, r, n) {
    if (!r) return;
    const i = r.content, s = t.ownerDocument;
    if (!s || !i || i === "none" || i === "-moz-alt-content" || r.display === "none") return;
    this.counters.parse(new xb(this.context, r));
    const a = new YK(this.context, r), o = s.createElement("html2canvaspseudoelement");
    NB(r, o), a.content.forEach((c) => {
      if (c.type === 0) o.appendChild(s.createTextNode(c.value));
      else if (c.type === 22) {
        const u = s.createElement("img");
        u.src = c.value, u.style.opacity = "1", o.appendChild(u);
      } else if (c.type === 18) {
        if (c.name === "attr") {
          const u = c.values.filter(Oe);
          u.length && o.appendChild(s.createTextNode(A.getAttribute(u[0].value) || ""));
        } else if (c.name === "counter") {
          const [u, d] = c.values.filter(Vr);
          if (u && Oe(u)) {
            const h = this.counters.getCounterValue(u.value), p = d && Oe(d) ? Z1.parse(this.context, d.value) : 3;
            o.appendChild(s.createTextNode(Ph(h, p, !1)));
          }
        } else if (c.name === "counters") {
          const [u, d, h] = c.values.filter(Vr);
          if (u && Oe(u)) {
            const p = this.counters.getCounterValues(u.value), B = h && Oe(h) ? Z1.parse(this.context, h.value) : 3, y = d && d.type === 0 ? d.value : "", m = p.map((C) => Ph(C, B, !1)).join(y);
            o.appendChild(s.createTextNode(m));
          }
        }
      } else if (c.type === 20) switch (c.value) {
        case "open-quote":
          o.appendChild(s.createTextNode(Eb(a.quotes, this.quoteDepth++, !0)));
          break;
        case "close-quote":
          o.appendChild(s.createTextNode(Eb(a.quotes, --this.quoteDepth, !1)));
          break;
        default:
          o.appendChild(s.createTextNode(c.value));
      }
    }), o.className = `${nv} ${iv}`;
    const l = n === 0 ? ` ${nv}` : ` ${iv}`;
    return Sl(t) ? t.className.baseValue += l : t.className += l, o;
  }
  static destroy(A) {
    return A.parentNode ? (A.parentNode.removeChild(A), !0) : !1;
  }
};
const r7 = (e, A, t) => {
  const r = e.createElement("iframe");
  return r.className = "html2canvas-container", r.style.visibility = "hidden", r.style.position = "fixed", r.style.left = "-10000px", r.style.top = "0px", r.style.border = "0", r.width = A.width.toString(), r.height = A.height.toString(), r.scrolling = "no", r.setAttribute(A7, "true"), (t || e.body).appendChild(r), r;
}, n7 = (e) => new Promise((A) => {
  if (e.complete) {
    A();
    return;
  }
  if (!e.src) {
    A();
    return;
  }
  e.onload = A, e.onerror = A;
}), i7 = (e) => Promise.all([].slice.call(e.images, 0).map(n7)), s7 = (e) => new Promise((A, t) => {
  const r = e.contentWindow;
  if (!r) return t("No window assigned for iframe");
  const n = r.document;
  r.onload = e.onload = () => {
    r.onload = e.onload = null;
    const i = 600;
    let s = 0;
    const a = setInterval(() => {
      s++, (n.body.childNodes.length > 0 && n.readyState === "complete" || s >= i) && (clearInterval(a), A(e));
    }, 50);
  };
}), a7 = [
  "all",
  "d",
  "content"
], NB = (e, A) => {
  const t = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const n = e.item(r);
    if (a7.indexOf(n) === -1 && !n.startsWith("--")) {
      const i = e.getPropertyValue(n);
      if (i) {
        const s = e.getPropertyPriority(n);
        t.push(s ? `${n}:${i} !${s}` : `${n}:${i}`);
      }
    }
  }
  return t.length > 0 && (A.style.cssText = t.join(";") + ";"), A;
}, o7 = (e) => {
  let A = "";
  return e && (A += "<!DOCTYPE ", e.name && (A += e.name), e.internalSubset && (A += " " + e.internalSubset.replace(/"/g, "&quot;").replace(/>/g, "&gt;")), e.publicId ? (A += ' PUBLIC "' + e.publicId.replace(/"/g, "&quot;") + '"', e.systemId && (A += ' "' + e.systemId.replace(/"/g, "&quot;") + '"')) : e.systemId && (A += ' SYSTEM "' + e.systemId.replace(/"/g, "&quot;") + '"'), A += ">"), A;
}, l7 = (e, A, t) => {
  e && e.defaultView && (A !== e.defaultView.pageXOffset || t !== e.defaultView.pageYOffset) && e.defaultView.scrollTo(A, t);
}, c7 = ([e, A, t]) => {
  e.scrollLeft = A, e.scrollTop = t;
}, u7 = ":before", h7 = ":after", nv = "___html2canvas___pseudoelement_before", iv = "___html2canvas___pseudoelement_after", Sb = `{
    content: "" !important;
    display: none !important;
}`, f7 = (e, A) => {
  d7(e, `.${nv}${u7}${Sb}
         .${iv}${h7}${Sb}`, A);
}, d7 = (e, A, t) => {
  const r = e.ownerDocument;
  if (r) {
    const n = r.createElement("style");
    n.textContent = A, t && (n.nonce = t), e.appendChild(n);
  }
}, g7 = (e, A) => {
  const t = e.ownerDocument.createElement("base");
  t.href = A;
  const r = e.getElementsByTagName("head").item(0);
  r?.insertBefore(t, r?.firstChild ?? null);
};
var Lb = class {
  /**
  * Normalize a single element and return original styles.
  *
  * ## Why we replace transforms with an identity value instead of "none"
  *
  * `getBoundingClientRect()` returns visual (post-transform) coordinates, so we
  * must neutralize any active transform before measuring element bounds.
  *
  * The naive approach of setting `transform: none` (or `rotate: none`) has a
  * critical side-effect: per **CSS Transforms Level 2**, an element whose
  * `transform` is non-none automatically becomes the **containing block** for
  * all of its `position: absolute` *and* `position: fixed` descendants.
  * Setting it to `none` destroys that role, causing children to resolve their
  * percentage dimensions and offsets against an unintended ancestor — which
  * produces completely wrong bounds.
  *
  * Solution: instead of removing the transform, we replace it with a visually
  * inert identity value:
  *
  * - `transform: scale(0.5)` → `transform: translate(0, 0)`
  *   - `translate(0, 0)` is an identity transform (no visual change, no layout shift).
  *   - `getBoundingClientRect()` returns the same layout-space coordinates as
  *     if there were no transform at all.
  *   - Because the value is still non-none, the element **remains a containing
  *     block** for both `position: absolute` and `position: fixed` descendants.
  *
  * - `rotate: 45deg` → `rotate: 0deg`
  *   - `0deg` is the identity rotation; `0deg ≠ none`, so the same containing-
  *     block guarantee holds.
  *
  * @param element - Element to normalize
  * @param styles - Parsed CSS styles
  * @returns Original styles map for restoration
  */
  static normalizeElement(e, A) {
    const t = {};
    return Mh(e) && (A.animationDuration.some((r) => r > 0) && (t.animationDuration = e.style.animationDuration, e.style.animationDuration = "0s"), A.transform !== null && (t.transform = e.style.transform, e.style.transform = "translate(0, 0)"), A.rotate !== null && (t.rotate = e.style.rotate, e.style.rotate = "0deg", t.transform === void 0 && (t.transform = e.style.transform, e.style.transform = "translate(0, 0)"))), t;
  }
  /**
  * Restore element styles after rendering.
  *
  * @param element - Element to restore
  * @param originalStyles - Original styles to restore
  */
  static restoreElement(e, A) {
    Mh(e) && (A.animationDuration !== void 0 && (e.style.animationDuration = A.animationDuration), A.transform !== void 0 && (e.style.transform = A.transform), A.rotate !== void 0 && (e.style.rotate = A.rotate));
  }
}, Ys = class {
  constructor(A, t, r = {}) {
    if (this.context = A, this.textNodes = [], this.elements = [], this.createsStackingContext = !1, this.createsRealStackingContext = !1, this.isListOwner = !1, this.debugRender = !1, rv(t, 3)) debugger;
    if (this.styles = new XK(A, A.config.window.getComputedStyle(t, null)), r.normalizeDom !== !1 && Mh(t) && (this.originalStyles = Lb.normalizeElement(t, this.styles), this.originalElement = t), this.bounds = Nh(this.context, t), t.tagName === "FIELDSET") {
      const n = t.querySelector(":scope > legend");
      if (n) {
        const i = Nh(this.context, n);
        this.legendBounds = i;
        const s = i.top + i.height / 2 - this.styles.borderTopWidth / 2;
        this.bounds = new Hn(this.bounds.left, s, this.bounds.width, this.bounds.height - (s - this.bounds.top));
      }
    }
    rv(t, 4) && (this.debugRender = !0);
  }
  /**
  * Restore original element styles (if normalized)
  * Call this after rendering is complete to clean up DOM state
  */
  restore() {
    this.originalStyles && this.originalElement && (Lb.restoreElement(this.originalElement, this.originalStyles), this.originalStyles = void 0, this.originalElement = void 0);
  }
  /**
  * Recursively restore all elements in the tree
  * Call this on the root container after rendering is complete
  */
  restoreTree() {
    this.restore();
    for (const A of this.elements) A.restoreTree();
  }
}, p7 = "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", Hb = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Ah = typeof Uint8Array > "u" ? [] : /* @__PURE__ */ new Uint8Array(256);
for (var Ad = 0; Ad < Hb.length; Ad++) Ah[Hb.charCodeAt(Ad)] = Ad;
var B7 = function(e) {
  var A = e.length * 0.75, t = e.length, r, n = 0, i, s, a, o;
  e[e.length - 1] === "=" && (A--, e[e.length - 2] === "=" && A--);
  var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), c = Array.isArray(l) ? l : new Uint8Array(l);
  for (r = 0; r < t; r += 4)
    i = Ah[e.charCodeAt(r)], s = Ah[e.charCodeAt(r + 1)], a = Ah[e.charCodeAt(r + 2)], o = Ah[e.charCodeAt(r + 3)], c[n++] = i << 2 | s >> 4, c[n++] = (s & 15) << 4 | a >> 2, c[n++] = (a & 3) << 6 | o & 63;
  return l;
}, w7 = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 2) t.push(e[r + 1] << 8 | e[r]);
  return t;
}, m7 = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 4) t.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
  return t;
}, Nl = 5, _y = 11, DB = 2, v7 = _y - Nl, SS = 65536 >> Nl, RB = (1 << Nl) - 1, y7 = SS + (1024 >> Nl) + 32, C7 = 65536 >> _y, b7 = (1 << v7) - 1, Tb = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint16Array(Array.prototype.slice.call(e, A, t));
}, F7 = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint32Array(Array.prototype.slice.call(e, A, t));
}, Q7 = function(e, A) {
  var t = B7(e), r = Array.isArray(t) ? m7(t) : new Uint32Array(t), n = Array.isArray(t) ? w7(t) : new Uint16Array(t), i = 24, s = Tb(n, i / 2, r[4] / 2), a = r[5] === 2 ? Tb(n, (i + r[4]) / 2) : F7(r, Math.ceil((i + r[4]) / 4));
  return new U7(r[0], r[1], r[2], r[3], s, a);
}, U7 = (function() {
  function e(A, t, r, n, i, s) {
    this.initialValue = A, this.errorValue = t, this.highStart = r, this.highValueIndex = n, this.index = i, this.data = s;
  }
  return e.prototype.get = function(A) {
    var t;
    if (A >= 0) {
      if (A < 55296 || A > 56319 && A <= 65535)
        return t = this.index[A >> Nl], t = (t << DB) + (A & RB), this.data[t];
      if (A <= 65535)
        return t = this.index[SS + (A - 55296 >> Nl)], t = (t << DB) + (A & RB), this.data[t];
      if (A < this.highStart)
        return t = y7 - C7 + (A >> _y), t = this.index[t], t += A >> Nl & b7, t = this.index[t], t = (t << DB) + (A & RB), this.data[t];
      if (A <= 1114111) return this.data[this.highValueIndex];
    }
    return this.errorValue;
  }, e;
})(), _b = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", E7 = typeof Uint8Array > "u" ? [] : /* @__PURE__ */ new Uint8Array(256);
for (var ed = 0; ed < _b.length; ed++) E7[_b.charCodeAt(ed)] = ed;
var x7 = 1, MB = 2, PB = 3, Ob = 4, Nb = 5, I7 = 7, Db = 8, kB = 9, KB = 10, Rb = 11, Mb = 12, Pb = 13, kb = 14, VB = 15, S7 = function(e) {
  for (var A = [], t = 0, r = e.length; t < r; ) {
    var n = e.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < r) {
      var i = e.charCodeAt(t++);
      (i & 64512) === 56320 ? A.push(((n & 1023) << 10) + (i & 1023) + 65536) : (A.push(n), t--);
    } else A.push(n);
  }
  return A;
}, L7 = function() {
  for (var e = [], A = 0; A < arguments.length; A++) e[A] = arguments[A];
  if (String.fromCodePoint) return String.fromCodePoint.apply(String, e);
  var t = e.length;
  if (!t) return "";
  for (var r = [], n = -1, i = ""; ++n < t; ) {
    var s = e[n];
    s <= 65535 ? r.push(s) : (s -= 65536, r.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === t || r.length > 16384) && (i += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return i;
}, H7 = Q7(p7), Mi = "×", GB = "÷", T7 = function(e) {
  return H7.get(e);
}, _7 = function(e, A, t) {
  var r = t - 2, n = A[r], i = A[t - 1], s = A[t];
  if (i === MB && s === PB) return Mi;
  if (i === MB || i === PB || i === Ob || s === MB || s === PB || s === Ob) return GB;
  if (i === Db && [
    Db,
    kB,
    Rb,
    Mb
  ].indexOf(s) !== -1 || (i === Rb || i === kB) && (s === kB || s === KB) || (i === Mb || i === KB) && s === KB || s === Pb || s === Nb || s === I7 || i === x7) return Mi;
  if (i === Pb && s === kb) {
    for (; n === Nb; ) n = A[--r];
    if (n === kb) return Mi;
  }
  if (i === VB && s === VB) {
    for (var a = 0; n === VB; )
      a++, n = A[--r];
    if (a % 2 === 0) return Mi;
  }
  return GB;
}, O7 = function(e) {
  var A = S7(e), t = A.length, r = 0, n = 0, i = A.map(T7);
  return { next: function() {
    if (r >= t) return {
      done: !0,
      value: null
    };
    for (var s = Mi; r < t && (s = _7(A, i, ++r)) === Mi; ) ;
    if (s !== Mi || r === t) {
      var a = L7.apply(null, A.slice(n, r));
      return n = r, {
        value: a,
        done: !1
      };
    }
    return {
      done: !0,
      value: null
    };
  } };
}, N7 = function(e) {
  for (var A = O7(e), t = [], r; !(r = A.next()).done; ) r.value && t.push(r.value.slice());
  return t;
};
const D7 = (e) => {
  if (e.createRange) {
    const t = e.createRange();
    if (t.getBoundingClientRect) {
      const r = e.createElement("boundtest");
      r.style.height = "123px", r.style.display = "block", e.body.appendChild(r), t.selectNode(r);
      const n = t.getBoundingClientRect(), i = Math.round(n.height);
      if (e.body.removeChild(r), i === 123) return !0;
    }
  }
  return !1;
}, R7 = (e) => {
  const A = e.createElement("boundtest");
  A.style.width = "50px", A.style.display = "block", A.style.fontSize = "12px", A.style.letterSpacing = "0px", A.style.wordSpacing = "0px", e.body.appendChild(A);
  const t = e.createRange();
  A.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
  const r = A.firstChild, n = Ap(r.data).map((o) => wr(o));
  let i = 0, s = {};
  const a = n.every((o, l) => {
    t.setStart(r, i), t.setEnd(r, i + o.length);
    const c = t.getBoundingClientRect();
    i += o.length;
    const u = c.x > s.x || c.y > s.y;
    return s = c, l === 0 ? !0 : u;
  });
  return e.body.removeChild(A), a;
}, M7 = () => typeof new Image().crossOrigin < "u", P7 = () => typeof new XMLHttpRequest().responseType == "string", k7 = (e) => {
  const A = new Image(), t = e.createElement("canvas"), r = t.getContext("2d");
  if (!r) return !1;
  A.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
  try {
    r.drawImage(A, 0, 0), t.toDataURL();
  } catch {
    return !1;
  }
  return !0;
}, Kb = (e) => e[0] === 0 && e[1] === 255 && e[2] === 0 && e[3] === 255, K7 = (e) => {
  const A = e.createElement("canvas"), t = 100;
  A.width = t, A.height = t;
  const r = A.getContext("2d");
  if (!r) return Promise.reject(/* @__PURE__ */ new Error("Failed to get 2D rendering context"));
  r.fillStyle = "rgb(0, 255, 0)", r.fillRect(0, 0, t, t);
  const n = new Image(), i = A.toDataURL();
  n.src = i;
  const s = sv(t, t, 0, 0, n);
  return r.fillStyle = "red", r.fillRect(0, 0, t, t), av(s).then((a) => {
    r.drawImage(a, 0, 0);
    const o = r.getImageData(0, 0, t, t).data;
    r.fillStyle = "red", r.fillRect(0, 0, t, t);
    const l = e.createElement("div");
    return l.style.backgroundImage = `url(${i})`, l.style.height = `${t}px`, Kb(o) ? av(sv(t, t, 0, 0, l)) : Promise.reject(/* @__PURE__ */ new Error("ForeignObject rendering not supported"));
  }).then((a) => (r.drawImage(a, 0, 0), Kb(r.getImageData(0, 0, t, t).data))).catch(() => !1);
}, sv = (e, A, t, r, n) => {
  const i = "http://www.w3.org/2000/svg", s = document.createElementNS(i, "svg"), a = document.createElementNS(i, "foreignObject");
  return s.setAttributeNS(null, "width", e.toString()), s.setAttributeNS(null, "height", A.toString()), a.setAttributeNS(null, "width", "100%"), a.setAttributeNS(null, "height", "100%"), a.setAttributeNS(null, "x", t.toString()), a.setAttributeNS(null, "y", r.toString()), a.setAttributeNS(null, "externalResourcesRequired", "true"), s.appendChild(a), a.appendChild(n), s;
}, av = (e) => new Promise((A, t) => {
  const r = new Image();
  r.onload = () => A(r), r.onerror = t, r.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(new XMLSerializer().serializeToString(e))}`;
}), sn = {
  get SUPPORT_RANGE_BOUNDS() {
    const e = D7(document);
    return Object.defineProperty(sn, "SUPPORT_RANGE_BOUNDS", { value: e }), e;
  },
  get SUPPORT_WORD_BREAKING() {
    const e = sn.SUPPORT_RANGE_BOUNDS && R7(document);
    return Object.defineProperty(sn, "SUPPORT_WORD_BREAKING", { value: e }), e;
  },
  get SUPPORT_SVG_DRAWING() {
    const e = k7(document);
    return Object.defineProperty(sn, "SUPPORT_SVG_DRAWING", { value: e }), e;
  },
  get SUPPORT_FOREIGNOBJECT_DRAWING() {
    const e = typeof Array.from == "function" && typeof window.fetch == "function" ? K7(document) : Promise.resolve(!1);
    return Object.defineProperty(sn, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: e }), e;
  },
  get SUPPORT_CORS_IMAGES() {
    const e = M7();
    return Object.defineProperty(sn, "SUPPORT_CORS_IMAGES", { value: e }), e;
  },
  get SUPPORT_RESPONSE_TYPE() {
    const e = P7();
    return Object.defineProperty(sn, "SUPPORT_RESPONSE_TYPE", { value: e }), e;
  },
  get SUPPORT_CORS_XHR() {
    const e = "withCredentials" in new XMLHttpRequest();
    return Object.defineProperty(sn, "SUPPORT_CORS_XHR", { value: e }), e;
  },
  get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
    const e = !!(typeof Intl < "u" && Intl.Segmenter);
    return Object.defineProperty(sn, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: e }), e;
  }
};
var Dl = class {
  constructor(A, t) {
    this.text = A, this.bounds = t;
  }
};
const V7 = (e, A, t, r) => {
  const n = j7(A, t), i = [];
  let s = 0;
  return n.forEach((a) => {
    if (t.textDecorationLine.length || a.trim().length > 0) if (sn.SUPPORT_RANGE_BOUNDS) {
      const o = Vb(r, s, a.length).getClientRects();
      if (o.length > 1) {
        const l = Rl(a);
        let c = 0;
        l.forEach((u) => {
          i.push(new Dl(u, Hn.fromDOMRectList(e, Vb(r, c + s, u.length).getClientRects()))), c += u.length;
        });
      } else i.push(new Dl(a, Hn.fromDOMRectList(e, o)));
    } else {
      const o = r.splitText(a.length);
      i.push(new Dl(a, G7(e, r))), r = o;
    }
    else sn.SUPPORT_RANGE_BOUNDS || (r = r.splitText(a.length));
    s += a.length;
  }), i;
}, G7 = (e, A) => {
  const t = A.ownerDocument;
  if (t) {
    const r = t.createElement("html2canvaswrapper");
    r.appendChild(A.cloneNode(!0));
    const n = A.parentNode;
    if (n) {
      n.replaceChild(r, A);
      const i = Nh(e, r);
      return r.firstChild && n.replaceChild(r.firstChild, r), i;
    }
  }
  return Hn.EMPTY;
}, Vb = (e, A, t) => {
  const r = e.ownerDocument;
  if (!r) throw new Error("Node has no owner document");
  const n = r.createRange();
  return n.setStart(e, A), n.setEnd(e, A + t), n;
}, Rl = (e) => {
  if (sn.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    const A = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    return Array.from(A.segment(e)).map((t) => t.segment);
  }
  return N7(e);
}, W7 = (e, A) => {
  if (sn.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    const t = new Intl.Segmenter(void 0, { granularity: "word" });
    return Array.from(t.segment(e)).map((r) => r.segment);
  }
  return $7(e, A);
}, j7 = (e, A) => Cg(A.writingMode) || A.letterSpacing !== 0 ? Rl(e) : W7(e, A), q7 = [
  32,
  160,
  4961,
  65792,
  65793,
  4153,
  4241
], $7 = (e, A) => {
  const t = nM(e, {
    lineBreak: A.lineBreak,
    wordBreak: A.overflowWrap === "break-word" ? "break-word" : A.wordBreak
  }), r = [];
  let n;
  for (; !(n = t.next()).done; ) if (n.value) {
    const i = Ap(n.value.slice());
    let s = "";
    i.forEach((a) => {
      q7.indexOf(a) === -1 ? s += wr(a) : (s.length && r.push(s), r.push(wr(a)), s = "");
    }), s.length && r.push(s);
  }
  return r;
};
var z7 = class {
  constructor(A, t, r) {
    this.text = X7(t.data, r.textTransform), this.text.length !== t.data.length && (t.data = this.text), this.textBounds = V7(A, this.text, r, t);
  }
};
const X7 = (e, A) => {
  switch (A) {
    case 1:
      return e.toLowerCase();
    case 3:
      return e.replace(Y7, J7);
    case 2:
      return e.toUpperCase();
    default:
      return e;
  }
}, Y7 = /(^|\s|:|-|\(|\))([a-z])/g, J7 = (e, A, t) => e.length > 0 ? A + t.toUpperCase() : e;
var LS = class extends Ys {
  constructor(A, t) {
    super(A, t), this.src = t.currentSrc || t.src, this.intrinsicWidth = t.naturalWidth, this.intrinsicHeight = t.naturalHeight, this.context.cache.addImage(this.src);
  }
}, HS = class extends Ys {
  constructor(A, t) {
    super(A, t), this.canvas = t, this.intrinsicWidth = t.width, this.intrinsicHeight = t.height;
  }
};
const Z7 = [
  "position",
  "inset",
  "top",
  "right",
  "bottom",
  "left",
  "inset-inline",
  "inset-inline-start",
  "inset-inline-end",
  "inset-block",
  "inset-block-start",
  "inset-block-end",
  "margin",
  "margin-top",
  "margin-right",
  "margin-bottom",
  "margin-left",
  "margin-inline",
  "margin-inline-start",
  "margin-inline-end",
  "margin-block",
  "margin-block-start",
  "margin-block-end"
], A9 = (e, A) => {
  const t = A.getAttribute("style");
  Z7.forEach((n) => A.style.removeProperty(n));
  const r = e.serializeToString(A);
  return t === null ? A.removeAttribute("style") : A.setAttribute("style", t), r;
};
var TS = class extends Ys {
  constructor(A, t) {
    super(A, t);
    const r = new XMLSerializer(), n = Nh(A, t);
    t.setAttribute("width", `${n.width}px`), t.setAttribute("height", `${n.height}px`), this.svg = `data:image/svg+xml,${encodeURIComponent(A9(r, t))}`, this.intrinsicWidth = t.width.baseVal.value, this.intrinsicHeight = t.height.baseVal.value, this.context.cache.addImage(this.svg);
  }
}, _S = class extends Ys {
  constructor(A, t) {
    super(A, t), this.value = t.value;
  }
}, ov = class extends Ys {
  constructor(A, t) {
    super(A, t), this.start = t.start, this.reversed = typeof t.reversed == "boolean" && t.reversed === !0;
  }
};
const e9 = [{
  type: 15,
  flags: 0,
  unit: "px",
  number: 3
}], t9 = [{
  type: 16,
  flags: 0,
  number: 50
}], r9 = (e) => e.width > e.height ? new Hn(e.left + (e.width - e.height) / 2, e.top, e.height, e.height) : e.width < e.height ? new Hn(e.left, e.top + (e.height - e.width) / 2, e.width, e.width) : e, n9 = (e) => {
  const A = e.type === "password" ? new Array(e.value.length + 1).join("•") : e.value;
  return A.length === 0 ? e.placeholder || "" : A;
}, i9 = (e) => e.value.length === 0 && !!e.placeholder, s9 = "checkbox", a9 = "radio", Gb = 707406591, o9 = 1970632191;
var kc = class extends Ys {
  constructor(A, t) {
    switch (super(A, t), this.type = t.type.toLowerCase(), this.checked = t.checked, this.value = n9(t), this.isPlaceholder = i9(t), (this.type === "checkbox" || this.type === "radio") && (this.styles.backgroundColor = 3739148031, this.styles.borderTopColor = this.styles.borderRightColor = this.styles.borderBottomColor = this.styles.borderLeftColor = 2779096575, this.styles.borderTopWidth = this.styles.borderRightWidth = this.styles.borderBottomWidth = this.styles.borderLeftWidth = 1, this.styles.borderTopStyle = this.styles.borderRightStyle = this.styles.borderBottomStyle = this.styles.borderLeftStyle = 1, this.styles.backgroundClip = [0], this.styles.backgroundOrigin = [0], this.bounds = r9(this.bounds)), this.type) {
      case s9:
        this.styles.borderTopRightRadius = this.styles.borderTopLeftRadius = this.styles.borderBottomRightRadius = this.styles.borderBottomLeftRadius = e9;
        break;
      case a9:
        this.styles.borderTopRightRadius = this.styles.borderTopLeftRadius = this.styles.borderBottomRightRadius = this.styles.borderBottomLeftRadius = t9;
        break;
    }
  }
}, OS = class extends Ys {
  constructor(A, t) {
    super(A, t);
    const r = t.options[t.selectedIndex || 0];
    this.value = r && r.text || "";
  }
}, NS = class extends Ys {
  constructor(A, t) {
    super(A, t), this.value = t.value;
  }
}, DS = class extends Ys {
  constructor(A, t, r) {
    super(A, t), this.src = t.src, this.width = parseInt(t.width, 10) || 0, this.height = parseInt(t.height, 10) || 0, this.backgroundColor = this.styles.backgroundColor, this.parseTreeFn = r;
    try {
      if (t.contentWindow && t.contentWindow.document && t.contentWindow.document.documentElement && this.parseTreeFn) {
        this.tree = this.parseTreeFn(A, t.contentWindow.document.documentElement);
        const n = t.contentWindow.document.documentElement ? jc(A, getComputedStyle(t.contentWindow.document.documentElement).backgroundColor) : $s.TRANSPARENT, i = t.contentWindow.document.body ? jc(A, getComputedStyle(t.contentWindow.document.body).backgroundColor) : $s.TRANSPARENT;
        this.backgroundColor = Sa(n) ? Sa(i) ? this.styles.backgroundColor : i : n;
      }
    } catch {
    }
  }
};
const l9 = [
  "OL",
  "UL",
  "MENU"
], lv = (e, A, t, r) => {
  for (let n = A.firstChild, i; n; n = i)
    i = n.nextSibling, RS(e, n, t, r);
}, RS = (e, A, t, r) => {
  if (lS(A) && A.data.length > 0) t.textNodes.push(new z7(e, A, t.styles));
  else if (Il(A)) if (Zu(A) && A.assignedNodes) A.assignedNodes().forEach((n) => RS(e, n, t, r));
  else {
    const n = MS(e, A);
    n.styles.isVisible() && (c9(A, n, r) ? n.createsRealStackingContext = !0 : u9(n.styles) && (n.createsStackingContext = !0), l9.indexOf(A.tagName) !== -1 && (n.isListOwner = !0), t.elements.push(n), A.shadowRoot ? lv(e, A.shadowRoot, n, r) : !vg(A) && !cS(A) && !yg(A) && lv(e, A, n, r));
  }
}, MS = (e, A) => J1(A) ? new LS(e, A) : uS(A) ? new HS(e, A) : cS(A) ? new TS(e, A) : HP(A) ? new _S(e, A) : TP(A) ? new ov(e, A) : IP(A) ? new kc(e, A) : yg(A) ? new OS(e, A) : vg(A) ? new NS(e, A) : hS(A) ? new DS(e, A, PS) : new Ys(e, A), PS = (e, A) => {
  const t = MS(e, A);
  return t.createsRealStackingContext = !0, lv(e, A, t, t), t;
}, c9 = (e, A, t) => A.styles.isPositionedWithZIndex() || A.styles.opacity < 1 || !!A.styles.filter || A.styles.isTransformed() || Ty(e) && t.styles.isTransparent(), u9 = (e) => e.isPositioned() || e.isFloating() ? !0 : zr(e.display, 268435456) || zr(e.display, 33554432) || zr(e.display, 536870912) || zr(e.display, 134217728), Wb = (e, A) => e.length === A.length ? e.some((t, r) => t === A[r]) : !1, jb = (e, A, t, r, n) => e.map((i, s) => {
  switch (s) {
    case 0:
      return i.add(A, t);
    case 1:
      return i.add(A + r, t);
    case 2:
      return i.add(A + r, t + n);
    case 3:
      return i.add(A, t + n);
  }
  return i;
});
var re = class kS {
  constructor(A, t) {
    this.type = 0, this.x = A, this.y = t;
  }
  add(A, t) {
    return new kS(this.x + A, this.y + t);
  }
};
const Cc = (e, A, t) => new re(e.x + (A.x - e.x) * t, e.y + (A.y - e.y) * t);
var td = class eh {
  constructor(A, t, r, n) {
    this.type = 1, this.start = A, this.startControl = t, this.endControl = r, this.end = n;
  }
  subdivide(A, t) {
    const r = Cc(this.start, this.startControl, A), n = Cc(this.startControl, this.endControl, A), i = Cc(this.endControl, this.end, A), s = Cc(r, n, A), a = Cc(n, i, A), o = Cc(s, a, A);
    return t ? new eh(this.start, r, s, o) : new eh(o, a, i, this.end);
  }
  add(A, t) {
    return new eh(this.start.add(A, t), this.startControl.add(A, t), this.endControl.add(A, t), this.end.add(A, t));
  }
  reverse() {
    return new eh(this.end, this.endControl, this.startControl, this.start);
  }
};
const ji = (e) => e.type === 1;
var h9 = class {
  constructor(A) {
    const t = A.styles, r = A.bounds;
    let [n, i] = Ju(t.borderTopLeftRadius, r.width, r.height), [s, a] = Ju(t.borderTopRightRadius, r.width, r.height), [o, l] = Ju(t.borderBottomRightRadius, r.width, r.height), [c, u] = Ju(t.borderBottomLeftRadius, r.width, r.height);
    const d = [];
    d.push((n + s) / r.width), d.push((c + o) / r.width), d.push((i + u) / r.height), d.push((a + l) / r.height);
    const h = Math.max(...d);
    h > 1 && (n /= h, i /= h, s /= h, a /= h, o /= h, l /= h, c /= h, u /= h);
    const p = r.width - s, B = r.height - l, y = r.width - o, m = r.height - u, C = t.borderTopWidth, Q = t.borderRightWidth, F = t.borderBottomWidth, T = t.borderLeftWidth, V = Ie(t.paddingTop, A.bounds.width), M = Ie(t.paddingRight, A.bounds.width), D = Ie(t.paddingBottom, A.bounds.width), I = Ie(t.paddingLeft, A.bounds.width);
    this.topLeftBorderDoubleOuterBox = n > 0 || i > 0 ? Rt(r.left + T / 3, r.top + C / 3, n - T / 3, i - C / 3, 0) : new re(r.left + T / 3, r.top + C / 3), this.topRightBorderDoubleOuterBox = n > 0 || i > 0 ? Rt(r.left + p, r.top + C / 3, s - Q / 3, a - C / 3, 1) : new re(r.left + r.width - Q / 3, r.top + C / 3), this.bottomRightBorderDoubleOuterBox = o > 0 || l > 0 ? Rt(r.left + y, r.top + B, o - Q / 3, l - F / 3, 2) : new re(r.left + r.width - Q / 3, r.top + r.height - F / 3), this.bottomLeftBorderDoubleOuterBox = c > 0 || u > 0 ? Rt(r.left + T / 3, r.top + m, c - T / 3, u - F / 3, 3) : new re(r.left + T / 3, r.top + r.height - F / 3), this.topLeftBorderDoubleInnerBox = n > 0 || i > 0 ? Rt(r.left + T * 2 / 3, r.top + C * 2 / 3, n - T * 2 / 3, i - C * 2 / 3, 0) : new re(r.left + T * 2 / 3, r.top + C * 2 / 3), this.topRightBorderDoubleInnerBox = n > 0 || i > 0 ? Rt(r.left + p, r.top + C * 2 / 3, s - Q * 2 / 3, a - C * 2 / 3, 1) : new re(r.left + r.width - Q * 2 / 3, r.top + C * 2 / 3), this.bottomRightBorderDoubleInnerBox = o > 0 || l > 0 ? Rt(r.left + y, r.top + B, o - Q * 2 / 3, l - F * 2 / 3, 2) : new re(r.left + r.width - Q * 2 / 3, r.top + r.height - F * 2 / 3), this.bottomLeftBorderDoubleInnerBox = c > 0 || u > 0 ? Rt(r.left + T * 2 / 3, r.top + m, c - T * 2 / 3, u - F * 2 / 3, 3) : new re(r.left + T * 2 / 3, r.top + r.height - F * 2 / 3), this.topLeftBorderStroke = n > 0 || i > 0 ? Rt(r.left + T / 2, r.top + C / 2, n - T / 2, i - C / 2, 0) : new re(r.left + T / 2, r.top + C / 2), this.topRightBorderStroke = n > 0 || i > 0 ? Rt(r.left + p, r.top + C / 2, s - Q / 2, a - C / 2, 1) : new re(r.left + r.width - Q / 2, r.top + C / 2), this.bottomRightBorderStroke = o > 0 || l > 0 ? Rt(r.left + y, r.top + B, o - Q / 2, l - F / 2, 2) : new re(r.left + r.width - Q / 2, r.top + r.height - F / 2), this.bottomLeftBorderStroke = c > 0 || u > 0 ? Rt(r.left + T / 2, r.top + m, c - T / 2, u - F / 2, 3) : new re(r.left + T / 2, r.top + r.height - F / 2), this.topLeftBorderBox = n > 0 || i > 0 ? Rt(r.left, r.top, n, i, 0) : new re(r.left, r.top), this.topRightBorderBox = s > 0 || a > 0 ? Rt(r.left + p, r.top, s, a, 1) : new re(r.left + r.width, r.top), this.bottomRightBorderBox = o > 0 || l > 0 ? Rt(r.left + y, r.top + B, o, l, 2) : new re(r.left + r.width, r.top + r.height), this.bottomLeftBorderBox = c > 0 || u > 0 ? Rt(r.left, r.top + m, c, u, 3) : new re(r.left, r.top + r.height), this.topLeftPaddingBox = n > 0 || i > 0 ? Rt(r.left + T, r.top + C, Math.max(0, n - T), Math.max(0, i - C), 0) : new re(r.left + T, r.top + C), this.topRightPaddingBox = s > 0 || a > 0 ? Rt(r.left + Math.min(p, r.width - Q), r.top + C, p > r.width + Q ? 0 : Math.max(0, s - Q), Math.max(0, a - C), 1) : new re(r.left + r.width - Q, r.top + C), this.bottomRightPaddingBox = o > 0 || l > 0 ? Rt(r.left + Math.min(y, r.width - T), r.top + Math.min(B, r.height - F), Math.max(0, o - Q), Math.max(0, l - F), 2) : new re(r.left + r.width - Q, r.top + r.height - F), this.bottomLeftPaddingBox = c > 0 || u > 0 ? Rt(r.left + T, r.top + Math.min(m, r.height - F), Math.max(0, c - T), Math.max(0, u - F), 3) : new re(r.left + T, r.top + r.height - F), this.topLeftContentBox = n > 0 || i > 0 ? Rt(r.left + T + I, r.top + C + V, Math.max(0, n - (T + I)), Math.max(0, i - (C + V)), 0) : new re(r.left + T + I, r.top + C + V), this.topRightContentBox = s > 0 || a > 0 ? Rt(r.left + Math.min(p, r.width + T + I), r.top + C + V, p > r.width + T + I ? 0 : s - T + I, a - (C + V), 1) : new re(r.left + r.width - (Q + M), r.top + C + V), this.bottomRightContentBox = o > 0 || l > 0 ? Rt(r.left + Math.min(y, r.width - (T + I)), r.top + Math.min(B, r.height + C + V), Math.max(0, o - (Q + M)), l - (F + D), 2) : new re(r.left + r.width - (Q + M), r.top + r.height - (F + D)), this.bottomLeftContentBox = c > 0 || u > 0 ? Rt(r.left + T + I, r.top + m, Math.max(0, c - (T + I)), u - (F + D), 3) : new re(r.left + T + I, r.top + r.height - (F + D));
  }
};
const Rt = (e, A, t, r, n) => {
  const i = 4 * ((Math.sqrt(2) - 1) / 3), s = t * i, a = r * i, o = e + t, l = A + r;
  switch (n) {
    case 0:
      return new td(new re(e, l), new re(e, l - a), new re(o - s, A), new re(o, A));
    case 1:
      return new td(new re(e, A), new re(e + s, A), new re(o, l - a), new re(o, l));
    case 2:
      return new td(new re(o, A), new re(o, A + a), new re(e + s, l), new re(e, l));
    default:
      return new td(new re(o, l), new re(o - s, l), new re(e, A + a), new re(e, A));
  }
}, qc = (e) => [
  e.topLeftBorderBox,
  e.topRightBorderBox,
  e.bottomRightBorderBox,
  e.bottomLeftBorderBox
], f9 = (e) => [
  e.topLeftContentBox,
  e.topRightContentBox,
  e.bottomRightContentBox,
  e.bottomLeftContentBox
], bg = (e) => [
  e.topLeftPaddingBox,
  e.topRightPaddingBox,
  e.bottomRightPaddingBox,
  e.bottomLeftPaddingBox
];
var WB = class {
  constructor(A, t, r) {
    this.offsetX = A, this.offsetY = t, this.matrix = r, this.type = 0, this.target = 6;
  }
}, rd = class {
  constructor(A, t) {
    this.path = A, this.target = t, this.type = 1;
  }
}, d9 = class {
  constructor(A) {
    this.opacity = A, this.type = 2, this.target = 6;
  }
}, Lu = class {
  constructor(e) {
    this.applyClip = e, this.type = 3, this.target = 6;
  }
};
const g9 = {
  [Ir.NORMAL]: "source-over",
  [Ir.MULTIPLY]: "multiply",
  [Ir.SCREEN]: "screen",
  [Ir.OVERLAY]: "overlay",
  [Ir.DARKEN]: "darken",
  [Ir.LIGHTEN]: "lighten",
  [Ir.COLOR_DODGE]: "color-dodge",
  [Ir.COLOR_BURN]: "color-burn",
  [Ir.HARD_LIGHT]: "hard-light",
  [Ir.SOFT_LIGHT]: "soft-light",
  [Ir.DIFFERENCE]: "difference",
  [Ir.EXCLUSION]: "exclusion",
  [Ir.HUE]: "hue",
  [Ir.SATURATION]: "saturation",
  [Ir.COLOR]: "color",
  [Ir.LUMINOSITY]: "luminosity"
};
var p9 = class {
  constructor(e) {
    this.mixBlendMode = e, this.type = 4, this.target = 6, this.compositeOperation = g9[e];
  }
}, KS = class Oc {
  constructor(A) {
    this.type = 5, this.target = 6;
    const t = Oc.parseDropShadow(A);
    this.shadow = t.shadow, this.safeFilterString = t.safeFilterString;
  }
  /**
  * Parse a CSS filter string, extracting drop-shadow() parameters for
  * rendering via ctx.shadow* (which avoids canvas taint), and producing
  * a safe filter string with all drop-shadow() calls removed.
  *
  * Uses paren-depth tracking to correctly handle nested function
  * arguments — e.g. rgba() / hsla() inside drop-shadow() — which
  * the previous regex-based approach ([^)]+) could not handle.
  *
  * Per CSS spec the shadow value is: <color>? && <length>{2,3}
  * (components can appear in any order).
  */
  static parseDropShadow(A) {
    if (!A) return { safeFilterString: "" };
    const t = Oc.findDropShadows(A);
    if (t.length === 0) return { safeFilterString: A };
    const r = Oc.parseDropShadowBody(t[0].body);
    let n = "", i = 0;
    for (const s of t)
      n += A.slice(i, s.start), i = s.end;
    return n += A.slice(i), {
      shadow: r,
      safeFilterString: n.replace(/\s+/g, " ").trim()
    };
  }
  /**
  * Find all drop-shadow() function calls in a CSS filter string.
  * Uses paren-depth tracking to correctly skip over nested
  * parentheses (e.g. rgba(0, 0, 0, 0.15)).
  */
  static findDropShadows(A) {
    const t = [], r = /drop-shadow\(/gi;
    let n;
    for (; (n = r.exec(A)) !== null; ) {
      const i = n.index + 12 - 1, s = n.index;
      let a = 1, o = i + 1;
      for (; o < A.length && a > 0; ) {
        const c = A[o];
        c === "(" ? a++ : c === ")" && a--, o++;
      }
      if (a !== 0) break;
      const l = A.slice(i + 1, o - 1);
      t.push({
        body: l,
        start: s,
        end: o
      });
    }
    return t;
  }
  /**
  * Parse the body of a single drop-shadow() function.
  * Body format (order-independent): <offsetX> <offsetY> [<blur>] [<color>?]
  */
  static parseDropShadowBody(A) {
    const t = Oc.tokenizeFilterArgs(A.trim()), r = [];
    let n;
    for (const i of t) Oc.isCSSLength(i) ? r.push(parseFloat(i)) : i && (n = i);
    if (!(r.length < 2 || r.length > 3))
      return {
        offsetX: r[0],
        offsetY: r[1],
        blur: r[2] ?? 0,
        color: n ?? "rgba(0,0,0,1)"
      };
  }
  /**
  * Split whitespace-separated tokens while keeping parenthesised
  * expressions intact.
  *
  * e.g. "rgba(0, 0, 0, 0.15) 0px 1px 2px"
  *   → ["rgba(0, 0, 0, 0.15)", "0px", "1px", "2px"]
  */
  static tokenizeFilterArgs(A) {
    const t = [];
    let r = "", n = 0;
    for (let i = 0; i < A.length; i++) {
      const s = A[i];
      s === "(" ? (n++, r += s) : s === ")" ? (n--, r += s) : /\s/.test(s) ? n > 0 ? r += s : r && (t.push(r), r = "") : r += s;
    }
    return r && t.push(r), t;
  }
  /** True when token looks like a CSS length: number with optional unit. */
  static isCSSLength(A) {
    return /^-?[\d.]+(px|em|rem|pt|cm|mm|in|pc|ex|ch|vw|vh|vmin|vmax|%)?$/i.test(A);
  }
};
const qb = (e) => e.type === 0, Fg = (e) => e.type === 1, Oy = (e) => e.type === 2, $b = (e) => e.type === 3, B9 = (e) => e.type === 4, Ny = (e) => e.type === 5;
var VS = class {
  constructor(A) {
    this.element = A, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
  }
}, GS = class {
  constructor(A, t) {
    if (this.container = A, this.parent = t, this.effects = [], this.curves = new h9(this.container), this.container.styles.opacity < 1 && this.effects.push(new d9(this.container.styles.opacity)), this.container.styles.rotate !== null) {
      const r = this.container.styles.transformOrigin, n = this.container.bounds.left + Ie(r[0], this.container.bounds.width), i = this.container.bounds.top + Ie(r[1], this.container.bounds.height), s = this.container.styles.rotate * Math.PI / 180, a = Math.cos(s), o = Math.sin(s), l = [
        a,
        o,
        -o,
        a,
        0,
        0
      ];
      this.effects.push(new WB(n, i, l));
    }
    if (this.container.styles.transform !== null) {
      const r = this.container.styles.transformOrigin, n = this.container.bounds.left + Ie(r[0], this.container.bounds.width), i = this.container.bounds.top + Ie(r[1], this.container.bounds.height), s = this.container.styles.transform;
      this.effects.push(new WB(n, i, s));
    }
    if (zb(this.container.styles)) {
      const r = qc(this.curves), n = bg(this.curves);
      Wb(r, n) ? this.effects.push(new rd(r, 6)) : (this.effects.push(new rd(r, 2)), this.effects.push(new rd(n, 4)));
    }
    if (this.container.styles.clipPath.type !== 0) {
      const r = w9(this.container.styles.clipPath, this.container.bounds);
      r && this.effects.push(r);
    }
    if (this.container.styles.mixBlendMode !== Ir.NORMAL && this.effects.push(new p9(this.container.styles.mixBlendMode)), this.container.styles.filter !== null && this.effects.push(new KS(this.container.styles.filter)), this.container.styles.zoom !== 1) {
      const r = this.container.styles.transformOrigin, n = this.container.bounds.left + Ie(r[0], this.container.bounds.width), i = this.container.bounds.top + Ie(r[1], this.container.bounds.height), s = this.container.styles.zoom, a = [
        s,
        0,
        0,
        s,
        0,
        0
      ];
      this.effects.push(new WB(n, i, a));
    }
  }
  getEffects(A, t) {
    let r = [2, 3].indexOf(this.container.styles.position) === -1, n = this === t ? null : this.parent;
    const i = (a) => a.effects.filter((o) => a !== t || !Ny(o) && !Oy(o)), s = i(this);
    for (; n; ) {
      const a = i(n).filter((o) => !Fg(o));
      if (r || n.container.styles.position !== 0 || !n.parent) {
        if (r = [2, 3].indexOf(n.container.styles.position) === -1, zb(n.container.styles)) {
          const o = qc(n.curves), l = bg(n.curves);
          Wb(o, l) || s.unshift(new rd(l, 6));
        }
        s.unshift(...a);
      } else s.unshift(...a);
      n = n === t ? null : n.parent;
    }
    return s.filter((a) => zr(a.target, A));
  }
};
const zb = (e) => e.overflowX !== 0 || e.overflowY !== 0, Xb = (e, A, t, r, n) => e === "closest-side" ? Math.min(A - t, r - A) : e === "farthest-side" ? Math.max(A - t, r - A) : Ie(e, n), w9 = (e, A) => {
  const { left: t, top: r, width: n, height: i } = A;
  switch (e.type) {
    case 1: {
      const s = Ie(e.left, n), a = Ie(e.top, i), o = t + s, l = r + a, c = Math.max(0, n - s - Ie(e.right, n)), u = Math.max(0, i - a - Ie(e.bottom, i));
      return new Lu((d) => {
        d.beginPath(), d.rect(o, l, c, u), d.clip();
      });
    }
    case 2: {
      const s = t + Ie(e.cx, n), a = r + Ie(e.cy, i);
      let o;
      return e.radius === "closest-side" ? o = Math.min(s - t, a - r, t + n - s, r + i - a) : e.radius === "farthest-side" ? o = Math.max(s - t, a - r, t + n - s, r + i - a) : o = Ie(e.radius, Math.sqrt(n * n + i * i) / Math.SQRT2), new Lu((l) => {
        l.beginPath(), l.arc(s, a, Math.max(0, o), 0, Math.PI * 2), l.clip();
      });
    }
    case 3: {
      const s = t + Ie(e.cx, n), a = r + Ie(e.cy, i), o = Xb(e.rx, s, t, t + n, n), l = Xb(e.ry, a, r, r + i, i);
      return new Lu((c) => {
        c.beginPath(), c.ellipse(s, a, Math.max(0, o), Math.max(0, l), 0, 0, Math.PI * 2), c.clip();
      });
    }
    case 4: {
      const s = e.points.map(([a, o]) => [t + Ie(a, n), r + Ie(o, i)]);
      return new Lu((a) => {
        if (a.beginPath(), s.length > 0) {
          a.moveTo(s[0][0], s[0][1]);
          for (let o = 1; o < s.length; o++) a.lineTo(s[o][0], s[o][1]);
          a.closePath();
        }
        a.clip();
      });
    }
    case 5: {
      const { d: s } = e;
      let a = null;
      return new Lu((o) => {
        try {
          a || (a = new Path2D(s));
          const l = o.getTransform();
          o.translate(t, r), o.clip(a), o.setTransform(l);
        } catch {
        }
      });
    }
    case 0:
      return null;
    default:
      return null;
  }
}, cv = (e, A, t, r) => {
  e.container.elements.forEach((n) => {
    const i = n.createsRealStackingContext, s = n.createsStackingContext, a = new GS(n, e);
    zr(n.styles.display, 2048) && r.push(a);
    const o = n.isListOwner ? [] : r;
    if (i || s) {
      const l = i || n.styles.isPositioned() ? t : A, c = new VS(a);
      if (n.styles.isPositioned() || n.styles.opacity < 1 || n.styles.isTransformed()) {
        const u = n.styles.zIndex.order;
        if (u < 0) {
          let d = 0;
          l.negativeZIndex.some((h, p) => u > h.element.container.styles.zIndex.order ? (d = p, !1) : d > 0), l.negativeZIndex.splice(d, 0, c);
        } else if (u > 0) {
          let d = 0;
          l.positiveZIndex.some((h, p) => u >= h.element.container.styles.zIndex.order ? (d = p + 1, !1) : d > 0), l.positiveZIndex.splice(d, 0, c);
        } else l.zeroOrAutoZIndexOrTransformedOrOpacity.push(c);
      } else n.styles.isFloating() ? l.nonPositionedFloats.push(c) : l.nonPositionedInlineLevel.push(c);
      cv(a, c, i ? c : t, o);
    } else
      n.styles.isInlineLevel() ? A.inlineLevel.push(a) : A.nonInlineLevel.push(a), cv(a, A, t, o);
    n.isListOwner && WS(n, o);
  });
}, WS = (e, A) => {
  let t = e instanceof ov ? e.start : 1;
  const r = e instanceof ov ? e.reversed : !1;
  for (let n = 0; n < A.length; n++) {
    const i = A[n];
    i.container instanceof _S && typeof i.container.value == "number" && i.container.value !== 0 && (t = i.container.value), i.listValue = Ph(t, i.container.styles.listStyleType, !0), t += r ? -1 : 1;
  }
}, m9 = (e) => {
  const A = new GS(e, null), t = new VS(A), r = [];
  return cv(A, t, t, r), WS(A.container, r), t;
}, Dy = (e) => {
  const A = e.bounds, t = e.styles;
  return A.add(t.borderLeftWidth, t.borderTopWidth, -(t.borderRightWidth + t.borderLeftWidth), -(t.borderTopWidth + t.borderBottomWidth));
}, kh = (e) => {
  const A = e.styles, t = e.bounds, r = Ie(A.paddingLeft, t.width), n = Ie(A.paddingRight, t.width), i = Ie(A.paddingTop, t.width), s = Ie(A.paddingBottom, t.width);
  return t.add(r + A.borderLeftWidth, i + A.borderTopWidth, -(A.borderRightWidth + A.borderLeftWidth + r + n), -(A.borderTopWidth + A.borderBottomWidth + i + s));
}, v9 = (e, A) => e === 0 ? A.bounds : e === 2 ? kh(A) : Dy(A), y9 = (e, A) => e === 0 ? A.bounds : e === 2 ? kh(A) : Dy(A), nd = (e, A, t) => {
  const r = v9(Ql(e.styles.backgroundOrigin, A), e), n = y9(Ql(e.styles.backgroundClip, A), e), i = C9(Ql(e.styles.backgroundSize, A), t, r);
  let [s, a] = i;
  const o = Ju(Ql(e.styles.backgroundPosition, A), r.width - s, r.height - a), l = b9(Ql(e.styles.backgroundRepeat, A), o, i, r, n), c = Math.round(r.left + o[0]), u = Math.round(r.top + o[1]);
  return s = Math.max(1, s), a = Math.max(1, a), [
    l,
    c,
    u,
    s,
    a
  ];
}, bc = (e) => Oe(e) && e.value === "auto", id = (e) => typeof e == "number", C9 = (e, [A, t, r], n) => {
  const [i, s] = e;
  if (!i) return [0, 0];
  if (ft(i) && s && ft(s)) return [Ie(i, n.width), Ie(s, n.height)];
  const a = id(r);
  if (Oe(i) && (i.value === "contain" || i.value === "cover"))
    return id(r) ? n.width / n.height < r != (i.value === "cover") ? [n.width, n.width / r] : [n.height * r, n.height] : [n.width, n.height];
  const o = id(A), l = id(t), c = o || l;
  if (bc(i) && (!s || bc(s)))
    return o && l ? [A, t] : !a && !c ? [n.width, n.height] : c && a ? [o ? A : t * r, l ? t : A / r] : [o ? A : n.width, l ? t : n.height];
  if (a) {
    let h = 0, p = 0;
    return ft(i) ? h = Ie(i, n.width) : ft(s) && (p = Ie(s, n.height)), bc(i) ? h = p * r : (!s || bc(s)) && (p = h / r), [h, p];
  }
  let u = null, d = null;
  if (ft(i) ? u = Ie(i, n.width) : s && ft(s) && (d = Ie(s, n.height)), u !== null && (!s || bc(s)) && (d = o && l ? u / A * t : n.height), d !== null && bc(i) && (u = o && l ? d / t * A : n.width), u !== null && d !== null) return [u, d];
  throw new Error("Unable to calculate background-size for element");
}, Ql = (e, A) => {
  const t = e[A];
  return typeof t > "u" ? e[0] : t;
}, b9 = (e, [A, t], [r, n], i, s) => {
  switch (e) {
    case 2:
      return [
        new re(Math.round(i.left), Math.round(i.top + t)),
        new re(Math.round(i.left + i.width), Math.round(i.top + t)),
        new re(Math.round(i.left + i.width), Math.round(n + i.top + t)),
        new re(Math.round(i.left), Math.round(n + i.top + t))
      ];
    case 3:
      return [
        new re(Math.round(i.left + A), Math.round(i.top)),
        new re(Math.round(i.left + A + r), Math.round(i.top)),
        new re(Math.round(i.left + A + r), Math.round(i.height + i.top)),
        new re(Math.round(i.left + A), Math.round(i.height + i.top))
      ];
    case 1:
      return [
        new re(Math.round(i.left + A), Math.round(i.top + t)),
        new re(Math.round(i.left + A + r), Math.round(i.top + t)),
        new re(Math.round(i.left + A + r), Math.round(i.top + t + n)),
        new re(Math.round(i.left + A), Math.round(i.top + t + n))
      ];
    default:
      return [
        new re(Math.round(s.left), Math.round(s.top)),
        new re(Math.round(s.left + s.width), Math.round(s.top)),
        new re(Math.round(s.left + s.width), Math.round(s.height + s.top)),
        new re(Math.round(s.left), Math.round(s.height + s.top))
      ];
  }
}, qi = (e) => {
  if (e?.aborted) throw new DOMException("The operation was aborted.", "AbortError");
};
var Vi = class extends Error {
};
const Ui = (e) => {
  e.width = e.height = 0;
};
function uv(e) {
  if (!e || e === "none") return { blur: 0 };
  const A = new KS(e), t = e.match(/drop-shadow\(/g) || [];
  if (t.length > 1 || t.length === 1 && !A.shadow) return null;
  const r = A.safeFilterString.match(/^blur\((\d+(?:\.\d+)?)px\)$/);
  return A.safeFilterString && !r || r && t.length && e.indexOf("blur(") > e.indexOf("drop-shadow(") ? null : {
    blur: r ? Number(r[1]) : 0,
    shadow: A.shadow ? {
      x: A.shadow.offsetX,
      y: A.shadow.offsetY,
      blur: A.shadow.blur,
      color: A.shadow.color
    } : void 0
  };
}
function jS(e) {
  return Math.ceil(3 * (e.blur + (e.shadow?.blur ?? 0)) + Math.max(Math.abs(e.shadow?.x ?? 0), Math.abs(e.shadow?.y ?? 0)));
}
function Qg(e) {
  const A = document.createElement("canvas");
  return A.width = e.width, A.height = e.height, A;
}
const F9 = (e, A) => new Promise((t, r) => {
  const n = (a) => {
    clearTimeout(s), A?.removeEventListener("abort", i), a ? r(a) : t();
  }, i = () => n(new DOMException("The operation was aborted.", "AbortError")), s = setTimeout(() => n(new Vi("Filter surface image decode timed out")), 1e4);
  A?.addEventListener("abort", i, { once: !0 }), A?.aborted ? i() : e.decode().then(() => n(), () => n(new Vi("Filter surface image decode failed")));
}), Yb = /* @__PURE__ */ new WeakMap();
function Q9(e = document) {
  const A = Yb.get(e);
  if (A !== void 0) return A;
  const t = e.createElement("canvas"), r = e.createElement("canvas");
  let n = !1;
  try {
    t.width = t.height = r.width = r.height = 32;
    const i = t.getContext("2d"), s = r.getContext("2d");
    if (i && s && "filter" in s) {
      i.fillStyle = "#fff", i.fillRect(8, 8, 8, 8), s.filter = "blur(2px)", s.drawImage(t, 0, 0);
      const a = s.getImageData(6, 12, 1, 1).data[3] > 0;
      s.clearRect(0, 0, 32, 32), s.filter = "drop-shadow(12px 0px 0px rgba(255, 0, 0, 0.5))", s.drawImage(t, 0, 0);
      const o = s.getImageData(24, 12, 1, 1).data;
      n = a && o[0] > 240 && o[1] < 10 && o[3] >= 126 && o[3] <= 129;
    }
  } catch {
  } finally {
    Ui(t), Ui(r);
  }
  return Yb.set(e, n), n;
}
function U9(e, { blur: A, shadow: t }, r, n, i) {
  let s, a, o = !1;
  try {
    qi(i), s = Qg(e);
    const l = s.getContext("2d");
    if (!l || !("filter" in l)) return null;
    const c = [];
    if (A && c.push(`blur(${A * n}px)`), t && c.push(`drop-shadow(${t.x * n}px ${t.y * n}px ${t.blur * n}px ${t.color})`), l.filter = c.join(" "), l.filter === "none") return null;
    l.drawImage(e, 0, 0), qi(i), a = Qg(e);
    const u = a.getContext("2d");
    return u ? (u.globalAlpha = r, u.drawImage(s, 0, 0), qi(i), o = !0, a) : null;
  } catch {
    return qi(i), null;
  } finally {
    s && Ui(s), a && !o && Ui(a);
  }
}
async function Jb(e, A, t, r, n) {
  if (qi(n), (A.blur || A.shadow) && Q9()) {
    const i = U9(e, A, t, r, n);
    if (i) return i;
  }
  return E9(e, A, t, r, n);
}
async function E9(e, { blur: A, shadow: t }, r, n, i) {
  if (qi(i), !A && !t) {
    const p = Qg(e), B = p.getContext("2d");
    if (!B)
      throw Ui(p), new Vi("Filter surface canvas is unavailable");
    B.globalAlpha = r;
    try {
      return B.drawImage(e, 0, 0), p;
    } catch {
      throw Ui(p), new Vi("Filter surface image cannot be drawn");
    }
  }
  const s = "http://www.w3.org/2000/svg", a = (p, B = {}) => {
    const y = document.createElementNS(s, p);
    return Object.entries(B).forEach(([m, C]) => y.setAttribute(m, String(C))), y;
  }, o = a("svg", {
    width: e.width,
    height: e.height,
    viewBox: `0 0 ${e.width} ${e.height}`
  }), l = a("defs"), c = a("filter", {
    id: "composited-filter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: e.width,
    height: e.height,
    "color-interpolation-filters": "sRGB"
  });
  if (A && c.appendChild(a("feGaussianBlur", {
    stdDeviation: A * n,
    result: "blurred-source"
  })), t) {
    c.appendChild(a("feGaussianBlur", {
      in: A ? "blurred-source" : "SourceAlpha",
      stdDeviation: t.blur * n
    })), c.appendChild(a("feOffset", {
      dx: t.x * n,
      dy: t.y * n,
      result: "offset-shadow"
    })), c.appendChild(a("feFlood", { "flood-color": t.color })), c.appendChild(a("feComposite", {
      in2: "offset-shadow",
      operator: "in"
    }));
    const p = a("feMerge");
    p.appendChild(a("feMergeNode")), p.appendChild(a("feMergeNode", { in: A ? "blurred-source" : "SourceGraphic" })), c.appendChild(p);
  }
  l.appendChild(c), o.appendChild(l);
  let u;
  try {
    if (u = e.toDataURL("image/png"), u === "data:,") throw new Error("Canvas size is unsupported");
  } catch {
    throw new Vi("Filter surface pixels cannot be serialized");
  }
  o.appendChild(a("image", {
    width: e.width,
    height: e.height,
    href: u,
    filter: "url(#composited-filter)"
  }));
  const d = new Image();
  let h;
  try {
    d.src = `data:image/svg+xml,${encodeURIComponent(new XMLSerializer().serializeToString(o))}`, await F9(d, i), qi(i), h = Qg(e);
    const p = h.getContext("2d");
    if (!p) throw new Vi("Filter surface canvas is unavailable");
    return p.globalAlpha = r, p.drawImage(d, 0, 0), h;
  } catch (p) {
    throw h && Ui(h), i?.aborted && qi(i), p instanceof Vi ? p : new Vi("Filter surface image cannot be drawn");
  } finally {
    d.removeAttribute("src");
  }
}
function Zb(e, A, t) {
  const r = A * t * 4;
  return !Number.isFinite(r) || A <= 0 || t <= 0 || A > 8192 || t > 8192 || e.pixels + r > 16777216 ? 0 : (e.pixels += r, r);
}
const th = (e, A) => e.add(-A, -A, A * 2, A * 2), sd = (e, A) => new Hn(Math.min(e.left, A.left), Math.min(e.top, A.top), Math.max(e.left + e.width, A.left + A.width) - Math.min(e.left, A.left), Math.max(e.top + e.height, A.top + A.height) - Math.min(e.top, A.top));
function qS(e) {
  const A = e.styles;
  let t = e.bounds;
  for (const n of A.boxShadow) if (!n.inset) {
    const i = Math.max(0, n.spread.number) + 3 * n.blur.number;
    t = sd(t, th(e.bounds.add(n.offsetX.number, n.offsetY.number, 0, 0), i));
  }
  for (const n of e.textNodes) for (const i of n.textBounds) {
    const s = th(i.bounds, 2 * Ie(A.fontSize, e.bounds.height) + A.webkitTextStrokeWidth);
    t = sd(t, s);
    for (const a of A.textShadow) t = sd(t, th(s.add(a.offsetX.number, a.offsetY.number, 0, 0), 3 * a.blur.number));
  }
  for (const n of e.elements) n.styles.isVisible() && (t = sd(t, qS(n)));
  const r = uv(A.filter);
  return th(t, r ? jS(r) : 0);
}
function AF(e, A, t, r) {
  const n = th(A, t), i = Math.floor(Math.max(e.left, n.left) * r) / r, s = Math.floor(Math.max(e.top, n.top) * r) / r, a = Math.ceil(Math.min(e.left + e.width, n.left + n.width) * r) / r, o = Math.ceil(Math.min(e.top + e.height, n.top + n.height) * r) / r;
  return new Hn(i, s, Math.max(0, a - i), Math.max(0, o - s));
}
var x9 = class {
  constructor(e) {
    this.ctx = e;
  }
  render(e, A) {
    this.ctx.fillStyle = _t(A.textDecorationColor || A.color);
    let t = 1;
    typeof A.textDecorationThickness == "number" ? t = A.textDecorationThickness : A.textDecorationThickness === "from-font" && (t = Math.max(1, Math.floor(A.fontSize.number * 0.05)));
    let r = 0;
    typeof A.textUnderlineOffset == "number" && (r = A.textUnderlineOffset);
    const n = A.textDecorationStyle;
    A.textDecorationLine.forEach((i) => {
      let s = 0;
      switch (i) {
        case 1:
          s = e.top + e.height - t + r;
          break;
        case 2:
          s = e.top;
          break;
        case 3:
          s = e.top + (e.height / 2 - t / 2);
          break;
        default:
          return;
      }
      this.draw(e.left, s, e.width, t, n);
    });
  }
  draw(e, A, t, r, n) {
    switch (n) {
      case 0:
        this.ctx.fillRect(e, A, t, r);
        break;
      case 1: {
        const i = Math.max(1, r);
        this.ctx.fillRect(e, A, t, r), this.ctx.fillRect(e, A + r + i, t, r);
        break;
      }
      case 2:
        this.drawPattern(e, A, t, r, [r, r * 2]);
        break;
      case 3:
        this.drawPattern(e, A, t, r, [r * 3, r * 2]);
        break;
      case 4:
        this.drawWavy(e, A, t, r);
        break;
      default:
        this.ctx.fillRect(e, A, t, r);
    }
  }
  drawPattern(e, A, t, r, n) {
    this.ctx.save(), this.ctx.beginPath(), this.ctx.setLineDash(n), this.ctx.lineWidth = r, this.ctx.strokeStyle = this.ctx.fillStyle, this.ctx.moveTo(e, A + r / 2), this.ctx.lineTo(e + t, A + r / 2), this.ctx.stroke(), this.ctx.restore();
  }
  drawWavy(e, A, t, r) {
    this.ctx.save(), this.ctx.beginPath(), this.ctx.lineWidth = r, this.ctx.strokeStyle = this.ctx.fillStyle;
    const n = r * 2, i = r * 4;
    let s = e;
    for (this.ctx.moveTo(s, A + r / 2); s < e + t; ) {
      const a = Math.min(s + i / 2, e + t);
      if (this.ctx.quadraticCurveTo(s + i / 4, A + r / 2 - n, a, A + r / 2), s = a, s < e + t) {
        const o = Math.min(s + i / 2, e + t);
        this.ctx.quadraticCurveTo(s + i / 4, A + r / 2 + n, o, A + r / 2), s = o;
      }
    }
    this.ctx.stroke(), this.ctx.restore();
  }
};
const I9 = "Mg", Fc = (e) => e !== void 0 && !Number.isNaN(e), $S = (e, A) => {
  const t = e.measureText(I9), r = t;
  return {
    baseline: Fc(r.fontBoundingBoxAscent) ? r.fontBoundingBoxAscent : Fc(t.actualBoundingBoxAscent) ? t.actualBoundingBoxAscent : A,
    height: Fc(r.fontBoundingBoxAscent) && Fc(r.fontBoundingBoxDescent) ? r.fontBoundingBoxAscent + r.fontBoundingBoxDescent : Fc(t.actualBoundingBoxAscent) && Fc(t.actualBoundingBoxDescent) ? t.actualBoundingBoxAscent + t.actualBoundingBoxDescent : A
  };
}, zS = (e, A) => $S(e, A).baseline, S9 = ["-apple-system", "system-ui"], L9 = 1, H9 = /[\u2E80-\u2FFF\u3000-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uAC00-\uD7AF\uF900-\uFAFF\uFF01-\uFFEF]/, ad = (e) => H9.test(e), T9 = () => {
  if (typeof navigator > "u") return null;
  const e = navigator.userAgent, A = /iPhone|iPad|iPod/.test(e), t = /Macintosh/.test(e) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
  if (!A && !t) return null;
  for (const r of [/(?:iPhone|CPU(?:\siPhone)?)\sOS\s(\d+)[\._](\d+)/, /Version\/(\d+)\.(\d+)/]) {
    const n = e.match(r);
    if (n && n[1]) return parseInt(n[1], 10);
  }
  return null;
}, _9 = (e) => {
  const A = T9();
  return A !== null && A >= 15 && A < 17 ? e.map((t) => S9.indexOf(t) !== -1 ? '-apple-system, "Helvetica Neue", Arial, sans-serif' : t) : e;
}, O9 = () => (typeof window < "u" ? window : void 0)?.chrome ? "miter" : "round";
var N9 = class {
  constructor(e) {
    this.glyphWidthCache = null, this.ctx = e.ctx, this.options = e.options, this.decorationRenderer = new x9(e.ctx);
  }
  /**
  * Returns the cached width for a glyph+font pair, measuring via
  * measureText if not yet cached. Only used when letterSpacing !== 0
  * (the `canRenderWholeText` fast path handles the zero-spacing case).
  */
  cachedMeasureText(e, A) {
    let t = this.glyphWidthCache;
    t || (t = /* @__PURE__ */ new Map(), this.glyphWidthCache = t);
    const r = e + A;
    let n = t.get(r);
    return n === void 0 && (n = this.ctx.measureText(e).width, t.set(r, n)), n;
  }
  /**
  * Iterate grapheme clusters one-by-one, applying correct letter-spacing.
  *
  * Issue #73: When letter-spacing is non-zero, text must be rendered character by
  * character, adding `letterSpacing` to each character's advance width.
  *
  * In horizontal text every glyph keeps the alphabetic baseline, CJK included:
  * inline layout aligns a whole line on its alphabetic baseline regardless of
  * script, and `baseline` was measured for that. Drawing CJK graphemes at the
  * same y with `textBaseline = 'ideographic'` lifts them above the Latin text
  * next to them, and away from where the `letterSpacing === 0` whole-string
  * path draws them.
  *
  * The `renderFn` callback receives (letter, x, y) and performs the actual draw
  * call (fillText or strokeText), allowing fill and stroke paths to share one
  * implementation.
  */
  iterateLettersWithLetterSpacing(e, A, t, r, n) {
    if (Cg(r)) {
      this.iterateVerticalGlyphs(e, A, t, r, n);
      return;
    }
    const i = Rl(e.text), s = e.bounds.top + t, a = this.ctx.font;
    let o = e.bounds.left;
    for (const l of i)
      n(l, o, s), o += this.cachedMeasureText(l, a) + A;
  }
  iterateVerticalGlyphs(e, A, t, r, n) {
    const i = Rl(e.text), s = this.ctx.font, a = r === 4 ? -Math.PI / 2 : Math.PI / 2;
    let o = e.bounds.top;
    for (let l = 0; l < i.length; ) {
      const c = i[l];
      if (!(_B(r) || !ad(c) && c.trim().length > 0)) {
        const h = this.ctx.textBaseline;
        ad(c) && (this.ctx.textBaseline = "ideographic"), n(c, e.bounds.left, o + t), this.ctx.textBaseline = h, o += this.cachedMeasureText(c, s) + A, l++;
        continue;
      }
      const u = l;
      for (; l < i.length; ) {
        const h = i[l];
        if (!_B(r) && !ad(h) && h.trim().length === 0) break;
        if (_B(r) || !ad(h) && h.trim().length > 0) l++;
        else break;
      }
      this.ctx.save(), this.ctx.translate(e.bounds.left + t, o), this.ctx.rotate(a);
      let d = 0;
      for (let h = u; h < l; h++)
        n(i[h], 0, d), d += this.cachedMeasureText(i[h], s) + A;
      this.ctx.restore(), o += d;
    }
  }
  /**
  * Render text with letter-spacing applied (fill pass).
  * When letterSpacing is 0 the whole string is drawn in one call; otherwise each
  * grapheme is drawn individually so spacing is applied correctly.
  */
  renderTextWithLetterSpacing(e, A, t, r = 0) {
    this.renderFillText(e, A, t, r);
  }
  canRenderWholeText(e, A) {
    return e === 0 && !Cg(A);
  }
  renderFillText(e, A, t, r) {
    this.canRenderWholeText(A, r) ? this.ctx.fillText(e.text, e.bounds.left, e.bounds.top + t) : this.iterateLettersWithLetterSpacing(e, A, t, r, (n, i, s) => {
      this.ctx.fillText(n, i, s);
    });
  }
  renderStrokeText(e, A, t, r) {
    this.canRenderWholeText(A, r) ? this.ctx.strokeText(e.text, e.bounds.left, e.bounds.top + t) : this.iterateLettersWithLetterSpacing(e, A, t, r, (n, i, s) => {
      this.ctx.strokeText(n, i, s);
    });
  }
  renderTextStrokeWithStyle(e, A, t) {
    !A.webkitTextStrokeWidth || !e.text.trim().length || (this.ctx.strokeStyle = _t(A.webkitTextStrokeColor), this.ctx.lineWidth = A.webkitTextStrokeWidth, this.ctx.lineJoin = O9(), this.renderStrokeText(e, A.letterSpacing, t, A.writingMode), this.ctx.strokeStyle = "", this.ctx.lineWidth = 0, this.ctx.lineJoin = "miter");
  }
  renderTextFillWithShadows(e, A, t) {
    this.ctx.fillStyle = _t(A.color), this.renderTextWithLetterSpacing(e, A.letterSpacing, t, A.writingMode);
    const r = A.textShadow;
    r.length && e.text.trim().length && (r.slice(0).reverse().forEach((n) => {
      this.ctx.shadowColor = _t(n.color), this.ctx.shadowOffsetX = n.offsetX.number * this.options.scale, this.ctx.shadowOffsetY = n.offsetY.number * this.options.scale, this.ctx.shadowBlur = n.blur.number, this.renderTextWithLetterSpacing(e, A.letterSpacing, t, A.writingMode);
    }), this.ctx.shadowColor = "", this.ctx.shadowOffsetX = 0, this.ctx.shadowOffsetY = 0, this.ctx.shadowBlur = 0);
  }
  /**
  * Helper method to render text with paint order support
  * Reduces code duplication in line-clamp and normal rendering
  */
  renderTextBoundWithPaintOrder(e, A, t, r) {
    t.forEach((n) => {
      switch (n) {
        case 0:
          this.ctx.fillStyle = _t(A.color), this.renderTextWithLetterSpacing(e, A.letterSpacing, r, A.writingMode);
          break;
        case 1:
          this.renderTextStrokeWithStyle(e, A, r);
          break;
      }
    });
  }
  renderTextDecoration(e, A) {
    this.decorationRenderer.render(e, A);
  }
  truncateTextWithEllipsis(e, A, t) {
    const n = this.ctx.measureText("…").width, i = Rl(e);
    if (t === 0) {
      const s = (l) => this.ctx.measureText(i.slice(0, l).join("")).width + n <= A;
      let a = 0, o = i.length;
      for (; a < o; ) {
        const l = a + o + 1 >> 1;
        s(l) ? a = l : o = l - 1;
      }
      return i.slice(0, a).join("") + "…";
    } else {
      const s = this.ctx.font;
      let a = n;
      const o = [];
      for (const l of i) {
        const c = this.cachedMeasureText(l, s);
        if (a + c > A) break;
        o.push(l), a += c + t;
      }
      return o.join("") + "…";
    }
  }
  /**
  * Create font style array
  * Public method used by list rendering
  */
  createFontStyle(e) {
    const A = e.fontVariant.filter((n) => n === "normal" || n === "small-caps").join(""), t = _9(e.fontFamily).join(", "), r = Xs(e.fontSize) ? `${e.fontSize.number}${e.fontSize.unit}` : `${e.fontSize.number}px`;
    return [
      [
        e.fontStyle,
        A,
        e.fontWeight,
        r,
        t
      ].join(" "),
      t,
      r
    ];
  }
  /**
  * Render text with -webkit-line-clamp truncation.
  * Groups text bounds by their Y position into visual lines, then renders
  * only the first N-1 complete lines followed by an ellipsis on the Nth line.
  */
  renderLineClampedText(e, A, t, r, n) {
    const i = A.fontSize.number * 1.5, s = [];
    let a = [], o = e.textBounds[0].bounds.top;
    e.textBounds.forEach((u) => {
      Math.abs(u.bounds.top - o) >= i * 0.5 ? (a.length > 0 && s.push(a), a = [u], o = u.bounds.top) : a.push(u);
    }), a.length > 0 && s.push(a);
    const l = A.webkitLineClamp;
    if (s.length <= l) return !1;
    for (let u = 0; u < l - 1; u++) s[u].forEach((d) => this.renderTextBoundWithPaintOrder(d, A, t, r));
    const c = s[l - 1];
    if (c?.length && n) {
      const u = c.map((B) => B.text).join(""), d = c[0], h = n.width - (d.bounds.left - n.left), p = new Dl(this.truncateTextWithEllipsis(u, h, A.letterSpacing), d.bounds);
      for (const B of t) B === 0 ? (this.ctx.fillStyle = _t(A.color), this.renderTextWithLetterSpacing(p, A.letterSpacing, r, A.writingMode)) : B === 1 && this.renderTextStrokeWithStyle(p, A, r);
    }
    return !0;
  }
  /**
  * Render single-line text with text-overflow: ellipsis.
  * Returns true if ellipsis was applied (caller should skip normal rendering).
  */
  renderEllipsisText(e, A, t, r, n) {
    const i = A.fontSize.number * 1.5, s = e.textBounds[0].bounds.top;
    if (!e.textBounds.every((l) => Math.abs(l.bounds.top - s) < i * 0.5)) return !1;
    let a = e.textBounds.map((l) => l.text).join("").replace(/\s+/g, " ").trim();
    if (this.ctx.measureText(a).width <= n.width + L9) return !1;
    const o = new Dl(this.truncateTextWithEllipsis(a, n.width, A.letterSpacing), e.textBounds[0].bounds);
    for (const l of t) l === 0 ? this.renderTextFillWithShadows(o, A, r) : l === 1 && this.renderTextStrokeWithStyle(o, A, r);
    return !0;
  }
  async renderTextNode(e, A, t) {
    this.glyphWidthCache = null;
    const [r] = this.createFontStyle(A);
    this.ctx.font = r, this.ctx.direction = A.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic";
    const n = A.paintOrder, i = zS(this.ctx, A.fontSize.number);
    A.webkitLineClamp > 0 && (A.display & 2) !== 0 && A.overflowY === 1 && e.textBounds.length > 0 && this.renderLineClampedText(e, A, n, i, t) || A.textOverflow === 1 && t && A.overflowX === 1 && e.textBounds.length > 0 && this.renderEllipsisText(e, A, n, i, t) || e.textBounds.forEach((s) => {
      n.forEach((a) => {
        a === 0 ? (this.renderTextFillWithShadows(s, A, i), A.textDecorationLine.length && this.renderTextDecoration(s.bounds, A)) : a === 1 && this.renderTextStrokeWithStyle(s, A, i);
      });
    });
  }
};
const hv = (e, A) => {
  A.forEach((t, r) => {
    const n = ji(t) ? t.start : t;
    r === 0 ? e.moveTo(n.x, n.y) : e.lineTo(n.x, n.y), ji(t) && e.bezierCurveTo(t.startControl.x, t.startControl.y, t.endControl.x, t.endControl.y, t.end.x, t.end.y);
  });
}, fv = (e, A) => {
  e.beginPath(), hv(e, A), e.closePath();
};
var D9 = class {
  constructor(e) {
    this.maxSize = e, this._map = /* @__PURE__ */ new Map();
  }
  /**
  * Get a value by key.
  * On cache hit the entry is promoted to the end of the Map (most-recently-used).
  * Returns `undefined` on miss.
  */
  get(e) {
    if (!this._map.has(e)) return;
    const A = this._map.get(e);
    return this._map.delete(e), this._map.set(e, A), A;
  }
  /**
  * Insert or update a key-value pair.
  * If the key already exists it is moved to MRU position.  If the map is
  * at capacity the least-recently-used entry (oldest insertion order) is
  * evicted before inserting.
  */
  set(e, A) {
    if (this._map.has(e)) this._map.delete(e);
    else if (this._map.size >= this.maxSize) {
      const t = this._map.keys().next().value;
      t !== void 0 && this._map.delete(t);
    }
    this._map.set(e, A);
  }
  /** Current number of entries. */
  get size() {
    return this._map.size;
  }
  /** Remove all entries. */
  clear() {
    this._map.clear();
  }
}, eF = class {
  constructor(e) {
    this.patternCache = new D9(50), this.ctx = e.ctx, this.context = e.context, this.canvas = e.canvas;
  }
  /**
  * Render background images for a container
  * Supports URL images, linear gradients, and radial gradients
  *
  * @param container - Element container with background styles
  */
  async renderBackgroundImage(e) {
    let A = e.styles.backgroundImage.length - 1;
    const t = e.styles.backgroundBlendMode;
    let r = 0;
    for (const n of e.styles.backgroundImage.slice(0).reverse()) {
      if (r > 0) {
        const i = t[r] ?? t[0] ?? "normal";
        i !== "normal" && (this.ctx.save(), this.ctx.globalCompositeOperation = i);
      }
      n.type === 0 ? await this.renderBackgroundURLImage(e, n, A) : zP(n) ? this.renderLinearGradient(e, n, A) : YP(n) ? this.renderRepeatingLinearGradient(e, n, A) : XP(n) && this.renderRadialGradient(e, n, A), r > 0 && (t[r] ?? t[0] ?? "normal") !== "normal" && this.ctx.restore(), A--, r++;
    }
  }
  /**
  * Render a URL-based background image
  */
  async renderBackgroundURLImage(e, A, t) {
    let r;
    const n = A.url;
    try {
      r = await this.context.cache.match(n);
    } catch (i) {
      this.context.logger.error(`Error loading background-image ${n}`), this.context.onError?.(i instanceof Error ? i : new Error(String(i)));
    }
    if (r) {
      const i = isNaN(r.width) || r.width === 0 ? 1 : r.width, s = isNaN(r.height) || r.height === 0 ? 1 : r.height, [a, o, l, c, u] = nd(e, t, [
        i,
        s,
        i / s
      ]), d = Ql(e.styles.backgroundRepeat, t), h = d === 1 ? "no-repeat" : d === 2 ? "repeat-x" : d === 3 ? "repeat-y" : "repeat", p = `${n}|${Math.round(c)}x${Math.round(u)}|${e.styles.imageRendering}|${h}`;
      let B = this.patternCache.get(p);
      if (!B) {
        const y = this.resizeImage(r, c, u, e.styles.imageRendering);
        B = this.ctx.createPattern(y, h), this.patternCache.set(p, B);
      }
      this.renderRepeat(a, B, o, l);
    }
  }
  /**
  * Render a repeating linear gradient background.
  * Renders one cycle of the gradient to a pattern canvas, then fills
  * the background area using createPattern('repeat').
  */
  renderRepeatingLinearGradient(e, A, t) {
    const [r, n, i, s, a] = nd(e, t, [
      null,
      null,
      null
    ]), [o, l, c, u, d] = vb(A.angle, s, a), h = TB(A.stops, o || 1), p = h[h.length - 1], B = h[0], y = p.stop - B.stop;
    if (y <= 0) {
      this.renderLinearGradient(e, A, t);
      return;
    }
    const m = c - l, C = d - u, Q = y / (Math.sqrt(m * m + C * C) || 1), F = l, T = u, V = l + m * Q, M = u + C * Q, D = this.canvas.ownerDocument ?? document, I = `rlg|${A.angle}|${Math.round(y)}|${JSON.stringify(A.stops)}`;
    let q = this.patternCache.get(I);
    if (!q) {
      const U = D.createElement("canvas"), x = Math.max(1, Math.ceil(y));
      U.width = x, U.height = x;
      const P = U.getContext("2d");
      if (!P) return;
      const N = P.createLinearGradient(F - n, T - i, V - n, M - i);
      h.forEach((iA) => {
        N.addColorStop((iA.stop - B.stop) / y, _t(iA.color));
      }), P.fillStyle = N, P.fillRect(0, 0, x, x), x > 0 && (q = this.ctx.createPattern(U, "repeat"), this.patternCache.set(I, q));
    }
    q && this.renderRepeat(r, q, n, i);
  }
  /**
  * Render a linear gradient background
  */
  renderLinearGradient(e, A, t) {
    const [r, n, i, s, a] = nd(e, t, [
      null,
      null,
      null
    ]), [o, l, c, u, d] = vb(A.angle, s, a), h = `lg|${A.angle}|${Math.round(s)}x${Math.round(a)}|${JSON.stringify(A.stops)}`;
    let p = this.patternCache.get(h);
    if (!p) {
      const B = (this.canvas.ownerDocument ?? document).createElement("canvas");
      B.width = s, B.height = a;
      const y = B.getContext("2d");
      if (!y) return;
      const m = y.createLinearGradient(l, u, c, d);
      TB(A.stops, o || 1).forEach((C) => m.addColorStop(C.stop, _t(C.color))), y.fillStyle = m, y.fillRect(0, 0, s, a), s > 0 && a > 0 && (p = this.ctx.createPattern(B, "repeat"), this.patternCache.set(h, p));
    }
    p && this.renderRepeat(r, p, n, i);
  }
  /**
  * Render a radial gradient background
  */
  renderRadialGradient(e, A, t) {
    const [r, n, i, s, a] = nd(e, t, [
      null,
      null,
      null
    ]), o = A.position.length === 0 ? [Ia] : A.position, l = Ie(o[0], s), c = Ie(o[o.length - 1], a);
    let [u, d] = jP(A, l, c, s, a);
    if ((u === 0 || d === 0) && (u = Math.max(u, 0.01), d = Math.max(d, 0.01)), u > 0 && d > 0) {
      const h = `rg|${Math.round(l)}x${Math.round(c)}|${Math.round(u)}x${Math.round(d)}|${JSON.stringify(A.stops)}`, p = TB(A.stops, u * 2), B = p[p.length - 1];
      let y = this.patternCache.get(h);
      if (!y) {
        const m = (this.canvas.ownerDocument ?? document).createElement("canvas");
        m.width = Math.ceil(u * 2), m.height = Math.ceil(d * 2);
        const C = m.getContext("2d");
        if (C) {
          const Q = C.createRadialGradient(u, u, 0, u, u, u);
          p.forEach((F) => Q.addColorStop(F.stop, _t(F.color))), C.fillStyle = Q, u !== d && C.scale(1, d / u), C.fillRect(0, 0, u * 2, u * 2), y = this.ctx.createPattern(m, "no-repeat"), this.patternCache.set(h, y);
        }
      }
      y && (this.path(r), this.ctx.save(), this.ctx.clip(), B && (this.ctx.fillStyle = _t(B.color), this.ctx.fill()), this.ctx.translate(n + l - u, i + c - d), this.ctx.fillStyle = y, this.ctx.fillRect(0, 0, u * 2, d * 2), this.ctx.restore());
    }
  }
  /**
  * Render a repeating pattern with offset
  *
  * @param path - Path to fill
  * @param pattern - Canvas pattern or gradient
  * @param offsetX - X offset for pattern
  * @param offsetY - Y offset for pattern
  */
  renderRepeat(e, A, t, r) {
    this.path(e), this.ctx.fillStyle = A, this.ctx.translate(t, r), this.ctx.fill(), this.ctx.translate(-t, -r);
  }
  /**
  * Resize an image to target dimensions
  *
  * @param image - Source image
  * @param width - Target width
  * @param height - Target height
  * @param imageRendering - CSS image-rendering property value
  * @returns Resized canvas or original image
  */
  resizeImage(e, A, t, r) {
    const n = (this.canvas.ownerDocument ?? document).createElement("canvas");
    n.width = Math.max(1, A), n.height = Math.max(1, t);
    const i = n.getContext("2d");
    return i ? (r === 2 || r === 1 ? (this.context.logger.debug("Disabling image smoothing for background image due to CSS image-rendering"), i.imageSmoothingEnabled = !1) : r === 3 ? (this.context.logger.debug("Enabling image smoothing for background image due to CSS image-rendering: smooth"), i.imageSmoothingEnabled = !0) : i.imageSmoothingEnabled = this.ctx.imageSmoothingEnabled, this.ctx.imageSmoothingQuality && (i.imageSmoothingQuality = this.ctx.imageSmoothingQuality), i.drawImage(e, 0, 0, e.width, e.height, 0, 0, A, t), n) : e;
  }
  /**
  * Create a canvas path from path array
  *
  * @param paths - Array of path points
  */
  path(e) {
    fv(this.ctx, e);
  }
};
const tF = (e, A) => {
  switch (A) {
    case 0:
      return $i(e.topLeftBorderBox, e.topLeftPaddingBox, e.topRightBorderBox, e.topRightPaddingBox);
    case 1:
      return $i(e.topRightBorderBox, e.topRightPaddingBox, e.bottomRightBorderBox, e.bottomRightPaddingBox);
    case 2:
      return $i(e.bottomRightBorderBox, e.bottomRightPaddingBox, e.bottomLeftBorderBox, e.bottomLeftPaddingBox);
    default:
      return $i(e.bottomLeftBorderBox, e.bottomLeftPaddingBox, e.topLeftBorderBox, e.topLeftPaddingBox);
  }
}, R9 = (e, A) => {
  switch (A) {
    case 0:
      return $i(e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox, e.topRightBorderBox, e.topRightBorderDoubleOuterBox);
    case 1:
      return $i(e.topRightBorderBox, e.topRightBorderDoubleOuterBox, e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox);
    case 2:
      return $i(e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox, e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox);
    default:
      return $i(e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox, e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox);
  }
}, M9 = (e, A) => {
  switch (A) {
    case 0:
      return $i(e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox, e.topRightBorderDoubleInnerBox, e.topRightPaddingBox);
    case 1:
      return $i(e.topRightBorderDoubleInnerBox, e.topRightPaddingBox, e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox);
    case 2:
      return $i(e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox, e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox);
    default:
      return $i(e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox, e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox);
  }
}, P9 = (e, A) => {
  switch (A) {
    case 0:
      return od(e.topLeftBorderStroke, e.topRightBorderStroke);
    case 1:
      return od(e.topRightBorderStroke, e.bottomRightBorderStroke);
    case 2:
      return od(e.bottomRightBorderStroke, e.bottomLeftBorderStroke);
    default:
      return od(e.bottomLeftBorderStroke, e.topLeftBorderStroke);
  }
}, od = (e, A) => {
  const t = [];
  return ji(e) ? t.push(e.subdivide(0.5, !1)) : t.push(e), ji(A) ? t.push(A.subdivide(0.5, !0)) : t.push(A), t;
}, $i = (e, A, t, r) => {
  const n = [];
  return ji(e) ? n.push(e.subdivide(0.5, !1)) : n.push(e), ji(t) ? n.push(t.subdivide(0.5, !0)) : n.push(t), ji(r) ? n.push(r.subdivide(0.5, !0).reverse()) : n.push(r), ji(A) ? n.push(A.subdivide(0.5, !1).reverse()) : n.push(A), n;
};
var k9 = class {
  constructor(e, A) {
    this.ctx = e.ctx, this.pathCallbacks = A;
  }
  /**
  * Render a solid border
  *
  * @param color - Border color
  * @param side - Border side (0=top, 1=right, 2=bottom, 3=left)
  * @param curvePoints - Border curve points
  */
  async renderSolidBorder(e, A, t) {
    this.pathCallbacks.path(tF(t, A)), this.ctx.fillStyle = _t(e), this.ctx.fill();
  }
  /**
  * Render a double border
  * Falls back to solid border if width is too small
  *
  * @param color - Border color
  * @param width - Border width
  * @param side - Border side (0=top, 1=right, 2=bottom, 3=left)
  * @param curvePoints - Border curve points
  */
  async renderDoubleBorder(e, A, t, r) {
    if (A < 3) {
      await this.renderSolidBorder(e, t, r);
      return;
    }
    const n = R9(r, t);
    this.pathCallbacks.path(n), this.ctx.fillStyle = _t(e), this.ctx.fill();
    const i = M9(r, t);
    this.pathCallbacks.path(i), this.ctx.fill();
  }
  /**
  * Render a dashed or dotted border
  *
  * @param color - Border color
  * @param width - Border width
  * @param side - Border side (0=top, 1=right, 2=bottom, 3=left)
  * @param curvePoints - Border curve points
  * @param style - Border style (DASHED or DOTTED)
  */
  async renderDashedDottedBorder(e, A, t, r, n) {
    this.ctx.save();
    const i = P9(r, t), s = tF(r, t);
    n === 2 && (this.pathCallbacks.path(s), this.ctx.clip());
    let a, o, l, c;
    ji(s[0]) ? (a = s[0].start.x, o = s[0].start.y) : (a = s[0].x, o = s[0].y), ji(s[1]) ? (l = s[1].end.x, c = s[1].end.y) : (l = s[1].x, c = s[1].y);
    let u;
    t === 0 || t === 2 ? u = Math.abs(a - l) : u = Math.abs(o - c), this.ctx.beginPath(), n === 3 ? this.pathCallbacks.formatPath(i) : this.pathCallbacks.formatPath(s.slice(0, 2));
    let d = A < 3 ? A * 3 : A * 2, h = A < 3 ? A * 2 : A;
    n === 3 && (d = A, h = A);
    let p = !0;
    if (u <= d * 2) p = !1;
    else if (u <= d * 2 + h) {
      const B = u / (2 * d + h);
      d *= B, h *= B;
    } else {
      const B = Math.floor((u + h) / (d + h)), y = (u - B * d) / (B - 1), m = (u - (B + 1) * d) / B;
      h = m <= 0 || Math.abs(h - y) < Math.abs(h - m) ? y : m;
    }
    if (p && (n === 3 ? this.ctx.setLineDash([0, d + h]) : this.ctx.setLineDash([d, h])), n === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = A) : this.ctx.lineWidth = A * 2 + 1.1, this.ctx.strokeStyle = _t(e), this.ctx.stroke(), this.ctx.setLineDash([]), n === 2) {
      if (ji(s[0])) {
        const B = s[3], y = s[0];
        this.ctx.beginPath(), this.pathCallbacks.formatPath([new re(B.end.x, B.end.y), new re(y.start.x, y.start.y)]), this.ctx.stroke();
      }
      if (ji(s[1])) {
        const B = s[1], y = s[2];
        this.ctx.beginPath(), this.pathCallbacks.formatPath([new re(B.end.x, B.end.y), new re(y.start.x, y.start.y)]), this.ctx.stroke();
      }
    }
    this.ctx.restore();
  }
}, K9 = class {
  constructor(e) {
    this.ctx = e;
  }
  renderBorderImage(e, A, t, r, n, i, s, a) {
    const o = A.naturalWidth || A.width, l = A.naturalHeight || A.height;
    if (o <= 0 || l <= 0) return;
    const c = Math.min(t.unit === "percent" ? t.top / 100 * l : Math.min(t.top, l), l), u = Math.min(t.unit === "percent" ? t.right / 100 * o : Math.min(t.right, o), o), d = Math.min(t.unit === "percent" ? t.bottom / 100 * l : Math.min(t.bottom, l), l), h = Math.min(t.unit === "percent" ? t.left / 100 * o : Math.min(t.left, o), o), { left: p, top: B, width: y, height: m } = e;
    if (y <= 0 || m <= 0) return;
    const C = Math.min(n, m), Q = Math.min(i, y), F = Math.min(s, m - C), T = Math.min(a, y - Q);
    this.drawRegion(A, 0, 0, h, c, p, B, T, C), this.drawRegion(A, o - u, 0, u, c, p + y - Q, B, Q, C), this.drawRegion(A, o - u, l - d, u, d, p + y - Q, B + m - F, Q, F), this.drawRegion(A, 0, l - d, h, d, p, B + m - F, T, F);
    const V = [
      {
        sx: h,
        sy: 0,
        sw: o - h - u,
        sh: c,
        dx: p + T,
        dy: B,
        dw: y - T - Q,
        dh: C,
        repeat: r.horizontal
      },
      {
        sx: o - u,
        sy: c,
        sw: u,
        sh: l - c - d,
        dx: p + y - Q,
        dy: B + C,
        dw: Q,
        dh: m - C - F,
        repeat: r.vertical
      },
      {
        sx: h,
        sy: l - d,
        sw: o - h - u,
        sh: d,
        dx: p + T,
        dy: B + m - F,
        dw: y - T - Q,
        dh: F,
        repeat: r.horizontal
      },
      {
        sx: 0,
        sy: c,
        sw: h,
        sh: l - c - d,
        dx: p,
        dy: B + C,
        dw: T,
        dh: m - C - F,
        repeat: r.vertical
      }
    ];
    for (const M of V) {
      if (M.sw <= 0 || M.sh <= 0 || M.dw <= 0 || M.dh <= 0) continue;
      const D = M.dw >= M.dh;
      M.repeat === 0 ? this.ctx.drawImage(A, M.sx, M.sy, M.sw, M.sh, M.dx, M.dy, M.dw, M.dh) : (M.repeat === 1 || M.repeat === 2) && this.drawRepeatedEdge(A, M, D, M.repeat === 2);
    }
    if (t.fill) {
      const M = h, D = c, I = o - h - u, q = l - c - d, U = p + T, x = B + C, P = y - T - Q, N = m - C - F;
      this.drawRegion(A, M, D, I, q, U, x, P, N);
    }
  }
  drawRegion(e, A, t, r, n, i, s, a, o) {
    r > 0 && n > 0 && a > 0 && o > 0 && this.ctx.drawImage(e, A, t, r, n, i, s, a, o);
  }
  drawRepeatedEdge(e, A, t, r) {
    const n = t ? A.sw : A.sh, i = t ? A.dw : A.dh;
    if (n <= 0 || i <= 0) return;
    let s, a;
    r ? (a = Math.max(1, Math.round(i / n)), s = i / a) : (s = n, a = Math.ceil(i / s)), this.ctx.save(), this.ctx.beginPath(), this.ctx.rect(A.dx, A.dy, A.dw, A.dh), this.ctx.clip();
    for (let o = 0; o < a; o++) {
      const l = o * s, c = i - l, u = Math.min(s, c);
      if (u <= 0) break;
      t ? this.ctx.drawImage(e, A.sx, A.sy, A.sw, A.sh, A.dx + l, A.dy, u, A.dh) : this.ctx.drawImage(e, A.sx, A.sy, A.sw, A.sh, A.dx, A.dy + l, A.dw, u);
    }
    this.ctx.restore();
  }
}, V9 = class {
  constructor(e, A) {
    this.activeEffects = [], this.didSave = !1, this.saveAtDepth = -1, this.ctx = e.ctx, this.pathCallback = A;
  }
  /**
  * Apply multiple effects.
  * Clears existing effects and applies new ones.
  */
  applyEffects(e) {
    for (; this.activeEffects.length; ) this.popEffect();
    this.didSave = !1, this.saveAtDepth = -1;
    const A = (r) => qb(r) || Fg(r) || $b(r), t = e.reduceRight((r, n, i) => r !== -1 ? r : A(n) ? i : -1, -1);
    for (let r = 0; r < e.length; r++) {
      const n = e[r];
      A(n) && (this.didSave || (this.ctx.save(), this.didSave = !0), r === t && (this.saveAtDepth = this.activeEffects.length)), this.applyEffect(n);
    }
  }
  /**
  * Apply a single effect (called internally by applyEffects).
  */
  applyEffect(e) {
    qb(e) ? (this.ctx.translate(e.offsetX, e.offsetY), this.ctx.transform(e.matrix[0], e.matrix[1], e.matrix[2], e.matrix[3], e.matrix[4], e.matrix[5]), this.ctx.translate(-e.offsetX, -e.offsetY)) : Fg(e) ? (this.pathCallback.path(e.path), this.ctx.clip()) : $b(e) ? e.applyClip(this.ctx) : Oy(e) ? this.ctx.globalAlpha *= e.opacity : B9(e) ? this.ctx.globalCompositeOperation = e.compositeOperation : Ny(e) && (this.ctx.filter = e.safeFilterString || "none", e.shadow && (this.ctx.shadowOffsetX = e.shadow.offsetX, this.ctx.shadowOffsetY = e.shadow.offsetY, this.ctx.shadowBlur = e.shadow.blur, this.ctx.shadowColor = e.shadow.color)), this.activeEffects.push(e);
  }
  /**
  * Remove the most recent effect.
  * Restores canvas state if needed.
  */
  popEffect() {
    this.activeEffects.length !== 0 && (this.didSave && this.activeEffects.length - 1 === this.saveAtDepth && (this.ctx.restore(), this.didSave = !1, this.saveAtDepth = -1), this.activeEffects.pop(), !this.didSave && this.activeEffects.length === 0 && (this.ctx.globalAlpha = 1, this.ctx.globalCompositeOperation = "source-over", this.ctx.filter = "none", this.ctx.shadowOffsetX = 0, this.ctx.shadowOffsetY = 0, this.ctx.shadowBlur = 0, this.ctx.shadowColor = "rgba(0, 0, 0, 0)"));
  }
  /**
  * Get the current number of active effects.
  */
  getActiveEffectCount() {
    return this.activeEffects.length;
  }
  /**
  * Check if there are any active effects.
  */
  hasActiveEffects() {
    return this.activeEffects.length > 0;
  }
};
const G9 = (e, A, t, r, n) => {
  let i = 0, s = 0, a = e, o = A, l = t.left, c = t.top, u = t.width, d = t.height;
  const h = u / d, p = a / o, B = n ? Ie(n[0], 1) : 0.5, y = n ? Ie(n[1], 1) : 0.5;
  return r === 2 ? p > h ? (d = u / p, c += (t.height - d) * y) : (u = d * p, l += (t.width - u) * B) : r === 4 ? p > h ? (a = o * h, i += (e - a) * B) : (o = a / h, s += (A - o) * y) : r === 8 ? (a > u ? (i += (a - u) * B, a = u) : (l += (u - a) * B, u = a), o > d ? (s += (o - d) * y, o = d) : (c += (d - o) * y, d = o)) : r === 16 && ((p > h ? u : d * p) < (a > u ? a : u) ? p > h ? (d = u / p, c += (t.height - d) * y) : (u = d * p, l += (t.width - u) * B) : (a > u ? (i += (a - u) * B, a = u) : (l += (u - a) * B, u = a), o > d ? (s += (o - d) * y, o = d) : (c += (d - o) * y, d = o))), {
    sx: i,
    sy: s,
    sw: a,
    sh: o,
    dx: l,
    dy: c,
    dw: u,
    dh: d
  };
};
async function W9(e, A, t, r, n, i, s, a) {
  if (n instanceof LS) try {
    const o = await A.cache.match(n.src), l = e.imageSmoothingEnabled;
    s.imageRendering === 2 || s.imageRendering === 1 ? e.imageSmoothingEnabled = !1 : s.imageRendering === 3 && (e.imageSmoothingEnabled = !0), a(n, i, o), e.imageSmoothingEnabled = l;
  } catch (o) {
    A.logger.error(`Error loading image ${n.src}`), A.onError?.(o instanceof Error ? o : new Error(String(o)));
  }
  if (n instanceof HS && a(n, i, n.canvas), n instanceof TS) try {
    a(n, i, await A.cache.match(n.svg));
  } catch (o) {
    A.logger.error(`Error loading svg ${n.svg.substring(0, 255)}`), A.onError?.(o instanceof Error ? o : new Error(String(o)));
  }
  if (n instanceof DS && n.tree) {
    const o = await r(A, {
      scale: t.scale,
      backgroundColor: n.backgroundColor,
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }).render(n.tree);
    n.width && n.height && e.drawImage(o, 0, 0, n.width, n.height, n.bounds.left, n.bounds.top, n.bounds.width, n.bounds.height);
  }
}
function j9(e, A, t, r, n) {
  if (r instanceof kc) {
    const i = Math.min(r.bounds.width, r.bounds.height);
    r.type === "checkbox" && r.checked ? (e.save(), t([
      new re(r.bounds.left + i * 0.39363, r.bounds.top + i * 0.79),
      new re(r.bounds.left + i * 0.16, r.bounds.top + i * 0.5549),
      new re(r.bounds.left + i * 0.27347, r.bounds.top + i * 0.44071),
      new re(r.bounds.left + i * 0.39694, r.bounds.top + i * 0.5649),
      new re(r.bounds.left + i * 0.72983, r.bounds.top + i * 0.23),
      new re(r.bounds.left + i * 0.84, r.bounds.top + i * 0.34085),
      new re(r.bounds.left + i * 0.39363, r.bounds.top + i * 0.79)
    ]), e.fillStyle = _t(Gb), e.fill(), e.restore()) : r.type === "radio" && r.checked && (e.save(), e.beginPath(), e.arc(r.bounds.left + i / 2, r.bounds.top + i / 2, i / 4, 0, Math.PI * 2, !0), e.fillStyle = _t(Gb), e.fill(), e.restore());
  }
  if (X9(r) && r.value.length) {
    const [i] = A.createFontStyle(n);
    e.font = i;
    const s = Ie(n.fontSize, 0), { baseline: a, height: o } = $S(e, s);
    e.fillStyle = r instanceof kc && r.isPlaceholder ? _t(o9) : _t(n.color), e.textBaseline = "alphabetic", e.textAlign = Y9(r.styles.textAlign);
    const l = kh(r), c = r instanceof kc ? q9(l, Dy(r), o) : l;
    let u = 0;
    switch (r.styles.textAlign) {
      case 1:
        u += l.width / 2;
        break;
      case 2:
        u += l.width;
        break;
    }
    let d = 0;
    r instanceof kc && (d = (l.height - o) / 2);
    const h = l.add(u, d, 0, 0);
    e.save(), t([
      new re(c.left, c.top),
      new re(c.left + c.width, c.top),
      new re(c.left + c.width, c.top + c.height),
      new re(c.left, c.top + c.height)
    ]), e.clip();
    const p = $9(e, r.value, l.width, n.whiteSpace === "pre" || n.whiteSpace === "nowrap"), B = tv(n.lineHeight, s);
    p.forEach((y, m) => {
      let C = h.left;
      const Q = e.measureText(y).width;
      switch (n.textAlign) {
        case 1:
          C += (l.width - Q) / 2;
          break;
        case 2:
          C += l.width - Q;
          break;
      }
      const F = new Hn(C, h.top + m * B, 0, 0);
      A.renderTextWithLetterSpacing(new Dl(y, F), n.letterSpacing, a, n.writingMode);
    }), e.restore(), e.textBaseline = "alphabetic", e.textAlign = "left";
  }
}
const q9 = (e, A, t) => e.height < t ? new Hn(e.left, A.top, e.width, A.height) : e, $9 = (e, A, t, r) => {
  const n = [], i = A.split(`
`);
  for (const s of i) {
    if (r) {
      n.push(s);
      continue;
    }
    const a = s.split(/(\s+)/);
    let o = "";
    for (const l of a) {
      const c = o + l;
      e.measureText(c).width <= t || o === "" ? o = c : (n.push(o), o = l);
    }
    n.push(o);
  }
  return n;
};
async function z9(e, A, t, r, n, i) {
  if (zr(n.styles.display, 2048)) {
    if (n.styles.listStyleImage !== null) {
      const s = n.styles.listStyleImage;
      if (s.type === 0) {
        const a = s.url;
        try {
          const o = await A.cache.match(a);
          e.drawImage(o, n.bounds.left - (o.width + 10), n.bounds.top);
        } catch (o) {
          A.logger.error(`Error loading list-style-image ${a}`), A.onError?.(o instanceof Error ? o : new Error(String(o)));
        }
      }
    } else if (r.listValue && n.styles.listStyleType !== -1) {
      const [s] = t.createFontStyle(i);
      e.font = s, e.fillStyle = _t(i.color), e.textBaseline = "middle", e.textAlign = "right";
      const a = new Hn(n.bounds.left, n.bounds.top + Ie(n.styles.paddingTop, n.bounds.width), n.bounds.width, tv(i.lineHeight, i.fontSize.number) / 2 + 1);
      t.renderTextWithLetterSpacing(new Dl(r.listValue, a), i.letterSpacing, tv(i.lineHeight, i.fontSize.number) / 2 + 2, i.writingMode), e.textBaseline = "bottom", e.textAlign = "left";
    }
  }
}
const X9 = (e) => e instanceof NS || e instanceof OS ? !0 : e instanceof kc && e.type !== "radio" && e.type !== "checkbox", Y9 = (e) => {
  switch (e) {
    case 1:
      return "center";
    case 2:
      return "right";
    default:
      return "left";
  }
};
var J9 = class dv {
  constructor(A, t, r, n = { pixels: 0 }) {
    this.surfaceRoot = r, this.surfaceBudget = n, this.legacySubtree = !1, this.context = A, this.options = t, this.canvas = t.canvas ? t.canvas : document.createElement("canvas");
    const i = this.canvas.getContext("2d");
    if (!i)
      throw t.canvas || Ui(this.canvas), r ? new Vi("Filter surface canvas is unavailable") : new Error("Failed to get 2D rendering context from canvas");
    this.ctx = i, t.canvas || (this.canvas.width = Math.floor(t.width * t.scale), this.canvas.height = Math.floor(t.height * t.scale), this.canvas.style.width = `${t.width}px`, this.canvas.style.height = `${t.height}px`), this.ctx.scale(this.options.scale, this.options.scale), this.ctx.translate(-t.x, -t.y), this.ctx.textBaseline = "bottom", t.imageSmoothing !== void 0 && (this.ctx.imageSmoothingEnabled = t.imageSmoothing), t.imageSmoothingQuality && (this.ctx.imageSmoothingQuality = t.imageSmoothingQuality), this.backgroundRenderer = new eF({
      ctx: this.ctx,
      context: this.context,
      canvas: this.canvas,
      options: {
        width: t.width,
        height: t.height,
        scale: t.scale
      }
    }), this.borderRenderer = new k9({ ctx: this.ctx }, {
      path: (s) => this.path(s),
      formatPath: (s) => this.formatPath(s)
    }), this.borderImageRenderer = new K9(this.ctx), this.effectsRenderer = new V9({ ctx: this.ctx }, { path: (s) => this.path(s) }), this.textRenderer = new N9({
      ctx: this.ctx,
      options: { scale: t.scale }
    }), this.context.logger.debug(`Canvas renderer initialized (${t.width}x${t.height}) with scale ${t.scale}`);
  }
  async renderStack(A) {
    const t = A.element.container.styles;
    if (t.isVisible()) {
      const r = uv(t.filter);
      if (A.element !== this.surfaceRoot && !this.legacySubtree && r && (t.filter || t.opacity < 1) && this.canComposite(A.element)) {
        if (!await this.renderCompositedStack(A, r)) {
          this.legacySubtree = !0;
          try {
            await this.renderStackContent(A);
          } finally {
            this.legacySubtree = !1;
          }
        }
        return;
      }
      await this.renderStackContent(A);
    }
  }
  canComposite(A) {
    const t = (i) => {
      const s = i.styles;
      return !s.isTransformed() && s.zoom === 1 && s.mixBlendMode === Ir.NORMAL && s.clipPath.type === 0 && !zr(s.display, 2048) && uv(s.filter) !== null;
    }, r = (i) => t(i) && i.elements.every(r);
    let n = A.parent;
    for (; n && n !== this.surfaceRoot; ) {
      if (!t(n.container)) return !1;
      n = n.parent;
    }
    return r(A.container);
  }
  async renderCompositedStack(A, t) {
    const r = this.options.signal;
    if (r?.aborted) throw new DOMException("The operation was aborted.", "AbortError");
    const n = AF(qS(A.element.container), new Hn(this.options.x, this.options.y, this.options.width, this.options.height), jS(t), this.options.scale);
    if (!n.width || !n.height) return !0;
    const i = Zb(this.surfaceBudget, Math.ceil(n.width * this.options.scale), Math.ceil(n.height * this.options.scale));
    if (!i)
      return this.context.logger.info("Filter surface budget exceeded; using the existing renderer"), !1;
    const s = {
      ...this.options,
      canvas: void 0,
      backgroundColor: null,
      x: n.left,
      y: n.top,
      width: n.width,
      height: n.height
    };
    let a, o;
    try {
      if (a = new dv(this.context, s, A.element, this.surfaceBudget), await a.renderStackContent(A), a.effectsRenderer.applyEffects([]), o = await Jb(a.canvas, t, A.element.container.styles.opacity, s.scale, r), r?.aborted) throw new DOMException("The operation was aborted.", "AbortError");
      const l = A.element.effects, c = A.element.getEffects(4, this.surfaceRoot).filter((u) => !l.includes(u) || !Ny(u) && !Oy(u) && !Fg(u));
      return this.effectsRenderer.applyEffects(c), this.ctx.drawImage(o, s.x, s.y, o.width / s.scale, o.height / s.scale), !0;
    } catch (l) {
      if (!(l instanceof Vi)) throw l;
      return this.context.logger.info(`${l.message}; using the existing renderer`), !1;
    } finally {
      a && Ui(a.canvas), o && Ui(o), this.surfaceBudget.pixels -= i;
    }
  }
  async renderNode(A) {
    if (A.container.debugRender) debugger;
    A.container.styles.isVisible() && (await this.renderNodeBackgroundAndBorders(A), await this.renderNodeContent(A));
  }
  /**
  * Helper method to render text with paint order support
  * Reduces code duplication in line-clamp and normal rendering
  */
  renderReplacedElement(A, t, r) {
    const n = r.naturalWidth || A.intrinsicWidth, i = r.naturalHeight || A.intrinsicHeight;
    if (r && n > 0 && i > 0) {
      const s = kh(A), a = bg(t);
      this.path(a), this.ctx.save(), this.ctx.clip();
      const { sx: o, sy: l, sw: c, sh: u, dx: d, dy: h, dw: p, dh: B } = G9(n, i, s, A.styles.objectFit, A.styles.objectPosition);
      this.ctx.drawImage(r, o, l, c, u, d, h, p, B), this.ctx.restore();
    }
  }
  async renderNodeContent(A) {
    this.effectsRenderer.applyEffects(A.getEffects(4, this.surfaceRoot));
    const t = A.container, r = A.curves, n = t.styles, i = kh(t);
    for (const s of t.textNodes) await this.textRenderer.renderTextNode(s, n, i);
    await W9(this.ctx, this.context, {
      scale: this.options.scale,
      backgroundColor: this.options.backgroundColor,
      x: this.options.x,
      y: this.options.y,
      width: this.options.width,
      height: this.options.height
    }, (s, a) => new dv(s, a), t, r, n, (s, a, o) => this.renderReplacedElement(s, a, o)), j9(this.ctx, this.textRenderer, this.path.bind(this), t, n), await z9(this.ctx, this.context, this.textRenderer, A, t, n);
  }
  async renderStackContent(A) {
    if (A.element.container.debugRender) debugger;
    const t = this.options.signal;
    await this.renderNodeBackgroundAndBorders(A.element);
    for (const r of A.negativeZIndex) {
      if (t?.aborted) throw new DOMException("The operation was aborted.", "AbortError");
      await this.renderStack(r);
    }
    if (t?.aborted) throw new DOMException("The operation was aborted.", "AbortError");
    await this.renderNodeContent(A.element);
    for (const r of A.nonInlineLevel) await this.renderNode(r);
    for (const r of A.nonPositionedFloats) {
      if (t?.aborted) throw new DOMException("The operation was aborted.", "AbortError");
      await this.renderStack(r);
    }
    for (const r of A.nonPositionedInlineLevel) {
      if (t?.aborted) throw new DOMException("The operation was aborted.", "AbortError");
      await this.renderStack(r);
    }
    for (const r of A.inlineLevel) await this.renderNode(r);
    for (const r of A.zeroOrAutoZIndexOrTransformedOrOpacity) {
      if (t?.aborted) throw new DOMException("The operation was aborted.", "AbortError");
      await this.renderStack(r);
    }
    for (const r of A.positiveZIndex) {
      if (t?.aborted) throw new DOMException("The operation was aborted.", "AbortError");
      await this.renderStack(r);
    }
  }
  mask(A) {
    this.ctx.beginPath();
    const t = this.options.x, r = this.options.y;
    this.ctx.moveTo(t, r), this.ctx.lineTo(t + this.options.width, r), this.ctx.lineTo(t + this.options.width, r + this.options.height), this.ctx.lineTo(t, r + this.options.height), this.ctx.lineTo(t, r), this.formatPath(A.slice(0).reverse()), this.ctx.closePath();
  }
  path(A) {
    fv(this.ctx, A);
  }
  formatPath(A) {
    hv(this.ctx, A);
  }
  async renderSurfaceBoxShadow(A, t) {
    const r = t.spread.number, n = t.blur.number / 2, i = Math.ceil(3 * n) + 1, s = A.container.bounds.add(-r, -r, 2 * r, 2 * r);
    if (s.width <= 0 || s.height <= 0) return;
    const a = this.options.scale, o = AF(s.add(-i, -i, 2 * i, 2 * i), new Hn(this.options.x - t.offsetX.number, this.options.y - t.offsetY.number, this.options.width, this.options.height), i, a);
    if (!o.width || !o.height) return;
    const l = Math.ceil(o.width * a), c = Math.ceil(o.height * a), u = Zb(this.surfaceBudget, l, c);
    if (!u) throw new Vi("Box shadow surface budget exceeded");
    let d, h;
    try {
      d = document.createElement("canvas"), d.width = l, d.height = c;
      const p = d.getContext("2d");
      if (!p) throw new Vi("Box shadow surface canvas is unavailable");
      p.scale(a, a), p.translate(-o.left, -o.top), fv(p, jb(qc(A.curves), -r, -r, 2 * r, 2 * r)), p.fillStyle = _t(t.color), p.fill(), h = await Jb(d, { blur: n }, 1, a, this.options.signal), this.ctx.save();
      try {
        this.ctx.beginPath(), this.ctx.rect(this.options.x, this.options.y, this.options.width, this.options.height), hv(this.ctx, qc(A.curves)), this.ctx.closePath(), this.ctx.clip("evenodd"), this.ctx.drawImage(h, o.left + t.offsetX.number, o.top + t.offsetY.number, h.width / a, h.height / a);
      } finally {
        this.ctx.restore();
      }
    } finally {
      d && Ui(d), h && Ui(h), this.surfaceBudget.pixels -= u;
    }
  }
  async renderNodeBackgroundAndBorders(A) {
    this.effectsRenderer.applyEffects(A.getEffects(2, this.surfaceRoot));
    const t = A.container.styles, r = !Sa(t.backgroundColor) || t.backgroundImage.length, n = AV(t), i = [
      {
        style: t.borderTopStyle,
        color: t.borderTopColor,
        width: t.borderTopWidth
      },
      {
        style: t.borderRightStyle,
        color: t.borderRightColor,
        width: t.borderRightWidth
      },
      {
        style: t.borderBottomStyle,
        color: t.borderBottomColor,
        width: t.borderBottomWidth
      },
      {
        style: t.borderLeftStyle,
        color: t.borderLeftColor,
        width: t.borderLeftWidth
      }
    ], s = Ql(t.backgroundClip, 0), a = Z9(s, A.curves);
    if (r || t.boxShadow.length) {
      n && A.container.textNodes.length > 0 ? await this.renderTextClippedBackground(A) : (this.ctx.save(), this.path(a), this.ctx.clip(), Sa(t.backgroundColor) || (this.ctx.fillStyle = _t(t.backgroundColor), this.ctx.fill()), await this.backgroundRenderer.renderBackgroundImage(A.container), this.ctx.restore());
      for (const l of t.boxShadow.slice(0).reverse()) {
        if (this.surfaceRoot && !l.inset) {
          await this.renderSurfaceBoxShadow(A, l);
          continue;
        }
        this.ctx.save();
        const c = qc(A.curves), u = l.inset ? 0 : WK, d = jb(c, -u + (l.inset ? 1 : -1) * l.spread.number, (l.inset ? 1 : -1) * l.spread.number, l.spread.number * (l.inset ? -2 : 2), l.spread.number * (l.inset ? -2 : 2));
        l.inset ? (this.path(c), this.ctx.clip(), this.mask(d)) : (this.mask(c), this.ctx.clip(), this.path(d));
        const h = this.surfaceRoot ? this.options.scale : 1;
        this.ctx.shadowOffsetX = (l.offsetX.number + u) * h, this.ctx.shadowOffsetY = l.offsetY.number * h, this.ctx.shadowColor = _t(l.color), this.ctx.shadowBlur = l.blur.number * h, this.ctx.fillStyle = l.inset ? _t(l.color) : "rgba(0,0,0,1)", this.ctx.fill(), this.ctx.restore();
      }
    }
    if (t.borderImageSource) {
      const l = t.borderImageSource;
      if (l.type === 0) {
        const c = l.url;
        try {
          const u = await this.context.cache.match(c);
          if (u) {
            const d = A.container.bounds;
            this.borderImageRenderer.renderBorderImage(d, u, t.borderImageSlice, t.borderImageRepeat, Math.max(0, t.borderTopWidth), Math.max(0, t.borderRightWidth), Math.max(0, t.borderBottomWidth), Math.max(0, t.borderLeftWidth));
          }
        } catch {
          this.context.logger.error(`Error loading border-image ${c}`);
        }
      }
      return;
    }
    let o = 0;
    for (const l of i) {
      if (l.style !== 0 && !Sa(l.color) && l.width > 0) {
        const c = async () => {
          l.style === 2 ? await this.borderRenderer.renderDashedDottedBorder(l.color, l.width, o, A.curves, 2) : l.style === 3 ? await this.borderRenderer.renderDashedDottedBorder(l.color, l.width, o, A.curves, 3) : l.style === 4 ? await this.borderRenderer.renderDoubleBorder(l.color, l.width, o, A.curves) : await this.borderRenderer.renderSolidBorder(l.color, o, A.curves);
        }, u = A.container.legendBounds;
        if (o === 0 && u) {
          const d = A.container.bounds, h = u.left - d.left, p = u.left + u.width - d.left;
          h > 0 && (this.ctx.save(), this.ctx.beginPath(), this.ctx.rect(d.left, d.top, h, d.height), this.ctx.clip(), await c(), this.ctx.restore());
          const B = d.left + p, y = d.width - p;
          y > 0 && (this.ctx.save(), this.ctx.beginPath(), this.ctx.rect(B, d.top, y, d.height), this.ctx.clip(), await c(), this.ctx.restore());
        } else await c();
      }
      o++;
    }
  }
  async render(A) {
    try {
      this.options.backgroundColor && (this.ctx.fillStyle = _t(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height));
      const t = m9(A);
      return await this.renderStack(t), this.effectsRenderer.applyEffects([]), this.canvas;
    } catch (t) {
      throw this.options.canvas || Ui(this.canvas), t;
    }
  }
  /**
  * Render background clipped to text shape using offscreen canvas with destination-in compositing.
  * This implements background-clip: text support.
  *
  * Algorithm:
  *   1. Draw background (color + images) onto an offscreen canvas
  *   2. Use destination-in compositing to clip the background to the text glyph shapes
  *   3. Composite the result back onto the main canvas
  *
  * The offscreen canvas uses CSS-pixel dimensions (not device-pixel) because the
  * background renderer handles scaling internally via BackgroundRenderer options.
  */
  async renderTextClippedBackground(A) {
    const t = A.container, r = t.styles, n = t.bounds;
    if (n.width <= 0 || n.height <= 0) return;
    const i = (this.canvas.ownerDocument ?? document).createElement("canvas"), s = Math.ceil(n.width), a = Math.ceil(n.height);
    i.width = s, i.height = a;
    const o = i.getContext("2d");
    if (!o) return;
    const [l] = this.textRenderer.createFontStyle(r);
    o.font = l, o.textBaseline = "alphabetic", o.textAlign = "left", o.direction = r.direction === 1 ? "rtl" : "ltr";
    const c = zS(o, r.fontSize.number), u = new eF({
      ctx: o,
      context: this.context,
      canvas: i,
      options: {
        width: s,
        height: a,
        scale: 1
      }
    });
    Sa(r.backgroundColor) || (o.fillStyle = _t(r.backgroundColor), o.fillRect(0, 0, s, a)), o.save(), o.translate(-n.left, -n.top), await u.renderBackgroundImage(t), o.restore(), o.globalCompositeOperation = "destination-in", o.fillStyle = "#000";
    const d = r.writingMode, h = r.letterSpacing;
    for (const p of t.textNodes) for (const B of p.textBounds) {
      const y = B.bounds.left - n.left, m = B.bounds.top - n.top + c;
      h > 0 ? this.renderTextMaskWithLetterSpacing(o, B, h, y, m, d) : o.fillText(B.text, y, m);
    }
    this.ctx.drawImage(i, n.left, n.top);
  }
  /**
  * Render text glyphs one-by-one as a mask, applying letter-spacing between characters.
  * This ensures the mask matches how the text renderer lays out the characters.
  */
  renderTextMaskWithLetterSpacing(A, t, r, n, i, s) {
    const a = Rl(t.text);
    let o = n;
    for (const l of a) {
      if (Cg(s)) {
        A.fillText(t.text, n, i);
        return;
      }
      A.fillText(l, o, i), o += A.measureText(l).width + r;
    }
  }
};
const Z9 = (e, A) => {
  switch (e) {
    case 0:
      return qc(A);
    case 2:
      return f9(A);
    default:
      return bg(A);
  }
}, AV = (e) => e.backgroundClip.some((A) => A === 3);
var eV = class {
  constructor(A, t) {
    this.context = A, this.options = t, this.canvas = t.canvas ? t.canvas : document.createElement("canvas");
    const r = this.canvas.getContext("2d");
    if (!r) throw new Error("Failed to get 2D rendering context from canvas");
    this.ctx = r, this.canvas.width = Math.floor(t.width * t.scale), this.canvas.height = Math.floor(t.height * t.scale), this.canvas.style.width = `${t.width}px`, this.canvas.style.height = `${t.height}px`, this.ctx.scale(this.options.scale, this.options.scale), this.ctx.translate(-t.x, -t.y), this.context.logger.debug(`EXPERIMENTAL ForeignObject renderer initialized (${t.width}x${t.height} at ${t.x},${t.y}) with scale ${t.scale}`);
  }
  async render(A) {
    if (this.options.signal?.aborted) throw new DOMException("The operation was aborted.", "AbortError");
    const t = await av(sv(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, A));
    return this.options.backgroundColor && (this.ctx.fillStyle = _t(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(t, -this.options.x * this.options.scale, -this.options.y * this.options.scale), this.canvas;
  }
}, Yc, tV = (Yc = class {
  constructor({ id: A, enabled: t }) {
    this.id = A, this.enabled = t, this.start = Date.now();
  }
  debug(...A) {
    this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug(this.id, `${this.getTime()}ms`, ...A) : this.info(...A));
  }
  getTime() {
    return Date.now() - this.start;
  }
  info(...A) {
    this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info(this.id, `${this.getTime()}ms`, ...A);
  }
  warn(...A) {
    this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn(this.id, `${this.getTime()}ms`, ...A) : this.info(...A));
  }
  error(...A) {
    this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error(this.id, `${this.getTime()}ms`, ...A) : this.info(...A));
  }
}, Yc.instances = {}, Yc), rV = class {
  constructor(A, t) {
    if (this.context = A, this._options = t, this._cache = /* @__PURE__ */ new Map(), this._pendingOperations = /* @__PURE__ */ new Map(), this._deferMode = !1, this._collectedUrls = /* @__PURE__ */ new Set(), this.maxSize = t.maxCacheSize ?? 100, this.maxSize < 1) throw new Error("Cache maxSize must be at least 1");
    this.maxSize > 1e4 && this.context.logger.warn(`Cache maxSize ${this.maxSize} is very large and may cause memory issues. Consider using a smaller value (recommended: 100-1000).`);
  }
  /**
  * Enter defer mode: subsequent addImage() calls only collect URLs.
  * Call preloadAll() to exit defer mode and batch-load all URLs.
  */
  startDefer() {
    this._deferMode = !0;
  }
  /**
  * Exit defer mode and load all collected URLs in parallel, respecting
  * an optional concurrency cap to avoid overwhelming the browser's network
  * stack (default: 10 concurrent loads).
  * After this call returns, all images are either loaded (cache hit) or
  * failed (logged). Subsequent cache.match() calls return immediately.
  *
  * @param concurrency - Max concurrent image loads (1–100, default 10).
  */
  async preloadAll(A = 10) {
    this._deferMode = !1;
    const t = Array.from(this._collectedUrls);
    if (this._collectedUrls.clear(), t.length === 0) return;
    const r = Math.max(1, Math.min(A, 100));
    this.context.logger.debug(`Preloading ${t.length} image(s) with concurrency ${r}`);
    for (let n = 0; n < t.length; n += r) {
      const i = t.slice(n, n + r).map((s) => this._addImageWithPending(s));
      await Promise.allSettled(i);
    }
  }
  addImage(A) {
    if (this._deferMode)
      return !this.has(A) && (Hu(A) || rF(A)) && this._collectedUrls.add(A), Promise.resolve();
    const t = this._pendingOperations.get(A);
    if (t) return t;
    if (this.has(A)) {
      const r = this._cache.get(A);
      return this._cache.delete(A), this._cache.set(A, r), Promise.resolve();
    }
    return Hu(A) || rF(A) ? this._addImageWithPending(A) : Promise.resolve();
  }
  /**
  * Shared helper: enqueues loading for a single URL with pending-operation
  * deduplication and error swallowing. Used by both addImage() (normal mode)
  * and preloadAll() (batch mode).
  */
  _addImageWithPending(A) {
    const t = this._pendingOperations.get(A);
    if (t) return t;
    const r = this._addImageInternal(A);
    return this._pendingOperations.set(A, r), r.finally(() => {
      this._pendingOperations.delete(A);
    }), r;
  }
  async _addImageInternal(A) {
    const t = this._options.imageTimeout ?? 15e3, r = this.withTimeout(this.loadImage(A), t, `Timed out (${t}ms) loading image`);
    r.catch((n) => {
      this.context.logger.error(`Failed to load image ${A}: ${n instanceof Error ? n.message : "Unknown error"}`);
    }), this.set(A, r);
  }
  withTimeout(A, t, r) {
    if (t <= 0) return A;
    let n;
    const i = new Promise((s, a) => {
      n = setTimeout(() => a(new Error(r)), t);
    });
    return Promise.race([A, i]).finally(() => {
      n !== void 0 && clearTimeout(n);
    });
  }
  match(A) {
    const t = this._cache.get(A);
    if (t)
      return this._cache.delete(A), this._cache.set(A, t), t.value;
  }
  /**
  * Set a value in cache with LRU eviction (O(1) via Map insertion order).
  * Map preserves insertion order; delete+set on access moves items to the end.
  * The first key in Map.keys() is always the least recently used.
  */
  set(A, t) {
    if (this._cache.has(A)) this._cache.delete(A);
    else if (this._cache.size >= this.maxSize) {
      const r = this._cache.keys().next().value;
      r !== void 0 && (this._cache.delete(r), this.context.logger.debug(`Cache: Evicted LRU entry: ${r}`));
    }
    this._cache.set(A, { value: t });
  }
  /**
  * Get cache size
  */
  size() {
    return this._cache.size;
  }
  /**
  * Get max cache size
  */
  getMaxSize() {
    return this.maxSize;
  }
  /**
  * Clear all cache entries
  */
  clear() {
    this._cache.clear();
  }
  async loadImage(A) {
    const t = this.context.originChecker, r = (l) => t.isSameOrigin(l), n = typeof this._options.customIsSameOrigin == "function" ? await this._options.customIsSameOrigin(A, r) : r(A), i = !n && this._options.allowTaint === !1 && !ld(A) && !Hu(A) && typeof this._options.proxy != "string", s = !ld(A) && (this._options.useCORS === !0 || i) && sn.SUPPORT_CORS_IMAGES && !n, a = !ld(A) && !n && !Hu(A) && typeof this._options.proxy == "string" && sn.SUPPORT_CORS_XHR && !s;
    if (!n && this._options.allowTaint === !1 && !ld(A) && !Hu(A) && !a && !s) return;
    let o = A;
    return a && (o = await this.proxy(o)), this.context.logger.debug(`Added image ${A.substring(0, 256)}`), await new Promise((l, c) => {
      const u = new Image();
      u.onload = () => l(u), u.onerror = c, (aV(o) || s) && (u.crossOrigin = "anonymous"), u.src = o, u.complete === !0 && setTimeout(() => l(u), 500);
    });
  }
  has(A) {
    return this._cache.has(A);
  }
  keys() {
    return Promise.resolve(Array.from(this._cache.keys()));
  }
  proxy(A) {
    const t = this._options.proxy;
    if (!t) throw new Error("No proxy defined");
    const r = A.substring(0, 256);
    return new Promise((n, i) => {
      const s = sn.SUPPORT_RESPONSE_TYPE ? "blob" : "text", a = new XMLHttpRequest();
      a.onload = () => {
        if (a.status === 200) if (s === "text") n(a.response);
        else {
          const l = new FileReader();
          l.addEventListener("load", () => n(l.result), !1), l.addEventListener("error", (c) => i(c), !1), l.readAsDataURL(a.response);
        }
        else i(`Failed to proxy resource ${r} with status code ${a.status}`);
      }, a.onerror = i;
      const o = t.indexOf("?") > -1 ? "&" : "?";
      if (a.open("GET", `${t}${o}url=${encodeURIComponent(A)}&responseType=${s}`), s !== "text" && a instanceof XMLHttpRequest && (a.responseType = s), this._options.imageTimeout) {
        const l = this._options.imageTimeout;
        a.timeout = l, a.ontimeout = () => i(`Timed out (${l}ms) proxying ${r}`);
      }
      a.send();
    });
  }
};
const nV = /^data:image\/svg\+xml/i, iV = /^data:image\/.*;base64,/i, sV = /^data:image\/.*/i, rF = (e) => sn.SUPPORT_SVG_DRAWING || !oV(e), ld = (e) => sV.test(e), aV = (e) => iV.test(e), Hu = (e) => e.substring(0, 4) === "blob", oV = (e) => e.slice(-3).toLowerCase() === "svg" || nV.test(e);
var lV = class {
  constructor(e) {
    if (!e || !e.document) throw new Error("Valid window object required for OriginChecker");
    if (!e.location || !e.location.href) throw new Error("Window object must have valid location");
    this.link = e.document.createElement("a"), this.origin = this.getOrigin(e.location.href);
  }
  /**
  * Get the origin (protocol + hostname + port) of a URL
  *
  * @param url - URL to parse
  * @returns Origin string (e.g., "https://example.com:8080")
  */
  getOrigin(e) {
    return this.link.href = e, this.link.href = this.link.href, this.link.protocol + this.link.hostname + this.link.port;
  }
  /**
  * Check if a URL is from the same origin as the context
  *
  * @param src - URL to check
  * @returns true if same origin, false otherwise
  */
  isSameOrigin(e) {
    return this.getOrigin(e) === this.origin;
  }
  /**
  * Get the current context origin
  *
  * @returns The origin of the context window
  */
  getContextOrigin() {
    return this.origin;
  }
}, ql, cV = (ql = class {
  constructor(A, t, r) {
    this.windowBounds = t, this.instanceName = `#${ql.instanceCount++}`, this.config = r, this.logger = new tV({
      id: this.instanceName,
      enabled: A.logging
    }), this.originChecker = new lV(r.window), this.cache = A.cache ?? r.cache ?? new rV(this, A), this.onError = A.onError;
  }
}, ql.instanceCount = 1, ql);
const uV = (e) => {
  [
    "scale",
    "width",
    "height",
    "imageTimeout",
    "x",
    "y",
    "windowWidth",
    "windowHeight",
    "scrollX",
    "scrollY"
  ].forEach((A) => {
    const t = e[A];
    if (t != null && typeof t != "number") {
      const r = Number(t);
      Number.isNaN(r) || (e[A] = r);
    }
  });
}, hV = (e) => ({
  allowTaint: e.allowTaint ?? !1,
  imageTimeout: e.imageTimeout ?? 15e3,
  proxy: e.proxy,
  useCORS: e.useCORS ?? !1,
  customIsSameOrigin: e.customIsSameOrigin,
  maxCacheSize: e.maxCacheSize
}), fV = (e, A, t) => ({
  logging: e.logging ?? !0,
  cache: e.cache ?? A.cache,
  ...t
}), dV = 800, gV = 600, nF = 0, pV = (e, A) => {
  const t = A;
  return {
    windowWidth: e.windowWidth ?? t.innerWidth ?? dV,
    windowHeight: e.windowHeight ?? t.innerHeight ?? gV,
    scrollX: e.scrollX ?? t.pageXOffset ?? nF,
    scrollY: e.scrollY ?? t.pageYOffset ?? nF
  };
}, BV = (e, A, t) => ({
  allowTaint: e.allowTaint ?? !1,
  onclone: e.onclone,
  ignoreElements: e.ignoreElements,
  iframeContainer: e.iframeContainer,
  inlineImages: t,
  copyStyles: t,
  cspNonce: e.cspNonce ?? A.cspNonce
}), wV = (e, A, t, r, n, i, s) => ({
  canvas: e.canvas,
  backgroundColor: A,
  signal: e.signal,
  scale: e.scale ?? s ?? 1,
  x: (e.x ?? 0) + t,
  y: (e.y ?? 0) + r,
  width: e.width ?? Math.ceil(n),
  height: e.height ?? Math.ceil(i),
  imageSmoothing: e.imageSmoothing,
  imageSmoothingQuality: e.imageSmoothingQuality
}), mV = (e, A, t) => {
  const r = A.ownerDocument, n = r.documentElement ? jc(e, getComputedStyle(r.documentElement).backgroundColor) : $s.TRANSPARENT, i = r.body ? jc(e, getComputedStyle(r.body).backgroundColor) : $s.TRANSPARENT, s = typeof t == "string" ? jc(e, t) : t === null ? $s.TRANSPARENT : 4294967295;
  return A === r.documentElement ? Sa(n) ? Sa(i) ? s : i : n : s;
}, vV = async (e, A, t) => {
  if (uV(A), !A.skipValidation) {
    const I = A.validator || NI(), q = I.validateElement(e);
    if (!q.valid) throw new Error(q.error);
    const U = I.validateOptions(A);
    if (!U.valid) throw new Error(`Invalid options: ${U.error}`);
  }
  if (!e || typeof e != "object") throw new Error("Invalid element provided as first argument");
  const r = e.ownerDocument;
  if (!r) throw new Error("Element is not attached to a Document");
  const n = r.defaultView;
  if (!n) throw new Error("Document is not attached to a Window");
  const i = fV(A, t, hV(A)), s = pV(A, n), a = new Hn(s.scrollX, s.scrollY, s.windowWidth, s.windowHeight), o = new cV(i, a, t), l = A.enablePerformanceMonitoring ?? A.logging ?? !1, c = new DI(o, l);
  c.start("total", {
    width: s.windowWidth,
    height: s.windowHeight
  });
  const u = A.signal;
  qi(u);
  const d = A.foreignObjectRendering ?? !1, h = BV(A, t, d);
  o.logger.debug(`Starting document clone with size ${a.width}x${a.height} scrolled to ${-a.left},${-a.top}`), c.start("clone");
  const p = new OB(o, e, h), B = p.clonedReferenceElement;
  if (!B) throw new Error("Unable to find element in cloned iframe");
  const y = await p.toIFrame(r, a);
  c.end("clone"), u?.aborted && ((A.removeContainer ?? !0) && OB.destroy(y), qi(u));
  const { width: m, height: C, left: Q, top: F } = Ty(B) || SP(B) ? IR(B.ownerDocument) : Nh(o, B), T = mV(o, B, A.backgroundColor), V = wV(A, T, Q, F, m, C, n.devicePixelRatio ?? 1);
  let M, D;
  try {
    d ? (o.logger.debug("Document cloned, using foreign object rendering"), c.start("render-foreignobject"), M = await new eV(o, V).render(B), c.end("render-foreignobject")) : (o.logger.debug(`Document cloned, element located at ${Q},${F} with size ${m}x${C} using computed rendering`), o.logger.debug("Starting DOM parsing"), c.start("parse"), qi(u), o.cache.startDefer(), D = PS(o, B), c.end("parse"), c.start("preload"), await o.cache.preloadAll(), c.end("preload"), T === D.styles.backgroundColor && (D.styles.backgroundColor = $s.TRANSPARENT), o.logger.debug(`Starting renderer for element at ${V.x},${V.y} with size ${V.width}x${V.height}`), c.start("render"), qi(u), M = await new J9(o, V).render(D), c.end("render"));
  } finally {
    c.start("cleanup");
    try {
      D && D.restoreTree();
    } finally {
      (A.removeContainer ?? !0) && OB.destroy(y), c.end("cleanup");
    }
  }
  return c.end("total"), o.logger.debug("Finished rendering"), l && c.logSummary(), M;
}, iF = (e, A = {}, t) => vV(e, A, t || _I.fromElement(e, {
  cspNonce: A.cspNonce,
  cache: A.cache
})), yV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Html2CanvasConfig: _I,
  PerformanceMonitor: DI,
  Validator: OI,
  createDefaultValidator: NI,
  default: iF,
  html2canvas: iF
}, Symbol.toStringTag, { value: "Module" }));
function it(e) {
  "@babel/helpers - typeof";
  return it = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
    return typeof A;
  } : function(A) {
    return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
  }, it(e);
}
var Cs = Uint8Array, xi = Uint16Array, Ry = Int32Array, My = new Cs([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), Py = new Cs([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), sF = new Cs([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), XS = function(e, A) {
  for (var t = new xi(31), r = 0; r < 31; ++r)
    t[r] = A += 1 << e[r - 1];
  for (var n = new Ry(t[30]), r = 1; r < 30; ++r)
    for (var i = t[r]; i < t[r + 1]; ++i)
      n[i] = i - t[r] << 5 | r;
  return { b: t, r: n };
}, YS = XS(My, 2), CV = YS.b, gv = YS.r;
CV[28] = 258, gv[258] = 28;
var bV = XS(Py, 0), aF = bV.r, pv = new xi(32768);
for (var Ot = 0; Ot < 32768; ++Ot) {
  var uo = (Ot & 43690) >> 1 | (Ot & 21845) << 1;
  uo = (uo & 52428) >> 2 | (uo & 13107) << 2, uo = (uo & 61680) >> 4 | (uo & 3855) << 4, pv[Ot] = ((uo & 65280) >> 8 | (uo & 255) << 8) >> 1;
}
var ph = (function(e, A, t) {
  for (var r = e.length, n = 0, i = new xi(A); n < r; ++n)
    e[n] && ++i[e[n] - 1];
  var s = new xi(A);
  for (n = 1; n < A; ++n)
    s[n] = s[n - 1] + i[n - 1] << 1;
  var a;
  if (t) {
    a = new xi(1 << A);
    var o = 15 - A;
    for (n = 0; n < r; ++n)
      if (e[n])
        for (var l = n << 4 | e[n], c = A - e[n], u = s[e[n] - 1]++ << c, d = u | (1 << c) - 1; u <= d; ++u)
          a[pv[u] >> o] = l;
  } else
    for (a = new xi(r), n = 0; n < r; ++n)
      e[n] && (a[n] = pv[s[e[n] - 1]++] >> 15 - e[n]);
  return a;
}), zl = new Cs(288);
for (var Ot = 0; Ot < 144; ++Ot)
  zl[Ot] = 8;
for (var Ot = 144; Ot < 256; ++Ot)
  zl[Ot] = 9;
for (var Ot = 256; Ot < 280; ++Ot)
  zl[Ot] = 7;
for (var Ot = 280; Ot < 288; ++Ot)
  zl[Ot] = 8;
var Ug = new Cs(32);
for (var Ot = 0; Ot < 32; ++Ot)
  Ug[Ot] = 5;
var FV = /* @__PURE__ */ ph(zl, 9, 0), QV = /* @__PURE__ */ ph(Ug, 5, 0), JS = function(e) {
  return (e + 7) / 8 | 0;
}, UV = function(e, A, t) {
  return (t == null || t > e.length) && (t = e.length), new Cs(e.subarray(A, t));
}, wa = function(e, A, t) {
  t <<= A & 7;
  var r = A / 8 | 0;
  e[r] |= t, e[r + 1] |= t >> 8;
}, Tu = function(e, A, t) {
  t <<= A & 7;
  var r = A / 8 | 0;
  e[r] |= t, e[r + 1] |= t >> 8, e[r + 2] |= t >> 16;
}, jB = function(e, A) {
  for (var t = [], r = 0; r < e.length; ++r)
    e[r] && t.push({ s: r, f: e[r] });
  var n = t.length, i = t.slice();
  if (!n)
    return { t: A3, l: 0 };
  if (n == 1) {
    var s = new Cs(t[0].s + 1);
    return s[t[0].s] = 1, { t: s, l: 1 };
  }
  t.sort(function(T, V) {
    return T.f - V.f;
  }), t.push({ s: -1, f: 25001 });
  var a = t[0], o = t[1], l = 0, c = 1, u = 2;
  for (t[0] = { s: -1, f: a.f + o.f, l: a, r: o }; c != n - 1; )
    a = t[t[l].f < t[u].f ? l++ : u++], o = t[l != c && t[l].f < t[u].f ? l++ : u++], t[c++] = { s: -1, f: a.f + o.f, l: a, r: o };
  for (var d = i[0].s, r = 1; r < n; ++r)
    i[r].s > d && (d = i[r].s);
  var h = new xi(d + 1), p = Bv(t[c - 1], h, 0);
  if (p > A) {
    var r = 0, B = 0, y = p - A, m = 1 << y;
    for (i.sort(function(V, M) {
      return h[M.s] - h[V.s] || V.f - M.f;
    }); r < n; ++r) {
      var C = i[r].s;
      if (h[C] > A)
        B += m - (1 << p - h[C]), h[C] = A;
      else
        break;
    }
    for (B >>= y; B > 0; ) {
      var Q = i[r].s;
      h[Q] < A ? B -= 1 << A - h[Q]++ - 1 : ++r;
    }
    for (; r >= 0 && B; --r) {
      var F = i[r].s;
      h[F] == A && (--h[F], ++B);
    }
    p = A;
  }
  return { t: new Cs(h), l: p };
}, Bv = function(e, A, t) {
  return e.s == -1 ? Math.max(Bv(e.l, A, t + 1), Bv(e.r, A, t + 1)) : A[e.s] = t;
}, oF = function(e) {
  for (var A = e.length; A && !e[--A]; )
    ;
  for (var t = new xi(++A), r = 0, n = e[0], i = 1, s = function(o) {
    t[r++] = o;
  }, a = 1; a <= A; ++a)
    if (e[a] == n && a != A)
      ++i;
    else {
      if (!n && i > 2) {
        for (; i > 138; i -= 138)
          s(32754);
        i > 2 && (s(i > 10 ? i - 11 << 5 | 28690 : i - 3 << 5 | 12305), i = 0);
      } else if (i > 3) {
        for (s(n), --i; i > 6; i -= 6)
          s(8304);
        i > 2 && (s(i - 3 << 5 | 8208), i = 0);
      }
      for (; i--; )
        s(n);
      i = 1, n = e[a];
    }
  return { c: t.subarray(0, r), n: A };
}, _u = function(e, A) {
  for (var t = 0, r = 0; r < A.length; ++r)
    t += e[r] * A[r];
  return t;
}, ZS = function(e, A, t) {
  var r = t.length, n = JS(A + 2);
  e[n] = r & 255, e[n + 1] = r >> 8, e[n + 2] = e[n] ^ 255, e[n + 3] = e[n + 1] ^ 255;
  for (var i = 0; i < r; ++i)
    e[n + i + 4] = t[i];
  return (n + 4 + r) * 8;
}, lF = function(e, A, t, r, n, i, s, a, o, l, c) {
  wa(A, c++, t), ++n[256];
  for (var u = jB(n, 15), d = u.t, h = u.l, p = jB(i, 15), B = p.t, y = p.l, m = oF(d), C = m.c, Q = m.n, F = oF(B), T = F.c, V = F.n, M = new xi(19), D = 0; D < C.length; ++D)
    ++M[C[D] & 31];
  for (var D = 0; D < T.length; ++D)
    ++M[T[D] & 31];
  for (var I = jB(M, 7), q = I.t, U = I.l, x = 19; x > 4 && !q[sF[x - 1]]; --x)
    ;
  var P = l + 5 << 3, N = _u(n, zl) + _u(i, Ug) + s, iA = _u(n, d) + _u(i, B) + s + 14 + 3 * x + _u(M, q) + 2 * M[16] + 3 * M[17] + 7 * M[18];
  if (o >= 0 && P <= N && P <= iA)
    return ZS(A, c, e.subarray(o, o + l));
  var nA, sA, tA, cA;
  if (wa(A, c, 1 + (iA < N)), c += 2, iA < N) {
    nA = ph(d, h, 0), sA = d, tA = ph(B, y, 0), cA = B;
    var FA = ph(q, U, 0);
    wa(A, c, Q - 257), wa(A, c + 5, V - 1), wa(A, c + 10, x - 4), c += 14;
    for (var D = 0; D < x; ++D)
      wa(A, c + 3 * D, q[sF[D]]);
    c += 3 * x;
    for (var CA = [C, T], S = 0; S < 2; ++S)
      for (var W = CA[S], D = 0; D < W.length; ++D) {
        var Y = W[D] & 31;
        wa(A, c, FA[Y]), c += q[Y], Y > 15 && (wa(A, c, W[D] >> 5 & 127), c += W[D] >> 12);
      }
  } else
    nA = FV, sA = zl, tA = QV, cA = Ug;
  for (var D = 0; D < a; ++D) {
    var AA = r[D];
    if (AA > 255) {
      var Y = AA >> 18 & 31;
      Tu(A, c, nA[Y + 257]), c += sA[Y + 257], Y > 7 && (wa(A, c, AA >> 23 & 31), c += My[Y]);
      var oA = AA & 31;
      Tu(A, c, tA[oA]), c += cA[oA], oA > 3 && (Tu(A, c, AA >> 5 & 8191), c += Py[oA]);
    } else
      Tu(A, c, nA[AA]), c += sA[AA];
  }
  return Tu(A, c, nA[256]), c + sA[256];
}, EV = /* @__PURE__ */ new Ry([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), A3 = /* @__PURE__ */ new Cs(0), xV = function(e, A, t, r, n, i) {
  var s = i.z || e.length, a = new Cs(r + s + 5 * (1 + Math.ceil(s / 7e3)) + n), o = a.subarray(r, a.length - n), l = i.l, c = (i.r || 0) & 7;
  if (A) {
    c && (o[0] = i.r >> 3);
    for (var u = EV[A - 1], d = u >> 13, h = u & 8191, p = (1 << t) - 1, B = i.p || new xi(32768), y = i.h || new xi(p + 1), m = Math.ceil(t / 3), C = 2 * m, Q = function(uA) {
      return (e[uA] ^ e[uA + 1] << m ^ e[uA + 2] << C) & p;
    }, F = new Ry(25e3), T = new xi(288), V = new xi(32), M = 0, D = 0, I = i.i || 0, q = 0, U = i.w || 0, x = 0; I + 2 < s; ++I) {
      var P = Q(I), N = I & 32767, iA = y[P];
      if (B[N] = iA, y[P] = N, U <= I) {
        var nA = s - I;
        if ((M > 7e3 || q > 24576) && (nA > 423 || !l)) {
          c = lF(e, o, 0, F, T, V, D, q, x, I - x, c), q = M = D = 0, x = I;
          for (var sA = 0; sA < 286; ++sA)
            T[sA] = 0;
          for (var sA = 0; sA < 30; ++sA)
            V[sA] = 0;
        }
        var tA = 2, cA = 0, FA = h, CA = N - iA & 32767;
        if (nA > 2 && P == Q(I - CA))
          for (var S = Math.min(d, nA) - 1, W = Math.min(32767, I), Y = Math.min(258, nA); CA <= W && --FA && N != iA; ) {
            if (e[I + tA] == e[I + tA - CA]) {
              for (var AA = 0; AA < Y && e[I + AA] == e[I + AA - CA]; ++AA)
                ;
              if (AA > tA) {
                if (tA = AA, cA = CA, AA > S)
                  break;
                for (var oA = Math.min(CA, AA - 2), gA = 0, sA = 0; sA < oA; ++sA) {
                  var xA = I - CA + sA & 32767, IA = B[xA], pA = xA - IA & 32767;
                  pA > gA && (gA = pA, iA = xA);
                }
              }
            }
            N = iA, iA = B[N], CA += N - iA & 32767;
          }
        if (cA) {
          F[q++] = 268435456 | gv[tA] << 18 | aF[cA];
          var WA = gv[tA] & 31, k = aF[cA] & 31;
          D += My[WA] + Py[k], ++T[257 + WA], ++V[k], U = I + tA, ++M;
        } else
          F[q++] = e[I], ++T[e[I]];
      }
    }
    for (I = Math.max(I, U); I < s; ++I)
      F[q++] = e[I], ++T[e[I]];
    c = lF(e, o, l, F, T, V, D, q, x, I - x, c), l || (i.r = c & 7 | o[c / 8 | 0] << 3, c -= 7, i.h = y, i.p = B, i.i = I, i.w = U);
  } else {
    for (var I = i.w || 0; I < s + l; I += 65535) {
      var X = I + 65535;
      X >= s && (o[c / 8 | 0] = l, X = s), c = ZS(o, c + 1, e.subarray(I, X));
    }
    i.i = s;
  }
  return UV(a, 0, r + JS(c) + n);
}, e3 = function() {
  var e = 1, A = 0;
  return {
    p: function(t) {
      for (var r = e, n = A, i = t.length | 0, s = 0; s != i; ) {
        for (var a = Math.min(s + 2655, i); s < a; ++s)
          n += r += t[s];
        r = (r & 65535) + 15 * (r >> 16), n = (n & 65535) + 15 * (n >> 16);
      }
      e = r, A = n;
    },
    d: function() {
      return e %= 65521, A %= 65521, (e & 255) << 24 | (e & 65280) << 8 | (A & 255) << 8 | A >> 8;
    }
  };
}, IV = function(e, A, t, r, n) {
  if (!n && (n = { l: 1 }, A.dictionary)) {
    var i = A.dictionary.subarray(-32768), s = new Cs(i.length + e.length);
    s.set(i), s.set(e, i.length), e = s, n.w = i.length;
  }
  return xV(e, A.level == null ? 6 : A.level, A.mem == null ? n.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(e.length))) * 1.5) : 20 : 12 + A.mem, t, r, n);
}, t3 = function(e, A, t) {
  for (; t; ++A)
    e[A] = t, t >>>= 8;
}, SV = function(e, A) {
  var t = A.level, r = t == 0 ? 0 : t < 6 ? 1 : t == 9 ? 3 : 2;
  if (e[0] = 120, e[1] = r << 6 | (A.dictionary && 32), e[1] |= 31 - (e[0] << 8 | e[1]) % 31, A.dictionary) {
    var n = e3();
    n.p(A.dictionary), t3(e, 2, n.d());
  }
};
function wv(e, A) {
  A || (A = {});
  var t = e3();
  t.p(e);
  var r = IV(e, A, A.dictionary ? 6 : 2, 4);
  return SV(r, A), t3(r, r.length - 4, t.d()), r;
}
var LV = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), HV = 0;
try {
  LV.decode(A3, { stream: !0 }), HV = 1;
} catch {
}
function TV(e) {
  if (Array.isArray(e)) return e;
}
function _V(e, A) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r, n, i, s, a = [], o = !0, l = !1;
    try {
      if (i = (t = t.call(e)).next, A !== 0) for (; !(o = (r = i.call(t)).done) && (a.push(r.value), a.length !== A); o = !0) ;
    } catch (c) {
      l = !0, n = c;
    } finally {
      try {
        if (!o && t.return != null && (s = t.return(), Object(s) !== s)) return;
      } finally {
        if (l) throw n;
      }
    }
    return a;
  }
}
function cF(e, A) {
  (A == null || A > e.length) && (A = e.length);
  for (var t = 0, r = Array(A); t < A; t++) r[t] = e[t];
  return r;
}
function OV(e, A) {
  if (e) {
    if (typeof e == "string") return cF(e, A);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? cF(e, A) : void 0;
  }
}
function NV() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uF(e, A) {
  return TV(e) || _V(e, A) || OV(e, A) || NV();
}
function hF(e, A = "utf8") {
  return new TextDecoder(A).decode(e);
}
const DV = new TextEncoder();
function RV(e) {
  return DV.encode(e);
}
const MV = 1024 * 8, PV = (() => {
  const e = new Uint8Array(4), A = new Uint32Array(e.buffer);
  return !((A[0] = 1) & e[0]);
})(), qB = {
  int8: globalThis.Int8Array,
  uint8: globalThis.Uint8Array,
  int16: globalThis.Int16Array,
  uint16: globalThis.Uint16Array,
  int32: globalThis.Int32Array,
  uint32: globalThis.Uint32Array,
  uint64: globalThis.BigUint64Array,
  int64: globalThis.BigInt64Array,
  float32: globalThis.Float32Array,
  float64: globalThis.Float64Array
};
class ky {
  /**
   * Reference to the internal ArrayBuffer object.
   */
  buffer;
  /**
   * Byte length of the internal ArrayBuffer.
   */
  byteLength;
  /**
   * Byte offset of the internal ArrayBuffer.
   */
  byteOffset;
  /**
   * Byte length of the internal ArrayBuffer.
   */
  length;
  /**
   * The current offset of the buffer's pointer.
   */
  offset;
  lastWrittenByte;
  littleEndian;
  _data;
  _mark;
  _marks;
  /**
   * Create a new IOBuffer.
   * @param data - The data to construct the IOBuffer with.
   * If data is a number, it will be the new buffer's length<br>
   * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
   * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
   * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
   * @param options - An object for the options.
   * @returns A new IOBuffer instance.
   */
  constructor(A = MV, t = {}) {
    let r = !1;
    typeof A == "number" ? A = new ArrayBuffer(A) : (r = !0, this.lastWrittenByte = A.byteLength);
    const n = t.offset ? t.offset >>> 0 : 0, i = A.byteLength - n;
    let s = n;
    (ArrayBuffer.isView(A) || A instanceof ky) && (A.byteLength !== A.buffer.byteLength && (s = A.byteOffset + n), A = A.buffer), r ? this.lastWrittenByte = i : this.lastWrittenByte = 0, this.buffer = A, this.length = i, this.byteLength = i, this.byteOffset = s, this.offset = 0, this.littleEndian = !0, this._data = new DataView(this.buffer, s, i), this._mark = 0, this._marks = [];
  }
  /**
   * Checks if the memory allocated to the buffer is sufficient to store more
   * bytes after the offset.
   * @param byteLength - The needed memory in bytes.
   * @returns `true` if there is sufficient space and `false` otherwise.
   */
  available(A = 1) {
    return this.offset + A <= this.length;
  }
  /**
   * Check if little-endian mode is used for reading and writing multi-byte
   * values.
   * @returns `true` if little-endian mode is used, `false` otherwise.
   */
  isLittleEndian() {
    return this.littleEndian;
  }
  /**
   * Set little-endian mode for reading and writing multi-byte values.
   * @returns This.
   */
  setLittleEndian() {
    return this.littleEndian = !0, this;
  }
  /**
   * Check if big-endian mode is used for reading and writing multi-byte values.
   * @returns `true` if big-endian mode is used, `false` otherwise.
   */
  isBigEndian() {
    return !this.littleEndian;
  }
  /**
   * Switches to big-endian mode for reading and writing multi-byte values.
   * @returns This.
   */
  setBigEndian() {
    return this.littleEndian = !1, this;
  }
  /**
   * Move the pointer n bytes forward.
   * @param n - Number of bytes to skip.
   * @returns This.
   */
  skip(A = 1) {
    return this.offset += A, this;
  }
  /**
   * Move the pointer n bytes backward.
   * @param n - Number of bytes to move back.
   * @returns This.
   */
  back(A = 1) {
    return this.offset -= A, this;
  }
  /**
   * Move the pointer to the given offset.
   * @param offset - The offset to move to.
   * @returns This.
   */
  seek(A) {
    return this.offset = A, this;
  }
  /**
   * Store the current pointer offset.
   * @see {@link IOBuffer#reset}
   * @returns This.
   */
  mark() {
    return this._mark = this.offset, this;
  }
  /**
   * Move the pointer back to the last pointer offset set by mark.
   * @see {@link IOBuffer#mark}
   * @returns This.
   */
  reset() {
    return this.offset = this._mark, this;
  }
  /**
   * Push the current pointer offset to the mark stack.
   * @see {@link IOBuffer#popMark}
   * @returns This.
   */
  pushMark() {
    return this._marks.push(this.offset), this;
  }
  /**
   * Pop the last pointer offset from the mark stack, and set the current
   * pointer offset to the popped value.
   * @see {@link IOBuffer#pushMark}
   * @returns This.
   */
  popMark() {
    const A = this._marks.pop();
    if (A === void 0)
      throw new Error("Mark stack empty");
    return this.seek(A), this;
  }
  /**
   * Move the pointer offset back to 0.
   * @returns This.
   */
  rewind() {
    return this.offset = 0, this;
  }
  /**
   * Make sure the buffer has sufficient memory to write a given byteLength at
   * the current pointer offset.
   * If the buffer's memory is insufficient, this method will create a new
   * buffer (a copy) with a length that is twice (byteLength + current offset).
   * @param byteLength - The needed memory in bytes.
   * @returns This.
   */
  ensureAvailable(A = 1) {
    if (!this.available(A)) {
      const r = (this.offset + A) * 2, n = new Uint8Array(r);
      n.set(new Uint8Array(this.buffer)), this.buffer = n.buffer, this.length = r, this.byteLength = r, this._data = new DataView(this.buffer);
    }
    return this;
  }
  /**
   * Read a byte and return false if the byte's value is 0, or true otherwise.
   * Moves pointer forward by one byte.
   * @returns The read boolean.
   */
  readBoolean() {
    return this.readUint8() !== 0;
  }
  /**
   * Read a signed 8-bit integer and move pointer forward by 1 byte.
   * @returns The read byte.
   */
  readInt8() {
    return this._data.getInt8(this.offset++);
  }
  /**
   * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
   * @returns The read byte.
   */
  readUint8() {
    return this._data.getUint8(this.offset++);
  }
  /**
   * Alias for {@link IOBuffer#readUint8}.
   * @returns The read byte.
   */
  readByte() {
    return this.readUint8();
  }
  /**
   * Read `n` bytes and move pointer forward by `n` bytes.
   * @param n - Number of bytes to read.
   * @returns The read bytes.
   */
  readBytes(A = 1) {
    return this.readArray(A, "uint8");
  }
  /**
   * Creates an array of corresponding to the type `type` and size `size`.
   * For example type `uint8` will create a `Uint8Array`.
   * @param size - size of the resulting array
   * @param type - number type of elements to read
   * @returns The read array.
   */
  readArray(A, t) {
    const r = qB[t].BYTES_PER_ELEMENT * A, n = this.byteOffset + this.offset, i = this.buffer.slice(n, n + r);
    if (this.littleEndian === PV && t !== "uint8" && t !== "int8") {
      const a = new Uint8Array(this.buffer.slice(n, n + r));
      a.reverse();
      const o = new qB[t](a.buffer);
      return this.offset += r, o.reverse(), o;
    }
    const s = new qB[t](i);
    return this.offset += r, s;
  }
  /**
   * Read a 16-bit signed integer and move pointer forward by 2 bytes.
   * @returns The read value.
   */
  readInt16() {
    const A = this._data.getInt16(this.offset, this.littleEndian);
    return this.offset += 2, A;
  }
  /**
   * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
   * @returns The read value.
   */
  readUint16() {
    const A = this._data.getUint16(this.offset, this.littleEndian);
    return this.offset += 2, A;
  }
  /**
   * Read a 32-bit signed integer and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readInt32() {
    const A = this._data.getInt32(this.offset, this.littleEndian);
    return this.offset += 4, A;
  }
  /**
   * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readUint32() {
    const A = this._data.getUint32(this.offset, this.littleEndian);
    return this.offset += 4, A;
  }
  /**
   * Read a 32-bit floating number and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readFloat32() {
    const A = this._data.getFloat32(this.offset, this.littleEndian);
    return this.offset += 4, A;
  }
  /**
   * Read a 64-bit floating number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readFloat64() {
    const A = this._data.getFloat64(this.offset, this.littleEndian);
    return this.offset += 8, A;
  }
  /**
   * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readBigInt64() {
    const A = this._data.getBigInt64(this.offset, this.littleEndian);
    return this.offset += 8, A;
  }
  /**
   * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readBigUint64() {
    const A = this._data.getBigUint64(this.offset, this.littleEndian);
    return this.offset += 8, A;
  }
  /**
   * Read a 1-byte ASCII character and move pointer forward by 1 byte.
   * @returns The read character.
   */
  readChar() {
    return String.fromCharCode(this.readInt8());
  }
  /**
   * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
   * @param n - Number of characters to read.
   * @returns The read characters.
   */
  readChars(A = 1) {
    let t = "";
    for (let r = 0; r < A; r++)
      t += this.readChar();
    return t;
  }
  /**
   * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
   * forward by `n` bytes.
   * @param n - Number of bytes to read.
   * @returns The decoded string.
   */
  readUtf8(A = 1) {
    return hF(this.readBytes(A));
  }
  /**
   * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
   * forward by `n` bytes.
   * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
   * @param n - Number of bytes to read.
   * @param encoding - The encoding to use. Default is 'utf8'.
   * @returns The decoded string.
   */
  decodeText(A = 1, t = "utf8") {
    return hF(this.readBytes(A), t);
  }
  /**
   * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
   * forward by 1 byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeBoolean(A) {
    return this.writeUint8(A ? 255 : 0), this;
  }
  /**
   * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt8(A) {
    return this.ensureAvailable(1), this._data.setInt8(this.offset++, A), this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
   * byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint8(A) {
    return this.ensureAvailable(1), this._data.setUint8(this.offset++, A), this._updateLastWrittenByte(), this;
  }
  /**
   * An alias for {@link IOBuffer#writeUint8}.
   * @param value - The value to write.
   * @returns This.
   */
  writeByte(A) {
    return this.writeUint8(A);
  }
  /**
   * Write all elements of `bytes` as uint8 values and move pointer forward by
   * `bytes.length` bytes.
   * @param bytes - The array of bytes to write.
   * @returns This.
   */
  writeBytes(A) {
    this.ensureAvailable(A.length);
    for (let t = 0; t < A.length; t++)
      this._data.setUint8(this.offset++, A[t]);
    return this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 16-bit signed integer and move pointer forward by 2
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt16(A) {
    return this.ensureAvailable(2), this._data.setInt16(this.offset, A, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint16(A) {
    return this.ensureAvailable(2), this._data.setUint16(this.offset, A, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit signed integer and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt32(A) {
    return this.ensureAvailable(4), this._data.setInt32(this.offset, A, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint32(A) {
    return this.ensureAvailable(4), this._data.setUint32(this.offset, A, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit floating number and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeFloat32(A) {
    return this.ensureAvailable(4), this._data.setFloat32(this.offset, A, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit floating number and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeFloat64(A) {
    return this.ensureAvailable(8), this._data.setFloat64(this.offset, A, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit signed bigint and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeBigInt64(A) {
    return this.ensureAvailable(8), this._data.setBigInt64(this.offset, A, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeBigUint64(A) {
    return this.ensureAvailable(8), this._data.setBigUint64(this.offset, A, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write the charCode of `str`'s first character as an 8-bit unsigned integer
   * and move pointer forward by 1 byte.
   * @param str - The character to write.
   * @returns This.
   */
  writeChar(A) {
    return this.writeUint8(A.charCodeAt(0));
  }
  /**
   * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
   * and move pointer forward by `str.length` bytes.
   * @param str - The characters to write.
   * @returns This.
   */
  writeChars(A) {
    for (let t = 0; t < A.length; t++)
      this.writeUint8(A.charCodeAt(t));
    return this;
  }
  /**
   * UTF-8 encode and write `str` to the current pointer offset and move pointer
   * forward according to the encoded length.
   * @param str - The string to write.
   * @returns This.
   */
  writeUtf8(A) {
    return this.writeBytes(RV(A));
  }
  /**
   * Export a Uint8Array view of the internal buffer.
   * The view starts at the byte offset and its length
   * is calculated to stop at the last written byte or the original length.
   * @returns A new Uint8Array view.
   */
  toArray() {
    return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
  }
  /**
   *  Get the total number of bytes written so far, regardless of the current offset.
   * @returns - Total number of bytes.
   */
  getWrittenByteLength() {
    return this.lastWrittenByte - this.byteOffset;
  }
  /**
   * Update the last written byte offset
   * @private
   */
  _updateLastWrittenByte() {
    this.offset > this.lastWrittenByte && (this.lastWrittenByte = this.offset);
  }
}
function ru(e) {
  let A = e.length;
  for (; --A >= 0; )
    e[A] = 0;
}
const kV = 3, KV = 258, r3 = 29, VV = 256, GV = VV + 1 + r3, n3 = 30, WV = 512, jV = new Array((GV + 2) * 2);
ru(jV);
const qV = new Array(n3 * 2);
ru(qV);
const $V = new Array(WV);
ru($V);
const zV = new Array(KV - kV + 1);
ru(zV);
const XV = new Array(r3);
ru(XV);
const YV = new Array(n3);
ru(YV);
const JV = (e, A, t, r) => {
  let n = e & 65535 | 0, i = e >>> 16 & 65535 | 0, s = 0;
  for (; t !== 0; ) {
    s = t > 2e3 ? 2e3 : t, t -= s;
    do
      n = n + A[r++] | 0, i = i + n | 0;
    while (--s);
    n %= 65521, i %= 65521;
  }
  return n | i << 16 | 0;
};
var mv = JV;
const ZV = () => {
  let e, A = [];
  for (var t = 0; t < 256; t++) {
    e = t;
    for (var r = 0; r < 8; r++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    A[t] = e;
  }
  return A;
}, AG = new Uint32Array(ZV()), eG = (e, A, t, r) => {
  const n = AG, i = r + t;
  e ^= -1;
  for (let s = r; s < i; s++)
    e = e >>> 8 ^ n[(e ^ A[s]) & 255];
  return e ^ -1;
};
var Ds = eG, vv = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, i3 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const tG = (e, A) => Object.prototype.hasOwnProperty.call(e, A);
var rG = function(e) {
  const A = Array.prototype.slice.call(arguments, 1);
  for (; A.length; ) {
    const t = A.shift();
    if (t) {
      if (typeof t != "object")
        throw new TypeError(t + "must be non-object");
      for (const r in t)
        tG(t, r) && (e[r] = t[r]);
    }
  }
  return e;
}, nG = (e) => {
  let A = 0;
  for (let r = 0, n = e.length; r < n; r++)
    A += e[r].length;
  const t = new Uint8Array(A);
  for (let r = 0, n = 0, i = e.length; r < i; r++) {
    let s = e[r];
    t.set(s, n), n += s.length;
  }
  return t;
}, s3 = {
  assign: rG,
  flattenChunks: nG
};
let a3 = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  a3 = !1;
}
const Kh = new Uint8Array(256);
for (let e = 0; e < 256; e++)
  Kh[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
Kh[254] = Kh[255] = 1;
var iG = (e) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(e);
  let A, t, r, n, i, s = e.length, a = 0;
  for (n = 0; n < s; n++)
    t = e.charCodeAt(n), (t & 64512) === 55296 && n + 1 < s && (r = e.charCodeAt(n + 1), (r & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (r - 56320), n++)), a += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
  for (A = new Uint8Array(a), i = 0, n = 0; i < a; n++)
    t = e.charCodeAt(n), (t & 64512) === 55296 && n + 1 < s && (r = e.charCodeAt(n + 1), (r & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (r - 56320), n++)), t < 128 ? A[i++] = t : t < 2048 ? (A[i++] = 192 | t >>> 6, A[i++] = 128 | t & 63) : t < 65536 ? (A[i++] = 224 | t >>> 12, A[i++] = 128 | t >>> 6 & 63, A[i++] = 128 | t & 63) : (A[i++] = 240 | t >>> 18, A[i++] = 128 | t >>> 12 & 63, A[i++] = 128 | t >>> 6 & 63, A[i++] = 128 | t & 63);
  return A;
};
const sG = (e, A) => {
  if (A < 65534 && e.subarray && a3)
    return String.fromCharCode.apply(null, e.length === A ? e : e.subarray(0, A));
  let t = "";
  for (let r = 0; r < A; r++)
    t += String.fromCharCode(e[r]);
  return t;
};
var aG = (e, A) => {
  const t = A || e.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(e.subarray(0, A));
  let r, n;
  const i = new Array(t * 2);
  for (n = 0, r = 0; r < t; ) {
    let s = e[r++];
    if (s < 128) {
      i[n++] = s;
      continue;
    }
    let a = Kh[s];
    if (a > 4) {
      i[n++] = 65533, r += a - 1;
      continue;
    }
    for (s &= a === 2 ? 31 : a === 3 ? 15 : 7; a > 1 && r < t; )
      s = s << 6 | e[r++] & 63, a--;
    if (a > 1) {
      i[n++] = 65533;
      continue;
    }
    s < 65536 ? i[n++] = s : (s -= 65536, i[n++] = 55296 | s >> 10 & 1023, i[n++] = 56320 | s & 1023);
  }
  return sG(i, n);
}, oG = (e, A) => {
  A = A || e.length, A > e.length && (A = e.length);
  let t = A - 1;
  for (; t >= 0 && (e[t] & 192) === 128; )
    t--;
  return t < 0 || t === 0 ? A : t + Kh[e[t]] > A ? t : A;
}, yv = {
  string2buf: iG,
  buf2string: aG,
  utf8border: oG
};
function lG() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var cG = lG;
const cd = 16209, uG = 16191;
var hG = function(A, t) {
  let r, n, i, s, a, o, l, c, u, d, h, p, B, y, m, C, Q, F, T, V, M, D, I, q;
  const U = A.state;
  r = A.next_in, I = A.input, n = r + (A.avail_in - 5), i = A.next_out, q = A.output, s = i - (t - A.avail_out), a = i + (A.avail_out - 257), o = U.dmax, l = U.wsize, c = U.whave, u = U.wnext, d = U.window, h = U.hold, p = U.bits, B = U.lencode, y = U.distcode, m = (1 << U.lenbits) - 1, C = (1 << U.distbits) - 1;
  A:
    do {
      p < 15 && (h += I[r++] << p, p += 8, h += I[r++] << p, p += 8), Q = B[h & m];
      e:
        for (; ; ) {
          if (F = Q >>> 24, h >>>= F, p -= F, F = Q >>> 16 & 255, F === 0)
            q[i++] = Q & 65535;
          else if (F & 16) {
            T = Q & 65535, F &= 15, F && (p < F && (h += I[r++] << p, p += 8), T += h & (1 << F) - 1, h >>>= F, p -= F), p < 15 && (h += I[r++] << p, p += 8, h += I[r++] << p, p += 8), Q = y[h & C];
            t:
              for (; ; ) {
                if (F = Q >>> 24, h >>>= F, p -= F, F = Q >>> 16 & 255, F & 16) {
                  if (V = Q & 65535, F &= 15, p < F && (h += I[r++] << p, p += 8, p < F && (h += I[r++] << p, p += 8)), V += h & (1 << F) - 1, V > o) {
                    A.msg = "invalid distance too far back", U.mode = cd;
                    break A;
                  }
                  if (h >>>= F, p -= F, F = i - s, V > F) {
                    if (F = V - F, F > c && U.sane) {
                      A.msg = "invalid distance too far back", U.mode = cd;
                      break A;
                    }
                    if (M = 0, D = d, u === 0) {
                      if (M += l - F, F < T) {
                        T -= F;
                        do
                          q[i++] = d[M++];
                        while (--F);
                        M = i - V, D = q;
                      }
                    } else if (u < F) {
                      if (M += l + u - F, F -= u, F < T) {
                        T -= F;
                        do
                          q[i++] = d[M++];
                        while (--F);
                        if (M = 0, u < T) {
                          F = u, T -= F;
                          do
                            q[i++] = d[M++];
                          while (--F);
                          M = i - V, D = q;
                        }
                      }
                    } else if (M += u - F, F < T) {
                      T -= F;
                      do
                        q[i++] = d[M++];
                      while (--F);
                      M = i - V, D = q;
                    }
                    for (; T > 2; )
                      q[i++] = D[M++], q[i++] = D[M++], q[i++] = D[M++], T -= 3;
                    T && (q[i++] = D[M++], T > 1 && (q[i++] = D[M++]));
                  } else {
                    M = i - V;
                    do
                      q[i++] = q[M++], q[i++] = q[M++], q[i++] = q[M++], T -= 3;
                    while (T > 2);
                    T && (q[i++] = q[M++], T > 1 && (q[i++] = q[M++]));
                  }
                } else if ((F & 64) === 0) {
                  Q = y[(Q & 65535) + (h & (1 << F) - 1)];
                  continue t;
                } else {
                  A.msg = "invalid distance code", U.mode = cd;
                  break A;
                }
                break;
              }
          } else if ((F & 64) === 0) {
            Q = B[(Q & 65535) + (h & (1 << F) - 1)];
            continue e;
          } else if (F & 32) {
            U.mode = uG;
            break A;
          } else {
            A.msg = "invalid literal/length code", U.mode = cd;
            break A;
          }
          break;
        }
    } while (r < n && i < a);
  T = p >> 3, r -= T, p -= T << 3, h &= (1 << p) - 1, A.next_in = r, A.next_out = i, A.avail_in = r < n ? 5 + (n - r) : 5 - (r - n), A.avail_out = i < a ? 257 + (a - i) : 257 - (i - a), U.hold = h, U.bits = p;
};
const Qc = 15, fF = 852, dF = 592, gF = 0, $B = 1, pF = 2, fG = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), dG = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  199,
  75
]), gG = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), pG = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), BG = (e, A, t, r, n, i, s, a) => {
  const o = a.bits;
  let l = 0, c = 0, u = 0, d = 0, h = 0, p = 0, B = 0, y = 0, m = 0, C = 0, Q, F, T, V, M, D = null, I;
  const q = new Uint16Array(Qc + 1), U = new Uint16Array(Qc + 1);
  let x = null, P, N, iA;
  for (l = 0; l <= Qc; l++)
    q[l] = 0;
  for (c = 0; c < r; c++)
    q[A[t + c]]++;
  for (h = o, d = Qc; d >= 1 && q[d] === 0; d--)
    ;
  if (h > d && (h = d), d === 0)
    return n[i++] = 1 << 24 | 64 << 16 | 0, n[i++] = 1 << 24 | 64 << 16 | 0, a.bits = 1, 0;
  for (u = 1; u < d && q[u] === 0; u++)
    ;
  for (h < u && (h = u), y = 1, l = 1; l <= Qc; l++)
    if (y <<= 1, y -= q[l], y < 0)
      return -1;
  if (y > 0 && (e === gF || d !== 1))
    return -1;
  for (U[1] = 0, l = 1; l < Qc; l++)
    U[l + 1] = U[l] + q[l];
  for (c = 0; c < r; c++)
    A[t + c] !== 0 && (s[U[A[t + c]]++] = c);
  if (e === gF ? (D = x = s, I = 20) : e === $B ? (D = fG, x = dG, I = 257) : (D = gG, x = pG, I = 0), C = 0, c = 0, l = u, M = i, p = h, B = 0, T = -1, m = 1 << h, V = m - 1, e === $B && m > fF || e === pF && m > dF)
    return 1;
  for (; ; ) {
    P = l - B, s[c] + 1 < I ? (N = 0, iA = s[c]) : s[c] >= I ? (N = x[s[c] - I], iA = D[s[c] - I]) : (N = 96, iA = 0), Q = 1 << l - B, F = 1 << p, u = F;
    do
      F -= Q, n[M + (C >> B) + F] = P << 24 | N << 16 | iA | 0;
    while (F !== 0);
    for (Q = 1 << l - 1; C & Q; )
      Q >>= 1;
    if (Q !== 0 ? (C &= Q - 1, C += Q) : C = 0, c++, --q[l] === 0) {
      if (l === d)
        break;
      l = A[t + s[c]];
    }
    if (l > h && (C & V) !== T) {
      for (B === 0 && (B = h), M += u, p = l - B, y = 1 << p; p + B < d && (y -= q[p + B], !(y <= 0)); )
        p++, y <<= 1;
      if (m += 1 << p, e === $B && m > fF || e === pF && m > dF)
        return 1;
      T = C & V, n[T] = h << 24 | p << 16 | M - i | 0;
    }
  }
  return C !== 0 && (n[M + C] = l - B << 24 | 64 << 16 | 0), a.bits = h, 0;
};
var Bh = BG;
const wG = 0, o3 = 1, l3 = 2, {
  Z_FINISH: BF,
  Z_BLOCK: mG,
  Z_TREES: ud,
  Z_OK: Xl,
  Z_STREAM_END: vG,
  Z_NEED_DICT: yG,
  Z_STREAM_ERROR: As,
  Z_DATA_ERROR: c3,
  Z_MEM_ERROR: u3,
  Z_BUF_ERROR: CG,
  Z_DEFLATED: wF
} = i3, fp = 16180, mF = 16181, vF = 16182, yF = 16183, CF = 16184, bF = 16185, FF = 16186, QF = 16187, UF = 16188, EF = 16189, Eg = 16190, ma = 16191, zB = 16192, xF = 16193, XB = 16194, IF = 16195, SF = 16196, LF = 16197, HF = 16198, hd = 16199, fd = 16200, TF = 16201, _F = 16202, OF = 16203, NF = 16204, DF = 16205, YB = 16206, RF = 16207, MF = 16208, Mt = 16209, h3 = 16210, f3 = 16211, bG = 852, FG = 592, QG = 15, UG = QG, PF = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
function EG() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const tc = (e) => {
  if (!e)
    return 1;
  const A = e.state;
  return !A || A.strm !== e || A.mode < fp || A.mode > f3 ? 1 : 0;
}, d3 = (e) => {
  if (tc(e))
    return As;
  const A = e.state;
  return e.total_in = e.total_out = A.total = 0, e.msg = "", A.wrap && (e.adler = A.wrap & 1), A.mode = fp, A.last = 0, A.havedict = 0, A.flags = -1, A.dmax = 32768, A.head = null, A.hold = 0, A.bits = 0, A.lencode = A.lendyn = new Int32Array(bG), A.distcode = A.distdyn = new Int32Array(FG), A.sane = 1, A.back = -1, Xl;
}, g3 = (e) => {
  if (tc(e))
    return As;
  const A = e.state;
  return A.wsize = 0, A.whave = 0, A.wnext = 0, d3(e);
}, p3 = (e, A) => {
  let t;
  if (tc(e))
    return As;
  const r = e.state;
  return A < 0 ? (t = 0, A = -A) : (t = (A >> 4) + 5, A < 48 && (A &= 15)), A && (A < 8 || A > 15) ? As : (r.window !== null && r.wbits !== A && (r.window = null), r.wrap = t, r.wbits = A, g3(e));
}, B3 = (e, A) => {
  if (!e)
    return As;
  const t = new EG();
  e.state = t, t.strm = e, t.window = null, t.mode = fp;
  const r = p3(e, A);
  return r !== Xl && (e.state = null), r;
}, xG = (e) => B3(e, UG);
let kF = !0, JB, ZB;
const IG = (e) => {
  if (kF) {
    JB = new Int32Array(512), ZB = new Int32Array(32);
    let A = 0;
    for (; A < 144; )
      e.lens[A++] = 8;
    for (; A < 256; )
      e.lens[A++] = 9;
    for (; A < 280; )
      e.lens[A++] = 7;
    for (; A < 288; )
      e.lens[A++] = 8;
    for (Bh(o3, e.lens, 0, 288, JB, 0, e.work, { bits: 9 }), A = 0; A < 32; )
      e.lens[A++] = 5;
    Bh(l3, e.lens, 0, 32, ZB, 0, e.work, { bits: 5 }), kF = !1;
  }
  e.lencode = JB, e.lenbits = 9, e.distcode = ZB, e.distbits = 5;
}, w3 = (e, A, t, r) => {
  let n;
  const i = e.state;
  return i.window === null && (i.window = new Uint8Array(1 << i.wbits)), i.wsize === 0 && (i.wsize = 1 << i.wbits, i.wnext = 0, i.whave = 0), r >= i.wsize ? (i.window.set(A.subarray(t - i.wsize, t), 0), i.wnext = 0, i.whave = i.wsize) : (n = i.wsize - i.wnext, n > r && (n = r), i.window.set(A.subarray(t - r, t - r + n), i.wnext), r -= n, r ? (i.window.set(A.subarray(t - r, t), 0), i.wnext = r, i.whave = i.wsize) : (i.wnext += n, i.wnext === i.wsize && (i.wnext = 0), i.whave < i.wsize && (i.whave += n))), 0;
}, SG = (e, A) => {
  let t, r, n, i, s, a, o, l, c, u, d, h, p, B, y = 0, m, C, Q, F, T, V, M, D;
  const I = new Uint8Array(4);
  let q, U;
  const x = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (tc(e) || !e.output || !e.input && e.avail_in !== 0)
    return As;
  t = e.state, t.mode === ma && (t.mode = zB), s = e.next_out, n = e.output, o = e.avail_out, i = e.next_in, r = e.input, a = e.avail_in, l = t.hold, c = t.bits, u = a, d = o, D = Xl;
  A:
    for (; ; )
      switch (t.mode) {
        case fp:
          if (t.wrap === 0) {
            t.mode = zB;
            break;
          }
          for (; c < 16; ) {
            if (a === 0)
              break A;
            a--, l += r[i++] << c, c += 8;
          }
          if (t.wrap & 2 && l === 35615) {
            t.wbits === 0 && (t.wbits = 15), t.check = 0, I[0] = l & 255, I[1] = l >>> 8 & 255, t.check = Ds(t.check, I, 2, 0), l = 0, c = 0, t.mode = mF;
            break;
          }
          if (t.head && (t.head.done = !1), !(t.wrap & 1) || /* check if zlib header allowed */
          (((l & 255) << 8) + (l >> 8)) % 31) {
            e.msg = "incorrect header check", t.mode = Mt;
            break;
          }
          if ((l & 15) !== wF) {
            e.msg = "unknown compression method", t.mode = Mt;
            break;
          }
          if (l >>>= 4, c -= 4, M = (l & 15) + 8, t.wbits === 0 && (t.wbits = M), M > 15 || M > t.wbits) {
            e.msg = "invalid window size", t.mode = Mt;
            break;
          }
          t.dmax = 1 << t.wbits, t.flags = 0, e.adler = t.check = 1, t.mode = l & 512 ? EF : ma, l = 0, c = 0;
          break;
        case mF:
          for (; c < 16; ) {
            if (a === 0)
              break A;
            a--, l += r[i++] << c, c += 8;
          }
          if (t.flags = l, (t.flags & 255) !== wF) {
            e.msg = "unknown compression method", t.mode = Mt;
            break;
          }
          if (t.flags & 57344) {
            e.msg = "unknown header flags set", t.mode = Mt;
            break;
          }
          t.head && (t.head.text = l >> 8 & 1), t.flags & 512 && t.wrap & 4 && (I[0] = l & 255, I[1] = l >>> 8 & 255, t.check = Ds(t.check, I, 2, 0)), l = 0, c = 0, t.mode = vF;
        /* falls through */
        case vF:
          for (; c < 32; ) {
            if (a === 0)
              break A;
            a--, l += r[i++] << c, c += 8;
          }
          t.head && (t.head.time = l), t.flags & 512 && t.wrap & 4 && (I[0] = l & 255, I[1] = l >>> 8 & 255, I[2] = l >>> 16 & 255, I[3] = l >>> 24 & 255, t.check = Ds(t.check, I, 4, 0)), l = 0, c = 0, t.mode = yF;
        /* falls through */
        case yF:
          for (; c < 16; ) {
            if (a === 0)
              break A;
            a--, l += r[i++] << c, c += 8;
          }
          t.head && (t.head.xflags = l & 255, t.head.os = l >> 8), t.flags & 512 && t.wrap & 4 && (I[0] = l & 255, I[1] = l >>> 8 & 255, t.check = Ds(t.check, I, 2, 0)), l = 0, c = 0, t.mode = CF;
        /* falls through */
        case CF:
          if (t.flags & 1024) {
            for (; c < 16; ) {
              if (a === 0)
                break A;
              a--, l += r[i++] << c, c += 8;
            }
            t.length = l, t.head && (t.head.extra_len = l), t.flags & 512 && t.wrap & 4 && (I[0] = l & 255, I[1] = l >>> 8 & 255, t.check = Ds(t.check, I, 2, 0)), l = 0, c = 0;
          } else t.head && (t.head.extra = null);
          t.mode = bF;
        /* falls through */
        case bF:
          if (t.flags & 1024 && (h = t.length, h > a && (h = a), h && (t.head && (M = t.head.extra_len - t.length, t.head.extra || (t.head.extra = new Uint8Array(t.head.extra_len)), t.head.extra.set(
            r.subarray(
              i,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              i + h
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            M
          )), t.flags & 512 && t.wrap & 4 && (t.check = Ds(t.check, r, h, i)), a -= h, i += h, t.length -= h), t.length))
            break A;
          t.length = 0, t.mode = FF;
        /* falls through */
        case FF:
          if (t.flags & 2048) {
            if (a === 0)
              break A;
            h = 0;
            do
              M = r[i + h++], t.head && M && t.length < 65536 && (t.head.name += String.fromCharCode(M));
            while (M && h < a);
            if (t.flags & 512 && t.wrap & 4 && (t.check = Ds(t.check, r, h, i)), a -= h, i += h, M)
              break A;
          } else t.head && (t.head.name = null);
          t.length = 0, t.mode = QF;
        /* falls through */
        case QF:
          if (t.flags & 4096) {
            if (a === 0)
              break A;
            h = 0;
            do
              M = r[i + h++], t.head && M && t.length < 65536 && (t.head.comment += String.fromCharCode(M));
            while (M && h < a);
            if (t.flags & 512 && t.wrap & 4 && (t.check = Ds(t.check, r, h, i)), a -= h, i += h, M)
              break A;
          } else t.head && (t.head.comment = null);
          t.mode = UF;
        /* falls through */
        case UF:
          if (t.flags & 512) {
            for (; c < 16; ) {
              if (a === 0)
                break A;
              a--, l += r[i++] << c, c += 8;
            }
            if (t.wrap & 4 && l !== (t.check & 65535)) {
              e.msg = "header crc mismatch", t.mode = Mt;
              break;
            }
            l = 0, c = 0;
          }
          t.head && (t.head.hcrc = t.flags >> 9 & 1, t.head.done = !0), e.adler = t.check = 0, t.mode = ma;
          break;
        case EF:
          for (; c < 32; ) {
            if (a === 0)
              break A;
            a--, l += r[i++] << c, c += 8;
          }
          e.adler = t.check = PF(l), l = 0, c = 0, t.mode = Eg;
        /* falls through */
        case Eg:
          if (t.havedict === 0)
            return e.next_out = s, e.avail_out = o, e.next_in = i, e.avail_in = a, t.hold = l, t.bits = c, yG;
          e.adler = t.check = 1, t.mode = ma;
        /* falls through */
        case ma:
          if (A === mG || A === ud)
            break A;
        /* falls through */
        case zB:
          if (t.last) {
            l >>>= c & 7, c -= c & 7, t.mode = YB;
            break;
          }
          for (; c < 3; ) {
            if (a === 0)
              break A;
            a--, l += r[i++] << c, c += 8;
          }
          switch (t.last = l & 1, l >>>= 1, c -= 1, l & 3) {
            case 0:
              t.mode = xF;
              break;
            case 1:
              if (IG(t), t.mode = hd, A === ud) {
                l >>>= 2, c -= 2;
                break A;
              }
              break;
            case 2:
              t.mode = SF;
              break;
            case 3:
              e.msg = "invalid block type", t.mode = Mt;
          }
          l >>>= 2, c -= 2;
          break;
        case xF:
          for (l >>>= c & 7, c -= c & 7; c < 32; ) {
            if (a === 0)
              break A;
            a--, l += r[i++] << c, c += 8;
          }
          if ((l & 65535) !== (l >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", t.mode = Mt;
            break;
          }
          if (t.length = l & 65535, l = 0, c = 0, t.mode = XB, A === ud)
            break A;
        /* falls through */
        case XB:
          t.mode = IF;
        /* falls through */
        case IF:
          if (h = t.length, h) {
            if (h > a && (h = a), h > o && (h = o), h === 0)
              break A;
            n.set(r.subarray(i, i + h), s), a -= h, i += h, o -= h, s += h, t.length -= h;
            break;
          }
          t.mode = ma;
          break;
        case SF:
          for (; c < 14; ) {
            if (a === 0)
              break A;
            a--, l += r[i++] << c, c += 8;
          }
          if (t.nlen = (l & 31) + 257, l >>>= 5, c -= 5, t.ndist = (l & 31) + 1, l >>>= 5, c -= 5, t.ncode = (l & 15) + 4, l >>>= 4, c -= 4, t.nlen > 286 || t.ndist > 30) {
            e.msg = "too many length or distance symbols", t.mode = Mt;
            break;
          }
          t.have = 0, t.mode = LF;
        /* falls through */
        case LF:
          for (; t.have < t.ncode; ) {
            for (; c < 3; ) {
              if (a === 0)
                break A;
              a--, l += r[i++] << c, c += 8;
            }
            t.lens[x[t.have++]] = l & 7, l >>>= 3, c -= 3;
          }
          for (; t.have < 19; )
            t.lens[x[t.have++]] = 0;
          if (t.lencode = t.lendyn, t.lenbits = 7, q = { bits: t.lenbits }, D = Bh(wG, t.lens, 0, 19, t.lencode, 0, t.work, q), t.lenbits = q.bits, D) {
            e.msg = "invalid code lengths set", t.mode = Mt;
            break;
          }
          t.have = 0, t.mode = HF;
        /* falls through */
        case HF:
          for (; t.have < t.nlen + t.ndist; ) {
            for (; y = t.lencode[l & (1 << t.lenbits) - 1], m = y >>> 24, C = y >>> 16 & 255, Q = y & 65535, !(m <= c); ) {
              if (a === 0)
                break A;
              a--, l += r[i++] << c, c += 8;
            }
            if (Q < 16)
              l >>>= m, c -= m, t.lens[t.have++] = Q;
            else {
              if (Q === 16) {
                for (U = m + 2; c < U; ) {
                  if (a === 0)
                    break A;
                  a--, l += r[i++] << c, c += 8;
                }
                if (l >>>= m, c -= m, t.have === 0) {
                  e.msg = "invalid bit length repeat", t.mode = Mt;
                  break;
                }
                M = t.lens[t.have - 1], h = 3 + (l & 3), l >>>= 2, c -= 2;
              } else if (Q === 17) {
                for (U = m + 3; c < U; ) {
                  if (a === 0)
                    break A;
                  a--, l += r[i++] << c, c += 8;
                }
                l >>>= m, c -= m, M = 0, h = 3 + (l & 7), l >>>= 3, c -= 3;
              } else {
                for (U = m + 7; c < U; ) {
                  if (a === 0)
                    break A;
                  a--, l += r[i++] << c, c += 8;
                }
                l >>>= m, c -= m, M = 0, h = 11 + (l & 127), l >>>= 7, c -= 7;
              }
              if (t.have + h > t.nlen + t.ndist) {
                e.msg = "invalid bit length repeat", t.mode = Mt;
                break;
              }
              for (; h--; )
                t.lens[t.have++] = M;
            }
          }
          if (t.mode === Mt)
            break;
          if (t.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", t.mode = Mt;
            break;
          }
          if (t.lenbits = 9, q = { bits: t.lenbits }, D = Bh(o3, t.lens, 0, t.nlen, t.lencode, 0, t.work, q), t.lenbits = q.bits, D) {
            e.msg = "invalid literal/lengths set", t.mode = Mt;
            break;
          }
          if (t.distbits = 6, t.distcode = t.distdyn, q = { bits: t.distbits }, D = Bh(l3, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, q), t.distbits = q.bits, D) {
            e.msg = "invalid distances set", t.mode = Mt;
            break;
          }
          if (t.mode = hd, A === ud)
            break A;
        /* falls through */
        case hd:
          t.mode = fd;
        /* falls through */
        case fd:
          if (a >= 6 && o >= 258) {
            e.next_out = s, e.avail_out = o, e.next_in = i, e.avail_in = a, t.hold = l, t.bits = c, hG(e, d), s = e.next_out, n = e.output, o = e.avail_out, i = e.next_in, r = e.input, a = e.avail_in, l = t.hold, c = t.bits, t.mode === ma && (t.back = -1);
            break;
          }
          for (t.back = 0; y = t.lencode[l & (1 << t.lenbits) - 1], m = y >>> 24, C = y >>> 16 & 255, Q = y & 65535, !(m <= c); ) {
            if (a === 0)
              break A;
            a--, l += r[i++] << c, c += 8;
          }
          if (C && (C & 240) === 0) {
            for (F = m, T = C, V = Q; y = t.lencode[V + ((l & (1 << F + T) - 1) >> F)], m = y >>> 24, C = y >>> 16 & 255, Q = y & 65535, !(F + m <= c); ) {
              if (a === 0)
                break A;
              a--, l += r[i++] << c, c += 8;
            }
            l >>>= F, c -= F, t.back += F;
          }
          if (l >>>= m, c -= m, t.back += m, t.length = Q, C === 0) {
            t.mode = DF;
            break;
          }
          if (C & 32) {
            t.back = -1, t.mode = ma;
            break;
          }
          if (C & 64) {
            e.msg = "invalid literal/length code", t.mode = Mt;
            break;
          }
          t.extra = C & 15, t.mode = TF;
        /* falls through */
        case TF:
          if (t.extra) {
            for (U = t.extra; c < U; ) {
              if (a === 0)
                break A;
              a--, l += r[i++] << c, c += 8;
            }
            t.length += l & (1 << t.extra) - 1, l >>>= t.extra, c -= t.extra, t.back += t.extra;
          }
          t.was = t.length, t.mode = _F;
        /* falls through */
        case _F:
          for (; y = t.distcode[l & (1 << t.distbits) - 1], m = y >>> 24, C = y >>> 16 & 255, Q = y & 65535, !(m <= c); ) {
            if (a === 0)
              break A;
            a--, l += r[i++] << c, c += 8;
          }
          if ((C & 240) === 0) {
            for (F = m, T = C, V = Q; y = t.distcode[V + ((l & (1 << F + T) - 1) >> F)], m = y >>> 24, C = y >>> 16 & 255, Q = y & 65535, !(F + m <= c); ) {
              if (a === 0)
                break A;
              a--, l += r[i++] << c, c += 8;
            }
            l >>>= F, c -= F, t.back += F;
          }
          if (l >>>= m, c -= m, t.back += m, C & 64) {
            e.msg = "invalid distance code", t.mode = Mt;
            break;
          }
          t.offset = Q, t.extra = C & 15, t.mode = OF;
        /* falls through */
        case OF:
          if (t.extra) {
            for (U = t.extra; c < U; ) {
              if (a === 0)
                break A;
              a--, l += r[i++] << c, c += 8;
            }
            t.offset += l & (1 << t.extra) - 1, l >>>= t.extra, c -= t.extra, t.back += t.extra;
          }
          if (t.offset > t.dmax) {
            e.msg = "invalid distance too far back", t.mode = Mt;
            break;
          }
          t.mode = NF;
        /* falls through */
        case NF:
          if (o === 0)
            break A;
          if (h = d - o, t.offset > h) {
            if (h = t.offset - h, h > t.whave && t.sane) {
              e.msg = "invalid distance too far back", t.mode = Mt;
              break;
            }
            h > t.wnext ? (h -= t.wnext, p = t.wsize - h) : p = t.wnext - h, h > t.length && (h = t.length), B = t.window;
          } else
            B = n, p = s - t.offset, h = t.length;
          h > o && (h = o), o -= h, t.length -= h;
          do
            n[s++] = B[p++];
          while (--h);
          t.length === 0 && (t.mode = fd);
          break;
        case DF:
          if (o === 0)
            break A;
          n[s++] = t.length, o--, t.mode = fd;
          break;
        case YB:
          if (t.wrap) {
            for (; c < 32; ) {
              if (a === 0)
                break A;
              a--, l |= r[i++] << c, c += 8;
            }
            if (d -= o, e.total_out += d, t.total += d, t.wrap & 4 && d && (e.adler = t.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            t.flags ? Ds(t.check, n, d, s - d) : mv(t.check, n, d, s - d)), d = o, t.wrap & 4 && (t.flags ? l : PF(l)) !== t.check) {
              e.msg = "incorrect data check", t.mode = Mt;
              break;
            }
            l = 0, c = 0;
          }
          t.mode = RF;
        /* falls through */
        case RF:
          if (t.wrap && t.flags) {
            for (; c < 32; ) {
              if (a === 0)
                break A;
              a--, l += r[i++] << c, c += 8;
            }
            if (t.wrap & 4 && l !== (t.total & 4294967295)) {
              e.msg = "incorrect length check", t.mode = Mt;
              break;
            }
            l = 0, c = 0;
          }
          t.mode = MF;
        /* falls through */
        case MF:
          D = vG;
          break A;
        case Mt:
          D = c3;
          break A;
        case h3:
          return u3;
        case f3:
        /* falls through */
        default:
          return As;
      }
  return e.next_out = s, e.avail_out = o, e.next_in = i, e.avail_in = a, t.hold = l, t.bits = c, (t.wsize || d !== e.avail_out && t.mode < Mt && (t.mode < YB || A !== BF)) && w3(e, e.output, e.next_out, d - e.avail_out), u -= e.avail_in, d -= e.avail_out, e.total_in += u, e.total_out += d, t.total += d, t.wrap & 4 && d && (e.adler = t.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  t.flags ? Ds(t.check, n, d, e.next_out - d) : mv(t.check, n, d, e.next_out - d)), e.data_type = t.bits + (t.last ? 64 : 0) + (t.mode === ma ? 128 : 0) + (t.mode === hd || t.mode === XB ? 256 : 0), (u === 0 && d === 0 || A === BF) && D === Xl && (D = CG), D;
}, LG = (e) => {
  if (tc(e))
    return As;
  let A = e.state;
  return A.window && (A.window = null), e.state = null, Xl;
}, HG = (e, A) => {
  if (tc(e))
    return As;
  const t = e.state;
  return (t.wrap & 2) === 0 ? As : (t.head = A, A.done = !1, Xl);
}, TG = (e, A) => {
  const t = A.length;
  let r, n, i;
  return tc(e) || (r = e.state, r.wrap !== 0 && r.mode !== Eg) ? As : r.mode === Eg && (n = 1, n = mv(n, A, t, 0), n !== r.check) ? c3 : (i = w3(e, A, t, t), i ? (r.mode = h3, u3) : (r.havedict = 1, Xl));
};
var _G = g3, OG = p3, NG = d3, DG = xG, RG = B3, MG = SG, PG = LG, kG = HG, KG = TG, VG = "pako inflate (from Nodeca project)", Ks = {
  inflateReset: _G,
  inflateReset2: OG,
  inflateResetKeep: NG,
  inflateInit: DG,
  inflateInit2: RG,
  inflate: MG,
  inflateEnd: PG,
  inflateGetHeader: kG,
  inflateSetDictionary: KG,
  inflateInfo: VG
};
function GG() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var WG = GG;
const m3 = Object.prototype.toString, {
  Z_NO_FLUSH: jG,
  Z_FINISH: KF,
  Z_OK: $c,
  Z_STREAM_END: Aw,
  Z_NEED_DICT: ew,
  Z_STREAM_ERROR: qG,
  Z_DATA_ERROR: VF,
  Z_MEM_ERROR: $G,
  Z_BUF_ERROR: GF
} = i3, zG = {
  chunkSize: 1024 * 64,
  windowBits: 15,
  to: ""
};
function Jh(e) {
  this.options = s3.assign({}, zG, e || {});
  const A = this.options;
  A.raw && A.windowBits >= 0 && A.windowBits < 16 && (A.windowBits = -A.windowBits, A.windowBits === 0 && (A.windowBits = -15)), A.windowBits >= 0 && A.windowBits < 16 && !(e && e.windowBits) && (A.windowBits += 32), A.windowBits > 15 && A.windowBits < 48 && (A.windowBits & 15) === 0 && (A.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new cG(), this.strm.avail_out = 0;
  let t = Ks.inflateInit2(
    this.strm,
    A.windowBits
  );
  if (t !== $c)
    throw new Error(vv[t]);
  if (this.header = new WG(), Ks.inflateGetHeader(this.strm, this.header), A.dictionary && (typeof A.dictionary == "string" ? A.dictionary = yv.string2buf(A.dictionary) : m3.call(A.dictionary) === "[object ArrayBuffer]" && (A.dictionary = new Uint8Array(A.dictionary)), A.raw && (t = Ks.inflateSetDictionary(this.strm, A.dictionary), t !== $c)))
    throw new Error(vv[t]);
}
Jh.prototype.push = function(e, A) {
  const t = this.strm, r = this.options.chunkSize, n = this.options.dictionary;
  let i, s, a;
  if (this.ended) return !1;
  for (A === ~~A ? s = A : s = A === !0 ? KF : jG, m3.call(e) === "[object ArrayBuffer]" ? t.input = new Uint8Array(e) : t.input = e, t.next_in = 0, t.avail_in = t.input.length; ; ) {
    for (t.avail_out === 0 && (t.output = new Uint8Array(r), t.next_out = 0, t.avail_out = r), i = Ks.inflate(t, s), i === ew && n && (i = Ks.inflateSetDictionary(t, n), i === $c ? i = Ks.inflate(t, s) : i === VF && (i = ew)); t.avail_in > 0 && i === Aw && t.state.wrap & 2 && t.state.flags !== 0 && t.input[t.next_in] !== 0; )
      Ks.inflateReset(t), i = Ks.inflate(t, s);
    switch (i) {
      case qG:
      case VF:
      case ew:
      case $G:
        return this.onEnd(i), this.ended = !0, !1;
    }
    if (a = t.avail_out, t.next_out && (t.avail_out === 0 || i === Aw || s > 0))
      if (this.options.to === "string") {
        let o = yv.utf8border(t.output, t.next_out), l = t.next_out - o, c = yv.buf2string(t.output, o);
        t.next_out = l, t.avail_out = r - l, l && t.output.set(t.output.subarray(o, o + l), 0), this.onData(c);
      } else
        this.onData(t.output.length === t.next_out ? t.output : t.output.subarray(0, t.next_out)), t.avail_out = 0, t.next_out = 0;
    if (!((i === $c || i === GF) && a === 0)) {
      if (i === Aw)
        return i = Ks.inflateEnd(this.strm), this.onEnd(i), this.ended = !0, !0;
      if (t.avail_in === 0) {
        if (s === KF)
          return i = Ks.inflateEnd(this.strm), this.onEnd(i === $c ? GF : i), this.ended = !0, !1;
        break;
      }
    }
  }
  return !0;
};
Jh.prototype.onData = function(e) {
  this.chunks.push(e);
};
Jh.prototype.onEnd = function(e) {
  e === $c && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = s3.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function XG(e, A) {
  const t = new Jh(A);
  if (t.push(e, !0), t.err) throw t.msg || vv[t.err];
  return t.result;
}
var YG = Jh, JG = XG, ZG = {
  Inflate: YG,
  inflate: JG
};
const { Inflate: AW, inflate: eW } = ZG;
var WF = AW, tW = eW;
const v3 = [];
for (let e = 0; e < 256; e++) {
  let A = e;
  for (let t = 0; t < 8; t++)
    A & 1 ? A = 3988292384 ^ A >>> 1 : A = A >>> 1;
  v3[e] = A;
}
const jF = 4294967295;
function rW(e, A, t) {
  let r = e;
  for (let n = 0; n < t; n++)
    r = v3[(r ^ A[n]) & 255] ^ r >>> 8;
  return r;
}
function nW(e, A) {
  return (rW(jF, e, A) ^ jF) >>> 0;
}
function qF(e, A, t) {
  const r = e.readUint32(), n = nW(new Uint8Array(e.buffer, e.byteOffset + e.offset - A - 4, A), A);
  if (n !== r)
    throw new Error(`CRC mismatch for chunk ${t}. Expected ${r}, found ${n}`);
}
function y3(e, A, t) {
  for (let r = 0; r < t; r++)
    A[r] = e[r];
}
function C3(e, A, t, r) {
  let n = 0;
  for (; n < r; n++)
    A[n] = e[n];
  for (; n < t; n++)
    A[n] = e[n] + A[n - r] & 255;
}
function b3(e, A, t, r) {
  let n = 0;
  if (t.length === 0)
    for (; n < r; n++)
      A[n] = e[n];
  else
    for (; n < r; n++)
      A[n] = e[n] + t[n] & 255;
}
function F3(e, A, t, r, n) {
  let i = 0;
  if (t.length === 0) {
    for (; i < n; i++)
      A[i] = e[i];
    for (; i < r; i++)
      A[i] = e[i] + (A[i - n] >> 1) & 255;
  } else {
    for (; i < n; i++)
      A[i] = e[i] + (t[i] >> 1) & 255;
    for (; i < r; i++)
      A[i] = e[i] + (A[i - n] + t[i] >> 1) & 255;
  }
}
function Q3(e, A, t, r, n) {
  let i = 0;
  if (t.length === 0) {
    for (; i < n; i++)
      A[i] = e[i];
    for (; i < r; i++)
      A[i] = e[i] + A[i - n] & 255;
  } else {
    for (; i < n; i++)
      A[i] = e[i] + t[i] & 255;
    for (; i < r; i++)
      A[i] = e[i] + iW(A[i - n], t[i], t[i - n]) & 255;
  }
}
function iW(e, A, t) {
  const r = e + A - t, n = Math.abs(r - e), i = Math.abs(r - A), s = Math.abs(r - t);
  return n <= i && n <= s ? e : i <= s ? A : t;
}
function sW(e, A, t, r, n, i) {
  switch (e) {
    case 0:
      y3(A, t, n);
      break;
    case 1:
      C3(A, t, n, i);
      break;
    case 2:
      b3(A, t, r, n);
      break;
    case 3:
      F3(A, t, r, n, i);
      break;
    case 4:
      Q3(A, t, r, n, i);
      break;
    default:
      throw new Error(`Unsupported filter: ${e}`);
  }
}
const aW = new Uint16Array([255]), oW = new Uint8Array(aW.buffer), lW = oW[0] === 255;
function cW(e) {
  const { data: A, width: t, height: r, channels: n, depth: i } = e, s = [
    { x: 0, y: 0, xStep: 8, yStep: 8 },
    // Pass 1
    { x: 4, y: 0, xStep: 8, yStep: 8 },
    // Pass 2
    { x: 0, y: 4, xStep: 4, yStep: 8 },
    // Pass 3
    { x: 2, y: 0, xStep: 4, yStep: 4 },
    // Pass 4
    { x: 0, y: 2, xStep: 2, yStep: 4 },
    // Pass 5
    { x: 1, y: 0, xStep: 2, yStep: 2 },
    // Pass 6
    { x: 0, y: 1, xStep: 1, yStep: 2 }
    // Pass 7
  ], a = Math.ceil(i / 8) * n, o = new Uint8Array(r * t * a);
  let l = 0;
  for (let c = 0; c < 7; c++) {
    const u = s[c], d = Math.ceil((t - u.x) / u.xStep), h = Math.ceil((r - u.y) / u.yStep);
    if (d <= 0 || h <= 0)
      continue;
    const p = d * a, B = new Uint8Array(p);
    for (let y = 0; y < h; y++) {
      const m = A[l++], C = A.subarray(l, l + p);
      l += p;
      const Q = new Uint8Array(p);
      sW(m, C, Q, B, p, a), B.set(Q);
      for (let F = 0; F < d; F++) {
        const T = u.x + F * u.xStep, V = u.y + y * u.yStep;
        if (!(T >= t || V >= r))
          for (let M = 0; M < a; M++)
            o[(V * t + T) * a + M] = Q[F * a + M];
      }
    }
  }
  if (i === 16) {
    const c = new Uint16Array(o.buffer);
    if (lW)
      for (let u = 0; u < c.length; u++)
        c[u] = uW(c[u]);
    return c;
  } else
    return o;
}
function uW(e) {
  return (e & 255) << 8 | e >> 8 & 255;
}
const hW = new Uint16Array([255]), fW = new Uint8Array(hW.buffer), dW = fW[0] === 255, gW = new Uint8Array(0);
function $F(e) {
  const { data: A, width: t, height: r, channels: n, depth: i } = e, s = Math.ceil(i / 8) * n, a = Math.ceil(i / 8 * n * t), o = new Uint8Array(r * a);
  let l = gW, c = 0, u, d;
  for (let h = 0; h < r; h++) {
    switch (u = A.subarray(c + 1, c + 1 + a), d = o.subarray(h * a, (h + 1) * a), A[c]) {
      case 0:
        y3(u, d, a);
        break;
      case 1:
        C3(u, d, a, s);
        break;
      case 2:
        b3(u, d, l, a);
        break;
      case 3:
        F3(u, d, l, a, s);
        break;
      case 4:
        Q3(u, d, l, a, s);
        break;
      default:
        throw new Error(`Unsupported filter: ${A[c]}`);
    }
    l = d, c += a + 1;
  }
  if (i === 16) {
    const h = new Uint16Array(o.buffer);
    if (dW)
      for (let p = 0; p < h.length; p++)
        h[p] = pW(h[p]);
    return h;
  } else
    return o;
}
function pW(e) {
  return (e & 255) << 8 | e >> 8 & 255;
}
const Yd = Uint8Array.of(137, 80, 78, 71, 13, 10, 26, 10);
function zF(e) {
  if (!BW(e.readBytes(Yd.length)))
    throw new Error("wrong PNG signature");
}
function BW(e) {
  if (e.length < Yd.length)
    return !1;
  for (let A = 0; A < Yd.length; A++)
    if (e[A] !== Yd[A])
      return !1;
  return !0;
}
const wW = "tEXt", mW = 0, U3 = new TextDecoder("latin1");
function vW(e) {
  if (CW(e), e.length === 0 || e.length > 79)
    throw new Error("keyword length must be between 1 and 79");
}
const yW = /^[\u0000-\u00FF]*$/;
function CW(e) {
  if (!yW.test(e))
    throw new Error("invalid latin1 text");
}
function bW(e, A, t) {
  const r = E3(A);
  e[r] = FW(A, t - r.length - 1);
}
function E3(e) {
  for (e.mark(); e.readByte() !== mW; )
    ;
  const A = e.offset;
  e.reset();
  const t = U3.decode(e.readBytes(A - e.offset - 1));
  return e.skip(1), vW(t), t;
}
function FW(e, A) {
  return U3.decode(e.readBytes(A));
}
const vi = {
  UNKNOWN: -1,
  GREYSCALE: 0,
  TRUECOLOUR: 2,
  INDEXED_COLOUR: 3,
  GREYSCALE_ALPHA: 4,
  TRUECOLOUR_ALPHA: 6
}, tw = {
  UNKNOWN: -1,
  DEFLATE: 0
}, XF = {
  UNKNOWN: -1,
  ADAPTIVE: 0
}, rw = {
  UNKNOWN: -1,
  NO_INTERLACE: 0,
  ADAM7: 1
}, dd = {
  NONE: 0,
  BACKGROUND: 1,
  PREVIOUS: 2
}, nw = {
  SOURCE: 0,
  OVER: 1
};
class QW extends ky {
  _checkCrc;
  _inflator;
  _png;
  _apng;
  _end;
  _hasPalette;
  _palette;
  _hasTransparency;
  _transparency;
  _compressionMethod;
  _filterMethod;
  _interlaceMethod;
  _colorType;
  _isAnimated;
  _numberOfFrames;
  _numberOfPlays;
  _frames;
  _writingDataChunks;
  constructor(A, t = {}) {
    super(A);
    const { checkCrc: r = !1 } = t;
    this._checkCrc = r, this._inflator = new WF(), this._png = {
      width: -1,
      height: -1,
      channels: -1,
      data: new Uint8Array(0),
      depth: 1,
      text: {}
    }, this._apng = {
      width: -1,
      height: -1,
      channels: -1,
      depth: 1,
      numberOfFrames: 1,
      numberOfPlays: 0,
      text: {},
      frames: []
    }, this._end = !1, this._hasPalette = !1, this._palette = [], this._hasTransparency = !1, this._transparency = new Uint16Array(0), this._compressionMethod = tw.UNKNOWN, this._filterMethod = XF.UNKNOWN, this._interlaceMethod = rw.UNKNOWN, this._colorType = vi.UNKNOWN, this._isAnimated = !1, this._numberOfFrames = 1, this._numberOfPlays = 0, this._frames = [], this._writingDataChunks = !1, this.setBigEndian();
  }
  decode() {
    for (zF(this); !this._end; ) {
      const A = this.readUint32(), t = this.readChars(4);
      this.decodeChunk(A, t);
    }
    return this.decodeImage(), this._png;
  }
  decodeApng() {
    for (zF(this); !this._end; ) {
      const A = this.readUint32(), t = this.readChars(4);
      this.decodeApngChunk(A, t);
    }
    return this.decodeApngImage(), this._apng;
  }
  // https://www.w3.org/TR/PNG/#5Chunk-layout
  decodeChunk(A, t) {
    const r = this.offset;
    switch (t) {
      // 11.2 Critical chunks
      case "IHDR":
        this.decodeIHDR();
        break;
      case "PLTE":
        this.decodePLTE(A);
        break;
      case "IDAT":
        this.decodeIDAT(A);
        break;
      case "IEND":
        this._end = !0;
        break;
      // 11.3 Ancillary chunks
      case "tRNS":
        this.decodetRNS(A);
        break;
      case "iCCP":
        this.decodeiCCP(A);
        break;
      case wW:
        bW(this._png.text, this, A);
        break;
      case "pHYs":
        this.decodepHYs();
        break;
      default:
        this.skip(A);
        break;
    }
    if (this.offset - r !== A)
      throw new Error(`Length mismatch while decoding chunk ${t}`);
    this._checkCrc ? qF(this, A + 4, t) : this.skip(4);
  }
  decodeApngChunk(A, t) {
    const r = this.offset;
    switch (t !== "fdAT" && t !== "IDAT" && this._writingDataChunks && this.pushDataToFrame(), t) {
      case "acTL":
        this.decodeACTL();
        break;
      case "fcTL":
        this.decodeFCTL();
        break;
      case "fdAT":
        this.decodeFDAT(A);
        break;
      default:
        this.decodeChunk(A, t), this.offset = r + A;
        break;
    }
    if (this.offset - r !== A)
      throw new Error(`Length mismatch while decoding chunk ${t}`);
    this._checkCrc ? qF(this, A + 4, t) : this.skip(4);
  }
  // https://www.w3.org/TR/PNG/#11IHDR
  decodeIHDR() {
    const A = this._png;
    A.width = this.readUint32(), A.height = this.readUint32(), A.depth = UW(this.readUint8());
    const t = this.readUint8();
    this._colorType = t;
    let r;
    switch (t) {
      case vi.GREYSCALE:
        r = 1;
        break;
      case vi.TRUECOLOUR:
        r = 3;
        break;
      case vi.INDEXED_COLOUR:
        r = 1;
        break;
      case vi.GREYSCALE_ALPHA:
        r = 2;
        break;
      case vi.TRUECOLOUR_ALPHA:
        r = 4;
        break;
      // Kept for exhaustiveness.
      // eslint-disable-next-line unicorn/no-useless-switch-case
      case vi.UNKNOWN:
      default:
        throw new Error(`Unknown color type: ${t}`);
    }
    if (this._png.channels = r, this._compressionMethod = this.readUint8(), this._compressionMethod !== tw.DEFLATE)
      throw new Error(`Unsupported compression method: ${this._compressionMethod}`);
    this._filterMethod = this.readUint8(), this._interlaceMethod = this.readUint8();
  }
  decodeACTL() {
    this._numberOfFrames = this.readUint32(), this._numberOfPlays = this.readUint32(), this._isAnimated = !0;
  }
  decodeFCTL() {
    const A = {
      sequenceNumber: this.readUint32(),
      width: this.readUint32(),
      height: this.readUint32(),
      xOffset: this.readUint32(),
      yOffset: this.readUint32(),
      delayNumber: this.readUint16(),
      delayDenominator: this.readUint16(),
      disposeOp: this.readUint8(),
      blendOp: this.readUint8(),
      data: new Uint8Array(0)
    };
    this._frames.push(A);
  }
  // https://www.w3.org/TR/PNG/#11PLTE
  decodePLTE(A) {
    if (A % 3 !== 0)
      throw new RangeError(`PLTE field length must be a multiple of 3. Got ${A}`);
    const t = A / 3;
    this._hasPalette = !0;
    const r = [];
    this._palette = r;
    for (let n = 0; n < t; n++)
      r.push([this.readUint8(), this.readUint8(), this.readUint8()]);
  }
  // https://www.w3.org/TR/PNG/#11IDAT
  decodeIDAT(A) {
    this._writingDataChunks = !0;
    const t = A, r = this.offset + this.byteOffset;
    if (this._inflator.push(new Uint8Array(this.buffer, r, t)), this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    this.skip(A);
  }
  decodeFDAT(A) {
    this._writingDataChunks = !0;
    let t = A, r = this.offset + this.byteOffset;
    if (r += 4, t -= 4, this._inflator.push(new Uint8Array(this.buffer, r, t)), this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    this.skip(A);
  }
  // https://www.w3.org/TR/PNG/#11tRNS
  decodetRNS(A) {
    switch (this._colorType) {
      case vi.GREYSCALE:
      case vi.TRUECOLOUR: {
        if (A % 2 !== 0)
          throw new RangeError(`tRNS chunk length must be a multiple of 2. Got ${A}`);
        if (A / 2 > this._png.width * this._png.height)
          throw new Error(`tRNS chunk contains more alpha values than there are pixels (${A / 2} vs ${this._png.width * this._png.height})`);
        this._hasTransparency = !0, this._transparency = new Uint16Array(A / 2);
        for (let t = 0; t < A / 2; t++)
          this._transparency[t] = this.readUint16();
        break;
      }
      case vi.INDEXED_COLOUR: {
        if (A > this._palette.length)
          throw new Error(`tRNS chunk contains more alpha values than there are palette colors (${A} vs ${this._palette.length})`);
        let t = 0;
        for (; t < A; t++) {
          const r = this.readByte();
          this._palette[t].push(r);
        }
        for (; t < this._palette.length; t++)
          this._palette[t].push(255);
        break;
      }
      // Kept for exhaustiveness.
      /* eslint-disable unicorn/no-useless-switch-case */
      case vi.UNKNOWN:
      case vi.GREYSCALE_ALPHA:
      case vi.TRUECOLOUR_ALPHA:
      default:
        throw new Error(`tRNS chunk is not supported for color type ${this._colorType}`);
    }
  }
  // https://www.w3.org/TR/PNG/#11iCCP
  decodeiCCP(A) {
    const t = E3(this), r = this.readUint8();
    if (r !== tw.DEFLATE)
      throw new Error(`Unsupported iCCP compression method: ${r}`);
    const n = this.readBytes(A - t.length - 2);
    this._png.iccEmbeddedProfile = {
      name: t,
      profile: tW(n)
    };
  }
  // https://www.w3.org/TR/PNG/#11pHYs
  decodepHYs() {
    const A = this.readUint32(), t = this.readUint32(), r = this.readByte();
    this._png.resolution = { x: A, y: t, unit: r };
  }
  decodeApngImage() {
    this._apng.width = this._png.width, this._apng.height = this._png.height, this._apng.channels = this._png.channels, this._apng.depth = this._png.depth, this._apng.numberOfFrames = this._numberOfFrames, this._apng.numberOfPlays = this._numberOfPlays, this._apng.text = this._png.text, this._apng.resolution = this._png.resolution;
    for (let A = 0; A < this._numberOfFrames; A++) {
      const t = {
        sequenceNumber: this._frames[A].sequenceNumber,
        delayNumber: this._frames[A].delayNumber,
        delayDenominator: this._frames[A].delayDenominator,
        data: this._apng.depth === 8 ? new Uint8Array(this._apng.width * this._apng.height * this._apng.channels) : new Uint16Array(this._apng.width * this._apng.height * this._apng.channels)
      }, r = this._frames.at(A);
      if (r) {
        if (r.data = $F({
          data: r.data,
          width: r.width,
          height: r.height,
          channels: this._apng.channels,
          depth: this._apng.depth
        }), this._hasPalette && (this._apng.palette = this._palette), this._hasTransparency && (this._apng.transparency = this._transparency), A === 0 || r.xOffset === 0 && r.yOffset === 0 && r.width === this._png.width && r.height === this._png.height)
          t.data = r.data;
        else {
          const n = this._apng.frames.at(A - 1);
          this.disposeFrame(r, n, t), this.addFrameDataToCanvas(t, r);
        }
        this._apng.frames.push(t);
      }
    }
    return this._apng;
  }
  disposeFrame(A, t, r) {
    switch (A.disposeOp) {
      case dd.NONE:
        break;
      case dd.BACKGROUND:
        for (let n = 0; n < this._png.height; n++)
          for (let i = 0; i < this._png.width; i++) {
            const s = (n * A.width + i) * this._png.channels;
            for (let a = 0; a < this._png.channels; a++)
              r.data[s + a] = 0;
          }
        break;
      case dd.PREVIOUS:
        r.data.set(t.data);
        break;
      default:
        throw new Error("Unknown disposeOp");
    }
  }
  addFrameDataToCanvas(A, t) {
    const r = 1 << this._png.depth, n = (i, s) => {
      const a = ((i + t.yOffset) * this._png.width + t.xOffset + s) * this._png.channels, o = (i * t.width + s) * this._png.channels;
      return { index: a, frameIndex: o };
    };
    switch (t.blendOp) {
      case nw.SOURCE:
        for (let i = 0; i < t.height; i++)
          for (let s = 0; s < t.width; s++) {
            const { index: a, frameIndex: o } = n(i, s);
            for (let l = 0; l < this._png.channels; l++)
              A.data[a + l] = t.data[o + l];
          }
        break;
      // https://www.w3.org/TR/png-3/#13Alpha-channel-processing
      case nw.OVER:
        for (let i = 0; i < t.height; i++)
          for (let s = 0; s < t.width; s++) {
            const { index: a, frameIndex: o } = n(i, s);
            for (let l = 0; l < this._png.channels; l++) {
              const c = t.data[o + this._png.channels - 1] / r, u = l % (this._png.channels - 1) === 0 ? 1 : t.data[o + l], d = Math.floor(c * u + (1 - c) * A.data[a + l]);
              A.data[a + l] += d;
            }
          }
        break;
      default:
        throw new Error("Unknown blendOp");
    }
  }
  decodeImage() {
    if (this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    const A = this._isAnimated ? (this._frames?.at(0)).data : this._inflator.result;
    if (this._filterMethod !== XF.ADAPTIVE)
      throw new Error(`Filter method ${this._filterMethod} not supported`);
    if (this._interlaceMethod === rw.NO_INTERLACE)
      this._png.data = $F({
        data: A,
        width: this._png.width,
        height: this._png.height,
        channels: this._png.channels,
        depth: this._png.depth
      });
    else if (this._interlaceMethod === rw.ADAM7)
      this._png.data = cW({
        data: A,
        width: this._png.width,
        height: this._png.height,
        channels: this._png.channels,
        depth: this._png.depth
      });
    else
      throw new Error(`Interlace method ${this._interlaceMethod} not supported`);
    this._hasPalette && (this._png.palette = this._palette), this._hasTransparency && (this._png.transparency = this._transparency);
  }
  pushDataToFrame() {
    const A = this._inflator.result, t = this._frames.at(-1);
    t ? t.data = A : this._frames.push({
      sequenceNumber: 0,
      width: this._png.width,
      height: this._png.height,
      xOffset: 0,
      yOffset: 0,
      delayNumber: 0,
      delayDenominator: 0,
      disposeOp: dd.NONE,
      blendOp: nw.SOURCE,
      data: A
    }), this._inflator = new WF(), this._writingDataChunks = !1;
  }
}
function UW(e) {
  if (e !== 1 && e !== 2 && e !== 4 && e !== 8 && e !== 16)
    throw new Error(`invalid bit depth: ${e}`);
  return e;
}
var YF;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.METRE = 1] = "METRE";
})(YF || (YF = {}));
function EW(e, A) {
  return new QW(e, A).decode();
}
var He = /* @__PURE__ */ (function() {
  return typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this;
})();
function iw() {
  He.console && typeof He.console.log == "function" && He.console.log.apply(He.console, arguments);
}
var Ct = { log: iw, warn: function(e) {
  He.console && (typeof He.console.warn == "function" ? He.console.warn.apply(He.console, arguments) : iw.call(null, arguments));
}, error: function(e) {
  He.console && (typeof He.console.error == "function" ? He.console.error.apply(He.console, arguments) : iw(e));
} };
function sw(e, A, t) {
  var r = new XMLHttpRequest();
  r.open("GET", e), r.responseType = "blob", r.onload = function() {
    wl(r.response, A, t);
  }, r.onerror = function() {
    Ct.error("could not download file");
  }, r.send();
}
function JF(e) {
  var A = new XMLHttpRequest();
  A.open("HEAD", e, !1);
  try {
    A.send();
  } catch {
  }
  return A.status >= 200 && A.status <= 299;
}
function gd(e) {
  try {
    e.dispatchEvent(new MouseEvent("click"));
  } catch {
    var A = document.createEvent("MouseEvents");
    A.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(A);
  }
}
var wl = He.saveAs || ((typeof window > "u" ? "undefined" : it(window)) !== "object" || window !== He ? function() {
} : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype ? function(e, A, t) {
  var r = He.URL || He.webkitURL, n = document.createElement("a");
  A = A || e.name || "download", n.download = A, n.rel = "noopener", typeof e == "string" ? (n.href = e, n.origin !== location.origin ? JF(n.href) ? sw(e, A, t) : gd(n, n.target = "_blank") : gd(n)) : (n.href = r.createObjectURL(e), setTimeout(function() {
    r.revokeObjectURL(n.href);
  }, 4e4), setTimeout(function() {
    gd(n);
  }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, A, t) {
  if (A = A || e.name || "download", typeof e == "string") if (JF(e)) sw(e, A, t);
  else {
    var r = document.createElement("a");
    r.href = e, r.target = "_blank", setTimeout(function() {
      gd(r);
    });
  }
  else navigator.msSaveOrOpenBlob((function(n, i) {
    return i === void 0 ? i = { autoBom: !1 } : it(i) !== "object" && (Ct.warn("Deprecated: Expected third argument to be a object"), i = { autoBom: !i }), i.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(n.type) ? new Blob(["\uFEFF", n], { type: n.type }) : n;
  })(e, t), A);
} : function(e, A, t, r) {
  if ((r = r || open("", "_blank")) && (r.document.title = r.document.body.innerText = "downloading..."), typeof e == "string") return sw(e, A, t);
  var n = e.type === "application/octet-stream", i = /constructor/i.test(He.HTMLElement) || He.safari, s = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((s || n && i) && (typeof FileReader > "u" ? "undefined" : it(FileReader)) === "object") {
    var a = new FileReader();
    a.onloadend = function() {
      var c = a.result;
      c = s ? c : c.replace(/^data:[^;]*;/, "data:attachment/file;"), r ? r.location.href = c : location = c, r = null;
    }, a.readAsDataURL(e);
  } else {
    var o = He.URL || He.webkitURL, l = o.createObjectURL(e);
    r ? r.location = l : location.href = l, r = null, setTimeout(function() {
      o.revokeObjectURL(l);
    }, 4e4);
  }
});
function x3(e) {
  var A;
  e = e || "", this.ok = !1, e.charAt(0) == "#" && (e = e.substr(1, 6)), e = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }[e = (e = e.replace(/ /g, "")).toLowerCase()] || e;
  for (var t = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(a) {
    return [parseInt(a[1]), parseInt(a[2]), parseInt(a[3])];
  } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(a) {
    return [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)];
  } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(a) {
    return [parseInt(a[1] + a[1], 16), parseInt(a[2] + a[2], 16), parseInt(a[3] + a[3], 16)];
  } }], r = 0; r < t.length; r++) {
    var n = t[r].re, i = t[r].process, s = n.exec(e);
    s && (A = i(s), this.r = A[0], this.g = A[1], this.b = A[2], this.ok = !0);
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toHex = function() {
    var a = this.r.toString(16), o = this.g.toString(16), l = this.b.toString(16);
    return a.length == 1 && (a = "0" + a), o.length == 1 && (o = "0" + o), l.length == 1 && (l = "0" + l), "#" + a + o + l;
  };
}
var Jd = He.atob.bind(He), ZF = He.btoa.bind(He);
function aw(e, A) {
  var t = e[0], r = e[1], n = e[2], i = e[3];
  t = mn(t, r, n, i, A[0], 7, -680876936), i = mn(i, t, r, n, A[1], 12, -389564586), n = mn(n, i, t, r, A[2], 17, 606105819), r = mn(r, n, i, t, A[3], 22, -1044525330), t = mn(t, r, n, i, A[4], 7, -176418897), i = mn(i, t, r, n, A[5], 12, 1200080426), n = mn(n, i, t, r, A[6], 17, -1473231341), r = mn(r, n, i, t, A[7], 22, -45705983), t = mn(t, r, n, i, A[8], 7, 1770035416), i = mn(i, t, r, n, A[9], 12, -1958414417), n = mn(n, i, t, r, A[10], 17, -42063), r = mn(r, n, i, t, A[11], 22, -1990404162), t = mn(t, r, n, i, A[12], 7, 1804603682), i = mn(i, t, r, n, A[13], 12, -40341101), n = mn(n, i, t, r, A[14], 17, -1502002290), t = vn(t, r = mn(r, n, i, t, A[15], 22, 1236535329), n, i, A[1], 5, -165796510), i = vn(i, t, r, n, A[6], 9, -1069501632), n = vn(n, i, t, r, A[11], 14, 643717713), r = vn(r, n, i, t, A[0], 20, -373897302), t = vn(t, r, n, i, A[5], 5, -701558691), i = vn(i, t, r, n, A[10], 9, 38016083), n = vn(n, i, t, r, A[15], 14, -660478335), r = vn(r, n, i, t, A[4], 20, -405537848), t = vn(t, r, n, i, A[9], 5, 568446438), i = vn(i, t, r, n, A[14], 9, -1019803690), n = vn(n, i, t, r, A[3], 14, -187363961), r = vn(r, n, i, t, A[8], 20, 1163531501), t = vn(t, r, n, i, A[13], 5, -1444681467), i = vn(i, t, r, n, A[2], 9, -51403784), n = vn(n, i, t, r, A[7], 14, 1735328473), t = yn(t, r = vn(r, n, i, t, A[12], 20, -1926607734), n, i, A[5], 4, -378558), i = yn(i, t, r, n, A[8], 11, -2022574463), n = yn(n, i, t, r, A[11], 16, 1839030562), r = yn(r, n, i, t, A[14], 23, -35309556), t = yn(t, r, n, i, A[1], 4, -1530992060), i = yn(i, t, r, n, A[4], 11, 1272893353), n = yn(n, i, t, r, A[7], 16, -155497632), r = yn(r, n, i, t, A[10], 23, -1094730640), t = yn(t, r, n, i, A[13], 4, 681279174), i = yn(i, t, r, n, A[0], 11, -358537222), n = yn(n, i, t, r, A[3], 16, -722521979), r = yn(r, n, i, t, A[6], 23, 76029189), t = yn(t, r, n, i, A[9], 4, -640364487), i = yn(i, t, r, n, A[12], 11, -421815835), n = yn(n, i, t, r, A[15], 16, 530742520), t = Cn(t, r = yn(r, n, i, t, A[2], 23, -995338651), n, i, A[0], 6, -198630844), i = Cn(i, t, r, n, A[7], 10, 1126891415), n = Cn(n, i, t, r, A[14], 15, -1416354905), r = Cn(r, n, i, t, A[5], 21, -57434055), t = Cn(t, r, n, i, A[12], 6, 1700485571), i = Cn(i, t, r, n, A[3], 10, -1894986606), n = Cn(n, i, t, r, A[10], 15, -1051523), r = Cn(r, n, i, t, A[1], 21, -2054922799), t = Cn(t, r, n, i, A[8], 6, 1873313359), i = Cn(i, t, r, n, A[15], 10, -30611744), n = Cn(n, i, t, r, A[6], 15, -1560198380), r = Cn(r, n, i, t, A[13], 21, 1309151649), t = Cn(t, r, n, i, A[4], 6, -145523070), i = Cn(i, t, r, n, A[11], 10, -1120210379), n = Cn(n, i, t, r, A[2], 15, 718787259), r = Cn(r, n, i, t, A[9], 21, -343485551), e[0] = Eo(t, e[0]), e[1] = Eo(r, e[1]), e[2] = Eo(n, e[2]), e[3] = Eo(i, e[3]);
}
function dp(e, A, t, r, n, i) {
  return A = Eo(Eo(A, e), Eo(r, i)), Eo(A << n | A >>> 32 - n, t);
}
function mn(e, A, t, r, n, i, s) {
  return dp(A & t | ~A & r, e, A, n, i, s);
}
function vn(e, A, t, r, n, i, s) {
  return dp(A & r | t & ~r, e, A, n, i, s);
}
function yn(e, A, t, r, n, i, s) {
  return dp(A ^ t ^ r, e, A, n, i, s);
}
function Cn(e, A, t, r, n, i, s) {
  return dp(t ^ (A | ~r), e, A, n, i, s);
}
function I3(e) {
  var A, t = e.length, r = [1732584193, -271733879, -1732584194, 271733878];
  for (A = 64; A <= e.length; A += 64) aw(r, xW(e.substring(A - 64, A)));
  e = e.substring(A - 64);
  var n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (A = 0; A < e.length; A++) n[A >> 2] |= e.charCodeAt(A) << (A % 4 << 3);
  if (n[A >> 2] |= 128 << (A % 4 << 3), A > 55) for (aw(r, n), A = 0; A < 16; A++) n[A] = 0;
  return n[14] = 8 * t, aw(r, n), r;
}
function xW(e) {
  var A, t = [];
  for (A = 0; A < 64; A += 4) t[A >> 2] = e.charCodeAt(A) + (e.charCodeAt(A + 1) << 8) + (e.charCodeAt(A + 2) << 16) + (e.charCodeAt(A + 3) << 24);
  return t;
}
var AQ = "0123456789abcdef".split("");
function IW(e) {
  for (var A = "", t = 0; t < 4; t++) A += AQ[e >> 8 * t + 4 & 15] + AQ[e >> 8 * t & 15];
  return A;
}
function SW(e) {
  return String.fromCharCode(255 & e, (65280 & e) >> 8, (16711680 & e) >> 16, (4278190080 & e) >> 24);
}
function Cv(e) {
  return I3(e).map(SW).join("");
}
var LW = (function(e) {
  for (var A = 0; A < e.length; A++) e[A] = IW(e[A]);
  return e.join("");
})(I3("hello")) != "5d41402abc4b2a76b9719d911017c592";
function Eo(e, A) {
  if (LW) {
    var t = (65535 & e) + (65535 & A);
    return (e >> 16) + (A >> 16) + (t >> 16) << 16 | 65535 & t;
  }
  return e + A & 4294967295;
}
function bv(e, A) {
  var t, r, n, i;
  if (e !== t) {
    for (var s = (n = e, i = 1 + (256 / e.length | 0), new Array(i + 1).join(n)), a = [], o = 0; o < 256; o++) a[o] = o;
    var l = 0;
    for (o = 0; o < 256; o++) {
      var c = a[o];
      l = (l + c + s.charCodeAt(o)) % 256, a[o] = a[l], a[l] = c;
    }
    t = e, r = a;
  } else a = r;
  var u = A.length, d = 0, h = 0, p = "";
  for (o = 0; o < u; o++) h = (h + (c = a[d = (d + 1) % 256])) % 256, a[d] = a[h], a[h] = c, s = a[(a[d] + a[h]) % 256], p += String.fromCharCode(A.charCodeAt(o) ^ s);
  return p;
}
var eQ = { print: 4, modify: 8, copy: 16, "annot-forms": 32 };
function Nc(e, A, t, r) {
  this.v = 1, this.r = 2;
  var n = 192;
  e.forEach(function(a) {
    if (eQ.perm !== void 0) throw new Error("Invalid permission: " + a);
    n += eQ[a];
  }), this.padding = "(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";
  var i = (A + this.padding).substr(0, 32), s = (t + this.padding).substr(0, 32);
  this.O = this.processOwnerPassword(i, s), this.P = -(1 + (255 ^ n)), this.encryptionKey = Cv(i + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(r)).substr(0, 5), this.U = bv(this.encryptionKey, this.padding);
}
function Dc(e) {
  if (/[^\u0000-\u00ff]/.test(e)) throw new Error("Invalid PDF Name Object: " + e + ", Only accept ASCII characters.");
  for (var A = "", t = e.length, r = 0; r < t; r++) {
    var n = e.charCodeAt(r);
    A += n < 33 || n === 35 || n === 37 || n === 40 || n === 41 || n === 47 || n === 60 || n === 62 || n === 91 || n === 93 || n === 123 || n === 125 || n > 126 ? "#" + ("0" + n.toString(16)).slice(-2) : e[r];
  }
  return A;
}
function tQ(e) {
  if (it(e) !== "object") throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
  var A = {};
  this.subscribe = function(t, r, n) {
    if (n = n || !1, typeof t != "string" || typeof r != "function" || typeof n != "boolean") throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
    A.hasOwnProperty(t) || (A[t] = {});
    var i = Math.random().toString(35);
    return A[t][i] = [r, !!n], i;
  }, this.unsubscribe = function(t) {
    for (var r in A) if (A[r][t]) return delete A[r][t], Object.keys(A[r]).length === 0 && delete A[r], !0;
    return !1;
  }, this.publish = function(t) {
    if (A.hasOwnProperty(t)) {
      var r = Array.prototype.slice.call(arguments, 1), n = [];
      for (var i in A[t]) {
        var s = A[t][i];
        try {
          s[0].apply(e, r);
        } catch (a) {
          He.console && Ct.error("jsPDF PubSub Error", a.message, a);
        }
        s[1] && n.push(i);
      }
      n.length && n.forEach(this.unsubscribe);
    }
  }, this.getTopics = function() {
    return A;
  };
}
function Vh(e) {
  if (!(this instanceof Vh)) return new Vh(e);
  var A = "opacity,stroke-opacity".split(",");
  for (var t in e) e.hasOwnProperty(t) && A.indexOf(t) >= 0 && (this[t] = e[t]);
  this.id = "", this.objectNumber = -1;
}
function S3(e, A) {
  this.gState = e, this.matrix = A, this.id = "", this.objectNumber = -1;
}
function Qo(e, A, t, r, n) {
  if (!(this instanceof Qo)) return new Qo(e, A, t, r, n);
  this.type = e === "axial" ? 2 : 3, this.coords = A, this.colors = t, S3.call(this, r, n);
}
function Ll(e, A, t, r, n) {
  if (!(this instanceof Ll)) return new Ll(e, A, t, r, n);
  this.boundingBox = e, this.xStep = A, this.yStep = t, this.stream = "", this.cloneIndex = 0, S3.call(this, r, n);
}
function we(e) {
  var A, t = typeof arguments[0] == "string" ? arguments[0] : "p", r = arguments[1], n = arguments[2], i = arguments[3], s = [], a = 1, o = 16, l = "S", c = null;
  it(e = e || {}) === "object" && (t = e.orientation, r = e.unit || r, n = e.format || n, i = e.compress || e.compressPdf || i, (c = e.encryption || null) !== null && (c.userPassword = c.userPassword || "", c.ownerPassword = c.ownerPassword || "", c.userPermissions = c.userPermissions || []), a = typeof e.userUnit == "number" ? Math.abs(e.userUnit) : 1, e.precision !== void 0 && (A = e.precision), e.floatPrecision !== void 0 && (o = e.floatPrecision), l = e.defaultPathOperation || "S"), s = e.filters || (i === !0 ? ["FlateEncode"] : s), r = r || "mm", t = ("" + (t || "P")).toLowerCase();
  var u = e.putOnlyUsedFonts || !1, d = {}, h = { internal: {}, __private__: {} };
  h.__private__.PubSub = tQ;
  var p = "1.3", B = h.__private__.getPdfVersion = function() {
    return p;
  };
  h.__private__.setPdfVersion = function(w) {
    p = w;
  };
  var y = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
  h.__private__.getPageFormats = function() {
    return y;
  };
  var m = h.__private__.getPageFormat = function(w) {
    return y[w];
  };
  n = n || "a4";
  var C = "compat", Q = "advanced", F = C;
  function T() {
    this.saveGraphicsState(), E(new Be(ee, 0, 0, -ee, 0, Wt() * ee).toString() + " cm"), this.setFontSize(this.getFontSize() / ee), l = "n", F = Q;
  }
  function V() {
    this.restoreGraphicsState(), l = "S", F = C;
  }
  var M = h.__private__.combineFontStyleAndFontWeight = function(w, L) {
    if (w == "bold" && L == "normal" || w == "bold" && L == 400 || w == "normal" && L == "italic" || w == "bold" && L == "italic") throw new Error("Invalid Combination of fontweight and fontstyle");
    return L && (w = L == 400 || L === "normal" ? w === "italic" ? "italic" : "normal" : L != 700 && L !== "bold" || w !== "normal" ? (L == 700 ? "bold" : L) + "" + w : "bold"), w;
  };
  h.advancedAPI = function(w) {
    var L = F === C;
    return L && T.call(this), typeof w != "function" || (w(this), L && V.call(this)), this;
  }, h.compatAPI = function(w) {
    var L = F === Q;
    return L && V.call(this), typeof w != "function" || (w(this), L && T.call(this)), this;
  }, h.isAdvancedAPI = function() {
    return F === Q;
  };
  var D, I = function(w) {
    if (F !== Q) throw new Error(w + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
  }, q = h.roundToPrecision = h.__private__.roundToPrecision = function(w, L) {
    var z = A || L;
    if (isNaN(w) || isNaN(z)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
    return w.toFixed(z).replace(/0+$/, "");
  };
  D = h.hpf = h.__private__.hpf = typeof o == "number" ? function(w) {
    if (isNaN(w)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return q(w, o);
  } : o === "smart" ? function(w) {
    if (isNaN(w)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return q(w, w > -1 && w < 1 ? 16 : 5);
  } : function(w) {
    if (isNaN(w)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return q(w, 16);
  };
  var U = h.f2 = h.__private__.f2 = function(w) {
    if (isNaN(w)) throw new Error("Invalid argument passed to jsPDF.f2");
    return q(w, 2);
  }, x = h.__private__.f3 = function(w) {
    if (isNaN(w)) throw new Error("Invalid argument passed to jsPDF.f3");
    return q(w, 3);
  }, P = h.scale = h.__private__.scale = function(w) {
    if (isNaN(w)) throw new Error("Invalid argument passed to jsPDF.scale");
    return F === C ? w * ee : F === Q ? w : void 0;
  }, N = function(w) {
    return P((function(L) {
      return F === C ? Wt() - L : F === Q ? L : void 0;
    })(w));
  };
  h.__private__.setPrecision = h.setPrecision = function(w) {
    typeof parseInt(w, 10) == "number" && (A = parseInt(w, 10));
  };
  var iA, nA = "00000000000000000000000000000000", sA = h.__private__.getFileId = function() {
    return nA;
  }, tA = h.__private__.setFileId = function(w) {
    return nA = w !== void 0 && /^[a-fA-F0-9]{32}$/.test(w) ? w.toUpperCase() : nA.split("").map(function() {
      return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
    }).join(""), c !== null && (Lt = new Nc(c.userPermissions, c.userPassword, c.ownerPassword, nA)), nA;
  };
  h.setFileId = function(w) {
    return tA(w), this;
  }, h.getFileId = function() {
    return sA();
  };
  var cA = h.__private__.convertDateToPDFDate = function(w) {
    var L = w.getTimezoneOffset(), z = L < 0 ? "+" : "-", aA = Math.floor(Math.abs(L / 60)), mA = Math.abs(L % 60), OA = [z, Y(aA), "'", Y(mA), "'"].join("");
    return ["D:", w.getFullYear(), Y(w.getMonth() + 1), Y(w.getDate()), Y(w.getHours()), Y(w.getMinutes()), Y(w.getSeconds()), OA].join("");
  }, FA = h.__private__.convertPDFDateToDate = function(w) {
    var L = parseInt(w.substr(2, 4), 10), z = parseInt(w.substr(6, 2), 10) - 1, aA = parseInt(w.substr(8, 2), 10), mA = parseInt(w.substr(10, 2), 10), OA = parseInt(w.substr(12, 2), 10), jA = parseInt(w.substr(14, 2), 10);
    return new Date(L, z, aA, mA, OA, jA, 0);
  }, CA = h.__private__.setCreationDate = function(w) {
    var L;
    if (w === void 0 && (w = /* @__PURE__ */ new Date()), w instanceof Date) L = cA(w);
    else {
      if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(w)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
      L = w;
    }
    return iA = L;
  }, S = h.__private__.getCreationDate = function(w) {
    var L = iA;
    return w === "jsDate" && (L = FA(iA)), L;
  };
  h.setCreationDate = function(w) {
    return CA(w), this;
  }, h.getCreationDate = function(w) {
    return S(w);
  };
  var W, Y = h.__private__.padd2 = function(w) {
    return ("0" + parseInt(w)).slice(-2);
  }, AA = h.__private__.padd2Hex = function(w) {
    return ("00" + (w = w.toString())).substr(w.length);
  }, oA = 0, gA = [], xA = [], IA = 0, pA = [], WA = [], k = !1, X = xA;
  h.__private__.setCustomOutputDestination = function(w) {
    k = !0, X = w;
  };
  var uA = function(w) {
    k || (X = w);
  };
  h.__private__.resetCustomOutputDestination = function() {
    k = !1, X = xA;
  };
  var E = h.__private__.out = function(w) {
    return w = w.toString(), IA += w.length + 1, X.push(w), X;
  }, dA = h.__private__.write = function(w) {
    return E(arguments.length === 1 ? w.toString() : Array.prototype.join.call(arguments, " "));
  }, vA = h.__private__.getArrayBuffer = function(w) {
    for (var L = w.length, z = new ArrayBuffer(L), aA = new Uint8Array(z); L--; ) aA[L] = w.charCodeAt(L);
    return z;
  }, rA = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]];
  h.__private__.getStandardFonts = function() {
    return rA;
  };
  var fA = e.fontSize || 16;
  h.__private__.setFontSize = h.setFontSize = function(w) {
    return fA = F === Q ? w / ee : w, this;
  };
  var EA, lA = h.__private__.getFontSize = h.getFontSize = function() {
    return F === C ? fA : fA * ee;
  }, HA = e.R2L || !1;
  h.__private__.setR2L = h.setR2L = function(w) {
    return HA = w, this;
  }, h.__private__.getR2L = h.getR2L = function() {
    return HA;
  };
  var SA, yA = h.__private__.setZoomMode = function(w) {
    if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(w)) EA = w;
    else if (isNaN(w)) {
      if ([void 0, null, "fullwidth", "fullheight", "fullpage", "original"].indexOf(w) === -1) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + w + '" is not recognized.');
      EA = w;
    } else EA = parseInt(w, 10);
  };
  h.__private__.getZoomMode = function() {
    return EA;
  };
  var TA, _A = h.__private__.setPageMode = function(w) {
    if ([void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(w) == -1) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + w + '" is not recognized.');
    SA = w;
  };
  h.__private__.getPageMode = function() {
    return SA;
  };
  var MA = h.__private__.setLayoutMode = function(w) {
    if ([void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(w) == -1) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + w + '" is not recognized.');
    TA = w;
  };
  h.__private__.getLayoutMode = function() {
    return TA;
  }, h.__private__.setDisplayMode = h.setDisplayMode = function(w, L, z) {
    return yA(w), MA(L), _A(z), this;
  };
  var VA = { title: "", subject: "", author: "", keywords: "", creator: "" };
  h.__private__.getDocumentProperty = function(w) {
    if (Object.keys(VA).indexOf(w) === -1) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
    return VA[w];
  }, h.__private__.getDocumentProperties = function() {
    return VA;
  }, h.__private__.setDocumentProperties = h.setProperties = h.setDocumentProperties = function(w) {
    for (var L in VA) VA.hasOwnProperty(L) && w[L] && (VA[L] = w[L]);
    return this;
  }, h.__private__.setDocumentProperty = function(w, L) {
    if (Object.keys(VA).indexOf(w) === -1) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
    return VA[w] = L;
  };
  var $A, ee, ZA, Fe, me, Ce = {}, ae = {}, Te = [], ie = {}, Ke = {}, ge = {}, xe = {}, Ye = null, ue = 0, pe = [], ze = new tQ(h), Ii = e.hotfixes || [], Jt = {}, Wr = {}, un = [], Be = function w(L, z, aA, mA, OA, jA) {
    if (!(this instanceof w)) return new w(L, z, aA, mA, OA, jA);
    isNaN(L) && (L = 1), isNaN(z) && (z = 0), isNaN(aA) && (aA = 0), isNaN(mA) && (mA = 1), isNaN(OA) && (OA = 0), isNaN(jA) && (jA = 0), this._matrix = [L, z, aA, mA, OA, jA];
  };
  Object.defineProperty(Be.prototype, "sx", { get: function() {
    return this._matrix[0];
  }, set: function(w) {
    this._matrix[0] = w;
  } }), Object.defineProperty(Be.prototype, "shy", { get: function() {
    return this._matrix[1];
  }, set: function(w) {
    this._matrix[1] = w;
  } }), Object.defineProperty(Be.prototype, "shx", { get: function() {
    return this._matrix[2];
  }, set: function(w) {
    this._matrix[2] = w;
  } }), Object.defineProperty(Be.prototype, "sy", { get: function() {
    return this._matrix[3];
  }, set: function(w) {
    this._matrix[3] = w;
  } }), Object.defineProperty(Be.prototype, "tx", { get: function() {
    return this._matrix[4];
  }, set: function(w) {
    this._matrix[4] = w;
  } }), Object.defineProperty(Be.prototype, "ty", { get: function() {
    return this._matrix[5];
  }, set: function(w) {
    this._matrix[5] = w;
  } }), Object.defineProperty(Be.prototype, "a", { get: function() {
    return this._matrix[0];
  }, set: function(w) {
    this._matrix[0] = w;
  } }), Object.defineProperty(Be.prototype, "b", { get: function() {
    return this._matrix[1];
  }, set: function(w) {
    this._matrix[1] = w;
  } }), Object.defineProperty(Be.prototype, "c", { get: function() {
    return this._matrix[2];
  }, set: function(w) {
    this._matrix[2] = w;
  } }), Object.defineProperty(Be.prototype, "d", { get: function() {
    return this._matrix[3];
  }, set: function(w) {
    this._matrix[3] = w;
  } }), Object.defineProperty(Be.prototype, "e", { get: function() {
    return this._matrix[4];
  }, set: function(w) {
    this._matrix[4] = w;
  } }), Object.defineProperty(Be.prototype, "f", { get: function() {
    return this._matrix[5];
  }, set: function(w) {
    this._matrix[5] = w;
  } }), Object.defineProperty(Be.prototype, "rotation", { get: function() {
    return Math.atan2(this.shx, this.sx);
  } }), Object.defineProperty(Be.prototype, "scaleX", { get: function() {
    return this.decompose().scale.sx;
  } }), Object.defineProperty(Be.prototype, "scaleY", { get: function() {
    return this.decompose().scale.sy;
  } }), Object.defineProperty(Be.prototype, "isIdentity", { get: function() {
    return this.sx === 1 && this.shy === 0 && this.shx === 0 && this.sy === 1 && this.tx === 0 && this.ty === 0;
  } }), Be.prototype.join = function(w) {
    return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty].map(D).join(w);
  }, Be.prototype.multiply = function(w) {
    var L = w.sx * this.sx + w.shy * this.shx, z = w.sx * this.shy + w.shy * this.sy, aA = w.shx * this.sx + w.sy * this.shx, mA = w.shx * this.shy + w.sy * this.sy, OA = w.tx * this.sx + w.ty * this.shx + this.tx, jA = w.tx * this.shy + w.ty * this.sy + this.ty;
    return new Be(L, z, aA, mA, OA, jA);
  }, Be.prototype.decompose = function() {
    var w = this.sx, L = this.shy, z = this.shx, aA = this.sy, mA = this.tx, OA = this.ty, jA = Math.sqrt(w * w + L * L), he = (w /= jA) * z + (L /= jA) * aA;
    z -= w * he, aA -= L * he;
    var ce = Math.sqrt(z * z + aA * aA);
    return he /= ce, w * (aA /= ce) < L * (z /= ce) && (w = -w, L = -L, he = -he, jA = -jA), { scale: new Be(jA, 0, 0, ce, 0, 0), translate: new Be(1, 0, 0, 1, mA, OA), rotate: new Be(w, L, -L, w, 0, 0), skew: new Be(1, 0, he, 1, 0, 0) };
  }, Be.prototype.toString = function(w) {
    return this.join(" ");
  }, Be.prototype.inversed = function() {
    var w = this.sx, L = this.shy, z = this.shx, aA = this.sy, mA = this.tx, OA = this.ty, jA = 1 / (w * aA - L * z), he = aA * jA, ce = -L * jA, _e = -z * jA, Me = w * jA;
    return new Be(he, ce, _e, Me, -he * mA - _e * OA, -ce * mA - Me * OA);
  }, Be.prototype.applyToPoint = function(w) {
    var L = w.x * this.sx + w.y * this.shx + this.tx, z = w.x * this.shy + w.y * this.sy + this.ty;
    return new sa(L, z);
  }, Be.prototype.applyToRectangle = function(w) {
    var L = this.applyToPoint(w), z = this.applyToPoint(new sa(w.x + w.w, w.y + w.h));
    return new zo(L.x, L.y, z.x - L.x, z.y - L.y);
  }, Be.prototype.clone = function() {
    var w = this.sx, L = this.shy, z = this.shx, aA = this.sy, mA = this.tx, OA = this.ty;
    return new Be(w, L, z, aA, mA, OA);
  }, h.Matrix = Be;
  var Jr = h.matrixMult = function(w, L) {
    return L.multiply(w);
  }, Zt = new Be(1, 0, 0, 1, 0, 0);
  h.unitMatrix = h.identityMatrix = Zt;
  var Vt = function(w, L) {
    if (!Ke[w]) {
      var z = (L instanceof Qo ? "Sh" : "P") + (Object.keys(ie).length + 1).toString(10);
      L.id = z, Ke[w] = z, ie[z] = L, ze.publish("addPattern", L);
    }
  };
  h.ShadingPattern = Qo, h.TilingPattern = Ll, h.addShadingPattern = function(w, L) {
    return I("addShadingPattern()"), Vt(w, L), this;
  }, h.beginTilingPattern = function(w) {
    I("beginTilingPattern()"), G(w.boundingBox[0], w.boundingBox[1], w.boundingBox[2] - w.boundingBox[0], w.boundingBox[3] - w.boundingBox[1], w.matrix);
  }, h.endTilingPattern = function(w, L) {
    I("endTilingPattern()"), L.stream = WA[W].join(`
`), Vt(w, L), ze.publish("endTilingPattern", L), un.pop().restore();
  };
  var Ar, Bt = h.__private__.newObject = function() {
    var w = er();
    return Gt(w, !0), w;
  }, er = h.__private__.newObjectDeferred = function() {
    return oA++, gA[oA] = function() {
      return IA;
    }, oA;
  }, Gt = function(w, L) {
    return L = typeof L == "boolean" && L, gA[w] = IA, L && E(w + " 0 obj"), w;
  }, ui = h.__private__.newAdditionalObject = function() {
    var w = { objId: er(), content: "" };
    return pA.push(w), w;
  }, hi = er(), Hr = er(), jr = h.__private__.decodeColorString = function(w) {
    var L = w.split(" ");
    if (L.length !== 2 || L[1] !== "g" && L[1] !== "G") L.length !== 5 || L[4] !== "k" && L[4] !== "K" || (L = [(1 - L[0]) * (1 - L[3]), (1 - L[1]) * (1 - L[3]), (1 - L[2]) * (1 - L[3]), "r"]);
    else {
      var z = parseFloat(L[0]);
      L = [z, z, z, "r"];
    }
    for (var aA = "#", mA = 0; mA < 3; mA++) aA += ("0" + Math.floor(255 * parseFloat(L[mA])).toString(16)).slice(-2);
    return aA;
  }, tr = h.__private__.encodeColorString = function(w) {
    var L;
    typeof w == "string" && (w = { ch1: w });
    var z = w.ch1, aA = w.ch2, mA = w.ch3, OA = w.ch4, jA = w.pdfColorType === "draw" ? ["G", "RG", "K"] : ["g", "rg", "k"];
    if (typeof z == "string" && z.charAt(0) !== "#") {
      var he = new x3(z);
      if (he.ok) z = he.toHex();
      else if (!/^\d*\.?\d*$/.test(z)) throw new Error('Invalid color "' + z + '" passed to jsPDF.encodeColorString.');
    }
    if (typeof z == "string" && /^#[0-9A-Fa-f]{3}$/.test(z) && (z = "#" + z[1] + z[1] + z[2] + z[2] + z[3] + z[3]), typeof z == "string" && /^#[0-9A-Fa-f]{6}$/.test(z)) {
      var ce = parseInt(z.substr(1), 16);
      z = ce >> 16 & 255, aA = ce >> 8 & 255, mA = 255 & ce;
    }
    if (aA === void 0 || OA === void 0 && z === aA && aA === mA) L = typeof z == "string" ? z + " " + jA[0] : w.precision === 2 ? U(z / 255) + " " + jA[0] : x(z / 255) + " " + jA[0];
    else if (OA === void 0 || it(OA) === "object") {
      if (OA && !isNaN(OA.a) && OA.a === 0) return ["1.", "1.", "1.", jA[1]].join(" ");
      L = typeof z == "string" ? [z, aA, mA, jA[1]].join(" ") : w.precision === 2 ? [U(z / 255), U(aA / 255), U(mA / 255), jA[1]].join(" ") : [x(z / 255), x(aA / 255), x(mA / 255), jA[1]].join(" ");
    } else L = typeof z == "string" ? [z, aA, mA, OA, jA[2]].join(" ") : w.precision === 2 ? [U(z), U(aA), U(mA), U(OA), jA[2]].join(" ") : [x(z), x(aA), x(mA), x(OA), jA[2]].join(" ");
    return L;
  }, Tn = h.__private__.getFilters = function() {
    return s;
  }, hn = h.__private__.putStream = function(w) {
    var L = (w = w || {}).data || "", z = w.filters || Tn(), aA = w.alreadyAppliedFilters || [], mA = w.addLength1 || !1, OA = L.length, jA = w.objectId, he = function(Ht) {
      return Ht;
    };
    if (c !== null && jA === void 0) throw new Error("ObjectId must be passed to putStream for file encryption");
    c !== null && (he = Lt.encryptor(jA, 0));
    var ce = {};
    z === !0 && (z = ["FlateEncode"]);
    var _e = w.additionalKeyValues || [], Me = (ce = we.API.processDataByFilters !== void 0 ? we.API.processDataByFilters(L, z) : { data: L, reverseChain: [] }).reverseChain + (Array.isArray(aA) ? aA.join(" ") : aA.toString());
    if (ce.data.length !== 0 && (_e.push({ key: "Length", value: ce.data.length }), mA === !0 && _e.push({ key: "Length1", value: OA })), Me.length != 0) if (Me.split("/").length - 1 == 1) _e.push({ key: "Filter", value: Me });
    else {
      _e.push({ key: "Filter", value: "[" + Me + "]" });
      for (var Ze = 0; Ze < _e.length; Ze += 1) if (_e[Ze].key === "DecodeParms") {
        for (var Qr = [], vt = 0; vt < ce.reverseChain.split("/").length - 1; vt += 1) Qr.push("null");
        Qr.push(_e[Ze].value), _e[Ze].value = "[" + Qr.join(" ") + "]";
      }
    }
    E("<<");
    for (var wt = 0; wt < _e.length; wt++) E("/" + _e[wt].key + " " + _e[wt].value);
    E(">>"), ce.data.length !== 0 && (E("stream"), E(he(ce.data)), E("endstream"));
  }, je = h.__private__.putPage = function(w) {
    var L = w.number, z = w.data, aA = w.objId, mA = w.contentsObjId;
    Gt(aA, !0), E("<</Type /Page"), E("/Parent " + w.rootDictionaryObjId + " 0 R"), E("/Resources " + w.resourceDictionaryObjId + " 0 R"), E("/MediaBox [" + parseFloat(D(w.mediaBox.bottomLeftX)) + " " + parseFloat(D(w.mediaBox.bottomLeftY)) + " " + D(w.mediaBox.topRightX) + " " + D(w.mediaBox.topRightY) + "]"), w.cropBox !== null && E("/CropBox [" + D(w.cropBox.bottomLeftX) + " " + D(w.cropBox.bottomLeftY) + " " + D(w.cropBox.topRightX) + " " + D(w.cropBox.topRightY) + "]"), w.bleedBox !== null && E("/BleedBox [" + D(w.bleedBox.bottomLeftX) + " " + D(w.bleedBox.bottomLeftY) + " " + D(w.bleedBox.topRightX) + " " + D(w.bleedBox.topRightY) + "]"), w.trimBox !== null && E("/TrimBox [" + D(w.trimBox.bottomLeftX) + " " + D(w.trimBox.bottomLeftY) + " " + D(w.trimBox.topRightX) + " " + D(w.trimBox.topRightY) + "]"), w.artBox !== null && E("/ArtBox [" + D(w.artBox.bottomLeftX) + " " + D(w.artBox.bottomLeftY) + " " + D(w.artBox.topRightX) + " " + D(w.artBox.topRightY) + "]"), typeof w.userUnit == "number" && w.userUnit !== 1 && E("/UserUnit " + w.userUnit), ze.publish("putPage", { objId: aA, pageContext: pe[L], pageNumber: L, page: z }), E("/Contents " + mA + " 0 R"), E(">>"), E("endobj");
    var OA = z.join(`
`);
    return F === Q && (OA += `
Q`), Gt(mA, !0), hn({ data: OA, filters: Tn(), objectId: mA }), E("endobj"), aA;
  }, Nt = h.__private__.putPages = function() {
    var w, L, z = [];
    for (w = 1; w <= ue; w++) pe[w].objId = er(), pe[w].contentsObjId = er();
    for (w = 1; w <= ue; w++) z.push(je({ number: w, data: WA[w], objId: pe[w].objId, contentsObjId: pe[w].contentsObjId, mediaBox: pe[w].mediaBox, cropBox: pe[w].cropBox, bleedBox: pe[w].bleedBox, trimBox: pe[w].trimBox, artBox: pe[w].artBox, userUnit: pe[w].userUnit, rootDictionaryObjId: hi, resourceDictionaryObjId: Hr }));
    Gt(hi, !0), E("<</Type /Pages");
    var aA = "/Kids [";
    for (L = 0; L < ue; L++) aA += z[L] + " 0 R ";
    E(aA + "]"), E("/Count " + ue), E(">>"), E("endobj"), ze.publish("postPutPages");
  }, Si = function(w) {
    ze.publish("putFont", { font: w, out: E, newObject: Bt, putStream: hn }), w.isAlreadyPutted !== !0 && (w.objectNumber = Bt(), E("<<"), E("/Type /Font"), E("/BaseFont /" + Dc(w.postScriptName)), E("/Subtype /Type1"), typeof w.encoding == "string" && E("/Encoding /" + w.encoding), E("/FirstChar 32"), E("/LastChar 255"), E(">>"), E("endobj"));
  }, ts = function(w) {
    w.objectNumber = Bt();
    var L = [];
    L.push({ key: "Type", value: "/XObject" }), L.push({ key: "Subtype", value: "/Form" }), L.push({ key: "BBox", value: "[" + [D(w.x), D(w.y), D(w.x + w.width), D(w.y + w.height)].join(" ") + "]" }), L.push({ key: "Matrix", value: "[" + w.matrix.toString() + "]" });
    var z = w.pages[1].join(`
`);
    hn({ data: z, additionalKeyValues: L, objectId: w.objectNumber }), E("endobj");
  }, Li = function(w, L) {
    L || (L = 21);
    var z = Bt(), aA = (function(jA, he) {
      var ce, _e = [], Me = 1 / (he - 1);
      for (ce = 0; ce < 1; ce += Me) _e.push(ce);
      if (_e.push(1), jA[0].offset != 0) {
        var Ze = { offset: 0, color: jA[0].color };
        jA.unshift(Ze);
      }
      if (jA[jA.length - 1].offset != 1) {
        var Qr = { offset: 1, color: jA[jA.length - 1].color };
        jA.push(Qr);
      }
      for (var vt = "", wt = 0, Ht = 0; Ht < _e.length; Ht++) {
        for (ce = _e[Ht]; ce > jA[wt + 1].offset; ) wt++;
        var jt = jA[wt].offset, qt = (ce - jt) / (jA[wt + 1].offset - jt), gn = jA[wt].color, oa = jA[wt + 1].color;
        vt += AA(Math.round((1 - qt) * gn[0] + qt * oa[0]).toString(16)) + AA(Math.round((1 - qt) * gn[1] + qt * oa[1]).toString(16)) + AA(Math.round((1 - qt) * gn[2] + qt * oa[2]).toString(16));
      }
      return vt.trim();
    })(w.colors, L), mA = [];
    mA.push({ key: "FunctionType", value: "0" }), mA.push({ key: "Domain", value: "[0.0 1.0]" }), mA.push({ key: "Size", value: "[" + L + "]" }), mA.push({ key: "BitsPerSample", value: "8" }), mA.push({ key: "Range", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), mA.push({ key: "Decode", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), hn({ data: aA, additionalKeyValues: mA, alreadyAppliedFilters: ["/ASCIIHexDecode"], objectId: z }), E("endobj"), w.objectNumber = Bt(), E("<< /ShadingType " + w.type), E("/ColorSpace /DeviceRGB");
    var OA = "/Coords [" + D(parseFloat(w.coords[0])) + " " + D(parseFloat(w.coords[1])) + " ";
    w.type === 2 ? OA += D(parseFloat(w.coords[2])) + " " + D(parseFloat(w.coords[3])) : OA += D(parseFloat(w.coords[2])) + " " + D(parseFloat(w.coords[3])) + " " + D(parseFloat(w.coords[4])) + " " + D(parseFloat(w.coords[5])), E(OA += "]"), w.matrix && E("/Matrix [" + w.matrix.toString() + "]"), E("/Function " + z + " 0 R"), E("/Extend [true true]"), E(">>"), E("endobj");
  }, rs = function(w, L) {
    var z = er(), aA = Bt();
    L.push({ resourcesOid: z, objectOid: aA }), w.objectNumber = aA;
    var mA = [];
    mA.push({ key: "Type", value: "/Pattern" }), mA.push({ key: "PatternType", value: "1" }), mA.push({ key: "PaintType", value: "1" }), mA.push({ key: "TilingType", value: "1" }), mA.push({ key: "BBox", value: "[" + w.boundingBox.map(D).join(" ") + "]" }), mA.push({ key: "XStep", value: D(w.xStep) }), mA.push({ key: "YStep", value: D(w.yStep) }), mA.push({ key: "Resources", value: z + " 0 R" }), w.matrix && mA.push({ key: "Matrix", value: "[" + w.matrix.toString() + "]" }), hn({ data: w.stream, additionalKeyValues: mA, objectId: w.objectNumber }), E("endobj");
  }, Ma = function(w) {
    for (var L in w.objectNumber = Bt(), E("<<"), w) switch (L) {
      case "opacity":
        E("/ca " + U(w[L]));
        break;
      case "stroke-opacity":
        E("/CA " + U(w[L]));
    }
    E(">>"), E("endobj");
  }, ra = function(w) {
    Gt(w.resourcesOid, !0), E("<<"), E("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), (function() {
      for (var L in E("/Font <<"), Ce) Ce.hasOwnProperty(L) && (u === !1 || u === !0 && d.hasOwnProperty(L)) && E("/" + L + " " + Ce[L].objectNumber + " 0 R");
      E(">>");
    })(), (function() {
      if (Object.keys(ie).length > 0) {
        for (var L in E("/Shading <<"), ie) ie.hasOwnProperty(L) && ie[L] instanceof Qo && ie[L].objectNumber >= 0 && E("/" + L + " " + ie[L].objectNumber + " 0 R");
        ze.publish("putShadingPatternDict"), E(">>");
      }
    })(), (function(L) {
      if (Object.keys(ie).length > 0) {
        for (var z in E("/Pattern <<"), ie) ie.hasOwnProperty(z) && ie[z] instanceof h.TilingPattern && ie[z].objectNumber >= 0 && ie[z].objectNumber < L && E("/" + z + " " + ie[z].objectNumber + " 0 R");
        ze.publish("putTilingPatternDict"), E(">>");
      }
    })(w.objectOid), (function() {
      if (Object.keys(ge).length > 0) {
        var L;
        for (L in E("/ExtGState <<"), ge) ge.hasOwnProperty(L) && ge[L].objectNumber >= 0 && E("/" + L + " " + ge[L].objectNumber + " 0 R");
        ze.publish("putGStateDict"), E(">>");
      }
    })(), (function() {
      for (var L in E("/XObject <<"), Jt) Jt.hasOwnProperty(L) && Jt[L].objectNumber >= 0 && E("/" + L + " " + Jt[L].objectNumber + " 0 R");
      ze.publish("putXobjectDict"), E(">>");
    })(), E(">>"), E("endobj");
  }, Pa = function(w) {
    ae[w.fontName] = ae[w.fontName] || {}, ae[w.fontName][w.fontStyle] = w.id;
  }, ka = function(w, L, z, aA, mA) {
    var OA = { id: "F" + (Object.keys(Ce).length + 1).toString(10), postScriptName: w, fontName: L, fontStyle: z, encoding: aA, isStandardFont: mA || !1, metadata: {} };
    return ze.publish("addFont", { font: OA, instance: this }), Ce[OA.id] = OA, Pa(OA), OA.id;
  }, _n = h.__private__.pdfEscape = h.pdfEscape = function(w, L) {
    return (function(z, aA) {
      var mA, OA, jA, he, ce, _e, Me, Ze, Qr;
      if (jA = (aA = aA || {}).sourceEncoding || "Unicode", ce = aA.outputEncoding, (aA.autoencode || ce) && Ce[$A].metadata && Ce[$A].metadata[jA] && Ce[$A].metadata[jA].encoding && (he = Ce[$A].metadata[jA].encoding, !ce && Ce[$A].encoding && (ce = Ce[$A].encoding), !ce && he.codePages && (ce = he.codePages[0]), typeof ce == "string" && (ce = he[ce]), ce)) {
        for (Me = !1, _e = [], mA = 0, OA = z.length; mA < OA; mA++) (Ze = ce[z.charCodeAt(mA)]) ? _e.push(String.fromCharCode(Ze)) : _e.push(z[mA]), _e[mA].charCodeAt(0) >> 8 && (Me = !0);
        z = _e.join("");
      }
      for (mA = z.length; Me === void 0 && mA !== 0; ) z.charCodeAt(mA - 1) >> 8 && (Me = !0), mA--;
      if (!Me) return z;
      for (_e = aA.noBOM ? [] : [254, 255], mA = 0, OA = z.length; mA < OA; mA++) {
        if ((Qr = (Ze = z.charCodeAt(mA)) >> 8) >> 8) throw new Error("Character at position " + mA + " of string '" + z + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
        _e.push(Qr), _e.push(Ze - (Qr << 8));
      }
      return String.fromCharCode.apply(void 0, _e);
    })(w, L).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
  }, st = h.__private__.beginPage = function(w) {
    WA[++ue] = [], pe[ue] = { objId: 0, contentsObjId: 0, userUnit: Number(a), artBox: null, bleedBox: null, cropBox: null, trimBox: null, mediaBox: { bottomLeftX: 0, bottomLeftY: 0, topRightX: Number(w[0]), topRightY: Number(w[1]) } }, Ai(ue), uA(WA[W]);
  }, ns = function(w, L) {
    var z, aA, mA;
    switch (t = L || t, typeof w == "string" && (z = m(w.toLowerCase()), Array.isArray(z) && (aA = z[0], mA = z[1])), Array.isArray(w) && (aA = w[0] * ee, mA = w[1] * ee), isNaN(aA) && (aA = n[0], mA = n[1]), (aA > 14400 || mA > 14400) && (Ct.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), aA = Math.min(14400, aA), mA = Math.min(14400, mA)), n = [aA, mA], t.substr(0, 1)) {
      case "l":
        mA > aA && (n = [mA, aA]);
        break;
      case "p":
        aA > mA && (n = [mA, aA]);
    }
    st(n), Je(GA), E(na), $o !== 0 && E($o + " J"), Hs !== 0 && E(Hs + " j"), ze.publish("addPage", { pageNumber: ue });
  }, On = function(w) {
    w > 0 && w <= ue && (WA.splice(w, 1), pe.splice(w, 1), ue--, W > ue && (W = ue), this.setPage(W));
  }, Ai = function(w) {
    w > 0 && w <= ue && (W = w);
  }, Ka = h.__private__.getNumberOfPages = h.getNumberOfPages = function() {
    return WA.length - 1;
  }, is = function(w, L, z) {
    var aA, mA = void 0;
    return z = z || {}, w = w !== void 0 ? w : Ce[$A].fontName, L = L !== void 0 ? L : Ce[$A].fontStyle, aA = w.toLowerCase(), ae[aA] !== void 0 && ae[aA][L] !== void 0 ? mA = ae[aA][L] : ae[w] !== void 0 && ae[w][L] !== void 0 ? mA = ae[w][L] : z.disableWarning === !1 && Ct.warn("Unable to look up font label for font '" + w + "', '" + L + "'. Refer to getFontList() for available fonts."), mA || z.noFallback || (mA = ae.times[L]) == null && (mA = ae.times.normal), mA;
  }, Zr = h.__private__.putInfo = function() {
    var w = Bt(), L = function(aA) {
      return aA;
    };
    for (var z in c !== null && (L = Lt.encryptor(w, 0)), E("<<"), E("/Producer (" + _n(L("jsPDF " + we.version)) + ")"), VA) VA.hasOwnProperty(z) && VA[z] && E("/" + z.substr(0, 1).toUpperCase() + z.substr(1) + " (" + _n(L(VA[z])) + ")");
    E("/CreationDate (" + _n(L(iA)) + ")"), E(">>"), E("endobj");
  }, Ss = h.__private__.putCatalog = function(w) {
    var L = (w = w || {}).rootDictionaryObjId || hi;
    switch (Bt(), E("<<"), E("/Type /Catalog"), E("/Pages " + L + " 0 R"), EA || (EA = "fullwidth"), EA) {
      case "fullwidth":
        E("/OpenAction [3 0 R /FitH null]");
        break;
      case "fullheight":
        E("/OpenAction [3 0 R /FitV null]");
        break;
      case "fullpage":
        E("/OpenAction [3 0 R /Fit]");
        break;
      case "original":
        E("/OpenAction [3 0 R /XYZ null null 1]");
        break;
      default:
        var z = "" + EA;
        z.substr(z.length - 1) === "%" && (EA = parseInt(EA) / 100), typeof EA == "number" && E("/OpenAction [3 0 R /XYZ null null " + U(EA) + "]");
    }
    switch (TA || (TA = "continuous"), TA) {
      case "continuous":
        E("/PageLayout /OneColumn");
        break;
      case "single":
        E("/PageLayout /SinglePage");
        break;
      case "two":
      case "twoleft":
        E("/PageLayout /TwoColumnLeft");
        break;
      case "tworight":
        E("/PageLayout /TwoColumnRight");
    }
    SA && E("/PageMode /" + SA), ze.publish("putCatalog"), E(">>"), E("endobj");
  }, Va = h.__private__.putTrailer = function() {
    E("trailer"), E("<<"), E("/Size " + (oA + 1)), E("/Root " + oA + " 0 R"), E("/Info " + (oA - 1) + " 0 R"), c !== null && E("/Encrypt " + Lt.oid + " 0 R"), E("/ID [ <" + nA + "> <" + nA + "> ]"), E(">>");
  }, St = h.__private__.putHeader = function() {
    E("%PDF-" + p), E("%ºß¬à");
  }, ss = h.__private__.putXRef = function() {
    var w = "0000000000";
    E("xref"), E("0 " + (oA + 1)), E("0000000000 65535 f ");
    for (var L = 1; L <= oA; L++) typeof gA[L] == "function" ? E((w + gA[L]()).slice(-10) + " 00000 n ") : gA[L] !== void 0 ? E((w + gA[L]).slice(-10) + " 00000 n ") : E("0000000000 00000 n ");
  }, qr = h.__private__.buildDocument = function() {
    var w;
    oA = 0, IA = 0, xA = [], gA = [], pA = [], hi = er(), Hr = er(), uA(xA), ze.publish("buildDocument"), St(), Nt(), (function() {
      ze.publish("putAdditionalObjects");
      for (var z = 0; z < pA.length; z++) {
        var aA = pA[z];
        Gt(aA.objId, !0), E(aA.content), E("endobj");
      }
      ze.publish("postPutAdditionalObjects");
    })(), w = [], (function() {
      for (var z in Ce) Ce.hasOwnProperty(z) && (u === !1 || u === !0 && d.hasOwnProperty(z)) && Si(Ce[z]);
    })(), (function() {
      var z;
      for (z in ge) ge.hasOwnProperty(z) && Ma(ge[z]);
    })(), (function() {
      for (var z in Jt) Jt.hasOwnProperty(z) && ts(Jt[z]);
    })(), (function(z) {
      var aA;
      for (aA in ie) ie.hasOwnProperty(aA) && (ie[aA] instanceof Qo ? Li(ie[aA]) : ie[aA] instanceof Ll && rs(ie[aA], z));
    })(w), ze.publish("putResources"), w.forEach(ra), ra({ resourcesOid: Hr, objectOid: Number.MAX_SAFE_INTEGER }), ze.publish("postPutResources"), c !== null && (Lt.oid = Bt(), E("<<"), E("/Filter /Standard"), E("/V " + Lt.v), E("/R " + Lt.r), E("/U <" + Lt.toHexString(Lt.U) + ">"), E("/O <" + Lt.toHexString(Lt.O) + ">"), E("/P " + Lt.P), E(">>"), E("endobj")), Zr(), Ss();
    var L = IA;
    return ss(), Va(), E("startxref"), E("" + L), E("%%EOF"), uA(WA[W]), xA.join(`
`);
  }, Nn = h.__private__.getBlob = function(w) {
    return new Blob([vA(w)], { type: "application/pdf" });
  }, Dn = function(w) {
    for (; w.firstChild; ) w.removeChild(w.firstChild);
  }, hr = function(w) {
    var L, z = w.document, aA = z.documentElement, mA = z.head, OA = z.body;
    return mA || (mA = z.createElement("head"), aA.appendChild(mA)), OA || (OA = z.createElement("body"), aA.appendChild(OA)), Dn(mA), Dn(OA), (L = z.createElement("style")).appendChild(z.createTextNode("html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}")), mA.appendChild(L), { document: z, body: OA };
  }, Tr = h.output = h.__private__.output = (Ar = function(w, L) {
    switch (typeof (L = L || {}) == "string" ? L = { filename: L } : L.filename = L.filename || "generated.pdf", w) {
      case void 0:
        return qr();
      case "save":
        h.save(L.filename);
        break;
      case "arraybuffer":
        return vA(qr());
      case "blob":
        return Nn(qr());
      case "bloburi":
      case "bloburl":
        if (He.URL !== void 0 && typeof He.URL.createObjectURL == "function") return He.URL && He.URL.createObjectURL(Nn(qr())) || void 0;
        Ct.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
        break;
      case "datauristring":
      case "dataurlstring":
        var z = "", aA = qr();
        try {
          z = ZF(aA);
        } catch {
          z = ZF(unescape(encodeURIComponent(aA)));
        }
        return "data:application/pdf;filename=" + encodeURIComponent(L.filename) + ";base64," + z;
      case "pdfobjectnewwindow":
        if (Object.prototype.toString.call(He) === "[object Window]") {
          var mA = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", OA = !L.pdfObjectUrl;
          OA || (mA = L.pdfObjectUrl);
          var jA = He.open();
          if (jA !== null) {
            var he = hr(jA), ce = he.document.createElement("script"), _e = this;
            ce.src = mA, OA && (ce.integrity = "sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==", ce.crossOrigin = "anonymous"), ce.onload = function() {
              jA.PDFObject.embed(_e.output("dataurlstring"), L);
            }, he.body.appendChild(ce);
          }
          return jA;
        }
        throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
      case "pdfjsnewwindow":
        if (Object.prototype.toString.call(He) === "[object Window]") {
          var Me = L.pdfJsUrl || "examples/PDF.js/web/viewer.html", Ze = He.open();
          if (Ze !== null) {
            var Qr = hr(Ze), vt = Qr.document.createElement("iframe"), wt = Me.indexOf("?") === -1 ? "?" : "&";
            _e = this, vt.id = "pdfViewer", vt.width = "500px", vt.height = "400px", vt.src = Me + wt + "file=&downloadName=" + encodeURIComponent(L.filename), vt.onload = function() {
              Ze.document.title = L.filename, vt.contentWindow.PDFViewerApplication.open(_e.output("bloburl"));
            }, Qr.body.appendChild(vt);
          }
          return Ze;
        }
        throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
      case "dataurlnewwindow":
        if (Object.prototype.toString.call(He) !== "[object Window]") throw new Error("The option dataurlnewwindow just works in a browser-environment.");
        var Ht = He.open();
        if (Ht !== null) {
          var jt = hr(Ht), qt = jt.document.createElement("iframe");
          qt.src = this.output("datauristring", L), jt.body.appendChild(qt), Ht.document.title = L.filename;
        }
        if (Ht || typeof safari > "u") return Ht;
        break;
      case "datauri":
      case "dataurl":
        return He.document.location.href = this.output("datauristring", L);
      default:
        return null;
    }
  }, Ar.foo = function() {
    try {
      return Ar.apply(this, arguments);
    } catch (z) {
      var w = z.stack || "";
      ~w.indexOf(" at ") && (w = w.split(" at ")[1]);
      var L = "Error in function " + w.split(`
`)[0].split("<")[0] + ": " + z.message;
      if (!He.console) throw new Error(L);
      He.console.error(L, z), He.alert && alert(L);
    }
  }, Ar.foo.bar = Ar, Ar.foo), Rn = function(w) {
    return Array.isArray(Ii) === !0 && Ii.indexOf(w) > -1;
  };
  switch (r) {
    case "pt":
      ee = 1;
      break;
    case "mm":
      ee = 72 / 25.4;
      break;
    case "cm":
      ee = 72 / 2.54;
      break;
    case "in":
      ee = 72;
      break;
    case "px":
      ee = Rn("px_scaling") == 1 ? 0.75 : 96 / 72;
      break;
    case "pc":
    case "em":
      ee = 12;
      break;
    case "ex":
      ee = 6;
      break;
    default:
      if (typeof r != "number") throw new Error("Invalid unit: " + r);
      ee = r;
  }
  var Lt = null;
  CA(), tA();
  var Ga = h.__private__.getPageInfo = h.getPageInfo = function(w) {
    if (isNaN(w) || w % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
    return { objId: pe[w].objId, pageNumber: w, pageContext: pe[w] };
  }, Wa = h.__private__.getPageInfoByObjId = function(w) {
    if (isNaN(w) || w % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
    for (var L in pe) if (pe[L].objId === w) break;
    return Ga(L);
  }, ja = h.__private__.getCurrentPageInfo = h.getCurrentPageInfo = function() {
    return { objId: pe[W].objId, pageNumber: W, pageContext: pe[W] };
  };
  h.addPage = function() {
    return ns.apply(this, arguments), this;
  }, h.setPage = function() {
    return Ai.apply(this, arguments), uA.call(this, WA[W]), this;
  }, h.insertPage = function(w) {
    return this.addPage(), this.movePage(W, w), this;
  }, h.movePage = function(w, L) {
    var z, aA;
    if (w > L) {
      z = WA[w], aA = pe[w];
      for (var mA = w; mA > L; mA--) WA[mA] = WA[mA - 1], pe[mA] = pe[mA - 1];
      WA[L] = z, pe[L] = aA, this.setPage(L);
    } else if (w < L) {
      z = WA[w], aA = pe[w];
      for (var OA = w; OA < L; OA++) WA[OA] = WA[OA + 1], pe[OA] = pe[OA + 1];
      WA[L] = z, pe[L] = aA, this.setPage(L);
    }
    return this;
  }, h.deletePage = function() {
    return On.apply(this, arguments), this;
  }, h.__private__.text = h.text = function(w, L, z, aA, mA) {
    var OA, jA, he, ce, _e, Me, Ze, Qr, vt, wt = (aA = aA || {}).scope || this;
    if (typeof w == "number" && typeof L == "number" && (typeof z == "string" || Array.isArray(z))) {
      var Ht = z;
      z = L, L = w, w = Ht;
    }
    if (arguments[3] instanceof Be == 0 ? (he = arguments[4], ce = arguments[5], it(Ze = arguments[3]) === "object" && Ze !== null || (typeof he == "string" && (ce = he, he = null), typeof Ze == "string" && (ce = Ze, Ze = null), typeof Ze == "number" && (he = Ze, Ze = null), aA = { flags: Ze, angle: he, align: ce })) : (I("The transform parameter of text() with a Matrix value"), vt = mA), isNaN(L) || isNaN(z) || w == null) throw new Error("Invalid arguments passed to jsPDF.text");
    if (w.length === 0) return wt;
    var jt, qt = "", gn = typeof aA.lineHeightFactor == "number" ? aA.lineHeightFactor : Ae, oa = wt.internal.scaleFactor;
    function ou(Qt) {
      return Qt = Qt.split("	").join(Array(aA.TabLen || 9).join(" ")), _n(Qt, Ze);
    }
    function Xo(Qt) {
      for (var Ut, fr = Qt.concat(), Or = [], ca = fr.length; ca--; ) typeof (Ut = fr.shift()) == "string" ? Or.push(Ut) : Array.isArray(Qt) && (Ut.length === 1 || Ut[1] === void 0 && Ut[2] === void 0) ? Or.push(Ut[0]) : Or.push([Ut[0], Ut[1], Ut[2]]);
      return Or;
    }
    function Yo(Qt, Ut) {
      var fr;
      if (typeof Qt == "string") fr = Ut(Qt)[0];
      else if (Array.isArray(Qt)) {
        for (var Or, ca, du = Qt.concat(), gc = [], pf = du.length; pf--; ) typeof (Or = du.shift()) == "string" ? gc.push(Ut(Or)[0]) : Array.isArray(Or) && typeof Or[0] == "string" && (ca = Ut(Or[0], Or[1], Or[2]), gc.push([ca[0], ca[1], ca[2]]));
        fr = gc;
      }
      return fr;
    }
    var Ja = !1, Jo = !0;
    if (typeof w == "string") Ja = !0;
    else if (Array.isArray(w)) {
      var ac = w.concat();
      jA = [];
      for (var oc, pn = ac.length; pn--; ) (typeof (oc = ac.shift()) != "string" || Array.isArray(oc) && typeof oc[0] != "string") && (Jo = !1);
      Ja = Jo;
    }
    if (Ja === !1) throw new Error('Type of text must be string or Array. "' + w + '" is not recognized.');
    typeof w == "string" && (w = w.match(/[\r?\n]/) ? w.split(/\r\n|\r|\n/g) : [w]);
    var Zo = fA / wt.internal.scaleFactor, Al = Zo * (gn - 1);
    switch (aA.baseline) {
      case "bottom":
        z -= Al;
        break;
      case "top":
        z += Zo - Al;
        break;
      case "hanging":
        z += Zo - 2 * Al;
        break;
      case "middle":
        z += Zo / 2 - Al;
    }
    if ((Me = aA.maxWidth || 0) > 0 && (typeof w == "string" ? w = wt.splitTextToSize(w, Me) : Object.prototype.toString.call(w) === "[object Array]" && (w = w.reduce(function(Qt, Ut) {
      return Qt.concat(wt.splitTextToSize(Ut, Me));
    }, []))), OA = { text: w, x: L, y: z, options: aA, mutex: { pdfEscape: _n, activeFontKey: $A, fonts: Ce, activeFontSize: fA } }, ze.publish("preProcessText", OA), w = OA.text, he = (aA = OA.options).angle, vt instanceof Be == 0 && he && typeof he == "number") {
      he *= Math.PI / 180, aA.rotationDirection === 0 && (he = -he), F === Q && (he = -he);
      var lu = Math.cos(he), Ts = Math.sin(he);
      vt = new Be(lu, Ts, -Ts, lu, 0, 0);
    } else he && he instanceof Be && (vt = he);
    F !== Q || vt || (vt = Zt), (_e = aA.charSpace || ia) !== void 0 && (qt += D(P(_e)) + ` Tc
`, this.setCharSpace(this.getCharSpace() || 0)), (Qr = aA.horizontalScale) !== void 0 && (qt += D(100 * Qr) + ` Tz
`), aA.lang;
    var Kn = -1, df = aA.renderingMode !== void 0 ? aA.renderingMode : aA.stroke, lc = wt.internal.getCurrentPageInfo().pageContext;
    switch (df) {
      case 0:
      case !1:
      case "fill":
        Kn = 0;
        break;
      case 1:
      case !0:
      case "stroke":
        Kn = 1;
        break;
      case 2:
      case "fillThenStroke":
        Kn = 2;
        break;
      case 3:
      case "invisible":
        Kn = 3;
        break;
      case 4:
      case "fillAndAddForClipping":
        Kn = 4;
        break;
      case 5:
      case "strokeAndAddPathForClipping":
        Kn = 5;
        break;
      case 6:
      case "fillThenStrokeAndAddToPathForClipping":
        Kn = 6;
        break;
      case 7:
      case "addToPathForClipping":
        Kn = 7;
    }
    var gf = lc.usedRenderingMode !== void 0 ? lc.usedRenderingMode : -1;
    Kn !== -1 ? qt += Kn + ` Tr
` : gf !== -1 && (qt += `0 Tr
`), Kn !== -1 && (lc.usedRenderingMode = Kn), ce = aA.align || "left";
    var _i, el = fA * gn, cu = wt.internal.pageSize.getWidth(), cc = Ce[$A];
    _e = aA.charSpace || ia, Me = aA.maxWidth || 0, Ze = Object.assign({ autoencode: !0, noBOM: !0 }, aA.flags);
    var tl = [], uu = function(Qt) {
      return wt.getStringUnitWidth(Qt, { font: cc, charSpace: _e, fontSize: fA, doKerning: !1 }) * fA / oa;
    };
    if (Object.prototype.toString.call(w) === "[object Array]") {
      var Vn;
      jA = Xo(w), ce !== "left" && (_i = jA.map(uu));
      var ei, uc = 0;
      if (ce === "right") {
        L -= _i[0], w = [], pn = jA.length;
        for (var Za = 0; Za < pn; Za++) Za === 0 ? (ei = kn(L), Vn = et(z)) : (ei = P(uc - _i[Za]), Vn = -el), w.push([jA[Za], ei, Vn]), uc = _i[Za];
      } else if (ce === "center") {
        L -= _i[0] / 2, w = [], pn = jA.length;
        for (var Ao = 0; Ao < pn; Ao++) Ao === 0 ? (ei = kn(L), Vn = et(z)) : (ei = P((uc - _i[Ao]) / 2), Vn = -el), w.push([jA[Ao], ei, Vn]), uc = _i[Ao];
      } else if (ce === "left") {
        w = [], pn = jA.length;
        for (var hc = 0; hc < pn; hc++) w.push(jA[hc]);
      } else if (ce === "justify" && cc.encoding === "Identity-H") {
        w = [], pn = jA.length, Me = Me !== 0 ? Me : cu;
        for (var rl = 0, Ur = 0; Ur < pn; Ur++) if (Vn = Ur === 0 ? et(z) : -el, ei = Ur === 0 ? kn(L) : rl, Ur < pn - 1) {
          var Vp = P((Me - _i[Ur]) / (jA[Ur].split(" ").length - 1)), _s = jA[Ur].split(" ");
          w.push([_s[0] + " ", ei, Vn]), rl = 0;
          for (var as = 1; as < _s.length; as++) {
            var nl = (uu(_s[as - 1] + " " + _s[as]) - uu(_s[as])) * oa + Vp;
            as == _s.length - 1 ? w.push([_s[as], nl, 0]) : w.push([_s[as] + " ", nl, 0]), rl -= nl;
          }
        } else w.push([jA[Ur], ei, Vn]);
        w.push(["", rl, 0]);
      } else {
        if (ce !== "justify") throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
        for (w = [], pn = jA.length, Me = Me !== 0 ? Me : cu, Ur = 0; Ur < pn; Ur++) {
          Vn = Ur === 0 ? et(z) : -el, ei = Ur === 0 ? kn(L) : 0;
          var hu = jA[Ur].split(" ").length - 1, fu = hu > 0 ? (Me - _i[Ur]) / hu : 0;
          Ur < pn - 1 ? tl.push(D(P(fu))) : tl.push(0), w.push([jA[Ur], ei, Vn]);
        }
      }
    }
    (typeof aA.R2L == "boolean" ? aA.R2L : HA) === !0 && (w = Yo(w, function(Qt, Ut, fr) {
      return [Qt.split("").reverse().join(""), Ut, fr];
    })), OA = { text: w, x: L, y: z, options: aA, mutex: { pdfEscape: _n, activeFontKey: $A, fonts: Ce, activeFontSize: fA } }, ze.publish("postProcessText", OA), w = OA.text, jt = OA.mutex.isHex || !1;
    var fc = Ce[$A].encoding;
    fc !== "WinAnsiEncoding" && fc !== "StandardEncoding" || (w = Yo(w, function(Qt, Ut, fr) {
      return [ou(Qt), Ut, fr];
    })), jA = Xo(w), w = [];
    for (var il, sl, eo, la = Array.isArray(jA[0]) ? 1 : 0, to = "", dc = function(Qt, Ut, fr) {
      var Or = "";
      return fr instanceof Be ? (fr = typeof aA.angle == "number" ? Jr(fr, new Be(1, 0, 0, 1, Qt, Ut)) : Jr(new Be(1, 0, 0, 1, Qt, Ut), fr), F === Q && (fr = Jr(new Be(1, 0, 0, -1, 0, 0), fr)), Or = fr.join(" ") + ` Tm
`) : Or = D(Qt) + " " + D(Ut) + ` Td
`, Or;
    }, Bn = 0; Bn < jA.length; Bn++) {
      switch (to = "", la) {
        case 1:
          eo = (jt ? "<" : "(") + jA[Bn][0] + (jt ? ">" : ")"), il = parseFloat(jA[Bn][1]), sl = parseFloat(jA[Bn][2]);
          break;
        case 0:
          eo = (jt ? "<" : "(") + jA[Bn] + (jt ? ">" : ")"), il = kn(L), sl = et(z);
      }
      tl !== void 0 && tl[Bn] !== void 0 && (to = tl[Bn] + ` Tw
`), Bn === 0 ? w.push(to + dc(il, sl, vt) + eo) : la === 0 ? w.push(to + eo) : la === 1 && w.push(to + dc(il, sl, vt) + eo);
    }
    w = la === 0 ? w.join(` Tj
T* `) : w.join(` Tj
`), w += ` Tj
`;
    var Os = `BT
/`;
    return Os += $A + " " + fA + ` Tf
`, Os += D(fA * gn) + ` TL
`, Os += Ti + `
`, Os += qt, Os += w, E(Os += "ET"), d[$A] = !0, wt;
  };
  var qa = h.__private__.clip = h.clip = function(w) {
    return E(w === "evenodd" ? "W*" : "W"), this;
  };
  h.clipEvenOdd = function() {
    return qa("evenodd");
  }, h.__private__.discardPath = h.discardPath = function() {
    return E("n"), this;
  };
  var Mn = h.__private__.isValidStyle = function(w) {
    var L = !1;
    return [void 0, null, "S", "D", "F", "DF", "FD", "f", "f*", "B", "B*", "n"].indexOf(w) !== -1 && (L = !0), L;
  };
  h.__private__.setDefaultPathOperation = h.setDefaultPathOperation = function(w) {
    return Mn(w) && (l = w), this;
  };
  var Hi = h.__private__.getStyle = h.getStyle = function(w) {
    var L = l;
    switch (w) {
      case "D":
      case "S":
        L = "S";
        break;
      case "F":
        L = "f";
        break;
      case "FD":
      case "DF":
        L = "B";
        break;
      case "f":
      case "f*":
      case "B":
      case "B*":
        L = w;
    }
    return L;
  }, fi = h.close = function() {
    return E("h"), this;
  };
  h.stroke = function() {
    return E("S"), this;
  }, h.fill = function(w) {
    return An("f", w), this;
  }, h.fillEvenOdd = function(w) {
    return An("f*", w), this;
  }, h.fillStroke = function(w) {
    return An("B", w), this;
  }, h.fillStrokeEvenOdd = function(w) {
    return An("B*", w), this;
  };
  var An = function(w, L) {
    it(L) === "object" ? dn(L, w) : E(w);
  }, fn = function(w) {
    w === null || F === Q && w === void 0 || (w = Hi(w), E(w));
  };
  function _r(w, L, z, aA, mA) {
    var OA = new Ll(L || this.boundingBox, z || this.xStep, aA || this.yStep, this.gState, mA || this.matrix);
    OA.stream = this.stream;
    var jA = w + "$$" + this.cloneIndex++ + "$$";
    return Vt(jA, OA), OA;
  }
  var dn = function(w, L) {
    var z = Ke[w.key], aA = ie[z];
    if (aA instanceof Qo) E("q"), E(Pn(L)), aA.gState && h.setGState(aA.gState), E(w.matrix.toString() + " cm"), E("/" + z + " sh"), E("Q");
    else if (aA instanceof Ll) {
      var mA = new Be(1, 0, 0, -1, 0, Wt());
      w.matrix && (mA = mA.multiply(w.matrix || Zt), z = _r.call(aA, w.key, w.boundingBox, w.xStep, w.yStep, mA).id), E("q"), E("/Pattern cs"), E("/" + z + " scn"), aA.gState && h.setGState(aA.gState), E(L), E("Q");
    }
  }, Pn = function(w) {
    switch (w) {
      case "f":
      case "F":
      case "n":
        return "W n";
      case "f*":
        return "W* n";
      case "B":
      case "S":
        return "W S";
      case "B*":
        return "W* S";
    }
  }, zA = h.moveTo = function(w, L) {
    return E(D(P(w)) + " " + D(N(L)) + " m"), this;
  }, $ = h.lineTo = function(w, L) {
    return E(D(P(w)) + " " + D(N(L)) + " l"), this;
  }, wA = h.curveTo = function(w, L, z, aA, mA, OA) {
    return E([D(P(w)), D(N(L)), D(P(z)), D(N(aA)), D(P(mA)), D(N(OA)), "c"].join(" ")), this;
  };
  h.__private__.line = h.line = function(w, L, z, aA, mA) {
    if (isNaN(w) || isNaN(L) || isNaN(z) || isNaN(aA) || !Mn(mA)) throw new Error("Invalid arguments passed to jsPDF.line");
    return F === C ? this.lines([[z - w, aA - L]], w, L, [1, 1], mA || "S") : this.lines([[z - w, aA - L]], w, L, [1, 1]).stroke();
  }, h.__private__.lines = h.lines = function(w, L, z, aA, mA, OA) {
    var jA, he, ce, _e, Me, Ze, Qr, vt, wt, Ht, jt, qt;
    if (typeof w == "number" && (qt = z, z = L, L = w, w = qt), aA = aA || [1, 1], OA = OA || !1, isNaN(L) || isNaN(z) || !Array.isArray(w) || !Array.isArray(aA) || !Mn(mA) || typeof OA != "boolean") throw new Error("Invalid arguments passed to jsPDF.lines");
    for (zA(L, z), jA = aA[0], he = aA[1], _e = w.length, Ht = L, jt = z, ce = 0; ce < _e; ce++) (Me = w[ce]).length === 2 ? (Ht = Me[0] * jA + Ht, jt = Me[1] * he + jt, $(Ht, jt)) : (Ze = Me[0] * jA + Ht, Qr = Me[1] * he + jt, vt = Me[2] * jA + Ht, wt = Me[3] * he + jt, Ht = Me[4] * jA + Ht, jt = Me[5] * he + jt, wA(Ze, Qr, vt, wt, Ht, jt));
    return OA && fi(), fn(mA), this;
  }, h.path = function(w) {
    for (var L = 0; L < w.length; L++) {
      var z = w[L], aA = z.c;
      switch (z.op) {
        case "m":
          zA(aA[0], aA[1]);
          break;
        case "l":
          $(aA[0], aA[1]);
          break;
        case "c":
          wA.apply(this, aA);
          break;
        case "h":
          fi();
      }
    }
    return this;
  }, h.__private__.rect = h.rect = function(w, L, z, aA, mA) {
    if (isNaN(w) || isNaN(L) || isNaN(z) || isNaN(aA) || !Mn(mA)) throw new Error("Invalid arguments passed to jsPDF.rect");
    return F === C && (aA = -aA), E([D(P(w)), D(N(L)), D(P(z)), D(P(aA)), "re"].join(" ")), fn(mA), this;
  }, h.__private__.triangle = h.triangle = function(w, L, z, aA, mA, OA, jA) {
    if (isNaN(w) || isNaN(L) || isNaN(z) || isNaN(aA) || isNaN(mA) || isNaN(OA) || !Mn(jA)) throw new Error("Invalid arguments passed to jsPDF.triangle");
    return this.lines([[z - w, aA - L], [mA - z, OA - aA], [w - mA, L - OA]], w, L, [1, 1], jA, !0), this;
  }, h.__private__.roundedRect = h.roundedRect = function(w, L, z, aA, mA, OA, jA) {
    if (isNaN(w) || isNaN(L) || isNaN(z) || isNaN(aA) || isNaN(mA) || isNaN(OA) || !Mn(jA)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
    var he = 4 / 3 * (Math.SQRT2 - 1);
    return mA = Math.min(mA, 0.5 * z), OA = Math.min(OA, 0.5 * aA), this.lines([[z - 2 * mA, 0], [mA * he, 0, mA, OA - OA * he, mA, OA], [0, aA - 2 * OA], [0, OA * he, -mA * he, OA, -mA, OA], [2 * mA - z, 0], [-mA * he, 0, -mA, -OA * he, -mA, -OA], [0, 2 * OA - aA], [0, -OA * he, mA * he, -OA, mA, -OA]], w + mA, L, [1, 1], jA, !0), this;
  }, h.__private__.ellipse = h.ellipse = function(w, L, z, aA, mA) {
    if (isNaN(w) || isNaN(L) || isNaN(z) || isNaN(aA) || !Mn(mA)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
    var OA = 4 / 3 * (Math.SQRT2 - 1) * z, jA = 4 / 3 * (Math.SQRT2 - 1) * aA;
    return zA(w + z, L), wA(w + z, L - jA, w + OA, L - aA, w, L - aA), wA(w - OA, L - aA, w - z, L - jA, w - z, L), wA(w - z, L + jA, w - OA, L + aA, w, L + aA), wA(w + OA, L + aA, w + z, L + jA, w + z, L), fn(mA), this;
  }, h.__private__.circle = h.circle = function(w, L, z, aA) {
    if (isNaN(w) || isNaN(L) || isNaN(z) || !Mn(aA)) throw new Error("Invalid arguments passed to jsPDF.circle");
    return this.ellipse(w, L, z, z, aA);
  }, h.setFont = function(w, L, z) {
    return z && (L = M(L, z)), $A = is(w, L, { disableWarning: !1 }), this;
  };
  var PA = h.__private__.getFont = h.getFont = function() {
    return Ce[is.apply(h, arguments)];
  };
  h.__private__.getFontList = h.getFontList = function() {
    var w, L, z = {};
    for (w in ae) if (ae.hasOwnProperty(w)) for (L in z[w] = [], ae[w]) ae[w].hasOwnProperty(L) && z[w].push(L);
    return z;
  }, h.addFont = function(w, L, z, aA, mA) {
    var OA = ["StandardEncoding", "MacRomanEncoding", "Identity-H", "WinAnsiEncoding"];
    return arguments[3] && OA.indexOf(arguments[3]) !== -1 ? mA = arguments[3] : arguments[3] && OA.indexOf(arguments[3]) == -1 && (z = M(z, aA)), ka.call(this, w, L, z, mA = mA || "Identity-H");
  };
  var Ae, GA = e.lineWidth || 0.200025, Qe = h.__private__.getLineWidth = h.getLineWidth = function() {
    return GA;
  }, Je = h.__private__.setLineWidth = h.setLineWidth = function(w) {
    return GA = w, E(D(P(w)) + " w"), this;
  };
  h.__private__.setLineDash = we.API.setLineDash = we.API.setLineDashPattern = function(w, L) {
    if (w = w || [], L = L || 0, isNaN(L) || !Array.isArray(w)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
    return w = w.map(function(z) {
      return D(P(z));
    }).join(" "), L = D(P(L)), E("[" + w + "] " + L + " d"), this;
  };
  var ot = h.__private__.getLineHeight = h.getLineHeight = function() {
    return fA * Ae;
  };
  h.__private__.getLineHeight = h.getLineHeight = function() {
    return fA * Ae;
  };
  var rr = h.__private__.setLineHeightFactor = h.setLineHeightFactor = function(w) {
    return typeof (w = w || 1.15) == "number" && (Ae = w), this;
  }, Fr = h.__private__.getLineHeightFactor = h.getLineHeightFactor = function() {
    return Ae;
  };
  rr(e.lineHeight);
  var kn = h.__private__.getHorizontalCoordinate = function(w) {
    return P(w);
  }, et = h.__private__.getVerticalCoordinate = function(w) {
    return F === Q ? w : pe[W].mediaBox.topRightY - pe[W].mediaBox.bottomLeftY - P(w);
  }, Ls = h.__private__.getHorizontalCoordinateString = h.getHorizontalCoordinateString = function(w) {
    return D(kn(w));
  }, $a = h.__private__.getVerticalCoordinateString = h.getVerticalCoordinateString = function(w) {
    return D(et(w));
  }, na = e.strokeColor || "0 G";
  h.__private__.getStrokeColor = h.getDrawColor = function() {
    return jr(na);
  }, h.__private__.setStrokeColor = h.setDrawColor = function(w, L, z, aA) {
    return na = tr({ ch1: w, ch2: L, ch3: z, ch4: aA, pdfColorType: "draw", precision: 2 }), E(na), this;
  };
  var za = e.fillColor || "0 g";
  h.__private__.getFillColor = h.getFillColor = function() {
    return jr(za);
  }, h.__private__.setFillColor = h.setFillColor = function(w, L, z, aA) {
    return za = tr({ ch1: w, ch2: L, ch3: z, ch4: aA, pdfColorType: "fill", precision: 2 }), E(za), this;
  };
  var Ti = e.textColor || "0 g", ff = h.__private__.getTextColor = h.getTextColor = function() {
    return jr(Ti);
  };
  h.__private__.setTextColor = h.setTextColor = function(w, L, z, aA) {
    return Ti = tr({ ch1: w, ch2: L, ch3: z, ch4: aA, pdfColorType: "text", precision: 3 }), this;
  };
  var ia = e.charSpace, Xa = h.__private__.getCharSpace = h.getCharSpace = function() {
    return parseFloat(ia || 0);
  };
  h.__private__.setCharSpace = h.setCharSpace = function(w) {
    if (isNaN(w)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
    return ia = w, this;
  };
  var $o = 0;
  h.CapJoinStyles = { 0: 0, butt: 0, but: 0, miter: 0, 1: 1, round: 1, rounded: 1, circle: 1, 2: 2, projecting: 2, project: 2, square: 2, bevel: 2 }, h.__private__.setLineCap = h.setLineCap = function(w) {
    var L = h.CapJoinStyles[w];
    if (L === void 0) throw new Error("Line cap style of '" + w + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return $o = L, E(L + " J"), this;
  };
  var Hs = 0;
  h.__private__.setLineJoin = h.setLineJoin = function(w) {
    var L = h.CapJoinStyles[w];
    if (L === void 0) throw new Error("Line join style of '" + w + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return Hs = L, E(L + " j"), this;
  }, h.__private__.setLineMiterLimit = h.__private__.setMiterLimit = h.setLineMiterLimit = h.setMiterLimit = function(w) {
    if (w = w || 0, isNaN(w)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
    return E(D(P(w)) + " M"), this;
  }, h.GState = Vh, h.setGState = function(w) {
    (w = typeof w == "string" ? ge[xe[w]] : Ya(null, w)).equals(Ye) || (E("/" + w.id + " gs"), Ye = w);
  };
  var Ya = function(w, L) {
    if (!w || !xe[w]) {
      var z = !1;
      for (var aA in ge) if (ge.hasOwnProperty(aA) && ge[aA].equals(L)) {
        z = !0;
        break;
      }
      if (z) L = ge[aA];
      else {
        var mA = "GS" + (Object.keys(ge).length + 1).toString(10);
        ge[mA] = L, L.id = mA;
      }
      return w && (xe[w] = L.id), ze.publish("addGState", L), L;
    }
  };
  h.addGState = function(w, L) {
    return Ya(w, L), this;
  }, h.saveGraphicsState = function() {
    return E("q"), Te.push({ key: $A, size: fA, color: Ti }), this;
  }, h.restoreGraphicsState = function() {
    E("Q");
    var w = Te.pop();
    return $A = w.key, fA = w.size, Ti = w.color, Ye = null, this;
  }, h.setCurrentTransformationMatrix = function(w) {
    return E(w.toString() + " cm"), this;
  }, h.comment = function(w) {
    return E("#" + w), this;
  };
  var sa = function(w, L) {
    var z = w || 0;
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return z;
    }, set: function(OA) {
      isNaN(OA) || (z = parseFloat(OA));
    } });
    var aA = L || 0;
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return aA;
    }, set: function(OA) {
      isNaN(OA) || (aA = parseFloat(OA));
    } });
    var mA = "pt";
    return Object.defineProperty(this, "type", { enumerable: !0, get: function() {
      return mA;
    }, set: function(OA) {
      mA = OA.toString();
    } }), this;
  }, zo = function(w, L, z, aA) {
    sa.call(this, w, L), this.type = "rect";
    var mA = z || 0;
    Object.defineProperty(this, "w", { enumerable: !0, get: function() {
      return mA;
    }, set: function(jA) {
      isNaN(jA) || (mA = parseFloat(jA));
    } });
    var OA = aA || 0;
    return Object.defineProperty(this, "h", { enumerable: !0, get: function() {
      return OA;
    }, set: function(jA) {
      isNaN(jA) || (OA = parseFloat(jA));
    } }), this;
  }, aa = function() {
    this.page = ue, this.currentPage = W, this.pages = WA.slice(0), this.pagesContext = pe.slice(0), this.x = ZA, this.y = Fe, this.matrix = me, this.width = LA(W), this.height = JA(W), this.outputDestination = X, this.id = "", this.objectNumber = -1;
  };
  aa.prototype.restore = function() {
    ue = this.page, W = this.currentPage, pe = this.pagesContext, WA = this.pages, ZA = this.x, Fe = this.y, me = this.matrix, kA(W, this.width), Ue(W, this.height), X = this.outputDestination;
  };
  var G = function(w, L, z, aA, mA) {
    un.push(new aa()), ue = W = 0, WA = [], ZA = w, Fe = L, me = mA, st([z, aA]);
  };
  for (var O in h.beginFormObject = function(w, L, z, aA, mA) {
    return G(w, L, z, aA, mA), this;
  }, h.endFormObject = function(w) {
    return (function(L) {
      if (Wr[L]) un.pop().restore();
      else {
        var z = new aa(), aA = "Xo" + (Object.keys(Jt).length + 1).toString(10);
        z.id = aA, Wr[L] = aA, Jt[aA] = z, ze.publish("addFormObject", z), un.pop().restore();
      }
    })(w), this;
  }, h.doFormObject = function(w, L) {
    var z = Jt[Wr[w]];
    return E("q"), E(L.toString() + " cm"), E("/" + z.id + " Do"), E("Q"), this;
  }, h.getFormObject = function(w) {
    var L = Jt[Wr[w]];
    return { x: L.x, y: L.y, width: L.width, height: L.height, matrix: L.matrix };
  }, h.save = function(w, L) {
    return w = w || "generated.pdf", (L = L || {}).returnPromise = L.returnPromise || !1, L.returnPromise === !1 ? (wl(Nn(qr()), w), typeof wl.unload == "function" && He.setTimeout && setTimeout(wl.unload, 911), this) : new Promise(function(z, aA) {
      try {
        var mA = wl(Nn(qr()), w);
        typeof wl.unload == "function" && He.setTimeout && setTimeout(wl.unload, 911), z(mA);
      } catch (OA) {
        aA(OA.message);
      }
    });
  }, we.API) we.API.hasOwnProperty(O) && (O === "events" && we.API.events.length ? (function(w, L) {
    var z, aA, mA;
    for (mA = L.length - 1; mA !== -1; mA--) z = L[mA][0], aA = L[mA][1], w.subscribe.apply(w, [z].concat(typeof aA == "function" ? [aA] : aA));
  })(ze, we.API.events) : h[O] = we.API[O]);
  function LA(w) {
    return pe[w].mediaBox.topRightX - pe[w].mediaBox.bottomLeftX;
  }
  function kA(w, L) {
    pe[w].mediaBox.topRightX = L + pe[w].mediaBox.bottomLeftX;
  }
  function JA(w) {
    return pe[w].mediaBox.topRightY - pe[w].mediaBox.bottomLeftY;
  }
  function Ue(w, L) {
    pe[w].mediaBox.topRightY = L + pe[w].mediaBox.bottomLeftY;
  }
  var KA = h.getPageWidth = function(w) {
    return LA(w = w || W) / ee;
  }, Ne = h.setPageWidth = function(w, L) {
    kA(w, L * ee);
  }, Wt = h.getPageHeight = function(w) {
    return JA(w = w || W) / ee;
  }, Dt = h.setPageHeight = function(w, L) {
    Ue(w, L * ee);
  };
  return h.internal = { pdfEscape: _n, getStyle: Hi, getFont: PA, getFontSize: lA, getCharSpace: Xa, getTextColor: ff, getLineHeight: ot, getLineHeightFactor: Fr, getLineWidth: Qe, write: dA, getHorizontalCoordinate: kn, getVerticalCoordinate: et, getCoordinateString: Ls, getVerticalCoordinateString: $a, collections: {}, newObject: Bt, newAdditionalObject: ui, newObjectDeferred: er, newObjectDeferredBegin: Gt, getFilters: Tn, putStream: hn, events: ze, scaleFactor: ee, pageSize: { getWidth: function() {
    return KA(W);
  }, setWidth: function(w) {
    Ne(W, w);
  }, getHeight: function() {
    return Wt(W);
  }, setHeight: function(w) {
    Dt(W, w);
  } }, encryptionOptions: c, encryption: Lt, getEncryptor: function(w) {
    return c !== null ? Lt.encryptor(w, 0) : function(L) {
      return L;
    };
  }, output: Tr, getNumberOfPages: Ka, get pages() {
    return WA;
  }, out: E, f2: U, f3: x, getPageInfo: Ga, getPageInfoByObjId: Wa, getCurrentPageInfo: ja, getPDFVersion: B, Point: sa, Rectangle: zo, Matrix: Be, hasHotfix: Rn }, Object.defineProperty(h.internal.pageSize, "width", { get: function() {
    return KA(W);
  }, set: function(w) {
    Ne(W, w);
  }, enumerable: !0, configurable: !0 }), Object.defineProperty(h.internal.pageSize, "height", { get: function() {
    return Wt(W);
  }, set: function(w) {
    Dt(W, w);
  }, enumerable: !0, configurable: !0 }), (function(w) {
    for (var L = 0, z = rA.length; L < z; L++) {
      var aA = ka.call(this, w[L][0], w[L][1], w[L][2], rA[L][3], !0);
      u === !1 && (d[aA] = !0);
      var mA = w[L][0].split("-");
      Pa({ id: aA, fontName: mA[0], fontStyle: mA[1] || "" });
    }
    ze.publish("addFonts", { fonts: Ce, dictionary: ae });
  }).call(h, rA), $A = "F1", ns(n, t), ze.publish("initialized"), h;
}
Nc.prototype.lsbFirstWord = function(e) {
  return String.fromCharCode(255 & e, e >> 8 & 255, e >> 16 & 255, e >> 24 & 255);
}, Nc.prototype.toHexString = function(e) {
  return e.split("").map(function(A) {
    return ("0" + (255 & A.charCodeAt(0)).toString(16)).slice(-2);
  }).join("");
}, Nc.prototype.hexToBytes = function(e) {
  for (var A = [], t = 0; t < e.length; t += 2) A.push(String.fromCharCode(parseInt(e.substr(t, 2), 16)));
  return A.join("");
}, Nc.prototype.processOwnerPassword = function(e, A) {
  return bv(Cv(A).substr(0, 5), e);
}, Nc.prototype.encryptor = function(e, A) {
  var t = Cv(this.encryptionKey + String.fromCharCode(255 & e, e >> 8 & 255, e >> 16 & 255, 255 & A, A >> 8 & 255)).substr(0, 10);
  return function(r) {
    return bv(t, r);
  };
}, Vh.prototype.equals = function(e) {
  var A, t = "id,objectNumber,equals";
  if (!e || it(e) !== it(this)) return !1;
  var r = 0;
  for (A in this) if (!(t.indexOf(A) >= 0)) {
    if (this.hasOwnProperty(A) && !e.hasOwnProperty(A) || this[A] !== e[A]) return !1;
    r++;
  }
  for (A in e) e.hasOwnProperty(A) && t.indexOf(A) < 0 && r--;
  return r === 0;
}, we.API = { events: [] }, we.version = "4.2.1";
var sr = we.API, Ky = 1, rc = function(e) {
  return e.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, Uc = function(e) {
  return e.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, Yl = function(e) {
  return e.toString().replace(/#/g, "#23").replace(/[\s\n\r()<>[\]{}\/%]/g, function(A) {
    var t = A.charCodeAt(0).toString(16).toUpperCase();
    return "#" + (t.length === 1 ? "0" + t : t);
  });
}, De = function(e) {
  return e.toFixed(2);
}, ho = function(e) {
  return e.toFixed(5);
};
sr.__acroform__ = {};
var li = function(e, A) {
  e.prototype = Object.create(A.prototype), e.prototype.constructor = e;
}, rQ = function(e) {
  return e * Ky;
}, Ms = function(e) {
  var A = new H3(), t = le.internal.getHeight(e) || 0, r = le.internal.getWidth(e) || 0;
  return A.BBox = [0, 0, Number(De(r)), Number(De(t))], A;
}, HW = sr.__acroform__.setBit = function(e, A) {
  if (e = e || 0, A = A || 0, isNaN(e) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
  return e | 1 << A;
}, TW = sr.__acroform__.clearBit = function(e, A) {
  if (e = e || 0, A = A || 0, isNaN(e) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
  return e & ~(1 << A);
}, _W = sr.__acroform__.getBit = function(e, A) {
  if (isNaN(e) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
  return e & 1 << A ? 1 : 0;
}, vr = sr.__acroform__.getBitForPdf = function(e, A) {
  if (isNaN(e) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
  return _W(e, A - 1);
}, yr = sr.__acroform__.setBitForPdf = function(e, A) {
  if (isNaN(e) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
  return HW(e, A - 1);
}, Cr = sr.__acroform__.clearBitForPdf = function(e, A) {
  if (isNaN(e) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
  return TW(e, A - 1);
}, OW = sr.__acroform__.calculateCoordinates = function(e, A) {
  var t = A.internal.getHorizontalCoordinate, r = A.internal.getVerticalCoordinate, n = e[0], i = e[1], s = e[2], a = e[3], o = {};
  return o.lowerLeft_X = t(n) || 0, o.lowerLeft_Y = r(i + a) || 0, o.upperRight_X = t(n + s) || 0, o.upperRight_Y = r(i) || 0, [Number(De(o.lowerLeft_X)), Number(De(o.lowerLeft_Y)), Number(De(o.upperRight_X)), Number(De(o.upperRight_Y))];
}, NW = function(e) {
  if (e.appearanceStreamContent) return e.appearanceStreamContent;
  if (e.V || e.DV) {
    var A = [], t = e._V || e.DV, r = Fv(e, t), n = e.scope.internal.getFont(e.fontName, e.fontStyle).id;
    A.push("/Tx BMC"), A.push("q"), A.push("BT"), A.push(e.scope.__private__.encodeColorString(e.color)), A.push("/" + n + " " + De(r.fontSize) + " Tf"), A.push("1 0 0 1 0 0 Tm"), A.push(r.text), A.push("ET"), A.push("Q"), A.push("EMC");
    var i = Ms(e);
    return i.scope = e.scope, i.stream = A.join(`
`), i;
  }
}, Fv = function(e, A) {
  var t = e.fontSize === 0 ? e.maxFontSize : e.fontSize, r = { text: "", fontSize: "" }, n = (A = (A = A.substr(0, 1) == "(" ? A.substr(1) : A).substr(A.length - 1) == ")" ? A.substr(0, A.length - 1) : A).split(" ");
  n = e.multiline ? n.map(function(U) {
    return U.split(`
`);
  }) : n.map(function(U) {
    return [U];
  });
  var i = t, s = le.internal.getHeight(e) || 0;
  s = s < 0 ? -s : s;
  var a = le.internal.getWidth(e) || 0;
  a = a < 0 ? -a : a;
  var o = function(U, x, P) {
    if (U + 1 < n.length) {
      var N = x + " " + n[U + 1][0];
      return pd(N, e, P).width <= a - 4;
    }
    return !1;
  };
  i++;
  A: for (; i > 0; ) {
    A = "", i--;
    var l, c, u = pd("3", e, i).height, d = e.multiline ? s - i : (s - u) / 2, h = d += 2, p = 0, B = 0, y = 0;
    if (i <= 0) {
      A = `(...) Tj
`, A += "% Width of Text: " + pd(A, e, i = 12).width + ", FieldWidth:" + a + `
`;
      break;
    }
    for (var m = "", C = 0, Q = 0; Q < n.length; Q++) if (n.hasOwnProperty(Q)) {
      var F = !1;
      if (n[Q].length !== 1 && y !== n[Q].length - 1) {
        if ((u + 2) * (C + 2) + 2 > s) continue A;
        m += n[Q][y], F = !0, B = Q, Q--;
      } else {
        m = (m += n[Q][y] + " ").substr(m.length - 1) == " " ? m.substr(0, m.length - 1) : m;
        var T = parseInt(Q), V = o(T, m, i), M = Q >= n.length - 1;
        if (V && !M) {
          m += " ", y = 0;
          continue;
        }
        if (V || M) {
          if (M) B = T;
          else if (e.multiline && (u + 2) * (C + 2) + 2 > s) continue A;
        } else {
          if (!e.multiline || (u + 2) * (C + 2) + 2 > s) continue A;
          B = T;
        }
      }
      for (var D = "", I = p; I <= B; I++) {
        var q = n[I];
        if (e.multiline) {
          if (I === B) {
            D += q[y] + " ", y = (y + 1) % q.length;
            continue;
          }
          if (I === p) {
            D += q[q.length - 1] + " ";
            continue;
          }
        }
        D += q[0] + " ";
      }
      switch (D = D.substr(D.length - 1) == " " ? D.substr(0, D.length - 1) : D, c = pd(D, e, i).width, e.textAlign) {
        case "right":
          l = a - c - 2;
          break;
        case "center":
          l = (a - c) / 2;
          break;
        default:
          l = 2;
      }
      A += De(l) + " " + De(h) + ` Td
`, A += "(" + rc(D) + `) Tj
`, A += -De(l) + ` 0 Td
`, h = -(i + 2), c = 0, p = F ? B : B + 1, C++, m = "";
    }
    break;
  }
  return r.text = A, r.fontSize = i, r;
}, pd = function(e, A, t) {
  var r = A.scope.internal.getFont(A.fontName, A.fontStyle), n = A.scope.getStringUnitWidth(e, { font: r, fontSize: parseFloat(t), charSpace: 0 }) * parseFloat(t);
  return { height: A.scope.getStringUnitWidth("3", { font: r, fontSize: parseFloat(t), charSpace: 0 }) * parseFloat(t) * 1.5, width: n };
}, DW = { fields: [], xForms: [], acroFormDictionaryRoot: null, printedOut: !1, internal: null, isInitialized: !1 }, RW = function(e, A) {
  var t = { type: "reference", object: e };
  A.internal.getPageInfo(e.page).pageContext.annotations.find(function(r) {
    return r.type === t.type && r.object === t.object;
  }) === void 0 && A.internal.getPageInfo(e.page).pageContext.annotations.push(t);
}, MW = function(e, A) {
  if (A.scope = e, e.internal !== void 0 && (e.internal.acroformPlugin === void 0 || e.internal.acroformPlugin.isInitialized === !1)) {
    if (Fs.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify(DW)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
    Ky = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new T3(), e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
      (function(t) {
        t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
      })(e);
    }), e.internal.events.subscribe("buildDocument", function() {
      (function(t) {
        t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
        var r = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
        for (var n in r) if (r.hasOwnProperty(n)) {
          var i = r[n];
          i.objId = void 0, i.hasAnnotation && RW(i, t);
        }
      })(e);
    }), e.internal.events.subscribe("putCatalog", function() {
      (function(t) {
        if (t.internal.acroformPlugin.acroFormDictionaryRoot === void 0) throw new Error("putCatalogCallback: Root missing.");
        t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
      })(e);
    }), e.internal.events.subscribe("postPutPages", function(t) {
      (function(r, n) {
        var i = !r;
        for (var s in r || (n.internal.newObjectDeferredBegin(n.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), n.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), r = r || n.internal.acroformPlugin.acroFormDictionaryRoot.Kids) if (r.hasOwnProperty(s)) {
          var a = r[s], o = [], l = a.Rect;
          if (a.Rect && (a.Rect = OW(a.Rect, n)), n.internal.newObjectDeferredBegin(a.objId, !0), a.DA = le.createDefaultAppearanceStream(a), it(a) === "object" && typeof a.getKeyValueListForStream == "function" && (o = a.getKeyValueListForStream()), a.Rect = l, a.hasAppearanceStream && !a.appearanceStreamContent) {
            var c = NW(a);
            o.push({ key: "AP", value: "<</N " + c + ">>" }), n.internal.acroformPlugin.xForms.push(c);
          }
          if (a.appearanceStreamContent) {
            var u = "";
            for (var d in a.appearanceStreamContent) if (a.appearanceStreamContent.hasOwnProperty(d)) {
              var h = a.appearanceStreamContent[d];
              if (u += "/" + d + " ", u += "<<", Object.keys(h).length >= 1 || Array.isArray(h)) {
                for (var s in h) if (h.hasOwnProperty(s)) {
                  var p = h[s];
                  typeof p == "function" && (p = p.call(n, a)), u += "/" + s + " " + p + " ", n.internal.acroformPlugin.xForms.indexOf(p) >= 0 || n.internal.acroformPlugin.xForms.push(p);
                }
              } else typeof (p = h) == "function" && (p = p.call(n, a)), u += "/" + s + " " + p, n.internal.acroformPlugin.xForms.indexOf(p) >= 0 || n.internal.acroformPlugin.xForms.push(p);
              u += ">>";
            }
            o.push({ key: "AP", value: `<<
` + u + ">>" });
          }
          n.internal.putStream({ additionalKeyValues: o, objectId: a.objId }), n.internal.out("endobj");
        }
        i && (function(B, y) {
          for (var m in B) if (B.hasOwnProperty(m)) {
            var C = m, Q = B[m];
            y.internal.newObjectDeferredBegin(Q.objId, !0), it(Q) === "object" && typeof Q.putStream == "function" && Q.putStream(), delete B[C];
          }
        })(n.internal.acroformPlugin.xForms, n);
      })(t, e);
    }), e.internal.acroformPlugin.isInitialized = !0;
  }
}, L3 = sr.__acroform__.arrayToPdfArray = function(e, A, t) {
  var r = function(s) {
    return s;
  };
  if (Array.isArray(e)) {
    for (var n = "[", i = 0; i < e.length; i++) switch (i !== 0 && (n += " "), it(e[i])) {
      case "boolean":
      case "number":
      case "object":
        n += e[i].toString();
        break;
      case "string":
        e[i].substr(0, 1) === "/" ? n += "/" + Yl(e[i].substr(1)) : (A !== void 0 && t && (r = t.internal.getEncryptor(A)), n += "(" + rc(r(e[i].toString())) + ")");
    }
    return n + "]";
  }
  throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, ow = function(e, A, t) {
  var r = function(n) {
    return n;
  };
  return A !== void 0 && t && (r = t.internal.getEncryptor(A)), (e = e || "").toString(), "(" + rc(r(e)) + ")";
}, js = function() {
  this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", { get: function() {
    if (this._objId === void 0) {
      if (this.scope === void 0) return;
      this._objId = this.scope.internal.newObjectDeferred();
    }
    return this._objId;
  }, set: function(e) {
    this._objId = e;
  } }), Object.defineProperty(this, "scope", { value: this._scope, writable: !0 });
};
js.prototype.toString = function() {
  return this.objId + " 0 R";
}, js.prototype.putStream = function() {
  var e = this.getKeyValueListForStream();
  this.scope.internal.putStream({ data: this.stream, additionalKeyValues: e, objectId: this.objId }), this.scope.internal.out("endobj");
}, js.prototype.getKeyValueListForStream = function() {
  var e = [], A = Object.getOwnPropertyNames(this).filter(function(i) {
    return i != "content" && i != "appearanceStreamContent" && i != "scope" && i != "objId" && i.substring(0, 1) != "_";
  });
  for (var t in A) if (Object.getOwnPropertyDescriptor(this, A[t]).configurable === !1) {
    var r = A[t], n = this[r];
    n && (Array.isArray(n) ? e.push({ key: r, value: L3(n, this.objId, this.scope) }) : n instanceof js ? (n.scope = this.scope, e.push({ key: r, value: n.objId + " 0 R" })) : typeof n != "function" && e.push({ key: r, value: n }));
  }
  return e;
};
var H3 = function() {
  js.call(this), Object.defineProperty(this, "Type", { value: "/XObject", configurable: !1, writable: !0 }), Object.defineProperty(this, "Subtype", { value: "/Form", configurable: !1, writable: !0 }), Object.defineProperty(this, "FormType", { value: 1, configurable: !1, writable: !0 });
  var e, A = [];
  Object.defineProperty(this, "BBox", { configurable: !1, get: function() {
    return A;
  }, set: function(t) {
    A = t;
  } }), Object.defineProperty(this, "Resources", { value: "2 0 R", configurable: !1, writable: !0 }), Object.defineProperty(this, "stream", { enumerable: !1, configurable: !0, set: function(t) {
    e = t.trim();
  }, get: function() {
    return e || null;
  } });
};
li(H3, js);
var T3 = function() {
  js.call(this);
  var e, A = [];
  Object.defineProperty(this, "Kids", { enumerable: !1, configurable: !0, get: function() {
    return A.length > 0 ? A : void 0;
  } }), Object.defineProperty(this, "Fields", { enumerable: !1, configurable: !1, get: function() {
    return A;
  } }), Object.defineProperty(this, "DA", { enumerable: !1, configurable: !1, get: function() {
    if (e) {
      var t = function(r) {
        return r;
      };
      return this.scope && (t = this.scope.internal.getEncryptor(this.objId)), "(" + rc(t(e)) + ")";
    }
  }, set: function(t) {
    e = t;
  } });
};
li(T3, js);
var Fs = function e() {
  js.call(this);
  var A = 4;
  Object.defineProperty(this, "F", { enumerable: !1, configurable: !1, get: function() {
    return A;
  }, set: function(m) {
    if (isNaN(m)) throw new Error('Invalid value "' + m + '" for attribute F supplied.');
    A = m;
  } }), Object.defineProperty(this, "showWhenPrinted", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(A, 3);
  }, set: function(m) {
    m ? this.F = yr(A, 3) : this.F = Cr(A, 3);
  } });
  var t = 0;
  Object.defineProperty(this, "Ff", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(m) {
    if (isNaN(m)) throw new Error('Invalid value "' + m + '" for attribute Ff supplied.');
    t = m;
  } });
  var r = [];
  Object.defineProperty(this, "Rect", { enumerable: !1, configurable: !1, get: function() {
    if (r.length !== 0) return r;
  }, set: function(m) {
    r = m !== void 0 ? m : [];
  } }), Object.defineProperty(this, "x", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[0]) ? 0 : r[0];
  }, set: function(m) {
    r[0] = m;
  } }), Object.defineProperty(this, "y", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[1]) ? 0 : r[1];
  }, set: function(m) {
    r[1] = m;
  } }), Object.defineProperty(this, "width", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[2]) ? 0 : r[2];
  }, set: function(m) {
    r[2] = m;
  } }), Object.defineProperty(this, "height", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[3]) ? 0 : r[3];
  }, set: function(m) {
    r[3] = m;
  } });
  var n = "";
  Object.defineProperty(this, "FT", { enumerable: !0, configurable: !1, get: function() {
    return n;
  }, set: function(m) {
    switch (m) {
      case "/Btn":
      case "/Tx":
      case "/Ch":
      case "/Sig":
        n = m;
        break;
      default:
        throw new Error('Invalid value "' + m + '" for attribute FT supplied.');
    }
  } });
  var i = null;
  Object.defineProperty(this, "T", { enumerable: !0, configurable: !1, get: function() {
    if (!i || i.length < 1) {
      if (this instanceof xg) return;
      i = "FieldObject" + e.FieldNum++;
    }
    var m = function(C) {
      return C;
    };
    return this.scope && (m = this.scope.internal.getEncryptor(this.objId)), "(" + rc(m(i)) + ")";
  }, set: function(m) {
    i = m.toString();
  } }), Object.defineProperty(this, "fieldName", { configurable: !0, enumerable: !0, get: function() {
    return i;
  }, set: function(m) {
    i = m;
  } });
  var s = "helvetica";
  Object.defineProperty(this, "fontName", { enumerable: !0, configurable: !0, get: function() {
    return s;
  }, set: function(m) {
    s = m;
  } });
  var a = "normal";
  Object.defineProperty(this, "fontStyle", { enumerable: !0, configurable: !0, get: function() {
    return a;
  }, set: function(m) {
    a = m;
  } });
  var o = 0;
  Object.defineProperty(this, "fontSize", { enumerable: !0, configurable: !0, get: function() {
    return o;
  }, set: function(m) {
    o = m;
  } });
  var l = void 0;
  Object.defineProperty(this, "maxFontSize", { enumerable: !0, configurable: !0, get: function() {
    return l === void 0 ? 50 / Ky : l;
  }, set: function(m) {
    l = m;
  } });
  var c = "black";
  Object.defineProperty(this, "color", { enumerable: !0, configurable: !0, get: function() {
    return c;
  }, set: function(m) {
    c = m;
  } });
  var u = "/F1 0 Tf 0 g";
  Object.defineProperty(this, "DA", { enumerable: !0, configurable: !1, get: function() {
    if (!(!u || this instanceof xg || this instanceof _o)) return ow(u, this.objId, this.scope);
  }, set: function(m) {
    m = m.toString(), u = m;
  } });
  var d = null;
  Object.defineProperty(this, "DV", { enumerable: !1, configurable: !1, get: function() {
    if (d) return this instanceof Mr == 0 ? ow(d, this.objId, this.scope) : d;
  }, set: function(m) {
    m = m.toString(), d = this instanceof Mr == 0 ? m.substr(0, 1) === "(" ? Uc(m.substr(1, m.length - 2)) : Uc(m) : m;
  } }), Object.defineProperty(this, "defaultValue", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof Mr == 1 ? Uc(d.substr(1, d.length - 1)) : d;
  }, set: function(m) {
    m = m.toString(), d = this instanceof Mr == 1 ? "/" + Yl(m) : m;
  } });
  var h = null;
  Object.defineProperty(this, "_V", { enumerable: !1, configurable: !1, get: function() {
    if (h) return h;
  }, set: function(m) {
    this.V = m;
  } }), Object.defineProperty(this, "V", { enumerable: !1, configurable: !1, get: function() {
    if (h) return this instanceof Mr == 0 ? ow(h, this.objId, this.scope) : h;
  }, set: function(m) {
    m = m.toString(), h = this instanceof Mr == 0 ? m.substr(0, 1) === "(" ? Uc(m.substr(1, m.length - 2)) : Uc(m) : m;
  } }), Object.defineProperty(this, "value", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof Mr == 1 ? Uc(h.substr(1, h.length - 1)) : h;
  }, set: function(m) {
    m = m.toString(), h = this instanceof Mr == 1 ? "/" + Yl(m) : m;
  } }), Object.defineProperty(this, "hasAnnotation", { enumerable: !0, configurable: !0, get: function() {
    return this.Rect;
  } }), Object.defineProperty(this, "Type", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Annot" : null;
  } }), Object.defineProperty(this, "Subtype", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Widget" : null;
  } });
  var p, B = !1;
  Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return B;
  }, set: function(m) {
    m = !!m, B = m;
  } }), Object.defineProperty(this, "page", { enumerable: !0, configurable: !0, get: function() {
    if (p) return p;
  }, set: function(m) {
    p = m;
  } }), Object.defineProperty(this, "readOnly", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 1);
  }, set: function(m) {
    m ? this.Ff = yr(this.Ff, 1) : this.Ff = Cr(this.Ff, 1);
  } }), Object.defineProperty(this, "required", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 2);
  }, set: function(m) {
    m ? this.Ff = yr(this.Ff, 2) : this.Ff = Cr(this.Ff, 2);
  } }), Object.defineProperty(this, "noExport", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 3);
  }, set: function(m) {
    m ? this.Ff = yr(this.Ff, 3) : this.Ff = Cr(this.Ff, 3);
  } });
  var y = null;
  Object.defineProperty(this, "Q", { enumerable: !0, configurable: !1, get: function() {
    if (y !== null) return y;
  }, set: function(m) {
    if ([0, 1, 2].indexOf(m) === -1) throw new Error('Invalid value "' + m + '" for attribute Q supplied.');
    y = m;
  } }), Object.defineProperty(this, "textAlign", { get: function() {
    var m;
    switch (y) {
      case 0:
      default:
        m = "left";
        break;
      case 1:
        m = "center";
        break;
      case 2:
        m = "right";
    }
    return m;
  }, configurable: !0, enumerable: !0, set: function(m) {
    switch (m) {
      case "right":
      case 2:
        y = 2;
        break;
      case "center":
      case 1:
        y = 1;
        break;
      default:
        y = 0;
    }
  } });
};
li(Fs, js);
var Ml = function() {
  Fs.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
  var e = 0;
  Object.defineProperty(this, "TI", { enumerable: !0, configurable: !1, get: function() {
    return e;
  }, set: function(t) {
    e = t;
  } }), Object.defineProperty(this, "topIndex", { enumerable: !0, configurable: !0, get: function() {
    return e;
  }, set: function(t) {
    e = t;
  } });
  var A = [];
  Object.defineProperty(this, "Opt", { enumerable: !0, configurable: !1, get: function() {
    return L3(A, this.objId, this.scope);
  }, set: function(t) {
    var r, n;
    n = [], typeof (r = t) == "string" && (n = (function(i, s, a) {
      a || (a = 1);
      for (var o, l = []; o = s.exec(i); ) l.push(o[a]);
      return l;
    })(r, /\((.*?)\)/g)), A = n;
  } }), this.getOptions = function() {
    return A;
  }, this.setOptions = function(t) {
    A = t, this.sort && A.sort();
  }, this.addOption = function(t) {
    t = (t = t || "").toString(), A.push(t), this.sort && A.sort();
  }, this.removeOption = function(t, r) {
    for (r = r || !1, t = (t = t || "").toString(); A.indexOf(t) !== -1 && (A.splice(A.indexOf(t), 1), r !== !1); ) ;
  }, Object.defineProperty(this, "combo", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 18);
  }, set: function(t) {
    t ? this.Ff = yr(this.Ff, 18) : this.Ff = Cr(this.Ff, 18);
  } }), Object.defineProperty(this, "edit", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 19);
  }, set: function(t) {
    this.combo === !0 && (t ? this.Ff = yr(this.Ff, 19) : this.Ff = Cr(this.Ff, 19));
  } }), Object.defineProperty(this, "sort", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 20);
  }, set: function(t) {
    t ? (this.Ff = yr(this.Ff, 20), A.sort()) : this.Ff = Cr(this.Ff, 20);
  } }), Object.defineProperty(this, "multiSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 22);
  }, set: function(t) {
    t ? this.Ff = yr(this.Ff, 22) : this.Ff = Cr(this.Ff, 22);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 23);
  }, set: function(t) {
    t ? this.Ff = yr(this.Ff, 23) : this.Ff = Cr(this.Ff, 23);
  } }), Object.defineProperty(this, "commitOnSelChange", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 27);
  }, set: function(t) {
    t ? this.Ff = yr(this.Ff, 27) : this.Ff = Cr(this.Ff, 27);
  } }), this.hasAppearanceStream = !1;
};
li(Ml, Fs);
var Pl = function() {
  Ml.call(this), this.fontName = "helvetica", this.combo = !1;
};
li(Pl, Ml);
var kl = function() {
  Pl.call(this), this.combo = !0;
};
li(kl, Pl);
var wh = function() {
  kl.call(this), this.edit = !0;
};
li(wh, kl);
var Mr = function() {
  Fs.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 15);
  }, set: function(t) {
    t ? this.Ff = yr(this.Ff, 15) : this.Ff = Cr(this.Ff, 15);
  } }), Object.defineProperty(this, "radio", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 16);
  }, set: function(t) {
    t ? this.Ff = yr(this.Ff, 16) : this.Ff = Cr(this.Ff, 16);
  } }), Object.defineProperty(this, "pushButton", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 17);
  }, set: function(t) {
    t ? this.Ff = yr(this.Ff, 17) : this.Ff = Cr(this.Ff, 17);
  } }), Object.defineProperty(this, "radioIsUnison", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 26);
  }, set: function(t) {
    t ? this.Ff = yr(this.Ff, 26) : this.Ff = Cr(this.Ff, 26);
  } });
  var e, A = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var t = function(i) {
      return i;
    };
    if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), Object.keys(A).length !== 0) {
      var r, n = [];
      for (r in n.push("<<"), A) n.push("/" + r + " (" + rc(t(A[r])) + ")");
      return n.push(">>"), n.join(`
`);
    }
  }, set: function(t) {
    it(t) === "object" && (A = t);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return A.CA || "";
  }, set: function(t) {
    typeof t == "string" && (A.CA = t);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(t) {
    var r = t == null ? "" : t.toString();
    r.substr(0, 1) === "/" && (r = r.substr(1)), e = "/" + Yl(r);
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return e.substr(1, e.length - 1);
  }, set: function(t) {
    e = "/" + Yl(t);
  } });
};
li(Mr, Fs);
var mh = function() {
  Mr.call(this), this.pushButton = !0;
};
li(mh, Mr);
var Kl = function() {
  Mr.call(this), this.radio = !0, this.pushButton = !1;
  var e = [];
  Object.defineProperty(this, "Kids", { enumerable: !0, configurable: !1, get: function() {
    return e;
  }, set: function(A) {
    e = A !== void 0 ? A : [];
  } });
};
li(Kl, Mr);
var xg = function() {
  var e, A;
  Fs.call(this), Object.defineProperty(this, "Parent", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(n) {
    e = n;
  } }), Object.defineProperty(this, "optionName", { enumerable: !1, configurable: !0, get: function() {
    return A;
  }, set: function(n) {
    A = n;
  } });
  var t, r = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var n = function(a) {
      return a;
    };
    this.scope && (n = this.scope.internal.getEncryptor(this.objId));
    var i, s = [];
    for (i in s.push("<<"), r) s.push("/" + i + " (" + rc(n(r[i])) + ")");
    return s.push(">>"), s.join(`
`);
  }, set: function(n) {
    it(n) === "object" && (r = n);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return r.CA || "";
  }, set: function(n) {
    typeof n == "string" && (r.CA = n);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(n) {
    var i = n == null ? "" : n.toString();
    i.substr(0, 1) === "/" && (i = i.substr(1)), t = "/" + Yl(i);
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return t.substr(1, t.length - 1);
  }, set: function(n) {
    var i = n == null ? "" : n.toString();
    i.substr(0, 1) === "/" && (i = i.substr(1)), t = "/" + Yl(i);
  } }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = le.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
li(xg, Fs), Kl.prototype.setAppearance = function(e) {
  if (!("createAppearanceStream" in e) || !("getCA" in e)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
  for (var A in this.Kids) if (this.Kids.hasOwnProperty(A)) {
    var t = this.Kids[A];
    t.appearanceStreamContent = e.createAppearanceStream(t.optionName), t.caption = e.getCA();
  }
}, Kl.prototype.createOption = function(e) {
  var A = new xg();
  return A.Parent = this, A.optionName = e, this.Kids.push(A), PW.call(this.scope, A), A;
};
var vh = function() {
  Mr.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = le.CheckBox.createAppearanceStream();
};
li(vh, Mr);
var _o = function() {
  Fs.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 13);
  }, set: function(A) {
    A ? this.Ff = yr(this.Ff, 13) : this.Ff = Cr(this.Ff, 13);
  } }), Object.defineProperty(this, "fileSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 21);
  }, set: function(A) {
    A ? this.Ff = yr(this.Ff, 21) : this.Ff = Cr(this.Ff, 21);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 23);
  }, set: function(A) {
    A ? this.Ff = yr(this.Ff, 23) : this.Ff = Cr(this.Ff, 23);
  } }), Object.defineProperty(this, "doNotScroll", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 24);
  }, set: function(A) {
    A ? this.Ff = yr(this.Ff, 24) : this.Ff = Cr(this.Ff, 24);
  } }), Object.defineProperty(this, "comb", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 25);
  }, set: function(A) {
    A ? this.Ff = yr(this.Ff, 25) : this.Ff = Cr(this.Ff, 25);
  } }), Object.defineProperty(this, "richText", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 26);
  }, set: function(A) {
    A ? this.Ff = yr(this.Ff, 26) : this.Ff = Cr(this.Ff, 26);
  } });
  var e = null;
  Object.defineProperty(this, "MaxLen", { enumerable: !0, configurable: !1, get: function() {
    return e;
  }, set: function(A) {
    e = A;
  } }), Object.defineProperty(this, "maxLength", { enumerable: !0, configurable: !0, get: function() {
    return e;
  }, set: function(A) {
    Number.isInteger(A) && (e = A);
  } }), Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return this.V || this.DV;
  } });
};
li(_o, Fs);
var yh = function() {
  _o.call(this), Object.defineProperty(this, "password", { enumerable: !0, configurable: !0, get: function() {
    return !!vr(this.Ff, 14);
  }, set: function(e) {
    e ? this.Ff = yr(this.Ff, 14) : this.Ff = Cr(this.Ff, 14);
  } }), this.password = !0;
};
li(yh, _o);
var le = { CheckBox: { createAppearanceStream: function() {
  return { N: { On: le.CheckBox.YesNormal }, D: { On: le.CheckBox.YesPushDown, Off: le.CheckBox.OffPushDown } };
}, YesPushDown: function(e) {
  var A = Ms(e);
  A.scope = e.scope;
  var t = [], r = e.scope.internal.getFont(e.fontName, e.fontStyle).id, n = e.scope.__private__.encodeColorString(e.color), i = Fv(e, e.caption);
  return t.push("0.749023 g"), t.push("0 0 " + De(le.internal.getWidth(e)) + " " + De(le.internal.getHeight(e)) + " re"), t.push("f"), t.push("BMC"), t.push("q"), t.push("0 0 1 rg"), t.push("/" + r + " " + De(i.fontSize) + " Tf " + n), t.push("BT"), t.push(i.text), t.push("ET"), t.push("Q"), t.push("EMC"), A.stream = t.join(`
`), A;
}, YesNormal: function(e) {
  var A = Ms(e);
  A.scope = e.scope;
  var t = e.scope.internal.getFont(e.fontName, e.fontStyle).id, r = e.scope.__private__.encodeColorString(e.color), n = [], i = le.internal.getHeight(e), s = le.internal.getWidth(e), a = Fv(e, e.caption);
  return n.push("1 g"), n.push("0 0 " + De(s) + " " + De(i) + " re"), n.push("f"), n.push("q"), n.push("0 0 1 rg"), n.push("0 0 " + De(s - 1) + " " + De(i - 1) + " re"), n.push("W"), n.push("n"), n.push("0 g"), n.push("BT"), n.push("/" + t + " " + De(a.fontSize) + " Tf " + r), n.push(a.text), n.push("ET"), n.push("Q"), A.stream = n.join(`
`), A;
}, OffPushDown: function(e) {
  var A = Ms(e);
  A.scope = e.scope;
  var t = [];
  return t.push("0.749023 g"), t.push("0 0 " + De(le.internal.getWidth(e)) + " " + De(le.internal.getHeight(e)) + " re"), t.push("f"), A.stream = t.join(`
`), A;
} }, RadioButton: { Circle: { createAppearanceStream: function(e) {
  var A = { D: { Off: le.RadioButton.Circle.OffPushDown }, N: {} };
  return A.N[e] = le.RadioButton.Circle.YesNormal, A.D[e] = le.RadioButton.Circle.YesPushDown, A;
}, getCA: function() {
  return "l";
}, YesNormal: function(e) {
  var A = Ms(e);
  A.scope = e.scope;
  var t = [], r = le.internal.getWidth(e) <= le.internal.getHeight(e) ? le.internal.getWidth(e) / 4 : le.internal.getHeight(e) / 4;
  r = Number((0.9 * r).toFixed(5));
  var n = le.internal.Bezier_C, i = Number((r * n).toFixed(5));
  return t.push("q"), t.push("1 0 0 1 " + ho(le.internal.getWidth(e) / 2) + " " + ho(le.internal.getHeight(e) / 2) + " cm"), t.push(r + " 0 m"), t.push(r + " " + i + " " + i + " " + r + " 0 " + r + " c"), t.push("-" + i + " " + r + " -" + r + " " + i + " -" + r + " 0 c"), t.push("-" + r + " -" + i + " -" + i + " -" + r + " 0 -" + r + " c"), t.push(i + " -" + r + " " + r + " -" + i + " " + r + " 0 c"), t.push("f"), t.push("Q"), A.stream = t.join(`
`), A;
}, YesPushDown: function(e) {
  var A = Ms(e);
  A.scope = e.scope;
  var t = [], r = le.internal.getWidth(e) <= le.internal.getHeight(e) ? le.internal.getWidth(e) / 4 : le.internal.getHeight(e) / 4;
  r = Number((0.9 * r).toFixed(5));
  var n = Number((2 * r).toFixed(5)), i = Number((n * le.internal.Bezier_C).toFixed(5)), s = Number((r * le.internal.Bezier_C).toFixed(5));
  return t.push("0.749023 g"), t.push("q"), t.push("1 0 0 1 " + ho(le.internal.getWidth(e) / 2) + " " + ho(le.internal.getHeight(e) / 2) + " cm"), t.push(n + " 0 m"), t.push(n + " " + i + " " + i + " " + n + " 0 " + n + " c"), t.push("-" + i + " " + n + " -" + n + " " + i + " -" + n + " 0 c"), t.push("-" + n + " -" + i + " -" + i + " -" + n + " 0 -" + n + " c"), t.push(i + " -" + n + " " + n + " -" + i + " " + n + " 0 c"), t.push("f"), t.push("Q"), t.push("0 g"), t.push("q"), t.push("1 0 0 1 " + ho(le.internal.getWidth(e) / 2) + " " + ho(le.internal.getHeight(e) / 2) + " cm"), t.push(r + " 0 m"), t.push(r + " " + s + " " + s + " " + r + " 0 " + r + " c"), t.push("-" + s + " " + r + " -" + r + " " + s + " -" + r + " 0 c"), t.push("-" + r + " -" + s + " -" + s + " -" + r + " 0 -" + r + " c"), t.push(s + " -" + r + " " + r + " -" + s + " " + r + " 0 c"), t.push("f"), t.push("Q"), A.stream = t.join(`
`), A;
}, OffPushDown: function(e) {
  var A = Ms(e);
  A.scope = e.scope;
  var t = [], r = le.internal.getWidth(e) <= le.internal.getHeight(e) ? le.internal.getWidth(e) / 4 : le.internal.getHeight(e) / 4;
  r = Number((0.9 * r).toFixed(5));
  var n = Number((2 * r).toFixed(5)), i = Number((n * le.internal.Bezier_C).toFixed(5));
  return t.push("0.749023 g"), t.push("q"), t.push("1 0 0 1 " + ho(le.internal.getWidth(e) / 2) + " " + ho(le.internal.getHeight(e) / 2) + " cm"), t.push(n + " 0 m"), t.push(n + " " + i + " " + i + " " + n + " 0 " + n + " c"), t.push("-" + i + " " + n + " -" + n + " " + i + " -" + n + " 0 c"), t.push("-" + n + " -" + i + " -" + i + " -" + n + " 0 -" + n + " c"), t.push(i + " -" + n + " " + n + " -" + i + " " + n + " 0 c"), t.push("f"), t.push("Q"), A.stream = t.join(`
`), A;
} }, Cross: { createAppearanceStream: function(e) {
  var A = { D: { Off: le.RadioButton.Cross.OffPushDown }, N: {} };
  return A.N[e] = le.RadioButton.Cross.YesNormal, A.D[e] = le.RadioButton.Cross.YesPushDown, A;
}, getCA: function() {
  return "8";
}, YesNormal: function(e) {
  var A = Ms(e);
  A.scope = e.scope;
  var t = [], r = le.internal.calculateCross(e);
  return t.push("q"), t.push("1 1 " + De(le.internal.getWidth(e) - 2) + " " + De(le.internal.getHeight(e) - 2) + " re"), t.push("W"), t.push("n"), t.push(De(r.x1.x) + " " + De(r.x1.y) + " m"), t.push(De(r.x2.x) + " " + De(r.x2.y) + " l"), t.push(De(r.x4.x) + " " + De(r.x4.y) + " m"), t.push(De(r.x3.x) + " " + De(r.x3.y) + " l"), t.push("s"), t.push("Q"), A.stream = t.join(`
`), A;
}, YesPushDown: function(e) {
  var A = Ms(e);
  A.scope = e.scope;
  var t = le.internal.calculateCross(e), r = [];
  return r.push("0.749023 g"), r.push("0 0 " + De(le.internal.getWidth(e)) + " " + De(le.internal.getHeight(e)) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + De(le.internal.getWidth(e) - 2) + " " + De(le.internal.getHeight(e) - 2) + " re"), r.push("W"), r.push("n"), r.push(De(t.x1.x) + " " + De(t.x1.y) + " m"), r.push(De(t.x2.x) + " " + De(t.x2.y) + " l"), r.push(De(t.x4.x) + " " + De(t.x4.y) + " m"), r.push(De(t.x3.x) + " " + De(t.x3.y) + " l"), r.push("s"), r.push("Q"), A.stream = r.join(`
`), A;
}, OffPushDown: function(e) {
  var A = Ms(e);
  A.scope = e.scope;
  var t = [];
  return t.push("0.749023 g"), t.push("0 0 " + De(le.internal.getWidth(e)) + " " + De(le.internal.getHeight(e)) + " re"), t.push("f"), A.stream = t.join(`
`), A;
} } }, createDefaultAppearanceStream: function(e) {
  var A = e.scope.internal.getFont(e.fontName, e.fontStyle).id, t = e.scope.__private__.encodeColorString(e.color);
  return "/" + A + " " + e.fontSize + " Tf " + t;
} };
le.internal = { Bezier_C: 0.551915024494, calculateCross: function(e) {
  var A = le.internal.getWidth(e), t = le.internal.getHeight(e), r = Math.min(A, t);
  return { x1: { x: (A - r) / 2, y: (t - r) / 2 + r }, x2: { x: (A - r) / 2 + r, y: (t - r) / 2 }, x3: { x: (A - r) / 2, y: (t - r) / 2 }, x4: { x: (A - r) / 2 + r, y: (t - r) / 2 + r } };
} }, le.internal.getWidth = function(e) {
  var A = 0;
  return it(e) === "object" && (A = rQ(e.Rect[2])), A;
}, le.internal.getHeight = function(e) {
  var A = 0;
  return it(e) === "object" && (A = rQ(e.Rect[3])), A;
};
var PW = sr.addField = function(e) {
  if (MW(this, e), !(e instanceof Fs)) throw new Error("Invalid argument passed to jsPDF.addField.");
  var A;
  return (A = e).scope.internal.acroformPlugin.printedOut && (A.scope.internal.acroformPlugin.printedOut = !1, A.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), A.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(A), e.page = e.scope.internal.getCurrentPageInfo().pageNumber, this;
};
sr.AcroFormChoiceField = Ml, sr.AcroFormListBox = Pl, sr.AcroFormComboBox = kl, sr.AcroFormEditBox = wh, sr.AcroFormButton = Mr, sr.AcroFormPushButton = mh, sr.AcroFormRadioButton = Kl, sr.AcroFormCheckBox = vh, sr.AcroFormTextField = _o, sr.AcroFormPasswordField = yh, sr.AcroFormAppearance = le, sr.AcroForm = { ChoiceField: Ml, ListBox: Pl, ComboBox: kl, EditBox: wh, Button: Mr, PushButton: mh, RadioButton: Kl, CheckBox: vh, TextField: _o, PasswordField: yh, Appearance: le }, we.AcroForm = { ChoiceField: Ml, ListBox: Pl, ComboBox: kl, EditBox: wh, Button: Mr, PushButton: mh, RadioButton: Kl, CheckBox: vh, TextField: _o, PasswordField: yh, Appearance: le };
we.AcroForm;
function _3(e) {
  return e.reduce(function(A, t, r) {
    return A[t] = r, A;
  }, {});
}
(function(e) {
  var A = "addImage_";
  e.__addimage__ = {};
  var t = "UNKNOWN", r = { PNG: [[137, 80, 78, 71]], TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]], JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0], [255, 216, 255, 219], [255, 216, 255, 238]], JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]], GIF87a: [[71, 73, 70, 56, 55, 97]], GIF89a: [[71, 73, 70, 56, 57, 97]], WEBP: [[82, 73, 70, 70, void 0, void 0, void 0, void 0, 87, 69, 66, 80]], BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]] }, n = e.__addimage__.getImageFileTypeByImageData = function(U, x) {
    var P, N, iA, nA, sA, tA = t;
    if ((x = x || t) === "RGBA" || U.data !== void 0 && U.data instanceof Uint8ClampedArray && "height" in U && "width" in U) return "RGBA";
    if (V(U)) for (sA in r) for (iA = r[sA], P = 0; P < iA.length; P += 1) {
      for (nA = !0, N = 0; N < iA[P].length; N += 1) if (iA[P][N] !== void 0 && iA[P][N] !== U[N]) {
        nA = !1;
        break;
      }
      if (nA === !0) {
        tA = sA;
        break;
      }
    }
    else for (sA in r) for (iA = r[sA], P = 0; P < iA.length; P += 1) {
      for (nA = !0, N = 0; N < iA[P].length; N += 1) if (iA[P][N] !== void 0 && iA[P][N] !== U.charCodeAt(N)) {
        nA = !1;
        break;
      }
      if (nA === !0) {
        tA = sA;
        break;
      }
    }
    return tA === t && x !== t && (tA = x), tA;
  }, i = function U(x) {
    for (var P = this.internal.write, N = this.internal.putStream, iA = (0, this.internal.getFilters)(); iA.indexOf("FlateEncode") !== -1; ) iA.splice(iA.indexOf("FlateEncode"), 1);
    x.objectId = this.internal.newObject();
    var nA = [];
    if (nA.push({ key: "Type", value: "/XObject" }), nA.push({ key: "Subtype", value: "/Image" }), nA.push({ key: "Width", value: x.width }), nA.push({ key: "Height", value: x.height }), x.colorSpace === m.INDEXED ? nA.push({ key: "ColorSpace", value: "[/Indexed /DeviceRGB " + (x.palette.length / 3 - 1) + " " + ("sMask" in x && x.sMask !== void 0 ? x.objectId + 2 : x.objectId + 1) + " 0 R]" }) : (nA.push({ key: "ColorSpace", value: "/" + x.colorSpace }), x.colorSpace === m.DEVICE_CMYK && nA.push({ key: "Decode", value: "[1 0 1 0 1 0 1 0]" })), nA.push({ key: "BitsPerComponent", value: x.bitsPerComponent }), "decodeParameters" in x && x.decodeParameters !== void 0 && nA.push({ key: "DecodeParms", value: "<<" + x.decodeParameters + ">>" }), "transparency" in x && Array.isArray(x.transparency) && x.transparency.length > 0) {
      for (var sA = "", tA = 0, cA = x.transparency.length; tA < cA; tA++) sA += x.transparency[tA] + " " + x.transparency[tA] + " ";
      nA.push({ key: "Mask", value: "[" + sA + "]" });
    }
    x.sMask !== void 0 && nA.push({ key: "SMask", value: x.objectId + 1 + " 0 R" });
    var FA = x.filter !== void 0 ? ["/" + x.filter] : void 0;
    if (N({ data: x.data, additionalKeyValues: nA, alreadyAppliedFilters: FA, objectId: x.objectId }), P("endobj"), "sMask" in x && x.sMask !== void 0) {
      var CA, S = (CA = x.sMaskBitsPerComponent) !== null && CA !== void 0 ? CA : x.bitsPerComponent, W = { width: x.width, height: x.height, colorSpace: "DeviceGray", bitsPerComponent: S, data: x.sMask };
      "filter" in x && (W.decodeParameters = "/Predictor ".concat(x.predictor, " /Colors 1 /BitsPerComponent ").concat(S, " /Columns ").concat(x.width), W.filter = x.filter), U.call(this, W);
    }
    if (x.colorSpace === m.INDEXED) {
      var Y = this.internal.newObject();
      N({ data: D(new Uint8Array(x.palette)), objectId: Y }), P("endobj");
    }
  }, s = function() {
    var U = this.internal.collections[A + "images"];
    for (var x in U) i.call(this, U[x]);
  }, a = function() {
    var U, x = this.internal.collections[A + "images"], P = this.internal.write;
    for (var N in x) P("/I" + (U = x[N]).index, U.objectId, "0", "R");
  }, o = function() {
    this.internal.collections[A + "images"] || (this.internal.collections[A + "images"] = {}, this.internal.events.subscribe("putResources", s), this.internal.events.subscribe("putXobjectDict", a));
  }, l = function() {
    var U = this.internal.collections[A + "images"];
    return o.call(this), U;
  }, c = function() {
    return Object.keys(this.internal.collections[A + "images"]).length;
  }, u = function(U) {
    return typeof e["process" + U.toUpperCase()] == "function";
  }, d = function(U) {
    return it(U) === "object" && U.nodeType === 1;
  }, h = function(U, x) {
    if (U.nodeName === "IMG" && U.hasAttribute("src")) {
      var P = "" + U.getAttribute("src");
      if (P.indexOf("data:image/") === 0) return Jd(unescape(P).split("base64,").pop());
      var N = e.loadFile(P, !0);
      if (N !== void 0) return N;
    }
    if (U.nodeName === "CANVAS") {
      if (U.width === 0 || U.height === 0) throw new Error("Given canvas must have data. Canvas width: " + U.width + ", height: " + U.height);
      var iA;
      switch (x) {
        case "PNG":
          iA = "image/png";
          break;
        case "WEBP":
          iA = "image/webp";
          break;
        default:
          iA = "image/jpeg";
      }
      return Jd(U.toDataURL(iA, 1).split("base64,").pop());
    }
  }, p = function(U) {
    var x = this.internal.collections[A + "images"];
    if (x) {
      for (var P in x) if (U === x[P].alias) return x[P];
    }
  }, B = function(U, x, P) {
    return U || x || (U = -96, x = -96), U < 0 && (U = -1 * P.width * 72 / U / this.internal.scaleFactor), x < 0 && (x = -1 * P.height * 72 / x / this.internal.scaleFactor), U === 0 && (U = x * P.width / P.height), x === 0 && (x = U * P.height / P.width), [U, x];
  }, y = function(U, x, P, N, iA, nA) {
    var sA = B.call(this, P, N, iA), tA = this.internal.getCoordinateString, cA = this.internal.getVerticalCoordinateString, FA = l.call(this);
    if (P = sA[0], N = sA[1], FA[iA.index] = iA, nA) {
      nA *= Math.PI / 180;
      var CA = Math.cos(nA), S = Math.sin(nA), W = function(AA) {
        return AA.toFixed(4);
      }, Y = [W(CA), W(S), W(-1 * S), W(CA), 0, 0, "cm"];
    }
    this.internal.write("q"), nA ? (this.internal.write([1, "0", "0", 1, tA(U), cA(x + N), "cm"].join(" ")), this.internal.write(Y.join(" ")), this.internal.write([tA(P), "0", "0", tA(N), "0", "0", "cm"].join(" "))) : this.internal.write([tA(P), "0", "0", tA(N), tA(U), cA(x + N), "cm"].join(" ")), this.isAdvancedAPI() && this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")), this.internal.write("/I" + iA.index + " Do"), this.internal.write("Q");
  }, m = e.color_spaces = { DEVICE_RGB: "DeviceRGB", DEVICE_GRAY: "DeviceGray", DEVICE_CMYK: "DeviceCMYK", CAL_GREY: "CalGray", CAL_RGB: "CalRGB", LAB: "Lab", ICC_BASED: "ICCBased", INDEXED: "Indexed", PATTERN: "Pattern", SEPARATION: "Separation", DEVICE_N: "DeviceN" };
  e.decode = { DCT_DECODE: "DCTDecode", FLATE_DECODE: "FlateDecode", LZW_DECODE: "LZWDecode", JPX_DECODE: "JPXDecode", JBIG2_DECODE: "JBIG2Decode", ASCII85_DECODE: "ASCII85Decode", ASCII_HEX_DECODE: "ASCIIHexDecode", RUN_LENGTH_DECODE: "RunLengthDecode", CCITT_FAX_DECODE: "CCITTFaxDecode" };
  var C = e.image_compression = { NONE: "NONE", FAST: "FAST", MEDIUM: "MEDIUM", SLOW: "SLOW" }, Q = e.__addimage__.sHashCode = function(U) {
    var x, P, N = 0;
    if (typeof U == "string") for (P = U.length, x = 0; x < P; x++) N = (N << 5) - N + U.charCodeAt(x), N |= 0;
    else if (V(U)) for (P = U.byteLength / 2, x = 0; x < P; x++) N = (N << 5) - N + U[x], N |= 0;
    return N;
  }, F = e.__addimage__.validateStringAsBase64 = function(U) {
    (U = U || "").toString().trim();
    var x = !0;
    return U.length === 0 && (x = !1), U.length % 4 != 0 && (x = !1), /^[A-Za-z0-9+/]+$/.test(U.substr(0, U.length - 2)) === !1 && (x = !1), /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(U.substr(-2)) === !1 && (x = !1), x;
  }, T = e.__addimage__.extractImageFromDataUrl = function(U) {
    if (U == null || !(U = U.trim()).startsWith("data:")) return null;
    var x = U.indexOf(",");
    return x < 0 ? null : U.substring(0, x).trim().endsWith("base64") ? U.substring(x + 1) : null;
  };
  e.__addimage__.isArrayBuffer = function(U) {
    return U instanceof ArrayBuffer;
  };
  var V = e.__addimage__.isArrayBufferView = function(U) {
    return U instanceof Int8Array || U instanceof Uint8Array || U instanceof Uint8ClampedArray || U instanceof Int16Array || U instanceof Uint16Array || U instanceof Int32Array || U instanceof Uint32Array || U instanceof Float32Array || U instanceof Float64Array;
  }, M = e.__addimage__.binaryStringToUint8Array = function(U) {
    for (var x = U.length, P = new Uint8Array(x), N = 0; N < x; N++) P[N] = U.charCodeAt(N);
    return P;
  }, D = e.__addimage__.arrayBufferToBinaryString = function(U) {
    for (var x = "", P = V(U) ? U : new Uint8Array(U), N = 0; N < P.length; N += 8192) x += String.fromCharCode.apply(null, P.subarray(N, N + 8192));
    return x;
  };
  e.addImage = function() {
    var U, x, P, N, iA, nA, sA, tA, cA;
    if (typeof arguments[1] == "number" ? (x = t, P = arguments[1], N = arguments[2], iA = arguments[3], nA = arguments[4], sA = arguments[5], tA = arguments[6], cA = arguments[7]) : (x = arguments[1], P = arguments[2], N = arguments[3], iA = arguments[4], nA = arguments[5], sA = arguments[6], tA = arguments[7], cA = arguments[8]), it(U = arguments[0]) === "object" && !d(U) && "imageData" in U) {
      var FA = U;
      U = FA.imageData, x = FA.format || x || t, P = FA.x || P || 0, N = FA.y || N || 0, iA = FA.w || FA.width || iA, nA = FA.h || FA.height || nA, sA = FA.alias || sA, tA = FA.compression || tA, cA = FA.rotation || FA.angle || cA;
    }
    var CA = this.internal.getFilters();
    if (tA === void 0 && CA.indexOf("FlateEncode") !== -1 && (tA = "SLOW"), isNaN(P) || isNaN(N)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
    o.call(this);
    var S = I.call(this, U, x, sA, tA);
    return y.call(this, P, N, iA, nA, S, cA), this;
  };
  var I = function(U, x, P, N) {
    var iA, nA, sA;
    if (typeof U == "string" && n(U) === t) {
      U = unescape(U);
      var tA = q(U, !1);
      (tA !== "" || (tA = e.loadFile(U, !0)) !== void 0) && (U = tA);
    }
    if (d(U) && (U = h(U, x)), x = n(U, x), !u(x)) throw new Error("addImage does not support files of type '" + x + "', please ensure that a plugin for '" + x + "' support is added.");
    if (((sA = P) == null || sA.length === 0) && (P = (function(cA) {
      return typeof cA == "string" || V(cA) ? Q(cA) : V(cA.data) ? Q(cA.data) : null;
    })(U)), (iA = p.call(this, P)) || (U instanceof Uint8Array || x === "RGBA" || (nA = U, U = M(U)), iA = this["process" + x.toUpperCase()](U, c.call(this), P, (function(cA) {
      return cA && typeof cA == "string" && (cA = cA.toUpperCase()), cA in e.image_compression ? cA : C.NONE;
    })(N), nA)), !iA) throw new Error("An unknown error occurred whilst processing the image.");
    return iA;
  }, q = e.__addimage__.convertBase64ToBinaryString = function(U, x) {
    x = typeof x != "boolean" || x;
    var P, N = "";
    if (typeof U == "string") {
      var iA;
      P = (iA = T(U)) !== null && iA !== void 0 ? iA : U;
      try {
        N = Jd(P);
      } catch (nA) {
        if (x) throw F(P) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + nA.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
      }
    }
    return N;
  };
  e.getImageProperties = function(U) {
    var x, P, N = "";
    if (d(U) && (U = h(U)), typeof U == "string" && n(U) === t && ((N = q(U, !1)) === "" && (N = e.loadFile(U) || ""), U = N), P = n(U), !u(P)) throw new Error("addImage does not support files of type '" + P + "', please ensure that a plugin for '" + P + "' support is added.");
    if (U instanceof Uint8Array || (U = M(U)), !(x = this["process" + P.toUpperCase()](U))) throw new Error("An unknown error occurred whilst processing the image");
    return x.fileType = P, x;
  };
})(we.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(e) {
  var A = function(t) {
    if (t !== void 0 && t != "") return !0;
  };
  we.API.events.push(["addPage", function(t) {
    this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
  }]), e.events.push(["putPage", function(t) {
    for (var r, n, i, s = this.internal.getCoordinateString, a = this.internal.getVerticalCoordinateString, o = this.internal.getPageInfoByObjId(t.objId), l = t.pageContext.annotations, c = !1, u = 0; u < l.length && !c; u++) switch ((r = l[u]).type) {
      case "link":
        (A(r.options.url) || A(r.options.pageNumber)) && (c = !0);
        break;
      case "reference":
      case "text":
      case "freetext":
        c = !0;
    }
    if (c != 0) {
      this.internal.write("/Annots [");
      for (var d = 0; d < l.length; d++) {
        r = l[d];
        var h = this.internal.pdfEscape, p = this.internal.getEncryptor(t.objId);
        switch (r.type) {
          case "reference":
            this.internal.write(" " + r.object.objId + " 0 R ");
            break;
          case "text":
            var B = this.internal.newAdditionalObject(), y = this.internal.newAdditionalObject(), m = this.internal.getEncryptor(B.objId), C = r.title || "Note";
            i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + s(r.bounds.x) + " " + a(r.bounds.y + r.bounds.h) + " " + s(r.bounds.x + r.bounds.w) + " " + a(r.bounds.y) + "] ") + "/Contents (" + h(m(r.contents)) + ")", i += " /Popup " + y.objId + " 0 R", i += " /P " + o.objId + " 0 R", i += " /T (" + h(m(C)) + ") >>", B.content = i;
            var Q = B.objId + " 0 R";
            i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + s(r.bounds.x + 30) + " " + a(r.bounds.y + r.bounds.h) + " " + s(r.bounds.x + r.bounds.w + 30) + " " + a(r.bounds.y) + "] ") + " /Parent " + Q, r.open && (i += " /Open true"), i += " >>", y.content = i, this.internal.write(B.objId, "0 R", y.objId, "0 R");
            break;
          case "freetext":
            n = "/Rect [" + s(r.bounds.x) + " " + a(r.bounds.y) + " " + s(r.bounds.x + r.bounds.w) + " " + a(r.bounds.y + r.bounds.h) + "] ";
            var F = "font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + (r.color || "#000000");
            i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + h(p(r.contents)) + ")", i += " /DS(" + h(p(F)) + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
            break;
          case "link":
            if (r.options.name) {
              var T = this.annotations._nameMap[r.options.name];
              r.options.pageNumber = T.page, r.options.top = T.y;
            } else r.options.top || (r.options.top = 0);
            if (n = "/Rect [" + r.finalBounds.x + " " + r.finalBounds.y + " " + r.finalBounds.w + " " + r.finalBounds.h + "] ", i = "", r.options.url) i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + h(p(r.options.url)) + ") >>";
            else if (r.options.pageNumber) switch (i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r.options.pageNumber).objId + " 0 R", r.options.magFactor = r.options.magFactor || "XYZ", r.options.magFactor) {
              case "Fit":
                i += " /Fit]";
                break;
              case "FitH":
                i += " /FitH " + r.options.top + "]";
                break;
              case "FitV":
                r.options.left = r.options.left || 0, i += " /FitV " + r.options.left + "]";
                break;
              default:
                var V = a(r.options.top);
                r.options.left = r.options.left || 0, r.options.zoom === void 0 && (r.options.zoom = 0), i += " /XYZ " + r.options.left + " " + V + " " + r.options.zoom + "]";
            }
            i != "" && (i += " >>", this.internal.write(i));
        }
      }
      this.internal.write("]");
    }
  }]), e.createAnnotation = function(t) {
    var r = this.internal.getCurrentPageInfo();
    switch (t.type) {
      case "link":
        this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
        break;
      case "text":
      case "freetext":
        r.pageContext.annotations.push(t);
    }
  }, e.link = function(t, r, n, i, s) {
    var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, l = this.internal.getVerticalCoordinateString;
    a.pageContext.annotations.push({ finalBounds: { x: o(t), y: l(r), w: o(t + n), h: l(r + i) }, options: s, type: "link" });
  }, e.textWithLink = function(t, r, n, i) {
    var s, a, o = this.getTextWidth(t), l = this.internal.getLineHeight() / this.internal.scaleFactor;
    if (i.maxWidth !== void 0) {
      a = i.maxWidth;
      var c = this.splitTextToSize(t, a).length;
      s = Math.ceil(l * c);
    } else a = o, s = l;
    return this.text(t, r, n, i), n += 0.2 * l, i.align === "center" && (r -= o / 2), i.align === "right" && (r -= o), this.link(r, n - l, a, s, i), o;
  }, e.getTextWidth = function(t) {
    var r = this.internal.getFontSize();
    return this.getStringUnitWidth(t) * r / this.internal.scaleFactor;
  };
})(we.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(e) {
  var A = { 1569: [65152], 1570: [65153, 65154], 1571: [65155, 65156], 1572: [65157, 65158], 1573: [65159, 65160], 1574: [65161, 65162, 65163, 65164], 1575: [65165, 65166], 1576: [65167, 65168, 65169, 65170], 1577: [65171, 65172], 1578: [65173, 65174, 65175, 65176], 1579: [65177, 65178, 65179, 65180], 1580: [65181, 65182, 65183, 65184], 1581: [65185, 65186, 65187, 65188], 1582: [65189, 65190, 65191, 65192], 1583: [65193, 65194], 1584: [65195, 65196], 1585: [65197, 65198], 1586: [65199, 65200], 1587: [65201, 65202, 65203, 65204], 1588: [65205, 65206, 65207, 65208], 1589: [65209, 65210, 65211, 65212], 1590: [65213, 65214, 65215, 65216], 1591: [65217, 65218, 65219, 65220], 1592: [65221, 65222, 65223, 65224], 1593: [65225, 65226, 65227, 65228], 1594: [65229, 65230, 65231, 65232], 1601: [65233, 65234, 65235, 65236], 1602: [65237, 65238, 65239, 65240], 1603: [65241, 65242, 65243, 65244], 1604: [65245, 65246, 65247, 65248], 1605: [65249, 65250, 65251, 65252], 1606: [65253, 65254, 65255, 65256], 1607: [65257, 65258, 65259, 65260], 1608: [65261, 65262], 1609: [65263, 65264, 64488, 64489], 1610: [65265, 65266, 65267, 65268], 1649: [64336, 64337], 1655: [64477], 1657: [64358, 64359, 64360, 64361], 1658: [64350, 64351, 64352, 64353], 1659: [64338, 64339, 64340, 64341], 1662: [64342, 64343, 64344, 64345], 1663: [64354, 64355, 64356, 64357], 1664: [64346, 64347, 64348, 64349], 1667: [64374, 64375, 64376, 64377], 1668: [64370, 64371, 64372, 64373], 1670: [64378, 64379, 64380, 64381], 1671: [64382, 64383, 64384, 64385], 1672: [64392, 64393], 1676: [64388, 64389], 1677: [64386, 64387], 1678: [64390, 64391], 1681: [64396, 64397], 1688: [64394, 64395], 1700: [64362, 64363, 64364, 64365], 1702: [64366, 64367, 64368, 64369], 1705: [64398, 64399, 64400, 64401], 1709: [64467, 64468, 64469, 64470], 1711: [64402, 64403, 64404, 64405], 1713: [64410, 64411, 64412, 64413], 1715: [64406, 64407, 64408, 64409], 1722: [64414, 64415], 1723: [64416, 64417, 64418, 64419], 1726: [64426, 64427, 64428, 64429], 1728: [64420, 64421], 1729: [64422, 64423, 64424, 64425], 1733: [64480, 64481], 1734: [64473, 64474], 1735: [64471, 64472], 1736: [64475, 64476], 1737: [64482, 64483], 1739: [64478, 64479], 1740: [64508, 64509, 64510, 64511], 1744: [64484, 64485, 64486, 64487], 1746: [64430, 64431], 1747: [64432, 64433] }, t = { 65247: { 65154: 65269, 65156: 65271, 65160: 65273, 65166: 65275 }, 65248: { 65154: 65270, 65156: 65272, 65160: 65274, 65166: 65276 }, 65165: { 65247: { 65248: { 65258: 65010 } } }, 1617: { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 } }, r = { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 }, n = [1570, 1571, 1573, 1575];
  e.__arabicParser__ = {};
  var i = e.__arabicParser__.isInArabicSubstitutionA = function(B) {
    return A[B.charCodeAt(0)] !== void 0;
  }, s = e.__arabicParser__.isArabicLetter = function(B) {
    return typeof B == "string" && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(B);
  }, a = e.__arabicParser__.isArabicEndLetter = function(B) {
    return s(B) && i(B) && A[B.charCodeAt(0)].length <= 2;
  }, o = e.__arabicParser__.isArabicAlfLetter = function(B) {
    return s(B) && n.indexOf(B.charCodeAt(0)) >= 0;
  };
  e.__arabicParser__.arabicLetterHasIsolatedForm = function(B) {
    return s(B) && i(B) && A[B.charCodeAt(0)].length >= 1;
  };
  var l = e.__arabicParser__.arabicLetterHasFinalForm = function(B) {
    return s(B) && i(B) && A[B.charCodeAt(0)].length >= 2;
  };
  e.__arabicParser__.arabicLetterHasInitialForm = function(B) {
    return s(B) && i(B) && A[B.charCodeAt(0)].length >= 3;
  };
  var c = e.__arabicParser__.arabicLetterHasMedialForm = function(B) {
    return s(B) && i(B) && A[B.charCodeAt(0)].length == 4;
  }, u = e.__arabicParser__.resolveLigatures = function(B) {
    var y = 0, m = t, C = "", Q = 0;
    for (y = 0; y < B.length; y += 1) m[B.charCodeAt(y)] !== void 0 ? (Q++, typeof (m = m[B.charCodeAt(y)]) == "number" && (C += String.fromCharCode(m), m = t, Q = 0), y === B.length - 1 && (m = t, C += B.charAt(y - (Q - 1)), y -= Q - 1, Q = 0)) : (m = t, C += B.charAt(y - Q), y -= Q, Q = 0);
    return C;
  };
  e.__arabicParser__.isArabicDiacritic = function(B) {
    return B !== void 0 && r[B.charCodeAt(0)] !== void 0;
  };
  var d = e.__arabicParser__.getCorrectForm = function(B, y, m) {
    return s(B) ? i(B) === !1 ? -1 : !l(B) || !s(y) && !s(m) || !s(m) && a(y) || a(B) && !s(y) || a(B) && o(y) || a(B) && a(y) ? 0 : c(B) && s(y) && !a(y) && s(m) && l(m) ? 3 : a(B) || !s(m) ? 1 : 2 : -1;
  }, h = function(B) {
    var y = 0, m = 0, C = 0, Q = "", F = "", T = "", V = (B = B || "").split("\\s+"), M = [];
    for (y = 0; y < V.length; y += 1) {
      for (M.push(""), m = 0; m < V[y].length; m += 1) Q = V[y][m], F = V[y][m - 1], T = V[y][m + 1], s(Q) ? (C = d(Q, F, T), M[y] += C !== -1 ? String.fromCharCode(A[Q.charCodeAt(0)][C]) : Q) : M[y] += Q;
      M[y] = u(M[y]);
    }
    return M.join(" ");
  }, p = e.__arabicParser__.processArabic = e.processArabic = function() {
    var B, y = typeof arguments[0] == "string" ? arguments[0] : arguments[0].text, m = [];
    if (Array.isArray(y)) {
      var C = 0;
      for (m = [], C = 0; C < y.length; C += 1) Array.isArray(y[C]) ? m.push([h(y[C][0]), y[C][1], y[C][2]]) : m.push([h(y[C])]);
      B = m;
    } else B = h(y);
    return typeof arguments[0] == "string" ? B : (arguments[0].text = B, arguments[0]);
  };
  e.events.push(["preProcessText", p]);
})(we.API), we.API.autoPrint = function(e) {
  var A;
  return (e = e || {}).variant = e.variant || "non-conform", e.variant === "javascript" ? this.addJS("print({});") : (this.internal.events.subscribe("postPutResources", function() {
    A = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    this.internal.out("/OpenAction " + A + " 0 R");
  })), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(e) {
  var A = function() {
    var t = void 0;
    Object.defineProperty(this, "pdf", { get: function() {
      return t;
    }, set: function(a) {
      t = a;
    } });
    var r = 150;
    Object.defineProperty(this, "width", { get: function() {
      return r;
    }, set: function(a) {
      r = isNaN(a) || Number.isInteger(a) === !1 || a < 0 ? 150 : a, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = r + 1);
    } });
    var n = 300;
    Object.defineProperty(this, "height", { get: function() {
      return n;
    }, set: function(a) {
      n = isNaN(a) || Number.isInteger(a) === !1 || a < 0 ? 300 : a, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = n + 1);
    } });
    var i = [];
    Object.defineProperty(this, "childNodes", { get: function() {
      return i;
    }, set: function(a) {
      i = a;
    } });
    var s = {};
    Object.defineProperty(this, "style", { get: function() {
      return s;
    }, set: function(a) {
      s = a;
    } }), Object.defineProperty(this, "parentNode", {});
  };
  A.prototype.getContext = function(t, r) {
    var n;
    if ((t = t || "2d") !== "2d") return null;
    for (n in r) this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = r[n]);
    return this.pdf.context2d._canvas = this, this.pdf.context2d;
  }, A.prototype.toDataURL = function() {
    throw new Error("toDataURL is not implemented.");
  }, e.events.push(["initialized", function() {
    this.canvas = new A(), this.canvas.pdf = this;
  }]);
})(we.API), (function(e) {
  var A = { left: 0, top: 0, bottom: 0, right: 0 }, t = !1, r = function() {
    this.internal.__cell__ === void 0 && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, A), this.internal.__cell__.margins.width = this.getPageWidth(), n.call(this));
  }, n = function() {
    this.internal.__cell__.lastCell = new i(), this.internal.__cell__.pages = 1;
  }, i = function() {
    var o = arguments[0];
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return o;
    }, set: function(B) {
      o = B;
    } });
    var l = arguments[1];
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return l;
    }, set: function(B) {
      l = B;
    } });
    var c = arguments[2];
    Object.defineProperty(this, "width", { enumerable: !0, get: function() {
      return c;
    }, set: function(B) {
      c = B;
    } });
    var u = arguments[3];
    Object.defineProperty(this, "height", { enumerable: !0, get: function() {
      return u;
    }, set: function(B) {
      u = B;
    } });
    var d = arguments[4];
    Object.defineProperty(this, "text", { enumerable: !0, get: function() {
      return d;
    }, set: function(B) {
      d = B;
    } });
    var h = arguments[5];
    Object.defineProperty(this, "lineNumber", { enumerable: !0, get: function() {
      return h;
    }, set: function(B) {
      h = B;
    } });
    var p = arguments[6];
    return Object.defineProperty(this, "align", { enumerable: !0, get: function() {
      return p;
    }, set: function(B) {
      p = B;
    } }), this;
  };
  i.prototype.clone = function() {
    return new i(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
  }, i.prototype.toArray = function() {
    return [this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align];
  }, e.setHeaderFunction = function(o) {
    return r.call(this), this.internal.__cell__.headerFunction = typeof o == "function" ? o : void 0, this;
  }, e.getTextDimensions = function(o, l) {
    r.call(this);
    var c = (l = l || {}).fontSize || this.getFontSize(), u = l.font || this.getFont(), d = l.scaleFactor || this.internal.scaleFactor, h = 0, p = 0, B = 0, y = this;
    if (!Array.isArray(o) && typeof o != "string") {
      if (typeof o != "number") throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
      o = String(o);
    }
    var m = l.maxWidth;
    m > 0 ? typeof o == "string" ? o = this.splitTextToSize(o, m) : Object.prototype.toString.call(o) === "[object Array]" && (o = o.reduce(function(Q, F) {
      return Q.concat(y.splitTextToSize(F, m));
    }, [])) : o = Array.isArray(o) ? o : [o];
    for (var C = 0; C < o.length; C++) h < (B = this.getStringUnitWidth(o[C], { font: u }) * c) && (h = B);
    return h !== 0 && (p = o.length), { w: h /= d, h: Math.max((p * c * this.getLineHeightFactor() - c * (this.getLineHeightFactor() - 1)) / d, 0) };
  }, e.cellAddPage = function() {
    r.call(this), this.addPage();
    var o = this.internal.__cell__.margins || A;
    return this.internal.__cell__.lastCell = new i(o.left, o.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
  };
  var s = e.cell = function() {
    var o;
    o = arguments[0] instanceof i ? arguments[0] : new i(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]), r.call(this);
    var l = this.internal.__cell__.lastCell, c = this.internal.__cell__.padding, u = this.internal.__cell__.margins || A, d = this.internal.__cell__.tableHeaderRow, h = this.internal.__cell__.printHeaders;
    return l.lineNumber !== void 0 && (l.lineNumber === o.lineNumber ? (o.x = (l.x || 0) + (l.width || 0), o.y = l.y || 0) : l.y + l.height + o.height + u.bottom > this.getPageHeight() ? (this.cellAddPage(), o.y = u.top, h && d && (this.printHeaderRow(o.lineNumber, !0), o.y += d[0].height)) : o.y = l.y + l.height || o.y), o.text[0] !== void 0 && (this.rect(o.x, o.y, o.width, o.height, t === !0 ? "FD" : void 0), o.align === "right" ? this.text(o.text, o.x + o.width - c, o.y + c, { align: "right", baseline: "top" }) : o.align === "center" ? this.text(o.text, o.x + o.width / 2, o.y + c, { align: "center", baseline: "top", maxWidth: o.width - c - c }) : this.text(o.text, o.x + c, o.y + c, { align: "left", baseline: "top", maxWidth: o.width - c - c })), this.internal.__cell__.lastCell = o, this;
  };
  e.table = function(o, l, c, u, d) {
    if (r.call(this), !c) throw new Error("No data for PDF table.");
    var h, p, B, y, m = [], C = [], Q = [], F = {}, T = {}, V = [], M = [], D = (d = d || {}).autoSize || !1, I = d.printHeaders !== !1, q = d.css && d.css["font-size"] !== void 0 ? 16 * d.css["font-size"] : d.fontSize || 12, U = d.margins || Object.assign({ width: this.getPageWidth() }, A), x = typeof d.padding == "number" ? d.padding : 3, P = d.headerBackgroundColor || "#c8c8c8", N = d.headerTextColor || "#000";
    if (n.call(this), this.internal.__cell__.printHeaders = I, this.internal.__cell__.margins = U, this.internal.__cell__.table_font_size = q, this.internal.__cell__.padding = x, this.internal.__cell__.headerBackgroundColor = P, this.internal.__cell__.headerTextColor = N, this.setFontSize(q), u == null) C = m = Object.keys(c[0]), Q = m.map(function() {
      return "left";
    });
    else if (Array.isArray(u) && it(u[0]) === "object") for (m = u.map(function(FA) {
      return FA.name;
    }), C = u.map(function(FA) {
      return FA.prompt || FA.name || "";
    }), Q = u.map(function(FA) {
      return FA.align || "left";
    }), h = 0; h < u.length; h += 1) T[u[h].name] = 0.7499990551181103 * u[h].width;
    else Array.isArray(u) && typeof u[0] == "string" && (C = m = u, Q = m.map(function() {
      return "left";
    }));
    if (D || Array.isArray(u) && typeof u[0] == "string") for (h = 0; h < m.length; h += 1) {
      for (F[y = m[h]] = c.map(function(FA) {
        return FA[y];
      }), this.setFont(void 0, "bold"), V.push(this.getTextDimensions(C[h], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w), p = F[y], this.setFont(void 0, "normal"), B = 0; B < p.length; B += 1) V.push(this.getTextDimensions(p[B], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w);
      T[y] = Math.max.apply(null, V) + x + x, V = [];
    }
    if (I) {
      var iA = {};
      for (h = 0; h < m.length; h += 1) iA[m[h]] = {}, iA[m[h]].text = C[h], iA[m[h]].align = Q[h];
      var nA = a.call(this, iA, T);
      M = m.map(function(FA) {
        return new i(o, l, T[FA], nA, iA[FA].text, void 0, iA[FA].align);
      }), this.setTableHeaderRow(M), this.printHeaderRow(1, !1);
    }
    var sA = u.reduce(function(FA, CA) {
      return FA[CA.name] = CA.align, FA;
    }, {});
    for (h = 0; h < c.length; h += 1) {
      "rowStart" in d && d.rowStart instanceof Function && d.rowStart({ row: h, data: c[h] }, this);
      var tA = a.call(this, c[h], T);
      for (B = 0; B < m.length; B += 1) {
        var cA = c[h][m[B]];
        "cellStart" in d && d.cellStart instanceof Function && d.cellStart({ row: h, col: B, data: cA }, this), s.call(this, new i(o, l, T[m[B]], tA, cA, h + 2, sA[m[B]]));
      }
    }
    return this.internal.__cell__.table_x = o, this.internal.__cell__.table_y = l, this;
  };
  var a = function(o, l) {
    var c = this.internal.__cell__.padding, u = this.internal.__cell__.table_font_size, d = this.internal.scaleFactor;
    return Object.keys(o).map(function(h) {
      var p = o[h];
      return this.splitTextToSize(p.hasOwnProperty("text") ? p.text : p, l[h] - c - c);
    }, this).map(function(h) {
      return this.getLineHeightFactor() * h.length * u / d + c + c;
    }, this).reduce(function(h, p) {
      return Math.max(h, p);
    }, 0);
  };
  e.setTableHeaderRow = function(o) {
    r.call(this), this.internal.__cell__.tableHeaderRow = o;
  }, e.printHeaderRow = function(o, l) {
    if (r.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
    var c;
    if (t = !0, typeof this.internal.__cell__.headerFunction == "function") {
      var u = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
      this.internal.__cell__.lastCell = new i(u[0], u[1], u[2], u[3], void 0, -1);
    }
    this.setFont(void 0, "bold");
    for (var d = [], h = 0; h < this.internal.__cell__.tableHeaderRow.length; h += 1) {
      c = this.internal.__cell__.tableHeaderRow[h].clone(), l && (c.y = this.internal.__cell__.margins.top || 0, d.push(c)), c.lineNumber = o;
      var p = this.getTextColor();
      this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, c), this.setTextColor(p);
    }
    d.length > 0 && this.setTableHeaderRow(d), this.setFont(void 0, "normal"), t = !1;
  };
})(we.API);
var O3 = { italic: ["italic", "oblique", "normal"], oblique: ["oblique", "italic", "normal"], normal: ["normal", "oblique", "italic"] }, N3 = ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded"], Qv = _3(N3), D3 = [100, 200, 300, 400, 500, 600, 700, 800, 900], kW = _3(D3);
function lw(e) {
  var A = e.family.replace(/"|'/g, "").toLowerCase(), t = (function(i) {
    return O3[i = i || "normal"] ? i : "normal";
  })(e.style), r = (function(i) {
    return i ? typeof i == "number" ? i >= 100 && i <= 900 && i % 100 == 0 ? i : 400 : /^\d00$/.test(i) ? parseInt(i) : i === "bold" ? 700 : 400 : 400;
  })(e.weight), n = (function(i) {
    return typeof Qv[i = i || "normal"] == "number" ? i : "normal";
  })(e.stretch);
  return { family: A, style: t, weight: r, stretch: n, src: e.src || [], ref: e.ref || { name: A, style: [n, t, r].join(" ") } };
}
function nQ(e, A, t, r) {
  var n;
  for (n = t; n >= 0 && n < A.length; n += r) if (e[A[n]]) return e[A[n]];
  for (n = t; n >= 0 && n < A.length; n -= r) if (e[A[n]]) return e[A[n]];
}
var KW = { "sans-serif": "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", cursive: "times", fantasy: "times", serif: "times" }, iQ = { caption: "times", icon: "times", menu: "times", "message-box": "times", "small-caption": "times", "status-bar": "times" };
function sQ(e) {
  return [e.stretch, e.style, e.weight, e.family].join(" ");
}
function aQ(e) {
  return e.trimLeft();
}
function VW(e, A) {
  for (var t = 0; t < e.length; ) {
    if (e.charAt(t) === A) return [e.substring(0, t), e.substring(t + 1)];
    t += 1;
  }
  return null;
}
function GW(e) {
  var A = e.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
  return A === null ? null : [A[0], e.substring(A[0].length)];
}
var Ec, Bd, oQ, lQ, cQ, cw = ["times"];
function uQ(e, A, t, r, n) {
  var i = 4, s = fQ;
  switch (n) {
    case we.API.image_compression.FAST:
      i = 1, s = hQ;
      break;
    case we.API.image_compression.MEDIUM:
      i = 6, s = dQ;
      break;
    case we.API.image_compression.SLOW:
      i = 9, s = gQ;
  }
  e = (function(o, l, c, u) {
    for (var d, h = o.length / l, p = new Uint8Array(o.length + h), B = [WW, hQ, fQ, dQ, gQ], y = 0; y < h; y += 1) {
      var m = y * l, C = o.subarray(m, m + l);
      if (u) p.set(u(C, c, d), m + y);
      else {
        for (var Q = B.length, F = [], T = 0; T < Q; T += 1) F[T] = B[T](C, c, d);
        var V = qW(F.concat());
        p.set(F[V], m + y);
      }
      d = C;
    }
    return p;
  })(e, A, Math.ceil(t * r / 8), s);
  var a = wv(e, { level: i });
  return we.API.__addimage__.arrayBufferToBinaryString(a);
}
function WW(e) {
  var A = Array.apply([], e);
  return A.unshift(0), A;
}
function hQ(e, A) {
  var t = e.length, r = [];
  r[0] = 1;
  for (var n = 0; n < t; n += 1) {
    var i = e[n - A] || 0;
    r[n + 1] = e[n] - i + 256 & 255;
  }
  return r;
}
function fQ(e, A, t) {
  var r = e.length, n = [];
  n[0] = 2;
  for (var i = 0; i < r; i += 1) {
    var s = t && t[i] || 0;
    n[i + 1] = e[i] - s + 256 & 255;
  }
  return n;
}
function dQ(e, A, t) {
  var r = e.length, n = [];
  n[0] = 3;
  for (var i = 0; i < r; i += 1) {
    var s = e[i - A] || 0, a = t && t[i] || 0;
    n[i + 1] = e[i] + 256 - (s + a >>> 1) & 255;
  }
  return n;
}
function gQ(e, A, t) {
  var r = e.length, n = [];
  n[0] = 4;
  for (var i = 0; i < r; i += 1) {
    var s = jW(e[i - A] || 0, t && t[i] || 0, t && t[i - A] || 0);
    n[i + 1] = e[i] - s + 256 & 255;
  }
  return n;
}
function jW(e, A, t) {
  if (e === A && A === t) return e;
  var r = Math.abs(A - t), n = Math.abs(e - t), i = Math.abs(e + A - t - t);
  return r <= n && r <= i ? e : n <= i ? A : t;
}
function qW(e) {
  var A = e.map(function(t) {
    return t.reduce(function(r, n) {
      return r + Math.abs(n);
    }, 0);
  });
  return A.indexOf(Math.min.apply(null, A));
}
function uw(e, A, t) {
  var r = A * t, n = Math.floor(r / 8), i = 16 - (r - 8 * n + t), s = (1 << t) - 1;
  return R3(e, n) >> i & s;
}
function pQ(e, A, t, r) {
  var n = t * r, i = Math.floor(n / 8), s = 16 - (n - 8 * i + r), a = (1 << r) - 1, o = (A & a) << s;
  (function(l, c, u) {
    if (c + 1 < l.byteLength) l.setUint16(c, u, !1);
    else {
      var d = u >> 8 & 255;
      l.setUint8(c, d);
    }
  })(e, i, R3(e, i) & ~(a << s) & 65535 | o);
}
function R3(e, A) {
  return A + 1 < e.byteLength ? e.getUint16(A, !1) : e.getUint8(A) << 8;
}
function $W(e) {
  var A = 0;
  if (e[A++] !== 71 || e[A++] !== 73 || e[A++] !== 70 || e[A++] !== 56 || (e[A++] + 1 & 253) != 56 || e[A++] !== 97) throw new Error("Invalid GIF 87a/89a header.");
  var t = e[A++] | e[A++] << 8, r = e[A++] | e[A++] << 8, n = e[A++], i = n >> 7, s = 1 << 1 + (7 & n);
  e[A++], e[A++];
  var a = null, o = null;
  i && (a = A, o = s, A += 3 * s);
  var l = !0, c = [], u = 0, d = null, h = 0, p = null;
  for (this.width = t, this.height = r; l && A < e.length; ) switch (e[A++]) {
    case 33:
      switch (e[A++]) {
        case 255:
          if (e[A] !== 11 || e[A + 1] == 78 && e[A + 2] == 69 && e[A + 3] == 84 && e[A + 4] == 83 && e[A + 5] == 67 && e[A + 6] == 65 && e[A + 7] == 80 && e[A + 8] == 69 && e[A + 9] == 50 && e[A + 10] == 46 && e[A + 11] == 48 && e[A + 12] == 3 && e[A + 13] == 1 && e[A + 16] == 0) A += 14, p = e[A++] | e[A++] << 8, A++;
          else for (A += 12; ; ) {
            if (!((U = e[A++]) >= 0)) throw Error("Invalid block size");
            if (U === 0) break;
            A += U;
          }
          break;
        case 249:
          if (e[A++] !== 4 || e[A + 4] !== 0) throw new Error("Invalid graphics extension block.");
          var B = e[A++];
          u = e[A++] | e[A++] << 8, d = e[A++], 1 & B || (d = null), h = B >> 2 & 7, A++;
          break;
        case 254:
          for (; ; ) {
            if (!((U = e[A++]) >= 0)) throw Error("Invalid block size");
            if (U === 0) break;
            A += U;
          }
          break;
        default:
          throw new Error("Unknown graphic control label: 0x" + e[A - 1].toString(16));
      }
      break;
    case 44:
      var y = e[A++] | e[A++] << 8, m = e[A++] | e[A++] << 8, C = e[A++] | e[A++] << 8, Q = e[A++] | e[A++] << 8, F = e[A++], T = F >> 6 & 1, V = 1 << 1 + (7 & F), M = a, D = o, I = !1;
      F >> 7 && (I = !0, M = A, D = V, A += 3 * V);
      var q = A;
      for (A++; ; ) {
        var U;
        if (!((U = e[A++]) >= 0)) throw Error("Invalid block size");
        if (U === 0) break;
        A += U;
      }
      c.push({ x: y, y: m, width: C, height: Q, has_local_palette: I, palette_offset: M, palette_size: D, data_offset: q, data_length: A - q, transparent_index: d, interlaced: !!T, delay: u, disposal: h });
      break;
    case 59:
      l = !1;
      break;
    default:
      throw new Error("Unknown gif block: 0x" + e[A - 1].toString(16));
  }
  this.numFrames = function() {
    return c.length;
  }, this.loopCount = function() {
    return p;
  }, this.frameInfo = function(x) {
    if (x < 0 || x >= c.length) throw new Error("Frame index out of range.");
    return c[x];
  }, this.decodeAndBlitFrameBGRA = function(x, P) {
    var N = this.frameInfo(x), iA = N.width * N.height;
    if (iA > 536870912) throw new Error("Image dimensions exceed 512MB, which is too large.");
    var nA = new Uint8Array(iA);
    BQ(e, N.data_offset, nA, iA);
    var sA = N.palette_offset, tA = N.transparent_index;
    tA === null && (tA = 256);
    var cA = N.width, FA = t - cA, CA = cA, S = 4 * (N.y * t + N.x), W = 4 * ((N.y + N.height) * t + N.x), Y = S, AA = 4 * FA;
    N.interlaced === !0 && (AA += 4 * t * 7);
    for (var oA = 8, gA = 0, xA = nA.length; gA < xA; ++gA) {
      var IA = nA[gA];
      if (CA === 0 && (CA = cA, (Y += AA) >= W && (AA = 4 * FA + 4 * t * (oA - 1), Y = S + (cA + FA) * (oA << 1), oA >>= 1)), IA === tA) Y += 4;
      else {
        var pA = e[sA + 3 * IA], WA = e[sA + 3 * IA + 1], k = e[sA + 3 * IA + 2];
        P[Y++] = k, P[Y++] = WA, P[Y++] = pA, P[Y++] = 255;
      }
      --CA;
    }
  }, this.decodeAndBlitFrameRGBA = function(x, P) {
    var N = this.frameInfo(x), iA = N.width * N.height;
    if (iA > 536870912) throw new Error("Image dimensions exceed 512MB, which is too large.");
    var nA = new Uint8Array(iA);
    BQ(e, N.data_offset, nA, iA);
    var sA = N.palette_offset, tA = N.transparent_index;
    tA === null && (tA = 256);
    var cA = N.width, FA = t - cA, CA = cA, S = 4 * (N.y * t + N.x), W = 4 * ((N.y + N.height) * t + N.x), Y = S, AA = 4 * FA;
    N.interlaced === !0 && (AA += 4 * t * 7);
    for (var oA = 8, gA = 0, xA = nA.length; gA < xA; ++gA) {
      var IA = nA[gA];
      if (CA === 0 && (CA = cA, (Y += AA) >= W && (AA = 4 * FA + 4 * t * (oA - 1), Y = S + (cA + FA) * (oA << 1), oA >>= 1)), IA === tA) Y += 4;
      else {
        var pA = e[sA + 3 * IA], WA = e[sA + 3 * IA + 1], k = e[sA + 3 * IA + 2];
        P[Y++] = pA, P[Y++] = WA, P[Y++] = k, P[Y++] = 255;
      }
      --CA;
    }
  };
}
function BQ(e, A, t, r) {
  for (var n = e[A++], i = 1 << n, s = i + 1, a = s + 1, o = n + 1, l = (1 << o) - 1, c = 0, u = 0, d = 0, h = e[A++], p = new Int32Array(4096), B = null; ; ) {
    for (; c < 16 && h !== 0; ) u |= e[A++] << c, c += 8, h === 1 ? h = e[A++] : --h;
    if (c < o) break;
    var y = u & l;
    if (u >>= o, c -= o, y !== i) {
      if (y === s) break;
      for (var m = y < a ? y : B, C = 0, Q = m; Q > i; ) Q = p[Q] >> 8, ++C;
      var F = Q;
      if (d + C + (m !== y ? 1 : 0) > r) return void Ct.log("Warning, gif stream longer than expected.");
      t[d++] = F;
      var T = d += C;
      for (m !== y && (t[d++] = F), Q = m; C--; ) Q = p[Q], t[--T] = 255 & Q, Q >>= 8;
      B !== null && a < 4096 && (p[a++] = B << 8 | F, a >= l + 1 && o < 12 && (++o, l = l << 1 | 1)), B = y;
    } else a = s + 1, l = (1 << (o = n + 1)) - 1, B = null;
  }
  return d !== r && Ct.log("Warning, gif stream shorter than expected."), t;
}
function hw(e) {
  var A, t, r, n, i, s = Math.floor, a = new Array(64), o = new Array(64), l = new Array(64), c = new Array(64), u = new Array(65535), d = new Array(65535), h = new Array(64), p = new Array(64), B = [], y = 0, m = 7, C = new Array(64), Q = new Array(64), F = new Array(64), T = new Array(256), V = new Array(2048), M = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63], D = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], I = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], q = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], U = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250], x = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], P = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], N = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], iA = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
  function nA(S, W) {
    for (var Y = 0, AA = 0, oA = new Array(), gA = 1; gA <= 16; gA++) {
      for (var xA = 1; xA <= S[gA]; xA++) oA[W[AA]] = [], oA[W[AA]][0] = Y, oA[W[AA]][1] = gA, AA++, Y++;
      Y *= 2;
    }
    return oA;
  }
  function sA(S) {
    for (var W = S[0], Y = S[1] - 1; Y >= 0; ) W & 1 << Y && (y |= 1 << m), Y--, --m < 0 && (y == 255 ? (tA(255), tA(0)) : tA(y), m = 7, y = 0);
  }
  function tA(S) {
    B.push(S);
  }
  function cA(S) {
    tA(S >> 8 & 255), tA(255 & S);
  }
  function FA(S, W, Y, AA, oA) {
    for (var gA, xA = oA[0], IA = oA[240], pA = (function(fA, EA) {
      var lA, HA, SA, yA, TA, _A, MA, VA, $A, ee, ZA = 0;
      for ($A = 0; $A < 8; ++$A) {
        lA = fA[ZA], HA = fA[ZA + 1], SA = fA[ZA + 2], yA = fA[ZA + 3], TA = fA[ZA + 4], _A = fA[ZA + 5], MA = fA[ZA + 6];
        var Fe = lA + (VA = fA[ZA + 7]), me = lA - VA, Ce = HA + MA, ae = HA - MA, Te = SA + _A, ie = SA - _A, Ke = yA + TA, ge = yA - TA, xe = Fe + Ke, Ye = Fe - Ke, ue = Ce + Te, pe = Ce - Te;
        fA[ZA] = xe + ue, fA[ZA + 4] = xe - ue;
        var ze = 0.707106781 * (pe + Ye);
        fA[ZA + 2] = Ye + ze, fA[ZA + 6] = Ye - ze;
        var Ii = 0.382683433 * ((xe = ge + ie) - (pe = ae + me)), Jt = 0.5411961 * xe + Ii, Wr = 1.306562965 * pe + Ii, un = 0.707106781 * (ue = ie + ae), Be = me + un, Jr = me - un;
        fA[ZA + 5] = Jr + Jt, fA[ZA + 3] = Jr - Jt, fA[ZA + 1] = Be + Wr, fA[ZA + 7] = Be - Wr, ZA += 8;
      }
      for (ZA = 0, $A = 0; $A < 8; ++$A) {
        lA = fA[ZA], HA = fA[ZA + 8], SA = fA[ZA + 16], yA = fA[ZA + 24], TA = fA[ZA + 32], _A = fA[ZA + 40], MA = fA[ZA + 48];
        var Zt = lA + (VA = fA[ZA + 56]), Vt = lA - VA, Ar = HA + MA, Bt = HA - MA, er = SA + _A, Gt = SA - _A, ui = yA + TA, hi = yA - TA, Hr = Zt + ui, jr = Zt - ui, tr = Ar + er, Tn = Ar - er;
        fA[ZA] = Hr + tr, fA[ZA + 32] = Hr - tr;
        var hn = 0.707106781 * (Tn + jr);
        fA[ZA + 16] = jr + hn, fA[ZA + 48] = jr - hn;
        var je = 0.382683433 * ((Hr = hi + Gt) - (Tn = Bt + Vt)), Nt = 0.5411961 * Hr + je, Si = 1.306562965 * Tn + je, ts = 0.707106781 * (tr = Gt + Bt), Li = Vt + ts, rs = Vt - ts;
        fA[ZA + 40] = rs + Nt, fA[ZA + 24] = rs - Nt, fA[ZA + 8] = Li + Si, fA[ZA + 56] = Li - Si, ZA++;
      }
      for ($A = 0; $A < 64; ++$A) ee = fA[$A] * EA[$A], h[$A] = ee > 0 ? ee + 0.5 | 0 : ee - 0.5 | 0;
      return h;
    })(S, W), WA = 0; WA < 64; ++WA) p[M[WA]] = pA[WA];
    var k = p[0] - Y;
    Y = p[0], k == 0 ? sA(AA[0]) : (sA(AA[d[gA = 32767 + k]]), sA(u[gA]));
    for (var X = 63; X > 0 && p[X] == 0; ) X--;
    if (X == 0) return sA(xA), Y;
    for (var uA, E = 1; E <= X; ) {
      for (var dA = E; p[E] == 0 && E <= X; ) ++E;
      var vA = E - dA;
      if (vA >= 16) {
        uA = vA >> 4;
        for (var rA = 1; rA <= uA; ++rA) sA(IA);
        vA &= 15;
      }
      gA = 32767 + p[E], sA(oA[(vA << 4) + d[gA]]), sA(u[gA]), E++;
    }
    return X != 63 && sA(xA), Y;
  }
  function CA(S) {
    S = Math.min(Math.max(S, 1), 100), i != S && ((function(W) {
      for (var Y = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], AA = 0; AA < 64; AA++) {
        var oA = s((Y[AA] * W + 50) / 100);
        oA = Math.min(Math.max(oA, 1), 255), a[M[AA]] = oA;
      }
      for (var gA = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], xA = 0; xA < 64; xA++) {
        var IA = s((gA[xA] * W + 50) / 100);
        IA = Math.min(Math.max(IA, 1), 255), o[M[xA]] = IA;
      }
      for (var pA = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379], WA = 0, k = 0; k < 8; k++) for (var X = 0; X < 8; X++) l[WA] = 1 / (a[M[WA]] * pA[k] * pA[X] * 8), c[WA] = 1 / (o[M[WA]] * pA[k] * pA[X] * 8), WA++;
    })(S < 50 ? Math.floor(5e3 / S) : Math.floor(200 - 2 * S)), i = S);
  }
  this.encode = function(S, W) {
    W && CA(W), B = new Array(), y = 0, m = 7, cA(65496), cA(65504), cA(16), tA(74), tA(70), tA(73), tA(70), tA(0), tA(1), tA(1), tA(0), cA(1), cA(1), tA(0), tA(0), (function() {
      cA(65499), cA(132), tA(0);
      for (var HA = 0; HA < 64; HA++) tA(a[HA]);
      tA(1);
      for (var SA = 0; SA < 64; SA++) tA(o[SA]);
    })(), (function(HA, SA) {
      cA(65472), cA(17), tA(8), cA(SA), cA(HA), tA(3), tA(1), tA(17), tA(0), tA(2), tA(17), tA(1), tA(3), tA(17), tA(1);
    })(S.width, S.height), (function() {
      cA(65476), cA(418), tA(0);
      for (var HA = 0; HA < 16; HA++) tA(D[HA + 1]);
      for (var SA = 0; SA <= 11; SA++) tA(I[SA]);
      tA(16);
      for (var yA = 0; yA < 16; yA++) tA(q[yA + 1]);
      for (var TA = 0; TA <= 161; TA++) tA(U[TA]);
      tA(1);
      for (var _A = 0; _A < 16; _A++) tA(x[_A + 1]);
      for (var MA = 0; MA <= 11; MA++) tA(P[MA]);
      tA(17);
      for (var VA = 0; VA < 16; VA++) tA(N[VA + 1]);
      for (var $A = 0; $A <= 161; $A++) tA(iA[$A]);
    })(), cA(65498), cA(12), tA(3), tA(1), tA(0), tA(2), tA(17), tA(3), tA(17), tA(0), tA(63), tA(0);
    var Y = 0, AA = 0, oA = 0;
    y = 0, m = 7, this.encode.displayName = "_encode_";
    for (var gA, xA, IA, pA, WA, k, X, uA, E, dA = S.data, vA = S.width, rA = S.height, fA = 4 * vA, EA = 0; EA < rA; ) {
      for (gA = 0; gA < fA; ) {
        for (WA = fA * EA + gA, X = -1, uA = 0, E = 0; E < 64; E++) k = WA + (uA = E >> 3) * fA + (X = 4 * (7 & E)), EA + uA >= rA && (k -= fA * (EA + 1 + uA - rA)), gA + X >= fA && (k -= gA + X - fA + 4), xA = dA[k++], IA = dA[k++], pA = dA[k++], C[E] = (V[xA] + V[IA + 256 | 0] + V[pA + 512 | 0] >> 16) - 128, Q[E] = (V[xA + 768 | 0] + V[IA + 1024 | 0] + V[pA + 1280 | 0] >> 16) - 128, F[E] = (V[xA + 1280 | 0] + V[IA + 1536 | 0] + V[pA + 1792 | 0] >> 16) - 128;
        Y = FA(C, l, Y, A, r), AA = FA(Q, c, AA, t, n), oA = FA(F, c, oA, t, n), gA += 32;
      }
      EA += 8;
    }
    if (m >= 0) {
      var lA = [];
      lA[1] = m + 1, lA[0] = (1 << m + 1) - 1, sA(lA);
    }
    return cA(65497), new Uint8Array(B);
  }, e = e || 50, (function() {
    for (var S = String.fromCharCode, W = 0; W < 256; W++) T[W] = S(W);
  })(), A = nA(D, I), t = nA(x, P), r = nA(q, U), n = nA(N, iA), (function() {
    for (var S = 1, W = 2, Y = 1; Y <= 15; Y++) {
      for (var AA = S; AA < W; AA++) d[32767 + AA] = Y, u[32767 + AA] = [], u[32767 + AA][1] = Y, u[32767 + AA][0] = AA;
      for (var oA = -(W - 1); oA <= -S; oA++) d[32767 + oA] = Y, u[32767 + oA] = [], u[32767 + oA][1] = Y, u[32767 + oA][0] = W - 1 + oA;
      S <<= 1, W <<= 1;
    }
  })(), (function() {
    for (var S = 0; S < 256; S++) V[S] = 19595 * S, V[S + 256 | 0] = 38470 * S, V[S + 512 | 0] = 7471 * S + 32768, V[S + 768 | 0] = -11059 * S, V[S + 1024 | 0] = -21709 * S, V[S + 1280 | 0] = 32768 * S + 8421375, V[S + 1536 | 0] = -27439 * S, V[S + 1792 | 0] = -5329 * S;
  })(), CA(e);
}
function us(e, A) {
  if (this.pos = 0, this.buffer = e, this.datav = new DataView(e.buffer), this.is_with_alpha = !!A, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag) === -1) throw new Error("Invalid BMP File");
  this.parseHeader(), this.parseBGR();
}
function wQ(e) {
  function A(I) {
    if (!I) throw Error("assert :P");
  }
  function t(I, q, U) {
    for (var x = 0; 4 > x; x++) if (I[q + x] != U.charCodeAt(x)) return !0;
    return !1;
  }
  function r(I, q, U, x, P) {
    for (var N = 0; N < P; N++) I[q + N] = U[x + N];
  }
  function n(I, q, U, x) {
    for (var P = 0; P < x; P++) I[q + P] = U;
  }
  function i(I) {
    return new Int32Array(I);
  }
  function s(I, q) {
    for (var U = [], x = 0; x < I; x++) U.push(new q());
    return U;
  }
  function a(I, q) {
    var U = [];
    return (function x(P, N, iA) {
      for (var nA = iA[N], sA = 0; sA < nA && (P.push(iA.length > N + 1 ? [] : new q()), !(iA.length < N + 1)); sA++) x(P[sA], N + 1, iA);
    })(U, 0, I), U;
  }
  var o = function() {
    var I = this;
    function q(f, g) {
      for (var v = 1 << g - 1 >>> 0; f & v; ) v >>>= 1;
      return v ? (f & v - 1) + v : f;
    }
    function U(f, g, v, b, H) {
      A(!(b % v));
      do
        f[g + (b -= v)] = H;
      while (0 < b);
    }
    function x(f, g, v, b, H) {
      if (A(2328 >= H), 512 >= H) var _ = i(512);
      else if ((_ = i(H)) == null) return 0;
      return (function(R, K, j, J, hA, UA) {
        var Z, BA, bA = K, NA = 1 << j, QA = i(16), DA = i(16);
        for (A(hA != 0), A(J != null), A(R != null), A(0 < j), BA = 0; BA < hA; ++BA) {
          if (15 < J[BA]) return 0;
          ++QA[J[BA]];
        }
        if (QA[0] == hA) return 0;
        for (DA[1] = 0, Z = 1; 15 > Z; ++Z) {
          if (QA[Z] > 1 << Z) return 0;
          DA[Z + 1] = DA[Z] + QA[Z];
        }
        for (BA = 0; BA < hA; ++BA) Z = J[BA], 0 < J[BA] && (UA[DA[Z]++] = BA);
        if (DA[15] == 1) return (J = new P()).g = 0, J.value = UA[0], U(R, bA, 1, NA, J), NA;
        var RA, YA = -1, qA = NA - 1, ve = 0, oe = 1, Ve = 1, fe = 1 << j;
        for (BA = 0, Z = 1, hA = 2; Z <= j; ++Z, hA <<= 1) {
          if (oe += Ve <<= 1, 0 > (Ve -= QA[Z])) return 0;
          for (; 0 < QA[Z]; --QA[Z]) (J = new P()).g = Z, J.value = UA[BA++], U(R, bA + ve, hA, fe, J), ve = q(ve, Z);
        }
        for (Z = j + 1, hA = 2; 15 >= Z; ++Z, hA <<= 1) {
          if (oe += Ve <<= 1, 0 > (Ve -= QA[Z])) return 0;
          for (; 0 < QA[Z]; --QA[Z]) {
            if (J = new P(), (ve & qA) != YA) {
              for (bA += fe, RA = 1 << (YA = Z) - j; 15 > YA && !(0 >= (RA -= QA[YA])); ) ++YA, RA <<= 1;
              NA += fe = 1 << (RA = YA - j), R[K + (YA = ve & qA)].g = RA + j, R[K + YA].value = bA - K - YA;
            }
            J.g = Z - j, J.value = UA[BA++], U(R, bA + (ve >> j), hA, fe, J), ve = q(ve, Z);
          }
        }
        return oe != 2 * DA[15] - 1 ? 0 : NA;
      })(f, g, v, b, H, _);
    }
    function P() {
      this.value = this.g = 0;
    }
    function N() {
      this.value = this.g = 0;
    }
    function iA() {
      this.G = s(5, P), this.H = i(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = s(cc, N);
    }
    function nA(f, g, v, b) {
      A(f != null), A(g != null), A(2147483648 > b), f.Ca = 254, f.I = 0, f.b = -8, f.Ka = 0, f.oa = g, f.pa = v, f.Jd = g, f.Yc = v + b, f.Zc = 4 <= b ? v + b - 4 + 1 : v, xA(f);
    }
    function sA(f, g) {
      for (var v = 0; 0 < g--; ) v |= pA(f, 128) << g;
      return v;
    }
    function tA(f, g) {
      var v = sA(f, g);
      return IA(f) ? -v : v;
    }
    function cA(f, g, v, b) {
      var H, _ = 0;
      for (A(f != null), A(g != null), A(4294967288 > b), f.Sb = b, f.Ra = 0, f.u = 0, f.h = 0, 4 < b && (b = 4), H = 0; H < b; ++H) _ += g[v + H] << 8 * H;
      f.Ra = _, f.bb = b, f.oa = g, f.pa = v;
    }
    function FA(f) {
      for (; 8 <= f.u && f.bb < f.Sb; ) f.Ra >>>= 8, f.Ra += f.oa[f.pa + f.bb] << Vn - 8 >>> 0, ++f.bb, f.u -= 8;
      AA(f) && (f.h = 1, f.u = 0);
    }
    function CA(f, g) {
      if (A(0 <= g), !f.h && g <= uu) {
        var v = Y(f) & tl[g];
        return f.u += g, FA(f), v;
      }
      return f.h = 1, f.u = 0;
    }
    function S() {
      this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
    }
    function W() {
      this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
    }
    function Y(f) {
      return f.Ra >>> (f.u & Vn - 1) >>> 0;
    }
    function AA(f) {
      return A(f.bb <= f.Sb), f.h || f.bb == f.Sb && f.u > Vn;
    }
    function oA(f, g) {
      f.u = g, f.h = AA(f);
    }
    function gA(f) {
      f.u >= ei && (A(f.u >= ei), FA(f));
    }
    function xA(f) {
      A(f != null && f.oa != null), f.pa < f.Zc ? (f.I = (f.oa[f.pa++] | f.I << 8) >>> 0, f.b += 8) : (A(f != null && f.oa != null), f.pa < f.Yc ? (f.b += 8, f.I = f.oa[f.pa++] | f.I << 8) : f.Ka ? f.b = 0 : (f.I <<= 8, f.b += 8, f.Ka = 1));
    }
    function IA(f) {
      return sA(f, 1);
    }
    function pA(f, g) {
      var v = f.Ca;
      0 > f.b && xA(f);
      var b = f.b, H = v * g >>> 8, _ = (f.I >>> b > H) + 0;
      for (_ ? (v -= H, f.I -= H + 1 << b >>> 0) : v = H + 1, b = v, H = 0; 256 <= b; ) H += 8, b >>= 8;
      return b = 7 ^ H + uc[b], f.b -= b, f.Ca = (v << b) - 1, _;
    }
    function WA(f, g, v) {
      f[g + 0] = v >> 24 & 255, f[g + 1] = v >> 16 & 255, f[g + 2] = v >> 8 & 255, f[g + 3] = 255 & v;
    }
    function k(f, g) {
      return f[g + 0] | f[g + 1] << 8;
    }
    function X(f, g) {
      return k(f, g) | f[g + 2] << 16;
    }
    function uA(f, g) {
      return k(f, g) | k(f, g + 2) << 16;
    }
    function E(f, g) {
      var v = 1 << g;
      return A(f != null), A(0 < g), f.X = i(v), f.X == null ? 0 : (f.Mb = 32 - g, f.Xa = g, 1);
    }
    function dA(f, g) {
      A(f != null), A(g != null), A(f.Xa == g.Xa), r(g.X, 0, f.X, 0, 1 << g.Xa);
    }
    function vA() {
      this.X = [], this.Xa = this.Mb = 0;
    }
    function rA(f, g, v, b) {
      A(v != null), A(b != null);
      var H = v[0], _ = b[0];
      return H == 0 && (H = (f * _ + g / 2) / g), _ == 0 && (_ = (g * H + f / 2) / f), 0 >= H || 0 >= _ ? 0 : (v[0] = H, b[0] = _, 1);
    }
    function fA(f, g) {
      return f + (1 << g) - 1 >>> g;
    }
    function EA(f, g) {
      return ((4278255360 & f) + (4278255360 & g) >>> 0 & 4278255360) + ((16711935 & f) + (16711935 & g) >>> 0 & 16711935) >>> 0;
    }
    function lA(f, g) {
      I[g] = function(v, b, H, _, R, K, j) {
        var J;
        for (J = 0; J < R; ++J) {
          var hA = I[f](K[j + J - 1], H, _ + J);
          K[j + J] = EA(v[b + J], hA);
        }
      };
    }
    function HA() {
      this.ud = this.hd = this.jd = 0;
    }
    function SA(f, g) {
      return ((4278124286 & (f ^ g)) >>> 1) + (f & g) >>> 0;
    }
    function yA(f) {
      return 0 <= f && 256 > f ? f : 0 > f ? 0 : 255 < f ? 255 : void 0;
    }
    function TA(f, g) {
      return yA(f + (f - g + 0.5 >> 1));
    }
    function _A(f, g, v) {
      return Math.abs(g - v) - Math.abs(f - v);
    }
    function MA(f, g, v, b, H, _, R) {
      for (b = _[R - 1], v = 0; v < H; ++v) _[R + v] = b = EA(f[g + v], b);
    }
    function VA(f, g, v, b, H) {
      var _;
      for (_ = 0; _ < v; ++_) {
        var R = f[g + _], K = R >> 8 & 255, j = 16711935 & (j = (j = 16711935 & R) + ((K << 16) + K));
        b[H + _] = (4278255360 & R) + j >>> 0;
      }
    }
    function $A(f, g) {
      g.jd = 255 & f, g.hd = f >> 8 & 255, g.ud = f >> 16 & 255;
    }
    function ee(f, g, v, b, H, _) {
      var R;
      for (R = 0; R < b; ++R) {
        var K = g[v + R], j = K >>> 8, J = K, hA = 255 & (hA = (hA = K >>> 16) + ((f.jd << 24 >> 24) * (j << 24 >> 24) >>> 5));
        J = 255 & (J = (J += (f.hd << 24 >> 24) * (j << 24 >> 24) >>> 5) + ((f.ud << 24 >> 24) * (hA << 24 >> 24) >>> 5)), H[_ + R] = (4278255360 & K) + (hA << 16) + J;
      }
    }
    function ZA(f, g, v, b, H) {
      I[g] = function(_, R, K, j, J, hA, UA, Z, BA) {
        for (j = UA; j < Z; ++j) for (UA = 0; UA < BA; ++UA) J[hA++] = H(K[b(_[R++])]);
      }, I[f] = function(_, R, K, j, J, hA, UA) {
        var Z = 8 >> _.b, BA = _.Ea, bA = _.K[0], NA = _.w;
        if (8 > Z) for (_ = (1 << _.b) - 1, NA = (1 << Z) - 1; R < K; ++R) {
          var QA, DA = 0;
          for (QA = 0; QA < BA; ++QA) QA & _ || (DA = b(j[J++])), hA[UA++] = H(bA[DA & NA]), DA >>= Z;
        }
        else I["VP8LMapColor" + v](j, J, bA, NA, hA, UA, R, K, BA);
      };
    }
    function Fe(f, g, v, b, H) {
      for (v = g + v; g < v; ) {
        var _ = f[g++];
        b[H++] = _ >> 16 & 255, b[H++] = _ >> 8 & 255, b[H++] = 255 & _;
      }
    }
    function me(f, g, v, b, H) {
      for (v = g + v; g < v; ) {
        var _ = f[g++];
        b[H++] = _ >> 16 & 255, b[H++] = _ >> 8 & 255, b[H++] = 255 & _, b[H++] = _ >> 24 & 255;
      }
    }
    function Ce(f, g, v, b, H) {
      for (v = g + v; g < v; ) {
        var _ = (R = f[g++]) >> 16 & 240 | R >> 12 & 15, R = 240 & R | R >> 28 & 15;
        b[H++] = _, b[H++] = R;
      }
    }
    function ae(f, g, v, b, H) {
      for (v = g + v; g < v; ) {
        var _ = (R = f[g++]) >> 16 & 248 | R >> 13 & 7, R = R >> 5 & 224 | R >> 3 & 31;
        b[H++] = _, b[H++] = R;
      }
    }
    function Te(f, g, v, b, H) {
      for (v = g + v; g < v; ) {
        var _ = f[g++];
        b[H++] = 255 & _, b[H++] = _ >> 8 & 255, b[H++] = _ >> 16 & 255;
      }
    }
    function ie(f, g, v, b, H, _) {
      if (_ == 0) for (v = g + v; g < v; ) WA(b, ((_ = f[g++])[0] >> 24 | _[1] >> 8 & 65280 | _[2] << 8 & 16711680 | _[3] << 24) >>> 0), H += 32;
      else r(b, H, f, g, v);
    }
    function Ke(f, g) {
      I[g][0] = I[f + "0"], I[g][1] = I[f + "1"], I[g][2] = I[f + "2"], I[g][3] = I[f + "3"], I[g][4] = I[f + "4"], I[g][5] = I[f + "5"], I[g][6] = I[f + "6"], I[g][7] = I[f + "7"], I[g][8] = I[f + "8"], I[g][9] = I[f + "9"], I[g][10] = I[f + "10"], I[g][11] = I[f + "11"], I[g][12] = I[f + "12"], I[g][13] = I[f + "13"], I[g][14] = I[f + "0"], I[g][15] = I[f + "0"];
    }
    function ge(f) {
      return f == jp || f == qp || f == Cf || f == $p;
    }
    function xe() {
      this.eb = [], this.size = this.A = this.fb = 0;
    }
    function Ye() {
      this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
    }
    function ue() {
      this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new xe(), this.f.kb = new Ye(), this.sd = null;
    }
    function pe() {
      this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
    }
    function ze() {
      this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
    }
    function Ii(f) {
      return alert("todo:WebPSamplerProcessPlane"), f.T;
    }
    function Jt(f, g) {
      var v = f.T, b = g.ba.f.RGBA, H = b.eb, _ = b.fb + f.ka * b.A, R = Ni[g.ba.S], K = f.y, j = f.O, J = f.f, hA = f.N, UA = f.ea, Z = f.W, BA = g.cc, bA = g.dc, NA = g.Mc, QA = g.Nc, DA = f.ka, RA = f.ka + f.T, YA = f.U, qA = YA + 1 >> 1;
      for (DA == 0 ? R(K, j, null, null, J, hA, UA, Z, J, hA, UA, Z, H, _, null, null, YA) : (R(g.ec, g.fc, K, j, BA, bA, NA, QA, J, hA, UA, Z, H, _ - b.A, H, _, YA), ++v); DA + 2 < RA; DA += 2) BA = J, bA = hA, NA = UA, QA = Z, hA += f.Rc, Z += f.Rc, _ += 2 * b.A, R(K, (j += 2 * f.fa) - f.fa, K, j, BA, bA, NA, QA, J, hA, UA, Z, H, _ - b.A, H, _, YA);
      return j += f.fa, f.j + RA < f.o ? (r(g.ec, g.fc, K, j, YA), r(g.cc, g.dc, J, hA, qA), r(g.Mc, g.Nc, UA, Z, qA), v--) : 1 & RA || R(K, j, null, null, J, hA, UA, Z, J, hA, UA, Z, H, _ + b.A, null, null, YA), v;
    }
    function Wr(f, g, v) {
      var b = f.F, H = [f.J];
      if (b != null) {
        var _ = f.U, R = g.ba.S, K = R == yf || R == Cf;
        g = g.ba.f.RGBA;
        var j = [0], J = f.ka;
        j[0] = f.T, f.Kb && (J == 0 ? --j[0] : (--J, H[0] -= f.width), f.j + f.ka + f.T == f.o && (j[0] = f.o - f.j - J));
        var hA = g.eb;
        J = g.fb + J * g.A, f = I2(b, H[0], f.width, _, j, hA, J + (K ? 0 : 3), g.A), A(v == j), f && ge(R) && gu(hA, J, K, _, j, g.A);
      }
      return 0;
    }
    function un(f) {
      var g = f.ma, v = g.ba.S, b = 11 > v, H = v == mf || v == vf || v == yf || v == Wp || v == 12 || ge(v);
      if (g.memory = null, g.Ib = null, g.Jb = null, g.Nd = null, !_i(g.Oa, f, H ? 11 : 12)) return 0;
      if (H && ge(v) && oa(), f.da) alert("todo:use_scaling");
      else {
        if (b) {
          if (g.Ib = Ii, f.Kb) {
            if (v = f.U + 1 >> 1, g.memory = i(f.U + 2 * v), g.memory == null) return 0;
            g.ec = g.memory, g.fc = 0, g.cc = g.ec, g.dc = g.fc + f.U, g.Mc = g.cc, g.Nc = g.dc + v, g.Ib = Jt, oa();
          }
        } else alert("todo:EmitYUV");
        H && (g.Jb = Wr, b && qt());
      }
      if (b && !W2) {
        for (f = 0; 256 > f; ++f) DT[f] = 89858 * (f - 128) + Ff >> bf, PT[f] = -22014 * (f - 128) + Ff, MT[f] = -45773 * (f - 128), RT[f] = 113618 * (f - 128) + Ff >> bf;
        for (f = Bu; f < Yp; ++f) g = 76283 * (f - 16) + Ff >> bf, kT[f - Bu] = Zr(g, 255), KT[f - Bu] = Zr(g + 8 >> 4, 15);
        W2 = 1;
      }
      return 1;
    }
    function Be(f) {
      var g = f.ma, v = f.U, b = f.T;
      return A(!(1 & f.ka)), 0 >= v || 0 >= b ? 0 : (v = g.Ib(f, g), g.Jb != null && g.Jb(f, g, v), g.Dc += v, 1);
    }
    function Jr(f) {
      f.ma.memory = null;
    }
    function Zt(f, g, v, b) {
      return CA(f, 8) != 47 ? 0 : (g[0] = CA(f, 14) + 1, v[0] = CA(f, 14) + 1, b[0] = CA(f, 1), CA(f, 3) != 0 ? 0 : !f.h);
    }
    function Vt(f, g) {
      if (4 > f) return f + 1;
      var v = f - 2 >> 1;
      return (2 + (1 & f) << v) + CA(g, v) + 1;
    }
    function Ar(f, g) {
      return 120 < g ? g - 120 : 1 <= (v = ((v = bT[g - 1]) >> 4) * f + (8 - (15 & v))) ? v : 1;
      var v;
    }
    function Bt(f, g, v) {
      var b = Y(v), H = f[g += 255 & b].g - 8;
      return 0 < H && (oA(v, v.u + 8), b = Y(v), g += f[g].value, g += b & (1 << H) - 1), oA(v, v.u + f[g].g), f[g].value;
    }
    function er(f, g, v) {
      return v.g += f.g, v.value += f.value << g >>> 0, A(8 >= v.g), f.g;
    }
    function Gt(f, g, v) {
      var b = f.xc;
      return A((g = b == 0 ? 0 : f.vc[f.md * (v >> b) + (g >> b)]) < f.Wb), f.Ya[g];
    }
    function ui(f, g, v, b) {
      var H = f.ab, _ = f.c * g, R = f.C;
      g = R + g;
      var K = v, j = b;
      for (b = f.Ta, v = f.Ua; 0 < H--; ) {
        var J = f.gc[H], hA = R, UA = g, Z = K, BA = j, bA = (j = b, K = v, J.Ea);
        switch (A(hA < UA), A(UA <= J.nc), J.hc) {
          case 2:
            hc(Z, BA, (UA - hA) * bA, j, K);
            break;
          case 0:
            var NA = hA, QA = UA, DA = j, RA = K, YA = (fe = J).Ea;
            NA == 0 && (Za(Z, BA, null, null, 1, DA, RA), MA(Z, BA + 1, 0, 0, YA - 1, DA, RA + 1), BA += YA, RA += YA, ++NA);
            for (var qA = 1 << fe.b, ve = qA - 1, oe = fA(YA, fe.b), Ve = fe.K, fe = fe.w + (NA >> fe.b) * oe; NA < QA; ) {
              var Xe = Ve, Nr = fe, Ge = 1;
              for (Ao(Z, BA, DA, RA - YA, 1, DA, RA); Ge < YA; ) {
                var de = (Ge & ~ve) + qA;
                de > YA && (de = YA), (0, as[Xe[Nr++] >> 8 & 15])(Z, BA + +Ge, DA, RA + Ge - YA, de - Ge, DA, RA + Ge), Ge = de;
              }
              BA += YA, RA += YA, ++NA & ve || (fe += oe);
            }
            UA != J.nc && r(j, K - bA, j, K + (UA - hA - 1) * bA, bA);
            break;
          case 1:
            for (bA = Z, QA = BA, YA = (Z = J.Ea) - (RA = Z & ~(DA = (BA = 1 << J.b) - 1)), NA = fA(Z, J.b), qA = J.K, J = J.w + (hA >> J.b) * NA; hA < UA; ) {
              for (ve = qA, oe = J, Ve = new HA(), fe = QA + RA, Xe = QA + Z; QA < fe; ) $A(ve[oe++], Ve), nl(Ve, bA, QA, BA, j, K), QA += BA, K += BA;
              QA < Xe && ($A(ve[oe++], Ve), nl(Ve, bA, QA, YA, j, K), QA += YA, K += YA), ++hA & DA || (J += NA);
            }
            break;
          case 3:
            if (Z == j && BA == K && 0 < J.b) {
              for (QA = j, Z = bA = K + (UA - hA) * bA - (RA = (UA - hA) * fA(J.Ea, J.b)), BA = j, DA = K, NA = [], RA = (YA = RA) - 1; 0 <= RA; --RA) NA[RA] = BA[DA + RA];
              for (RA = YA - 1; 0 <= RA; --RA) QA[Z + RA] = NA[RA];
              rl(J, hA, UA, j, bA, j, K);
            } else rl(J, hA, UA, Z, BA, j, K);
        }
        K = b, j = v;
      }
      j != v && r(b, v, K, j, _);
    }
    function hi(f, g) {
      var v = f.V, b = f.Ba + f.c * f.C, H = g - f.C;
      if (A(g <= f.l.o), A(16 >= H), 0 < H) {
        var _ = f.l, R = f.Ta, K = f.Ua, j = _.width;
        if (ui(f, H, v, b), H = K = [K], A((v = f.C) < (b = g)), A(_.v < _.va), b > _.o && (b = _.o), v < _.j) {
          var J = _.j - v;
          v = _.j, H[0] += J * j;
        }
        if (v >= b ? v = 0 : (H[0] += 4 * _.v, _.ka = v - _.j, _.U = _.va - _.v, _.T = b - v, v = 1), v) {
          if (K = K[0], 11 > (v = f.ca).S) {
            var hA = v.f.RGBA, UA = (b = v.S, H = _.U, _ = _.T, J = hA.eb, hA.A), Z = _;
            for (hA = hA.fb + f.Ma * hA.A; 0 < Z--; ) {
              var BA = R, bA = K, NA = H, QA = J, DA = hA;
              switch (b) {
                case wf:
                  hu(BA, bA, NA, QA, DA);
                  break;
                case mf:
                  fu(BA, bA, NA, QA, DA);
                  break;
                case jp:
                  fu(BA, bA, NA, QA, DA), gu(QA, DA, 0, NA, 1, 0);
                  break;
                case N2:
                  sl(BA, bA, NA, QA, DA);
                  break;
                case vf:
                  ie(BA, bA, NA, QA, DA, 1);
                  break;
                case qp:
                  ie(BA, bA, NA, QA, DA, 1), gu(QA, DA, 0, NA, 1, 0);
                  break;
                case yf:
                  ie(BA, bA, NA, QA, DA, 0);
                  break;
                case Cf:
                  ie(BA, bA, NA, QA, DA, 0), gu(QA, DA, 1, NA, 1, 0);
                  break;
                case Wp:
                  fc(BA, bA, NA, QA, DA);
                  break;
                case $p:
                  fc(BA, bA, NA, QA, DA), x2(QA, DA, NA, 1, 0);
                  break;
                case D2:
                  il(BA, bA, NA, QA, DA);
                  break;
                default:
                  A(0);
              }
              K += j, hA += UA;
            }
            f.Ma += _;
          } else alert("todo:EmitRescaledRowsYUVA");
          A(f.Ma <= v.height);
        }
      }
      f.C = g, A(f.C <= f.i);
    }
    function Hr(f) {
      var g;
      if (0 < f.ua) return 0;
      for (g = 0; g < f.Wb; ++g) {
        var v = f.Ya[g].G, b = f.Ya[g].H;
        if (0 < v[1][b[1] + 0].g || 0 < v[2][b[2] + 0].g || 0 < v[3][b[3] + 0].g) return 0;
      }
      return 1;
    }
    function jr(f, g, v, b, H, _) {
      if (f.Z != 0) {
        var R = f.qd, K = f.rd;
        for (A(no[f.Z] != null); g < v; ++g) no[f.Z](R, K, b, H, b, H, _), R = b, K = H, H += _;
        f.qd = R, f.rd = K;
      }
    }
    function tr(f, g) {
      var v = f.l.ma, b = v.Z == 0 || v.Z == 1 ? f.l.j : f.C;
      if (b = f.C < b ? b : f.C, A(g <= f.l.o), g > b) {
        var H = f.l.width, _ = v.ca, R = v.tb + H * b, K = f.V, j = f.Ba + f.c * b, J = f.gc;
        A(f.ab == 1), A(J[0].hc == 3), Vp(J[0], b, g, K, j, _, R), jr(v, b, g, _, R, H);
      }
      f.C = f.Ma = g;
    }
    function Tn(f, g, v, b, H, _, R) {
      var K = f.$ / b, j = f.$ % b, J = f.m, hA = f.s, UA = v + f.$, Z = UA;
      H = v + b * H;
      var BA = v + b * _, bA = 280 + hA.ua, NA = f.Pb ? K : 16777216, QA = 0 < hA.ua ? hA.Wa : null, DA = hA.wc, RA = UA < BA ? Gt(hA, j, K) : null;
      A(f.C < _), A(BA <= H);
      var YA = !1;
      A: for (; ; ) {
        for (; YA || UA < BA; ) {
          var qA = 0;
          if (K >= NA) {
            var ve = UA - v;
            A((NA = f).Pb), NA.wd = NA.m, NA.xd = ve, 0 < NA.s.ua && dA(NA.s.Wa, NA.s.vb), NA = K + QT;
          }
          if (j & DA || (RA = Gt(hA, j, K)), A(RA != null), RA.Qb && (g[UA] = RA.qb, YA = !0), !YA) if (gA(J), RA.jc) {
            qA = J, ve = g;
            var oe = UA, Ve = RA.pd[Y(qA) & cc - 1];
            A(RA.jc), 256 > Ve.g ? (oA(qA, qA.u + Ve.g), ve[oe] = Ve.value, qA = 0) : (oA(qA, qA.u + Ve.g - 256), A(256 <= Ve.value), qA = Ve.value), qA == 0 && (YA = !0);
          } else qA = Bt(RA.G[0], RA.H[0], J);
          if (J.h) break;
          if (YA || 256 > qA) {
            if (!YA) if (RA.nd) g[UA] = (RA.qb | qA << 8) >>> 0;
            else {
              if (gA(J), YA = Bt(RA.G[1], RA.H[1], J), gA(J), ve = Bt(RA.G[2], RA.H[2], J), oe = Bt(RA.G[3], RA.H[3], J), J.h) break;
              g[UA] = (oe << 24 | YA << 16 | qA << 8 | ve) >>> 0;
            }
            if (YA = !1, ++UA, ++j >= b && (j = 0, ++K, R != null && K <= _ && !(K % 16) && R(f, K), QA != null)) for (; Z < UA; ) qA = g[Z++], QA.X[(506832829 * qA & 4294967295) >>> QA.Mb] = qA;
          } else if (280 > qA) {
            if (qA = Vt(qA - 256, J), ve = Bt(RA.G[4], RA.H[4], J), gA(J), ve = Ar(b, ve = Vt(ve, J)), J.h) break;
            if (UA - v < ve || H - UA < qA) break A;
            for (oe = 0; oe < qA; ++oe) g[UA + oe] = g[UA + oe - ve];
            for (UA += qA, j += qA; j >= b; ) j -= b, ++K, R != null && K <= _ && !(K % 16) && R(f, K);
            if (A(UA <= H), j & DA && (RA = Gt(hA, j, K)), QA != null) for (; Z < UA; ) qA = g[Z++], QA.X[(506832829 * qA & 4294967295) >>> QA.Mb] = qA;
          } else {
            if (!(qA < bA)) break A;
            for (YA = qA - 280, A(QA != null); Z < UA; ) qA = g[Z++], QA.X[(506832829 * qA & 4294967295) >>> QA.Mb] = qA;
            qA = UA, A(!(YA >>> (ve = QA).Xa)), g[qA] = ve.X[YA], YA = !0;
          }
          YA || A(J.h == AA(J));
        }
        if (f.Pb && J.h && UA < H) A(f.m.h), f.a = 5, f.m = f.wd, f.$ = f.xd, 0 < f.s.ua && dA(f.s.vb, f.s.Wa);
        else {
          if (J.h) break A;
          R?.(f, K > _ ? _ : K), f.a = 0, f.$ = UA - v;
        }
        return 1;
      }
      return f.a = 3, 0;
    }
    function hn(f) {
      A(f != null), f.vc = null, f.yc = null, f.Ya = null;
      var g = f.Wa;
      g != null && (g.X = null), f.vb = null, A(f != null);
    }
    function je() {
      var f = new he();
      return f == null ? null : (f.a = 0, f.xb = P2, Ke("Predictor", "VP8LPredictors"), Ke("Predictor", "VP8LPredictors_C"), Ke("PredictorAdd", "VP8LPredictorsAdd"), Ke("PredictorAdd", "VP8LPredictorsAdd_C"), hc = VA, nl = ee, hu = Fe, fu = me, fc = Ce, il = ae, sl = Te, I.VP8LMapColor32b = Ur, I.VP8LMapColor8b = _s, f);
    }
    function Nt(f, g, v, b, H) {
      var _ = 1, R = [f], K = [g], j = b.m, J = b.s, hA = null, UA = 0;
      A: for (; ; ) {
        if (v) for (; _ && CA(j, 1); ) {
          var Z = R, BA = K, bA = b, NA = 1, QA = bA.m, DA = bA.gc[bA.ab], RA = CA(QA, 2);
          if (bA.Oc & 1 << RA) _ = 0;
          else {
            switch (bA.Oc |= 1 << RA, DA.hc = RA, DA.Ea = Z[0], DA.nc = BA[0], DA.K = [null], ++bA.ab, A(4 >= bA.ab), RA) {
              case 0:
              case 1:
                DA.b = CA(QA, 3) + 2, NA = Nt(fA(DA.Ea, DA.b), fA(DA.nc, DA.b), 0, bA, DA.K), DA.K = DA.K[0];
                break;
              case 3:
                var YA, qA = CA(QA, 8) + 1, ve = 16 < qA ? 0 : 4 < qA ? 1 : 2 < qA ? 2 : 3;
                if (Z[0] = fA(DA.Ea, ve), DA.b = ve, YA = NA = Nt(qA, 1, 0, bA, DA.K)) {
                  var oe, Ve = qA, fe = DA, Xe = 1 << (8 >> fe.b), Nr = i(Xe);
                  if (Nr == null) YA = 0;
                  else {
                    var Ge = fe.K[0], de = fe.w;
                    for (Nr[0] = fe.K[0][0], oe = 1; oe < 1 * Ve; ++oe) Nr[oe] = EA(Ge[de + oe], Nr[oe - 1]);
                    for (; oe < 4 * Xe; ++oe) Nr[oe] = 0;
                    fe.K[0] = null, fe.K[0] = Nr, YA = 1;
                  }
                }
                NA = YA;
                break;
              case 2:
                break;
              default:
                A(0);
            }
            _ = NA;
          }
        }
        if (R = R[0], K = K[0], _ && CA(j, 1) && !(_ = 1 <= (UA = CA(j, 4)) && 11 >= UA)) {
          b.a = 3;
          break A;
        }
        var te;
        if (te = _) e: {
          var dr, Pe, At, Tt = b, en = R, Gn = K, nr = UA, wn = v, Wn = Tt.m, Dr = Tt.s, tt = [null], gt = 1, ir = 0, pt = FT[nr];
          t: for (; ; ) {
            if (wn && CA(Wn, 1)) {
              var tn = CA(Wn, 3) + 2, ls = fA(en, tn), gr = fA(Gn, tn), ti = ls * gr;
              if (!Nt(ls, gr, 0, Tt, tt)) break t;
              for (tt = tt[0], Dr.xc = tn, dr = 0; dr < ti; ++dr) {
                var yt = tt[dr] >> 8 & 65535;
                tt[dr] = yt, yt >= gt && (gt = yt + 1);
              }
            }
            if (Wn.h) break t;
            for (Pe = 0; 5 > Pe; ++Pe) {
              var Rr = R2[Pe];
              !Pe && 0 < nr && (Rr += 1 << nr), ir < Rr && (ir = Rr);
            }
            var gi = s(gt * pt, P), jn = gt, pi = s(jn, iA);
            if (pi == null) var Bi = null;
            else A(65536 >= jn), Bi = pi;
            var ri = i(ir);
            if (Bi == null || ri == null || gi == null) {
              Tt.a = 1;
              break t;
            }
            var wi = gi;
            for (dr = At = 0; dr < gt; ++dr) {
              var Et = Bi[dr], mi = Et.G, cs = Et.H, al = 0, ha = 1, rn = 0;
              for (Pe = 0; 5 > Pe; ++Pe) {
                Rr = R2[Pe], mi[Pe] = wi, cs[Pe] = At, !Pe && 0 < nr && (Rr += 1 << nr);
                n: {
                  var Uf, Jp = Rr, Ef = Tt, wu = ri, WT = wi, jT = At, Zp = 0, io = Ef.m, qT = CA(io, 1);
                  if (n(wu, 0, 0, Jp), qT) {
                    var $T = CA(io, 1) + 1, zT = CA(io, 1), $2 = CA(io, zT == 0 ? 1 : 8);
                    wu[$2] = 1, $T == 2 && (wu[$2 = CA(io, 8)] = 1);
                    var xf = 1;
                  } else {
                    var z2 = i(19), X2 = CA(io, 4) + 4;
                    if (19 < X2) {
                      Ef.a = 3;
                      var If = 0;
                      break n;
                    }
                    for (Uf = 0; Uf < X2; ++Uf) z2[CT[Uf]] = CA(io, 3);
                    var AB = void 0, mu = void 0, Y2 = Ef, XT = z2, Sf = Jp, J2 = wu, eB = 0, so = Y2.m, Z2 = 8, AC = s(128, P);
                    r: for (; x(AC, 0, 7, XT, 19); ) {
                      if (CA(so, 1)) {
                        var YT = 2 + 2 * CA(so, 3);
                        if ((AB = 2 + CA(so, YT)) > Sf) break r;
                      } else AB = Sf;
                      for (mu = 0; mu < Sf && AB--; ) {
                        gA(so);
                        var eC = AC[0 + (127 & Y(so))];
                        oA(so, so.u + eC.g);
                        var pc = eC.value;
                        if (16 > pc) J2[mu++] = pc, pc != 0 && (Z2 = pc);
                        else {
                          var JT = pc == 16, tC = pc - 16, ZT = vT[tC], rC = CA(so, mT[tC]) + ZT;
                          if (mu + rC > Sf) break r;
                          for (var A_ = JT ? Z2 : 0; 0 < rC--; ) J2[mu++] = A_;
                        }
                      }
                      eB = 1;
                      break r;
                    }
                    eB || (Y2.a = 3), xf = eB;
                  }
                  (xf = xf && !io.h) && (Zp = x(WT, jT, 8, wu, Jp)), xf && Zp != 0 ? If = Zp : (Ef.a = 3, If = 0);
                }
                if (If == 0) break t;
                if (ha && yT[Pe] == 1 && (ha = wi[At].g == 0), al += wi[At].g, At += If, 3 >= Pe) {
                  var vu, tB = ri[0];
                  for (vu = 1; vu < Rr; ++vu) ri[vu] > tB && (tB = ri[vu]);
                  rn += tB;
                }
              }
              if (Et.nd = ha, Et.Qb = 0, ha && (Et.qb = (mi[3][cs[3] + 0].value << 24 | mi[1][cs[1] + 0].value << 16 | mi[2][cs[2] + 0].value) >>> 0, al == 0 && 256 > mi[0][cs[0] + 0].value && (Et.Qb = 1, Et.qb += mi[0][cs[0] + 0].value << 8)), Et.jc = !Et.Qb && 6 > rn, Et.jc) {
                var Lf, fa = Et;
                for (Lf = 0; Lf < cc; ++Lf) {
                  var ao = Lf, oo = fa.pd[ao], Hf = fa.G[0][fa.H[0] + ao];
                  256 <= Hf.value ? (oo.g = Hf.g + 256, oo.value = Hf.value) : (oo.g = 0, oo.value = 0, ao >>= er(Hf, 8, oo), ao >>= er(fa.G[1][fa.H[1] + ao], 16, oo), ao >>= er(fa.G[2][fa.H[2] + ao], 0, oo), er(fa.G[3][fa.H[3] + ao], 24, oo));
                }
              }
            }
            Dr.vc = tt, Dr.Wb = gt, Dr.Ya = Bi, Dr.yc = gi, te = 1;
            break e;
          }
          te = 0;
        }
        if (!(_ = te)) {
          b.a = 3;
          break A;
        }
        if (0 < UA) {
          if (J.ua = 1 << UA, !E(J.Wa, UA)) {
            b.a = 1, _ = 0;
            break A;
          }
        } else J.ua = 0;
        var rB = b, nC = R, e_ = K, nB = rB.s, iB = nB.xc;
        if (rB.c = nC, rB.i = e_, nB.md = fA(nC, iB), nB.wc = iB == 0 ? -1 : (1 << iB) - 1, v) {
          b.xb = HT;
          break A;
        }
        if ((hA = i(R * K)) == null) {
          b.a = 1, _ = 0;
          break A;
        }
        _ = (_ = Tn(b, hA, 0, R, K, K, null)) && !j.h;
        break A;
      }
      return _ ? (H != null ? H[0] = hA : (A(hA == null), A(v)), b.$ = 0, v || hn(J)) : hn(J), _;
    }
    function Si(f, g) {
      var v = f.c * f.i, b = v + g + 16 * g;
      return A(f.c <= g), f.V = i(b), f.V == null ? (f.Ta = null, f.Ua = 0, f.a = 1, 0) : (f.Ta = f.V, f.Ua = f.Ba + v + g, 1);
    }
    function ts(f, g) {
      var v = f.C, b = g - v, H = f.V, _ = f.Ba + f.c * v;
      for (A(g <= f.l.o); 0 < b; ) {
        var R = 16 < b ? 16 : b, K = f.l.ma, j = f.l.width, J = j * R, hA = K.ca, UA = K.tb + j * v, Z = f.Ta, BA = f.Ua;
        ui(f, R, H, _), S2(Z, BA, hA, UA, J), jr(K, v, v + R, hA, UA, j), b -= R, H += R * f.c, v += R;
      }
      A(v == g), f.C = f.Ma = g;
    }
    function Li() {
      this.ub = this.yd = this.td = this.Rb = 0;
    }
    function rs() {
      this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
    }
    function Ma() {
      this.Fb = this.Bb = this.Cb = 0, this.Zb = i(4), this.Lb = i(4);
    }
    function ra() {
      this.Yb = (function() {
        var f = [];
        return (function g(v, b, H) {
          for (var _ = H[b], R = 0; R < _ && (v.push(H.length > b + 1 ? [] : 0), !(H.length < b + 1)); R++) g(v[R], b + 1, H);
        })(f, 0, [3, 11]), f;
      })();
    }
    function Pa() {
      this.jb = i(3), this.Wc = a([4, 8], ra), this.Xc = a([4, 17], ra);
    }
    function ka() {
      this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new i(4), this.od = new i(4);
    }
    function _n() {
      this.ld = this.La = this.dd = this.tc = 0;
    }
    function st() {
      this.Na = this.la = 0;
    }
    function ns() {
      this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
    }
    function On() {
      this.ad = i(384), this.Za = 0, this.Ob = i(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
    }
    function Ai() {
      this.uc = this.M = this.Nb = 0, this.wa = Array(new _n()), this.Y = 0, this.ya = Array(new On()), this.aa = 0, this.l = new Ss();
    }
    function Ka() {
      this.y = i(16), this.f = i(8), this.ea = i(8);
    }
    function is() {
      this.cb = this.a = 0, this.sc = "", this.m = new S(), this.Od = new Li(), this.Kc = new rs(), this.ed = new ka(), this.Qa = new Ma(), this.Ic = this.$c = this.Aa = 0, this.D = new Ai(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = s(8, S), this.ia = 0, this.pb = s(4, ns), this.Pa = new Pa(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [0, 0, 0, 0], this.Gd = Array(new Ka()), this.Hd = 0, this.rb = Array(new st()), this.sb = 0, this.wa = Array(new _n()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new On()), this.L = this.aa = 0, this.gd = a([4, 2], _n), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
    }
    function Zr(f, g) {
      return 0 > f ? 0 : f > g ? g : f;
    }
    function Ss() {
      this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
    }
    function Va() {
      var f = new is();
      return f != null && (f.a = 0, f.sc = "OK", f.cb = 0, f.Xb = 0, pu || (pu = Nn)), f;
    }
    function St(f, g, v) {
      return f.a == 0 && (f.a = g, f.sc = v, f.cb = 0), 0;
    }
    function ss(f, g, v) {
      return 3 <= v && f[g + 0] == 157 && f[g + 1] == 1 && f[g + 2] == 42;
    }
    function qr(f, g) {
      if (f == null) return 0;
      if (f.a = 0, f.sc = "OK", g == null) return St(f, 2, "null VP8Io passed to VP8GetHeaders()");
      var v = g.data, b = g.w, H = g.ha;
      if (4 > H) return St(f, 7, "Truncated header.");
      var _ = v[b + 0] | v[b + 1] << 8 | v[b + 2] << 16, R = f.Od;
      if (R.Rb = !(1 & _), R.td = _ >> 1 & 7, R.yd = _ >> 4 & 1, R.ub = _ >> 5, 3 < R.td) return St(f, 3, "Incorrect keyframe parameters.");
      if (!R.yd) return St(f, 4, "Frame not displayable.");
      b += 3, H -= 3;
      var K = f.Kc;
      if (R.Rb) {
        if (7 > H) return St(f, 7, "cannot parse picture header");
        if (!ss(v, b, H)) return St(f, 3, "Bad code word");
        K.c = 16383 & (v[b + 4] << 8 | v[b + 3]), K.Td = v[b + 4] >> 6, K.i = 16383 & (v[b + 6] << 8 | v[b + 5]), K.Ud = v[b + 6] >> 6, b += 7, H -= 7, f.za = K.c + 15 >> 4, f.Ub = K.i + 15 >> 4, g.width = K.c, g.height = K.i, g.Da = 0, g.j = 0, g.v = 0, g.va = g.width, g.o = g.height, g.da = 0, g.ib = g.width, g.hb = g.height, g.U = g.width, g.T = g.height, n((_ = f.Pa).jb, 0, 255, _.jb.length), A((_ = f.Qa) != null), _.Cb = 0, _.Bb = 0, _.Fb = 1, n(_.Zb, 0, 0, _.Zb.length), n(_.Lb, 0, 0, _.Lb);
      }
      if (R.ub > H) return St(f, 7, "bad partition length");
      nA(_ = f.m, v, b, R.ub), b += R.ub, H -= R.ub, R.Rb && (K.Ld = IA(_), K.Kd = IA(_)), K = f.Qa;
      var j, J = f.Pa;
      if (A(_ != null), A(K != null), K.Cb = IA(_), K.Cb) {
        if (K.Bb = IA(_), IA(_)) {
          for (K.Fb = IA(_), j = 0; 4 > j; ++j) K.Zb[j] = IA(_) ? tA(_, 7) : 0;
          for (j = 0; 4 > j; ++j) K.Lb[j] = IA(_) ? tA(_, 6) : 0;
        }
        if (K.Bb) for (j = 0; 3 > j; ++j) J.jb[j] = IA(_) ? sA(_, 8) : 255;
      } else K.Bb = 0;
      if (_.Ka) return St(f, 3, "cannot parse segment header");
      if ((K = f.ed).zd = IA(_), K.Tb = sA(_, 6), K.wb = sA(_, 3), K.Pc = IA(_), K.Pc && IA(_)) {
        for (J = 0; 4 > J; ++J) IA(_) && (K.vd[J] = tA(_, 6));
        for (J = 0; 4 > J; ++J) IA(_) && (K.od[J] = tA(_, 6));
      }
      if (f.L = K.Tb == 0 ? 0 : K.zd ? 1 : 2, _.Ka) return St(f, 3, "cannot parse filter header");
      var hA = H;
      if (H = j = b, b = j + hA, K = hA, f.Xb = (1 << sA(f.m, 2)) - 1, hA < 3 * (J = f.Xb)) v = 7;
      else {
        for (j += 3 * J, K -= 3 * J, hA = 0; hA < J; ++hA) {
          var UA = v[H + 0] | v[H + 1] << 8 | v[H + 2] << 16;
          UA > K && (UA = K), nA(f.Jc[+hA], v, j, UA), j += UA, K -= UA, H += 3;
        }
        nA(f.Jc[+J], v, j, K), v = j < b ? 0 : 5;
      }
      if (v != 0) return St(f, v, "cannot parse partitions");
      for (v = sA(j = f.m, 7), H = IA(j) ? tA(j, 4) : 0, b = IA(j) ? tA(j, 4) : 0, K = IA(j) ? tA(j, 4) : 0, J = IA(j) ? tA(j, 4) : 0, j = IA(j) ? tA(j, 4) : 0, hA = f.Qa, UA = 0; 4 > UA; ++UA) {
        if (hA.Cb) {
          var Z = hA.Zb[UA];
          hA.Fb || (Z += v);
        } else {
          if (0 < UA) {
            f.pb[UA] = f.pb[0];
            continue;
          }
          Z = v;
        }
        var BA = f.pb[UA];
        BA.Sc[0] = zp[Zr(Z + H, 127)], BA.Sc[1] = Xp[Zr(Z + 0, 127)], BA.Eb[0] = 2 * zp[Zr(Z + b, 127)], BA.Eb[1] = 101581 * Xp[Zr(Z + K, 127)] >> 16, 8 > BA.Eb[1] && (BA.Eb[1] = 8), BA.Qc[0] = zp[Zr(Z + J, 117)], BA.Qc[1] = Xp[Zr(Z + j, 127)], BA.lc = Z + j;
      }
      if (!R.Rb) return St(f, 4, "Not a key frame.");
      for (IA(_), R = f.Pa, v = 0; 4 > v; ++v) {
        for (H = 0; 8 > H; ++H) for (b = 0; 3 > b; ++b) for (K = 0; 11 > K; ++K) J = pA(_, ST[v][H][b][K]) ? sA(_, 8) : xT[v][H][b][K], R.Wc[v][H].Yb[b][K] = J;
        for (H = 0; 17 > H; ++H) R.Xc[v][H] = R.Wc[v][LT[H]];
      }
      return f.kc = IA(_), f.kc && (f.Bd = sA(_, 8)), f.cb = 1;
    }
    function Nn(f, g, v, b, H, _, R) {
      var K = g[H].Yb[v];
      for (v = 0; 16 > H; ++H) {
        if (!pA(f, K[v + 0])) return H;
        for (; !pA(f, K[v + 1]); ) if (K = g[++H].Yb[0], v = 0, H == 16) return 16;
        var j = g[H + 1].Yb;
        if (pA(f, K[v + 2])) {
          var J = f, hA = 0;
          if (pA(J, (Z = K)[(UA = v) + 3])) if (pA(J, Z[UA + 6])) {
            for (K = 0, UA = 2 * (hA = pA(J, Z[UA + 8])) + (Z = pA(J, Z[UA + 9 + hA])), hA = 0, Z = UT[UA]; Z[K]; ++K) hA += hA + pA(J, Z[K]);
            hA += 3 + (8 << UA);
          } else pA(J, Z[UA + 7]) ? (hA = 7 + 2 * pA(J, 165), hA += pA(J, 145)) : hA = 5 + pA(J, 159);
          else hA = pA(J, Z[UA + 4]) ? 3 + pA(J, Z[UA + 5]) : 2;
          K = j[2];
        } else hA = 1, K = j[1];
        j = R + ET[H], 0 > (J = f).b && xA(J);
        var UA, Z = J.b, BA = (UA = J.Ca >> 1) - (J.I >> Z) >> 31;
        --J.b, J.Ca += BA, J.Ca |= 1, J.I -= (UA + 1 & BA) << Z, _[j] = ((hA ^ BA) - BA) * b[(0 < H) + 0];
      }
      return 16;
    }
    function Dn(f) {
      var g = f.rb[f.sb - 1];
      g.la = 0, g.Na = 0, n(f.zc, 0, 0, f.zc.length), f.ja = 0;
    }
    function hr(f, g, v, b, H) {
      H = f[g + v + 32 * b] + (H >> 3), f[g + v + 32 * b] = -256 & H ? 0 > H ? 0 : 255 : H;
    }
    function Tr(f, g, v, b, H, _) {
      hr(f, g, 0, v, b + H), hr(f, g, 1, v, b + _), hr(f, g, 2, v, b - _), hr(f, g, 3, v, b - H);
    }
    function Rn(f) {
      return (20091 * f >> 16) + f;
    }
    function Lt(f, g, v, b) {
      var H, _ = 0, R = i(16);
      for (H = 0; 4 > H; ++H) {
        var K = f[g + 0] + f[g + 8], j = f[g + 0] - f[g + 8], J = (35468 * f[g + 4] >> 16) - Rn(f[g + 12]), hA = Rn(f[g + 4]) + (35468 * f[g + 12] >> 16);
        R[_ + 0] = K + hA, R[_ + 1] = j + J, R[_ + 2] = j - J, R[_ + 3] = K - hA, _ += 4, g++;
      }
      for (H = _ = 0; 4 > H; ++H) K = (f = R[_ + 0] + 4) + R[_ + 8], j = f - R[_ + 8], J = (35468 * R[_ + 4] >> 16) - Rn(R[_ + 12]), hr(v, b, 0, 0, K + (hA = Rn(R[_ + 4]) + (35468 * R[_ + 12] >> 16))), hr(v, b, 1, 0, j + J), hr(v, b, 2, 0, j - J), hr(v, b, 3, 0, K - hA), _++, b += 32;
    }
    function Ga(f, g, v, b) {
      var H = f[g + 0] + 4, _ = 35468 * f[g + 4] >> 16, R = Rn(f[g + 4]), K = 35468 * f[g + 1] >> 16;
      Tr(v, b, 0, H + R, f = Rn(f[g + 1]), K), Tr(v, b, 1, H + _, f, K), Tr(v, b, 2, H - _, f, K), Tr(v, b, 3, H - R, f, K);
    }
    function Wa(f, g, v, b, H) {
      Lt(f, g, v, b), H && Lt(f, g + 16, v, b + 4);
    }
    function ja(f, g, v, b) {
      la(f, g + 0, v, b, 1), la(f, g + 32, v, b + 128, 1);
    }
    function qa(f, g, v, b) {
      var H;
      for (f = f[g + 0] + 4, H = 0; 4 > H; ++H) for (g = 0; 4 > g; ++g) hr(v, b, g, H, f);
    }
    function Mn(f, g, v, b) {
      f[g + 0] && Bn(f, g + 0, v, b), f[g + 16] && Bn(f, g + 16, v, b + 4), f[g + 32] && Bn(f, g + 32, v, b + 128), f[g + 48] && Bn(f, g + 48, v, b + 128 + 4);
    }
    function Hi(f, g, v, b) {
      var H, _ = i(16);
      for (H = 0; 4 > H; ++H) {
        var R = f[g + 0 + H] + f[g + 12 + H], K = f[g + 4 + H] + f[g + 8 + H], j = f[g + 4 + H] - f[g + 8 + H], J = f[g + 0 + H] - f[g + 12 + H];
        _[0 + H] = R + K, _[8 + H] = R - K, _[4 + H] = J + j, _[12 + H] = J - j;
      }
      for (H = 0; 4 > H; ++H) R = (f = _[0 + 4 * H] + 3) + _[3 + 4 * H], K = _[1 + 4 * H] + _[2 + 4 * H], j = _[1 + 4 * H] - _[2 + 4 * H], J = f - _[3 + 4 * H], v[b + 0] = R + K >> 3, v[b + 16] = J + j >> 3, v[b + 32] = R - K >> 3, v[b + 48] = J - j >> 3, b += 64;
    }
    function fi(f, g, v) {
      var b, H = g - 32, _ = di, R = 255 - f[H - 1];
      for (b = 0; b < v; ++b) {
        var K, j = _, J = R + f[g - 1];
        for (K = 0; K < v; ++K) f[g + K] = j[J + f[H + K]];
        g += 32;
      }
    }
    function An(f, g) {
      fi(f, g, 4);
    }
    function fn(f, g) {
      fi(f, g, 8);
    }
    function _r(f, g) {
      fi(f, g, 16);
    }
    function dn(f, g) {
      var v;
      for (v = 0; 16 > v; ++v) r(f, g + 32 * v, f, g - 32, 16);
    }
    function Pn(f, g) {
      var v;
      for (v = 16; 0 < v; --v) n(f, g, f[g - 1], 16), g += 32;
    }
    function zA(f, g, v) {
      var b;
      for (b = 0; 16 > b; ++b) n(g, v + 32 * b, f, 16);
    }
    function $(f, g) {
      var v, b = 16;
      for (v = 0; 16 > v; ++v) b += f[g - 1 + 32 * v] + f[g + v - 32];
      zA(b >> 5, f, g);
    }
    function wA(f, g) {
      var v, b = 8;
      for (v = 0; 16 > v; ++v) b += f[g - 1 + 32 * v];
      zA(b >> 4, f, g);
    }
    function PA(f, g) {
      var v, b = 8;
      for (v = 0; 16 > v; ++v) b += f[g + v - 32];
      zA(b >> 4, f, g);
    }
    function Ae(f, g) {
      zA(128, f, g);
    }
    function GA(f, g, v) {
      return f + 2 * g + v + 2 >> 2;
    }
    function Qe(f, g) {
      var v, b = g - 32;
      for (b = new Uint8Array([GA(f[b - 1], f[b + 0], f[b + 1]), GA(f[b + 0], f[b + 1], f[b + 2]), GA(f[b + 1], f[b + 2], f[b + 3]), GA(f[b + 2], f[b + 3], f[b + 4])]), v = 0; 4 > v; ++v) r(f, g + 32 * v, b, 0, b.length);
    }
    function Je(f, g) {
      var v = f[g - 1], b = f[g - 1 + 32], H = f[g - 1 + 64], _ = f[g - 1 + 96];
      WA(f, g + 0, 16843009 * GA(f[g - 1 - 32], v, b)), WA(f, g + 32, 16843009 * GA(v, b, H)), WA(f, g + 64, 16843009 * GA(b, H, _)), WA(f, g + 96, 16843009 * GA(H, _, _));
    }
    function ot(f, g) {
      var v, b = 4;
      for (v = 0; 4 > v; ++v) b += f[g + v - 32] + f[g - 1 + 32 * v];
      for (b >>= 3, v = 0; 4 > v; ++v) n(f, g + 32 * v, b, 4);
    }
    function rr(f, g) {
      var v = f[g - 1 + 0], b = f[g - 1 + 32], H = f[g - 1 + 64], _ = f[g - 1 - 32], R = f[g + 0 - 32], K = f[g + 1 - 32], j = f[g + 2 - 32], J = f[g + 3 - 32];
      f[g + 0 + 96] = GA(b, H, f[g - 1 + 96]), f[g + 1 + 96] = f[g + 0 + 64] = GA(v, b, H), f[g + 2 + 96] = f[g + 1 + 64] = f[g + 0 + 32] = GA(_, v, b), f[g + 3 + 96] = f[g + 2 + 64] = f[g + 1 + 32] = f[g + 0 + 0] = GA(R, _, v), f[g + 3 + 64] = f[g + 2 + 32] = f[g + 1 + 0] = GA(K, R, _), f[g + 3 + 32] = f[g + 2 + 0] = GA(j, K, R), f[g + 3 + 0] = GA(J, j, K);
    }
    function Fr(f, g) {
      var v = f[g + 1 - 32], b = f[g + 2 - 32], H = f[g + 3 - 32], _ = f[g + 4 - 32], R = f[g + 5 - 32], K = f[g + 6 - 32], j = f[g + 7 - 32];
      f[g + 0 + 0] = GA(f[g + 0 - 32], v, b), f[g + 1 + 0] = f[g + 0 + 32] = GA(v, b, H), f[g + 2 + 0] = f[g + 1 + 32] = f[g + 0 + 64] = GA(b, H, _), f[g + 3 + 0] = f[g + 2 + 32] = f[g + 1 + 64] = f[g + 0 + 96] = GA(H, _, R), f[g + 3 + 32] = f[g + 2 + 64] = f[g + 1 + 96] = GA(_, R, K), f[g + 3 + 64] = f[g + 2 + 96] = GA(R, K, j), f[g + 3 + 96] = GA(K, j, j);
    }
    function kn(f, g) {
      var v = f[g - 1 + 0], b = f[g - 1 + 32], H = f[g - 1 + 64], _ = f[g - 1 - 32], R = f[g + 0 - 32], K = f[g + 1 - 32], j = f[g + 2 - 32], J = f[g + 3 - 32];
      f[g + 0 + 0] = f[g + 1 + 64] = _ + R + 1 >> 1, f[g + 1 + 0] = f[g + 2 + 64] = R + K + 1 >> 1, f[g + 2 + 0] = f[g + 3 + 64] = K + j + 1 >> 1, f[g + 3 + 0] = j + J + 1 >> 1, f[g + 0 + 96] = GA(H, b, v), f[g + 0 + 64] = GA(b, v, _), f[g + 0 + 32] = f[g + 1 + 96] = GA(v, _, R), f[g + 1 + 32] = f[g + 2 + 96] = GA(_, R, K), f[g + 2 + 32] = f[g + 3 + 96] = GA(R, K, j), f[g + 3 + 32] = GA(K, j, J);
    }
    function et(f, g) {
      var v = f[g + 0 - 32], b = f[g + 1 - 32], H = f[g + 2 - 32], _ = f[g + 3 - 32], R = f[g + 4 - 32], K = f[g + 5 - 32], j = f[g + 6 - 32], J = f[g + 7 - 32];
      f[g + 0 + 0] = v + b + 1 >> 1, f[g + 1 + 0] = f[g + 0 + 64] = b + H + 1 >> 1, f[g + 2 + 0] = f[g + 1 + 64] = H + _ + 1 >> 1, f[g + 3 + 0] = f[g + 2 + 64] = _ + R + 1 >> 1, f[g + 0 + 32] = GA(v, b, H), f[g + 1 + 32] = f[g + 0 + 96] = GA(b, H, _), f[g + 2 + 32] = f[g + 1 + 96] = GA(H, _, R), f[g + 3 + 32] = f[g + 2 + 96] = GA(_, R, K), f[g + 3 + 64] = GA(R, K, j), f[g + 3 + 96] = GA(K, j, J);
    }
    function Ls(f, g) {
      var v = f[g - 1 + 0], b = f[g - 1 + 32], H = f[g - 1 + 64], _ = f[g - 1 + 96];
      f[g + 0 + 0] = v + b + 1 >> 1, f[g + 2 + 0] = f[g + 0 + 32] = b + H + 1 >> 1, f[g + 2 + 32] = f[g + 0 + 64] = H + _ + 1 >> 1, f[g + 1 + 0] = GA(v, b, H), f[g + 3 + 0] = f[g + 1 + 32] = GA(b, H, _), f[g + 3 + 32] = f[g + 1 + 64] = GA(H, _, _), f[g + 3 + 64] = f[g + 2 + 64] = f[g + 0 + 96] = f[g + 1 + 96] = f[g + 2 + 96] = f[g + 3 + 96] = _;
    }
    function $a(f, g) {
      var v = f[g - 1 + 0], b = f[g - 1 + 32], H = f[g - 1 + 64], _ = f[g - 1 + 96], R = f[g - 1 - 32], K = f[g + 0 - 32], j = f[g + 1 - 32], J = f[g + 2 - 32];
      f[g + 0 + 0] = f[g + 2 + 32] = v + R + 1 >> 1, f[g + 0 + 32] = f[g + 2 + 64] = b + v + 1 >> 1, f[g + 0 + 64] = f[g + 2 + 96] = H + b + 1 >> 1, f[g + 0 + 96] = _ + H + 1 >> 1, f[g + 3 + 0] = GA(K, j, J), f[g + 2 + 0] = GA(R, K, j), f[g + 1 + 0] = f[g + 3 + 32] = GA(v, R, K), f[g + 1 + 32] = f[g + 3 + 64] = GA(b, v, R), f[g + 1 + 64] = f[g + 3 + 96] = GA(H, b, v), f[g + 1 + 96] = GA(_, H, b);
    }
    function na(f, g) {
      var v;
      for (v = 0; 8 > v; ++v) r(f, g + 32 * v, f, g - 32, 8);
    }
    function za(f, g) {
      var v;
      for (v = 0; 8 > v; ++v) n(f, g, f[g - 1], 8), g += 32;
    }
    function Ti(f, g, v) {
      var b;
      for (b = 0; 8 > b; ++b) n(g, v + 32 * b, f, 8);
    }
    function ff(f, g) {
      var v, b = 8;
      for (v = 0; 8 > v; ++v) b += f[g + v - 32] + f[g - 1 + 32 * v];
      Ti(b >> 4, f, g);
    }
    function ia(f, g) {
      var v, b = 4;
      for (v = 0; 8 > v; ++v) b += f[g + v - 32];
      Ti(b >> 3, f, g);
    }
    function Xa(f, g) {
      var v, b = 4;
      for (v = 0; 8 > v; ++v) b += f[g - 1 + 32 * v];
      Ti(b >> 3, f, g);
    }
    function $o(f, g) {
      Ti(128, f, g);
    }
    function Hs(f, g, v) {
      var b = f[g - v], H = f[g + 0], _ = 3 * (H - b) + Gp[1020 + f[g - 2 * v] - f[g + v]], R = Bf[112 + (_ + 4 >> 3)];
      f[g - v] = di[255 + b + Bf[112 + (_ + 3 >> 3)]], f[g + 0] = di[255 + H - R];
    }
    function Ya(f, g, v, b) {
      var H = f[g + 0], _ = f[g + v];
      return Oi[255 + f[g - 2 * v] - f[g - v]] > b || Oi[255 + _ - H] > b;
    }
    function sa(f, g, v, b) {
      return 4 * Oi[255 + f[g - v] - f[g + 0]] + Oi[255 + f[g - 2 * v] - f[g + v]] <= b;
    }
    function zo(f, g, v, b, H) {
      var _ = f[g - 3 * v], R = f[g - 2 * v], K = f[g - v], j = f[g + 0], J = f[g + v], hA = f[g + 2 * v], UA = f[g + 3 * v];
      return 4 * Oi[255 + K - j] + Oi[255 + R - J] > b ? 0 : Oi[255 + f[g - 4 * v] - _] <= H && Oi[255 + _ - R] <= H && Oi[255 + R - K] <= H && Oi[255 + UA - hA] <= H && Oi[255 + hA - J] <= H && Oi[255 + J - j] <= H;
    }
    function aa(f, g, v, b) {
      var H = 2 * b + 1;
      for (b = 0; 16 > b; ++b) sa(f, g + b, v, H) && Hs(f, g + b, v);
    }
    function G(f, g, v, b) {
      var H = 2 * b + 1;
      for (b = 0; 16 > b; ++b) sa(f, g + b * v, 1, H) && Hs(f, g + b * v, 1);
    }
    function O(f, g, v, b) {
      var H;
      for (H = 3; 0 < H; --H) aa(f, g += 4 * v, v, b);
    }
    function LA(f, g, v, b) {
      var H;
      for (H = 3; 0 < H; --H) G(f, g += 4, v, b);
    }
    function kA(f, g, v, b, H, _, R, K) {
      for (_ = 2 * _ + 1; 0 < H--; ) {
        if (zo(f, g, v, _, R)) if (Ya(f, g, v, K)) Hs(f, g, v);
        else {
          var j = f, J = g, hA = v, UA = j[J - 2 * hA], Z = j[J - hA], BA = j[J + 0], bA = j[J + hA], NA = j[J + 2 * hA], QA = 27 * (RA = Gp[1020 + 3 * (BA - Z) + Gp[1020 + UA - bA]]) + 63 >> 7, DA = 18 * RA + 63 >> 7, RA = 9 * RA + 63 >> 7;
          j[J - 3 * hA] = di[255 + j[J - 3 * hA] + RA], j[J - 2 * hA] = di[255 + UA + DA], j[J - hA] = di[255 + Z + QA], j[J + 0] = di[255 + BA - QA], j[J + hA] = di[255 + bA - DA], j[J + 2 * hA] = di[255 + NA - RA];
        }
        g += b;
      }
    }
    function JA(f, g, v, b, H, _, R, K) {
      for (_ = 2 * _ + 1; 0 < H--; ) {
        if (zo(f, g, v, _, R)) if (Ya(f, g, v, K)) Hs(f, g, v);
        else {
          var j = f, J = g, hA = v, UA = j[J - hA], Z = j[J + 0], BA = j[J + hA], bA = Bf[112 + (4 + (NA = 3 * (Z - UA)) >> 3)], NA = Bf[112 + (NA + 3 >> 3)], QA = bA + 1 >> 1;
          j[J - 2 * hA] = di[255 + j[J - 2 * hA] + QA], j[J - hA] = di[255 + UA + NA], j[J + 0] = di[255 + Z - bA], j[J + hA] = di[255 + BA - QA];
        }
        g += b;
      }
    }
    function Ue(f, g, v, b, H, _) {
      kA(f, g, v, 1, 16, b, H, _);
    }
    function KA(f, g, v, b, H, _) {
      kA(f, g, 1, v, 16, b, H, _);
    }
    function Ne(f, g, v, b, H, _) {
      var R;
      for (R = 3; 0 < R; --R) JA(f, g += 4 * v, v, 1, 16, b, H, _);
    }
    function Wt(f, g, v, b, H, _) {
      var R;
      for (R = 3; 0 < R; --R) JA(f, g += 4, 1, v, 16, b, H, _);
    }
    function Dt(f, g, v, b, H, _, R, K) {
      kA(f, g, H, 1, 8, _, R, K), kA(v, b, H, 1, 8, _, R, K);
    }
    function w(f, g, v, b, H, _, R, K) {
      kA(f, g, 1, H, 8, _, R, K), kA(v, b, 1, H, 8, _, R, K);
    }
    function L(f, g, v, b, H, _, R, K) {
      JA(f, g + 4 * H, H, 1, 8, _, R, K), JA(v, b + 4 * H, H, 1, 8, _, R, K);
    }
    function z(f, g, v, b, H, _, R, K) {
      JA(f, g + 4, 1, H, 8, _, R, K), JA(v, b + 4, 1, H, 8, _, R, K);
    }
    function aA() {
      this.ba = new ue(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ze(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
    }
    function mA() {
      this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
    }
    function OA() {
      this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
    }
    function jA() {
      this.ua = 0, this.Wa = new vA(), this.vb = new vA(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new iA(), this.yc = new P();
    }
    function he() {
      this.xb = this.a = 0, this.l = new Ss(), this.ca = new ue(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new W(), this.Pb = 0, this.wd = new W(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new jA(), this.ab = 0, this.gc = s(4, OA), this.Oc = 0;
    }
    function ce() {
      this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Ss(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
    }
    function _e(f, g, v, b, H, _, R) {
      for (f = f == null ? 0 : f[g + 0], g = 0; g < R; ++g) H[_ + g] = f + v[b + g] & 255, f = H[_ + g];
    }
    function Me(f, g, v, b, H, _, R) {
      var K;
      if (f == null) _e(null, null, v, b, H, _, R);
      else for (K = 0; K < R; ++K) H[_ + K] = f[g + K] + v[b + K] & 255;
    }
    function Ze(f, g, v, b, H, _, R) {
      if (f == null) _e(null, null, v, b, H, _, R);
      else {
        var K, j = f[g + 0], J = j, hA = j;
        for (K = 0; K < R; ++K) J = hA + (j = f[g + K]) - J, hA = v[b + K] + (-256 & J ? 0 > J ? 0 : 255 : J) & 255, J = j, H[_ + K] = hA;
      }
    }
    function Qr(f, g, v, b) {
      var H = g.width, _ = g.o;
      if (A(f != null && g != null), 0 > v || 0 >= b || v + b > _) return null;
      if (!f.Cc) {
        if (f.ga == null) {
          var R;
          if (f.ga = new ce(), (R = f.ga == null) || (R = g.width * g.o, A(f.Gb.length == 0), f.Gb = i(R), f.Uc = 0, f.Gb == null ? R = 0 : (f.mb = f.Gb, f.nb = f.Uc, f.rc = null, R = 1), R = !R), !R) {
            R = f.ga;
            var K = f.Fa, j = f.P, J = f.qc, hA = f.mb, UA = f.nb, Z = j + 1, BA = J - 1, bA = R.l;
            if (A(K != null && hA != null && g != null), no[0] = null, no[1] = _e, no[2] = Me, no[3] = Ze, R.ca = hA, R.tb = UA, R.c = g.width, R.i = g.height, A(0 < R.c && 0 < R.i), 1 >= J) g = 0;
            else if (R.$a = 3 & K[j + 0], R.Z = K[j + 0] >> 2 & 3, R.Lc = K[j + 0] >> 4 & 3, j = K[j + 0] >> 6 & 3, 0 > R.$a || 1 < R.$a || 4 <= R.Z || 1 < R.Lc || j) g = 0;
            else if (bA.put = Be, bA.ac = un, bA.bc = Jr, bA.ma = R, bA.width = g.width, bA.height = g.height, bA.Da = g.Da, bA.v = g.v, bA.va = g.va, bA.j = g.j, bA.o = g.o, R.$a) A: {
              A(R.$a == 1), g = je();
              e: for (; ; ) {
                if (g == null) {
                  g = 0;
                  break A;
                }
                if (A(R != null), R.mc = g, g.c = R.c, g.i = R.i, g.l = R.l, g.l.ma = R, g.l.width = R.c, g.l.height = R.i, g.a = 0, cA(g.m, K, Z, BA), !Nt(R.c, R.i, 1, g, null) || (g.ab == 1 && g.gc[0].hc == 3 && Hr(g.s) ? (R.ic = 1, K = g.c * g.i, g.Ta = null, g.Ua = 0, g.V = i(K), g.Ba = 0, g.V == null ? (g.a = 1, g = 0) : g = 1) : (R.ic = 0, g = Si(g, R.c)), !g)) break e;
                g = 1;
                break A;
              }
              R.mc = null, g = 0;
            }
            else g = BA >= R.c * R.i;
            R = !g;
          }
          if (R) return null;
          f.ga.Lc != 1 ? f.Ga = 0 : b = _ - v;
        }
        A(f.ga != null), A(v + b <= _);
        A: {
          if (g = (K = f.ga).c, _ = K.l.o, K.$a == 0) {
            if (Z = f.rc, BA = f.Vc, bA = f.Fa, j = f.P + 1 + v * g, J = f.mb, hA = f.nb + v * g, A(j <= f.P + f.qc), K.Z != 0) for (A(no[K.Z] != null), R = 0; R < b; ++R) no[K.Z](Z, BA, bA, j, J, hA, g), Z = J, BA = hA, hA += g, j += g;
            else for (R = 0; R < b; ++R) r(J, hA, bA, j, g), Z = J, BA = hA, hA += g, j += g;
            f.rc = Z, f.Vc = BA;
          } else {
            if (A(K.mc != null), g = v + b, A((R = K.mc) != null), A(g <= R.i), R.C >= g) g = 1;
            else if (K.ic || qt(), K.ic) {
              K = R.V, Z = R.Ba, BA = R.c;
              var NA = R.i, QA = (bA = 1, j = R.$ / BA, J = R.$ % BA, hA = R.m, UA = R.s, R.$), DA = BA * NA, RA = BA * g, YA = UA.wc, qA = QA < RA ? Gt(UA, J, j) : null;
              A(QA <= DA), A(g <= NA), A(Hr(UA));
              e: for (; ; ) {
                for (; !hA.h && QA < RA; ) {
                  if (J & YA || (qA = Gt(UA, J, j)), A(qA != null), gA(hA), 256 > (NA = Bt(qA.G[0], qA.H[0], hA))) K[Z + QA] = NA, ++QA, ++J >= BA && (J = 0, ++j <= g && !(j % 16) && tr(R, j));
                  else {
                    if (!(280 > NA)) {
                      bA = 0;
                      break e;
                    }
                    NA = Vt(NA - 256, hA);
                    var ve, oe = Bt(qA.G[4], qA.H[4], hA);
                    if (gA(hA), !(QA >= (oe = Ar(BA, oe = Vt(oe, hA))) && DA - QA >= NA)) {
                      bA = 0;
                      break e;
                    }
                    for (ve = 0; ve < NA; ++ve) K[Z + QA + ve] = K[Z + QA + ve - oe];
                    for (QA += NA, J += NA; J >= BA; ) J -= BA, ++j <= g && !(j % 16) && tr(R, j);
                    QA < RA && J & YA && (qA = Gt(UA, J, j));
                  }
                  A(hA.h == AA(hA));
                }
                tr(R, j > g ? g : j);
                break e;
              }
              !bA || hA.h && QA < DA ? (bA = 0, R.a = hA.h ? 5 : 3) : R.$ = QA, g = bA;
            } else g = Tn(R, R.V, R.Ba, R.c, R.i, g, ts);
            if (!g) {
              b = 0;
              break A;
            }
          }
          v + b >= _ && (f.Cc = 1), b = 1;
        }
        if (!b) return null;
        if (f.Cc && ((b = f.ga) != null && (b.mc = null), f.ga = null, 0 < f.Ga)) return alert("todo:WebPDequantizeLevels"), null;
      }
      return f.nb + v * H;
    }
    function vt(f, g, v, b, H, _) {
      for (; 0 < H--; ) {
        var R, K = f, j = g + (v ? 1 : 0), J = f, hA = g + (v ? 0 : 3);
        for (R = 0; R < b; ++R) {
          var UA = J[hA + 4 * R];
          UA != 255 && (UA *= 32897, K[j + 4 * R + 0] = K[j + 4 * R + 0] * UA >> 23, K[j + 4 * R + 1] = K[j + 4 * R + 1] * UA >> 23, K[j + 4 * R + 2] = K[j + 4 * R + 2] * UA >> 23);
        }
        g += _;
      }
    }
    function wt(f, g, v, b, H) {
      for (; 0 < b--; ) {
        var _;
        for (_ = 0; _ < v; ++_) {
          var R = f[g + 2 * _ + 0], K = 15 & (J = f[g + 2 * _ + 1]), j = 4369 * K, J = (240 & J | J >> 4) * j >> 16;
          f[g + 2 * _ + 0] = (240 & R | R >> 4) * j >> 16 & 240 | (15 & R | R << 4) * j >> 16 >> 4 & 15, f[g + 2 * _ + 1] = 240 & J | K;
        }
        g += H;
      }
    }
    function Ht(f, g, v, b, H, _, R, K) {
      var j, J, hA = 255;
      for (J = 0; J < H; ++J) {
        for (j = 0; j < b; ++j) {
          var UA = f[g + j];
          _[R + 4 * j] = UA, hA &= UA;
        }
        g += v, R += K;
      }
      return hA != 255;
    }
    function jt(f, g, v, b, H) {
      var _;
      for (_ = 0; _ < H; ++_) v[b + _] = f[g + _] >> 8;
    }
    function qt() {
      gu = vt, x2 = wt, I2 = Ht, S2 = jt;
    }
    function gn(f, g, v) {
      I[f] = function(b, H, _, R, K, j, J, hA, UA, Z, BA, bA, NA, QA, DA, RA, YA) {
        var qA, ve = YA - 1 >> 1, oe = K[j + 0] | J[hA + 0] << 16, Ve = UA[Z + 0] | BA[bA + 0] << 16;
        A(b != null);
        var fe = 3 * oe + Ve + 131074 >> 2;
        for (g(b[H + 0], 255 & fe, fe >> 16, NA, QA), _ != null && (fe = 3 * Ve + oe + 131074 >> 2, g(_[R + 0], 255 & fe, fe >> 16, DA, RA)), qA = 1; qA <= ve; ++qA) {
          var Xe = K[j + qA] | J[hA + qA] << 16, Nr = UA[Z + qA] | BA[bA + qA] << 16, Ge = oe + Xe + Ve + Nr + 524296, de = Ge + 2 * (Xe + Ve) >> 3;
          fe = de + oe >> 1, oe = (Ge = Ge + 2 * (oe + Nr) >> 3) + Xe >> 1, g(b[H + 2 * qA - 1], 255 & fe, fe >> 16, NA, QA + (2 * qA - 1) * v), g(b[H + 2 * qA - 0], 255 & oe, oe >> 16, NA, QA + (2 * qA - 0) * v), _ != null && (fe = Ge + Ve >> 1, oe = de + Nr >> 1, g(_[R + 2 * qA - 1], 255 & fe, fe >> 16, DA, RA + (2 * qA - 1) * v), g(_[R + 2 * qA + 0], 255 & oe, oe >> 16, DA, RA + (2 * qA + 0) * v)), oe = Xe, Ve = Nr;
        }
        1 & YA || (fe = 3 * oe + Ve + 131074 >> 2, g(b[H + YA - 1], 255 & fe, fe >> 16, NA, QA + (YA - 1) * v), _ != null && (fe = 3 * Ve + oe + 131074 >> 2, g(_[R + YA - 1], 255 & fe, fe >> 16, DA, RA + (YA - 1) * v)));
      };
    }
    function oa() {
      Ni[wf] = TT, Ni[mf] = k2, Ni[N2] = _T, Ni[vf] = K2, Ni[yf] = V2, Ni[Wp] = G2, Ni[D2] = OT, Ni[jp] = k2, Ni[qp] = K2, Ni[Cf] = V2, Ni[$p] = G2;
    }
    function ou(f) {
      return f & -16384 ? 0 > f ? 0 : 255 : f >> NT;
    }
    function Xo(f, g) {
      return ou((19077 * f >> 8) + (26149 * g >> 8) - 14234);
    }
    function Yo(f, g, v) {
      return ou((19077 * f >> 8) - (6419 * g >> 8) - (13320 * v >> 8) + 8708);
    }
    function Ja(f, g) {
      return ou((19077 * f >> 8) + (33050 * g >> 8) - 17685);
    }
    function Jo(f, g, v, b, H) {
      b[H + 0] = Xo(f, v), b[H + 1] = Yo(f, g, v), b[H + 2] = Ja(f, g);
    }
    function ac(f, g, v, b, H) {
      b[H + 0] = Ja(f, g), b[H + 1] = Yo(f, g, v), b[H + 2] = Xo(f, v);
    }
    function oc(f, g, v, b, H) {
      var _ = Yo(f, g, v);
      g = _ << 3 & 224 | Ja(f, g) >> 3, b[H + 0] = 248 & Xo(f, v) | _ >> 5, b[H + 1] = g;
    }
    function pn(f, g, v, b, H) {
      var _ = 240 & Ja(f, g) | 15;
      b[H + 0] = 240 & Xo(f, v) | Yo(f, g, v) >> 4, b[H + 1] = _;
    }
    function Zo(f, g, v, b, H) {
      b[H + 0] = 255, Jo(f, g, v, b, H + 1);
    }
    function Al(f, g, v, b, H) {
      ac(f, g, v, b, H), b[H + 3] = 255;
    }
    function lu(f, g, v, b, H) {
      Jo(f, g, v, b, H), b[H + 3] = 255;
    }
    function Ts(f, g, v) {
      I[f] = function(b, H, _, R, K, j, J, hA, UA) {
        for (var Z = hA + (-2 & UA) * v; hA != Z; ) g(b[H + 0], _[R + 0], K[j + 0], J, hA), g(b[H + 1], _[R + 0], K[j + 0], J, hA + v), H += 2, ++R, ++j, hA += 2 * v;
        1 & UA && g(b[H + 0], _[R + 0], K[j + 0], J, hA);
      };
    }
    function Kn(f, g, v) {
      return v == 0 ? f == 0 ? g == 0 ? 6 : 5 : g == 0 ? 4 : 0 : v;
    }
    function df(f, g, v, b, H) {
      switch (f >>> 30) {
        case 3:
          la(g, v, b, H, 0);
          break;
        case 2:
          to(g, v, b, H);
          break;
        case 1:
          Bn(g, v, b, H);
      }
    }
    function lc(f, g) {
      var v, b, H = g.M, _ = g.Nb, R = f.oc, K = f.pc + 40, j = f.oc, J = f.pc + 584, hA = f.oc, UA = f.pc + 600;
      for (v = 0; 16 > v; ++v) R[K + 32 * v - 1] = 129;
      for (v = 0; 8 > v; ++v) j[J + 32 * v - 1] = 129, hA[UA + 32 * v - 1] = 129;
      for (0 < H ? R[K - 1 - 32] = j[J - 1 - 32] = hA[UA - 1 - 32] = 129 : (n(R, K - 32 - 1, 127, 21), n(j, J - 32 - 1, 127, 9), n(hA, UA - 32 - 1, 127, 9)), b = 0; b < f.za; ++b) {
        var Z = g.ya[g.aa + b];
        if (0 < b) {
          for (v = -1; 16 > v; ++v) r(R, K + 32 * v - 4, R, K + 32 * v + 12, 4);
          for (v = -1; 8 > v; ++v) r(j, J + 32 * v - 4, j, J + 32 * v + 4, 4), r(hA, UA + 32 * v - 4, hA, UA + 32 * v + 4, 4);
        }
        var BA = f.Gd, bA = f.Hd + b, NA = Z.ad, QA = Z.Hc;
        if (0 < H && (r(R, K - 32, BA[bA].y, 0, 16), r(j, J - 32, BA[bA].f, 0, 8), r(hA, UA - 32, BA[bA].ea, 0, 8)), Z.Za) {
          var DA = R, RA = K - 32 + 16;
          for (0 < H && (b >= f.za - 1 ? n(DA, RA, BA[bA].y[15], 4) : r(DA, RA, BA[bA + 1].y, 0, 4)), v = 0; 4 > v; v++) DA[RA + 128 + v] = DA[RA + 256 + v] = DA[RA + 384 + v] = DA[RA + 0 + v];
          for (v = 0; 16 > v; ++v, QA <<= 2) DA = R, RA = K + j2[v], os[Z.Ob[v]](DA, RA), df(QA, NA, 16 * +v, DA, RA);
        } else if (DA = Kn(b, H, Z.Ob[0]), ro[DA](R, K), QA != 0) for (v = 0; 16 > v; ++v, QA <<= 2) df(QA, NA, 16 * +v, R, K + j2[v]);
        for (v = Z.Gc, DA = Kn(b, H, Z.Dd), ua[DA](j, J), ua[DA](hA, UA), QA = NA, DA = j, RA = J, 255 & (Z = 0 | v) && (170 & Z ? dc(QA, 256, DA, RA) : Os(QA, 256, DA, RA)), Z = hA, QA = UA, 255 & (v >>= 8) && (170 & v ? dc(NA, 320, Z, QA) : Os(NA, 320, Z, QA)), H < f.Ub - 1 && (r(BA[bA].y, 0, R, K + 480, 16), r(BA[bA].f, 0, j, J + 224, 8), r(BA[bA].ea, 0, hA, UA + 224, 8)), v = 8 * _ * f.B, BA = f.sa, bA = f.ta + 16 * b + 16 * _ * f.R, NA = f.qa, Z = f.ra + 8 * b + v, QA = f.Ha, DA = f.Ia + 8 * b + v, v = 0; 16 > v; ++v) r(BA, bA + v * f.R, R, K + 32 * v, 16);
        for (v = 0; 8 > v; ++v) r(NA, Z + v * f.B, j, J + 32 * v, 8), r(QA, DA + v * f.B, hA, UA + 32 * v, 8);
      }
    }
    function gf(f, g, v, b, H, _, R, K, j) {
      var J = [0], hA = [0], UA = 0, Z = j != null ? j.kd : 0, BA = j ?? new mA();
      if (f == null || 12 > v) return 7;
      BA.data = f, BA.w = g, BA.ha = v, g = [g], v = [v], BA.gb = [BA.gb];
      A: {
        var bA = g, NA = v, QA = BA.gb;
        if (A(f != null), A(NA != null), A(QA != null), QA[0] = 0, 12 <= NA[0] && !t(f, bA[0], "RIFF")) {
          if (t(f, bA[0] + 8, "WEBP")) {
            QA = 3;
            break A;
          }
          var DA = uA(f, bA[0] + 4);
          if (12 > DA || 4294967286 < DA) {
            QA = 3;
            break A;
          }
          if (Z && DA > NA[0] - 8) {
            QA = 7;
            break A;
          }
          QA[0] = DA, bA[0] += 12, NA[0] -= 12;
        }
        QA = 0;
      }
      if (QA != 0) return QA;
      for (DA = 0 < BA.gb[0], v = v[0]; ; ) {
        A: {
          var RA = f;
          NA = g, QA = v;
          var YA = J, qA = hA, ve = bA = [0];
          if ((fe = UA = [UA])[0] = 0, 8 > QA[0]) QA = 7;
          else {
            if (!t(RA, NA[0], "VP8X")) {
              if (uA(RA, NA[0] + 4) != 10) {
                QA = 3;
                break A;
              }
              if (18 > QA[0]) {
                QA = 7;
                break A;
              }
              var oe = uA(RA, NA[0] + 8), Ve = 1 + X(RA, NA[0] + 12);
              if (2147483648 <= Ve * (RA = 1 + X(RA, NA[0] + 15))) {
                QA = 3;
                break A;
              }
              ve != null && (ve[0] = oe), YA != null && (YA[0] = Ve), qA != null && (qA[0] = RA), NA[0] += 18, QA[0] -= 18, fe[0] = 1;
            }
            QA = 0;
          }
        }
        if (UA = UA[0], bA = bA[0], QA != 0) return QA;
        if (NA = !!(2 & bA), !DA && UA) return 3;
        if (_ != null && (_[0] = !!(16 & bA)), R != null && (R[0] = NA), K != null && (K[0] = 0), R = J[0], bA = hA[0], UA && NA && j == null) {
          QA = 0;
          break;
        }
        if (4 > v) {
          QA = 7;
          break;
        }
        if (DA && UA || !DA && !UA && !t(f, g[0], "ALPH")) {
          v = [v], BA.na = [BA.na], BA.P = [BA.P], BA.Sa = [BA.Sa];
          A: {
            oe = f, QA = g, DA = v;
            var fe = BA.gb;
            YA = BA.na, qA = BA.P, ve = BA.Sa, Ve = 22, A(oe != null), A(DA != null), RA = QA[0];
            var Xe = DA[0];
            for (A(YA != null), A(ve != null), YA[0] = null, qA[0] = null, ve[0] = 0; ; ) {
              if (QA[0] = RA, DA[0] = Xe, 8 > Xe) {
                QA = 7;
                break A;
              }
              var Nr = uA(oe, RA + 4);
              if (4294967286 < Nr) {
                QA = 3;
                break A;
              }
              var Ge = 8 + Nr + 1 & -2;
              if (Ve += Ge, 0 < fe && Ve > fe) {
                QA = 3;
                break A;
              }
              if (!t(oe, RA, "VP8 ") || !t(oe, RA, "VP8L")) {
                QA = 0;
                break A;
              }
              if (Xe[0] < Ge) {
                QA = 7;
                break A;
              }
              t(oe, RA, "ALPH") || (YA[0] = oe, qA[0] = RA + 8, ve[0] = Nr), RA += Ge, Xe -= Ge;
            }
          }
          if (v = v[0], BA.na = BA.na[0], BA.P = BA.P[0], BA.Sa = BA.Sa[0], QA != 0) break;
        }
        v = [v], BA.Ja = [BA.Ja], BA.xa = [BA.xa];
        A: if (fe = f, QA = g, DA = v, YA = BA.gb[0], qA = BA.Ja, ve = BA.xa, oe = QA[0], RA = !t(fe, oe, "VP8 "), Ve = !t(fe, oe, "VP8L"), A(fe != null), A(DA != null), A(qA != null), A(ve != null), 8 > DA[0]) QA = 7;
        else {
          if (RA || Ve) {
            if (fe = uA(fe, oe + 4), 12 <= YA && fe > YA - 12) {
              QA = 3;
              break A;
            }
            if (Z && fe > DA[0] - 8) {
              QA = 7;
              break A;
            }
            qA[0] = fe, QA[0] += 8, DA[0] -= 8, ve[0] = Ve;
          } else ve[0] = 5 <= DA[0] && fe[oe + 0] == 47 && !(fe[oe + 4] >> 5), qA[0] = DA[0];
          QA = 0;
        }
        if (v = v[0], BA.Ja = BA.Ja[0], BA.xa = BA.xa[0], g = g[0], QA != 0) break;
        if (4294967286 < BA.Ja) return 3;
        if (K == null || NA || (K[0] = BA.xa ? 2 : 1), R = [R], bA = [bA], BA.xa) {
          if (5 > v) {
            QA = 7;
            break;
          }
          K = R, Z = bA, NA = _, f == null || 5 > v ? f = 0 : 5 <= v && f[g + 0] == 47 && !(f[g + 4] >> 5) ? (DA = [0], fe = [0], YA = [0], cA(qA = new W(), f, g, v), Zt(qA, DA, fe, YA) ? (K != null && (K[0] = DA[0]), Z != null && (Z[0] = fe[0]), NA != null && (NA[0] = YA[0]), f = 1) : f = 0) : f = 0;
        } else {
          if (10 > v) {
            QA = 7;
            break;
          }
          K = bA, f == null || 10 > v || !ss(f, g + 3, v - 3) ? f = 0 : (Z = f[g + 0] | f[g + 1] << 8 | f[g + 2] << 16, NA = 16383 & (f[g + 7] << 8 | f[g + 6]), f = 16383 & (f[g + 9] << 8 | f[g + 8]), 1 & Z || 3 < (Z >> 1 & 7) || !(Z >> 4 & 1) || Z >> 5 >= BA.Ja || !NA || !f ? f = 0 : (R && (R[0] = NA), K && (K[0] = f), f = 1));
        }
        if (!f || (R = R[0], bA = bA[0], UA && (J[0] != R || hA[0] != bA))) return 3;
        j != null && (j[0] = BA, j.offset = g - j.w, A(4294967286 > g - j.w), A(j.offset == j.ha - v));
        break;
      }
      return QA == 0 || QA == 7 && UA && j == null ? (_ != null && (_[0] |= BA.na != null && 0 < BA.na.length), b != null && (b[0] = R), H != null && (H[0] = bA), 0) : QA;
    }
    function _i(f, g, v) {
      var b = g.width, H = g.height, _ = 0, R = 0, K = b, j = H;
      if (g.Da = f != null && 0 < f.Da, g.Da && (K = f.cd, j = f.bd, _ = f.v, R = f.j, 11 > v || (_ &= -2, R &= -2), 0 > _ || 0 > R || 0 >= K || 0 >= j || _ + K > b || R + j > H)) return 0;
      if (g.v = _, g.j = R, g.va = _ + K, g.o = R + j, g.U = K, g.T = j, g.da = f != null && 0 < f.da, g.da) {
        if (!rA(K, j, v = [f.ib], _ = [f.hb])) return 0;
        g.ib = v[0], g.hb = _[0];
      }
      return g.ob = f != null && f.ob, g.Kb = f == null || !f.Sd, g.da && (g.ob = g.ib < 3 * b / 4 && g.hb < 3 * H / 4, g.Kb = 0), 1;
    }
    function el(f) {
      if (f == null) return 2;
      if (11 > f.S) {
        var g = f.f.RGBA;
        g.fb += (f.height - 1) * g.A, g.A = -g.A;
      } else g = f.f.kb, f = f.height, g.O += (f - 1) * g.fa, g.fa = -g.fa, g.N += (f - 1 >> 1) * g.Ab, g.Ab = -g.Ab, g.W += (f - 1 >> 1) * g.Db, g.Db = -g.Db, g.F != null && (g.J += (f - 1) * g.lb, g.lb = -g.lb);
      return 0;
    }
    function cu(f, g, v, b) {
      if (b == null || 0 >= f || 0 >= g) return 2;
      if (v != null) {
        if (v.Da) {
          var H = v.cd, _ = v.bd, R = -2 & v.v, K = -2 & v.j;
          if (0 > R || 0 > K || 0 >= H || 0 >= _ || R + H > f || K + _ > g) return 2;
          f = H, g = _;
        }
        if (v.da) {
          if (!rA(f, g, H = [v.ib], _ = [v.hb])) return 2;
          f = H[0], g = _[0];
        }
      }
      b.width = f, b.height = g;
      A: {
        var j = b.width, J = b.height;
        if (f = b.S, 0 >= j || 0 >= J || !(f >= wf && 13 > f)) f = 2;
        else {
          if (0 >= b.Rd && b.sd == null) {
            R = _ = H = g = 0;
            var hA = (K = j * q2[f]) * J;
            if (11 > f || (_ = (J + 1) / 2 * (g = (j + 1) / 2), f == 12 && (R = (H = j) * J)), (J = i(hA + 2 * _ + R)) == null) {
              f = 1;
              break A;
            }
            b.sd = J, 11 > f ? ((j = b.f.RGBA).eb = J, j.fb = 0, j.A = K, j.size = hA) : ((j = b.f.kb).y = J, j.O = 0, j.fa = K, j.Fd = hA, j.f = J, j.N = 0 + hA, j.Ab = g, j.Cd = _, j.ea = J, j.W = 0 + hA + _, j.Db = g, j.Ed = _, f == 12 && (j.F = J, j.J = 0 + hA + 2 * _), j.Tc = R, j.lb = H);
          }
          if (g = 1, H = b.S, _ = b.width, R = b.height, H >= wf && 13 > H) if (11 > H) f = b.f.RGBA, g &= (K = Math.abs(f.A)) * (R - 1) + _ <= f.size, g &= K >= _ * q2[H], g &= f.eb != null;
          else {
            f = b.f.kb, K = (_ + 1) / 2, hA = (R + 1) / 2, j = Math.abs(f.fa), J = Math.abs(f.Ab);
            var UA = Math.abs(f.Db), Z = Math.abs(f.lb), BA = Z * (R - 1) + _;
            g &= j * (R - 1) + _ <= f.Fd, g &= J * (hA - 1) + K <= f.Cd, g = (g &= UA * (hA - 1) + K <= f.Ed) & j >= _ & J >= K & UA >= K, g &= f.y != null, g &= f.f != null, g &= f.ea != null, H == 12 && (g &= Z >= _, g &= BA <= f.Tc, g &= f.F != null);
          }
          else g = 0;
          f = g ? 0 : 2;
        }
      }
      return f != 0 || v != null && v.fd && (f = el(b)), f;
    }
    var cc = 64, tl = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215], uu = 24, Vn = 32, ei = 8, uc = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];
    lA("Predictor0", "PredictorAdd0"), I.Predictor0 = function() {
      return 4278190080;
    }, I.Predictor1 = function(f) {
      return f;
    }, I.Predictor2 = function(f, g, v) {
      return g[v + 0];
    }, I.Predictor3 = function(f, g, v) {
      return g[v + 1];
    }, I.Predictor4 = function(f, g, v) {
      return g[v - 1];
    }, I.Predictor5 = function(f, g, v) {
      return SA(SA(f, g[v + 1]), g[v + 0]);
    }, I.Predictor6 = function(f, g, v) {
      return SA(f, g[v - 1]);
    }, I.Predictor7 = function(f, g, v) {
      return SA(f, g[v + 0]);
    }, I.Predictor8 = function(f, g, v) {
      return SA(g[v - 1], g[v + 0]);
    }, I.Predictor9 = function(f, g, v) {
      return SA(g[v + 0], g[v + 1]);
    }, I.Predictor10 = function(f, g, v) {
      return SA(SA(f, g[v - 1]), SA(g[v + 0], g[v + 1]));
    }, I.Predictor11 = function(f, g, v) {
      var b = g[v + 0];
      return 0 >= _A(b >> 24 & 255, f >> 24 & 255, (g = g[v - 1]) >> 24 & 255) + _A(b >> 16 & 255, f >> 16 & 255, g >> 16 & 255) + _A(b >> 8 & 255, f >> 8 & 255, g >> 8 & 255) + _A(255 & b, 255 & f, 255 & g) ? b : f;
    }, I.Predictor12 = function(f, g, v) {
      var b = g[v + 0];
      return (yA((f >> 24 & 255) + (b >> 24 & 255) - ((g = g[v - 1]) >> 24 & 255)) << 24 | yA((f >> 16 & 255) + (b >> 16 & 255) - (g >> 16 & 255)) << 16 | yA((f >> 8 & 255) + (b >> 8 & 255) - (g >> 8 & 255)) << 8 | yA((255 & f) + (255 & b) - (255 & g))) >>> 0;
    }, I.Predictor13 = function(f, g, v) {
      var b = g[v - 1];
      return (TA((f = SA(f, g[v + 0])) >> 24 & 255, b >> 24 & 255) << 24 | TA(f >> 16 & 255, b >> 16 & 255) << 16 | TA(f >> 8 & 255, b >> 8 & 255) << 8 | TA(255 & f, 255 & b)) >>> 0;
    };
    var Za = I.PredictorAdd0;
    I.PredictorAdd1 = MA, lA("Predictor2", "PredictorAdd2"), lA("Predictor3", "PredictorAdd3"), lA("Predictor4", "PredictorAdd4"), lA("Predictor5", "PredictorAdd5"), lA("Predictor6", "PredictorAdd6"), lA("Predictor7", "PredictorAdd7"), lA("Predictor8", "PredictorAdd8"), lA("Predictor9", "PredictorAdd9"), lA("Predictor10", "PredictorAdd10"), lA("Predictor11", "PredictorAdd11"), lA("Predictor12", "PredictorAdd12"), lA("Predictor13", "PredictorAdd13");
    var Ao = I.PredictorAdd2;
    ZA("ColorIndexInverseTransform", "MapARGB", "32b", function(f) {
      return f >> 8 & 255;
    }, function(f) {
      return f;
    }), ZA("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(f) {
      return f;
    }, function(f) {
      return f >> 8 & 255;
    });
    var hc, rl = I.ColorIndexInverseTransform, Ur = I.MapARGB, Vp = I.VP8LColorIndexInverseTransformAlpha, _s = I.MapAlpha, as = I.VP8LPredictorsAdd = [];
    as.length = 16, (I.VP8LPredictors = []).length = 16, (I.VP8LPredictorsAdd_C = []).length = 16, (I.VP8LPredictors_C = []).length = 16;
    var nl, hu, fu, fc, il, sl, eo, la, to, dc, Bn, Os, Qt, Ut, fr, Or, ca, du, gc, pf, F2, Q2, U2, E2, gu, x2, I2, S2, L2 = i(511), H2 = i(2041), T2 = i(225), _2 = i(767), O2 = 0, Gp = H2, Bf = T2, di = _2, Oi = L2, wf = 0, mf = 1, N2 = 2, vf = 3, yf = 4, Wp = 5, D2 = 6, jp = 7, qp = 8, Cf = 9, $p = 10, mT = [2, 3, 7], vT = [3, 3, 11], R2 = [280, 256, 256, 256, 40], yT = [0, 1, 1, 1, 0], CT = [17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], bT = [24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21, 27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36, 44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68, 76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46, 84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17, 31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99, 109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125, 81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112], FT = [2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468, 3980, 5004], QT = 8, zp = [4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114, 116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143, 145, 148, 151, 154, 157], Xp = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143, 146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239, 245, 249, 254, 259, 264, 269, 274, 279, 284], pu = null, UT = [[173, 148, 140, 0], [176, 155, 140, 135, 0], [180, 157, 141, 134, 130, 0], [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0]], ET = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15], M2 = [-0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9], xT = [[[[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]], [[253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128], [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128], [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128]], [[1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128], [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128], [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128]], [[1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128], [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128], [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128]], [[1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128], [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128], [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128]], [[1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128], [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128], [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128]], [[1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128], [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128], [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62], [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1], [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128]], [[1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128], [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128], [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128]], [[1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128], [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128], [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128]], [[1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128], [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128], [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128]], [[1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128], [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128], [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128]], [[1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128], [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128], [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128]], [[1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128], [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128], [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128]], [[1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128], [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128], [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128]]], [[[253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128], [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128], [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128]], [[1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128], [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128], [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128]], [[1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128], [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128], [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128]], [[1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128], [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128], [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128]], [[1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128], [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128], [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128], [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128], [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128], [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128], [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255], [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128], [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128]], [[1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128], [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128], [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128]], [[1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128], [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128], [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128]], [[1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128], [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128], [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128]], [[1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128], [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128], [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128]], [[1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128], [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128], [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128]], [[1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128], [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128], [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]]]], IT = [[[231, 120, 48, 89, 115, 113, 120, 152, 112], [152, 179, 64, 126, 170, 118, 46, 70, 95], [175, 69, 143, 80, 85, 82, 72, 155, 103], [56, 58, 10, 171, 218, 189, 17, 13, 152], [114, 26, 17, 163, 44, 195, 21, 10, 173], [121, 24, 80, 195, 26, 62, 44, 64, 85], [144, 71, 10, 38, 171, 213, 144, 34, 26], [170, 46, 55, 19, 136, 160, 33, 206, 71], [63, 20, 8, 114, 114, 208, 12, 9, 226], [81, 40, 11, 96, 182, 84, 29, 16, 36]], [[134, 183, 89, 137, 98, 101, 106, 165, 148], [72, 187, 100, 130, 157, 111, 32, 75, 80], [66, 102, 167, 99, 74, 62, 40, 234, 128], [41, 53, 9, 178, 241, 141, 26, 8, 107], [74, 43, 26, 146, 73, 166, 49, 23, 157], [65, 38, 105, 160, 51, 52, 31, 115, 128], [104, 79, 12, 27, 217, 255, 87, 17, 7], [87, 68, 71, 44, 114, 51, 15, 186, 23], [47, 41, 14, 110, 182, 183, 21, 17, 194], [66, 45, 25, 102, 197, 189, 23, 18, 22]], [[88, 88, 147, 150, 42, 46, 45, 196, 205], [43, 97, 183, 117, 85, 38, 35, 179, 61], [39, 53, 200, 87, 26, 21, 43, 232, 171], [56, 34, 51, 104, 114, 102, 29, 93, 77], [39, 28, 85, 171, 58, 165, 90, 98, 64], [34, 22, 116, 206, 23, 34, 43, 166, 73], [107, 54, 32, 26, 51, 1, 81, 43, 31], [68, 25, 106, 22, 64, 171, 36, 225, 114], [34, 19, 21, 102, 132, 188, 16, 76, 124], [62, 18, 78, 95, 85, 57, 50, 48, 51]], [[193, 101, 35, 159, 215, 111, 89, 46, 111], [60, 148, 31, 172, 219, 228, 21, 18, 111], [112, 113, 77, 85, 179, 255, 38, 120, 114], [40, 42, 1, 196, 245, 209, 10, 25, 109], [88, 43, 29, 140, 166, 213, 37, 43, 154], [61, 63, 30, 155, 67, 45, 68, 1, 209], [100, 80, 8, 43, 154, 1, 51, 26, 71], [142, 78, 78, 16, 255, 128, 34, 197, 171], [41, 40, 5, 102, 211, 183, 4, 1, 221], [51, 50, 17, 168, 209, 192, 23, 25, 82]], [[138, 31, 36, 171, 27, 166, 38, 44, 229], [67, 87, 58, 169, 82, 115, 26, 59, 179], [63, 59, 90, 180, 59, 166, 93, 73, 154], [40, 40, 21, 116, 143, 209, 34, 39, 175], [47, 15, 16, 183, 34, 223, 49, 45, 183], [46, 17, 33, 183, 6, 98, 15, 32, 183], [57, 46, 22, 24, 128, 1, 54, 17, 37], [65, 32, 73, 115, 28, 128, 23, 128, 205], [40, 3, 9, 115, 51, 192, 18, 6, 223], [87, 37, 9, 115, 59, 77, 64, 21, 47]], [[104, 55, 44, 218, 9, 54, 53, 130, 226], [64, 90, 70, 205, 40, 41, 23, 26, 57], [54, 57, 112, 184, 5, 41, 38, 166, 213], [30, 34, 26, 133, 152, 116, 10, 32, 134], [39, 19, 53, 221, 26, 114, 32, 73, 255], [31, 9, 65, 234, 2, 15, 1, 118, 73], [75, 32, 12, 51, 192, 255, 160, 43, 51], [88, 31, 35, 67, 102, 85, 55, 186, 85], [56, 21, 23, 111, 59, 205, 45, 37, 192], [55, 38, 70, 124, 73, 102, 1, 34, 98]], [[125, 98, 42, 88, 104, 85, 117, 175, 82], [95, 84, 53, 89, 128, 100, 113, 101, 45], [75, 79, 123, 47, 51, 128, 81, 171, 1], [57, 17, 5, 71, 102, 57, 53, 41, 49], [38, 33, 13, 121, 57, 73, 26, 1, 85], [41, 10, 67, 138, 77, 110, 90, 47, 114], [115, 21, 2, 10, 102, 255, 166, 23, 6], [101, 29, 16, 10, 85, 128, 101, 196, 26], [57, 18, 10, 102, 102, 213, 34, 20, 43], [117, 20, 15, 36, 163, 128, 68, 1, 26]], [[102, 61, 71, 37, 34, 53, 31, 243, 192], [69, 60, 71, 38, 73, 119, 28, 222, 37], [68, 45, 128, 34, 1, 47, 11, 245, 171], [62, 17, 19, 70, 146, 85, 55, 62, 70], [37, 43, 37, 154, 100, 163, 85, 160, 1], [63, 9, 92, 136, 28, 64, 32, 201, 85], [75, 15, 9, 9, 64, 255, 184, 119, 16], [86, 6, 28, 5, 64, 255, 25, 248, 1], [56, 8, 17, 132, 137, 255, 55, 116, 128], [58, 15, 20, 82, 135, 57, 26, 121, 40]], [[164, 50, 31, 137, 154, 133, 25, 35, 218], [51, 103, 44, 131, 131, 123, 31, 6, 158], [86, 40, 64, 135, 148, 224, 45, 183, 128], [22, 26, 17, 131, 240, 154, 14, 1, 209], [45, 16, 21, 91, 64, 222, 7, 1, 197], [56, 21, 39, 155, 60, 138, 23, 102, 213], [83, 12, 13, 54, 192, 255, 68, 47, 28], [85, 26, 85, 85, 128, 128, 32, 146, 171], [18, 11, 7, 63, 144, 171, 4, 4, 246], [35, 27, 10, 146, 174, 171, 12, 26, 128]], [[190, 80, 35, 99, 180, 80, 126, 54, 45], [85, 126, 47, 87, 176, 51, 41, 20, 32], [101, 75, 128, 139, 118, 146, 116, 128, 85], [56, 41, 15, 176, 236, 85, 37, 9, 62], [71, 30, 17, 119, 118, 255, 17, 18, 138], [101, 38, 60, 138, 55, 70, 43, 26, 142], [146, 36, 19, 30, 171, 255, 97, 27, 20], [138, 45, 61, 62, 219, 1, 81, 188, 64], [32, 41, 20, 117, 151, 142, 20, 21, 163], [112, 19, 12, 61, 195, 128, 48, 4, 24]]], ST = [[[[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255], [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255], [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255], [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255], [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255], [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255], [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255], [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255], [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255], [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255], [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255], [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]]], LT = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0], ro = [], os = [], ua = [], HT = 1, P2 = 2, no = [], Ni = [];
    gn("UpsampleRgbLinePair", Jo, 3), gn("UpsampleBgrLinePair", ac, 3), gn("UpsampleRgbaLinePair", lu, 4), gn("UpsampleBgraLinePair", Al, 4), gn("UpsampleArgbLinePair", Zo, 4), gn("UpsampleRgba4444LinePair", pn, 2), gn("UpsampleRgb565LinePair", oc, 2);
    var TT = I.UpsampleRgbLinePair, _T = I.UpsampleBgrLinePair, k2 = I.UpsampleRgbaLinePair, K2 = I.UpsampleBgraLinePair, V2 = I.UpsampleArgbLinePair, G2 = I.UpsampleRgba4444LinePair, OT = I.UpsampleRgb565LinePair, bf = 16, Ff = 1 << bf - 1, Bu = -227, Yp = 482, NT = 6, W2 = 0, DT = i(256), RT = i(256), MT = i(256), PT = i(256), kT = i(Yp - Bu), KT = i(Yp - Bu);
    Ts("YuvToRgbRow", Jo, 3), Ts("YuvToBgrRow", ac, 3), Ts("YuvToRgbaRow", lu, 4), Ts("YuvToBgraRow", Al, 4), Ts("YuvToArgbRow", Zo, 4), Ts("YuvToRgba4444Row", pn, 2), Ts("YuvToRgb565Row", oc, 2);
    var j2 = [0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388, 392, 396], Qf = [0, 2, 8], VT = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1], GT = 1;
    this.WebPDecodeRGBA = function(f, g, v, b, H) {
      var _ = mf, R = new aA(), K = new ue();
      R.ba = K, K.S = _, K.width = [K.width], K.height = [K.height];
      var j = K.width, J = K.height, hA = new pe();
      if (hA == null || f == null) var UA = 2;
      else A(hA != null), UA = gf(f, g, v, hA.width, hA.height, hA.Pd, hA.Qd, hA.format, null);
      if (UA != 0 ? j = 0 : (j != null && (j[0] = hA.width[0]), J != null && (J[0] = hA.height[0]), j = 1), j) {
        K.width = K.width[0], K.height = K.height[0], b != null && (b[0] = K.width), H != null && (H[0] = K.height);
        A: {
          if (b = new Ss(), (H = new mA()).data = f, H.w = g, H.ha = v, H.kd = 1, g = [0], A(H != null), ((f = gf(H.data, H.w, H.ha, null, null, null, g, null, H)) == 0 || f == 7) && g[0] && (f = 4), (g = f) == 0) {
            if (A(R != null), b.data = H.data, b.w = H.w + H.offset, b.ha = H.ha - H.offset, b.put = Be, b.ac = un, b.bc = Jr, b.ma = R, H.xa) {
              if ((f = je()) == null) {
                R = 1;
                break A;
              }
              if ((function(Z, BA) {
                var bA = [0], NA = [0], QA = [0];
                e: for (; ; ) {
                  if (Z == null) return 0;
                  if (BA == null) return Z.a = 2, 0;
                  if (Z.l = BA, Z.a = 0, cA(Z.m, BA.data, BA.w, BA.ha), !Zt(Z.m, bA, NA, QA)) {
                    Z.a = 3;
                    break e;
                  }
                  if (Z.xb = P2, BA.width = bA[0], BA.height = NA[0], !Nt(bA[0], NA[0], 1, Z, null)) break e;
                  return 1;
                }
                return A(Z.a != 0), 0;
              })(f, b)) {
                if (b = (g = cu(b.width, b.height, R.Oa, R.ba)) == 0) {
                  e: {
                    b = f;
                    t: for (; ; ) {
                      if (b == null) {
                        b = 0;
                        break e;
                      }
                      if (A(b.s.yc != null), A(b.s.Ya != null), A(0 < b.s.Wb), A((v = b.l) != null), A((H = v.ma) != null), b.xb != 0) {
                        if (b.ca = H.ba, b.tb = H.tb, A(b.ca != null), !_i(H.Oa, v, vf)) {
                          b.a = 2;
                          break t;
                        }
                        if (!Si(b, v.width) || v.da) break t;
                        if ((v.da || ge(b.ca.S)) && qt(), 11 > b.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), b.ca.f.kb.F != null && qt()), b.Pb && 0 < b.s.ua && b.s.vb.X == null && !E(b.s.vb, b.s.Wa.Xa)) {
                          b.a = 1;
                          break t;
                        }
                        b.xb = 0;
                      }
                      if (!Tn(b, b.V, b.Ba, b.c, b.i, v.o, hi)) break t;
                      H.Dc = b.Ma, b = 1;
                      break e;
                    }
                    A(b.a != 0), b = 0;
                  }
                  b = !b;
                }
                b && (g = f.a);
              } else g = f.a;
            } else {
              if ((f = new Va()) == null) {
                R = 1;
                break A;
              }
              if (f.Fa = H.na, f.P = H.P, f.qc = H.Sa, qr(f, b)) {
                if ((g = cu(b.width, b.height, R.Oa, R.ba)) == 0) {
                  if (f.Aa = 0, v = R.Oa, A((H = f) != null), v != null) {
                    if (0 < (j = 0 > (j = v.Md) ? 0 : 100 < j ? 255 : 255 * j / 100)) {
                      for (J = hA = 0; 4 > J; ++J) 12 > (UA = H.pb[J]).lc && (UA.ia = j * VT[0 > UA.lc ? 0 : UA.lc] >> 3), hA |= UA.ia;
                      hA && (alert("todo:VP8InitRandom"), H.ia = 1);
                    }
                    H.Ga = v.Id, 100 < H.Ga ? H.Ga = 100 : 0 > H.Ga && (H.Ga = 0);
                  }
                  (function(Z, BA) {
                    if (Z == null) return 0;
                    if (BA == null) return St(Z, 2, "NULL VP8Io parameter in VP8Decode().");
                    if (!Z.cb && !qr(Z, BA)) return 0;
                    if (A(Z.cb), BA.ac == null || BA.ac(BA)) {
                      BA.ob && (Z.L = 0);
                      var bA = Qf[Z.L];
                      if (Z.L == 2 ? (Z.yb = 0, Z.zb = 0) : (Z.yb = BA.v - bA >> 4, Z.zb = BA.j - bA >> 4, 0 > Z.yb && (Z.yb = 0), 0 > Z.zb && (Z.zb = 0)), Z.Va = BA.o + 15 + bA >> 4, Z.Hb = BA.va + 15 + bA >> 4, Z.Hb > Z.za && (Z.Hb = Z.za), Z.Va > Z.Ub && (Z.Va = Z.Ub), 0 < Z.L) {
                        var NA = Z.ed;
                        for (bA = 0; 4 > bA; ++bA) {
                          var QA;
                          if (Z.Qa.Cb) {
                            var DA = Z.Qa.Lb[bA];
                            Z.Qa.Fb || (DA += NA.Tb);
                          } else DA = NA.Tb;
                          for (QA = 0; 1 >= QA; ++QA) {
                            var RA = Z.gd[bA][QA], YA = DA;
                            if (NA.Pc && (YA += NA.vd[0], QA && (YA += NA.od[0])), 0 < (YA = 0 > YA ? 0 : 63 < YA ? 63 : YA)) {
                              var qA = YA;
                              0 < NA.wb && (qA = 4 < NA.wb ? qA >> 2 : qA >> 1) > 9 - NA.wb && (qA = 9 - NA.wb), 1 > qA && (qA = 1), RA.dd = qA, RA.tc = 2 * YA + qA, RA.ld = 40 <= YA ? 2 : 15 <= YA ? 1 : 0;
                            } else RA.tc = 0;
                            RA.La = QA;
                          }
                        }
                      }
                      bA = 0;
                    } else St(Z, 6, "Frame setup failed"), bA = Z.a;
                    if (bA = bA == 0) {
                      if (bA) {
                        Z.$c = 0, 0 < Z.Aa || (Z.Ic = GT);
                        e: {
                          bA = Z.Ic, NA = 4 * (qA = Z.za);
                          var ve = 32 * qA, oe = qA + 1, Ve = 0 < Z.L ? qA * (0 < Z.Aa ? 2 : 1) : 0, fe = (Z.Aa == 2 ? 2 : 1) * qA;
                          if ((RA = NA + 832 + (QA = 3 * (16 * bA + Qf[Z.L]) / 2 * ve) + (DA = Z.Fa != null && 0 < Z.Fa.length ? Z.Kc.c * Z.Kc.i : 0)) != RA) bA = 0;
                          else {
                            if (RA > Z.Vb) {
                              if (Z.Vb = 0, Z.Ec = i(RA), Z.Fc = 0, Z.Ec == null) {
                                bA = St(Z, 1, "no memory during frame initialization.");
                                break e;
                              }
                              Z.Vb = RA;
                            }
                            RA = Z.Ec, YA = Z.Fc, Z.Ac = RA, Z.Bc = YA, YA += NA, Z.Gd = s(ve, Ka), Z.Hd = 0, Z.rb = s(oe + 1, st), Z.sb = 1, Z.wa = Ve ? s(Ve, _n) : null, Z.Y = 0, Z.D.Nb = 0, Z.D.wa = Z.wa, Z.D.Y = Z.Y, 0 < Z.Aa && (Z.D.Y += qA), A(!0), Z.oc = RA, Z.pc = YA, YA += 832, Z.ya = s(fe, On), Z.aa = 0, Z.D.ya = Z.ya, Z.D.aa = Z.aa, Z.Aa == 2 && (Z.D.aa += qA), Z.R = 16 * qA, Z.B = 8 * qA, qA = (ve = Qf[Z.L]) * Z.R, ve = ve / 2 * Z.B, Z.sa = RA, Z.ta = YA + qA, Z.qa = Z.sa, Z.ra = Z.ta + 16 * bA * Z.R + ve, Z.Ha = Z.qa, Z.Ia = Z.ra + 8 * bA * Z.B + ve, Z.$c = 0, YA += QA, Z.mb = DA ? RA : null, Z.nb = DA ? YA : null, A(YA + DA <= Z.Fc + Z.Vb), Dn(Z), n(Z.Ac, Z.Bc, 0, NA), bA = 1;
                          }
                        }
                        if (bA) {
                          if (BA.ka = 0, BA.y = Z.sa, BA.O = Z.ta, BA.f = Z.qa, BA.N = Z.ra, BA.ea = Z.Ha, BA.Vd = Z.Ia, BA.fa = Z.R, BA.Rc = Z.B, BA.F = null, BA.J = 0, !O2) {
                            for (bA = -255; 255 >= bA; ++bA) L2[255 + bA] = 0 > bA ? -bA : bA;
                            for (bA = -1020; 1020 >= bA; ++bA) H2[1020 + bA] = -128 > bA ? -128 : 127 < bA ? 127 : bA;
                            for (bA = -112; 112 >= bA; ++bA) T2[112 + bA] = -16 > bA ? -16 : 15 < bA ? 15 : bA;
                            for (bA = -255; 510 >= bA; ++bA) _2[255 + bA] = 0 > bA ? 0 : 255 < bA ? 255 : bA;
                            O2 = 1;
                          }
                          eo = Hi, la = Wa, dc = ja, Bn = qa, Os = Mn, to = Ga, Qt = Ue, Ut = KA, fr = Dt, Or = w, ca = Ne, du = Wt, gc = L, pf = z, F2 = aa, Q2 = G, U2 = O, E2 = LA, os[0] = ot, os[1] = An, os[2] = Qe, os[3] = Je, os[4] = rr, os[5] = kn, os[6] = Fr, os[7] = et, os[8] = $a, os[9] = Ls, ro[0] = $, ro[1] = _r, ro[2] = dn, ro[3] = Pn, ro[4] = wA, ro[5] = PA, ro[6] = Ae, ua[0] = ff, ua[1] = fn, ua[2] = na, ua[3] = za, ua[4] = Xa, ua[5] = ia, ua[6] = $o, bA = 1;
                        } else bA = 0;
                      }
                      bA && (bA = (function(Xe, Nr) {
                        for (Xe.M = 0; Xe.M < Xe.Va; ++Xe.M) {
                          var Ge, de = Xe.Jc[Xe.M & Xe.Xb], te = Xe.m, dr = Xe;
                          for (Ge = 0; Ge < dr.za; ++Ge) {
                            var Pe = te, At = dr, Tt = At.Ac, en = At.Bc + 4 * Ge, Gn = At.zc, nr = At.ya[At.aa + Ge];
                            if (At.Qa.Bb ? nr.$b = pA(Pe, At.Pa.jb[0]) ? 2 + pA(Pe, At.Pa.jb[2]) : pA(Pe, At.Pa.jb[1]) : nr.$b = 0, At.kc && (nr.Ad = pA(Pe, At.Bd)), nr.Za = !pA(Pe, 145) + 0, nr.Za) {
                              var wn = nr.Ob, Wn = 0;
                              for (At = 0; 4 > At; ++At) {
                                var Dr, tt = Gn[0 + At];
                                for (Dr = 0; 4 > Dr; ++Dr) {
                                  tt = IT[Tt[en + Dr]][tt];
                                  for (var gt = M2[pA(Pe, tt[0])]; 0 < gt; ) gt = M2[2 * gt + pA(Pe, tt[gt])];
                                  tt = -gt, Tt[en + Dr] = tt;
                                }
                                r(wn, Wn, Tt, en, 4), Wn += 4, Gn[0 + At] = tt;
                              }
                            } else tt = pA(Pe, 156) ? pA(Pe, 128) ? 1 : 3 : pA(Pe, 163) ? 2 : 0, nr.Ob[0] = tt, n(Tt, en, tt, 4), n(Gn, 0, tt, 4);
                            nr.Dd = pA(Pe, 142) ? pA(Pe, 114) ? pA(Pe, 183) ? 1 : 3 : 2 : 0;
                          }
                          if (dr.m.Ka) return St(Xe, 7, "Premature end-of-partition0 encountered.");
                          for (; Xe.ja < Xe.za; ++Xe.ja) {
                            if (dr = de, Pe = (te = Xe).rb[te.sb - 1], Tt = te.rb[te.sb + te.ja], Ge = te.ya[te.aa + te.ja], en = te.kc ? Ge.Ad : 0) Pe.la = Tt.la = 0, Ge.Za || (Pe.Na = Tt.Na = 0), Ge.Hc = 0, Ge.Gc = 0, Ge.ia = 0;
                            else {
                              var ir, pt;
                              if (Pe = Tt, Tt = dr, en = te.Pa.Xc, Gn = te.ya[te.aa + te.ja], nr = te.pb[Gn.$b], At = Gn.ad, wn = 0, Wn = te.rb[te.sb - 1], tt = Dr = 0, n(At, wn, 0, 384), Gn.Za) var tn = 0, ls = en[3];
                              else {
                                gt = i(16);
                                var gr = Pe.Na + Wn.Na;
                                if (gr = pu(Tt, en[1], gr, nr.Eb, 0, gt, 0), Pe.Na = Wn.Na = (0 < gr) + 0, 1 < gr) eo(gt, 0, At, wn);
                                else {
                                  var ti = gt[0] + 3 >> 3;
                                  for (gt = 0; 256 > gt; gt += 16) At[wn + gt] = ti;
                                }
                                tn = 1, ls = en[0];
                              }
                              var yt = 15 & Pe.la, Rr = 15 & Wn.la;
                              for (gt = 0; 4 > gt; ++gt) {
                                var gi = 1 & Rr;
                                for (ti = pt = 0; 4 > ti; ++ti) yt = yt >> 1 | (gi = (gr = pu(Tt, ls, gr = gi + (1 & yt), nr.Sc, tn, At, wn)) > tn) << 7, pt = pt << 2 | (3 < gr ? 3 : 1 < gr ? 2 : At[wn + 0] != 0), wn += 16;
                                yt >>= 4, Rr = Rr >> 1 | gi << 7, Dr = (Dr << 8 | pt) >>> 0;
                              }
                              for (ls = yt, tn = Rr >> 4, ir = 0; 4 > ir; ir += 2) {
                                for (pt = 0, yt = Pe.la >> 4 + ir, Rr = Wn.la >> 4 + ir, gt = 0; 2 > gt; ++gt) {
                                  for (gi = 1 & Rr, ti = 0; 2 > ti; ++ti) gr = gi + (1 & yt), yt = yt >> 1 | (gi = 0 < (gr = pu(Tt, en[2], gr, nr.Qc, 0, At, wn))) << 3, pt = pt << 2 | (3 < gr ? 3 : 1 < gr ? 2 : At[wn + 0] != 0), wn += 16;
                                  yt >>= 2, Rr = Rr >> 1 | gi << 5;
                                }
                                tt |= pt << 4 * ir, ls |= yt << 4 << ir, tn |= (240 & Rr) << ir;
                              }
                              Pe.la = ls, Wn.la = tn, Gn.Hc = Dr, Gn.Gc = tt, Gn.ia = 43690 & tt ? 0 : nr.ia, en = !(Dr | tt);
                            }
                            if (0 < te.L && (te.wa[te.Y + te.ja] = te.gd[Ge.$b][Ge.Za], te.wa[te.Y + te.ja].La |= !en), dr.Ka) return St(Xe, 7, "Premature end-of-file encountered.");
                          }
                          if (Dn(Xe), te = Nr, dr = 1, Ge = (de = Xe).D, Pe = 0 < de.L && de.M >= de.zb && de.M <= de.Va, de.Aa == 0) e: {
                            if (Ge.M = de.M, Ge.uc = Pe, lc(de, Ge), dr = 1, Ge = (pt = de.D).Nb, Pe = (tt = Qf[de.L]) * de.R, Tt = tt / 2 * de.B, gt = 16 * Ge * de.R, ti = 8 * Ge * de.B, en = de.sa, Gn = de.ta - Pe + gt, nr = de.qa, At = de.ra - Tt + ti, wn = de.Ha, Wn = de.Ia - Tt + ti, Rr = (yt = pt.M) == 0, Dr = yt >= de.Va - 1, de.Aa == 2 && lc(de, pt), pt.uc) for (gi = (gr = de).D.M, A(gr.D.uc), pt = gr.yb; pt < gr.Hb; ++pt) {
                              tn = pt, ls = gi;
                              var jn = (pi = (rn = gr).D).Nb;
                              ir = rn.R;
                              var pi = pi.wa[pi.Y + tn], Bi = rn.sa, ri = rn.ta + 16 * jn * ir + 16 * tn, wi = pi.dd, Et = pi.tc;
                              if (Et != 0) if (A(3 <= Et), rn.L == 1) 0 < tn && Q2(Bi, ri, ir, Et + 4), pi.La && E2(Bi, ri, ir, Et), 0 < ls && F2(Bi, ri, ir, Et + 4), pi.La && U2(Bi, ri, ir, Et);
                              else {
                                var mi = rn.B, cs = rn.qa, al = rn.ra + 8 * jn * mi + 8 * tn, ha = rn.Ha, rn = rn.Ia + 8 * jn * mi + 8 * tn;
                                jn = pi.ld, 0 < tn && (Ut(Bi, ri, ir, Et + 4, wi, jn), Or(cs, al, ha, rn, mi, Et + 4, wi, jn)), pi.La && (du(Bi, ri, ir, Et, wi, jn), pf(cs, al, ha, rn, mi, Et, wi, jn)), 0 < ls && (Qt(Bi, ri, ir, Et + 4, wi, jn), fr(cs, al, ha, rn, mi, Et + 4, wi, jn)), pi.La && (ca(Bi, ri, ir, Et, wi, jn), gc(cs, al, ha, rn, mi, Et, wi, jn));
                              }
                            }
                            if (de.ia && alert("todo:DitherRow"), te.put != null) {
                              if (pt = 16 * yt, yt = 16 * (yt + 1), Rr ? (te.y = de.sa, te.O = de.ta + gt, te.f = de.qa, te.N = de.ra + ti, te.ea = de.Ha, te.W = de.Ia + ti) : (pt -= tt, te.y = en, te.O = Gn, te.f = nr, te.N = At, te.ea = wn, te.W = Wn), Dr || (yt -= tt), yt > te.o && (yt = te.o), te.F = null, te.J = null, de.Fa != null && 0 < de.Fa.length && pt < yt && (te.J = Qr(de, te, pt, yt - pt), te.F = de.mb, te.F == null && te.F.length == 0)) {
                                dr = St(de, 3, "Could not decode alpha data.");
                                break e;
                              }
                              pt < te.j && (tt = te.j - pt, pt = te.j, A(!(1 & tt)), te.O += de.R * tt, te.N += de.B * (tt >> 1), te.W += de.B * (tt >> 1), te.F != null && (te.J += te.width * tt)), pt < yt && (te.O += te.v, te.N += te.v >> 1, te.W += te.v >> 1, te.F != null && (te.J += te.v), te.ka = pt - te.j, te.U = te.va - te.v, te.T = yt - pt, dr = te.put(te));
                            }
                            Ge + 1 != de.Ic || Dr || (r(de.sa, de.ta - Pe, en, Gn + 16 * de.R, Pe), r(de.qa, de.ra - Tt, nr, At + 8 * de.B, Tt), r(de.Ha, de.Ia - Tt, wn, Wn + 8 * de.B, Tt));
                          }
                          if (!dr) return St(Xe, 6, "Output aborted.");
                        }
                        return 1;
                      })(Z, BA)), BA.bc != null && BA.bc(BA), bA &= 1;
                    }
                    return bA ? (Z.cb = 0, bA) : 0;
                  })(f, b) || (g = f.a);
                }
              } else g = f.a;
            }
            g == 0 && R.Oa != null && R.Oa.fd && (g = el(R.ba));
          }
          R = g;
        }
        _ = R != 0 ? null : 11 > _ ? K.f.RGBA.eb : K.f.kb.y;
      } else _ = null;
      return _;
    };
    var q2 = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
  };
  function l(I, q) {
    for (var U = "", x = 0; x < 4; x++) U += String.fromCharCode(I[q++]);
    return U;
  }
  function c(I, q) {
    return I[q + 0] | I[q + 1] << 8;
  }
  function u(I, q) {
    return (I[q + 0] | I[q + 1] << 8 | I[q + 2] << 16) >>> 0;
  }
  function d(I, q) {
    return (I[q + 0] | I[q + 1] << 8 | I[q + 2] << 16 | I[q + 3] << 24) >>> 0;
  }
  new o();
  var h = [0], p = [0], B = [], y = new o(), m = e, C = (function(I, q) {
    var U = {}, x = 0, P = !1, N = 0, iA = 0;
    if (U.frames = [], !/** @license
       * Copyright (c) 2017 Dominik Homberger
      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      https://webpjs.appspot.com
      WebPRiffParser dominikhlbg@gmail.com
      */
    (function(S, W) {
      for (var Y = 0; Y < 4; Y++) if (S[W + Y] != "RIFF".charCodeAt(Y)) return !0;
      return !1;
    })(I, q)) {
      for (d(I, q += 4), q += 8; q < I.length; ) {
        var nA = l(I, q), sA = d(I, q += 4);
        q += 4;
        var tA = sA + (1 & sA);
        switch (nA) {
          case "VP8 ":
          case "VP8L":
            U.frames[x] === void 0 && (U.frames[x] = {}), (CA = U.frames[x]).src_off = P ? iA : q - 8, CA.src_size = N + sA + 8, x++, P && (P = !1, N = 0, iA = 0);
            break;
          case "VP8X":
            (CA = U.header = {}).feature_flags = I[q];
            var cA = q + 4;
            CA.canvas_width = 1 + u(I, cA), cA += 3, CA.canvas_height = 1 + u(I, cA), cA += 3;
            break;
          case "ALPH":
            P = !0, N = tA + 8, iA = q - 8;
            break;
          case "ANIM":
            (CA = U.header).bgcolor = d(I, q), cA = q + 4, CA.loop_count = c(I, cA), cA += 2;
            break;
          case "ANMF":
            var FA, CA;
            (CA = U.frames[x] = {}).offset_x = 2 * u(I, q), q += 3, CA.offset_y = 2 * u(I, q), q += 3, CA.width = 1 + u(I, q), q += 3, CA.height = 1 + u(I, q), q += 3, CA.duration = u(I, q), q += 3, FA = I[q++], CA.dispose = 1 & FA, CA.blend = FA >> 1 & 1;
        }
        nA != "ANMF" && (q += tA);
      }
      return U;
    }
  })(m, 0);
  C.response = m, C.rgbaoutput = !0, C.dataurl = !1;
  var Q = C.header ? C.header : null, F = C.frames ? C.frames : null;
  if (Q) {
    Q.loop_counter = Q.loop_count, h = [Q.canvas_height], p = [Q.canvas_width];
    for (var T = 0; T < F.length && F[T].blend != 0; T++) ;
  }
  var V = F[0], M = y.WebPDecodeRGBA(m, V.src_off, V.src_size, p, h);
  V.rgba = M, V.imgwidth = p[0], V.imgheight = h[0];
  for (var D = 0; D < p[0] * h[0] * 4; D++) B[D] = M[D];
  return this.width = p, this.height = h, this.data = B, this;
}
function zW() {
  var e, A = this.internal.__metadata__.metadata, t = unescape(encodeURIComponent(A));
  e = this.internal.__metadata__.rawXml ? t : '<x:xmpmeta xmlns:x="adobe:ns:meta/"><rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceUri + '"><jspdf:metadata>' + t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;") + "</jspdf:metadata></rdf:Description></rdf:RDF></x:xmpmeta>", this.internal.__metadata__.metadataObjectNumber = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + e.length + " >>"), this.internal.write("stream"), this.internal.write(e), this.internal.write("endstream"), this.internal.write("endobj");
}
function XW() {
  this.internal.__metadata__.metadataObjectNumber && this.internal.write("/Metadata " + this.internal.__metadata__.metadataObjectNumber + " 0 R");
}
(function(e) {
  var A, t, r, n, i, s, a, o, l, c = function(S) {
    return S = S || {}, this.isStrokeTransparent = S.isStrokeTransparent || !1, this.strokeOpacity = S.strokeOpacity || 1, this.strokeStyle = S.strokeStyle || "#000000", this.fillStyle = S.fillStyle || "#000000", this.isFillTransparent = S.isFillTransparent || !1, this.fillOpacity = S.fillOpacity || 1, this.font = S.font || "10px sans-serif", this.textBaseline = S.textBaseline || "alphabetic", this.textAlign = S.textAlign || "left", this.lineWidth = S.lineWidth || 1, this.lineJoin = S.lineJoin || "miter", this.lineCap = S.lineCap || "butt", this.path = S.path || [], this.transform = S.transform !== void 0 ? S.transform.clone() : new o(), this.globalCompositeOperation = S.globalCompositeOperation || "normal", this.globalAlpha = S.globalAlpha || 1, this.clip_path = S.clip_path || [], this.currentPoint = S.currentPoint || new s(), this.miterLimit = S.miterLimit || 10, this.lastPoint = S.lastPoint || new s(), this.lineDashOffset = S.lineDashOffset || 0, this.lineDash = S.lineDash || [], this.margin = S.margin || [0, 0, 0, 0], this.prevPageLastElemOffset = S.prevPageLastElemOffset || 0, this.ignoreClearRect = typeof S.ignoreClearRect != "boolean" || S.ignoreClearRect, this;
  };
  e.events.push(["initialized", function() {
    this.context2d = new u(this), A = this.internal.f2, t = this.internal.getCoordinateString, r = this.internal.getVerticalCoordinateString, n = this.internal.getHorizontalCoordinate, i = this.internal.getVerticalCoordinate, s = this.internal.Point, a = this.internal.Rectangle, o = this.internal.Matrix, l = new c();
  }]);
  var u = function(S) {
    Object.defineProperty(this, "canvas", { get: function() {
      return { parentNode: !1, style: !1 };
    } });
    var W = S;
    Object.defineProperty(this, "pdf", { get: function() {
      return W;
    } });
    var Y = !1;
    Object.defineProperty(this, "pageWrapXEnabled", { get: function() {
      return Y;
    }, set: function(E) {
      Y = !!E;
    } });
    var AA = !1;
    Object.defineProperty(this, "pageWrapYEnabled", { get: function() {
      return AA;
    }, set: function(E) {
      AA = !!E;
    } });
    var oA = 0;
    Object.defineProperty(this, "posX", { get: function() {
      return oA;
    }, set: function(E) {
      isNaN(E) || (oA = E);
    } });
    var gA = 0;
    Object.defineProperty(this, "posY", { get: function() {
      return gA;
    }, set: function(E) {
      isNaN(E) || (gA = E);
    } }), Object.defineProperty(this, "margin", { get: function() {
      return l.margin;
    }, set: function(E) {
      var dA;
      typeof E == "number" ? dA = [E, E, E, E] : ((dA = new Array(4))[0] = E[0], dA[1] = E.length >= 2 ? E[1] : dA[0], dA[2] = E.length >= 3 ? E[2] : dA[0], dA[3] = E.length >= 4 ? E[3] : dA[1]), l.margin = dA;
    } });
    var xA = !1;
    Object.defineProperty(this, "autoPaging", { get: function() {
      return xA;
    }, set: function(E) {
      xA = E;
    } });
    var IA = 0;
    Object.defineProperty(this, "lastBreak", { get: function() {
      return IA;
    }, set: function(E) {
      IA = E;
    } });
    var pA = [];
    Object.defineProperty(this, "pageBreaks", { get: function() {
      return pA;
    }, set: function(E) {
      pA = E;
    } }), Object.defineProperty(this, "ctx", { get: function() {
      return l;
    }, set: function(E) {
      E instanceof c && (l = E);
    } }), Object.defineProperty(this, "path", { get: function() {
      return l.path;
    }, set: function(E) {
      l.path = E;
    } });
    var WA = [];
    Object.defineProperty(this, "ctxStack", { get: function() {
      return WA;
    }, set: function(E) {
      WA = E;
    } }), Object.defineProperty(this, "fillStyle", { get: function() {
      return this.ctx.fillStyle;
    }, set: function(E) {
      var dA;
      dA = d(E), this.ctx.fillStyle = dA.style, this.ctx.isFillTransparent = dA.a === 0, this.ctx.fillOpacity = dA.a, this.pdf.setFillColor(dA.r, dA.g, dA.b, { a: dA.a }), this.pdf.setTextColor(dA.r, dA.g, dA.b, { a: dA.a });
    } }), Object.defineProperty(this, "strokeStyle", { get: function() {
      return this.ctx.strokeStyle;
    }, set: function(E) {
      var dA = d(E);
      this.ctx.strokeStyle = dA.style, this.ctx.isStrokeTransparent = dA.a === 0, this.ctx.strokeOpacity = dA.a, dA.a === 0 ? this.pdf.setDrawColor(255, 255, 255) : (dA.a, this.pdf.setDrawColor(dA.r, dA.g, dA.b));
    } }), Object.defineProperty(this, "lineCap", { get: function() {
      return this.ctx.lineCap;
    }, set: function(E) {
      ["butt", "round", "square"].indexOf(E) !== -1 && (this.ctx.lineCap = E, this.pdf.setLineCap(E));
    } }), Object.defineProperty(this, "lineWidth", { get: function() {
      return this.ctx.lineWidth;
    }, set: function(E) {
      isNaN(E) || (this.ctx.lineWidth = E, this.pdf.setLineWidth(E));
    } }), Object.defineProperty(this, "lineJoin", { get: function() {
      return this.ctx.lineJoin;
    }, set: function(E) {
      ["bevel", "round", "miter"].indexOf(E) !== -1 && (this.ctx.lineJoin = E, this.pdf.setLineJoin(E));
    } }), Object.defineProperty(this, "miterLimit", { get: function() {
      return this.ctx.miterLimit;
    }, set: function(E) {
      isNaN(E) || (this.ctx.miterLimit = E, this.pdf.setMiterLimit(E));
    } }), Object.defineProperty(this, "textBaseline", { get: function() {
      return this.ctx.textBaseline;
    }, set: function(E) {
      this.ctx.textBaseline = E;
    } }), Object.defineProperty(this, "textAlign", { get: function() {
      return this.ctx.textAlign;
    }, set: function(E) {
      ["right", "end", "center", "left", "start"].indexOf(E) !== -1 && (this.ctx.textAlign = E);
    } });
    var k = null, X = null, uA = null;
    Object.defineProperty(this, "fontFaces", { get: function() {
      return uA;
    }, set: function(E) {
      k = null, X = null, uA = E;
    } }), Object.defineProperty(this, "font", { get: function() {
      return this.ctx.font;
    }, set: function(E) {
      var dA;
      if (this.ctx.font = E, (dA = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z0-9]+?)\s*$/i.exec(E)) !== null) {
        var vA = dA[1];
        dA[2];
        var rA = dA[3], fA = dA[4];
        dA[5];
        var EA = dA[6], lA = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(fA)[2];
        fA = Math.floor(lA === "px" ? parseFloat(fA) * this.pdf.internal.scaleFactor : lA === "em" ? parseFloat(fA) * this.pdf.getFontSize() : parseFloat(fA) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(fA);
        var HA = (function(ZA) {
          var Fe, me, Ce = [], ae = ZA.trim();
          if (ae === "") return cw;
          if (ae in iQ) return [iQ[ae]];
          for (; ae !== ""; ) {
            switch (me = null, Fe = (ae = aQ(ae)).charAt(0)) {
              case '"':
              case "'":
                me = VW(ae.substring(1), Fe);
                break;
              default:
                me = GW(ae);
            }
            if (me === null || (Ce.push(me[0]), (ae = aQ(me[1])) !== "" && ae.charAt(0) !== ",")) return cw;
            ae = ae.replace(/^,/, "");
          }
          return Ce;
        })(EA);
        if (this.fontFaces) {
          var SA = (function(ZA, Fe) {
            var me = ZA.getFontList(), Ce = JSON.stringify(me);
            if (k === null || X !== Ce) {
              var ae = (function(Te) {
                var ie = [];
                return Object.keys(Te).forEach(function(Ke) {
                  Te[Ke].forEach(function(ge) {
                    var xe = null;
                    switch (ge) {
                      case "bold":
                        xe = { family: Ke, weight: "bold" };
                        break;
                      case "italic":
                        xe = { family: Ke, style: "italic" };
                        break;
                      case "bolditalic":
                        xe = { family: Ke, weight: "bold", style: "italic" };
                        break;
                      case "":
                      case "normal":
                        xe = { family: Ke };
                    }
                    xe !== null && (xe.ref = { name: Ke, style: ge }, ie.push(xe));
                  });
                }), ie;
              })(me);
              k = (function(Te) {
                for (var ie = {}, Ke = 0; Ke < Te.length; ++Ke) {
                  var ge = lw(Te[Ke]), xe = ge.family, Ye = ge.stretch, ue = ge.style, pe = ge.weight;
                  ie[xe] = ie[xe] || {}, ie[xe][Ye] = ie[xe][Ye] || {}, ie[xe][Ye][ue] = ie[xe][Ye][ue] || {}, ie[xe][Ye][ue][pe] = ge;
                }
                return ie;
              })(ae.concat(Fe)), X = Ce;
            }
            return k;
          })(this.pdf, this.fontFaces), yA = HA.map(function(ZA) {
            return { family: ZA, stretch: "normal", weight: rA, style: vA };
          }), TA = (function(ZA, Fe, me) {
            for (var Ce = (me = me || {}).defaultFontFamily || "times", ae = Object.assign({}, KW, me.genericFontFamilies || {}), Te = null, ie = null, Ke = 0; Ke < Fe.length; ++Ke) if (ae[(Te = lw(Fe[Ke])).family] && (Te.family = ae[Te.family]), ZA.hasOwnProperty(Te.family)) {
              ie = ZA[Te.family];
              break;
            }
            if (!(ie = ie || ZA[Ce])) throw new Error("Could not find a font-family for the rule '" + sQ(Te) + "' and default family '" + Ce + "'.");
            if (ie = (function(ge, xe) {
              if (xe[ge]) return xe[ge];
              var Ye = Qv[ge], ue = Ye <= Qv.normal ? -1 : 1, pe = nQ(xe, N3, Ye, ue);
              if (!pe) throw new Error("Could not find a matching font-stretch value for " + ge);
              return pe;
            })(Te.stretch, ie), ie = (function(ge, xe) {
              if (xe[ge]) return xe[ge];
              for (var Ye = O3[ge], ue = 0; ue < Ye.length; ++ue) if (xe[Ye[ue]]) return xe[Ye[ue]];
              throw new Error("Could not find a matching font-style for " + ge);
            })(Te.style, ie), !(ie = (function(ge, xe) {
              if (xe[ge]) return xe[ge];
              if (ge === 400 && xe[500]) return xe[500];
              if (ge === 500 && xe[400]) return xe[400];
              var Ye = kW[ge], ue = nQ(xe, D3, Ye, ge < 400 ? -1 : 1);
              if (!ue) throw new Error("Could not find a matching font-weight for value " + ge);
              return ue;
            })(Te.weight, ie))) throw new Error("Failed to resolve a font for the rule '" + sQ(Te) + "'.");
            return ie;
          })(SA, yA);
          this.pdf.setFont(TA.ref.name, TA.ref.style);
        } else {
          var _A = "";
          (rA === "bold" || parseInt(rA, 10) >= 700 || vA === "bold") && (_A = "bold"), vA === "italic" && (_A += "italic"), _A.length === 0 && (_A = "normal");
          for (var MA = "", VA = { arial: "Helvetica", Arial: "Helvetica", verdana: "Helvetica", Verdana: "Helvetica", helvetica: "Helvetica", Helvetica: "Helvetica", "sans-serif": "Helvetica", fixed: "Courier", monospace: "Courier", terminal: "Courier", cursive: "Times", fantasy: "Times", serif: "Times" }, $A = 0; $A < HA.length; $A++) {
            if (this.pdf.internal.getFont(HA[$A], _A, { noFallback: !0, disableWarning: !0 }) !== void 0) {
              MA = HA[$A];
              break;
            }
            if (_A === "bolditalic" && this.pdf.internal.getFont(HA[$A], "bold", { noFallback: !0, disableWarning: !0 }) !== void 0) MA = HA[$A], _A = "bold";
            else if (this.pdf.internal.getFont(HA[$A], "normal", { noFallback: !0, disableWarning: !0 }) !== void 0) {
              MA = HA[$A], _A = "normal";
              break;
            }
          }
          if (MA === "") {
            for (var ee = 0; ee < HA.length; ee++) if (VA[HA[ee]]) {
              MA = VA[HA[ee]];
              break;
            }
          }
          MA = MA === "" ? "Times" : MA, this.pdf.setFont(MA, _A);
        }
      }
    } }), Object.defineProperty(this, "globalCompositeOperation", { get: function() {
      return this.ctx.globalCompositeOperation;
    }, set: function(E) {
      this.ctx.globalCompositeOperation = E;
    } }), Object.defineProperty(this, "globalAlpha", { get: function() {
      return this.ctx.globalAlpha;
    }, set: function(E) {
      this.ctx.globalAlpha = E;
    } }), Object.defineProperty(this, "lineDashOffset", { get: function() {
      return this.ctx.lineDashOffset;
    }, set: function(E) {
      this.ctx.lineDashOffset = E, CA.call(this);
    } }), Object.defineProperty(this, "lineDash", { get: function() {
      return this.ctx.lineDash;
    }, set: function(E) {
      this.ctx.lineDash = E, CA.call(this);
    } }), Object.defineProperty(this, "ignoreClearRect", { get: function() {
      return this.ctx.ignoreClearRect;
    }, set: function(E) {
      this.ctx.ignoreClearRect = !!E;
    } });
  };
  u.prototype.setLineDash = function(S) {
    this.lineDash = S;
  }, u.prototype.getLineDash = function() {
    return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
  }, u.prototype.fill = function() {
    F.call(this, "fill", !1);
  }, u.prototype.stroke = function() {
    F.call(this, "stroke", !1);
  }, u.prototype.beginPath = function() {
    this.path = [{ type: "begin" }];
  }, u.prototype.moveTo = function(S, W) {
    if (isNaN(S) || isNaN(W)) throw Ct.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
    var Y = this.ctx.transform.applyToPoint(new s(S, W));
    this.path.push({ type: "mt", x: Y.x, y: Y.y }), this.ctx.lastPoint = new s(S, W);
  }, u.prototype.closePath = function() {
    var S = new s(0, 0), W = 0;
    for (W = this.path.length - 1; W !== -1; W--) if (this.path[W].type === "begin" && it(this.path[W + 1]) === "object" && typeof this.path[W + 1].x == "number") {
      S = new s(this.path[W + 1].x, this.path[W + 1].y);
      break;
    }
    this.path.push({ type: "close" }), this.ctx.lastPoint = new s(S.x, S.y);
  }, u.prototype.lineTo = function(S, W) {
    if (isNaN(S) || isNaN(W)) throw Ct.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
    var Y = this.ctx.transform.applyToPoint(new s(S, W));
    this.path.push({ type: "lt", x: Y.x, y: Y.y }), this.ctx.lastPoint = new s(Y.x, Y.y);
  }, u.prototype.clip = function() {
    this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), F.call(this, null, !0);
  }, u.prototype.quadraticCurveTo = function(S, W, Y, AA) {
    if (isNaN(Y) || isNaN(AA) || isNaN(S) || isNaN(W)) throw Ct.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
    var oA = this.ctx.transform.applyToPoint(new s(Y, AA)), gA = this.ctx.transform.applyToPoint(new s(S, W));
    this.path.push({ type: "qct", x1: gA.x, y1: gA.y, x: oA.x, y: oA.y }), this.ctx.lastPoint = new s(oA.x, oA.y);
  }, u.prototype.bezierCurveTo = function(S, W, Y, AA, oA, gA) {
    if (isNaN(oA) || isNaN(gA) || isNaN(S) || isNaN(W) || isNaN(Y) || isNaN(AA)) throw Ct.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
    var xA = this.ctx.transform.applyToPoint(new s(oA, gA)), IA = this.ctx.transform.applyToPoint(new s(S, W)), pA = this.ctx.transform.applyToPoint(new s(Y, AA));
    this.path.push({ type: "bct", x1: IA.x, y1: IA.y, x2: pA.x, y2: pA.y, x: xA.x, y: xA.y }), this.ctx.lastPoint = new s(xA.x, xA.y);
  }, u.prototype.arc = function(S, W, Y, AA, oA, gA) {
    if (isNaN(S) || isNaN(W) || isNaN(Y) || isNaN(AA) || isNaN(oA)) throw Ct.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
    if (gA = !!gA, !this.ctx.transform.isIdentity) {
      var xA = this.ctx.transform.applyToPoint(new s(S, W));
      S = xA.x, W = xA.y;
      var IA = this.ctx.transform.applyToPoint(new s(0, Y)), pA = this.ctx.transform.applyToPoint(new s(0, 0));
      Y = Math.sqrt(Math.pow(IA.x - pA.x, 2) + Math.pow(IA.y - pA.y, 2));
    }
    Math.abs(oA - AA) >= 2 * Math.PI && (AA = 0, oA = 2 * Math.PI), this.path.push({ type: "arc", x: S, y: W, radius: Y, startAngle: AA, endAngle: oA, counterclockwise: gA });
  }, u.prototype.arcTo = function(S, W, Y, AA, oA) {
    throw new Error("arcTo not implemented.");
  }, u.prototype.rect = function(S, W, Y, AA) {
    if (isNaN(S) || isNaN(W) || isNaN(Y) || isNaN(AA)) throw Ct.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
    this.moveTo(S, W), this.lineTo(S + Y, W), this.lineTo(S + Y, W + AA), this.lineTo(S, W + AA), this.lineTo(S, W), this.lineTo(S + Y, W), this.lineTo(S, W);
  }, u.prototype.fillRect = function(S, W, Y, AA) {
    if (isNaN(S) || isNaN(W) || isNaN(Y) || isNaN(AA)) throw Ct.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
    if (!h.call(this)) {
      var oA = {};
      this.lineCap !== "butt" && (oA.lineCap = this.lineCap, this.lineCap = "butt"), this.lineJoin !== "miter" && (oA.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(S, W, Y, AA), this.fill(), oA.hasOwnProperty("lineCap") && (this.lineCap = oA.lineCap), oA.hasOwnProperty("lineJoin") && (this.lineJoin = oA.lineJoin);
    }
  }, u.prototype.strokeRect = function(S, W, Y, AA) {
    if (isNaN(S) || isNaN(W) || isNaN(Y) || isNaN(AA)) throw Ct.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
    p.call(this) || (this.beginPath(), this.rect(S, W, Y, AA), this.stroke());
  }, u.prototype.clearRect = function(S, W, Y, AA) {
    if (isNaN(S) || isNaN(W) || isNaN(Y) || isNaN(AA)) throw Ct.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
    this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(S, W, Y, AA));
  }, u.prototype.save = function(S) {
    S = typeof S != "boolean" || S;
    for (var W = this.pdf.internal.getCurrentPageInfo().pageNumber, Y = 0; Y < this.pdf.internal.getNumberOfPages(); Y++) this.pdf.setPage(Y + 1), this.pdf.internal.out("q");
    if (this.pdf.setPage(W), S) {
      this.ctx.fontSize = this.pdf.internal.getFontSize();
      var AA = new c(this.ctx);
      this.ctxStack.push(this.ctx), this.ctx = AA;
    }
  }, u.prototype.restore = function(S) {
    S = typeof S != "boolean" || S;
    for (var W = this.pdf.internal.getCurrentPageInfo().pageNumber, Y = 0; Y < this.pdf.internal.getNumberOfPages(); Y++) this.pdf.setPage(Y + 1), this.pdf.internal.out("Q");
    this.pdf.setPage(W), S && this.ctxStack.length !== 0 && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
  }, u.prototype.toDataURL = function() {
    throw new Error("toDataUrl not implemented.");
  };
  var d = function(S) {
    var W, Y, AA, oA;
    if (S.isCanvasGradient === !0 && (S = S.getColor()), !S) return { r: 0, g: 0, b: 0, a: 0, style: S };
    if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(S)) W = 0, Y = 0, AA = 0, oA = 0;
    else {
      var gA = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(S);
      if (gA !== null) W = parseInt(gA[1]), Y = parseInt(gA[2]), AA = parseInt(gA[3]), oA = 1;
      else if ((gA = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(S)) !== null) W = parseInt(gA[1]), Y = parseInt(gA[2]), AA = parseInt(gA[3]), oA = parseFloat(gA[4]);
      else {
        if (oA = 1, typeof S == "string" && S.charAt(0) !== "#") {
          var xA = new x3(S);
          S = xA.ok ? xA.toHex() : "#000000";
        }
        S.length === 4 ? (W = S.substring(1, 2), W += W, Y = S.substring(2, 3), Y += Y, AA = S.substring(3, 4), AA += AA) : (W = S.substring(1, 3), Y = S.substring(3, 5), AA = S.substring(5, 7)), W = parseInt(W, 16), Y = parseInt(Y, 16), AA = parseInt(AA, 16);
      }
    }
    return { r: W, g: Y, b: AA, a: oA, style: S };
  }, h = function() {
    return this.ctx.isFillTransparent || this.globalAlpha == 0;
  }, p = function() {
    return !!(this.ctx.isStrokeTransparent || this.globalAlpha == 0);
  };
  u.prototype.fillText = function(S, W, Y, AA) {
    if (isNaN(W) || isNaN(Y) || typeof S != "string") throw Ct.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
    if (AA = isNaN(AA) ? void 0 : AA, !h.call(this)) {
      var oA = tA(this.ctx.transform.rotation), gA = this.ctx.transform.scaleX;
      x.call(this, { text: S, x: W, y: Y, scale: gA, angle: oA, align: this.textAlign, maxWidth: AA });
    }
  }, u.prototype.strokeText = function(S, W, Y, AA) {
    if (isNaN(W) || isNaN(Y) || typeof S != "string") throw Ct.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
    if (!p.call(this)) {
      AA = isNaN(AA) ? void 0 : AA;
      var oA = tA(this.ctx.transform.rotation), gA = this.ctx.transform.scaleX;
      x.call(this, { text: S, x: W, y: Y, scale: gA, renderingMode: "stroke", angle: oA, align: this.textAlign, maxWidth: AA });
    }
  }, u.prototype.measureText = function(S) {
    if (typeof S != "string") throw Ct.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
    var W = this.pdf, Y = this.pdf.internal.scaleFactor, AA = W.internal.getFontSize(), oA = W.getStringUnitWidth(S) * AA / W.internal.scaleFactor;
    return new function(gA) {
      var xA = (gA = gA || {}).width || 0;
      return Object.defineProperty(this, "width", { get: function() {
        return xA;
      } }), this;
    }({ width: oA *= Math.round(96 * Y / 72 * 1e4) / 1e4 });
  }, u.prototype.scale = function(S, W) {
    if (isNaN(S) || isNaN(W)) throw Ct.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
    var Y = new o(S, 0, 0, W, 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(Y);
  }, u.prototype.rotate = function(S) {
    if (isNaN(S)) throw Ct.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
    var W = new o(Math.cos(S), Math.sin(S), -Math.sin(S), Math.cos(S), 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(W);
  }, u.prototype.translate = function(S, W) {
    if (isNaN(S) || isNaN(W)) throw Ct.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
    var Y = new o(1, 0, 0, 1, S, W);
    this.ctx.transform = this.ctx.transform.multiply(Y);
  }, u.prototype.transform = function(S, W, Y, AA, oA, gA) {
    if (isNaN(S) || isNaN(W) || isNaN(Y) || isNaN(AA) || isNaN(oA) || isNaN(gA)) throw Ct.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
    var xA = new o(S, W, Y, AA, oA, gA);
    this.ctx.transform = this.ctx.transform.multiply(xA);
  }, u.prototype.setTransform = function(S, W, Y, AA, oA, gA) {
    S = isNaN(S) ? 1 : S, W = isNaN(W) ? 0 : W, Y = isNaN(Y) ? 0 : Y, AA = isNaN(AA) ? 1 : AA, oA = isNaN(oA) ? 0 : oA, gA = isNaN(gA) ? 0 : gA, this.ctx.transform = new o(S, W, Y, AA, oA, gA);
  };
  var B = function() {
    return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
  };
  u.prototype.drawImage = function(S, W, Y, AA, oA, gA, xA, IA, pA) {
    var WA = this.pdf.getImageProperties(S), k = 1, X = 1, uA = 1, E = 1;
    AA !== void 0 && IA !== void 0 && (uA = IA / AA, E = pA / oA, k = WA.width / AA * IA / AA, X = WA.height / oA * pA / oA), gA === void 0 && (gA = W, xA = Y, W = 0, Y = 0), AA !== void 0 && IA === void 0 && (IA = AA, pA = oA), AA === void 0 && IA === void 0 && (IA = WA.width, pA = WA.height);
    var dA = this.ctx.transform.decompose(), vA = tA(dA.rotate.shx), rA = new o(), fA = (rA = (rA = (rA = rA.multiply(dA.translate)).multiply(dA.skew)).multiply(dA.scale)).applyToRectangle(new a(gA - W * uA, xA - Y * E, AA * k, oA * X));
    if (this.autoPaging) {
      for (var EA, lA = y.call(this, fA), HA = [], SA = 0; SA < lA.length; SA += 1) HA.indexOf(lA[SA]) === -1 && HA.push(lA[SA]);
      Q(HA);
      for (var yA = HA[0], TA = HA[HA.length - 1], _A = yA; _A < TA + 1; _A++) {
        this.pdf.setPage(_A);
        var MA = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], VA = _A === 1 ? this.posY + this.margin[0] : this.margin[0], $A = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], ee = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], ZA = _A === 1 ? 0 : $A + (_A - 2) * ee;
        if (this.ctx.clip_path.length !== 0) {
          var Fe = this.path;
          EA = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = C(EA, this.posX + this.margin[3], -ZA + VA + this.ctx.prevPageLastElemOffset), T.call(this, "fill", !0), this.path = Fe;
        }
        var me = JSON.parse(JSON.stringify(fA));
        me = C([me], this.posX + this.margin[3], -ZA + VA + this.ctx.prevPageLastElemOffset)[0];
        var Ce = (_A > yA || _A < TA) && B.call(this);
        Ce && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], MA, ee, null).clip().discardPath()), this.pdf.addImage(S, "JPEG", me.x, me.y, me.w, me.h, null, null, vA), Ce && this.pdf.restoreGraphicsState();
      }
    } else this.pdf.addImage(S, "JPEG", fA.x, fA.y, fA.w, fA.h, null, null, vA);
  };
  var y = function(S, W, Y) {
    var AA = [];
    W = W || this.pdf.internal.pageSize.width, Y = Y || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
    var oA = this.posY + this.ctx.prevPageLastElemOffset;
    switch (S.type) {
      default:
      case "mt":
      case "lt":
        AA.push(Math.floor((S.y + oA) / Y) + 1);
        break;
      case "arc":
        AA.push(Math.floor((S.y + oA - S.radius) / Y) + 1), AA.push(Math.floor((S.y + oA + S.radius) / Y) + 1);
        break;
      case "qct":
        var gA = cA(this.ctx.lastPoint.x, this.ctx.lastPoint.y, S.x1, S.y1, S.x, S.y);
        AA.push(Math.floor((gA.y + oA) / Y) + 1), AA.push(Math.floor((gA.y + gA.h + oA) / Y) + 1);
        break;
      case "bct":
        var xA = FA(this.ctx.lastPoint.x, this.ctx.lastPoint.y, S.x1, S.y1, S.x2, S.y2, S.x, S.y);
        AA.push(Math.floor((xA.y + oA) / Y) + 1), AA.push(Math.floor((xA.y + xA.h + oA) / Y) + 1);
        break;
      case "rect":
        AA.push(Math.floor((S.y + oA) / Y) + 1), AA.push(Math.floor((S.y + S.h + oA) / Y) + 1);
    }
    for (var IA = 0; IA < AA.length; IA += 1) for (; this.pdf.internal.getNumberOfPages() < AA[IA]; ) m.call(this);
    return AA;
  }, m = function() {
    var S = this.fillStyle, W = this.strokeStyle, Y = this.font, AA = this.lineCap, oA = this.lineWidth, gA = this.lineJoin;
    this.pdf.addPage(), this.fillStyle = S, this.strokeStyle = W, this.font = Y, this.lineCap = AA, this.lineWidth = oA, this.lineJoin = gA;
  }, C = function(S, W, Y) {
    for (var AA = 0; AA < S.length; AA++) switch (S[AA].type) {
      case "bct":
        S[AA].x2 += W, S[AA].y2 += Y;
      case "qct":
        S[AA].x1 += W, S[AA].y1 += Y;
      default:
        S[AA].x += W, S[AA].y += Y;
    }
    return S;
  }, Q = function(S) {
    return S.sort(function(W, Y) {
      return W - Y;
    });
  }, F = function(S, W) {
    var Y = this.fillStyle, AA = this.strokeStyle, oA = this.lineCap, gA = this.lineWidth, xA = Math.abs(gA * this.ctx.transform.scaleX), IA = this.lineJoin;
    if (this.autoPaging) {
      for (var pA, WA, k = JSON.parse(JSON.stringify(this.path)), X = JSON.parse(JSON.stringify(this.path)), uA = [], E = 0; E < X.length; E++) if (X[E].x !== void 0) for (var dA = y.call(this, X[E]), vA = 0; vA < dA.length; vA += 1) uA.indexOf(dA[vA]) === -1 && uA.push(dA[vA]);
      for (var rA = 0; rA < uA.length; rA++) for (; this.pdf.internal.getNumberOfPages() < uA[rA]; ) m.call(this);
      Q(uA);
      for (var fA = uA[0], EA = uA[uA.length - 1], lA = fA; lA < EA + 1; lA++) {
        this.pdf.setPage(lA), this.fillStyle = Y, this.strokeStyle = AA, this.lineCap = oA, this.lineWidth = xA, this.lineJoin = IA;
        var HA = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], SA = lA === 1 ? this.posY + this.margin[0] : this.margin[0], yA = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], TA = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], _A = lA === 1 ? 0 : yA + (lA - 2) * TA;
        if (this.ctx.clip_path.length !== 0) {
          var MA = this.path;
          pA = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = C(pA, this.posX + this.margin[3], -_A + SA + this.ctx.prevPageLastElemOffset), T.call(this, S, !0), this.path = MA;
        }
        if (WA = JSON.parse(JSON.stringify(k)), this.path = C(WA, this.posX + this.margin[3], -_A + SA + this.ctx.prevPageLastElemOffset), W === !1 || lA === 0) {
          var VA = (lA > fA || lA < EA) && B.call(this);
          VA && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], HA, TA, null).clip().discardPath()), T.call(this, S, W), VA && this.pdf.restoreGraphicsState();
        }
        this.lineWidth = gA;
      }
      this.path = k;
    } else this.lineWidth = xA, T.call(this, S, W), this.lineWidth = gA;
  }, T = function(S, W) {
    if ((S !== "stroke" || W || !p.call(this)) && (S === "stroke" || W || !h.call(this))) {
      for (var Y, AA, oA = [], gA = this.path, xA = 0; xA < gA.length; xA++) {
        var IA = gA[xA];
        switch (IA.type) {
          case "begin":
            oA.push({ begin: !0 });
            break;
          case "close":
            oA.push({ close: !0 });
            break;
          case "mt":
            oA.push({ start: IA, deltas: [], abs: [] });
            break;
          case "lt":
            var pA = oA.length;
            if (gA[xA - 1] && !isNaN(gA[xA - 1].x) && (Y = [IA.x - gA[xA - 1].x, IA.y - gA[xA - 1].y], pA > 0)) {
              for (; pA >= 0; pA--) if (oA[pA - 1].close !== !0 && oA[pA - 1].begin !== !0) {
                oA[pA - 1].deltas.push(Y), oA[pA - 1].abs.push(IA);
                break;
              }
            }
            break;
          case "bct":
            Y = [IA.x1 - gA[xA - 1].x, IA.y1 - gA[xA - 1].y, IA.x2 - gA[xA - 1].x, IA.y2 - gA[xA - 1].y, IA.x - gA[xA - 1].x, IA.y - gA[xA - 1].y], oA[oA.length - 1].deltas.push(Y);
            break;
          case "qct":
            var WA = gA[xA - 1].x + 2 / 3 * (IA.x1 - gA[xA - 1].x), k = gA[xA - 1].y + 2 / 3 * (IA.y1 - gA[xA - 1].y), X = IA.x + 2 / 3 * (IA.x1 - IA.x), uA = IA.y + 2 / 3 * (IA.y1 - IA.y), E = IA.x, dA = IA.y;
            Y = [WA - gA[xA - 1].x, k - gA[xA - 1].y, X - gA[xA - 1].x, uA - gA[xA - 1].y, E - gA[xA - 1].x, dA - gA[xA - 1].y], oA[oA.length - 1].deltas.push(Y);
            break;
          case "arc":
            oA.push({ deltas: [], abs: [], arc: !0 }), Array.isArray(oA[oA.length - 1].abs) && oA[oA.length - 1].abs.push(IA);
        }
      }
      AA = W ? null : S === "stroke" ? "stroke" : "fill";
      for (var vA = !1, rA = 0; rA < oA.length; rA++) if (oA[rA].arc) for (var fA = oA[rA].abs, EA = 0; EA < fA.length; EA++) {
        var lA = fA[EA];
        lA.type === "arc" ? D.call(this, lA.x, lA.y, lA.radius, lA.startAngle, lA.endAngle, lA.counterclockwise, void 0, W, !vA) : P.call(this, lA.x, lA.y), vA = !0;
      }
      else if (oA[rA].close === !0) this.pdf.internal.out("h"), vA = !1;
      else if (oA[rA].begin !== !0) {
        var HA = oA[rA].start.x, SA = oA[rA].start.y;
        N.call(this, oA[rA].deltas, HA, SA), vA = !0;
      }
      AA && I.call(this, AA), W && q.call(this);
    }
  }, V = function(S) {
    var W = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, Y = W * (this.pdf.internal.getLineHeightFactor() - 1);
    switch (this.ctx.textBaseline) {
      case "bottom":
        return S - Y;
      case "top":
        return S + W - Y;
      case "hanging":
        return S + W - 2 * Y;
      case "middle":
        return S + W / 2 - Y;
      default:
        return S;
    }
  }, M = function(S) {
    return S + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
  };
  u.prototype.createLinearGradient = function() {
    var S = function() {
    };
    return S.colorStops = [], S.addColorStop = function(W, Y) {
      this.colorStops.push([W, Y]);
    }, S.getColor = function() {
      return this.colorStops.length === 0 ? "#000000" : this.colorStops[0][1];
    }, S.isCanvasGradient = !0, S;
  }, u.prototype.createPattern = function() {
    return this.createLinearGradient();
  }, u.prototype.createRadialGradient = function() {
    return this.createLinearGradient();
  };
  var D = function(S, W, Y, AA, oA, gA, xA, IA, pA) {
    for (var WA = nA.call(this, Y, AA, oA, gA), k = 0; k < WA.length; k++) {
      var X = WA[k];
      k === 0 && (pA ? U.call(this, X.x1 + S, X.y1 + W) : P.call(this, X.x1 + S, X.y1 + W)), iA.call(this, S, W, X.x2, X.y2, X.x3, X.y3, X.x4, X.y4);
    }
    IA ? q.call(this) : I.call(this, xA);
  }, I = function(S) {
    switch (S) {
      case "stroke":
        this.pdf.internal.out("S");
        break;
      case "fill":
        this.pdf.internal.out("f");
    }
  }, q = function() {
    this.pdf.clip(), this.pdf.discardPath();
  }, U = function(S, W) {
    this.pdf.internal.out(t(S) + " " + r(W) + " m");
  }, x = function(S) {
    var W;
    switch (S.align) {
      case "right":
      case "end":
        W = "right";
        break;
      case "center":
        W = "center";
        break;
      default:
        W = "left";
    }
    var Y, AA, oA, gA = this.pdf.getTextDimensions(S.text), xA = V.call(this, S.y), IA = M.call(this, xA) - gA.h, pA = this.ctx.transform.applyToPoint(new s(S.x, xA));
    if (this.autoPaging) {
      var WA = this.ctx.transform.decompose(), k = new o();
      k = (k = (k = k.multiply(WA.translate)).multiply(WA.skew)).multiply(WA.scale);
      for (var X = this.ctx.transform.applyToRectangle(new a(S.x, xA, gA.w, gA.h)), uA = k.applyToRectangle(new a(S.x, IA, gA.w, gA.h)), E = y.call(this, uA), dA = [], vA = 0; vA < E.length; vA += 1) dA.indexOf(E[vA]) === -1 && dA.push(E[vA]);
      Q(dA);
      for (var rA = dA[0], fA = dA[dA.length - 1], EA = rA; EA < fA + 1; EA++) {
        this.pdf.setPage(EA);
        var lA = EA === 1 ? this.posY + this.margin[0] : this.margin[0], HA = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], SA = this.pdf.internal.pageSize.height - this.margin[2], yA = SA - this.margin[0], TA = this.pdf.internal.pageSize.width - this.margin[1], _A = TA - this.margin[3], MA = EA === 1 ? 0 : HA + (EA - 2) * yA;
        if (this.ctx.clip_path.length !== 0) {
          var VA = this.path;
          Y = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = C(Y, this.posX + this.margin[3], -1 * MA + lA), T.call(this, "fill", !0), this.path = VA;
        }
        var $A = C([JSON.parse(JSON.stringify(uA))], this.posX + this.margin[3], -MA + lA + this.ctx.prevPageLastElemOffset)[0];
        S.scale >= 0.01 && (AA = this.pdf.internal.getFontSize(), this.pdf.setFontSize(AA * S.scale), oA = this.lineWidth, this.lineWidth = oA * S.scale);
        var ee = this.autoPaging !== "text";
        if (ee || $A.y + $A.h <= SA) {
          if (ee || $A.y >= lA && $A.x <= TA) {
            var ZA = ee ? S.text : this.pdf.splitTextToSize(S.text, S.maxWidth || TA - $A.x)[0], Fe = C([JSON.parse(JSON.stringify(X))], this.posX + this.margin[3], -MA + lA + this.ctx.prevPageLastElemOffset)[0], me = ee && (EA > rA || EA < fA) && B.call(this);
            me && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _A, yA, null).clip().discardPath()), this.pdf.text(ZA, Fe.x, Fe.y, { angle: S.angle, align: W, renderingMode: S.renderingMode }), me && this.pdf.restoreGraphicsState();
          }
        } else $A.y < SA && (this.ctx.prevPageLastElemOffset += SA - $A.y);
        S.scale >= 0.01 && (this.pdf.setFontSize(AA), this.lineWidth = oA);
      }
    } else S.scale >= 0.01 && (AA = this.pdf.internal.getFontSize(), this.pdf.setFontSize(AA * S.scale), oA = this.lineWidth, this.lineWidth = oA * S.scale), this.pdf.text(S.text, pA.x + this.posX, pA.y + this.posY, { angle: S.angle, align: W, renderingMode: S.renderingMode, maxWidth: S.maxWidth }), S.scale >= 0.01 && (this.pdf.setFontSize(AA), this.lineWidth = oA);
  }, P = function(S, W, Y, AA) {
    Y = Y || 0, AA = AA || 0, this.pdf.internal.out(t(S + Y) + " " + r(W + AA) + " l");
  }, N = function(S, W, Y) {
    return this.pdf.lines(S, W, Y, null, null);
  }, iA = function(S, W, Y, AA, oA, gA, xA, IA) {
    this.pdf.internal.out([A(n(Y + S)), A(i(AA + W)), A(n(oA + S)), A(i(gA + W)), A(n(xA + S)), A(i(IA + W)), "c"].join(" "));
  }, nA = function(S, W, Y, AA) {
    for (var oA = 2 * Math.PI, gA = Math.PI / 2; W > Y; ) W -= oA;
    var xA = Math.abs(Y - W);
    xA < oA && AA && (xA = oA - xA);
    for (var IA = [], pA = AA ? -1 : 1, WA = W; xA > 1e-5; ) {
      var k = WA + pA * Math.min(xA, gA);
      IA.push(sA.call(this, S, WA, k)), xA -= Math.abs(k - WA), WA = k;
    }
    return IA;
  }, sA = function(S, W, Y) {
    var AA = (Y - W) / 2, oA = S * Math.cos(AA), gA = S * Math.sin(AA), xA = oA, IA = -gA, pA = xA * xA + IA * IA, WA = pA + xA * oA + IA * gA, k = 4 / 3 * (Math.sqrt(2 * pA * WA) - WA) / (xA * gA - IA * oA), X = xA - k * IA, uA = IA + k * xA, E = X, dA = -uA, vA = AA + W, rA = Math.cos(vA), fA = Math.sin(vA);
    return { x1: S * Math.cos(W), y1: S * Math.sin(W), x2: X * rA - uA * fA, y2: X * fA + uA * rA, x3: E * rA - dA * fA, y3: E * fA + dA * rA, x4: S * Math.cos(Y), y4: S * Math.sin(Y) };
  }, tA = function(S) {
    return 180 * S / Math.PI;
  }, cA = function(S, W, Y, AA, oA, gA) {
    var xA = S + 0.5 * (Y - S), IA = W + 0.5 * (AA - W), pA = oA + 0.5 * (Y - oA), WA = gA + 0.5 * (AA - gA), k = Math.min(S, oA, xA, pA), X = Math.max(S, oA, xA, pA), uA = Math.min(W, gA, IA, WA), E = Math.max(W, gA, IA, WA);
    return new a(k, uA, X - k, E - uA);
  }, FA = function(S, W, Y, AA, oA, gA, xA, IA) {
    var pA, WA, k, X, uA, E, dA, vA, rA, fA, EA, lA, HA, SA, yA = Y - S, TA = AA - W, _A = oA - Y, MA = gA - AA, VA = xA - oA, $A = IA - gA;
    for (WA = 0; WA < 41; WA++) rA = (dA = (k = S + (pA = WA / 40) * yA) + pA * ((uA = Y + pA * _A) - k)) + pA * (uA + pA * (oA + pA * VA - uA) - dA), fA = (vA = (X = W + pA * TA) + pA * ((E = AA + pA * MA) - X)) + pA * (E + pA * (gA + pA * $A - E) - vA), WA == 0 ? (EA = rA, lA = fA, HA = rA, SA = fA) : (EA = Math.min(EA, rA), lA = Math.min(lA, fA), HA = Math.max(HA, rA), SA = Math.max(SA, fA));
    return new a(Math.round(EA), Math.round(lA), Math.round(HA - EA), Math.round(SA - lA));
  }, CA = function() {
    if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
      var S, W, Y = (S = this.ctx.lineDash, W = this.ctx.lineDashOffset, JSON.stringify({ lineDash: S, lineDashOffset: W }));
      this.prevLineDash !== Y && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = Y);
    }
  };
})(we.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(e) {
  var A = function(s) {
    var a, o, l, c, u, d, h, p, B, y;
    for (o = [], l = 0, c = (s += a = "\0\0\0\0".slice(s.length % 4 || 4)).length; c > l; l += 4) (u = (s.charCodeAt(l) << 24) + (s.charCodeAt(l + 1) << 16) + (s.charCodeAt(l + 2) << 8) + s.charCodeAt(l + 3)) !== 0 ? (d = (u = ((u = ((u = ((u = (u - (y = u % 85)) / 85) - (B = u % 85)) / 85) - (p = u % 85)) / 85) - (h = u % 85)) / 85) % 85, o.push(d + 33, h + 33, p + 33, B + 33, y + 33)) : o.push(122);
    return (function(m, C) {
      for (var Q = C; Q > 0; Q--) m.pop();
    })(o, a.length), String.fromCharCode.apply(String, o) + "~>";
  }, t = function(s) {
    var a, o, l, c, u, d = String, h = "length", p = 255, B = "charCodeAt", y = "slice", m = "replace";
    for (s[y](-2), s = s[y](0, -2)[m](/\s/g, "")[m]("z", "!!!!!"), l = [], c = 0, u = (s += a = "uuuuu"[y](s[h] % 5 || 5))[h]; u > c; c += 5) o = 52200625 * (s[B](c) - 33) + 614125 * (s[B](c + 1) - 33) + 7225 * (s[B](c + 2) - 33) + 85 * (s[B](c + 3) - 33) + (s[B](c + 4) - 33), l.push(p & o >> 24, p & o >> 16, p & o >> 8, p & o);
    return (function(C, Q) {
      for (var F = Q; F > 0; F--) C.pop();
    })(l, a[h]), d.fromCharCode.apply(d, l);
  }, r = function(s) {
    return s.split("").map(function(a) {
      return ("0" + a.charCodeAt().toString(16)).slice(-2);
    }).join("") + ">";
  }, n = function(s) {
    var a = new RegExp(/^([0-9A-Fa-f]{2})+$/);
    if ((s = s.replace(/\s/g, "")).indexOf(">") !== -1 && (s = s.substr(0, s.indexOf(">"))), s.length % 2 && (s += "0"), a.test(s) === !1) return "";
    for (var o = "", l = 0; l < s.length; l += 2) o += String.fromCharCode("0x" + (s[l] + s[l + 1]));
    return o;
  }, i = function(s) {
    for (var a = new Uint8Array(s.length), o = s.length; o--; ) a[o] = s.charCodeAt(o);
    return (a = wv(a)).reduce(function(l, c) {
      return l + String.fromCharCode(c);
    }, "");
  };
  e.processDataByFilters = function(s, a) {
    var o = 0, l = s || "", c = [];
    for (typeof (a = a || []) == "string" && (a = [a]), o = 0; o < a.length; o += 1) switch (a[o]) {
      case "ASCII85Decode":
      case "/ASCII85Decode":
        l = t(l), c.push("/ASCII85Encode");
        break;
      case "ASCII85Encode":
      case "/ASCII85Encode":
        l = A(l), c.push("/ASCII85Decode");
        break;
      case "ASCIIHexDecode":
      case "/ASCIIHexDecode":
        l = n(l), c.push("/ASCIIHexEncode");
        break;
      case "ASCIIHexEncode":
      case "/ASCIIHexEncode":
        l = r(l), c.push("/ASCIIHexDecode");
        break;
      case "FlateEncode":
      case "/FlateEncode":
        l = i(l), c.push("/FlateDecode");
        break;
      default:
        throw new Error('The filter: "' + a[o] + '" is not implemented');
    }
    return { data: l, reverseChain: c.reverse().join(" ") };
  };
})(we.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(e) {
  e.loadFile = function(A, t, r) {
    return (function(n, i, s) {
      i = i !== !1, s = typeof s == "function" ? s : function() {
      };
      var a = void 0;
      try {
        a = (function(o, l, c) {
          var u = new XMLHttpRequest(), d = 0, h = function(p) {
            var B = p.length, y = [], m = String.fromCharCode;
            for (d = 0; d < B; d += 1) y.push(m(255 & p.charCodeAt(d)));
            return y.join("");
          };
          if (u.open("GET", o, !l), u.overrideMimeType("text/plain; charset=x-user-defined"), l === !1 && (u.onload = function() {
            u.status === 200 ? c(h(this.responseText)) : c(void 0);
          }), u.send(null), l && u.status === 200) return h(u.responseText);
        })(n, i, s);
      } catch {
      }
      return a;
    })(A, t, r);
  }, e.allowFsRead = void 0, e.loadImageFile = e.loadFile;
})(we.API), (function(e) {
  function A() {
    return (He.html2canvas ? Promise.resolve(He.html2canvas) : Promise.resolve().then(() => RY)).catch(function(a) {
      return Promise.reject(new Error("Could not load html2canvas: " + a));
    }).then(function(a) {
      return a.default ? a.default : a;
    });
  }
  function t() {
    return (He.DOMPurify ? Promise.resolve(He.DOMPurify) : Promise.resolve().then(() => vJ)).catch(function(a) {
      return Promise.reject(new Error("Could not load dompurify: " + a));
    }).then(function(a) {
      return a.default ? a.default : a;
    });
  }
  var r = function(a) {
    var o = it(a);
    return o === "undefined" ? "undefined" : o === "string" || a instanceof String ? "string" : o === "number" || a instanceof Number ? "number" : o === "function" || a instanceof Function ? "function" : a && a.constructor === Array ? "array" : a && a.nodeType === 1 ? "element" : o === "object" ? "object" : "unknown";
  }, n = function(a, o) {
    var l = document.createElement(a);
    for (var c in o.className && (l.className = o.className), o.innerHTML && o.dompurify && (l.innerHTML = o.dompurify.sanitize(o.innerHTML)), o.style) l.style[c] = o.style[c];
    return l;
  }, i = function a(o, l) {
    for (var c = o.nodeType === 3 ? document.createTextNode(o.nodeValue) : o.cloneNode(!1), u = o.firstChild; u; u = u.nextSibling) l !== !0 && u.nodeType === 1 && u.nodeName === "SCRIPT" || c.appendChild(a(u, l));
    return o.nodeType === 1 && (o.nodeName === "CANVAS" ? (c.width = o.width, c.height = o.height, c.getContext("2d").drawImage(o, 0, 0)) : o.nodeName !== "TEXTAREA" && o.nodeName !== "SELECT" || (c.value = o.value), c.addEventListener("load", function() {
      c.scrollTop = o.scrollTop, c.scrollLeft = o.scrollLeft;
    }, !0)), c;
  }, s = function a(o) {
    var l = Object.assign(a.convert(Promise.resolve()), JSON.parse(JSON.stringify(a.template))), c = a.convert(Promise.resolve(), l);
    return (c = c.setProgress(1, a, 1, [a])).set(o);
  };
  (s.prototype = Object.create(Promise.prototype)).constructor = s, s.convert = function(a, o) {
    return a.__proto__ = o || s.prototype, a;
  }, s.template = { prop: { src: null, container: null, overlay: null, canvas: null, img: null, pdf: null, pageSize: null, callback: function() {
  } }, progress: { val: 0, state: null, n: 0, stack: [] }, opt: { filename: "file.pdf", margin: [0, 0, 0, 0], enableLinks: !0, x: 0, y: 0, html2canvas: {}, jsPDF: {}, backgroundColor: "transparent" } }, s.prototype.from = function(a, o) {
    return this.then(function() {
      switch (o = o || (function(l) {
        switch (r(l)) {
          case "string":
            return "string";
          case "element":
            return l.nodeName.toLowerCase() === "canvas" ? "canvas" : "element";
          default:
            return "unknown";
        }
      })(a), o) {
        case "string":
          return this.then(t).then(function(l) {
            return this.set({ src: n("div", { innerHTML: a, dompurify: l }) });
          });
        case "element":
          return this.set({ src: a });
        case "canvas":
          return this.set({ canvas: a });
        case "img":
          return this.set({ img: a });
        default:
          return this.error("Unknown source type.");
      }
    });
  }, s.prototype.to = function(a) {
    switch (a) {
      case "container":
        return this.toContainer();
      case "canvas":
        return this.toCanvas();
      case "img":
        return this.toImg();
      case "pdf":
        return this.toPdf();
      default:
        return this.error("Invalid target.");
    }
  }, s.prototype.toContainer = function() {
    return this.thenList([function() {
      return this.prop.src || this.error("Cannot duplicate - no source HTML.");
    }, function() {
      return this.prop.pageSize || this.setPageSize();
    }]).then(function() {
      var a = { position: "relative", display: "inline-block", width: (typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px", left: 0, right: 0, top: 0, margin: "auto", backgroundColor: this.opt.backgroundColor }, o = i(this.prop.src, this.opt.html2canvas.javascriptEnabled);
      o.tagName === "BODY" && (a.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = n("div", { className: "html2pdf__overlay", style: { position: "fixed", overflow: "hidden", zIndex: 1e3, left: "-100000px", right: 0, bottom: 0, top: 0 } }), this.prop.container = n("div", { className: "html2pdf__container", style: a }), this.prop.container.appendChild(o), this.prop.container.firstChild.appendChild(n("div", { style: { clear: "both", border: "0 none transparent", margin: 0, padding: 0, height: 0 } })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
    });
  }, s.prototype.toCanvas = function() {
    var a = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(a).then(A).then(function(o) {
      var l = Object.assign({}, this.opt.html2canvas);
      return delete l.onrendered, o(this.prop.container, l);
    }).then(function(o) {
      (this.opt.html2canvas.onrendered || function() {
      })(o), this.prop.canvas = o, document.body.removeChild(this.prop.overlay);
    });
  }, s.prototype.toContext2d = function() {
    var a = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(a).then(A).then(function(o) {
      var l = this.opt.jsPDF, c = this.opt.fontFaces, u = typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, d = Object.assign({ async: !0, allowTaint: !0, scale: u, scrollX: this.opt.scrollX || 0, scrollY: this.opt.scrollY || 0, backgroundColor: "#ffffff", imageTimeout: 15e3, logging: !0, proxy: null, removeContainer: !0, foreignObjectRendering: !1, useCORS: !1 }, this.opt.html2canvas);
      if (delete d.onrendered, l.context2d.autoPaging = this.opt.autoPaging === void 0 || this.opt.autoPaging, l.context2d.posX = this.opt.x, l.context2d.posY = this.opt.y, l.context2d.margin = this.opt.margin, l.context2d.fontFaces = c, c) for (var h = 0; h < c.length; ++h) {
        var p = c[h], B = p.src.find(function(y) {
          return y.format === "truetype";
        });
        B && l.addFont(B.url, p.ref.name, p.ref.style);
      }
      return d.windowHeight = d.windowHeight || 0, d.windowHeight = d.windowHeight == 0 ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : d.windowHeight, l.context2d.save(!0), o(this.prop.container, d);
    }).then(function(o) {
      this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {
      })(o), this.prop.canvas = o, document.body.removeChild(this.prop.overlay);
    });
  }, s.prototype.toImg = function() {
    return this.thenList([function() {
      return this.prop.canvas || this.toCanvas();
    }]).then(function() {
      var a = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
      this.prop.img = document.createElement("img"), this.prop.img.src = a;
    });
  }, s.prototype.toPdf = function() {
    return this.thenList([function() {
      return this.toContext2d();
    }]).then(function() {
      this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
    });
  }, s.prototype.output = function(a, o, l) {
    return (l = l || "pdf").toLowerCase() === "img" || l.toLowerCase() === "image" ? this.outputImg(a, o) : this.outputPdf(a, o);
  }, s.prototype.outputPdf = function(a, o) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      return this.prop.pdf.output(a, o);
    });
  }, s.prototype.outputImg = function(a) {
    return this.thenList([function() {
      return this.prop.img || this.toImg();
    }]).then(function() {
      switch (a) {
        case void 0:
        case "img":
          return this.prop.img;
        case "datauristring":
        case "dataurlstring":
          return this.prop.img.src;
        case "datauri":
        case "dataurl":
          return document.location.href = this.prop.img.src;
        default:
          throw 'Image output type "' + a + '" is not supported.';
      }
    });
  }, s.prototype.save = function(a) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).set(a ? { filename: a } : null).then(function() {
      this.prop.pdf.save(this.opt.filename);
    });
  }, s.prototype.doCallback = function() {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      this.prop.callback(this.prop.pdf);
    });
  }, s.prototype.set = function(a) {
    if (r(a) !== "object") return this;
    var o = Object.keys(a || {}).map(function(l) {
      if (l in s.template.prop) return function() {
        this.prop[l] = a[l];
      };
      switch (l) {
        case "margin":
          return this.setMargin.bind(this, a.margin);
        case "jsPDF":
          return function() {
            return this.opt.jsPDF = a.jsPDF, this.setPageSize();
          };
        case "pageSize":
          return this.setPageSize.bind(this, a.pageSize);
        default:
          return function() {
            this.opt[l] = a[l];
          };
      }
    }, this);
    return this.then(function() {
      return this.thenList(o);
    });
  }, s.prototype.get = function(a, o) {
    return this.then(function() {
      var l = a in s.template.prop ? this.prop[a] : this.opt[a];
      return o ? o(l) : l;
    });
  }, s.prototype.setMargin = function(a) {
    return this.then(function() {
      switch (r(a)) {
        case "number":
          a = [a, a, a, a];
        case "array":
          if (a.length === 2 && (a = [a[0], a[1], a[0], a[1]]), a.length === 4) break;
        default:
          return this.error("Invalid margin array.");
      }
      this.opt.margin = a;
    }).then(this.setPageSize);
  }, s.prototype.setPageSize = function(a) {
    function o(l, c) {
      return Math.floor(l * c / 72 * 96);
    }
    return this.then(function() {
      (a = a || we.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (a.inner = { width: a.width - this.opt.margin[1] - this.opt.margin[3], height: a.height - this.opt.margin[0] - this.opt.margin[2] }, a.inner.px = { width: o(a.inner.width, a.k), height: o(a.inner.height, a.k) }, a.inner.ratio = a.inner.height / a.inner.width), this.prop.pageSize = a;
    });
  }, s.prototype.setProgress = function(a, o, l, c) {
    return a != null && (this.progress.val = a), o != null && (this.progress.state = o), l != null && (this.progress.n = l), c != null && (this.progress.stack = c), this.progress.ratio = this.progress.val / this.progress.state, this;
  }, s.prototype.updateProgress = function(a, o, l, c) {
    return this.setProgress(a ? this.progress.val + a : null, o || null, l ? this.progress.n + l : null, c ? this.progress.stack.concat(c) : null);
  }, s.prototype.then = function(a, o) {
    var l = this;
    return this.thenCore(a, o, function(c, u) {
      return l.updateProgress(null, null, 1, [c]), Promise.prototype.then.call(this, function(d) {
        return l.updateProgress(null, c), d;
      }).then(c, u).then(function(d) {
        return l.updateProgress(1), d;
      });
    });
  }, s.prototype.thenCore = function(a, o, l) {
    l = l || Promise.prototype.then;
    var c = this;
    a && (a = a.bind(c)), o && (o = o.bind(c));
    var u = Promise.toString().indexOf("[native code]") !== -1 && Promise.name === "Promise" ? c : s.convert(Object.assign({}, c), Promise.prototype), d = l.call(u, a, o);
    return s.convert(d, c.__proto__);
  }, s.prototype.thenExternal = function(a, o) {
    return Promise.prototype.then.call(this, a, o);
  }, s.prototype.thenList = function(a) {
    var o = this;
    return a.forEach(function(l) {
      o = o.thenCore(l);
    }), o;
  }, s.prototype.catch = function(a) {
    a && (a = a.bind(this));
    var o = Promise.prototype.catch.call(this, a);
    return s.convert(o, this);
  }, s.prototype.catchExternal = function(a) {
    return Promise.prototype.catch.call(this, a);
  }, s.prototype.error = function(a) {
    return this.then(function() {
      throw new Error(a);
    });
  }, s.prototype.using = s.prototype.set, s.prototype.saveAs = s.prototype.save, s.prototype.export = s.prototype.output, s.prototype.run = s.prototype.then, we.getPageSize = function(a, o, l) {
    if (it(a) === "object") {
      var c = a;
      a = c.orientation, o = c.unit || o, l = c.format || l;
    }
    o = o || "mm", l = l || "a4", a = ("" + (a || "P")).toLowerCase();
    var u, d = ("" + l).toLowerCase(), h = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
    switch (o) {
      case "pt":
        u = 1;
        break;
      case "mm":
        u = 72 / 25.4;
        break;
      case "cm":
        u = 72 / 2.54;
        break;
      case "in":
        u = 72;
        break;
      case "px":
        u = 0.75;
        break;
      case "pc":
      case "em":
        u = 12;
        break;
      case "ex":
        u = 6;
        break;
      default:
        throw "Invalid unit: " + o;
    }
    var p, B = 0, y = 0;
    if (h.hasOwnProperty(d)) B = h[d][1] / u, y = h[d][0] / u;
    else try {
      B = l[1], y = l[0];
    } catch {
      throw new Error("Invalid format: " + l);
    }
    if (a === "p" || a === "portrait") a = "p", y > B && (p = y, y = B, B = p);
    else {
      if (a !== "l" && a !== "landscape") throw "Invalid orientation: " + a;
      a = "l", B > y && (p = y, y = B, B = p);
    }
    return { width: y, height: B, unit: o, k: u, orientation: a };
  }, e.html = function(a, o) {
    (o = o || {}).callback = o.callback || function() {
    }, o.html2canvas = o.html2canvas || {}, o.html2canvas.canvas = o.html2canvas.canvas || this.canvas, o.jsPDF = o.jsPDF || this, o.fontFaces = o.fontFaces ? o.fontFaces.map(lw) : null;
    var l = new s(o);
    return o.worker ? l : l.from(a).doCallback();
  };
})(we.API), we.API.addJS = function(e) {
  var A, t, r = (function(n) {
    for (var i = "", s = 0; s < n.length; s++) {
      var a = n[s];
      if (a === "(" || a === ")") {
        for (var o = 0, l = s - 1; l >= 0 && n[l] === "\\"; l--) o++;
        i += o % 2 == 0 ? "\\" + a : a;
      } else i += a;
    }
    return i;
  })(e);
  return this.internal.events.subscribe("postPutResources", function() {
    A = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (A + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), t = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + r + ")"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    A !== void 0 && t !== void 0 && this.internal.out("/Names <</JavaScript " + A + " 0 R>>");
  }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(e) {
  var A;
  e.events.push(["postPutResources", function() {
    var t = this, r = /^(\d+) 0 obj$/;
    if (this.outline.root.children.length > 0) for (var n = t.outline.render().split(/\r\n/), i = 0; i < n.length; i++) {
      var s = n[i], a = r.exec(s);
      if (a != null) {
        var o = a[1];
        t.internal.newObjectDeferredBegin(o, !1);
      }
      t.internal.write(s);
    }
    if (this.outline.createNamedDestinations) {
      var l = this.internal.pages.length, c = [];
      for (i = 0; i < l; i++) {
        var u = t.internal.newObject();
        c.push(u);
        var d = t.internal.getPageInfo(i + 1);
        t.internal.write("<< /D[" + d.objId + " 0 R /XYZ null null null]>> endobj");
      }
      var h = t.internal.newObject();
      for (t.internal.write("<< /Names [ "), i = 0; i < c.length; i++) t.internal.write("(page_" + (i + 1) + ")" + c[i] + " 0 R");
      t.internal.write(" ] >>", "endobj"), A = t.internal.newObject(), t.internal.write("<< /Dests " + h + " 0 R"), t.internal.write(">>", "endobj");
    }
  }]), e.events.push(["putCatalog", function() {
    var t = this;
    t.outline.root.children.length > 0 && (t.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && t.internal.write("/Names " + A + " 0 R"));
  }]), e.events.push(["initialized", function() {
    var t = this;
    t.outline = { createNamedDestinations: !1, root: { children: [] } }, t.outline.add = function(r, n, i) {
      var s = { title: n, options: i, children: [] };
      return r == null && (r = this.root), r.children.push(s), s;
    }, t.outline.render = function() {
      return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
    }, t.outline.genIds_r = function(r) {
      r.id = t.internal.newObjectDeferred();
      for (var n = 0; n < r.children.length; n++) this.genIds_r(r.children[n]);
    }, t.outline.renderRoot = function(r) {
      this.objStart(r), this.line("/Type /Outlines"), r.children.length > 0 && (this.line("/First " + this.makeRef(r.children[0])), this.line("/Last " + this.makeRef(r.children[r.children.length - 1]))), this.line("/Count " + this.count_r({ count: 0 }, r)), this.objEnd();
    }, t.outline.renderItems = function(r) {
      for (var n = this.ctx.pdf.internal.getVerticalCoordinateString, i = 0; i < r.children.length; i++) {
        var s = r.children[i];
        this.objStart(s), this.line("/Title " + this.makeString(s.title)), this.line("/Parent " + this.makeRef(r)), i > 0 && this.line("/Prev " + this.makeRef(r.children[i - 1])), i < r.children.length - 1 && this.line("/Next " + this.makeRef(r.children[i + 1])), s.children.length > 0 && (this.line("/First " + this.makeRef(s.children[0])), this.line("/Last " + this.makeRef(s.children[s.children.length - 1])));
        var a = this.count = this.count_r({ count: 0 }, s);
        if (a > 0 && this.line("/Count " + a), s.options && s.options.pageNumber) {
          var o = t.internal.getPageInfo(s.options.pageNumber);
          this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + n(0) + " 0]");
        }
        this.objEnd();
      }
      for (var l = 0; l < r.children.length; l++) this.renderItems(r.children[l]);
    }, t.outline.line = function(r) {
      this.ctx.val += r + `\r
`;
    }, t.outline.makeRef = function(r) {
      return r.id + " 0 R";
    }, t.outline.makeString = function(r) {
      return "(" + t.internal.pdfEscape(r) + ")";
    }, t.outline.objStart = function(r) {
      this.ctx.val += `\r
` + r.id + ` 0 obj\r
<<\r
`;
    }, t.outline.objEnd = function() {
      this.ctx.val += `>> \r
endobj\r
`;
    }, t.outline.count_r = function(r, n) {
      for (var i = 0; i < n.children.length; i++) r.count++, this.count_r(r, n.children[i]);
      return r.count;
    };
  }]);
})(we.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(e) {
  var A = [192, 193, 194, 195, 196, 197, 198, 199];
  e.processJPEG = function(t, r, n, i, s, a) {
    var o, l = this.decode.DCT_DECODE, c = null;
    if (typeof t == "string" || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
      switch (t = s || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, o = (function(u) {
        for (var d, h = 256 * u.charCodeAt(4) + u.charCodeAt(5), p = u.length, B = { width: 0, height: 0, numcomponents: 1 }, y = 4; y < p; y += 2) {
          if (y += h, A.indexOf(u.charCodeAt(y + 1)) !== -1) {
            d = 256 * u.charCodeAt(y + 5) + u.charCodeAt(y + 6), B = { width: 256 * u.charCodeAt(y + 7) + u.charCodeAt(y + 8), height: d, numcomponents: u.charCodeAt(y + 9) };
            break;
          }
          h = 256 * u.charCodeAt(y + 2) + u.charCodeAt(y + 3);
        }
        return B;
      })(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t), o.numcomponents) {
        case 1:
          a = this.color_spaces.DEVICE_GRAY;
          break;
        case 4:
          a = this.color_spaces.DEVICE_CMYK;
          break;
        case 3:
          a = this.color_spaces.DEVICE_RGB;
      }
      c = { data: t, width: o.width, height: o.height, colorSpace: a, bitsPerComponent: 8, filter: l, index: r, alias: n };
    }
    return c;
  };
})(we.API), we.API.processPNG = function(e, A, t, r) {
  if (this.__addimage__.isArrayBuffer(e) && (e = new Uint8Array(e)), this.__addimage__.isArrayBufferView(e)) {
    var n, i = EW(e, { checkCrc: !0 }), s = i.width, a = i.height, o = i.channels, l = i.palette, c = i.depth;
    n = l && o === 1 ? (function(D) {
      for (var I = D.width, q = D.height, U = D.data, x = D.palette, P = D.depth, N = !1, iA = [], nA = [], sA = void 0, tA = !1, cA = 0, FA = 0; FA < x.length; FA++) {
        var CA = uF(x[FA], 4), S = CA[0], W = CA[1], Y = CA[2], AA = CA[3];
        iA.push(S, W, Y), AA != null && (AA === 0 ? (cA++, nA.length < 1 && nA.push(FA)) : AA < 255 && (tA = !0));
      }
      if (tA || cA > 1) {
        N = !0, nA = void 0;
        var oA = I * q;
        sA = new Uint8Array(oA);
        for (var gA = new DataView(U.buffer), xA = 0; xA < oA; xA++) {
          var IA = uw(gA, xA, P), pA = uF(x[IA], 4)[3];
          sA[xA] = pA;
        }
      } else cA === 0 && (nA = void 0);
      return { colorSpace: "Indexed", colorsPerPixel: 1, sMaskBitsPerComponent: N ? 8 : void 0, colorBytes: U, alphaBytes: sA, needSMask: N, palette: iA, mask: nA };
    })(i) : o === 2 || o === 4 ? (function(D) {
      for (var I = D.data, q = D.width, U = D.height, x = D.channels, P = D.depth, N = x === 2 ? "DeviceGray" : "DeviceRGB", iA = x - 1, nA = q * U, sA = iA, tA = nA * sA, cA = 1 * nA, FA = Math.ceil(tA * P / 8), CA = Math.ceil(cA * P / 8), S = new Uint8Array(FA), W = new Uint8Array(CA), Y = new DataView(I.buffer), AA = new DataView(S.buffer), oA = new DataView(W.buffer), gA = !1, xA = 0; xA < nA; xA++) {
        for (var IA = xA * x, pA = 0; pA < sA; pA++) pQ(AA, uw(Y, IA + pA, P), xA * sA + pA, P);
        var WA = uw(Y, IA + sA, P);
        WA < (1 << P) - 1 && (gA = !0), pQ(oA, WA, 1 * xA, P);
      }
      return { colorSpace: N, colorsPerPixel: iA, sMaskBitsPerComponent: gA ? P : void 0, colorBytes: S, alphaBytes: W, needSMask: gA };
    })(i) : (function(D) {
      var I = D.data, q = D.channels === 1 ? "DeviceGray" : "DeviceRGB";
      return { colorSpace: q, colorsPerPixel: q === "DeviceGray" ? 1 : 3, colorBytes: I instanceof Uint16Array ? (function(U) {
        for (var x = U.length, P = new Uint8Array(2 * x), N = new DataView(P.buffer, P.byteOffset, P.byteLength), iA = 0; iA < x; iA++) N.setUint16(2 * iA, U[iA], !1);
        return P;
      })(I) : I, needSMask: !1 };
    })(i);
    var u, d, h, p = n, B = p.colorSpace, y = p.colorsPerPixel, m = p.sMaskBitsPerComponent, C = p.colorBytes, Q = p.alphaBytes, F = p.needSMask, T = p.palette, V = p.mask, M = null;
    return r !== we.API.image_compression.NONE && typeof wv == "function" ? (M = (function(D) {
      var I;
      switch (D) {
        case we.API.image_compression.FAST:
          I = 11;
          break;
        case we.API.image_compression.MEDIUM:
          I = 13;
          break;
        case we.API.image_compression.SLOW:
          I = 14;
          break;
        default:
          I = 12;
      }
      return I;
    })(r), u = this.decode.FLATE_DECODE, d = "/Predictor ".concat(M, " /Colors ").concat(y, " /BitsPerComponent ").concat(c, " /Columns ").concat(s), e = uQ(C, Math.ceil(s * y * c / 8), y, c, r), F && (h = uQ(Q, Math.ceil(s * m / 8), 1, m, r))) : (u = void 0, d = void 0, e = C, F && (h = Q)), (this.__addimage__.isArrayBuffer(e) || this.__addimage__.isArrayBufferView(e)) && (e = this.__addimage__.arrayBufferToBinaryString(e)), (h && this.__addimage__.isArrayBuffer(h) || this.__addimage__.isArrayBufferView(h)) && (h = this.__addimage__.arrayBufferToBinaryString(h)), { alias: t, data: e, index: A, filter: u, decodeParameters: d, transparency: V, palette: T, sMask: h, predictor: M, width: s, height: a, bitsPerComponent: c, sMaskBitsPerComponent: m, colorSpace: B };
  }
}, (function(e) {
  e.processGIF89A = function(A, t, r, n) {
    var i = new $W(A), s = i.width, a = i.height, o = [];
    i.decodeAndBlitFrameRGBA(0, o);
    var l = { data: o, width: s, height: a }, c = new hw(100).encode(l, 100);
    return e.processJPEG.call(this, c, t, r, n);
  }, e.processGIF87A = e.processGIF89A;
})(we.API), us.prototype.parseHeader = function() {
  if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
    var e = this.colors === 0 ? 1 << this.bitPP : this.colors;
    this.palette = new Array(e);
    for (var A = 0; A < e; A++) {
      var t = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0);
      this.palette[A] = { red: n, green: r, blue: t, quad: i };
    }
  }
  this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, us.prototype.parseBGR = function() {
  this.pos = this.offset;
  var e = "bit" + this.bitPP, A = this.width * this.height * 4;
  if (A > 536870912) throw new Error("Image dimensions exceed 512MB, which is too large.");
  this.data = new Uint8Array(A);
  try {
    this[e]();
  } catch (t) {
    Ct.log("bit decode error:" + t);
  }
}, us.prototype.bit1 = function() {
  var e, A = Math.ceil(this.width / 8), t = A % 4;
  for (e = this.height - 1; e >= 0; e--) {
    for (var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < A; n++) for (var i = this.datav.getUint8(this.pos++, !0), s = r * this.width * 4 + 8 * n * 4, a = 0; a < 8 && 8 * n + a < this.width; a++) {
      var o = this.palette[i >> 7 - a & 1];
      this.data[s + 4 * a] = o.blue, this.data[s + 4 * a + 1] = o.green, this.data[s + 4 * a + 2] = o.red, this.data[s + 4 * a + 3] = 255;
    }
    t !== 0 && (this.pos += 4 - t);
  }
}, us.prototype.bit4 = function() {
  for (var e = Math.ceil(this.width / 2), A = e % 4, t = this.height - 1; t >= 0; t--) {
    for (var r = this.bottom_up ? t : this.height - 1 - t, n = 0; n < e; n++) {
      var i = this.datav.getUint8(this.pos++, !0), s = r * this.width * 4 + 2 * n * 4, a = i >> 4, o = 15 & i, l = this.palette[a];
      if (this.data[s] = l.blue, this.data[s + 1] = l.green, this.data[s + 2] = l.red, this.data[s + 3] = 255, 2 * n + 1 >= this.width) break;
      l = this.palette[o], this.data[s + 4] = l.blue, this.data[s + 4 + 1] = l.green, this.data[s + 4 + 2] = l.red, this.data[s + 4 + 3] = 255;
    }
    A !== 0 && (this.pos += 4 - A);
  }
}, us.prototype.bit8 = function() {
  for (var e = this.width % 4, A = this.height - 1; A >= 0; A--) {
    for (var t = this.bottom_up ? A : this.height - 1 - A, r = 0; r < this.width; r++) {
      var n = this.datav.getUint8(this.pos++, !0), i = t * this.width * 4 + 4 * r;
      if (n < this.palette.length) {
        var s = this.palette[n];
        this.data[i] = s.red, this.data[i + 1] = s.green, this.data[i + 2] = s.blue, this.data[i + 3] = 255;
      } else this.data[i] = 255, this.data[i + 1] = 255, this.data[i + 2] = 255, this.data[i + 3] = 255;
    }
    e !== 0 && (this.pos += 4 - e);
  }
}, us.prototype.bit15 = function() {
  for (var e = this.width % 3, A = parseInt("11111", 2), t = this.height - 1; t >= 0; t--) {
    for (var r = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++) {
      var i = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var s = (i & A) / A * 255 | 0, a = (i >> 5 & A) / A * 255 | 0, o = (i >> 10 & A) / A * 255 | 0, l = i >> 15 ? 255 : 0, c = r * this.width * 4 + 4 * n;
      this.data[c] = o, this.data[c + 1] = a, this.data[c + 2] = s, this.data[c + 3] = l;
    }
    this.pos += e;
  }
}, us.prototype.bit16 = function() {
  for (var e = this.width % 3, A = parseInt("11111", 2), t = parseInt("111111", 2), r = this.height - 1; r >= 0; r--) {
    for (var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < this.width; i++) {
      var s = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var a = (s & A) / A * 255 | 0, o = (s >> 5 & t) / t * 255 | 0, l = (s >> 11) / A * 255 | 0, c = n * this.width * 4 + 4 * i;
      this.data[c] = l, this.data[c + 1] = o, this.data[c + 2] = a, this.data[c + 3] = 255;
    }
    this.pos += e;
  }
}, us.prototype.bit24 = function() {
  for (var e = this.height - 1; e >= 0; e--) {
    for (var A = this.bottom_up ? e : this.height - 1 - e, t = 0; t < this.width; t++) {
      var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = A * this.width * 4 + 4 * t;
      this.data[s] = i, this.data[s + 1] = n, this.data[s + 2] = r, this.data[s + 3] = 255;
    }
    this.pos += this.width % 4;
  }
}, us.prototype.bit32 = function() {
  for (var e = this.height - 1; e >= 0; e--) for (var A = this.bottom_up ? e : this.height - 1 - e, t = 0; t < this.width; t++) {
    var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = this.datav.getUint8(this.pos++, !0), a = A * this.width * 4 + 4 * t;
    this.data[a] = i, this.data[a + 1] = n, this.data[a + 2] = r, this.data[a + 3] = s;
  }
}, us.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(e) {
  e.processBMP = function(A, t, r, n) {
    var i = new us(A, !1), s = i.width, a = i.height, o = { data: i.getData(), width: s, height: a }, l = new hw(100).encode(o, 100);
    return e.processJPEG.call(this, l, t, r, n);
  };
})(we.API), wQ.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(e) {
  e.processWEBP = function(A, t, r, n) {
    var i = new wQ(A), s = i.width, a = i.height, o = { data: i.getData(), width: s, height: a }, l = new hw(100).encode(o, 100);
    return e.processJPEG.call(this, l, t, r, n);
  };
})(we.API), we.API.processRGBA = function(e, A, t) {
  for (var r = e.data, n = r.length, i = new Uint8Array(n / 4 * 3), s = new Uint8Array(n / 4), a = 0, o = 0, l = 0; l < n; l += 4) {
    var c = r[l], u = r[l + 1], d = r[l + 2], h = r[l + 3];
    i[a++] = c, i[a++] = u, i[a++] = d, s[o++] = h;
  }
  var p = this.__addimage__.arrayBufferToBinaryString(i);
  return { alpha: this.__addimage__.arrayBufferToBinaryString(s), data: p, index: A, alias: t, colorSpace: "DeviceRGB", bitsPerComponent: 8, width: e.width, height: e.height };
}, we.API.setLanguage = function(e) {
  return this.internal.languageSettings === void 0 && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), { af: "Afrikaans", sq: "Albanian", ar: "Arabic (Standard)", "ar-DZ": "Arabic (Algeria)", "ar-BH": "Arabic (Bahrain)", "ar-EG": "Arabic (Egypt)", "ar-IQ": "Arabic (Iraq)", "ar-JO": "Arabic (Jordan)", "ar-KW": "Arabic (Kuwait)", "ar-LB": "Arabic (Lebanon)", "ar-LY": "Arabic (Libya)", "ar-MA": "Arabic (Morocco)", "ar-OM": "Arabic (Oman)", "ar-QA": "Arabic (Qatar)", "ar-SA": "Arabic (Saudi Arabia)", "ar-SY": "Arabic (Syria)", "ar-TN": "Arabic (Tunisia)", "ar-AE": "Arabic (U.A.E.)", "ar-YE": "Arabic (Yemen)", an: "Aragonese", hy: "Armenian", as: "Assamese", ast: "Asturian", az: "Azerbaijani", eu: "Basque", be: "Belarusian", bn: "Bengali", bs: "Bosnian", br: "Breton", bg: "Bulgarian", my: "Burmese", ca: "Catalan", ch: "Chamorro", ce: "Chechen", zh: "Chinese", "zh-HK": "Chinese (Hong Kong)", "zh-CN": "Chinese (PRC)", "zh-SG": "Chinese (Singapore)", "zh-TW": "Chinese (Taiwan)", cv: "Chuvash", co: "Corsican", cr: "Cree", hr: "Croatian", cs: "Czech", da: "Danish", nl: "Dutch (Standard)", "nl-BE": "Dutch (Belgian)", en: "English", "en-AU": "English (Australia)", "en-BZ": "English (Belize)", "en-CA": "English (Canada)", "en-IE": "English (Ireland)", "en-JM": "English (Jamaica)", "en-NZ": "English (New Zealand)", "en-PH": "English (Philippines)", "en-ZA": "English (South Africa)", "en-TT": "English (Trinidad & Tobago)", "en-GB": "English (United Kingdom)", "en-US": "English (United States)", "en-ZW": "English (Zimbabwe)", eo: "Esperanto", et: "Estonian", fo: "Faeroese", fj: "Fijian", fi: "Finnish", fr: "French (Standard)", "fr-BE": "French (Belgium)", "fr-CA": "French (Canada)", "fr-FR": "French (France)", "fr-LU": "French (Luxembourg)", "fr-MC": "French (Monaco)", "fr-CH": "French (Switzerland)", fy: "Frisian", fur: "Friulian", gd: "Gaelic (Scots)", "gd-IE": "Gaelic (Irish)", gl: "Galacian", ka: "Georgian", de: "German (Standard)", "de-AT": "German (Austria)", "de-DE": "German (Germany)", "de-LI": "German (Liechtenstein)", "de-LU": "German (Luxembourg)", "de-CH": "German (Switzerland)", el: "Greek", gu: "Gujurati", ht: "Haitian", he: "Hebrew", hi: "Hindi", hu: "Hungarian", is: "Icelandic", id: "Indonesian", iu: "Inuktitut", ga: "Irish", it: "Italian (Standard)", "it-CH": "Italian (Switzerland)", ja: "Japanese", kn: "Kannada", ks: "Kashmiri", kk: "Kazakh", km: "Khmer", ky: "Kirghiz", tlh: "Klingon", ko: "Korean", "ko-KP": "Korean (North Korea)", "ko-KR": "Korean (South Korea)", la: "Latin", lv: "Latvian", lt: "Lithuanian", lb: "Luxembourgish", mk: "North Macedonia", ms: "Malay", ml: "Malayalam", mt: "Maltese", mi: "Maori", mr: "Marathi", mo: "Moldavian", nv: "Navajo", ng: "Ndonga", ne: "Nepali", no: "Norwegian", nb: "Norwegian (Bokmal)", nn: "Norwegian (Nynorsk)", oc: "Occitan", or: "Oriya", om: "Oromo", fa: "Persian", "fa-IR": "Persian/Iran", pl: "Polish", pt: "Portuguese", "pt-BR": "Portuguese (Brazil)", pa: "Punjabi", "pa-IN": "Punjabi (India)", "pa-PK": "Punjabi (Pakistan)", qu: "Quechua", rm: "Rhaeto-Romanic", ro: "Romanian", "ro-MO": "Romanian (Moldavia)", ru: "Russian", "ru-MO": "Russian (Moldavia)", sz: "Sami (Lappish)", sg: "Sango", sa: "Sanskrit", sc: "Sardinian", sd: "Sindhi", si: "Singhalese", sr: "Serbian", sk: "Slovak", sl: "Slovenian", so: "Somani", sb: "Sorbian", es: "Spanish", "es-AR": "Spanish (Argentina)", "es-BO": "Spanish (Bolivia)", "es-CL": "Spanish (Chile)", "es-CO": "Spanish (Colombia)", "es-CR": "Spanish (Costa Rica)", "es-DO": "Spanish (Dominican Republic)", "es-EC": "Spanish (Ecuador)", "es-SV": "Spanish (El Salvador)", "es-GT": "Spanish (Guatemala)", "es-HN": "Spanish (Honduras)", "es-MX": "Spanish (Mexico)", "es-NI": "Spanish (Nicaragua)", "es-PA": "Spanish (Panama)", "es-PY": "Spanish (Paraguay)", "es-PE": "Spanish (Peru)", "es-PR": "Spanish (Puerto Rico)", "es-ES": "Spanish (Spain)", "es-UY": "Spanish (Uruguay)", "es-VE": "Spanish (Venezuela)", sx: "Sutu", sw: "Swahili", sv: "Swedish", "sv-FI": "Swedish (Finland)", "sv-SV": "Swedish (Sweden)", ta: "Tamil", tt: "Tatar", te: "Teluga", th: "Thai", tig: "Tigre", ts: "Tsonga", tn: "Tswana", tr: "Turkish", tk: "Turkmen", uk: "Ukrainian", hsb: "Upper Sorbian", ur: "Urdu", ve: "Venda", vi: "Vietnamese", vo: "Volapuk", wa: "Walloon", cy: "Welsh", xh: "Xhosa", ji: "Yiddish", zu: "Zulu" }[e] !== void 0 && (this.internal.languageSettings.languageCode = e, this.internal.languageSettings.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
  }), this.internal.languageSettings.isSubscribed = !0)), this;
}, Ec = we.API, Bd = Ec.getCharWidthsArray = function(e, A) {
  var t, r, n = (A = A || {}).font || this.internal.getFont(), i = A.fontSize || this.internal.getFontSize(), s = A.charSpace || this.internal.getCharSpace(), a = A.widths ? A.widths : n.metadata.Unicode.widths, o = a.fof ? a.fof : 1, l = A.kerning ? A.kerning : n.metadata.Unicode.kerning, c = l.fof ? l.fof : 1, u = A.doKerning !== !1, d = 0, h = e.length, p = 0, B = a[0] || o, y = [];
  for (t = 0; t < h; t++) r = e.charCodeAt(t), typeof n.metadata.widthOfString == "function" ? y.push((n.metadata.widthOfGlyph(n.metadata.characterToGlyph(r)) + s * (1e3 / i) || 0) / 1e3) : (d = u && it(l[r]) === "object" && !isNaN(parseInt(l[r][p], 10)) ? l[r][p] / c : 0, y.push((a[r] || B) / o + d)), p = r;
  return y;
}, oQ = Ec.getStringUnitWidth = function(e, A) {
  var t = (A = A || {}).fontSize || this.internal.getFontSize(), r = A.font || this.internal.getFont(), n = A.charSpace || this.internal.getCharSpace();
  return Ec.processArabic && (e = Ec.processArabic(e)), typeof r.metadata.widthOfString == "function" ? r.metadata.widthOfString(e, t, n) / t : Bd.apply(this, arguments).reduce(function(i, s) {
    return i + s;
  }, 0);
}, lQ = function(e, A, t, r) {
  for (var n = [], i = 0, s = e.length, a = 0; i !== s && a + A[i] < t; ) a += A[i], i++;
  n.push(e.slice(0, i));
  var o = i;
  for (a = 0; i !== s; ) a + A[i] > r && (n.push(e.slice(o, i)), a = 0, o = i), a += A[i], i++;
  return o !== i && n.push(e.slice(o, i)), n;
}, cQ = function(e, A, t) {
  t || (t = {});
  var r, n, i, s, a, o, l, c = [], u = [c], d = t.textIndent || 0, h = 0, p = 0, B = e.split(" "), y = Bd.apply(this, [" ", t])[0];
  if (o = t.lineIndent === -1 ? B[0].length + 2 : t.lineIndent || 0) {
    var m = Array(o).join(" "), C = [];
    B.map(function(F) {
      (F = F.split(/\s*\n/)).length > 1 ? C = C.concat(F.map(function(T, V) {
        return (V && T.length ? `
` : "") + T;
      })) : C.push(F[0]);
    }), B = C, o = oQ.apply(this, [m, t]);
  }
  for (i = 0, s = B.length; i < s; i++) {
    var Q = 0;
    if (r = B[i], o && r[0] == `
` && (r = r.substr(1), Q = 1), d + h + (p = (n = Bd.apply(this, [r, t])).reduce(function(F, T) {
      return F + T;
    }, 0)) > A || Q) {
      if (p > A) {
        for (a = lQ.apply(this, [r, n, A - (d + h), A]), c.push(a.shift()), c = [a.pop()]; a.length; ) u.push([a.shift()]);
        p = n.slice(r.length - (c[0] ? c[0].length : 0)).reduce(function(F, T) {
          return F + T;
        }, 0);
      } else c = [r];
      u.push(c), d = p + o, h = y;
    } else c.push(r), d += h + p, h = y;
  }
  return l = o ? function(F, T) {
    return (T ? m : "") + F.join(" ");
  } : function(F) {
    return F.join(" ");
  }, u.map(l);
}, Ec.splitTextToSize = function(e, A, t) {
  var r, n = (t = t || {}).fontSize || this.internal.getFontSize(), i = (function(c) {
    if (c.widths && c.kerning) return { widths: c.widths, kerning: c.kerning };
    var u = this.internal.getFont(c.fontName, c.fontStyle), d = "Unicode";
    return u.metadata[d] ? { widths: u.metadata[d].widths || { 0: 1 }, kerning: u.metadata[d].kerning || {} } : { font: u.metadata, fontSize: this.internal.getFontSize(), charSpace: this.internal.getCharSpace() };
  }).call(this, t);
  r = Array.isArray(e) ? e : String(e).split(/\r?\n/);
  var s = 1 * this.internal.scaleFactor * A / n;
  i.textIndent = t.textIndent ? 1 * t.textIndent * this.internal.scaleFactor / n : 0, i.lineIndent = t.lineIndent;
  var a, o, l = [];
  for (a = 0, o = r.length; a < o; a++) l = l.concat(cQ.apply(this, [r[a], s, i]));
  return l;
}, (function(e) {
  e.__fontmetrics__ = e.__fontmetrics__ || {};
  for (var A = "0123456789abcdef", t = "klmnopqrstuvwxyz", r = {}, n = {}, i = 0; i < 16; i++) r[t[i]] = A[i], n[A[i]] = t[i];
  var s = function(d) {
    return "0x" + parseInt(d, 10).toString(16);
  }, a = e.__fontmetrics__.compress = function(d) {
    var h, p, B, y, m = ["{"];
    for (var C in d) {
      if (h = d[C], isNaN(parseInt(C, 10)) ? p = "'" + C + "'" : (C = parseInt(C, 10), p = (p = s(C).slice(2)).slice(0, -1) + n[p.slice(-1)]), typeof h == "number") h < 0 ? (B = s(h).slice(3), y = "-") : (B = s(h).slice(2), y = ""), B = y + B.slice(0, -1) + n[B.slice(-1)];
      else {
        if (it(h) !== "object") throw new Error("Don't know what to do with value type " + it(h) + ".");
        B = a(h);
      }
      m.push(p + B);
    }
    return m.push("}"), m.join("");
  }, o = e.__fontmetrics__.uncompress = function(d) {
    if (typeof d != "string") throw new Error("Invalid argument passed to uncompress.");
    for (var h, p, B, y, m = {}, C = 1, Q = m, F = [], T = "", V = "", M = d.length - 1, D = 1; D < M; D += 1) (y = d[D]) == "'" ? h ? (B = h.join(""), h = void 0) : h = [] : h ? h.push(y) : y == "{" ? (F.push([Q, B]), Q = {}, B = void 0) : y == "}" ? ((p = F.pop())[0][p[1]] = Q, B = void 0, Q = p[0]) : y == "-" ? C = -1 : B === void 0 ? r.hasOwnProperty(y) ? (T += r[y], B = parseInt(T, 16) * C, C = 1, T = "") : T += y : r.hasOwnProperty(y) ? (V += r[y], Q[B] = parseInt(V, 16) * C, C = 1, B = void 0, V = "") : V += y;
    return m;
  }, l = { codePages: ["WinAnsiEncoding"], WinAnsiEncoding: o("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}") }, c = { Unicode: { Courier: l, "Courier-Bold": l, "Courier-BoldOblique": l, "Courier-Oblique": l, Helvetica: l, "Helvetica-Bold": l, "Helvetica-BoldOblique": l, "Helvetica-Oblique": l, "Times-Roman": l, "Times-Bold": l, "Times-BoldItalic": l, "Times-Italic": l } }, u = { Unicode: { "Courier-Oblique": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-BoldItalic": o("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"), "Helvetica-Bold": o("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), Courier: o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-BoldOblique": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Bold": o("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), Symbol: o("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"), Helvetica: o("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"), "Helvetica-BoldOblique": o("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), ZapfDingbats: o("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-Bold": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Italic": o("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"), "Times-Roman": o("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"), "Helvetica-Oblique": o("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}") } };
  e.events.push(["addFont", function(d) {
    var h = d.font, p = u.Unicode[h.postScriptName];
    p && (h.metadata.Unicode = {}, h.metadata.Unicode.widths = p.widths, h.metadata.Unicode.kerning = p.kerning);
    var B = c.Unicode[h.postScriptName];
    B && (h.metadata.Unicode.encoding = B, h.encoding = B.codePages[0]);
  }]);
})(we.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(e) {
  var A = function(t) {
    for (var r = t.length, n = new Uint8Array(r), i = 0; i < r; i++) n[i] = t.charCodeAt(i);
    return n;
  };
  e.API.events.push(["addFont", function(t) {
    var r = void 0, n = t.font, i = t.instance;
    if (!n.isStandardFont) {
      if (i === void 0) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + n.postScriptName + "').");
      if (typeof (r = i.existsFileInVFS(n.postScriptName) === !1 ? i.loadFile(n.postScriptName) : i.getFileFromVFS(n.postScriptName)) != "string") throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + n.postScriptName + "').");
      (function(s, a) {
        a = /^\x00\x01\x00\x00/.test(a) ? A(a) : A(Jd(a)), s.metadata = e.API.TTFFont.open(a), s.metadata.Unicode = s.metadata.Unicode || { encoding: {}, kerning: {}, widths: [] }, s.metadata.glyIdsUsed = [0];
      })(n, r);
    }
  }]);
})(we), we.API.addSvgAsImage = function(e, A, t, r, n, i, s, a) {
  if (isNaN(A) || isNaN(t)) throw Ct.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
  if (isNaN(r) || isNaN(n)) throw Ct.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
  var o = document.createElement("canvas");
  o.width = r, o.height = n;
  var l = o.getContext("2d");
  l.fillStyle = "#fff", l.fillRect(0, 0, o.width, o.height);
  var c = { ignoreMouse: !0, ignoreAnimation: !0, ignoreDimensions: !0 }, u = this;
  return (He.canvg ? Promise.resolve(He.canvg) : Promise.resolve().then(() => EAA)).catch(function(d) {
    return Promise.reject(new Error("Could not load canvg: " + d));
  }).then(function(d) {
    return d.default ? d.default : d;
  }).then(function(d) {
    return d.fromString(l, e, c);
  }, function() {
    return Promise.reject(new Error("Could not load canvg."));
  }).then(function(d) {
    return d.render(c);
  }).then(function() {
    u.addImage(o.toDataURL("image/jpeg", 1), A, t, r, n, s, a);
  });
}, we.API.putTotalPages = function(e) {
  var A, t = 0;
  parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (A = new RegExp(e, "g"), t = this.internal.getNumberOfPages()) : (A = new RegExp(this.pdfEscape16(e, this.internal.getFont()), "g"), t = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
  for (var r = 1; r <= this.internal.getNumberOfPages(); r++) for (var n = 0; n < this.internal.pages[r].length; n++) this.internal.pages[r][n] = this.internal.pages[r][n].replace(A, t);
  return this;
}, we.API.viewerPreferences = function(e, A) {
  var t;
  e = e || {}, A = A || !1;
  var r, n, i, s = { HideToolbar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideMenubar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideWindowUI: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, FitWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, CenterWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, DisplayDocTitle: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.4 }, NonFullScreenPageMode: { defaultValue: "UseNone", value: "UseNone", type: "name", explicitSet: !1, valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"], pdfVersion: 1.3 }, Direction: { defaultValue: "L2R", value: "L2R", type: "name", explicitSet: !1, valueSet: ["L2R", "R2L"], pdfVersion: 1.3 }, ViewArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, ViewClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintScaling: { defaultValue: "AppDefault", value: "AppDefault", type: "name", explicitSet: !1, valueSet: ["AppDefault", "None"], pdfVersion: 1.6 }, Duplex: { defaultValue: "", value: "none", type: "name", explicitSet: !1, valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"], pdfVersion: 1.7 }, PickTrayByPDFSize: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.7 }, PrintPageRange: { defaultValue: "", value: "", type: "array", explicitSet: !1, valueSet: null, pdfVersion: 1.7 }, NumCopies: { defaultValue: 1, value: 1, type: "integer", explicitSet: !1, valueSet: null, pdfVersion: 1.7 } }, a = Object.keys(s), o = [], l = 0, c = 0, u = 0;
  function d(p, B) {
    var y, m = !1;
    for (y = 0; y < p.length; y += 1) p[y] === B && (m = !0);
    return m;
  }
  if (this.internal.viewerpreferences === void 0 && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), t = this.internal.viewerpreferences.configuration, e === "reset" || A === !0) {
    var h = a.length;
    for (u = 0; u < h; u += 1) t[a[u]].value = t[a[u]].defaultValue, t[a[u]].explicitSet = !1;
  }
  if (it(e) === "object") {
    for (n in e) if (i = e[n], d(a, n) && i !== void 0) {
      if (t[n].type === "boolean" && typeof i == "boolean") t[n].value = i;
      else if (t[n].type === "name" && d(t[n].valueSet, i)) t[n].value = i;
      else if (t[n].type === "integer" && Number.isInteger(i)) t[n].value = i;
      else if (t[n].type === "array") {
        for (l = 0; l < i.length; l += 1) if (r = !0, i[l].length === 1 && typeof i[l][0] == "number") o.push(String(i[l] - 1));
        else if (i[l].length > 1) {
          for (c = 0; c < i[l].length; c += 1) typeof i[l][c] != "number" && (r = !1);
          r === !0 && o.push([i[l][0] - 1, i[l][1] - 1].join(" "));
        }
        t[n].value = "[" + o.join(" ") + "]";
      } else t[n].value = t[n].defaultValue;
      t[n].explicitSet = !0;
    }
  }
  return this.internal.viewerpreferences.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    var p, B = [];
    for (p in t) t[p].explicitSet === !0 && (t[p].type === "name" ? B.push("/" + p + " /" + t[p].value) : B.push("/" + p + " " + t[p].value));
    B.length !== 0 && this.internal.write(`/ViewerPreferences
<<
` + B.join(`
`) + `
>>`);
  }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = t, this;
}, we.API.addMetadata = function(e, A) {
  return this.internal.__metadata__ === void 0 && (this.internal.__metadata__ = { metadata: e, namespaceUri: A ?? "http://jspdf.default.namespaceuri/", rawXml: typeof A == "boolean" && A }, this.internal.events.subscribe("putCatalog", XW), this.internal.events.subscribe("postPutResources", zW)), this;
}, (function(e) {
  var A = e.API, t = A.pdfEscape16 = function(i, s) {
    for (var a, o = s.metadata.Unicode.widths, l = ["", "0", "00", "000", "0000"], c = [""], u = 0, d = i.length; u < d; ++u) {
      if (a = s.metadata.characterToGlyph(i.charCodeAt(u)), s.metadata.glyIdsUsed.push(a), s.metadata.toUnicode[a] = i.charCodeAt(u), o.indexOf(a) == -1 && (o.push(a), o.push([parseInt(s.metadata.widthOfGlyph(a), 10)])), a == "0") return c.join("");
      a = a.toString(16), c.push(l[4 - a.length], a);
    }
    return c.join("");
  }, r = function(i) {
    var s, a, o, l, c, u, d;
    for (c = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange`, o = [], u = 0, d = (a = Object.keys(i).sort(function(h, p) {
      return h - p;
    })).length; u < d; u++) s = a[u], o.length >= 100 && (c += `
` + o.length + ` beginbfchar
` + o.join(`
`) + `
endbfchar`, o = []), i[s] !== void 0 && i[s] !== null && typeof i[s].toString == "function" && (l = ("0000" + i[s].toString(16)).slice(-4), s = ("0000" + (+s).toString(16)).slice(-4), o.push("<" + s + "><" + l + ">"));
    return o.length && (c += `
` + o.length + ` beginbfchar
` + o.join(`
`) + `
endbfchar
`), c + `endcmap
CMapName currentdict /CMap defineresource pop
end
end`;
  };
  A.events.push(["putFont", function(i) {
    (function(s) {
      var a = s.font, o = s.out, l = s.newObject, c = s.putStream;
      if (a.metadata instanceof e.API.TTFFont && a.encoding === "Identity-H") {
        for (var u = a.metadata.Unicode.widths, d = a.metadata.subset.encode(a.metadata.glyIdsUsed, 1), h = "", p = 0; p < d.length; p++) h += String.fromCharCode(d[p]);
        var B = l();
        c({ data: h, addLength1: !0, objectId: B }), o("endobj");
        var y = l();
        c({ data: r(a.metadata.toUnicode), addLength1: !0, objectId: y }), o("endobj");
        var m = l();
        o("<<"), o("/Type /FontDescriptor"), o("/FontName /" + Dc(a.fontName)), o("/FontFile2 " + B + " 0 R"), o("/FontBBox " + e.API.PDFObject.convert(a.metadata.bbox)), o("/Flags " + a.metadata.flags), o("/StemV " + a.metadata.stemV), o("/ItalicAngle " + a.metadata.italicAngle), o("/Ascent " + a.metadata.ascender), o("/Descent " + a.metadata.decender), o("/CapHeight " + a.metadata.capHeight), o(">>"), o("endobj");
        var C = l();
        o("<<"), o("/Type /Font"), o("/BaseFont /" + Dc(a.fontName)), o("/FontDescriptor " + m + " 0 R"), o("/W " + e.API.PDFObject.convert(u)), o("/CIDToGIDMap /Identity"), o("/DW 1000"), o("/Subtype /CIDFontType2"), o("/CIDSystemInfo"), o("<<"), o("/Supplement 0"), o("/Registry (Adobe)"), o("/Ordering (" + a.encoding + ")"), o(">>"), o(">>"), o("endobj"), a.objectNumber = l(), o("<<"), o("/Type /Font"), o("/Subtype /Type0"), o("/ToUnicode " + y + " 0 R"), o("/BaseFont /" + Dc(a.fontName)), o("/Encoding /" + a.encoding), o("/DescendantFonts [" + C + " 0 R]"), o(">>"), o("endobj"), a.isAlreadyPutted = !0;
      }
    })(i);
  }]), A.events.push(["putFont", function(i) {
    (function(s) {
      var a = s.font, o = s.out, l = s.newObject, c = s.putStream;
      if (a.metadata instanceof e.API.TTFFont && a.encoding === "WinAnsiEncoding") {
        for (var u = a.metadata.rawData, d = "", h = 0; h < u.length; h++) d += String.fromCharCode(u[h]);
        var p = l();
        c({ data: d, addLength1: !0, objectId: p }), o("endobj");
        var B = l();
        c({ data: r(a.metadata.toUnicode), addLength1: !0, objectId: B }), o("endobj");
        var y = l();
        o("<<"), o("/Descent " + a.metadata.decender), o("/CapHeight " + a.metadata.capHeight), o("/StemV " + a.metadata.stemV), o("/Type /FontDescriptor"), o("/FontFile2 " + p + " 0 R"), o("/Flags 96"), o("/FontBBox " + e.API.PDFObject.convert(a.metadata.bbox)), o("/FontName /" + Dc(a.fontName)), o("/ItalicAngle " + a.metadata.italicAngle), o("/Ascent " + a.metadata.ascender), o(">>"), o("endobj"), a.objectNumber = l();
        for (var m = 0; m < a.metadata.hmtx.widths.length; m++) a.metadata.hmtx.widths[m] = parseInt(a.metadata.hmtx.widths[m] * (1e3 / a.metadata.head.unitsPerEm));
        o("<</Subtype/TrueType/Type/Font/ToUnicode " + B + " 0 R/BaseFont/" + Dc(a.fontName) + "/FontDescriptor " + y + " 0 R/Encoding/" + a.encoding + " /FirstChar 29 /LastChar 255 /Widths " + e.API.PDFObject.convert(a.metadata.hmtx.widths) + ">>"), o("endobj"), a.isAlreadyPutted = !0;
      }
    })(i);
  }]);
  var n = function(i) {
    var s, a = i.text || "", o = i.x, l = i.y, c = i.options || {}, u = i.mutex || {}, d = u.pdfEscape, h = u.activeFontKey, p = u.fonts, B = h, y = "", m = 0, C = "", Q = p[B].encoding;
    if (p[B].encoding !== "Identity-H") return { text: a, x: o, y: l, options: c, mutex: u };
    for (C = a, B = h, Array.isArray(a) && (C = a[0]), m = 0; m < C.length; m += 1) p[B].metadata.hasOwnProperty("cmap") && (s = p[B].metadata.cmap.unicode.codeMap[C[m].charCodeAt(0)]), s || C[m].charCodeAt(0) < 256 && p[B].metadata.hasOwnProperty("Unicode") ? y += C[m] : y += "";
    var F = "";
    return parseInt(B.slice(1)) < 14 || Q === "WinAnsiEncoding" ? F = d(y, B).split("").map(function(T) {
      return T.charCodeAt(0).toString(16);
    }).join("") : Q === "Identity-H" && (F = t(y, p[B])), u.isHex = !0, { text: F, x: o, y: l, options: c, mutex: u };
  };
  A.events.push(["postProcessText", function(i) {
    var s = i.text || "", a = [], o = { text: s, x: i.x, y: i.y, options: i.options, mutex: i.mutex };
    if (Array.isArray(s)) {
      var l = 0;
      for (l = 0; l < s.length; l += 1) Array.isArray(s[l]) && s[l].length === 3 ? a.push([n(Object.assign({}, o, { text: s[l][0] })).text, s[l][1], s[l][2]]) : a.push(n(Object.assign({}, o, { text: s[l] })).text);
      i.text = a;
    } else i.text = n(Object.assign({}, o, { text: s })).text;
  }]);
})(we), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(e) {
  var A = function() {
    return this.internal.vFS === void 0 && (this.internal.vFS = {}), !0;
  };
  e.existsFileInVFS = function(t) {
    return A.call(this), this.internal.vFS[t] !== void 0;
  }, e.addFileToVFS = function(t, r) {
    return A.call(this), this.internal.vFS[t] = r, this;
  }, e.getFileFromVFS = function(t) {
    return A.call(this), this.internal.vFS[t] !== void 0 ? this.internal.vFS[t] : null;
  };
})(we.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
(function(e) {
  e.__bidiEngine__ = e.prototype.__bidiEngine__ = function(r) {
    var n, i, s, a, o, l, c, u = A, d = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]], h = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]], p = { L: 0, R: 1, EN: 2, AN: 3, N: 4, B: 5, S: 6 }, B = { 0: 0, 5: 1, 6: 2, 7: 3, 32: 4, 251: 5, 254: 6, 255: 7 }, y = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "«", "»", "«", "‹", "›", "‹", "⁅", "⁆", "⁅", "⁽", "⁾", "⁽", "₍", "₎", "₍", "≤", "≥", "≤", "〈", "〉", "〈", "﹙", "﹚", "﹙", "﹛", "﹜", "﹛", "﹝", "﹞", "﹝", "﹤", "﹥", "﹤"], m = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), C = !1, Q = 0;
    this.__bidiEngine__ = {};
    var F = function(U) {
      var x = U.charCodeAt(), P = x >> 8, N = B[P];
      return N !== void 0 ? u[256 * N + (255 & x)] : P === 252 || P === 253 ? "AL" : m.test(P) ? "L" : P === 8 ? "R" : "N";
    }, T = function(U) {
      for (var x, P = 0; P < U.length; P++) {
        if ((x = F(U.charAt(P))) === "L") return !1;
        if (x === "R") return !0;
      }
      return !1;
    }, V = function(U, x, P, N) {
      var iA, nA, sA, tA, cA = x[N];
      switch (cA) {
        case "L":
        case "R":
        case "LRE":
        case "RLE":
        case "LRO":
        case "RLO":
        case "PDF":
          C = !1;
          break;
        case "N":
        case "AN":
          break;
        case "EN":
          C && (cA = "AN");
          break;
        case "AL":
          C = !0, cA = "R";
          break;
        case "WS":
        case "BN":
          cA = "N";
          break;
        case "CS":
          N < 1 || N + 1 >= x.length || (iA = P[N - 1]) !== "EN" && iA !== "AN" || (nA = x[N + 1]) !== "EN" && nA !== "AN" ? cA = "N" : C && (nA = "AN"), cA = nA === iA ? nA : "N";
          break;
        case "ES":
          cA = (iA = N > 0 ? P[N - 1] : "B") === "EN" && N + 1 < x.length && x[N + 1] === "EN" ? "EN" : "N";
          break;
        case "ET":
          if (N > 0 && P[N - 1] === "EN") {
            cA = "EN";
            break;
          }
          if (C) {
            cA = "N";
            break;
          }
          for (sA = N + 1, tA = x.length; sA < tA && x[sA] === "ET"; ) sA++;
          cA = sA < tA && x[sA] === "EN" ? "EN" : "N";
          break;
        case "NSM":
          if (s && !a) {
            for (tA = x.length, sA = N + 1; sA < tA && x[sA] === "NSM"; ) sA++;
            if (sA < tA) {
              var FA = U[N], CA = FA >= 1425 && FA <= 2303 || FA === 64286;
              if (iA = x[sA], CA && (iA === "R" || iA === "AL")) {
                cA = "R";
                break;
              }
            }
          }
          cA = N < 1 || (iA = x[N - 1]) === "B" ? "N" : P[N - 1];
          break;
        case "B":
          C = !1, n = !0, cA = Q;
          break;
        case "S":
          i = !0, cA = "N";
      }
      return cA;
    }, M = function(U, x, P) {
      var N = U.split("");
      return P && D(N, P, { hiLevel: Q }), N.reverse(), x && x.reverse(), N.join("");
    }, D = function(U, x, P) {
      var N, iA, nA, sA, tA, cA = -1, FA = U.length, CA = 0, S = [], W = Q ? h : d, Y = [];
      for (C = !1, n = !1, i = !1, iA = 0; iA < FA; iA++) Y[iA] = F(U[iA]);
      for (nA = 0; nA < FA; nA++) {
        if (tA = CA, S[nA] = V(U, Y, S, nA), N = 240 & (CA = W[tA][p[S[nA]]]), CA &= 15, x[nA] = sA = W[CA][5], N > 0) if (N === 16) {
          for (iA = cA; iA < nA; iA++) x[iA] = 1;
          cA = -1;
        } else cA = -1;
        if (W[CA][6]) cA === -1 && (cA = nA);
        else if (cA > -1) {
          for (iA = cA; iA < nA; iA++) x[iA] = sA;
          cA = -1;
        }
        Y[nA] === "B" && (x[nA] = 0), P.hiLevel |= sA;
      }
      i && (function(AA, oA, gA) {
        for (var xA = 0; xA < gA; xA++) if (AA[xA] === "S") {
          oA[xA] = Q;
          for (var IA = xA - 1; IA >= 0 && AA[IA] === "WS"; IA--) oA[IA] = Q;
        }
      })(Y, x, FA);
    }, I = function(U, x, P, N, iA) {
      if (!(iA.hiLevel < U)) {
        if (U === 1 && Q === 1 && !n) return x.reverse(), void (P && P.reverse());
        for (var nA, sA, tA, cA, FA = x.length, CA = 0; CA < FA; ) {
          if (N[CA] >= U) {
            for (tA = CA + 1; tA < FA && N[tA] >= U; ) tA++;
            for (cA = CA, sA = tA - 1; cA < sA; cA++, sA--) nA = x[cA], x[cA] = x[sA], x[sA] = nA, P && (nA = P[cA], P[cA] = P[sA], P[sA] = nA);
            CA = tA;
          }
          CA++;
        }
      }
    }, q = function(U, x, P) {
      var N = U.split(""), iA = { hiLevel: Q };
      return P || (P = []), D(N, P, iA), (function(nA, sA, tA) {
        if (tA.hiLevel !== 0 && c) for (var cA, FA = 0; FA < nA.length; FA++) sA[FA] === 1 && (cA = y.indexOf(nA[FA])) >= 0 && (nA[FA] = y[cA + 1]);
      })(N, P, iA), I(2, N, x, P, iA), I(1, N, x, P, iA), N.join("");
    };
    return this.__bidiEngine__.doBidiReorder = function(U, x, P) {
      if ((function(iA, nA) {
        if (nA) for (var sA = 0; sA < iA.length; sA++) nA[sA] = sA;
        a === void 0 && (a = T(iA)), l === void 0 && (l = T(iA));
      })(U, x), s || !o || l) if (s && o && a ^ l) Q = a ? 1 : 0, U = M(U, x, P);
      else if (!s && o && l) Q = a ? 1 : 0, U = q(U, x, P), U = M(U, x);
      else if (!s || a || o || l) {
        if (s && !o && a ^ l) U = M(U, x), a ? (Q = 0, U = q(U, x, P)) : (Q = 1, U = q(U, x, P), U = M(U, x));
        else if (s && a && !o && l) Q = 1, U = q(U, x, P), U = M(U, x);
        else if (!s && !o && a ^ l) {
          var N = c;
          a ? (Q = 1, U = q(U, x, P), Q = 0, c = !1, U = q(U, x, P), c = N) : (Q = 0, U = q(U, x, P), U = M(U, x), Q = 1, c = !1, U = q(U, x, P), c = N, U = M(U, x));
        }
      } else Q = 0, U = q(U, x, P);
      else Q = a ? 1 : 0, U = q(U, x, P);
      return U;
    }, this.__bidiEngine__.setOptions = function(U) {
      U && (s = U.isInputVisual, o = U.isOutputVisual, a = U.isInputRtl, l = U.isOutputRtl, c = U.isSymmetricSwapping);
    }, this.__bidiEngine__.setOptions(r), this.__bidiEngine__;
  };
  var A = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"], t = new e.__bidiEngine__({ isInputVisual: !0 });
  e.API.events.push(["postProcessText", function(r) {
    var n = r.text;
    r.x, r.y;
    var i = r.options || {};
    r.mutex, i.lang;
    var s = [];
    if (i.isInputVisual = typeof i.isInputVisual != "boolean" || i.isInputVisual, t.setOptions(i), Object.prototype.toString.call(n) === "[object Array]") {
      var a = 0;
      for (s = [], a = 0; a < n.length; a += 1) Object.prototype.toString.call(n[a]) === "[object Array]" ? s.push([t.doBidiReorder(n[a][0]), n[a][1], n[a][2]]) : s.push([t.doBidiReorder(n[a])]);
      r.text = s;
    } else r.text = t.doBidiReorder(n);
    t.setOptions({ isInputVisual: !0 });
  }]);
})(we), we.API.TTFFont = (function() {
  function e(A) {
    var t;
    if (this.rawData = A, t = this.contents = new Po(A), this.contents.pos = 4, t.readString(4) === "ttcf") throw new Error("TTCF not supported.");
    t.pos = 0, this.parse(), this.subset = new uj(this), this.registerTTF();
  }
  return e.open = function(A) {
    return new e(A);
  }, e.prototype.parse = function() {
    return this.directory = new YW(this.contents), this.head = new ZW(this), this.name = new nj(this), this.cmap = new M3(this), this.toUnicode = {}, this.hhea = new Aj(this), this.maxp = new ij(this), this.hmtx = new sj(this), this.post = new tj(this), this.os2 = new ej(this), this.loca = new cj(this), this.glyf = new aj(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
  }, e.prototype.registerTTF = function() {
    var A, t, r, n, i;
    if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
      var s, a, o, l;
      for (l = [], s = 0, a = (o = this.bbox).length; s < a; s++) A = o[s], l.push(Math.round(A * this.scaleFactor));
      return l;
    }).call(this), this.stemV = 0, this.post.exists ? (r = 255 & (n = this.post.italic_angle), 32768 & (t = n >> 16) && (t = -(1 + (65535 ^ t))), this.italicAngle = +(t + "." + r)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = (i = this.familyClass) === 1 || i === 2 || i === 3 || i === 4 || i === 5 || i === 7, this.isScript = this.familyClass === 10, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), this.italicAngle !== 0 && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
  }, e.prototype.characterToGlyph = function(A) {
    var t;
    return ((t = this.cmap.unicode) != null ? t.codeMap[A] : void 0) || 0;
  }, e.prototype.widthOfGlyph = function(A) {
    var t;
    return t = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(A).advance * t;
  }, e.prototype.widthOfString = function(A, t, r) {
    var n, i, s, a;
    for (s = 0, i = 0, a = (A = "" + A).length; 0 <= a ? i < a : i > a; i = 0 <= a ? ++i : --i) n = A.charCodeAt(i), s += this.widthOfGlyph(this.characterToGlyph(n)) + r * (1e3 / t) || 0;
    return s * (t / 1e3);
  }, e.prototype.lineHeight = function(A, t) {
    var r;
    return t == null && (t = !1), r = t ? this.lineGap : 0, (this.ascender + r - this.decender) / 1e3 * A;
  }, e;
})();
var Qs, Po = (function() {
  function e(A) {
    this.data = A ?? [], this.pos = 0, this.length = this.data.length;
  }
  return e.prototype.readByte = function() {
    return this.data[this.pos++];
  }, e.prototype.writeByte = function(A) {
    return this.data[this.pos++] = A;
  }, e.prototype.readUInt32 = function() {
    return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
  }, e.prototype.writeUInt32 = function(A) {
    return this.writeByte(A >>> 24 & 255), this.writeByte(A >> 16 & 255), this.writeByte(A >> 8 & 255), this.writeByte(255 & A);
  }, e.prototype.readInt32 = function() {
    var A;
    return (A = this.readUInt32()) >= 2147483648 ? A - 4294967296 : A;
  }, e.prototype.writeInt32 = function(A) {
    return A < 0 && (A += 4294967296), this.writeUInt32(A);
  }, e.prototype.readUInt16 = function() {
    return this.readByte() << 8 | this.readByte();
  }, e.prototype.writeUInt16 = function(A) {
    return this.writeByte(A >> 8 & 255), this.writeByte(255 & A);
  }, e.prototype.readInt16 = function() {
    var A;
    return (A = this.readUInt16()) >= 32768 ? A - 65536 : A;
  }, e.prototype.writeInt16 = function(A) {
    return A < 0 && (A += 65536), this.writeUInt16(A);
  }, e.prototype.readString = function(A) {
    var t, r;
    for (r = [], t = 0; 0 <= A ? t < A : t > A; t = 0 <= A ? ++t : --t) r[t] = String.fromCharCode(this.readByte());
    return r.join("");
  }, e.prototype.writeString = function(A) {
    var t, r, n;
    for (n = [], t = 0, r = A.length; 0 <= r ? t < r : t > r; t = 0 <= r ? ++t : --t) n.push(this.writeByte(A.charCodeAt(t)));
    return n;
  }, e.prototype.readShort = function() {
    return this.readInt16();
  }, e.prototype.writeShort = function(A) {
    return this.writeInt16(A);
  }, e.prototype.readLongLong = function() {
    var A, t, r, n, i, s, a, o;
    return A = this.readByte(), t = this.readByte(), r = this.readByte(), n = this.readByte(), i = this.readByte(), s = this.readByte(), a = this.readByte(), o = this.readByte(), 128 & A ? -1 * (72057594037927940 * (255 ^ A) + 281474976710656 * (255 ^ t) + 1099511627776 * (255 ^ r) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ i) + 65536 * (255 ^ s) + 256 * (255 ^ a) + (255 ^ o) + 1) : 72057594037927940 * A + 281474976710656 * t + 1099511627776 * r + 4294967296 * n + 16777216 * i + 65536 * s + 256 * a + o;
  }, e.prototype.writeLongLong = function(A) {
    var t, r;
    return t = Math.floor(A / 4294967296), r = 4294967295 & A, this.writeByte(t >> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t), this.writeByte(r >> 24 & 255), this.writeByte(r >> 16 & 255), this.writeByte(r >> 8 & 255), this.writeByte(255 & r);
  }, e.prototype.readInt = function() {
    return this.readInt32();
  }, e.prototype.writeInt = function(A) {
    return this.writeInt32(A);
  }, e.prototype.read = function(A) {
    var t, r;
    for (t = [], r = 0; 0 <= A ? r < A : r > A; r = 0 <= A ? ++r : --r) t.push(this.readByte());
    return t;
  }, e.prototype.write = function(A) {
    var t, r, n, i;
    for (i = [], r = 0, n = A.length; r < n; r++) t = A[r], i.push(this.writeByte(t));
    return i;
  }, e;
})(), YW = (function() {
  var e;
  function A(t) {
    var r, n, i;
    for (this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, i = this.tableCount; 0 <= i ? n < i : n > i; n = 0 <= i ? ++n : --n) r = { tag: t.readString(4), checksum: t.readInt(), offset: t.readInt(), length: t.readInt() }, this.tables[r.tag] = r;
  }
  return A.prototype.encode = function(t) {
    var r, n, i, s, a, o, l, c, u, d, h, p, B;
    for (B in h = Object.keys(t).length, o = Math.log(2), u = 16 * Math.floor(Math.log(h) / o), s = Math.floor(u / o), c = 16 * h - u, (n = new Po()).writeInt(this.scalarType), n.writeShort(h), n.writeShort(u), n.writeShort(s), n.writeShort(c), i = 16 * h, l = n.pos + i, a = null, p = [], t) for (d = t[B], n.writeString(B), n.writeInt(e(d)), n.writeInt(l), n.writeInt(d.length), p = p.concat(d), B === "head" && (a = l), l += d.length; l % 4; ) p.push(0), l++;
    return n.write(p), r = 2981146554 - e(n.data), n.pos = a + 8, n.writeUInt32(r), n.data;
  }, e = function(t) {
    var r, n, i, s;
    for (t = P3.call(t); t.length % 4; ) t.push(0);
    for (i = new Po(t), n = 0, r = 0, s = t.length; r < s; r = r += 4) n += i.readUInt32();
    return 4294967295 & n;
  }, A;
})(), JW = {}.hasOwnProperty, Js = function(e, A) {
  for (var t in A) JW.call(A, t) && (e[t] = A[t]);
  function r() {
    this.constructor = e;
  }
  return r.prototype = A.prototype, e.prototype = new r(), e.__super__ = A.prototype, e;
};
Qs = (function() {
  function e(A) {
    var t;
    this.file = A, t = this.file.directory.tables[this.tag], this.exists = !!t, t && (this.offset = t.offset, this.length = t.length, this.parse(this.file.contents));
  }
  return e.prototype.parse = function() {
  }, e.prototype.encode = function() {
  }, e.prototype.raw = function() {
    return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
  }, e;
})();
var ZW = (function() {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Js(e, Qs), e.prototype.tag = "head", e.prototype.parse = function(A) {
    return A.pos = this.offset, this.version = A.readInt(), this.revision = A.readInt(), this.checkSumAdjustment = A.readInt(), this.magicNumber = A.readInt(), this.flags = A.readShort(), this.unitsPerEm = A.readShort(), this.created = A.readLongLong(), this.modified = A.readLongLong(), this.xMin = A.readShort(), this.yMin = A.readShort(), this.xMax = A.readShort(), this.yMax = A.readShort(), this.macStyle = A.readShort(), this.lowestRecPPEM = A.readShort(), this.fontDirectionHint = A.readShort(), this.indexToLocFormat = A.readShort(), this.glyphDataFormat = A.readShort();
  }, e.prototype.encode = function(A) {
    var t;
    return (t = new Po()).writeInt(this.version), t.writeInt(this.revision), t.writeInt(this.checkSumAdjustment), t.writeInt(this.magicNumber), t.writeShort(this.flags), t.writeShort(this.unitsPerEm), t.writeLongLong(this.created), t.writeLongLong(this.modified), t.writeShort(this.xMin), t.writeShort(this.yMin), t.writeShort(this.xMax), t.writeShort(this.yMax), t.writeShort(this.macStyle), t.writeShort(this.lowestRecPPEM), t.writeShort(this.fontDirectionHint), t.writeShort(A), t.writeShort(this.glyphDataFormat), t.data;
  }, e;
})(), mQ = (function() {
  function e(A, t) {
    var r, n, i, s, a, o, l, c, u, d, h, p, B, y, m, C, Q;
    switch (this.platformID = A.readUInt16(), this.encodingID = A.readShort(), this.offset = t + A.readInt(), u = A.pos, A.pos = this.offset, this.format = A.readUInt16(), this.length = A.readUInt16(), this.language = A.readUInt16(), this.isUnicode = this.platformID === 3 && this.encodingID === 1 && this.format === 4 || this.platformID === 0 && this.format === 4, this.codeMap = {}, this.format) {
      case 0:
        for (o = 0; o < 256; ++o) this.codeMap[o] = A.readByte();
        break;
      case 4:
        for (h = A.readUInt16(), d = h / 2, A.pos += 6, i = (function() {
          var F, T;
          for (T = [], o = F = 0; 0 <= d ? F < d : F > d; o = 0 <= d ? ++F : --F) T.push(A.readUInt16());
          return T;
        })(), A.pos += 2, B = (function() {
          var F, T;
          for (T = [], o = F = 0; 0 <= d ? F < d : F > d; o = 0 <= d ? ++F : --F) T.push(A.readUInt16());
          return T;
        })(), l = (function() {
          var F, T;
          for (T = [], o = F = 0; 0 <= d ? F < d : F > d; o = 0 <= d ? ++F : --F) T.push(A.readUInt16());
          return T;
        })(), c = (function() {
          var F, T;
          for (T = [], o = F = 0; 0 <= d ? F < d : F > d; o = 0 <= d ? ++F : --F) T.push(A.readUInt16());
          return T;
        })(), n = (this.length - A.pos + this.offset) / 2, a = (function() {
          var F, T;
          for (T = [], o = F = 0; 0 <= n ? F < n : F > n; o = 0 <= n ? ++F : --F) T.push(A.readUInt16());
          return T;
        })(), o = m = 0, Q = i.length; m < Q; o = ++m) for (y = i[o], r = C = p = B[o]; p <= y ? C <= y : C >= y; r = p <= y ? ++C : --C) c[o] === 0 ? s = r + l[o] : (s = a[c[o] / 2 + (r - p) - (d - o)] || 0) !== 0 && (s += l[o]), this.codeMap[r] = 65535 & s;
    }
    A.pos = u;
  }
  return e.encode = function(A, t) {
    var r, n, i, s, a, o, l, c, u, d, h, p, B, y, m, C, Q, F, T, V, M, D, I, q, U, x, P, N, iA, nA, sA, tA, cA, FA, CA, S, W, Y, AA, oA, gA, xA, IA, pA, WA, k;
    switch (N = new Po(), s = Object.keys(A).sort(function(X, uA) {
      return X - uA;
    }), t) {
      case "macroman":
        for (B = 0, y = (function() {
          var X = [];
          for (p = 0; p < 256; ++p) X.push(0);
          return X;
        })(), C = { 0: 0 }, i = {}, iA = 0, cA = s.length; iA < cA; iA++) C[IA = A[n = s[iA]]] == null && (C[IA] = ++B), i[n] = { old: A[n], new: C[A[n]] }, y[n] = C[A[n]];
        return N.writeUInt16(1), N.writeUInt16(0), N.writeUInt32(12), N.writeUInt16(0), N.writeUInt16(262), N.writeUInt16(0), N.write(y), { charMap: i, subtable: N.data, maxGlyphID: B + 1 };
      case "unicode":
        for (x = [], u = [], Q = 0, C = {}, r = {}, m = l = null, nA = 0, FA = s.length; nA < FA; nA++) C[T = A[n = s[nA]]] == null && (C[T] = ++Q), r[n] = { old: T, new: C[T] }, a = C[T] - n, m != null && a === l || (m && u.push(m), x.push(n), l = a), m = n;
        for (m && u.push(m), u.push(65535), x.push(65535), q = 2 * (I = x.length), D = 2 * Math.pow(Math.log(I) / Math.LN2, 2), d = Math.log(D / 2) / Math.LN2, M = 2 * I - D, o = [], V = [], h = [], p = sA = 0, CA = x.length; sA < CA; p = ++sA) {
          if (U = x[p], c = u[p], U === 65535) {
            o.push(0), V.push(0);
            break;
          }
          if (U - (P = r[U].new) >= 32768) for (o.push(0), V.push(2 * (h.length + I - p)), n = tA = U; U <= c ? tA <= c : tA >= c; n = U <= c ? ++tA : --tA) h.push(r[n].new);
          else o.push(P - U), V.push(0);
        }
        for (N.writeUInt16(3), N.writeUInt16(1), N.writeUInt32(12), N.writeUInt16(4), N.writeUInt16(16 + 8 * I + 2 * h.length), N.writeUInt16(0), N.writeUInt16(q), N.writeUInt16(D), N.writeUInt16(d), N.writeUInt16(M), gA = 0, S = u.length; gA < S; gA++) n = u[gA], N.writeUInt16(n);
        for (N.writeUInt16(0), xA = 0, W = x.length; xA < W; xA++) n = x[xA], N.writeUInt16(n);
        for (pA = 0, Y = o.length; pA < Y; pA++) a = o[pA], N.writeUInt16(a);
        for (WA = 0, AA = V.length; WA < AA; WA++) F = V[WA], N.writeUInt16(F);
        for (k = 0, oA = h.length; k < oA; k++) B = h[k], N.writeUInt16(B);
        return { charMap: r, subtable: N.data, maxGlyphID: Q + 1 };
    }
  }, e;
})(), M3 = (function() {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Js(e, Qs), e.prototype.tag = "cmap", e.prototype.parse = function(A) {
    var t, r, n;
    for (A.pos = this.offset, this.version = A.readUInt16(), n = A.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r) t = new mQ(A, this.offset), this.tables.push(t), t.isUnicode && this.unicode == null && (this.unicode = t);
    return !0;
  }, e.encode = function(A, t) {
    var r, n;
    return t == null && (t = "macroman"), r = mQ.encode(A, t), (n = new Po()).writeUInt16(0), n.writeUInt16(1), r.table = n.data.concat(r.subtable), r;
  }, e;
})(), Aj = (function() {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Js(e, Qs), e.prototype.tag = "hhea", e.prototype.parse = function(A) {
    return A.pos = this.offset, this.version = A.readInt(), this.ascender = A.readShort(), this.decender = A.readShort(), this.lineGap = A.readShort(), this.advanceWidthMax = A.readShort(), this.minLeftSideBearing = A.readShort(), this.minRightSideBearing = A.readShort(), this.xMaxExtent = A.readShort(), this.caretSlopeRise = A.readShort(), this.caretSlopeRun = A.readShort(), this.caretOffset = A.readShort(), A.pos += 8, this.metricDataFormat = A.readShort(), this.numberOfMetrics = A.readUInt16();
  }, e;
})(), ej = (function() {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Js(e, Qs), e.prototype.tag = "OS/2", e.prototype.parse = function(A) {
    if (A.pos = this.offset, this.version = A.readUInt16(), this.averageCharWidth = A.readShort(), this.weightClass = A.readUInt16(), this.widthClass = A.readUInt16(), this.type = A.readShort(), this.ySubscriptXSize = A.readShort(), this.ySubscriptYSize = A.readShort(), this.ySubscriptXOffset = A.readShort(), this.ySubscriptYOffset = A.readShort(), this.ySuperscriptXSize = A.readShort(), this.ySuperscriptYSize = A.readShort(), this.ySuperscriptXOffset = A.readShort(), this.ySuperscriptYOffset = A.readShort(), this.yStrikeoutSize = A.readShort(), this.yStrikeoutPosition = A.readShort(), this.familyClass = A.readShort(), this.panose = (function() {
      var t, r;
      for (r = [], t = 0; t < 10; ++t) r.push(A.readByte());
      return r;
    })(), this.charRange = (function() {
      var t, r;
      for (r = [], t = 0; t < 4; ++t) r.push(A.readInt());
      return r;
    })(), this.vendorID = A.readString(4), this.selection = A.readShort(), this.firstCharIndex = A.readShort(), this.lastCharIndex = A.readShort(), this.version > 0 && (this.ascent = A.readShort(), this.descent = A.readShort(), this.lineGap = A.readShort(), this.winAscent = A.readShort(), this.winDescent = A.readShort(), this.codePageRange = (function() {
      var t, r;
      for (r = [], t = 0; t < 2; t = ++t) r.push(A.readInt());
      return r;
    })(), this.version > 1)) return this.xHeight = A.readShort(), this.capHeight = A.readShort(), this.defaultChar = A.readShort(), this.breakChar = A.readShort(), this.maxContext = A.readShort();
  }, e;
})(), tj = (function() {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Js(e, Qs), e.prototype.tag = "post", e.prototype.parse = function(A) {
    var t, r, n;
    switch (A.pos = this.offset, this.format = A.readInt(), this.italicAngle = A.readInt(), this.underlinePosition = A.readShort(), this.underlineThickness = A.readShort(), this.isFixedPitch = A.readInt(), this.minMemType42 = A.readInt(), this.maxMemType42 = A.readInt(), this.minMemType1 = A.readInt(), this.maxMemType1 = A.readInt(), this.format) {
      case 65536:
      case 196608:
        break;
      case 131072:
        var i;
        for (r = A.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= r ? i < r : i > r; i = 0 <= r ? ++i : --i) this.glyphNameIndex.push(A.readUInt16());
        for (this.names = [], n = []; A.pos < this.offset + this.length; ) t = A.readByte(), n.push(this.names.push(A.readString(t)));
        return n;
      case 151552:
        return r = A.readUInt16(), this.offsets = A.read(r);
      case 262144:
        return this.map = (function() {
          var s, a, o;
          for (o = [], i = s = 0, a = this.file.maxp.numGlyphs; 0 <= a ? s < a : s > a; i = 0 <= a ? ++s : --s) o.push(A.readUInt32());
          return o;
        }).call(this);
    }
  }, e;
})(), rj = function(e, A) {
  this.raw = e, this.length = e.length, this.platformID = A.platformID, this.encodingID = A.encodingID, this.languageID = A.languageID;
}, nj = (function() {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Js(e, Qs), e.prototype.tag = "name", e.prototype.parse = function(A) {
    var t, r, n, i, s, a, o, l, c, u, d;
    for (A.pos = this.offset, A.readShort(), t = A.readShort(), a = A.readShort(), r = [], i = 0; 0 <= t ? i < t : i > t; i = 0 <= t ? ++i : --i) r.push({ platformID: A.readShort(), encodingID: A.readShort(), languageID: A.readShort(), nameID: A.readShort(), length: A.readShort(), offset: this.offset + a + A.readShort() });
    for (o = {}, i = c = 0, u = r.length; c < u; i = ++c) n = r[i], A.pos = n.offset, l = A.readString(n.length), s = new rj(l, n), o[d = n.nameID] == null && (o[d] = []), o[n.nameID].push(s);
    this.strings = o, this.copyright = o[0], this.fontFamily = o[1], this.fontSubfamily = o[2], this.uniqueSubfamily = o[3], this.fontName = o[4], this.version = o[5];
    try {
      this.postscriptName = o[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    } catch {
      this.postscriptName = o[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    }
    return this.trademark = o[7], this.manufacturer = o[8], this.designer = o[9], this.description = o[10], this.vendorUrl = o[11], this.designerUrl = o[12], this.license = o[13], this.licenseUrl = o[14], this.preferredFamily = o[15], this.preferredSubfamily = o[17], this.compatibleFull = o[18], this.sampleText = o[19];
  }, e;
})(), ij = (function() {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Js(e, Qs), e.prototype.tag = "maxp", e.prototype.parse = function(A) {
    return A.pos = this.offset, this.version = A.readInt(), this.numGlyphs = A.readUInt16(), this.maxPoints = A.readUInt16(), this.maxContours = A.readUInt16(), this.maxCompositePoints = A.readUInt16(), this.maxComponentContours = A.readUInt16(), this.maxZones = A.readUInt16(), this.maxTwilightPoints = A.readUInt16(), this.maxStorage = A.readUInt16(), this.maxFunctionDefs = A.readUInt16(), this.maxInstructionDefs = A.readUInt16(), this.maxStackElements = A.readUInt16(), this.maxSizeOfInstructions = A.readUInt16(), this.maxComponentElements = A.readUInt16(), this.maxComponentDepth = A.readUInt16();
  }, e;
})(), sj = (function() {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Js(e, Qs), e.prototype.tag = "hmtx", e.prototype.parse = function(A) {
    var t, r, n, i, s, a, o;
    for (A.pos = this.offset, this.metrics = [], t = 0, a = this.file.hhea.numberOfMetrics; 0 <= a ? t < a : t > a; t = 0 <= a ? ++t : --t) this.metrics.push({ advance: A.readUInt16(), lsb: A.readInt16() });
    for (n = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = (function() {
      var l, c;
      for (c = [], t = l = 0; 0 <= n ? l < n : l > n; t = 0 <= n ? ++l : --l) c.push(A.readInt16());
      return c;
    })(), this.widths = (function() {
      var l, c, u, d;
      for (d = [], l = 0, c = (u = this.metrics).length; l < c; l++) i = u[l], d.push(i.advance);
      return d;
    }).call(this), r = this.widths[this.widths.length - 1], o = [], t = s = 0; 0 <= n ? s < n : s > n; t = 0 <= n ? ++s : --s) o.push(this.widths.push(r));
    return o;
  }, e.prototype.forGlyph = function(A) {
    return A in this.metrics ? this.metrics[A] : { advance: this.metrics[this.metrics.length - 1].advance, lsb: this.leftSideBearings[A - this.metrics.length] };
  }, e;
})(), P3 = [].slice, aj = (function() {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Js(e, Qs), e.prototype.tag = "glyf", e.prototype.parse = function() {
    return this.cache = {};
  }, e.prototype.glyphFor = function(A) {
    var t, r, n, i, s, a, o, l, c, u;
    return A in this.cache ? this.cache[A] : (i = this.file.loca, t = this.file.contents, r = i.indexOf(A), (n = i.lengthOf(A)) === 0 ? this.cache[A] = null : (t.pos = this.offset + r, s = (a = new Po(t.read(n))).readShort(), l = a.readShort(), u = a.readShort(), o = a.readShort(), c = a.readShort(), this.cache[A] = s === -1 ? new lj(a, l, u, o, c) : new oj(a, s, l, u, o, c), this.cache[A]));
  }, e.prototype.encode = function(A, t, r) {
    var n, i, s, a, o;
    for (s = [], i = [], a = 0, o = t.length; a < o; a++) n = A[t[a]], i.push(s.length), n && (s = s.concat(n.encode(r)));
    return i.push(s.length), { table: s, offsets: i };
  }, e;
})(), oj = (function() {
  function e(A, t, r, n, i, s) {
    this.raw = A, this.numberOfContours = t, this.xMin = r, this.yMin = n, this.xMax = i, this.yMax = s, this.compound = !1;
  }
  return e.prototype.encode = function() {
    return this.raw.data;
  }, e;
})(), lj = (function() {
  function e(A, t, r, n, i) {
    var s, a;
    for (this.raw = A, this.xMin = t, this.yMin = r, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], s = this.raw; a = s.readShort(), this.glyphOffsets.push(s.pos), this.glyphIDs.push(s.readUInt16()), 32 & a; ) s.pos += 1 & a ? 4 : 2, 128 & a ? s.pos += 8 : 64 & a ? s.pos += 4 : 8 & a && (s.pos += 2);
  }
  return e.prototype.encode = function() {
    var A, t, r;
    for (t = new Po(P3.call(this.raw.data)), A = 0, r = this.glyphIDs.length; A < r; ++A) t.pos = this.glyphOffsets[A];
    return t.data;
  }, e;
})(), cj = (function() {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Js(e, Qs), e.prototype.tag = "loca", e.prototype.parse = function(A) {
    var t, r;
    return A.pos = this.offset, t = this.file.head.indexToLocFormat, this.offsets = t === 0 ? (function() {
      var n, i;
      for (i = [], r = 0, n = this.length; r < n; r += 2) i.push(2 * A.readUInt16());
      return i;
    }).call(this) : (function() {
      var n, i;
      for (i = [], r = 0, n = this.length; r < n; r += 4) i.push(A.readUInt32());
      return i;
    }).call(this);
  }, e.prototype.indexOf = function(A) {
    return this.offsets[A];
  }, e.prototype.lengthOf = function(A) {
    return this.offsets[A + 1] - this.offsets[A];
  }, e.prototype.encode = function(A, t) {
    for (var r = new Uint32Array(this.offsets.length), n = 0, i = 0, s = 0; s < r.length; ++s) if (r[s] = n, i < t.length && t[i] == s) {
      ++i, r[s] = n;
      var a = this.offsets[s], o = this.offsets[s + 1] - a;
      o > 0 && (n += o);
    }
    for (var l = new Array(4 * r.length), c = 0; c < r.length; ++c) l[4 * c + 3] = 255 & r[c], l[4 * c + 2] = (65280 & r[c]) >> 8, l[4 * c + 1] = (16711680 & r[c]) >> 16, l[4 * c] = (4278190080 & r[c]) >> 24;
    return l;
  }, e;
})(), uj = (function() {
  function e(A) {
    this.font = A, this.subset = {}, this.unicodes = {}, this.next = 33;
  }
  return e.prototype.generateCmap = function() {
    var A, t, r, n, i;
    for (t in n = this.font.cmap.tables[0].codeMap, A = {}, i = this.subset) r = i[t], A[t] = n[r];
    return A;
  }, e.prototype.glyphsFor = function(A) {
    var t, r, n, i, s, a, o;
    for (n = {}, s = 0, a = A.length; s < a; s++) n[i = A[s]] = this.font.glyf.glyphFor(i);
    for (i in t = [], n) (r = n[i]) != null && r.compound && t.push.apply(t, r.glyphIDs);
    if (t.length > 0) for (i in o = this.glyphsFor(t)) r = o[i], n[i] = r;
    return n;
  }, e.prototype.encode = function(A, t) {
    var r, n, i, s, a, o, l, c, u, d, h, p, B, y, m;
    for (n in r = M3.encode(this.generateCmap(), "unicode"), s = this.glyphsFor(A), h = { 0: 0 }, m = r.charMap) h[(o = m[n]).old] = o.new;
    for (p in d = r.maxGlyphID, s) p in h || (h[p] = d++);
    return c = (function(C) {
      var Q, F;
      for (Q in F = {}, C) F[C[Q]] = Q;
      return F;
    })(h), u = Object.keys(c).sort(function(C, Q) {
      return C - Q;
    }), B = (function() {
      var C, Q, F;
      for (F = [], C = 0, Q = u.length; C < Q; C++) a = u[C], F.push(c[a]);
      return F;
    })(), i = this.font.glyf.encode(s, B, h), l = this.font.loca.encode(i.offsets, B), y = { cmap: this.font.cmap.raw(), glyf: i.table, loca: l, hmtx: this.font.hmtx.raw(), hhea: this.font.hhea.raw(), maxp: this.font.maxp.raw(), post: this.font.post.raw(), name: this.font.name.raw(), head: this.font.head.encode(t) }, this.font.os2.exists && (y["OS/2"] = this.font.os2.raw()), this.font.directory.encode(y);
  }, e;
})();
we.API.PDFObject = (function() {
  var e;
  function A() {
  }
  return e = function(t, r) {
    return (Array(r + 1).join("0") + t).slice(-r);
  }, A.convert = function(t) {
    var r, n, i, s;
    if (Array.isArray(t)) return "[" + (function() {
      var a, o, l;
      for (l = [], a = 0, o = t.length; a < o; a++) r = t[a], l.push(A.convert(r));
      return l;
    })().join(" ") + "]";
    if (typeof t == "string") return "/" + t;
    if (t?.isString) return "(" + t + ")";
    if (t instanceof Date) return "(D:" + e(t.getUTCFullYear(), 4) + e(t.getUTCMonth(), 2) + e(t.getUTCDate(), 2) + e(t.getUTCHours(), 2) + e(t.getUTCMinutes(), 2) + e(t.getUTCSeconds(), 2) + "Z)";
    if ({}.toString.call(t) === "[object Object]") {
      for (n in i = ["<<"], t) s = t[n], i.push("/" + n + " " + A.convert(s));
      return i.push(">>"), i.join(`
`);
    }
    return "" + t;
  }, A;
})();
const hj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AcroFormAppearance: le,
  AcroFormButton: Mr,
  AcroFormCheckBox: vh,
  AcroFormChoiceField: Ml,
  AcroFormComboBox: kl,
  AcroFormEditBox: wh,
  AcroFormListBox: Pl,
  AcroFormPasswordField: yh,
  AcroFormPushButton: mh,
  AcroFormRadioButton: Kl,
  AcroFormTextField: _o,
  GState: Vh,
  ShadingPattern: Qo,
  TilingPattern: Ll,
  default: we,
  jsPDF: we
}, Symbol.toStringTag, { value: "Module" }));
var Uv = function(e, A) {
  return Uv = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }, Uv(e, A);
};
function Us(e, A) {
  if (typeof A != "function" && A !== null)
    throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
  Uv(e, A);
  function t() {
    this.constructor = e;
  }
  e.prototype = A === null ? Object.create(A) : (t.prototype = A.prototype, new t());
}
var Ev = function() {
  return Ev = Object.assign || function(A) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (A[i] = t[i]);
    }
    return A;
  }, Ev.apply(this, arguments);
};
function zn(e, A, t, r) {
  function n(i) {
    return i instanceof t ? i : new t(function(s) {
      s(i);
    });
  }
  return new (t || (t = Promise))(function(i, s) {
    function a(c) {
      try {
        l(r.next(c));
      } catch (u) {
        s(u);
      }
    }
    function o(c) {
      try {
        l(r.throw(c));
      } catch (u) {
        s(u);
      }
    }
    function l(c) {
      c.done ? i(c.value) : n(c.value).then(a, o);
    }
    l((r = r.apply(e, [])).next());
  });
}
function Fn(e, A) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, n, i, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(l) {
    return function(c) {
      return o([l, c]);
    };
  }
  function o(l) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (r = 1, n && (i = l[0] & 2 ? n.return : l[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, l[1])).done) return i;
      switch (n = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return t.label++, { value: l[1], done: !1 };
        case 5:
          t.label++, n = l[1], l = [0];
          continue;
        case 7:
          l = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            t = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            t.label = l[1];
            break;
          }
          if (l[0] === 6 && t.label < i[1]) {
            t.label = i[1], i = l;
            break;
          }
          if (i && t.label < i[2]) {
            t.label = i[2], t.ops.push(l);
            break;
          }
          i[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      l = A.call(e, t);
    } catch (c) {
      l = [6, c], n = 0;
    } finally {
      r = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function wd(e, A, t) {
  if (arguments.length === 2) for (var r = 0, n = A.length, i; r < n; r++)
    (i || !(r in A)) && (i || (i = Array.prototype.slice.call(A, 0, r)), i[r] = A[r]);
  return e.concat(i || A);
}
var Oa = (
  /** @class */
  (function() {
    function e(A, t, r, n) {
      this.left = A, this.top = t, this.width = r, this.height = n;
    }
    return e.prototype.add = function(A, t, r, n) {
      return new e(this.left + A, this.top + t, this.width + r, this.height + n);
    }, e.fromClientRect = function(A, t) {
      return new e(t.left + A.windowBounds.left, t.top + A.windowBounds.top, t.width, t.height);
    }, e.fromDOMRectList = function(A, t) {
      var r = Array.from(t).find(function(n) {
        return n.width !== 0;
      });
      return r ? new e(r.left + A.windowBounds.left, r.top + A.windowBounds.top, r.width, r.height) : e.EMPTY;
    }, e.EMPTY = new e(0, 0, 0, 0), e;
  })()
), gp = function(e, A) {
  return Oa.fromClientRect(e, A.getBoundingClientRect());
}, fj = function(e) {
  var A = e.body, t = e.documentElement;
  if (!A || !t)
    throw new Error("Unable to get document size");
  var r = Math.max(Math.max(A.scrollWidth, t.scrollWidth), Math.max(A.offsetWidth, t.offsetWidth), Math.max(A.clientWidth, t.clientWidth)), n = Math.max(Math.max(A.scrollHeight, t.scrollHeight), Math.max(A.offsetHeight, t.offsetHeight), Math.max(A.clientHeight, t.clientHeight));
  return new Oa(0, 0, r, n);
}, pp = function(e) {
  for (var A = [], t = 0, r = e.length; t < r; ) {
    var n = e.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < r) {
      var i = e.charCodeAt(t++);
      (i & 64512) === 56320 ? A.push(((n & 1023) << 10) + (i & 1023) + 65536) : (A.push(n), t--);
    } else
      A.push(n);
  }
  return A;
}, mr = function() {
  for (var e = [], A = 0; A < arguments.length; A++)
    e[A] = arguments[A];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, e);
  var t = e.length;
  if (!t)
    return "";
  for (var r = [], n = -1, i = ""; ++n < t; ) {
    var s = e[n];
    s <= 65535 ? r.push(s) : (s -= 65536, r.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === t || r.length > 16384) && (i += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return i;
}, vQ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", dj = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var md = 0; md < vQ.length; md++)
  dj[vQ.charCodeAt(md)] = md;
var yQ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", rh = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var vd = 0; vd < yQ.length; vd++)
  rh[yQ.charCodeAt(vd)] = vd;
var gj = function(e) {
  var A = e.length * 0.75, t = e.length, r, n = 0, i, s, a, o;
  e[e.length - 1] === "=" && (A--, e[e.length - 2] === "=" && A--);
  var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), c = Array.isArray(l) ? l : new Uint8Array(l);
  for (r = 0; r < t; r += 4)
    i = rh[e.charCodeAt(r)], s = rh[e.charCodeAt(r + 1)], a = rh[e.charCodeAt(r + 2)], o = rh[e.charCodeAt(r + 3)], c[n++] = i << 2 | s >> 4, c[n++] = (s & 15) << 4 | a >> 2, c[n++] = (a & 3) << 6 | o & 63;
  return l;
}, pj = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 2)
    t.push(e[r + 1] << 8 | e[r]);
  return t;
}, Bj = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 4)
    t.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
  return t;
}, Vl = 5, Vy = 11, fw = 2, wj = Vy - Vl, k3 = 65536 >> Vl, mj = 1 << Vl, dw = mj - 1, vj = 1024 >> Vl, yj = k3 + vj, Cj = yj, bj = 32, Fj = Cj + bj, Qj = 65536 >> Vy, Uj = 1 << wj, Ej = Uj - 1, CQ = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint16Array(Array.prototype.slice.call(e, A, t));
}, xj = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint32Array(Array.prototype.slice.call(e, A, t));
}, Ij = function(e, A) {
  var t = gj(e), r = Array.isArray(t) ? Bj(t) : new Uint32Array(t), n = Array.isArray(t) ? pj(t) : new Uint16Array(t), i = 24, s = CQ(n, i / 2, r[4] / 2), a = r[5] === 2 ? CQ(n, (i + r[4]) / 2) : xj(r, Math.ceil((i + r[4]) / 4));
  return new Sj(r[0], r[1], r[2], r[3], s, a);
}, Sj = (
  /** @class */
  (function() {
    function e(A, t, r, n, i, s) {
      this.initialValue = A, this.errorValue = t, this.highStart = r, this.highValueIndex = n, this.index = i, this.data = s;
    }
    return e.prototype.get = function(A) {
      var t;
      if (A >= 0) {
        if (A < 55296 || A > 56319 && A <= 65535)
          return t = this.index[A >> Vl], t = (t << fw) + (A & dw), this.data[t];
        if (A <= 65535)
          return t = this.index[k3 + (A - 55296 >> Vl)], t = (t << fw) + (A & dw), this.data[t];
        if (A < this.highStart)
          return t = Fj - Qj + (A >> Vy), t = this.index[t], t += A >> Vl & Ej, t = this.index[t], t = (t << fw) + (A & dw), this.data[t];
        if (A <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, e;
  })()
), bQ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Lj = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var yd = 0; yd < bQ.length; yd++)
  Lj[bQ.charCodeAt(yd)] = yd;
var Hj = "KwAAAAAAAAAACA4AUD0AADAgAAACAAAAAAAIABAAGABAAEgAUABYAGAAaABgAGgAYgBqAF8AZwBgAGgAcQB5AHUAfQCFAI0AlQCdAKIAqgCyALoAYABoAGAAaABgAGgAwgDKAGAAaADGAM4A0wDbAOEA6QDxAPkAAQEJAQ8BFwF1AH0AHAEkASwBNAE6AUIBQQFJAVEBWQFhAWgBcAF4ATAAgAGGAY4BlQGXAZ8BpwGvAbUBvQHFAc0B0wHbAeMB6wHxAfkBAQIJAvEBEQIZAiECKQIxAjgCQAJGAk4CVgJeAmQCbAJ0AnwCgQKJApECmQKgAqgCsAK4ArwCxAIwAMwC0wLbAjAA4wLrAvMC+AIAAwcDDwMwABcDHQMlAy0DNQN1AD0DQQNJA0kDSQNRA1EDVwNZA1kDdQB1AGEDdQBpA20DdQN1AHsDdQCBA4kDkQN1AHUAmQOhA3UAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AKYDrgN1AHUAtgO+A8YDzgPWAxcD3gPjA+sD8wN1AHUA+wMDBAkEdQANBBUEHQQlBCoEFwMyBDgEYABABBcDSARQBFgEYARoBDAAcAQzAXgEgASIBJAEdQCXBHUAnwSnBK4EtgS6BMIEyAR1AHUAdQB1AHUAdQCVANAEYABgAGAAYABgAGAAYABgANgEYADcBOQEYADsBPQE/AQEBQwFFAUcBSQFLAU0BWQEPAVEBUsFUwVbBWAAYgVgAGoFcgV6BYIFigWRBWAAmQWfBaYFYABgAGAAYABgAKoFYACxBbAFuQW6BcEFwQXHBcEFwQXPBdMF2wXjBeoF8gX6BQIGCgYSBhoGIgYqBjIGOgZgAD4GRgZMBmAAUwZaBmAAYABgAGAAYABgAGAAYABgAGAAYABgAGIGYABpBnAGYABgAGAAYABgAGAAYABgAGAAYAB4Bn8GhQZgAGAAYAB1AHcDFQSLBmAAYABgAJMGdQA9A3UAmwajBqsGqwaVALMGuwbDBjAAywbSBtIG1QbSBtIG0gbSBtIG0gbdBuMG6wbzBvsGAwcLBxMHAwcbByMHJwcsBywHMQcsB9IGOAdAB0gHTgfSBkgHVgfSBtIG0gbSBtIG0gbSBtIG0gbSBiwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdgAGAALAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdbB2MHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB2kH0gZwB64EdQB1AHUAdQB1AHUAdQB1AHUHfQdgAIUHjQd1AHUAlQedB2AAYAClB6sHYACzB7YHvgfGB3UAzgfWBzMB3gfmB1EB7gf1B/0HlQENAQUIDQh1ABUIHQglCBcDLQg1CD0IRQhNCEEDUwh1AHUAdQBbCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIcAh3CHoIMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIgggwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAALAcsBywHLAcsBywHLAcsBywHLAcsB4oILAcsB44I0gaWCJ4Ipgh1AHUAqgiyCHUAdQB1AHUAdQB1AHUAdQB1AHUAtwh8AXUAvwh1AMUIyQjRCNkI4AjoCHUAdQB1AO4I9gj+CAYJDgkTCS0HGwkjCYIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiAAIAAAAFAAYABgAGIAXwBgAHEAdQBFAJUAogCyAKAAYABgAEIA4ABGANMA4QDxAMEBDwE1AFwBLAE6AQEBUQF4QkhCmEKoQrhCgAHIQsAB0MLAAcABwAHAAeDC6ABoAHDCwMMAAcABwAHAAdDDGMMAAcAB6MM4wwjDWMNow3jDaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAEjDqABWw6bDqABpg6gAaABoAHcDvwOPA+gAaABfA/8DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DpcPAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcAB9cPKwkyCToJMAB1AHUAdQBCCUoJTQl1AFUJXAljCWcJawkwADAAMAAwAHMJdQB2CX4JdQCECYoJjgmWCXUAngkwAGAAYABxAHUApgn3A64JtAl1ALkJdQDACTAAMAAwADAAdQB1AHUAdQB1AHUAdQB1AHUAowYNBMUIMAAwADAAMADICcsJ0wnZCRUE4QkwAOkJ8An4CTAAMAB1AAAKvwh1AAgKDwoXCh8KdQAwACcKLgp1ADYKqAmICT4KRgowADAAdQB1AE4KMAB1AFYKdQBeCnUAZQowADAAMAAwADAAMAAwADAAMAAVBHUAbQowADAAdQC5CXUKMAAwAHwBxAijBogEMgF9CoQKiASMCpQKmgqIBKIKqgquCogEDQG2Cr4KxgrLCjAAMADTCtsKCgHjCusK8Qr5CgELMAAwADAAMAB1AIsECQsRC3UANAEZCzAAMAAwADAAMAB1ACELKQswAHUANAExCzkLdQBBC0kLMABRC1kLMAAwADAAMAAwADAAdQBhCzAAMAAwAGAAYABpC3ELdwt/CzAAMACHC4sLkwubC58Lpwt1AK4Ltgt1APsDMAAwADAAMAAwADAAMAAwAL4LwwvLC9IL1wvdCzAAMADlC+kL8Qv5C/8LSQswADAAMAAwADAAMAAwADAAMAAHDDAAMAAwADAAMAAODBYMHgx1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1ACYMMAAwADAAdQB1AHUALgx1AHUAdQB1AHUAdQA2DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AD4MdQBGDHUAdQB1AHUAdQB1AEkMdQB1AHUAdQB1AFAMMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQBYDHUAdQB1AF8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUA+wMVBGcMMAAwAHwBbwx1AHcMfwyHDI8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAYABgAJcMMAAwADAAdQB1AJ8MlQClDDAAMACtDCwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB7UMLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AA0EMAC9DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAsBywHLAcsBywHLAcsBywHLQcwAMEMyAwsBywHLAcsBywHLAcsBywHLAcsBywHzAwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1ANQM2QzhDDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMABgAGAAYABgAGAAYABgAOkMYADxDGAA+AwADQYNYABhCWAAYAAODTAAMAAwADAAFg1gAGAAHg37AzAAMAAwADAAYABgACYNYAAsDTQNPA1gAEMNPg1LDWAAYABgAGAAYABgAGAAYABgAGAAUg1aDYsGVglhDV0NcQBnDW0NdQ15DWAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAlQCBDZUAiA2PDZcNMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAnw2nDTAAMAAwADAAMAAwAHUArw23DTAAMAAwADAAMAAwADAAMAAwADAAMAB1AL8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQDHDTAAYABgAM8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA1w11ANwNMAAwAD0B5A0wADAAMAAwADAAMADsDfQN/A0EDgwOFA4wABsOMAAwADAAMAAwADAAMAAwANIG0gbSBtIG0gbSBtIG0gYjDigOwQUuDsEFMw7SBjoO0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGQg5KDlIOVg7SBtIGXg5lDm0OdQ7SBtIGfQ6EDooOjQ6UDtIGmg6hDtIG0gaoDqwO0ga0DrwO0gZgAGAAYADEDmAAYAAkBtIGzA5gANIOYADaDokO0gbSBt8O5w7SBu8O0gb1DvwO0gZgAGAAxA7SBtIG0gbSBtIGYABgAGAAYAAED2AAsAUMD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHJA8sBywHLAcsBywHLAccDywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywPLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAc0D9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHPA/SBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gYUD0QPlQCVAJUAMAAwADAAMACVAJUAlQCVAJUAlQCVAEwPMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA//8EAAQABAAEAAQABAAEAAQABAANAAMAAQABAAIABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQACgATABcAHgAbABoAHgAXABYAEgAeABsAGAAPABgAHABLAEsASwBLAEsASwBLAEsASwBLABgAGAAeAB4AHgATAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYAGwASAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWAA0AEQAeAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAFAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJABYAGgAbABsAGwAeAB0AHQAeAE8AFwAeAA0AHgAeABoAGwBPAE8ADgBQAB0AHQAdAE8ATwAXAE8ATwBPABYAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAFAATwBAAE8ATwBPAEAATwBQAFAATwBQAB4AHgAeAB4AHgAeAB0AHQAdAB0AHgAdAB4ADgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgBQAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkACQAJAAkACQAJAAkABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAFAAHgAeAB4AKwArAFAAUABQAFAAGABQACsAKwArACsAHgAeAFAAHgBQAFAAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUAAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAYAA0AKwArAB4AHgAbACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAB4ABAAEAB4ABAAEABMABAArACsAKwArACsAKwArACsAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAKwArACsAKwBWAFYAVgBWAB4AHgArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AGgAaABoAGAAYAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQAEwAEACsAEwATAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABLAEsASwBLAEsASwBLAEsASwBLABoAGQAZAB4AUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABMAUAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABABQAFAABAAEAB4ABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUAAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAFAABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQAUABQAB4AHgAYABMAUAArACsABAAbABsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAFAABAAEAAQABAAEAFAABAAEAAQAUAAEAAQABAAEAAQAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArACsAHgArAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAUAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEAA0ADQBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUAArACsAKwBQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABABQACsAKwArACsAKwArACsAKwAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUAAaABoAUABQAFAAUABQAEwAHgAbAFAAHgAEACsAKwAEAAQABAArAFAAUABQAFAAUABQACsAKwArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQACsAUABQACsAKwAEACsABAAEAAQABAAEACsAKwArACsABAAEACsAKwAEAAQABAArACsAKwAEACsAKwArACsAKwArACsAUABQAFAAUAArAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLAAQABABQAFAAUAAEAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAArACsAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AGwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAKwArACsAKwArAAQABAAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAAQAUAArAFAAUABQAFAAUABQACsAKwArAFAAUABQACsAUABQAFAAUAArACsAKwBQAFAAKwBQACsAUABQACsAKwArAFAAUAArACsAKwBQAFAAUAArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAAQABAAEAAQABAArACsAKwAEAAQABAArAAQABAAEAAQAKwArAFAAKwArACsAKwArACsABAArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAHgAeAB4AHgAeAB4AGwAeACsAKwArACsAKwAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAUABQAFAAKwArACsAKwArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwAOAFAAUABQAFAAUABQAFAAHgBQAAQABAAEAA4AUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAKwArAAQAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAKwArACsAKwArACsAUAArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABABQAB4AKwArACsAKwBQAFAAUAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQABoAUABQAFAAUABQAFAAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQACsAUAArACsAUABQAFAAUABQAFAAUAArACsAKwAEACsAKwArACsABAAEAAQABAAEAAQAKwAEACsABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgAqACsAKwArACsAGwBcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAeAEsASwBLAEsASwBLAEsASwBLAEsADQANACsAKwArACsAKwBcAFwAKwBcACsAXABcAFwAXABcACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAXAArAFwAXABcAFwAXABcAFwAXABcAFwAKgBcAFwAKgAqACoAKgAqACoAKgAqACoAXAArACsAXABcAFwAXABcACsAXAArACoAKgAqACoAKgAqACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwBcAFwAXABcAFAADgAOAA4ADgAeAA4ADgAJAA4ADgANAAkAEwATABMAEwATAAkAHgATAB4AHgAeAAQABAAeAB4AHgAeAB4AHgBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQAFAADQAEAB4ABAAeAAQAFgARABYAEQAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAAQABAAEAAQADQAEAAQAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAA0ADQAeAB4AHgAeAB4AHgAEAB4AHgAeAB4AHgAeACsAHgAeAA4ADgANAA4AHgAeAB4AHgAeAAkACQArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgBcAEsASwBLAEsASwBLAEsASwBLAEsADQANAB4AHgAeAB4AXABcAFwAXABcAFwAKgAqACoAKgBcAFwAXABcACoAKgAqAFwAKgAqACoAXABcACoAKgAqACoAKgAqACoAXABcAFwAKgAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqAFwAKgBLAEsASwBLAEsASwBLAEsASwBLACoAKgAqACoAKgAqAFAAUABQAFAAUABQACsAUAArACsAKwArACsAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAKwBQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsABAAEAAQAHgANAB4AHgAeAB4AHgAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUAArACsADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWABEAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQANAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAANAA0AKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUAArAAQABAArACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqAA0ADQAVAFwADQAeAA0AGwBcACoAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwAeAB4AEwATAA0ADQAOAB4AEwATAB4ABAAEAAQACQArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAHgArACsAKwATABMASwBLAEsASwBLAEsASwBLAEsASwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAXABcAFwAXABcACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAXAArACsAKwAqACoAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsAHgAeAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKwAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKwArAAQASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACoAKgAqACoAKgAqACoAXAAqACoAKgAqACoAKgArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABABQAFAAUABQAFAAUABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwANAA0AHgANAA0ADQANAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwAeAB4AHgAeAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArAA0ADQANAA0ADQBLAEsASwBLAEsASwBLAEsASwBLACsAKwArAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUAAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAAQAUABQAFAAUABQAFAABABQAFAABAAEAAQAUAArACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQACsAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQACsAKwAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQACsAHgAeAB4AHgAeAB4AHgAOAB4AKwANAA0ADQANAA0ADQANAAkADQANAA0ACAAEAAsABAAEAA0ACQANAA0ADAAdAB0AHgAXABcAFgAXABcAFwAWABcAHQAdAB4AHgAUABQAFAANAAEAAQAEAAQABAAEAAQACQAaABoAGgAaABoAGgAaABoAHgAXABcAHQAVABUAHgAeAB4AHgAeAB4AGAAWABEAFQAVABUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ADQAeAA0ADQANAA0AHgANAA0ADQAHAB4AHgAeAB4AKwAEAAQABAAEAAQABAAEAAQABAAEAFAAUAArACsATwBQAFAAUABQAFAAHgAeAB4AFgARAE8AUABPAE8ATwBPAFAAUABQAFAAUAAeAB4AHgAWABEAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArABsAGwAbABsAGwAbABsAGgAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGgAbABsAGwAbABoAGwAbABoAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAHgAeAFAAGgAeAB0AHgBQAB4AGgAeAB4AHgAeAB4AHgAeAB4AHgBPAB4AUAAbAB4AHgBQAFAAUABQAFAAHgAeAB4AHQAdAB4AUAAeAFAAHgBQAB4AUABPAFAAUAAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgBQAFAAUABQAE8ATwBQAFAAUABQAFAATwBQAFAATwBQAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAUABQAFAATwBPAE8ATwBPAE8ATwBPAE8ATwBQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABPAB4AHgArACsAKwArAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHQAdAB4AHgAeAB0AHQAeAB4AHQAeAB4AHgAdAB4AHQAbABsAHgAdAB4AHgAeAB4AHQAeAB4AHQAdAB0AHQAeAB4AHQAeAB0AHgAdAB0AHQAdAB0AHQAeAB0AHgAeAB4AHgAeAB0AHQAdAB0AHgAeAB4AHgAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB0AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAdAB0AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAWABEAHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AHQAdAB0AHgAeAB0AHgAeAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlAB4AHQAdAB4AHgAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AJQAlAB0AHQAlAB4AJQAlACUAIAAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAdAB0AHQAeAB0AJQAdAB0AHgAdAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAdAB0AHQAdACUAHgAlACUAJQAdACUAJQAdAB0AHQAlACUAHQAdACUAHQAdACUAJQAlAB4AHQAeAB4AHgAeAB0AHQAlAB0AHQAdAB0AHQAdACUAJQAlACUAJQAdACUAJQAgACUAHQAdACUAJQAlACUAJQAlACUAJQAeAB4AHgAlACUAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AFwAXABcAFwAXABcAHgATABMAJQAeAB4AHgAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARABYAEQAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAeAB4AKwArACsAKwArABMADQANAA0AUAATAA0AUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUAANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAA0ADQANAA0ADQANAA0ADQAeAA0AFgANAB4AHgAXABcAHgAeABcAFwAWABEAFgARABYAEQAWABEADQANAA0ADQATAFAADQANAB4ADQANAB4AHgAeAB4AHgAMAAwADQANAA0AHgANAA0AFgANAA0ADQANAA0ADQANAA0AHgANAB4ADQANAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArAA0AEQARACUAJQBHAFcAVwAWABEAFgARABYAEQAWABEAFgARACUAJQAWABEAFgARABYAEQAWABEAFQAWABEAEQAlAFcAVwBXAFcAVwBXAFcAVwBXAAQABAAEAAQABAAEACUAVwBXAFcAVwA2ACUAJQBXAFcAVwBHAEcAJQAlACUAKwBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBRAFcAUQBXAFEAVwBXAFcAVwBXAFcAUQBXAFcAVwBXAFcAVwBRAFEAKwArAAQABAAVABUARwBHAFcAFQBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBRAFcAVwBXAFcAVwBXAFEAUQBXAFcAVwBXABUAUQBHAEcAVwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwAlACUAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACsAKwArACsAKwArACsAKwArACsAKwArAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBPAE8ATwBPAE8ATwBPAE8AJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADQATAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQAHgBQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAeAA0ADQANAA0ADQArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAAQAUABQAFAABABQAFAAUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAeAB4AHgAeAAQAKwArACsAUABQAFAAUABQAFAAHgAeABoAHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADgAOABMAEwArACsAKwArACsAKwArACsABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUAAeAB4AHgBQAA4AUABQAAQAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAB4AWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYACsAKwArAAQAHgAeAB4AHgAeAB4ADQANAA0AHgAeAB4AHgArAFAASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArAB4AHgBcAFwAXABcAFwAKgBcAFwAXABcAFwAXABcAFwAXABcAEsASwBLAEsASwBLAEsASwBLAEsAXABcAFwAXABcACsAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAFAAUABQAAQAUABQAFAAUABQAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAHgANAA0ADQBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAKgAqACoAXABcACoAKgBcAFwAXABcAFwAKgAqAFwAKgBcACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAA0ADQBQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQADQAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAVABVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBUAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVACsAKwArACsAKwArACsAKwArACsAKwArAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAKwArACsAKwBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAKwArACsAKwAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArACsAKwArAFYABABWAFYAVgBWAFYAVgBWAFYAVgBWAB4AVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgArAFYAVgBWAFYAVgArAFYAKwBWAFYAKwBWAFYAKwBWAFYAVgBWAFYAVgBWAFYAVgBWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAEQAWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAaAB4AKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAGAARABEAGAAYABMAEwAWABEAFAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACUAJQAlACUAJQAWABEAFgARABYAEQAWABEAFgARABYAEQAlACUAFgARACUAJQAlACUAJQAlACUAEQAlABEAKwAVABUAEwATACUAFgARABYAEQAWABEAJQAlACUAJQAlACUAJQAlACsAJQAbABoAJQArACsAKwArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAcAKwATACUAJQAbABoAJQAlABYAEQAlACUAEQAlABEAJQBXAFcAVwBXAFcAVwBXAFcAVwBXABUAFQAlACUAJQATACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXABYAJQARACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAWACUAEQAlABYAEQARABYAEQARABUAVwBRAFEAUQBRAFEAUQBRAFEAUQBRAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcARwArACsAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXACsAKwBXAFcAVwBXAFcAVwArACsAVwBXAFcAKwArACsAGgAbACUAJQAlABsAGwArAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAAQAB0AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsADQANAA0AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAA0AUABQAFAAUAArACsAKwArAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwBQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAUABQAFAAUABQAAQABAAEACsABAAEACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAKwBQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAA0ADQANAA0ADQANAA0ADQAeACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAArACsAKwArAFAAUABQAFAAUAANAA0ADQANAA0ADQAUACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsADQANAA0ADQANAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArAAQABAANACsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAB4AHgAeAB4AHgArACsAKwArACsAKwAEAAQABAAEAAQABAAEAA0ADQAeAB4AHgAeAB4AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsASwBLAEsASwBLAEsASwBLAEsASwANAA0ADQANAFAABAAEAFAAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAeAA4AUAArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAADQANAB4ADQAEAAQABAAEAB4ABAAEAEsASwBLAEsASwBLAEsASwBLAEsAUAAOAFAADQANAA0AKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAA0AHgANAA0AHgAEACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAA0AKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsABAAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAUAArACsAKwArACsAKwAEACsAKwArACsAKwBQAFAAUABQAFAABAAEACsAKwAEAAQABAAEAAQABAAEACsAKwArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABABQAFAAUABQAA0ADQANAA0AHgBLAEsASwBLAEsASwBLAEsASwBLAA0ADQArAB4ABABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUAAeAFAAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABAAEAAQADgANAA0AEwATAB4AHgAeAA0ADQANAA0ADQANAA0ADQANAA0ADQANAA0ADQANAFAAUABQAFAABAAEACsAKwAEAA0ADQAeAFAAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKwArACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBcAFwADQANAA0AKgBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQAKwAEAAQAKwArAAQABAAEAAQAUAAEAFAABAAEAA0ADQANACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABABQAA4AUAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAOAB4ADQANAA0ADQAOAB4ABAArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAA0ADQANAFAADgAOAA4ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAFAADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAOABMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAArACsAKwAEACsABAAEACsABAAEAAQABAAEAAQABABQAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAaABoAGgAaAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABIAEgAQwBDAEMAUABQAFAAUABDAFAAUABQAEgAQwBIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABDAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAJAAkACQAJAAkACQAJABYAEQArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwANAA0AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAANACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQANAB4AHgAeAB4AHgAeAFAAUABQAFAADQAeACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAA0AHgAeACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAARwBHABUARwAJACsAKwArACsAKwArACsAKwArACsAKwAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUQBRAFEAKwArACsAKwArACsAKwArACsAKwArACsAKwBRAFEAUQBRACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAHgAEAAQADQAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQABAAEAAQABAAeAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQAHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAKwArAFAAKwArAFAAUAArACsAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUAArAFAAUABQAFAAUABQAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAHgAeAFAAUABQAFAAUAArAFAAKwArACsAUABQAFAAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeACsAKwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4ABAAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAHgAeAA0ADQANAA0AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArAAQABAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwBQAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArABsAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAB4AHgAeAB4ABAAEAAQABAAEAAQABABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArABYAFgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAGgBQAFAAUAAaAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUAArACsAKwArACsAKwBQACsAKwArACsAUAArAFAAKwBQACsAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUAArAFAAKwBQACsAUAArAFAAUAArAFAAKwArAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAKwBQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AJQAlACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeACUAJQAlAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAlACUAJQAlACUAHgAlACUAJQAlACUAIAAgACAAJQAlACAAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACEAIQAhACEAIQAlACUAIAAgACUAJQAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAIAAlACUAJQAlACAAIAAgACUAIAAgACAAJQAlACUAJQAlACUAJQAgACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAlAB4AJQAeACUAJQAlACUAJQAgACUAJQAlACUAHgAlAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACAAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABcAFwAXABUAFQAVAB4AHgAeAB4AJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAgACUAJQAgACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAIAAgACUAJQAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACAAIAAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACAAIAAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAA==", FQ = 50, Tj = 1, K3 = 2, V3 = 3, _j = 4, Oj = 5, QQ = 7, G3 = 8, UQ = 9, xo = 10, xv = 11, EQ = 12, Iv = 13, Nj = 14, nh = 15, Sv = 16, Cd = 17, Ou = 18, Dj = 19, xQ = 20, Lv = 21, Nu = 22, gw = 23, xc = 24, Fi = 25, ih = 26, sh = 27, Ic = 28, Rj = 29, Ul = 30, Mj = 31, bd = 32, Fd = 33, Hv = 34, Tv = 35, _v = 36, Gh = 37, Ov = 38, Zd = 39, Ag = 40, pw = 41, W3 = 42, Pj = 43, kj = [9001, 65288], j3 = "!", $e = "×", Qd = "÷", Nv = Ij(Hj), va = [Ul, _v], Dv = [Tj, K3, V3, Oj], q3 = [xo, G3], IQ = [sh, ih], Kj = Dv.concat(q3), SQ = [Ov, Zd, Ag, Hv, Tv], Vj = [nh, Iv], Gj = function(e, A) {
  A === void 0 && (A = "strict");
  var t = [], r = [], n = [];
  return e.forEach(function(i, s) {
    var a = Nv.get(i);
    if (a > FQ ? (n.push(!0), a -= FQ) : n.push(!1), ["normal", "auto", "loose"].indexOf(A) !== -1 && [8208, 8211, 12316, 12448].indexOf(i) !== -1)
      return r.push(s), t.push(Sv);
    if (a === _j || a === xv) {
      if (s === 0)
        return r.push(s), t.push(Ul);
      var o = t[s - 1];
      return Kj.indexOf(o) === -1 ? (r.push(r[s - 1]), t.push(o)) : (r.push(s), t.push(Ul));
    }
    if (r.push(s), a === Mj)
      return t.push(A === "strict" ? Lv : Gh);
    if (a === W3 || a === Rj)
      return t.push(Ul);
    if (a === Pj)
      return i >= 131072 && i <= 196605 || i >= 196608 && i <= 262141 ? t.push(Gh) : t.push(Ul);
    t.push(a);
  }), [r, t, n];
}, Bw = function(e, A, t, r) {
  var n = r[t];
  if (Array.isArray(e) ? e.indexOf(n) !== -1 : e === n)
    for (var i = t; i <= r.length; ) {
      i++;
      var s = r[i];
      if (s === A)
        return !0;
      if (s !== xo)
        break;
    }
  if (n === xo)
    for (var i = t; i > 0; ) {
      i--;
      var a = r[i];
      if (Array.isArray(e) ? e.indexOf(a) !== -1 : e === a)
        for (var o = t; o <= r.length; ) {
          o++;
          var s = r[o];
          if (s === A)
            return !0;
          if (s !== xo)
            break;
        }
      if (a !== xo)
        break;
    }
  return !1;
}, LQ = function(e, A) {
  for (var t = e; t >= 0; ) {
    var r = A[t];
    if (r === xo)
      t--;
    else
      return r;
  }
  return 0;
}, Wj = function(e, A, t, r, n) {
  if (t[r] === 0)
    return $e;
  var i = r - 1;
  if (Array.isArray(n) && n[i] === !0)
    return $e;
  var s = i - 1, a = i + 1, o = A[i], l = s >= 0 ? A[s] : 0, c = A[a];
  if (o === K3 && c === V3)
    return $e;
  if (Dv.indexOf(o) !== -1)
    return j3;
  if (Dv.indexOf(c) !== -1 || q3.indexOf(c) !== -1)
    return $e;
  if (LQ(i, A) === G3)
    return Qd;
  if (Nv.get(e[i]) === xv || (o === bd || o === Fd) && Nv.get(e[a]) === xv || o === QQ || c === QQ || o === UQ || [xo, Iv, nh].indexOf(o) === -1 && c === UQ || [Cd, Ou, Dj, xc, Ic].indexOf(c) !== -1 || LQ(i, A) === Nu || Bw(gw, Nu, i, A) || Bw([Cd, Ou], Lv, i, A) || Bw(EQ, EQ, i, A))
    return $e;
  if (o === xo)
    return Qd;
  if (o === gw || c === gw)
    return $e;
  if (c === Sv || o === Sv)
    return Qd;
  if ([Iv, nh, Lv].indexOf(c) !== -1 || o === Nj || l === _v && Vj.indexOf(o) !== -1 || o === Ic && c === _v || c === xQ || va.indexOf(c) !== -1 && o === Fi || va.indexOf(o) !== -1 && c === Fi || o === sh && [Gh, bd, Fd].indexOf(c) !== -1 || [Gh, bd, Fd].indexOf(o) !== -1 && c === ih || va.indexOf(o) !== -1 && IQ.indexOf(c) !== -1 || IQ.indexOf(o) !== -1 && va.indexOf(c) !== -1 || // (PR | PO) × ( OP | HY )? NU
  [sh, ih].indexOf(o) !== -1 && (c === Fi || [Nu, nh].indexOf(c) !== -1 && A[a + 1] === Fi) || // ( OP | HY ) × NU
  [Nu, nh].indexOf(o) !== -1 && c === Fi || // NU ×	(NU | SY | IS)
  o === Fi && [Fi, Ic, xc].indexOf(c) !== -1)
    return $e;
  if ([Fi, Ic, xc, Cd, Ou].indexOf(c) !== -1)
    for (var u = i; u >= 0; ) {
      var d = A[u];
      if (d === Fi)
        return $e;
      if ([Ic, xc].indexOf(d) !== -1)
        u--;
      else
        break;
    }
  if ([sh, ih].indexOf(c) !== -1)
    for (var u = [Cd, Ou].indexOf(o) !== -1 ? s : i; u >= 0; ) {
      var d = A[u];
      if (d === Fi)
        return $e;
      if ([Ic, xc].indexOf(d) !== -1)
        u--;
      else
        break;
    }
  if (Ov === o && [Ov, Zd, Hv, Tv].indexOf(c) !== -1 || [Zd, Hv].indexOf(o) !== -1 && [Zd, Ag].indexOf(c) !== -1 || [Ag, Tv].indexOf(o) !== -1 && c === Ag || SQ.indexOf(o) !== -1 && [xQ, ih].indexOf(c) !== -1 || SQ.indexOf(c) !== -1 && o === sh || va.indexOf(o) !== -1 && va.indexOf(c) !== -1 || o === xc && va.indexOf(c) !== -1 || va.concat(Fi).indexOf(o) !== -1 && c === Nu && kj.indexOf(e[a]) === -1 || va.concat(Fi).indexOf(c) !== -1 && o === Ou)
    return $e;
  if (o === pw && c === pw) {
    for (var h = t[i], p = 1; h > 0 && (h--, A[h] === pw); )
      p++;
    if (p % 2 !== 0)
      return $e;
  }
  return o === bd && c === Fd ? $e : Qd;
}, jj = function(e, A) {
  A || (A = { lineBreak: "normal", wordBreak: "normal" });
  var t = Gj(e, A.lineBreak), r = t[0], n = t[1], i = t[2];
  (A.wordBreak === "break-all" || A.wordBreak === "break-word") && (n = n.map(function(a) {
    return [Fi, Ul, W3].indexOf(a) !== -1 ? Gh : a;
  }));
  var s = A.wordBreak === "keep-all" ? i.map(function(a, o) {
    return a && e[o] >= 19968 && e[o] <= 40959;
  }) : void 0;
  return [r, n, s];
}, qj = (
  /** @class */
  (function() {
    function e(A, t, r, n) {
      this.codePoints = A, this.required = t === j3, this.start = r, this.end = n;
    }
    return e.prototype.slice = function() {
      return mr.apply(void 0, this.codePoints.slice(this.start, this.end));
    }, e;
  })()
), $j = function(e, A) {
  var t = pp(e), r = jj(t, A), n = r[0], i = r[1], s = r[2], a = t.length, o = 0, l = 0;
  return {
    next: function() {
      if (l >= a)
        return { done: !0, value: null };
      for (var c = $e; l < a && (c = Wj(t, i, n, ++l, s)) === $e; )
        ;
      if (c !== $e || l === a) {
        var u = new qj(t, c, o, l);
        return o = l, { value: u, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, zj = 1, Xj = 2, Zh = 4, HQ = 8, Ig = 10, TQ = 47, Ch = 92, Yj = 9, Jj = 32, Ud = 34, Du = 61, Zj = 35, Aq = 36, eq = 37, Ed = 39, xd = 40, Ru = 41, tq = 95, si = 45, rq = 33, nq = 60, iq = 62, sq = 64, aq = 91, oq = 93, lq = 61, cq = 123, Id = 63, uq = 125, _Q = 124, hq = 126, fq = 128, OQ = 65533, ww = 42, Hl = 43, dq = 44, gq = 58, pq = 59, Wh = 46, Bq = 0, wq = 8, mq = 11, vq = 14, yq = 31, Cq = 127, Rs = -1, $3 = 48, z3 = 97, X3 = 101, bq = 102, Fq = 117, Qq = 122, Y3 = 65, J3 = 69, Z3 = 70, Uq = 85, Eq = 90, Un = function(e) {
  return e >= $3 && e <= 57;
}, xq = function(e) {
  return e >= 55296 && e <= 57343;
}, Sc = function(e) {
  return Un(e) || e >= Y3 && e <= Z3 || e >= z3 && e <= bq;
}, Iq = function(e) {
  return e >= z3 && e <= Qq;
}, Sq = function(e) {
  return e >= Y3 && e <= Eq;
}, Lq = function(e) {
  return Iq(e) || Sq(e);
}, Hq = function(e) {
  return e >= fq;
}, Sd = function(e) {
  return e === Ig || e === Yj || e === Jj;
}, Sg = function(e) {
  return Lq(e) || Hq(e) || e === tq;
}, NQ = function(e) {
  return Sg(e) || Un(e) || e === si;
}, Tq = function(e) {
  return e >= Bq && e <= wq || e === mq || e >= vq && e <= yq || e === Cq;
}, Co = function(e, A) {
  return e !== Ch ? !1 : A !== Ig;
}, Ld = function(e, A, t) {
  return e === si ? Sg(A) || Co(A, t) : Sg(e) ? !0 : !!(e === Ch && Co(e, A));
}, mw = function(e, A, t) {
  return e === Hl || e === si ? Un(A) ? !0 : A === Wh && Un(t) : Un(e === Wh ? A : e);
}, _q = function(e) {
  var A = 0, t = 1;
  (e[A] === Hl || e[A] === si) && (e[A] === si && (t = -1), A++);
  for (var r = []; Un(e[A]); )
    r.push(e[A++]);
  var n = r.length ? parseInt(mr.apply(void 0, r), 10) : 0;
  e[A] === Wh && A++;
  for (var i = []; Un(e[A]); )
    i.push(e[A++]);
  var s = i.length, a = s ? parseInt(mr.apply(void 0, i), 10) : 0;
  (e[A] === J3 || e[A] === X3) && A++;
  var o = 1;
  (e[A] === Hl || e[A] === si) && (e[A] === si && (o = -1), A++);
  for (var l = []; Un(e[A]); )
    l.push(e[A++]);
  var c = l.length ? parseInt(mr.apply(void 0, l), 10) : 0;
  return t * (n + a * Math.pow(10, -s)) * Math.pow(10, o * c);
}, Oq = {
  type: 2
  /* LEFT_PARENTHESIS_TOKEN */
}, Nq = {
  type: 3
  /* RIGHT_PARENTHESIS_TOKEN */
}, Dq = {
  type: 4
  /* COMMA_TOKEN */
}, Rq = {
  type: 13
  /* SUFFIX_MATCH_TOKEN */
}, Mq = {
  type: 8
  /* PREFIX_MATCH_TOKEN */
}, Pq = {
  type: 21
  /* COLUMN_TOKEN */
}, kq = {
  type: 9
  /* DASH_MATCH_TOKEN */
}, Kq = {
  type: 10
  /* INCLUDE_MATCH_TOKEN */
}, Vq = {
  type: 11
  /* LEFT_CURLY_BRACKET_TOKEN */
}, Gq = {
  type: 12
  /* RIGHT_CURLY_BRACKET_TOKEN */
}, Wq = {
  type: 14
  /* SUBSTRING_MATCH_TOKEN */
}, Hd = {
  type: 23
  /* BAD_URL_TOKEN */
}, jq = {
  type: 1
  /* BAD_STRING_TOKEN */
}, qq = {
  type: 25
  /* CDO_TOKEN */
}, $q = {
  type: 24
  /* CDC_TOKEN */
}, zq = {
  type: 26
  /* COLON_TOKEN */
}, Xq = {
  type: 27
  /* SEMICOLON_TOKEN */
}, Yq = {
  type: 28
  /* LEFT_SQUARE_BRACKET_TOKEN */
}, Jq = {
  type: 29
  /* RIGHT_SQUARE_BRACKET_TOKEN */
}, Zq = {
  type: 31
  /* WHITESPACE_TOKEN */
}, Rv = {
  type: 32
  /* EOF_TOKEN */
}, AL = (
  /** @class */
  (function() {
    function e() {
      this._value = [];
    }
    return e.prototype.write = function(A) {
      this._value = this._value.concat(pp(A));
    }, e.prototype.read = function() {
      for (var A = [], t = this.consumeToken(); t !== Rv; )
        A.push(t), t = this.consumeToken();
      return A;
    }, e.prototype.consumeToken = function() {
      var A = this.consumeCodePoint();
      switch (A) {
        case Ud:
          return this.consumeStringToken(Ud);
        case Zj:
          var t = this.peekCodePoint(0), r = this.peekCodePoint(1), n = this.peekCodePoint(2);
          if (NQ(t) || Co(r, n)) {
            var i = Ld(t, r, n) ? Xj : zj, s = this.consumeName();
            return { type: 5, value: s, flags: i };
          }
          break;
        case Aq:
          if (this.peekCodePoint(0) === Du)
            return this.consumeCodePoint(), Rq;
          break;
        case Ed:
          return this.consumeStringToken(Ed);
        case xd:
          return Oq;
        case Ru:
          return Nq;
        case ww:
          if (this.peekCodePoint(0) === Du)
            return this.consumeCodePoint(), Wq;
          break;
        case Hl:
          if (mw(A, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case dq:
          return Dq;
        case si:
          var a = A, o = this.peekCodePoint(0), l = this.peekCodePoint(1);
          if (mw(a, o, l))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          if (Ld(a, o, l))
            return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          if (o === si && l === iq)
            return this.consumeCodePoint(), this.consumeCodePoint(), $q;
          break;
        case Wh:
          if (mw(A, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case TQ:
          if (this.peekCodePoint(0) === ww)
            for (this.consumeCodePoint(); ; ) {
              var c = this.consumeCodePoint();
              if (c === ww && (c = this.consumeCodePoint(), c === TQ))
                return this.consumeToken();
              if (c === Rs)
                return this.consumeToken();
            }
          break;
        case gq:
          return zq;
        case pq:
          return Xq;
        case nq:
          if (this.peekCodePoint(0) === rq && this.peekCodePoint(1) === si && this.peekCodePoint(2) === si)
            return this.consumeCodePoint(), this.consumeCodePoint(), qq;
          break;
        case sq:
          var u = this.peekCodePoint(0), d = this.peekCodePoint(1), h = this.peekCodePoint(2);
          if (Ld(u, d, h)) {
            var s = this.consumeName();
            return { type: 7, value: s };
          }
          break;
        case aq:
          return Yq;
        case Ch:
          if (Co(A, this.peekCodePoint(0)))
            return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          break;
        case oq:
          return Jq;
        case lq:
          if (this.peekCodePoint(0) === Du)
            return this.consumeCodePoint(), Mq;
          break;
        case cq:
          return Vq;
        case uq:
          return Gq;
        case Fq:
        case Uq:
          var p = this.peekCodePoint(0), B = this.peekCodePoint(1);
          return p === Hl && (Sc(B) || B === Id) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
        case _Q:
          if (this.peekCodePoint(0) === Du)
            return this.consumeCodePoint(), kq;
          if (this.peekCodePoint(0) === _Q)
            return this.consumeCodePoint(), Pq;
          break;
        case hq:
          if (this.peekCodePoint(0) === Du)
            return this.consumeCodePoint(), Kq;
          break;
        case Rs:
          return Rv;
      }
      return Sd(A) ? (this.consumeWhiteSpace(), Zq) : Un(A) ? (this.reconsumeCodePoint(A), this.consumeNumericToken()) : Sg(A) ? (this.reconsumeCodePoint(A), this.consumeIdentLikeToken()) : { type: 6, value: mr(A) };
    }, e.prototype.consumeCodePoint = function() {
      var A = this._value.shift();
      return typeof A > "u" ? -1 : A;
    }, e.prototype.reconsumeCodePoint = function(A) {
      this._value.unshift(A);
    }, e.prototype.peekCodePoint = function(A) {
      return A >= this._value.length ? -1 : this._value[A];
    }, e.prototype.consumeUnicodeRangeToken = function() {
      for (var A = [], t = this.consumeCodePoint(); Sc(t) && A.length < 6; )
        A.push(t), t = this.consumeCodePoint();
      for (var r = !1; t === Id && A.length < 6; )
        A.push(t), t = this.consumeCodePoint(), r = !0;
      if (r) {
        var n = parseInt(mr.apply(void 0, A.map(function(o) {
          return o === Id ? $3 : o;
        })), 16), i = parseInt(mr.apply(void 0, A.map(function(o) {
          return o === Id ? Z3 : o;
        })), 16);
        return { type: 30, start: n, end: i };
      }
      var s = parseInt(mr.apply(void 0, A), 16);
      if (this.peekCodePoint(0) === si && Sc(this.peekCodePoint(1))) {
        this.consumeCodePoint(), t = this.consumeCodePoint();
        for (var a = []; Sc(t) && a.length < 6; )
          a.push(t), t = this.consumeCodePoint();
        var i = parseInt(mr.apply(void 0, a), 16);
        return { type: 30, start: s, end: i };
      } else
        return { type: 30, start: s, end: s };
    }, e.prototype.consumeIdentLikeToken = function() {
      var A = this.consumeName();
      return A.toLowerCase() === "url" && this.peekCodePoint(0) === xd ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === xd ? (this.consumeCodePoint(), { type: 19, value: A }) : { type: 20, value: A };
    }, e.prototype.consumeUrlToken = function() {
      var A = [];
      if (this.consumeWhiteSpace(), this.peekCodePoint(0) === Rs)
        return { type: 22, value: "" };
      var t = this.peekCodePoint(0);
      if (t === Ed || t === Ud) {
        var r = this.consumeStringToken(this.consumeCodePoint());
        return r.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === Rs || this.peekCodePoint(0) === Ru) ? (this.consumeCodePoint(), { type: 22, value: r.value }) : (this.consumeBadUrlRemnants(), Hd);
      }
      for (; ; ) {
        var n = this.consumeCodePoint();
        if (n === Rs || n === Ru)
          return { type: 22, value: mr.apply(void 0, A) };
        if (Sd(n))
          return this.consumeWhiteSpace(), this.peekCodePoint(0) === Rs || this.peekCodePoint(0) === Ru ? (this.consumeCodePoint(), { type: 22, value: mr.apply(void 0, A) }) : (this.consumeBadUrlRemnants(), Hd);
        if (n === Ud || n === Ed || n === xd || Tq(n))
          return this.consumeBadUrlRemnants(), Hd;
        if (n === Ch)
          if (Co(n, this.peekCodePoint(0)))
            A.push(this.consumeEscapedCodePoint());
          else
            return this.consumeBadUrlRemnants(), Hd;
        else
          A.push(n);
      }
    }, e.prototype.consumeWhiteSpace = function() {
      for (; Sd(this.peekCodePoint(0)); )
        this.consumeCodePoint();
    }, e.prototype.consumeBadUrlRemnants = function() {
      for (; ; ) {
        var A = this.consumeCodePoint();
        if (A === Ru || A === Rs)
          return;
        Co(A, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
      }
    }, e.prototype.consumeStringSlice = function(A) {
      for (var t = 5e4, r = ""; A > 0; ) {
        var n = Math.min(t, A);
        r += mr.apply(void 0, this._value.splice(0, n)), A -= n;
      }
      return this._value.shift(), r;
    }, e.prototype.consumeStringToken = function(A) {
      var t = "", r = 0;
      do {
        var n = this._value[r];
        if (n === Rs || n === void 0 || n === A)
          return t += this.consumeStringSlice(r), { type: 0, value: t };
        if (n === Ig)
          return this._value.splice(0, r), jq;
        if (n === Ch) {
          var i = this._value[r + 1];
          i !== Rs && i !== void 0 && (i === Ig ? (t += this.consumeStringSlice(r), r = -1, this._value.shift()) : Co(n, i) && (t += this.consumeStringSlice(r), t += mr(this.consumeEscapedCodePoint()), r = -1));
        }
        r++;
      } while (!0);
    }, e.prototype.consumeNumber = function() {
      var A = [], t = Zh, r = this.peekCodePoint(0);
      for ((r === Hl || r === si) && A.push(this.consumeCodePoint()); Un(this.peekCodePoint(0)); )
        A.push(this.consumeCodePoint());
      r = this.peekCodePoint(0);
      var n = this.peekCodePoint(1);
      if (r === Wh && Un(n))
        for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), t = HQ; Un(this.peekCodePoint(0)); )
          A.push(this.consumeCodePoint());
      r = this.peekCodePoint(0), n = this.peekCodePoint(1);
      var i = this.peekCodePoint(2);
      if ((r === J3 || r === X3) && ((n === Hl || n === si) && Un(i) || Un(n)))
        for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), t = HQ; Un(this.peekCodePoint(0)); )
          A.push(this.consumeCodePoint());
      return [_q(A), t];
    }, e.prototype.consumeNumericToken = function() {
      var A = this.consumeNumber(), t = A[0], r = A[1], n = this.peekCodePoint(0), i = this.peekCodePoint(1), s = this.peekCodePoint(2);
      if (Ld(n, i, s)) {
        var a = this.consumeName();
        return { type: 15, number: t, flags: r, unit: a };
      }
      return n === eq ? (this.consumeCodePoint(), { type: 16, number: t, flags: r }) : { type: 17, number: t, flags: r };
    }, e.prototype.consumeEscapedCodePoint = function() {
      var A = this.consumeCodePoint();
      if (Sc(A)) {
        for (var t = mr(A); Sc(this.peekCodePoint(0)) && t.length < 6; )
          t += mr(this.consumeCodePoint());
        Sd(this.peekCodePoint(0)) && this.consumeCodePoint();
        var r = parseInt(t, 16);
        return r === 0 || xq(r) || r > 1114111 ? OQ : r;
      }
      return A === Rs ? OQ : A;
    }, e.prototype.consumeName = function() {
      for (var A = ""; ; ) {
        var t = this.consumeCodePoint();
        if (NQ(t))
          A += mr(t);
        else if (Co(t, this.peekCodePoint(0)))
          A += mr(this.consumeEscapedCodePoint());
        else
          return this.reconsumeCodePoint(t), A;
      }
    }, e;
  })()
), eL = (
  /** @class */
  (function() {
    function e(A) {
      this._tokens = A;
    }
    return e.create = function(A) {
      var t = new AL();
      return t.write(A), new e(t.read());
    }, e.parseValue = function(A) {
      return e.create(A).parseComponentValue();
    }, e.parseValues = function(A) {
      return e.create(A).parseComponentValues();
    }, e.prototype.parseComponentValue = function() {
      for (var A = this.consumeToken(); A.type === 31; )
        A = this.consumeToken();
      if (A.type === 32)
        throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
      this.reconsumeToken(A);
      var t = this.consumeComponentValue();
      do
        A = this.consumeToken();
      while (A.type === 31);
      if (A.type === 32)
        return t;
      throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
    }, e.prototype.parseComponentValues = function() {
      for (var A = []; ; ) {
        var t = this.consumeComponentValue();
        if (t.type === 32)
          return A;
        A.push(t), A.push();
      }
    }, e.prototype.consumeComponentValue = function() {
      var A = this.consumeToken();
      switch (A.type) {
        case 11:
        case 28:
        case 2:
          return this.consumeSimpleBlock(A.type);
        case 19:
          return this.consumeFunction(A);
      }
      return A;
    }, e.prototype.consumeSimpleBlock = function(A) {
      for (var t = { type: A, values: [] }, r = this.consumeToken(); ; ) {
        if (r.type === 32 || e$(r, A))
          return t;
        this.reconsumeToken(r), t.values.push(this.consumeComponentValue()), r = this.consumeToken();
      }
    }, e.prototype.consumeFunction = function(A) {
      for (var t = {
        name: A.value,
        values: [],
        type: 18
        /* FUNCTION */
      }; ; ) {
        var r = this.consumeToken();
        if (r.type === 32 || r.type === 3)
          return t;
        this.reconsumeToken(r), t.values.push(this.consumeComponentValue());
      }
    }, e.prototype.consumeToken = function() {
      var A = this._tokens.shift();
      return typeof A > "u" ? Rv : A;
    }, e.prototype.reconsumeToken = function(A) {
      this._tokens.unshift(A);
    }, e;
  })()
), Af = function(e) {
  return e.type === 15;
}, nu = function(e) {
  return e.type === 17;
}, mt = function(e) {
  return e.type === 20;
}, A$ = function(e) {
  return e.type === 0;
}, Mv = function(e, A) {
  return mt(e) && e.value === A;
}, tL = function(e) {
  return e.type !== 31;
}, Zc = function(e) {
  return e.type !== 31 && e.type !== 4;
}, Zs = function(e) {
  var A = [], t = [];
  return e.forEach(function(r) {
    if (r.type === 4) {
      if (t.length === 0)
        throw new Error("Error parsing function args, zero tokens for arg");
      A.push(t), t = [];
      return;
    }
    r.type !== 31 && t.push(r);
  }), t.length && A.push(t), A;
}, e$ = function(e, A) {
  return A === 11 && e.type === 12 || A === 28 && e.type === 29 ? !0 : A === 2 && e.type === 3;
}, ko = function(e) {
  return e.type === 17 || e.type === 15;
}, Sr = function(e) {
  return e.type === 16 || ko(e);
}, rL = function(e) {
  return e.length > 1 ? [e[0], e[1]] : [e[0]];
}, ln = {
  type: 17,
  number: 0,
  flags: Zh
}, Gy = {
  type: 16,
  number: 50,
  flags: Zh
}, Io = {
  type: 16,
  number: 100,
  flags: Zh
}, ah = function(e, A, t) {
  var r = e[0], n = e[1];
  return [It(r, A), It(typeof n < "u" ? n : r, t)];
}, It = function(e, A) {
  if (e.type === 16)
    return e.number / 100 * A;
  if (Af(e))
    switch (e.unit) {
      case "rem":
      case "em":
        return 16 * e.number;
      default:
        return e.number;
    }
  return e.number;
}, nL = "deg", iL = "grad", sL = "rad", aL = "turn", Bp = {
  name: "angle",
  parse: function(e, A) {
    if (A.type === 15)
      switch (A.unit) {
        case nL:
          return Math.PI * A.number / 180;
        case iL:
          return Math.PI / 200 * A.number;
        case sL:
          return A.number;
        case aL:
          return Math.PI * 2 * A.number;
      }
    throw new Error("Unsupported angle type");
  }
}, oL = function(e) {
  return e.type === 15 && (e.unit === nL || e.unit === iL || e.unit === sL || e.unit === aL);
}, lL = function(e) {
  var A = e.filter(mt).map(function(t) {
    return t.value;
  }).join(" ");
  switch (A) {
    case "to bottom right":
    case "to right bottom":
    case "left top":
    case "top left":
      return [ln, ln];
    case "to top":
    case "bottom":
      return zi(0);
    case "to bottom left":
    case "to left bottom":
    case "right top":
    case "top right":
      return [ln, Io];
    case "to right":
    case "left":
      return zi(90);
    case "to top left":
    case "to left top":
    case "right bottom":
    case "bottom right":
      return [Io, Io];
    case "to bottom":
    case "top":
      return zi(180);
    case "to top right":
    case "to right top":
    case "left bottom":
    case "bottom left":
      return [Io, ln];
    case "to left":
    case "right":
      return zi(270);
  }
  return 0;
}, zi = function(e) {
  return Math.PI * e / 180;
}, Oo = {
  name: "color",
  parse: function(e, A) {
    if (A.type === 18) {
      var t = t$[A.name];
      if (typeof t > "u")
        throw new Error('Attempting to parse an unsupported color function "' + A.name + '"');
      return t(e, A.values);
    }
    if (A.type === 5) {
      if (A.value.length === 3) {
        var r = A.value.substring(0, 1), n = A.value.substring(1, 2), i = A.value.substring(2, 3);
        return So(parseInt(r + r, 16), parseInt(n + n, 16), parseInt(i + i, 16), 1);
      }
      if (A.value.length === 4) {
        var r = A.value.substring(0, 1), n = A.value.substring(1, 2), i = A.value.substring(2, 3), s = A.value.substring(3, 4);
        return So(parseInt(r + r, 16), parseInt(n + n, 16), parseInt(i + i, 16), parseInt(s + s, 16) / 255);
      }
      if (A.value.length === 6) {
        var r = A.value.substring(0, 2), n = A.value.substring(2, 4), i = A.value.substring(4, 6);
        return So(parseInt(r, 16), parseInt(n, 16), parseInt(i, 16), 1);
      }
      if (A.value.length === 8) {
        var r = A.value.substring(0, 2), n = A.value.substring(2, 4), i = A.value.substring(4, 6), s = A.value.substring(6, 8);
        return So(parseInt(r, 16), parseInt(n, 16), parseInt(i, 16), parseInt(s, 16) / 255);
      }
    }
    if (A.type === 20) {
      var a = Ha[A.value.toUpperCase()];
      if (typeof a < "u")
        return a;
    }
    return Ha.TRANSPARENT;
  }
}, No = function(e) {
  return (255 & e) === 0;
}, $r = function(e) {
  var A = 255 & e, t = 255 & e >> 8, r = 255 & e >> 16, n = 255 & e >> 24;
  return A < 255 ? "rgba(" + n + "," + r + "," + t + "," + A / 255 + ")" : "rgb(" + n + "," + r + "," + t + ")";
}, So = function(e, A, t, r) {
  return (e << 24 | A << 16 | t << 8 | Math.round(r * 255) << 0) >>> 0;
}, DQ = function(e, A) {
  if (e.type === 17)
    return e.number;
  if (e.type === 16) {
    var t = A === 3 ? 1 : 255;
    return A === 3 ? e.number / 100 * t : Math.round(e.number / 100 * t);
  }
  return 0;
}, RQ = function(e, A) {
  var t = A.filter(Zc);
  if (t.length === 3) {
    var r = t.map(DQ), n = r[0], i = r[1], s = r[2];
    return So(n, i, s, 1);
  }
  if (t.length === 4) {
    var a = t.map(DQ), n = a[0], i = a[1], s = a[2], o = a[3];
    return So(n, i, s, o);
  }
  return 0;
};
function vw(e, A, t) {
  return t < 0 && (t += 1), t >= 1 && (t -= 1), t < 1 / 6 ? (A - e) * t * 6 + e : t < 1 / 2 ? A : t < 2 / 3 ? (A - e) * 6 * (2 / 3 - t) + e : e;
}
var MQ = function(e, A) {
  var t = A.filter(Zc), r = t[0], n = t[1], i = t[2], s = t[3], a = (r.type === 17 ? zi(r.number) : Bp.parse(e, r)) / (Math.PI * 2), o = Sr(n) ? n.number / 100 : 0, l = Sr(i) ? i.number / 100 : 0, c = typeof s < "u" && Sr(s) ? It(s, 1) : 1;
  if (o === 0)
    return So(l * 255, l * 255, l * 255, 1);
  var u = l <= 0.5 ? l * (o + 1) : l + o - l * o, d = l * 2 - u, h = vw(d, u, a + 1 / 3), p = vw(d, u, a), B = vw(d, u, a - 1 / 3);
  return So(h * 255, p * 255, B * 255, c);
}, t$ = {
  hsl: MQ,
  hsla: MQ,
  rgb: RQ,
  rgba: RQ
}, bh = function(e, A) {
  return Oo.parse(e, eL.create(A).parseComponentValue());
}, Ha = {
  ALICEBLUE: 4042850303,
  ANTIQUEWHITE: 4209760255,
  AQUA: 16777215,
  AQUAMARINE: 2147472639,
  AZURE: 4043309055,
  BEIGE: 4126530815,
  BISQUE: 4293182719,
  BLACK: 255,
  BLANCHEDALMOND: 4293643775,
  BLUE: 65535,
  BLUEVIOLET: 2318131967,
  BROWN: 2771004159,
  BURLYWOOD: 3736635391,
  CADETBLUE: 1604231423,
  CHARTREUSE: 2147418367,
  CHOCOLATE: 3530104575,
  CORAL: 4286533887,
  CORNFLOWERBLUE: 1687547391,
  CORNSILK: 4294499583,
  CRIMSON: 3692313855,
  CYAN: 16777215,
  DARKBLUE: 35839,
  DARKCYAN: 9145343,
  DARKGOLDENROD: 3095837695,
  DARKGRAY: 2846468607,
  DARKGREEN: 6553855,
  DARKGREY: 2846468607,
  DARKKHAKI: 3182914559,
  DARKMAGENTA: 2332068863,
  DARKOLIVEGREEN: 1433087999,
  DARKORANGE: 4287365375,
  DARKORCHID: 2570243327,
  DARKRED: 2332033279,
  DARKSALMON: 3918953215,
  DARKSEAGREEN: 2411499519,
  DARKSLATEBLUE: 1211993087,
  DARKSLATEGRAY: 793726975,
  DARKSLATEGREY: 793726975,
  DARKTURQUOISE: 13554175,
  DARKVIOLET: 2483082239,
  DEEPPINK: 4279538687,
  DEEPSKYBLUE: 12582911,
  DIMGRAY: 1768516095,
  DIMGREY: 1768516095,
  DODGERBLUE: 512819199,
  FIREBRICK: 2988581631,
  FLORALWHITE: 4294635775,
  FORESTGREEN: 579543807,
  FUCHSIA: 4278255615,
  GAINSBORO: 3705462015,
  GHOSTWHITE: 4177068031,
  GOLD: 4292280575,
  GOLDENROD: 3668254975,
  GRAY: 2155905279,
  GREEN: 8388863,
  GREENYELLOW: 2919182335,
  GREY: 2155905279,
  HONEYDEW: 4043305215,
  HOTPINK: 4285117695,
  INDIANRED: 3445382399,
  INDIGO: 1258324735,
  IVORY: 4294963455,
  KHAKI: 4041641215,
  LAVENDER: 3873897215,
  LAVENDERBLUSH: 4293981695,
  LAWNGREEN: 2096890111,
  LEMONCHIFFON: 4294626815,
  LIGHTBLUE: 2916673279,
  LIGHTCORAL: 4034953471,
  LIGHTCYAN: 3774873599,
  LIGHTGOLDENRODYELLOW: 4210742015,
  LIGHTGRAY: 3553874943,
  LIGHTGREEN: 2431553791,
  LIGHTGREY: 3553874943,
  LIGHTPINK: 4290167295,
  LIGHTSALMON: 4288707327,
  LIGHTSEAGREEN: 548580095,
  LIGHTSKYBLUE: 2278488831,
  LIGHTSLATEGRAY: 2005441023,
  LIGHTSLATEGREY: 2005441023,
  LIGHTSTEELBLUE: 2965692159,
  LIGHTYELLOW: 4294959359,
  LIME: 16711935,
  LIMEGREEN: 852308735,
  LINEN: 4210091775,
  MAGENTA: 4278255615,
  MAROON: 2147483903,
  MEDIUMAQUAMARINE: 1724754687,
  MEDIUMBLUE: 52735,
  MEDIUMORCHID: 3126187007,
  MEDIUMPURPLE: 2473647103,
  MEDIUMSEAGREEN: 1018393087,
  MEDIUMSLATEBLUE: 2070474495,
  MEDIUMSPRINGGREEN: 16423679,
  MEDIUMTURQUOISE: 1221709055,
  MEDIUMVIOLETRED: 3340076543,
  MIDNIGHTBLUE: 421097727,
  MINTCREAM: 4127193855,
  MISTYROSE: 4293190143,
  MOCCASIN: 4293178879,
  NAVAJOWHITE: 4292783615,
  NAVY: 33023,
  OLDLACE: 4260751103,
  OLIVE: 2155872511,
  OLIVEDRAB: 1804477439,
  ORANGE: 4289003775,
  ORANGERED: 4282712319,
  ORCHID: 3664828159,
  PALEGOLDENROD: 4008225535,
  PALEGREEN: 2566625535,
  PALETURQUOISE: 2951671551,
  PALEVIOLETRED: 3681588223,
  PAPAYAWHIP: 4293907967,
  PEACHPUFF: 4292524543,
  PERU: 3448061951,
  PINK: 4290825215,
  PLUM: 3718307327,
  POWDERBLUE: 2967529215,
  PURPLE: 2147516671,
  REBECCAPURPLE: 1714657791,
  RED: 4278190335,
  ROSYBROWN: 3163525119,
  ROYALBLUE: 1097458175,
  SADDLEBROWN: 2336560127,
  SALMON: 4202722047,
  SANDYBROWN: 4104413439,
  SEAGREEN: 780883967,
  SEASHELL: 4294307583,
  SIENNA: 2689740287,
  SILVER: 3233857791,
  SKYBLUE: 2278484991,
  SLATEBLUE: 1784335871,
  SLATEGRAY: 1887473919,
  SLATEGREY: 1887473919,
  SNOW: 4294638335,
  SPRINGGREEN: 16744447,
  STEELBLUE: 1182971135,
  TAN: 3535047935,
  TEAL: 8421631,
  THISTLE: 3636451583,
  TOMATO: 4284696575,
  TRANSPARENT: 0,
  TURQUOISE: 1088475391,
  VIOLET: 4001558271,
  WHEAT: 4125012991,
  WHITE: 4294967295,
  WHITESMOKE: 4126537215,
  YELLOW: 4294902015,
  YELLOWGREEN: 2597139199
}, r$ = {
  name: "background-clip",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.map(function(t) {
      if (mt(t))
        switch (t.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, n$ = {
  name: "background-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, wp = function(e, A) {
  var t = Oo.parse(e, A[0]), r = A[1];
  return r && Sr(r) ? { color: t, stop: r } : { color: t, stop: null };
}, PQ = function(e, A) {
  var t = e[0], r = e[e.length - 1];
  t.stop === null && (t.stop = ln), r.stop === null && (r.stop = Io);
  for (var n = [], i = 0, s = 0; s < e.length; s++) {
    var a = e[s].stop;
    if (a !== null) {
      var o = It(a, A);
      o > i ? n.push(o) : n.push(i), i = o;
    } else
      n.push(null);
  }
  for (var l = null, s = 0; s < n.length; s++) {
    var c = n[s];
    if (c === null)
      l === null && (l = s);
    else if (l !== null) {
      for (var u = s - l, d = n[l - 1], h = (c - d) / (u + 1), p = 1; p <= u; p++)
        n[l + p - 1] = h * p;
      l = null;
    }
  }
  return e.map(function(B, y) {
    var m = B.color;
    return { color: m, stop: Math.max(Math.min(1, n[y] / A), 0) };
  });
}, i$ = function(e, A, t) {
  var r = A / 2, n = t / 2, i = It(e[0], A) - r, s = n - It(e[1], t);
  return (Math.atan2(s, i) + Math.PI * 2) % (Math.PI * 2);
}, s$ = function(e, A, t) {
  var r = typeof e == "number" ? e : i$(e, A, t), n = Math.abs(A * Math.sin(r)) + Math.abs(t * Math.cos(r)), i = A / 2, s = t / 2, a = n / 2, o = Math.sin(r - Math.PI / 2) * a, l = Math.cos(r - Math.PI / 2) * a;
  return [n, i - l, i + l, s - o, s + o];
}, gs = function(e, A) {
  return Math.sqrt(e * e + A * A);
}, kQ = function(e, A, t, r, n) {
  var i = [
    [0, 0],
    [0, A],
    [e, 0],
    [e, A]
  ];
  return i.reduce(function(s, a) {
    var o = a[0], l = a[1], c = gs(t - o, r - l);
    return (n ? c < s.optimumDistance : c > s.optimumDistance) ? {
      optimumCorner: a,
      optimumDistance: c
    } : s;
  }, {
    optimumDistance: n ? 1 / 0 : -1 / 0,
    optimumCorner: null
  }).optimumCorner;
}, a$ = function(e, A, t, r, n) {
  var i = 0, s = 0;
  switch (e.size) {
    case 0:
      e.shape === 0 ? i = s = Math.min(Math.abs(A), Math.abs(A - r), Math.abs(t), Math.abs(t - n)) : e.shape === 1 && (i = Math.min(Math.abs(A), Math.abs(A - r)), s = Math.min(Math.abs(t), Math.abs(t - n)));
      break;
    case 2:
      if (e.shape === 0)
        i = s = Math.min(gs(A, t), gs(A, t - n), gs(A - r, t), gs(A - r, t - n));
      else if (e.shape === 1) {
        var a = Math.min(Math.abs(t), Math.abs(t - n)) / Math.min(Math.abs(A), Math.abs(A - r)), o = kQ(r, n, A, t, !0), l = o[0], c = o[1];
        i = gs(l - A, (c - t) / a), s = a * i;
      }
      break;
    case 1:
      e.shape === 0 ? i = s = Math.max(Math.abs(A), Math.abs(A - r), Math.abs(t), Math.abs(t - n)) : e.shape === 1 && (i = Math.max(Math.abs(A), Math.abs(A - r)), s = Math.max(Math.abs(t), Math.abs(t - n)));
      break;
    case 3:
      if (e.shape === 0)
        i = s = Math.max(gs(A, t), gs(A, t - n), gs(A - r, t), gs(A - r, t - n));
      else if (e.shape === 1) {
        var a = Math.max(Math.abs(t), Math.abs(t - n)) / Math.max(Math.abs(A), Math.abs(A - r)), u = kQ(r, n, A, t, !1), l = u[0], c = u[1];
        i = gs(l - A, (c - t) / a), s = a * i;
      }
      break;
  }
  return Array.isArray(e.size) && (i = It(e.size[0], r), s = e.size.length === 2 ? It(e.size[1], n) : i), [i, s];
}, o$ = function(e, A) {
  var t = zi(180), r = [];
  return Zs(A).forEach(function(n, i) {
    if (i === 0) {
      var s = n[0];
      if (s.type === 20 && s.value === "to") {
        t = lL(n);
        return;
      } else if (oL(s)) {
        t = Bp.parse(e, s);
        return;
      }
    }
    var a = wp(e, n);
    r.push(a);
  }), {
    angle: t,
    stops: r,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, Td = function(e, A) {
  var t = zi(180), r = [];
  return Zs(A).forEach(function(n, i) {
    if (i === 0) {
      var s = n[0];
      if (s.type === 20 && ["top", "left", "right", "bottom"].indexOf(s.value) !== -1) {
        t = lL(n);
        return;
      } else if (oL(s)) {
        t = (Bp.parse(e, s) + zi(270)) % zi(360);
        return;
      }
    }
    var a = wp(e, n);
    r.push(a);
  }), {
    angle: t,
    stops: r,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, l$ = function(e, A) {
  var t = zi(180), r = [], n = 1, i = 0, s = 3, a = [];
  return Zs(A).forEach(function(o, l) {
    var c = o[0];
    if (l === 0) {
      if (mt(c) && c.value === "linear") {
        n = 1;
        return;
      } else if (mt(c) && c.value === "radial") {
        n = 2;
        return;
      }
    }
    if (c.type === 18) {
      if (c.name === "from") {
        var u = Oo.parse(e, c.values[0]);
        r.push({ stop: ln, color: u });
      } else if (c.name === "to") {
        var u = Oo.parse(e, c.values[0]);
        r.push({ stop: Io, color: u });
      } else if (c.name === "color-stop") {
        var d = c.values.filter(Zc);
        if (d.length === 2) {
          var u = Oo.parse(e, d[1]), h = d[0];
          nu(h) && r.push({
            stop: { type: 16, number: h.number * 100, flags: h.flags },
            color: u
          });
        }
      }
    }
  }), n === 1 ? {
    angle: (t + zi(180)) % zi(360),
    stops: r,
    type: n
  } : { size: s, shape: i, stops: r, position: a, type: n };
}, cL = "closest-side", uL = "farthest-side", hL = "closest-corner", fL = "farthest-corner", dL = "circle", gL = "ellipse", pL = "cover", BL = "contain", c$ = function(e, A) {
  var t = 0, r = 3, n = [], i = [];
  return Zs(A).forEach(function(s, a) {
    var o = !0;
    if (a === 0) {
      var l = !1;
      o = s.reduce(function(u, d) {
        if (l)
          if (mt(d))
            switch (d.value) {
              case "center":
                return i.push(Gy), u;
              case "top":
              case "left":
                return i.push(ln), u;
              case "right":
              case "bottom":
                return i.push(Io), u;
            }
          else (Sr(d) || ko(d)) && i.push(d);
        else if (mt(d))
          switch (d.value) {
            case dL:
              return t = 0, !1;
            case gL:
              return t = 1, !1;
            case "at":
              return l = !0, !1;
            case cL:
              return r = 0, !1;
            case pL:
            case uL:
              return r = 1, !1;
            case BL:
            case hL:
              return r = 2, !1;
            case fL:
              return r = 3, !1;
          }
        else if (ko(d) || Sr(d))
          return Array.isArray(r) || (r = []), r.push(d), !1;
        return u;
      }, o);
    }
    if (o) {
      var c = wp(e, s);
      n.push(c);
    }
  }), {
    size: r,
    shape: t,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, _d = function(e, A) {
  var t = 0, r = 3, n = [], i = [];
  return Zs(A).forEach(function(s, a) {
    var o = !0;
    if (a === 0 ? o = s.reduce(function(c, u) {
      if (mt(u))
        switch (u.value) {
          case "center":
            return i.push(Gy), !1;
          case "top":
          case "left":
            return i.push(ln), !1;
          case "right":
          case "bottom":
            return i.push(Io), !1;
        }
      else if (Sr(u) || ko(u))
        return i.push(u), !1;
      return c;
    }, o) : a === 1 && (o = s.reduce(function(c, u) {
      if (mt(u))
        switch (u.value) {
          case dL:
            return t = 0, !1;
          case gL:
            return t = 1, !1;
          case BL:
          case cL:
            return r = 0, !1;
          case uL:
            return r = 1, !1;
          case hL:
            return r = 2, !1;
          case pL:
          case fL:
            return r = 3, !1;
        }
      else if (ko(u) || Sr(u))
        return Array.isArray(r) || (r = []), r.push(u), !1;
      return c;
    }, o)), o) {
      var l = wp(e, s);
      n.push(l);
    }
  }), {
    size: r,
    shape: t,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, u$ = function(e) {
  return e.type === 1;
}, h$ = function(e) {
  return e.type === 2;
}, Wy = {
  name: "image",
  parse: function(e, A) {
    if (A.type === 22) {
      var t = {
        url: A.value,
        type: 0
        /* URL */
      };
      return e.cache.addImage(A.value), t;
    }
    if (A.type === 18) {
      var r = wL[A.name];
      if (typeof r > "u")
        throw new Error('Attempting to parse an unsupported image function "' + A.name + '"');
      return r(e, A.values);
    }
    throw new Error("Unsupported image type " + A.type);
  }
};
function f$(e) {
  return !(e.type === 20 && e.value === "none") && (e.type !== 18 || !!wL[e.name]);
}
var wL = {
  "linear-gradient": o$,
  "-moz-linear-gradient": Td,
  "-ms-linear-gradient": Td,
  "-o-linear-gradient": Td,
  "-webkit-linear-gradient": Td,
  "radial-gradient": c$,
  "-moz-radial-gradient": _d,
  "-ms-radial-gradient": _d,
  "-o-radial-gradient": _d,
  "-webkit-radial-gradient": _d,
  "-webkit-gradient": l$
}, d$ = {
  name: "background-image",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    if (A.length === 0)
      return [];
    var t = A[0];
    return t.type === 20 && t.value === "none" ? [] : A.filter(function(r) {
      return Zc(r) && f$(r);
    }).map(function(r) {
      return Wy.parse(e, r);
    });
  }
}, g$ = {
  name: "background-origin",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.map(function(t) {
      if (mt(t))
        switch (t.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, p$ = {
  name: "background-position",
  initialValue: "0% 0%",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return Zs(A).map(function(t) {
      return t.filter(Sr);
    }).map(rL);
  }
}, B$ = {
  name: "background-repeat",
  initialValue: "repeat",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return Zs(A).map(function(t) {
      return t.filter(mt).map(function(r) {
        return r.value;
      }).join(" ");
    }).map(w$);
  }
}, w$ = function(e) {
  switch (e) {
    case "no-repeat":
      return 1;
    case "repeat-x":
    case "repeat no-repeat":
      return 2;
    case "repeat-y":
    case "no-repeat repeat":
      return 3;
    default:
      return 0;
  }
}, zc;
(function(e) {
  e.AUTO = "auto", e.CONTAIN = "contain", e.COVER = "cover";
})(zc || (zc = {}));
var m$ = {
  name: "background-size",
  initialValue: "0",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return Zs(A).map(function(t) {
      return t.filter(v$);
    });
  }
}, v$ = function(e) {
  return mt(e) || Sr(e);
}, mp = function(e) {
  return {
    name: "border-" + e + "-color",
    initialValue: "transparent",
    prefix: !1,
    type: 3,
    format: "color"
  };
}, y$ = mp("top"), C$ = mp("right"), b$ = mp("bottom"), F$ = mp("left"), vp = function(e) {
  return {
    name: "border-radius-" + e,
    initialValue: "0 0",
    prefix: !1,
    type: 1,
    parse: function(A, t) {
      return rL(t.filter(Sr));
    }
  };
}, Q$ = vp("top-left"), U$ = vp("top-right"), E$ = vp("bottom-right"), x$ = vp("bottom-left"), yp = function(e) {
  return {
    name: "border-" + e + "-style",
    initialValue: "solid",
    prefix: !1,
    type: 2,
    parse: function(A, t) {
      switch (t) {
        case "none":
          return 0;
        case "dashed":
          return 2;
        case "dotted":
          return 3;
        case "double":
          return 4;
      }
      return 1;
    }
  };
}, I$ = yp("top"), S$ = yp("right"), L$ = yp("bottom"), H$ = yp("left"), Cp = function(e) {
  return {
    name: "border-" + e + "-width",
    initialValue: "0",
    type: 0,
    prefix: !1,
    parse: function(A, t) {
      return Af(t) ? t.number : 0;
    }
  };
}, T$ = Cp("top"), _$ = Cp("right"), O$ = Cp("bottom"), N$ = Cp("left"), D$ = {
  name: "color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, R$ = {
  name: "direction",
  initialValue: "ltr",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    return A === "rtl" ? 1 : 0;
  }
}, M$ = {
  name: "display",
  initialValue: "inline-block",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(mt).reduce(
      function(t, r) {
        return t | P$(r.value);
      },
      0
      /* NONE */
    );
  }
}, P$ = function(e) {
  switch (e) {
    case "block":
    case "-webkit-box":
      return 2;
    case "inline":
      return 4;
    case "run-in":
      return 8;
    case "flow":
      return 16;
    case "flow-root":
      return 32;
    case "table":
      return 64;
    case "flex":
    case "-webkit-flex":
      return 128;
    case "grid":
    case "-ms-grid":
      return 256;
    case "ruby":
      return 512;
    case "subgrid":
      return 1024;
    case "list-item":
      return 2048;
    case "table-row-group":
      return 4096;
    case "table-header-group":
      return 8192;
    case "table-footer-group":
      return 16384;
    case "table-row":
      return 32768;
    case "table-cell":
      return 65536;
    case "table-column-group":
      return 131072;
    case "table-column":
      return 262144;
    case "table-caption":
      return 524288;
    case "ruby-base":
      return 1048576;
    case "ruby-text":
      return 2097152;
    case "ruby-base-container":
      return 4194304;
    case "ruby-text-container":
      return 8388608;
    case "contents":
      return 16777216;
    case "inline-block":
      return 33554432;
    case "inline-list-item":
      return 67108864;
    case "inline-table":
      return 134217728;
    case "inline-flex":
      return 268435456;
    case "inline-grid":
      return 536870912;
  }
  return 0;
}, k$ = {
  name: "float",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "left":
        return 1;
      case "right":
        return 2;
      case "inline-start":
        return 3;
      case "inline-end":
        return 4;
    }
    return 0;
  }
}, K$ = {
  name: "letter-spacing",
  initialValue: "0",
  prefix: !1,
  type: 0,
  parse: function(e, A) {
    return A.type === 20 && A.value === "normal" ? 0 : A.type === 17 || A.type === 15 ? A.number : 0;
  }
}, Lg;
(function(e) {
  e.NORMAL = "normal", e.STRICT = "strict";
})(Lg || (Lg = {}));
var V$ = {
  name: "line-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    return A === "strict" ? Lg.STRICT : Lg.NORMAL;
  }
}, G$ = {
  name: "line-height",
  initialValue: "normal",
  prefix: !1,
  type: 4
  /* TOKEN_VALUE */
}, KQ = function(e, A) {
  return mt(e) && e.value === "normal" ? 1.2 * A : e.type === 17 ? A * e.number : Sr(e) ? It(e, A) : A;
}, W$ = {
  name: "list-style-image",
  initialValue: "none",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    return A.type === 20 && A.value === "none" ? null : Wy.parse(e, A);
  }
}, j$ = {
  name: "list-style-position",
  initialValue: "outside",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    return A === "inside" ? 0 : 1;
  }
}, Pv = {
  name: "list-style-type",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "disc":
        return 0;
      case "circle":
        return 1;
      case "square":
        return 2;
      case "decimal":
        return 3;
      case "cjk-decimal":
        return 4;
      case "decimal-leading-zero":
        return 5;
      case "lower-roman":
        return 6;
      case "upper-roman":
        return 7;
      case "lower-greek":
        return 8;
      case "lower-alpha":
        return 9;
      case "upper-alpha":
        return 10;
      case "arabic-indic":
        return 11;
      case "armenian":
        return 12;
      case "bengali":
        return 13;
      case "cambodian":
        return 14;
      case "cjk-earthly-branch":
        return 15;
      case "cjk-heavenly-stem":
        return 16;
      case "cjk-ideographic":
        return 17;
      case "devanagari":
        return 18;
      case "ethiopic-numeric":
        return 19;
      case "georgian":
        return 20;
      case "gujarati":
        return 21;
      case "gurmukhi":
        return 22;
      case "hebrew":
        return 22;
      case "hiragana":
        return 23;
      case "hiragana-iroha":
        return 24;
      case "japanese-formal":
        return 25;
      case "japanese-informal":
        return 26;
      case "kannada":
        return 27;
      case "katakana":
        return 28;
      case "katakana-iroha":
        return 29;
      case "khmer":
        return 30;
      case "korean-hangul-formal":
        return 31;
      case "korean-hanja-formal":
        return 32;
      case "korean-hanja-informal":
        return 33;
      case "lao":
        return 34;
      case "lower-armenian":
        return 35;
      case "malayalam":
        return 36;
      case "mongolian":
        return 37;
      case "myanmar":
        return 38;
      case "oriya":
        return 39;
      case "persian":
        return 40;
      case "simp-chinese-formal":
        return 41;
      case "simp-chinese-informal":
        return 42;
      case "tamil":
        return 43;
      case "telugu":
        return 44;
      case "thai":
        return 45;
      case "tibetan":
        return 46;
      case "trad-chinese-formal":
        return 47;
      case "trad-chinese-informal":
        return 48;
      case "upper-armenian":
        return 49;
      case "disclosure-open":
        return 50;
      case "disclosure-closed":
        return 51;
      default:
        return -1;
    }
  }
}, bp = function(e) {
  return {
    name: "margin-" + e,
    initialValue: "0",
    prefix: !1,
    type: 4
    /* TOKEN_VALUE */
  };
}, q$ = bp("top"), $$ = bp("right"), z$ = bp("bottom"), X$ = bp("left"), Y$ = {
  name: "overflow",
  initialValue: "visible",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(mt).map(function(t) {
      switch (t.value) {
        case "hidden":
          return 1;
        case "scroll":
          return 2;
        case "clip":
          return 3;
        case "auto":
          return 4;
        default:
          return 0;
      }
    });
  }
}, J$ = {
  name: "overflow-wrap",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    return A === "break-word" ? "break-word" : "normal";
  }
}, Fp = function(e) {
  return {
    name: "padding-" + e,
    initialValue: "0",
    prefix: !1,
    type: 3,
    format: "length-percentage"
  };
}, Z$ = Fp("top"), Az = Fp("right"), ez = Fp("bottom"), tz = Fp("left"), rz = {
  name: "text-align",
  initialValue: "left",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "right":
        return 2;
      case "center":
      case "justify":
        return 1;
      default:
        return 0;
    }
  }
}, nz = {
  name: "position",
  initialValue: "static",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "relative":
        return 1;
      case "absolute":
        return 2;
      case "fixed":
        return 3;
      case "sticky":
        return 4;
    }
    return 0;
  }
}, iz = {
  name: "text-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return A.length === 1 && Mv(A[0], "none") ? [] : Zs(A).map(function(t) {
      for (var r = {
        color: Ha.TRANSPARENT,
        offsetX: ln,
        offsetY: ln,
        blur: ln
      }, n = 0, i = 0; i < t.length; i++) {
        var s = t[i];
        ko(s) ? (n === 0 ? r.offsetX = s : n === 1 ? r.offsetY = s : r.blur = s, n++) : r.color = Oo.parse(e, s);
      }
      return r;
    });
  }
}, sz = {
  name: "text-transform",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "uppercase":
        return 2;
      case "lowercase":
        return 1;
      case "capitalize":
        return 3;
    }
    return 0;
  }
}, az = {
  name: "transform",
  initialValue: "none",
  prefix: !0,
  type: 0,
  parse: function(e, A) {
    if (A.type === 20 && A.value === "none")
      return null;
    if (A.type === 18) {
      var t = cz[A.name];
      if (typeof t > "u")
        throw new Error('Attempting to parse an unsupported transform function "' + A.name + '"');
      return t(A.values);
    }
    return null;
  }
}, oz = function(e) {
  var A = e.filter(function(t) {
    return t.type === 17;
  }).map(function(t) {
    return t.number;
  });
  return A.length === 6 ? A : null;
}, lz = function(e) {
  var A = e.filter(function(o) {
    return o.type === 17;
  }).map(function(o) {
    return o.number;
  }), t = A[0], r = A[1];
  A[2], A[3];
  var n = A[4], i = A[5];
  A[6], A[7], A[8], A[9], A[10], A[11];
  var s = A[12], a = A[13];
  return A[14], A[15], A.length === 16 ? [t, r, n, i, s, a] : null;
}, cz = {
  matrix: oz,
  matrix3d: lz
}, VQ = {
  type: 16,
  number: 50,
  flags: Zh
}, uz = [VQ, VQ], hz = {
  name: "transform-origin",
  initialValue: "50% 50%",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    var t = A.filter(Sr);
    return t.length !== 2 ? uz : [t[0], t[1]];
  }
}, fz = {
  name: "visible",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "hidden":
        return 1;
      case "collapse":
        return 2;
      default:
        return 0;
    }
  }
}, Fh;
(function(e) {
  e.NORMAL = "normal", e.BREAK_ALL = "break-all", e.KEEP_ALL = "keep-all";
})(Fh || (Fh = {}));
var dz = {
  name: "word-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "break-all":
        return Fh.BREAK_ALL;
      case "keep-all":
        return Fh.KEEP_ALL;
      default:
        return Fh.NORMAL;
    }
  }
}, gz = {
  name: "z-index",
  initialValue: "auto",
  prefix: !1,
  type: 0,
  parse: function(e, A) {
    if (A.type === 20)
      return { auto: !0, order: 0 };
    if (nu(A))
      return { auto: !1, order: A.number };
    throw new Error("Invalid z-index number parsed");
  }
}, mL = {
  name: "time",
  parse: function(e, A) {
    if (A.type === 15)
      switch (A.unit.toLowerCase()) {
        case "s":
          return 1e3 * A.number;
        case "ms":
          return A.number;
      }
    throw new Error("Unsupported time type");
  }
}, pz = {
  name: "opacity",
  initialValue: "1",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    return nu(A) ? A.number : 1;
  }
}, Bz = {
  name: "text-decoration-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, wz = {
  name: "text-decoration-line",
  initialValue: "none",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(mt).map(function(t) {
      switch (t.value) {
        case "underline":
          return 1;
        case "overline":
          return 2;
        case "line-through":
          return 3;
        case "none":
          return 4;
      }
      return 0;
    }).filter(function(t) {
      return t !== 0;
    });
  }
}, mz = {
  name: "font-family",
  initialValue: "",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    var t = [], r = [];
    return A.forEach(function(n) {
      switch (n.type) {
        case 20:
        case 0:
          t.push(n.value);
          break;
        case 17:
          t.push(n.number.toString());
          break;
        case 4:
          r.push(t.join(" ")), t.length = 0;
          break;
      }
    }), t.length && r.push(t.join(" ")), r.map(function(n) {
      return n.indexOf(" ") === -1 ? n : "'" + n + "'";
    });
  }
}, vz = {
  name: "font-size",
  initialValue: "0",
  prefix: !1,
  type: 3,
  format: "length"
}, yz = {
  name: "font-weight",
  initialValue: "normal",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    return nu(A) ? A.number : mt(A) && A.value === "bold" ? 700 : 400;
  }
}, Cz = {
  name: "font-variant",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return A.filter(mt).map(function(t) {
      return t.value;
    });
  }
}, bz = {
  name: "font-style",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "oblique":
        return "oblique";
      case "italic":
        return "italic";
      default:
        return "normal";
    }
  }
}, kr = function(e, A) {
  return (e & A) !== 0;
}, Fz = {
  name: "content",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    if (A.length === 0)
      return [];
    var t = A[0];
    return t.type === 20 && t.value === "none" ? [] : A;
  }
}, Qz = {
  name: "counter-increment",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    if (A.length === 0)
      return null;
    var t = A[0];
    if (t.type === 20 && t.value === "none")
      return null;
    for (var r = [], n = A.filter(tL), i = 0; i < n.length; i++) {
      var s = n[i], a = n[i + 1];
      if (s.type === 20) {
        var o = a && nu(a) ? a.number : 1;
        r.push({ counter: s.value, increment: o });
      }
    }
    return r;
  }
}, Uz = {
  name: "counter-reset",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    if (A.length === 0)
      return [];
    for (var t = [], r = A.filter(tL), n = 0; n < r.length; n++) {
      var i = r[n], s = r[n + 1];
      if (mt(i) && i.value !== "none") {
        var a = s && nu(s) ? s.number : 0;
        t.push({ counter: i.value, reset: a });
      }
    }
    return t;
  }
}, Ez = {
  name: "duration",
  initialValue: "0s",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(Af).map(function(t) {
      return mL.parse(e, t);
    });
  }
}, xz = {
  name: "quotes",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    if (A.length === 0)
      return null;
    var t = A[0];
    if (t.type === 20 && t.value === "none")
      return null;
    var r = [], n = A.filter(A$);
    if (n.length % 2 !== 0)
      return null;
    for (var i = 0; i < n.length; i += 2) {
      var s = n[i].value, a = n[i + 1].value;
      r.push({ open: s, close: a });
    }
    return r;
  }
}, GQ = function(e, A, t) {
  if (!e)
    return "";
  var r = e[Math.min(A, e.length - 1)];
  return r ? t ? r.open : r.close : "";
}, Iz = {
  name: "box-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return A.length === 1 && Mv(A[0], "none") ? [] : Zs(A).map(function(t) {
      for (var r = {
        color: 255,
        offsetX: ln,
        offsetY: ln,
        blur: ln,
        spread: ln,
        inset: !1
      }, n = 0, i = 0; i < t.length; i++) {
        var s = t[i];
        Mv(s, "inset") ? r.inset = !0 : ko(s) ? (n === 0 ? r.offsetX = s : n === 1 ? r.offsetY = s : n === 2 ? r.blur = s : r.spread = s, n++) : r.color = Oo.parse(e, s);
      }
      return r;
    });
  }
}, Sz = {
  name: "paint-order",
  initialValue: "normal",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    var t = [
      0,
      1,
      2
      /* MARKERS */
    ], r = [];
    return A.filter(mt).forEach(function(n) {
      switch (n.value) {
        case "stroke":
          r.push(
            1
            /* STROKE */
          );
          break;
        case "fill":
          r.push(
            0
            /* FILL */
          );
          break;
        case "markers":
          r.push(
            2
            /* MARKERS */
          );
          break;
      }
    }), t.forEach(function(n) {
      r.indexOf(n) === -1 && r.push(n);
    }), r;
  }
}, Lz = {
  name: "-webkit-text-stroke-color",
  initialValue: "currentcolor",
  prefix: !1,
  type: 3,
  format: "color"
}, Hz = {
  name: "-webkit-text-stroke-width",
  initialValue: "0",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    return Af(A) ? A.number : 0;
  }
}, Tz = (
  /** @class */
  (function() {
    function e(A, t) {
      var r, n;
      this.animationDuration = se(A, Ez, t.animationDuration), this.backgroundClip = se(A, r$, t.backgroundClip), this.backgroundColor = se(A, n$, t.backgroundColor), this.backgroundImage = se(A, d$, t.backgroundImage), this.backgroundOrigin = se(A, g$, t.backgroundOrigin), this.backgroundPosition = se(A, p$, t.backgroundPosition), this.backgroundRepeat = se(A, B$, t.backgroundRepeat), this.backgroundSize = se(A, m$, t.backgroundSize), this.borderTopColor = se(A, y$, t.borderTopColor), this.borderRightColor = se(A, C$, t.borderRightColor), this.borderBottomColor = se(A, b$, t.borderBottomColor), this.borderLeftColor = se(A, F$, t.borderLeftColor), this.borderTopLeftRadius = se(A, Q$, t.borderTopLeftRadius), this.borderTopRightRadius = se(A, U$, t.borderTopRightRadius), this.borderBottomRightRadius = se(A, E$, t.borderBottomRightRadius), this.borderBottomLeftRadius = se(A, x$, t.borderBottomLeftRadius), this.borderTopStyle = se(A, I$, t.borderTopStyle), this.borderRightStyle = se(A, S$, t.borderRightStyle), this.borderBottomStyle = se(A, L$, t.borderBottomStyle), this.borderLeftStyle = se(A, H$, t.borderLeftStyle), this.borderTopWidth = se(A, T$, t.borderTopWidth), this.borderRightWidth = se(A, _$, t.borderRightWidth), this.borderBottomWidth = se(A, O$, t.borderBottomWidth), this.borderLeftWidth = se(A, N$, t.borderLeftWidth), this.boxShadow = se(A, Iz, t.boxShadow), this.color = se(A, D$, t.color), this.direction = se(A, R$, t.direction), this.display = se(A, M$, t.display), this.float = se(A, k$, t.cssFloat), this.fontFamily = se(A, mz, t.fontFamily), this.fontSize = se(A, vz, t.fontSize), this.fontStyle = se(A, bz, t.fontStyle), this.fontVariant = se(A, Cz, t.fontVariant), this.fontWeight = se(A, yz, t.fontWeight), this.letterSpacing = se(A, K$, t.letterSpacing), this.lineBreak = se(A, V$, t.lineBreak), this.lineHeight = se(A, G$, t.lineHeight), this.listStyleImage = se(A, W$, t.listStyleImage), this.listStylePosition = se(A, j$, t.listStylePosition), this.listStyleType = se(A, Pv, t.listStyleType), this.marginTop = se(A, q$, t.marginTop), this.marginRight = se(A, $$, t.marginRight), this.marginBottom = se(A, z$, t.marginBottom), this.marginLeft = se(A, X$, t.marginLeft), this.opacity = se(A, pz, t.opacity);
      var i = se(A, Y$, t.overflow);
      this.overflowX = i[0], this.overflowY = i[i.length > 1 ? 1 : 0], this.overflowWrap = se(A, J$, t.overflowWrap), this.paddingTop = se(A, Z$, t.paddingTop), this.paddingRight = se(A, Az, t.paddingRight), this.paddingBottom = se(A, ez, t.paddingBottom), this.paddingLeft = se(A, tz, t.paddingLeft), this.paintOrder = se(A, Sz, t.paintOrder), this.position = se(A, nz, t.position), this.textAlign = se(A, rz, t.textAlign), this.textDecorationColor = se(A, Bz, (r = t.textDecorationColor) !== null && r !== void 0 ? r : t.color), this.textDecorationLine = se(A, wz, (n = t.textDecorationLine) !== null && n !== void 0 ? n : t.textDecoration), this.textShadow = se(A, iz, t.textShadow), this.textTransform = se(A, sz, t.textTransform), this.transform = se(A, az, t.transform), this.transformOrigin = se(A, hz, t.transformOrigin), this.visibility = se(A, fz, t.visibility), this.webkitTextStrokeColor = se(A, Lz, t.webkitTextStrokeColor), this.webkitTextStrokeWidth = se(A, Hz, t.webkitTextStrokeWidth), this.wordBreak = se(A, dz, t.wordBreak), this.zIndex = se(A, gz, t.zIndex);
    }
    return e.prototype.isVisible = function() {
      return this.display > 0 && this.opacity > 0 && this.visibility === 0;
    }, e.prototype.isTransparent = function() {
      return No(this.backgroundColor);
    }, e.prototype.isTransformed = function() {
      return this.transform !== null;
    }, e.prototype.isPositioned = function() {
      return this.position !== 0;
    }, e.prototype.isPositionedWithZIndex = function() {
      return this.isPositioned() && !this.zIndex.auto;
    }, e.prototype.isFloating = function() {
      return this.float !== 0;
    }, e.prototype.isInlineLevel = function() {
      return kr(
        this.display,
        4
        /* INLINE */
      ) || kr(
        this.display,
        33554432
        /* INLINE_BLOCK */
      ) || kr(
        this.display,
        268435456
        /* INLINE_FLEX */
      ) || kr(
        this.display,
        536870912
        /* INLINE_GRID */
      ) || kr(
        this.display,
        67108864
        /* INLINE_LIST_ITEM */
      ) || kr(
        this.display,
        134217728
        /* INLINE_TABLE */
      );
    }, e;
  })()
), _z = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(A, t) {
      this.content = se(A, Fz, t.content), this.quotes = se(A, xz, t.quotes);
    }
    return e;
  })()
), WQ = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(A, t) {
      this.counterIncrement = se(A, Qz, t.counterIncrement), this.counterReset = se(A, Uz, t.counterReset);
    }
    return e;
  })()
), se = function(e, A, t) {
  var r = new AL(), n = t !== null && typeof t < "u" ? t.toString() : A.initialValue;
  r.write(n);
  var i = new eL(r.read());
  switch (A.type) {
    case 2:
      var s = i.parseComponentValue();
      return A.parse(e, mt(s) ? s.value : A.initialValue);
    case 0:
      return A.parse(e, i.parseComponentValue());
    case 1:
      return A.parse(e, i.parseComponentValues());
    case 4:
      return i.parseComponentValue();
    case 3:
      switch (A.format) {
        case "angle":
          return Bp.parse(e, i.parseComponentValue());
        case "color":
          return Oo.parse(e, i.parseComponentValue());
        case "image":
          return Wy.parse(e, i.parseComponentValue());
        case "length":
          var a = i.parseComponentValue();
          return ko(a) ? a : ln;
        case "length-percentage":
          var o = i.parseComponentValue();
          return Sr(o) ? o : ln;
        case "time":
          return mL.parse(e, i.parseComponentValue());
      }
      break;
  }
}, Oz = "data-html2canvas-debug", Nz = function(e) {
  var A = e.getAttribute(Oz);
  switch (A) {
    case "all":
      return 1;
    case "clone":
      return 2;
    case "parse":
      return 3;
    case "render":
      return 4;
    default:
      return 0;
  }
}, kv = function(e, A) {
  var t = Nz(e);
  return t === 1 || A === t;
}, Aa = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(A, t) {
      if (this.context = A, this.textNodes = [], this.elements = [], this.flags = 0, kv(
        t,
        3
        /* PARSE */
      ))
        debugger;
      this.styles = new Tz(A, window.getComputedStyle(t, null)), Gv(t) && (this.styles.animationDuration.some(function(r) {
        return r > 0;
      }) && (t.style.animationDuration = "0s"), this.styles.transform !== null && (t.style.transform = "none")), this.bounds = gp(this.context, t), kv(
        t,
        4
        /* RENDER */
      ) && (this.flags |= 16);
    }
    return e;
  })()
), Dz = "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", jQ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", oh = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Od = 0; Od < jQ.length; Od++)
  oh[jQ.charCodeAt(Od)] = Od;
var Rz = function(e) {
  var A = e.length * 0.75, t = e.length, r, n = 0, i, s, a, o;
  e[e.length - 1] === "=" && (A--, e[e.length - 2] === "=" && A--);
  var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), c = Array.isArray(l) ? l : new Uint8Array(l);
  for (r = 0; r < t; r += 4)
    i = oh[e.charCodeAt(r)], s = oh[e.charCodeAt(r + 1)], a = oh[e.charCodeAt(r + 2)], o = oh[e.charCodeAt(r + 3)], c[n++] = i << 2 | s >> 4, c[n++] = (s & 15) << 4 | a >> 2, c[n++] = (a & 3) << 6 | o & 63;
  return l;
}, Mz = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 2)
    t.push(e[r + 1] << 8 | e[r]);
  return t;
}, Pz = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 4)
    t.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
  return t;
}, Gl = 5, jy = 11, yw = 2, kz = jy - Gl, vL = 65536 >> Gl, Kz = 1 << Gl, Cw = Kz - 1, Vz = 1024 >> Gl, Gz = vL + Vz, Wz = Gz, jz = 32, qz = Wz + jz, $z = 65536 >> jy, zz = 1 << kz, Xz = zz - 1, qQ = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint16Array(Array.prototype.slice.call(e, A, t));
}, Yz = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint32Array(Array.prototype.slice.call(e, A, t));
}, Jz = function(e, A) {
  var t = Rz(e), r = Array.isArray(t) ? Pz(t) : new Uint32Array(t), n = Array.isArray(t) ? Mz(t) : new Uint16Array(t), i = 24, s = qQ(n, i / 2, r[4] / 2), a = r[5] === 2 ? qQ(n, (i + r[4]) / 2) : Yz(r, Math.ceil((i + r[4]) / 4));
  return new Zz(r[0], r[1], r[2], r[3], s, a);
}, Zz = (
  /** @class */
  (function() {
    function e(A, t, r, n, i, s) {
      this.initialValue = A, this.errorValue = t, this.highStart = r, this.highValueIndex = n, this.index = i, this.data = s;
    }
    return e.prototype.get = function(A) {
      var t;
      if (A >= 0) {
        if (A < 55296 || A > 56319 && A <= 65535)
          return t = this.index[A >> Gl], t = (t << yw) + (A & Cw), this.data[t];
        if (A <= 65535)
          return t = this.index[vL + (A - 55296 >> Gl)], t = (t << yw) + (A & Cw), this.data[t];
        if (A < this.highStart)
          return t = qz - $z + (A >> jy), t = this.index[t], t += A >> Gl & Xz, t = this.index[t], t = (t << yw) + (A & Cw), this.data[t];
        if (A <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, e;
  })()
), $Q = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", AX = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Nd = 0; Nd < $Q.length; Nd++)
  AX[$Q.charCodeAt(Nd)] = Nd;
var eX = 1, bw = 2, Fw = 3, zQ = 4, XQ = 5, tX = 7, YQ = 8, Qw = 9, Uw = 10, JQ = 11, ZQ = 12, A5 = 13, e5 = 14, Ew = 15, rX = function(e) {
  for (var A = [], t = 0, r = e.length; t < r; ) {
    var n = e.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < r) {
      var i = e.charCodeAt(t++);
      (i & 64512) === 56320 ? A.push(((n & 1023) << 10) + (i & 1023) + 65536) : (A.push(n), t--);
    } else
      A.push(n);
  }
  return A;
}, nX = function() {
  for (var e = [], A = 0; A < arguments.length; A++)
    e[A] = arguments[A];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, e);
  var t = e.length;
  if (!t)
    return "";
  for (var r = [], n = -1, i = ""; ++n < t; ) {
    var s = e[n];
    s <= 65535 ? r.push(s) : (s -= 65536, r.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === t || r.length > 16384) && (i += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return i;
}, iX = Jz(Dz), Pi = "×", xw = "÷", sX = function(e) {
  return iX.get(e);
}, aX = function(e, A, t) {
  var r = t - 2, n = A[r], i = A[t - 1], s = A[t];
  if (i === bw && s === Fw)
    return Pi;
  if (i === bw || i === Fw || i === zQ || s === bw || s === Fw || s === zQ)
    return xw;
  if (i === YQ && [YQ, Qw, JQ, ZQ].indexOf(s) !== -1 || (i === JQ || i === Qw) && (s === Qw || s === Uw) || (i === ZQ || i === Uw) && s === Uw || s === A5 || s === XQ || s === tX || i === eX)
    return Pi;
  if (i === A5 && s === e5) {
    for (; n === XQ; )
      n = A[--r];
    if (n === e5)
      return Pi;
  }
  if (i === Ew && s === Ew) {
    for (var a = 0; n === Ew; )
      a++, n = A[--r];
    if (a % 2 === 0)
      return Pi;
  }
  return xw;
}, oX = function(e) {
  var A = rX(e), t = A.length, r = 0, n = 0, i = A.map(sX);
  return {
    next: function() {
      if (r >= t)
        return { done: !0, value: null };
      for (var s = Pi; r < t && (s = aX(A, i, ++r)) === Pi; )
        ;
      if (s !== Pi || r === t) {
        var a = nX.apply(null, A.slice(n, r));
        return n = r, { value: a, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, lX = function(e) {
  for (var A = oX(e), t = [], r; !(r = A.next()).done; )
    r.value && t.push(r.value.slice());
  return t;
}, cX = function(e) {
  var A = 123;
  if (e.createRange) {
    var t = e.createRange();
    if (t.getBoundingClientRect) {
      var r = e.createElement("boundtest");
      r.style.height = A + "px", r.style.display = "block", e.body.appendChild(r), t.selectNode(r);
      var n = t.getBoundingClientRect(), i = Math.round(n.height);
      if (e.body.removeChild(r), i === A)
        return !0;
    }
  }
  return !1;
}, uX = function(e) {
  var A = e.createElement("boundtest");
  A.style.width = "50px", A.style.display = "block", A.style.fontSize = "12px", A.style.letterSpacing = "0px", A.style.wordSpacing = "0px", e.body.appendChild(A);
  var t = e.createRange();
  A.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
  var r = A.firstChild, n = pp(r.data).map(function(o) {
    return mr(o);
  }), i = 0, s = {}, a = n.every(function(o, l) {
    t.setStart(r, i), t.setEnd(r, i + o.length);
    var c = t.getBoundingClientRect();
    i += o.length;
    var u = c.x > s.x || c.y > s.y;
    return s = c, l === 0 ? !0 : u;
  });
  return e.body.removeChild(A), a;
}, hX = function() {
  return typeof new Image().crossOrigin < "u";
}, fX = function() {
  return typeof new XMLHttpRequest().responseType == "string";
}, dX = function(e) {
  var A = new Image(), t = e.createElement("canvas"), r = t.getContext("2d");
  if (!r)
    return !1;
  A.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
  try {
    r.drawImage(A, 0, 0), t.toDataURL();
  } catch {
    return !1;
  }
  return !0;
}, t5 = function(e) {
  return e[0] === 0 && e[1] === 255 && e[2] === 0 && e[3] === 255;
}, gX = function(e) {
  var A = e.createElement("canvas"), t = 100;
  A.width = t, A.height = t;
  var r = A.getContext("2d");
  if (!r)
    return Promise.reject(!1);
  r.fillStyle = "rgb(0, 255, 0)", r.fillRect(0, 0, t, t);
  var n = new Image(), i = A.toDataURL();
  n.src = i;
  var s = Kv(t, t, 0, 0, n);
  return r.fillStyle = "red", r.fillRect(0, 0, t, t), r5(s).then(function(a) {
    r.drawImage(a, 0, 0);
    var o = r.getImageData(0, 0, t, t).data;
    r.fillStyle = "red", r.fillRect(0, 0, t, t);
    var l = e.createElement("div");
    return l.style.backgroundImage = "url(" + i + ")", l.style.height = t + "px", t5(o) ? r5(Kv(t, t, 0, 0, l)) : Promise.reject(!1);
  }).then(function(a) {
    return r.drawImage(a, 0, 0), t5(r.getImageData(0, 0, t, t).data);
  }).catch(function() {
    return !1;
  });
}, Kv = function(e, A, t, r, n) {
  var i = "http://www.w3.org/2000/svg", s = document.createElementNS(i, "svg"), a = document.createElementNS(i, "foreignObject");
  return s.setAttributeNS(null, "width", e.toString()), s.setAttributeNS(null, "height", A.toString()), a.setAttributeNS(null, "width", "100%"), a.setAttributeNS(null, "height", "100%"), a.setAttributeNS(null, "x", t.toString()), a.setAttributeNS(null, "y", r.toString()), a.setAttributeNS(null, "externalResourcesRequired", "true"), s.appendChild(a), a.appendChild(n), s;
}, r5 = function(e) {
  return new Promise(function(A, t) {
    var r = new Image();
    r.onload = function() {
      return A(r);
    }, r.onerror = t, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(e));
  });
}, an = {
  get SUPPORT_RANGE_BOUNDS() {
    var e = cX(document);
    return Object.defineProperty(an, "SUPPORT_RANGE_BOUNDS", { value: e }), e;
  },
  get SUPPORT_WORD_BREAKING() {
    var e = an.SUPPORT_RANGE_BOUNDS && uX(document);
    return Object.defineProperty(an, "SUPPORT_WORD_BREAKING", { value: e }), e;
  },
  get SUPPORT_SVG_DRAWING() {
    var e = dX(document);
    return Object.defineProperty(an, "SUPPORT_SVG_DRAWING", { value: e }), e;
  },
  get SUPPORT_FOREIGNOBJECT_DRAWING() {
    var e = typeof Array.from == "function" && typeof window.fetch == "function" ? gX(document) : Promise.resolve(!1);
    return Object.defineProperty(an, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: e }), e;
  },
  get SUPPORT_CORS_IMAGES() {
    var e = hX();
    return Object.defineProperty(an, "SUPPORT_CORS_IMAGES", { value: e }), e;
  },
  get SUPPORT_RESPONSE_TYPE() {
    var e = fX();
    return Object.defineProperty(an, "SUPPORT_RESPONSE_TYPE", { value: e }), e;
  },
  get SUPPORT_CORS_XHR() {
    var e = "withCredentials" in new XMLHttpRequest();
    return Object.defineProperty(an, "SUPPORT_CORS_XHR", { value: e }), e;
  },
  get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
    var e = !!(typeof Intl < "u" && Intl.Segmenter);
    return Object.defineProperty(an, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: e }), e;
  }
}, Qh = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(A, t) {
      this.text = A, this.bounds = t;
    }
    return e;
  })()
), pX = function(e, A, t, r) {
  var n = mX(A, t), i = [], s = 0;
  return n.forEach(function(a) {
    if (t.textDecorationLine.length || a.trim().length > 0)
      if (an.SUPPORT_RANGE_BOUNDS) {
        var o = n5(r, s, a.length).getClientRects();
        if (o.length > 1) {
          var l = qy(a), c = 0;
          l.forEach(function(d) {
            i.push(new Qh(d, Oa.fromDOMRectList(e, n5(r, c + s, d.length).getClientRects()))), c += d.length;
          });
        } else
          i.push(new Qh(a, Oa.fromDOMRectList(e, o)));
      } else {
        var u = r.splitText(a.length);
        i.push(new Qh(a, BX(e, r))), r = u;
      }
    else an.SUPPORT_RANGE_BOUNDS || (r = r.splitText(a.length));
    s += a.length;
  }), i;
}, BX = function(e, A) {
  var t = A.ownerDocument;
  if (t) {
    var r = t.createElement("html2canvaswrapper");
    r.appendChild(A.cloneNode(!0));
    var n = A.parentNode;
    if (n) {
      n.replaceChild(r, A);
      var i = gp(e, r);
      return r.firstChild && n.replaceChild(r.firstChild, r), i;
    }
  }
  return Oa.EMPTY;
}, n5 = function(e, A, t) {
  var r = e.ownerDocument;
  if (!r)
    throw new Error("Node has no owner document");
  var n = r.createRange();
  return n.setStart(e, A), n.setEnd(e, A + t), n;
}, qy = function(e) {
  if (an.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var A = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    return Array.from(A.segment(e)).map(function(t) {
      return t.segment;
    });
  }
  return lX(e);
}, wX = function(e, A) {
  if (an.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var t = new Intl.Segmenter(void 0, {
      granularity: "word"
    });
    return Array.from(t.segment(e)).map(function(r) {
      return r.segment;
    });
  }
  return yX(e, A);
}, mX = function(e, A) {
  return A.letterSpacing !== 0 ? qy(e) : wX(e, A);
}, vX = [32, 160, 4961, 65792, 65793, 4153, 4241], yX = function(e, A) {
  for (var t = $j(e, {
    lineBreak: A.lineBreak,
    wordBreak: A.overflowWrap === "break-word" ? "break-word" : A.wordBreak
  }), r = [], n, i = function() {
    if (n.value) {
      var s = n.value.slice(), a = pp(s), o = "";
      a.forEach(function(l) {
        vX.indexOf(l) === -1 ? o += mr(l) : (o.length && r.push(o), r.push(mr(l)), o = "");
      }), o.length && r.push(o);
    }
  }; !(n = t.next()).done; )
    i();
  return r;
}, CX = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(A, t, r) {
      this.text = bX(t.data, r.textTransform), this.textBounds = pX(A, this.text, r, t);
    }
    return e;
  })()
), bX = function(e, A) {
  switch (A) {
    case 1:
      return e.toLowerCase();
    case 3:
      return e.replace(FX, QX);
    case 2:
      return e.toUpperCase();
    default:
      return e;
  }
}, FX = /(^|\s|:|-|\(|\))([a-z])/g, QX = function(e, A, t) {
  return e.length > 0 ? A + t.toUpperCase() : e;
}, yL = (
  /** @class */
  (function(e) {
    Us(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.src = r.currentSrc || r.src, n.intrinsicWidth = r.naturalWidth, n.intrinsicHeight = r.naturalHeight, n.context.cache.addImage(n.src), n;
    }
    return A;
  })(Aa)
), CL = (
  /** @class */
  (function(e) {
    Us(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.canvas = r, n.intrinsicWidth = r.width, n.intrinsicHeight = r.height, n;
    }
    return A;
  })(Aa)
), bL = (
  /** @class */
  (function(e) {
    Us(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this, i = new XMLSerializer(), s = gp(t, r);
      return r.setAttribute("width", s.width + "px"), r.setAttribute("height", s.height + "px"), n.svg = "data:image/svg+xml," + encodeURIComponent(i.serializeToString(r)), n.intrinsicWidth = r.width.baseVal.value, n.intrinsicHeight = r.height.baseVal.value, n.context.cache.addImage(n.svg), n;
    }
    return A;
  })(Aa)
), FL = (
  /** @class */
  (function(e) {
    Us(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.value = r.value, n;
    }
    return A;
  })(Aa)
), Vv = (
  /** @class */
  (function(e) {
    Us(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.start = r.start, n.reversed = typeof r.reversed == "boolean" && r.reversed === !0, n;
    }
    return A;
  })(Aa)
), UX = [
  {
    type: 15,
    flags: 0,
    unit: "px",
    number: 3
  }
], EX = [
  {
    type: 16,
    flags: 0,
    number: 50
  }
], xX = function(e) {
  return e.width > e.height ? new Oa(e.left + (e.width - e.height) / 2, e.top, e.height, e.height) : e.width < e.height ? new Oa(e.left, e.top + (e.height - e.width) / 2, e.width, e.width) : e;
}, IX = function(e) {
  var A = e.type === SX ? new Array(e.value.length + 1).join("•") : e.value;
  return A.length === 0 ? e.placeholder || "" : A;
}, Hg = "checkbox", Tg = "radio", SX = "password", i5 = 707406591, $y = (
  /** @class */
  (function(e) {
    Us(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      switch (n.type = r.type.toLowerCase(), n.checked = r.checked, n.value = IX(r), (n.type === Hg || n.type === Tg) && (n.styles.backgroundColor = 3739148031, n.styles.borderTopColor = n.styles.borderRightColor = n.styles.borderBottomColor = n.styles.borderLeftColor = 2779096575, n.styles.borderTopWidth = n.styles.borderRightWidth = n.styles.borderBottomWidth = n.styles.borderLeftWidth = 1, n.styles.borderTopStyle = n.styles.borderRightStyle = n.styles.borderBottomStyle = n.styles.borderLeftStyle = 1, n.styles.backgroundClip = [
        0
        /* BORDER_BOX */
      ], n.styles.backgroundOrigin = [
        0
        /* BORDER_BOX */
      ], n.bounds = xX(n.bounds)), n.type) {
        case Hg:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = UX;
          break;
        case Tg:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = EX;
          break;
      }
      return n;
    }
    return A;
  })(Aa)
), QL = (
  /** @class */
  (function(e) {
    Us(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this, i = r.options[r.selectedIndex || 0];
      return n.value = i && i.text || "", n;
    }
    return A;
  })(Aa)
), UL = (
  /** @class */
  (function(e) {
    Us(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.value = r.value, n;
    }
    return A;
  })(Aa)
), EL = (
  /** @class */
  (function(e) {
    Us(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      n.src = r.src, n.width = parseInt(r.width, 10) || 0, n.height = parseInt(r.height, 10) || 0, n.backgroundColor = n.styles.backgroundColor;
      try {
        if (r.contentWindow && r.contentWindow.document && r.contentWindow.document.documentElement) {
          n.tree = IL(t, r.contentWindow.document.documentElement);
          var i = r.contentWindow.document.documentElement ? bh(t, getComputedStyle(r.contentWindow.document.documentElement).backgroundColor) : Ha.TRANSPARENT, s = r.contentWindow.document.body ? bh(t, getComputedStyle(r.contentWindow.document.body).backgroundColor) : Ha.TRANSPARENT;
          n.backgroundColor = No(i) ? No(s) ? n.styles.backgroundColor : s : i;
        }
      } catch {
      }
      return n;
    }
    return A;
  })(Aa)
), LX = ["OL", "UL", "MENU"], eg = function(e, A, t, r) {
  for (var n = A.firstChild, i = void 0; n; n = i)
    if (i = n.nextSibling, SL(n) && n.data.trim().length > 0)
      t.textNodes.push(new CX(e, n, t.styles));
    else if (Kc(n))
      if (_L(n) && n.assignedNodes)
        n.assignedNodes().forEach(function(a) {
          return eg(e, a, t, r);
        });
      else {
        var s = xL(e, n);
        s.styles.isVisible() && (HX(n, s, r) ? s.flags |= 4 : TX(s.styles) && (s.flags |= 2), LX.indexOf(n.tagName) !== -1 && (s.flags |= 8), t.elements.push(s), n.slot, n.shadowRoot ? eg(e, n.shadowRoot, s, r) : !_g(n) && !LL(n) && !Og(n) && eg(e, n, s, r));
      }
}, xL = function(e, A) {
  return Wv(A) ? new yL(e, A) : HL(A) ? new CL(e, A) : LL(A) ? new bL(e, A) : _X(A) ? new FL(e, A) : OX(A) ? new Vv(e, A) : NX(A) ? new $y(e, A) : Og(A) ? new QL(e, A) : _g(A) ? new UL(e, A) : TL(A) ? new EL(e, A) : new Aa(e, A);
}, IL = function(e, A) {
  var t = xL(e, A);
  return t.flags |= 4, eg(e, A, t, t), t;
}, HX = function(e, A, t) {
  return A.styles.isPositionedWithZIndex() || A.styles.opacity < 1 || A.styles.isTransformed() || zy(e) && t.styles.isTransparent();
}, TX = function(e) {
  return e.isPositioned() || e.isFloating();
}, SL = function(e) {
  return e.nodeType === Node.TEXT_NODE;
}, Kc = function(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}, Gv = function(e) {
  return Kc(e) && typeof e.style < "u" && !tg(e);
}, tg = function(e) {
  return typeof e.className == "object";
}, _X = function(e) {
  return e.tagName === "LI";
}, OX = function(e) {
  return e.tagName === "OL";
}, NX = function(e) {
  return e.tagName === "INPUT";
}, DX = function(e) {
  return e.tagName === "HTML";
}, LL = function(e) {
  return e.tagName === "svg";
}, zy = function(e) {
  return e.tagName === "BODY";
}, HL = function(e) {
  return e.tagName === "CANVAS";
}, s5 = function(e) {
  return e.tagName === "VIDEO";
}, Wv = function(e) {
  return e.tagName === "IMG";
}, TL = function(e) {
  return e.tagName === "IFRAME";
}, a5 = function(e) {
  return e.tagName === "STYLE";
}, RX = function(e) {
  return e.tagName === "SCRIPT";
}, _g = function(e) {
  return e.tagName === "TEXTAREA";
}, Og = function(e) {
  return e.tagName === "SELECT";
}, _L = function(e) {
  return e.tagName === "SLOT";
}, o5 = function(e) {
  return e.tagName.indexOf("-") > 0;
}, MX = (
  /** @class */
  (function() {
    function e() {
      this.counters = {};
    }
    return e.prototype.getCounterValue = function(A) {
      var t = this.counters[A];
      return t && t.length ? t[t.length - 1] : 1;
    }, e.prototype.getCounterValues = function(A) {
      var t = this.counters[A];
      return t || [];
    }, e.prototype.pop = function(A) {
      var t = this;
      A.forEach(function(r) {
        return t.counters[r].pop();
      });
    }, e.prototype.parse = function(A) {
      var t = this, r = A.counterIncrement, n = A.counterReset, i = !0;
      r !== null && r.forEach(function(a) {
        var o = t.counters[a.counter];
        o && a.increment !== 0 && (i = !1, o.length || o.push(1), o[Math.max(0, o.length - 1)] += a.increment);
      });
      var s = [];
      return i && n.forEach(function(a) {
        var o = t.counters[a.counter];
        s.push(a.counter), o || (o = t.counters[a.counter] = []), o.push(a.reset);
      }), s;
    }, e;
  })()
), l5 = {
  integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
  values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
}, c5 = {
  integers: [
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "Ք",
    "Փ",
    "Ւ",
    "Ց",
    "Ր",
    "Տ",
    "Վ",
    "Ս",
    "Ռ",
    "Ջ",
    "Պ",
    "Չ",
    "Ո",
    "Շ",
    "Ն",
    "Յ",
    "Մ",
    "Ճ",
    "Ղ",
    "Ձ",
    "Հ",
    "Կ",
    "Ծ",
    "Խ",
    "Լ",
    "Ի",
    "Ժ",
    "Թ",
    "Ը",
    "Է",
    "Զ",
    "Ե",
    "Դ",
    "Գ",
    "Բ",
    "Ա"
  ]
}, PX = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    19,
    18,
    17,
    16,
    15,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "י׳",
    "ט׳",
    "ח׳",
    "ז׳",
    "ו׳",
    "ה׳",
    "ד׳",
    "ג׳",
    "ב׳",
    "א׳",
    "ת",
    "ש",
    "ר",
    "ק",
    "צ",
    "פ",
    "ע",
    "ס",
    "נ",
    "מ",
    "ל",
    "כ",
    "יט",
    "יח",
    "יז",
    "טז",
    "טו",
    "י",
    "ט",
    "ח",
    "ז",
    "ו",
    "ה",
    "ד",
    "ג",
    "ב",
    "א"
  ]
}, kX = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "ჵ",
    "ჰ",
    "ჯ",
    "ჴ",
    "ხ",
    "ჭ",
    "წ",
    "ძ",
    "ც",
    "ჩ",
    "შ",
    "ყ",
    "ღ",
    "ქ",
    "ფ",
    "ჳ",
    "ტ",
    "ს",
    "რ",
    "ჟ",
    "პ",
    "ო",
    "ჲ",
    "ნ",
    "მ",
    "ლ",
    "კ",
    "ი",
    "თ",
    "ჱ",
    "ზ",
    "ვ",
    "ე",
    "დ",
    "გ",
    "ბ",
    "ა"
  ]
}, Lc = function(e, A, t, r, n, i) {
  return e < A || e > t ? jh(e, n, i.length > 0) : r.integers.reduce(function(s, a, o) {
    for (; e >= a; )
      e -= a, s += r.values[o];
    return s;
  }, "") + i;
}, OL = function(e, A, t, r) {
  var n = "";
  do
    t || e--, n = r(e) + n, e /= A;
  while (e * A >= A);
  return n;
}, Br = function(e, A, t, r, n) {
  var i = t - A + 1;
  return (e < 0 ? "-" : "") + (OL(Math.abs(e), i, r, function(s) {
    return mr(Math.floor(s % i) + A);
  }) + n);
}, fl = function(e, A, t) {
  t === void 0 && (t = ". ");
  var r = A.length;
  return OL(Math.abs(e), r, !1, function(n) {
    return A[Math.floor(n % r)];
  }) + t;
}, Rc = 1, Bo = 2, wo = 4, lh = 8, ya = function(e, A, t, r, n, i) {
  if (e < -9999 || e > 9999)
    return jh(e, 4, n.length > 0);
  var s = Math.abs(e), a = n;
  if (s === 0)
    return A[0] + a;
  for (var o = 0; s > 0 && o <= 4; o++) {
    var l = s % 10;
    l === 0 && kr(i, Rc) && a !== "" ? a = A[l] + a : l > 1 || l === 1 && o === 0 || l === 1 && o === 1 && kr(i, Bo) || l === 1 && o === 1 && kr(i, wo) && e > 100 || l === 1 && o > 1 && kr(i, lh) ? a = A[l] + (o > 0 ? t[o - 1] : "") + a : l === 1 && o > 0 && (a = t[o - 1] + a), s = Math.floor(s / 10);
  }
  return (e < 0 ? r : "") + a;
}, u5 = "十百千萬", h5 = "拾佰仟萬", f5 = "マイナス", Iw = "마이너스", jh = function(e, A, t) {
  var r = t ? ". " : "", n = t ? "、" : "", i = t ? ", " : "", s = t ? " " : "";
  switch (A) {
    case 0:
      return "•" + s;
    case 1:
      return "◦" + s;
    case 2:
      return "◾" + s;
    case 5:
      var a = Br(e, 48, 57, !0, r);
      return a.length < 4 ? "0" + a : a;
    case 4:
      return fl(e, "〇一二三四五六七八九", n);
    case 6:
      return Lc(e, 1, 3999, l5, 3, r).toLowerCase();
    case 7:
      return Lc(e, 1, 3999, l5, 3, r);
    case 8:
      return Br(e, 945, 969, !1, r);
    case 9:
      return Br(e, 97, 122, !1, r);
    case 10:
      return Br(e, 65, 90, !1, r);
    case 11:
      return Br(e, 1632, 1641, !0, r);
    case 12:
    case 49:
      return Lc(e, 1, 9999, c5, 3, r);
    case 35:
      return Lc(e, 1, 9999, c5, 3, r).toLowerCase();
    case 13:
      return Br(e, 2534, 2543, !0, r);
    case 14:
    case 30:
      return Br(e, 6112, 6121, !0, r);
    case 15:
      return fl(e, "子丑寅卯辰巳午未申酉戌亥", n);
    case 16:
      return fl(e, "甲乙丙丁戊己庚辛壬癸", n);
    case 17:
    case 48:
      return ya(e, "零一二三四五六七八九", u5, "負", n, Bo | wo | lh);
    case 47:
      return ya(e, "零壹貳參肆伍陸柒捌玖", h5, "負", n, Rc | Bo | wo | lh);
    case 42:
      return ya(e, "零一二三四五六七八九", u5, "负", n, Bo | wo | lh);
    case 41:
      return ya(e, "零壹贰叁肆伍陆柒捌玖", h5, "负", n, Rc | Bo | wo | lh);
    case 26:
      return ya(e, "〇一二三四五六七八九", "十百千万", f5, n, 0);
    case 25:
      return ya(e, "零壱弐参四伍六七八九", "拾百千万", f5, n, Rc | Bo | wo);
    case 31:
      return ya(e, "영일이삼사오육칠팔구", "십백천만", Iw, i, Rc | Bo | wo);
    case 33:
      return ya(e, "零一二三四五六七八九", "十百千萬", Iw, i, 0);
    case 32:
      return ya(e, "零壹貳參四五六七八九", "拾百千", Iw, i, Rc | Bo | wo);
    case 18:
      return Br(e, 2406, 2415, !0, r);
    case 20:
      return Lc(e, 1, 19999, kX, 3, r);
    case 21:
      return Br(e, 2790, 2799, !0, r);
    case 22:
      return Br(e, 2662, 2671, !0, r);
    case 22:
      return Lc(e, 1, 10999, PX, 3, r);
    case 23:
      return fl(e, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
    case 24:
      return fl(e, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
    case 27:
      return Br(e, 3302, 3311, !0, r);
    case 28:
      return fl(e, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", n);
    case 29:
      return fl(e, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", n);
    case 34:
      return Br(e, 3792, 3801, !0, r);
    case 37:
      return Br(e, 6160, 6169, !0, r);
    case 38:
      return Br(e, 4160, 4169, !0, r);
    case 39:
      return Br(e, 2918, 2927, !0, r);
    case 40:
      return Br(e, 1776, 1785, !0, r);
    case 43:
      return Br(e, 3046, 3055, !0, r);
    case 44:
      return Br(e, 3174, 3183, !0, r);
    case 45:
      return Br(e, 3664, 3673, !0, r);
    case 46:
      return Br(e, 3872, 3881, !0, r);
    default:
      return Br(e, 48, 57, !0, r);
  }
}, NL = "data-html2canvas-ignore", d5 = (
  /** @class */
  (function() {
    function e(A, t, r) {
      if (this.context = A, this.options = r, this.scrolledElements = [], this.referenceElement = t, this.counters = new MX(), this.quoteDepth = 0, !t.ownerDocument)
        throw new Error("Cloned element does not have an owner document");
      this.documentElement = this.cloneNode(t.ownerDocument.documentElement, !1);
    }
    return e.prototype.toIFrame = function(A, t) {
      var r = this, n = KX(A, t);
      if (!n.contentWindow)
        return Promise.reject("Unable to find iframe window");
      var i = A.defaultView.pageXOffset, s = A.defaultView.pageYOffset, a = n.contentWindow, o = a.document, l = WX(n).then(function() {
        return zn(r, void 0, void 0, function() {
          var c, u;
          return Fn(this, function(d) {
            switch (d.label) {
              case 0:
                return this.scrolledElements.forEach(zX), a && (a.scrollTo(t.left, t.top), /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (a.scrollY !== t.top || a.scrollX !== t.left) && (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(a.scrollX - t.left, a.scrollY - t.top, 0, 0))), c = this.options.onclone, u = this.clonedReferenceElement, typeof u > "u" ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : o.fonts && o.fonts.ready ? [4, o.fonts.ready] : [3, 2];
              case 1:
                d.sent(), d.label = 2;
              case 2:
                return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, GX(o)] : [3, 4];
              case 3:
                d.sent(), d.label = 4;
              case 4:
                return typeof c == "function" ? [2, Promise.resolve().then(function() {
                  return c(o, u);
                }).then(function() {
                  return n;
                })] : [2, n];
            }
          });
        });
      });
      return o.open(), o.write(qX(document.doctype) + "<html></html>"), $X(this.referenceElement.ownerDocument, i, s), o.replaceChild(o.adoptNode(this.documentElement), o.documentElement), o.close(), l;
    }, e.prototype.createElementClone = function(A) {
      if (kv(
        A,
        2
        /* CLONE */
      ))
        debugger;
      if (HL(A))
        return this.createCanvasClone(A);
      if (s5(A))
        return this.createVideoClone(A);
      if (a5(A))
        return this.createStyleClone(A);
      var t = A.cloneNode(!1);
      return Wv(t) && (Wv(A) && A.currentSrc && A.currentSrc !== A.src && (t.src = A.currentSrc, t.srcset = ""), t.loading === "lazy" && (t.loading = "eager")), o5(t) ? this.createCustomElementClone(t) : t;
    }, e.prototype.createCustomElementClone = function(A) {
      var t = document.createElement("html2canvascustomelement");
      return Sw(A.style, t), t;
    }, e.prototype.createStyleClone = function(A) {
      try {
        var t = A.sheet;
        if (t && t.cssRules) {
          var r = [].slice.call(t.cssRules, 0).reduce(function(i, s) {
            return s && typeof s.cssText == "string" ? i + s.cssText : i;
          }, ""), n = A.cloneNode(!1);
          return n.textContent = r, n;
        }
      } catch (i) {
        if (this.context.logger.error("Unable to access cssRules property", i), i.name !== "SecurityError")
          throw i;
      }
      return A.cloneNode(!1);
    }, e.prototype.createCanvasClone = function(A) {
      var t;
      if (this.options.inlineImages && A.ownerDocument) {
        var r = A.ownerDocument.createElement("img");
        try {
          return r.src = A.toDataURL(), r;
        } catch {
          this.context.logger.info("Unable to inline canvas contents, canvas is tainted", A);
        }
      }
      var n = A.cloneNode(!1);
      try {
        n.width = A.width, n.height = A.height;
        var i = A.getContext("2d"), s = n.getContext("2d");
        if (s)
          if (!this.options.allowTaint && i)
            s.putImageData(i.getImageData(0, 0, A.width, A.height), 0, 0);
          else {
            var a = (t = A.getContext("webgl2")) !== null && t !== void 0 ? t : A.getContext("webgl");
            if (a) {
              var o = a.getContextAttributes();
              o?.preserveDrawingBuffer === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", A);
            }
            s.drawImage(A, 0, 0);
          }
        return n;
      } catch {
        this.context.logger.info("Unable to clone canvas as it is tainted", A);
      }
      return n;
    }, e.prototype.createVideoClone = function(A) {
      var t = A.ownerDocument.createElement("canvas");
      t.width = A.offsetWidth, t.height = A.offsetHeight;
      var r = t.getContext("2d");
      try {
        return r && (r.drawImage(A, 0, 0, t.width, t.height), this.options.allowTaint || r.getImageData(0, 0, t.width, t.height)), t;
      } catch {
        this.context.logger.info("Unable to clone video as it is tainted", A);
      }
      var n = A.ownerDocument.createElement("canvas");
      return n.width = A.offsetWidth, n.height = A.offsetHeight, n;
    }, e.prototype.appendChildNode = function(A, t, r) {
      (!Kc(t) || !RX(t) && !t.hasAttribute(NL) && (typeof this.options.ignoreElements != "function" || !this.options.ignoreElements(t))) && (!this.options.copyStyles || !Kc(t) || !a5(t)) && A.appendChild(this.cloneNode(t, r));
    }, e.prototype.cloneChildNodes = function(A, t, r) {
      for (var n = this, i = A.shadowRoot ? A.shadowRoot.firstChild : A.firstChild; i; i = i.nextSibling)
        if (Kc(i) && _L(i) && typeof i.assignedNodes == "function") {
          var s = i.assignedNodes();
          s.length && s.forEach(function(a) {
            return n.appendChildNode(t, a, r);
          });
        } else
          this.appendChildNode(t, i, r);
    }, e.prototype.cloneNode = function(A, t) {
      if (SL(A))
        return document.createTextNode(A.data);
      if (!A.ownerDocument)
        return A.cloneNode(!1);
      var r = A.ownerDocument.defaultView;
      if (r && Kc(A) && (Gv(A) || tg(A))) {
        var n = this.createElementClone(A);
        n.style.transitionProperty = "none";
        var i = r.getComputedStyle(A), s = r.getComputedStyle(A, ":before"), a = r.getComputedStyle(A, ":after");
        this.referenceElement === A && Gv(n) && (this.clonedReferenceElement = n), zy(n) && JX(n);
        var o = this.counters.parse(new WQ(this.context, i)), l = this.resolvePseudoContent(A, n, s, Uh.BEFORE);
        o5(A) && (t = !0), s5(A) || this.cloneChildNodes(A, n, t), l && n.insertBefore(l, n.firstChild);
        var c = this.resolvePseudoContent(A, n, a, Uh.AFTER);
        return c && n.appendChild(c), this.counters.pop(o), (i && (this.options.copyStyles || tg(A)) && !TL(A) || t) && Sw(i, n), (A.scrollTop !== 0 || A.scrollLeft !== 0) && this.scrolledElements.push([n, A.scrollLeft, A.scrollTop]), (_g(A) || Og(A)) && (_g(n) || Og(n)) && (n.value = A.value), n;
      }
      return A.cloneNode(!1);
    }, e.prototype.resolvePseudoContent = function(A, t, r, n) {
      var i = this;
      if (r) {
        var s = r.content, a = t.ownerDocument;
        if (!(!a || !s || s === "none" || s === "-moz-alt-content" || r.display === "none")) {
          this.counters.parse(new WQ(this.context, r));
          var o = new _z(this.context, r), l = a.createElement("html2canvaspseudoelement");
          Sw(r, l), o.content.forEach(function(u) {
            if (u.type === 0)
              l.appendChild(a.createTextNode(u.value));
            else if (u.type === 22) {
              var d = a.createElement("img");
              d.src = u.value, d.style.opacity = "1", l.appendChild(d);
            } else if (u.type === 18) {
              if (u.name === "attr") {
                var h = u.values.filter(mt);
                h.length && l.appendChild(a.createTextNode(A.getAttribute(h[0].value) || ""));
              } else if (u.name === "counter") {
                var p = u.values.filter(Zc), B = p[0], y = p[1];
                if (B && mt(B)) {
                  var m = i.counters.getCounterValue(B.value), C = y && mt(y) ? Pv.parse(i.context, y.value) : 3;
                  l.appendChild(a.createTextNode(jh(m, C, !1)));
                }
              } else if (u.name === "counters") {
                var Q = u.values.filter(Zc), B = Q[0], F = Q[1], y = Q[2];
                if (B && mt(B)) {
                  var T = i.counters.getCounterValues(B.value), V = y && mt(y) ? Pv.parse(i.context, y.value) : 3, M = F && F.type === 0 ? F.value : "", D = T.map(function(U) {
                    return jh(U, V, !1);
                  }).join(M);
                  l.appendChild(a.createTextNode(D));
                }
              }
            } else if (u.type === 20)
              switch (u.value) {
                case "open-quote":
                  l.appendChild(a.createTextNode(GQ(o.quotes, i.quoteDepth++, !0)));
                  break;
                case "close-quote":
                  l.appendChild(a.createTextNode(GQ(o.quotes, --i.quoteDepth, !1)));
                  break;
                default:
                  l.appendChild(a.createTextNode(u.value));
              }
          }), l.className = jv + " " + qv;
          var c = n === Uh.BEFORE ? " " + jv : " " + qv;
          return tg(t) ? t.className.baseValue += c : t.className += c, l;
        }
      }
    }, e.destroy = function(A) {
      return A.parentNode ? (A.parentNode.removeChild(A), !0) : !1;
    }, e;
  })()
), Uh;
(function(e) {
  e[e.BEFORE = 0] = "BEFORE", e[e.AFTER = 1] = "AFTER";
})(Uh || (Uh = {}));
var KX = function(e, A) {
  var t = e.createElement("iframe");
  return t.className = "html2canvas-container", t.style.visibility = "hidden", t.style.position = "fixed", t.style.left = "-10000px", t.style.top = "0px", t.style.border = "0", t.width = A.width.toString(), t.height = A.height.toString(), t.scrolling = "no", t.setAttribute(NL, "true"), e.body.appendChild(t), t;
}, VX = function(e) {
  return new Promise(function(A) {
    if (e.complete) {
      A();
      return;
    }
    if (!e.src) {
      A();
      return;
    }
    e.onload = A, e.onerror = A;
  });
}, GX = function(e) {
  return Promise.all([].slice.call(e.images, 0).map(VX));
}, WX = function(e) {
  return new Promise(function(A, t) {
    var r = e.contentWindow;
    if (!r)
      return t("No window assigned for iframe");
    var n = r.document;
    r.onload = e.onload = function() {
      r.onload = e.onload = null;
      var i = setInterval(function() {
        n.body.childNodes.length > 0 && n.readyState === "complete" && (clearInterval(i), A(e));
      }, 50);
    };
  });
}, jX = [
  "all",
  "d",
  "content"
  // Safari shows pseudoelements if content is set
], Sw = function(e, A) {
  for (var t = e.length - 1; t >= 0; t--) {
    var r = e.item(t);
    jX.indexOf(r) === -1 && A.style.setProperty(r, e.getPropertyValue(r));
  }
  return A;
}, qX = function(e) {
  var A = "";
  return e && (A += "<!DOCTYPE ", e.name && (A += e.name), e.internalSubset && (A += e.internalSubset), e.publicId && (A += '"' + e.publicId + '"'), e.systemId && (A += '"' + e.systemId + '"'), A += ">"), A;
}, $X = function(e, A, t) {
  e && e.defaultView && (A !== e.defaultView.pageXOffset || t !== e.defaultView.pageYOffset) && e.defaultView.scrollTo(A, t);
}, zX = function(e) {
  var A = e[0], t = e[1], r = e[2];
  A.scrollLeft = t, A.scrollTop = r;
}, XX = ":before", YX = ":after", jv = "___html2canvas___pseudoelement_before", qv = "___html2canvas___pseudoelement_after", g5 = `{
    content: "" !important;
    display: none !important;
}`, JX = function(e) {
  ZX(e, "." + jv + XX + g5 + `
         .` + qv + YX + g5);
}, ZX = function(e, A) {
  var t = e.ownerDocument;
  if (t) {
    var r = t.createElement("style");
    r.textContent = A, e.appendChild(r);
  }
}, DL = (
  /** @class */
  (function() {
    function e() {
    }
    return e.getOrigin = function(A) {
      var t = e._link;
      return t ? (t.href = A, t.href = t.href, t.protocol + t.hostname + t.port) : "about:blank";
    }, e.isSameOrigin = function(A) {
      return e.getOrigin(A) === e._origin;
    }, e.setContext = function(A) {
      e._link = A.document.createElement("a"), e._origin = e.getOrigin(A.location.href);
    }, e._origin = "about:blank", e;
  })()
), AY = (
  /** @class */
  (function() {
    function e(A, t) {
      this.context = A, this._options = t, this._cache = {};
    }
    return e.prototype.addImage = function(A) {
      var t = Promise.resolve();
      return this.has(A) || (Hw(A) || nY(A)) && (this._cache[A] = this.loadImage(A)).catch(function() {
      }), t;
    }, e.prototype.match = function(A) {
      return this._cache[A];
    }, e.prototype.loadImage = function(A) {
      return zn(this, void 0, void 0, function() {
        var t, r, n, i, s = this;
        return Fn(this, function(a) {
          switch (a.label) {
            case 0:
              return t = DL.isSameOrigin(A), r = !Lw(A) && this._options.useCORS === !0 && an.SUPPORT_CORS_IMAGES && !t, n = !Lw(A) && !t && !Hw(A) && typeof this._options.proxy == "string" && an.SUPPORT_CORS_XHR && !r, !t && this._options.allowTaint === !1 && !Lw(A) && !Hw(A) && !n && !r ? [
                2
                /*return*/
              ] : (i = A, n ? [4, this.proxy(i)] : [3, 2]);
            case 1:
              i = a.sent(), a.label = 2;
            case 2:
              return this.context.logger.debug("Added image " + A.substring(0, 256)), [4, new Promise(function(o, l) {
                var c = new Image();
                c.onload = function() {
                  return o(c);
                }, c.onerror = l, (iY(i) || r) && (c.crossOrigin = "anonymous"), c.src = i, c.complete === !0 && setTimeout(function() {
                  return o(c);
                }, 500), s._options.imageTimeout > 0 && setTimeout(function() {
                  return l("Timed out (" + s._options.imageTimeout + "ms) loading image");
                }, s._options.imageTimeout);
              })];
            case 3:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.has = function(A) {
      return typeof this._cache[A] < "u";
    }, e.prototype.keys = function() {
      return Promise.resolve(Object.keys(this._cache));
    }, e.prototype.proxy = function(A) {
      var t = this, r = this._options.proxy;
      if (!r)
        throw new Error("No proxy defined");
      var n = A.substring(0, 256);
      return new Promise(function(i, s) {
        var a = an.SUPPORT_RESPONSE_TYPE ? "blob" : "text", o = new XMLHttpRequest();
        o.onload = function() {
          if (o.status === 200)
            if (a === "text")
              i(o.response);
            else {
              var u = new FileReader();
              u.addEventListener("load", function() {
                return i(u.result);
              }, !1), u.addEventListener("error", function(d) {
                return s(d);
              }, !1), u.readAsDataURL(o.response);
            }
          else
            s("Failed to proxy resource " + n + " with status code " + o.status);
        }, o.onerror = s;
        var l = r.indexOf("?") > -1 ? "&" : "?";
        if (o.open("GET", "" + r + l + "url=" + encodeURIComponent(A) + "&responseType=" + a), a !== "text" && o instanceof XMLHttpRequest && (o.responseType = a), t._options.imageTimeout) {
          var c = t._options.imageTimeout;
          o.timeout = c, o.ontimeout = function() {
            return s("Timed out (" + c + "ms) proxying " + n);
          };
        }
        o.send();
      });
    }, e;
  })()
), eY = /^data:image\/svg\+xml/i, tY = /^data:image\/.*;base64,/i, rY = /^data:image\/.*/i, nY = function(e) {
  return an.SUPPORT_SVG_DRAWING || !sY(e);
}, Lw = function(e) {
  return rY.test(e);
}, iY = function(e) {
  return tY.test(e);
}, Hw = function(e) {
  return e.substr(0, 4) === "blob";
}, sY = function(e) {
  return e.substr(-3).toLowerCase() === "svg" || eY.test(e);
}, ne = (
  /** @class */
  (function() {
    function e(A, t) {
      this.type = 0, this.x = A, this.y = t;
    }
    return e.prototype.add = function(A, t) {
      return new e(this.x + A, this.y + t);
    }, e;
  })()
), Hc = function(e, A, t) {
  return new ne(e.x + (A.x - e.x) * t, e.y + (A.y - e.y) * t);
}, Dd = (
  /** @class */
  (function() {
    function e(A, t, r, n) {
      this.type = 1, this.start = A, this.startControl = t, this.endControl = r, this.end = n;
    }
    return e.prototype.subdivide = function(A, t) {
      var r = Hc(this.start, this.startControl, A), n = Hc(this.startControl, this.endControl, A), i = Hc(this.endControl, this.end, A), s = Hc(r, n, A), a = Hc(n, i, A), o = Hc(s, a, A);
      return t ? new e(this.start, r, s, o) : new e(o, a, i, this.end);
    }, e.prototype.add = function(A, t) {
      return new e(this.start.add(A, t), this.startControl.add(A, t), this.endControl.add(A, t), this.end.add(A, t));
    }, e.prototype.reverse = function() {
      return new e(this.end, this.endControl, this.startControl, this.start);
    }, e;
  })()
), Gi = function(e) {
  return e.type === 1;
}, aY = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(A) {
      var t = A.styles, r = A.bounds, n = ah(t.borderTopLeftRadius, r.width, r.height), i = n[0], s = n[1], a = ah(t.borderTopRightRadius, r.width, r.height), o = a[0], l = a[1], c = ah(t.borderBottomRightRadius, r.width, r.height), u = c[0], d = c[1], h = ah(t.borderBottomLeftRadius, r.width, r.height), p = h[0], B = h[1], y = [];
      y.push((i + o) / r.width), y.push((p + u) / r.width), y.push((s + B) / r.height), y.push((l + d) / r.height);
      var m = Math.max.apply(Math, y);
      m > 1 && (i /= m, s /= m, o /= m, l /= m, u /= m, d /= m, p /= m, B /= m);
      var C = r.width - o, Q = r.height - d, F = r.width - u, T = r.height - B, V = t.borderTopWidth, M = t.borderRightWidth, D = t.borderBottomWidth, I = t.borderLeftWidth, q = It(t.paddingTop, A.bounds.width), U = It(t.paddingRight, A.bounds.width), x = It(t.paddingBottom, A.bounds.width), P = It(t.paddingLeft, A.bounds.width);
      this.topLeftBorderDoubleOuterBox = i > 0 || s > 0 ? Pt(r.left + I / 3, r.top + V / 3, i - I / 3, s - V / 3, ct.TOP_LEFT) : new ne(r.left + I / 3, r.top + V / 3), this.topRightBorderDoubleOuterBox = i > 0 || s > 0 ? Pt(r.left + C, r.top + V / 3, o - M / 3, l - V / 3, ct.TOP_RIGHT) : new ne(r.left + r.width - M / 3, r.top + V / 3), this.bottomRightBorderDoubleOuterBox = u > 0 || d > 0 ? Pt(r.left + F, r.top + Q, u - M / 3, d - D / 3, ct.BOTTOM_RIGHT) : new ne(r.left + r.width - M / 3, r.top + r.height - D / 3), this.bottomLeftBorderDoubleOuterBox = p > 0 || B > 0 ? Pt(r.left + I / 3, r.top + T, p - I / 3, B - D / 3, ct.BOTTOM_LEFT) : new ne(r.left + I / 3, r.top + r.height - D / 3), this.topLeftBorderDoubleInnerBox = i > 0 || s > 0 ? Pt(r.left + I * 2 / 3, r.top + V * 2 / 3, i - I * 2 / 3, s - V * 2 / 3, ct.TOP_LEFT) : new ne(r.left + I * 2 / 3, r.top + V * 2 / 3), this.topRightBorderDoubleInnerBox = i > 0 || s > 0 ? Pt(r.left + C, r.top + V * 2 / 3, o - M * 2 / 3, l - V * 2 / 3, ct.TOP_RIGHT) : new ne(r.left + r.width - M * 2 / 3, r.top + V * 2 / 3), this.bottomRightBorderDoubleInnerBox = u > 0 || d > 0 ? Pt(r.left + F, r.top + Q, u - M * 2 / 3, d - D * 2 / 3, ct.BOTTOM_RIGHT) : new ne(r.left + r.width - M * 2 / 3, r.top + r.height - D * 2 / 3), this.bottomLeftBorderDoubleInnerBox = p > 0 || B > 0 ? Pt(r.left + I * 2 / 3, r.top + T, p - I * 2 / 3, B - D * 2 / 3, ct.BOTTOM_LEFT) : new ne(r.left + I * 2 / 3, r.top + r.height - D * 2 / 3), this.topLeftBorderStroke = i > 0 || s > 0 ? Pt(r.left + I / 2, r.top + V / 2, i - I / 2, s - V / 2, ct.TOP_LEFT) : new ne(r.left + I / 2, r.top + V / 2), this.topRightBorderStroke = i > 0 || s > 0 ? Pt(r.left + C, r.top + V / 2, o - M / 2, l - V / 2, ct.TOP_RIGHT) : new ne(r.left + r.width - M / 2, r.top + V / 2), this.bottomRightBorderStroke = u > 0 || d > 0 ? Pt(r.left + F, r.top + Q, u - M / 2, d - D / 2, ct.BOTTOM_RIGHT) : new ne(r.left + r.width - M / 2, r.top + r.height - D / 2), this.bottomLeftBorderStroke = p > 0 || B > 0 ? Pt(r.left + I / 2, r.top + T, p - I / 2, B - D / 2, ct.BOTTOM_LEFT) : new ne(r.left + I / 2, r.top + r.height - D / 2), this.topLeftBorderBox = i > 0 || s > 0 ? Pt(r.left, r.top, i, s, ct.TOP_LEFT) : new ne(r.left, r.top), this.topRightBorderBox = o > 0 || l > 0 ? Pt(r.left + C, r.top, o, l, ct.TOP_RIGHT) : new ne(r.left + r.width, r.top), this.bottomRightBorderBox = u > 0 || d > 0 ? Pt(r.left + F, r.top + Q, u, d, ct.BOTTOM_RIGHT) : new ne(r.left + r.width, r.top + r.height), this.bottomLeftBorderBox = p > 0 || B > 0 ? Pt(r.left, r.top + T, p, B, ct.BOTTOM_LEFT) : new ne(r.left, r.top + r.height), this.topLeftPaddingBox = i > 0 || s > 0 ? Pt(r.left + I, r.top + V, Math.max(0, i - I), Math.max(0, s - V), ct.TOP_LEFT) : new ne(r.left + I, r.top + V), this.topRightPaddingBox = o > 0 || l > 0 ? Pt(r.left + Math.min(C, r.width - M), r.top + V, C > r.width + M ? 0 : Math.max(0, o - M), Math.max(0, l - V), ct.TOP_RIGHT) : new ne(r.left + r.width - M, r.top + V), this.bottomRightPaddingBox = u > 0 || d > 0 ? Pt(r.left + Math.min(F, r.width - I), r.top + Math.min(Q, r.height - D), Math.max(0, u - M), Math.max(0, d - D), ct.BOTTOM_RIGHT) : new ne(r.left + r.width - M, r.top + r.height - D), this.bottomLeftPaddingBox = p > 0 || B > 0 ? Pt(r.left + I, r.top + Math.min(T, r.height - D), Math.max(0, p - I), Math.max(0, B - D), ct.BOTTOM_LEFT) : new ne(r.left + I, r.top + r.height - D), this.topLeftContentBox = i > 0 || s > 0 ? Pt(r.left + I + P, r.top + V + q, Math.max(0, i - (I + P)), Math.max(0, s - (V + q)), ct.TOP_LEFT) : new ne(r.left + I + P, r.top + V + q), this.topRightContentBox = o > 0 || l > 0 ? Pt(r.left + Math.min(C, r.width + I + P), r.top + V + q, C > r.width + I + P ? 0 : o - I + P, l - (V + q), ct.TOP_RIGHT) : new ne(r.left + r.width - (M + U), r.top + V + q), this.bottomRightContentBox = u > 0 || d > 0 ? Pt(r.left + Math.min(F, r.width - (I + P)), r.top + Math.min(Q, r.height + V + q), Math.max(0, u - (M + U)), d - (D + x), ct.BOTTOM_RIGHT) : new ne(r.left + r.width - (M + U), r.top + r.height - (D + x)), this.bottomLeftContentBox = p > 0 || B > 0 ? Pt(r.left + I + P, r.top + T, Math.max(0, p - (I + P)), B - (D + x), ct.BOTTOM_LEFT) : new ne(r.left + I + P, r.top + r.height - (D + x));
    }
    return e;
  })()
), ct;
(function(e) {
  e[e.TOP_LEFT = 0] = "TOP_LEFT", e[e.TOP_RIGHT = 1] = "TOP_RIGHT", e[e.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", e[e.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
})(ct || (ct = {}));
var Pt = function(e, A, t, r, n) {
  var i = 4 * ((Math.sqrt(2) - 1) / 3), s = t * i, a = r * i, o = e + t, l = A + r;
  switch (n) {
    case ct.TOP_LEFT:
      return new Dd(new ne(e, l), new ne(e, l - a), new ne(o - s, A), new ne(o, A));
    case ct.TOP_RIGHT:
      return new Dd(new ne(e, A), new ne(e + s, A), new ne(o, l - a), new ne(o, l));
    case ct.BOTTOM_RIGHT:
      return new Dd(new ne(o, A), new ne(o, A + a), new ne(e + s, l), new ne(e, l));
    case ct.BOTTOM_LEFT:
    default:
      return new Dd(new ne(o, l), new ne(o - s, l), new ne(e, A + a), new ne(e, A));
  }
}, Ng = function(e) {
  return [e.topLeftBorderBox, e.topRightBorderBox, e.bottomRightBorderBox, e.bottomLeftBorderBox];
}, oY = function(e) {
  return [
    e.topLeftContentBox,
    e.topRightContentBox,
    e.bottomRightContentBox,
    e.bottomLeftContentBox
  ];
}, Dg = function(e) {
  return [
    e.topLeftPaddingBox,
    e.topRightPaddingBox,
    e.bottomRightPaddingBox,
    e.bottomLeftPaddingBox
  ];
}, lY = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(A, t, r) {
      this.offsetX = A, this.offsetY = t, this.matrix = r, this.type = 0, this.target = 6;
    }
    return e;
  })()
), Rd = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(A, t) {
      this.path = A, this.target = t, this.type = 1;
    }
    return e;
  })()
), cY = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(A) {
      this.opacity = A, this.type = 2, this.target = 6;
    }
    return e;
  })()
), uY = function(e) {
  return e.type === 0;
}, RL = function(e) {
  return e.type === 1;
}, hY = function(e) {
  return e.type === 2;
}, p5 = function(e, A) {
  return e.length === A.length ? e.some(function(t, r) {
    return t === A[r];
  }) : !1;
}, fY = function(e, A, t, r, n) {
  return e.map(function(i, s) {
    switch (s) {
      case 0:
        return i.add(A, t);
      case 1:
        return i.add(A + r, t);
      case 2:
        return i.add(A + r, t + n);
      case 3:
        return i.add(A, t + n);
    }
    return i;
  });
}, ML = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(A) {
      this.element = A, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
    }
    return e;
  })()
), PL = (
  /** @class */
  (function() {
    function e(A, t) {
      if (this.container = A, this.parent = t, this.effects = [], this.curves = new aY(this.container), this.container.styles.opacity < 1 && this.effects.push(new cY(this.container.styles.opacity)), this.container.styles.transform !== null) {
        var r = this.container.bounds.left + this.container.styles.transformOrigin[0].number, n = this.container.bounds.top + this.container.styles.transformOrigin[1].number, i = this.container.styles.transform;
        this.effects.push(new lY(r, n, i));
      }
      if (this.container.styles.overflowX !== 0) {
        var s = Ng(this.curves), a = Dg(this.curves);
        p5(s, a) ? this.effects.push(new Rd(
          s,
          6
          /* CONTENT */
        )) : (this.effects.push(new Rd(
          s,
          2
          /* BACKGROUND_BORDERS */
        )), this.effects.push(new Rd(
          a,
          4
          /* CONTENT */
        )));
      }
    }
    return e.prototype.getEffects = function(A) {
      for (var t = [
        2,
        3
        /* FIXED */
      ].indexOf(this.container.styles.position) === -1, r = this.parent, n = this.effects.slice(0); r; ) {
        var i = r.effects.filter(function(o) {
          return !RL(o);
        });
        if (t || r.container.styles.position !== 0 || !r.parent) {
          if (n.unshift.apply(n, i), t = [
            2,
            3
            /* FIXED */
          ].indexOf(r.container.styles.position) === -1, r.container.styles.overflowX !== 0) {
            var s = Ng(r.curves), a = Dg(r.curves);
            p5(s, a) || n.unshift(new Rd(
              a,
              6
              /* CONTENT */
            ));
          }
        } else
          n.unshift.apply(n, i);
        r = r.parent;
      }
      return n.filter(function(o) {
        return kr(o.target, A);
      });
    }, e;
  })()
), $v = function(e, A, t, r) {
  e.container.elements.forEach(function(n) {
    var i = kr(
      n.flags,
      4
      /* CREATES_REAL_STACKING_CONTEXT */
    ), s = kr(
      n.flags,
      2
      /* CREATES_STACKING_CONTEXT */
    ), a = new PL(n, e);
    kr(
      n.styles.display,
      2048
      /* LIST_ITEM */
    ) && r.push(a);
    var o = kr(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) ? [] : r;
    if (i || s) {
      var l = i || n.styles.isPositioned() ? t : A, c = new ML(a);
      if (n.styles.isPositioned() || n.styles.opacity < 1 || n.styles.isTransformed()) {
        var u = n.styles.zIndex.order;
        if (u < 0) {
          var d = 0;
          l.negativeZIndex.some(function(p, B) {
            return u > p.element.container.styles.zIndex.order ? (d = B, !1) : d > 0;
          }), l.negativeZIndex.splice(d, 0, c);
        } else if (u > 0) {
          var h = 0;
          l.positiveZIndex.some(function(p, B) {
            return u >= p.element.container.styles.zIndex.order ? (h = B + 1, !1) : h > 0;
          }), l.positiveZIndex.splice(h, 0, c);
        } else
          l.zeroOrAutoZIndexOrTransformedOrOpacity.push(c);
      } else
        n.styles.isFloating() ? l.nonPositionedFloats.push(c) : l.nonPositionedInlineLevel.push(c);
      $v(a, c, i ? c : t, o);
    } else
      n.styles.isInlineLevel() ? A.inlineLevel.push(a) : A.nonInlineLevel.push(a), $v(a, A, t, o);
    kr(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) && kL(n, o);
  });
}, kL = function(e, A) {
  for (var t = e instanceof Vv ? e.start : 1, r = e instanceof Vv ? e.reversed : !1, n = 0; n < A.length; n++) {
    var i = A[n];
    i.container instanceof FL && typeof i.container.value == "number" && i.container.value !== 0 && (t = i.container.value), i.listValue = jh(t, i.container.styles.listStyleType, !0), t += r ? -1 : 1;
  }
}, dY = function(e) {
  var A = new PL(e, null), t = new ML(A), r = [];
  return $v(A, t, t, r), kL(A.container, r), t;
}, B5 = function(e, A) {
  switch (A) {
    case 0:
      return Xi(e.topLeftBorderBox, e.topLeftPaddingBox, e.topRightBorderBox, e.topRightPaddingBox);
    case 1:
      return Xi(e.topRightBorderBox, e.topRightPaddingBox, e.bottomRightBorderBox, e.bottomRightPaddingBox);
    case 2:
      return Xi(e.bottomRightBorderBox, e.bottomRightPaddingBox, e.bottomLeftBorderBox, e.bottomLeftPaddingBox);
    default:
      return Xi(e.bottomLeftBorderBox, e.bottomLeftPaddingBox, e.topLeftBorderBox, e.topLeftPaddingBox);
  }
}, gY = function(e, A) {
  switch (A) {
    case 0:
      return Xi(e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox, e.topRightBorderBox, e.topRightBorderDoubleOuterBox);
    case 1:
      return Xi(e.topRightBorderBox, e.topRightBorderDoubleOuterBox, e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox);
    case 2:
      return Xi(e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox, e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox);
    default:
      return Xi(e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox, e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox);
  }
}, pY = function(e, A) {
  switch (A) {
    case 0:
      return Xi(e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox, e.topRightBorderDoubleInnerBox, e.topRightPaddingBox);
    case 1:
      return Xi(e.topRightBorderDoubleInnerBox, e.topRightPaddingBox, e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox);
    case 2:
      return Xi(e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox, e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox);
    default:
      return Xi(e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox, e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox);
  }
}, BY = function(e, A) {
  switch (A) {
    case 0:
      return Md(e.topLeftBorderStroke, e.topRightBorderStroke);
    case 1:
      return Md(e.topRightBorderStroke, e.bottomRightBorderStroke);
    case 2:
      return Md(e.bottomRightBorderStroke, e.bottomLeftBorderStroke);
    default:
      return Md(e.bottomLeftBorderStroke, e.topLeftBorderStroke);
  }
}, Md = function(e, A) {
  var t = [];
  return Gi(e) ? t.push(e.subdivide(0.5, !1)) : t.push(e), Gi(A) ? t.push(A.subdivide(0.5, !0)) : t.push(A), t;
}, Xi = function(e, A, t, r) {
  var n = [];
  return Gi(e) ? n.push(e.subdivide(0.5, !1)) : n.push(e), Gi(t) ? n.push(t.subdivide(0.5, !0)) : n.push(t), Gi(r) ? n.push(r.subdivide(0.5, !0).reverse()) : n.push(r), Gi(A) ? n.push(A.subdivide(0.5, !1).reverse()) : n.push(A), n;
}, KL = function(e) {
  var A = e.bounds, t = e.styles;
  return A.add(t.borderLeftWidth, t.borderTopWidth, -(t.borderRightWidth + t.borderLeftWidth), -(t.borderTopWidth + t.borderBottomWidth));
}, Rg = function(e) {
  var A = e.styles, t = e.bounds, r = It(A.paddingLeft, t.width), n = It(A.paddingRight, t.width), i = It(A.paddingTop, t.width), s = It(A.paddingBottom, t.width);
  return t.add(r + A.borderLeftWidth, i + A.borderTopWidth, -(A.borderRightWidth + A.borderLeftWidth + r + n), -(A.borderTopWidth + A.borderBottomWidth + i + s));
}, wY = function(e, A) {
  return e === 0 ? A.bounds : e === 2 ? Rg(A) : KL(A);
}, mY = function(e, A) {
  return e === 0 ? A.bounds : e === 2 ? Rg(A) : KL(A);
}, Tw = function(e, A, t) {
  var r = wY(Mc(e.styles.backgroundOrigin, A), e), n = mY(Mc(e.styles.backgroundClip, A), e), i = vY(Mc(e.styles.backgroundSize, A), t, r), s = i[0], a = i[1], o = ah(Mc(e.styles.backgroundPosition, A), r.width - s, r.height - a), l = yY(Mc(e.styles.backgroundRepeat, A), o, i, r, n), c = Math.round(r.left + o[0]), u = Math.round(r.top + o[1]);
  return [l, c, u, s, a];
}, Tc = function(e) {
  return mt(e) && e.value === zc.AUTO;
}, Pd = function(e) {
  return typeof e == "number";
}, vY = function(e, A, t) {
  var r = A[0], n = A[1], i = A[2], s = e[0], a = e[1];
  if (!s)
    return [0, 0];
  if (Sr(s) && a && Sr(a))
    return [It(s, t.width), It(a, t.height)];
  var o = Pd(i);
  if (mt(s) && (s.value === zc.CONTAIN || s.value === zc.COVER)) {
    if (Pd(i)) {
      var l = t.width / t.height;
      return l < i != (s.value === zc.COVER) ? [t.width, t.width / i] : [t.height * i, t.height];
    }
    return [t.width, t.height];
  }
  var c = Pd(r), u = Pd(n), d = c || u;
  if (Tc(s) && (!a || Tc(a))) {
    if (c && u)
      return [r, n];
    if (!o && !d)
      return [t.width, t.height];
    if (d && o) {
      var h = c ? r : n * i, p = u ? n : r / i;
      return [h, p];
    }
    var B = c ? r : t.width, y = u ? n : t.height;
    return [B, y];
  }
  if (o) {
    var m = 0, C = 0;
    return Sr(s) ? m = It(s, t.width) : Sr(a) && (C = It(a, t.height)), Tc(s) ? m = C * i : (!a || Tc(a)) && (C = m / i), [m, C];
  }
  var Q = null, F = null;
  if (Sr(s) ? Q = It(s, t.width) : a && Sr(a) && (F = It(a, t.height)), Q !== null && (!a || Tc(a)) && (F = c && u ? Q / r * n : t.height), F !== null && Tc(s) && (Q = c && u ? F / n * r : t.width), Q !== null && F !== null)
    return [Q, F];
  throw new Error("Unable to calculate background-size for element");
}, Mc = function(e, A) {
  var t = e[A];
  return typeof t > "u" ? e[0] : t;
}, yY = function(e, A, t, r, n) {
  var i = A[0], s = A[1], a = t[0], o = t[1];
  switch (e) {
    case 2:
      return [
        new ne(Math.round(r.left), Math.round(r.top + s)),
        new ne(Math.round(r.left + r.width), Math.round(r.top + s)),
        new ne(Math.round(r.left + r.width), Math.round(o + r.top + s)),
        new ne(Math.round(r.left), Math.round(o + r.top + s))
      ];
    case 3:
      return [
        new ne(Math.round(r.left + i), Math.round(r.top)),
        new ne(Math.round(r.left + i + a), Math.round(r.top)),
        new ne(Math.round(r.left + i + a), Math.round(r.height + r.top)),
        new ne(Math.round(r.left + i), Math.round(r.height + r.top))
      ];
    case 1:
      return [
        new ne(Math.round(r.left + i), Math.round(r.top + s)),
        new ne(Math.round(r.left + i + a), Math.round(r.top + s)),
        new ne(Math.round(r.left + i + a), Math.round(r.top + s + o)),
        new ne(Math.round(r.left + i), Math.round(r.top + s + o))
      ];
    default:
      return [
        new ne(Math.round(n.left), Math.round(n.top)),
        new ne(Math.round(n.left + n.width), Math.round(n.top)),
        new ne(Math.round(n.left + n.width), Math.round(n.height + n.top)),
        new ne(Math.round(n.left), Math.round(n.height + n.top))
      ];
  }
}, CY = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", w5 = "Hidden Text", bY = (
  /** @class */
  (function() {
    function e(A) {
      this._data = {}, this._document = A;
    }
    return e.prototype.parseMetrics = function(A, t) {
      var r = this._document.createElement("div"), n = this._document.createElement("img"), i = this._document.createElement("span"), s = this._document.body;
      r.style.visibility = "hidden", r.style.fontFamily = A, r.style.fontSize = t, r.style.margin = "0", r.style.padding = "0", r.style.whiteSpace = "nowrap", s.appendChild(r), n.src = CY, n.width = 1, n.height = 1, n.style.margin = "0", n.style.padding = "0", n.style.verticalAlign = "baseline", i.style.fontFamily = A, i.style.fontSize = t, i.style.margin = "0", i.style.padding = "0", i.appendChild(this._document.createTextNode(w5)), r.appendChild(i), r.appendChild(n);
      var a = n.offsetTop - i.offsetTop + 2;
      r.removeChild(i), r.appendChild(this._document.createTextNode(w5)), r.style.lineHeight = "normal", n.style.verticalAlign = "super";
      var o = n.offsetTop - r.offsetTop + 2;
      return s.removeChild(r), { baseline: a, middle: o };
    }, e.prototype.getMetrics = function(A, t) {
      var r = A + " " + t;
      return typeof this._data[r] > "u" && (this._data[r] = this.parseMetrics(A, t)), this._data[r];
    }, e;
  })()
), VL = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(A, t) {
      this.context = A, this.options = t;
    }
    return e;
  })()
), FY = 1e4, QY = (
  /** @class */
  (function(e) {
    Us(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n._activeEffects = [], n.canvas = r.canvas ? r.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), r.canvas || (n.canvas.width = Math.floor(r.width * r.scale), n.canvas.height = Math.floor(r.height * r.scale), n.canvas.style.width = r.width + "px", n.canvas.style.height = r.height + "px"), n.fontMetrics = new bY(document), n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-r.x, -r.y), n.ctx.textBaseline = "bottom", n._activeEffects = [], n.context.logger.debug("Canvas renderer initialized (" + r.width + "x" + r.height + ") with scale " + r.scale), n;
    }
    return A.prototype.applyEffects = function(t) {
      for (var r = this; this._activeEffects.length; )
        this.popEffect();
      t.forEach(function(n) {
        return r.applyEffect(n);
      });
    }, A.prototype.applyEffect = function(t) {
      this.ctx.save(), hY(t) && (this.ctx.globalAlpha = t.opacity), uY(t) && (this.ctx.translate(t.offsetX, t.offsetY), this.ctx.transform(t.matrix[0], t.matrix[1], t.matrix[2], t.matrix[3], t.matrix[4], t.matrix[5]), this.ctx.translate(-t.offsetX, -t.offsetY)), RL(t) && (this.path(t.path), this.ctx.clip()), this._activeEffects.push(t);
    }, A.prototype.popEffect = function() {
      this._activeEffects.pop(), this.ctx.restore();
    }, A.prototype.renderStack = function(t) {
      return zn(this, void 0, void 0, function() {
        var r;
        return Fn(this, function(n) {
          switch (n.label) {
            case 0:
              return r = t.element.container.styles, r.isVisible() ? [4, this.renderStackContent(t)] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderNode = function(t) {
      return zn(this, void 0, void 0, function() {
        return Fn(this, function(r) {
          switch (r.label) {
            case 0:
              if (kr(
                t.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return t.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(t)] : [3, 3];
            case 1:
              return r.sent(), [4, this.renderNodeContent(t)];
            case 2:
              r.sent(), r.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderTextWithLetterSpacing = function(t, r, n) {
      var i = this;
      if (r === 0)
        this.ctx.fillText(t.text, t.bounds.left, t.bounds.top + n);
      else {
        var s = qy(t.text);
        s.reduce(function(a, o) {
          return i.ctx.fillText(o, a, t.bounds.top + n), a + i.ctx.measureText(o).width;
        }, t.bounds.left);
      }
    }, A.prototype.createFontStyle = function(t) {
      var r = t.fontVariant.filter(function(s) {
        return s === "normal" || s === "small-caps";
      }).join(""), n = SY(t.fontFamily).join(", "), i = Af(t.fontSize) ? "" + t.fontSize.number + t.fontSize.unit : t.fontSize.number + "px";
      return [
        [t.fontStyle, r, t.fontWeight, i, n].join(" "),
        n,
        i
      ];
    }, A.prototype.renderTextNode = function(t, r) {
      return zn(this, void 0, void 0, function() {
        var n, i, s, a, o, l, c, u, d = this;
        return Fn(this, function(h) {
          return n = this.createFontStyle(r), i = n[0], s = n[1], a = n[2], this.ctx.font = i, this.ctx.direction = r.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", o = this.fontMetrics.getMetrics(s, a), l = o.baseline, c = o.middle, u = r.paintOrder, t.textBounds.forEach(function(p) {
            u.forEach(function(B) {
              switch (B) {
                case 0:
                  d.ctx.fillStyle = $r(r.color), d.renderTextWithLetterSpacing(p, r.letterSpacing, l);
                  var y = r.textShadow;
                  y.length && p.text.trim().length && (y.slice(0).reverse().forEach(function(m) {
                    d.ctx.shadowColor = $r(m.color), d.ctx.shadowOffsetX = m.offsetX.number * d.options.scale, d.ctx.shadowOffsetY = m.offsetY.number * d.options.scale, d.ctx.shadowBlur = m.blur.number, d.renderTextWithLetterSpacing(p, r.letterSpacing, l);
                  }), d.ctx.shadowColor = "", d.ctx.shadowOffsetX = 0, d.ctx.shadowOffsetY = 0, d.ctx.shadowBlur = 0), r.textDecorationLine.length && (d.ctx.fillStyle = $r(r.textDecorationColor || r.color), r.textDecorationLine.forEach(function(m) {
                    switch (m) {
                      case 1:
                        d.ctx.fillRect(p.bounds.left, Math.round(p.bounds.top + l), p.bounds.width, 1);
                        break;
                      case 2:
                        d.ctx.fillRect(p.bounds.left, Math.round(p.bounds.top), p.bounds.width, 1);
                        break;
                      case 3:
                        d.ctx.fillRect(p.bounds.left, Math.ceil(p.bounds.top + c), p.bounds.width, 1);
                        break;
                    }
                  }));
                  break;
                case 1:
                  r.webkitTextStrokeWidth && p.text.trim().length && (d.ctx.strokeStyle = $r(r.webkitTextStrokeColor), d.ctx.lineWidth = r.webkitTextStrokeWidth, d.ctx.lineJoin = window.chrome ? "miter" : "round", d.ctx.strokeText(p.text, p.bounds.left, p.bounds.top + l)), d.ctx.strokeStyle = "", d.ctx.lineWidth = 0, d.ctx.lineJoin = "miter";
                  break;
              }
            });
          }), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.renderReplacedElement = function(t, r, n) {
      if (n && t.intrinsicWidth > 0 && t.intrinsicHeight > 0) {
        var i = Rg(t), s = Dg(r);
        this.path(s), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(n, 0, 0, t.intrinsicWidth, t.intrinsicHeight, i.left, i.top, i.width, i.height), this.ctx.restore();
      }
    }, A.prototype.renderNodeContent = function(t) {
      return zn(this, void 0, void 0, function() {
        var r, n, i, s, a, o, C, C, l, c, u, d, F, h, p, T, B, y, m, C, Q, F, T;
        return Fn(this, function(V) {
          switch (V.label) {
            case 0:
              this.applyEffects(t.getEffects(
                4
                /* CONTENT */
              )), r = t.container, n = t.curves, i = r.styles, s = 0, a = r.textNodes, V.label = 1;
            case 1:
              return s < a.length ? (o = a[s], [4, this.renderTextNode(o, i)]) : [3, 4];
            case 2:
              V.sent(), V.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              if (!(r instanceof yL)) return [3, 8];
              V.label = 5;
            case 5:
              return V.trys.push([5, 7, , 8]), [4, this.context.cache.match(r.src)];
            case 6:
              return C = V.sent(), this.renderReplacedElement(r, n, C), [3, 8];
            case 7:
              return V.sent(), this.context.logger.error("Error loading image " + r.src), [3, 8];
            case 8:
              if (r instanceof CL && this.renderReplacedElement(r, n, r.canvas), !(r instanceof bL)) return [3, 12];
              V.label = 9;
            case 9:
              return V.trys.push([9, 11, , 12]), [4, this.context.cache.match(r.svg)];
            case 10:
              return C = V.sent(), this.renderReplacedElement(r, n, C), [3, 12];
            case 11:
              return V.sent(), this.context.logger.error("Error loading svg " + r.svg.substring(0, 255)), [3, 12];
            case 12:
              return r instanceof EL && r.tree ? (l = new A(this.context, {
                scale: this.options.scale,
                backgroundColor: r.backgroundColor,
                x: 0,
                y: 0,
                width: r.width,
                height: r.height
              }), [4, l.render(r.tree)]) : [3, 14];
            case 13:
              c = V.sent(), r.width && r.height && this.ctx.drawImage(c, 0, 0, r.width, r.height, r.bounds.left, r.bounds.top, r.bounds.width, r.bounds.height), V.label = 14;
            case 14:
              if (r instanceof $y && (u = Math.min(r.bounds.width, r.bounds.height), r.type === Hg ? r.checked && (this.ctx.save(), this.path([
                new ne(r.bounds.left + u * 0.39363, r.bounds.top + u * 0.79),
                new ne(r.bounds.left + u * 0.16, r.bounds.top + u * 0.5549),
                new ne(r.bounds.left + u * 0.27347, r.bounds.top + u * 0.44071),
                new ne(r.bounds.left + u * 0.39694, r.bounds.top + u * 0.5649),
                new ne(r.bounds.left + u * 0.72983, r.bounds.top + u * 0.23),
                new ne(r.bounds.left + u * 0.84, r.bounds.top + u * 0.34085),
                new ne(r.bounds.left + u * 0.39363, r.bounds.top + u * 0.79)
              ]), this.ctx.fillStyle = $r(i5), this.ctx.fill(), this.ctx.restore()) : r.type === Tg && r.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(r.bounds.left + u / 2, r.bounds.top + u / 2, u / 4, 0, Math.PI * 2, !0), this.ctx.fillStyle = $r(i5), this.ctx.fill(), this.ctx.restore())), UY(r) && r.value.length) {
                switch (d = this.createFontStyle(i), F = d[0], h = d[1], p = this.fontMetrics.getMetrics(F, h).baseline, this.ctx.font = F, this.ctx.fillStyle = $r(i.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = xY(r.styles.textAlign), T = Rg(r), B = 0, r.styles.textAlign) {
                  case 1:
                    B += T.width / 2;
                    break;
                  case 2:
                    B += T.width;
                    break;
                }
                y = T.add(B, 0, 0, -T.height / 2 + 1), this.ctx.save(), this.path([
                  new ne(T.left, T.top),
                  new ne(T.left + T.width, T.top),
                  new ne(T.left + T.width, T.top + T.height),
                  new ne(T.left, T.top + T.height)
                ]), this.ctx.clip(), this.renderTextWithLetterSpacing(new Qh(r.value, y), i.letterSpacing, p), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
              }
              if (!kr(
                r.styles.display,
                2048
                /* LIST_ITEM */
              )) return [3, 20];
              if (r.styles.listStyleImage === null) return [3, 19];
              if (m = r.styles.listStyleImage, m.type !== 0) return [3, 18];
              C = void 0, Q = m.url, V.label = 15;
            case 15:
              return V.trys.push([15, 17, , 18]), [4, this.context.cache.match(Q)];
            case 16:
              return C = V.sent(), this.ctx.drawImage(C, r.bounds.left - (C.width + 10), r.bounds.top), [3, 18];
            case 17:
              return V.sent(), this.context.logger.error("Error loading list-style-image " + Q), [3, 18];
            case 18:
              return [3, 20];
            case 19:
              t.listValue && r.styles.listStyleType !== -1 && (F = this.createFontStyle(i)[0], this.ctx.font = F, this.ctx.fillStyle = $r(i.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", T = new Oa(r.bounds.left, r.bounds.top + It(r.styles.paddingTop, r.bounds.width), r.bounds.width, KQ(i.lineHeight, i.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new Qh(t.listValue, T), i.letterSpacing, KQ(i.lineHeight, i.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), V.label = 20;
            case 20:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderStackContent = function(t) {
      return zn(this, void 0, void 0, function() {
        var r, n, m, i, s, m, a, o, m, l, c, m, u, d, m, h, p, m, B, y, m;
        return Fn(this, function(C) {
          switch (C.label) {
            case 0:
              if (kr(
                t.element.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return [4, this.renderNodeBackgroundAndBorders(t.element)];
            case 1:
              C.sent(), r = 0, n = t.negativeZIndex, C.label = 2;
            case 2:
              return r < n.length ? (m = n[r], [4, this.renderStack(m)]) : [3, 5];
            case 3:
              C.sent(), C.label = 4;
            case 4:
              return r++, [3, 2];
            case 5:
              return [4, this.renderNodeContent(t.element)];
            case 6:
              C.sent(), i = 0, s = t.nonInlineLevel, C.label = 7;
            case 7:
              return i < s.length ? (m = s[i], [4, this.renderNode(m)]) : [3, 10];
            case 8:
              C.sent(), C.label = 9;
            case 9:
              return i++, [3, 7];
            case 10:
              a = 0, o = t.nonPositionedFloats, C.label = 11;
            case 11:
              return a < o.length ? (m = o[a], [4, this.renderStack(m)]) : [3, 14];
            case 12:
              C.sent(), C.label = 13;
            case 13:
              return a++, [3, 11];
            case 14:
              l = 0, c = t.nonPositionedInlineLevel, C.label = 15;
            case 15:
              return l < c.length ? (m = c[l], [4, this.renderStack(m)]) : [3, 18];
            case 16:
              C.sent(), C.label = 17;
            case 17:
              return l++, [3, 15];
            case 18:
              u = 0, d = t.inlineLevel, C.label = 19;
            case 19:
              return u < d.length ? (m = d[u], [4, this.renderNode(m)]) : [3, 22];
            case 20:
              C.sent(), C.label = 21;
            case 21:
              return u++, [3, 19];
            case 22:
              h = 0, p = t.zeroOrAutoZIndexOrTransformedOrOpacity, C.label = 23;
            case 23:
              return h < p.length ? (m = p[h], [4, this.renderStack(m)]) : [3, 26];
            case 24:
              C.sent(), C.label = 25;
            case 25:
              return h++, [3, 23];
            case 26:
              B = 0, y = t.positiveZIndex, C.label = 27;
            case 27:
              return B < y.length ? (m = y[B], [4, this.renderStack(m)]) : [3, 30];
            case 28:
              C.sent(), C.label = 29;
            case 29:
              return B++, [3, 27];
            case 30:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.mask = function(t) {
      this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(t.slice(0).reverse()), this.ctx.closePath();
    }, A.prototype.path = function(t) {
      this.ctx.beginPath(), this.formatPath(t), this.ctx.closePath();
    }, A.prototype.formatPath = function(t) {
      var r = this;
      t.forEach(function(n, i) {
        var s = Gi(n) ? n.start : n;
        i === 0 ? r.ctx.moveTo(s.x, s.y) : r.ctx.lineTo(s.x, s.y), Gi(n) && r.ctx.bezierCurveTo(n.startControl.x, n.startControl.y, n.endControl.x, n.endControl.y, n.end.x, n.end.y);
      });
    }, A.prototype.renderRepeat = function(t, r, n, i) {
      this.path(t), this.ctx.fillStyle = r, this.ctx.translate(n, i), this.ctx.fill(), this.ctx.translate(-n, -i);
    }, A.prototype.resizeImage = function(t, r, n) {
      var i;
      if (t.width === r && t.height === n)
        return t;
      var s = (i = this.canvas.ownerDocument) !== null && i !== void 0 ? i : document, a = s.createElement("canvas");
      a.width = Math.max(1, r), a.height = Math.max(1, n);
      var o = a.getContext("2d");
      return o.drawImage(t, 0, 0, t.width, t.height, 0, 0, r, n), a;
    }, A.prototype.renderBackgroundImage = function(t) {
      return zn(this, void 0, void 0, function() {
        var r, n, i, s, a, o;
        return Fn(this, function(l) {
          switch (l.label) {
            case 0:
              r = t.styles.backgroundImage.length - 1, n = function(c) {
                var u, d, h, q, nA, sA, P, N, D, p, q, nA, sA, P, N, B, y, m, C, Q, F, T, V, M, D, I, q, U, x, P, N, iA, nA, sA, tA, cA, FA, CA, S, W, Y, AA;
                return Fn(this, function(oA) {
                  switch (oA.label) {
                    case 0:
                      if (c.type !== 0) return [3, 5];
                      u = void 0, d = c.url, oA.label = 1;
                    case 1:
                      return oA.trys.push([1, 3, , 4]), [4, i.context.cache.match(d)];
                    case 2:
                      return u = oA.sent(), [3, 4];
                    case 3:
                      return oA.sent(), i.context.logger.error("Error loading background-image " + d), [3, 4];
                    case 4:
                      return u && (h = Tw(t, r, [
                        u.width,
                        u.height,
                        u.width / u.height
                      ]), q = h[0], nA = h[1], sA = h[2], P = h[3], N = h[4], D = i.ctx.createPattern(i.resizeImage(u, P, N), "repeat"), i.renderRepeat(q, D, nA, sA)), [3, 6];
                    case 5:
                      u$(c) ? (p = Tw(t, r, [null, null, null]), q = p[0], nA = p[1], sA = p[2], P = p[3], N = p[4], B = s$(c.angle, P, N), y = B[0], m = B[1], C = B[2], Q = B[3], F = B[4], T = document.createElement("canvas"), T.width = P, T.height = N, V = T.getContext("2d"), M = V.createLinearGradient(m, Q, C, F), PQ(c.stops, y).forEach(function(gA) {
                        return M.addColorStop(gA.stop, $r(gA.color));
                      }), V.fillStyle = M, V.fillRect(0, 0, P, N), P > 0 && N > 0 && (D = i.ctx.createPattern(T, "repeat"), i.renderRepeat(q, D, nA, sA))) : h$(c) && (I = Tw(t, r, [
                        null,
                        null,
                        null
                      ]), q = I[0], U = I[1], x = I[2], P = I[3], N = I[4], iA = c.position.length === 0 ? [Gy] : c.position, nA = It(iA[0], P), sA = It(iA[iA.length - 1], N), tA = a$(c, nA, sA, P, N), cA = tA[0], FA = tA[1], cA > 0 && FA > 0 && (CA = i.ctx.createRadialGradient(U + nA, x + sA, 0, U + nA, x + sA, cA), PQ(c.stops, cA * 2).forEach(function(gA) {
                        return CA.addColorStop(gA.stop, $r(gA.color));
                      }), i.path(q), i.ctx.fillStyle = CA, cA !== FA ? (S = t.bounds.left + 0.5 * t.bounds.width, W = t.bounds.top + 0.5 * t.bounds.height, Y = FA / cA, AA = 1 / Y, i.ctx.save(), i.ctx.translate(S, W), i.ctx.transform(1, 0, 0, Y, 0, 0), i.ctx.translate(-S, -W), i.ctx.fillRect(U, AA * (x - W) + W, P, N * AA), i.ctx.restore()) : i.ctx.fill())), oA.label = 6;
                    case 6:
                      return r--, [
                        2
                        /*return*/
                      ];
                  }
                });
              }, i = this, s = 0, a = t.styles.backgroundImage.slice(0).reverse(), l.label = 1;
            case 1:
              return s < a.length ? (o = a[s], [5, n(o)]) : [3, 4];
            case 2:
              l.sent(), l.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderSolidBorder = function(t, r, n) {
      return zn(this, void 0, void 0, function() {
        return Fn(this, function(i) {
          return this.path(B5(n, r)), this.ctx.fillStyle = $r(t), this.ctx.fill(), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.renderDoubleBorder = function(t, r, n, i) {
      return zn(this, void 0, void 0, function() {
        var s, a;
        return Fn(this, function(o) {
          switch (o.label) {
            case 0:
              return r < 3 ? [4, this.renderSolidBorder(t, n, i)] : [3, 2];
            case 1:
              return o.sent(), [
                2
                /*return*/
              ];
            case 2:
              return s = gY(i, n), this.path(s), this.ctx.fillStyle = $r(t), this.ctx.fill(), a = pY(i, n), this.path(a), this.ctx.fill(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderNodeBackgroundAndBorders = function(t) {
      return zn(this, void 0, void 0, function() {
        var r, n, i, s, a, o, l, c, u = this;
        return Fn(this, function(d) {
          switch (d.label) {
            case 0:
              return this.applyEffects(t.getEffects(
                2
                /* BACKGROUND_BORDERS */
              )), r = t.container.styles, n = !No(r.backgroundColor) || r.backgroundImage.length, i = [
                { style: r.borderTopStyle, color: r.borderTopColor, width: r.borderTopWidth },
                { style: r.borderRightStyle, color: r.borderRightColor, width: r.borderRightWidth },
                { style: r.borderBottomStyle, color: r.borderBottomColor, width: r.borderBottomWidth },
                { style: r.borderLeftStyle, color: r.borderLeftColor, width: r.borderLeftWidth }
              ], s = EY(Mc(r.backgroundClip, 0), t.curves), n || r.boxShadow.length ? (this.ctx.save(), this.path(s), this.ctx.clip(), No(r.backgroundColor) || (this.ctx.fillStyle = $r(r.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(t.container)]) : [3, 2];
            case 1:
              d.sent(), this.ctx.restore(), r.boxShadow.slice(0).reverse().forEach(function(h) {
                u.ctx.save();
                var p = Ng(t.curves), B = h.inset ? 0 : FY, y = fY(p, -B + (h.inset ? 1 : -1) * h.spread.number, (h.inset ? 1 : -1) * h.spread.number, h.spread.number * (h.inset ? -2 : 2), h.spread.number * (h.inset ? -2 : 2));
                h.inset ? (u.path(p), u.ctx.clip(), u.mask(y)) : (u.mask(p), u.ctx.clip(), u.path(y)), u.ctx.shadowOffsetX = h.offsetX.number + B, u.ctx.shadowOffsetY = h.offsetY.number, u.ctx.shadowColor = $r(h.color), u.ctx.shadowBlur = h.blur.number, u.ctx.fillStyle = h.inset ? $r(h.color) : "rgba(0,0,0,1)", u.ctx.fill(), u.ctx.restore();
              }), d.label = 2;
            case 2:
              a = 0, o = 0, l = i, d.label = 3;
            case 3:
              return o < l.length ? (c = l[o], c.style !== 0 && !No(c.color) && c.width > 0 ? c.style !== 2 ? [3, 5] : [4, this.renderDashedDottedBorder(
                c.color,
                c.width,
                a,
                t.curves,
                2
                /* DASHED */
              )] : [3, 11]) : [3, 13];
            case 4:
              return d.sent(), [3, 11];
            case 5:
              return c.style !== 3 ? [3, 7] : [4, this.renderDashedDottedBorder(
                c.color,
                c.width,
                a,
                t.curves,
                3
                /* DOTTED */
              )];
            case 6:
              return d.sent(), [3, 11];
            case 7:
              return c.style !== 4 ? [3, 9] : [4, this.renderDoubleBorder(c.color, c.width, a, t.curves)];
            case 8:
              return d.sent(), [3, 11];
            case 9:
              return [4, this.renderSolidBorder(c.color, a, t.curves)];
            case 10:
              d.sent(), d.label = 11;
            case 11:
              a++, d.label = 12;
            case 12:
              return o++, [3, 3];
            case 13:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderDashedDottedBorder = function(t, r, n, i, s) {
      return zn(this, void 0, void 0, function() {
        var a, o, l, c, u, d, h, p, B, y, m, C, Q, F, T, V, T, V;
        return Fn(this, function(M) {
          return this.ctx.save(), a = BY(i, n), o = B5(i, n), s === 2 && (this.path(o), this.ctx.clip()), Gi(o[0]) ? (l = o[0].start.x, c = o[0].start.y) : (l = o[0].x, c = o[0].y), Gi(o[1]) ? (u = o[1].end.x, d = o[1].end.y) : (u = o[1].x, d = o[1].y), n === 0 || n === 2 ? h = Math.abs(l - u) : h = Math.abs(c - d), this.ctx.beginPath(), s === 3 ? this.formatPath(a) : this.formatPath(o.slice(0, 2)), p = r < 3 ? r * 3 : r * 2, B = r < 3 ? r * 2 : r, s === 3 && (p = r, B = r), y = !0, h <= p * 2 ? y = !1 : h <= p * 2 + B ? (m = h / (2 * p + B), p *= m, B *= m) : (C = Math.floor((h + B) / (p + B)), Q = (h - C * p) / (C - 1), F = (h - (C + 1) * p) / C, B = F <= 0 || Math.abs(B - Q) < Math.abs(B - F) ? Q : F), y && (s === 3 ? this.ctx.setLineDash([0, p + B]) : this.ctx.setLineDash([p, B])), s === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = r) : this.ctx.lineWidth = r * 2 + 1.1, this.ctx.strokeStyle = $r(t), this.ctx.stroke(), this.ctx.setLineDash([]), s === 2 && (Gi(o[0]) && (T = o[3], V = o[0], this.ctx.beginPath(), this.formatPath([new ne(T.end.x, T.end.y), new ne(V.start.x, V.start.y)]), this.ctx.stroke()), Gi(o[1]) && (T = o[1], V = o[2], this.ctx.beginPath(), this.formatPath([new ne(T.end.x, T.end.y), new ne(V.start.x, V.start.y)]), this.ctx.stroke())), this.ctx.restore(), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.render = function(t) {
      return zn(this, void 0, void 0, function() {
        var r;
        return Fn(this, function(n) {
          switch (n.label) {
            case 0:
              return this.options.backgroundColor && (this.ctx.fillStyle = $r(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), r = dY(t), [4, this.renderStack(r)];
            case 1:
              return n.sent(), this.applyEffects([]), [2, this.canvas];
          }
        });
      });
    }, A;
  })(VL)
), UY = function(e) {
  return e instanceof UL || e instanceof QL ? !0 : e instanceof $y && e.type !== Tg && e.type !== Hg;
}, EY = function(e, A) {
  switch (e) {
    case 0:
      return Ng(A);
    case 2:
      return oY(A);
    default:
      return Dg(A);
  }
}, xY = function(e) {
  switch (e) {
    case 1:
      return "center";
    case 2:
      return "right";
    default:
      return "left";
  }
}, IY = ["-apple-system", "system-ui"], SY = function(e) {
  return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? e.filter(function(A) {
    return IY.indexOf(A) === -1;
  }) : e;
}, LY = (
  /** @class */
  (function(e) {
    Us(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.canvas = r.canvas ? r.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), n.options = r, n.canvas.width = Math.floor(r.width * r.scale), n.canvas.height = Math.floor(r.height * r.scale), n.canvas.style.width = r.width + "px", n.canvas.style.height = r.height + "px", n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-r.x, -r.y), n.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + r.width + "x" + r.height + " at " + r.x + "," + r.y + ") with scale " + r.scale), n;
    }
    return A.prototype.render = function(t) {
      return zn(this, void 0, void 0, function() {
        var r, n;
        return Fn(this, function(i) {
          switch (i.label) {
            case 0:
              return r = Kv(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, t), [4, HY(r)];
            case 1:
              return n = i.sent(), this.options.backgroundColor && (this.ctx.fillStyle = $r(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(n, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
          }
        });
      });
    }, A;
  })(VL)
), HY = function(e) {
  return new Promise(function(A, t) {
    var r = new Image();
    r.onload = function() {
      A(r);
    }, r.onerror = t, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(e));
  });
}, TY = (
  /** @class */
  (function() {
    function e(A) {
      var t = A.id, r = A.enabled;
      this.id = t, this.enabled = r, this.start = Date.now();
    }
    return e.prototype.debug = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug.apply(console, wd([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, e.prototype.getTime = function() {
      return Date.now() - this.start;
    }, e.prototype.info = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info.apply(console, wd([this.id, this.getTime() + "ms"], A));
    }, e.prototype.warn = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn.apply(console, wd([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, e.prototype.error = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error.apply(console, wd([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, e.instances = {}, e;
  })()
), _Y = (
  /** @class */
  (function() {
    function e(A, t) {
      var r;
      this.windowBounds = t, this.instanceName = "#" + e.instanceCount++, this.logger = new TY({ id: this.instanceName, enabled: A.logging }), this.cache = (r = A.cache) !== null && r !== void 0 ? r : new AY(this, A);
    }
    return e.instanceCount = 1, e;
  })()
), OY = function(e, A) {
  return A === void 0 && (A = {}), NY(e, A);
};
typeof window < "u" && DL.setContext(window);
var NY = function(e, A) {
  return zn(void 0, void 0, void 0, function() {
    var t, r, n, i, s, a, o, l, c, u, d, h, p, B, y, m, C, Q, F, T, M, V, M, D, I, q, U, x, P, N, iA, nA, sA, tA, cA, FA, CA, S, W, Y;
    return Fn(this, function(AA) {
      switch (AA.label) {
        case 0:
          if (!e || typeof e != "object")
            return [2, Promise.reject("Invalid element provided as first argument")];
          if (t = e.ownerDocument, !t)
            throw new Error("Element is not attached to a Document");
          if (r = t.defaultView, !r)
            throw new Error("Document is not attached to a Window");
          return n = {
            allowTaint: (D = A.allowTaint) !== null && D !== void 0 ? D : !1,
            imageTimeout: (I = A.imageTimeout) !== null && I !== void 0 ? I : 15e3,
            proxy: A.proxy,
            useCORS: (q = A.useCORS) !== null && q !== void 0 ? q : !1
          }, i = Ev({ logging: (U = A.logging) !== null && U !== void 0 ? U : !0, cache: A.cache }, n), s = {
            windowWidth: (x = A.windowWidth) !== null && x !== void 0 ? x : r.innerWidth,
            windowHeight: (P = A.windowHeight) !== null && P !== void 0 ? P : r.innerHeight,
            scrollX: (N = A.scrollX) !== null && N !== void 0 ? N : r.pageXOffset,
            scrollY: (iA = A.scrollY) !== null && iA !== void 0 ? iA : r.pageYOffset
          }, a = new Oa(s.scrollX, s.scrollY, s.windowWidth, s.windowHeight), o = new _Y(i, a), l = (nA = A.foreignObjectRendering) !== null && nA !== void 0 ? nA : !1, c = {
            allowTaint: (sA = A.allowTaint) !== null && sA !== void 0 ? sA : !1,
            onclone: A.onclone,
            ignoreElements: A.ignoreElements,
            inlineImages: l,
            copyStyles: l
          }, o.logger.debug("Starting document clone with size " + a.width + "x" + a.height + " scrolled to " + -a.left + "," + -a.top), u = new d5(o, e, c), d = u.clonedReferenceElement, d ? [4, u.toIFrame(t, a)] : [2, Promise.reject("Unable to find element in cloned iframe")];
        case 1:
          return h = AA.sent(), p = zy(d) || DX(d) ? fj(d.ownerDocument) : gp(o, d), B = p.width, y = p.height, m = p.left, C = p.top, Q = DY(o, d, A.backgroundColor), F = {
            canvas: A.canvas,
            backgroundColor: Q,
            scale: (cA = (tA = A.scale) !== null && tA !== void 0 ? tA : r.devicePixelRatio) !== null && cA !== void 0 ? cA : 1,
            x: ((FA = A.x) !== null && FA !== void 0 ? FA : 0) + m,
            y: ((CA = A.y) !== null && CA !== void 0 ? CA : 0) + C,
            width: (S = A.width) !== null && S !== void 0 ? S : Math.ceil(B),
            height: (W = A.height) !== null && W !== void 0 ? W : Math.ceil(y)
          }, l ? (o.logger.debug("Document cloned, using foreign object rendering"), M = new LY(o, F), [4, M.render(d)]) : [3, 3];
        case 2:
          return T = AA.sent(), [3, 5];
        case 3:
          return o.logger.debug("Document cloned, element located at " + m + "," + C + " with size " + B + "x" + y + " using computed rendering"), o.logger.debug("Starting DOM parsing"), V = IL(o, d), Q === V.styles.backgroundColor && (V.styles.backgroundColor = Ha.TRANSPARENT), o.logger.debug("Starting renderer for element at " + F.x + "," + F.y + " with size " + F.width + "x" + F.height), M = new QY(o, F), [4, M.render(V)];
        case 4:
          T = AA.sent(), AA.label = 5;
        case 5:
          return (!((Y = A.removeContainer) !== null && Y !== void 0) || Y) && (d5.destroy(h) || o.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore")), o.logger.debug("Finished rendering"), [2, T];
      }
    });
  });
}, DY = function(e, A, t) {
  var r = A.ownerDocument, n = r.documentElement ? bh(e, getComputedStyle(r.documentElement).backgroundColor) : Ha.TRANSPARENT, i = r.body ? bh(e, getComputedStyle(r.body).backgroundColor) : Ha.TRANSPARENT, s = typeof t == "string" ? bh(e, t) : t === null ? Ha.TRANSPARENT : 4294967295;
  return A === r.documentElement ? No(n) ? No(i) ? s : i : n : s;
};
const RY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: OY
}, Symbol.toStringTag, { value: "Module" }));
function m5(e, A) {
  (A == null || A > e.length) && (A = e.length);
  for (var t = 0, r = Array(A); t < A; t++) r[t] = e[t];
  return r;
}
function MY(e) {
  if (Array.isArray(e)) return e;
}
function PY(e, A) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r, n, i, s, a = [], o = !0, l = !1;
    try {
      if (i = (t = t.call(e)).next, A !== 0) for (; !(o = (r = i.call(t)).done) && (a.push(r.value), a.length !== A); o = !0) ;
    } catch (c) {
      l = !0, n = c;
    } finally {
      try {
        if (!o && t.return != null && (s = t.return(), Object(s) !== s)) return;
      } finally {
        if (l) throw n;
      }
    }
    return a;
  }
}
function kY() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function KY(e, A) {
  return MY(e) || PY(e, A) || VY(e, A) || kY();
}
function VY(e, A) {
  if (e) {
    if (typeof e == "string") return m5(e, A);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? m5(e, A) : void 0;
  }
}
const GL = Object.entries, v5 = Object.setPrototypeOf, GY = Object.isFrozen, WY = Object.getPrototypeOf, jY = Object.getOwnPropertyDescriptor;
let Kr = Object.freeze, Xr = Object.seal, Pc = Object.create, WL = typeof Reflect < "u" && Reflect, zv = WL.apply, Xv = WL.construct;
Kr || (Kr = function(A) {
  return A;
});
Xr || (Xr = function(A) {
  return A;
});
zv || (zv = function(A, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)
    n[i - 2] = arguments[i];
  return A.apply(t, n);
});
Xv || (Xv = function(A) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return new A(...r);
});
const ml = Lr(Array.prototype.forEach), qY = Lr(Array.prototype.lastIndexOf), y5 = Lr(Array.prototype.pop), Mu = Lr(Array.prototype.push), $Y = Lr(Array.prototype.splice), Xc = Array.isArray, ch = Lr(String.prototype.toLowerCase), _w = Lr(String.prototype.toString), C5 = Lr(String.prototype.match), Pu = Lr(String.prototype.replace), b5 = Lr(String.prototype.indexOf), zY = Lr(String.prototype.trim), XY = Lr(Number.prototype.toString), YY = Lr(Boolean.prototype.toString), F5 = typeof BigInt > "u" ? null : Lr(BigInt.prototype.toString), Q5 = typeof Symbol > "u" ? null : Lr(Symbol.prototype.toString), ii = Lr(Object.prototype.hasOwnProperty), ku = Lr(Object.prototype.toString), bn = Lr(RegExp.prototype.test), dl = JY(TypeError);
function Lr(e) {
  return function(A) {
    A instanceof RegExp && (A.lastIndex = 0);
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
      r[n - 1] = arguments[n];
    return zv(e, A, r);
  };
}
function JY(e) {
  return function() {
    for (var A = arguments.length, t = new Array(A), r = 0; r < A; r++)
      t[r] = arguments[r];
    return Xv(e, t);
  };
}
function rt(e, A) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ch;
  if (v5 && v5(e, null), !Xc(A))
    return e;
  let r = A.length;
  for (; r--; ) {
    let n = A[r];
    if (typeof n == "string") {
      const i = t(n);
      i !== n && (GY(A) || (A[r] = i), n = i);
    }
    e[n] = !0;
  }
  return e;
}
function ZY(e) {
  for (let A = 0; A < e.length; A++)
    ii(e, A) || (e[A] = null);
  return e;
}
function Qi(e) {
  const A = Pc(null);
  for (const r of GL(e)) {
    var t = KY(r, 2);
    const n = t[0], i = t[1];
    ii(e, n) && (Xc(i) ? A[n] = ZY(i) : i && typeof i == "object" && i.constructor === Object ? A[n] = Qi(i) : A[n] = i);
  }
  return A;
}
function AJ(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return XY(e);
    case "boolean":
      return YY(e);
    case "bigint":
      return F5 ? F5(e) : "0";
    case "symbol":
      return Q5 ? Q5(e) : "Symbol()";
    case "undefined":
      return ku(e);
    case "function":
    case "object": {
      if (e === null)
        return ku(e);
      const A = e, t = Ri(A, "toString");
      if (typeof t == "function") {
        const r = t(A);
        return typeof r == "string" ? r : ku(r);
      }
      return ku(e);
    }
    default:
      return ku(e);
  }
}
function Ri(e, A) {
  for (; e !== null; ) {
    const r = jY(e, A);
    if (r) {
      if (r.get)
        return Lr(r.get);
      if (typeof r.value == "function")
        return Lr(r.value);
    }
    e = WY(e);
  }
  function t() {
    return null;
  }
  return t;
}
function eJ(e) {
  try {
    return bn(e, ""), !0;
  } catch {
    return !1;
  }
}
const U5 = Kr(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Ow = Kr(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Nw = Kr(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), tJ = Kr(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Dw = Kr(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), rJ = Kr(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), E5 = Kr(["#text"]), x5 = Kr(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Rw = Kr(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dominant-baseline", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "pointer-events", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-orientation", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "vector-effect", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), I5 = Kr(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), kd = Kr(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), nJ = Xr(/{{[\w\W]*|^[\w\W]*}}/g), iJ = Xr(/<%[\w\W]*|^[\w\W]*%>/g), sJ = Xr(/\${[\w\W]*/g), aJ = Xr(/^data-[\-\w.\u00B7-\uFFFF]+$/), oJ = Xr(/^aria-[\-\w]+$/), S5 = Xr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), lJ = Xr(/^(?:\w+script|data):/i), cJ = Xr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), uJ = Xr(/^html$/i), hJ = Xr(/^[a-z][.\w]*(-[.\w]+)+$/i), L5 = Xr(/<[/\w!]/g), H5 = Xr(/<[/\w]/g), fJ = Xr(/<\/no(script|embed|frames)/i), dJ = Xr(/\/>/i), yi = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, jL = ["style", "script", "xmp", "iframe", "noembed", "noframes", "plaintext", "noscript"], gJ = Kr(rt({}, jL)), pJ = (function() {
  const e = {};
  return ml(jL, (A) => {
    e[A] = Xr(new RegExp("</" + A + "(?=[\\t\\n\\f\\r />])", "i"));
  }), Kr(e);
})(), BJ = function() {
  return typeof window > "u" ? null : window;
}, wJ = function(A, t) {
  if (typeof A != "object" || typeof A.createPolicy != "function")
    return null;
  let r = null;
  const n = "data-tt-policy-suffix";
  t && t.hasAttribute(n) && (r = t.getAttribute(n));
  const i = "dompurify" + (r ? "#" + r : "");
  try {
    return A.createPolicy(i, {
      createHTML(s) {
        return s;
      },
      createScriptURL(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
}, T5 = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, fo = function(A, t, r, n) {
  return ii(A, t) && Xc(A[t]) ? rt(n.base ? Qi(n.base) : {}, A[t], n.transform) : r;
}, Mw = function(A, t, r) {
  const n = ii(A, t) ? A[t] : void 0;
  return n && typeof n == "object" ? Qi(n) : r();
};
function qL() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : BJ();
  const A = (zA) => qL(zA);
  if (A.version = "3.4.15", A.removed = [], !e || !e.document || e.document.nodeType !== yi.document || !e.Element)
    return A.isSupported = !1, A;
  let t = e.document;
  const r = t, n = r.currentScript;
  e.DocumentFragment;
  const i = e.HTMLTemplateElement, s = e.Node, a = e.Element, o = e.NodeFilter, l = e.NamedNodeMap;
  l === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
  const c = e.DOMParser, u = e.trustedTypes, d = a.prototype, h = Ri(d, "cloneNode"), p = Ri(d, "remove"), B = Ri(d, "removeAttributeNode"), y = Ri(d, "nextSibling"), m = Ri(d, "childNodes"), C = Ri(d, "parentNode"), Q = Ri(d, "shadowRoot"), F = Ri(d, "attributes"), T = s && s.prototype ? Ri(s.prototype, "nodeType") : null, V = s && s.prototype ? Ri(s.prototype, "nodeName") : null, M = s && s.prototype ? Ri(s.prototype, "ownerDocument") : null, D = function($) {
    return T ? T($) : $.nodeType;
  }, I = function($) {
    return V ? V($) : $.nodeName;
  };
  if (typeof i == "function") {
    const zA = t.createElement("template");
    zA.content && zA.content.ownerDocument && (t = zA.content.ownerDocument);
  }
  let q, U = "", x, P = !1, N = 0;
  const iA = function() {
    if (N > 0)
      throw dl('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, nA = function($) {
    iA(), N++;
    try {
      return q.createHTML($);
    } finally {
      N--;
    }
  }, sA = function($) {
    iA(), N++;
    try {
      return q.createScriptURL($);
    } finally {
      N--;
    }
  }, tA = function() {
    return P || (x = wJ(u, n), P = !0), x;
  }, cA = t, FA = cA.implementation, CA = cA.createNodeIterator, S = cA.createDocumentFragment, W = cA.getElementsByTagName, Y = r.importNode;
  let AA = T5();
  A.isSupported = typeof GL == "function" && typeof C == "function" && FA && FA.createHTMLDocument !== void 0;
  const oA = nJ, gA = iJ, xA = sJ, IA = aJ, pA = oJ, WA = lJ, k = cJ, X = hJ;
  let uA = S5, E = null;
  const dA = rt({}, [...U5, ...Ow, ...Nw, ...Dw, ...E5]);
  let vA = null;
  const rA = rt({}, [...x5, ...Rw, ...I5, ...kd]);
  let fA = Object.seal(Pc(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), EA = null, lA = null;
  const HA = Object.seal(Pc(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let SA = !0, yA = !0, TA = !1, _A = !0, MA = !1, VA = !0, $A = !1, ee = !1, ZA = null, Fe = null, me = !1, Ce = !1, ae = !1, Te = !1, ie = !0, Ke = !1;
  const ge = "user-content-";
  let xe = !0, Ye = !1, ue = {}, pe = null;
  const ze = rt({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let Ii = null;
  const Jt = rt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Wr = null;
  const un = rt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Be = "http://www.w3.org/1998/Math/MathML", Jr = "http://www.w3.org/2000/svg", Zt = "http://www.w3.org/1999/xhtml";
  let Vt = Zt, Ar = !1, Bt = null;
  const er = rt({}, [Be, Jr, Zt], _w), Gt = Kr(["mi", "mo", "mn", "ms", "mtext"]);
  let ui = rt({}, Gt);
  const hi = Kr(["annotation-xml"]);
  let Hr = rt({}, hi);
  const jr = rt({}, ["title", "style", "font", "a", "script"]);
  let tr = null;
  const Tn = ["application/xhtml+xml", "text/html"], hn = "text/html";
  let je = null, Nt = null;
  const Si = t.createElement("form"), ts = function($) {
    return $ instanceof RegExp || $ instanceof Function;
  }, Li = function() {
    let $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Nt && Nt === $)
      return;
    (!$ || typeof $ != "object") && ($ = {}), $ = Qi($), tr = // eslint-disable-next-line unicorn/prefer-includes
    Tn.indexOf($.PARSER_MEDIA_TYPE) === -1 ? hn : $.PARSER_MEDIA_TYPE, je = tr === "application/xhtml+xml" ? _w : ch, E = fo($, "ALLOWED_TAGS", dA, {
      transform: je
    }), vA = fo($, "ALLOWED_ATTR", rA, {
      transform: je
    }), Bt = fo($, "ALLOWED_NAMESPACES", er, {
      transform: _w
    }), Wr = fo($, "ADD_URI_SAFE_ATTR", un, {
      transform: je,
      base: un
    }), Ii = fo($, "ADD_DATA_URI_TAGS", Jt, {
      transform: je,
      base: Jt
    }), pe = fo($, "FORBID_CONTENTS", ze, {
      transform: je
    }), EA = fo($, "FORBID_TAGS", Qi({}), {
      transform: je
    }), lA = fo($, "FORBID_ATTR", Qi({}), {
      transform: je
    }), ue = ii($, "USE_PROFILES") ? $.USE_PROFILES && typeof $.USE_PROFILES == "object" ? Qi($.USE_PROFILES) : $.USE_PROFILES : !1, SA = $.ALLOW_ARIA_ATTR !== !1, yA = $.ALLOW_DATA_ATTR !== !1, TA = $.ALLOW_UNKNOWN_PROTOCOLS || !1, _A = $.ALLOW_SELF_CLOSE_IN_ATTR !== !1, MA = $.SAFE_FOR_TEMPLATES || !1, VA = $.SAFE_FOR_XML !== !1, $A = $.WHOLE_DOCUMENT || !1, Ce = $.RETURN_DOM || !1, ae = $.RETURN_DOM_FRAGMENT || !1, Te = $.RETURN_TRUSTED_TYPE || !1, me = $.FORCE_BODY || !1, ie = $.SANITIZE_DOM !== !1, Ke = $.SANITIZE_NAMED_PROPS || !1, xe = $.KEEP_CONTENT !== !1, Ye = $.IN_PLACE || !1, uA = eJ($.ALLOWED_URI_REGEXP) ? $.ALLOWED_URI_REGEXP : S5, Vt = typeof $.NAMESPACE == "string" ? $.NAMESPACE : Zt, ui = Mw(
      $,
      "MATHML_TEXT_INTEGRATION_POINTS",
      () => rt({}, Gt)
      // Default built-in map
    ), Hr = Mw(
      $,
      "HTML_INTEGRATION_POINTS",
      () => rt({}, hi)
      // Default built-in map
    );
    const wA = Mw($, "CUSTOM_ELEMENT_HANDLING", () => Pc(null));
    if (fA = Pc(null), ii(wA, "tagNameCheck") && ts(wA.tagNameCheck) && (fA.tagNameCheck = wA.tagNameCheck), ii(wA, "attributeNameCheck") && ts(wA.attributeNameCheck) && (fA.attributeNameCheck = wA.attributeNameCheck), ii(wA, "allowCustomizedBuiltInElements") && typeof wA.allowCustomizedBuiltInElements == "boolean" && (fA.allowCustomizedBuiltInElements = wA.allowCustomizedBuiltInElements), Xr(fA), MA && (yA = !1), ae && (Ce = !0), ue && (E = rt({}, E5), vA = Pc(null), ue.html === !0 && (rt(E, U5), rt(vA, x5)), ue.svg === !0 && (rt(E, Ow), rt(vA, Rw), rt(vA, kd)), ue.svgFilters === !0 && (rt(E, Nw), rt(vA, Rw), rt(vA, kd)), ue.mathMl === !0 && (rt(E, Dw), rt(vA, I5), rt(vA, kd))), HA.tagCheck = null, HA.attributeCheck = null, ii($, "ADD_TAGS") && (typeof $.ADD_TAGS == "function" ? HA.tagCheck = $.ADD_TAGS : Xc($.ADD_TAGS) && (E === dA && (E = Qi(E)), rt(E, $.ADD_TAGS, je))), ii($, "ADD_ATTR") && (typeof $.ADD_ATTR == "function" ? HA.attributeCheck = $.ADD_ATTR : Xc($.ADD_ATTR) && (vA === rA && (vA = Qi(vA)), rt(vA, $.ADD_ATTR, je))), ii($, "ADD_FORBID_CONTENTS") && Xc($.ADD_FORBID_CONTENTS) && (pe === ze && (pe = Qi(pe)), rt(pe, $.ADD_FORBID_CONTENTS, je)), xe && (E["#text"] = !0), $A && rt(E, ["html", "head", "body"]), E.table && (rt(E, ["tbody"]), delete EA.tbody), $.TRUSTED_TYPES_POLICY) {
      if (typeof $.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw dl('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof $.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw dl('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const PA = q;
      q = $.TRUSTED_TYPES_POLICY;
      try {
        U = nA("");
      } catch (Ae) {
        throw q = PA, Ae;
      }
    } else $.TRUSTED_TYPES_POLICY === null ? (q = void 0, U = "") : (q === void 0 && (q = tA()), q && typeof U == "string" && (U = nA("")));
    Kr && Kr($), Nt = $;
  }, rs = rt({}, [...Ow, ...Nw, ...tJ]), Ma = rt({}, [...Dw, ...rJ]), ra = function($, wA, PA) {
    return wA.namespaceURI === Zt ? $ === "svg" : wA.namespaceURI === Be ? $ === "svg" && (PA === "annotation-xml" || ui[PA]) : !!rs[$];
  }, Pa = function($, wA, PA) {
    return wA.namespaceURI === Zt ? $ === "math" : wA.namespaceURI === Jr ? $ === "math" && Hr[PA] : !!Ma[$];
  }, ka = function($, wA, PA) {
    return wA.namespaceURI === Jr && !Hr[PA] || wA.namespaceURI === Be && !ui[PA] ? !1 : !Ma[$] && (jr[$] || !rs[$]);
  }, _n = function($) {
    let wA = C($);
    (!wA || !wA.tagName) && (wA = {
      namespaceURI: Vt,
      tagName: "template"
    });
    const PA = ch($.tagName), Ae = ch(wA.tagName);
    return Bt[$.namespaceURI] ? $.namespaceURI === Jr ? ra(PA, wA, Ae) : $.namespaceURI === Be ? Pa(PA, wA, Ae) : $.namespaceURI === Zt ? ka(PA, wA, Ae) : !!(tr === "application/xhtml+xml" && Bt[$.namespaceURI]) : !1;
  }, st = function($) {
    Mu(A.removed, {
      element: $
    });
    try {
      C($).removeChild($);
    } catch {
      if (p($), !C($))
        throw dl("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, ns = function($, wA, PA) {
    try {
      B($, wA);
    } catch {
      try {
        $.removeAttribute(PA);
      } catch {
      }
    }
  }, On = function($) {
    is($);
    const wA = m($);
    if (wA) {
      const Ae = [];
      ml(wA, (GA) => {
        Mu(Ae, GA);
      }), ml(Ae, (GA) => {
        try {
          p(GA);
        } catch {
        }
      });
    }
    const PA = F($);
    if (PA)
      for (let Ae = PA.length - 1; Ae >= 0; --Ae) {
        const GA = PA[Ae], Qe = GA && GA.name;
        typeof Qe == "string" && ns($, GA, Qe);
      }
  }, Ai = function($, wA, PA) {
    if (!PA)
      try {
        PA = wA.getAttributeNode($);
      } catch {
        PA = null;
      }
    Mu(A.removed, {
      attribute: PA || null,
      from: wA
    });
    try {
      PA ? B(wA, PA) : wA.removeAttribute($);
    } catch {
      try {
        wA.removeAttribute($);
      } catch {
      }
    }
    if ($ === "is")
      if (Ce || ae)
        try {
          st(wA);
        } catch {
        }
      else
        try {
          wA.setAttribute($, "");
        } catch {
        }
  }, Ka = function($) {
    const wA = F($);
    if (wA)
      for (let PA = wA.length - 1; PA >= 0; --PA) {
        const Ae = wA[PA], GA = Ae && Ae.name;
        typeof GA != "string" || vA[je(GA)] || ns($, Ae, GA);
      }
  }, is = function($) {
    const wA = [$];
    for (; wA.length > 0; ) {
      const PA = wA.pop();
      D(PA) === yi.element && Ka(PA);
      const GA = m(PA);
      if (GA)
        for (let Qe = GA.length - 1; Qe >= 0; --Qe)
          wA.push(GA[Qe]);
    }
  }, Zr = function($, wA) {
    return VA ? $ === "patchsrc" ? !0 : $ === "for" && wA !== "label" && wA !== "output" : !1;
  }, Ss = function($) {
    if (!VA)
      return;
    const wA = [$];
    for (; wA.length > 0; ) {
      const PA = wA.pop(), Ae = D(PA);
      if (Ae === yi.processingInstruction || Ae === yi.comment && bn(H5, PA.data)) {
        try {
          p(PA);
        } catch {
        }
        continue;
      }
      if (Ae === yi.element) {
        const Qe = PA, Je = je(I(PA));
        try {
          Qe.hasAttribute && Qe.hasAttribute("patchsrc") && Qe.removeAttribute("patchsrc"), Qe.hasAttribute && Qe.hasAttribute("for") && Zr("for", Je) && Qe.removeAttribute("for");
        } catch {
        }
      }
      const GA = m(PA);
      if (GA)
        for (let Qe = GA.length - 1; Qe >= 0; --Qe)
          wA.push(GA[Qe]);
    }
  }, Va = function($) {
    let wA = null, PA = null;
    if (me)
      $ = "<remove></remove>" + $;
    else {
      const Qe = C5($, /^[\r\n\t ]+/);
      PA = Qe && Qe[0];
    }
    tr === "application/xhtml+xml" && Vt === Zt && ($ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + $ + "</body></html>");
    const Ae = q ? nA($) : $;
    if (Vt === Zt)
      try {
        wA = new c().parseFromString(Ae, tr);
      } catch {
      }
    if (!wA || !wA.documentElement) {
      wA = FA.createDocument(Vt, "template", null);
      try {
        wA.documentElement.innerHTML = Ar ? U : Ae;
      } catch {
      }
    }
    const GA = wA.body || wA.documentElement;
    return $ && PA && GA.insertBefore(t.createTextNode(PA), GA.childNodes[0] || null), Vt === Zt ? W.call(wA, $A ? "html" : "body")[0] : $A ? wA.documentElement : GA;
  }, St = function($) {
    const wA = M ? M($) : $.ownerDocument;
    return CA.call(
      wA || $,
      $,
      // eslint-disable-next-line no-bitwise
      o.SHOW_ELEMENT | o.SHOW_COMMENT | o.SHOW_TEXT | o.SHOW_PROCESSING_INSTRUCTION | o.SHOW_CDATA_SECTION,
      null
    );
  }, ss = function($) {
    return $ = Pu($, oA, " "), $ = Pu($, gA, " "), $ = Pu($, xA, " "), $;
  }, qr = function($) {
    var wA;
    $.normalize();
    const PA = M ? M($) : $.ownerDocument, Ae = CA.call(
      PA || $,
      $,
      // eslint-disable-next-line no-bitwise
      o.SHOW_TEXT | o.SHOW_COMMENT | o.SHOW_CDATA_SECTION | o.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let GA = Ae.nextNode();
    for (; GA; )
      GA.data = ss(GA.data), GA = Ae.nextNode();
    const Qe = (wA = $.querySelectorAll) === null || wA === void 0 ? void 0 : wA.call($, "template");
    Qe && ml(Qe, (Je) => {
      Dn(Je.content) && qr(Je.content);
    });
  }, Nn = function($) {
    const wA = V ? V($) : null;
    return typeof wA != "string" || je(wA) !== "form" ? !1 : typeof $.nodeName != "string" || typeof $.textContent != "string" || typeof $.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    $.attributes !== F($) || typeof $.removeAttribute != "function" || // A form descendant named "removeAttributeNode" or "getAttributeNode"
    // shadows these Attr-node methods via [LegacyOverrideBuiltIns].
    // _removeAttribute() / _stripAttributeNode() reach for
    // element.removeAttributeNode(attr) first; when it is shadowed the call
    // throws and the name-based fallback element.removeAttribute(name)
    // ASCII-lowercases its lookup key in an HTML document, silently missing
    // a case-preserved event-handler attribute (e.g. an ONANIMATIONSTART
    // that reached the sanitizer through an XML/XHTML parse). Flag the form
    // so it is removed wholesale, exactly as for the other shadowed methods.
    typeof $.removeAttributeNode != "function" || typeof $.getAttributeNode != "function" || typeof $.setAttribute != "function" || typeof $.namespaceURI != "string" || typeof $.insertBefore != "function" || typeof $.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    $.nodeType !== T($) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    $.childNodes !== m($);
  }, Dn = function($) {
    if (!T || typeof $ != "object" || $ === null)
      return !1;
    try {
      return T($) === yi.documentFragment;
    } catch {
      return !1;
    }
  }, hr = function($) {
    if (!T || typeof $ != "object" || $ === null)
      return !1;
    try {
      return typeof T($) == "number";
    } catch {
      return !1;
    }
  };
  function Tr(zA, $, wA) {
    zA.length !== 0 && ml(zA, (PA) => {
      PA.call(A, $, wA, Nt);
    });
  }
  const Rn = function($, wA) {
    return !!(VA && $.hasChildNodes() && !hr($.firstElementChild) && bn(L5, $.textContent) && bn(L5, $.innerHTML) || VA && $.namespaceURI === Zt && gJ[wA] && (hr($.firstElementChild) || typeof $.textContent == "string" && bn(pJ[wA], $.textContent)) || $.nodeType === yi.processingInstruction || VA && $.nodeType === yi.comment && bn(H5, $.data));
  }, Lt = function($, wA) {
    if ($ instanceof RegExp)
      return bn($, wA);
    if ($ instanceof Function) {
      for (var PA = arguments.length, Ae = new Array(PA > 2 ? PA - 2 : 0), GA = 2; GA < PA; GA++)
        Ae[GA - 2] = arguments[GA];
      return !!$(wA, ...Ae);
    }
    return !1;
  }, Ga = function($, wA, PA) {
    if (!EA[wA] && fi(wA) && Lt(fA.tagNameCheck, wA))
      return !1;
    if (xe && !pe[wA]) {
      const Ae = C($), GA = m($);
      if (GA && Ae) {
        const Qe = GA.length;
        for (let Je = Qe - 1; Je >= 0; --Je) {
          const ot = $ === PA ? h(GA[Je], !0) : GA[Je];
          Ae.insertBefore(ot, y($));
        }
      }
    }
    return st($), !0;
  }, Wa = function($, wA, PA, Ae) {
    return $.length === 0 ? wA : wA === PA || wA === Ae ? Qi(wA) : wA;
  }, ja = function($, wA) {
    return $ === wA || C($) !== null ? !1 : (Ye && is($), !0);
  }, qa = function($, wA) {
    if (Tr(AA.beforeSanitizeElements, $, null), ja($, wA))
      return !0;
    if (Nn($))
      return st($), !0;
    const PA = je(I($));
    if (E = Wa(AA.uponSanitizeElement, E, dA, ZA), Tr(AA.uponSanitizeElement, $, {
      tagName: PA,
      allowedTags: E
    }), ja($, wA))
      return !0;
    if (Rn($, PA))
      return st($), !0;
    if (EA[PA] || !(HA.tagCheck instanceof Function && HA.tagCheck(PA)) && !E[PA]) {
      const GA = Ga($, PA, wA);
      return GA === !1 && Tr(AA.afterSanitizeElements, $, null), GA;
    }
    if (D($) === yi.element && !_n($) || (PA === "noscript" || PA === "noembed" || PA === "noframes") && bn(fJ, $.innerHTML))
      return st($), !0;
    if (MA && $.nodeType === yi.text) {
      const GA = ss($.textContent);
      $.textContent !== GA && (Mu(A.removed, {
        element: $.cloneNode()
      }), $.textContent = GA);
    }
    return Tr(AA.afterSanitizeElements, $, null), !1;
  }, Mn = function($, wA, PA) {
    if (lA[wA] || Zr(wA, $) || ie && (wA === "id" || wA === "name") && (PA in t || PA in Si))
      return !1;
    const Ae = vA[wA] || HA.attributeCheck instanceof Function && HA.attributeCheck(wA, $);
    return yA && bn(IA, wA) || SA && bn(pA, wA) ? !0 : Ae ? Wr[wA] || bn(uA, Pu(PA, k, "")) || (wA === "src" || wA === "xlink:href" || wA === "href") && $ !== "script" && b5(PA, "data:") === 0 && Ii[$] || TA && !bn(WA, Pu(PA, k, "")) ? !0 : !PA : (
      // Condition a) covers a basically valid custom element tag name whose
      // tag passes the configured tagNameCheck and whose attribute name
      // passes the configured attributeNameCheck ...
      fi($) && Lt(fA.tagNameCheck, $) && Lt(fA.attributeNameCheck, wA, $) || // Condition b) covers an `is` attribute whose value passes the
      // configured tagNameCheck while customized built-in elements are
      // allowed.
      wA === "is" && fA.allowCustomizedBuiltInElements && Lt(fA.tagNameCheck, PA)
    );
  }, Hi = rt({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), fi = function($) {
    return !Hi[ch($)] && bn(X, $);
  }, An = function($, wA, PA, Ae) {
    if (q && typeof u == "object" && typeof u.getAttributeType == "function" && !PA)
      switch (u.getAttributeType($, wA)) {
        case "TrustedHTML":
          return nA(Ae);
        case "TrustedScriptURL":
          return sA(Ae);
      }
    return Ae;
  }, fn = function($, wA, PA, Ae) {
    try {
      return PA ? $.setAttributeNS(PA, wA, Ae) : $.setAttribute(wA, Ae), Nn($) ? (st($), !1) : !0;
    } catch {
      return Ai(wA, $), !1;
    }
  }, _r = function($) {
    Tr(AA.beforeSanitizeAttributes, $, null);
    const wA = $.attributes;
    if (!wA || Nn($))
      return;
    vA = Wa(AA.uponSanitizeAttribute, vA, rA, Fe);
    const PA = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: vA,
      forceKeepAttr: void 0
    };
    let Ae = wA.length;
    const GA = je($.nodeName);
    for (; Ae--; ) {
      const Qe = wA[Ae], Je = Qe.name, ot = Qe.namespaceURI, rr = Qe.value, Fr = je(Je), kn = rr;
      let et = Je === "value" ? kn : zY(kn), Ls = !1;
      if (PA.attrName = Fr, PA.attrValue = et, PA.keepAttr = !0, PA.forceKeepAttr = void 0, Tr(AA.uponSanitizeAttribute, $, PA), et = PA.attrValue, Ke && (Fr === "id" || Fr === "name") && b5(et, ge) !== 0 && (Ai(Je, $, Qe), et = ge + et, Ls = !0), VA && bn(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, et)) {
        Ai(Je, $, Qe);
        continue;
      }
      if (Fr === "attributename" && C5(et, "href")) {
        Ai(Je, $, Qe);
        continue;
      }
      if (!PA.forceKeepAttr) {
        if (!PA.keepAttr) {
          Ai(Je, $, Qe);
          continue;
        }
        if (!_A && bn(dJ, et)) {
          Ai(Je, $, Qe);
          continue;
        }
        if (MA && (et = ss(et)), !Mn(GA, Fr, et)) {
          Ai(Je, $, Qe);
          continue;
        }
        et = An(GA, Fr, ot, et), et !== kn && fn($, Je, ot, et) && Ls && y5(A.removed);
      }
    }
    Tr(AA.afterSanitizeAttributes, $, null);
  }, dn = function($) {
    let wA = null;
    const PA = St($);
    for (Tr(AA.beforeSanitizeShadowDOM, $, null); wA = PA.nextNode(); )
      if (Tr(AA.uponSanitizeShadowNode, wA, null), qa(wA, $), _r(wA), Dn(wA.content) && dn(wA.content), D(wA) === yi.element) {
        const Ae = Q(wA);
        Dn(Ae) && (Pn(Ae), dn(Ae));
      }
    Tr(AA.afterSanitizeShadowDOM, $, null);
  }, Pn = function($) {
    const wA = [{
      node: $,
      shadow: null
    }];
    for (; wA.length > 0; ) {
      const PA = wA.pop();
      if (PA.shadow) {
        dn(PA.shadow);
        continue;
      }
      const Ae = PA.node, Qe = D(Ae) === yi.element, Je = m(Ae);
      if (Je)
        for (let ot = Je.length - 1; ot >= 0; --ot)
          wA.push({
            node: Je[ot],
            shadow: null
          });
      if (Qe) {
        const ot = V ? V(Ae) : null;
        if (typeof ot == "string" && je(ot) === "template") {
          const rr = Ae.content;
          Dn(rr) && wA.push({
            node: rr,
            shadow: null
          });
        }
      }
      if (Qe) {
        const ot = Q(Ae);
        Dn(ot) && wA.push({
          node: null,
          shadow: ot
        }, {
          node: ot,
          shadow: null
        });
      }
    }
  };
  return A.sanitize = function(zA) {
    let $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, wA = null, PA = null, Ae = null, GA = null;
    if (Ar = !zA, Ar && (zA = "<!-->"), typeof zA != "string" && !hr(zA) && (zA = AJ(zA), typeof zA != "string"))
      throw dl("dirty is not a string, aborting");
    if (!A.isSupported)
      return zA;
    ee ? (E = ZA, vA = Fe) : Li($), (AA.uponSanitizeElement.length > 0 || AA.uponSanitizeAttribute.length > 0) && (E = Qi(E)), AA.uponSanitizeAttribute.length > 0 && (vA = Qi(vA)), A.removed = [];
    const Qe = Ye && typeof zA != "string" && hr(zA);
    if (Qe) {
      Ss(zA);
      const rr = I(zA);
      if (typeof rr == "string") {
        const Fr = je(rr);
        if (!E[Fr] || EA[Fr])
          throw On(zA), dl("root node is forbidden and cannot be sanitized in-place");
      }
      if (Nn(zA))
        throw On(zA), dl("root node is clobbered and cannot be sanitized in-place");
      try {
        Pn(zA);
      } catch (Fr) {
        throw On(zA), Fr;
      }
    } else if (hr(zA))
      wA = Va("<!---->"), PA = wA.ownerDocument.importNode(zA, !0), PA.nodeType === yi.element && PA.nodeName === "BODY" || PA.nodeName === "HTML" ? wA = PA : wA.appendChild(PA), Pn(wA);
    else {
      if (!Ce && !MA && !$A && // eslint-disable-next-line unicorn/prefer-includes
      zA.indexOf("<") === -1)
        return q && Te ? nA(zA) : zA;
      if (wA = Va(zA), !wA)
        return Ce ? null : Te ? U : "";
    }
    wA && me && st(wA.firstChild);
    const Je = Qe ? zA : wA;
    try {
      const rr = St(Je);
      for (; Ae = rr.nextNode(); )
        qa(Ae, Je), _r(Ae), Dn(Ae.content) && dn(Ae.content);
    } catch (rr) {
      throw Qe && (On(zA), ml(A.removed, (Fr) => {
        Fr.element && is(Fr.element);
      })), rr;
    }
    if (Qe)
      return ml(A.removed, (rr) => {
        rr.element && is(rr.element);
      }), MA && qr(zA), zA;
    if (Ce) {
      if (MA && qr(wA), ae)
        for (GA = S.call(wA.ownerDocument); wA.firstChild; )
          GA.appendChild(wA.firstChild);
      else
        GA = wA;
      return (vA.shadowroot || vA.shadowrootmode) && (GA = Y.call(r, GA, !0)), GA;
    }
    let ot = $A ? wA.outerHTML : wA.innerHTML;
    return $A && E["!doctype"] && wA.ownerDocument && wA.ownerDocument.doctype && wA.ownerDocument.doctype.name && bn(uJ, wA.ownerDocument.doctype.name) && (ot = "<!DOCTYPE " + wA.ownerDocument.doctype.name + `>
` + ot), MA && (ot = ss(ot)), q && Te ? nA(ot) : ot;
  }, A.setConfig = function() {
    let zA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Li(zA), ee = !0, ZA = E, Fe = vA;
  }, A.clearConfig = function() {
    Nt = null, ee = !1, ZA = null, Fe = null, q = x, U = "";
  }, A.isValidAttribute = function(zA, $, wA) {
    Nt || Li({});
    const PA = je(zA), Ae = je($);
    return Mn(PA, Ae, wA);
  }, A.addHook = function(zA, $) {
    typeof $ == "function" && ii(AA, zA) && Mu(AA[zA], $);
  }, A.removeHook = function(zA, $) {
    if (ii(AA, zA)) {
      if ($ !== void 0) {
        const wA = qY(AA[zA], $);
        return wA === -1 ? void 0 : $Y(AA[zA], wA, 1)[0];
      }
      return y5(AA[zA]);
    }
  }, A.removeHooks = function(zA) {
    ii(AA, zA) && (AA[zA] = []);
  }, A.removeAllHooks = function() {
    AA = T5();
  }, A;
}
var mJ = qL();
const vJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mJ
}, Symbol.toStringTag, { value: "Module" }));
var Yv = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function $L(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var _5 = {}, O5 = {}, Ku, N5;
function Kt() {
  if (N5) return Ku;
  N5 = 1;
  var e = function(A) {
    return A && A.Math === Math && A;
  };
  return Ku = // eslint-disable-next-line es/no-global-this -- safe
  e(typeof globalThis == "object" && globalThis) || e(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  e(typeof self == "object" && self) || e(typeof Yv == "object" && Yv) || e(typeof Ku == "object" && Ku) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ (function() {
    return this;
  })() || Function("return this")(), Ku;
}
var Pw = {}, kw, D5;
function lr() {
  return D5 || (D5 = 1, kw = function(e) {
    try {
      return !!e();
    } catch {
      return !0;
    }
  }), kw;
}
var Kw, R5;
function Es() {
  if (R5) return Kw;
  R5 = 1;
  var e = lr();
  return Kw = !e(function() {
    return Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1] !== 7;
  }), Kw;
}
var Vw, M5;
function Qp() {
  if (M5) return Vw;
  M5 = 1;
  var e = lr();
  return Vw = !e(function() {
    var A = (function() {
    }).bind();
    return typeof A != "function" || A.hasOwnProperty("prototype");
  }), Vw;
}
var Gw, P5;
function cn() {
  if (P5) return Gw;
  P5 = 1;
  var e = Qp(), A = Function.prototype.call;
  return Gw = e ? A.bind(A) : function() {
    return A.apply(A, arguments);
  }, Gw;
}
var Ww = {}, k5;
function yJ() {
  if (k5) return Ww;
  k5 = 1;
  var e = {}.propertyIsEnumerable, A = Object.getOwnPropertyDescriptor, t = A && !e.call({ 1: 2 }, 1);
  return Ww.f = t ? function(n) {
    var i = A(this, n);
    return !!i && i.enumerable;
  } : e, Ww;
}
var jw, K5;
function Xy() {
  return K5 || (K5 = 1, jw = function(e, A) {
    return {
      enumerable: !(e & 1),
      configurable: !(e & 2),
      writable: !(e & 4),
      value: A
    };
  }), jw;
}
var qw, V5;
function cr() {
  if (V5) return qw;
  V5 = 1;
  var e = Qp(), A = Function.prototype, t = A.call, r = e && A.bind.bind(t, t);
  return qw = e ? r : function(n) {
    return function() {
      return t.apply(n, arguments);
    };
  }, qw;
}
var $w, G5;
function Go() {
  if (G5) return $w;
  G5 = 1;
  var e = cr(), A = e({}.toString), t = e("".slice);
  return $w = function(r) {
    return t(A(r), 8, -1);
  }, $w;
}
var zw, W5;
function zL() {
  if (W5) return zw;
  W5 = 1;
  var e = cr(), A = lr(), t = Go(), r = Object, n = e("".split);
  return zw = A(function() {
    return !r("z").propertyIsEnumerable(0);
  }) ? function(i) {
    return t(i) === "String" ? n(i, "") : r(i);
  } : r, zw;
}
var Xw, j5;
function Up() {
  return j5 || (j5 = 1, Xw = function(e) {
    return e == null;
  }), Xw;
}
var Yw, q5;
function xs() {
  if (q5) return Yw;
  q5 = 1;
  var e = Up(), A = TypeError;
  return Yw = function(t) {
    if (e(t)) throw new A("Can't call method on " + t);
    return t;
  }, Yw;
}
var Jw, $5;
function ef() {
  if ($5) return Jw;
  $5 = 1;
  var e = zL(), A = xs();
  return Jw = function(t) {
    return e(A(t));
  }, Jw;
}
var Zw, z5;
function ur() {
  if (z5) return Zw;
  z5 = 1;
  var e = typeof document == "object" && document.all;
  return Zw = typeof e > "u" && e !== void 0 ? function(A) {
    return typeof A == "function" || A === e;
  } : function(A) {
    return typeof A == "function";
  }, Zw;
}
var A0, X5;
function ci() {
  if (X5) return A0;
  X5 = 1;
  var e = ur();
  return A0 = function(A) {
    return typeof A == "object" ? A !== null : e(A);
  }, A0;
}
var e0, Y5;
function nc() {
  if (Y5) return e0;
  Y5 = 1;
  var e = Kt(), A = ur(), t = function(r) {
    return A(r) ? r : void 0;
  };
  return e0 = function(r, n) {
    return arguments.length < 2 ? t(e[r]) : e[r] && e[r][n];
  }, e0;
}
var t0, J5;
function Ep() {
  if (J5) return t0;
  J5 = 1;
  var e = cr();
  return t0 = e({}.isPrototypeOf), t0;
}
var r0, Z5;
function tf() {
  if (Z5) return r0;
  Z5 = 1;
  var e = Kt(), A = e.navigator, t = A && A.userAgent;
  return r0 = t ? String(t) : "", r0;
}
var n0, AU;
function Yy() {
  if (AU) return n0;
  AU = 1;
  var e = Kt(), A = tf(), t = e.process, r = e.Deno, n = t && t.versions || r && r.version, i = n && n.v8, s, a;
  return i && (s = i.split("."), a = s[0] > 0 && s[0] < 4 ? 1 : +(s[0] + s[1])), !a && A && (s = A.match(/Edge\/(\d+)/), (!s || s[1] >= 74) && (s = A.match(/Chrome\/(\d+)/), s && (a = +s[1]))), n0 = a, n0;
}
var i0, eU;
function XL() {
  if (eU) return i0;
  eU = 1;
  var e = Yy(), A = lr(), t = Kt(), r = t.String;
  return i0 = !!Object.getOwnPropertySymbols && !A(function() {
    var n = /* @__PURE__ */ Symbol("symbol detection");
    return !r(n) || !(Object(n) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && e && e < 41;
  }), i0;
}
var s0, tU;
function YL() {
  if (tU) return s0;
  tU = 1;
  var e = XL();
  return s0 = e && !Symbol.sham && typeof Symbol.iterator == "symbol", s0;
}
var a0, rU;
function JL() {
  if (rU) return a0;
  rU = 1;
  var e = nc(), A = ur(), t = Ep(), r = YL(), n = Object;
  return a0 = r ? function(i) {
    return typeof i == "symbol";
  } : function(i) {
    var s = e("Symbol");
    return A(s) && t(s.prototype, n(i));
  }, a0;
}
var o0, nU;
function xp() {
  if (nU) return o0;
  nU = 1;
  var e = String;
  return o0 = function(A) {
    try {
      return e(A);
    } catch {
      return "Object";
    }
  }, o0;
}
var l0, iU;
function Wo() {
  if (iU) return l0;
  iU = 1;
  var e = ur(), A = xp(), t = TypeError;
  return l0 = function(r) {
    if (e(r)) return r;
    throw new t(A(r) + " is not a function");
  }, l0;
}
var c0, sU;
function iu() {
  if (sU) return c0;
  sU = 1;
  var e = Wo(), A = Up();
  return c0 = function(t, r) {
    var n = t[r];
    return A(n) ? void 0 : e(n);
  }, c0;
}
var u0, aU;
function CJ() {
  if (aU) return u0;
  aU = 1;
  var e = cn(), A = ur(), t = ci(), r = TypeError;
  return u0 = function(n, i) {
    var s, a;
    if (i === "string" && A(s = n.toString) && !t(a = e(s, n)) || A(s = n.valueOf) && !t(a = e(s, n)) || i !== "string" && A(s = n.toString) && !t(a = e(s, n))) return a;
    throw new r("Can't convert object to primitive value");
  }, u0;
}
var h0 = { exports: {} }, f0, oU;
function ea() {
  return oU || (oU = 1, f0 = !1), f0;
}
var d0, lU;
function Jy() {
  if (lU) return d0;
  lU = 1;
  var e = Kt(), A = Object.defineProperty;
  return d0 = function(t, r) {
    try {
      A(e, t, { value: r, configurable: !0, writable: !0 });
    } catch {
      e[t] = r;
    }
    return r;
  }, d0;
}
var cU;
function Zy() {
  if (cU) return h0.exports;
  cU = 1;
  var e = ea(), A = Kt(), t = Jy(), r = "__core-js_shared__", n = h0.exports = A[r] || t(r, {});
  return (n.versions || (n.versions = [])).push({
    version: "3.50.0",
    mode: e ? "pure" : "global",
    copyright: "© 2013–2025 Denis Pushkarev (zloirock.ru), 2025–2026 CoreJS Company (core-js.io). All rights reserved.",
    license: "https://github.com/zloirock/core-js/blob/v3.50.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
  }), h0.exports;
}
var g0, uU;
function A2() {
  if (uU) return g0;
  uU = 1;
  var e = Zy(), A = Object.create || Object;
  return g0 = function(t, r) {
    return e[t] || (e[t] = r || A(null));
  }, g0;
}
var p0, hU;
function Ip() {
  if (hU) return p0;
  hU = 1;
  var e = xs(), A = Object;
  return p0 = function(t) {
    return A(e(t));
  }, p0;
}
var B0, fU;
function Is() {
  if (fU) return B0;
  fU = 1;
  var e = cr(), A = Ip(), t = e({}.hasOwnProperty);
  return B0 = Object.hasOwn || function(n, i) {
    return t(A(n), i);
  }, B0;
}
var w0, dU;
function ZL() {
  if (dU) return w0;
  dU = 1;
  var e = cr(), A = 0, t = Math.random(), r = e(1.1.toString);
  return w0 = function(n) {
    return "Symbol(" + (n === void 0 ? "" : n) + ")_" + r(++A + t, 36);
  }, w0;
}
var m0, gU;
function Yr() {
  if (gU) return m0;
  gU = 1;
  var e = Kt(), A = A2(), t = Is(), r = ZL(), n = XL(), i = YL(), s = e.Symbol, a = A("wks"), o = i ? s.for || s : s && s.withoutSetter || r;
  return m0 = function(l) {
    return t(a, l) || (a[l] = n && t(s, l) ? s[l] : o("Symbol." + l)), a[l];
  }, m0;
}
var v0, pU;
function bJ() {
  if (pU) return v0;
  pU = 1;
  var e = cn(), A = ci(), t = JL(), r = iu(), n = CJ(), i = Yr(), s = TypeError, a = i("toPrimitive");
  return v0 = function(o, l) {
    if (!A(o) || t(o)) return o;
    var c = r(o, a), u;
    if (c) {
      if (l === void 0 && (l = "default"), u = e(c, o, l), !A(u) || t(u)) return u;
      throw new s("Can't convert object to primitive value");
    }
    return l === void 0 && (l = "number"), n(o, l);
  }, v0;
}
var y0, BU;
function AH() {
  if (BU) return y0;
  BU = 1;
  var e = bJ(), A = JL();
  return y0 = function(t) {
    var r = e(t, "string");
    return A(r) ? r : r + "";
  }, y0;
}
var C0, wU;
function Sp() {
  if (wU) return C0;
  wU = 1;
  var e = Kt(), A = ci(), t = e.document, r = A(t) && A(t.createElement);
  return C0 = function(n) {
    return r ? t.createElement(n) : {};
  }, C0;
}
var b0, mU;
function eH() {
  if (mU) return b0;
  mU = 1;
  var e = Es(), A = lr(), t = Sp();
  return b0 = !e && !A(function() {
    return Object.defineProperty(t("div"), "a", {
      get: function() {
        return 7;
      }
    }).a !== 7;
  }), b0;
}
var vU;
function Lp() {
  if (vU) return Pw;
  vU = 1;
  var e = Es(), A = cn(), t = yJ(), r = Xy(), n = ef(), i = AH(), s = Is(), a = eH(), o = Object.getOwnPropertyDescriptor;
  return Pw.f = e ? o : function(c, u) {
    if (c = n(c), u = i(u), a) try {
      return o(c, u);
    } catch {
    }
    if (s(c, u)) return r(!A(t.f, c, u), c[u]);
  }, Pw;
}
var F0 = {}, Q0, yU;
function tH() {
  if (yU) return Q0;
  yU = 1;
  var e = Es(), A = lr();
  return Q0 = e && A(function() {
    return Object.defineProperty(function() {
    }, "prototype", {
      value: 42,
      writable: !1
    }).prototype !== 42;
  }), Q0;
}
var U0, CU;
function Jn() {
  if (CU) return U0;
  CU = 1;
  var e = ci(), A = String, t = TypeError;
  return U0 = function(r) {
    if (e(r)) return r;
    throw new t(A(r) + " is not an object");
  }, U0;
}
var bU;
function jo() {
  if (bU) return F0;
  bU = 1;
  var e = Es(), A = eH(), t = tH(), r = Jn(), n = AH(), i = TypeError, s = Object.defineProperty, a = Object.getOwnPropertyDescriptor, o = "enumerable", l = "configurable", c = "writable";
  return F0.f = e ? t ? function(d, h, p) {
    if (r(d), h = n(h), r(p), typeof d == "function" && h === "prototype" && "value" in p && c in p && !p[c]) {
      var B = a(d, h);
      B && B[c] && (d[h] = p.value, p = {
        configurable: l in p ? p[l] : B[l],
        enumerable: o in p ? p[o] : B[o],
        writable: !1
      });
    }
    return s(d, h, p);
  } : s : function(d, h, p) {
    if (r(d), h = n(h), r(p), A) try {
      return s(d, h, p);
    } catch {
    }
    if ("get" in p || "set" in p) throw new i("Accessors not supported");
    return "value" in p && (d[h] = p.value), d;
  }, F0;
}
var E0, FU;
function rf() {
  if (FU) return E0;
  FU = 1;
  var e = Es(), A = jo(), t = Xy();
  return E0 = e ? function(r, n, i) {
    return A.f(r, n, t(1, i));
  } : function(r, n, i) {
    return r[n] = i, r;
  }, E0;
}
var x0 = { exports: {} }, I0, QU;
function Hp() {
  if (QU) return I0;
  QU = 1;
  var e = Es(), A = Is(), t = Function.prototype, r = e && Object.getOwnPropertyDescriptor, n = A(t, "name"), i = n && (function() {
  }).name === "something", s = n && (!e || e && r(t, "name").configurable);
  return I0 = {
    EXISTS: n,
    PROPER: i,
    CONFIGURABLE: s
  }, I0;
}
var S0, UU;
function e2() {
  if (UU) return S0;
  UU = 1;
  var e = cr(), A = ur(), t = Zy(), r = e(Function.toString);
  return A(t.inspectSource) || (t.inspectSource = function(n) {
    return r(n);
  }), S0 = t.inspectSource, S0;
}
var L0, EU;
function FJ() {
  if (EU) return L0;
  EU = 1;
  var e = Kt(), A = ur(), t = e.WeakMap;
  return L0 = A(t) && /native code/.test(String(t)), L0;
}
var H0, xU;
function t2() {
  if (xU) return H0;
  xU = 1;
  var e = A2(), A = ZL(), t = e("keys");
  return H0 = function(r) {
    return t[r] || (t[r] = A(r));
  }, H0;
}
var T0, IU;
function r2() {
  return IU || (IU = 1, T0 = {}), T0;
}
var _0, SU;
function Tp() {
  if (SU) return _0;
  SU = 1;
  var e = FJ(), A = Kt(), t = ci(), r = rf(), n = Is(), i = Zy(), s = t2(), a = r2(), o = "Object already initialized", l = A.TypeError, c = A.WeakMap, u, d, h, p = function(C) {
    return h(C) ? d(C) : u(C, {});
  }, B = function(C) {
    return function(Q) {
      var F;
      if (!t(Q) || (F = d(Q)).type !== C)
        throw new l("Incompatible receiver, " + C + " required");
      return F;
    };
  };
  if (e || i.state) {
    var y = i.state || (i.state = new c());
    y.get = y.get, y.has = y.has, y.set = y.set, u = function(C, Q) {
      if (y.has(C)) throw new l(o);
      return Q.facade = C, y.set(C, Q), Q;
    }, d = function(C) {
      return y.get(C) || {};
    }, h = function(C) {
      return y.has(C);
    };
  } else {
    var m = s("state");
    a[m] = !0, u = function(C, Q) {
      if (n(C, m)) throw new l(o);
      return Q.facade = C, r(C, m, Q), Q;
    }, d = function(C) {
      return n(C, m) ? C[m] : {};
    }, h = function(C) {
      return n(C, m);
    };
  }
  return _0 = {
    set: u,
    get: d,
    has: h,
    enforce: p,
    getterFor: B
  }, _0;
}
var LU;
function rH() {
  if (LU) return x0.exports;
  LU = 1;
  var e = cr(), A = lr(), t = ur(), r = Is(), n = Es(), i = Hp().CONFIGURABLE, s = e2(), a = Tp(), o = a.enforce, l = a.get, c = String, u = Object.defineProperty, d = e("".slice), h = e("".replace), p = e([].join), B = n && !A(function() {
    return u(function() {
    }, "length", { value: 8 }).length !== 8;
  }), y = String(String).split("String"), m = x0.exports = function(C, Q, F) {
    d(c(Q), 0, 7) === "Symbol(" && (Q = "[" + h(c(Q), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), F && F.getter && (Q = "get " + Q), F && F.setter && (Q = "set " + Q), (!r(C, "name") || i && C.name !== Q) && (n ? u(C, "name", { value: Q, configurable: !0 }) : C.name = Q), B && F && r(F, "arity") && C.length !== F.arity && u(C, "length", { value: F.arity });
    try {
      F && r(F, "constructor") && F.constructor ? n && u(C, "prototype", { writable: !1 }) : C.prototype && (C.prototype = void 0);
    } catch {
    }
    var T = o(C);
    return r(T, "source") || (T.source = p(y, typeof Q == "string" ? Q : "")), C;
  };
  return Function.prototype.toString = m(function() {
    return t(this) && l(this).source || s(this);
  }, "toString"), x0.exports;
}
var O0, HU;
function ic() {
  if (HU) return O0;
  HU = 1;
  var e = ur(), A = jo(), t = rH(), r = Jy();
  return O0 = function(n, i, s, a) {
    a || (a = {});
    var o = a.enumerable, l = a.name !== void 0 ? a.name : i;
    if (e(s) && t(s, l, a), a.global)
      o ? n[i] = s : r(i, s);
    else {
      try {
        a.unsafe ? n[i] && (o = !0) : delete n[i];
      } catch {
      }
      o ? n[i] = s : A.f(n, i, {
        value: s,
        enumerable: !1,
        configurable: !a.nonConfigurable,
        writable: !a.nonWritable
      });
    }
    return n;
  }, O0;
}
var N0 = {}, D0, TU;
function QJ() {
  if (TU) return D0;
  TU = 1;
  var e = Math.ceil, A = Math.floor;
  return D0 = Math.trunc || function(r) {
    var n = +r;
    return (n > 0 ? A : e)(n);
  }, D0;
}
var R0, _U;
function _p() {
  if (_U) return R0;
  _U = 1;
  var e = QJ();
  return R0 = function(A) {
    var t = +A;
    return t !== t || t === 0 ? 0 : e(t);
  }, R0;
}
var M0, OU;
function UJ() {
  if (OU) return M0;
  OU = 1;
  var e = _p(), A = Math.max, t = Math.min;
  return M0 = function(r, n) {
    var i = e(r);
    return i < 0 ? A(i + n, 0) : t(i, n);
  }, M0;
}
var P0, NU;
function su() {
  if (NU) return P0;
  NU = 1;
  var e = _p(), A = Math.min;
  return P0 = function(t) {
    var r = e(t);
    return r > 0 ? A(r, 9007199254740991) : 0;
  }, P0;
}
var k0, DU;
function n2() {
  if (DU) return k0;
  DU = 1;
  var e = su();
  return k0 = function(A) {
    return e(A.length);
  }, k0;
}
var K0, RU;
function nH() {
  if (RU) return K0;
  RU = 1;
  var e = ef(), A = UJ(), t = n2(), r = function(n) {
    return function(i, s, a) {
      var o = e(i), l = t(o);
      if (l === 0) return !n && -1;
      var c = A(a, l), u;
      if (n && s !== s) {
        for (; l > c; )
          if (u = o[c++], u !== u) return !0;
      } else for (; l > c; c++)
        if ((n || c in o) && o[c] === s) return n || c || 0;
      return !n && -1;
    };
  };
  return K0 = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: r(!0),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: r(!1)
  }, K0;
}
var V0, MU;
function iH() {
  if (MU) return V0;
  MU = 1;
  var e = cr(), A = Is(), t = ef(), r = nH().indexOf, n = r2(), i = e([].push);
  return V0 = function(s, a) {
    var o = t(s), l = 0, c = [], u;
    for (u in o) !A(n, u) && A(o, u) && i(c, u);
    for (; a.length > l; ) A(o, u = a[l++]) && (~r(c, u) || i(c, u));
    return c;
  }, V0;
}
var G0, PU;
function i2() {
  return PU || (PU = 1, G0 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
  ]), G0;
}
var kU;
function EJ() {
  if (kU) return N0;
  kU = 1;
  var e = iH(), A = i2(), t = A.concat("length", "prototype");
  return N0.f = Object.getOwnPropertyNames || function(n) {
    return e(n, t);
  }, N0;
}
var W0 = {}, KU;
function xJ() {
  return KU || (KU = 1, W0.f = Object.getOwnPropertySymbols), W0;
}
var j0, VU;
function IJ() {
  if (VU) return j0;
  VU = 1;
  var e = nc(), A = cr(), t = EJ(), r = xJ(), n = Jn(), i = A([].concat);
  return j0 = e("Reflect", "ownKeys") || function(a) {
    var o = t.f(n(a)), l = r.f;
    return l ? i(o, l(a)) : o;
  }, j0;
}
var q0, GU;
function SJ() {
  if (GU) return q0;
  GU = 1;
  var e = Is(), A = IJ(), t = Lp(), r = jo();
  return q0 = function(n, i, s) {
    for (var a = A(i), o = r.f, l = t.f, c = 0; c < a.length; c++) {
      var u = a[c];
      !e(n, u) && !(s && e(s, u)) && o(n, u, l(i, u));
    }
  }, q0;
}
var $0, WU;
function sH() {
  if (WU) return $0;
  WU = 1;
  var e = lr(), A = ur(), t = /#|\.prototype\./, r = function(o, l) {
    var c = i[n(o)];
    return c === a ? !0 : c === s ? !1 : A(l) ? e(l) : !!l;
  }, n = r.normalize = function(o) {
    return String(o).replace(t, ".").toLowerCase();
  }, i = r.data = {}, s = r.NATIVE = "N", a = r.POLYFILL = "P";
  return $0 = r, $0;
}
var z0, jU;
function Zn() {
  if (jU) return z0;
  jU = 1;
  var e = Kt(), A = Lp().f, t = rf(), r = ic(), n = Jy(), i = SJ(), s = sH();
  return z0 = function(a, o) {
    var l = a.target, c = a.global, u = a.stat, d, h, p, B, y, m;
    if (c ? h = e : u ? h = e[l] || n(l, {}) : h = e[l] && e[l].prototype, h) for (p in o) {
      if (y = o[p], a.dontCallGetSet ? (m = A(h, p), B = m && m.value) : B = h[p], d = s(c ? p : l + (u ? "." : "#") + p, a.forced), !d && B !== void 0) {
        if (typeof y == typeof B) continue;
        i(y, B);
      }
      (a.sham || B && B.sham) && t(y, "sham", !0), r(h, p, y, a);
    }
  }, z0;
}
var X0, qU;
function aH() {
  if (qU) return X0;
  qU = 1;
  var e = Kt(), A = tf(), t = Go(), r = function(n) {
    return A.slice(0, n.length) === n;
  };
  return X0 = (function() {
    return r("Bun/") ? "BUN" : r("Cloudflare-Workers") ? "CLOUDFLARE" : r("Deno/") ? "DENO" : r("Node.js/") ? "NODE" : e.Bun && typeof Bun.version == "string" ? "BUN" : e.Deno && typeof Deno.version == "object" ? "DENO" : t(e.process) === "process" ? "NODE" : e.window && e.document ? "BROWSER" : "REST";
  })(), X0;
}
var Y0, $U;
function Op() {
  if ($U) return Y0;
  $U = 1;
  var e = aH();
  return Y0 = e === "NODE", Y0;
}
var J0, zU;
function LJ() {
  if (zU) return J0;
  zU = 1;
  var e = Kt();
  return J0 = e, J0;
}
var Z0, XU;
function HJ() {
  if (XU) return Z0;
  XU = 1;
  var e = cr(), A = Wo();
  return Z0 = function(t, r, n) {
    try {
      return e(A(Object.getOwnPropertyDescriptor(t, r)[n]));
    } catch {
    }
  }, Z0;
}
var Am, YU;
function TJ() {
  if (YU) return Am;
  YU = 1;
  var e = ci();
  return Am = function(A) {
    return e(A) || A === null;
  }, Am;
}
var em, JU;
function _J() {
  if (JU) return em;
  JU = 1;
  var e = TJ(), A = String, t = TypeError;
  return em = function(r) {
    if (e(r)) return r;
    throw new t("Can't set " + A(r) + " as a prototype");
  }, em;
}
var tm, ZU;
function oH() {
  if (ZU) return tm;
  ZU = 1;
  var e = HJ(), A = ci(), t = xs(), r = _J();
  return tm = Object.setPrototypeOf || ("__proto__" in {} ? (function() {
    var n = !1, i = {}, s;
    try {
      s = e(Object.prototype, "__proto__", "set"), s(i, []), n = i instanceof Array;
    } catch {
    }
    return function(o, l) {
      return t(o), r(l), A(o) && (n ? s(o, l) : o.__proto__ = l), o;
    };
  })() : void 0), tm;
}
var rm, AE;
function Np() {
  if (AE) return rm;
  AE = 1;
  var e = jo().f, A = Is(), t = Yr(), r = t("toStringTag");
  return rm = function(n, i, s) {
    n && !s && (n = n.prototype), n && !A(n, r) && e(n, r, { configurable: !0, value: i });
  }, rm;
}
var nm, eE;
function OJ() {
  if (eE) return nm;
  eE = 1;
  var e = rH(), A = jo();
  return nm = function(t, r, n) {
    return n.get && e(n.get, r, { getter: !0 }), n.set && e(n.set, r, { setter: !0 }), A.f(t, r, n);
  }, nm;
}
var im, tE;
function NJ() {
  if (tE) return im;
  tE = 1;
  var e = nc(), A = OJ(), t = Yr(), r = Es(), n = t("species");
  return im = function(i) {
    var s = e(i);
    r && s && !s[n] && A(s, n, {
      configurable: !0,
      get: function() {
        return this;
      }
    });
  }, im;
}
var sm, rE;
function DJ() {
  if (rE) return sm;
  rE = 1;
  var e = Ep(), A = TypeError;
  return sm = function(t, r) {
    if (e(r, t)) return t;
    throw new A("Incorrect invocation");
  }, sm;
}
var am, nE;
function RJ() {
  if (nE) return am;
  nE = 1;
  var e = Yr(), A = e("toStringTag"), t = {};
  return t[A] = "z", am = String(t) === "[object z]", am;
}
var om, iE;
function lH() {
  if (iE) return om;
  iE = 1;
  var e = RJ(), A = ur(), t = Go(), r = Yr(), n = r("toStringTag"), i = Object, s = t(/* @__PURE__ */ (function() {
    return arguments;
  })()) === "Arguments", a = function(o, l) {
    try {
      return o[l];
    } catch {
    }
  };
  return om = e ? t : function(o) {
    var l, c, u;
    return o === void 0 ? "Undefined" : o === null ? "Null" : typeof (c = a(l = i(o), n)) == "string" ? c : s ? t(l) : (u = t(l)) === "Object" && A(l.callee) ? "Arguments" : u;
  }, om;
}
var lm, sE;
function MJ() {
  if (sE) return lm;
  sE = 1;
  var e = cr(), A = lr(), t = ur(), r = lH(), n = nc(), i = e2(), s = function() {
  }, a = n("Reflect", "construct"), o = /^\s*(?:class|function)\b/, l = e(o.exec), c = !o.test(s), u = function(p) {
    if (!t(p)) return !1;
    try {
      return a(s, [], p), !0;
    } catch {
      return !1;
    }
  }, d = function(p) {
    if (!t(p)) return !1;
    switch (r(p)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }
    try {
      return c || !!l(o, i(p));
    } catch {
      return !0;
    }
  };
  return d.sham = !0, lm = !a || A(function() {
    var h;
    return u(u.call) || !u(Object) || !u(function() {
      h = !0;
    }) || h;
  }) ? d : u, lm;
}
var cm, aE;
function PJ() {
  if (aE) return cm;
  aE = 1;
  var e = MJ(), A = xp(), t = TypeError;
  return cm = function(r) {
    if (e(r)) return r;
    throw new t(A(r) + " is not a constructor");
  }, cm;
}
var um, oE;
function cH() {
  if (oE) return um;
  oE = 1;
  var e = Jn(), A = PJ(), t = Up(), r = Yr(), n = r("species");
  return um = function(i, s) {
    var a = e(i).constructor, o;
    return a === void 0 || t(o = e(a)[n]) ? s : A(o);
  }, um;
}
var hm, lE;
function uH() {
  if (lE) return hm;
  lE = 1;
  var e = Qp(), A = Function.prototype, t = A.apply, r = A.call;
  return hm = typeof Reflect == "object" && Reflect.apply || (e ? r.bind(t) : function() {
    return r.apply(t, arguments);
  }), hm;
}
var fm, cE;
function Dp() {
  if (cE) return fm;
  cE = 1;
  var e = Go(), A = cr();
  return fm = function(t) {
    if (e(t) === "Function") return A(t);
  }, fm;
}
var dm, uE;
function s2() {
  if (uE) return dm;
  uE = 1;
  var e = Dp(), A = Wo(), t = Qp(), r = e(e.bind);
  return dm = function(n, i) {
    return A(n), i === void 0 ? n : t ? r(n, i) : function() {
      return n.apply(i, arguments);
    };
  }, dm;
}
var gm, hE;
function hH() {
  if (hE) return gm;
  hE = 1;
  var e = nc();
  return gm = e("document", "documentElement"), gm;
}
var pm, fE;
function kJ() {
  if (fE) return pm;
  fE = 1;
  var e = cr();
  return pm = e([].slice), pm;
}
var Bm, dE;
function KJ() {
  if (dE) return Bm;
  dE = 1;
  var e = TypeError;
  return Bm = function(A, t) {
    if (A < t) throw new e("Not enough arguments");
    return A;
  }, Bm;
}
var wm, gE;
function fH() {
  if (gE) return wm;
  gE = 1;
  var e = tf();
  return wm = /ipad|iphone|ipod/i.test(e) && /applewebkit/i.test(e), wm;
}
var mm, pE;
function dH() {
  if (pE) return mm;
  pE = 1;
  var e = Kt(), A = uH(), t = s2(), r = ur(), n = Is(), i = lr(), s = hH(), a = kJ(), o = Sp(), l = KJ(), c = fH(), u = Op(), d = e.setImmediate, h = e.clearImmediate, p = e.process, B = e.Dispatch, y = e.Function, m = e.MessageChannel, C = e.String, Q = 0, F = {}, T = "onreadystatechange", V, M, D, I;
  i(function() {
    V = e.location;
  });
  var q = function(N) {
    if (n(F, N)) {
      var iA = F[N];
      delete F[N], iA();
    }
  }, U = function(N) {
    return function() {
      q(N);
    };
  }, x = function(N) {
    q(N.data);
  }, P = function(N) {
    e.postMessage(C(N), V.protocol + "//" + V.host);
  };
  return (!d || !h) && (d = function(iA) {
    l(arguments.length, 1);
    var nA = r(iA) ? iA : y(iA), sA = a(arguments, 1);
    return F[++Q] = function() {
      A(nA, void 0, sA);
    }, M(Q), Q;
  }, h = function(iA) {
    delete F[iA];
  }, u ? M = function(N) {
    p.nextTick(U(N));
  } : B && B.now ? M = function(N) {
    B.now(U(N));
  } : m && !c ? (D = new m(), I = D.port2, D.port1.onmessage = x, M = t(I.postMessage, I)) : e.addEventListener && r(e.postMessage) && !e.importScripts && V && V.protocol !== "file:" && !i(P) ? (M = P, e.addEventListener("message", x, !1)) : T in o("script") ? M = function(N) {
    s.appendChild(o("script"))[T] = function() {
      s.removeChild(this), q(N);
    };
  } : M = function(N) {
    setTimeout(U(N), 0);
  }), mm = {
    set: d,
    clear: h
  }, mm;
}
var vm, BE;
function VJ() {
  if (BE) return vm;
  BE = 1;
  var e = Kt(), A = Es(), t = Object.getOwnPropertyDescriptor;
  return vm = function(r) {
    if (!A) return e[r];
    var n = t(e, r);
    return n && n.value;
  }, vm;
}
var ym, wE;
function gH() {
  if (wE) return ym;
  wE = 1;
  var e = function() {
    this.head = null, this.tail = null;
  };
  return e.prototype = {
    add: function(A) {
      var t = { item: A, next: null }, r = this.tail;
      r ? r.next = t : this.head = t, this.tail = t;
    },
    get: function() {
      var A = this.head;
      if (A) {
        var t = this.head = A.next;
        return t === null && (this.tail = null), A.item;
      }
    }
  }, ym = e, ym;
}
var Cm, mE;
function GJ() {
  if (mE) return Cm;
  mE = 1;
  var e = tf();
  return Cm = /ipad|iphone|ipod/i.test(e) && typeof Pebble < "u", Cm;
}
var bm, vE;
function WJ() {
  if (vE) return bm;
  vE = 1;
  var e = tf();
  return bm = /web0s(?!.*chrome)/i.test(e), bm;
}
var Fm, yE;
function jJ() {
  if (yE) return Fm;
  yE = 1;
  var e = Kt(), A = VJ(), t = s2(), r = dH().set, n = gH(), i = fH(), s = GJ(), a = WJ(), o = Op(), l = e.MutationObserver || e.WebKitMutationObserver, c = e.document, u = e.process, d = e.Promise, h = A("queueMicrotask"), p, B, y, m, C;
  if (!h) {
    var Q = new n(), F = function() {
      var T, V;
      for (o && (T = u.domain) && T.exit(); V = Q.get(); ) try {
        V();
      } catch (M) {
        throw Q.head && p(), M;
      }
      T && T.enter();
    };
    !i && !o && !a && l && c ? (B = !0, y = c.createTextNode(""), new l(F).observe(y, { characterData: !0 }), p = function() {
      y.data = B = !B;
    }) : !s && d && d.resolve ? (m = d.resolve(void 0), m.constructor = d, C = t(m.then, m), p = function() {
      C(F);
    }) : o ? p = function() {
      u.nextTick(F);
    } : (r = t(r, e), p = function() {
      r(F);
    }), h = function(T) {
      Q.head || p(), Q.add(T);
    };
  }
  return Fm = h, Fm;
}
var Qm, CE;
function qJ() {
  return CE || (CE = 1, Qm = function(e, A) {
    try {
      arguments.length === 1 ? console.error(e) : console.error(e, A);
    } catch {
    }
  }), Qm;
}
var Um, bE;
function a2() {
  return bE || (bE = 1, Um = function(e) {
    try {
      return { error: !1, value: e() };
    } catch (A) {
      return { error: !0, value: A };
    }
  }), Um;
}
var Em, FE;
function nf() {
  if (FE) return Em;
  FE = 1;
  var e = Kt();
  return Em = e.Promise, Em;
}
var xm, QE;
function sf() {
  if (QE) return xm;
  QE = 1;
  var e = Kt(), A = nf(), t = ur(), r = sH(), n = e2(), i = Yr(), s = aH(), a = ea(), o = Yy(), l = A && A.prototype, c = i("species"), u = !1, d = t(e.PromiseRejectionEvent), h = r("Promise", function() {
    var p = n(A), B = p !== String(A);
    if (!B && o === 66 || a && !(l.catch && l.finally)) return !0;
    if (!o || o < 51 || !/native code/.test(p)) {
      var y = new A(function(Q) {
        Q(1);
      }), m = function(Q) {
        Q(function() {
        }, function() {
        });
      }, C = y.constructor = {};
      if (C[c] = m, u = y.then(function() {
      }) instanceof m, !u) return !0;
    }
    return !B && (s === "BROWSER" || s === "DENO") && !d;
  });
  return xm = {
    CONSTRUCTOR: h,
    REJECTION_EVENT: d,
    SUBCLASSING: u
  }, xm;
}
var Im = {}, UE;
function af() {
  if (UE) return Im;
  UE = 1;
  var e = Wo(), A = TypeError, t = function(r) {
    var n, i;
    this.promise = new r(function(s, a) {
      if (n !== void 0 || i !== void 0) throw new A("Bad Promise constructor");
      n = s, i = a;
    }), this.resolve = e(n), this.reject = e(i);
  };
  return Im.f = function(r) {
    return new t(r);
  }, Im;
}
var EE;
function $J() {
  if (EE) return O5;
  EE = 1;
  var e = Zn(), A = ea(), t = Op(), r = Kt(), n = LJ(), i = cn(), s = ic(), a = oH(), o = Np(), l = NJ(), c = Wo(), u = ur(), d = ci(), h = DJ(), p = cH(), B = dH().set, y = jJ(), m = qJ(), C = a2(), Q = gH(), F = Tp(), T = nf(), V = sf(), M = af(), D = "Promise", I = V.CONSTRUCTOR, q = V.REJECTION_EVENT, U = V.SUBCLASSING, x = F.getterFor(D), P = F.set, N = T && T.prototype, iA = T, nA = N, sA = r.TypeError, tA = r.document, cA = r.process, FA = M.f, CA = FA, S = !!(tA && tA.createEvent && r.dispatchEvent), W = "unhandledrejection", Y = "rejectionhandled", AA = 0, oA = 1, gA = 2, xA = 1, IA = 2, pA, WA, k, X, uA = function(yA) {
    var TA;
    return d(yA) && u(TA = yA.then) ? TA : !1;
  }, E = function(yA, TA) {
    var _A = TA.value, MA = TA.state === oA, VA = MA ? yA.ok : yA.fail, $A = yA.resolve, ee = yA.reject, ZA = yA.domain, Fe, me, Ce;
    try {
      VA ? (MA || (TA.rejection === IA && EA(TA), TA.rejection = xA), VA === !0 ? Fe = _A : (ZA && ZA.enter(), Fe = VA(_A), ZA && (ZA.exit(), Ce = !0)), Fe === yA.promise ? ee(new sA("Promise-chain cycle")) : (me = uA(Fe)) ? i(me, Fe, $A, ee) : $A(Fe)) : ee(_A);
    } catch (ae) {
      ZA && !Ce && ZA.exit(), ee(ae);
    }
  }, dA = function(yA, TA) {
    yA.notified || (yA.notified = !0, y(function() {
      for (var _A = yA.reactions, MA; MA = _A.get(); )
        E(MA, yA);
      yA.notified = !1, TA && !yA.rejection && rA(yA);
    }));
  }, vA = function(yA, TA, _A) {
    var MA, VA;
    S ? (MA = tA.createEvent("Event"), MA.promise = TA, MA.reason = _A, MA.initEvent(yA, !1, !0), r.dispatchEvent(MA)) : MA = { promise: TA, reason: _A }, !q && (VA = r["on" + yA]) ? VA(MA) : yA === W && m("Unhandled promise rejection", _A);
  }, rA = function(yA) {
    i(B, r, function() {
      var TA = yA.facade, _A = yA.value, MA = fA(yA), VA;
      if (MA && (VA = C(function() {
        t ? cA.emit("unhandledRejection", _A, TA) : vA(W, TA, _A);
      }), yA.rejection = t || fA(yA) ? IA : xA, VA.error))
        throw VA.value;
    });
  }, fA = function(yA) {
    return yA.rejection !== xA && !yA.parent;
  }, EA = function(yA) {
    i(B, r, function() {
      var TA = yA.facade;
      t ? cA.emit("rejectionHandled", TA) : vA(Y, TA, yA.value);
    });
  }, lA = function(yA, TA, _A) {
    return function(MA) {
      yA(TA, MA, _A);
    };
  }, HA = function(yA, TA, _A) {
    yA.done || (yA.done = !0, _A && (yA = _A), yA.value = TA, yA.state = gA, dA(yA, !0));
  }, SA = function(yA, TA, _A) {
    if (!yA.done) {
      yA.done = !0, _A && (yA = _A);
      try {
        if (yA.facade === TA) throw new sA("Promise can't be resolved itself");
        var MA = uA(TA);
        MA ? y(function() {
          var VA = { done: !1 };
          try {
            i(
              MA,
              TA,
              lA(SA, VA, yA),
              lA(HA, VA, yA)
            );
          } catch ($A) {
            HA(VA, $A, yA);
          }
        }) : (yA.value = TA, yA.state = oA, dA(yA, !1));
      } catch (VA) {
        HA({ done: !1 }, VA, yA);
      }
    }
  };
  if (I && (iA = function(TA) {
    h(this, nA), c(TA), i(pA, this);
    var _A = x(this);
    try {
      TA(lA(SA, _A), lA(HA, _A));
    } catch (MA) {
      HA(_A, MA);
    }
  }, nA = iA.prototype, pA = function(TA) {
    P(this, {
      type: D,
      done: !1,
      notified: !1,
      parent: !1,
      reactions: new Q(),
      rejection: !1,
      state: AA,
      value: null
    });
  }, pA.prototype = s(nA, "then", function(TA, _A) {
    var MA = x(this), VA = FA(p(this, iA));
    return MA.parent = !0, VA.ok = u(TA) ? TA : !0, VA.fail = u(_A) && _A, VA.domain = t ? cA.domain : void 0, MA.state === AA ? MA.reactions.add(VA) : y(function() {
      E(VA, MA);
    }), VA.promise;
  }), WA = function() {
    var yA = new pA(), TA = x(yA);
    this.promise = yA, this.resolve = lA(SA, TA), this.reject = lA(HA, TA);
  }, M.f = FA = function(yA) {
    return yA === iA || yA === k ? new WA(yA) : CA(yA);
  }, !A && u(T) && N !== Object.prototype)) {
    X = N.then, U || s(N, "then", function(TA, _A) {
      var MA = this;
      return new iA(function(VA, $A) {
        i(X, MA, VA, $A);
      }).then(TA, _A);
    }, { unsafe: !0 });
    try {
      delete N.constructor;
    } catch {
    }
    a && a(N, nA);
  }
  return e({ global: !0, constructor: !0, wrap: !0, forced: I }, {
    Promise: iA
  }), k = n.Promise, o(iA, D, !1, !0), l(D), O5;
}
var xE = {}, Sm, IE;
function Rp() {
  return IE || (IE = 1, Sm = Object.create ? /* @__PURE__ */ Object.create(null) : {}), Sm;
}
var Lm, SE;
function zJ() {
  if (SE) return Lm;
  SE = 1;
  var e = Yr(), A = Rp(), t = e("iterator"), r = Array.prototype;
  return Lm = function(n) {
    return n !== void 0 && (A.Array === n || r[t] === n);
  }, Lm;
}
var Hm, LE;
function pH() {
  if (LE) return Hm;
  LE = 1;
  var e = Go(), A = Up(), t = iu(), r = Yr(), n = r("iterator"), i = Array.prototype;
  return Hm = function(s) {
    if (!A(s)) return t(s, n) || t(s, "@@iterator") || (e(s) === "Arguments" ? i[n] : void 0);
  }, Hm;
}
var Tm, HE;
function XJ() {
  if (HE) return Tm;
  HE = 1;
  var e = cn(), A = ur(), t = Jn(), r = xp(), n = pH(), i = TypeError;
  return Tm = function(s, a) {
    var o = arguments.length < 2 ? n(s) : a;
    if (A(o)) return t(e(o, s));
    throw new i(r(s) + " is not iterable");
  }, Tm;
}
var _m, TE;
function YJ() {
  if (TE) return _m;
  TE = 1;
  var e = cn(), A = Jn(), t = iu();
  return _m = function(r, n, i) {
    var s, a;
    A(r);
    try {
      if (s = t(r, "return"), !s) {
        if (n === "throw") throw i;
        return i;
      }
      s = e(s, r);
    } catch (o) {
      a = !0, s = o;
    }
    if (n === "throw") throw i;
    if (a) throw s;
    return A(s), i;
  }, _m;
}
var Om, _E;
function BH() {
  if (_E) return Om;
  _E = 1;
  var e = s2(), A = cn(), t = Jn(), r = xp(), n = zJ(), i = n2(), s = Ep(), a = XJ(), o = pH(), l = YJ(), c = TypeError, u = function(h, p) {
    this.stopped = h, this.result = p;
  }, d = u.prototype;
  return Om = function(h, p, B) {
    var y = B && B.that, m = !!(B && B.AS_ENTRIES), C = !!(B && B.IS_RECORD), Q = !!(B && B.IS_ITERATOR), F = !!(B && B.INTERRUPTED), T = e(p, y), V, M, D, I, q, U, x, P = function(nA) {
      var sA = V;
      return V = void 0, sA && l(sA, "normal"), new u(!0, nA);
    }, N = function(nA) {
      return m ? (t(nA), F ? T(nA[0], nA[1], P) : T(nA[0], nA[1])) : F ? T(nA, P) : T(nA);
    };
    if (C)
      V = h.iterator;
    else if (Q)
      V = h;
    else {
      if (M = o(h), !M) throw new c(r(h) + " is not iterable");
      if (n(M)) {
        for (D = 0, I = i(h); I > D; D++)
          if (q = N(h[D]), q && s(d, q)) return q;
        return new u(!1);
      }
      V = a(h, M);
    }
    for (U = C ? h.next : V.next; !(x = A(U, V)).done; ) {
      var iA = x.value;
      try {
        q = N(iA);
      } catch (nA) {
        if (V) l(V, "throw", nA);
        else throw nA;
      }
      if (typeof q == "object" && q && s(d, q)) return q;
    }
    return new u(!1);
  }, Om;
}
var Nm, OE;
function JJ() {
  if (OE) return Nm;
  OE = 1;
  var e = Yr(), A = e("iterator"), t = !1;
  try {
    var r = 0, n = {
      next: function() {
        return { done: !!r++ };
      },
      return: function() {
        t = !0;
      }
    };
    n[A] = function() {
      return this;
    }, Array.from(n, function() {
      throw 2;
    });
  } catch {
  }
  return Nm = function(i, s) {
    try {
      if (!s && !t) return !1;
    } catch {
      return !1;
    }
    var a = !1;
    try {
      var o = {};
      o[A] = function() {
        return {
          next: function() {
            return { done: a = !0 };
          }
        };
      }, i(o);
    } catch {
    }
    return a;
  }, Nm;
}
var Dm, NE;
function wH() {
  if (NE) return Dm;
  NE = 1;
  var e = nf(), A = JJ(), t = sf().CONSTRUCTOR;
  return Dm = t || !A(function(r) {
    e.all(r).then(void 0, function() {
    });
  }), Dm;
}
var DE;
function ZJ() {
  if (DE) return xE;
  DE = 1;
  var e = Zn(), A = cn(), t = Wo(), r = af(), n = a2(), i = BH(), s = wH();
  return e({ target: "Promise", stat: !0, forced: s }, {
    all: function(o) {
      var l = this, c = r.f(l), u = c.resolve, d = c.reject, h = n(function() {
        var p = t(l.resolve), B = [], y = 0, m = 1;
        i(o, function(C) {
          var Q = y++, F = !1;
          m++, A(p, l, C).then(function(T) {
            F || (F = !0, B[Q] = T, --m || u(B));
          }, d);
        }), --m || u(B);
      });
      return h.error && d(h.value), c.promise;
    }
  }), xE;
}
var RE = {}, ME;
function AZ() {
  if (ME) return RE;
  ME = 1;
  var e = Zn(), A = ea(), t = sf().CONSTRUCTOR, r = nf(), n = nc(), i = ur(), s = ic(), a = r && r.prototype;
  if (e({ target: "Promise", proto: !0, forced: t, real: !0 }, {
    catch: function(l) {
      return this.then(void 0, l);
    }
  }), !A && i(r)) {
    var o = n("Promise").prototype.catch;
    a.catch !== o && s(a, "catch", o, { unsafe: !0 });
  }
  return RE;
}
var PE = {}, kE;
function eZ() {
  if (kE) return PE;
  kE = 1;
  var e = Zn(), A = cn(), t = Wo(), r = af(), n = a2(), i = BH(), s = wH();
  return e({ target: "Promise", stat: !0, forced: s }, {
    race: function(o) {
      var l = this, c = r.f(l), u = c.reject, d = n(function() {
        var h = t(l.resolve);
        i(o, function(p) {
          A(h, l, p).then(c.resolve, u);
        });
      });
      return d.error && u(d.value), c.promise;
    }
  }), PE;
}
var KE = {}, VE;
function tZ() {
  if (VE) return KE;
  VE = 1;
  var e = Zn(), A = af(), t = sf().CONSTRUCTOR;
  return e({ target: "Promise", stat: !0, forced: t }, {
    reject: function(n) {
      var i = A.f(this), s = i.reject;
      return s(n), i.promise;
    }
  }), KE;
}
var GE = {}, Rm, WE;
function rZ() {
  if (WE) return Rm;
  WE = 1;
  var e = Jn(), A = ci(), t = af();
  return Rm = function(r, n) {
    if (e(r), A(n) && n.constructor === r) return n;
    var i = t.f(r), s = i.resolve;
    return s(n), i.promise;
  }, Rm;
}
var jE;
function nZ() {
  if (jE) return GE;
  jE = 1;
  var e = Zn(), A = nc(), t = ea(), r = nf(), n = sf().CONSTRUCTOR, i = rZ(), s = A("Promise"), a = t && !n;
  return e({ target: "Promise", stat: !0, forced: t || n }, {
    resolve: function(l) {
      return i(a && this === s ? r : this, l);
    }
  }), GE;
}
var qE;
function iZ() {
  return qE || (qE = 1, $J(), ZJ(), AZ(), eZ(), tZ(), nZ()), _5;
}
iZ();
function $E(e, A, t, r, n, i, s) {
  try {
    var a = e[i](s), o = a.value;
  } catch (l) {
    return void t(l);
  }
  a.done ? A(o) : Promise.resolve(o).then(r, n);
}
function Na(e) {
  return function() {
    var A = this, t = arguments;
    return new Promise(function(r, n) {
      var i = e.apply(A, t);
      function s(o) {
        $E(i, r, n, s, a, "next", o);
      }
      function a(o) {
        $E(i, r, n, s, a, "throw", o);
      }
      s(void 0);
    });
  };
}
var zE = {}, XE = {}, Mm, YE;
function ta() {
  if (YE) return Mm;
  YE = 1;
  var e = lH(), A = String;
  return Mm = function(t) {
    if (e(t) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return A(t);
  }, Mm;
}
var Pm, JE;
function mH() {
  if (JE) return Pm;
  JE = 1;
  var e = Jn();
  return Pm = function() {
    var A = e(this), t = "";
    return A.hasIndices && (t += "d"), A.global && (t += "g"), A.ignoreCase && (t += "i"), A.multiline && (t += "m"), A.dotAll && (t += "s"), A.unicode && (t += "u"), A.unicodeSets && (t += "v"), A.sticky && (t += "y"), t;
  }, Pm;
}
var km, ZE;
function vH() {
  if (ZE) return km;
  ZE = 1;
  var e = lr(), A = Kt(), t = A.RegExp, r = e(function() {
    var s = t("a", "y");
    return s.lastIndex = 2, s.exec("abcd") !== null;
  }), n = r || e(function() {
    return !t("a", "y").sticky;
  }), i = r || e(function() {
    var s = t("^r", "gy");
    return s.lastIndex = 2, s.exec("str") !== null;
  });
  return km = {
    BROKEN_CARET: i,
    MISSED_STICKY: n,
    UNSUPPORTED_Y: r
  }, km;
}
var Km = {}, Vm, A4;
function sZ() {
  if (A4) return Vm;
  A4 = 1;
  var e = iH(), A = i2();
  return Vm = Object.keys || function(r) {
    return e(r, A);
  }, Vm;
}
var e4;
function aZ() {
  if (e4) return Km;
  e4 = 1;
  var e = Es(), A = tH(), t = jo(), r = Jn(), n = ef(), i = sZ();
  return Km.f = e && !A ? Object.defineProperties : function(a, o) {
    r(a);
    for (var l = n(o), c = i(o), u = c.length, d = 0, h; u > d; ) t.f(a, h = c[d++], l[h]);
    return a;
  }, Km;
}
var Gm, t4;
function Mp() {
  if (t4) return Gm;
  t4 = 1;
  var e = Jn(), A = aZ(), t = i2(), r = r2(), n = hH(), i = Sp(), s = t2(), a = ">", o = "<", l = "prototype", c = "script", u = s("IE_PROTO"), d = function() {
  }, h = function(C) {
    return o + c + a + C + o + "/" + c + a;
  }, p = function(C) {
    C.write(h("")), C.close();
    var Q = C.parentWindow.Object;
    return C = null, Q;
  }, B = function() {
    var C = i("iframe"), Q = "java" + c + ":", F;
    return C.style.display = "none", n.appendChild(C), C.src = String(Q), F = C.contentWindow.document, F.open(), F.write(h("document.F=Object")), F.close(), F.F;
  }, y, m = function() {
    try {
      y = new ActiveXObject("htmlfile");
    } catch {
    }
    m = typeof document < "u" ? document.domain && y ? p(y) : B() : p(y);
    for (var C = t.length; C--; ) delete m[l][t[C]];
    return m();
  };
  return r[u] = !0, Gm = Object.create || function(Q, F) {
    var T;
    return Q !== null ? (d[l] = e(Q), T = new d(), d[l] = null, T[u] = Q) : T = m(), F === void 0 ? T : A.f(T, F);
  }, Gm;
}
var Wm, r4;
function oZ() {
  if (r4) return Wm;
  r4 = 1;
  var e = lr(), A = Kt(), t = A.RegExp;
  return Wm = e(function() {
    var r = t(".", "s");
    return !(r.dotAll && r.test(`
`) && r.flags === "s");
  }), Wm;
}
var jm, n4;
function lZ() {
  if (n4) return jm;
  n4 = 1;
  var e = lr(), A = Kt(), t = A.RegExp;
  return jm = e(function() {
    var r = t("(?<a>b)", "g");
    return r.exec("b").groups.a !== "b" || "b".replace(r, "$<a>c") !== "bc";
  }), jm;
}
var qm, i4;
function o2() {
  if (i4) return qm;
  i4 = 1;
  var e = cn(), A = cr(), t = ta(), r = mH(), n = vH(), i = A2(), s = Mp(), a = Tp().get, o = oZ(), l = lZ(), c = i("native-string-replace", String.prototype.replace), u = RegExp.prototype.exec, d = u, h = A("".charAt), p = A("".indexOf), B = A("".replace), y = A("".slice), m = (function() {
    var V = /a/, M = /b*/g;
    return e(u, V, "a"), e(u, M, "a"), V.lastIndex !== 0 || M.lastIndex !== 0;
  })(), C = n.BROKEN_CARET, Q = /()??/.exec("")[1] !== void 0, F = m || Q || C || o || l, T = function(V, M) {
    for (var D = V.groups = s(null), I = 0; I < M.length; I++) {
      var q = M[I];
      D[q[0]] = V[q[1]];
    }
  };
  return F && (d = function(M) {
    var D = this, I = a(D), q = t(M), U = I.raw, x, P, N;
    if (U)
      return U.lastIndex = D.lastIndex, x = e(d, U, q), D.lastIndex = U.lastIndex, x && I.groups && T(x, I.groups), x;
    var iA = I.groups, nA = C && D.sticky, sA = e(r, D), tA = D.source, cA = 0, FA = q;
    if (nA) {
      sA = B(sA, "y", ""), p(sA, "g") === -1 && (sA += "g"), FA = y(q, D.lastIndex);
      var CA = D.lastIndex > 0 && h(q, D.lastIndex - 1);
      D.lastIndex > 0 && (!D.multiline || D.multiline && CA !== `
` && CA !== "\r" && CA !== "\u2028" && CA !== "\u2029") && (tA = "(?: (?:" + tA + "))", FA = " " + FA, cA++), P = new RegExp("^(?:" + tA + ")", sA);
    }
    Q && (P = new RegExp("^" + tA + "$(?!\\s)", sA)), m && (N = D.lastIndex);
    var S = e(u, nA ? P : D, FA);
    return nA ? S ? (S.input = q, S[0] = y(S[0], cA), S.index = D.lastIndex, D.lastIndex += S[0].length) : D.lastIndex = 0 : m && S && (D.lastIndex = D.global ? S.index + S[0].length : N), Q && S && S.length > 1 && e(c, S[0], P, function() {
      for (var W = 1; W < arguments.length - 2; W++)
        arguments[W] === void 0 && (S[W] = void 0);
    }), S && iA && T(S, iA), S;
  }), qm = d, qm;
}
var s4;
function cZ() {
  if (s4) return XE;
  s4 = 1;
  var e = Zn(), A = o2();
  return e({ target: "RegExp", proto: !0, forced: /./.exec !== A }, {
    exec: A
  }), XE;
}
var $m, a4;
function l2() {
  if (a4) return $m;
  a4 = 1, cZ();
  var e = cn(), A = ic(), t = o2(), r = lr(), n = Yr(), i = rf(), s = n("species"), a = RegExp.prototype;
  return $m = function(o, l, c, u) {
    var d = n(o), h = !r(function() {
      var m = {};
      return m[d] = function() {
        return 7;
      }, ""[o](m) !== 7;
    }), p = h && !r(function() {
      var m = !1, C = /a/;
      if (o === "split") {
        var Q = {};
        Q[s] = function() {
          return C;
        }, C = { constructor: Q, flags: "" }, C[d] = /./[d];
      }
      return C.exec = function() {
        return m = !0, null;
      }, C[d](""), !m;
    });
    if (!h || !p || c) {
      var B = /./[d], y = l(d, ""[o], function(m, C, Q, F, T) {
        var V = C.exec;
        return V === t || V === a.exec ? h && !T ? { done: !0, value: e(B, C, Q, F) } : { done: !0, value: e(m, Q, C, F) } : { done: !1 };
      });
      A(String.prototype, o, y[0]), A(a, d, y[1]);
    }
    u && i(a[d], "sham", !0);
  }, $m;
}
var zm, o4;
function uZ() {
  if (o4) return zm;
  o4 = 1;
  var e = cr(), A = _p(), t = ta(), r = xs(), n = e("".charAt), i = e("".charCodeAt), s = e("".slice), a = function(o) {
    return function(l, c) {
      var u = t(r(l)), d = A(c), h = u.length, p, B;
      return d < 0 || d >= h ? o ? "" : void 0 : (p = i(u, d), p < 55296 || p > 56319 || d + 1 === h || (B = i(u, d + 1)) < 56320 || B > 57343 ? o ? n(u, d) : p : o ? s(u, d, d + 2) : (p - 55296 << 10) + (B - 56320) + 65536);
    };
  };
  return zm = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: a(!1),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: a(!0)
  }, zm;
}
var Xm, l4;
function c2() {
  if (l4) return Xm;
  l4 = 1;
  var e = uZ().charAt;
  return Xm = function(A, t, r) {
    return t + (r && e(A, t).length || 1);
  }, Xm;
}
var Ym, c4;
function hZ() {
  if (c4) return Ym;
  c4 = 1;
  var e = Kt(), A = lr(), t = e.RegExp, r = !A(function() {
    var n = !0;
    try {
      t(".", "d");
    } catch {
      n = !1;
    }
    var i = {}, s = "", a = n ? "dgimsy" : "gimsy", o = function(d, h) {
      Object.defineProperty(i, d, { get: function() {
        return s += h, !0;
      } });
    }, l = {
      dotAll: "s",
      global: "g",
      ignoreCase: "i",
      multiline: "m",
      sticky: "y"
    };
    n && (l.hasIndices = "d");
    for (var c in l) o(c, l[c]);
    var u = Object.getOwnPropertyDescriptor(t.prototype, "flags").get.call(i);
    return u !== a || s !== a;
  });
  return Ym = { correct: r }, Ym;
}
var Jm, u4;
function Pp() {
  if (u4) return Jm;
  u4 = 1;
  var e = cn(), A = Is(), t = Ep(), r = hZ(), n = mH(), i = RegExp.prototype;
  return Jm = r.correct ? function(s) {
    return s.flags;
  } : function(s) {
    return !r.correct && t(i, s) && !A(s, "flags") ? e(n, s) : s.flags;
  }, Jm;
}
var Zm, h4;
function u2() {
  if (h4) return Zm;
  h4 = 1;
  var e = cn(), A = Jn(), t = ur(), r = Go(), n = o2(), i = TypeError;
  return Zm = function(s, a) {
    var o = s.exec;
    if (t(o)) {
      var l = e(o, s, a);
      return l !== null && A(l), l;
    }
    if (r(s) === "RegExp") return e(n, s, a);
    throw new i("RegExp#exec called on incompatible receiver");
  }, Zm;
}
var f4;
function fZ() {
  if (f4) return zE;
  f4 = 1;
  var e = cn(), A = cr(), t = l2(), r = Jn(), n = ci(), i = su(), s = ta(), a = xs(), o = iu(), l = c2(), c = Pp(), u = u2(), d = A("".indexOf);
  return t("match", function(h, p, B) {
    return [
      // `String.prototype.match` method
      // https://tc39.es/ecma262/#sec-string.prototype.match
      function(m) {
        var C = a(this), Q = n(m) ? o(m, h) : void 0;
        if (Q) return e(Q, m, C);
        var F = s(C);
        return new RegExp(m)[h](F);
      },
      // `RegExp.prototype[@@match]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
      function(y) {
        var m = r(this), C = s(y), Q = B(p, m, C);
        if (Q.done) return Q.value;
        var F = s(c(m));
        if (!~d(F, "g")) return u(m, C);
        var T = !!~d(F, "u") || !!~d(F, "v");
        m.lastIndex = 0;
        for (var V = [], M = 0, D; (D = u(m, C)) !== null; ) {
          var I = s(D[0]);
          V[M] = I, I === "" && (m.lastIndex = l(C, i(m.lastIndex), T)), M++;
        }
        return M === 0 ? null : V;
      }
    ];
  }), zE;
}
fZ();
var d4 = {}, A1, g4;
function dZ() {
  if (g4) return A1;
  g4 = 1;
  var e = cr(), A = Ip(), t = Math.floor, r = e("".charAt), n = e("".replace), i = e("".slice), s = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, a = /\$([$&'`]|\d{1,2})/g;
  return A1 = function(o, l, c, u, d, h) {
    var p = c + o.length, B = u.length, y = a;
    return d !== void 0 && (d = A(d), y = s), n(h, y, function(m, C) {
      var Q;
      switch (r(C, 0)) {
        case "$":
          return "$";
        case "&":
          return o;
        case "`":
          return i(l, 0, c);
        case "'":
          return i(l, p);
        case "<":
          Q = d[i(C, 1, -1)];
          break;
        default:
          var F = +C;
          if (F === 0) return m;
          if (F > B) {
            var T = t(F / 10);
            return T === 0 ? m : T <= B ? u[T - 1] === void 0 ? r(C, 1) : u[T - 1] + r(C, 1) : m;
          }
          Q = u[F - 1];
      }
      return Q === void 0 ? "" : Q;
    });
  }, A1;
}
var p4;
function gZ() {
  if (p4) return d4;
  p4 = 1;
  var e = uH(), A = cn(), t = cr(), r = l2(), n = lr(), i = Jn(), s = ur(), a = ci(), o = _p(), l = su(), c = ta(), u = xs(), d = c2(), h = iu(), p = dZ(), B = Pp(), y = u2(), m = Yr(), C = m("replace"), Q = Math.max, F = Math.min, T = t([].concat), V = t([].push), M = t("".indexOf), D = t("".slice), I = function(P) {
    return P === void 0 ? P : String(P);
  }, q = (function() {
    return "a".replace(/./, "$0") === "$0";
  })(), U = (function() {
    return /./[C] ? /./[C]("a", "$0") === "" : !1;
  })(), x = !n(function() {
    var P = /./;
    return P.exec = function() {
      var N = [];
      return N.groups = { a: "7" }, N;
    }, "".replace(P, "$<a>") !== "7";
  });
  return r("replace", function(P, N, iA) {
    var nA = U ? "$" : "$0";
    return [
      // `String.prototype.replace` method
      // https://tc39.es/ecma262/#sec-string.prototype.replace
      function(tA, cA) {
        var FA = u(this), CA = a(tA) ? h(tA, C) : void 0;
        return CA ? A(CA, tA, FA, cA) : A(N, c(FA), tA, cA);
      },
      // `RegExp.prototype[@@replace]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
      function(sA, tA) {
        var cA = i(this), FA = c(sA), CA = s(tA);
        CA || (tA = c(tA));
        var S = c(B(cA));
        if (typeof tA == "string" && !~M(tA, nA) && !~M(tA, "$<") && !~M(S, "y")) {
          var W = iA(N, cA, FA, tA);
          if (W.done) return W.value;
        }
        var Y = !!~M(S, "g"), AA;
        Y && (AA = !!~M(S, "u") || !!~M(S, "v"), cA.lastIndex = 0);
        for (var oA = [], gA; gA = y(cA, FA), !(gA === null || (V(oA, gA), !Y)); ) {
          var xA = c(gA[0]);
          xA === "" && (cA.lastIndex = d(FA, l(cA.lastIndex), AA));
        }
        for (var IA = "", pA = 0, WA = 0; WA < oA.length; WA++) {
          gA = oA[WA];
          for (var k = c(gA[0]), X = Q(F(o(gA.index), FA.length), 0), uA = [], E, dA = 1; dA < gA.length; dA++) V(uA, I(gA[dA]));
          var vA = gA.groups;
          if (CA) {
            var rA = T([k], uA, X, FA);
            vA !== void 0 && V(rA, vA), E = c(e(tA, void 0, rA));
          } else
            E = p(k, FA, X, uA, vA, tA);
          X >= pA && (IA += D(FA, pA, X) + E, pA = X + k.length);
        }
        return IA + D(FA, pA);
      }
    ];
  }, !x || !q || U), d4;
}
gZ();
var B4 = {}, e1, w4;
function pZ() {
  if (w4) return e1;
  w4 = 1;
  var e = ci(), A = Go(), t = Yr(), r = t("match");
  return e1 = function(n) {
    var i;
    return e(n) && ((i = n[r]) !== void 0 ? !!i : A(n) === "RegExp");
  }, e1;
}
var t1, m4;
function h2() {
  if (m4) return t1;
  m4 = 1;
  var e = pZ(), A = TypeError;
  return t1 = function(t) {
    if (e(t))
      throw new A("The method doesn't accept regular expressions");
    return t;
  }, t1;
}
var r1, v4;
function f2() {
  if (v4) return r1;
  v4 = 1;
  var e = Yr(), A = e("match");
  return r1 = function(t) {
    var r = /./;
    try {
      "/./"[t](r);
    } catch {
      try {
        return r[A] = !1, "/./"[t](r);
      } catch {
      }
    }
    return !1;
  }, r1;
}
var y4;
function BZ() {
  if (y4) return B4;
  y4 = 1;
  var e = Zn(), A = Dp(), t = Lp().f, r = su(), n = ta(), i = h2(), s = xs(), a = f2(), o = ea(), l = A("".slice), c = Math.min, u = a("startsWith"), d = !o && !u && !!(function() {
    var h = t(String.prototype, "startsWith");
    return h && !h.writable;
  })();
  return e({ target: "String", proto: !0, forced: !d && !u }, {
    startsWith: function(p) {
      var B = n(s(this));
      i(p);
      var y = n(p), m = r(c(arguments.length > 1 ? arguments[1] : void 0, B.length));
      return l(B, m, m + y.length) === y;
    }
  }), B4;
}
BZ();
var n1, C4;
function wZ() {
  if (C4) return n1;
  C4 = 1;
  var e = Yr(), A = Mp(), t = jo().f, r = e("unscopables"), n = Array.prototype;
  return n[r] === void 0 && t(n, r, {
    configurable: !0,
    value: A(null)
  }), n1 = function(i) {
    n[r][i] = !0;
  }, n1;
}
var i1, b4;
function mZ() {
  if (b4) return i1;
  b4 = 1;
  var e = lr();
  return i1 = !e(function() {
    function A() {
    }
    return A.prototype.constructor = null, Object.getPrototypeOf(new A()) !== A.prototype;
  }), i1;
}
var s1, F4;
function yH() {
  if (F4) return s1;
  F4 = 1;
  var e = Is(), A = ur(), t = Ip(), r = t2(), n = mZ(), i = r("IE_PROTO"), s = Object, a = s.prototype;
  return s1 = n ? s.getPrototypeOf : function(o) {
    var l = t(o);
    if (e(l, i)) return l[i];
    var c = l.constructor;
    return A(c) && l instanceof c ? c.prototype : l instanceof s ? a : null;
  }, s1;
}
var a1, Q4;
function CH() {
  if (Q4) return a1;
  Q4 = 1;
  var e = lr(), A = ur(), t = ci(), r = Mp(), n = yH(), i = ic(), s = Yr(), a = ea(), o = s("iterator"), l = !1, c, u, d;
  [].keys && (d = [].keys(), "next" in d ? (u = n(n(d)), u !== Object.prototype && (c = u)) : l = !0);
  var h = !t(c) || e(function() {
    var p = {};
    return c[o].call(p) !== p;
  });
  return h ? c = {} : a && (c = r(c)), A(c[o]) || i(c, o, function() {
    return this;
  }), a1 = {
    IteratorPrototype: c,
    BUGGY_SAFARI_ITERATORS: l
  }, a1;
}
var o1, U4;
function vZ() {
  if (U4) return o1;
  U4 = 1;
  var e = CH().IteratorPrototype, A = Mp(), t = Xy(), r = Np(), n = Rp(), i = function() {
    return this;
  };
  return o1 = function(s, a, o, l) {
    var c = a + " Iterator";
    return s.prototype = A(e, { next: t(+!l, o) }), r(s, c, !1, !0), n[c] = i, s;
  }, o1;
}
var l1, E4;
function yZ() {
  if (E4) return l1;
  E4 = 1;
  var e = Zn(), A = cn(), t = ea(), r = Hp(), n = ur(), i = vZ(), s = yH(), a = oH(), o = Np(), l = rf(), c = ic(), u = Yr(), d = Rp(), h = CH(), p = r.PROPER, B = r.CONFIGURABLE, y = h.IteratorPrototype, m = h.BUGGY_SAFARI_ITERATORS, C = u("iterator"), Q = "keys", F = "values", T = "entries", V = function() {
    return this;
  };
  return l1 = function(M, D, I, q, U, x, P) {
    i(I, D, q);
    var N = function(Y) {
      if (Y === U && cA) return cA;
      if (!m && Y && Y in sA) return sA[Y];
      switch (Y) {
        case Q:
          return function() {
            return new I(this, Y);
          };
        case F:
          return function() {
            return new I(this, Y);
          };
        case T:
          return function() {
            return new I(this, Y);
          };
      }
      return function() {
        return new I(this);
      };
    }, iA = D + " Iterator", nA = !1, sA = M.prototype, tA = sA[C] || sA["@@iterator"] || U && sA[U], cA = !m && tA || N(U), FA = D === "Array" && sA.entries || tA, CA, S, W;
    if (FA && (CA = s(FA.call(new M())), CA !== Object.prototype && CA.next && (!t && s(CA) !== y && (a ? a(CA, y) : n(CA[C]) || c(CA, C, V)), o(CA, iA, !0, !0), t && (d[iA] = V))), p && U === F && tA && tA.name !== F && (!t && B ? l(sA, "name", F) : (nA = !0, cA = function() {
      return A(tA, this);
    })), U)
      if (S = {
        values: N(F),
        keys: x ? cA : N(Q),
        entries: N(T)
      }, P) for (W in S)
        (m || nA || !(W in sA)) && c(sA, W, S[W]);
      else e({ target: D, proto: !0, forced: m || nA }, S);
    return (!t || P) && sA[C] !== cA && c(sA, C, cA, { name: U }), d[D] = cA, S;
  }, l1;
}
var c1, x4;
function CZ() {
  return x4 || (x4 = 1, c1 = function(e, A) {
    return { value: e, done: A };
  }), c1;
}
var u1, I4;
function bH() {
  if (I4) return u1;
  I4 = 1;
  var e = ef(), A = wZ(), t = Rp(), r = Tp(), n = jo().f, i = yZ(), s = CZ(), a = ea(), o = Es(), l = "Array Iterator", c = r.set, u = r.getterFor(l);
  u1 = i(Array, "Array", function(h, p) {
    c(this, {
      type: l,
      target: e(h),
      // target
      index: 0,
      // next index
      kind: p
      // kind
    });
  }, function() {
    var h = u(this), p = h.target, B = h.index++;
    if (!p || B >= p.length)
      return h.target = null, s(void 0, !0);
    switch (h.kind) {
      case "keys":
        return s(B, !1);
      case "values":
        return s(p[B], !1);
    }
    return s([B, p[B]], !1);
  }, "values");
  var d = t.Arguments = t.Array;
  if (A("keys"), A("values"), A("entries"), !a && o && d.name !== "values") try {
    n(d, "name", { value: "values" });
  } catch {
  }
  return u1;
}
bH();
var S4 = {}, h1, L4;
function bZ() {
  return L4 || (L4 = 1, h1 = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }), h1;
}
var f1, H4;
function FZ() {
  if (H4) return f1;
  H4 = 1;
  var e = Sp(), A = e("span").classList, t = A && A.constructor && A.constructor.prototype;
  return f1 = t === Object.prototype ? void 0 : t, f1;
}
var T4;
function QZ() {
  if (T4) return S4;
  T4 = 1;
  var e = Kt(), A = bZ(), t = FZ(), r = bH(), n = rf(), i = Np(), s = Yr(), a = s("iterator"), o = r.values, l = function(u, d) {
    if (u) {
      if (u[a] !== o) try {
        n(u, a, o);
      } catch {
        u[a] = o;
      }
      if (i(u, d, !0), A[d]) {
        for (var h in r)
          if (u[h] !== r[h]) try {
            n(u, h, r[h]);
          } catch {
            u[h] = r[h];
          }
      }
    }
  };
  for (var c in A)
    l(e[c] && e[c].prototype, c);
  return l(t, "DOMTokenList"), S4;
}
QZ();
function UZ(e, A) {
  if (it(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, A);
    if (it(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (A === "string" ? String : Number)(e);
}
function EZ(e) {
  var A = UZ(e, "string");
  return it(A) == "symbol" ? A : A + "";
}
function d2(e, A, t) {
  return (A = EZ(A)) in e ? Object.defineProperty(e, A, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[A] = t, e;
}
var _4 = {}, d1, O4;
function xZ() {
  if (O4) return d1;
  O4 = 1;
  var e = Wo(), A = Ip(), t = zL(), r = n2(), n = TypeError, i = "Reduce of empty array with no initial value", s = function(a) {
    return function(o, l, c, u) {
      var d = A(o), h = t(d), p = r(d);
      if (e(l), p === 0 && c < 2) throw new n(i);
      var B = a ? p - 1 : 0, y = a ? -1 : 1;
      if (c < 2) for (; ; ) {
        if (B in h) {
          u = h[B], B += y;
          break;
        }
        if (B += y, a ? B < 0 : p <= B)
          throw new n(i);
      }
      for (; a ? B >= 0 : p > B; B += y) B in h && (u = l(u, h[B], B, d));
      return u;
    };
  };
  return d1 = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: s(!1),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: s(!0)
  }, d1;
}
var g1, N4;
function FH() {
  if (N4) return g1;
  N4 = 1;
  var e = lr();
  return g1 = function(A, t) {
    var r = [][A];
    return !!r && e(function() {
      r.call(null, t || function() {
        return 1;
      }, 1);
    });
  }, g1;
}
var D4;
function IZ() {
  if (D4) return _4;
  D4 = 1;
  var e = Zn(), A = xZ().left, t = FH(), r = Yy(), n = Op(), i = !n && r > 79 && r < 83, s = i || !t("reduce");
  return e({ target: "Array", proto: !0, forced: s }, {
    reduce: function(o) {
      var l = arguments.length;
      return A(this, o, l, l > 1 ? arguments[1] : void 0);
    }
  }), _4;
}
IZ();
var R4 = {}, M4;
function SZ() {
  if (M4) return R4;
  M4 = 1;
  var e = Zn(), A = Dp(), t = Lp().f, r = su(), n = ta(), i = h2(), s = xs(), a = f2(), o = ea(), l = A("".slice), c = Math.min, u = a("endsWith"), d = !o && !u && !!(function() {
    var h = t(String.prototype, "endsWith");
    return h && !h.writable;
  })();
  return e({ target: "String", proto: !0, forced: !d && !u }, {
    endsWith: function(p) {
      var B = n(s(this));
      i(p);
      var y = n(p), m = arguments.length > 1 ? arguments[1] : void 0, C = B.length, Q = m === void 0 ? C : c(r(m), C);
      return l(B, Q - y.length, Q) === y;
    }
  }), R4;
}
SZ();
var P4 = {}, k4;
function LZ() {
  if (k4) return P4;
  k4 = 1;
  var e = cn(), A = cr(), t = l2(), r = Jn(), n = ci(), i = xs(), s = cH(), a = c2(), o = su(), l = ta(), c = iu(), u = Pp(), d = u2(), h = vH(), p = lr(), B = h.UNSUPPORTED_Y, y = 4294967295, m = Math.min, C = A([].push), Q = A("".slice), F = A("".indexOf), T = !p(function() {
    var M = /(?:)/, D = M.exec;
    M.exec = function() {
      return D.apply(this, arguments);
    };
    var I = "ab".split(M);
    return I.length !== 2 || I[0] !== "a" || I[1] !== "b";
  }), V = "abbc".split(/(b)*/)[1] === "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
  "test".split(/(?:)/, -1).length !== 4 || "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  ".".split(/()()/).length > 1 || "".split(/.?/).length;
  return t("split", function(M, D, I) {
    var q = "0".split(void 0, 0).length ? function(U, x) {
      return U === void 0 && x === 0 ? [] : e(D, this, U, x);
    } : D;
    return [
      // `String.prototype.split` method
      // https://tc39.es/ecma262/#sec-string.prototype.split
      function(x, P) {
        var N = i(this), iA = n(x) ? c(x, M) : void 0;
        return iA ? e(iA, x, N, P) : e(q, l(N), x, P);
      },
      // `RegExp.prototype[@@split]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
      //
      // NOTE: This cannot be properly polyfilled in engines that don't support
      // the 'y' flag.
      function(U, x) {
        var P = r(this), N = l(U);
        if (!V) {
          var iA = I(q, P, N, x, q !== D);
          if (iA.done) return iA.value;
        }
        var nA = s(P, RegExp), sA = l(u(P)), tA = !!~F(sA, "u") || !!~F(sA, "v");
        B ? ~F(sA, "g") || (sA += "g") : ~F(sA, "y") || (sA += "y");
        var cA = new nA(B ? "^(?:" + P.source + ")" : P, sA), FA = x === void 0 ? y : x >>> 0;
        if (FA === 0) return [];
        if (N.length === 0) return d(cA, N) === null ? [N] : [];
        for (var CA = 0, S = 0, W = []; S < N.length; ) {
          cA.lastIndex = B ? 0 : S;
          var Y = d(cA, B ? Q(N, S) : N), AA;
          if (Y === null || (AA = m(o(cA.lastIndex + (B ? S : 0)), N.length)) === CA)
            S = a(N, S, tA);
          else {
            if (C(W, Q(N, CA, S)), W.length === FA) return W;
            for (var oA = 1; oA <= Y.length - 1; oA++)
              if (C(W, Y[oA]), W.length === FA) return W;
            S = CA = AA;
          }
        }
        return C(W, Q(N, CA)), W;
      }
    ];
  }, V || !T, B), P4;
}
LZ();
var Vu = { exports: {} }, vl = { exports: {} }, HZ = vl.exports, K4;
function TZ() {
  return K4 || (K4 = 1, (function() {
    var e, A, t, r, n, i;
    typeof performance < "u" && performance !== null && performance.now ? vl.exports = function() {
      return performance.now();
    } : typeof process < "u" && process !== null && process.hrtime ? (vl.exports = function() {
      return (e() - n) / 1e6;
    }, A = process.hrtime, e = function() {
      var s;
      return s = A(), s[0] * 1e9 + s[1];
    }, r = e(), i = process.uptime() * 1e9, n = r - i) : Date.now ? (vl.exports = function() {
      return Date.now() - t;
    }, t = Date.now()) : (vl.exports = function() {
      return (/* @__PURE__ */ new Date()).getTime() - t;
    }, t = (/* @__PURE__ */ new Date()).getTime());
  }).call(HZ)), vl.exports;
}
var V4;
function _Z() {
  if (V4) return Vu.exports;
  V4 = 1;
  for (var e = TZ(), A = typeof window > "u" ? Yv : window, t = ["moz", "webkit"], r = "AnimationFrame", n = A["request" + r], i = A["cancel" + r] || A["cancelRequest" + r], s = 0; !n && s < t.length; s++)
    n = A[t[s] + "Request" + r], i = A[t[s] + "Cancel" + r] || A[t[s] + "CancelRequest" + r];
  if (!n || !i) {
    var a = 0, o = 0, l = [], c = 1e3 / 60;
    n = function(u) {
      if (l.length === 0) {
        var d = e(), h = Math.max(0, c - (d - a));
        a = h + d, setTimeout(function() {
          var p = l.slice(0);
          l.length = 0;
          for (var B = 0; B < p.length; B++)
            if (!p[B].cancelled)
              try {
                p[B].callback(a);
              } catch (y) {
                setTimeout(function() {
                  throw y;
                }, 0);
              }
        }, Math.round(h));
      }
      return l.push({
        handle: ++o,
        callback: u,
        cancelled: !1
      }), o;
    }, i = function(u) {
      for (var d = 0; d < l.length; d++)
        l[d].handle === u && (l[d].cancelled = !0);
    };
  }
  return Vu.exports = function(u) {
    return n.call(A, u);
  }, Vu.exports.cancel = function() {
    i.apply(A, arguments);
  }, Vu.exports.polyfill = function(u) {
    u || (u = A), u.requestAnimationFrame = n, u.cancelAnimationFrame = i;
  }, Vu.exports;
}
var OZ = _Z();
const p1 = /* @__PURE__ */ $L(OZ);
var G4 = {}, B1, W4;
function QH() {
  return W4 || (W4 = 1, B1 = `	
\v\f\r                　\u2028\u2029\uFEFF`), B1;
}
var w1, j4;
function NZ() {
  if (j4) return w1;
  j4 = 1;
  var e = cr(), A = xs(), t = ta(), r = QH(), n = e("".replace), i = RegExp("^[" + r + "]+"), s = RegExp("(^|[^" + r + "])[" + r + "]+$"), a = function(o) {
    return function(l) {
      var c = t(A(l));
      return o & 1 && (c = n(c, i, "")), o & 2 && (c = n(c, s, "$1")), c;
    };
  };
  return w1 = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: a(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: a(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: a(3)
  }, w1;
}
var m1, q4;
function DZ() {
  if (q4) return m1;
  q4 = 1;
  var e = Hp().PROPER, A = lr(), t = QH(), r = "​᠎";
  return m1 = function(n) {
    return A(function() {
      return !!t[n]() || r[n]() !== r || e && t[n].name !== n;
    });
  }, m1;
}
var $4;
function RZ() {
  if ($4) return G4;
  $4 = 1;
  var e = Zn(), A = NZ().trim, t = DZ();
  return e({ target: "String", proto: !0, forced: t("trim") }, {
    trim: function() {
      return A(this);
    }
  }), G4;
}
RZ();
var v1, z4;
function MZ() {
  return z4 || (z4 = 1, v1 = function(e) {
    this.ok = !1, this.alpha = 1, e.charAt(0) == "#" && (e = e.substr(1, 6)), e = e.replace(/ /g, ""), e = e.toLowerCase();
    var A = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "00ffff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000000",
      blanchedalmond: "ffebcd",
      blue: "0000ff",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "00ffff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dodgerblue: "1e90ff",
      feldspar: "d19275",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "ff00ff",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgrey: "d3d3d3",
      lightgreen: "90ee90",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslateblue: "8470ff",
      lightslategray: "778899",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "00ff00",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "ff00ff",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370d8",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "d87093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "ff0000",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      violetred: "d02090",
      wheat: "f5deb3",
      white: "ffffff",
      whitesmoke: "f5f5f5",
      yellow: "ffff00",
      yellowgreen: "9acd32"
    };
    e = A[e] || e;
    for (var t = [
      {
        re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
        example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
        process: function(o) {
          return [
            parseInt(o[1]),
            parseInt(o[2]),
            parseInt(o[3]),
            parseFloat(o[4])
          ];
        }
      },
      {
        re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
        process: function(o) {
          return [
            parseInt(o[1]),
            parseInt(o[2]),
            parseInt(o[3])
          ];
        }
      },
      {
        re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        example: ["#00ff00", "336699"],
        process: function(o) {
          return [
            parseInt(o[1], 16),
            parseInt(o[2], 16),
            parseInt(o[3], 16)
          ];
        }
      },
      {
        re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        example: ["#fb0", "f0f"],
        process: function(o) {
          return [
            parseInt(o[1] + o[1], 16),
            parseInt(o[2] + o[2], 16),
            parseInt(o[3] + o[3], 16)
          ];
        }
      }
    ], r = 0; r < t.length; r++) {
      var n = t[r].re, i = t[r].process, s = n.exec(e);
      if (s) {
        var a = i(s);
        this.r = a[0], this.g = a[1], this.b = a[2], a.length > 3 && (this.alpha = a[3]), this.ok = !0;
      }
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha, this.toRGB = function() {
      return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toRGBA = function() {
      return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
    }, this.toHex = function() {
      var o = this.r.toString(16), l = this.g.toString(16), c = this.b.toString(16);
      return o.length == 1 && (o = "0" + o), l.length == 1 && (l = "0" + l), c.length == 1 && (c = "0" + c), "#" + o + l + c;
    }, this.getHelpXML = function() {
      for (var o = new Array(), l = 0; l < t.length; l++)
        for (var c = t[l].example, u = 0; u < c.length; u++)
          o[o.length] = c[u];
      for (var d in A)
        o[o.length] = d;
      var h = document.createElement("ul");
      h.setAttribute("id", "rgbcolor-examples");
      for (var l = 0; l < o.length; l++)
        try {
          var p = document.createElement("li"), B = new RGBColor(o[l]), y = document.createElement("div");
          y.style.cssText = "margin: 3px; border: 1px solid black; background:" + B.toHex() + "; color:" + B.toHex(), y.appendChild(document.createTextNode("test"));
          var m = document.createTextNode(
            " " + o[l] + " -> " + B.toRGB() + " -> " + B.toHex()
          );
          p.appendChild(y), p.appendChild(m), h.appendChild(p);
        } catch {
        }
      return h;
    };
  }), v1;
}
var PZ = MZ();
const Jv = /* @__PURE__ */ $L(PZ);
var X4 = {}, Y4;
function kZ() {
  if (Y4) return X4;
  Y4 = 1;
  var e = Zn(), A = Dp(), t = nH().indexOf, r = FH(), n = A([].indexOf), i = !!n && 1 / n([1], 1, -0) < 0, s = i || !r("indexOf");
  return e({ target: "Array", proto: !0, forced: s }, {
    indexOf: function(o) {
      var l = arguments.length > 1 ? arguments[1] : void 0;
      return i ? n(this, o, l) || 0 : t(this, o, l);
    }
  }), X4;
}
kZ();
var J4 = {}, Z4;
function KZ() {
  if (Z4) return J4;
  Z4 = 1;
  var e = Zn(), A = cr(), t = h2(), r = xs(), n = ta(), i = f2(), s = A("".indexOf);
  return e({ target: "String", proto: !0, forced: !i("includes") }, {
    includes: function(o) {
      return !!~s(
        n(r(this)),
        n(t(o)),
        arguments.length > 1 ? arguments[1] : void 0
      );
    }
  }), J4;
}
KZ();
var Ax = {}, y1, ex;
function VZ() {
  if (ex) return y1;
  ex = 1;
  var e = Go();
  return y1 = Array.isArray || function(t) {
    return e(t) === "Array";
  }, y1;
}
var tx;
function GZ() {
  if (tx) return Ax;
  tx = 1;
  var e = Zn(), A = cr(), t = VZ(), r = A([].reverse), n = [1, 2];
  return e({ target: "Array", proto: !0, forced: String(n) === String(n.reverse()) }, {
    reverse: function() {
      return t(this) && (this.length = this.length), r(this);
    }
  }), Ax;
}
GZ();
var UH = function(e, A) {
  return (UH = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  })(e, A);
};
function EH(e, A) {
  if (typeof A != "function" && A !== null) throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
  function t() {
    this.constructor = e;
  }
  UH(e, A), e.prototype = A === null ? Object.create(A) : (t.prototype = A.prototype, new t());
}
function WZ(e) {
  var A = "";
  Array.isArray(e) || (e = [e]);
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    if (r.type === XA.CLOSE_PATH) A += "z";
    else if (r.type === XA.HORIZ_LINE_TO) A += (r.relative ? "h" : "H") + r.x;
    else if (r.type === XA.VERT_LINE_TO) A += (r.relative ? "v" : "V") + r.y;
    else if (r.type === XA.MOVE_TO) A += (r.relative ? "m" : "M") + r.x + " " + r.y;
    else if (r.type === XA.LINE_TO) A += (r.relative ? "l" : "L") + r.x + " " + r.y;
    else if (r.type === XA.CURVE_TO) A += (r.relative ? "c" : "C") + r.x1 + " " + r.y1 + " " + r.x2 + " " + r.y2 + " " + r.x + " " + r.y;
    else if (r.type === XA.SMOOTH_CURVE_TO) A += (r.relative ? "s" : "S") + r.x2 + " " + r.y2 + " " + r.x + " " + r.y;
    else if (r.type === XA.QUAD_TO) A += (r.relative ? "q" : "Q") + r.x1 + " " + r.y1 + " " + r.x + " " + r.y;
    else if (r.type === XA.SMOOTH_QUAD_TO) A += (r.relative ? "t" : "T") + r.x + " " + r.y;
    else {
      if (r.type !== XA.ARC) throw new Error('Unexpected command type "' + r.type + '" at index ' + t + ".");
      A += (r.relative ? "a" : "A") + r.rX + " " + r.rY + " " + r.xRot + " " + +r.lArcFlag + " " + +r.sweepFlag + " " + r.x + " " + r.y;
    }
  }
  return A;
}
function Zv(e, A) {
  var t = e[0], r = e[1];
  return [t * Math.cos(A) - r * Math.sin(A), t * Math.sin(A) + r * Math.cos(A)];
}
function ps() {
  for (var e = [], A = 0; A < arguments.length; A++) e[A] = arguments[A];
  for (var t = 0; t < e.length; t++) if (typeof e[t] != "number") throw new Error("assertNumbers arguments[" + t + "] is not a number. " + typeof e[t] + " == typeof " + e[t]);
  return !0;
}
var bo = Math.PI;
function C1(e, A, t) {
  e.lArcFlag = e.lArcFlag === 0 ? 0 : 1, e.sweepFlag = e.sweepFlag === 0 ? 0 : 1;
  var r = e.rX, n = e.rY, i = e.x, s = e.y;
  r = Math.abs(e.rX), n = Math.abs(e.rY);
  var a = Zv([(A - i) / 2, (t - s) / 2], -e.xRot / 180 * bo), o = a[0], l = a[1], c = Math.pow(o, 2) / Math.pow(r, 2) + Math.pow(l, 2) / Math.pow(n, 2);
  1 < c && (r *= Math.sqrt(c), n *= Math.sqrt(c)), e.rX = r, e.rY = n;
  var u = Math.pow(r, 2) * Math.pow(l, 2) + Math.pow(n, 2) * Math.pow(o, 2), d = (e.lArcFlag !== e.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(r, 2) * Math.pow(n, 2) - u) / u)), h = r * l / n * d, p = -n * o / r * d, B = Zv([h, p], e.xRot / 180 * bo);
  e.cX = B[0] + (A + i) / 2, e.cY = B[1] + (t + s) / 2, e.phi1 = Math.atan2((l - p) / n, (o - h) / r), e.phi2 = Math.atan2((-l - p) / n, (-o - h) / r), e.sweepFlag === 0 && e.phi2 > e.phi1 && (e.phi2 -= 2 * bo), e.sweepFlag === 1 && e.phi2 < e.phi1 && (e.phi2 += 2 * bo), e.phi1 *= 180 / bo, e.phi2 *= 180 / bo;
}
function rx(e, A, t) {
  ps(e, A, t);
  var r = e * e + A * A - t * t;
  if (0 > r) return [];
  if (r === 0) return [[e * t / (e * e + A * A), A * t / (e * e + A * A)]];
  var n = Math.sqrt(r);
  return [[(e * t + A * n) / (e * e + A * A), (A * t - e * n) / (e * e + A * A)], [(e * t - A * n) / (e * e + A * A), (A * t + e * n) / (e * e + A * A)]];
}
var xr, Ca = Math.PI / 180;
function nx(e, A, t) {
  return (1 - t) * e + t * A;
}
function ix(e, A, t, r) {
  return e + Math.cos(r / 180 * bo) * A + Math.sin(r / 180 * bo) * t;
}
function sx(e, A, t, r) {
  var n = 1e-6, i = A - e, s = t - A, a = 3 * i + 3 * (r - t) - 6 * s, o = 6 * (s - i), l = 3 * i;
  return Math.abs(a) < n ? [-l / o] : (function(c, u, d) {
    var h = c * c / 4 - u;
    if (h < -d) return [];
    if (h <= d) return [-c / 2];
    var p = Math.sqrt(h);
    return [-c / 2 - p, -c / 2 + p];
  })(o / a, l / a, n);
}
function ax(e, A, t, r, n) {
  var i = 1 - n;
  return e * (i * i * i) + A * (3 * i * i * n) + t * (3 * i * n * n) + r * (n * n * n);
}
(function(e) {
  function A() {
    return n((function(a, o, l) {
      return a.relative && (a.x1 !== void 0 && (a.x1 += o), a.y1 !== void 0 && (a.y1 += l), a.x2 !== void 0 && (a.x2 += o), a.y2 !== void 0 && (a.y2 += l), a.x !== void 0 && (a.x += o), a.y !== void 0 && (a.y += l), a.relative = !1), a;
    }));
  }
  function t() {
    var a = NaN, o = NaN, l = NaN, c = NaN;
    return n((function(u, d, h) {
      return u.type & XA.SMOOTH_CURVE_TO && (u.type = XA.CURVE_TO, a = isNaN(a) ? d : a, o = isNaN(o) ? h : o, u.x1 = u.relative ? d - a : 2 * d - a, u.y1 = u.relative ? h - o : 2 * h - o), u.type & XA.CURVE_TO ? (a = u.relative ? d + u.x2 : u.x2, o = u.relative ? h + u.y2 : u.y2) : (a = NaN, o = NaN), u.type & XA.SMOOTH_QUAD_TO && (u.type = XA.QUAD_TO, l = isNaN(l) ? d : l, c = isNaN(c) ? h : c, u.x1 = u.relative ? d - l : 2 * d - l, u.y1 = u.relative ? h - c : 2 * h - c), u.type & XA.QUAD_TO ? (l = u.relative ? d + u.x1 : u.x1, c = u.relative ? h + u.y1 : u.y1) : (l = NaN, c = NaN), u;
    }));
  }
  function r() {
    var a = NaN, o = NaN;
    return n((function(l, c, u) {
      if (l.type & XA.SMOOTH_QUAD_TO && (l.type = XA.QUAD_TO, a = isNaN(a) ? c : a, o = isNaN(o) ? u : o, l.x1 = l.relative ? c - a : 2 * c - a, l.y1 = l.relative ? u - o : 2 * u - o), l.type & XA.QUAD_TO) {
        a = l.relative ? c + l.x1 : l.x1, o = l.relative ? u + l.y1 : l.y1;
        var d = l.x1, h = l.y1;
        l.type = XA.CURVE_TO, l.x1 = ((l.relative ? 0 : c) + 2 * d) / 3, l.y1 = ((l.relative ? 0 : u) + 2 * h) / 3, l.x2 = (l.x + 2 * d) / 3, l.y2 = (l.y + 2 * h) / 3;
      } else a = NaN, o = NaN;
      return l;
    }));
  }
  function n(a) {
    var o = 0, l = 0, c = NaN, u = NaN;
    return function(d) {
      if (isNaN(c) && !(d.type & XA.MOVE_TO)) throw new Error("path must start with moveto");
      var h = a(d, o, l, c, u);
      return d.type & XA.CLOSE_PATH && (o = c, l = u), d.x !== void 0 && (o = d.relative ? o + d.x : d.x), d.y !== void 0 && (l = d.relative ? l + d.y : d.y), d.type & XA.MOVE_TO && (c = o, u = l), h;
    };
  }
  function i(a, o, l, c, u, d) {
    return ps(a, o, l, c, u, d), n((function(h, p, B, y) {
      var m = h.x1, C = h.x2, Q = h.relative && !isNaN(y), F = h.x !== void 0 ? h.x : Q ? 0 : p, T = h.y !== void 0 ? h.y : Q ? 0 : B;
      function V(S) {
        return S * S;
      }
      h.type & XA.HORIZ_LINE_TO && o !== 0 && (h.type = XA.LINE_TO, h.y = h.relative ? 0 : B), h.type & XA.VERT_LINE_TO && l !== 0 && (h.type = XA.LINE_TO, h.x = h.relative ? 0 : p), h.x !== void 0 && (h.x = h.x * a + T * l + (Q ? 0 : u)), h.y !== void 0 && (h.y = F * o + h.y * c + (Q ? 0 : d)), h.x1 !== void 0 && (h.x1 = h.x1 * a + h.y1 * l + (Q ? 0 : u)), h.y1 !== void 0 && (h.y1 = m * o + h.y1 * c + (Q ? 0 : d)), h.x2 !== void 0 && (h.x2 = h.x2 * a + h.y2 * l + (Q ? 0 : u)), h.y2 !== void 0 && (h.y2 = C * o + h.y2 * c + (Q ? 0 : d));
      var M = a * c - o * l;
      if (h.xRot !== void 0 && (a !== 1 || o !== 0 || l !== 0 || c !== 1)) if (M === 0) delete h.rX, delete h.rY, delete h.xRot, delete h.lArcFlag, delete h.sweepFlag, h.type = XA.LINE_TO;
      else {
        var D = h.xRot * Math.PI / 180, I = Math.sin(D), q = Math.cos(D), U = 1 / V(h.rX), x = 1 / V(h.rY), P = V(q) * U + V(I) * x, N = 2 * I * q * (U - x), iA = V(I) * U + V(q) * x, nA = P * c * c - N * o * c + iA * o * o, sA = N * (a * c + o * l) - 2 * (P * l * c + iA * a * o), tA = P * l * l - N * a * l + iA * a * a, cA = (Math.atan2(sA, nA - tA) + Math.PI) % Math.PI / 2, FA = Math.sin(cA), CA = Math.cos(cA);
        h.rX = Math.abs(M) / Math.sqrt(nA * V(CA) + sA * FA * CA + tA * V(FA)), h.rY = Math.abs(M) / Math.sqrt(nA * V(FA) - sA * FA * CA + tA * V(CA)), h.xRot = 180 * cA / Math.PI;
      }
      return h.sweepFlag !== void 0 && 0 > M && (h.sweepFlag = +!h.sweepFlag), h;
    }));
  }
  function s() {
    return function(a) {
      var o = {};
      for (var l in a) o[l] = a[l];
      return o;
    };
  }
  e.ROUND = function(a) {
    function o(l) {
      return Math.round(l * a) / a;
    }
    return a === void 0 && (a = 1e13), ps(a), function(l) {
      return l.x1 !== void 0 && (l.x1 = o(l.x1)), l.y1 !== void 0 && (l.y1 = o(l.y1)), l.x2 !== void 0 && (l.x2 = o(l.x2)), l.y2 !== void 0 && (l.y2 = o(l.y2)), l.x !== void 0 && (l.x = o(l.x)), l.y !== void 0 && (l.y = o(l.y)), l.rX !== void 0 && (l.rX = o(l.rX)), l.rY !== void 0 && (l.rY = o(l.rY)), l;
    };
  }, e.TO_ABS = A, e.TO_REL = function() {
    return n((function(a, o, l) {
      return a.relative || (a.x1 !== void 0 && (a.x1 -= o), a.y1 !== void 0 && (a.y1 -= l), a.x2 !== void 0 && (a.x2 -= o), a.y2 !== void 0 && (a.y2 -= l), a.x !== void 0 && (a.x -= o), a.y !== void 0 && (a.y -= l), a.relative = !0), a;
    }));
  }, e.NORMALIZE_HVZ = function(a, o, l) {
    return a === void 0 && (a = !0), o === void 0 && (o = !0), l === void 0 && (l = !0), n((function(c, u, d, h, p) {
      if (isNaN(h) && !(c.type & XA.MOVE_TO)) throw new Error("path must start with moveto");
      return o && c.type & XA.HORIZ_LINE_TO && (c.type = XA.LINE_TO, c.y = c.relative ? 0 : d), l && c.type & XA.VERT_LINE_TO && (c.type = XA.LINE_TO, c.x = c.relative ? 0 : u), a && c.type & XA.CLOSE_PATH && (c.type = XA.LINE_TO, c.x = c.relative ? h - u : h, c.y = c.relative ? p - d : p), c.type & XA.ARC && (c.rX === 0 || c.rY === 0) && (c.type = XA.LINE_TO, delete c.rX, delete c.rY, delete c.xRot, delete c.lArcFlag, delete c.sweepFlag), c;
    }));
  }, e.NORMALIZE_ST = t, e.QT_TO_C = r, e.INFO = n, e.SANITIZE = function(a) {
    a === void 0 && (a = 0), ps(a);
    var o = NaN, l = NaN, c = NaN, u = NaN;
    return n((function(d, h, p, B, y) {
      var m = Math.abs, C = !1, Q = 0, F = 0;
      if (d.type & XA.SMOOTH_CURVE_TO && (Q = isNaN(o) ? 0 : h - o, F = isNaN(l) ? 0 : p - l), d.type & (XA.CURVE_TO | XA.SMOOTH_CURVE_TO) ? (o = d.relative ? h + d.x2 : d.x2, l = d.relative ? p + d.y2 : d.y2) : (o = NaN, l = NaN), d.type & XA.SMOOTH_QUAD_TO ? (c = isNaN(c) ? h : 2 * h - c, u = isNaN(u) ? p : 2 * p - u) : d.type & XA.QUAD_TO ? (c = d.relative ? h + d.x1 : d.x1, u = d.relative ? p + d.y1 : d.y2) : (c = NaN, u = NaN), d.type & XA.LINE_COMMANDS || d.type & XA.ARC && (d.rX === 0 || d.rY === 0 || !d.lArcFlag) || d.type & XA.CURVE_TO || d.type & XA.SMOOTH_CURVE_TO || d.type & XA.QUAD_TO || d.type & XA.SMOOTH_QUAD_TO) {
        var T = d.x === void 0 ? 0 : d.relative ? d.x : d.x - h, V = d.y === void 0 ? 0 : d.relative ? d.y : d.y - p;
        Q = isNaN(c) ? d.x1 === void 0 ? Q : d.relative ? d.x : d.x1 - h : c - h, F = isNaN(u) ? d.y1 === void 0 ? F : d.relative ? d.y : d.y1 - p : u - p;
        var M = d.x2 === void 0 ? 0 : d.relative ? d.x : d.x2 - h, D = d.y2 === void 0 ? 0 : d.relative ? d.y : d.y2 - p;
        m(T) <= a && m(V) <= a && m(Q) <= a && m(F) <= a && m(M) <= a && m(D) <= a && (C = !0);
      }
      return d.type & XA.CLOSE_PATH && m(h - B) <= a && m(p - y) <= a && (C = !0), C ? [] : d;
    }));
  }, e.MATRIX = i, e.ROTATE = function(a, o, l) {
    o === void 0 && (o = 0), l === void 0 && (l = 0), ps(a, o, l);
    var c = Math.sin(a), u = Math.cos(a);
    return i(u, c, -c, u, o - o * u + l * c, l - o * c - l * u);
  }, e.TRANSLATE = function(a, o) {
    return o === void 0 && (o = 0), ps(a, o), i(1, 0, 0, 1, a, o);
  }, e.SCALE = function(a, o) {
    return o === void 0 && (o = a), ps(a, o), i(a, 0, 0, o, 0, 0);
  }, e.SKEW_X = function(a) {
    return ps(a), i(1, 0, Math.atan(a), 1, 0, 0);
  }, e.SKEW_Y = function(a) {
    return ps(a), i(1, Math.atan(a), 0, 1, 0, 0);
  }, e.X_AXIS_SYMMETRY = function(a) {
    return a === void 0 && (a = 0), ps(a), i(-1, 0, 0, 1, a, 0);
  }, e.Y_AXIS_SYMMETRY = function(a) {
    return a === void 0 && (a = 0), ps(a), i(1, 0, 0, -1, 0, a);
  }, e.A_TO_C = function() {
    return n((function(a, o, l) {
      return XA.ARC === a.type ? (function(c, u, d) {
        var h, p, B, y;
        c.cX || C1(c, u, d);
        for (var m = Math.min(c.phi1, c.phi2), C = Math.max(c.phi1, c.phi2) - m, Q = Math.ceil(C / 90), F = new Array(Q), T = u, V = d, M = 0; M < Q; M++) {
          var D = nx(c.phi1, c.phi2, M / Q), I = nx(c.phi1, c.phi2, (M + 1) / Q), q = I - D, U = 4 / 3 * Math.tan(q * Ca / 4), x = [Math.cos(D * Ca) - U * Math.sin(D * Ca), Math.sin(D * Ca) + U * Math.cos(D * Ca)], P = x[0], N = x[1], iA = [Math.cos(I * Ca), Math.sin(I * Ca)], nA = iA[0], sA = iA[1], tA = [nA + U * Math.sin(I * Ca), sA - U * Math.cos(I * Ca)], cA = tA[0], FA = tA[1];
          F[M] = { relative: c.relative, type: XA.CURVE_TO };
          var CA = function(S, W) {
            var Y = Zv([S * c.rX, W * c.rY], c.xRot), AA = Y[0], oA = Y[1];
            return [c.cX + AA, c.cY + oA];
          };
          h = CA(P, N), F[M].x1 = h[0], F[M].y1 = h[1], p = CA(cA, FA), F[M].x2 = p[0], F[M].y2 = p[1], B = CA(nA, sA), F[M].x = B[0], F[M].y = B[1], c.relative && (F[M].x1 -= T, F[M].y1 -= V, F[M].x2 -= T, F[M].y2 -= V, F[M].x -= T, F[M].y -= V), T = (y = [F[M].x, F[M].y])[0], V = y[1];
        }
        return F;
      })(a, a.relative ? 0 : o, a.relative ? 0 : l) : a;
    }));
  }, e.ANNOTATE_ARCS = function() {
    return n((function(a, o, l) {
      return a.relative && (o = 0, l = 0), XA.ARC === a.type && C1(a, o, l), a;
    }));
  }, e.CLONE = s, e.CALCULATE_BOUNDS = function() {
    var a = function(d) {
      var h = {};
      for (var p in d) h[p] = d[p];
      return h;
    }, o = A(), l = r(), c = t(), u = n((function(d, h, p) {
      var B = c(l(o(a(d))));
      function y(FA) {
        FA > u.maxX && (u.maxX = FA), FA < u.minX && (u.minX = FA);
      }
      function m(FA) {
        FA > u.maxY && (u.maxY = FA), FA < u.minY && (u.minY = FA);
      }
      if (B.type & XA.DRAWING_COMMANDS && (y(h), m(p)), B.type & XA.HORIZ_LINE_TO && y(B.x), B.type & XA.VERT_LINE_TO && m(B.y), B.type & XA.LINE_TO && (y(B.x), m(B.y)), B.type & XA.CURVE_TO) {
        y(B.x), m(B.y);
        for (var C = 0, Q = sx(h, B.x1, B.x2, B.x); C < Q.length; C++)
          0 < (cA = Q[C]) && 1 > cA && y(ax(h, B.x1, B.x2, B.x, cA));
        for (var F = 0, T = sx(p, B.y1, B.y2, B.y); F < T.length; F++)
          0 < (cA = T[F]) && 1 > cA && m(ax(p, B.y1, B.y2, B.y, cA));
      }
      if (B.type & XA.ARC) {
        y(B.x), m(B.y), C1(B, h, p);
        for (var V = B.xRot / 180 * Math.PI, M = Math.cos(V) * B.rX, D = Math.sin(V) * B.rX, I = -Math.sin(V) * B.rY, q = Math.cos(V) * B.rY, U = B.phi1 < B.phi2 ? [B.phi1, B.phi2] : -180 > B.phi2 ? [B.phi2 + 360, B.phi1 + 360] : [B.phi2, B.phi1], x = U[0], P = U[1], N = function(FA) {
          var CA = FA[0], S = FA[1], W = 180 * Math.atan2(S, CA) / Math.PI;
          return W < x ? W + 360 : W;
        }, iA = 0, nA = rx(I, -M, 0).map(N); iA < nA.length; iA++)
          (cA = nA[iA]) > x && cA < P && y(ix(B.cX, M, I, cA));
        for (var sA = 0, tA = rx(q, -D, 0).map(N); sA < tA.length; sA++) {
          var cA;
          (cA = tA[sA]) > x && cA < P && m(ix(B.cY, D, q, cA));
        }
      }
      return d;
    }));
    return u.minX = 1 / 0, u.maxX = -1 / 0, u.minY = 1 / 0, u.maxY = -1 / 0, u;
  };
})(xr || (xr = {}));
var hs, xH = (function() {
  function e() {
  }
  return e.prototype.round = function(A) {
    return this.transform(xr.ROUND(A));
  }, e.prototype.toAbs = function() {
    return this.transform(xr.TO_ABS());
  }, e.prototype.toRel = function() {
    return this.transform(xr.TO_REL());
  }, e.prototype.normalizeHVZ = function(A, t, r) {
    return this.transform(xr.NORMALIZE_HVZ(A, t, r));
  }, e.prototype.normalizeST = function() {
    return this.transform(xr.NORMALIZE_ST());
  }, e.prototype.qtToC = function() {
    return this.transform(xr.QT_TO_C());
  }, e.prototype.aToC = function() {
    return this.transform(xr.A_TO_C());
  }, e.prototype.sanitize = function(A) {
    return this.transform(xr.SANITIZE(A));
  }, e.prototype.translate = function(A, t) {
    return this.transform(xr.TRANSLATE(A, t));
  }, e.prototype.scale = function(A, t) {
    return this.transform(xr.SCALE(A, t));
  }, e.prototype.rotate = function(A, t, r) {
    return this.transform(xr.ROTATE(A, t, r));
  }, e.prototype.matrix = function(A, t, r, n, i, s) {
    return this.transform(xr.MATRIX(A, t, r, n, i, s));
  }, e.prototype.skewX = function(A) {
    return this.transform(xr.SKEW_X(A));
  }, e.prototype.skewY = function(A) {
    return this.transform(xr.SKEW_Y(A));
  }, e.prototype.xSymmetry = function(A) {
    return this.transform(xr.X_AXIS_SYMMETRY(A));
  }, e.prototype.ySymmetry = function(A) {
    return this.transform(xr.Y_AXIS_SYMMETRY(A));
  }, e.prototype.annotateArcs = function() {
    return this.transform(xr.ANNOTATE_ARCS());
  }, e;
})(), jZ = function(e) {
  return e === " " || e === "	" || e === "\r" || e === `
`;
}, ox = function(e) {
  return 48 <= e.charCodeAt(0) && e.charCodeAt(0) <= 57;
}, qZ = (function(e) {
  function A() {
    var t = e.call(this) || this;
    return t.curNumber = "", t.curCommandType = -1, t.curCommandRelative = !1, t.canParseCommandOrComma = !0, t.curNumberHasExp = !1, t.curNumberHasExpDigits = !1, t.curNumberHasDecimal = !1, t.curArgs = [], t;
  }
  return EH(A, e), A.prototype.finish = function(t) {
    if (t === void 0 && (t = []), this.parse(" ", t), this.curArgs.length !== 0 || !this.canParseCommandOrComma) throw new SyntaxError("Unterminated command at the path end.");
    return t;
  }, A.prototype.parse = function(t, r) {
    var n = this;
    r === void 0 && (r = []);
    for (var i = function(u) {
      r.push(u), n.curArgs.length = 0, n.canParseCommandOrComma = !0;
    }, s = 0; s < t.length; s++) {
      var a = t[s], o = !(this.curCommandType !== XA.ARC || this.curArgs.length !== 3 && this.curArgs.length !== 4 || this.curNumber.length !== 1 || this.curNumber !== "0" && this.curNumber !== "1"), l = ox(a) && (this.curNumber === "0" && a === "0" || o);
      if (!ox(a) || l) if (a !== "e" && a !== "E") if (a !== "-" && a !== "+" || !this.curNumberHasExp || this.curNumberHasExpDigits) if (a !== "." || this.curNumberHasExp || this.curNumberHasDecimal || o) {
        if (this.curNumber && this.curCommandType !== -1) {
          var c = Number(this.curNumber);
          if (isNaN(c)) throw new SyntaxError("Invalid number ending at " + s);
          if (this.curCommandType === XA.ARC) {
            if (this.curArgs.length === 0 || this.curArgs.length === 1) {
              if (0 > c) throw new SyntaxError('Expected positive number, got "' + c + '" at index "' + s + '"');
            } else if ((this.curArgs.length === 3 || this.curArgs.length === 4) && this.curNumber !== "0" && this.curNumber !== "1") throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + s + '"');
          }
          this.curArgs.push(c), this.curArgs.length === $Z[this.curCommandType] && (XA.HORIZ_LINE_TO === this.curCommandType ? i({ type: XA.HORIZ_LINE_TO, relative: this.curCommandRelative, x: c }) : XA.VERT_LINE_TO === this.curCommandType ? i({ type: XA.VERT_LINE_TO, relative: this.curCommandRelative, y: c }) : this.curCommandType === XA.MOVE_TO || this.curCommandType === XA.LINE_TO || this.curCommandType === XA.SMOOTH_QUAD_TO ? (i({ type: this.curCommandType, relative: this.curCommandRelative, x: this.curArgs[0], y: this.curArgs[1] }), XA.MOVE_TO === this.curCommandType && (this.curCommandType = XA.LINE_TO)) : this.curCommandType === XA.CURVE_TO ? i({ type: XA.CURVE_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x2: this.curArgs[2], y2: this.curArgs[3], x: this.curArgs[4], y: this.curArgs[5] }) : this.curCommandType === XA.SMOOTH_CURVE_TO ? i({ type: XA.SMOOTH_CURVE_TO, relative: this.curCommandRelative, x2: this.curArgs[0], y2: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === XA.QUAD_TO ? i({ type: XA.QUAD_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === XA.ARC && i({ type: XA.ARC, relative: this.curCommandRelative, rX: this.curArgs[0], rY: this.curArgs[1], xRot: this.curArgs[2], lArcFlag: this.curArgs[3], sweepFlag: this.curArgs[4], x: this.curArgs[5], y: this.curArgs[6] })), this.curNumber = "", this.curNumberHasExpDigits = !1, this.curNumberHasExp = !1, this.curNumberHasDecimal = !1, this.canParseCommandOrComma = !0;
        }
        if (!jZ(a)) if (a === "," && this.canParseCommandOrComma) this.canParseCommandOrComma = !1;
        else if (a !== "+" && a !== "-" && a !== ".") if (l) this.curNumber = a, this.curNumberHasDecimal = !1;
        else {
          if (this.curArgs.length !== 0) throw new SyntaxError("Unterminated command at index " + s + ".");
          if (!this.canParseCommandOrComma) throw new SyntaxError('Unexpected character "' + a + '" at index ' + s + ". Command cannot follow comma");
          if (this.canParseCommandOrComma = !1, a !== "z" && a !== "Z") if (a === "h" || a === "H") this.curCommandType = XA.HORIZ_LINE_TO, this.curCommandRelative = a === "h";
          else if (a === "v" || a === "V") this.curCommandType = XA.VERT_LINE_TO, this.curCommandRelative = a === "v";
          else if (a === "m" || a === "M") this.curCommandType = XA.MOVE_TO, this.curCommandRelative = a === "m";
          else if (a === "l" || a === "L") this.curCommandType = XA.LINE_TO, this.curCommandRelative = a === "l";
          else if (a === "c" || a === "C") this.curCommandType = XA.CURVE_TO, this.curCommandRelative = a === "c";
          else if (a === "s" || a === "S") this.curCommandType = XA.SMOOTH_CURVE_TO, this.curCommandRelative = a === "s";
          else if (a === "q" || a === "Q") this.curCommandType = XA.QUAD_TO, this.curCommandRelative = a === "q";
          else if (a === "t" || a === "T") this.curCommandType = XA.SMOOTH_QUAD_TO, this.curCommandRelative = a === "t";
          else {
            if (a !== "a" && a !== "A") throw new SyntaxError('Unexpected character "' + a + '" at index ' + s + ".");
            this.curCommandType = XA.ARC, this.curCommandRelative = a === "a";
          }
          else r.push({ type: XA.CLOSE_PATH }), this.canParseCommandOrComma = !0, this.curCommandType = -1;
        }
        else this.curNumber = a, this.curNumberHasDecimal = a === ".";
      } else this.curNumber += a, this.curNumberHasDecimal = !0;
      else this.curNumber += a;
      else this.curNumber += a, this.curNumberHasExp = !0;
      else this.curNumber += a, this.curNumberHasExpDigits = this.curNumberHasExp;
    }
    return r;
  }, A.prototype.transform = function(t) {
    return Object.create(this, { parse: { value: function(r, n) {
      n === void 0 && (n = []);
      for (var i = 0, s = Object.getPrototypeOf(this).parse.call(this, r); i < s.length; i++) {
        var a = s[i], o = t(a);
        Array.isArray(o) ? n.push.apply(n, o) : n.push(o);
      }
      return n;
    } } });
  }, A;
})(xH), XA = (function(e) {
  function A(t) {
    var r = e.call(this) || this;
    return r.commands = typeof t == "string" ? A.parse(t) : t, r;
  }
  return EH(A, e), A.prototype.encode = function() {
    return A.encode(this.commands);
  }, A.prototype.getBounds = function() {
    var t = xr.CALCULATE_BOUNDS();
    return this.transform(t), t;
  }, A.prototype.transform = function(t) {
    for (var r = [], n = 0, i = this.commands; n < i.length; n++) {
      var s = t(i[n]);
      Array.isArray(s) ? r.push.apply(r, s) : r.push(s);
    }
    return this.commands = r, this;
  }, A.encode = function(t) {
    return WZ(t);
  }, A.parse = function(t) {
    var r = new qZ(), n = [];
    return r.parse(t, n), r.finish(n), n;
  }, A.CLOSE_PATH = 1, A.MOVE_TO = 2, A.HORIZ_LINE_TO = 4, A.VERT_LINE_TO = 8, A.LINE_TO = 16, A.CURVE_TO = 32, A.SMOOTH_CURVE_TO = 64, A.QUAD_TO = 128, A.SMOOTH_QUAD_TO = 256, A.ARC = 512, A.LINE_COMMANDS = A.LINE_TO | A.HORIZ_LINE_TO | A.VERT_LINE_TO, A.DRAWING_COMMANDS = A.HORIZ_LINE_TO | A.VERT_LINE_TO | A.LINE_TO | A.CURVE_TO | A.SMOOTH_CURVE_TO | A.QUAD_TO | A.SMOOTH_QUAD_TO | A.ARC, A;
})(xH), $Z = ((hs = {})[XA.MOVE_TO] = 2, hs[XA.LINE_TO] = 2, hs[XA.HORIZ_LINE_TO] = 1, hs[XA.VERT_LINE_TO] = 1, hs[XA.CLOSE_PATH] = 0, hs[XA.QUAD_TO] = 4, hs[XA.SMOOTH_QUAD_TO] = 2, hs[XA.CURVE_TO] = 6, hs[XA.SMOOTH_CURVE_TO] = 4, hs[XA.ARC] = 7, hs), lx = {}, cx;
function zZ() {
  if (cx) return lx;
  cx = 1;
  var e = Hp().PROPER, A = ic(), t = Jn(), r = ta(), n = lr(), i = Pp(), s = "toString", a = RegExp.prototype, o = a[s], l = n(function() {
    return o.call({ source: "a", flags: "b" }) !== "/a/b";
  }), c = e && o.name !== s;
  return (l || c) && A(a, s, function() {
    var d = t(this), h = r(d.source), p = r(i(d));
    return "/" + h + "/" + p;
  }, { unsafe: !0 }), lx;
}
zZ();
function rg(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? rg = function(A) {
    return typeof A;
  } : rg = function(A) {
    return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
  }, rg(e);
}
function XZ(e, A) {
  if (!(e instanceof A))
    throw new TypeError("Cannot call a class as a function");
}
var YZ = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259], JZ = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
function ZZ(e, A, t, r, n) {
  if (typeof e == "string" && (e = document.getElementById(e)), !e || rg(e) !== "object" || !("getContext" in e))
    throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
  var i = e.getContext("2d");
  try {
    return i.getImageData(A, t, r, n);
  } catch (s) {
    throw new Error("unable to access image data: " + s);
  }
}
function AAA(e, A, t, r, n, i) {
  if (!(isNaN(i) || i < 1)) {
    i |= 0;
    var s = ZZ(e, A, t, r, n);
    s = eAA(s, A, t, r, n, i), e.getContext("2d").putImageData(s, A, t);
  }
}
function eAA(e, A, t, r, n, i) {
  for (var s = e.data, a = 2 * i + 1, o = r - 1, l = n - 1, c = i + 1, u = c * (c + 1) / 2, d = new ux(), h = d, p, B = 1; B < a; B++)
    h = h.next = new ux(), B === c && (p = h);
  h.next = d;
  for (var y = null, m = null, C = 0, Q = 0, F = YZ[i], T = JZ[i], V = 0; V < n; V++) {
    h = d;
    for (var M = s[Q], D = s[Q + 1], I = s[Q + 2], q = s[Q + 3], U = 0; U < c; U++)
      h.r = M, h.g = D, h.b = I, h.a = q, h = h.next;
    for (var x = 0, P = 0, N = 0, iA = 0, nA = c * M, sA = c * D, tA = c * I, cA = c * q, FA = u * M, CA = u * D, S = u * I, W = u * q, Y = 1; Y < c; Y++) {
      var AA = Q + ((o < Y ? o : Y) << 2), oA = s[AA], gA = s[AA + 1], xA = s[AA + 2], IA = s[AA + 3], pA = c - Y;
      FA += (h.r = oA) * pA, CA += (h.g = gA) * pA, S += (h.b = xA) * pA, W += (h.a = IA) * pA, x += oA, P += gA, N += xA, iA += IA, h = h.next;
    }
    y = d, m = p;
    for (var WA = 0; WA < r; WA++) {
      var k = W * F >>> T;
      if (s[Q + 3] = k, k !== 0) {
        var X = 255 / k;
        s[Q] = (FA * F >>> T) * X, s[Q + 1] = (CA * F >>> T) * X, s[Q + 2] = (S * F >>> T) * X;
      } else
        s[Q] = s[Q + 1] = s[Q + 2] = 0;
      FA -= nA, CA -= sA, S -= tA, W -= cA, nA -= y.r, sA -= y.g, tA -= y.b, cA -= y.a;
      var uA = WA + i + 1;
      uA = C + (uA < o ? uA : o) << 2, x += y.r = s[uA], P += y.g = s[uA + 1], N += y.b = s[uA + 2], iA += y.a = s[uA + 3], FA += x, CA += P, S += N, W += iA, y = y.next;
      var E = m, dA = E.r, vA = E.g, rA = E.b, fA = E.a;
      nA += dA, sA += vA, tA += rA, cA += fA, x -= dA, P -= vA, N -= rA, iA -= fA, m = m.next, Q += 4;
    }
    C += r;
  }
  for (var EA = 0; EA < r; EA++) {
    Q = EA << 2;
    var lA = s[Q], HA = s[Q + 1], SA = s[Q + 2], yA = s[Q + 3], TA = c * lA, _A = c * HA, MA = c * SA, VA = c * yA, $A = u * lA, ee = u * HA, ZA = u * SA, Fe = u * yA;
    h = d;
    for (var me = 0; me < c; me++)
      h.r = lA, h.g = HA, h.b = SA, h.a = yA, h = h.next;
    for (var Ce = r, ae = 0, Te = 0, ie = 0, Ke = 0, ge = 1; ge <= i; ge++) {
      Q = Ce + EA << 2;
      var xe = c - ge;
      $A += (h.r = lA = s[Q]) * xe, ee += (h.g = HA = s[Q + 1]) * xe, ZA += (h.b = SA = s[Q + 2]) * xe, Fe += (h.a = yA = s[Q + 3]) * xe, Ke += lA, ae += HA, Te += SA, ie += yA, h = h.next, ge < l && (Ce += r);
    }
    Q = EA, y = d, m = p;
    for (var Ye = 0; Ye < n; Ye++) {
      var ue = Q << 2;
      s[ue + 3] = yA = Fe * F >>> T, yA > 0 ? (yA = 255 / yA, s[ue] = ($A * F >>> T) * yA, s[ue + 1] = (ee * F >>> T) * yA, s[ue + 2] = (ZA * F >>> T) * yA) : s[ue] = s[ue + 1] = s[ue + 2] = 0, $A -= TA, ee -= _A, ZA -= MA, Fe -= VA, TA -= y.r, _A -= y.g, MA -= y.b, VA -= y.a, ue = EA + ((ue = Ye + c) < l ? ue : l) * r << 2, $A += Ke += y.r = s[ue], ee += ae += y.g = s[ue + 1], ZA += Te += y.b = s[ue + 2], Fe += ie += y.a = s[ue + 3], y = y.next, TA += lA = m.r, _A += HA = m.g, MA += SA = m.b, VA += yA = m.a, Ke -= lA, ae -= HA, Te -= SA, ie -= yA, m = m.next, Q += r;
    }
  }
  return e;
}
var ux = (
  /**
   * Set properties.
   */
  function e() {
    XZ(this, e), this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
);
function tAA() {
  var {
    DOMParser: e
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, A = {
    window: null,
    ignoreAnimation: !0,
    ignoreMouse: !0,
    DOMParser: e,
    createCanvas(t, r) {
      return new OffscreenCanvas(t, r);
    },
    createImage(t) {
      return Na(function* () {
        var r = yield fetch(t), n = yield r.blob(), i = yield createImageBitmap(n);
        return i;
      })();
    }
  };
  return (typeof DOMParser < "u" || typeof e > "u") && Reflect.deleteProperty(A, "DOMParser"), A;
}
function rAA(e) {
  var {
    DOMParser: A,
    canvas: t,
    fetch: r
  } = e;
  return {
    window: null,
    ignoreAnimation: !0,
    ignoreMouse: !0,
    DOMParser: A,
    fetch: r,
    createCanvas: t.createCanvas,
    createImage: t.loadImage
  };
}
var nAA = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  offscreen: tAA,
  node: rAA
});
function sc(e) {
  return e.replace(/(?!\u3000)\s+/gm, " ");
}
function IH(e) {
  return e.replace(/^[\n \t]+/, "");
}
function SH(e) {
  return e.replace(/[\n \t]+$/, "");
}
function ai(e) {
  var A = (e || "").match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [];
  return A.map(parseFloat);
}
var iAA = /^[A-Z-]+$/;
function LH(e) {
  return iAA.test(e) ? e.toLowerCase() : e;
}
function g2(e) {
  var A = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(e) || [];
  return A[2] || A[3] || A[4];
}
function HH(e) {
  if (!e.startsWith("rgb"))
    return e;
  var A = 3, t = e.replace(/\d+(\.\d+)?/g, (r, n) => A-- && n ? String(Math.round(parseFloat(r))) : r);
  return t;
}
var sAA = /(\[[^\]]+\])/g, aAA = /(#[^\s+>~.[:]+)/g, oAA = /(\.[^\s+>~.[:]+)/g, lAA = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi, cAA = /(:[\w-]+\([^)]*\))/gi, uAA = /(:[^\s+>~.[:]+)/g, hAA = /([^\s+>~.[:]+)/g;
function gl(e, A) {
  var t = A.exec(e);
  return t ? [e.replace(A, " "), t.length] : [e, 0];
}
function TH(e) {
  var A = [0, 0, 0], t = e.replace(/:not\(([^)]*)\)/g, "     $1 ").replace(/{[\s\S]*/gm, " "), r = 0;
  return [t, r] = gl(t, sAA), A[1] += r, [t, r] = gl(t, aAA), A[0] += r, [t, r] = gl(t, oAA), A[1] += r, [t, r] = gl(t, lAA), A[2] += r, [t, r] = gl(t, cAA), A[1] += r, [t, r] = gl(t, uAA), A[1] += r, t = t.replace(/[*\s+>~]/g, " ").replace(/[#.]/g, " "), [t, r] = gl(t, hAA), A[2] += r, A.join("");
}
var Wl = 1e-8;
function Ay(e) {
  return Math.sqrt(Math.pow(e[0], 2) + Math.pow(e[1], 2));
}
function Mg(e, A) {
  return (e[0] * A[0] + e[1] * A[1]) / (Ay(e) * Ay(A));
}
function ey(e, A) {
  return (e[0] * A[1] < e[1] * A[0] ? -1 : 1) * Math.acos(Mg(e, A));
}
function ty(e) {
  return e * e * e;
}
function ry(e) {
  return 3 * e * e * (1 - e);
}
function ny(e) {
  return 3 * e * (1 - e) * (1 - e);
}
function iy(e) {
  return (1 - e) * (1 - e) * (1 - e);
}
function sy(e) {
  return e * e;
}
function ay(e) {
  return 2 * e * (1 - e);
}
function oy(e) {
  return (1 - e) * (1 - e);
}
class be {
  constructor(A, t, r) {
    this.document = A, this.name = t, this.value = r, this.isNormalizedColor = !1;
  }
  static empty(A) {
    return new be(A, "EMPTY", "");
  }
  split() {
    var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", {
      document: t,
      name: r
    } = this;
    return sc(this.getString()).trim().split(A).map((n) => new be(t, r, n));
  }
  hasValue(A) {
    var {
      value: t
    } = this;
    return t !== null && t !== "" && (A || t !== 0) && typeof t < "u";
  }
  isString(A) {
    var {
      value: t
    } = this, r = typeof t == "string";
    return !r || !A ? r : A.test(t);
  }
  isUrlDefinition() {
    return this.isString(/^url\(/);
  }
  isPixels() {
    if (!this.hasValue())
      return !1;
    var A = this.getString();
    switch (!0) {
      case A.endsWith("px"):
      case /^[0-9]+$/.test(A):
        return !0;
      default:
        return !1;
    }
  }
  setValue(A) {
    return this.value = A, this;
  }
  getValue(A) {
    return typeof A > "u" || this.hasValue() ? this.value : A;
  }
  getNumber(A) {
    if (!this.hasValue())
      return typeof A > "u" ? 0 : parseFloat(A);
    var {
      value: t
    } = this, r = parseFloat(t);
    return this.isString(/%$/) && (r /= 100), r;
  }
  getString(A) {
    return typeof A > "u" || this.hasValue() ? typeof this.value > "u" ? "" : String(this.value) : String(A);
  }
  getColor(A) {
    var t = this.getString(A);
    return this.isNormalizedColor || (this.isNormalizedColor = !0, t = HH(t), this.value = t), t;
  }
  getDpi() {
    return 96;
  }
  getRem() {
    return this.document.rootEmSize;
  }
  getEm() {
    return this.document.emSize;
  }
  getUnits() {
    return this.getString().replace(/[0-9.-]/g, "");
  }
  getPixels(A) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!this.hasValue())
      return 0;
    var [r, n] = typeof A == "boolean" ? [void 0, A] : [A], {
      viewPort: i
    } = this.document.screen;
    switch (!0) {
      case this.isString(/vmin$/):
        return this.getNumber() / 100 * Math.min(i.computeSize("x"), i.computeSize("y"));
      case this.isString(/vmax$/):
        return this.getNumber() / 100 * Math.max(i.computeSize("x"), i.computeSize("y"));
      case this.isString(/vw$/):
        return this.getNumber() / 100 * i.computeSize("x");
      case this.isString(/vh$/):
        return this.getNumber() / 100 * i.computeSize("y");
      case this.isString(/rem$/):
        return this.getNumber() * this.getRem();
      case this.isString(/em$/):
        return this.getNumber() * this.getEm();
      case this.isString(/ex$/):
        return this.getNumber() * this.getEm() / 2;
      case this.isString(/px$/):
        return this.getNumber();
      case this.isString(/pt$/):
        return this.getNumber() * this.getDpi() * (1 / 72);
      case this.isString(/pc$/):
        return this.getNumber() * 15;
      case this.isString(/cm$/):
        return this.getNumber() * this.getDpi() / 2.54;
      case this.isString(/mm$/):
        return this.getNumber() * this.getDpi() / 25.4;
      case this.isString(/in$/):
        return this.getNumber() * this.getDpi();
      case (this.isString(/%$/) && n):
        return this.getNumber() * this.getEm();
      case this.isString(/%$/):
        return this.getNumber() * i.computeSize(r);
      default: {
        var s = this.getNumber();
        return t && s < 1 ? s * i.computeSize(r) : s;
      }
    }
  }
  getMilliseconds() {
    return this.hasValue() ? this.isString(/ms$/) ? this.getNumber() : this.getNumber() * 1e3 : 0;
  }
  getRadians() {
    if (!this.hasValue())
      return 0;
    switch (!0) {
      case this.isString(/deg$/):
        return this.getNumber() * (Math.PI / 180);
      case this.isString(/grad$/):
        return this.getNumber() * (Math.PI / 200);
      case this.isString(/rad$/):
        return this.getNumber();
      default:
        return this.getNumber() * (Math.PI / 180);
    }
  }
  getDefinition() {
    var A = this.getString(), t = /#([^)'"]+)/.exec(A);
    return t && (t = t[1]), t || (t = A), this.document.definitions[t];
  }
  getFillStyleDefinition(A, t) {
    var r = this.getDefinition();
    if (!r)
      return null;
    if (typeof r.createGradient == "function")
      return r.createGradient(this.document.ctx, A, t);
    if (typeof r.createPattern == "function") {
      if (r.getHrefAttribute().hasValue()) {
        var n = r.getAttribute("patternTransform");
        r = r.getHrefAttribute().getDefinition(), n.hasValue() && r.getAttribute("patternTransform", !0).setValue(n.value);
      }
      return r.createPattern(this.document.ctx, A, t);
    }
    return null;
  }
  getTextBaseline() {
    return this.hasValue() ? be.textBaselineMapping[this.getString()] : null;
  }
  addOpacity(A) {
    for (var t = this.getColor(), r = t.length, n = 0, i = 0; i < r && (t[i] === "," && n++, n !== 3); i++)
      ;
    if (A.hasValue() && this.isString() && n !== 3) {
      var s = new Jv(t);
      s.ok && (s.alpha = A.getNumber(), t = s.toRGBA());
    }
    return new be(this.document, this.name, t);
  }
}
be.textBaselineMapping = {
  baseline: "alphabetic",
  "before-edge": "top",
  "text-before-edge": "top",
  middle: "middle",
  central: "middle",
  "after-edge": "bottom",
  "text-after-edge": "bottom",
  ideographic: "ideographic",
  alphabetic: "alphabetic",
  hanging: "hanging",
  mathematical: "alphabetic"
};
class _H {
  constructor() {
    this.viewPorts = [];
  }
  clear() {
    this.viewPorts = [];
  }
  setCurrent(A, t) {
    this.viewPorts.push({
      width: A,
      height: t
    });
  }
  removeCurrent() {
    this.viewPorts.pop();
  }
  getCurrent() {
    var {
      viewPorts: A
    } = this;
    return A[A.length - 1];
  }
  get width() {
    return this.getCurrent().width;
  }
  get height() {
    return this.getCurrent().height;
  }
  computeSize(A) {
    return typeof A == "number" ? A : A === "x" ? this.width : A === "y" ? this.height : Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
  }
}
class ar {
  constructor(A, t) {
    this.x = A, this.y = t;
  }
  static parse(A) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, [r = t, n = t] = ai(A);
    return new ar(r, n);
  }
  static parseScale(A) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, [r = t, n = r] = ai(A);
    return new ar(r, n);
  }
  static parsePath(A) {
    for (var t = ai(A), r = t.length, n = [], i = 0; i < r; i += 2)
      n.push(new ar(t[i], t[i + 1]));
    return n;
  }
  angleTo(A) {
    return Math.atan2(A.y - this.y, A.x - this.x);
  }
  applyTransform(A) {
    var {
      x: t,
      y: r
    } = this, n = t * A[0] + r * A[2] + A[4], i = t * A[1] + r * A[3] + A[5];
    this.x = n, this.y = i;
  }
}
class OH {
  constructor(A) {
    this.screen = A, this.working = !1, this.events = [], this.eventElements = [], this.onClick = this.onClick.bind(this), this.onMouseMove = this.onMouseMove.bind(this);
  }
  isWorking() {
    return this.working;
  }
  start() {
    if (!this.working) {
      var {
        screen: A,
        onClick: t,
        onMouseMove: r
      } = this, n = A.ctx.canvas;
      n.onclick = t, n.onmousemove = r, this.working = !0;
    }
  }
  stop() {
    if (this.working) {
      var A = this.screen.ctx.canvas;
      this.working = !1, A.onclick = null, A.onmousemove = null;
    }
  }
  hasEvents() {
    return this.working && this.events.length > 0;
  }
  runEvents() {
    if (this.working) {
      var {
        screen: A,
        events: t,
        eventElements: r
      } = this, {
        style: n
      } = A.ctx.canvas;
      n && (n.cursor = ""), t.forEach((i, s) => {
        for (var {
          run: a
        } = i, o = r[s]; o; )
          a(o), o = o.parent;
      }), this.events = [], this.eventElements = [];
    }
  }
  checkPath(A, t) {
    if (!(!this.working || !t)) {
      var {
        events: r,
        eventElements: n
      } = this;
      r.forEach((i, s) => {
        var {
          x: a,
          y: o
        } = i;
        !n[s] && t.isPointInPath && t.isPointInPath(a, o) && (n[s] = A);
      });
    }
  }
  checkBoundingBox(A, t) {
    if (!(!this.working || !t)) {
      var {
        events: r,
        eventElements: n
      } = this;
      r.forEach((i, s) => {
        var {
          x: a,
          y: o
        } = i;
        !n[s] && t.isPointInBox(a, o) && (n[s] = A);
      });
    }
  }
  mapXY(A, t) {
    for (var {
      window: r,
      ctx: n
    } = this.screen, i = new ar(A, t), s = n.canvas; s; )
      i.x -= s.offsetLeft, i.y -= s.offsetTop, s = s.offsetParent;
    return r.scrollX && (i.x += r.scrollX), r.scrollY && (i.y += r.scrollY), i;
  }
  onClick(A) {
    var {
      x: t,
      y: r
    } = this.mapXY(A.clientX, A.clientY);
    this.events.push({
      type: "onclick",
      x: t,
      y: r,
      run(n) {
        n.onClick && n.onClick();
      }
    });
  }
  onMouseMove(A) {
    var {
      x: t,
      y: r
    } = this.mapXY(A.clientX, A.clientY);
    this.events.push({
      type: "onmousemove",
      x: t,
      y: r,
      run(n) {
        n.onMouseMove && n.onMouseMove();
      }
    });
  }
}
var NH = typeof window < "u" ? window : null, DH = typeof fetch < "u" ? fetch.bind(void 0) : null;
class of {
  constructor(A) {
    var {
      fetch: t = DH,
      window: r = NH
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.ctx = A, this.FRAMERATE = 30, this.MAX_VIRTUAL_PIXELS = 3e4, this.CLIENT_WIDTH = 800, this.CLIENT_HEIGHT = 600, this.viewPort = new _H(), this.mouse = new OH(this), this.animations = [], this.waits = [], this.frameDuration = 0, this.isReadyLock = !1, this.isFirstRender = !0, this.intervalId = null, this.window = r, this.fetch = t;
  }
  wait(A) {
    this.waits.push(A);
  }
  ready() {
    return this.readyPromise ? this.readyPromise : Promise.resolve();
  }
  isReady() {
    if (this.isReadyLock)
      return !0;
    var A = this.waits.every((t) => t());
    return A && (this.waits = [], this.resolveReady && this.resolveReady()), this.isReadyLock = A, A;
  }
  setDefaults(A) {
    A.strokeStyle = "rgba(0,0,0,0)", A.lineCap = "butt", A.lineJoin = "miter", A.miterLimit = 4;
  }
  setViewBox(A) {
    var {
      document: t,
      ctx: r,
      aspectRatio: n,
      width: i,
      desiredWidth: s,
      height: a,
      desiredHeight: o,
      minX: l = 0,
      minY: c = 0,
      refX: u,
      refY: d,
      clip: h = !1,
      clipX: p = 0,
      clipY: B = 0
    } = A, y = sc(n).replace(/^defer\s/, ""), [m, C] = y.split(" "), Q = m || "xMidYMid", F = C || "meet", T = i / s, V = a / o, M = Math.min(T, V), D = Math.max(T, V), I = s, q = o;
    F === "meet" && (I *= M, q *= M), F === "slice" && (I *= D, q *= D);
    var U = new be(t, "refX", u), x = new be(t, "refY", d), P = U.hasValue() && x.hasValue();
    if (P && r.translate(-M * U.getPixels("x"), -M * x.getPixels("y")), h) {
      var N = M * p, iA = M * B;
      r.beginPath(), r.moveTo(N, iA), r.lineTo(i, iA), r.lineTo(i, a), r.lineTo(N, a), r.closePath(), r.clip();
    }
    if (!P) {
      var nA = F === "meet" && M === V, sA = F === "slice" && D === V, tA = F === "meet" && M === T, cA = F === "slice" && D === T;
      Q.startsWith("xMid") && (nA || sA) && r.translate(i / 2 - I / 2, 0), Q.endsWith("YMid") && (tA || cA) && r.translate(0, a / 2 - q / 2), Q.startsWith("xMax") && (nA || sA) && r.translate(i - I, 0), Q.endsWith("YMax") && (tA || cA) && r.translate(0, a - q);
    }
    switch (!0) {
      case Q === "none":
        r.scale(T, V);
        break;
      case F === "meet":
        r.scale(M, M);
        break;
      case F === "slice":
        r.scale(D, D);
        break;
    }
    r.translate(-l, -c);
  }
  start(A) {
    var {
      enableRedraw: t = !1,
      ignoreMouse: r = !1,
      ignoreAnimation: n = !1,
      ignoreDimensions: i = !1,
      ignoreClear: s = !1,
      forceRedraw: a,
      scaleWidth: o,
      scaleHeight: l,
      offsetX: c,
      offsetY: u
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      FRAMERATE: d,
      mouse: h
    } = this, p = 1e3 / d;
    if (this.frameDuration = p, this.readyPromise = new Promise((Q) => {
      this.resolveReady = Q;
    }), this.isReady() && this.render(A, i, s, o, l, c, u), !!t) {
      var B = Date.now(), y = B, m = 0, C = () => {
        B = Date.now(), m = B - y, m >= p && (y = B - m % p, this.shouldUpdate(n, a) && (this.render(A, i, s, o, l, c, u), h.runEvents())), this.intervalId = p1(C);
      };
      r || h.start(), this.intervalId = p1(C);
    }
  }
  stop() {
    this.intervalId && (p1.cancel(this.intervalId), this.intervalId = null), this.mouse.stop();
  }
  shouldUpdate(A, t) {
    if (!A) {
      var {
        frameDuration: r
      } = this, n = this.animations.reduce((i, s) => s.update(r) || i, !1);
      if (n)
        return !0;
    }
    return !!(typeof t == "function" && t() || !this.isReadyLock && this.isReady() || this.mouse.hasEvents());
  }
  render(A, t, r, n, i, s, a) {
    var {
      CLIENT_WIDTH: o,
      CLIENT_HEIGHT: l,
      viewPort: c,
      ctx: u,
      isFirstRender: d
    } = this, h = u.canvas;
    c.clear(), h.width && h.height ? c.setCurrent(h.width, h.height) : c.setCurrent(o, l);
    var p = A.getStyle("width"), B = A.getStyle("height");
    !t && (d || typeof n != "number" && typeof i != "number") && (p.hasValue() && (h.width = p.getPixels("x"), h.style && (h.style.width = "".concat(h.width, "px"))), B.hasValue() && (h.height = B.getPixels("y"), h.style && (h.style.height = "".concat(h.height, "px"))));
    var y = h.clientWidth || h.width, m = h.clientHeight || h.height;
    if (t && p.hasValue() && B.hasValue() && (y = p.getPixels("x"), m = B.getPixels("y")), c.setCurrent(y, m), typeof s == "number" && A.getAttribute("x", !0).setValue(s), typeof a == "number" && A.getAttribute("y", !0).setValue(a), typeof n == "number" || typeof i == "number") {
      var C = ai(A.getAttribute("viewBox").getString()), Q = 0, F = 0;
      if (typeof n == "number") {
        var T = A.getStyle("width");
        T.hasValue() ? Q = T.getPixels("x") / n : isNaN(C[2]) || (Q = C[2] / n);
      }
      if (typeof i == "number") {
        var V = A.getStyle("height");
        V.hasValue() ? F = V.getPixels("y") / i : isNaN(C[3]) || (F = C[3] / i);
      }
      Q || (Q = F), F || (F = Q), A.getAttribute("width", !0).setValue(n), A.getAttribute("height", !0).setValue(i);
      var M = A.getStyle("transform", !0, !0);
      M.setValue("".concat(M.getString(), " scale(").concat(1 / Q, ", ").concat(1 / F, ")"));
    }
    r || u.clearRect(0, 0, y, m), A.render(u), d && (this.isFirstRender = !1);
  }
}
of.defaultWindow = NH;
of.defaultFetch = DH;
var {
  defaultFetch: fAA
} = of, dAA = typeof DOMParser < "u" ? DOMParser : null;
class ng {
  constructor() {
    var {
      fetch: A = fAA,
      DOMParser: t = dAA
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.fetch = A, this.DOMParser = t;
  }
  parse(A) {
    var t = this;
    return Na(function* () {
      return A.startsWith("<") ? t.parseFromString(A) : t.load(A);
    })();
  }
  parseFromString(A) {
    var t = new this.DOMParser();
    try {
      return this.checkDocument(t.parseFromString(A, "image/svg+xml"));
    } catch {
      return this.checkDocument(t.parseFromString(A, "text/xml"));
    }
  }
  checkDocument(A) {
    var t = A.getElementsByTagName("parsererror")[0];
    if (t)
      throw new Error(t.textContent);
    return A;
  }
  load(A) {
    var t = this;
    return Na(function* () {
      var r = yield t.fetch(A), n = yield r.text();
      return t.parseFromString(n);
    })();
  }
}
class RH {
  constructor(A, t) {
    this.type = "translate", this.point = null, this.point = ar.parse(t);
  }
  apply(A) {
    var {
      x: t,
      y: r
    } = this.point;
    A.translate(t || 0, r || 0);
  }
  unapply(A) {
    var {
      x: t,
      y: r
    } = this.point;
    A.translate(-1 * t || 0, -1 * r || 0);
  }
  applyToPoint(A) {
    var {
      x: t,
      y: r
    } = this.point;
    A.applyTransform([1, 0, 0, 1, t || 0, r || 0]);
  }
}
class MH {
  constructor(A, t, r) {
    this.type = "rotate", this.angle = null, this.originX = null, this.originY = null, this.cx = 0, this.cy = 0;
    var n = ai(t);
    this.angle = new be(A, "angle", n[0]), this.originX = r[0], this.originY = r[1], this.cx = n[1] || 0, this.cy = n[2] || 0;
  }
  apply(A) {
    var {
      cx: t,
      cy: r,
      originX: n,
      originY: i,
      angle: s
    } = this, a = t + n.getPixels("x"), o = r + i.getPixels("y");
    A.translate(a, o), A.rotate(s.getRadians()), A.translate(-a, -o);
  }
  unapply(A) {
    var {
      cx: t,
      cy: r,
      originX: n,
      originY: i,
      angle: s
    } = this, a = t + n.getPixels("x"), o = r + i.getPixels("y");
    A.translate(a, o), A.rotate(-1 * s.getRadians()), A.translate(-a, -o);
  }
  applyToPoint(A) {
    var {
      cx: t,
      cy: r,
      angle: n
    } = this, i = n.getRadians();
    A.applyTransform([
      1,
      0,
      0,
      1,
      t || 0,
      r || 0
      // this.p.y
    ]), A.applyTransform([Math.cos(i), Math.sin(i), -Math.sin(i), Math.cos(i), 0, 0]), A.applyTransform([
      1,
      0,
      0,
      1,
      -t || 0,
      -r || 0
      // -this.p.y
    ]);
  }
}
class PH {
  constructor(A, t, r) {
    this.type = "scale", this.scale = null, this.originX = null, this.originY = null;
    var n = ar.parseScale(t);
    (n.x === 0 || n.y === 0) && (n.x = Wl, n.y = Wl), this.scale = n, this.originX = r[0], this.originY = r[1];
  }
  apply(A) {
    var {
      scale: {
        x: t,
        y: r
      },
      originX: n,
      originY: i
    } = this, s = n.getPixels("x"), a = i.getPixels("y");
    A.translate(s, a), A.scale(t, r || t), A.translate(-s, -a);
  }
  unapply(A) {
    var {
      scale: {
        x: t,
        y: r
      },
      originX: n,
      originY: i
    } = this, s = n.getPixels("x"), a = i.getPixels("y");
    A.translate(s, a), A.scale(1 / t, 1 / r || t), A.translate(-s, -a);
  }
  applyToPoint(A) {
    var {
      x: t,
      y: r
    } = this.scale;
    A.applyTransform([t || 0, 0, 0, r || 0, 0, 0]);
  }
}
class p2 {
  constructor(A, t, r) {
    this.type = "matrix", this.matrix = [], this.originX = null, this.originY = null, this.matrix = ai(t), this.originX = r[0], this.originY = r[1];
  }
  apply(A) {
    var {
      originX: t,
      originY: r,
      matrix: n
    } = this, i = t.getPixels("x"), s = r.getPixels("y");
    A.translate(i, s), A.transform(n[0], n[1], n[2], n[3], n[4], n[5]), A.translate(-i, -s);
  }
  unapply(A) {
    var {
      originX: t,
      originY: r,
      matrix: n
    } = this, i = n[0], s = n[2], a = n[4], o = n[1], l = n[3], c = n[5], u = 0, d = 0, h = 1, p = 1 / (i * (l * h - c * d) - s * (o * h - c * u) + a * (o * d - l * u)), B = t.getPixels("x"), y = r.getPixels("y");
    A.translate(B, y), A.transform(p * (l * h - c * d), p * (c * u - o * h), p * (a * d - s * h), p * (i * h - a * u), p * (s * c - a * l), p * (a * o - i * c)), A.translate(-B, -y);
  }
  applyToPoint(A) {
    A.applyTransform(this.matrix);
  }
}
class B2 extends p2 {
  constructor(A, t, r) {
    super(A, t, r), this.type = "skew", this.angle = null, this.angle = new be(A, "angle", t);
  }
}
class kH extends B2 {
  constructor(A, t, r) {
    super(A, t, r), this.type = "skewX", this.matrix = [1, 0, Math.tan(this.angle.getRadians()), 1, 0, 0];
  }
}
class KH extends B2 {
  constructor(A, t, r) {
    super(A, t, r), this.type = "skewY", this.matrix = [1, Math.tan(this.angle.getRadians()), 0, 1, 0, 0];
  }
}
function gAA(e) {
  return sc(e).trim().replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/);
}
function pAA(e) {
  var [A, t] = e.split("(");
  return [A.trim(), t.trim().replace(")", "")];
}
class Ko {
  constructor(A, t, r) {
    this.document = A, this.transforms = [];
    var n = gAA(t);
    n.forEach((i) => {
      if (i !== "none") {
        var [s, a] = pAA(i), o = Ko.transformTypes[s];
        typeof o < "u" && this.transforms.push(new o(this.document, a, r));
      }
    });
  }
  static fromElement(A, t) {
    var r = t.getStyle("transform", !1, !0), [n, i = n] = t.getStyle("transform-origin", !1, !0).split(), s = [n, i];
    return r.hasValue() ? new Ko(A, r.getString(), s) : null;
  }
  apply(A) {
    for (var {
      transforms: t
    } = this, r = t.length, n = 0; n < r; n++)
      t[n].apply(A);
  }
  unapply(A) {
    for (var {
      transforms: t
    } = this, r = t.length, n = r - 1; n >= 0; n--)
      t[n].unapply(A);
  }
  // TODO: applyToPoint unused ... remove?
  applyToPoint(A) {
    for (var {
      transforms: t
    } = this, r = t.length, n = 0; n < r; n++)
      t[n].applyToPoint(A);
  }
}
Ko.transformTypes = {
  translate: RH,
  rotate: MH,
  scale: PH,
  matrix: p2,
  skewX: kH,
  skewY: KH
};
let Yt = class ly {
  constructor(A, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (this.document = A, this.node = t, this.captureTextNodes = r, this.attributes = /* @__PURE__ */ Object.create(null), this.styles = /* @__PURE__ */ Object.create(null), this.stylesSpecificity = /* @__PURE__ */ Object.create(null), this.animationFrozen = !1, this.animationFrozenValue = "", this.parent = null, this.children = [], !(!t || t.nodeType !== 1)) {
      if (Array.from(t.attributes).forEach((a) => {
        var o = LH(a.nodeName);
        this.attributes[o] = new be(A, o, a.value);
      }), this.addStylesFromStyleDefinition(), this.getAttribute("style").hasValue()) {
        var n = this.getAttribute("style").getString().split(";").map((a) => a.trim());
        n.forEach((a) => {
          if (a) {
            var [o, l] = a.split(":").map((c) => c.trim());
            this.styles[o] = new be(A, o, l);
          }
        });
      }
      var {
        definitions: i
      } = A, s = this.getAttribute("id");
      s.hasValue() && (i[s.getString()] || (i[s.getString()] = this)), Array.from(t.childNodes).forEach((a) => {
        if (a.nodeType === 1)
          this.addChild(a);
        else if (r && (a.nodeType === 3 || a.nodeType === 4)) {
          var o = A.createTextNode(a);
          o.getText().length > 0 && this.addChild(o);
        }
      });
    }
  }
  getAttribute(A) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = this.attributes[A];
    if (!r && t) {
      var n = new be(this.document, A, "");
      return this.attributes[A] = n, n;
    }
    return r || be.empty(this.document);
  }
  getHrefAttribute() {
    for (var A in this.attributes)
      if (A === "href" || A.endsWith(":href"))
        return this.attributes[A];
    return be.empty(this.document);
  }
  getStyle(A) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = this.styles[A];
    if (n)
      return n;
    var i = this.getAttribute(A);
    if (i != null && i.hasValue())
      return this.styles[A] = i, i;
    if (!r) {
      var {
        parent: s
      } = this;
      if (s) {
        var a = s.getStyle(A);
        if (a != null && a.hasValue())
          return a;
      }
    }
    if (t) {
      var o = new be(this.document, A, "");
      return this.styles[A] = o, o;
    }
    return n || be.empty(this.document);
  }
  render(A) {
    if (!(this.getStyle("display").getString() === "none" || this.getStyle("visibility").getString() === "hidden")) {
      if (A.save(), this.getStyle("mask").hasValue()) {
        var t = this.getStyle("mask").getDefinition();
        t && (this.applyEffects(A), t.apply(A, this));
      } else if (this.getStyle("filter").getValue("none") !== "none") {
        var r = this.getStyle("filter").getDefinition();
        r && (this.applyEffects(A), r.apply(A, this));
      } else
        this.setContext(A), this.renderChildren(A), this.clearContext(A);
      A.restore();
    }
  }
  setContext(A) {
  }
  applyEffects(A) {
    var t = Ko.fromElement(this.document, this);
    t && t.apply(A);
    var r = this.getStyle("clip-path", !1, !0);
    if (r.hasValue()) {
      var n = r.getDefinition();
      n && n.apply(A);
    }
  }
  clearContext(A) {
  }
  renderChildren(A) {
    this.children.forEach((t) => {
      t.render(A);
    });
  }
  addChild(A) {
    var t = A instanceof ly ? A : this.document.createElement(A);
    t.parent = this, ly.ignoreChildTypes.includes(t.type) || this.children.push(t);
  }
  matchesSelector(A) {
    var t, {
      node: r
    } = this;
    if (typeof r.matches == "function")
      return r.matches(A);
    var n = (t = r.getAttribute) === null || t === void 0 ? void 0 : t.call(r, "class");
    return !n || n === "" ? !1 : n.split(" ").some((i) => ".".concat(i) === A);
  }
  addStylesFromStyleDefinition() {
    var {
      styles: A,
      stylesSpecificity: t
    } = this.document;
    for (var r in A)
      if (!r.startsWith("@") && this.matchesSelector(r)) {
        var n = A[r], i = t[r];
        if (n)
          for (var s in n) {
            var a = this.stylesSpecificity[s];
            typeof a > "u" && (a = "000"), i >= a && (this.styles[s] = n[s], this.stylesSpecificity[s] = i);
          }
      }
  }
  removeStyles(A, t) {
    var r = t.reduce((n, i) => {
      var s = A.getStyle(i);
      if (!s.hasValue())
        return n;
      var a = s.getString();
      return s.setValue(""), [...n, [i, a]];
    }, []);
    return r;
  }
  restoreStyles(A, t) {
    t.forEach((r) => {
      var [n, i] = r;
      A.getStyle(n, !0).setValue(i);
    });
  }
  isFirstChild() {
    var A;
    return ((A = this.parent) === null || A === void 0 ? void 0 : A.children.indexOf(this)) === 0;
  }
};
Yt.ignoreChildTypes = ["title"];
class VH extends Yt {
  constructor(A, t, r) {
    super(A, t, r);
  }
}
function BAA(e) {
  var A = e.trim();
  return /^('|")/.test(A) ? A : '"'.concat(A, '"');
}
function wAA(e) {
  return typeof process > "u" ? e : e.trim().split(",").map(BAA).join(",");
}
function mAA(e) {
  if (!e)
    return "";
  var A = e.trim().toLowerCase();
  switch (A) {
    case "normal":
    case "italic":
    case "oblique":
    case "inherit":
    case "initial":
    case "unset":
      return A;
    default:
      return /^oblique\s+(-|)\d+deg$/.test(A) ? A : "";
  }
}
function vAA(e) {
  if (!e)
    return "";
  var A = e.trim().toLowerCase();
  switch (A) {
    case "normal":
    case "bold":
    case "lighter":
    case "bolder":
    case "inherit":
    case "initial":
    case "unset":
      return A;
    default:
      return /^[\d.]+$/.test(A) ? A : "";
  }
}
class Sn {
  constructor(A, t, r, n, i, s) {
    var a = s ? typeof s == "string" ? Sn.parse(s) : s : {};
    this.fontFamily = i || a.fontFamily, this.fontSize = n || a.fontSize, this.fontStyle = A || a.fontStyle, this.fontWeight = r || a.fontWeight, this.fontVariant = t || a.fontVariant;
  }
  static parse() {
    var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0, r = "", n = "", i = "", s = "", a = "", o = sc(A).trim().split(" "), l = {
      fontSize: !1,
      fontStyle: !1,
      fontWeight: !1,
      fontVariant: !1
    };
    return o.forEach((c) => {
      switch (!0) {
        case (!l.fontStyle && Sn.styles.includes(c)):
          c !== "inherit" && (r = c), l.fontStyle = !0;
          break;
        case (!l.fontVariant && Sn.variants.includes(c)):
          c !== "inherit" && (n = c), l.fontStyle = !0, l.fontVariant = !0;
          break;
        case (!l.fontWeight && Sn.weights.includes(c)):
          c !== "inherit" && (i = c), l.fontStyle = !0, l.fontVariant = !0, l.fontWeight = !0;
          break;
        case !l.fontSize:
          c !== "inherit" && ([s] = c.split("/")), l.fontStyle = !0, l.fontVariant = !0, l.fontWeight = !0, l.fontSize = !0;
          break;
        default:
          c !== "inherit" && (a += c);
      }
    }), new Sn(r, n, i, s, a, t);
  }
  toString() {
    return [
      mAA(this.fontStyle),
      this.fontVariant,
      vAA(this.fontWeight),
      this.fontSize,
      // Wrap fontFamily only on nodejs and only for canvas.ctx
      wAA(this.fontFamily)
    ].join(" ").trim();
  }
}
Sn.styles = "normal|italic|oblique|inherit";
Sn.variants = "normal|small-caps|inherit";
Sn.weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit";
class es {
  constructor() {
    var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Number.NaN, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.NaN, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Number.NaN, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Number.NaN;
    this.x1 = A, this.y1 = t, this.x2 = r, this.y2 = n, this.addPoint(A, t), this.addPoint(r, n);
  }
  get x() {
    return this.x1;
  }
  get y() {
    return this.y1;
  }
  get width() {
    return this.x2 - this.x1;
  }
  get height() {
    return this.y2 - this.y1;
  }
  addPoint(A, t) {
    typeof A < "u" && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = A, this.x2 = A), A < this.x1 && (this.x1 = A), A > this.x2 && (this.x2 = A)), typeof t < "u" && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = t, this.y2 = t), t < this.y1 && (this.y1 = t), t > this.y2 && (this.y2 = t));
  }
  addX(A) {
    this.addPoint(A, null);
  }
  addY(A) {
    this.addPoint(null, A);
  }
  addBoundingBox(A) {
    if (A) {
      var {
        x1: t,
        y1: r,
        x2: n,
        y2: i
      } = A;
      this.addPoint(t, r), this.addPoint(n, i);
    }
  }
  sumCubic(A, t, r, n, i) {
    return Math.pow(1 - A, 3) * t + 3 * Math.pow(1 - A, 2) * A * r + 3 * (1 - A) * Math.pow(A, 2) * n + Math.pow(A, 3) * i;
  }
  bezierCurveAdd(A, t, r, n, i) {
    var s = 6 * t - 12 * r + 6 * n, a = -3 * t + 9 * r - 9 * n + 3 * i, o = 3 * r - 3 * t;
    if (a === 0) {
      if (s === 0)
        return;
      var l = -o / s;
      0 < l && l < 1 && (A ? this.addX(this.sumCubic(l, t, r, n, i)) : this.addY(this.sumCubic(l, t, r, n, i)));
      return;
    }
    var c = Math.pow(s, 2) - 4 * o * a;
    if (!(c < 0)) {
      var u = (-s + Math.sqrt(c)) / (2 * a);
      0 < u && u < 1 && (A ? this.addX(this.sumCubic(u, t, r, n, i)) : this.addY(this.sumCubic(u, t, r, n, i)));
      var d = (-s - Math.sqrt(c)) / (2 * a);
      0 < d && d < 1 && (A ? this.addX(this.sumCubic(d, t, r, n, i)) : this.addY(this.sumCubic(d, t, r, n, i)));
    }
  }
  // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
  addBezierCurve(A, t, r, n, i, s, a, o) {
    this.addPoint(A, t), this.addPoint(a, o), this.bezierCurveAdd(!0, A, r, i, a), this.bezierCurveAdd(!1, t, n, s, o);
  }
  addQuadraticCurve(A, t, r, n, i, s) {
    var a = A + 0.6666666666666666 * (r - A), o = t + 2 / 3 * (n - t), l = a + 1 / 3 * (i - A), c = o + 1 / 3 * (s - t);
    this.addBezierCurve(A, t, a, l, o, c, i, s);
  }
  isPointInBox(A, t) {
    var {
      x1: r,
      y1: n,
      x2: i,
      y2: s
    } = this;
    return r <= A && A <= i && n <= t && t <= s;
  }
}
class ke extends XA {
  constructor(A) {
    super(A.replace(/([+\-.])\s+/gm, "$1").replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, "")), this.control = null, this.start = null, this.current = null, this.command = null, this.commands = this.commands, this.i = -1, this.previousCommand = null, this.points = [], this.angles = [];
  }
  reset() {
    this.i = -1, this.command = null, this.previousCommand = null, this.start = new ar(0, 0), this.control = new ar(0, 0), this.current = new ar(0, 0), this.points = [], this.angles = [];
  }
  isEnd() {
    var {
      i: A,
      commands: t
    } = this;
    return A >= t.length - 1;
  }
  next() {
    var A = this.commands[++this.i];
    return this.previousCommand = this.command, this.command = A, A;
  }
  getPoint() {
    var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "x", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "y", r = new ar(this.command[A], this.command[t]);
    return this.makeAbsolute(r);
  }
  getAsControlPoint(A, t) {
    var r = this.getPoint(A, t);
    return this.control = r, r;
  }
  getAsCurrentPoint(A, t) {
    var r = this.getPoint(A, t);
    return this.current = r, r;
  }
  getReflectedControlPoint() {
    var A = this.previousCommand.type;
    if (A !== XA.CURVE_TO && A !== XA.SMOOTH_CURVE_TO && A !== XA.QUAD_TO && A !== XA.SMOOTH_QUAD_TO)
      return this.current;
    var {
      current: {
        x: t,
        y: r
      },
      control: {
        x: n,
        y: i
      }
    } = this, s = new ar(2 * t - n, 2 * r - i);
    return s;
  }
  makeAbsolute(A) {
    if (this.command.relative) {
      var {
        x: t,
        y: r
      } = this.current;
      A.x += t, A.y += r;
    }
    return A;
  }
  addMarker(A, t, r) {
    var {
      points: n,
      angles: i
    } = this;
    r && i.length > 0 && !i[i.length - 1] && (i[i.length - 1] = n[n.length - 1].angleTo(r)), this.addMarkerAngle(A, t ? t.angleTo(A) : null);
  }
  addMarkerAngle(A, t) {
    this.points.push(A), this.angles.push(t);
  }
  getMarkerPoints() {
    return this.points;
  }
  getMarkerAngles() {
    for (var {
      angles: A
    } = this, t = A.length, r = 0; r < t; r++)
      if (!A[r]) {
        for (var n = r + 1; n < t; n++)
          if (A[n]) {
            A[r] = A[n];
            break;
          }
      }
    return A;
  }
}
class qo extends Yt {
  constructor() {
    super(...arguments), this.modifiedEmSizeStack = !1;
  }
  calculateOpacity() {
    for (var A = 1, t = this; t; ) {
      var r = t.getStyle("opacity", !1, !0);
      r.hasValue(!0) && (A *= r.getNumber()), t = t.parent;
    }
    return A;
  }
  setContext(A) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!t) {
      var r = this.getStyle("fill"), n = this.getStyle("fill-opacity"), i = this.getStyle("stroke"), s = this.getStyle("stroke-opacity");
      if (r.isUrlDefinition()) {
        var a = r.getFillStyleDefinition(this, n);
        a && (A.fillStyle = a);
      } else if (r.hasValue()) {
        r.getString() === "currentColor" && r.setValue(this.getStyle("color").getColor());
        var o = r.getColor();
        o !== "inherit" && (A.fillStyle = o === "none" ? "rgba(0,0,0,0)" : o);
      }
      if (n.hasValue()) {
        var l = new be(this.document, "fill", A.fillStyle).addOpacity(n).getColor();
        A.fillStyle = l;
      }
      if (i.isUrlDefinition()) {
        var c = i.getFillStyleDefinition(this, s);
        c && (A.strokeStyle = c);
      } else if (i.hasValue()) {
        i.getString() === "currentColor" && i.setValue(this.getStyle("color").getColor());
        var u = i.getString();
        u !== "inherit" && (A.strokeStyle = u === "none" ? "rgba(0,0,0,0)" : u);
      }
      if (s.hasValue()) {
        var d = new be(this.document, "stroke", A.strokeStyle).addOpacity(s).getString();
        A.strokeStyle = d;
      }
      var h = this.getStyle("stroke-width");
      if (h.hasValue()) {
        var p = h.getPixels();
        A.lineWidth = p || Wl;
      }
      var B = this.getStyle("stroke-linecap"), y = this.getStyle("stroke-linejoin"), m = this.getStyle("stroke-miterlimit"), C = this.getStyle("stroke-dasharray"), Q = this.getStyle("stroke-dashoffset");
      if (B.hasValue() && (A.lineCap = B.getString()), y.hasValue() && (A.lineJoin = y.getString()), m.hasValue() && (A.miterLimit = m.getNumber()), C.hasValue() && C.getString() !== "none") {
        var F = ai(C.getString());
        typeof A.setLineDash < "u" ? A.setLineDash(F) : typeof A.webkitLineDash < "u" ? A.webkitLineDash = F : typeof A.mozDash < "u" && !(F.length === 1 && F[0] === 0) && (A.mozDash = F);
        var T = Q.getPixels();
        typeof A.lineDashOffset < "u" ? A.lineDashOffset = T : typeof A.webkitLineDashOffset < "u" ? A.webkitLineDashOffset = T : typeof A.mozDashOffset < "u" && (A.mozDashOffset = T);
      }
    }
    if (this.modifiedEmSizeStack = !1, typeof A.font < "u") {
      var V = this.getStyle("font"), M = this.getStyle("font-style"), D = this.getStyle("font-variant"), I = this.getStyle("font-weight"), q = this.getStyle("font-size"), U = this.getStyle("font-family"), x = new Sn(M.getString(), D.getString(), I.getString(), q.hasValue() ? "".concat(q.getPixels(!0), "px") : "", U.getString(), Sn.parse(V.getString(), A.font));
      M.setValue(x.fontStyle), D.setValue(x.fontVariant), I.setValue(x.fontWeight), q.setValue(x.fontSize), U.setValue(x.fontFamily), A.font = x.toString(), q.isPixels() && (this.document.emSize = q.getPixels(), this.modifiedEmSizeStack = !0);
    }
    t || (this.applyEffects(A), A.globalAlpha = this.calculateOpacity());
  }
  clearContext(A) {
    super.clearContext(A), this.modifiedEmSizeStack && this.document.popEmSize();
  }
}
class ht extends qo {
  constructor(A, t, r) {
    super(A, t, r), this.type = "path", this.pathParser = null, this.pathParser = new ke(this.getAttribute("d").getString());
  }
  path(A) {
    var {
      pathParser: t
    } = this, r = new es();
    for (t.reset(), A && A.beginPath(); !t.isEnd(); )
      switch (t.next().type) {
        case ke.MOVE_TO:
          this.pathM(A, r);
          break;
        case ke.LINE_TO:
          this.pathL(A, r);
          break;
        case ke.HORIZ_LINE_TO:
          this.pathH(A, r);
          break;
        case ke.VERT_LINE_TO:
          this.pathV(A, r);
          break;
        case ke.CURVE_TO:
          this.pathC(A, r);
          break;
        case ke.SMOOTH_CURVE_TO:
          this.pathS(A, r);
          break;
        case ke.QUAD_TO:
          this.pathQ(A, r);
          break;
        case ke.SMOOTH_QUAD_TO:
          this.pathT(A, r);
          break;
        case ke.ARC:
          this.pathA(A, r);
          break;
        case ke.CLOSE_PATH:
          this.pathZ(A, r);
          break;
      }
    return r;
  }
  getBoundingBox(A) {
    return this.path();
  }
  getMarkers() {
    var {
      pathParser: A
    } = this, t = A.getMarkerPoints(), r = A.getMarkerAngles(), n = t.map((i, s) => [i, r[s]]);
    return n;
  }
  renderChildren(A) {
    this.path(A), this.document.screen.mouse.checkPath(this, A);
    var t = this.getStyle("fill-rule");
    A.fillStyle !== "" && (t.getString("inherit") !== "inherit" ? A.fill(t.getString()) : A.fill()), A.strokeStyle !== "" && (this.getAttribute("vector-effect").getString() === "non-scaling-stroke" ? (A.save(), A.setTransform(1, 0, 0, 1, 0, 0), A.stroke(), A.restore()) : A.stroke());
    var r = this.getMarkers();
    if (r) {
      var n = r.length - 1, i = this.getStyle("marker-start"), s = this.getStyle("marker-mid"), a = this.getStyle("marker-end");
      if (i.isUrlDefinition()) {
        var o = i.getDefinition(), [l, c] = r[0];
        o.render(A, l, c);
      }
      if (s.isUrlDefinition())
        for (var u = s.getDefinition(), d = 1; d < n; d++) {
          var [h, p] = r[d];
          u.render(A, h, p);
        }
      if (a.isUrlDefinition()) {
        var B = a.getDefinition(), [y, m] = r[n];
        B.render(A, y, m);
      }
    }
  }
  static pathM(A) {
    var t = A.getAsCurrentPoint();
    return A.start = A.current, {
      point: t
    };
  }
  pathM(A, t) {
    var {
      pathParser: r
    } = this, {
      point: n
    } = ht.pathM(r), {
      x: i,
      y: s
    } = n;
    r.addMarker(n), t.addPoint(i, s), A && A.moveTo(i, s);
  }
  static pathL(A) {
    var {
      current: t
    } = A, r = A.getAsCurrentPoint();
    return {
      current: t,
      point: r
    };
  }
  pathL(A, t) {
    var {
      pathParser: r
    } = this, {
      current: n,
      point: i
    } = ht.pathL(r), {
      x: s,
      y: a
    } = i;
    r.addMarker(i, n), t.addPoint(s, a), A && A.lineTo(s, a);
  }
  static pathH(A) {
    var {
      current: t,
      command: r
    } = A, n = new ar((r.relative ? t.x : 0) + r.x, t.y);
    return A.current = n, {
      current: t,
      point: n
    };
  }
  pathH(A, t) {
    var {
      pathParser: r
    } = this, {
      current: n,
      point: i
    } = ht.pathH(r), {
      x: s,
      y: a
    } = i;
    r.addMarker(i, n), t.addPoint(s, a), A && A.lineTo(s, a);
  }
  static pathV(A) {
    var {
      current: t,
      command: r
    } = A, n = new ar(t.x, (r.relative ? t.y : 0) + r.y);
    return A.current = n, {
      current: t,
      point: n
    };
  }
  pathV(A, t) {
    var {
      pathParser: r
    } = this, {
      current: n,
      point: i
    } = ht.pathV(r), {
      x: s,
      y: a
    } = i;
    r.addMarker(i, n), t.addPoint(s, a), A && A.lineTo(s, a);
  }
  static pathC(A) {
    var {
      current: t
    } = A, r = A.getPoint("x1", "y1"), n = A.getAsControlPoint("x2", "y2"), i = A.getAsCurrentPoint();
    return {
      current: t,
      point: r,
      controlPoint: n,
      currentPoint: i
    };
  }
  pathC(A, t) {
    var {
      pathParser: r
    } = this, {
      current: n,
      point: i,
      controlPoint: s,
      currentPoint: a
    } = ht.pathC(r);
    r.addMarker(a, s, i), t.addBezierCurve(n.x, n.y, i.x, i.y, s.x, s.y, a.x, a.y), A && A.bezierCurveTo(i.x, i.y, s.x, s.y, a.x, a.y);
  }
  static pathS(A) {
    var {
      current: t
    } = A, r = A.getReflectedControlPoint(), n = A.getAsControlPoint("x2", "y2"), i = A.getAsCurrentPoint();
    return {
      current: t,
      point: r,
      controlPoint: n,
      currentPoint: i
    };
  }
  pathS(A, t) {
    var {
      pathParser: r
    } = this, {
      current: n,
      point: i,
      controlPoint: s,
      currentPoint: a
    } = ht.pathS(r);
    r.addMarker(a, s, i), t.addBezierCurve(n.x, n.y, i.x, i.y, s.x, s.y, a.x, a.y), A && A.bezierCurveTo(i.x, i.y, s.x, s.y, a.x, a.y);
  }
  static pathQ(A) {
    var {
      current: t
    } = A, r = A.getAsControlPoint("x1", "y1"), n = A.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: r,
      currentPoint: n
    };
  }
  pathQ(A, t) {
    var {
      pathParser: r
    } = this, {
      current: n,
      controlPoint: i,
      currentPoint: s
    } = ht.pathQ(r);
    r.addMarker(s, i, i), t.addQuadraticCurve(n.x, n.y, i.x, i.y, s.x, s.y), A && A.quadraticCurveTo(i.x, i.y, s.x, s.y);
  }
  static pathT(A) {
    var {
      current: t
    } = A, r = A.getReflectedControlPoint();
    A.control = r;
    var n = A.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: r,
      currentPoint: n
    };
  }
  pathT(A, t) {
    var {
      pathParser: r
    } = this, {
      current: n,
      controlPoint: i,
      currentPoint: s
    } = ht.pathT(r);
    r.addMarker(s, i, i), t.addQuadraticCurve(n.x, n.y, i.x, i.y, s.x, s.y), A && A.quadraticCurveTo(i.x, i.y, s.x, s.y);
  }
  static pathA(A) {
    var {
      current: t,
      command: r
    } = A, {
      rX: n,
      rY: i,
      xRot: s,
      lArcFlag: a,
      sweepFlag: o
    } = r, l = s * (Math.PI / 180), c = A.getAsCurrentPoint(), u = new ar(Math.cos(l) * (t.x - c.x) / 2 + Math.sin(l) * (t.y - c.y) / 2, -Math.sin(l) * (t.x - c.x) / 2 + Math.cos(l) * (t.y - c.y) / 2), d = Math.pow(u.x, 2) / Math.pow(n, 2) + Math.pow(u.y, 2) / Math.pow(i, 2);
    d > 1 && (n *= Math.sqrt(d), i *= Math.sqrt(d));
    var h = (a === o ? -1 : 1) * Math.sqrt((Math.pow(n, 2) * Math.pow(i, 2) - Math.pow(n, 2) * Math.pow(u.y, 2) - Math.pow(i, 2) * Math.pow(u.x, 2)) / (Math.pow(n, 2) * Math.pow(u.y, 2) + Math.pow(i, 2) * Math.pow(u.x, 2)));
    isNaN(h) && (h = 0);
    var p = new ar(h * n * u.y / i, h * -i * u.x / n), B = new ar((t.x + c.x) / 2 + Math.cos(l) * p.x - Math.sin(l) * p.y, (t.y + c.y) / 2 + Math.sin(l) * p.x + Math.cos(l) * p.y), y = ey([1, 0], [(u.x - p.x) / n, (u.y - p.y) / i]), m = [(u.x - p.x) / n, (u.y - p.y) / i], C = [(-u.x - p.x) / n, (-u.y - p.y) / i], Q = ey(m, C);
    return Mg(m, C) <= -1 && (Q = Math.PI), Mg(m, C) >= 1 && (Q = 0), {
      currentPoint: c,
      rX: n,
      rY: i,
      sweepFlag: o,
      xAxisRotation: l,
      centp: B,
      a1: y,
      ad: Q
    };
  }
  pathA(A, t) {
    var {
      pathParser: r
    } = this, {
      currentPoint: n,
      rX: i,
      rY: s,
      sweepFlag: a,
      xAxisRotation: o,
      centp: l,
      a1: c,
      ad: u
    } = ht.pathA(r), d = 1 - a ? 1 : -1, h = c + d * (u / 2), p = new ar(l.x + i * Math.cos(h), l.y + s * Math.sin(h));
    if (r.addMarkerAngle(p, h - d * Math.PI / 2), r.addMarkerAngle(n, h - d * Math.PI), t.addPoint(n.x, n.y), A && !isNaN(c) && !isNaN(u)) {
      var B = i > s ? i : s, y = i > s ? 1 : i / s, m = i > s ? s / i : 1;
      A.translate(l.x, l.y), A.rotate(o), A.scale(y, m), A.arc(0, 0, B, c, c + u, !!(1 - a)), A.scale(1 / y, 1 / m), A.rotate(-o), A.translate(-l.x, -l.y);
    }
  }
  static pathZ(A) {
    A.current = A.start;
  }
  pathZ(A, t) {
    ht.pathZ(this.pathParser), A && t.x1 !== t.x2 && t.y1 !== t.y2 && A.closePath();
  }
}
class w2 extends ht {
  constructor(A, t, r) {
    super(A, t, r), this.type = "glyph", this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber(), this.unicode = this.getAttribute("unicode").getString(), this.arabicForm = this.getAttribute("arabic-form").getString();
  }
}
class Da extends qo {
  constructor(A, t, r) {
    super(A, t, new.target === Da ? !0 : r), this.type = "text", this.x = 0, this.y = 0, this.measureCache = -1;
  }
  setContext(A) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    super.setContext(A, t);
    var r = this.getStyle("dominant-baseline").getTextBaseline() || this.getStyle("alignment-baseline").getTextBaseline();
    r && (A.textBaseline = r);
  }
  initializeCoordinates() {
    this.x = 0, this.y = 0, this.leafTexts = [], this.textChunkStart = 0, this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY;
  }
  getBoundingBox(A) {
    if (this.type !== "text")
      return this.getTElementBoundingBox(A);
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(A);
    var t = null;
    return this.children.forEach((r, n) => {
      var i = this.getChildBoundingBox(A, this, this, n);
      t ? t.addBoundingBox(i) : t = i;
    }), t;
  }
  getFontSize() {
    var {
      document: A,
      parent: t
    } = this, r = Sn.parse(A.ctx.font).fontSize, n = t.getStyle("font-size").getNumber(r);
    return n;
  }
  getTElementBoundingBox(A) {
    var t = this.getFontSize();
    return new es(this.x, this.y - t, this.x + this.measureText(A), this.y);
  }
  getGlyph(A, t, r) {
    var n = t[r], i = null;
    if (A.isArabic) {
      var s = t.length, a = t[r - 1], o = t[r + 1], l = "isolated";
      if ((r === 0 || a === " ") && r < s - 1 && o !== " " && (l = "terminal"), r > 0 && a !== " " && r < s - 1 && o !== " " && (l = "medial"), r > 0 && a !== " " && (r === s - 1 || o === " ") && (l = "initial"), typeof A.glyphs[n] < "u") {
        var c = A.glyphs[n];
        i = c instanceof w2 ? c : c[l];
      }
    } else
      i = A.glyphs[n];
    return i || (i = A.missingGlyph), i;
  }
  getText() {
    return "";
  }
  getTextFromNode(A) {
    var t = A || this.node, r = Array.from(t.parentNode.childNodes), n = r.indexOf(t), i = r.length - 1, s = sc(
      // textNode.value
      // || textNode.text
      t.textContent || ""
    );
    return n === 0 && (s = IH(s)), n === i && (s = SH(s)), s;
  }
  renderChildren(A) {
    if (this.type !== "text") {
      this.renderTElementChildren(A);
      return;
    }
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(A), this.children.forEach((r, n) => {
      this.renderChild(A, this, this, n);
    });
    var {
      mouse: t
    } = this.document.screen;
    t.isWorking() && t.checkBoundingBox(this, this.getBoundingBox(A));
  }
  renderTElementChildren(A) {
    var {
      document: t,
      parent: r
    } = this, n = this.getText(), i = r.getStyle("font-family").getDefinition();
    if (i) {
      for (var {
        unitsPerEm: s
      } = i.fontFace, a = Sn.parse(t.ctx.font), o = r.getStyle("font-size").getNumber(a.fontSize), l = r.getStyle("font-style").getString(a.fontStyle), c = o / s, u = i.isRTL ? n.split("").reverse().join("") : n, d = ai(r.getAttribute("dx").getString()), h = u.length, p = 0; p < h; p++) {
        var B = this.getGlyph(i, u, p);
        A.translate(this.x, this.y), A.scale(c, -c);
        var y = A.lineWidth;
        A.lineWidth = A.lineWidth * s / o, l === "italic" && A.transform(1, 0, 0.4, 1, 0, 0), B.render(A), l === "italic" && A.transform(1, 0, -0.4, 1, 0, 0), A.lineWidth = y, A.scale(1 / c, -1 / c), A.translate(-this.x, -this.y), this.x += o * (B.horizAdvX || i.horizAdvX) / s, typeof d[p] < "u" && !isNaN(d[p]) && (this.x += d[p]);
      }
      return;
    }
    var {
      x: m,
      y: C
    } = this;
    A.fillStyle && A.fillText(n, m, C), A.strokeStyle && A.strokeText(n, m, C);
  }
  applyAnchoring() {
    if (!(this.textChunkStart >= this.leafTexts.length)) {
      var A = this.leafTexts[this.textChunkStart], t = A.getStyle("text-anchor").getString("start"), r = !1, n = 0;
      t === "start" && !r || t === "end" && r ? n = A.x - this.minX : t === "end" && !r || t === "start" && r ? n = A.x - this.maxX : n = A.x - (this.minX + this.maxX) / 2;
      for (var i = this.textChunkStart; i < this.leafTexts.length; i++)
        this.leafTexts[i].x += n;
      this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY, this.textChunkStart = this.leafTexts.length;
    }
  }
  adjustChildCoordinatesRecursive(A) {
    this.children.forEach((t, r) => {
      this.adjustChildCoordinatesRecursiveCore(A, this, this, r);
    }), this.applyAnchoring();
  }
  adjustChildCoordinatesRecursiveCore(A, t, r, n) {
    var i = r.children[n];
    i.children.length > 0 ? i.children.forEach((s, a) => {
      t.adjustChildCoordinatesRecursiveCore(A, t, i, a);
    }) : this.adjustChildCoordinates(A, t, r, n);
  }
  adjustChildCoordinates(A, t, r, n) {
    var i = r.children[n];
    if (typeof i.measureText != "function")
      return i;
    A.save(), i.setContext(A, !0);
    var s = i.getAttribute("x"), a = i.getAttribute("y"), o = i.getAttribute("dx"), l = i.getAttribute("dy"), c = i.getStyle("font-family").getDefinition(), u = !!c && c.isRTL;
    n === 0 && (s.hasValue() || s.setValue(i.getInheritedAttribute("x")), a.hasValue() || a.setValue(i.getInheritedAttribute("y")), o.hasValue() || o.setValue(i.getInheritedAttribute("dx")), l.hasValue() || l.setValue(i.getInheritedAttribute("dy")));
    var d = i.measureText(A);
    return u && (t.x -= d), s.hasValue() ? (t.applyAnchoring(), i.x = s.getPixels("x"), o.hasValue() && (i.x += o.getPixels("x"))) : (o.hasValue() && (t.x += o.getPixels("x")), i.x = t.x), t.x = i.x, u || (t.x += d), a.hasValue() ? (i.y = a.getPixels("y"), l.hasValue() && (i.y += l.getPixels("y"))) : (l.hasValue() && (t.y += l.getPixels("y")), i.y = t.y), t.y = i.y, t.leafTexts.push(i), t.minX = Math.min(t.minX, i.x, i.x + d), t.maxX = Math.max(t.maxX, i.x, i.x + d), i.clearContext(A), A.restore(), i;
  }
  getChildBoundingBox(A, t, r, n) {
    var i = r.children[n];
    if (typeof i.getBoundingBox != "function")
      return null;
    var s = i.getBoundingBox(A);
    return s ? (i.children.forEach((a, o) => {
      var l = t.getChildBoundingBox(A, t, i, o);
      s.addBoundingBox(l);
    }), s) : null;
  }
  renderChild(A, t, r, n) {
    var i = r.children[n];
    i.render(A), i.children.forEach((s, a) => {
      t.renderChild(A, t, i, a);
    });
  }
  measureText(A) {
    var {
      measureCache: t
    } = this;
    if (~t)
      return t;
    var r = this.getText(), n = this.measureTargetText(A, r);
    return this.measureCache = n, n;
  }
  measureTargetText(A, t) {
    if (!t.length)
      return 0;
    var {
      parent: r
    } = this, n = r.getStyle("font-family").getDefinition();
    if (n) {
      for (var i = this.getFontSize(), s = n.isRTL ? t.split("").reverse().join("") : t, a = ai(r.getAttribute("dx").getString()), o = s.length, l = 0, c = 0; c < o; c++) {
        var u = this.getGlyph(n, s, c);
        l += (u.horizAdvX || n.horizAdvX) * i / n.fontFace.unitsPerEm, typeof a[c] < "u" && !isNaN(a[c]) && (l += a[c]);
      }
      return l;
    }
    if (!A.measureText)
      return t.length * 10;
    A.save(), this.setContext(A, !0);
    var {
      width: d
    } = A.measureText(t);
    return this.clearContext(A), A.restore(), d;
  }
  /**
   * Inherits positional attributes from {@link TextElement} parent(s). Attributes
   * are only inherited from a parent to its first child.
   * @param name - The attribute name.
   * @returns The attribute value or null.
   */
  getInheritedAttribute(A) {
    for (var t = this; t instanceof Da && t.isFirstChild(); ) {
      var r = t.parent.getAttribute(A);
      if (r.hasValue(!0))
        return r.getValue("0");
      t = t.parent;
    }
    return null;
  }
}
class lf extends Da {
  constructor(A, t, r) {
    super(A, t, new.target === lf ? !0 : r), this.type = "tspan", this.text = this.children.length > 0 ? "" : this.getTextFromNode();
  }
  getText() {
    return this.text;
  }
}
class yAA extends lf {
  constructor() {
    super(...arguments), this.type = "textNode";
  }
}
let au = class extends qo {
  constructor() {
    super(...arguments), this.type = "svg", this.root = !1;
  }
  setContext(A) {
    var t, {
      document: r
    } = this, {
      screen: n,
      window: i
    } = r, s = A.canvas;
    if (n.setDefaults(A), s.style && typeof A.font < "u" && i && typeof i.getComputedStyle < "u") {
      A.font = i.getComputedStyle(s).getPropertyValue("font");
      var a = new be(r, "fontSize", Sn.parse(A.font).fontSize);
      a.hasValue() && (r.rootEmSize = a.getPixels("y"), r.emSize = r.rootEmSize);
    }
    this.getAttribute("x").hasValue() || this.getAttribute("x", !0).setValue(0), this.getAttribute("y").hasValue() || this.getAttribute("y", !0).setValue(0);
    var {
      width: o,
      height: l
    } = n.viewPort;
    this.getStyle("width").hasValue() || this.getStyle("width", !0).setValue("100%"), this.getStyle("height").hasValue() || this.getStyle("height", !0).setValue("100%"), this.getStyle("color").hasValue() || this.getStyle("color", !0).setValue("black");
    var c = this.getAttribute("refX"), u = this.getAttribute("refY"), d = this.getAttribute("viewBox"), h = d.hasValue() ? ai(d.getString()) : null, p = !this.root && this.getStyle("overflow").getValue("hidden") !== "visible", B = 0, y = 0, m = 0, C = 0;
    h && (B = h[0], y = h[1]), this.root || (o = this.getStyle("width").getPixels("x"), l = this.getStyle("height").getPixels("y"), this.type === "marker" && (m = B, C = y, B = 0, y = 0)), n.viewPort.setCurrent(o, l), this.node && (!this.parent || ((t = this.node.parentNode) === null || t === void 0 ? void 0 : t.nodeName) === "foreignObject") && this.getStyle("transform", !1, !0).hasValue() && !this.getStyle("transform-origin", !1, !0).hasValue() && this.getStyle("transform-origin", !0, !0).setValue("50% 50%"), super.setContext(A), A.translate(this.getAttribute("x").getPixels("x"), this.getAttribute("y").getPixels("y")), h && (o = h[2], l = h[3]), r.setViewBox({
      ctx: A,
      aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
      width: n.viewPort.width,
      desiredWidth: o,
      height: n.viewPort.height,
      desiredHeight: l,
      minX: B,
      minY: y,
      refX: c.getValue(),
      refY: u.getValue(),
      clip: p,
      clipX: m,
      clipY: C
    }), h && (n.viewPort.removeCurrent(), n.viewPort.setCurrent(o, l));
  }
  clearContext(A) {
    super.clearContext(A), this.document.screen.viewPort.removeCurrent();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(A) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : A, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = this.getAttribute("width", !0), i = this.getAttribute("height", !0), s = this.getAttribute("viewBox"), a = this.getAttribute("style"), o = n.getNumber(0), l = i.getNumber(0);
    if (r)
      if (typeof r == "string")
        this.getAttribute("preserveAspectRatio", !0).setValue(r);
      else {
        var c = this.getAttribute("preserveAspectRatio");
        c.hasValue() && c.setValue(c.getString().replace(/^\s*(\S.*\S)\s*$/, "$1"));
      }
    if (n.setValue(A), i.setValue(t), s.hasValue() || s.setValue("0 0 ".concat(o || A, " ").concat(l || t)), a.hasValue()) {
      var u = this.getStyle("width"), d = this.getStyle("height");
      u.hasValue() && u.setValue("".concat(A, "px")), d.hasValue() && d.setValue("".concat(t, "px"));
    }
  }
};
class m2 extends ht {
  constructor() {
    super(...arguments), this.type = "rect";
  }
  path(A) {
    var t = this.getAttribute("x").getPixels("x"), r = this.getAttribute("y").getPixels("y"), n = this.getStyle("width", !1, !0).getPixels("x"), i = this.getStyle("height", !1, !0).getPixels("y"), s = this.getAttribute("rx"), a = this.getAttribute("ry"), o = s.getPixels("x"), l = a.getPixels("y");
    if (s.hasValue() && !a.hasValue() && (l = o), a.hasValue() && !s.hasValue() && (o = l), o = Math.min(o, n / 2), l = Math.min(l, i / 2), A) {
      var c = 4 * ((Math.sqrt(2) - 1) / 3);
      A.beginPath(), i > 0 && n > 0 && (A.moveTo(t + o, r), A.lineTo(t + n - o, r), A.bezierCurveTo(t + n - o + c * o, r, t + n, r + l - c * l, t + n, r + l), A.lineTo(t + n, r + i - l), A.bezierCurveTo(t + n, r + i - l + c * l, t + n - o + c * o, r + i, t + n - o, r + i), A.lineTo(t + o, r + i), A.bezierCurveTo(t + o - c * o, r + i, t, r + i - l + c * l, t, r + i - l), A.lineTo(t, r + l), A.bezierCurveTo(t, r + l - c * l, t + o - c * o, r, t + o, r), A.closePath());
    }
    return new es(t, r, t + n, r + i);
  }
  getMarkers() {
    return null;
  }
}
class GH extends ht {
  constructor() {
    super(...arguments), this.type = "circle";
  }
  path(A) {
    var t = this.getAttribute("cx").getPixels("x"), r = this.getAttribute("cy").getPixels("y"), n = this.getAttribute("r").getPixels();
    return A && n > 0 && (A.beginPath(), A.arc(t, r, n, 0, Math.PI * 2, !1), A.closePath()), new es(t - n, r - n, t + n, r + n);
  }
  getMarkers() {
    return null;
  }
}
class WH extends ht {
  constructor() {
    super(...arguments), this.type = "ellipse";
  }
  path(A) {
    var t = 4 * ((Math.sqrt(2) - 1) / 3), r = this.getAttribute("rx").getPixels("x"), n = this.getAttribute("ry").getPixels("y"), i = this.getAttribute("cx").getPixels("x"), s = this.getAttribute("cy").getPixels("y");
    return A && r > 0 && n > 0 && (A.beginPath(), A.moveTo(i + r, s), A.bezierCurveTo(i + r, s + t * n, i + t * r, s + n, i, s + n), A.bezierCurveTo(i - t * r, s + n, i - r, s + t * n, i - r, s), A.bezierCurveTo(i - r, s - t * n, i - t * r, s - n, i, s - n), A.bezierCurveTo(i + t * r, s - n, i + r, s - t * n, i + r, s), A.closePath()), new es(i - r, s - n, i + r, s + n);
  }
  getMarkers() {
    return null;
  }
}
class jH extends ht {
  constructor() {
    super(...arguments), this.type = "line";
  }
  getPoints() {
    return [new ar(this.getAttribute("x1").getPixels("x"), this.getAttribute("y1").getPixels("y")), new ar(this.getAttribute("x2").getPixels("x"), this.getAttribute("y2").getPixels("y"))];
  }
  path(A) {
    var [{
      x: t,
      y: r
    }, {
      x: n,
      y: i
    }] = this.getPoints();
    return A && (A.beginPath(), A.moveTo(t, r), A.lineTo(n, i)), new es(t, r, n, i);
  }
  getMarkers() {
    var [A, t] = this.getPoints(), r = A.angleTo(t);
    return [[A, r], [t, r]];
  }
}
class v2 extends ht {
  constructor(A, t, r) {
    super(A, t, r), this.type = "polyline", this.points = [], this.points = ar.parsePath(this.getAttribute("points").getString());
  }
  path(A) {
    var {
      points: t
    } = this, [{
      x: r,
      y: n
    }] = t, i = new es(r, n);
    return A && (A.beginPath(), A.moveTo(r, n)), t.forEach((s) => {
      var {
        x: a,
        y: o
      } = s;
      i.addPoint(a, o), A && A.lineTo(a, o);
    }), i;
  }
  getMarkers() {
    var {
      points: A
    } = this, t = A.length - 1, r = [];
    return A.forEach((n, i) => {
      i !== t && r.push([n, n.angleTo(A[i + 1])]);
    }), r.length > 0 && r.push([A[A.length - 1], r[r.length - 1][1]]), r;
  }
}
class qH extends v2 {
  constructor() {
    super(...arguments), this.type = "polygon";
  }
  path(A) {
    var t = super.path(A), [{
      x: r,
      y: n
    }] = this.points;
    return A && (A.lineTo(r, n), A.closePath()), t;
  }
}
class $H extends Yt {
  constructor() {
    super(...arguments), this.type = "pattern";
  }
  createPattern(A, t, r) {
    var n = this.getStyle("width").getPixels("x", !0), i = this.getStyle("height").getPixels("y", !0), s = new au(this.document, null);
    s.attributes.viewBox = new be(this.document, "viewBox", this.getAttribute("viewBox").getValue()), s.attributes.width = new be(this.document, "width", "".concat(n, "px")), s.attributes.height = new be(this.document, "height", "".concat(i, "px")), s.attributes.transform = new be(this.document, "transform", this.getAttribute("patternTransform").getValue()), s.children = this.children;
    var a = this.document.createCanvas(n, i), o = a.getContext("2d"), l = this.getAttribute("x"), c = this.getAttribute("y");
    l.hasValue() && c.hasValue() && o.translate(l.getPixels("x", !0), c.getPixels("y", !0)), r.hasValue() ? this.styles["fill-opacity"] = r : Reflect.deleteProperty(this.styles, "fill-opacity");
    for (var u = -1; u <= 1; u++)
      for (var d = -1; d <= 1; d++)
        o.save(), s.attributes.x = new be(this.document, "x", u * a.width), s.attributes.y = new be(this.document, "y", d * a.height), s.render(o), o.restore();
    var h = A.createPattern(a, "repeat");
    return h;
  }
}
class zH extends Yt {
  constructor() {
    super(...arguments), this.type = "marker";
  }
  render(A, t, r) {
    if (t) {
      var {
        x: n,
        y: i
      } = t, s = this.getAttribute("orient").getString("auto"), a = this.getAttribute("markerUnits").getString("strokeWidth");
      A.translate(n, i), s === "auto" && A.rotate(r), a === "strokeWidth" && A.scale(A.lineWidth, A.lineWidth), A.save();
      var o = new au(this.document, null);
      o.type = this.type, o.attributes.viewBox = new be(this.document, "viewBox", this.getAttribute("viewBox").getValue()), o.attributes.refX = new be(this.document, "refX", this.getAttribute("refX").getValue()), o.attributes.refY = new be(this.document, "refY", this.getAttribute("refY").getValue()), o.attributes.width = new be(this.document, "width", this.getAttribute("markerWidth").getValue()), o.attributes.height = new be(this.document, "height", this.getAttribute("markerHeight").getValue()), o.attributes.overflow = new be(this.document, "overflow", this.getAttribute("overflow").getValue()), o.attributes.fill = new be(this.document, "fill", this.getAttribute("fill").getColor("black")), o.attributes.stroke = new be(this.document, "stroke", this.getAttribute("stroke").getValue("none")), o.children = this.children, o.render(A), A.restore(), a === "strokeWidth" && A.scale(1 / A.lineWidth, 1 / A.lineWidth), s === "auto" && A.rotate(-r), A.translate(-n, -i);
    }
  }
}
class XH extends Yt {
  constructor() {
    super(...arguments), this.type = "defs";
  }
  render() {
  }
}
class kp extends qo {
  constructor() {
    super(...arguments), this.type = "g";
  }
  getBoundingBox(A) {
    var t = new es();
    return this.children.forEach((r) => {
      t.addBoundingBox(r.getBoundingBox(A));
    }), t;
  }
}
class y2 extends Yt {
  constructor(A, t, r) {
    super(A, t, r), this.attributesToInherit = ["gradientUnits"], this.stops = [];
    var {
      stops: n,
      children: i
    } = this;
    i.forEach((s) => {
      s.type === "stop" && n.push(s);
    });
  }
  getGradientUnits() {
    return this.getAttribute("gradientUnits").getString("objectBoundingBox");
  }
  createGradient(A, t, r) {
    var n = this;
    this.getHrefAttribute().hasValue() && (n = this.getHrefAttribute().getDefinition(), this.inheritStopContainer(n));
    var {
      stops: i
    } = n, s = this.getGradient(A, t);
    if (!s)
      return this.addParentOpacity(r, i[i.length - 1].color);
    if (i.forEach((y) => {
      s.addColorStop(y.offset, this.addParentOpacity(r, y.color));
    }), this.getAttribute("gradientTransform").hasValue()) {
      var {
        document: a
      } = this, {
        MAX_VIRTUAL_PIXELS: o,
        viewPort: l
      } = a.screen, [c] = l.viewPorts, u = new m2(a, null);
      u.attributes.x = new be(a, "x", -o / 3), u.attributes.y = new be(a, "y", -o / 3), u.attributes.width = new be(a, "width", o), u.attributes.height = new be(a, "height", o);
      var d = new kp(a, null);
      d.attributes.transform = new be(a, "transform", this.getAttribute("gradientTransform").getValue()), d.children = [u];
      var h = new au(a, null);
      h.attributes.x = new be(a, "x", 0), h.attributes.y = new be(a, "y", 0), h.attributes.width = new be(a, "width", c.width), h.attributes.height = new be(a, "height", c.height), h.children = [d];
      var p = a.createCanvas(c.width, c.height), B = p.getContext("2d");
      return B.fillStyle = s, h.render(B), B.createPattern(p, "no-repeat");
    }
    return s;
  }
  inheritStopContainer(A) {
    this.attributesToInherit.forEach((t) => {
      !this.getAttribute(t).hasValue() && A.getAttribute(t).hasValue() && this.getAttribute(t, !0).setValue(A.getAttribute(t).getValue());
    });
  }
  addParentOpacity(A, t) {
    if (A.hasValue()) {
      var r = new be(this.document, "color", t);
      return r.addOpacity(A).getColor();
    }
    return t;
  }
}
class YH extends y2 {
  constructor(A, t, r) {
    super(A, t, r), this.type = "linearGradient", this.attributesToInherit.push("x1", "y1", "x2", "y2");
  }
  getGradient(A, t) {
    var r = this.getGradientUnits() === "objectBoundingBox", n = r ? t.getBoundingBox(A) : null;
    if (r && !n)
      return null;
    !this.getAttribute("x1").hasValue() && !this.getAttribute("y1").hasValue() && !this.getAttribute("x2").hasValue() && !this.getAttribute("y2").hasValue() && (this.getAttribute("x1", !0).setValue(0), this.getAttribute("y1", !0).setValue(0), this.getAttribute("x2", !0).setValue(1), this.getAttribute("y2", !0).setValue(0));
    var i = r ? n.x + n.width * this.getAttribute("x1").getNumber() : this.getAttribute("x1").getPixels("x"), s = r ? n.y + n.height * this.getAttribute("y1").getNumber() : this.getAttribute("y1").getPixels("y"), a = r ? n.x + n.width * this.getAttribute("x2").getNumber() : this.getAttribute("x2").getPixels("x"), o = r ? n.y + n.height * this.getAttribute("y2").getNumber() : this.getAttribute("y2").getPixels("y");
    return i === a && s === o ? null : A.createLinearGradient(i, s, a, o);
  }
}
class JH extends y2 {
  constructor(A, t, r) {
    super(A, t, r), this.type = "radialGradient", this.attributesToInherit.push("cx", "cy", "r", "fx", "fy", "fr");
  }
  getGradient(A, t) {
    var r = this.getGradientUnits() === "objectBoundingBox", n = t.getBoundingBox(A);
    if (r && !n)
      return null;
    this.getAttribute("cx").hasValue() || this.getAttribute("cx", !0).setValue("50%"), this.getAttribute("cy").hasValue() || this.getAttribute("cy", !0).setValue("50%"), this.getAttribute("r").hasValue() || this.getAttribute("r", !0).setValue("50%");
    var i = r ? n.x + n.width * this.getAttribute("cx").getNumber() : this.getAttribute("cx").getPixels("x"), s = r ? n.y + n.height * this.getAttribute("cy").getNumber() : this.getAttribute("cy").getPixels("y"), a = i, o = s;
    this.getAttribute("fx").hasValue() && (a = r ? n.x + n.width * this.getAttribute("fx").getNumber() : this.getAttribute("fx").getPixels("x")), this.getAttribute("fy").hasValue() && (o = r ? n.y + n.height * this.getAttribute("fy").getNumber() : this.getAttribute("fy").getPixels("y"));
    var l = r ? (n.width + n.height) / 2 * this.getAttribute("r").getNumber() : this.getAttribute("r").getPixels(), c = this.getAttribute("fr").getPixels();
    return A.createRadialGradient(a, o, c, i, s, l);
  }
}
class ZH extends Yt {
  constructor(A, t, r) {
    super(A, t, r), this.type = "stop";
    var n = Math.max(0, Math.min(1, this.getAttribute("offset").getNumber())), i = this.getStyle("stop-opacity"), s = this.getStyle("stop-color", !0);
    s.getString() === "" && s.setValue("#000"), i.hasValue() && (s = s.addOpacity(i)), this.offset = n, this.color = s.getColor();
  }
}
class Kp extends Yt {
  constructor(A, t, r) {
    super(A, t, r), this.type = "animate", this.duration = 0, this.initialValue = null, this.initialUnits = "", this.removed = !1, this.frozen = !1, A.screen.animations.push(this), this.begin = this.getAttribute("begin").getMilliseconds(), this.maxDuration = this.begin + this.getAttribute("dur").getMilliseconds(), this.from = this.getAttribute("from"), this.to = this.getAttribute("to"), this.values = new be(A, "values", null);
    var n = this.getAttribute("values");
    n.hasValue() && this.values.setValue(n.getString().split(";"));
  }
  getProperty() {
    var A = this.getAttribute("attributeType").getString(), t = this.getAttribute("attributeName").getString();
    return A === "CSS" ? this.parent.getStyle(t, !0) : this.parent.getAttribute(t, !0);
  }
  calcValue() {
    var {
      initialUnits: A
    } = this, {
      progress: t,
      from: r,
      to: n
    } = this.getProgress(), i = r.getNumber() + (n.getNumber() - r.getNumber()) * t;
    return A === "%" && (i *= 100), "".concat(i).concat(A);
  }
  update(A) {
    var {
      parent: t
    } = this, r = this.getProperty();
    if (this.initialValue || (this.initialValue = r.getString(), this.initialUnits = r.getUnits()), this.duration > this.maxDuration) {
      var n = this.getAttribute("fill").getString("remove");
      if (this.getAttribute("repeatCount").getString() === "indefinite" || this.getAttribute("repeatDur").getString() === "indefinite")
        this.duration = 0;
      else if (n === "freeze" && !this.frozen)
        this.frozen = !0, t.animationFrozen = !0, t.animationFrozenValue = r.getString();
      else if (n === "remove" && !this.removed)
        return this.removed = !0, r.setValue(t.animationFrozen ? t.animationFrozenValue : this.initialValue), !0;
      return !1;
    }
    this.duration += A;
    var i = !1;
    if (this.begin < this.duration) {
      var s = this.calcValue(), a = this.getAttribute("type");
      if (a.hasValue()) {
        var o = a.getString();
        s = "".concat(o, "(").concat(s, ")");
      }
      r.setValue(s), i = !0;
    }
    return i;
  }
  getProgress() {
    var {
      document: A,
      values: t
    } = this, r = {
      progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
    };
    if (t.hasValue()) {
      var n = r.progress * (t.getValue().length - 1), i = Math.floor(n), s = Math.ceil(n);
      r.from = new be(A, "from", parseFloat(t.getValue()[i])), r.to = new be(A, "to", parseFloat(t.getValue()[s])), r.progress = (n - i) / (s - i);
    } else
      r.from = this.from, r.to = this.to;
    return r;
  }
}
class AT extends Kp {
  constructor() {
    super(...arguments), this.type = "animateColor";
  }
  calcValue() {
    var {
      progress: A,
      from: t,
      to: r
    } = this.getProgress(), n = new Jv(t.getColor()), i = new Jv(r.getColor());
    if (n.ok && i.ok) {
      var s = n.r + (i.r - n.r) * A, a = n.g + (i.g - n.g) * A, o = n.b + (i.b - n.b) * A;
      return "rgb(".concat(Math.floor(s), ", ").concat(Math.floor(a), ", ").concat(Math.floor(o), ")");
    }
    return this.getAttribute("from").getColor();
  }
}
class eT extends Kp {
  constructor() {
    super(...arguments), this.type = "animateTransform";
  }
  calcValue() {
    var {
      progress: A,
      from: t,
      to: r
    } = this.getProgress(), n = ai(t.getString()), i = ai(r.getString()), s = n.map((a, o) => {
      var l = i[o];
      return a + (l - a) * A;
    }).join(" ");
    return s;
  }
}
class tT extends Yt {
  constructor(A, t, r) {
    super(A, t, r), this.type = "font", this.glyphs = /* @__PURE__ */ Object.create(null), this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
    var {
      definitions: n
    } = A, {
      children: i
    } = this;
    for (var s of i)
      switch (s.type) {
        case "font-face": {
          this.fontFace = s;
          var a = s.getStyle("font-family");
          a.hasValue() && (n[a.getString()] = this);
          break;
        }
        case "missing-glyph":
          this.missingGlyph = s;
          break;
        case "glyph": {
          var o = s;
          o.arabicForm ? (this.isRTL = !0, this.isArabic = !0, typeof this.glyphs[o.unicode] > "u" && (this.glyphs[o.unicode] = /* @__PURE__ */ Object.create(null)), this.glyphs[o.unicode][o.arabicForm] = o) : this.glyphs[o.unicode] = o;
          break;
        }
      }
  }
  render() {
  }
}
class rT extends Yt {
  constructor(A, t, r) {
    super(A, t, r), this.type = "font-face", this.ascent = this.getAttribute("ascent").getNumber(), this.descent = this.getAttribute("descent").getNumber(), this.unitsPerEm = this.getAttribute("units-per-em").getNumber();
  }
}
class nT extends ht {
  constructor() {
    super(...arguments), this.type = "missing-glyph", this.horizAdvX = 0;
  }
}
class iT extends Da {
  constructor() {
    super(...arguments), this.type = "tref";
  }
  getText() {
    var A = this.getHrefAttribute().getDefinition();
    if (A) {
      var t = A.children[0];
      if (t)
        return t.getText();
    }
    return "";
  }
}
class sT extends Da {
  constructor(A, t, r) {
    super(A, t, r), this.type = "a";
    var {
      childNodes: n
    } = t, i = n[0], s = n.length > 0 && Array.from(n).every((a) => a.nodeType === 3);
    this.hasText = s, this.text = s ? this.getTextFromNode(i) : "";
  }
  getText() {
    return this.text;
  }
  renderChildren(A) {
    if (this.hasText) {
      super.renderChildren(A);
      var {
        document: t,
        x: r,
        y: n
      } = this, {
        mouse: i
      } = t.screen, s = new be(t, "fontSize", Sn.parse(t.ctx.font).fontSize);
      i.isWorking() && i.checkBoundingBox(this, new es(r, n - s.getPixels("y"), r + this.measureText(A), n));
    } else if (this.children.length > 0) {
      var a = new kp(this.document, null);
      a.children = this.children, a.parent = this, a.render(A);
    }
  }
  onClick() {
    var {
      window: A
    } = this.document;
    A && A.open(this.getHrefAttribute().getString());
  }
  onMouseMove() {
    var A = this.document.ctx;
    A.canvas.style.cursor = "pointer";
  }
}
function hx(e, A) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    A && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Kd(e) {
  for (var A = 1; A < arguments.length; A++) {
    var t = arguments[A] != null ? arguments[A] : {};
    A % 2 ? hx(Object(t), !0).forEach(function(r) {
      d2(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : hx(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
class aT extends Da {
  constructor(A, t, r) {
    super(A, t, r), this.type = "textPath", this.textWidth = 0, this.textHeight = 0, this.pathLength = -1, this.glyphInfo = null, this.letterSpacingCache = [], this.measuresCache = /* @__PURE__ */ new Map([["", 0]]);
    var n = this.getHrefAttribute().getDefinition();
    this.text = this.getTextFromNode(), this.dataArray = this.parsePathData(n);
  }
  getText() {
    return this.text;
  }
  path(A) {
    var {
      dataArray: t
    } = this;
    A && A.beginPath(), t.forEach((r) => {
      var {
        type: n,
        points: i
      } = r;
      switch (n) {
        case ke.LINE_TO:
          A && A.lineTo(i[0], i[1]);
          break;
        case ke.MOVE_TO:
          A && A.moveTo(i[0], i[1]);
          break;
        case ke.CURVE_TO:
          A && A.bezierCurveTo(i[0], i[1], i[2], i[3], i[4], i[5]);
          break;
        case ke.QUAD_TO:
          A && A.quadraticCurveTo(i[0], i[1], i[2], i[3]);
          break;
        case ke.ARC: {
          var [s, a, o, l, c, u, d, h] = i, p = o > l ? o : l, B = o > l ? 1 : o / l, y = o > l ? l / o : 1;
          A && (A.translate(s, a), A.rotate(d), A.scale(B, y), A.arc(0, 0, p, c, c + u, !!(1 - h)), A.scale(1 / B, 1 / y), A.rotate(-d), A.translate(-s, -a));
          break;
        }
        case ke.CLOSE_PATH:
          A && A.closePath();
          break;
      }
    });
  }
  renderChildren(A) {
    this.setTextData(A), A.save();
    var t = this.parent.getStyle("text-decoration").getString(), r = this.getFontSize(), {
      glyphInfo: n
    } = this, i = A.fillStyle;
    t === "underline" && A.beginPath(), n.forEach((s, a) => {
      var {
        p0: o,
        p1: l,
        rotation: c,
        text: u
      } = s;
      A.save(), A.translate(o.x, o.y), A.rotate(c), A.fillStyle && A.fillText(u, 0, 0), A.strokeStyle && A.strokeText(u, 0, 0), A.restore(), t === "underline" && (a === 0 && A.moveTo(o.x, o.y + r / 8), A.lineTo(l.x, l.y + r / 5));
    }), t === "underline" && (A.lineWidth = r / 20, A.strokeStyle = i, A.stroke(), A.closePath()), A.restore();
  }
  getLetterSpacingAt() {
    var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return this.letterSpacingCache[A] || 0;
  }
  findSegmentToFitChar(A, t, r, n, i, s, a, o, l) {
    var c = s, u = this.measureText(A, o);
    o === " " && t === "justify" && r < n && (u += (n - r) / i), l > -1 && (c += this.getLetterSpacingAt(l));
    var d = this.textHeight / 20, h = this.getEquidistantPointOnPath(c, d, 0), p = this.getEquidistantPointOnPath(c + u, d, 0), B = {
      p0: h,
      p1: p
    }, y = h && p ? Math.atan2(p.y - h.y, p.x - h.x) : 0;
    if (a) {
      var m = Math.cos(Math.PI / 2 + y) * a, C = Math.cos(-y) * a;
      B.p0 = Kd(Kd({}, h), {}, {
        x: h.x + m,
        y: h.y + C
      }), B.p1 = Kd(Kd({}, p), {}, {
        x: p.x + m,
        y: p.y + C
      });
    }
    return c += u, {
      offset: c,
      segment: B,
      rotation: y
    };
  }
  measureText(A, t) {
    var {
      measuresCache: r
    } = this, n = t || this.getText();
    if (r.has(n))
      return r.get(n);
    var i = this.measureTargetText(A, n);
    return r.set(n, i), i;
  }
  // This method supposes what all custom fonts already loaded.
  // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
  // You need to call this method manually to update glyphs cache.
  setTextData(A) {
    if (!this.glyphInfo) {
      var t = this.getText(), r = t.split(""), n = t.split(" ").length - 1, i = this.parent.getAttribute("dx").split().map((F) => F.getPixels("x")), s = this.parent.getAttribute("dy").getPixels("y"), a = this.parent.getStyle("text-anchor").getString("start"), o = this.getStyle("letter-spacing"), l = this.parent.getStyle("letter-spacing"), c = 0;
      !o.hasValue() || o.getValue() === "inherit" ? c = l.getPixels() : o.hasValue() && o.getValue() !== "initial" && o.getValue() !== "unset" && (c = o.getPixels());
      var u = [], d = t.length;
      this.letterSpacingCache = u;
      for (var h = 0; h < d; h++)
        u.push(typeof i[h] < "u" ? i[h] : c);
      var p = u.reduce((F, T, V) => V === 0 ? 0 : F + T || 0, 0), B = this.measureText(A), y = Math.max(B + p, 0);
      this.textWidth = B, this.textHeight = this.getFontSize(), this.glyphInfo = [];
      var m = this.getPathLength(), C = this.getStyle("startOffset").getNumber(0) * m, Q = 0;
      (a === "middle" || a === "center") && (Q = -y / 2), (a === "end" || a === "right") && (Q = -y), Q += C, r.forEach((F, T) => {
        var {
          offset: V,
          segment: M,
          rotation: D
        } = this.findSegmentToFitChar(A, a, y, m, n, Q, s, F, T);
        Q = V, !(!M.p0 || !M.p1) && this.glyphInfo.push({
          // transposeX: midpoint.x,
          // transposeY: midpoint.y,
          text: r[T],
          p0: M.p0,
          p1: M.p1,
          rotation: D
        });
      });
    }
  }
  parsePathData(A) {
    if (this.pathLength = -1, !A)
      return [];
    var t = [], {
      pathParser: r
    } = A;
    for (r.reset(); !r.isEnd(); ) {
      var {
        current: n
      } = r, i = n ? n.x : 0, s = n ? n.y : 0, a = r.next(), o = a.type, l = [];
      switch (a.type) {
        case ke.MOVE_TO:
          this.pathM(r, l);
          break;
        case ke.LINE_TO:
          o = this.pathL(r, l);
          break;
        case ke.HORIZ_LINE_TO:
          o = this.pathH(r, l);
          break;
        case ke.VERT_LINE_TO:
          o = this.pathV(r, l);
          break;
        case ke.CURVE_TO:
          this.pathC(r, l);
          break;
        case ke.SMOOTH_CURVE_TO:
          o = this.pathS(r, l);
          break;
        case ke.QUAD_TO:
          this.pathQ(r, l);
          break;
        case ke.SMOOTH_QUAD_TO:
          o = this.pathT(r, l);
          break;
        case ke.ARC:
          l = this.pathA(r);
          break;
        case ke.CLOSE_PATH:
          ht.pathZ(r);
          break;
      }
      a.type !== ke.CLOSE_PATH ? t.push({
        type: o,
        points: l,
        start: {
          x: i,
          y: s
        },
        pathLength: this.calcLength(i, s, o, l)
      }) : t.push({
        type: ke.CLOSE_PATH,
        points: [],
        pathLength: 0
      });
    }
    return t;
  }
  pathM(A, t) {
    var {
      x: r,
      y: n
    } = ht.pathM(A).point;
    t.push(r, n);
  }
  pathL(A, t) {
    var {
      x: r,
      y: n
    } = ht.pathL(A).point;
    return t.push(r, n), ke.LINE_TO;
  }
  pathH(A, t) {
    var {
      x: r,
      y: n
    } = ht.pathH(A).point;
    return t.push(r, n), ke.LINE_TO;
  }
  pathV(A, t) {
    var {
      x: r,
      y: n
    } = ht.pathV(A).point;
    return t.push(r, n), ke.LINE_TO;
  }
  pathC(A, t) {
    var {
      point: r,
      controlPoint: n,
      currentPoint: i
    } = ht.pathC(A);
    t.push(r.x, r.y, n.x, n.y, i.x, i.y);
  }
  pathS(A, t) {
    var {
      point: r,
      controlPoint: n,
      currentPoint: i
    } = ht.pathS(A);
    return t.push(r.x, r.y, n.x, n.y, i.x, i.y), ke.CURVE_TO;
  }
  pathQ(A, t) {
    var {
      controlPoint: r,
      currentPoint: n
    } = ht.pathQ(A);
    t.push(r.x, r.y, n.x, n.y);
  }
  pathT(A, t) {
    var {
      controlPoint: r,
      currentPoint: n
    } = ht.pathT(A);
    return t.push(r.x, r.y, n.x, n.y), ke.QUAD_TO;
  }
  pathA(A) {
    var {
      rX: t,
      rY: r,
      sweepFlag: n,
      xAxisRotation: i,
      centp: s,
      a1: a,
      ad: o
    } = ht.pathA(A);
    return n === 0 && o > 0 && (o -= 2 * Math.PI), n === 1 && o < 0 && (o += 2 * Math.PI), [s.x, s.y, t, r, a, o, i, n];
  }
  calcLength(A, t, r, n) {
    var i = 0, s = null, a = null, o = 0;
    switch (r) {
      case ke.LINE_TO:
        return this.getLineLength(A, t, n[0], n[1]);
      case ke.CURVE_TO:
        for (i = 0, s = this.getPointOnCubicBezier(0, A, t, n[0], n[1], n[2], n[3], n[4], n[5]), o = 0.01; o <= 1; o += 0.01)
          a = this.getPointOnCubicBezier(o, A, t, n[0], n[1], n[2], n[3], n[4], n[5]), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        return i;
      case ke.QUAD_TO:
        for (i = 0, s = this.getPointOnQuadraticBezier(0, A, t, n[0], n[1], n[2], n[3]), o = 0.01; o <= 1; o += 0.01)
          a = this.getPointOnQuadraticBezier(o, A, t, n[0], n[1], n[2], n[3]), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        return i;
      case ke.ARC: {
        i = 0;
        var l = n[4], c = n[5], u = n[4] + c, d = Math.PI / 180;
        if (Math.abs(l - u) < d && (d = Math.abs(l - u)), s = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], l, 0), c < 0)
          for (o = l - d; o > u; o -= d)
            a = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], o, 0), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        else
          for (o = l + d; o < u; o += d)
            a = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], o, 0), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        return a = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], u, 0), i += this.getLineLength(s.x, s.y, a.x, a.y), i;
      }
    }
    return 0;
  }
  getPointOnLine(A, t, r, n, i) {
    var s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : t, a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : r, o = (i - r) / (n - t + Wl), l = Math.sqrt(A * A / (1 + o * o));
    n < t && (l *= -1);
    var c = o * l, u = null;
    if (n === t)
      u = {
        x: s,
        y: a + c
      };
    else if ((a - r) / (s - t + Wl) === o)
      u = {
        x: s + l,
        y: a + c
      };
    else {
      var d = 0, h = 0, p = this.getLineLength(t, r, n, i);
      if (p < Wl)
        return null;
      var B = (s - t) * (n - t) + (a - r) * (i - r);
      B /= p * p, d = t + B * (n - t), h = r + B * (i - r);
      var y = this.getLineLength(s, a, d, h), m = Math.sqrt(A * A - y * y);
      l = Math.sqrt(m * m / (1 + o * o)), n < t && (l *= -1), c = o * l, u = {
        x: d + l,
        y: h + c
      };
    }
    return u;
  }
  getPointOnPath(A) {
    var t = this.getPathLength(), r = 0, n = null;
    if (A < -5e-5 || A - 5e-5 > t)
      return null;
    var {
      dataArray: i
    } = this;
    for (var s of i) {
      if (s && (s.pathLength < 5e-5 || r + s.pathLength + 5e-5 < A)) {
        r += s.pathLength;
        continue;
      }
      var a = A - r, o = 0;
      switch (s.type) {
        case ke.LINE_TO:
          n = this.getPointOnLine(a, s.start.x, s.start.y, s.points[0], s.points[1], s.start.x, s.start.y);
          break;
        case ke.ARC: {
          var l = s.points[4], c = s.points[5], u = s.points[4] + c;
          if (o = l + a / s.pathLength * c, c < 0 && o < u || c >= 0 && o > u)
            break;
          n = this.getPointOnEllipticalArc(s.points[0], s.points[1], s.points[2], s.points[3], o, s.points[6]);
          break;
        }
        case ke.CURVE_TO:
          o = a / s.pathLength, o > 1 && (o = 1), n = this.getPointOnCubicBezier(o, s.start.x, s.start.y, s.points[0], s.points[1], s.points[2], s.points[3], s.points[4], s.points[5]);
          break;
        case ke.QUAD_TO:
          o = a / s.pathLength, o > 1 && (o = 1), n = this.getPointOnQuadraticBezier(o, s.start.x, s.start.y, s.points[0], s.points[1], s.points[2], s.points[3]);
          break;
      }
      if (n)
        return n;
      break;
    }
    return null;
  }
  getLineLength(A, t, r, n) {
    return Math.sqrt((r - A) * (r - A) + (n - t) * (n - t));
  }
  getPathLength() {
    return this.pathLength === -1 && (this.pathLength = this.dataArray.reduce((A, t) => t.pathLength > 0 ? A + t.pathLength : A, 0)), this.pathLength;
  }
  getPointOnCubicBezier(A, t, r, n, i, s, a, o, l) {
    var c = o * ty(A) + s * ry(A) + n * ny(A) + t * iy(A), u = l * ty(A) + a * ry(A) + i * ny(A) + r * iy(A);
    return {
      x: c,
      y: u
    };
  }
  getPointOnQuadraticBezier(A, t, r, n, i, s, a) {
    var o = s * sy(A) + n * ay(A) + t * oy(A), l = a * sy(A) + i * ay(A) + r * oy(A);
    return {
      x: o,
      y: l
    };
  }
  getPointOnEllipticalArc(A, t, r, n, i, s) {
    var a = Math.cos(s), o = Math.sin(s), l = {
      x: r * Math.cos(i),
      y: n * Math.sin(i)
    };
    return {
      x: A + (l.x * a - l.y * o),
      y: t + (l.x * o + l.y * a)
    };
  }
  // TODO need some optimisations. possibly build cache only for curved segments?
  buildEquidistantCache(A, t) {
    var r = this.getPathLength(), n = t || 0.25, i = A || r / 100;
    if (!this.equidistantCache || this.equidistantCache.step !== i || this.equidistantCache.precision !== n) {
      this.equidistantCache = {
        step: i,
        precision: n,
        points: []
      };
      for (var s = 0, a = 0; a <= r; a += n) {
        var o = this.getPointOnPath(a), l = this.getPointOnPath(a + n);
        !o || !l || (s += this.getLineLength(o.x, o.y, l.x, l.y), s >= i && (this.equidistantCache.points.push({
          x: o.x,
          y: o.y,
          distance: a
        }), s -= i));
      }
    }
  }
  getEquidistantPointOnPath(A, t, r) {
    if (this.buildEquidistantCache(t, r), A < 0 || A - this.getPathLength() > 5e-5)
      return null;
    var n = Math.round(A / this.getPathLength() * (this.equidistantCache.points.length - 1));
    return this.equidistantCache.points[n] || null;
  }
}
var CAA = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
class oT extends qo {
  constructor(A, t, r) {
    super(A, t, r), this.type = "image", this.loaded = !1;
    var n = this.getHrefAttribute().getString();
    if (n) {
      var i = n.endsWith(".svg") || /^\s*data:image\/svg\+xml/i.test(n);
      A.images.push(this), i ? this.loadSvg(n) : this.loadImage(n), this.isSvg = i;
    }
  }
  loadImage(A) {
    var t = this;
    return Na(function* () {
      try {
        var r = yield t.document.createImage(A);
        t.image = r;
      } catch (n) {
        console.error('Error while loading image "'.concat(A, '":'), n);
      }
      t.loaded = !0;
    })();
  }
  loadSvg(A) {
    var t = this;
    return Na(function* () {
      var r = CAA.exec(A);
      if (r) {
        var n = r[5];
        r[4] === "base64" ? t.image = atob(n) : t.image = decodeURIComponent(n);
      } else
        try {
          var i = yield t.document.fetch(A), s = yield i.text();
          t.image = s;
        } catch (a) {
          console.error('Error while loading image "'.concat(A, '":'), a);
        }
      t.loaded = !0;
    })();
  }
  renderChildren(A) {
    var {
      document: t,
      image: r,
      loaded: n
    } = this, i = this.getAttribute("x").getPixels("x"), s = this.getAttribute("y").getPixels("y"), a = this.getStyle("width").getPixels("x"), o = this.getStyle("height").getPixels("y");
    if (!(!n || !r || !a || !o)) {
      if (A.save(), A.translate(i, s), this.isSvg) {
        var l = t.canvg.forkString(A, this.image, {
          ignoreMouse: !0,
          ignoreAnimation: !0,
          ignoreDimensions: !0,
          ignoreClear: !0,
          offsetX: 0,
          offsetY: 0,
          scaleWidth: a,
          scaleHeight: o
        });
        l.document.documentElement.parent = this, l.render();
      } else {
        var c = this.image;
        t.setViewBox({
          ctx: A,
          aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
          width: a,
          desiredWidth: c.width,
          height: o,
          desiredHeight: c.height
        }), this.loaded && (typeof c.complete > "u" || c.complete) && A.drawImage(c, 0, 0);
      }
      A.restore();
    }
  }
  getBoundingBox() {
    var A = this.getAttribute("x").getPixels("x"), t = this.getAttribute("y").getPixels("y"), r = this.getStyle("width").getPixels("x"), n = this.getStyle("height").getPixels("y");
    return new es(A, t, A + r, t + n);
  }
}
class lT extends qo {
  constructor() {
    super(...arguments), this.type = "symbol";
  }
  render(A) {
  }
}
class cT {
  constructor(A) {
    this.document = A, this.loaded = !1, A.fonts.push(this);
  }
  load(A, t) {
    var r = this;
    return Na(function* () {
      try {
        var {
          document: n
        } = r, i = yield n.canvg.parser.load(t), s = i.getElementsByTagName("font");
        Array.from(s).forEach((a) => {
          var o = n.createElement(a);
          n.definitions[A] = o;
        });
      } catch (a) {
        console.error('Error while loading font "'.concat(t, '":'), a);
      }
      r.loaded = !0;
    })();
  }
}
class C2 extends Yt {
  constructor(A, t, r) {
    super(A, t, r), this.type = "style";
    var n = sc(
      Array.from(t.childNodes).map((s) => s.textContent).join("").replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "").replace(/@import.*;/g, "")
      // remove imports
    ), i = n.split("}");
    i.forEach((s) => {
      var a = s.trim();
      if (a) {
        var o = a.split("{"), l = o[0].split(","), c = o[1].split(";");
        l.forEach((u) => {
          var d = u.trim();
          if (d) {
            var h = A.styles[d] || {};
            if (c.forEach((y) => {
              var m = y.indexOf(":"), C = y.substr(0, m).trim(), Q = y.substr(m + 1, y.length - m).trim();
              C && Q && (h[C] = new be(A, C, Q));
            }), A.styles[d] = h, A.stylesSpecificity[d] = TH(d), d === "@font-face") {
              var p = h["font-family"].getString().replace(/"|'/g, ""), B = h.src.getString().split(",");
              B.forEach((y) => {
                if (y.indexOf('format("svg")') > 0) {
                  var m = g2(y);
                  m && new cT(A).load(p, m);
                }
              });
            }
          }
        });
      }
    });
  }
}
C2.parseExternalUrl = g2;
class uT extends qo {
  constructor() {
    super(...arguments), this.type = "use";
  }
  setContext(A) {
    super.setContext(A);
    var t = this.getAttribute("x"), r = this.getAttribute("y");
    t.hasValue() && A.translate(t.getPixels("x"), 0), r.hasValue() && A.translate(0, r.getPixels("y"));
  }
  path(A) {
    var {
      element: t
    } = this;
    t && t.path(A);
  }
  renderChildren(A) {
    var {
      document: t,
      element: r
    } = this;
    if (r) {
      var n = r;
      if (r.type === "symbol" && (n = new au(t, null), n.attributes.viewBox = new be(t, "viewBox", r.getAttribute("viewBox").getString()), n.attributes.preserveAspectRatio = new be(t, "preserveAspectRatio", r.getAttribute("preserveAspectRatio").getString()), n.attributes.overflow = new be(t, "overflow", r.getAttribute("overflow").getString()), n.children = r.children, r.styles.opacity = new be(t, "opacity", this.calculateOpacity())), n.type === "svg") {
        var i = this.getStyle("width", !1, !0), s = this.getStyle("height", !1, !0);
        i.hasValue() && (n.attributes.width = new be(t, "width", i.getString())), s.hasValue() && (n.attributes.height = new be(t, "height", s.getString()));
      }
      var a = n.parent;
      n.parent = this, n.render(A), n.parent = a;
    }
  }
  getBoundingBox(A) {
    var {
      element: t
    } = this;
    return t ? t.getBoundingBox(A) : null;
  }
  elementTransform() {
    var {
      document: A,
      element: t
    } = this;
    return Ko.fromElement(A, t);
  }
  get element() {
    return this.cachedElement || (this.cachedElement = this.getHrefAttribute().getDefinition()), this.cachedElement;
  }
}
function Vd(e, A, t, r, n, i) {
  return e[t * r * 4 + A * 4 + i];
}
function Gd(e, A, t, r, n, i, s) {
  e[t * r * 4 + A * 4 + i] = s;
}
function Er(e, A, t) {
  var r = e[A];
  return r * t;
}
function ba(e, A, t, r) {
  return A + Math.cos(e) * t + Math.sin(e) * r;
}
class b2 extends Yt {
  constructor(A, t, r) {
    super(A, t, r), this.type = "feColorMatrix";
    var n = ai(this.getAttribute("values").getString());
    switch (this.getAttribute("type").getString("matrix")) {
      // http://www.w3.org/TR/SVG/filters.html#feColorMatrixElement
      case "saturate": {
        var i = n[0];
        n = [0.213 + 0.787 * i, 0.715 - 0.715 * i, 0.072 - 0.072 * i, 0, 0, 0.213 - 0.213 * i, 0.715 + 0.285 * i, 0.072 - 0.072 * i, 0, 0, 0.213 - 0.213 * i, 0.715 - 0.715 * i, 0.072 + 0.928 * i, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
        break;
      }
      case "hueRotate": {
        var s = n[0] * Math.PI / 180;
        n = [ba(s, 0.213, 0.787, -0.213), ba(s, 0.715, -0.715, -0.715), ba(s, 0.072, -0.072, 0.928), 0, 0, ba(s, 0.213, -0.213, 0.143), ba(s, 0.715, 0.285, 0.14), ba(s, 0.072, -0.072, -0.283), 0, 0, ba(s, 0.213, -0.213, -0.787), ba(s, 0.715, -0.715, 0.715), ba(s, 0.072, 0.928, 0.072), 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
        break;
      }
      case "luminanceToAlpha":
        n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2125, 0.7154, 0.0721, 0, 0, 0, 0, 0, 0, 1];
        break;
    }
    this.matrix = n, this.includeOpacity = this.getAttribute("includeOpacity").hasValue();
  }
  apply(A, t, r, n, i) {
    for (var {
      includeOpacity: s,
      matrix: a
    } = this, o = A.getImageData(0, 0, n, i), l = 0; l < i; l++)
      for (var c = 0; c < n; c++) {
        var u = Vd(o.data, c, l, n, i, 0), d = Vd(o.data, c, l, n, i, 1), h = Vd(o.data, c, l, n, i, 2), p = Vd(o.data, c, l, n, i, 3), B = Er(a, 0, u) + Er(a, 1, d) + Er(a, 2, h) + Er(a, 3, p) + Er(a, 4, 1), y = Er(a, 5, u) + Er(a, 6, d) + Er(a, 7, h) + Er(a, 8, p) + Er(a, 9, 1), m = Er(a, 10, u) + Er(a, 11, d) + Er(a, 12, h) + Er(a, 13, p) + Er(a, 14, 1), C = Er(a, 15, u) + Er(a, 16, d) + Er(a, 17, h) + Er(a, 18, p) + Er(a, 19, 1);
        s && (B = 0, y = 0, m = 0, C *= p / 255), Gd(o.data, c, l, n, i, 0, B), Gd(o.data, c, l, n, i, 1, y), Gd(o.data, c, l, n, i, 2, m), Gd(o.data, c, l, n, i, 3, C);
      }
    A.clearRect(0, 0, n, i), A.putImageData(o, 0, 0);
  }
}
class cf extends Yt {
  constructor() {
    super(...arguments), this.type = "mask";
  }
  apply(A, t) {
    var {
      document: r
    } = this, n = this.getAttribute("x").getPixels("x"), i = this.getAttribute("y").getPixels("y"), s = this.getStyle("width").getPixels("x"), a = this.getStyle("height").getPixels("y");
    if (!s && !a) {
      var o = new es();
      this.children.forEach((p) => {
        o.addBoundingBox(p.getBoundingBox(A));
      }), n = Math.floor(o.x1), i = Math.floor(o.y1), s = Math.floor(o.width), a = Math.floor(o.height);
    }
    var l = this.removeStyles(t, cf.ignoreStyles), c = r.createCanvas(n + s, i + a), u = c.getContext("2d");
    r.screen.setDefaults(u), this.renderChildren(u), new b2(r, {
      nodeType: 1,
      childNodes: [],
      attributes: [{
        nodeName: "type",
        value: "luminanceToAlpha"
      }, {
        nodeName: "includeOpacity",
        value: "true"
      }]
    }).apply(u, 0, 0, n + s, i + a);
    var d = r.createCanvas(n + s, i + a), h = d.getContext("2d");
    r.screen.setDefaults(h), t.render(h), h.globalCompositeOperation = "destination-in", h.fillStyle = u.createPattern(c, "no-repeat"), h.fillRect(0, 0, n + s, i + a), A.fillStyle = h.createPattern(d, "no-repeat"), A.fillRect(0, 0, n + s, i + a), this.restoreStyles(t, l);
  }
  render(A) {
  }
}
cf.ignoreStyles = ["mask", "transform", "clip-path"];
var fx = () => {
};
class hT extends Yt {
  constructor() {
    super(...arguments), this.type = "clipPath";
  }
  apply(A) {
    var {
      document: t
    } = this, r = Reflect.getPrototypeOf(A), {
      beginPath: n,
      closePath: i
    } = A;
    r && (r.beginPath = fx, r.closePath = fx), Reflect.apply(n, A, []), this.children.forEach((s) => {
      if (!(typeof s.path > "u")) {
        var a = typeof s.elementTransform < "u" ? s.elementTransform() : null;
        a || (a = Ko.fromElement(t, s)), a && a.apply(A), s.path(A), r && (r.closePath = i), a && a.unapply(A);
      }
    }), Reflect.apply(i, A, []), A.clip(), r && (r.beginPath = n, r.closePath = i);
  }
  render(A) {
  }
}
class uf extends Yt {
  constructor() {
    super(...arguments), this.type = "filter";
  }
  apply(A, t) {
    var {
      document: r,
      children: n
    } = this, i = t.getBoundingBox(A);
    if (i) {
      var s = 0, a = 0;
      n.forEach((m) => {
        var C = m.extraFilterDistance || 0;
        s = Math.max(s, C), a = Math.max(a, C);
      });
      var o = Math.floor(i.width), l = Math.floor(i.height), c = o + 2 * s, u = l + 2 * a;
      if (!(c < 1 || u < 1)) {
        var d = Math.floor(i.x), h = Math.floor(i.y), p = this.removeStyles(t, uf.ignoreStyles), B = r.createCanvas(c, u), y = B.getContext("2d");
        r.screen.setDefaults(y), y.translate(-d + s, -h + a), t.render(y), n.forEach((m) => {
          typeof m.apply == "function" && m.apply(y, 0, 0, c, u);
        }), A.drawImage(B, 0, 0, c, u, d - s, h - a, c, u), this.restoreStyles(t, p);
      }
    }
  }
  render(A) {
  }
}
uf.ignoreStyles = ["filter", "transform", "clip-path"];
class fT extends Yt {
  constructor(A, t, r) {
    super(A, t, r), this.type = "feDropShadow", this.addStylesFromStyleDefinition();
  }
  apply(A, t, r, n, i) {
  }
}
class dT extends Yt {
  constructor() {
    super(...arguments), this.type = "feMorphology";
  }
  apply(A, t, r, n, i) {
  }
}
class gT extends Yt {
  constructor() {
    super(...arguments), this.type = "feComposite";
  }
  apply(A, t, r, n, i) {
  }
}
class pT extends Yt {
  constructor(A, t, r) {
    super(A, t, r), this.type = "feGaussianBlur", this.blurRadius = Math.floor(this.getAttribute("stdDeviation").getNumber()), this.extraFilterDistance = this.blurRadius;
  }
  apply(A, t, r, n, i) {
    var {
      document: s,
      blurRadius: a
    } = this, o = s.window ? s.window.document.body : null, l = A.canvas;
    l.id = s.getUniqueId(), o && (l.style.display = "none", o.appendChild(l)), AAA(l, t, r, n, i, a), o && o.removeChild(l);
  }
}
class BT extends Yt {
  constructor() {
    super(...arguments), this.type = "title";
  }
}
class wT extends Yt {
  constructor() {
    super(...arguments), this.type = "desc";
  }
}
var bAA = {
  svg: au,
  rect: m2,
  circle: GH,
  ellipse: WH,
  line: jH,
  polyline: v2,
  polygon: qH,
  path: ht,
  pattern: $H,
  marker: zH,
  defs: XH,
  linearGradient: YH,
  radialGradient: JH,
  stop: ZH,
  animate: Kp,
  animateColor: AT,
  animateTransform: eT,
  font: tT,
  "font-face": rT,
  "missing-glyph": nT,
  glyph: w2,
  text: Da,
  tspan: lf,
  tref: iT,
  a: sT,
  textPath: aT,
  image: oT,
  g: kp,
  symbol: lT,
  style: C2,
  use: uT,
  mask: cf,
  clipPath: hT,
  filter: uf,
  feDropShadow: fT,
  feMorphology: dT,
  feComposite: gT,
  feColorMatrix: b2,
  feGaussianBlur: pT,
  title: BT,
  desc: wT
};
function dx(e, A) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    A && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function FAA(e) {
  for (var A = 1; A < arguments.length; A++) {
    var t = arguments[A] != null ? arguments[A] : {};
    A % 2 ? dx(Object(t), !0).forEach(function(r) {
      d2(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : dx(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function QAA(e, A) {
  var t = document.createElement("canvas");
  return t.width = e, t.height = A, t;
}
function UAA(e) {
  return cy.apply(this, arguments);
}
function cy() {
  return cy = Na(function* (e) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, t = document.createElement("img");
    return A && (t.crossOrigin = "Anonymous"), new Promise((r, n) => {
      t.onload = () => {
        r(t);
      }, t.onerror = (i, s, a, o, l) => {
        n(l);
      }, t.src = e;
    });
  }), cy.apply(this, arguments);
}
let hf = class ig {
  constructor(A) {
    var {
      rootEmSize: t = 12,
      emSize: r = 12,
      createCanvas: n = ig.createCanvas,
      createImage: i = ig.createImage,
      anonymousCrossOrigin: s
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.canvg = A, this.definitions = /* @__PURE__ */ Object.create(null), this.styles = /* @__PURE__ */ Object.create(null), this.stylesSpecificity = /* @__PURE__ */ Object.create(null), this.images = [], this.fonts = [], this.emSizeStack = [], this.uniqueId = 0, this.screen = A.screen, this.rootEmSize = t, this.emSize = r, this.createCanvas = n, this.createImage = this.bindCreateImage(i, s), this.screen.wait(this.isImagesLoaded.bind(this)), this.screen.wait(this.isFontsLoaded.bind(this));
  }
  bindCreateImage(A, t) {
    return typeof t == "boolean" ? (r, n) => A(r, typeof n == "boolean" ? n : t) : A;
  }
  get window() {
    return this.screen.window;
  }
  get fetch() {
    return this.screen.fetch;
  }
  get ctx() {
    return this.screen.ctx;
  }
  get emSize() {
    var {
      emSizeStack: A
    } = this;
    return A[A.length - 1];
  }
  set emSize(A) {
    var {
      emSizeStack: t
    } = this;
    t.push(A);
  }
  popEmSize() {
    var {
      emSizeStack: A
    } = this;
    A.pop();
  }
  getUniqueId() {
    return "canvg".concat(++this.uniqueId);
  }
  isImagesLoaded() {
    return this.images.every((A) => A.loaded);
  }
  isFontsLoaded() {
    return this.fonts.every((A) => A.loaded);
  }
  createDocumentElement(A) {
    var t = this.createElement(A.documentElement);
    return t.root = !0, t.addStylesFromStyleDefinition(), this.documentElement = t, t;
  }
  createElement(A) {
    var t = A.nodeName.replace(/^[^:]+:/, ""), r = ig.elementTypes[t];
    return typeof r < "u" ? new r(this, A) : new VH(this, A);
  }
  createTextNode(A) {
    return new yAA(this, A);
  }
  setViewBox(A) {
    this.screen.setViewBox(FAA({
      document: this
    }, A));
  }
};
hf.createCanvas = QAA;
hf.createImage = UAA;
hf.elementTypes = bAA;
function gx(e, A) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    A && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function pl(e) {
  for (var A = 1; A < arguments.length; A++) {
    var t = arguments[A] != null ? arguments[A] : {};
    A % 2 ? gx(Object(t), !0).forEach(function(r) {
      d2(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : gx(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
class Tl {
  /**
   * Main constructor.
   * @param ctx - Rendering context.
   * @param svg - SVG Document.
   * @param options - Rendering options.
   */
  constructor(A, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.parser = new ng(r), this.screen = new of(A, r), this.options = r;
    var n = new hf(this, r), i = n.createDocumentElement(t);
    this.document = n, this.documentElement = i;
  }
  /**
   * Create Canvg instance from SVG source string or URL.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  static from(A, t) {
    var r = arguments;
    return Na(function* () {
      var n = r.length > 2 && r[2] !== void 0 ? r[2] : {}, i = new ng(n), s = yield i.parse(t);
      return new Tl(A, s, n);
    })();
  }
  /**
   * Create Canvg instance from SVG source string.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  static fromString(A, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = new ng(r), i = n.parseFromString(t);
    return new Tl(A, i, r);
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  fork(A, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Tl.from(A, t, pl(pl({}, this.options), r));
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  forkString(A, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Tl.fromString(A, t, pl(pl({}, this.options), r));
  }
  /**
   * Document is ready promise.
   * @returns Ready promise.
   */
  ready() {
    return this.screen.ready();
  }
  /**
   * Document is ready value.
   * @returns Is ready or not.
   */
  isReady() {
    return this.screen.isReady();
  }
  /**
   * Render only first frame, ignoring animations and mouse.
   * @param options - Rendering options.
   */
  render() {
    var A = arguments, t = this;
    return Na(function* () {
      var r = A.length > 0 && A[0] !== void 0 ? A[0] : {};
      t.start(pl({
        enableRedraw: !0,
        ignoreAnimation: !0,
        ignoreMouse: !0
      }, r)), yield t.ready(), t.stop();
    })();
  }
  /**
   * Start rendering.
   * @param options - Render options.
   */
  start() {
    var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, {
      documentElement: t,
      screen: r,
      options: n
    } = this;
    r.start(t, pl(pl({
      enableRedraw: !0
    }, n), A));
  }
  /**
   * Stop rendering.
   */
  stop() {
    this.screen.stop();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(A) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : A, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    this.documentElement.resize(A, t, r);
  }
}
const EAA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AElement: sT,
  AnimateColorElement: AT,
  AnimateElement: Kp,
  AnimateTransformElement: eT,
  BoundingBox: es,
  CB1: ty,
  CB2: ry,
  CB3: ny,
  CB4: iy,
  Canvg: Tl,
  CircleElement: GH,
  ClipPathElement: hT,
  DefsElement: XH,
  DescElement: wT,
  Document: hf,
  Element: Yt,
  EllipseElement: WH,
  FeColorMatrixElement: b2,
  FeCompositeElement: gT,
  FeDropShadowElement: fT,
  FeGaussianBlurElement: pT,
  FeMorphologyElement: dT,
  FilterElement: uf,
  Font: Sn,
  FontElement: tT,
  FontFaceElement: rT,
  GElement: kp,
  GlyphElement: w2,
  GradientElement: y2,
  ImageElement: oT,
  LineElement: jH,
  LinearGradientElement: YH,
  MarkerElement: zH,
  MaskElement: cf,
  Matrix: p2,
  MissingGlyphElement: nT,
  Mouse: OH,
  PSEUDO_ZERO: Wl,
  Parser: ng,
  PathElement: ht,
  PathParser: ke,
  PatternElement: $H,
  Point: ar,
  PolygonElement: qH,
  PolylineElement: v2,
  Property: be,
  QB1: sy,
  QB2: ay,
  QB3: oy,
  RadialGradientElement: JH,
  RectElement: m2,
  RenderedElement: qo,
  Rotate: MH,
  SVGElement: au,
  SVGFontLoader: cT,
  Scale: PH,
  Screen: of,
  Skew: B2,
  SkewX: kH,
  SkewY: KH,
  StopElement: ZH,
  StyleElement: C2,
  SymbolElement: lT,
  TRefElement: iT,
  TSpanElement: lf,
  TextElement: Da,
  TextPathElement: aT,
  TitleElement: BT,
  Transform: Ko,
  Translate: RH,
  UnknownElement: VH,
  UseElement: uT,
  ViewPort: _H,
  compressSpaces: sc,
  default: Tl,
  getSelectorSpecificity: TH,
  normalizeAttributeName: LH,
  normalizeColor: HH,
  parseExternalUrl: g2,
  presets: nAA,
  toNumbers: ai,
  trimLeft: IH,
  trimRight: SH,
  vectorMagnitude: Ay,
  vectorsAngle: ey,
  vectorsRatio: Mg
}, Symbol.toStringTag, { value: "Module" }));
